import "./devParcel.efc2538a.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9fb6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9fb6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8JYDX", function(module, exports) {
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */ (function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    'use strict';
    var version = "1.9.4";
    /*
   * @namespace Util
   *
   * Various utility functions, used by Leaflet internally.
   */ // @function extend(dest: Object, src?: Object): Object
    // Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
    function extend(dest) {
        var i, j, len, src;
        for(j = 1, len = arguments.length; j < len; j++){
            src = arguments[j];
            for(i in src)dest[i] = src[i];
        }
        return dest;
    }
    // @function create(proto: Object, properties?: Object): Object
    // Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
    var create$2 = Object.create || function() {
        function F() {}
        return function(proto) {
            F.prototype = proto;
            return new F();
        };
    }();
    // @function bind(fn: Function, …): Function
    // Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
    // Has a `L.bind()` shortcut.
    function bind(fn, obj) {
        var slice = Array.prototype.slice;
        if (fn.bind) return fn.bind.apply(fn, slice.call(arguments, 1));
        var args = slice.call(arguments, 2);
        return function() {
            return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
        };
    }
    // @property lastId: Number
    // Last unique ID used by [`stamp()`](#util-stamp)
    var lastId = 0;
    // @function stamp(obj: Object): Number
    // Returns the unique ID of an object, assigning it one if it doesn't have it.
    function stamp(obj) {
        if (!('_leaflet_id' in obj)) obj['_leaflet_id'] = ++lastId;
        return obj._leaflet_id;
    }
    // @function throttle(fn: Function, time: Number, context: Object): Function
    // Returns a function which executes function `fn` with the given scope `context`
    // (so that the `this` keyword refers to `context` inside `fn`'s code). The function
    // `fn` will be called no more than one time per given amount of `time`. The arguments
    // received by the bound function will be any arguments passed when binding the
    // function, followed by any arguments passed when invoking the bound function.
    // Has an `L.throttle` shortcut.
    function throttle(fn, time, context) {
        var lock, args, wrapperFn, later;
        later = function() {
            // reset lock and call if queued
            lock = false;
            if (args) {
                wrapperFn.apply(context, args);
                args = false;
            }
        };
        wrapperFn = function() {
            if (lock) // called too soon, queue to call later
            args = arguments;
            else {
                // call and lock until later
                fn.apply(context, arguments);
                setTimeout(later, time);
                lock = true;
            }
        };
        return wrapperFn;
    }
    // @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
    // Returns the number `num` modulo `range` in such a way so it lies within
    // `range[0]` and `range[1]`. The returned value will be always smaller than
    // `range[1]` unless `includeMax` is set to `true`.
    function wrapNum(x, range, includeMax) {
        var max = range[1], min = range[0], d = max - min;
        return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
    }
    // @function falseFn(): Function
    // Returns a function which always returns `false`.
    function falseFn() {
        return false;
    }
    // @function formatNum(num: Number, precision?: Number|false): Number
    // Returns the number `num` rounded with specified `precision`.
    // The default `precision` value is 6 decimal places.
    // `false` can be passed to skip any processing (can be useful to avoid round-off errors).
    function formatNum(num, precision) {
        if (precision === false) return num;
        var pow = Math.pow(10, precision === undefined ? 6 : precision);
        return Math.round(num * pow) / pow;
    }
    // @function trim(str: String): String
    // Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
    function trim(str) {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
    }
    // @function splitWords(str: String): String[]
    // Trims and splits the string on whitespace and returns the array of parts.
    function splitWords(str) {
        return trim(str).split(/\s+/);
    }
    // @function setOptions(obj: Object, options: Object): Object
    // Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
    function setOptions(obj, options) {
        if (!Object.prototype.hasOwnProperty.call(obj, 'options')) obj.options = obj.options ? create$2(obj.options) : {};
        for(var i in options)obj.options[i] = options[i];
        return obj.options;
    }
    // @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
    // Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
    // translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
    // be appended at the end. If `uppercase` is `true`, the parameter names will
    // be uppercased (e.g. `'?A=foo&B=bar'`)
    function getParamString(obj, existingUrl, uppercase) {
        var params = [];
        for(var i in obj)params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
        return (!existingUrl || existingUrl.indexOf('?') === -1 ? '?' : '&') + params.join('&');
    }
    var templateRe = /\{ *([\w_ -]+) *\}/g;
    // @function template(str: String, data: Object): String
    // Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
    // and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
    // `('Hello foo, bar')`. You can also specify functions instead of strings for
    // data values — they will be evaluated passing `data` as an argument.
    function template(str, data) {
        return str.replace(templateRe, function(str, key) {
            var value = data[key];
            if (value === undefined) throw new Error('No value provided for variable ' + str);
            else if (typeof value === 'function') value = value(data);
            return value;
        });
    }
    // @function isArray(obj): Boolean
    // Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
    var isArray = Array.isArray || function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    // @function indexOf(array: Array, el: Object): Number
    // Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
    function indexOf(array, el) {
        for(var i = 0; i < array.length; i++){
            if (array[i] === el) return i;
        }
        return -1;
    }
    // @property emptyImageUrl: String
    // Data URI string containing a base64-encoded empty GIF image.
    // Used as a hack to free memory from unused images on WebKit-powered
    // mobile devices (by setting image `src` to this string).
    var emptyImageUrl = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
    // inspired by https://paulirish.com/2011/requestanimationframe-for-smart-animating/
    function getPrefixed(name) {
        return window['webkit' + name] || window['moz' + name] || window['ms' + name];
    }
    var lastTime = 0;
    // fallback for IE 7-8
    function timeoutDefer(fn) {
        var time = +new Date(), timeToCall = Math.max(0, 16 - (time - lastTime));
        lastTime = time + timeToCall;
        return window.setTimeout(fn, timeToCall);
    }
    var requestFn = window.requestAnimationFrame || getPrefixed('RequestAnimationFrame') || timeoutDefer;
    var cancelFn = window.cancelAnimationFrame || getPrefixed('CancelAnimationFrame') || getPrefixed('CancelRequestAnimationFrame') || function(id) {
        window.clearTimeout(id);
    };
    // @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
    // Schedules `fn` to be executed when the browser repaints. `fn` is bound to
    // `context` if given. When `immediate` is set, `fn` is called immediately if
    // the browser doesn't have native support for
    // [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
    // otherwise it's delayed. Returns a request ID that can be used to cancel the request.
    function requestAnimFrame(fn, context, immediate) {
        if (immediate && requestFn === timeoutDefer) fn.call(context);
        else return requestFn.call(window, bind(fn, context));
    }
    // @function cancelAnimFrame(id: Number): undefined
    // Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
    function cancelAnimFrame(id) {
        if (id) cancelFn.call(window, id);
    }
    var Util = {
        __proto__: null,
        extend: extend,
        create: create$2,
        bind: bind,
        get lastId () {
            return lastId;
        },
        stamp: stamp,
        throttle: throttle,
        wrapNum: wrapNum,
        falseFn: falseFn,
        formatNum: formatNum,
        trim: trim,
        splitWords: splitWords,
        setOptions: setOptions,
        getParamString: getParamString,
        template: template,
        isArray: isArray,
        indexOf: indexOf,
        emptyImageUrl: emptyImageUrl,
        requestFn: requestFn,
        cancelFn: cancelFn,
        requestAnimFrame: requestAnimFrame,
        cancelAnimFrame: cancelAnimFrame
    };
    // @class Class
    // @aka L.Class
    // @section
    // @uninheritable
    // Thanks to John Resig and Dean Edwards for inspiration!
    function Class() {}
    Class.extend = function(props) {
        // @function extend(props: Object): Function
        // [Extends the current class](#class-inheritance) given the properties to be included.
        // Returns a Javascript function that is a class constructor (to be called with `new`).
        var NewClass = function() {
            setOptions(this);
            // call the constructor
            if (this.initialize) this.initialize.apply(this, arguments);
            // call all constructor hooks
            this.callInitHooks();
        };
        var parentProto = NewClass.__super__ = this.prototype;
        var proto = create$2(parentProto);
        proto.constructor = NewClass;
        NewClass.prototype = proto;
        // inherit parent's statics
        for(var i in this)if (Object.prototype.hasOwnProperty.call(this, i) && i !== 'prototype' && i !== '__super__') NewClass[i] = this[i];
        // mix static properties into the class
        if (props.statics) extend(NewClass, props.statics);
        // mix includes into the prototype
        if (props.includes) {
            checkDeprecatedMixinEvents(props.includes);
            extend.apply(null, [
                proto
            ].concat(props.includes));
        }
        // mix given properties into the prototype
        extend(proto, props);
        delete proto.statics;
        delete proto.includes;
        // merge options
        if (proto.options) {
            proto.options = parentProto.options ? create$2(parentProto.options) : {};
            extend(proto.options, props.options);
        }
        proto._initHooks = [];
        // add method for calling all hooks
        proto.callInitHooks = function() {
            if (this._initHooksCalled) return;
            if (parentProto.callInitHooks) parentProto.callInitHooks.call(this);
            this._initHooksCalled = true;
            for(var i = 0, len = proto._initHooks.length; i < len; i++)proto._initHooks[i].call(this);
        };
        return NewClass;
    };
    // @function include(properties: Object): this
    // [Includes a mixin](#class-includes) into the current class.
    Class.include = function(props) {
        var parentOptions = this.prototype.options;
        extend(this.prototype, props);
        if (props.options) {
            this.prototype.options = parentOptions;
            this.mergeOptions(props.options);
        }
        return this;
    };
    // @function mergeOptions(options: Object): this
    // [Merges `options`](#class-options) into the defaults of the class.
    Class.mergeOptions = function(options) {
        extend(this.prototype.options, options);
        return this;
    };
    // @function addInitHook(fn: Function): this
    // Adds a [constructor hook](#class-constructor-hooks) to the class.
    Class.addInitHook = function(fn) {
        var args = Array.prototype.slice.call(arguments, 1);
        var init = typeof fn === 'function' ? fn : function() {
            this[fn].apply(this, args);
        };
        this.prototype._initHooks = this.prototype._initHooks || [];
        this.prototype._initHooks.push(init);
        return this;
    };
    function checkDeprecatedMixinEvents(includes) {
        /* global L: true */ if (typeof L === 'undefined' || !L || !L.Mixin) return;
        includes = isArray(includes) ? includes : [
            includes
        ];
        for(var i = 0; i < includes.length; i++)if (includes[i] === L.Mixin.Events) console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
    }
    /*
   * @class Evented
   * @aka L.Evented
   * @inherits Class
   *
   * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
   *
   * @example
   *
   * ```js
   * map.on('click', function(e) {
   * 	alert(e.latlng);
   * } );
   * ```
   *
   * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
   *
   * ```js
   * function onClick(e) { ... }
   *
   * map.on('click', onClick);
   * map.off('click', onClick);
   * ```
   */ var Events = {
        /* @method on(type: String, fn: Function, context?: Object): this
  	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
  	 *
  	 * @alternative
  	 * @method on(eventMap: Object): this
  	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
  	 */ on: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === 'object') for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context);
            }
            return this;
        },
        /* @method off(type: String, fn?: Function, context?: Object): this
  	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
  	 *
  	 * @alternative
  	 * @method off(eventMap: Object): this
  	 * Removes a set of type/listener pairs.
  	 *
  	 * @alternative
  	 * @method off: this
  	 * Removes all listeners to all events on the object. This includes implicitly attached events.
  	 */ off: function(types, fn, context) {
            if (!arguments.length) // clear all listeners if called without arguments
            delete this._events;
            else if (typeof types === 'object') for(var type in types)this._off(type, types[type], fn);
            else {
                types = splitWords(types);
                var removeAll = arguments.length === 1;
                for(var i = 0, len = types.length; i < len; i++)if (removeAll) this._off(types[i]);
                else this._off(types[i], fn, context);
            }
            return this;
        },
        // attach listener (without syntactic sugar now)
        _on: function(type, fn, context, _once) {
            if (typeof fn !== 'function') {
                console.warn('wrong listener type: ' + typeof fn);
                return;
            }
            // check if fn already there
            if (this._listens(type, fn, context) !== false) return;
            if (context === this) // Less memory footprint.
            context = undefined;
            var newListener = {
                fn: fn,
                ctx: context
            };
            if (_once) newListener.once = true;
            this._events = this._events || {};
            this._events[type] = this._events[type] || [];
            this._events[type].push(newListener);
        },
        _off: function(type, fn, context) {
            var listeners, i, len;
            if (!this._events) return;
            listeners = this._events[type];
            if (!listeners) return;
            if (arguments.length === 1) {
                if (this._firingCount) // Set all removed listeners to noop
                // so they are not called if remove happens in fire
                for(i = 0, len = listeners.length; i < len; i++)listeners[i].fn = falseFn;
                // clear all listeners for a type if function isn't specified
                delete this._events[type];
                return;
            }
            if (typeof fn !== 'function') {
                console.warn('wrong listener type: ' + typeof fn);
                return;
            }
            // find fn and remove it
            var index = this._listens(type, fn, context);
            if (index !== false) {
                var listener = listeners[index];
                if (this._firingCount) {
                    // set the removed listener to noop so that's not called if remove happens in fire
                    listener.fn = falseFn;
                    /* copy array in case events are being fired */ this._events[type] = listeners = listeners.slice();
                }
                listeners.splice(index, 1);
            }
        },
        // @method fire(type: String, data?: Object, propagate?: Boolean): this
        // Fires an event of the specified type. You can optionally provide a data
        // object — the first argument of the listener function will contain its
        // properties. The event can optionally be propagated to event parents.
        fire: function(type, data, propagate) {
            if (!this.listens(type, propagate)) return this;
            var event = extend({}, data, {
                type: type,
                target: this,
                sourceTarget: data && data.sourceTarget || this
            });
            if (this._events) {
                var listeners = this._events[type];
                if (listeners) {
                    this._firingCount = this._firingCount + 1 || 1;
                    for(var i = 0, len = listeners.length; i < len; i++){
                        var l = listeners[i];
                        // off overwrites l.fn, so we need to copy fn to a var
                        var fn = l.fn;
                        if (l.once) this.off(type, fn, l.ctx);
                        fn.call(l.ctx || this, event);
                    }
                    this._firingCount--;
                }
            }
            if (propagate) // propagate the event to parents (set with addEventParent)
            this._propagateEvent(event);
            return this;
        },
        // @method listens(type: String, propagate?: Boolean): Boolean
        // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
        // Returns `true` if a particular event type has any listeners attached to it.
        // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
        listens: function(type, fn, context, propagate) {
            if (typeof type !== 'string') console.warn('"string" type argument expected');
            // we don't overwrite the input `fn` value, because we need to use it for propagation
            var _fn = fn;
            if (typeof fn !== 'function') {
                propagate = !!fn;
                _fn = undefined;
                context = undefined;
            }
            var listeners = this._events && this._events[type];
            if (listeners && listeners.length) {
                if (this._listens(type, _fn, context) !== false) return true;
            }
            if (propagate) // also check parents for listeners if event propagates
            for(var id in this._eventParents){
                if (this._eventParents[id].listens(type, fn, context, propagate)) return true;
            }
            return false;
        },
        // returns the index (number) or false
        _listens: function(type, fn, context) {
            if (!this._events) return false;
            var listeners = this._events[type] || [];
            if (!fn) return !!listeners.length;
            if (context === this) // Less memory footprint.
            context = undefined;
            for(var i = 0, len = listeners.length; i < len; i++){
                if (listeners[i].fn === fn && listeners[i].ctx === context) return i;
            }
            return false;
        },
        // @method once(…): this
        // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
        once: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === 'object') for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn, true);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context, true);
            }
            return this;
        },
        // @method addEventParent(obj: Evented): this
        // Adds an event parent - an `Evented` that will receive propagated events
        addEventParent: function(obj) {
            this._eventParents = this._eventParents || {};
            this._eventParents[stamp(obj)] = obj;
            return this;
        },
        // @method removeEventParent(obj: Evented): this
        // Removes an event parent, so it will stop receiving propagated events
        removeEventParent: function(obj) {
            if (this._eventParents) delete this._eventParents[stamp(obj)];
            return this;
        },
        _propagateEvent: function(e) {
            for(var id in this._eventParents)this._eventParents[id].fire(e.type, extend({
                layer: e.target,
                propagatedFrom: e.target
            }, e), true);
        }
    };
    // aliases; we should ditch those eventually
    // @method addEventListener(…): this
    // Alias to [`on(…)`](#evented-on)
    Events.addEventListener = Events.on;
    // @method removeEventListener(…): this
    // Alias to [`off(…)`](#evented-off)
    // @method clearAllEventListeners(…): this
    // Alias to [`off()`](#evented-off)
    Events.removeEventListener = Events.clearAllEventListeners = Events.off;
    // @method addOneTimeEventListener(…): this
    // Alias to [`once(…)`](#evented-once)
    Events.addOneTimeEventListener = Events.once;
    // @method fireEvent(…): this
    // Alias to [`fire(…)`](#evented-fire)
    Events.fireEvent = Events.fire;
    // @method hasEventListeners(…): Boolean
    // Alias to [`listens(…)`](#evented-listens)
    Events.hasEventListeners = Events.listens;
    var Evented = Class.extend(Events);
    /*
   * @class Point
   * @aka L.Point
   *
   * Represents a point with `x` and `y` coordinates in pixels.
   *
   * @example
   *
   * ```js
   * var point = L.point(200, 300);
   * ```
   *
   * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
   *
   * ```js
   * map.panBy([200, 300]);
   * map.panBy(L.point(200, 300));
   * ```
   *
   * Note that `Point` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Point(x, y, round) {
        // @property x: Number; The `x` coordinate of the point
        this.x = round ? Math.round(x) : x;
        // @property y: Number; The `y` coordinate of the point
        this.y = round ? Math.round(y) : y;
    }
    var trunc = Math.trunc || function(v) {
        return v > 0 ? Math.floor(v) : Math.ceil(v);
    };
    Point.prototype = {
        // @method clone(): Point
        // Returns a copy of the current point.
        clone: function() {
            return new Point(this.x, this.y);
        },
        // @method add(otherPoint: Point): Point
        // Returns the result of addition of the current and the given points.
        add: function(point) {
            // non-destructive, returns a new point
            return this.clone()._add(toPoint(point));
        },
        _add: function(point) {
            // destructive, used directly for performance in situations where it's safe to modify existing point
            this.x += point.x;
            this.y += point.y;
            return this;
        },
        // @method subtract(otherPoint: Point): Point
        // Returns the result of subtraction of the given point from the current.
        subtract: function(point) {
            return this.clone()._subtract(toPoint(point));
        },
        _subtract: function(point) {
            this.x -= point.x;
            this.y -= point.y;
            return this;
        },
        // @method divideBy(num: Number): Point
        // Returns the result of division of the current point by the given number.
        divideBy: function(num) {
            return this.clone()._divideBy(num);
        },
        _divideBy: function(num) {
            this.x /= num;
            this.y /= num;
            return this;
        },
        // @method multiplyBy(num: Number): Point
        // Returns the result of multiplication of the current point by the given number.
        multiplyBy: function(num) {
            return this.clone()._multiplyBy(num);
        },
        _multiplyBy: function(num) {
            this.x *= num;
            this.y *= num;
            return this;
        },
        // @method scaleBy(scale: Point): Point
        // Multiply each coordinate of the current point by each coordinate of
        // `scale`. In linear algebra terms, multiply the point by the
        // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
        // defined by `scale`.
        scaleBy: function(point) {
            return new Point(this.x * point.x, this.y * point.y);
        },
        // @method unscaleBy(scale: Point): Point
        // Inverse of `scaleBy`. Divide each coordinate of the current point by
        // each coordinate of `scale`.
        unscaleBy: function(point) {
            return new Point(this.x / point.x, this.y / point.y);
        },
        // @method round(): Point
        // Returns a copy of the current point with rounded coordinates.
        round: function() {
            return this.clone()._round();
        },
        _round: function() {
            this.x = Math.round(this.x);
            this.y = Math.round(this.y);
            return this;
        },
        // @method floor(): Point
        // Returns a copy of the current point with floored coordinates (rounded down).
        floor: function() {
            return this.clone()._floor();
        },
        _floor: function() {
            this.x = Math.floor(this.x);
            this.y = Math.floor(this.y);
            return this;
        },
        // @method ceil(): Point
        // Returns a copy of the current point with ceiled coordinates (rounded up).
        ceil: function() {
            return this.clone()._ceil();
        },
        _ceil: function() {
            this.x = Math.ceil(this.x);
            this.y = Math.ceil(this.y);
            return this;
        },
        // @method trunc(): Point
        // Returns a copy of the current point with truncated coordinates (rounded towards zero).
        trunc: function() {
            return this.clone()._trunc();
        },
        _trunc: function() {
            this.x = trunc(this.x);
            this.y = trunc(this.y);
            return this;
        },
        // @method distanceTo(otherPoint: Point): Number
        // Returns the cartesian distance between the current and the given points.
        distanceTo: function(point) {
            point = toPoint(point);
            var x = point.x - this.x, y = point.y - this.y;
            return Math.sqrt(x * x + y * y);
        },
        // @method equals(otherPoint: Point): Boolean
        // Returns `true` if the given point has the same coordinates.
        equals: function(point) {
            point = toPoint(point);
            return point.x === this.x && point.y === this.y;
        },
        // @method contains(otherPoint: Point): Boolean
        // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
        contains: function(point) {
            point = toPoint(point);
            return Math.abs(point.x) <= Math.abs(this.x) && Math.abs(point.y) <= Math.abs(this.y);
        },
        // @method toString(): String
        // Returns a string representation of the point for debugging purposes.
        toString: function() {
            return 'Point(' + formatNum(this.x) + ', ' + formatNum(this.y) + ')';
        }
    };
    // @factory L.point(x: Number, y: Number, round?: Boolean)
    // Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
    // @alternative
    // @factory L.point(coords: Number[])
    // Expects an array of the form `[x, y]` instead.
    // @alternative
    // @factory L.point(coords: Object)
    // Expects a plain object of the form `{x: Number, y: Number}` instead.
    function toPoint(x, y, round) {
        if (x instanceof Point) return x;
        if (isArray(x)) return new Point(x[0], x[1]);
        if (x === undefined || x === null) return x;
        if (typeof x === 'object' && 'x' in x && 'y' in x) return new Point(x.x, x.y);
        return new Point(x, y, round);
    }
    /*
   * @class Bounds
   * @aka L.Bounds
   *
   * Represents a rectangular area in pixel coordinates.
   *
   * @example
   *
   * ```js
   * var p1 = L.point(10, 10),
   * p2 = L.point(40, 60),
   * bounds = L.bounds(p1, p2);
   * ```
   *
   * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * otherBounds.intersects([[10, 10], [40, 60]]);
   * ```
   *
   * Note that `Bounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Bounds(a, b) {
        if (!a) return;
        var points = b ? [
            a,
            b
        ] : a;
        for(var i = 0, len = points.length; i < len; i++)this.extend(points[i]);
    }
    Bounds.prototype = {
        // @method extend(point: Point): this
        // Extends the bounds to contain the given point.
        // @alternative
        // @method extend(otherBounds: Bounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var min2, max2;
            if (!obj) return this;
            if (obj instanceof Point || typeof obj[0] === 'number' || 'x' in obj) min2 = max2 = toPoint(obj);
            else {
                obj = toBounds(obj);
                min2 = obj.min;
                max2 = obj.max;
                if (!min2 || !max2) return this;
            }
            // @property min: Point
            // The top left corner of the rectangle.
            // @property max: Point
            // The bottom right corner of the rectangle.
            if (!this.min && !this.max) {
                this.min = min2.clone();
                this.max = max2.clone();
            } else {
                this.min.x = Math.min(min2.x, this.min.x);
                this.max.x = Math.max(max2.x, this.max.x);
                this.min.y = Math.min(min2.y, this.min.y);
                this.max.y = Math.max(max2.y, this.max.y);
            }
            return this;
        },
        // @method getCenter(round?: Boolean): Point
        // Returns the center point of the bounds.
        getCenter: function(round) {
            return toPoint((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, round);
        },
        // @method getBottomLeft(): Point
        // Returns the bottom-left point of the bounds.
        getBottomLeft: function() {
            return toPoint(this.min.x, this.max.y);
        },
        // @method getTopRight(): Point
        // Returns the top-right point of the bounds.
        getTopRight: function() {
            return toPoint(this.max.x, this.min.y);
        },
        // @method getTopLeft(): Point
        // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
        getTopLeft: function() {
            return this.min; // left, top
        },
        // @method getBottomRight(): Point
        // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
        getBottomRight: function() {
            return this.max; // right, bottom
        },
        // @method getSize(): Point
        // Returns the size of the given bounds
        getSize: function() {
            return this.max.subtract(this.min);
        },
        // @method contains(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains(point: Point): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            var min, max;
            if (typeof obj[0] === 'number' || obj instanceof Point) obj = toPoint(obj);
            else obj = toBounds(obj);
            if (obj instanceof Bounds) {
                min = obj.min;
                max = obj.max;
            } else min = max = obj;
            return min.x >= this.min.x && max.x <= this.max.x && min.y >= this.min.y && max.y <= this.max.y;
        },
        // @method intersects(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds
        // intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xIntersects = max2.x >= min.x && min2.x <= max.x, yIntersects = max2.y >= min.y && min2.y <= max.y;
            return xIntersects && yIntersects;
        },
        // @method overlaps(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds
        // overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xOverlaps = max2.x > min.x && min2.x < max.x, yOverlaps = max2.y > min.y && min2.y < max.y;
            return xOverlaps && yOverlaps;
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this.min && this.max);
        },
        // @method pad(bufferRatio: Number): Bounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var min = this.min, max = this.max, heightBuffer = Math.abs(min.x - max.x) * bufferRatio, widthBuffer = Math.abs(min.y - max.y) * bufferRatio;
            return toBounds(toPoint(min.x - heightBuffer, min.y - widthBuffer), toPoint(max.x + heightBuffer, max.y + widthBuffer));
        },
        // @method equals(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle is equivalent to the given bounds.
        equals: function(bounds) {
            if (!bounds) return false;
            bounds = toBounds(bounds);
            return this.min.equals(bounds.getTopLeft()) && this.max.equals(bounds.getBottomRight());
        }
    };
    // @factory L.bounds(corner1: Point, corner2: Point)
    // Creates a Bounds object from two corners coordinate pairs.
    // @alternative
    // @factory L.bounds(points: Point[])
    // Creates a Bounds object from the given array of points.
    function toBounds(a, b) {
        if (!a || a instanceof Bounds) return a;
        return new Bounds(a, b);
    }
    /*
   * @class LatLngBounds
   * @aka L.LatLngBounds
   *
   * Represents a rectangular geographical area on a map.
   *
   * @example
   *
   * ```js
   * var corner1 = L.latLng(40.712, -74.227),
   * corner2 = L.latLng(40.774, -74.125),
   * bounds = L.latLngBounds(corner1, corner2);
   * ```
   *
   * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * map.fitBounds([
   * 	[40.712, -74.227],
   * 	[40.774, -74.125]
   * ]);
   * ```
   *
   * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
   *
   * Note that `LatLngBounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLngBounds(corner1, corner2) {
        if (!corner1) return;
        var latlngs = corner2 ? [
            corner1,
            corner2
        ] : corner1;
        for(var i = 0, len = latlngs.length; i < len; i++)this.extend(latlngs[i]);
    }
    LatLngBounds.prototype = {
        // @method extend(latlng: LatLng): this
        // Extend the bounds to contain the given point
        // @alternative
        // @method extend(otherBounds: LatLngBounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLng) {
                sw2 = obj;
                ne2 = obj;
            } else if (obj instanceof LatLngBounds) {
                sw2 = obj._southWest;
                ne2 = obj._northEast;
                if (!sw2 || !ne2) return this;
            } else return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
            if (!sw && !ne) {
                this._southWest = new LatLng(sw2.lat, sw2.lng);
                this._northEast = new LatLng(ne2.lat, ne2.lng);
            } else {
                sw.lat = Math.min(sw2.lat, sw.lat);
                sw.lng = Math.min(sw2.lng, sw.lng);
                ne.lat = Math.max(ne2.lat, ne.lat);
                ne.lng = Math.max(ne2.lng, ne.lng);
            }
            return this;
        },
        // @method pad(bufferRatio: Number): LatLngBounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var sw = this._southWest, ne = this._northEast, heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio, widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
            return new LatLngBounds(new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer), new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
        },
        // @method getCenter(): LatLng
        // Returns the center point of the bounds.
        getCenter: function() {
            return new LatLng((this._southWest.lat + this._northEast.lat) / 2, (this._southWest.lng + this._northEast.lng) / 2);
        },
        // @method getSouthWest(): LatLng
        // Returns the south-west point of the bounds.
        getSouthWest: function() {
            return this._southWest;
        },
        // @method getNorthEast(): LatLng
        // Returns the north-east point of the bounds.
        getNorthEast: function() {
            return this._northEast;
        },
        // @method getNorthWest(): LatLng
        // Returns the north-west point of the bounds.
        getNorthWest: function() {
            return new LatLng(this.getNorth(), this.getWest());
        },
        // @method getSouthEast(): LatLng
        // Returns the south-east point of the bounds.
        getSouthEast: function() {
            return new LatLng(this.getSouth(), this.getEast());
        },
        // @method getWest(): Number
        // Returns the west longitude of the bounds
        getWest: function() {
            return this._southWest.lng;
        },
        // @method getSouth(): Number
        // Returns the south latitude of the bounds
        getSouth: function() {
            return this._southWest.lat;
        },
        // @method getEast(): Number
        // Returns the east longitude of the bounds
        getEast: function() {
            return this._northEast.lng;
        },
        // @method getNorth(): Number
        // Returns the north latitude of the bounds
        getNorth: function() {
            return this._northEast.lat;
        },
        // @method contains(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains (latlng: LatLng): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            if (typeof obj[0] === 'number' || obj instanceof LatLng || 'lat' in obj) obj = toLatLng(obj);
            else obj = toLatLngBounds(obj);
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLngBounds) {
                sw2 = obj.getSouthWest();
                ne2 = obj.getNorthEast();
            } else sw2 = ne2 = obj;
            return sw2.lat >= sw.lat && ne2.lat <= ne.lat && sw2.lng >= sw.lng && ne2.lng <= ne.lng;
        },
        // @method intersects(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latIntersects = ne2.lat >= sw.lat && sw2.lat <= ne.lat, lngIntersects = ne2.lng >= sw.lng && sw2.lng <= ne.lng;
            return latIntersects && lngIntersects;
        },
        // @method overlaps(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latOverlaps = ne2.lat > sw.lat && sw2.lat < ne.lat, lngOverlaps = ne2.lng > sw.lng && sw2.lng < ne.lng;
            return latOverlaps && lngOverlaps;
        },
        // @method toBBoxString(): String
        // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
        toBBoxString: function() {
            return [
                this.getWest(),
                this.getSouth(),
                this.getEast(),
                this.getNorth()
            ].join(',');
        },
        // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
        // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(bounds, maxMargin) {
            if (!bounds) return false;
            bounds = toLatLngBounds(bounds);
            return this._southWest.equals(bounds.getSouthWest(), maxMargin) && this._northEast.equals(bounds.getNorthEast(), maxMargin);
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this._southWest && this._northEast);
        }
    };
    // TODO International date line?
    // @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
    // Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
    // @alternative
    // @factory L.latLngBounds(latlngs: LatLng[])
    // Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
    function toLatLngBounds(a, b) {
        if (a instanceof LatLngBounds) return a;
        return new LatLngBounds(a, b);
    }
    /* @class LatLng
   * @aka L.LatLng
   *
   * Represents a geographical point with a certain latitude and longitude.
   *
   * @example
   *
   * ```
   * var latlng = L.latLng(50.5, 30.5);
   * ```
   *
   * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
   *
   * ```
   * map.panTo([50, 30]);
   * map.panTo({lon: 30, lat: 50});
   * map.panTo({lat: 50, lng: 30});
   * map.panTo(L.latLng(50, 30));
   * ```
   *
   * Note that `LatLng` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLng(lat, lng, alt) {
        if (isNaN(lat) || isNaN(lng)) throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
        // @property lat: Number
        // Latitude in degrees
        this.lat = +lat;
        // @property lng: Number
        // Longitude in degrees
        this.lng = +lng;
        // @property alt: Number
        // Altitude in meters (optional)
        if (alt !== undefined) this.alt = +alt;
    }
    LatLng.prototype = {
        // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
        // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(obj, maxMargin) {
            if (!obj) return false;
            obj = toLatLng(obj);
            var margin = Math.max(Math.abs(this.lat - obj.lat), Math.abs(this.lng - obj.lng));
            return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
        },
        // @method toString(): String
        // Returns a string representation of the point (for debugging purposes).
        toString: function(precision) {
            return 'LatLng(' + formatNum(this.lat, precision) + ', ' + formatNum(this.lng, precision) + ')';
        },
        // @method distanceTo(otherLatLng: LatLng): Number
        // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
        distanceTo: function(other) {
            return Earth.distance(this, toLatLng(other));
        },
        // @method wrap(): LatLng
        // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
        wrap: function() {
            return Earth.wrapLatLng(this);
        },
        // @method toBounds(sizeInMeters: Number): LatLngBounds
        // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
        toBounds: function(sizeInMeters) {
            var latAccuracy = 180 * sizeInMeters / 40075017, lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
            return toLatLngBounds([
                this.lat - latAccuracy,
                this.lng - lngAccuracy
            ], [
                this.lat + latAccuracy,
                this.lng + lngAccuracy
            ]);
        },
        clone: function() {
            return new LatLng(this.lat, this.lng, this.alt);
        }
    };
    // @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
    // Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
    // @alternative
    // @factory L.latLng(coords: Array): LatLng
    // Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
    // @alternative
    // @factory L.latLng(coords: Object): LatLng
    // Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
    function toLatLng(a, b, c) {
        if (a instanceof LatLng) return a;
        if (isArray(a) && typeof a[0] !== 'object') {
            if (a.length === 3) return new LatLng(a[0], a[1], a[2]);
            if (a.length === 2) return new LatLng(a[0], a[1]);
            return null;
        }
        if (a === undefined || a === null) return a;
        if (typeof a === 'object' && 'lat' in a) return new LatLng(a.lat, 'lng' in a ? a.lng : a.lon, a.alt);
        if (b === undefined) return null;
        return new LatLng(a, b, c);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.Base
   * Object that defines coordinate reference systems for projecting
   * geographical points into pixel (screen) coordinates and back (and to
   * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
   * [spatial reference system](https://en.wikipedia.org/wiki/Spatial_reference_system).
   *
   * Leaflet defines the most usual CRSs by default. If you want to use a
   * CRS not defined by default, take a look at the
   * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
   *
   * Note that the CRS instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.
   */ var CRS = {
        // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
        // Projects geographical coordinates into pixel coordinates for a given zoom.
        latLngToPoint: function(latlng, zoom) {
            var projectedPoint = this.projection.project(latlng), scale = this.scale(zoom);
            return this.transformation._transform(projectedPoint, scale);
        },
        // @method pointToLatLng(point: Point, zoom: Number): LatLng
        // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
        // zoom into geographical coordinates.
        pointToLatLng: function(point, zoom) {
            var scale = this.scale(zoom), untransformedPoint = this.transformation.untransform(point, scale);
            return this.projection.unproject(untransformedPoint);
        },
        // @method project(latlng: LatLng): Point
        // Projects geographical coordinates into coordinates in units accepted for
        // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
        project: function(latlng) {
            return this.projection.project(latlng);
        },
        // @method unproject(point: Point): LatLng
        // Given a projected coordinate returns the corresponding LatLng.
        // The inverse of `project`.
        unproject: function(point) {
            return this.projection.unproject(point);
        },
        // @method scale(zoom: Number): Number
        // Returns the scale used when transforming projected coordinates into
        // pixel coordinates for a particular zoom. For example, it returns
        // `256 * 2^zoom` for Mercator-based CRS.
        scale: function(zoom) {
            return 256 * Math.pow(2, zoom);
        },
        // @method zoom(scale: Number): Number
        // Inverse of `scale()`, returns the zoom level corresponding to a scale
        // factor of `scale`.
        zoom: function(scale) {
            return Math.log(scale / 256) / Math.LN2;
        },
        // @method getProjectedBounds(zoom: Number): Bounds
        // Returns the projection's bounds scaled and transformed for the provided `zoom`.
        getProjectedBounds: function(zoom) {
            if (this.infinite) return null;
            var b = this.projection.bounds, s = this.scale(zoom), min = this.transformation.transform(b.min, s), max = this.transformation.transform(b.max, s);
            return new Bounds(min, max);
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates.
        // @property code: String
        // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
        //
        // @property wrapLng: Number[]
        // An array of two numbers defining whether the longitude (horizontal) coordinate
        // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
        // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
        //
        // @property wrapLat: Number[]
        // Like `wrapLng`, but for the latitude (vertical) axis.
        // wrapLng: [min, max],
        // wrapLat: [min, max],
        // @property infinite: Boolean
        // If true, the coordinate space will be unbounded (infinite in both axes)
        infinite: false,
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where lat and lng has been wrapped according to the
        // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
        wrapLatLng: function(latlng) {
            var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng, lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat, alt = latlng.alt;
            return new LatLng(lat, lng, alt);
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring
        // that its center is within the CRS's bounds.
        // Only accepts actual `L.LatLngBounds` instances, not arrays.
        wrapLatLngBounds: function(bounds) {
            var center = bounds.getCenter(), newCenter = this.wrapLatLng(center), latShift = center.lat - newCenter.lat, lngShift = center.lng - newCenter.lng;
            if (latShift === 0 && lngShift === 0) return bounds;
            var sw = bounds.getSouthWest(), ne = bounds.getNorthEast(), newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift), newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
            return new LatLngBounds(newSw, newNe);
        }
    };
    /*
   * @namespace CRS
   * @crs L.CRS.Earth
   *
   * Serves as the base for CRS that are global such that they cover the earth.
   * Can only be used as the base for other CRS and cannot be used directly,
   * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
   * meters.
   */ var Earth = extend({}, CRS, {
        wrapLng: [
            -180,
            180
        ],
        // Mean Earth Radius, as recommended for use by
        // the International Union of Geodesy and Geophysics,
        // see https://rosettacode.org/wiki/Haversine_formula
        R: 6371000,
        // distance between two geographical points using spherical law of cosines approximation
        distance: function(latlng1, latlng2) {
            var rad = Math.PI / 180, lat1 = latlng1.lat * rad, lat2 = latlng2.lat * rad, sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2), sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2), a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon, c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return this.R * c;
        }
    });
    /*
   * @namespace Projection
   * @projection L.Projection.SphericalMercator
   *
   * Spherical Mercator projection — the most common projection for online maps,
   * used by almost all free and commercial tile providers. Assumes that Earth is
   * a sphere. Used by the `EPSG:3857` CRS.
   */ var earthRadius = 6378137;
    var SphericalMercator = {
        R: earthRadius,
        MAX_LATITUDE: 85.0511287798,
        project: function(latlng) {
            var d = Math.PI / 180, max = this.MAX_LATITUDE, lat = Math.max(Math.min(max, latlng.lat), -max), sin = Math.sin(lat * d);
            return new Point(this.R * latlng.lng * d, this.R * Math.log((1 + sin) / (1 - sin)) / 2);
        },
        unproject: function(point) {
            var d = 180 / Math.PI;
            return new LatLng((2 * Math.atan(Math.exp(point.y / this.R)) - Math.PI / 2) * d, point.x * d / this.R);
        },
        bounds: function() {
            var d = earthRadius * Math.PI;
            return new Bounds([
                -d,
                -d
            ], [
                d,
                d
            ]);
        }()
    };
    /*
   * @class Transformation
   * @aka L.Transformation
   *
   * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
   * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
   * the reverse. Used by Leaflet in its projections code.
   *
   * @example
   *
   * ```js
   * var transformation = L.transformation(2, 5, -1, 10),
   * 	p = L.point(1, 2),
   * 	p2 = transformation.transform(p), //  L.point(7, 8)
   * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
   * ```
   */ // factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
    // Creates a `Transformation` object with the given coefficients.
    function Transformation(a, b, c, d) {
        if (isArray(a)) {
            // use array properties
            this._a = a[0];
            this._b = a[1];
            this._c = a[2];
            this._d = a[3];
            return;
        }
        this._a = a;
        this._b = b;
        this._c = c;
        this._d = d;
    }
    Transformation.prototype = {
        // @method transform(point: Point, scale?: Number): Point
        // Returns a transformed point, optionally multiplied by the given scale.
        // Only accepts actual `L.Point` instances, not arrays.
        transform: function(point, scale) {
            return this._transform(point.clone(), scale);
        },
        // destructive transform (faster)
        _transform: function(point, scale) {
            scale = scale || 1;
            point.x = scale * (this._a * point.x + this._b);
            point.y = scale * (this._c * point.y + this._d);
            return point;
        },
        // @method untransform(point: Point, scale?: Number): Point
        // Returns the reverse transformation of the given point, optionally divided
        // by the given scale. Only accepts actual `L.Point` instances, not arrays.
        untransform: function(point, scale) {
            scale = scale || 1;
            return new Point((point.x / scale - this._b) / this._a, (point.y / scale - this._d) / this._c);
        }
    };
    // factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // Instantiates a Transformation object with the given coefficients.
    // @alternative
    // @factory L.transformation(coefficients: Array): Transformation
    // Expects an coefficients array of the form
    // `[a: Number, b: Number, c: Number, d: Number]`.
    function toTransformation(a, b, c, d) {
        return new Transformation(a, b, c, d);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3857
   *
   * The most common CRS for online maps, used by almost all free and commercial
   * tile providers. Uses Spherical Mercator projection. Set in by default in
   * Map's `crs` option.
   */ var EPSG3857 = extend({}, Earth, {
        code: 'EPSG:3857',
        projection: SphericalMercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * SphericalMercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    var EPSG900913 = extend({}, EPSG3857, {
        code: 'EPSG:900913'
    });
    // @namespace SVG; @section
    // There are several static functions which can be called without instantiating L.SVG:
    // @function create(name: String): SVGElement
    // Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
    // corresponding to the class name passed. For example, using 'line' will return
    // an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
    function svgCreate(name) {
        return document.createElementNS('http://www.w3.org/2000/svg', name);
    }
    // @function pointsToPath(rings: Point[], closed: Boolean): String
    // Generates a SVG path string for multiple rings, with each ring turning
    // into "M..L..L.." instructions
    function pointsToPath(rings, closed) {
        var str = '', i, j, len, len2, points, p;
        for(i = 0, len = rings.length; i < len; i++){
            points = rings[i];
            for(j = 0, len2 = points.length; j < len2; j++){
                p = points[j];
                str += (j ? 'L' : 'M') + p.x + ' ' + p.y;
            }
            // closes the ring for polygons; "x" is VML syntax
            str += closed ? Browser.svg ? 'z' : 'x' : '';
        }
        // SVG complains about empty path strings
        return str || 'M0 0';
    }
    /*
   * @namespace Browser
   * @aka L.Browser
   *
   * A namespace with static properties for browser/feature detection used by Leaflet internally.
   *
   * @example
   *
   * ```js
   * if (L.Browser.ielt9) {
   *   alert('Upgrade your browser, dude!');
   * }
   * ```
   */ var style = document.documentElement.style;
    // @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
    var ie = 'ActiveXObject' in window;
    // @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
    var ielt9 = ie && !document.addEventListener;
    // @property edge: Boolean; `true` for the Edge web browser.
    var edge = 'msLaunchUri' in navigator && !('documentMode' in document);
    // @property webkit: Boolean;
    // `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
    var webkit = userAgentContains('webkit');
    // @property android: Boolean
    // **Deprecated.** `true` for any browser running on an Android platform.
    var android = userAgentContains('android');
    // @property android23: Boolean; **Deprecated.** `true` for browsers running on Android 2 or Android 3.
    var android23 = userAgentContains('android 2') || userAgentContains('android 3');
    /* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */ var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
    // @property androidStock: Boolean; **Deprecated.** `true` for the Android stock browser (i.e. not Chrome)
    var androidStock = android && userAgentContains('Google') && webkitVer < 537 && !('AudioNode' in window);
    // @property opera: Boolean; `true` for the Opera browser
    var opera = !!window.opera;
    // @property chrome: Boolean; `true` for the Chrome browser.
    var chrome = !edge && userAgentContains('chrome');
    // @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
    var gecko = userAgentContains('gecko') && !webkit && !opera && !ie;
    // @property safari: Boolean; `true` for the Safari browser.
    var safari = !chrome && userAgentContains('safari');
    var phantom = userAgentContains('phantom');
    // @property opera12: Boolean
    // `true` for the Opera browser supporting CSS transforms (version 12 or later).
    var opera12 = 'OTransition' in style;
    // @property win: Boolean; `true` when the browser is running in a Windows platform
    var win = navigator.platform.indexOf('Win') === 0;
    // @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
    var ie3d = ie && 'transition' in style;
    // @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
    var webkit3d = 'WebKitCSSMatrix' in window && 'm11' in new window.WebKitCSSMatrix() && !android23;
    // @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
    var gecko3d = 'MozPerspective' in style;
    // @property any3d: Boolean
    // `true` for all browsers supporting CSS transforms.
    var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
    // @property mobile: Boolean; `true` for all browsers running in a mobile device.
    var mobile = typeof orientation !== 'undefined' || userAgentContains('mobile');
    // @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
    var mobileWebkit = mobile && webkit;
    // @property mobileWebkit3d: Boolean
    // `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
    var mobileWebkit3d = mobile && webkit3d;
    // @property msPointer: Boolean
    // `true` for browsers implementing the Microsoft touch events model (notably IE10).
    var msPointer = !window.PointerEvent && window.MSPointerEvent;
    // @property pointer: Boolean
    // `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
    var pointer = !!(window.PointerEvent || msPointer);
    // @property touchNative: Boolean
    // `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
    // **This does not necessarily mean** that the browser is running in a computer with
    // a touchscreen, it only means that the browser is capable of understanding
    // touch events.
    var touchNative = 'ontouchstart' in window || !!window.TouchEvent;
    // @property touch: Boolean
    // `true` for all browsers supporting either [touch](#browser-touch) or [pointer](#browser-pointer) events.
    // Note: pointer events will be preferred (if available), and processed for all `touch*` listeners.
    var touch = !window.L_NO_TOUCH && (touchNative || pointer);
    // @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
    var mobileOpera = mobile && opera;
    // @property mobileGecko: Boolean
    // `true` for gecko-based browsers running in a mobile device.
    var mobileGecko = mobile && gecko;
    // @property retina: Boolean
    // `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
    var retina = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1;
    // @property passiveEvents: Boolean
    // `true` for browsers that support passive events.
    var passiveEvents = function() {
        var supportsPassiveOption = false;
        try {
            var opts = Object.defineProperty({}, 'passive', {
                get: function() {
                    supportsPassiveOption = true;
                }
            });
            window.addEventListener('testPassiveEventSupport', falseFn, opts);
            window.removeEventListener('testPassiveEventSupport', falseFn, opts);
        } catch (e) {
        // Errors can safely be ignored since this is only a browser support test.
        }
        return supportsPassiveOption;
    }();
    // @property canvas: Boolean
    // `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
    var canvas$1 = function() {
        return !!document.createElement('canvas').getContext;
    }();
    // @property svg: Boolean
    // `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
    var svg$1 = !!(document.createElementNS && svgCreate('svg').createSVGRect);
    var inlineSvg = !!svg$1 && function() {
        var div = document.createElement('div');
        div.innerHTML = '<svg/>';
        return (div.firstChild && div.firstChild.namespaceURI) === 'http://www.w3.org/2000/svg';
    }();
    // @property vml: Boolean
    // `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
    var vml = !svg$1 && function() {
        try {
            var div = document.createElement('div');
            div.innerHTML = '<v:shape adj="1"/>';
            var shape = div.firstChild;
            shape.style.behavior = 'url(#default#VML)';
            return shape && typeof shape.adj === 'object';
        } catch (e) {
            return false;
        }
    }();
    // @property mac: Boolean; `true` when the browser is running in a Mac platform
    var mac = navigator.platform.indexOf('Mac') === 0;
    // @property mac: Boolean; `true` when the browser is running in a Linux platform
    var linux = navigator.platform.indexOf('Linux') === 0;
    function userAgentContains(str) {
        return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
    }
    var Browser = {
        ie: ie,
        ielt9: ielt9,
        edge: edge,
        webkit: webkit,
        android: android,
        android23: android23,
        androidStock: androidStock,
        opera: opera,
        chrome: chrome,
        gecko: gecko,
        safari: safari,
        phantom: phantom,
        opera12: opera12,
        win: win,
        ie3d: ie3d,
        webkit3d: webkit3d,
        gecko3d: gecko3d,
        any3d: any3d,
        mobile: mobile,
        mobileWebkit: mobileWebkit,
        mobileWebkit3d: mobileWebkit3d,
        msPointer: msPointer,
        pointer: pointer,
        touch: touch,
        touchNative: touchNative,
        mobileOpera: mobileOpera,
        mobileGecko: mobileGecko,
        retina: retina,
        passiveEvents: passiveEvents,
        canvas: canvas$1,
        svg: svg$1,
        vml: vml,
        inlineSvg: inlineSvg,
        mac: mac,
        linux: linux
    };
    /*
   * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
   */ var POINTER_DOWN = Browser.msPointer ? 'MSPointerDown' : 'pointerdown';
    var POINTER_MOVE = Browser.msPointer ? 'MSPointerMove' : 'pointermove';
    var POINTER_UP = Browser.msPointer ? 'MSPointerUp' : 'pointerup';
    var POINTER_CANCEL = Browser.msPointer ? 'MSPointerCancel' : 'pointercancel';
    var pEvent = {
        touchstart: POINTER_DOWN,
        touchmove: POINTER_MOVE,
        touchend: POINTER_UP,
        touchcancel: POINTER_CANCEL
    };
    var handle = {
        touchstart: _onPointerStart,
        touchmove: _handlePointer,
        touchend: _handlePointer,
        touchcancel: _handlePointer
    };
    var _pointers = {};
    var _pointerDocListener = false;
    // Provides a touch events wrapper for (ms)pointer events.
    // ref https://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
    function addPointerListener(obj, type, handler) {
        if (type === 'touchstart') _addPointerDocListener();
        if (!handle[type]) {
            console.warn('wrong event specified:', type);
            return falseFn;
        }
        handler = handle[type].bind(this, handler);
        obj.addEventListener(pEvent[type], handler, false);
        return handler;
    }
    function removePointerListener(obj, type, handler) {
        if (!pEvent[type]) {
            console.warn('wrong event specified:', type);
            return;
        }
        obj.removeEventListener(pEvent[type], handler, false);
    }
    function _globalPointerDown(e) {
        _pointers[e.pointerId] = e;
    }
    function _globalPointerMove(e) {
        if (_pointers[e.pointerId]) _pointers[e.pointerId] = e;
    }
    function _globalPointerUp(e) {
        delete _pointers[e.pointerId];
    }
    function _addPointerDocListener() {
        // need to keep track of what pointers and how many are active to provide e.touches emulation
        if (!_pointerDocListener) {
            // we listen document as any drags that end by moving the touch off the screen get fired there
            document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
            document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
            document.addEventListener(POINTER_UP, _globalPointerUp, true);
            document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
            _pointerDocListener = true;
        }
    }
    function _handlePointer(handler, e) {
        if (e.pointerType === (e.MSPOINTER_TYPE_MOUSE || 'mouse')) return;
        e.touches = [];
        for(var i in _pointers)e.touches.push(_pointers[i]);
        e.changedTouches = [
            e
        ];
        handler(e);
    }
    function _onPointerStart(handler, e) {
        // IE10 specific: MsTouch needs preventDefault. See #2000
        if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) preventDefault(e);
        _handlePointer(handler, e);
    }
    /*
   * Extends the event handling code with double tap support for mobile browsers.
   *
   * Note: currently most browsers fire native dblclick, with only a few exceptions
   * (see https://github.com/Leaflet/Leaflet/issues/7012#issuecomment-595087386)
   */ function makeDblclick(event) {
        // in modern browsers `type` cannot be just overridden:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only
        var newEvent = {}, prop, i;
        for(i in event){
            prop = event[i];
            newEvent[i] = prop && prop.bind ? prop.bind(event) : prop;
        }
        event = newEvent;
        newEvent.type = 'dblclick';
        newEvent.detail = 2;
        newEvent.isTrusted = false;
        newEvent._simulated = true; // for debug purposes
        return newEvent;
    }
    var delay = 200;
    function addDoubleTapListener(obj, handler) {
        // Most browsers handle double tap natively
        obj.addEventListener('dblclick', handler);
        // On some platforms the browser doesn't fire native dblclicks for touch events.
        // It seems that in all such cases `detail` property of `click` event is always `1`.
        // So here we rely on that fact to avoid excessive 'dblclick' simulation when not needed.
        var last = 0, detail;
        function simDblclick(e) {
            if (e.detail !== 1) {
                detail = e.detail; // keep in sync to avoid false dblclick in some cases
                return;
            }
            if (e.pointerType === 'mouse' || e.sourceCapabilities && !e.sourceCapabilities.firesTouchEvents) return;
            // When clicking on an <input>, the browser generates a click on its
            // <label> (and vice versa) triggering two clicks in quick succession.
            // This ignores clicks on elements which are a label with a 'for'
            // attribute (or children of such a label), but not children of
            // a <input>.
            var path = getPropagationPath(e);
            if (path.some(function(el) {
                return el instanceof HTMLLabelElement && el.attributes.for;
            }) && !path.some(function(el) {
                return el instanceof HTMLInputElement || el instanceof HTMLSelectElement;
            })) return;
            var now = Date.now();
            if (now - last <= delay) {
                detail++;
                if (detail === 2) handler(makeDblclick(e));
            } else detail = 1;
            last = now;
        }
        obj.addEventListener('click', simDblclick);
        return {
            dblclick: handler,
            simDblclick: simDblclick
        };
    }
    function removeDoubleTapListener(obj, handlers) {
        obj.removeEventListener('dblclick', handlers.dblclick);
        obj.removeEventListener('click', handlers.simDblclick);
    }
    /*
   * @namespace DomUtil
   *
   * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
   * tree, used by Leaflet internally.
   *
   * Most functions expecting or returning a `HTMLElement` also work for
   * SVG elements. The only difference is that classes refer to CSS classes
   * in HTML and SVG classes in SVG.
   */ // @property TRANSFORM: String
    // Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
    var TRANSFORM = testProp([
        'transform',
        'webkitTransform',
        'OTransform',
        'MozTransform',
        'msTransform'
    ]);
    // webkitTransition comes first because some browser versions that drop vendor prefix don't do
    // the same for the transitionend event, in particular the Android 4.1 stock browser
    // @property TRANSITION: String
    // Vendor-prefixed transition style name.
    var TRANSITION = testProp([
        'webkitTransition',
        'transition',
        'OTransition',
        'MozTransition',
        'msTransition'
    ]);
    // @property TRANSITION_END: String
    // Vendor-prefixed transitionend event name.
    var TRANSITION_END = TRANSITION === 'webkitTransition' || TRANSITION === 'OTransition' ? TRANSITION + 'End' : 'transitionend';
    // @function get(id: String|HTMLElement): HTMLElement
    // Returns an element given its DOM id, or returns the element itself
    // if it was passed directly.
    function get(id) {
        return typeof id === 'string' ? document.getElementById(id) : id;
    }
    // @function getStyle(el: HTMLElement, styleAttrib: String): String
    // Returns the value for a certain style attribute on an element,
    // including computed values or values set through CSS.
    function getStyle(el, style) {
        var value = el.style[style] || el.currentStyle && el.currentStyle[style];
        if ((!value || value === 'auto') && document.defaultView) {
            var css = document.defaultView.getComputedStyle(el, null);
            value = css ? css[style] : null;
        }
        return value === 'auto' ? null : value;
    }
    // @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
    // Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
    function create$1(tagName, className, container) {
        var el = document.createElement(tagName);
        el.className = className || '';
        if (container) container.appendChild(el);
        return el;
    }
    // @function remove(el: HTMLElement)
    // Removes `el` from its parent element
    function remove(el) {
        var parent = el.parentNode;
        if (parent) parent.removeChild(el);
    }
    // @function empty(el: HTMLElement)
    // Removes all of `el`'s children elements from `el`
    function empty(el) {
        while(el.firstChild)el.removeChild(el.firstChild);
    }
    // @function toFront(el: HTMLElement)
    // Makes `el` the last child of its parent, so it renders in front of the other children.
    function toFront(el) {
        var parent = el.parentNode;
        if (parent && parent.lastChild !== el) parent.appendChild(el);
    }
    // @function toBack(el: HTMLElement)
    // Makes `el` the first child of its parent, so it renders behind the other children.
    function toBack(el) {
        var parent = el.parentNode;
        if (parent && parent.firstChild !== el) parent.insertBefore(el, parent.firstChild);
    }
    // @function hasClass(el: HTMLElement, name: String): Boolean
    // Returns `true` if the element's class attribute contains `name`.
    function hasClass(el, name) {
        if (el.classList !== undefined) return el.classList.contains(name);
        var className = getClass(el);
        return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
    }
    // @function addClass(el: HTMLElement, name: String)
    // Adds `name` to the element's class attribute.
    function addClass(el, name) {
        if (el.classList !== undefined) {
            var classes = splitWords(name);
            for(var i = 0, len = classes.length; i < len; i++)el.classList.add(classes[i]);
        } else if (!hasClass(el, name)) {
            var className = getClass(el);
            setClass(el, (className ? className + ' ' : '') + name);
        }
    }
    // @function removeClass(el: HTMLElement, name: String)
    // Removes `name` from the element's class attribute.
    function removeClass(el, name) {
        if (el.classList !== undefined) el.classList.remove(name);
        else setClass(el, trim((' ' + getClass(el) + ' ').replace(' ' + name + ' ', ' ')));
    }
    // @function setClass(el: HTMLElement, name: String)
    // Sets the element's class.
    function setClass(el, name) {
        if (el.className.baseVal === undefined) el.className = name;
        else // in case of SVG element
        el.className.baseVal = name;
    }
    // @function getClass(el: HTMLElement): String
    // Returns the element's class.
    function getClass(el) {
        // Check if the element is an SVGElementInstance and use the correspondingElement instead
        // (Required for linked SVG elements in IE11.)
        if (el.correspondingElement) el = el.correspondingElement;
        return el.className.baseVal === undefined ? el.className : el.className.baseVal;
    }
    // @function setOpacity(el: HTMLElement, opacity: Number)
    // Set the opacity of an element (including old IE support).
    // `opacity` must be a number from `0` to `1`.
    function setOpacity(el, value) {
        if ('opacity' in el.style) el.style.opacity = value;
        else if ('filter' in el.style) _setOpacityIE(el, value);
    }
    function _setOpacityIE(el, value) {
        var filter = false, filterName = 'DXImageTransform.Microsoft.Alpha';
        // filters collection throws an error if we try to retrieve a filter that doesn't exist
        try {
            filter = el.filters.item(filterName);
        } catch (e) {
            // don't set opacity to 1 if we haven't already set an opacity,
            // it isn't needed and breaks transparent pngs.
            if (value === 1) return;
        }
        value = Math.round(value * 100);
        if (filter) {
            filter.Enabled = value !== 100;
            filter.Opacity = value;
        } else el.style.filter += ' progid:' + filterName + '(opacity=' + value + ')';
    }
    // @function testProp(props: String[]): String|false
    // Goes through the array of style names and returns the first name
    // that is a valid style name for an element. If no such name is found,
    // it returns false. Useful for vendor-prefixed styles like `transform`.
    function testProp(props) {
        var style = document.documentElement.style;
        for(var i = 0; i < props.length; i++){
            if (props[i] in style) return props[i];
        }
        return false;
    }
    // @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
    // Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
    // and optionally scaled by `scale`. Does not have an effect if the
    // browser doesn't support 3D CSS transforms.
    function setTransform(el, offset, scale) {
        var pos = offset || new Point(0, 0);
        el.style[TRANSFORM] = (Browser.ie3d ? 'translate(' + pos.x + 'px,' + pos.y + 'px)' : 'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') + (scale ? ' scale(' + scale + ')' : '');
    }
    // @function setPosition(el: HTMLElement, position: Point)
    // Sets the position of `el` to coordinates specified by `position`,
    // using CSS translate or top/left positioning depending on the browser
    // (used by Leaflet internally to position its layers).
    function setPosition(el, point) {
        /*eslint-disable */ el._leaflet_pos = point;
        /* eslint-enable */ if (Browser.any3d) setTransform(el, point);
        else {
            el.style.left = point.x + 'px';
            el.style.top = point.y + 'px';
        }
    }
    // @function getPosition(el: HTMLElement): Point
    // Returns the coordinates of an element previously positioned with setPosition.
    function getPosition(el) {
        // this method is only used for elements previously positioned using setPosition,
        // so it's safe to cache the position for performance
        return el._leaflet_pos || new Point(0, 0);
    }
    // @function disableTextSelection()
    // Prevents the user from generating `selectstart` DOM events, usually generated
    // when the user drags the mouse through a page with text. Used internally
    // by Leaflet to override the behaviour of any click-and-drag interaction on
    // the map. Affects drag interactions on the whole document.
    // @function enableTextSelection()
    // Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
    var disableTextSelection;
    var enableTextSelection;
    var _userSelect;
    if ('onselectstart' in document) {
        disableTextSelection = function() {
            on(window, 'selectstart', preventDefault);
        };
        enableTextSelection = function() {
            off(window, 'selectstart', preventDefault);
        };
    } else {
        var userSelectProperty = testProp([
            'userSelect',
            'WebkitUserSelect',
            'OUserSelect',
            'MozUserSelect',
            'msUserSelect'
        ]);
        disableTextSelection = function() {
            if (userSelectProperty) {
                var style = document.documentElement.style;
                _userSelect = style[userSelectProperty];
                style[userSelectProperty] = 'none';
            }
        };
        enableTextSelection = function() {
            if (userSelectProperty) {
                document.documentElement.style[userSelectProperty] = _userSelect;
                _userSelect = undefined;
            }
        };
    }
    // @function disableImageDrag()
    // As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
    // for `dragstart` DOM events, usually generated when the user drags an image.
    function disableImageDrag() {
        on(window, 'dragstart', preventDefault);
    }
    // @function enableImageDrag()
    // Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
    function enableImageDrag() {
        off(window, 'dragstart', preventDefault);
    }
    var _outlineElement, _outlineStyle;
    // @function preventOutline(el: HTMLElement)
    // Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
    // of the element `el` invisible. Used internally by Leaflet to prevent
    // focusable elements from displaying an outline when the user performs a
    // drag interaction on them.
    function preventOutline(element) {
        while(element.tabIndex === -1)element = element.parentNode;
        if (!element.style) return;
        restoreOutline();
        _outlineElement = element;
        _outlineStyle = element.style.outlineStyle;
        element.style.outlineStyle = 'none';
        on(window, 'keydown', restoreOutline);
    }
    // @function restoreOutline()
    // Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
    function restoreOutline() {
        if (!_outlineElement) return;
        _outlineElement.style.outlineStyle = _outlineStyle;
        _outlineElement = undefined;
        _outlineStyle = undefined;
        off(window, 'keydown', restoreOutline);
    }
    // @function getSizedParentNode(el: HTMLElement): HTMLElement
    // Finds the closest parent node which size (width and height) is not null.
    function getSizedParentNode(element) {
        do element = element.parentNode;
        while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
        return element;
    }
    // @function getScale(el: HTMLElement): Object
    // Computes the CSS scale currently applied on the element.
    // Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
    // and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
    function getScale(element) {
        var rect = element.getBoundingClientRect(); // Read-only in old browsers.
        return {
            x: rect.width / element.offsetWidth || 1,
            y: rect.height / element.offsetHeight || 1,
            boundingClientRect: rect
        };
    }
    var DomUtil = {
        __proto__: null,
        TRANSFORM: TRANSFORM,
        TRANSITION: TRANSITION,
        TRANSITION_END: TRANSITION_END,
        get: get,
        getStyle: getStyle,
        create: create$1,
        remove: remove,
        empty: empty,
        toFront: toFront,
        toBack: toBack,
        hasClass: hasClass,
        addClass: addClass,
        removeClass: removeClass,
        setClass: setClass,
        getClass: getClass,
        setOpacity: setOpacity,
        testProp: testProp,
        setTransform: setTransform,
        setPosition: setPosition,
        getPosition: getPosition,
        get disableTextSelection () {
            return disableTextSelection;
        },
        get enableTextSelection () {
            return enableTextSelection;
        },
        disableImageDrag: disableImageDrag,
        enableImageDrag: enableImageDrag,
        preventOutline: preventOutline,
        restoreOutline: restoreOutline,
        getSizedParentNode: getSizedParentNode,
        getScale: getScale
    };
    /*
   * @namespace DomEvent
   * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
   */ // Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
    // @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Adds a listener function (`fn`) to a particular DOM event type of the
    // element `el`. You can optionally specify the context of the listener
    // (object the `this` keyword will point to). You can also pass several
    // space-separated types (e.g. `'click dblclick'`).
    // @alternative
    // @function on(el: HTMLElement, eventMap: Object, context?: Object): this
    // Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    function on(obj, types, fn, context) {
        if (types && typeof types === 'object') for(var type in types)addOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            for(var i = 0, len = types.length; i < len; i++)addOne(obj, types[i], fn, context);
        }
        return this;
    }
    var eventsKey = '_leaflet_events';
    // @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Removes a previously added listener function.
    // Note that if you passed a custom context to on, you must pass the same
    // context to `off` in order to remove the listener.
    // @alternative
    // @function off(el: HTMLElement, eventMap: Object, context?: Object): this
    // Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    // @alternative
    // @function off(el: HTMLElement, types: String): this
    // Removes all previously added listeners of given types.
    // @alternative
    // @function off(el: HTMLElement): this
    // Removes all previously added listeners from given HTMLElement
    function off(obj, types, fn, context) {
        if (arguments.length === 1) {
            batchRemove(obj);
            delete obj[eventsKey];
        } else if (types && typeof types === 'object') for(var type in types)removeOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            if (arguments.length === 2) batchRemove(obj, function(type) {
                return indexOf(types, type) !== -1;
            });
            else for(var i = 0, len = types.length; i < len; i++)removeOne(obj, types[i], fn, context);
        }
        return this;
    }
    function batchRemove(obj, filterFn) {
        for(var id in obj[eventsKey]){
            var type = id.split(/\d/)[0];
            if (!filterFn || filterFn(type)) removeOne(obj, type, null, null, id);
        }
    }
    var mouseSubst = {
        mouseenter: 'mouseover',
        mouseleave: 'mouseout',
        wheel: !('onwheel' in window) && 'mousewheel'
    };
    function addOne(obj, type, fn, context) {
        var id = type + stamp(fn) + (context ? '_' + stamp(context) : '');
        if (obj[eventsKey] && obj[eventsKey][id]) return this;
        var handler = function(e) {
            return fn.call(context || obj, e || window.event);
        };
        var originalHandler = handler;
        if (!Browser.touchNative && Browser.pointer && type.indexOf('touch') === 0) // Needs DomEvent.Pointer.js
        handler = addPointerListener(obj, type, handler);
        else if (Browser.touch && type === 'dblclick') handler = addDoubleTapListener(obj, handler);
        else if ('addEventListener' in obj) {
            if (type === 'touchstart' || type === 'touchmove' || type === 'wheel' || type === 'mousewheel') obj.addEventListener(mouseSubst[type] || type, handler, Browser.passiveEvents ? {
                passive: false
            } : false);
            else if (type === 'mouseenter' || type === 'mouseleave') {
                handler = function(e) {
                    e = e || window.event;
                    if (isExternalTarget(obj, e)) originalHandler(e);
                };
                obj.addEventListener(mouseSubst[type], handler, false);
            } else obj.addEventListener(type, originalHandler, false);
        } else obj.attachEvent('on' + type, handler);
        obj[eventsKey] = obj[eventsKey] || {};
        obj[eventsKey][id] = handler;
    }
    function removeOne(obj, type, fn, context, id) {
        id = id || type + stamp(fn) + (context ? '_' + stamp(context) : '');
        var handler = obj[eventsKey] && obj[eventsKey][id];
        if (!handler) return this;
        if (!Browser.touchNative && Browser.pointer && type.indexOf('touch') === 0) removePointerListener(obj, type, handler);
        else if (Browser.touch && type === 'dblclick') removeDoubleTapListener(obj, handler);
        else if ('removeEventListener' in obj) obj.removeEventListener(mouseSubst[type] || type, handler, false);
        else obj.detachEvent('on' + type, handler);
        obj[eventsKey][id] = null;
    }
    // @function stopPropagation(ev: DOMEvent): this
    // Stop the given event from propagation to parent elements. Used inside the listener functions:
    // ```js
    // L.DomEvent.on(div, 'click', function (ev) {
    // 	L.DomEvent.stopPropagation(ev);
    // });
    // ```
    function stopPropagation(e) {
        if (e.stopPropagation) e.stopPropagation();
        else if (e.originalEvent) e.originalEvent._stopped = true;
        else e.cancelBubble = true;
        return this;
    }
    // @function disableScrollPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'wheel'` events (plus browser variants).
    function disableScrollPropagation(el) {
        addOne(el, 'wheel', stopPropagation);
        return this;
    }
    // @function disableClickPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'click'`, `'dblclick'`, `'contextmenu'`,
    // `'mousedown'` and `'touchstart'` events (plus browser variants).
    function disableClickPropagation(el) {
        on(el, 'mousedown touchstart dblclick contextmenu', stopPropagation);
        el['_leaflet_disable_click'] = true;
        return this;
    }
    // @function preventDefault(ev: DOMEvent): this
    // Prevents the default action of the DOM Event `ev` from happening (such as
    // following a link in the href of the a element, or doing a POST request
    // with page reload when a `<form>` is submitted).
    // Use it inside listener functions.
    function preventDefault(e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return this;
    }
    // @function stop(ev: DOMEvent): this
    // Does `stopPropagation` and `preventDefault` at the same time.
    function stop(e) {
        preventDefault(e);
        stopPropagation(e);
        return this;
    }
    // @function getPropagationPath(ev: DOMEvent): Array
    // Compatibility polyfill for [`Event.composedPath()`](https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath).
    // Returns an array containing the `HTMLElement`s that the given DOM event
    // should propagate to (if not stopped).
    function getPropagationPath(ev) {
        if (ev.composedPath) return ev.composedPath();
        var path = [];
        var el = ev.target;
        while(el){
            path.push(el);
            el = el.parentNode;
        }
        return path;
    }
    // @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
    // Gets normalized mouse position from a DOM event relative to the
    // `container` (border excluded) or to the whole page if not specified.
    function getMousePosition(e, container) {
        if (!container) return new Point(e.clientX, e.clientY);
        var scale = getScale(container), offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
        return new Point(// offset.left/top values are in page scale (like clientX/Y),
        // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
        (e.clientX - offset.left) / scale.x - container.clientLeft, (e.clientY - offset.top) / scale.y - container.clientTop);
    }
    //  except , Safari and
    // We need double the scroll pixels (see #7403 and #4538) for all Browsers
    // except OSX (Mac) -> 3x, Chrome running on Linux 1x
    var wheelPxFactor = Browser.linux && Browser.chrome ? window.devicePixelRatio : Browser.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
    // @function getWheelDelta(ev: DOMEvent): Number
    // Gets normalized wheel delta from a wheel DOM event, in vertical
    // pixels scrolled (negative if scrolling down).
    // Events from pointing devices without precise scrolling are mapped to
    // a best guess of 60 pixels.
    function getWheelDelta(e) {
        return Browser.edge ? e.wheelDeltaY / 2 : e.deltaY && e.deltaMode === 0 ? -e.deltaY / wheelPxFactor : e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 : e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 : e.deltaX || e.deltaZ ? 0 : e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 : e.detail ? e.detail / -32765 * 60 : 0;
    }
    // check if element really left/entered the event target (for mouseenter/mouseleave)
    function isExternalTarget(el, e) {
        var related = e.relatedTarget;
        if (!related) return true;
        try {
            while(related && related !== el)related = related.parentNode;
        } catch (err) {
            return false;
        }
        return related !== el;
    }
    var DomEvent = {
        __proto__: null,
        on: on,
        off: off,
        stopPropagation: stopPropagation,
        disableScrollPropagation: disableScrollPropagation,
        disableClickPropagation: disableClickPropagation,
        preventDefault: preventDefault,
        stop: stop,
        getPropagationPath: getPropagationPath,
        getMousePosition: getMousePosition,
        getWheelDelta: getWheelDelta,
        isExternalTarget: isExternalTarget,
        addListener: on,
        removeListener: off
    };
    /*
   * @class PosAnimation
   * @aka L.PosAnimation
   * @inherits Evented
   * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
   *
   * @example
   * ```js
   * var myPositionMarker = L.marker([48.864716, 2.294694]).addTo(map);
   *
   * myPositionMarker.on("click", function() {
   * 	var pos = map.latLngToLayerPoint(myPositionMarker.getLatLng());
   * 	pos.y -= 25;
   * 	var fx = new L.PosAnimation();
   *
   * 	fx.once('end',function() {
   * 		pos.y += 25;
   * 		fx.run(myPositionMarker._icon, pos, 0.8);
   * 	});
   *
   * 	fx.run(myPositionMarker._icon, pos, 0.3);
   * });
   *
   * ```
   *
   * @constructor L.PosAnimation()
   * Creates a `PosAnimation` object.
   *
   */ var PosAnimation = Evented.extend({
        // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
        // Run an animation of a given element to a new position, optionally setting
        // duration in seconds (`0.25` by default) and easing linearity factor (3rd
        // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
        // `0.5` by default).
        run: function(el, newPos, duration, easeLinearity) {
            this.stop();
            this._el = el;
            this._inProgress = true;
            this._duration = duration || 0.25;
            this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
            this._startPos = getPosition(el);
            this._offset = newPos.subtract(this._startPos);
            this._startTime = +new Date();
            // @event start: Event
            // Fired when the animation starts
            this.fire('start');
            this._animate();
        },
        // @method stop()
        // Stops the animation (if currently running).
        stop: function() {
            if (!this._inProgress) return;
            this._step(true);
            this._complete();
        },
        _animate: function() {
            // animation loop
            this._animId = requestAnimFrame(this._animate, this);
            this._step();
        },
        _step: function(round) {
            var elapsed = +new Date() - this._startTime, duration = this._duration * 1000;
            if (elapsed < duration) this._runFrame(this._easeOut(elapsed / duration), round);
            else {
                this._runFrame(1);
                this._complete();
            }
        },
        _runFrame: function(progress, round) {
            var pos = this._startPos.add(this._offset.multiplyBy(progress));
            if (round) pos._round();
            setPosition(this._el, pos);
            // @event step: Event
            // Fired continuously during the animation.
            this.fire('step');
        },
        _complete: function() {
            cancelAnimFrame(this._animId);
            this._inProgress = false;
            // @event end: Event
            // Fired when the animation ends.
            this.fire('end');
        },
        _easeOut: function(t) {
            return 1 - Math.pow(1 - t, this._easeOutPower);
        }
    });
    /*
   * @class Map
   * @aka L.Map
   * @inherits Evented
   *
   * The central class of the API — it is used to create a map on a page and manipulate it.
   *
   * @example
   *
   * ```js
   * // initialize the map on the "map" div with a given center and zoom
   * var map = L.map('map', {
   * 	center: [51.505, -0.09],
   * 	zoom: 13
   * });
   * ```
   *
   */ var Map = Evented.extend({
        options: {
            // @section Map State Options
            // @option crs: CRS = L.CRS.EPSG3857
            // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
            // sure what it means.
            crs: EPSG3857,
            // @option center: LatLng = undefined
            // Initial geographic center of the map
            center: undefined,
            // @option zoom: Number = undefined
            // Initial map zoom level
            zoom: undefined,
            // @option minZoom: Number = *
            // Minimum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the lowest of their `minZoom` options will be used instead.
            minZoom: undefined,
            // @option maxZoom: Number = *
            // Maximum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the highest of their `maxZoom` options will be used instead.
            maxZoom: undefined,
            // @option layers: Layer[] = []
            // Array of layers that will be added to the map initially
            layers: [],
            // @option maxBounds: LatLngBounds = null
            // When this option is set, the map restricts the view to the given
            // geographical bounds, bouncing the user back if the user tries to pan
            // outside the view. To set the restriction dynamically, use
            // [`setMaxBounds`](#map-setmaxbounds) method.
            maxBounds: undefined,
            // @option renderer: Renderer = *
            // The default method for drawing vector layers on the map. `L.SVG`
            // or `L.Canvas` by default depending on browser support.
            renderer: undefined,
            // @section Animation Options
            // @option zoomAnimation: Boolean = true
            // Whether the map zoom animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            zoomAnimation: true,
            // @option zoomAnimationThreshold: Number = 4
            // Won't animate zoom if the zoom difference exceeds this value.
            zoomAnimationThreshold: 4,
            // @option fadeAnimation: Boolean = true
            // Whether the tile fade animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            fadeAnimation: true,
            // @option markerZoomAnimation: Boolean = true
            // Whether markers animate their zoom with the zoom animation, if disabled
            // they will disappear for the length of the animation. By default it's
            // enabled in all browsers that support CSS3 Transitions except Android.
            markerZoomAnimation: true,
            // @option transform3DLimit: Number = 2^23
            // Defines the maximum size of a CSS translation transform. The default
            // value should not be changed unless a web browser positions layers in
            // the wrong place after doing a large `panBy`.
            transform3DLimit: 8388608,
            // @section Interaction Options
            // @option zoomSnap: Number = 1
            // Forces the map's zoom level to always be a multiple of this, particularly
            // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
            // By default, the zoom level snaps to the nearest integer; lower values
            // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
            // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
            zoomSnap: 1,
            // @option zoomDelta: Number = 1
            // Controls how much the map's zoom level will change after a
            // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
            // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
            // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
            zoomDelta: 1,
            // @option trackResize: Boolean = true
            // Whether the map automatically handles browser window resize to update itself.
            trackResize: true
        },
        initialize: function(id, options) {
            options = setOptions(this, options);
            // Make sure to assign internal flags at the beginning,
            // to avoid inconsistent state in some edge cases.
            this._handlers = [];
            this._layers = {};
            this._zoomBoundLayers = {};
            this._sizeChanged = true;
            this._initContainer(id);
            this._initLayout();
            // hack for https://github.com/Leaflet/Leaflet/issues/1980
            this._onResize = bind(this._onResize, this);
            this._initEvents();
            if (options.maxBounds) this.setMaxBounds(options.maxBounds);
            if (options.zoom !== undefined) this._zoom = this._limitZoom(options.zoom);
            if (options.center && options.zoom !== undefined) this.setView(toLatLng(options.center), options.zoom, {
                reset: true
            });
            this.callInitHooks();
            // don't animate on browsers without hardware-accelerated transitions or old Android/Opera
            this._zoomAnimated = TRANSITION && Browser.any3d && !Browser.mobileOpera && this.options.zoomAnimation;
            // zoom transitions run with the same duration for all layers, so if one of transitionend events
            // happens after starting zoom animation (propagating to the map pane), we know that it ended globally
            if (this._zoomAnimated) {
                this._createAnimProxy();
                on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
            }
            this._addLayers(this.options.layers);
        },
        // @section Methods for modifying map state
        // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) with the given
        // animation options.
        setView: function(center, zoom, options) {
            zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
            center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
            options = options || {};
            this._stop();
            if (this._loaded && !options.reset && options !== true) {
                if (options.animate !== undefined) {
                    options.zoom = extend({
                        animate: options.animate
                    }, options.zoom);
                    options.pan = extend({
                        animate: options.animate,
                        duration: options.duration
                    }, options.pan);
                }
                // try animating pan or zoom
                var moved = this._zoom !== zoom ? this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) : this._tryAnimatedPan(center, options.pan);
                if (moved) {
                    // prevent resize handler call, the view will refresh after animation anyway
                    clearTimeout(this._sizeTimer);
                    return this;
                }
            }
            // animation didn't start, just reset the map view
            this._resetView(center, zoom, options.pan && options.pan.noMoveStart);
            return this;
        },
        // @method setZoom(zoom: Number, options?: Zoom/pan options): this
        // Sets the zoom of the map.
        setZoom: function(zoom, options) {
            if (!this._loaded) {
                this._zoom = zoom;
                return this;
            }
            return this.setView(this.getCenter(), zoom, {
                zoom: options
            });
        },
        // @method zoomIn(delta?: Number, options?: Zoom options): this
        // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomIn: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom + delta, options);
        },
        // @method zoomOut(delta?: Number, options?: Zoom options): this
        // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomOut: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom - delta, options);
        },
        // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified geographical point on the map
        // stationary (e.g. used internally for scroll zoom and double-click zoom).
        // @alternative
        // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
        setZoomAround: function(latlng, zoom, options) {
            var scale = this.getZoomScale(zoom), viewHalf = this.getSize().divideBy(2), containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng), centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale), newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
            return this.setView(newCenter, zoom, {
                zoom: options
            });
        },
        _getBoundsCenterZoom: function(bounds, options) {
            options = options || {};
            bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
            zoom = typeof options.maxZoom === 'number' ? Math.min(options.maxZoom, zoom) : zoom;
            if (zoom === Infinity) return {
                center: bounds.getCenter(),
                zoom: zoom
            };
            var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2), swPoint = this.project(bounds.getSouthWest(), zoom), nePoint = this.project(bounds.getNorthEast(), zoom), center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
            return {
                center: center,
                zoom: zoom
            };
        },
        // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets a map view that contains the given geographical bounds with the
        // maximum zoom level possible.
        fitBounds: function(bounds, options) {
            bounds = toLatLngBounds(bounds);
            if (!bounds.isValid()) throw new Error('Bounds are not valid.');
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.setView(target.center, target.zoom, options);
        },
        // @method fitWorld(options?: fitBounds options): this
        // Sets a map view that mostly contains the whole world with the maximum
        // zoom level possible.
        fitWorld: function(options) {
            return this.fitBounds([
                [
                    -90,
                    -180
                ],
                [
                    90,
                    180
                ]
            ], options);
        },
        // @method panTo(latlng: LatLng, options?: Pan options): this
        // Pans the map to a given center.
        panTo: function(center, options) {
            return this.setView(center, this._zoom, {
                pan: options
            });
        },
        // @method panBy(offset: Point, options?: Pan options): this
        // Pans the map by a given number of pixels (animated).
        panBy: function(offset, options) {
            offset = toPoint(offset).round();
            options = options || {};
            if (!offset.x && !offset.y) return this.fire('moveend');
            // If we pan too far, Chrome gets issues with tiles
            // and makes them disappear or appear in the wrong place (slightly offset) #2602
            if (options.animate !== true && !this.getSize().contains(offset)) {
                this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
                return this;
            }
            if (!this._panAnim) {
                this._panAnim = new PosAnimation();
                this._panAnim.on({
                    'step': this._onPanTransitionStep,
                    'end': this._onPanTransitionEnd
                }, this);
            }
            // don't fire movestart if animating inertia
            if (!options.noMoveStart) this.fire('movestart');
            // animate pan unless animate: false specified
            if (options.animate !== false) {
                addClass(this._mapPane, 'leaflet-pan-anim');
                var newPos = this._getMapPanePos().subtract(offset).round();
                this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
            } else {
                this._rawPanBy(offset);
                this.fire('move').fire('moveend');
            }
            return this;
        },
        // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) performing a smooth
        // pan-zoom animation.
        flyTo: function(targetCenter, targetZoom, options) {
            options = options || {};
            if (options.animate === false || !Browser.any3d) return this.setView(targetCenter, targetZoom, options);
            this._stop();
            var from = this.project(this.getCenter()), to = this.project(targetCenter), size = this.getSize(), startZoom = this._zoom;
            targetCenter = toLatLng(targetCenter);
            targetZoom = targetZoom === undefined ? startZoom : targetZoom;
            var w0 = Math.max(size.x, size.y), w1 = w0 * this.getZoomScale(startZoom, targetZoom), u1 = to.distanceTo(from) || 1, rho = 1.42, rho2 = rho * rho;
            function r(i) {
                var s1 = i ? -1 : 1, s2 = i ? w1 : w0, t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1, b1 = 2 * s2 * rho2 * u1, b = t1 / b1, sq = Math.sqrt(b * b + 1) - b;
                // workaround for floating point precision bug when sq = 0, log = -Infinite,
                // thus triggering an infinite loop in flyTo
                var log = sq < 0.000000001 ? -18 : Math.log(sq);
                return log;
            }
            function sinh(n) {
                return (Math.exp(n) - Math.exp(-n)) / 2;
            }
            function cosh(n) {
                return (Math.exp(n) + Math.exp(-n)) / 2;
            }
            function tanh(n) {
                return sinh(n) / cosh(n);
            }
            var r0 = r(0);
            function w(s) {
                return w0 * (cosh(r0) / cosh(r0 + rho * s));
            }
            function u(s) {
                return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2;
            }
            function easeOut(t) {
                return 1 - Math.pow(1 - t, 1.5);
            }
            var start = Date.now(), S = (r(1) - r0) / rho, duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
            function frame() {
                var t = (Date.now() - start) / duration, s = easeOut(t) * S;
                if (t <= 1) {
                    this._flyToFrame = requestAnimFrame(frame, this);
                    this._move(this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom), this.getScaleZoom(w0 / w(s), startZoom), {
                        flyTo: true
                    });
                } else this._move(targetCenter, targetZoom)._moveEnd(true);
            }
            this._moveStart(true, options.noMoveStart);
            frame.call(this);
            return this;
        },
        // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
        // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
        flyToBounds: function(bounds, options) {
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.flyTo(target.center, target.zoom, options);
        },
        // @method setMaxBounds(bounds: LatLngBounds): this
        // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
        setMaxBounds: function(bounds) {
            bounds = toLatLngBounds(bounds);
            if (this.listens('moveend', this._panInsideMaxBounds)) this.off('moveend', this._panInsideMaxBounds);
            if (!bounds.isValid()) {
                this.options.maxBounds = null;
                return this;
            }
            this.options.maxBounds = bounds;
            if (this._loaded) this._panInsideMaxBounds();
            return this.on('moveend', this._panInsideMaxBounds);
        },
        // @method setMinZoom(zoom: Number): this
        // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
        setMinZoom: function(zoom) {
            var oldZoom = this.options.minZoom;
            this.options.minZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire('zoomlevelschange');
                if (this.getZoom() < this.options.minZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method setMaxZoom(zoom: Number): this
        // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
        setMaxZoom: function(zoom) {
            var oldZoom = this.options.maxZoom;
            this.options.maxZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire('zoomlevelschange');
                if (this.getZoom() > this.options.maxZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
        // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
        panInsideBounds: function(bounds, options) {
            this._enforcingBounds = true;
            var center = this.getCenter(), newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
            if (!center.equals(newCenter)) this.panTo(newCenter, options);
            this._enforcingBounds = false;
            return this;
        },
        // @method panInside(latlng: LatLng, options?: padding options): this
        // Pans the map the minimum amount to make the `latlng` visible. Use
        // padding options to fit the display to more restricted bounds.
        // If `latlng` is already within the (optionally padded) display bounds,
        // the map will not be panned.
        panInside: function(latlng, options) {
            options = options || {};
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), pixelCenter = this.project(this.getCenter()), pixelPoint = this.project(latlng), pixelBounds = this.getPixelBounds(), paddedBounds = toBounds([
                pixelBounds.min.add(paddingTL),
                pixelBounds.max.subtract(paddingBR)
            ]), paddedSize = paddedBounds.getSize();
            if (!paddedBounds.contains(pixelPoint)) {
                this._enforcingBounds = true;
                var centerOffset = pixelPoint.subtract(paddedBounds.getCenter());
                var offset = paddedBounds.extend(pixelPoint).getSize().subtract(paddedSize);
                pixelCenter.x += centerOffset.x < 0 ? -offset.x : offset.x;
                pixelCenter.y += centerOffset.y < 0 ? -offset.y : offset.y;
                this.panTo(this.unproject(pixelCenter), options);
                this._enforcingBounds = false;
            }
            return this;
        },
        // @method invalidateSize(options: Zoom/pan options): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default. If `options.pan` is `false`, panning will not occur.
        // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
        // that it doesn't happen often even if the method is called many
        // times in a row.
        // @alternative
        // @method invalidateSize(animate: Boolean): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default.
        invalidateSize: function(options) {
            if (!this._loaded) return this;
            options = extend({
                animate: false,
                pan: true
            }, options === true ? {
                animate: true
            } : options);
            var oldSize = this.getSize();
            this._sizeChanged = true;
            this._lastCenter = null;
            var newSize = this.getSize(), oldCenter = oldSize.divideBy(2).round(), newCenter = newSize.divideBy(2).round(), offset = oldCenter.subtract(newCenter);
            if (!offset.x && !offset.y) return this;
            if (options.animate && options.pan) this.panBy(offset);
            else {
                if (options.pan) this._rawPanBy(offset);
                this.fire('move');
                if (options.debounceMoveend) {
                    clearTimeout(this._sizeTimer);
                    this._sizeTimer = setTimeout(bind(this.fire, this, 'moveend'), 200);
                } else this.fire('moveend');
            }
            // @section Map state change events
            // @event resize: ResizeEvent
            // Fired when the map is resized.
            return this.fire('resize', {
                oldSize: oldSize,
                newSize: newSize
            });
        },
        // @section Methods for modifying map state
        // @method stop(): this
        // Stops the currently running `panTo` or `flyTo` animation, if any.
        stop: function() {
            this.setZoom(this._limitZoom(this._zoom));
            if (!this.options.zoomSnap) this.fire('viewreset');
            return this._stop();
        },
        // @section Geolocation methods
        // @method locate(options?: Locate options): this
        // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
        // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
        // and optionally sets the map view to the user's location with respect to
        // detection accuracy (or to the world view if geolocation failed).
        // Note that, if your page doesn't use HTTPS, this method will fail in
        // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
        // See `Locate options` for more details.
        locate: function(options) {
            options = this._locateOptions = extend({
                timeout: 10000,
                watch: false
            }, options);
            if (!('geolocation' in navigator)) {
                this._handleGeolocationError({
                    code: 0,
                    message: 'Geolocation not supported.'
                });
                return this;
            }
            var onResponse = bind(this._handleGeolocationResponse, this), onError = bind(this._handleGeolocationError, this);
            if (options.watch) this._locationWatchId = navigator.geolocation.watchPosition(onResponse, onError, options);
            else navigator.geolocation.getCurrentPosition(onResponse, onError, options);
            return this;
        },
        // @method stopLocate(): this
        // Stops watching location previously initiated by `map.locate({watch: true})`
        // and aborts resetting the map view if map.locate was called with
        // `{setView: true}`.
        stopLocate: function() {
            if (navigator.geolocation && navigator.geolocation.clearWatch) navigator.geolocation.clearWatch(this._locationWatchId);
            if (this._locateOptions) this._locateOptions.setView = false;
            return this;
        },
        _handleGeolocationError: function(error) {
            if (!this._container._leaflet_id) return;
            var c = error.code, message = error.message || (c === 1 ? 'permission denied' : c === 2 ? 'position unavailable' : 'timeout');
            if (this._locateOptions.setView && !this._loaded) this.fitWorld();
            // @section Location events
            // @event locationerror: ErrorEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method) failed.
            this.fire('locationerror', {
                code: c,
                message: 'Geolocation error: ' + message + '.'
            });
        },
        _handleGeolocationResponse: function(pos) {
            if (!this._container._leaflet_id) return;
            var lat = pos.coords.latitude, lng = pos.coords.longitude, latlng = new LatLng(lat, lng), bounds = latlng.toBounds(pos.coords.accuracy * 2), options = this._locateOptions;
            if (options.setView) {
                var zoom = this.getBoundsZoom(bounds);
                this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
            }
            var data = {
                latlng: latlng,
                bounds: bounds,
                timestamp: pos.timestamp
            };
            for(var i in pos.coords)if (typeof pos.coords[i] === 'number') data[i] = pos.coords[i];
            // @event locationfound: LocationEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method)
            // went successfully.
            this.fire('locationfound', data);
        },
        // TODO Appropriate docs section?
        // @section Other Methods
        // @method addHandler(name: String, HandlerClass: Function): this
        // Adds a new `Handler` to the map, given its name and constructor function.
        addHandler: function(name, HandlerClass) {
            if (!HandlerClass) return this;
            var handler = this[name] = new HandlerClass(this);
            this._handlers.push(handler);
            if (this.options[name]) handler.enable();
            return this;
        },
        // @method remove(): this
        // Destroys the map and clears all related event listeners.
        remove: function() {
            this._initEvents(true);
            if (this.options.maxBounds) this.off('moveend', this._panInsideMaxBounds);
            if (this._containerId !== this._container._leaflet_id) throw new Error('Map container is being reused by another instance');
            try {
                // throws error in IE6-8
                delete this._container._leaflet_id;
                delete this._containerId;
            } catch (e) {
                /*eslint-disable */ this._container._leaflet_id = undefined;
                /* eslint-enable */ this._containerId = undefined;
            }
            if (this._locationWatchId !== undefined) this.stopLocate();
            this._stop();
            remove(this._mapPane);
            if (this._clearControlPos) this._clearControlPos();
            if (this._resizeRequest) {
                cancelAnimFrame(this._resizeRequest);
                this._resizeRequest = null;
            }
            this._clearHandlers();
            if (this._loaded) // @section Map state change events
            // @event unload: Event
            // Fired when the map is destroyed with [remove](#map-remove) method.
            this.fire('unload');
            var i;
            for(i in this._layers)this._layers[i].remove();
            for(i in this._panes)remove(this._panes[i]);
            this._layers = [];
            this._panes = [];
            delete this._mapPane;
            delete this._renderer;
            return this;
        },
        // @section Other Methods
        // @method createPane(name: String, container?: HTMLElement): HTMLElement
        // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
        // then returns it. The pane is created as a child of `container`, or
        // as a child of the main map pane if not set.
        createPane: function(name, container) {
            var className = 'leaflet-pane' + (name ? ' leaflet-' + name.replace('Pane', '') + '-pane' : ''), pane = create$1('div', className, container || this._mapPane);
            if (name) this._panes[name] = pane;
            return pane;
        },
        // @section Methods for Getting Map State
        // @method getCenter(): LatLng
        // Returns the geographical center of the map view
        getCenter: function() {
            this._checkIfLoaded();
            if (this._lastCenter && !this._moved()) return this._lastCenter.clone();
            return this.layerPointToLatLng(this._getCenterLayerPoint());
        },
        // @method getZoom(): Number
        // Returns the current zoom level of the map view
        getZoom: function() {
            return this._zoom;
        },
        // @method getBounds(): LatLngBounds
        // Returns the geographical bounds visible in the current map view
        getBounds: function() {
            var bounds = this.getPixelBounds(), sw = this.unproject(bounds.getBottomLeft()), ne = this.unproject(bounds.getTopRight());
            return new LatLngBounds(sw, ne);
        },
        // @method getMinZoom(): Number
        // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
        getMinZoom: function() {
            return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
        },
        // @method getMaxZoom(): Number
        // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
        getMaxZoom: function() {
            return this.options.maxZoom === undefined ? this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom : this.options.maxZoom;
        },
        // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
        // Returns the maximum zoom level on which the given bounds fit to the map
        // view in its entirety. If `inside` (optional) is set to `true`, the method
        // instead returns the minimum zoom level on which the map view fits into
        // the given bounds in its entirety.
        getBoundsZoom: function(bounds, inside, padding) {
            bounds = toLatLngBounds(bounds);
            padding = toPoint(padding || [
                0,
                0
            ]);
            var zoom = this.getZoom() || 0, min = this.getMinZoom(), max = this.getMaxZoom(), nw = bounds.getNorthWest(), se = bounds.getSouthEast(), size = this.getSize().subtract(padding), boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(), snap = Browser.any3d ? this.options.zoomSnap : 1, scalex = size.x / boundsSize.x, scaley = size.y / boundsSize.y, scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
            zoom = this.getScaleZoom(scale, zoom);
            if (snap) {
                zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
                zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
            }
            return Math.max(min, Math.min(max, zoom));
        },
        // @method getSize(): Point
        // Returns the current size of the map container (in pixels).
        getSize: function() {
            if (!this._size || this._sizeChanged) {
                this._size = new Point(this._container.clientWidth || 0, this._container.clientHeight || 0);
                this._sizeChanged = false;
            }
            return this._size.clone();
        },
        // @method getPixelBounds(): Bounds
        // Returns the bounds of the current map view in projected pixel
        // coordinates (sometimes useful in layer and overlay implementations).
        getPixelBounds: function(center, zoom) {
            var topLeftPoint = this._getTopLeftPoint(center, zoom);
            return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
        },
        // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
        // the map pane? "left point of the map layer" can be confusing, specially
        // since there can be negative offsets.
        // @method getPixelOrigin(): Point
        // Returns the projected pixel coordinates of the top left point of
        // the map layer (useful in custom layer and overlay implementations).
        getPixelOrigin: function() {
            this._checkIfLoaded();
            return this._pixelOrigin;
        },
        // @method getPixelWorldBounds(zoom?: Number): Bounds
        // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
        // If `zoom` is omitted, the map's current zoom level is used.
        getPixelWorldBounds: function(zoom) {
            return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
        },
        // @section Other Methods
        // @method getPane(pane: String|HTMLElement): HTMLElement
        // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
        getPane: function(pane) {
            return typeof pane === 'string' ? this._panes[pane] : pane;
        },
        // @method getPanes(): Object
        // Returns a plain object containing the names of all [panes](#map-pane) as keys and
        // the panes as values.
        getPanes: function() {
            return this._panes;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the map.
        getContainer: function() {
            return this._container;
        },
        // @section Conversion Methods
        // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
        // Returns the scale factor to be applied to a map transition from zoom level
        // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
        getZoomScale: function(toZoom, fromZoom) {
            // TODO replace with universal implementation after refactoring projections
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            return crs.scale(toZoom) / crs.scale(fromZoom);
        },
        // @method getScaleZoom(scale: Number, fromZoom: Number): Number
        // Returns the zoom level that the map would end up at, if it is at `fromZoom`
        // level and everything is scaled by a factor of `scale`. Inverse of
        // [`getZoomScale`](#map-getZoomScale).
        getScaleZoom: function(scale, fromZoom) {
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            var zoom = crs.zoom(scale * crs.scale(fromZoom));
            return isNaN(zoom) ? Infinity : zoom;
        },
        // @method project(latlng: LatLng, zoom: Number): Point
        // Projects a geographical coordinate `LatLng` according to the projection
        // of the map's CRS, then scales it according to `zoom` and the CRS's
        // `Transformation`. The result is pixel coordinate relative to
        // the CRS origin.
        project: function(latlng, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
        },
        // @method unproject(point: Point, zoom: Number): LatLng
        // Inverse of [`project`](#map-project).
        unproject: function(point, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.pointToLatLng(toPoint(point), zoom);
        },
        // @method layerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding geographical coordinate (for the current zoom level).
        layerPointToLatLng: function(point) {
            var projectedPoint = toPoint(point).add(this.getPixelOrigin());
            return this.unproject(projectedPoint);
        },
        // @method latLngToLayerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the [origin pixel](#map-getpixelorigin).
        latLngToLayerPoint: function(latlng) {
            var projectedPoint = this.project(toLatLng(latlng))._round();
            return projectedPoint._subtract(this.getPixelOrigin());
        },
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
        // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
        // CRS's bounds.
        // By default this means longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees.
        wrapLatLng: function(latlng) {
            return this.options.crs.wrapLatLng(toLatLng(latlng));
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring that
        // its center is within the CRS's bounds.
        // By default this means the center longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees, and the majority of the bounds
        // overlaps the CRS's bounds.
        wrapLatLngBounds: function(latlng) {
            return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates according to
        // the map's CRS. By default this measures distance in meters.
        distance: function(latlng1, latlng2) {
            return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
        },
        // @method containerPointToLayerPoint(point: Point): Point
        // Given a pixel coordinate relative to the map container, returns the corresponding
        // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
        containerPointToLayerPoint: function(point) {
            return toPoint(point).subtract(this._getMapPanePos());
        },
        // @method layerPointToContainerPoint(point: Point): Point
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding pixel coordinate relative to the map container.
        layerPointToContainerPoint: function(point) {
            return toPoint(point).add(this._getMapPanePos());
        },
        // @method containerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the map container, returns
        // the corresponding geographical coordinate (for the current zoom level).
        containerPointToLatLng: function(point) {
            var layerPoint = this.containerPointToLayerPoint(toPoint(point));
            return this.layerPointToLatLng(layerPoint);
        },
        // @method latLngToContainerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the map container.
        latLngToContainerPoint: function(latlng) {
            return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
        },
        // @method mouseEventToContainerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to the
        // map container where the event took place.
        mouseEventToContainerPoint: function(e) {
            return getMousePosition(e, this._container);
        },
        // @method mouseEventToLayerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to
        // the [origin pixel](#map-getpixelorigin) where the event took place.
        mouseEventToLayerPoint: function(e) {
            return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
        },
        // @method mouseEventToLatLng(ev: MouseEvent): LatLng
        // Given a MouseEvent object, returns geographical coordinate where the
        // event took place.
        mouseEventToLatLng: function(e) {
            return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
        },
        // map initialization methods
        _initContainer: function(id) {
            var container = this._container = get(id);
            if (!container) throw new Error('Map container not found.');
            else if (container._leaflet_id) throw new Error('Map container is already initialized.');
            on(container, 'scroll', this._onScroll, this);
            this._containerId = stamp(container);
        },
        _initLayout: function() {
            var container = this._container;
            this._fadeAnimated = this.options.fadeAnimation && Browser.any3d;
            addClass(container, 'leaflet-container' + (Browser.touch ? ' leaflet-touch' : '') + (Browser.retina ? ' leaflet-retina' : '') + (Browser.ielt9 ? ' leaflet-oldie' : '') + (Browser.safari ? ' leaflet-safari' : '') + (this._fadeAnimated ? ' leaflet-fade-anim' : ''));
            var position = getStyle(container, 'position');
            if (position !== 'absolute' && position !== 'relative' && position !== 'fixed' && position !== 'sticky') container.style.position = 'relative';
            this._initPanes();
            if (this._initControlPos) this._initControlPos();
        },
        _initPanes: function() {
            var panes = this._panes = {};
            this._paneRenderers = {};
            // @section
            //
            // Panes are DOM elements used to control the ordering of layers on the map. You
            // can access panes with [`map.getPane`](#map-getpane) or
            // [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
            // [`map.createPane`](#map-createpane) method.
            //
            // Every map has the following default panes that differ only in zIndex.
            //
            // @pane mapPane: HTMLElement = 'auto'
            // Pane that contains all other map panes
            this._mapPane = this.createPane('mapPane', this._container);
            setPosition(this._mapPane, new Point(0, 0));
            // @pane tilePane: HTMLElement = 200
            // Pane for `GridLayer`s and `TileLayer`s
            this.createPane('tilePane');
            // @pane overlayPane: HTMLElement = 400
            // Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
            this.createPane('overlayPane');
            // @pane shadowPane: HTMLElement = 500
            // Pane for overlay shadows (e.g. `Marker` shadows)
            this.createPane('shadowPane');
            // @pane markerPane: HTMLElement = 600
            // Pane for `Icon`s of `Marker`s
            this.createPane('markerPane');
            // @pane tooltipPane: HTMLElement = 650
            // Pane for `Tooltip`s.
            this.createPane('tooltipPane');
            // @pane popupPane: HTMLElement = 700
            // Pane for `Popup`s.
            this.createPane('popupPane');
            if (!this.options.markerZoomAnimation) {
                addClass(panes.markerPane, 'leaflet-zoom-hide');
                addClass(panes.shadowPane, 'leaflet-zoom-hide');
            }
        },
        // private methods that modify map state
        // @section Map state change events
        _resetView: function(center, zoom, noMoveStart) {
            setPosition(this._mapPane, new Point(0, 0));
            var loading = !this._loaded;
            this._loaded = true;
            zoom = this._limitZoom(zoom);
            this.fire('viewprereset');
            var zoomChanged = this._zoom !== zoom;
            this._moveStart(zoomChanged, noMoveStart)._move(center, zoom)._moveEnd(zoomChanged);
            // @event viewreset: Event
            // Fired when the map needs to redraw its content (this usually happens
            // on map zoom or load). Very useful for creating custom overlays.
            this.fire('viewreset');
            // @event load: Event
            // Fired when the map is initialized (when its center and zoom are set
            // for the first time).
            if (loading) this.fire('load');
        },
        _moveStart: function(zoomChanged, noMoveStart) {
            // @event zoomstart: Event
            // Fired when the map zoom is about to change (e.g. before zoom animation).
            // @event movestart: Event
            // Fired when the view of the map starts changing (e.g. user starts dragging the map).
            if (zoomChanged) this.fire('zoomstart');
            if (!noMoveStart) this.fire('movestart');
            return this;
        },
        _move: function(center, zoom, data, supressEvent) {
            if (zoom === undefined) zoom = this._zoom;
            var zoomChanged = this._zoom !== zoom;
            this._zoom = zoom;
            this._lastCenter = center;
            this._pixelOrigin = this._getNewPixelOrigin(center);
            if (!supressEvent) {
                // @event zoom: Event
                // Fired repeatedly during any change in zoom level,
                // including zoom and fly animations.
                if (zoomChanged || data && data.pinch) this.fire('zoom', data);
                // @event move: Event
                // Fired repeatedly during any movement of the map,
                // including pan and fly animations.
                this.fire('move', data);
            } else if (data && data.pinch) this.fire('zoom', data);
            return this;
        },
        _moveEnd: function(zoomChanged) {
            // @event zoomend: Event
            // Fired when the map zoom changed, after any animations.
            if (zoomChanged) this.fire('zoomend');
            // @event moveend: Event
            // Fired when the center of the map stops changing
            // (e.g. user stopped dragging the map or after non-centered zoom).
            return this.fire('moveend');
        },
        _stop: function() {
            cancelAnimFrame(this._flyToFrame);
            if (this._panAnim) this._panAnim.stop();
            return this;
        },
        _rawPanBy: function(offset) {
            setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
        },
        _getZoomSpan: function() {
            return this.getMaxZoom() - this.getMinZoom();
        },
        _panInsideMaxBounds: function() {
            if (!this._enforcingBounds) this.panInsideBounds(this.options.maxBounds);
        },
        _checkIfLoaded: function() {
            if (!this._loaded) throw new Error('Set map center and zoom first.');
        },
        // DOM event handling
        // @section Interaction events
        _initEvents: function(remove) {
            this._targets = {};
            this._targets[stamp(this._container)] = this;
            var onOff = remove ? off : on;
            // @event click: MouseEvent
            // Fired when the user clicks (or taps) the map.
            // @event dblclick: MouseEvent
            // Fired when the user double-clicks (or double-taps) the map.
            // @event mousedown: MouseEvent
            // Fired when the user pushes the mouse button on the map.
            // @event mouseup: MouseEvent
            // Fired when the user releases the mouse button on the map.
            // @event mouseover: MouseEvent
            // Fired when the mouse enters the map.
            // @event mouseout: MouseEvent
            // Fired when the mouse leaves the map.
            // @event mousemove: MouseEvent
            // Fired while the mouse moves over the map.
            // @event contextmenu: MouseEvent
            // Fired when the user pushes the right mouse button on the map, prevents
            // default browser context menu from showing if there are listeners on
            // this event. Also fired on mobile when the user holds a single touch
            // for a second (also called long press).
            // @event keypress: KeyboardEvent
            // Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
            // @event keydown: KeyboardEvent
            // Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
            // the `keydown` event is fired for keys that produce a character value and for keys
            // that do not produce a character value.
            // @event keyup: KeyboardEvent
            // Fired when the user releases a key from the keyboard while the map is focused.
            onOff(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this);
            if (this.options.trackResize) onOff(window, 'resize', this._onResize, this);
            if (Browser.any3d && this.options.transform3DLimit) (remove ? this.off : this.on).call(this, 'moveend', this._onMoveEnd);
        },
        _onResize: function() {
            cancelAnimFrame(this._resizeRequest);
            this._resizeRequest = requestAnimFrame(function() {
                this.invalidateSize({
                    debounceMoveend: true
                });
            }, this);
        },
        _onScroll: function() {
            this._container.scrollTop = 0;
            this._container.scrollLeft = 0;
        },
        _onMoveEnd: function() {
            var pos = this._getMapPanePos();
            if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) // https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
            // a pixel offset on very high values, see: https://jsfiddle.net/dg6r5hhb/
            this._resetView(this.getCenter(), this.getZoom());
        },
        _findEventTargets: function(e, type) {
            var targets = [], target, isHover = type === 'mouseout' || type === 'mouseover', src = e.target || e.srcElement, dragging = false;
            while(src){
                target = this._targets[stamp(src)];
                if (target && (type === 'click' || type === 'preclick') && this._draggableMoved(target)) {
                    // Prevent firing click after you just dragged an object.
                    dragging = true;
                    break;
                }
                if (target && target.listens(type, true)) {
                    if (isHover && !isExternalTarget(src, e)) break;
                    targets.push(target);
                    if (isHover) break;
                }
                if (src === this._container) break;
                src = src.parentNode;
            }
            if (!targets.length && !dragging && !isHover && this.listens(type, true)) targets = [
                this
            ];
            return targets;
        },
        _isClickDisabled: function(el) {
            while(el && el !== this._container){
                if (el['_leaflet_disable_click']) return true;
                el = el.parentNode;
            }
        },
        _handleDOMEvent: function(e) {
            var el = e.target || e.srcElement;
            if (!this._loaded || el['_leaflet_disable_events'] || e.type === 'click' && this._isClickDisabled(el)) return;
            var type = e.type;
            if (type === 'mousedown') // prevents outline when clicking on keyboard-focusable element
            preventOutline(el);
            this._fireDOMEvent(e, type);
        },
        _mouseEvents: [
            'click',
            'dblclick',
            'mouseover',
            'mouseout',
            'contextmenu'
        ],
        _fireDOMEvent: function(e, type, canvasTargets) {
            if (e.type === 'click') {
                // Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
                // @event preclick: MouseEvent
                // Fired before mouse click on the map (sometimes useful when you
                // want something to happen on click before any existing click
                // handlers start running).
                var synth = extend({}, e);
                synth.type = 'preclick';
                this._fireDOMEvent(synth, synth.type, canvasTargets);
            }
            // Find the layer the event is propagating from and its parents.
            var targets = this._findEventTargets(e, type);
            if (canvasTargets) {
                var filtered = []; // pick only targets with listeners
                for(var i = 0; i < canvasTargets.length; i++)if (canvasTargets[i].listens(type, true)) filtered.push(canvasTargets[i]);
                targets = filtered.concat(targets);
            }
            if (!targets.length) return;
            if (type === 'contextmenu') preventDefault(e);
            var target = targets[0];
            var data = {
                originalEvent: e
            };
            if (e.type !== 'keypress' && e.type !== 'keydown' && e.type !== 'keyup') {
                var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
                data.containerPoint = isMarker ? this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
                data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
                data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
            }
            for(i = 0; i < targets.length; i++){
                targets[i].fire(type, data, true);
                if (data.originalEvent._stopped || targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1) return;
            }
        },
        _draggableMoved: function(obj) {
            obj = obj.dragging && obj.dragging.enabled() ? obj : this;
            return obj.dragging && obj.dragging.moved() || this.boxZoom && this.boxZoom.moved();
        },
        _clearHandlers: function() {
            for(var i = 0, len = this._handlers.length; i < len; i++)this._handlers[i].disable();
        },
        // @section Other Methods
        // @method whenReady(fn: Function, context?: Object): this
        // Runs the given function `fn` when the map gets initialized with
        // a view (center and zoom) and at least one layer, or immediately
        // if it's already initialized, optionally passing a function context.
        whenReady: function(callback, context) {
            if (this._loaded) callback.call(context || this, {
                target: this
            });
            else this.on('load', callback, context);
            return this;
        },
        // private methods for getting map state
        _getMapPanePos: function() {
            return getPosition(this._mapPane) || new Point(0, 0);
        },
        _moved: function() {
            var pos = this._getMapPanePos();
            return pos && !pos.equals([
                0,
                0
            ]);
        },
        _getTopLeftPoint: function(center, zoom) {
            var pixelOrigin = center && zoom !== undefined ? this._getNewPixelOrigin(center, zoom) : this.getPixelOrigin();
            return pixelOrigin.subtract(this._getMapPanePos());
        },
        _getNewPixelOrigin: function(center, zoom) {
            var viewHalf = this.getSize()._divideBy(2);
            return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
        },
        _latLngToNewLayerPoint: function(latlng, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return this.project(latlng, zoom)._subtract(topLeft);
        },
        _latLngBoundsToNewLayerBounds: function(latLngBounds, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return toBounds([
                this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
            ]);
        },
        // layer point of the current center
        _getCenterLayerPoint: function() {
            return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
        },
        // offset of the specified place to the current center in pixels
        _getCenterOffset: function(latlng) {
            return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
        },
        // adjust center for view to get inside bounds
        _limitCenter: function(center, zoom, bounds) {
            if (!bounds) return center;
            var centerPoint = this.project(center, zoom), viewHalf = this.getSize().divideBy(2), viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)), offset = this._getBoundsOffset(viewBounds, bounds, zoom);
            // If offset is less than a pixel, ignore.
            // This prevents unstable projections from getting into
            // an infinite loop of tiny offsets.
            if (Math.abs(offset.x) <= 1 && Math.abs(offset.y) <= 1) return center;
            return this.unproject(centerPoint.add(offset), zoom);
        },
        // adjust offset for view to get inside bounds
        _limitOffset: function(offset, bounds) {
            if (!bounds) return offset;
            var viewBounds = this.getPixelBounds(), newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
            return offset.add(this._getBoundsOffset(newBounds, bounds));
        },
        // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
        _getBoundsOffset: function(pxBounds, maxBounds, zoom) {
            var projectedMaxBounds = toBounds(this.project(maxBounds.getNorthEast(), zoom), this.project(maxBounds.getSouthWest(), zoom)), minOffset = projectedMaxBounds.min.subtract(pxBounds.min), maxOffset = projectedMaxBounds.max.subtract(pxBounds.max), dx = this._rebound(minOffset.x, -maxOffset.x), dy = this._rebound(minOffset.y, -maxOffset.y);
            return new Point(dx, dy);
        },
        _rebound: function(left, right) {
            return left + right > 0 ? Math.round(left - right) / 2 : Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
        },
        _limitZoom: function(zoom) {
            var min = this.getMinZoom(), max = this.getMaxZoom(), snap = Browser.any3d ? this.options.zoomSnap : 1;
            if (snap) zoom = Math.round(zoom / snap) * snap;
            return Math.max(min, Math.min(max, zoom));
        },
        _onPanTransitionStep: function() {
            this.fire('move');
        },
        _onPanTransitionEnd: function() {
            removeClass(this._mapPane, 'leaflet-pan-anim');
            this.fire('moveend');
        },
        _tryAnimatedPan: function(center, options) {
            // difference between the new and current centers in pixels
            var offset = this._getCenterOffset(center)._trunc();
            // don't animate too far unless animate: true specified in options
            if ((options && options.animate) !== true && !this.getSize().contains(offset)) return false;
            this.panBy(offset, options);
            return true;
        },
        _createAnimProxy: function() {
            var proxy = this._proxy = create$1('div', 'leaflet-proxy leaflet-zoom-animated');
            this._panes.mapPane.appendChild(proxy);
            this.on('zoomanim', function(e) {
                var prop = TRANSFORM, transform = this._proxy.style[prop];
                setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
                // workaround for case when transform is the same and so transitionend event is not fired
                if (transform === this._proxy.style[prop] && this._animatingZoom) this._onZoomTransitionEnd();
            }, this);
            this.on('load moveend', this._animMoveEnd, this);
            this._on('unload', this._destroyAnimProxy, this);
        },
        _destroyAnimProxy: function() {
            remove(this._proxy);
            this.off('load moveend', this._animMoveEnd, this);
            delete this._proxy;
        },
        _animMoveEnd: function() {
            var c = this.getCenter(), z = this.getZoom();
            setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
        },
        _catchTransitionEnd: function(e) {
            if (this._animatingZoom && e.propertyName.indexOf('transform') >= 0) this._onZoomTransitionEnd();
        },
        _nothingToAnimate: function() {
            return !this._container.getElementsByClassName('leaflet-zoom-animated').length;
        },
        _tryAnimatedZoom: function(center, zoom, options) {
            if (this._animatingZoom) return true;
            options = options || {};
            // don't animate if disabled, not supported or zoom difference is too large
            if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() || Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) return false;
            // offset is the pixel coords of the zoom origin relative to the current center
            var scale = this.getZoomScale(zoom), offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
            // don't animate if the zoom origin isn't within one screen from the current center, unless forced
            if (options.animate !== true && !this.getSize().contains(offset)) return false;
            requestAnimFrame(function() {
                this._moveStart(true, options.noMoveStart || false)._animateZoom(center, zoom, true);
            }, this);
            return true;
        },
        _animateZoom: function(center, zoom, startAnim, noUpdate) {
            if (!this._mapPane) return;
            if (startAnim) {
                this._animatingZoom = true;
                // remember what center/zoom to set after animation
                this._animateToCenter = center;
                this._animateToZoom = zoom;
                addClass(this._mapPane, 'leaflet-zoom-anim');
            }
            // @section Other Events
            // @event zoomanim: ZoomAnimEvent
            // Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
            this.fire('zoomanim', {
                center: center,
                zoom: zoom,
                noUpdate: noUpdate
            });
            if (!this._tempFireZoomEvent) this._tempFireZoomEvent = this._zoom !== this._animateToZoom;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            // Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
            setTimeout(bind(this._onZoomTransitionEnd, this), 250);
        },
        _onZoomTransitionEnd: function() {
            if (!this._animatingZoom) return;
            if (this._mapPane) removeClass(this._mapPane, 'leaflet-zoom-anim');
            this._animatingZoom = false;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            if (this._tempFireZoomEvent) this.fire('zoom');
            delete this._tempFireZoomEvent;
            this.fire('move');
            this._moveEnd(true);
        }
    });
    // @section
    // @factory L.map(id: String, options?: Map options)
    // Instantiates a map object given the DOM ID of a `<div>` element
    // and optionally an object literal with `Map options`.
    //
    // @alternative
    // @factory L.map(el: HTMLElement, options?: Map options)
    // Instantiates a map object given an instance of a `<div>` HTML element
    // and optionally an object literal with `Map options`.
    function createMap(id, options) {
        return new Map(id, options);
    }
    /*
   * @class Control
   * @aka L.Control
   * @inherits Class
   *
   * L.Control is a base class for implementing map controls. Handles positioning.
   * All other controls extend from this class.
   */ var Control = Class.extend({
        // @section
        // @aka Control Options
        options: {
            // @option position: String = 'topright'
            // The position of the control (one of the map corners). Possible values are `'topleft'`,
            // `'topright'`, `'bottomleft'` or `'bottomright'`
            position: 'topright'
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        /* @section
  	 * Classes extending L.Control will inherit the following methods:
  	 *
  	 * @method getPosition: string
  	 * Returns the position of the control.
  	 */ getPosition: function() {
            return this.options.position;
        },
        // @method setPosition(position: string): this
        // Sets the position of the control.
        setPosition: function(position) {
            var map = this._map;
            if (map) map.removeControl(this);
            this.options.position = position;
            if (map) map.addControl(this);
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTMLElement that contains the control.
        getContainer: function() {
            return this._container;
        },
        // @method addTo(map: Map): this
        // Adds the control to the given map.
        addTo: function(map) {
            this.remove();
            this._map = map;
            var container = this._container = this.onAdd(map), pos = this.getPosition(), corner = map._controlCorners[pos];
            addClass(container, 'leaflet-control');
            if (pos.indexOf('bottom') !== -1) corner.insertBefore(container, corner.firstChild);
            else corner.appendChild(container);
            this._map.on('unload', this.remove, this);
            return this;
        },
        // @method remove: this
        // Removes the control from the map it is currently active on.
        remove: function() {
            if (!this._map) return this;
            remove(this._container);
            if (this.onRemove) this.onRemove(this._map);
            this._map.off('unload', this.remove, this);
            this._map = null;
            return this;
        },
        _refocusOnMap: function(e) {
            // if map exists and event is not a keyboard event
            if (this._map && e && e.screenX > 0 && e.screenY > 0) this._map.getContainer().focus();
        }
    });
    var control = function(options) {
        return new Control(options);
    };
    /* @section Extension methods
   * @uninheritable
   *
   * Every control should extend from `L.Control` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): HTMLElement
   * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
   *
   * @method onRemove(map: Map)
   * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
   */ /* @namespace Map
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addControl(control: Control): this
        // Adds the given control to the map
        addControl: function(control) {
            control.addTo(this);
            return this;
        },
        // @method removeControl(control: Control): this
        // Removes the given control from the map
        removeControl: function(control) {
            control.remove();
            return this;
        },
        _initControlPos: function() {
            var corners = this._controlCorners = {}, l = 'leaflet-', container = this._controlContainer = create$1('div', l + 'control-container', this._container);
            function createCorner(vSide, hSide) {
                var className = l + vSide + ' ' + l + hSide;
                corners[vSide + hSide] = create$1('div', className, container);
            }
            createCorner('top', 'left');
            createCorner('top', 'right');
            createCorner('bottom', 'left');
            createCorner('bottom', 'right');
        },
        _clearControlPos: function() {
            for(var i in this._controlCorners)remove(this._controlCorners[i]);
            remove(this._controlContainer);
            delete this._controlCorners;
            delete this._controlContainer;
        }
    });
    /*
   * @class Control.Layers
   * @aka L.Control.Layers
   * @inherits Control
   *
   * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](https://leafletjs.com/examples/layers-control/)). Extends `Control`.
   *
   * @example
   *
   * ```js
   * var baseLayers = {
   * 	"Mapbox": mapbox,
   * 	"OpenStreetMap": osm
   * };
   *
   * var overlays = {
   * 	"Marker": marker,
   * 	"Roads": roadsLayer
   * };
   *
   * L.control.layers(baseLayers, overlays).addTo(map);
   * ```
   *
   * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
   *
   * ```js
   * {
   *     "<someName1>": layer1,
   *     "<someName2>": layer2
   * }
   * ```
   *
   * The layer names can contain HTML, which allows you to add additional styling to the items:
   *
   * ```js
   * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
   * ```
   */ var Layers = Control.extend({
        // @section
        // @aka Control.Layers options
        options: {
            // @option collapsed: Boolean = true
            // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
            collapsed: true,
            position: 'topright',
            // @option autoZIndex: Boolean = true
            // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
            autoZIndex: true,
            // @option hideSingleBase: Boolean = false
            // If `true`, the base layers in the control will be hidden when there is only one.
            hideSingleBase: false,
            // @option sortLayers: Boolean = false
            // Whether to sort the layers. When `false`, layers will keep the order
            // in which they were added to the control.
            sortLayers: false,
            // @option sortFunction: Function = *
            // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
            // that will be used for sorting the layers, when `sortLayers` is `true`.
            // The function receives both the `L.Layer` instances and their names, as in
            // `sortFunction(layerA, layerB, nameA, nameB)`.
            // By default, it sorts layers alphabetically by their name.
            sortFunction: function(layerA, layerB, nameA, nameB) {
                return nameA < nameB ? -1 : nameB < nameA ? 1 : 0;
            }
        },
        initialize: function(baseLayers, overlays, options) {
            setOptions(this, options);
            this._layerControlInputs = [];
            this._layers = [];
            this._lastZIndex = 0;
            this._handlingClick = false;
            this._preventClick = false;
            for(var i in baseLayers)this._addLayer(baseLayers[i], i);
            for(i in overlays)this._addLayer(overlays[i], i, true);
        },
        onAdd: function(map) {
            this._initLayout();
            this._update();
            this._map = map;
            map.on('zoomend', this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.on('add remove', this._onLayerChange, this);
            return this._container;
        },
        addTo: function(map) {
            Control.prototype.addTo.call(this, map);
            // Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
            return this._expandIfNotCollapsed();
        },
        onRemove: function() {
            this._map.off('zoomend', this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.off('add remove', this._onLayerChange, this);
        },
        // @method addBaseLayer(layer: Layer, name: String): this
        // Adds a base layer (radio button entry) with the given name to the control.
        addBaseLayer: function(layer, name) {
            this._addLayer(layer, name);
            return this._map ? this._update() : this;
        },
        // @method addOverlay(layer: Layer, name: String): this
        // Adds an overlay (checkbox entry) with the given name to the control.
        addOverlay: function(layer, name) {
            this._addLayer(layer, name, true);
            return this._map ? this._update() : this;
        },
        // @method removeLayer(layer: Layer): this
        // Remove the given layer from the control.
        removeLayer: function(layer) {
            layer.off('add remove', this._onLayerChange, this);
            var obj = this._getLayer(stamp(layer));
            if (obj) this._layers.splice(this._layers.indexOf(obj), 1);
            return this._map ? this._update() : this;
        },
        // @method expand(): this
        // Expand the control container if collapsed.
        expand: function() {
            addClass(this._container, 'leaflet-control-layers-expanded');
            this._section.style.height = null;
            var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
            if (acceptableHeight < this._section.clientHeight) {
                addClass(this._section, 'leaflet-control-layers-scrollbar');
                this._section.style.height = acceptableHeight + 'px';
            } else removeClass(this._section, 'leaflet-control-layers-scrollbar');
            this._checkDisabledLayers();
            return this;
        },
        // @method collapse(): this
        // Collapse the control container if expanded.
        collapse: function() {
            removeClass(this._container, 'leaflet-control-layers-expanded');
            return this;
        },
        _initLayout: function() {
            var className = 'leaflet-control-layers', container = this._container = create$1('div', className), collapsed = this.options.collapsed;
            // makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
            container.setAttribute('aria-haspopup', true);
            disableClickPropagation(container);
            disableScrollPropagation(container);
            var section = this._section = create$1('section', className + '-list');
            if (collapsed) {
                this._map.on('click', this.collapse, this);
                on(container, {
                    mouseenter: this._expandSafely,
                    mouseleave: this.collapse
                }, this);
            }
            var link = this._layersLink = create$1('a', className + '-toggle', container);
            link.href = '#';
            link.title = 'Layers';
            link.setAttribute('role', 'button');
            on(link, {
                keydown: function(e) {
                    if (e.keyCode === 13) this._expandSafely();
                },
                // Certain screen readers intercept the key event and instead send a click event
                click: function(e) {
                    preventDefault(e);
                    this._expandSafely();
                }
            }, this);
            if (!collapsed) this.expand();
            this._baseLayersList = create$1('div', className + '-base', section);
            this._separator = create$1('div', className + '-separator', section);
            this._overlaysList = create$1('div', className + '-overlays', section);
            container.appendChild(section);
        },
        _getLayer: function(id) {
            for(var i = 0; i < this._layers.length; i++){
                if (this._layers[i] && stamp(this._layers[i].layer) === id) return this._layers[i];
            }
        },
        _addLayer: function(layer, name, overlay) {
            if (this._map) layer.on('add remove', this._onLayerChange, this);
            this._layers.push({
                layer: layer,
                name: name,
                overlay: overlay
            });
            if (this.options.sortLayers) this._layers.sort(bind(function(a, b) {
                return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
            }, this));
            if (this.options.autoZIndex && layer.setZIndex) {
                this._lastZIndex++;
                layer.setZIndex(this._lastZIndex);
            }
            this._expandIfNotCollapsed();
        },
        _update: function() {
            if (!this._container) return this;
            empty(this._baseLayersList);
            empty(this._overlaysList);
            this._layerControlInputs = [];
            var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
            for(i = 0; i < this._layers.length; i++){
                obj = this._layers[i];
                this._addItem(obj);
                overlaysPresent = overlaysPresent || obj.overlay;
                baseLayersPresent = baseLayersPresent || !obj.overlay;
                baseLayersCount += !obj.overlay ? 1 : 0;
            }
            // Hide base layers section if there's only one layer.
            if (this.options.hideSingleBase) {
                baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
                this._baseLayersList.style.display = baseLayersPresent ? '' : 'none';
            }
            this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';
            return this;
        },
        _onLayerChange: function(e) {
            if (!this._handlingClick) this._update();
            var obj = this._getLayer(stamp(e.target));
            // @namespace Map
            // @section Layer events
            // @event baselayerchange: LayersControlEvent
            // Fired when the base layer is changed through the [layers control](#control-layers).
            // @event overlayadd: LayersControlEvent
            // Fired when an overlay is selected through the [layers control](#control-layers).
            // @event overlayremove: LayersControlEvent
            // Fired when an overlay is deselected through the [layers control](#control-layers).
            // @namespace Control.Layers
            var type = obj.overlay ? e.type === 'add' ? 'overlayadd' : 'overlayremove' : e.type === 'add' ? 'baselayerchange' : null;
            if (type) this._map.fire(type, obj);
        },
        // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
        _createRadioElement: function(name, checked) {
            var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"' + (checked ? ' checked="checked"' : '') + '/>';
            var radioFragment = document.createElement('div');
            radioFragment.innerHTML = radioHtml;
            return radioFragment.firstChild;
        },
        _addItem: function(obj) {
            var label = document.createElement('label'), checked = this._map.hasLayer(obj.layer), input;
            if (obj.overlay) {
                input = document.createElement('input');
                input.type = 'checkbox';
                input.className = 'leaflet-control-layers-selector';
                input.defaultChecked = checked;
            } else input = this._createRadioElement('leaflet-base-layers_' + stamp(this), checked);
            this._layerControlInputs.push(input);
            input.layerId = stamp(obj.layer);
            on(input, 'click', this._onInputClick, this);
            var name = document.createElement('span');
            name.innerHTML = ' ' + obj.name;
            // Helps from preventing layer control flicker when checkboxes are disabled
            // https://github.com/Leaflet/Leaflet/issues/2771
            var holder = document.createElement('span');
            label.appendChild(holder);
            holder.appendChild(input);
            holder.appendChild(name);
            var container = obj.overlay ? this._overlaysList : this._baseLayersList;
            container.appendChild(label);
            this._checkDisabledLayers();
            return label;
        },
        _onInputClick: function() {
            // expanding the control on mobile with a click can cause adding a layer - we don't want this
            if (this._preventClick) return;
            var inputs = this._layerControlInputs, input, layer;
            var addedLayers = [], removedLayers = [];
            this._handlingClick = true;
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                if (input.checked) addedLayers.push(layer);
                else if (!input.checked) removedLayers.push(layer);
            }
            // Bugfix issue 2318: Should remove all old layers before readding new ones
            for(i = 0; i < removedLayers.length; i++)if (this._map.hasLayer(removedLayers[i])) this._map.removeLayer(removedLayers[i]);
            for(i = 0; i < addedLayers.length; i++)if (!this._map.hasLayer(addedLayers[i])) this._map.addLayer(addedLayers[i]);
            this._handlingClick = false;
            this._refocusOnMap();
        },
        _checkDisabledLayers: function() {
            var inputs = this._layerControlInputs, input, layer, zoom = this._map.getZoom();
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                input.disabled = layer.options.minZoom !== undefined && zoom < layer.options.minZoom || layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom;
            }
        },
        _expandIfNotCollapsed: function() {
            if (this._map && !this.options.collapsed) this.expand();
            return this;
        },
        _expandSafely: function() {
            var section = this._section;
            this._preventClick = true;
            on(section, 'click', preventDefault);
            this.expand();
            var that = this;
            setTimeout(function() {
                off(section, 'click', preventDefault);
                that._preventClick = false;
            });
        }
    });
    // @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
    // Creates a layers control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
    var layers = function(baseLayers, overlays, options) {
        return new Layers(baseLayers, overlays, options);
    };
    /*
   * @class Control.Zoom
   * @aka L.Control.Zoom
   * @inherits Control
   *
   * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
   */ var Zoom = Control.extend({
        // @section
        // @aka Control.Zoom options
        options: {
            position: 'topleft',
            // @option zoomInText: String = '<span aria-hidden="true">+</span>'
            // The text set on the 'zoom in' button.
            zoomInText: '<span aria-hidden="true">+</span>',
            // @option zoomInTitle: String = 'Zoom in'
            // The title set on the 'zoom in' button.
            zoomInTitle: 'Zoom in',
            // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
            // The text set on the 'zoom out' button.
            zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
            // @option zoomOutTitle: String = 'Zoom out'
            // The title set on the 'zoom out' button.
            zoomOutTitle: 'Zoom out'
        },
        onAdd: function(map) {
            var zoomName = 'leaflet-control-zoom', container = create$1('div', zoomName + ' leaflet-bar'), options = this.options;
            this._zoomInButton = this._createButton(options.zoomInText, options.zoomInTitle, zoomName + '-in', container, this._zoomIn);
            this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle, zoomName + '-out', container, this._zoomOut);
            this._updateDisabled();
            map.on('zoomend zoomlevelschange', this._updateDisabled, this);
            return container;
        },
        onRemove: function(map) {
            map.off('zoomend zoomlevelschange', this._updateDisabled, this);
        },
        disable: function() {
            this._disabled = true;
            this._updateDisabled();
            return this;
        },
        enable: function() {
            this._disabled = false;
            this._updateDisabled();
            return this;
        },
        _zoomIn: function(e) {
            if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _zoomOut: function(e) {
            if (!this._disabled && this._map._zoom > this._map.getMinZoom()) this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _createButton: function(html, title, className, container, fn) {
            var link = create$1('a', className, container);
            link.innerHTML = html;
            link.href = '#';
            link.title = title;
            /*
  		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
  		 */ link.setAttribute('role', 'button');
            link.setAttribute('aria-label', title);
            disableClickPropagation(link);
            on(link, 'click', stop);
            on(link, 'click', fn, this);
            on(link, 'click', this._refocusOnMap, this);
            return link;
        },
        _updateDisabled: function() {
            var map = this._map, className = 'leaflet-disabled';
            removeClass(this._zoomInButton, className);
            removeClass(this._zoomOutButton, className);
            this._zoomInButton.setAttribute('aria-disabled', 'false');
            this._zoomOutButton.setAttribute('aria-disabled', 'false');
            if (this._disabled || map._zoom === map.getMinZoom()) {
                addClass(this._zoomOutButton, className);
                this._zoomOutButton.setAttribute('aria-disabled', 'true');
            }
            if (this._disabled || map._zoom === map.getMaxZoom()) {
                addClass(this._zoomInButton, className);
                this._zoomInButton.setAttribute('aria-disabled', 'true');
            }
        }
    });
    // @namespace Map
    // @section Control options
    // @option zoomControl: Boolean = true
    // Whether a [zoom control](#control-zoom) is added to the map by default.
    Map.mergeOptions({
        zoomControl: true
    });
    Map.addInitHook(function() {
        if (this.options.zoomControl) {
            // @section Controls
            // @property zoomControl: Control.Zoom
            // The default zoom control (only available if the
            // [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
            this.zoomControl = new Zoom();
            this.addControl(this.zoomControl);
        }
    });
    // @namespace Control.Zoom
    // @factory L.control.zoom(options: Control.Zoom options)
    // Creates a zoom control
    var zoom = function(options) {
        return new Zoom(options);
    };
    /*
   * @class Control.Scale
   * @aka L.Control.Scale
   * @inherits Control
   *
   * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
   *
   * @example
   *
   * ```js
   * L.control.scale().addTo(map);
   * ```
   */ var Scale = Control.extend({
        // @section
        // @aka Control.Scale options
        options: {
            position: 'bottomleft',
            // @option maxWidth: Number = 100
            // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
            maxWidth: 100,
            // @option metric: Boolean = True
            // Whether to show the metric scale line (m/km).
            metric: true,
            // @option imperial: Boolean = True
            // Whether to show the imperial scale line (mi/ft).
            imperial: true
        },
        onAdd: function(map) {
            var className = 'leaflet-control-scale', container = create$1('div', className), options = this.options;
            this._addScales(options, className + '-line', container);
            map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
            map.whenReady(this._update, this);
            return container;
        },
        onRemove: function(map) {
            map.off(this.options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
        },
        _addScales: function(options, className, container) {
            if (options.metric) this._mScale = create$1('div', className, container);
            if (options.imperial) this._iScale = create$1('div', className, container);
        },
        _update: function() {
            var map = this._map, y = map.getSize().y / 2;
            var maxMeters = map.distance(map.containerPointToLatLng([
                0,
                y
            ]), map.containerPointToLatLng([
                this.options.maxWidth,
                y
            ]));
            this._updateScales(maxMeters);
        },
        _updateScales: function(maxMeters) {
            if (this.options.metric && maxMeters) this._updateMetric(maxMeters);
            if (this.options.imperial && maxMeters) this._updateImperial(maxMeters);
        },
        _updateMetric: function(maxMeters) {
            var meters = this._getRoundNum(maxMeters), label = meters < 1000 ? meters + ' m' : meters / 1000 + ' km';
            this._updateScale(this._mScale, label, meters / maxMeters);
        },
        _updateImperial: function(maxMeters) {
            var maxFeet = maxMeters * 3.2808399, maxMiles, miles, feet;
            if (maxFeet > 5280) {
                maxMiles = maxFeet / 5280;
                miles = this._getRoundNum(maxMiles);
                this._updateScale(this._iScale, miles + ' mi', miles / maxMiles);
            } else {
                feet = this._getRoundNum(maxFeet);
                this._updateScale(this._iScale, feet + ' ft', feet / maxFeet);
            }
        },
        _updateScale: function(scale, text, ratio) {
            scale.style.width = Math.round(this.options.maxWidth * ratio) + 'px';
            scale.innerHTML = text;
        },
        _getRoundNum: function(num) {
            var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1), d = num / pow10;
            d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
            return pow10 * d;
        }
    });
    // @factory L.control.scale(options?: Control.Scale options)
    // Creates an scale control with the given options.
    var scale = function(options) {
        return new Scale(options);
    };
    var ukrainianFlag = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>';
    /*
   * @class Control.Attribution
   * @aka L.Control.Attribution
   * @inherits Control
   *
   * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
   */ var Attribution = Control.extend({
        // @section
        // @aka Control.Attribution options
        options: {
            position: 'bottomright',
            // @option prefix: String|false = 'Leaflet'
            // The HTML text shown before the attributions. Pass `false` to disable.
            prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (Browser.inlineSvg ? ukrainianFlag + ' ' : '') + 'Leaflet</a>'
        },
        initialize: function(options) {
            setOptions(this, options);
            this._attributions = {};
        },
        onAdd: function(map) {
            map.attributionControl = this;
            this._container = create$1('div', 'leaflet-control-attribution');
            disableClickPropagation(this._container);
            // TODO ugly, refactor
            for(var i in map._layers)if (map._layers[i].getAttribution) this.addAttribution(map._layers[i].getAttribution());
            this._update();
            map.on('layeradd', this._addAttribution, this);
            return this._container;
        },
        onRemove: function(map) {
            map.off('layeradd', this._addAttribution, this);
        },
        _addAttribution: function(ev) {
            if (ev.layer.getAttribution) {
                this.addAttribution(ev.layer.getAttribution());
                ev.layer.once('remove', function() {
                    this.removeAttribution(ev.layer.getAttribution());
                }, this);
            }
        },
        // @method setPrefix(prefix: String|false): this
        // The HTML text shown before the attributions. Pass `false` to disable.
        setPrefix: function(prefix) {
            this.options.prefix = prefix;
            this._update();
            return this;
        },
        // @method addAttribution(text: String): this
        // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
        addAttribution: function(text) {
            if (!text) return this;
            if (!this._attributions[text]) this._attributions[text] = 0;
            this._attributions[text]++;
            this._update();
            return this;
        },
        // @method removeAttribution(text: String): this
        // Removes an attribution text.
        removeAttribution: function(text) {
            if (!text) return this;
            if (this._attributions[text]) {
                this._attributions[text]--;
                this._update();
            }
            return this;
        },
        _update: function() {
            if (!this._map) return;
            var attribs = [];
            for(var i in this._attributions)if (this._attributions[i]) attribs.push(i);
            var prefixAndAttribs = [];
            if (this.options.prefix) prefixAndAttribs.push(this.options.prefix);
            if (attribs.length) prefixAndAttribs.push(attribs.join(', '));
            this._container.innerHTML = prefixAndAttribs.join(' <span aria-hidden="true">|</span> ');
        }
    });
    // @namespace Map
    // @section Control options
    // @option attributionControl: Boolean = true
    // Whether a [attribution control](#control-attribution) is added to the map by default.
    Map.mergeOptions({
        attributionControl: true
    });
    Map.addInitHook(function() {
        if (this.options.attributionControl) new Attribution().addTo(this);
    });
    // @namespace Control.Attribution
    // @factory L.control.attribution(options: Control.Attribution options)
    // Creates an attribution control.
    var attribution = function(options) {
        return new Attribution(options);
    };
    Control.Layers = Layers;
    Control.Zoom = Zoom;
    Control.Scale = Scale;
    Control.Attribution = Attribution;
    control.layers = layers;
    control.zoom = zoom;
    control.scale = scale;
    control.attribution = attribution;
    /*
  	L.Handler is a base class for handler classes that are used internally to inject
  	interaction features like dragging to classes like Map and Marker.
  */ // @class Handler
    // @aka L.Handler
    // Abstract class for map interaction handlers
    var Handler = Class.extend({
        initialize: function(map) {
            this._map = map;
        },
        // @method enable(): this
        // Enables the handler
        enable: function() {
            if (this._enabled) return this;
            this._enabled = true;
            this.addHooks();
            return this;
        },
        // @method disable(): this
        // Disables the handler
        disable: function() {
            if (!this._enabled) return this;
            this._enabled = false;
            this.removeHooks();
            return this;
        },
        // @method enabled(): Boolean
        // Returns `true` if the handler is enabled
        enabled: function() {
            return !!this._enabled;
        }
    });
    // @section There is static function which can be called without instantiating L.Handler:
    // @function addTo(map: Map, name: String): this
    // Adds a new Handler to the given map with the given name.
    Handler.addTo = function(map, name) {
        map.addHandler(name, this);
        return this;
    };
    var Mixin = {
        Events: Events
    };
    /*
   * @class Draggable
   * @aka L.Draggable
   * @inherits Evented
   *
   * A class for making DOM elements draggable (including touch support).
   * Used internally for map and marker dragging. Only works for elements
   * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
   *
   * @example
   * ```js
   * var draggable = new L.Draggable(elementToDrag);
   * draggable.enable();
   * ```
   */ var START = Browser.touch ? 'touchstart mousedown' : 'mousedown';
    var Draggable = Evented.extend({
        options: {
            // @section
            // @aka Draggable options
            // @option clickTolerance: Number = 3
            // The max number of pixels a user can shift the mouse pointer during a click
            // for it to be considered a valid click (as opposed to a mouse drag).
            clickTolerance: 3
        },
        // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
        // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
        initialize: function(element, dragStartTarget, preventOutline, options) {
            setOptions(this, options);
            this._element = element;
            this._dragStartTarget = dragStartTarget || element;
            this._preventOutline = preventOutline;
        },
        // @method enable()
        // Enables the dragging ability
        enable: function() {
            if (this._enabled) return;
            on(this._dragStartTarget, START, this._onDown, this);
            this._enabled = true;
        },
        // @method disable()
        // Disables the dragging ability
        disable: function() {
            if (!this._enabled) return;
            // If we're currently dragging this draggable,
            // disabling it counts as first ending the drag.
            if (Draggable._dragging === this) this.finishDrag(true);
            off(this._dragStartTarget, START, this._onDown, this);
            this._enabled = false;
            this._moved = false;
        },
        _onDown: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this._moved = false;
            if (hasClass(this._element, 'leaflet-zoom-anim')) return;
            if (e.touches && e.touches.length !== 1) {
                // Finish dragging to avoid conflict with touchZoom
                if (Draggable._dragging === this) this.finishDrag();
                return;
            }
            if (Draggable._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) return;
            Draggable._dragging = this; // Prevent dragging multiple objects at once.
            if (this._preventOutline) preventOutline(this._element);
            disableImageDrag();
            disableTextSelection();
            if (this._moving) return;
            // @event down: Event
            // Fired when a drag is about to start.
            this.fire('down');
            var first = e.touches ? e.touches[0] : e, sizedParent = getSizedParentNode(this._element);
            this._startPoint = new Point(first.clientX, first.clientY);
            this._startPos = getPosition(this._element);
            // Cache the scale, so that we can continuously compensate for it during drag (_onMove).
            this._parentScale = getScale(sizedParent);
            var mouseevent = e.type === 'mousedown';
            on(document, mouseevent ? 'mousemove' : 'touchmove', this._onMove, this);
            on(document, mouseevent ? 'mouseup' : 'touchend touchcancel', this._onUp, this);
        },
        _onMove: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            if (e.touches && e.touches.length > 1) {
                this._moved = true;
                return;
            }
            var first = e.touches && e.touches.length === 1 ? e.touches[0] : e, offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
            if (!offset.x && !offset.y) return;
            if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) return;
            // We assume that the parent container's position, border and scale do not change for the duration of the drag.
            // Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
            // and we can use the cached value for the scale.
            offset.x /= this._parentScale.x;
            offset.y /= this._parentScale.y;
            preventDefault(e);
            if (!this._moved) {
                // @event dragstart: Event
                // Fired when a drag starts
                this.fire('dragstart');
                this._moved = true;
                addClass(document.body, 'leaflet-dragging');
                this._lastTarget = e.target || e.srcElement;
                // IE and Edge do not give the <use> element, so fetch it
                // if necessary
                if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) this._lastTarget = this._lastTarget.correspondingUseElement;
                addClass(this._lastTarget, 'leaflet-drag-target');
            }
            this._newPos = this._startPos.add(offset);
            this._moving = true;
            this._lastEvent = e;
            this._updatePosition();
        },
        _updatePosition: function() {
            var e = {
                originalEvent: this._lastEvent
            };
            // @event predrag: Event
            // Fired continuously during dragging *before* each corresponding
            // update of the element's position.
            this.fire('predrag', e);
            setPosition(this._element, this._newPos);
            // @event drag: Event
            // Fired continuously during dragging.
            this.fire('drag', e);
        },
        _onUp: function() {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this.finishDrag();
        },
        finishDrag: function(noInertia) {
            removeClass(document.body, 'leaflet-dragging');
            if (this._lastTarget) {
                removeClass(this._lastTarget, 'leaflet-drag-target');
                this._lastTarget = null;
            }
            off(document, 'mousemove touchmove', this._onMove, this);
            off(document, 'mouseup touchend touchcancel', this._onUp, this);
            enableImageDrag();
            enableTextSelection();
            var fireDragend = this._moved && this._moving;
            this._moving = false;
            Draggable._dragging = false;
            if (fireDragend) // @event dragend: DragEndEvent
            // Fired when the drag ends.
            this.fire('dragend', {
                noInertia: noInertia,
                distance: this._newPos.distanceTo(this._startPos)
            });
        }
    });
    /*
   * @namespace PolyUtil
   * Various utility functions for polygon geometries.
   */ /* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
   * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
   * Used by Leaflet to only show polygon points that are on the screen or near, increasing
   * performance. Note that polygon points needs different algorithm for clipping
   * than polyline, so there's a separate method for it.
   */ function clipPolygon(points, bounds, round) {
        var clippedPoints, edges = [
            1,
            4,
            2,
            8
        ], i, j, k, a, b, len, edge, p;
        for(i = 0, len = points.length; i < len; i++)points[i]._code = _getBitCode(points[i], bounds);
        // for each edge (left, bottom, right, top)
        for(k = 0; k < 4; k++){
            edge = edges[k];
            clippedPoints = [];
            for(i = 0, len = points.length, j = len - 1; i < len; j = i++){
                a = points[i];
                b = points[j];
                // if a is inside the clip window
                if (!(a._code & edge)) {
                    // if b is outside the clip window (a->b goes out of screen)
                    if (b._code & edge) {
                        p = _getEdgeIntersection(b, a, edge, bounds, round);
                        p._code = _getBitCode(p, bounds);
                        clippedPoints.push(p);
                    }
                    clippedPoints.push(a);
                // else if b is inside the clip window (a->b enters the screen)
                } else if (!(b._code & edge)) {
                    p = _getEdgeIntersection(b, a, edge, bounds, round);
                    p._code = _getBitCode(p, bounds);
                    clippedPoints.push(p);
                }
            }
            points = clippedPoints;
        }
        return points;
    }
    /* @function polygonCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polygon.
   */ function polygonCenter(latlngs, crs) {
        var i, j, p1, p2, f, area, x, y, center;
        if (!latlngs || latlngs.length === 0) throw new Error('latlngs not passed');
        if (!isFlat(latlngs)) {
            console.warn('latlngs are not flat! Only the first ring will be used');
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        area = x = y = 0;
        // polygon centroid algorithm;
        for(i = 0, j = len - 1; i < len; j = i++){
            p1 = points[i];
            p2 = points[j];
            f = p1.y * p2.x - p2.y * p1.x;
            x += (p1.x + p2.x) * f;
            y += (p1.y + p2.y) * f;
            area += f * 3;
        }
        if (area === 0) // Polygon is so small that all points are on same pixel.
        center = points[0];
        else center = [
            x / area,
            y / area
        ];
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    /* @function centroid(latlngs: LatLng[]): LatLng
   * Returns the 'center of mass' of the passed LatLngs.
   */ function centroid(coords) {
        var latSum = 0;
        var lngSum = 0;
        var len = 0;
        for(var i = 0; i < coords.length; i++){
            var latlng = toLatLng(coords[i]);
            latSum += latlng.lat;
            lngSum += latlng.lng;
            len++;
        }
        return toLatLng([
            latSum / len,
            lngSum / len
        ]);
    }
    var PolyUtil = {
        __proto__: null,
        clipPolygon: clipPolygon,
        polygonCenter: polygonCenter,
        centroid: centroid
    };
    /*
   * @namespace LineUtil
   *
   * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
   */ // Simplify polyline with vertex reduction and Douglas-Peucker simplification.
    // Improves rendering performance dramatically by lessening the number of points to draw.
    // @function simplify(points: Point[], tolerance: Number): Point[]
    // Dramatically reduces the number of points in a polyline while retaining
    // its shape and returns a new array of simplified points, using the
    // [Ramer-Douglas-Peucker algorithm](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm).
    // Used for a huge performance boost when processing/displaying Leaflet polylines for
    // each zoom level and also reducing visual noise. tolerance affects the amount of
    // simplification (lesser value means higher quality but slower and with more points).
    // Also released as a separated micro-library [Simplify.js](https://mourner.github.io/simplify-js/).
    function simplify(points, tolerance) {
        if (!tolerance || !points.length) return points.slice();
        var sqTolerance = tolerance * tolerance;
        // stage 1: vertex reduction
        points = _reducePoints(points, sqTolerance);
        // stage 2: Douglas-Peucker simplification
        points = _simplifyDP(points, sqTolerance);
        return points;
    }
    // @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
    // Returns the distance between point `p` and segment `p1` to `p2`.
    function pointToSegmentDistance(p, p1, p2) {
        return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
    }
    // @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
    // Returns the closest point from a point `p` on a segment `p1` to `p2`.
    function closestPointOnSegment(p, p1, p2) {
        return _sqClosestPointOnSegment(p, p1, p2);
    }
    // Ramer-Douglas-Peucker simplification, see https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm
    function _simplifyDP(points, sqTolerance) {
        var len = points.length, ArrayConstructor = typeof Uint8Array !== "undefined" ? Uint8Array : Array, markers = new ArrayConstructor(len);
        markers[0] = markers[len - 1] = 1;
        _simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
        var i, newPoints = [];
        for(i = 0; i < len; i++)if (markers[i]) newPoints.push(points[i]);
        return newPoints;
    }
    function _simplifyDPStep(points, markers, sqTolerance, first, last) {
        var maxSqDist = 0, index, i, sqDist;
        for(i = first + 1; i <= last - 1; i++){
            sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
            if (sqDist > maxSqDist) {
                index = i;
                maxSqDist = sqDist;
            }
        }
        if (maxSqDist > sqTolerance) {
            markers[index] = 1;
            _simplifyDPStep(points, markers, sqTolerance, first, index);
            _simplifyDPStep(points, markers, sqTolerance, index, last);
        }
    }
    // reduce points that are too close to each other to a single point
    function _reducePoints(points, sqTolerance) {
        var reducedPoints = [
            points[0]
        ];
        for(var i = 1, prev = 0, len = points.length; i < len; i++)if (_sqDist(points[i], points[prev]) > sqTolerance) {
            reducedPoints.push(points[i]);
            prev = i;
        }
        if (prev < len - 1) reducedPoints.push(points[len - 1]);
        return reducedPoints;
    }
    var _lastCode;
    // @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
    // Clips the segment a to b by rectangular bounds with the
    // [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
    // (modifying the segment points directly!). Used by Leaflet to only show polyline
    // points that are on the screen or near, increasing performance.
    function clipSegment(a, b, bounds, useLastCode, round) {
        var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds), codeB = _getBitCode(b, bounds), codeOut, p, newCode;
        // save 2nd code to avoid calculating it on the next segment
        _lastCode = codeB;
        while(true){
            // if a,b is inside the clip window (trivial accept)
            if (!(codeA | codeB)) return [
                a,
                b
            ];
            // if a,b is outside the clip window (trivial reject)
            if (codeA & codeB) return false;
            // other cases
            codeOut = codeA || codeB;
            p = _getEdgeIntersection(a, b, codeOut, bounds, round);
            newCode = _getBitCode(p, bounds);
            if (codeOut === codeA) {
                a = p;
                codeA = newCode;
            } else {
                b = p;
                codeB = newCode;
            }
        }
    }
    function _getEdgeIntersection(a, b, code, bounds, round) {
        var dx = b.x - a.x, dy = b.y - a.y, min = bounds.min, max = bounds.max, x, y;
        if (code & 8) {
            x = a.x + dx * (max.y - a.y) / dy;
            y = max.y;
        } else if (code & 4) {
            x = a.x + dx * (min.y - a.y) / dy;
            y = min.y;
        } else if (code & 2) {
            x = max.x;
            y = a.y + dy * (max.x - a.x) / dx;
        } else if (code & 1) {
            x = min.x;
            y = a.y + dy * (min.x - a.x) / dx;
        }
        return new Point(x, y, round);
    }
    function _getBitCode(p, bounds) {
        var code = 0;
        if (p.x < bounds.min.x) code |= 1;
        else if (p.x > bounds.max.x) code |= 2;
        if (p.y < bounds.min.y) code |= 4;
        else if (p.y > bounds.max.y) code |= 8;
        return code;
    }
    // square distance (to avoid unnecessary Math.sqrt calls)
    function _sqDist(p1, p2) {
        var dx = p2.x - p1.x, dy = p2.y - p1.y;
        return dx * dx + dy * dy;
    }
    // return closest point on segment or distance to that point
    function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
        var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y, dot = dx * dx + dy * dy, t;
        if (dot > 0) {
            t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
            if (t > 1) {
                x = p2.x;
                y = p2.y;
            } else if (t > 0) {
                x += dx * t;
                y += dy * t;
            }
        }
        dx = p.x - x;
        dy = p.y - y;
        return sqDist ? dx * dx + dy * dy : new Point(x, y);
    }
    // @function isFlat(latlngs: LatLng[]): Boolean
    // Returns true if `latlngs` is a flat array, false is nested.
    function isFlat(latlngs) {
        return !isArray(latlngs[0]) || typeof latlngs[0][0] !== 'object' && typeof latlngs[0][0] !== 'undefined';
    }
    function _flat(latlngs) {
        console.warn('Deprecated use of _flat, please use L.LineUtil.isFlat instead.');
        return isFlat(latlngs);
    }
    /* @function polylineCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polyline.
   */ function polylineCenter(latlngs, crs) {
        var i, halfDist, segDist, dist, p1, p2, ratio, center;
        if (!latlngs || latlngs.length === 0) throw new Error('latlngs not passed');
        if (!isFlat(latlngs)) {
            console.warn('latlngs are not flat! Only the first ring will be used');
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        for(i = 0, halfDist = 0; i < len - 1; i++)halfDist += points[i].distanceTo(points[i + 1]) / 2;
        // The line is so small in the current view that all points are on the same pixel.
        if (halfDist === 0) center = points[0];
        else for(i = 0, dist = 0; i < len - 1; i++){
            p1 = points[i];
            p2 = points[i + 1];
            segDist = p1.distanceTo(p2);
            dist += segDist;
            if (dist > halfDist) {
                ratio = (dist - halfDist) / segDist;
                center = [
                    p2.x - ratio * (p2.x - p1.x),
                    p2.y - ratio * (p2.y - p1.y)
                ];
                break;
            }
        }
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    var LineUtil = {
        __proto__: null,
        simplify: simplify,
        pointToSegmentDistance: pointToSegmentDistance,
        closestPointOnSegment: closestPointOnSegment,
        clipSegment: clipSegment,
        _getEdgeIntersection: _getEdgeIntersection,
        _getBitCode: _getBitCode,
        _sqClosestPointOnSegment: _sqClosestPointOnSegment,
        isFlat: isFlat,
        _flat: _flat,
        polylineCenter: polylineCenter
    };
    /*
   * @namespace Projection
   * @section
   * Leaflet comes with a set of already defined Projections out of the box:
   *
   * @projection L.Projection.LonLat
   *
   * Equirectangular, or Plate Carree projection — the most simple projection,
   * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
   * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
   * `EPSG:4326` and `Simple` CRS.
   */ var LonLat = {
        project: function(latlng) {
            return new Point(latlng.lng, latlng.lat);
        },
        unproject: function(point) {
            return new LatLng(point.y, point.x);
        },
        bounds: new Bounds([
            -180,
            -90
        ], [
            180,
            90
        ])
    };
    /*
   * @namespace Projection
   * @projection L.Projection.Mercator
   *
   * Elliptical Mercator projection — more complex than Spherical Mercator. Assumes that Earth is an ellipsoid. Used by the EPSG:3395 CRS.
   */ var Mercator = {
        R: 6378137,
        R_MINOR: 6356752.314245179,
        bounds: new Bounds([
            -20037508.34279,
            -15496570.73972
        ], [
            20037508.34279,
            18764656.23138
        ]),
        project: function(latlng) {
            var d = Math.PI / 180, r = this.R, y = latlng.lat * d, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), con = e * Math.sin(y);
            var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
            y = -r * Math.log(Math.max(ts, 1E-10));
            return new Point(latlng.lng * d * r, y);
        },
        unproject: function(point) {
            var d = 180 / Math.PI, r = this.R, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), ts = Math.exp(-point.y / r), phi = Math.PI / 2 - 2 * Math.atan(ts);
            for(var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++){
                con = e * Math.sin(phi);
                con = Math.pow((1 - con) / (1 + con), e / 2);
                dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
                phi += dphi;
            }
            return new LatLng(phi * d, point.x * d / r);
        }
    };
    /*
   * @class Projection

   * An object with methods for projecting geographical coordinates of the world onto
   * a flat surface (and back). See [Map projection](https://en.wikipedia.org/wiki/Map_projection).

   * @property bounds: Bounds
   * The bounds (specified in CRS units) where the projection is valid

   * @method project(latlng: LatLng): Point
   * Projects geographical coordinates into a 2D point.
   * Only accepts actual `L.LatLng` instances, not arrays.

   * @method unproject(point: Point): LatLng
   * The inverse of `project`. Projects a 2D point into a geographical location.
   * Only accepts actual `L.Point` instances, not arrays.

   * Note that the projection instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.

   */ var index = {
        __proto__: null,
        LonLat: LonLat,
        Mercator: Mercator,
        SphericalMercator: SphericalMercator
    };
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3395
   *
   * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
   */ var EPSG3395 = extend({}, Earth, {
        code: 'EPSG:3395',
        projection: Mercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * Mercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG4326
   *
   * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
   *
   * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
   * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
   * with this CRS, ensure that there are two 256x256 pixel tiles covering the
   * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
   * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
   */ var EPSG4326 = extend({}, Earth, {
        code: 'EPSG:4326',
        projection: LonLat,
        transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
    });
    /*
   * @namespace CRS
   * @crs L.CRS.Simple
   *
   * A simple CRS that maps longitude and latitude into `x` and `y` directly.
   * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
   * axis should still be inverted (going from bottom to top). `distance()` returns
   * simple euclidean distance.
   */ var Simple = extend({}, CRS, {
        projection: LonLat,
        transformation: toTransformation(1, 0, -1, 0),
        scale: function(zoom) {
            return Math.pow(2, zoom);
        },
        zoom: function(scale) {
            return Math.log(scale) / Math.LN2;
        },
        distance: function(latlng1, latlng2) {
            var dx = latlng2.lng - latlng1.lng, dy = latlng2.lat - latlng1.lat;
            return Math.sqrt(dx * dx + dy * dy);
        },
        infinite: true
    });
    CRS.Earth = Earth;
    CRS.EPSG3395 = EPSG3395;
    CRS.EPSG3857 = EPSG3857;
    CRS.EPSG900913 = EPSG900913;
    CRS.EPSG4326 = EPSG4326;
    CRS.Simple = Simple;
    /*
   * @class Layer
   * @inherits Evented
   * @aka L.Layer
   * @aka ILayer
   *
   * A set of methods from the Layer base class that all Leaflet layers use.
   * Inherits all methods, options and events from `L.Evented`.
   *
   * @example
   *
   * ```js
   * var layer = L.marker(latlng).addTo(map);
   * layer.addTo(map);
   * layer.remove();
   * ```
   *
   * @event add: Event
   * Fired after the layer is added to a map
   *
   * @event remove: Event
   * Fired after the layer is removed from a map
   */ var Layer = Evented.extend({
        // Classes extending `L.Layer` will inherit the following options:
        options: {
            // @option pane: String = 'overlayPane'
            // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
            pane: 'overlayPane',
            // @option attribution: String = null
            // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
            attribution: null,
            bubblingMouseEvents: true
        },
        /* @section
  	 * Classes extending `L.Layer` will inherit the following methods:
  	 *
  	 * @method addTo(map: Map|LayerGroup): this
  	 * Adds the layer to the given map or layer group.
  	 */ addTo: function(map) {
            map.addLayer(this);
            return this;
        },
        // @method remove: this
        // Removes the layer from the map it is currently active on.
        remove: function() {
            return this.removeFrom(this._map || this._mapToAdd);
        },
        // @method removeFrom(map: Map): this
        // Removes the layer from the given map
        //
        // @alternative
        // @method removeFrom(group: LayerGroup): this
        // Removes the layer from the given `LayerGroup`
        removeFrom: function(obj) {
            if (obj) obj.removeLayer(this);
            return this;
        },
        // @method getPane(name? : String): HTMLElement
        // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
        getPane: function(name) {
            return this._map.getPane(name ? this.options[name] || name : this.options.pane);
        },
        addInteractiveTarget: function(targetEl) {
            this._map._targets[stamp(targetEl)] = this;
            return this;
        },
        removeInteractiveTarget: function(targetEl) {
            delete this._map._targets[stamp(targetEl)];
            return this;
        },
        // @method getAttribution: String
        // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
        getAttribution: function() {
            return this.options.attribution;
        },
        _layerAdd: function(e) {
            var map = e.target;
            // check in case layer gets added and then removed before the map is ready
            if (!map.hasLayer(this)) return;
            this._map = map;
            this._zoomAnimated = map._zoomAnimated;
            if (this.getEvents) {
                var events = this.getEvents();
                map.on(events, this);
                this.once('remove', function() {
                    map.off(events, this);
                }, this);
            }
            this.onAdd(map);
            this.fire('add');
            map.fire('layeradd', {
                layer: this
            });
        }
    });
    /* @section Extension methods
   * @uninheritable
   *
   * Every layer should extend from `L.Layer` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): this
   * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
   *
   * @method onRemove(map: Map): this
   * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
   *
   * @method getEvents(): Object
   * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
   *
   * @method getAttribution(): String
   * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
   *
   * @method beforeAdd(map: Map): this
   * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
   */ /* @namespace Map
   * @section Layer events
   *
   * @event layeradd: LayerEvent
   * Fired when a new layer is added to the map.
   *
   * @event layerremove: LayerEvent
   * Fired when some layer is removed from the map
   *
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the map
        addLayer: function(layer) {
            if (!layer._layerAdd) throw new Error('The provided object is not a Layer.');
            var id = stamp(layer);
            if (this._layers[id]) return this;
            this._layers[id] = layer;
            layer._mapToAdd = this;
            if (layer.beforeAdd) layer.beforeAdd(this);
            this.whenReady(layer._layerAdd, layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the map.
        removeLayer: function(layer) {
            var id = stamp(layer);
            if (!this._layers[id]) return this;
            if (this._loaded) layer.onRemove(this);
            delete this._layers[id];
            if (this._loaded) {
                this.fire('layerremove', {
                    layer: layer
                });
                layer.fire('remove');
            }
            layer._map = layer._mapToAdd = null;
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the map
        hasLayer: function(layer) {
            return stamp(layer) in this._layers;
        },
        /* @method eachLayer(fn: Function, context?: Object): this
  	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
  	 * ```
  	 * map.eachLayer(function(layer){
  	 *     layer.bindPopup('Hello');
  	 * });
  	 * ```
  	 */ eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        _addLayers: function(layers) {
            layers = layers ? isArray(layers) ? layers : [
                layers
            ] : [];
            for(var i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        _addZoomLimit: function(layer) {
            if (!isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
                this._zoomBoundLayers[stamp(layer)] = layer;
                this._updateZoomLevels();
            }
        },
        _removeZoomLimit: function(layer) {
            var id = stamp(layer);
            if (this._zoomBoundLayers[id]) {
                delete this._zoomBoundLayers[id];
                this._updateZoomLevels();
            }
        },
        _updateZoomLevels: function() {
            var minZoom = Infinity, maxZoom = -Infinity, oldZoomSpan = this._getZoomSpan();
            for(var i in this._zoomBoundLayers){
                var options = this._zoomBoundLayers[i].options;
                minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
                maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
            }
            this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
            this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
            // @section Map state change events
            // @event zoomlevelschange: Event
            // Fired when the number of zoomlevels on the map is changed due
            // to adding or removing a layer.
            if (oldZoomSpan !== this._getZoomSpan()) this.fire('zoomlevelschange');
            if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) this.setZoom(this._layersMaxZoom);
            if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) this.setZoom(this._layersMinZoom);
        }
    });
    /*
   * @class LayerGroup
   * @aka L.LayerGroup
   * @inherits Interactive layer
   *
   * Used to group several layers and handle them as one. If you add it to the map,
   * any layers added or removed from the group will be added/removed on the map as
   * well. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.layerGroup([marker1, marker2])
   * 	.addLayer(polyline)
   * 	.addTo(map);
   * ```
   */ var LayerGroup = Layer.extend({
        initialize: function(layers, options) {
            setOptions(this, options);
            this._layers = {};
            var i, len;
            if (layers) for(i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the group.
        addLayer: function(layer) {
            var id = this.getLayerId(layer);
            this._layers[id] = layer;
            if (this._map) this._map.addLayer(layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the group.
        // @alternative
        // @method removeLayer(id: Number): this
        // Removes the layer with the given internal ID from the group.
        removeLayer: function(layer) {
            var id = layer in this._layers ? layer : this.getLayerId(layer);
            if (this._map && this._layers[id]) this._map.removeLayer(this._layers[id]);
            delete this._layers[id];
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the group.
        // @alternative
        // @method hasLayer(id: Number): Boolean
        // Returns `true` if the given internal ID is currently added to the group.
        hasLayer: function(layer) {
            var layerId = typeof layer === 'number' ? layer : this.getLayerId(layer);
            return layerId in this._layers;
        },
        // @method clearLayers(): this
        // Removes all the layers from the group.
        clearLayers: function() {
            return this.eachLayer(this.removeLayer, this);
        },
        // @method invoke(methodName: String, …): this
        // Calls `methodName` on every layer contained in this group, passing any
        // additional parameters. Has no effect if the layers contained do not
        // implement `methodName`.
        invoke: function(methodName) {
            var args = Array.prototype.slice.call(arguments, 1), i, layer;
            for(i in this._layers){
                layer = this._layers[i];
                if (layer[methodName]) layer[methodName].apply(layer, args);
            }
            return this;
        },
        onAdd: function(map) {
            this.eachLayer(map.addLayer, map);
        },
        onRemove: function(map) {
            this.eachLayer(map.removeLayer, map);
        },
        // @method eachLayer(fn: Function, context?: Object): this
        // Iterates over the layers of the group, optionally specifying context of the iterator function.
        // ```js
        // group.eachLayer(function (layer) {
        // 	layer.bindPopup('Hello');
        // });
        // ```
        eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        // @method getLayer(id: Number): Layer
        // Returns the layer with the given internal ID.
        getLayer: function(id) {
            return this._layers[id];
        },
        // @method getLayers(): Layer[]
        // Returns an array of all the layers added to the group.
        getLayers: function() {
            var layers = [];
            this.eachLayer(layers.push, layers);
            return layers;
        },
        // @method setZIndex(zIndex: Number): this
        // Calls `setZIndex` on every layer contained in this group, passing the z-index.
        setZIndex: function(zIndex) {
            return this.invoke('setZIndex', zIndex);
        },
        // @method getLayerId(layer: Layer): Number
        // Returns the internal ID for a layer
        getLayerId: function(layer) {
            return stamp(layer);
        }
    });
    // @factory L.layerGroup(layers?: Layer[], options?: Object)
    // Create a layer group, optionally given an initial set of layers and an `options` object.
    var layerGroup = function(layers, options) {
        return new LayerGroup(layers, options);
    };
    /*
   * @class FeatureGroup
   * @aka L.FeatureGroup
   * @inherits LayerGroup
   *
   * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
   *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
   *  * Events are propagated to the `FeatureGroup`, so if the group has an event
   * handler, it will handle events from any of the layers. This includes mouse events
   * and custom events.
   *  * Has `layeradd` and `layerremove` events
   *
   * @example
   *
   * ```js
   * L.featureGroup([marker1, marker2, polyline])
   * 	.bindPopup('Hello world!')
   * 	.on('click', function() { alert('Clicked on a member of the group!'); })
   * 	.addTo(map);
   * ```
   */ var FeatureGroup = LayerGroup.extend({
        addLayer: function(layer) {
            if (this.hasLayer(layer)) return this;
            layer.addEventParent(this);
            LayerGroup.prototype.addLayer.call(this, layer);
            // @event layeradd: LayerEvent
            // Fired when a layer is added to this `FeatureGroup`
            return this.fire('layeradd', {
                layer: layer
            });
        },
        removeLayer: function(layer) {
            if (!this.hasLayer(layer)) return this;
            if (layer in this._layers) layer = this._layers[layer];
            layer.removeEventParent(this);
            LayerGroup.prototype.removeLayer.call(this, layer);
            // @event layerremove: LayerEvent
            // Fired when a layer is removed from this `FeatureGroup`
            return this.fire('layerremove', {
                layer: layer
            });
        },
        // @method setStyle(style: Path options): this
        // Sets the given path options to each layer of the group that has a `setStyle` method.
        setStyle: function(style) {
            return this.invoke('setStyle', style);
        },
        // @method bringToFront(): this
        // Brings the layer group to the top of all other layers
        bringToFront: function() {
            return this.invoke('bringToFront');
        },
        // @method bringToBack(): this
        // Brings the layer group to the back of all other layers
        bringToBack: function() {
            return this.invoke('bringToBack');
        },
        // @method getBounds(): LatLngBounds
        // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
        getBounds: function() {
            var bounds = new LatLngBounds();
            for(var id in this._layers){
                var layer = this._layers[id];
                bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
            }
            return bounds;
        }
    });
    // @factory L.featureGroup(layers?: Layer[], options?: Object)
    // Create a feature group, optionally given an initial set of layers and an `options` object.
    var featureGroup = function(layers, options) {
        return new FeatureGroup(layers, options);
    };
    /*
   * @class Icon
   * @aka L.Icon
   *
   * Represents an icon to provide when creating a marker.
   *
   * @example
   *
   * ```js
   * var myIcon = L.icon({
   *     iconUrl: 'my-icon.png',
   *     iconRetinaUrl: 'my-icon@2x.png',
   *     iconSize: [38, 95],
   *     iconAnchor: [22, 94],
   *     popupAnchor: [-3, -76],
   *     shadowUrl: 'my-icon-shadow.png',
   *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
   *     shadowSize: [68, 95],
   *     shadowAnchor: [22, 94]
   * });
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
   *
   */ var Icon = Class.extend({
        /* @section
  	 * @aka Icon options
  	 *
  	 * @option iconUrl: String = null
  	 * **(required)** The URL to the icon image (absolute or relative to your script path).
  	 *
  	 * @option iconRetinaUrl: String = null
  	 * The URL to a retina sized version of the icon image (absolute or relative to your
  	 * script path). Used for Retina screen devices.
  	 *
  	 * @option iconSize: Point = null
  	 * Size of the icon image in pixels.
  	 *
  	 * @option iconAnchor: Point = null
  	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
  	 * will be aligned so that this point is at the marker's geographical location. Centered
  	 * by default if size is specified, also can be set in CSS with negative margins.
  	 *
  	 * @option popupAnchor: Point = [0, 0]
  	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
  	 *
  	 * @option tooltipAnchor: Point = [0, 0]
  	 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
  	 *
  	 * @option shadowUrl: String = null
  	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
  	 *
  	 * @option shadowRetinaUrl: String = null
  	 *
  	 * @option shadowSize: Point = null
  	 * Size of the shadow image in pixels.
  	 *
  	 * @option shadowAnchor: Point = null
  	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
  	 * as iconAnchor if not specified).
  	 *
  	 * @option className: String = ''
  	 * A custom class name to assign to both icon and shadow images. Empty by default.
  	 */ options: {
            popupAnchor: [
                0,
                0
            ],
            tooltipAnchor: [
                0,
                0
            ],
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        // @method createIcon(oldIcon?: HTMLElement): HTMLElement
        // Called internally when the icon has to be shown, returns a `<img>` HTML element
        // styled according to the options.
        createIcon: function(oldIcon) {
            return this._createIcon('icon', oldIcon);
        },
        // @method createShadow(oldIcon?: HTMLElement): HTMLElement
        // As `createIcon`, but for the shadow beneath it.
        createShadow: function(oldIcon) {
            return this._createIcon('shadow', oldIcon);
        },
        _createIcon: function(name, oldIcon) {
            var src = this._getIconUrl(name);
            if (!src) {
                if (name === 'icon') throw new Error('iconUrl not set in Icon options (see the docs).');
                return null;
            }
            var img = this._createImg(src, oldIcon && oldIcon.tagName === 'IMG' ? oldIcon : null);
            this._setIconStyles(img, name);
            if (this.options.crossOrigin || this.options.crossOrigin === '') img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            return img;
        },
        _setIconStyles: function(img, name) {
            var options = this.options;
            var sizeOption = options[name + 'Size'];
            if (typeof sizeOption === 'number') sizeOption = [
                sizeOption,
                sizeOption
            ];
            var size = toPoint(sizeOption), anchor = toPoint(name === 'shadow' && options.shadowAnchor || options.iconAnchor || size && size.divideBy(2, true));
            img.className = 'leaflet-marker-' + name + ' ' + (options.className || '');
            if (anchor) {
                img.style.marginLeft = -anchor.x + 'px';
                img.style.marginTop = -anchor.y + 'px';
            }
            if (size) {
                img.style.width = size.x + 'px';
                img.style.height = size.y + 'px';
            }
        },
        _createImg: function(src, el) {
            el = el || document.createElement('img');
            el.src = src;
            return el;
        },
        _getIconUrl: function(name) {
            return Browser.retina && this.options[name + 'RetinaUrl'] || this.options[name + 'Url'];
        }
    });
    // @factory L.icon(options: Icon options)
    // Creates an icon instance with the given options.
    function icon(options) {
        return new Icon(options);
    }
    /*
   * @miniclass Icon.Default (Icon)
   * @aka L.Icon.Default
   * @section
   *
   * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
   * no icon is specified. Points to the blue marker image distributed with Leaflet
   * releases.
   *
   * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
   * (which is a set of `Icon options`).
   *
   * If you want to _completely_ replace the default icon, override the
   * `L.Marker.prototype.options.icon` with your own icon instead.
   */ var IconDefault = Icon.extend({
        options: {
            iconUrl: 'marker-icon.png',
            iconRetinaUrl: 'marker-icon-2x.png',
            shadowUrl: 'marker-shadow.png',
            iconSize: [
                25,
                41
            ],
            iconAnchor: [
                12,
                41
            ],
            popupAnchor: [
                1,
                -34
            ],
            tooltipAnchor: [
                16,
                -28
            ],
            shadowSize: [
                41,
                41
            ]
        },
        _getIconUrl: function(name) {
            if (typeof IconDefault.imagePath !== 'string') IconDefault.imagePath = this._detectIconPath();
            // @option imagePath: String
            // `Icon.Default` will try to auto-detect the location of the
            // blue icon images. If you are placing these images in a non-standard
            // way, set this option to point to the right path.
            return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
        },
        _stripUrl: function(path) {
            var strip = function(str, re, idx) {
                var match = re.exec(str);
                return match && match[idx];
            };
            path = strip(path, /^url\((['"])?(.+)\1\)$/, 2);
            return path && strip(path, /^(.*)marker-icon\.png$/, 1);
        },
        _detectIconPath: function() {
            var el = create$1('div', 'leaflet-default-icon-path', document.body);
            var path = getStyle(el, 'background-image') || getStyle(el, 'backgroundImage'); // IE8
            document.body.removeChild(el);
            path = this._stripUrl(path);
            if (path) return path;
            var link = document.querySelector('link[href$="leaflet.css"]');
            if (!link) return '';
            return link.href.substring(0, link.href.length - 11 - 1);
        }
    });
    /*
   * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
   */ /* @namespace Marker
   * @section Interaction handlers
   *
   * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
   *
   * ```js
   * marker.dragging.disable();
   * ```
   *
   * @property dragging: Handler
   * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
   */ var MarkerDrag = Handler.extend({
        initialize: function(marker) {
            this._marker = marker;
        },
        addHooks: function() {
            var icon = this._marker._icon;
            if (!this._draggable) this._draggable = new Draggable(icon, icon, true);
            this._draggable.on({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).enable();
            addClass(icon, 'leaflet-marker-draggable');
        },
        removeHooks: function() {
            this._draggable.off({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).disable();
            if (this._marker._icon) removeClass(this._marker._icon, 'leaflet-marker-draggable');
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        _adjustPan: function(e) {
            var marker = this._marker, map = marker._map, speed = this._marker.options.autoPanSpeed, padding = this._marker.options.autoPanPadding, iconPos = getPosition(marker._icon), bounds = map.getPixelBounds(), origin = map.getPixelOrigin();
            var panBounds = toBounds(bounds.min._subtract(origin).add(padding), bounds.max._subtract(origin).subtract(padding));
            if (!panBounds.contains(iconPos)) {
                // Compute incremental movement
                var movement = toPoint((Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) - (Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x), (Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) - (Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)).multiplyBy(speed);
                map.panBy(movement, {
                    animate: false
                });
                this._draggable._newPos._add(movement);
                this._draggable._startPos._add(movement);
                setPosition(marker._icon, this._draggable._newPos);
                this._onDrag(e);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDragStart: function() {
            // @section Dragging events
            // @event dragstart: Event
            // Fired when the user starts dragging the marker.
            // @event movestart: Event
            // Fired when the marker starts moving (because of dragging).
            this._oldLatLng = this._marker.getLatLng();
            // When using ES6 imports it could not be set when `Popup` was not imported as well
            this._marker.closePopup && this._marker.closePopup();
            this._marker.fire('movestart').fire('dragstart');
        },
        _onPreDrag: function(e) {
            if (this._marker.options.autoPan) {
                cancelAnimFrame(this._panRequest);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDrag: function(e) {
            var marker = this._marker, shadow = marker._shadow, iconPos = getPosition(marker._icon), latlng = marker._map.layerPointToLatLng(iconPos);
            // update shadow position
            if (shadow) setPosition(shadow, iconPos);
            marker._latlng = latlng;
            e.latlng = latlng;
            e.oldLatLng = this._oldLatLng;
            // @event drag: Event
            // Fired repeatedly while the user drags the marker.
            marker.fire('move', e).fire('drag', e);
        },
        _onDragEnd: function(e) {
            // @event dragend: DragEndEvent
            // Fired when the user stops dragging the marker.
            cancelAnimFrame(this._panRequest);
            // @event moveend: Event
            // Fired when the marker stops moving (because of dragging).
            delete this._oldLatLng;
            this._marker.fire('moveend').fire('dragend', e);
        }
    });
    /*
   * @class Marker
   * @inherits Interactive layer
   * @aka L.Marker
   * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.marker([50.5, 30.5]).addTo(map);
   * ```
   */ var Marker = Layer.extend({
        // @section
        // @aka Marker options
        options: {
            // @option icon: Icon = *
            // Icon instance to use for rendering the marker.
            // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
            // If not specified, a common instance of `L.Icon.Default` is used.
            icon: new IconDefault(),
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option keyboard: Boolean = true
            // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
            keyboard: true,
            // @option title: String = ''
            // Text for the browser tooltip that appear on marker hover (no tooltip by default).
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            title: '',
            // @option alt: String = 'Marker'
            // Text for the `alt` attribute of the icon image.
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            alt: 'Marker',
            // @option zIndexOffset: Number = 0
            // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
            zIndexOffset: 0,
            // @option opacity: Number = 1.0
            // The opacity of the marker.
            opacity: 1,
            // @option riseOnHover: Boolean = false
            // If `true`, the marker will get on top of others when you hover the mouse over it.
            riseOnHover: false,
            // @option riseOffset: Number = 250
            // The z-index offset used for the `riseOnHover` feature.
            riseOffset: 250,
            // @option pane: String = 'markerPane'
            // `Map pane` where the markers icon will be added.
            pane: 'markerPane',
            // @option shadowPane: String = 'shadowPane'
            // `Map pane` where the markers shadow will be added.
            shadowPane: 'shadowPane',
            // @option bubblingMouseEvents: Boolean = false
            // When `true`, a mouse event on this marker will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: false,
            // @option autoPanOnFocus: Boolean = true
            // When `true`, the map will pan whenever the marker is focused (via
            // e.g. pressing `tab` on the keyboard) to ensure the marker is
            // visible within the map's bounds
            autoPanOnFocus: true,
            // @section Draggable marker options
            // @option draggable: Boolean = false
            // Whether the marker is draggable with mouse/touch or not.
            draggable: false,
            // @option autoPan: Boolean = false
            // Whether to pan the map when dragging this marker near its edge or not.
            autoPan: false,
            // @option autoPanPadding: Point = Point(50, 50)
            // Distance (in pixels to the left/right and to the top/bottom) of the
            // map edge to start panning the map.
            autoPanPadding: [
                50,
                50
            ],
            // @option autoPanSpeed: Number = 10
            // Number of pixels the map should pan by.
            autoPanSpeed: 10
        },
        /* @section
  	 *
  	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
  	 */ initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
        },
        onAdd: function(map) {
            this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
            if (this._zoomAnimated) map.on('zoomanim', this._animateZoom, this);
            this._initIcon();
            this.update();
        },
        onRemove: function(map) {
            if (this.dragging && this.dragging.enabled()) {
                this.options.draggable = true;
                this.dragging.removeHooks();
            }
            delete this.dragging;
            if (this._zoomAnimated) map.off('zoomanim', this._animateZoom, this);
            this._removeIcon();
            this._removeShadow();
        },
        getEvents: function() {
            return {
                zoom: this.update,
                viewreset: this.update
            };
        },
        // @method getLatLng: LatLng
        // Returns the current geographical position of the marker.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Changes the marker position to the given point.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.update();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire('move', {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method setZIndexOffset(offset: Number): this
        // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
        setZIndexOffset: function(offset) {
            this.options.zIndexOffset = offset;
            return this.update();
        },
        // @method getIcon: Icon
        // Returns the current icon used by the marker
        getIcon: function() {
            return this.options.icon;
        },
        // @method setIcon(icon: Icon): this
        // Changes the marker icon.
        setIcon: function(icon) {
            this.options.icon = icon;
            if (this._map) {
                this._initIcon();
                this.update();
            }
            if (this._popup) this.bindPopup(this._popup, this._popup.options);
            return this;
        },
        getElement: function() {
            return this._icon;
        },
        update: function() {
            if (this._icon && this._map) {
                var pos = this._map.latLngToLayerPoint(this._latlng).round();
                this._setPos(pos);
            }
            return this;
        },
        _initIcon: function() {
            var options = this.options, classToAdd = 'leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
            var icon = options.icon.createIcon(this._icon), addIcon = false;
            // if we're not reusing the icon, remove the old one and init new one
            if (icon !== this._icon) {
                if (this._icon) this._removeIcon();
                addIcon = true;
                if (options.title) icon.title = options.title;
                if (icon.tagName === 'IMG') icon.alt = options.alt || '';
            }
            addClass(icon, classToAdd);
            if (options.keyboard) {
                icon.tabIndex = '0';
                icon.setAttribute('role', 'button');
            }
            this._icon = icon;
            if (options.riseOnHover) this.on({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) on(icon, 'focus', this._panOnFocus, this);
            var newShadow = options.icon.createShadow(this._shadow), addShadow = false;
            if (newShadow !== this._shadow) {
                this._removeShadow();
                addShadow = true;
            }
            if (newShadow) {
                addClass(newShadow, classToAdd);
                newShadow.alt = '';
            }
            this._shadow = newShadow;
            if (options.opacity < 1) this._updateOpacity();
            if (addIcon) this.getPane().appendChild(this._icon);
            this._initInteraction();
            if (newShadow && addShadow) this.getPane(options.shadowPane).appendChild(this._shadow);
        },
        _removeIcon: function() {
            if (this.options.riseOnHover) this.off({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) off(this._icon, 'focus', this._panOnFocus, this);
            remove(this._icon);
            this.removeInteractiveTarget(this._icon);
            this._icon = null;
        },
        _removeShadow: function() {
            if (this._shadow) remove(this._shadow);
            this._shadow = null;
        },
        _setPos: function(pos) {
            if (this._icon) setPosition(this._icon, pos);
            if (this._shadow) setPosition(this._shadow, pos);
            this._zIndex = pos.y + this.options.zIndexOffset;
            this._resetZIndex();
        },
        _updateZIndex: function(offset) {
            if (this._icon) this._icon.style.zIndex = this._zIndex + offset;
        },
        _animateZoom: function(opt) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
            this._setPos(pos);
        },
        _initInteraction: function() {
            if (!this.options.interactive) return;
            addClass(this._icon, 'leaflet-interactive');
            this.addInteractiveTarget(this._icon);
            if (MarkerDrag) {
                var draggable = this.options.draggable;
                if (this.dragging) {
                    draggable = this.dragging.enabled();
                    this.dragging.disable();
                }
                this.dragging = new MarkerDrag(this);
                if (draggable) this.dragging.enable();
            }
        },
        // @method setOpacity(opacity: Number): this
        // Changes the opacity of the marker.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._map) this._updateOpacity();
            return this;
        },
        _updateOpacity: function() {
            var opacity = this.options.opacity;
            if (this._icon) setOpacity(this._icon, opacity);
            if (this._shadow) setOpacity(this._shadow, opacity);
        },
        _bringToFront: function() {
            this._updateZIndex(this.options.riseOffset);
        },
        _resetZIndex: function() {
            this._updateZIndex(0);
        },
        _panOnFocus: function() {
            var map = this._map;
            if (!map) return;
            var iconOpts = this.options.icon.options;
            var size = iconOpts.iconSize ? toPoint(iconOpts.iconSize) : toPoint(0, 0);
            var anchor = iconOpts.iconAnchor ? toPoint(iconOpts.iconAnchor) : toPoint(0, 0);
            map.panInside(this._latlng, {
                paddingTopLeft: anchor,
                paddingBottomRight: size.subtract(anchor)
            });
        },
        _getPopupAnchor: function() {
            return this.options.icon.options.popupAnchor;
        },
        _getTooltipAnchor: function() {
            return this.options.icon.options.tooltipAnchor;
        }
    });
    // factory L.marker(latlng: LatLng, options? : Marker options)
    // @factory L.marker(latlng: LatLng, options? : Marker options)
    // Instantiates a Marker object given a geographical point and optionally an options object.
    function marker(latlng, options) {
        return new Marker(latlng, options);
    }
    /*
   * @class Path
   * @aka L.Path
   * @inherits Interactive layer
   *
   * An abstract class that contains options and constants shared between vector
   * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
   */ var Path = Layer.extend({
        // @section
        // @aka Path options
        options: {
            // @option stroke: Boolean = true
            // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
            stroke: true,
            // @option color: String = '#3388ff'
            // Stroke color
            color: '#3388ff',
            // @option weight: Number = 3
            // Stroke width in pixels
            weight: 3,
            // @option opacity: Number = 1.0
            // Stroke opacity
            opacity: 1,
            // @option lineCap: String= 'round'
            // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
            lineCap: 'round',
            // @option lineJoin: String = 'round'
            // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
            lineJoin: 'round',
            // @option dashArray: String = null
            // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashArray: null,
            // @option dashOffset: String = null
            // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashOffset: null,
            // @option fill: Boolean = depends
            // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
            fill: false,
            // @option fillColor: String = *
            // Fill color. Defaults to the value of the [`color`](#path-color) option
            fillColor: null,
            // @option fillOpacity: Number = 0.2
            // Fill opacity.
            fillOpacity: 0.2,
            // @option fillRule: String = 'evenodd'
            // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
            fillRule: 'evenodd',
            // className: '',
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option bubblingMouseEvents: Boolean = true
            // When `true`, a mouse event on this path will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: true
        },
        beforeAdd: function(map) {
            // Renderer is set here because we need to call renderer.getEvents
            // before this.getEvents.
            this._renderer = map.getRenderer(this);
        },
        onAdd: function() {
            this._renderer._initPath(this);
            this._reset();
            this._renderer._addPath(this);
        },
        onRemove: function() {
            this._renderer._removePath(this);
        },
        // @method redraw(): this
        // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
        redraw: function() {
            if (this._map) this._renderer._updatePath(this);
            return this;
        },
        // @method setStyle(style: Path options): this
        // Changes the appearance of a Path based on the options in the `Path options` object.
        setStyle: function(style) {
            setOptions(this, style);
            if (this._renderer) {
                this._renderer._updateStyle(this);
                if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, 'weight')) this._updateBounds();
            }
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all path layers.
        bringToFront: function() {
            if (this._renderer) this._renderer._bringToFront(this);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all path layers.
        bringToBack: function() {
            if (this._renderer) this._renderer._bringToBack(this);
            return this;
        },
        getElement: function() {
            return this._path;
        },
        _reset: function() {
            // defined in child classes
            this._project();
            this._update();
        },
        _clickTolerance: function() {
            // used when doing hit detection for Canvas layers
            return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
        }
    });
    /*
   * @class CircleMarker
   * @aka L.CircleMarker
   * @inherits Path
   *
   * A circle of a fixed size with radius specified in pixels. Extends `Path`.
   */ var CircleMarker = Path.extend({
        // @section
        // @aka CircleMarker options
        options: {
            fill: true,
            // @option radius: Number = 10
            // Radius of the circle marker, in pixels
            radius: 10
        },
        initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            this._radius = this.options.radius;
        },
        // @method setLatLng(latLng: LatLng): this
        // Sets the position of a circle marker to a new location.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.redraw();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire('move', {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method getLatLng(): LatLng
        // Returns the current geographical position of the circle marker
        getLatLng: function() {
            return this._latlng;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle marker. Units are in pixels.
        setRadius: function(radius) {
            this.options.radius = this._radius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of the circle
        getRadius: function() {
            return this._radius;
        },
        setStyle: function(options) {
            var radius = options && options.radius || this._radius;
            Path.prototype.setStyle.call(this, options);
            this.setRadius(radius);
            return this;
        },
        _project: function() {
            this._point = this._map.latLngToLayerPoint(this._latlng);
            this._updateBounds();
        },
        _updateBounds: function() {
            var r = this._radius, r2 = this._radiusY || r, w = this._clickTolerance(), p = [
                r + w,
                r2 + w
            ];
            this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
        },
        _update: function() {
            if (this._map) this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updateCircle(this);
        },
        _empty: function() {
            return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
        }
    });
    // @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
    // Instantiates a circle marker object given a geographical point, and an optional options object.
    function circleMarker(latlng, options) {
        return new CircleMarker(latlng, options);
    }
    /*
   * @class Circle
   * @aka L.Circle
   * @inherits CircleMarker
   *
   * A class for drawing circle overlays on a map. Extends `CircleMarker`.
   *
   * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
   *
   * @example
   *
   * ```js
   * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
   * ```
   */ var Circle = CircleMarker.extend({
        initialize: function(latlng, options, legacyOptions) {
            if (typeof options === 'number') // Backwards compatibility with 0.7.x factory (latlng, radius, options?)
            options = extend({}, legacyOptions, {
                radius: options
            });
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            if (isNaN(this.options.radius)) throw new Error('Circle radius cannot be NaN');
            // @section
            // @aka Circle options
            // @option radius: Number; Radius of the circle, in meters.
            this._mRadius = this.options.radius;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle. Units are in meters.
        setRadius: function(radius) {
            this._mRadius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of a circle. Units are in meters.
        getRadius: function() {
            return this._mRadius;
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            var half = [
                this._radius,
                this._radiusY || this._radius
            ];
            return new LatLngBounds(this._map.layerPointToLatLng(this._point.subtract(half)), this._map.layerPointToLatLng(this._point.add(half)));
        },
        setStyle: Path.prototype.setStyle,
        _project: function() {
            var lng = this._latlng.lng, lat = this._latlng.lat, map = this._map, crs = map.options.crs;
            if (crs.distance === Earth.distance) {
                var d = Math.PI / 180, latR = this._mRadius / Earth.R / d, top = map.project([
                    lat + latR,
                    lng
                ]), bottom = map.project([
                    lat - latR,
                    lng
                ]), p = top.add(bottom).divideBy(2), lat2 = map.unproject(p).lat, lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) / (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
                if (isNaN(lngR) || lngR === 0) lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
                this._point = p.subtract(map.getPixelOrigin());
                this._radius = isNaN(lngR) ? 0 : p.x - map.project([
                    lat2,
                    lng - lngR
                ]).x;
                this._radiusY = p.y - top.y;
            } else {
                var latlng2 = crs.unproject(crs.project(this._latlng).subtract([
                    this._mRadius,
                    0
                ]));
                this._point = map.latLngToLayerPoint(this._latlng);
                this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
            }
            this._updateBounds();
        }
    });
    // @factory L.circle(latlng: LatLng, options?: Circle options)
    // Instantiates a circle object given a geographical point, and an options object
    // which contains the circle radius.
    // @alternative
    // @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
    // Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
    // Do not use in new applications or plugins.
    function circle(latlng, options, legacyOptions) {
        return new Circle(latlng, options, legacyOptions);
    }
    /*
   * @class Polyline
   * @aka L.Polyline
   * @inherits Path
   *
   * A class for drawing polyline overlays on a map. Extends `Path`.
   *
   * @example
   *
   * ```js
   * // create a red polyline from an array of LatLng points
   * var latlngs = [
   * 	[45.51, -122.68],
   * 	[37.77, -122.43],
   * 	[34.04, -118.2]
   * ];
   *
   * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polyline
   * map.fitBounds(polyline.getBounds());
   * ```
   *
   * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
   *
   * ```js
   * // create a red polyline from an array of arrays of LatLng points
   * var latlngs = [
   * 	[[45.51, -122.68],
   * 	 [37.77, -122.43],
   * 	 [34.04, -118.2]],
   * 	[[40.78, -73.91],
   * 	 [41.83, -87.62],
   * 	 [32.76, -96.72]]
   * ];
   * ```
   */ var Polyline = Path.extend({
        // @section
        // @aka Polyline options
        options: {
            // @option smoothFactor: Number = 1.0
            // How much to simplify the polyline on each zoom level. More means
            // better performance and smoother look, and less means more accurate representation.
            smoothFactor: 1.0,
            // @option noClip: Boolean = false
            // Disable polyline clipping.
            noClip: false
        },
        initialize: function(latlngs, options) {
            setOptions(this, options);
            this._setLatLngs(latlngs);
        },
        // @method getLatLngs(): LatLng[]
        // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
        getLatLngs: function() {
            return this._latlngs;
        },
        // @method setLatLngs(latlngs: LatLng[]): this
        // Replaces all the points in the polyline with the given array of geographical points.
        setLatLngs: function(latlngs) {
            this._setLatLngs(latlngs);
            return this.redraw();
        },
        // @method isEmpty(): Boolean
        // Returns `true` if the Polyline has no LatLngs.
        isEmpty: function() {
            return !this._latlngs.length;
        },
        // @method closestLayerPoint(p: Point): Point
        // Returns the point closest to `p` on the Polyline.
        closestLayerPoint: function(p) {
            var minDistance = Infinity, minPoint = null, closest = _sqClosestPointOnSegment, p1, p2;
            for(var j = 0, jLen = this._parts.length; j < jLen; j++){
                var points = this._parts[j];
                for(var i = 1, len = points.length; i < len; i++){
                    p1 = points[i - 1];
                    p2 = points[i];
                    var sqDist = closest(p, p1, p2, true);
                    if (sqDist < minDistance) {
                        minDistance = sqDist;
                        minPoint = closest(p, p1, p2);
                    }
                }
            }
            if (minPoint) minPoint.distance = Math.sqrt(minDistance);
            return minPoint;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error('Must add layer to map before using getCenter()');
            return polylineCenter(this._defaultShape(), this._map.options.crs);
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            return this._bounds;
        },
        // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
        // Adds a given point to the polyline. By default, adds to the first ring of
        // the polyline in case of a multi-polyline, but can be overridden by passing
        // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
        addLatLng: function(latlng, latlngs) {
            latlngs = latlngs || this._defaultShape();
            latlng = toLatLng(latlng);
            latlngs.push(latlng);
            this._bounds.extend(latlng);
            return this.redraw();
        },
        _setLatLngs: function(latlngs) {
            this._bounds = new LatLngBounds();
            this._latlngs = this._convertLatLngs(latlngs);
        },
        _defaultShape: function() {
            return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
        },
        // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
        _convertLatLngs: function(latlngs) {
            var result = [], flat = isFlat(latlngs);
            for(var i = 0, len = latlngs.length; i < len; i++)if (flat) {
                result[i] = toLatLng(latlngs[i]);
                this._bounds.extend(result[i]);
            } else result[i] = this._convertLatLngs(latlngs[i]);
            return result;
        },
        _project: function() {
            var pxBounds = new Bounds();
            this._rings = [];
            this._projectLatlngs(this._latlngs, this._rings, pxBounds);
            if (this._bounds.isValid() && pxBounds.isValid()) {
                this._rawPxBounds = pxBounds;
                this._updateBounds();
            }
        },
        _updateBounds: function() {
            var w = this._clickTolerance(), p = new Point(w, w);
            if (!this._rawPxBounds) return;
            this._pxBounds = new Bounds([
                this._rawPxBounds.min.subtract(p),
                this._rawPxBounds.max.add(p)
            ]);
        },
        // recursively turns latlngs into a set of rings with projected coordinates
        _projectLatlngs: function(latlngs, result, projectedBounds) {
            var flat = latlngs[0] instanceof LatLng, len = latlngs.length, i, ring;
            if (flat) {
                ring = [];
                for(i = 0; i < len; i++){
                    ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
                    projectedBounds.extend(ring[i]);
                }
                result.push(ring);
            } else for(i = 0; i < len; i++)this._projectLatlngs(latlngs[i], result, projectedBounds);
        },
        // clip polyline by renderer bounds so that we have less to render for performance
        _clipPoints: function() {
            var bounds = this._renderer._bounds;
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            var parts = this._parts, i, j, k, len, len2, segment, points;
            for(i = 0, k = 0, len = this._rings.length; i < len; i++){
                points = this._rings[i];
                for(j = 0, len2 = points.length; j < len2 - 1; j++){
                    segment = clipSegment(points[j], points[j + 1], bounds, j, true);
                    if (!segment) continue;
                    parts[k] = parts[k] || [];
                    parts[k].push(segment[0]);
                    // if segment goes out of screen, or it's the last one, it's the end of the line part
                    if (segment[1] !== points[j + 1] || j === len2 - 2) {
                        parts[k].push(segment[1]);
                        k++;
                    }
                }
            }
        },
        // simplify each clipped part of the polyline for performance
        _simplifyPoints: function() {
            var parts = this._parts, tolerance = this.options.smoothFactor;
            for(var i = 0, len = parts.length; i < len; i++)parts[i] = simplify(parts[i], tolerance);
        },
        _update: function() {
            if (!this._map) return;
            this._clipPoints();
            this._simplifyPoints();
            this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updatePoly(this);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p, closed) {
            var i, j, k, len, len2, part, w = this._clickTolerance();
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // hit detection for polylines
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    if (!closed && j === 0) continue;
                    if (pointToSegmentDistance(p, part[k], part[j]) <= w) return true;
                }
            }
            return false;
        }
    });
    // @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
    // Instantiates a polyline object given an array of geographical points and
    // optionally an options object. You can create a `Polyline` object with
    // multiple separate lines (`MultiPolyline`) by passing an array of arrays
    // of geographic points.
    function polyline(latlngs, options) {
        return new Polyline(latlngs, options);
    }
    // Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
    Polyline._flat = _flat;
    /*
   * @class Polygon
   * @aka L.Polygon
   * @inherits Polyline
   *
   * A class for drawing polygon overlays on a map. Extends `Polyline`.
   *
   * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
   *
   *
   * @example
   *
   * ```js
   * // create a red polygon from an array of LatLng points
   * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
   *
   * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polygon
   * map.fitBounds(polygon.getBounds());
   * ```
   *
   * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
   *
   * ```js
   * var latlngs = [
   *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   * ];
   * ```
   *
   * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
   *
   * ```js
   * var latlngs = [
   *   [ // first polygon
   *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   *   ],
   *   [ // second polygon
   *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
   *   ]
   * ];
   * ```
   */ var Polygon = Polyline.extend({
        options: {
            fill: true
        },
        isEmpty: function() {
            return !this._latlngs.length || !this._latlngs[0].length;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error('Must add layer to map before using getCenter()');
            return polygonCenter(this._defaultShape(), this._map.options.crs);
        },
        _convertLatLngs: function(latlngs) {
            var result = Polyline.prototype._convertLatLngs.call(this, latlngs), len = result.length;
            // remove last point if it equals first one
            if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) result.pop();
            return result;
        },
        _setLatLngs: function(latlngs) {
            Polyline.prototype._setLatLngs.call(this, latlngs);
            if (isFlat(this._latlngs)) this._latlngs = [
                this._latlngs
            ];
        },
        _defaultShape: function() {
            return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
        },
        _clipPoints: function() {
            // polygons need a different clipping algorithm so we redefine that
            var bounds = this._renderer._bounds, w = this.options.weight, p = new Point(w, w);
            // increase clip padding by stroke width to avoid stroke on clip edges
            bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            for(var i = 0, len = this._rings.length, clipped; i < len; i++){
                clipped = clipPolygon(this._rings[i], bounds, true);
                if (clipped.length) this._parts.push(clipped);
            }
        },
        _updatePath: function() {
            this._renderer._updatePoly(this, true);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            var inside = false, part, p1, p2, i, j, k, len, len2;
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // ray casting algorithm for detecting if point is in polygon
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    p1 = part[j];
                    p2 = part[k];
                    if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) inside = !inside;
                }
            }
            // also check if it's on polygon stroke
            return inside || Polyline.prototype._containsPoint.call(this, p, true);
        }
    });
    // @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
    function polygon(latlngs, options) {
        return new Polygon(latlngs, options);
    }
    /*
   * @class GeoJSON
   * @aka L.GeoJSON
   * @inherits FeatureGroup
   *
   * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
   * GeoJSON data and display it on the map. Extends `FeatureGroup`.
   *
   * @example
   *
   * ```js
   * L.geoJSON(data, {
   * 	style: function (feature) {
   * 		return {color: feature.properties.color};
   * 	}
   * }).bindPopup(function (layer) {
   * 	return layer.feature.properties.description;
   * }).addTo(map);
   * ```
   */ var GeoJSON = FeatureGroup.extend({
        /* @section
  	 * @aka GeoJSON options
  	 *
  	 * @option pointToLayer: Function = *
  	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
  	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
  	 * The default is to spawn a default `Marker`:
  	 * ```js
  	 * function(geoJsonPoint, latlng) {
  	 * 	return L.marker(latlng);
  	 * }
  	 * ```
  	 *
  	 * @option style: Function = *
  	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
  	 * called internally when data is added.
  	 * The default value is to not override any defaults:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return {}
  	 * }
  	 * ```
  	 *
  	 * @option onEachFeature: Function = *
  	 * A `Function` that will be called once for each created `Feature`, after it has
  	 * been created and styled. Useful for attaching events and popups to features.
  	 * The default is to do nothing with the newly created layers:
  	 * ```js
  	 * function (feature, layer) {}
  	 * ```
  	 *
  	 * @option filter: Function = *
  	 * A `Function` that will be used to decide whether to include a feature or not.
  	 * The default is to include all features:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return true;
  	 * }
  	 * ```
  	 * Note: dynamically changing the `filter` option will have effect only on newly
  	 * added data. It will _not_ re-evaluate already included features.
  	 *
  	 * @option coordsToLatLng: Function = *
  	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
  	 * The default is the `coordsToLatLng` static method.
  	 *
  	 * @option markersInheritOptions: Boolean = false
  	 * Whether default Markers for "Point" type Features inherit from group options.
  	 */ initialize: function(geojson, options) {
            setOptions(this, options);
            this._layers = {};
            if (geojson) this.addData(geojson);
        },
        // @method addData( <GeoJSON> data ): this
        // Adds a GeoJSON object to the layer.
        addData: function(geojson) {
            var features = isArray(geojson) ? geojson : geojson.features, i, len, feature;
            if (features) {
                for(i = 0, len = features.length; i < len; i++){
                    // only add this if geometry or geometries are set and not null
                    feature = features[i];
                    if (feature.geometries || feature.geometry || feature.features || feature.coordinates) this.addData(feature);
                }
                return this;
            }
            var options = this.options;
            if (options.filter && !options.filter(geojson)) return this;
            var layer = geometryToLayer(geojson, options);
            if (!layer) return this;
            layer.feature = asFeature(geojson);
            layer.defaultOptions = layer.options;
            this.resetStyle(layer);
            if (options.onEachFeature) options.onEachFeature(geojson, layer);
            return this.addLayer(layer);
        },
        // @method resetStyle( <Path> layer? ): this
        // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
        // If `layer` is omitted, the style of all features in the current layer is reset.
        resetStyle: function(layer) {
            if (layer === undefined) return this.eachLayer(this.resetStyle, this);
            // reset any custom styles
            layer.options = extend({}, layer.defaultOptions);
            this._setLayerStyle(layer, this.options.style);
            return this;
        },
        // @method setStyle( <Function> style ): this
        // Changes styles of GeoJSON vector layers with the given style function.
        setStyle: function(style) {
            return this.eachLayer(function(layer) {
                this._setLayerStyle(layer, style);
            }, this);
        },
        _setLayerStyle: function(layer, style) {
            if (layer.setStyle) {
                if (typeof style === 'function') style = style(layer.feature);
                layer.setStyle(style);
            }
        }
    });
    // @section
    // There are several static functions which can be called without instantiating L.GeoJSON:
    // @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
    // Creates a `Layer` from a given GeoJSON feature. Can use a custom
    // [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
    // functions if provided as options.
    function geometryToLayer(geojson, options) {
        var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson, coords = geometry ? geometry.coordinates : null, layers = [], pointToLayer = options && options.pointToLayer, _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng, latlng, latlngs, i, len;
        if (!coords && !geometry) return null;
        switch(geometry.type){
            case 'Point':
                latlng = _coordsToLatLng(coords);
                return _pointToLayer(pointToLayer, geojson, latlng, options);
            case 'MultiPoint':
                for(i = 0, len = coords.length; i < len; i++){
                    latlng = _coordsToLatLng(coords[i]);
                    layers.push(_pointToLayer(pointToLayer, geojson, latlng, options));
                }
                return new FeatureGroup(layers);
            case 'LineString':
            case 'MultiLineString':
                latlngs = coordsToLatLngs(coords, geometry.type === 'LineString' ? 0 : 1, _coordsToLatLng);
                return new Polyline(latlngs, options);
            case 'Polygon':
            case 'MultiPolygon':
                latlngs = coordsToLatLngs(coords, geometry.type === 'Polygon' ? 1 : 2, _coordsToLatLng);
                return new Polygon(latlngs, options);
            case 'GeometryCollection':
                for(i = 0, len = geometry.geometries.length; i < len; i++){
                    var geoLayer = geometryToLayer({
                        geometry: geometry.geometries[i],
                        type: 'Feature',
                        properties: geojson.properties
                    }, options);
                    if (geoLayer) layers.push(geoLayer);
                }
                return new FeatureGroup(layers);
            case 'FeatureCollection':
                for(i = 0, len = geometry.features.length; i < len; i++){
                    var featureLayer = geometryToLayer(geometry.features[i], options);
                    if (featureLayer) layers.push(featureLayer);
                }
                return new FeatureGroup(layers);
            default:
                throw new Error('Invalid GeoJSON object.');
        }
    }
    function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
        return pointToLayerFn ? pointToLayerFn(geojson, latlng) : new Marker(latlng, options && options.markersInheritOptions && options);
    }
    // @function coordsToLatLng(coords: Array): LatLng
    // Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
    // or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
    function coordsToLatLng(coords) {
        return new LatLng(coords[1], coords[0], coords[2]);
    }
    // @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
    // Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
    // `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
    // Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
    function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
        var latlngs = [];
        for(var i = 0, len = coords.length, latlng; i < len; i++){
            latlng = levelsDeep ? coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) : (_coordsToLatLng || coordsToLatLng)(coords[i]);
            latlngs.push(latlng);
        }
        return latlngs;
    }
    // @function latLngToCoords(latlng: LatLng, precision?: Number|false): Array
    // Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngToCoords(latlng, precision) {
        latlng = toLatLng(latlng);
        return latlng.alt !== undefined ? [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision),
            formatNum(latlng.alt, precision)
        ] : [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision)
        ];
    }
    // @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean, precision?: Number|false): Array
    // Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
    // `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
        var coords = [];
        for(var i = 0, len = latlngs.length; i < len; i++)// Check for flat arrays required to ensure unbalanced arrays are correctly converted in recursion
        coords.push(levelsDeep ? latLngsToCoords(latlngs[i], isFlat(latlngs[i]) ? 0 : levelsDeep - 1, closed, precision) : latLngToCoords(latlngs[i], precision));
        if (!levelsDeep && closed && coords.length > 0) coords.push(coords[0].slice());
        return coords;
    }
    function getFeature(layer, newGeometry) {
        return layer.feature ? extend({}, layer.feature, {
            geometry: newGeometry
        }) : asFeature(newGeometry);
    }
    // @function asFeature(geojson: Object): Object
    // Normalize GeoJSON geometries/features into GeoJSON features.
    function asFeature(geojson) {
        if (geojson.type === 'Feature' || geojson.type === 'FeatureCollection') return geojson;
        return {
            type: 'Feature',
            properties: {},
            geometry: geojson
        };
    }
    var PointToGeoJSON = {
        toGeoJSON: function(precision) {
            return getFeature(this, {
                type: 'Point',
                coordinates: latLngToCoords(this.getLatLng(), precision)
            });
        }
    };
    // @namespace Marker
    // @section Other methods
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
    Marker.include(PointToGeoJSON);
    // @namespace CircleMarker
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
    Circle.include(PointToGeoJSON);
    CircleMarker.include(PointToGeoJSON);
    // @namespace Polyline
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
    Polyline.include({
        toGeoJSON: function(precision) {
            var multi = !isFlat(this._latlngs);
            var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
            return getFeature(this, {
                type: (multi ? 'Multi' : '') + 'LineString',
                coordinates: coords
            });
        }
    });
    // @namespace Polygon
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
    Polygon.include({
        toGeoJSON: function(precision) {
            var holes = !isFlat(this._latlngs), multi = holes && !isFlat(this._latlngs[0]);
            var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
            if (!holes) coords = [
                coords
            ];
            return getFeature(this, {
                type: (multi ? 'Multi' : '') + 'Polygon',
                coordinates: coords
            });
        }
    });
    // @namespace LayerGroup
    LayerGroup.include({
        toMultiPoint: function(precision) {
            var coords = [];
            this.eachLayer(function(layer) {
                coords.push(layer.toGeoJSON(precision).geometry.coordinates);
            });
            return getFeature(this, {
                type: 'MultiPoint',
                coordinates: coords
            });
        },
        // @method toGeoJSON(precision?: Number|false): Object
        // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
        // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
        toGeoJSON: function(precision) {
            var type = this.feature && this.feature.geometry && this.feature.geometry.type;
            if (type === 'MultiPoint') return this.toMultiPoint(precision);
            var isGeometryCollection = type === 'GeometryCollection', jsons = [];
            this.eachLayer(function(layer) {
                if (layer.toGeoJSON) {
                    var json = layer.toGeoJSON(precision);
                    if (isGeometryCollection) jsons.push(json.geometry);
                    else {
                        var feature = asFeature(json);
                        // Squash nested feature collections
                        if (feature.type === 'FeatureCollection') jsons.push.apply(jsons, feature.features);
                        else jsons.push(feature);
                    }
                }
            });
            if (isGeometryCollection) return getFeature(this, {
                geometries: jsons,
                type: 'GeometryCollection'
            });
            return {
                type: 'FeatureCollection',
                features: jsons
            };
        }
    });
    // @namespace GeoJSON
    // @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
    // Creates a GeoJSON layer. Optionally accepts an object in
    // [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
    // (you can alternatively add it later with `addData` method) and an `options` object.
    function geoJSON(geojson, options) {
        return new GeoJSON(geojson, options);
    }
    // Backward compatibility.
    var geoJson = geoJSON;
    /*
   * @class ImageOverlay
   * @aka L.ImageOverlay
   * @inherits Interactive layer
   *
   * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * var imageUrl = 'https://maps.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
   * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
   * L.imageOverlay(imageUrl, imageBounds).addTo(map);
   * ```
   */ var ImageOverlay = Layer.extend({
        // @section
        // @aka ImageOverlay options
        options: {
            // @option opacity: Number = 1.0
            // The opacity of the image overlay.
            opacity: 1,
            // @option alt: String = ''
            // Text for the `alt` attribute of the image (useful for accessibility).
            alt: '',
            // @option interactive: Boolean = false
            // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
            interactive: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the image.
            // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option errorOverlayUrl: String = ''
            // URL to the overlay image to show in place of the overlay that failed to load.
            errorOverlayUrl: '',
            // @option zIndex: Number = 1
            // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
            zIndex: 1,
            // @option className: String = ''
            // A custom class name to assign to the image. Empty by default.
            className: ''
        },
        initialize: function(url, bounds, options) {
            this._url = url;
            this._bounds = toLatLngBounds(bounds);
            setOptions(this, options);
        },
        onAdd: function() {
            if (!this._image) {
                this._initImage();
                if (this.options.opacity < 1) this._updateOpacity();
            }
            if (this.options.interactive) {
                addClass(this._image, 'leaflet-interactive');
                this.addInteractiveTarget(this._image);
            }
            this.getPane().appendChild(this._image);
            this._reset();
        },
        onRemove: function() {
            remove(this._image);
            if (this.options.interactive) this.removeInteractiveTarget(this._image);
        },
        // @method setOpacity(opacity: Number): this
        // Sets the opacity of the overlay.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._image) this._updateOpacity();
            return this;
        },
        setStyle: function(styleOpts) {
            if (styleOpts.opacity) this.setOpacity(styleOpts.opacity);
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all overlays.
        bringToFront: function() {
            if (this._map) toFront(this._image);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all overlays.
        bringToBack: function() {
            if (this._map) toBack(this._image);
            return this;
        },
        // @method setUrl(url: String): this
        // Changes the URL of the image.
        setUrl: function(url) {
            this._url = url;
            if (this._image) this._image.src = url;
            return this;
        },
        // @method setBounds(bounds: LatLngBounds): this
        // Update the bounds that this ImageOverlay covers
        setBounds: function(bounds) {
            this._bounds = toLatLngBounds(bounds);
            if (this._map) this._reset();
            return this;
        },
        getEvents: function() {
            var events = {
                zoom: this._reset,
                viewreset: this._reset
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method setZIndex(value: Number): this
        // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
        setZIndex: function(value) {
            this.options.zIndex = value;
            this._updateZIndex();
            return this;
        },
        // @method getBounds(): LatLngBounds
        // Get the bounds that this ImageOverlay covers
        getBounds: function() {
            return this._bounds;
        },
        // @method getElement(): HTMLElement
        // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
        // used by this overlay.
        getElement: function() {
            return this._image;
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === 'IMG';
            var img = this._image = wasElementSupplied ? this._url : create$1('img');
            addClass(img, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(img, 'leaflet-zoom-animated');
            if (this.options.className) addClass(img, this.options.className);
            img.onselectstart = falseFn;
            img.onmousemove = falseFn;
            // @event load: Event
            // Fired when the ImageOverlay layer has loaded its image
            img.onload = bind(this.fire, this, 'load');
            img.onerror = bind(this._overlayOnError, this, 'error');
            if (this.options.crossOrigin || this.options.crossOrigin === '') img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            if (this.options.zIndex) this._updateZIndex();
            if (wasElementSupplied) {
                this._url = img.src;
                return;
            }
            img.src = this._url;
            img.alt = this.options.alt;
        },
        _animateZoom: function(e) {
            var scale = this._map.getZoomScale(e.zoom), offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
            setTransform(this._image, offset, scale);
        },
        _reset: function() {
            var image = this._image, bounds = new Bounds(this._map.latLngToLayerPoint(this._bounds.getNorthWest()), this._map.latLngToLayerPoint(this._bounds.getSouthEast())), size = bounds.getSize();
            setPosition(image, bounds.min);
            image.style.width = size.x + 'px';
            image.style.height = size.y + 'px';
        },
        _updateOpacity: function() {
            setOpacity(this._image, this.options.opacity);
        },
        _updateZIndex: function() {
            if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) this._image.style.zIndex = this.options.zIndex;
        },
        _overlayOnError: function() {
            // @event error: Event
            // Fired when the ImageOverlay layer fails to load its image
            this.fire('error');
            var errorUrl = this.options.errorOverlayUrl;
            if (errorUrl && this._url !== errorUrl) {
                this._url = errorUrl;
                this._image.src = errorUrl;
            }
        },
        // @method getCenter(): LatLng
        // Returns the center of the ImageOverlay.
        getCenter: function() {
            return this._bounds.getCenter();
        }
    });
    // @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
    // Instantiates an image overlay object given the URL of the image and the
    // geographical bounds it is tied to.
    var imageOverlay = function(url, bounds, options) {
        return new ImageOverlay(url, bounds, options);
    };
    /*
   * @class VideoOverlay
   * @aka L.VideoOverlay
   * @inherits ImageOverlay
   *
   * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
   *
   * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
   * HTML5 element.
   *
   * @example
   *
   * ```js
   * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
   * 	videoBounds = [[ 32, -130], [ 13, -100]];
   * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
   * ```
   */ var VideoOverlay = ImageOverlay.extend({
        // @section
        // @aka VideoOverlay options
        options: {
            // @option autoplay: Boolean = true
            // Whether the video starts playing automatically when loaded.
            // On some browsers autoplay will only work with `muted: true`
            autoplay: true,
            // @option loop: Boolean = true
            // Whether the video will loop back to the beginning when played.
            loop: true,
            // @option keepAspectRatio: Boolean = true
            // Whether the video will save aspect ratio after the projection.
            // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
            keepAspectRatio: true,
            // @option muted: Boolean = false
            // Whether the video starts on mute when loaded.
            muted: false,
            // @option playsInline: Boolean = true
            // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
            playsInline: true
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === 'VIDEO';
            var vid = this._image = wasElementSupplied ? this._url : create$1('video');
            addClass(vid, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(vid, 'leaflet-zoom-animated');
            if (this.options.className) addClass(vid, this.options.className);
            vid.onselectstart = falseFn;
            vid.onmousemove = falseFn;
            // @event load: Event
            // Fired when the video has finished loading the first frame
            vid.onloadeddata = bind(this.fire, this, 'load');
            if (wasElementSupplied) {
                var sourceElements = vid.getElementsByTagName('source');
                var sources = [];
                for(var j = 0; j < sourceElements.length; j++)sources.push(sourceElements[j].src);
                this._url = sourceElements.length > 0 ? sources : [
                    vid.src
                ];
                return;
            }
            if (!isArray(this._url)) this._url = [
                this._url
            ];
            if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, 'objectFit')) vid.style['objectFit'] = 'fill';
            vid.autoplay = !!this.options.autoplay;
            vid.loop = !!this.options.loop;
            vid.muted = !!this.options.muted;
            vid.playsInline = !!this.options.playsInline;
            for(var i = 0; i < this._url.length; i++){
                var source = create$1('source');
                source.src = this._url[i];
                vid.appendChild(source);
            }
        }
    });
    // @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
    // Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
    // geographical bounds it is tied to.
    function videoOverlay(video, bounds, options) {
        return new VideoOverlay(video, bounds, options);
    }
    /*
   * @class SVGOverlay
   * @aka L.SVGOverlay
   * @inherits ImageOverlay
   *
   * Used to load, display and provide DOM access to an SVG file over specific bounds of the map. Extends `ImageOverlay`.
   *
   * An SVG overlay uses the [`<svg>`](https://developer.mozilla.org/docs/Web/SVG/Element/svg) element.
   *
   * @example
   *
   * ```js
   * var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
   * svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
   * svgElement.setAttribute('viewBox', "0 0 200 200");
   * svgElement.innerHTML = '<rect width="200" height="200"/><rect x="75" y="23" width="50" height="50" style="fill:red"/><rect x="75" y="123" width="50" height="50" style="fill:#0013ff"/>';
   * var svgElementBounds = [ [ 32, -130 ], [ 13, -100 ] ];
   * L.svgOverlay(svgElement, svgElementBounds).addTo(map);
   * ```
   */ var SVGOverlay = ImageOverlay.extend({
        _initImage: function() {
            var el = this._image = this._url;
            addClass(el, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(el, 'leaflet-zoom-animated');
            if (this.options.className) addClass(el, this.options.className);
            el.onselectstart = falseFn;
            el.onmousemove = falseFn;
        }
    });
    // @factory L.svgOverlay(svg: String|SVGElement, bounds: LatLngBounds, options?: SVGOverlay options)
    // Instantiates an image overlay object given an SVG element and the geographical bounds it is tied to.
    // A viewBox attribute is required on the SVG element to zoom in and out properly.
    function svgOverlay(el, bounds, options) {
        return new SVGOverlay(el, bounds, options);
    }
    /*
   * @class DivOverlay
   * @inherits Interactive layer
   * @aka L.DivOverlay
   * Base model for L.Popup and L.Tooltip. Inherit from it for custom overlays like plugins.
   */ // @namespace DivOverlay
    var DivOverlay = Layer.extend({
        // @section
        // @aka DivOverlay options
        options: {
            // @option interactive: Boolean = false
            // If true, the popup/tooltip will listen to the mouse events.
            interactive: false,
            // @option offset: Point = Point(0, 0)
            // The offset of the overlay position.
            offset: [
                0,
                0
            ],
            // @option className: String = ''
            // A custom CSS class name to assign to the overlay.
            className: '',
            // @option pane: String = undefined
            // `Map pane` where the overlay will be added.
            pane: undefined,
            // @option content: String|HTMLElement|Function = ''
            // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
            // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
            content: ''
        },
        initialize: function(options, source) {
            if (options && (options instanceof LatLng || isArray(options))) {
                this._latlng = toLatLng(options);
                setOptions(this, source);
            } else {
                setOptions(this, options);
                this._source = source;
            }
            if (this.options.content) this._content = this.options.content;
        },
        // @method openOn(map: Map): this
        // Adds the overlay to the map.
        // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this)) map.addLayer(this);
            return this;
        },
        // @method close(): this
        // Closes the overlay.
        // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
        // and `layer.closePopup()`/`.closeTooltip()`.
        close: function() {
            if (this._map) this._map.removeLayer(this);
            return this;
        },
        // @method toggle(layer?: Layer): this
        // Opens or closes the overlay bound to layer depending on its current state.
        // Argument may be omitted only for overlay bound to layer.
        // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
        toggle: function(layer) {
            if (this._map) this.close();
            else {
                if (arguments.length) this._source = layer;
                else layer = this._source;
                this._prepareOpen();
                // open the overlay on the map
                this.openOn(layer._map);
            }
            return this;
        },
        onAdd: function(map) {
            this._zoomAnimated = map._zoomAnimated;
            if (!this._container) this._initLayout();
            if (map._fadeAnimated) setOpacity(this._container, 0);
            clearTimeout(this._removeTimeout);
            this.getPane().appendChild(this._container);
            this.update();
            if (map._fadeAnimated) setOpacity(this._container, 1);
            this.bringToFront();
            if (this.options.interactive) {
                addClass(this._container, 'leaflet-interactive');
                this.addInteractiveTarget(this._container);
            }
        },
        onRemove: function(map) {
            if (map._fadeAnimated) {
                setOpacity(this._container, 0);
                this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
            } else remove(this._container);
            if (this.options.interactive) {
                removeClass(this._container, 'leaflet-interactive');
                this.removeInteractiveTarget(this._container);
            }
        },
        // @namespace DivOverlay
        // @method getLatLng: LatLng
        // Returns the geographical point of the overlay.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Sets the geographical point where the overlay will open.
        setLatLng: function(latlng) {
            this._latlng = toLatLng(latlng);
            if (this._map) {
                this._updatePosition();
                this._adjustPan();
            }
            return this;
        },
        // @method getContent: String|HTMLElement
        // Returns the content of the overlay.
        getContent: function() {
            return this._content;
        },
        // @method setContent(htmlContent: String|HTMLElement|Function): this
        // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
        // The function should return a `String` or `HTMLElement` to be used in the overlay.
        setContent: function(content) {
            this._content = content;
            this.update();
            return this;
        },
        // @method getElement: String|HTMLElement
        // Returns the HTML container of the overlay.
        getElement: function() {
            return this._container;
        },
        // @method update: null
        // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
        update: function() {
            if (!this._map) return;
            this._container.style.visibility = 'hidden';
            this._updateContent();
            this._updateLayout();
            this._updatePosition();
            this._container.style.visibility = '';
            this._adjustPan();
        },
        getEvents: function() {
            var events = {
                zoom: this._updatePosition,
                viewreset: this._updatePosition
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method isOpen: Boolean
        // Returns `true` when the overlay is visible on the map.
        isOpen: function() {
            return !!this._map && this._map.hasLayer(this);
        },
        // @method bringToFront: this
        // Brings this overlay in front of other overlays (in the same map pane).
        bringToFront: function() {
            if (this._map) toFront(this._container);
            return this;
        },
        // @method bringToBack: this
        // Brings this overlay to the back of other overlays (in the same map pane).
        bringToBack: function() {
            if (this._map) toBack(this._container);
            return this;
        },
        // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
        _prepareOpen: function(latlng) {
            var source = this._source;
            if (!source._map) return false;
            if (source instanceof FeatureGroup) {
                source = null;
                var layers = this._source._layers;
                for(var id in layers)if (layers[id]._map) {
                    source = layers[id];
                    break;
                }
                if (!source) return false;
                 // Unable to get source layer.
                // set overlay source to this layer
                this._source = source;
            }
            if (!latlng) {
                if (source.getCenter) latlng = source.getCenter();
                else if (source.getLatLng) latlng = source.getLatLng();
                else if (source.getBounds) latlng = source.getBounds().getCenter();
                else throw new Error('Unable to get source layer LatLng.');
            }
            this.setLatLng(latlng);
            if (this._map) // update the overlay (content, layout, etc...)
            this.update();
            return true;
        },
        _updateContent: function() {
            if (!this._content) return;
            var node = this._contentNode;
            var content = typeof this._content === 'function' ? this._content(this._source || this) : this._content;
            if (typeof content === 'string') node.innerHTML = content;
            else {
                while(node.hasChildNodes())node.removeChild(node.firstChild);
                node.appendChild(content);
            }
            // @namespace DivOverlay
            // @section DivOverlay events
            // @event contentupdate: Event
            // Fired when the content of the overlay is updated
            this.fire('contentupdate');
        },
        _updatePosition: function() {
            if (!this._map) return;
            var pos = this._map.latLngToLayerPoint(this._latlng), offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (this._zoomAnimated) setPosition(this._container, pos.add(anchor));
            else offset = offset.add(pos).add(anchor);
            var bottom = this._containerBottom = -offset.y, left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
            // bottom position the overlay in case the height of the overlay changes (images loading etc)
            this._container.style.bottom = bottom + 'px';
            this._container.style.left = left + 'px';
        },
        _getAnchor: function() {
            return [
                0,
                0
            ];
        }
    });
    Map.include({
        _initOverlay: function(OverlayClass, content, latlng, options) {
            var overlay = content;
            if (!(overlay instanceof OverlayClass)) overlay = new OverlayClass(options).setContent(content);
            if (latlng) overlay.setLatLng(latlng);
            return overlay;
        }
    });
    Layer.include({
        _initOverlay: function(OverlayClass, old, content, options) {
            var overlay = content;
            if (overlay instanceof OverlayClass) {
                setOptions(overlay, options);
                overlay._source = this;
            } else {
                overlay = old && !options ? old : new OverlayClass(options, this);
                overlay.setContent(content);
            }
            return overlay;
        }
    });
    /*
   * @class Popup
   * @inherits DivOverlay
   * @aka L.Popup
   * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
   * open popups while making sure that only one popup is open at one time
   * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
   *
   * @example
   *
   * If you want to just bind a popup to marker click and then open it, it's really easy:
   *
   * ```js
   * marker.bindPopup(popupContent).openPopup();
   * ```
   * Path overlays like polylines also have a `bindPopup` method.
   *
   * A popup can be also standalone:
   *
   * ```js
   * var popup = L.popup()
   * 	.setLatLng(latlng)
   * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   * or
   * ```js
   * var popup = L.popup(latlng, {content: '<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   */ // @namespace Popup
    var Popup = DivOverlay.extend({
        // @section
        // @aka Popup options
        options: {
            // @option pane: String = 'popupPane'
            // `Map pane` where the popup will be added.
            pane: 'popupPane',
            // @option offset: Point = Point(0, 7)
            // The offset of the popup position.
            offset: [
                0,
                7
            ],
            // @option maxWidth: Number = 300
            // Max width of the popup, in pixels.
            maxWidth: 300,
            // @option minWidth: Number = 50
            // Min width of the popup, in pixels.
            minWidth: 50,
            // @option maxHeight: Number = null
            // If set, creates a scrollable container of the given height
            // inside a popup if its content exceeds it.
            // The scrollable container can be styled using the
            // `leaflet-popup-scrolled` CSS class selector.
            maxHeight: null,
            // @option autoPan: Boolean = true
            // Set it to `false` if you don't want the map to do panning animation
            // to fit the opened popup.
            autoPan: true,
            // @option autoPanPaddingTopLeft: Point = null
            // The margin between the popup and the top left corner of the map
            // view after autopanning was performed.
            autoPanPaddingTopLeft: null,
            // @option autoPanPaddingBottomRight: Point = null
            // The margin between the popup and the bottom right corner of the map
            // view after autopanning was performed.
            autoPanPaddingBottomRight: null,
            // @option autoPanPadding: Point = Point(5, 5)
            // Equivalent of setting both top left and bottom right autopan padding to the same value.
            autoPanPadding: [
                5,
                5
            ],
            // @option keepInView: Boolean = false
            // Set it to `true` if you want to prevent users from panning the popup
            // off of the screen while it is open.
            keepInView: false,
            // @option closeButton: Boolean = true
            // Controls the presence of a close button in the popup.
            closeButton: true,
            // @option autoClose: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the popup closing when another popup is opened.
            autoClose: true,
            // @option closeOnEscapeKey: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the ESC key for closing of the popup.
            closeOnEscapeKey: true,
            // @option closeOnClick: Boolean = *
            // Set it if you want to override the default behavior of the popup closing when user clicks
            // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
            // @option className: String = ''
            // A custom CSS class name to assign to the popup.
            className: ''
        },
        // @namespace Popup
        // @method openOn(map: Map): this
        // Alternative to `map.openPopup(popup)`.
        // Adds the popup to the map and closes the previous one.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this) && map._popup && map._popup.options.autoClose) map.removeLayer(map._popup);
            map._popup = this;
            return DivOverlay.prototype.openOn.call(this, map);
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupopen: PopupEvent
            // Fired when a popup is opened in the map
            map.fire('popupopen', {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupopen: PopupEvent
                // Fired when a popup bound to this layer is opened
                this._source.fire('popupopen', {
                    popup: this
                }, true);
                // For non-path layers, we toggle the popup when clicking
                // again the layer, so prevent the map to reopen it.
                if (!(this._source instanceof Path)) this._source.on('preclick', stopPropagation);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupclose: PopupEvent
            // Fired when a popup in the map is closed
            map.fire('popupclose', {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupclose: PopupEvent
                // Fired when a popup bound to this layer is closed
                this._source.fire('popupclose', {
                    popup: this
                }, true);
                if (!(this._source instanceof Path)) this._source.off('preclick', stopPropagation);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) events.preclick = this.close;
            if (this.options.keepInView) events.moveend = this._adjustPan;
            return events;
        },
        _initLayout: function() {
            var prefix = 'leaflet-popup', container = this._container = create$1('div', prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-animated');
            var wrapper = this._wrapper = create$1('div', prefix + '-content-wrapper', container);
            this._contentNode = create$1('div', prefix + '-content', wrapper);
            disableClickPropagation(container);
            disableScrollPropagation(this._contentNode);
            on(container, 'contextmenu', stopPropagation);
            this._tipContainer = create$1('div', prefix + '-tip-container', container);
            this._tip = create$1('div', prefix + '-tip', this._tipContainer);
            if (this.options.closeButton) {
                var closeButton = this._closeButton = create$1('a', prefix + '-close-button', container);
                closeButton.setAttribute('role', 'button'); // overrides the implicit role=link of <a> elements #7399
                closeButton.setAttribute('aria-label', 'Close popup');
                closeButton.href = '#close';
                closeButton.innerHTML = '<span aria-hidden="true">&#215;</span>';
                on(closeButton, 'click', function(ev) {
                    preventDefault(ev);
                    this.close();
                }, this);
            }
        },
        _updateLayout: function() {
            var container = this._contentNode, style = container.style;
            style.width = '';
            style.whiteSpace = 'nowrap';
            var width = container.offsetWidth;
            width = Math.min(width, this.options.maxWidth);
            width = Math.max(width, this.options.minWidth);
            style.width = width + 1 + 'px';
            style.whiteSpace = '';
            style.height = '';
            var height = container.offsetHeight, maxHeight = this.options.maxHeight, scrolledClass = 'leaflet-popup-scrolled';
            if (maxHeight && height > maxHeight) {
                style.height = maxHeight + 'px';
                addClass(container, scrolledClass);
            } else removeClass(container, scrolledClass);
            this._containerWidth = this._container.offsetWidth;
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center), anchor = this._getAnchor();
            setPosition(this._container, pos.add(anchor));
        },
        _adjustPan: function() {
            if (!this.options.autoPan) return;
            if (this._map._panAnim) this._map._panAnim.stop();
            // We can endlessly recurse if keepInView is set and the view resets.
            // Let's guard against that by exiting early if we're responding to our own autopan.
            if (this._autopanning) {
                this._autopanning = false;
                return;
            }
            var map = this._map, marginBottom = parseInt(getStyle(this._container, 'marginBottom'), 10) || 0, containerHeight = this._container.offsetHeight + marginBottom, containerWidth = this._containerWidth, layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
            layerPos._add(getPosition(this._container));
            var containerPos = map.layerPointToContainerPoint(layerPos), padding = toPoint(this.options.autoPanPadding), paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding), paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding), size = map.getSize(), dx = 0, dy = 0;
            if (containerPos.x + containerWidth + paddingBR.x > size.x) dx = containerPos.x + containerWidth - size.x + paddingBR.x;
            if (containerPos.x - dx - paddingTL.x < 0) dx = containerPos.x - paddingTL.x;
            if (containerPos.y + containerHeight + paddingBR.y > size.y) dy = containerPos.y + containerHeight - size.y + paddingBR.y;
            if (containerPos.y - dy - paddingTL.y < 0) dy = containerPos.y - paddingTL.y;
            // @namespace Map
            // @section Popup events
            // @event autopanstart: Event
            // Fired when the map starts autopanning when opening a popup.
            if (dx || dy) {
                // Track that we're autopanning, as this function will be re-ran on moveend
                if (this.options.keepInView) this._autopanning = true;
                map.fire('autopanstart').panBy([
                    dx,
                    dy
                ]);
            }
        },
        _getAnchor: function() {
            // Where should we anchor the popup on the source layer?
            return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Popup
    // @factory L.popup(options?: Popup options, source?: Layer)
    // Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.popup(latlng: LatLng, options?: Popup options)
    // Instantiates a `Popup` object given `latlng` where the popup will open and an optional `options` object that describes its appearance and location.
    var popup = function(options, source) {
        return new Popup(options, source);
    };
    /* @namespace Map
   * @section Interaction Options
   * @option closePopupOnClick: Boolean = true
   * Set it to `false` if you don't want popups to close when user clicks the map.
   */ Map.mergeOptions({
        closePopupOnClick: true
    });
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openPopup(popup: Popup): this
        // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
        // @alternative
        // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
        // Creates a popup with the specified content and options and opens it in the given point on a map.
        openPopup: function(popup, latlng, options) {
            this._initOverlay(Popup, popup, latlng, options).openOn(this);
            return this;
        },
        // @method closePopup(popup?: Popup): this
        // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
        closePopup: function(popup) {
            popup = arguments.length ? popup : this._popup;
            if (popup) popup.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Popup methods example
   *
   * All layers share a set of methods convenient for binding popups to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
   * layer.openPopup();
   * layer.closePopup();
   * ```
   *
   * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
   */ // @section Popup methods
    Layer.include({
        // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
        // Binds a popup to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindPopup: function(content, options) {
            this._popup = this._initOverlay(Popup, this._popup, content, options);
            if (!this._popupHandlersAdded) {
                this.on({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = true;
            }
            return this;
        },
        // @method unbindPopup(): this
        // Removes the popup previously bound with `bindPopup`.
        unbindPopup: function() {
            if (this._popup) {
                this.off({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = false;
                this._popup = null;
            }
            return this;
        },
        // @method openPopup(latlng?: LatLng): this
        // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
        openPopup: function(latlng) {
            if (this._popup) {
                if (!(this instanceof FeatureGroup)) this._popup._source = this;
                if (this._popup._prepareOpen(latlng || this._latlng)) // open the popup on the map
                this._popup.openOn(this._map);
            }
            return this;
        },
        // @method closePopup(): this
        // Closes the popup bound to this layer if it is open.
        closePopup: function() {
            if (this._popup) this._popup.close();
            return this;
        },
        // @method togglePopup(): this
        // Opens or closes the popup bound to this layer depending on its current state.
        togglePopup: function() {
            if (this._popup) this._popup.toggle(this);
            return this;
        },
        // @method isPopupOpen(): boolean
        // Returns `true` if the popup bound to this layer is currently open.
        isPopupOpen: function() {
            return this._popup ? this._popup.isOpen() : false;
        },
        // @method setPopupContent(content: String|HTMLElement|Popup): this
        // Sets the content of the popup bound to this layer.
        setPopupContent: function(content) {
            if (this._popup) this._popup.setContent(content);
            return this;
        },
        // @method getPopup(): Popup
        // Returns the popup bound to this layer.
        getPopup: function() {
            return this._popup;
        },
        _openPopup: function(e) {
            if (!this._popup || !this._map) return;
            // prevent map click
            stop(e);
            var target = e.layer || e.target;
            if (this._popup._source === target && !(target instanceof Path)) {
                // treat it like a marker and figure out
                // if we should toggle it open/closed
                if (this._map.hasLayer(this._popup)) this.closePopup();
                else this.openPopup(e.latlng);
                return;
            }
            this._popup._source = target;
            this.openPopup(e.latlng);
        },
        _movePopup: function(e) {
            this._popup.setLatLng(e.latlng);
        },
        _onKeyPress: function(e) {
            if (e.originalEvent.keyCode === 13) this._openPopup(e);
        }
    });
    /*
   * @class Tooltip
   * @inherits DivOverlay
   * @aka L.Tooltip
   * Used to display small texts on top of map layers.
   *
   * @example
   * If you want to just bind a tooltip to marker:
   *
   * ```js
   * marker.bindTooltip("my tooltip text").openTooltip();
   * ```
   * Path overlays like polylines also have a `bindTooltip` method.
   *
   * A tooltip can be also standalone:
   *
   * ```js
   * var tooltip = L.tooltip()
   * 	.setLatLng(latlng)
   * 	.setContent('Hello world!<br />This is a nice tooltip.')
   * 	.addTo(map);
   * ```
   * or
   * ```js
   * var tooltip = L.tooltip(latlng, {content: 'Hello world!<br />This is a nice tooltip.'})
   * 	.addTo(map);
   * ```
   *
   *
   * Note about tooltip offset. Leaflet takes two options in consideration
   * for computing tooltip offsetting:
   * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
   *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
   *   move it to the bottom. Negatives will move to the left and top.
   * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
   *   should adapt this value if you use a custom icon.
   */ // @namespace Tooltip
    var Tooltip = DivOverlay.extend({
        // @section
        // @aka Tooltip options
        options: {
            // @option pane: String = 'tooltipPane'
            // `Map pane` where the tooltip will be added.
            pane: 'tooltipPane',
            // @option offset: Point = Point(0, 0)
            // Optional offset of the tooltip position.
            offset: [
                0,
                0
            ],
            // @option direction: String = 'auto'
            // Direction where to open the tooltip. Possible values are: `right`, `left`,
            // `top`, `bottom`, `center`, `auto`.
            // `auto` will dynamically switch between `right` and `left` according to the tooltip
            // position on the map.
            direction: 'auto',
            // @option permanent: Boolean = false
            // Whether to open the tooltip permanently or only on mouseover.
            permanent: false,
            // @option sticky: Boolean = false
            // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
            sticky: false,
            // @option opacity: Number = 0.9
            // Tooltip container opacity.
            opacity: 0.9
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            this.setOpacity(this.options.opacity);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipopen: TooltipEvent
            // Fired when a tooltip is opened in the map.
            map.fire('tooltipopen', {
                tooltip: this
            });
            if (this._source) {
                this.addEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipopen: TooltipEvent
                // Fired when a tooltip bound to this layer is opened.
                this._source.fire('tooltipopen', {
                    tooltip: this
                }, true);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipclose: TooltipEvent
            // Fired when a tooltip in the map is closed.
            map.fire('tooltipclose', {
                tooltip: this
            });
            if (this._source) {
                this.removeEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipclose: TooltipEvent
                // Fired when a tooltip bound to this layer is closed.
                this._source.fire('tooltipclose', {
                    tooltip: this
                }, true);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (!this.options.permanent) events.preclick = this.close;
            return events;
        },
        _initLayout: function() {
            var prefix = 'leaflet-tooltip', className = prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
            this._contentNode = this._container = create$1('div', className);
            this._container.setAttribute('role', 'tooltip');
            this._container.setAttribute('id', 'leaflet-tooltip-' + stamp(this));
        },
        _updateLayout: function() {},
        _adjustPan: function() {},
        _setPosition: function(pos) {
            var subX, subY, map = this._map, container = this._container, centerPoint = map.latLngToContainerPoint(map.getCenter()), tooltipPoint = map.layerPointToContainerPoint(pos), direction = this.options.direction, tooltipWidth = container.offsetWidth, tooltipHeight = container.offsetHeight, offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (direction === 'top') {
                subX = tooltipWidth / 2;
                subY = tooltipHeight;
            } else if (direction === 'bottom') {
                subX = tooltipWidth / 2;
                subY = 0;
            } else if (direction === 'center') {
                subX = tooltipWidth / 2;
                subY = tooltipHeight / 2;
            } else if (direction === 'right') {
                subX = 0;
                subY = tooltipHeight / 2;
            } else if (direction === 'left') {
                subX = tooltipWidth;
                subY = tooltipHeight / 2;
            } else if (tooltipPoint.x < centerPoint.x) {
                direction = 'right';
                subX = 0;
                subY = tooltipHeight / 2;
            } else {
                direction = 'left';
                subX = tooltipWidth + (offset.x + anchor.x) * 2;
                subY = tooltipHeight / 2;
            }
            pos = pos.subtract(toPoint(subX, subY, true)).add(offset).add(anchor);
            removeClass(container, 'leaflet-tooltip-right');
            removeClass(container, 'leaflet-tooltip-left');
            removeClass(container, 'leaflet-tooltip-top');
            removeClass(container, 'leaflet-tooltip-bottom');
            addClass(container, 'leaflet-tooltip-' + direction);
            setPosition(container, pos);
        },
        _updatePosition: function() {
            var pos = this._map.latLngToLayerPoint(this._latlng);
            this._setPosition(pos);
        },
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._container) setOpacity(this._container, opacity);
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
            this._setPosition(pos);
        },
        _getAnchor: function() {
            // Where should we anchor the tooltip on the source layer?
            return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Tooltip
    // @factory L.tooltip(options?: Tooltip options, source?: Layer)
    // Instantiates a `Tooltip` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.tooltip(latlng: LatLng, options?: Tooltip options)
    // Instantiates a `Tooltip` object given `latlng` where the tooltip will open and an optional `options` object that describes its appearance and location.
    var tooltip = function(options, source) {
        return new Tooltip(options, source);
    };
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openTooltip(tooltip: Tooltip): this
        // Opens the specified tooltip.
        // @alternative
        // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
        // Creates a tooltip with the specified content and options and open it.
        openTooltip: function(tooltip, latlng, options) {
            this._initOverlay(Tooltip, tooltip, latlng, options).openOn(this);
            return this;
        },
        // @method closeTooltip(tooltip: Tooltip): this
        // Closes the tooltip given as parameter.
        closeTooltip: function(tooltip) {
            tooltip.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Tooltip methods example
   *
   * All layers share a set of methods convenient for binding tooltips to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
   * layer.openTooltip();
   * layer.closeTooltip();
   * ```
   */ // @section Tooltip methods
    Layer.include({
        // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
        // Binds a tooltip to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindTooltip: function(content, options) {
            if (this._tooltip && this.isTooltipOpen()) this.unbindTooltip();
            this._tooltip = this._initOverlay(Tooltip, this._tooltip, content, options);
            this._initTooltipInteractions();
            if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) this.openTooltip();
            return this;
        },
        // @method unbindTooltip(): this
        // Removes the tooltip previously bound with `bindTooltip`.
        unbindTooltip: function() {
            if (this._tooltip) {
                this._initTooltipInteractions(true);
                this.closeTooltip();
                this._tooltip = null;
            }
            return this;
        },
        _initTooltipInteractions: function(remove) {
            if (!remove && this._tooltipHandlersAdded) return;
            var onOff = remove ? 'off' : 'on', events = {
                remove: this.closeTooltip,
                move: this._moveTooltip
            };
            if (!this._tooltip.options.permanent) {
                events.mouseover = this._openTooltip;
                events.mouseout = this.closeTooltip;
                events.click = this._openTooltip;
                if (this._map) this._addFocusListeners();
                else events.add = this._addFocusListeners;
            } else events.add = this._openTooltip;
            if (this._tooltip.options.sticky) events.mousemove = this._moveTooltip;
            this[onOff](events);
            this._tooltipHandlersAdded = !remove;
        },
        // @method openTooltip(latlng?: LatLng): this
        // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
        openTooltip: function(latlng) {
            if (this._tooltip) {
                if (!(this instanceof FeatureGroup)) this._tooltip._source = this;
                if (this._tooltip._prepareOpen(latlng)) {
                    // open the tooltip on the map
                    this._tooltip.openOn(this._map);
                    if (this.getElement) this._setAriaDescribedByOnLayer(this);
                    else if (this.eachLayer) this.eachLayer(this._setAriaDescribedByOnLayer, this);
                }
            }
            return this;
        },
        // @method closeTooltip(): this
        // Closes the tooltip bound to this layer if it is open.
        closeTooltip: function() {
            if (this._tooltip) return this._tooltip.close();
        },
        // @method toggleTooltip(): this
        // Opens or closes the tooltip bound to this layer depending on its current state.
        toggleTooltip: function() {
            if (this._tooltip) this._tooltip.toggle(this);
            return this;
        },
        // @method isTooltipOpen(): boolean
        // Returns `true` if the tooltip bound to this layer is currently open.
        isTooltipOpen: function() {
            return this._tooltip.isOpen();
        },
        // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
        // Sets the content of the tooltip bound to this layer.
        setTooltipContent: function(content) {
            if (this._tooltip) this._tooltip.setContent(content);
            return this;
        },
        // @method getTooltip(): Tooltip
        // Returns the tooltip bound to this layer.
        getTooltip: function() {
            return this._tooltip;
        },
        _addFocusListeners: function() {
            if (this.getElement) this._addFocusListenersOnLayer(this);
            else if (this.eachLayer) this.eachLayer(this._addFocusListenersOnLayer, this);
        },
        _addFocusListenersOnLayer: function(layer) {
            var el = typeof layer.getElement === 'function' && layer.getElement();
            if (el) {
                on(el, 'focus', function() {
                    this._tooltip._source = layer;
                    this.openTooltip();
                }, this);
                on(el, 'blur', this.closeTooltip, this);
            }
        },
        _setAriaDescribedByOnLayer: function(layer) {
            var el = typeof layer.getElement === 'function' && layer.getElement();
            if (el) el.setAttribute('aria-describedby', this._tooltip._container.id);
        },
        _openTooltip: function(e) {
            if (!this._tooltip || !this._map) return;
            // If the map is moving, we will show the tooltip after it's done.
            if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
                this._openOnceFlag = true;
                var that = this;
                this._map.once('moveend', function() {
                    that._openOnceFlag = false;
                    that._openTooltip(e);
                });
                return;
            }
            this._tooltip._source = e.layer || e.target;
            this.openTooltip(this._tooltip.options.sticky ? e.latlng : undefined);
        },
        _moveTooltip: function(e) {
            var latlng = e.latlng, containerPoint, layerPoint;
            if (this._tooltip.options.sticky && e.originalEvent) {
                containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
                layerPoint = this._map.containerPointToLayerPoint(containerPoint);
                latlng = this._map.layerPointToLatLng(layerPoint);
            }
            this._tooltip.setLatLng(latlng);
        }
    });
    /*
   * @class DivIcon
   * @aka L.DivIcon
   * @inherits Icon
   *
   * Represents a lightweight icon for markers that uses a simple `<div>`
   * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
   *
   * @example
   * ```js
   * var myIcon = L.divIcon({className: 'my-div-icon'});
   * // you can set .my-div-icon styles in CSS
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
   */ var DivIcon = Icon.extend({
        options: {
            // @section
            // @aka DivIcon options
            iconSize: [
                12,
                12
            ],
            // iconAnchor: (Point),
            // popupAnchor: (Point),
            // @option html: String|HTMLElement = ''
            // Custom HTML code to put inside the div element, empty by default. Alternatively,
            // an instance of `HTMLElement`.
            html: false,
            // @option bgPos: Point = [0, 0]
            // Optional relative position of the background, in pixels
            bgPos: null,
            className: 'leaflet-div-icon'
        },
        createIcon: function(oldIcon) {
            var div = oldIcon && oldIcon.tagName === 'DIV' ? oldIcon : document.createElement('div'), options = this.options;
            if (options.html instanceof Element) {
                empty(div);
                div.appendChild(options.html);
            } else div.innerHTML = options.html !== false ? options.html : '';
            if (options.bgPos) {
                var bgPos = toPoint(options.bgPos);
                div.style.backgroundPosition = -bgPos.x + 'px ' + -bgPos.y + 'px';
            }
            this._setIconStyles(div, 'icon');
            return div;
        },
        createShadow: function() {
            return null;
        }
    });
    // @factory L.divIcon(options: DivIcon options)
    // Creates a `DivIcon` instance with the given options.
    function divIcon(options) {
        return new DivIcon(options);
    }
    Icon.Default = IconDefault;
    /*
   * @class GridLayer
   * @inherits Layer
   * @aka L.GridLayer
   *
   * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
   * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
   *
   *
   * @section Synchronous usage
   * @example
   *
   * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords){
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
   *         var ctx = tile.getContext('2d');
   *
   *         // return the tile so it can be rendered on screen
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section Asynchronous usage
   * @example
   *
   * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords, done){
   *         var error;
   *
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // draw something asynchronously and pass the tile to the done() callback
   *         setTimeout(function() {
   *             done(error, tile);
   *         }, 1000);
   *
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section
   */ var GridLayer = Layer.extend({
        // @section
        // @aka GridLayer options
        options: {
            // @option tileSize: Number|Point = 256
            // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
            tileSize: 256,
            // @option opacity: Number = 1.0
            // Opacity of the tiles. Can be used in the `createTile()` function.
            opacity: 1,
            // @option updateWhenIdle: Boolean = (depends)
            // Load new tiles only when panning ends.
            // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
            // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
            // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
            updateWhenIdle: Browser.mobile,
            // @option updateWhenZooming: Boolean = true
            // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
            updateWhenZooming: true,
            // @option updateInterval: Number = 200
            // Tiles will not update more than once every `updateInterval` milliseconds when panning.
            updateInterval: 200,
            // @option zIndex: Number = 1
            // The explicit zIndex of the tile layer.
            zIndex: 1,
            // @option bounds: LatLngBounds = undefined
            // If set, tiles will only be loaded inside the set `LatLngBounds`.
            bounds: null,
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = undefined
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: undefined,
            // @option maxNativeZoom: Number = undefined
            // Maximum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
            // from `maxNativeZoom` level and auto-scaled.
            maxNativeZoom: undefined,
            // @option minNativeZoom: Number = undefined
            // Minimum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
            // from `minNativeZoom` level and auto-scaled.
            minNativeZoom: undefined,
            // @option noWrap: Boolean = false
            // Whether the layer is wrapped around the antimeridian. If `true`, the
            // GridLayer will only be displayed once at low zoom levels. Has no
            // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
            // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
            // tiles outside the CRS limits.
            noWrap: false,
            // @option pane: String = 'tilePane'
            // `Map pane` where the grid layer will be added.
            pane: 'tilePane',
            // @option className: String = ''
            // A custom class name to assign to the tile layer. Empty by default.
            className: '',
            // @option keepBuffer: Number = 2
            // When panning the map, keep this many rows and columns of tiles before unloading them.
            keepBuffer: 2
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        onAdd: function() {
            this._initContainer();
            this._levels = {};
            this._tiles = {};
            this._resetView(); // implicit _update() call
        },
        beforeAdd: function(map) {
            map._addZoomLimit(this);
        },
        onRemove: function(map) {
            this._removeAllTiles();
            remove(this._container);
            map._removeZoomLimit(this);
            this._container = null;
            this._tileZoom = undefined;
        },
        // @method bringToFront: this
        // Brings the tile layer to the top of all tile layers.
        bringToFront: function() {
            if (this._map) {
                toFront(this._container);
                this._setAutoZIndex(Math.max);
            }
            return this;
        },
        // @method bringToBack: this
        // Brings the tile layer to the bottom of all tile layers.
        bringToBack: function() {
            if (this._map) {
                toBack(this._container);
                this._setAutoZIndex(Math.min);
            }
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the tiles for this layer.
        getContainer: function() {
            return this._container;
        },
        // @method setOpacity(opacity: Number): this
        // Changes the [opacity](#gridlayer-opacity) of the grid layer.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            this._updateOpacity();
            return this;
        },
        // @method setZIndex(zIndex: Number): this
        // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
        setZIndex: function(zIndex) {
            this.options.zIndex = zIndex;
            this._updateZIndex();
            return this;
        },
        // @method isLoading: Boolean
        // Returns `true` if any tile in the grid layer has not finished loading.
        isLoading: function() {
            return this._loading;
        },
        // @method redraw: this
        // Causes the layer to clear all the tiles and request them again.
        redraw: function() {
            if (this._map) {
                this._removeAllTiles();
                var tileZoom = this._clampZoom(this._map.getZoom());
                if (tileZoom !== this._tileZoom) {
                    this._tileZoom = tileZoom;
                    this._updateLevels();
                }
                this._update();
            }
            return this;
        },
        getEvents: function() {
            var events = {
                viewprereset: this._invalidateAll,
                viewreset: this._resetView,
                zoom: this._resetView,
                moveend: this._onMoveEnd
            };
            if (!this.options.updateWhenIdle) {
                // update tiles on move, but not more often than once per given interval
                if (!this._onMove) this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
                events.move = this._onMove;
            }
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @section Extension methods
        // Layers extending `GridLayer` shall reimplement the following method.
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, must be overridden by classes extending `GridLayer`.
        // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
        // is specified, it must be called when the tile has finished loading and drawing.
        createTile: function() {
            return document.createElement('div');
        },
        // @section
        // @method getTileSize: Point
        // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
        getTileSize: function() {
            var s = this.options.tileSize;
            return s instanceof Point ? s : new Point(s, s);
        },
        _updateZIndex: function() {
            if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) this._container.style.zIndex = this.options.zIndex;
        },
        _setAutoZIndex: function(compare) {
            // go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
            var layers = this.getPane().children, edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
            for(var i = 0, len = layers.length, zIndex; i < len; i++){
                zIndex = layers[i].style.zIndex;
                if (layers[i] !== this._container && zIndex) edgeZIndex = compare(edgeZIndex, +zIndex);
            }
            if (isFinite(edgeZIndex)) {
                this.options.zIndex = edgeZIndex + compare(-1, 1);
                this._updateZIndex();
            }
        },
        _updateOpacity: function() {
            if (!this._map) return;
            // IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
            if (Browser.ielt9) return;
            setOpacity(this._container, this.options.opacity);
            var now = +new Date(), nextFrame = false, willPrune = false;
            for(var key in this._tiles){
                var tile = this._tiles[key];
                if (!tile.current || !tile.loaded) continue;
                var fade = Math.min(1, (now - tile.loaded) / 200);
                setOpacity(tile.el, fade);
                if (fade < 1) nextFrame = true;
                else {
                    if (tile.active) willPrune = true;
                    else this._onOpaqueTile(tile);
                    tile.active = true;
                }
            }
            if (willPrune && !this._noPrune) this._pruneTiles();
            if (nextFrame) {
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            }
        },
        _onOpaqueTile: falseFn,
        _initContainer: function() {
            if (this._container) return;
            this._container = create$1('div', 'leaflet-layer ' + (this.options.className || ''));
            this._updateZIndex();
            if (this.options.opacity < 1) this._updateOpacity();
            this.getPane().appendChild(this._container);
        },
        _updateLevels: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom;
            if (zoom === undefined) return undefined;
            for(var z in this._levels){
                z = Number(z);
                if (this._levels[z].el.children.length || z === zoom) {
                    this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
                    this._onUpdateLevel(z);
                } else {
                    remove(this._levels[z].el);
                    this._removeTilesAtZoom(z);
                    this._onRemoveLevel(z);
                    delete this._levels[z];
                }
            }
            var level = this._levels[zoom], map = this._map;
            if (!level) {
                level = this._levels[zoom] = {};
                level.el = create$1('div', 'leaflet-tile-container leaflet-zoom-animated', this._container);
                level.el.style.zIndex = maxZoom;
                level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
                level.zoom = zoom;
                this._setZoomTransform(level, map.getCenter(), map.getZoom());
                // force the browser to consider the newly added element for transition
                falseFn(level.el.offsetWidth);
                this._onCreateLevel(level);
            }
            this._level = level;
            return level;
        },
        _onUpdateLevel: falseFn,
        _onRemoveLevel: falseFn,
        _onCreateLevel: falseFn,
        _pruneTiles: function() {
            if (!this._map) return;
            var key, tile;
            var zoom = this._map.getZoom();
            if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
                this._removeAllTiles();
                return;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                tile.retain = tile.current;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                if (tile.current && !tile.active) {
                    var coords = tile.coords;
                    if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
                }
            }
            for(key in this._tiles)if (!this._tiles[key].retain) this._removeTile(key);
        },
        _removeTilesAtZoom: function(zoom) {
            for(var key in this._tiles){
                if (this._tiles[key].coords.z !== zoom) continue;
                this._removeTile(key);
            }
        },
        _removeAllTiles: function() {
            for(var key in this._tiles)this._removeTile(key);
        },
        _invalidateAll: function() {
            for(var z in this._levels){
                remove(this._levels[z].el);
                this._onRemoveLevel(Number(z));
                delete this._levels[z];
            }
            this._removeAllTiles();
            this._tileZoom = undefined;
        },
        _retainParent: function(x, y, z, minZoom) {
            var x2 = Math.floor(x / 2), y2 = Math.floor(y / 2), z2 = z - 1, coords2 = new Point(+x2, +y2);
            coords2.z = +z2;
            var key = this._tileCoordsToKey(coords2), tile = this._tiles[key];
            if (tile && tile.active) {
                tile.retain = true;
                return true;
            } else if (tile && tile.loaded) tile.retain = true;
            if (z2 > minZoom) return this._retainParent(x2, y2, z2, minZoom);
            return false;
        },
        _retainChildren: function(x, y, z, maxZoom) {
            for(var i = 2 * x; i < 2 * x + 2; i++)for(var j = 2 * y; j < 2 * y + 2; j++){
                var coords = new Point(i, j);
                coords.z = z + 1;
                var key = this._tileCoordsToKey(coords), tile = this._tiles[key];
                if (tile && tile.active) {
                    tile.retain = true;
                    continue;
                } else if (tile && tile.loaded) tile.retain = true;
                if (z + 1 < maxZoom) this._retainChildren(i, j, z + 1, maxZoom);
            }
        },
        _resetView: function(e) {
            var animating = e && (e.pinch || e.flyTo);
            this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
        },
        _animateZoom: function(e) {
            this._setView(e.center, e.zoom, true, e.noUpdate);
        },
        _clampZoom: function(zoom) {
            var options = this.options;
            if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) return options.minNativeZoom;
            if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) return options.maxNativeZoom;
            return zoom;
        },
        _setView: function(center, zoom, noPrune, noUpdate) {
            var tileZoom = Math.round(zoom);
            if (this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom || this.options.minZoom !== undefined && tileZoom < this.options.minZoom) tileZoom = undefined;
            else tileZoom = this._clampZoom(tileZoom);
            var tileZoomChanged = this.options.updateWhenZooming && tileZoom !== this._tileZoom;
            if (!noUpdate || tileZoomChanged) {
                this._tileZoom = tileZoom;
                if (this._abortLoading) this._abortLoading();
                this._updateLevels();
                this._resetGrid();
                if (tileZoom !== undefined) this._update(center);
                if (!noPrune) this._pruneTiles();
                // Flag to prevent _updateOpacity from pruning tiles during
                // a zoom anim or a pinch gesture
                this._noPrune = !!noPrune;
            }
            this._setZoomTransforms(center, zoom);
        },
        _setZoomTransforms: function(center, zoom) {
            for(var i in this._levels)this._setZoomTransform(this._levels[i], center, zoom);
        },
        _setZoomTransform: function(level, center, zoom) {
            var scale = this._map.getZoomScale(zoom, level.zoom), translate = level.origin.multiplyBy(scale).subtract(this._map._getNewPixelOrigin(center, zoom)).round();
            if (Browser.any3d) setTransform(level.el, translate, scale);
            else setPosition(level.el, translate);
        },
        _resetGrid: function() {
            var map = this._map, crs = map.options.crs, tileSize = this._tileSize = this.getTileSize(), tileZoom = this._tileZoom;
            var bounds = this._map.getPixelWorldBounds(this._tileZoom);
            if (bounds) this._globalTileRange = this._pxBoundsToTileRange(bounds);
            this._wrapX = crs.wrapLng && !this.options.noWrap && [
                Math.floor(map.project([
                    0,
                    crs.wrapLng[0]
                ], tileZoom).x / tileSize.x),
                Math.ceil(map.project([
                    0,
                    crs.wrapLng[1]
                ], tileZoom).x / tileSize.y)
            ];
            this._wrapY = crs.wrapLat && !this.options.noWrap && [
                Math.floor(map.project([
                    crs.wrapLat[0],
                    0
                ], tileZoom).y / tileSize.x),
                Math.ceil(map.project([
                    crs.wrapLat[1],
                    0
                ], tileZoom).y / tileSize.y)
            ];
        },
        _onMoveEnd: function() {
            if (!this._map || this._map._animatingZoom) return;
            this._update();
        },
        _getTiledPixelBounds: function(center) {
            var map = this._map, mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(), scale = map.getZoomScale(mapZoom, this._tileZoom), pixelCenter = map.project(center, this._tileZoom).floor(), halfSize = map.getSize().divideBy(scale * 2);
            return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
        },
        // Private method to load tiles in the grid's active zoom level according to map bounds
        _update: function(center) {
            var map = this._map;
            if (!map) return;
            var zoom = this._clampZoom(map.getZoom());
            if (center === undefined) center = map.getCenter();
            if (this._tileZoom === undefined) return;
             // if out of minzoom/maxzoom
            var pixelBounds = this._getTiledPixelBounds(center), tileRange = this._pxBoundsToTileRange(pixelBounds), tileCenter = tileRange.getCenter(), queue = [], margin = this.options.keepBuffer, noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([
                margin,
                -margin
            ]), tileRange.getTopRight().add([
                margin,
                -margin
            ]));
            // Sanity check: panic if the tile range contains Infinity somewhere.
            if (!(isFinite(tileRange.min.x) && isFinite(tileRange.min.y) && isFinite(tileRange.max.x) && isFinite(tileRange.max.y))) throw new Error('Attempted to load an infinite number of tiles');
            for(var key in this._tiles){
                var c = this._tiles[key].coords;
                if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) this._tiles[key].current = false;
            }
            // _update just loads more tiles. If the tile zoom level differs too much
            // from the map's, let _setView reset levels and prune old tiles.
            if (Math.abs(zoom - this._tileZoom) > 1) {
                this._setView(center, zoom);
                return;
            }
            // create a queue of coordinates to load tiles from
            for(var j = tileRange.min.y; j <= tileRange.max.y; j++)for(var i = tileRange.min.x; i <= tileRange.max.x; i++){
                var coords = new Point(i, j);
                coords.z = this._tileZoom;
                if (!this._isValidTile(coords)) continue;
                var tile = this._tiles[this._tileCoordsToKey(coords)];
                if (tile) tile.current = true;
                else queue.push(coords);
            }
            // sort tile queue to load tiles in order of their distance to center
            queue.sort(function(a, b) {
                return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
            });
            if (queue.length !== 0) {
                // if it's the first batch of tiles to load
                if (!this._loading) {
                    this._loading = true;
                    // @event loading: Event
                    // Fired when the grid layer starts loading tiles.
                    this.fire('loading');
                }
                // create DOM fragment to append tiles in one batch
                var fragment = document.createDocumentFragment();
                for(i = 0; i < queue.length; i++)this._addTile(queue[i], fragment);
                this._level.el.appendChild(fragment);
            }
        },
        _isValidTile: function(coords) {
            var crs = this._map.options.crs;
            if (!crs.infinite) {
                // don't load tile if it's out of bounds and not wrapped
                var bounds = this._globalTileRange;
                if (!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x) || !crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y)) return false;
            }
            if (!this.options.bounds) return true;
            // don't load tile if it doesn't intersect the bounds in options
            var tileBounds = this._tileCoordsToBounds(coords);
            return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
        },
        _keyToBounds: function(key) {
            return this._tileCoordsToBounds(this._keyToTileCoords(key));
        },
        _tileCoordsToNwSe: function(coords) {
            var map = this._map, tileSize = this.getTileSize(), nwPoint = coords.scaleBy(tileSize), sePoint = nwPoint.add(tileSize), nw = map.unproject(nwPoint, coords.z), se = map.unproject(sePoint, coords.z);
            return [
                nw,
                se
            ];
        },
        // converts tile coordinates to its geographical bounds
        _tileCoordsToBounds: function(coords) {
            var bp = this._tileCoordsToNwSe(coords), bounds = new LatLngBounds(bp[0], bp[1]);
            if (!this.options.noWrap) bounds = this._map.wrapLatLngBounds(bounds);
            return bounds;
        },
        // converts tile coordinates to key for the tile cache
        _tileCoordsToKey: function(coords) {
            return coords.x + ':' + coords.y + ':' + coords.z;
        },
        // converts tile cache key to coordinates
        _keyToTileCoords: function(key) {
            var k = key.split(':'), coords = new Point(+k[0], +k[1]);
            coords.z = +k[2];
            return coords;
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            remove(tile.el);
            delete this._tiles[key];
            // @event tileunload: TileEvent
            // Fired when a tile is removed (e.g. when a tile goes off the screen).
            this.fire('tileunload', {
                tile: tile.el,
                coords: this._keyToTileCoords(key)
            });
        },
        _initTile: function(tile) {
            addClass(tile, 'leaflet-tile');
            var tileSize = this.getTileSize();
            tile.style.width = tileSize.x + 'px';
            tile.style.height = tileSize.y + 'px';
            tile.onselectstart = falseFn;
            tile.onmousemove = falseFn;
            // update opacity on tiles in IE7-8 because of filter inheritance problems
            if (Browser.ielt9 && this.options.opacity < 1) setOpacity(tile, this.options.opacity);
        },
        _addTile: function(coords, container) {
            var tilePos = this._getTilePos(coords), key = this._tileCoordsToKey(coords);
            var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
            this._initTile(tile);
            // if createTile is defined with a second argument ("done" callback),
            // we know that tile is async and will be ready later; otherwise
            if (this.createTile.length < 2) // mark tile as ready, but delay one frame for opacity animation to happen
            requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
            setPosition(tile, tilePos);
            // save tile in cache
            this._tiles[key] = {
                el: tile,
                coords: coords,
                current: true
            };
            container.appendChild(tile);
            // @event tileloadstart: TileEvent
            // Fired when a tile is requested and starts loading.
            this.fire('tileloadstart', {
                tile: tile,
                coords: coords
            });
        },
        _tileReady: function(coords, err, tile) {
            if (err) // @event tileerror: TileErrorEvent
            // Fired when there is an error loading a tile.
            this.fire('tileerror', {
                error: err,
                tile: tile,
                coords: coords
            });
            var key = this._tileCoordsToKey(coords);
            tile = this._tiles[key];
            if (!tile) return;
            tile.loaded = +new Date();
            if (this._map._fadeAnimated) {
                setOpacity(tile.el, 0);
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            } else {
                tile.active = true;
                this._pruneTiles();
            }
            if (!err) {
                addClass(tile.el, 'leaflet-tile-loaded');
                // @event tileload: TileEvent
                // Fired when a tile loads.
                this.fire('tileload', {
                    tile: tile.el,
                    coords: coords
                });
            }
            if (this._noTilesToLoad()) {
                this._loading = false;
                // @event load: Event
                // Fired when the grid layer loaded all visible tiles.
                this.fire('load');
                if (Browser.ielt9 || !this._map._fadeAnimated) requestAnimFrame(this._pruneTiles, this);
                else // Wait a bit more than 0.2 secs (the duration of the tile fade-in)
                // to trigger a pruning.
                setTimeout(bind(this._pruneTiles, this), 250);
            }
        },
        _getTilePos: function(coords) {
            return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
        },
        _wrapCoords: function(coords) {
            var newCoords = new Point(this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x, this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
            newCoords.z = coords.z;
            return newCoords;
        },
        _pxBoundsToTileRange: function(bounds) {
            var tileSize = this.getTileSize();
            return new Bounds(bounds.min.unscaleBy(tileSize).floor(), bounds.max.unscaleBy(tileSize).ceil().subtract([
                1,
                1
            ]));
        },
        _noTilesToLoad: function() {
            for(var key in this._tiles){
                if (!this._tiles[key].loaded) return false;
            }
            return true;
        }
    });
    // @factory L.gridLayer(options?: GridLayer options)
    // Creates a new instance of GridLayer with the supplied options.
    function gridLayer(options) {
        return new GridLayer(options);
    }
    /*
   * @class TileLayer
   * @inherits GridLayer
   * @aka L.TileLayer
   * Used to load and display tile layers on the map. Note that most tile servers require attribution, which you can set under `Layer`. Extends `GridLayer`.
   *
   * @example
   *
   * ```js
   * L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo(map);
   * ```
   *
   * @section URL template
   * @example
   *
   * A string of the following form:
   *
   * ```
   * 'https://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
   * ```
   *
   * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
   *
   * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
   *
   * ```
   * L.tileLayer('https://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
   * ```
   */ var TileLayer = GridLayer.extend({
        // @section
        // @aka TileLayer options
        options: {
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = 18
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: 18,
            // @option subdomains: String|String[] = 'abc'
            // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
            subdomains: 'abc',
            // @option errorTileUrl: String = ''
            // URL to the tile image to show in place of the tile that failed to load.
            errorTileUrl: '',
            // @option zoomOffset: Number = 0
            // The zoom number used in tile URLs will be offset with this value.
            zoomOffset: 0,
            // @option tms: Boolean = false
            // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
            tms: false,
            // @option zoomReverse: Boolean = false
            // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
            zoomReverse: false,
            // @option detectRetina: Boolean = false
            // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
            detectRetina: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option referrerPolicy: Boolean|String = false
            // Whether the referrerPolicy attribute will be added to the tiles.
            // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
            // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
            // (e.g. to validate an API token).
            // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
            referrerPolicy: false
        },
        initialize: function(url, options) {
            this._url = url;
            options = setOptions(this, options);
            // detecting retina displays, adjusting tileSize and zoom levels
            if (options.detectRetina && Browser.retina && options.maxZoom > 0) {
                options.tileSize = Math.floor(options.tileSize / 2);
                if (!options.zoomReverse) {
                    options.zoomOffset++;
                    options.maxZoom = Math.max(options.minZoom, options.maxZoom - 1);
                } else {
                    options.zoomOffset--;
                    options.minZoom = Math.min(options.maxZoom, options.minZoom + 1);
                }
                options.minZoom = Math.max(0, options.minZoom);
            } else if (!options.zoomReverse) // make sure maxZoom is gte minZoom
            options.maxZoom = Math.max(options.minZoom, options.maxZoom);
            else // make sure minZoom is lte maxZoom
            options.minZoom = Math.min(options.maxZoom, options.minZoom);
            if (typeof options.subdomains === 'string') options.subdomains = options.subdomains.split('');
            this.on('tileunload', this._onTileRemove);
        },
        // @method setUrl(url: String, noRedraw?: Boolean): this
        // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
        // If the URL does not change, the layer will not be redrawn unless
        // the noRedraw parameter is set to false.
        setUrl: function(url, noRedraw) {
            if (this._url === url && noRedraw === undefined) noRedraw = true;
            this._url = url;
            if (!noRedraw) this.redraw();
            return this;
        },
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
        // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
        // callback is called when the tile has been loaded.
        createTile: function(coords, done) {
            var tile = document.createElement('img');
            on(tile, 'load', bind(this._tileOnLoad, this, done, tile));
            on(tile, 'error', bind(this._tileOnError, this, done, tile));
            if (this.options.crossOrigin || this.options.crossOrigin === '') tile.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            // for this new option we follow the documented behavior
            // more closely by only setting the property when string
            if (typeof this.options.referrerPolicy === 'string') tile.referrerPolicy = this.options.referrerPolicy;
            // The alt attribute is set to the empty string,
            // allowing screen readers to ignore the decorative image tiles.
            // https://www.w3.org/WAI/tutorials/images/decorative/
            // https://www.w3.org/TR/html-aria/#el-img-empty-alt
            tile.alt = '';
            tile.src = this.getTileUrl(coords);
            return tile;
        },
        // @section Extension methods
        // @uninheritable
        // Layers extending `TileLayer` might reimplement the following method.
        // @method getTileUrl(coords: Object): String
        // Called only internally, returns the URL for a tile given its coordinates.
        // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
        getTileUrl: function(coords) {
            var data = {
                r: Browser.retina ? '@2x' : '',
                s: this._getSubdomain(coords),
                x: coords.x,
                y: coords.y,
                z: this._getZoomForUrl()
            };
            if (this._map && !this._map.options.crs.infinite) {
                var invertedY = this._globalTileRange.max.y - coords.y;
                if (this.options.tms) data['y'] = invertedY;
                data['-y'] = invertedY;
            }
            return template(this._url, extend(data, this.options));
        },
        _tileOnLoad: function(done, tile) {
            // For https://github.com/Leaflet/Leaflet/issues/3332
            if (Browser.ielt9) setTimeout(bind(done, this, null, tile), 0);
            else done(null, tile);
        },
        _tileOnError: function(done, tile, e) {
            var errorUrl = this.options.errorTileUrl;
            if (errorUrl && tile.getAttribute('src') !== errorUrl) tile.src = errorUrl;
            done(e, tile);
        },
        _onTileRemove: function(e) {
            e.tile.onload = null;
        },
        _getZoomForUrl: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom, zoomReverse = this.options.zoomReverse, zoomOffset = this.options.zoomOffset;
            if (zoomReverse) zoom = maxZoom - zoom;
            return zoom + zoomOffset;
        },
        _getSubdomain: function(tilePoint) {
            var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
            return this.options.subdomains[index];
        },
        // stops loading all tiles in the background layer
        _abortLoading: function() {
            var i, tile;
            for(i in this._tiles)if (this._tiles[i].coords.z !== this._tileZoom) {
                tile = this._tiles[i].el;
                tile.onload = falseFn;
                tile.onerror = falseFn;
                if (!tile.complete) {
                    tile.src = emptyImageUrl;
                    var coords = this._tiles[i].coords;
                    remove(tile);
                    delete this._tiles[i];
                    // @event tileabort: TileEvent
                    // Fired when a tile was loading but is now not wanted.
                    this.fire('tileabort', {
                        tile: tile,
                        coords: coords
                    });
                }
            }
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            // Cancels any pending http requests associated with the tile
            tile.el.setAttribute('src', emptyImageUrl);
            return GridLayer.prototype._removeTile.call(this, key);
        },
        _tileReady: function(coords, err, tile) {
            if (!this._map || tile && tile.getAttribute('src') === emptyImageUrl) return;
            return GridLayer.prototype._tileReady.call(this, coords, err, tile);
        }
    });
    // @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
    // Instantiates a tile layer object given a `URL template` and optionally an options object.
    function tileLayer(url, options) {
        return new TileLayer(url, options);
    }
    /*
   * @class TileLayer.WMS
   * @inherits TileLayer
   * @aka L.TileLayer.WMS
   * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
   *
   * @example
   *
   * ```js
   * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
   * 	layers: 'nexrad-n0r-900913',
   * 	format: 'image/png',
   * 	transparent: true,
   * 	attribution: "Weather data © 2012 IEM Nexrad"
   * });
   * ```
   */ var TileLayerWMS = TileLayer.extend({
        // @section
        // @aka TileLayer.WMS options
        // If any custom options not documented here are used, they will be sent to the
        // WMS server as extra parameters in each request URL. This can be useful for
        // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
        defaultWmsParams: {
            service: 'WMS',
            request: 'GetMap',
            // @option layers: String = ''
            // **(required)** Comma-separated list of WMS layers to show.
            layers: '',
            // @option styles: String = ''
            // Comma-separated list of WMS styles.
            styles: '',
            // @option format: String = 'image/jpeg'
            // WMS image format (use `'image/png'` for layers with transparency).
            format: 'image/jpeg',
            // @option transparent: Boolean = false
            // If `true`, the WMS service will return images with transparency.
            transparent: false,
            // @option version: String = '1.1.1'
            // Version of the WMS service to use
            version: '1.1.1'
        },
        options: {
            // @option crs: CRS = null
            // Coordinate Reference System to use for the WMS requests, defaults to
            // map CRS. Don't change this if you're not sure what it means.
            crs: null,
            // @option uppercase: Boolean = false
            // If `true`, WMS request parameter keys will be uppercase.
            uppercase: false
        },
        initialize: function(url, options) {
            this._url = url;
            var wmsParams = extend({}, this.defaultWmsParams);
            // all keys that are not TileLayer options go to WMS params
            for(var i in options)if (!(i in this.options)) wmsParams[i] = options[i];
            options = setOptions(this, options);
            var realRetina = options.detectRetina && Browser.retina ? 2 : 1;
            var tileSize = this.getTileSize();
            wmsParams.width = tileSize.x * realRetina;
            wmsParams.height = tileSize.y * realRetina;
            this.wmsParams = wmsParams;
        },
        onAdd: function(map) {
            this._crs = this.options.crs || map.options.crs;
            this._wmsVersion = parseFloat(this.wmsParams.version);
            var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
            this.wmsParams[projectionKey] = this._crs.code;
            TileLayer.prototype.onAdd.call(this, map);
        },
        getTileUrl: function(coords) {
            var tileBounds = this._tileCoordsToNwSe(coords), crs = this._crs, bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])), min = bounds.min, max = bounds.max, bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ? [
                min.y,
                min.x,
                max.y,
                max.x
            ] : [
                min.x,
                min.y,
                max.x,
                max.y
            ]).join(','), url = TileLayer.prototype.getTileUrl.call(this, coords);
            return url + getParamString(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
        },
        // @method setParams(params: Object, noRedraw?: Boolean): this
        // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
        setParams: function(params, noRedraw) {
            extend(this.wmsParams, params);
            if (!noRedraw) this.redraw();
            return this;
        }
    });
    // @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
    // Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
    function tileLayerWMS(url, options) {
        return new TileLayerWMS(url, options);
    }
    TileLayer.WMS = TileLayerWMS;
    tileLayer.wms = tileLayerWMS;
    /*
   * @class Renderer
   * @inherits Layer
   * @aka L.Renderer
   *
   * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
   * DOM container of the renderer, its bounds, and its zoom animation.
   *
   * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
   * itself can be added or removed to the map. All paths use a renderer, which can
   * be implicit (the map will decide the type of renderer and use it automatically)
   * or explicit (using the [`renderer`](#path-renderer) option of the path).
   *
   * Do not use this class directly, use `SVG` and `Canvas` instead.
   *
   * @event update: Event
   * Fired when the renderer updates its bounds, center and zoom, for example when
   * its map has moved
   */ var Renderer = Layer.extend({
        // @section
        // @aka Renderer options
        options: {
            // @option padding: Number = 0.1
            // How much to extend the clip area around the map view (relative to its size)
            // e.g. 0.1 would be 10% of map view in each direction
            padding: 0.1
        },
        initialize: function(options) {
            setOptions(this, options);
            stamp(this);
            this._layers = this._layers || {};
        },
        onAdd: function() {
            if (!this._container) {
                this._initContainer(); // defined by renderer implementations
                // always keep transform-origin as 0 0
                addClass(this._container, 'leaflet-zoom-animated');
            }
            this.getPane().appendChild(this._container);
            this._update();
            this.on('update', this._updatePaths, this);
        },
        onRemove: function() {
            this.off('update', this._updatePaths, this);
            this._destroyContainer();
        },
        getEvents: function() {
            var events = {
                viewreset: this._reset,
                zoom: this._onZoom,
                moveend: this._update,
                zoomend: this._onZoomEnd
            };
            if (this._zoomAnimated) events.zoomanim = this._onAnimZoom;
            return events;
        },
        _onAnimZoom: function(ev) {
            this._updateTransform(ev.center, ev.zoom);
        },
        _onZoom: function() {
            this._updateTransform(this._map.getCenter(), this._map.getZoom());
        },
        _updateTransform: function(center, zoom) {
            var scale = this._map.getZoomScale(zoom, this._zoom), viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding), currentCenterPoint = this._map.project(this._center, zoom), topLeftOffset = viewHalf.multiplyBy(-scale).add(currentCenterPoint).subtract(this._map._getNewPixelOrigin(center, zoom));
            if (Browser.any3d) setTransform(this._container, topLeftOffset, scale);
            else setPosition(this._container, topLeftOffset);
        },
        _reset: function() {
            this._update();
            this._updateTransform(this._center, this._zoom);
            for(var id in this._layers)this._layers[id]._reset();
        },
        _onZoomEnd: function() {
            for(var id in this._layers)this._layers[id]._project();
        },
        _updatePaths: function() {
            for(var id in this._layers)this._layers[id]._update();
        },
        _update: function() {
            // Update pixel bounds of renderer container (for positioning/sizing/clipping later)
            // Subclasses are responsible of firing the 'update' event.
            var p = this.options.padding, size = this._map.getSize(), min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
            this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
            this._center = this._map.getCenter();
            this._zoom = this._map.getZoom();
        }
    });
    /*
   * @class Canvas
   * @inherits Renderer
   * @aka L.Canvas
   *
   * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/canvas), Canvas is not
   * available in all web browsers, notably IE8, and overlapping geometries might
   * not display properly in some edge cases.
   *
   * @example
   *
   * Use Canvas by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.canvas()
   * });
   * ```
   *
   * Use a Canvas renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.canvas({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var Canvas = Renderer.extend({
        // @section
        // @aka Canvas options
        options: {
            // @option tolerance: Number = 0
            // How much to extend the click tolerance around a path/object on the map.
            tolerance: 0
        },
        getEvents: function() {
            var events = Renderer.prototype.getEvents.call(this);
            events.viewprereset = this._onViewPreReset;
            return events;
        },
        _onViewPreReset: function() {
            // Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
            this._postponeUpdatePaths = true;
        },
        onAdd: function() {
            Renderer.prototype.onAdd.call(this);
            // Redraw vectors since canvas is cleared upon removal,
            // in case of removing the renderer itself from the map.
            this._draw();
        },
        _initContainer: function() {
            var container = this._container = document.createElement('canvas');
            on(container, 'mousemove', this._onMouseMove, this);
            on(container, 'click dblclick mousedown mouseup contextmenu', this._onClick, this);
            on(container, 'mouseout', this._handleMouseOut, this);
            container['_leaflet_disable_events'] = true;
            this._ctx = container.getContext('2d');
        },
        _destroyContainer: function() {
            cancelAnimFrame(this._redrawRequest);
            delete this._ctx;
            remove(this._container);
            off(this._container);
            delete this._container;
        },
        _updatePaths: function() {
            if (this._postponeUpdatePaths) return;
            var layer;
            this._redrawBounds = null;
            for(var id in this._layers){
                layer = this._layers[id];
                layer._update();
            }
            this._redraw();
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, container = this._container, size = b.getSize(), m = Browser.retina ? 2 : 1;
            setPosition(container, b.min);
            // set canvas size (also clearing it); use double size on retina
            container.width = m * size.x;
            container.height = m * size.y;
            container.style.width = size.x + 'px';
            container.style.height = size.y + 'px';
            if (Browser.retina) this._ctx.scale(2, 2);
            // translate so we use the same path coordinates after canvas element moves
            this._ctx.translate(-b.min.x, -b.min.y);
            // Tell paths to redraw themselves
            this.fire('update');
        },
        _reset: function() {
            Renderer.prototype._reset.call(this);
            if (this._postponeUpdatePaths) {
                this._postponeUpdatePaths = false;
                this._updatePaths();
            }
        },
        _initPath: function(layer) {
            this._updateDashArray(layer);
            this._layers[stamp(layer)] = layer;
            var order = layer._order = {
                layer: layer,
                prev: this._drawLast,
                next: null
            };
            if (this._drawLast) this._drawLast.next = order;
            this._drawLast = order;
            this._drawFirst = this._drawFirst || this._drawLast;
        },
        _addPath: function(layer) {
            this._requestRedraw(layer);
        },
        _removePath: function(layer) {
            var order = layer._order;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else this._drawLast = prev;
            if (prev) prev.next = next;
            else this._drawFirst = next;
            delete layer._order;
            delete this._layers[stamp(layer)];
            this._requestRedraw(layer);
        },
        _updatePath: function(layer) {
            // Redraw the union of the layer's old pixel
            // bounds and the new pixel bounds.
            this._extendRedrawBounds(layer);
            layer._project();
            layer._update();
            // The redraw will extend the redraw bounds
            // with the new pixel bounds.
            this._requestRedraw(layer);
        },
        _updateStyle: function(layer) {
            this._updateDashArray(layer);
            this._requestRedraw(layer);
        },
        _updateDashArray: function(layer) {
            if (typeof layer.options.dashArray === 'string') {
                var parts = layer.options.dashArray.split(/[, ]+/), dashArray = [], dashValue, i;
                for(i = 0; i < parts.length; i++){
                    dashValue = Number(parts[i]);
                    // Ignore dash array containing invalid lengths
                    if (isNaN(dashValue)) return;
                    dashArray.push(dashValue);
                }
                layer.options._dashArray = dashArray;
            } else layer.options._dashArray = layer.options.dashArray;
        },
        _requestRedraw: function(layer) {
            if (!this._map) return;
            this._extendRedrawBounds(layer);
            this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
        },
        _extendRedrawBounds: function(layer) {
            if (layer._pxBounds) {
                var padding = (layer.options.weight || 0) + 1;
                this._redrawBounds = this._redrawBounds || new Bounds();
                this._redrawBounds.extend(layer._pxBounds.min.subtract([
                    padding,
                    padding
                ]));
                this._redrawBounds.extend(layer._pxBounds.max.add([
                    padding,
                    padding
                ]));
            }
        },
        _redraw: function() {
            this._redrawRequest = null;
            if (this._redrawBounds) {
                this._redrawBounds.min._floor();
                this._redrawBounds.max._ceil();
            }
            this._clear(); // clear layers in redraw bounds
            this._draw(); // draw layers
            this._redrawBounds = null;
        },
        _clear: function() {
            var bounds = this._redrawBounds;
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
            } else {
                this._ctx.save();
                this._ctx.setTransform(1, 0, 0, 1, 0, 0);
                this._ctx.clearRect(0, 0, this._container.width, this._container.height);
                this._ctx.restore();
            }
        },
        _draw: function() {
            var layer, bounds = this._redrawBounds;
            this._ctx.save();
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.beginPath();
                this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
                this._ctx.clip();
            }
            this._drawing = true;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (!bounds || layer._pxBounds && layer._pxBounds.intersects(bounds)) layer._updatePath();
            }
            this._drawing = false;
            this._ctx.restore(); // Restore state before clipping.
        },
        _updatePoly: function(layer, closed) {
            if (!this._drawing) return;
            var i, j, len2, p, parts = layer._parts, len = parts.length, ctx = this._ctx;
            if (!len) return;
            ctx.beginPath();
            for(i = 0; i < len; i++){
                for(j = 0, len2 = parts[i].length; j < len2; j++){
                    p = parts[i][j];
                    ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
                }
                if (closed) ctx.closePath();
            }
            this._fillStroke(ctx, layer);
        // TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
        },
        _updateCircle: function(layer) {
            if (!this._drawing || layer._empty()) return;
            var p = layer._point, ctx = this._ctx, r = Math.max(Math.round(layer._radius), 1), s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
            if (s !== 1) {
                ctx.save();
                ctx.scale(1, s);
            }
            ctx.beginPath();
            ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
            if (s !== 1) ctx.restore();
            this._fillStroke(ctx, layer);
        },
        _fillStroke: function(ctx, layer) {
            var options = layer.options;
            if (options.fill) {
                ctx.globalAlpha = options.fillOpacity;
                ctx.fillStyle = options.fillColor || options.color;
                ctx.fill(options.fillRule || 'evenodd');
            }
            if (options.stroke && options.weight !== 0) {
                if (ctx.setLineDash) ctx.setLineDash(layer.options && layer.options._dashArray || []);
                ctx.globalAlpha = options.opacity;
                ctx.lineWidth = options.weight;
                ctx.strokeStyle = options.color;
                ctx.lineCap = options.lineCap;
                ctx.lineJoin = options.lineJoin;
                ctx.stroke();
            }
        },
        // Canvas obviously doesn't have mouse events for individual drawn objects,
        // so we emulate that by calculating what's under the mouse on mousemove/click manually
        _onClick: function(e) {
            var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) {
                    if (!(e.type === 'click' || e.type === 'preclick') || !this._map._draggableMoved(layer)) clickedLayer = layer;
                }
            }
            this._fireEvent(clickedLayer ? [
                clickedLayer
            ] : false, e);
        },
        _onMouseMove: function(e) {
            if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) return;
            var point = this._map.mouseEventToLayerPoint(e);
            this._handleMouseHover(e, point);
        },
        _handleMouseOut: function(e) {
            var layer = this._hoveredLayer;
            if (layer) {
                // if we're leaving the layer, fire mouseout
                removeClass(this._container, 'leaflet-interactive');
                this._fireEvent([
                    layer
                ], e, 'mouseout');
                this._hoveredLayer = null;
                this._mouseHoverThrottled = false;
            }
        },
        _handleMouseHover: function(e, point) {
            if (this._mouseHoverThrottled) return;
            var layer, candidateHoveredLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) candidateHoveredLayer = layer;
            }
            if (candidateHoveredLayer !== this._hoveredLayer) {
                this._handleMouseOut(e);
                if (candidateHoveredLayer) {
                    addClass(this._container, 'leaflet-interactive'); // change cursor
                    this._fireEvent([
                        candidateHoveredLayer
                    ], e, 'mouseover');
                    this._hoveredLayer = candidateHoveredLayer;
                }
            }
            this._fireEvent(this._hoveredLayer ? [
                this._hoveredLayer
            ] : false, e);
            this._mouseHoverThrottled = true;
            setTimeout(bind(function() {
                this._mouseHoverThrottled = false;
            }, this), 32);
        },
        _fireEvent: function(layers, e, type) {
            this._map._fireDOMEvent(e, type || e.type, layers);
        },
        _bringToFront: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else // Already last
            return;
            if (prev) prev.next = next;
            else if (next) // Update first entry unless this is the
            // single entry
            this._drawFirst = next;
            order.prev = this._drawLast;
            this._drawLast.next = order;
            order.next = null;
            this._drawLast = order;
            this._requestRedraw(layer);
        },
        _bringToBack: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (prev) prev.next = next;
            else // Already first
            return;
            if (next) next.prev = prev;
            else if (prev) // Update last entry unless this is the
            // single entry
            this._drawLast = prev;
            order.prev = null;
            order.next = this._drawFirst;
            this._drawFirst.prev = order;
            this._drawFirst = order;
            this._requestRedraw(layer);
        }
    });
    // @factory L.canvas(options?: Renderer options)
    // Creates a Canvas renderer with the given options.
    function canvas(options) {
        return Browser.canvas ? new Canvas(options) : null;
    }
    /*
   * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
   */ var vmlCreate = function() {
        try {
            document.namespaces.add('lvml', 'urn:schemas-microsoft-com:vml');
            return function(name) {
                return document.createElement('<lvml:' + name + ' class="lvml">');
            };
        } catch (e) {
        // Do not return fn from catch block so `e` can be garbage collected
        // See https://github.com/Leaflet/Leaflet/pull/7279
        }
        return function(name) {
            return document.createElement('<' + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
        };
    }();
    /*
   * @class SVG
   *
   *
   * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
   * with old versions of Internet Explorer.
   */ // mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
    var vmlMixin = {
        _initContainer: function() {
            this._container = create$1('div', 'leaflet-vml-container');
        },
        _update: function() {
            if (this._map._animatingZoom) return;
            Renderer.prototype._update.call(this);
            this.fire('update');
        },
        _initPath: function(layer) {
            var container = layer._container = vmlCreate('shape');
            addClass(container, 'leaflet-vml-shape ' + (this.options.className || ''));
            container.coordsize = '1 1';
            layer._path = vmlCreate('path');
            container.appendChild(layer._path);
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            var container = layer._container;
            this._container.appendChild(container);
            if (layer.options.interactive) layer.addInteractiveTarget(container);
        },
        _removePath: function(layer) {
            var container = layer._container;
            remove(container);
            layer.removeInteractiveTarget(container);
            delete this._layers[stamp(layer)];
        },
        _updateStyle: function(layer) {
            var stroke = layer._stroke, fill = layer._fill, options = layer.options, container = layer._container;
            container.stroked = !!options.stroke;
            container.filled = !!options.fill;
            if (options.stroke) {
                if (!stroke) stroke = layer._stroke = vmlCreate('stroke');
                container.appendChild(stroke);
                stroke.weight = options.weight + 'px';
                stroke.color = options.color;
                stroke.opacity = options.opacity;
                if (options.dashArray) stroke.dashStyle = isArray(options.dashArray) ? options.dashArray.join(' ') : options.dashArray.replace(/( *, *)/g, ' ');
                else stroke.dashStyle = '';
                stroke.endcap = options.lineCap.replace('butt', 'flat');
                stroke.joinstyle = options.lineJoin;
            } else if (stroke) {
                container.removeChild(stroke);
                layer._stroke = null;
            }
            if (options.fill) {
                if (!fill) fill = layer._fill = vmlCreate('fill');
                container.appendChild(fill);
                fill.color = options.fillColor || options.color;
                fill.opacity = options.fillOpacity;
            } else if (fill) {
                container.removeChild(fill);
                layer._fill = null;
            }
        },
        _updateCircle: function(layer) {
            var p = layer._point.round(), r = Math.round(layer._radius), r2 = Math.round(layer._radiusY || r);
            this._setPath(layer, layer._empty() ? 'M0 0' : 'AL ' + p.x + ',' + p.y + ' ' + r + ',' + r2 + ' 0,' + 23592600);
        },
        _setPath: function(layer, path) {
            layer._path.v = path;
        },
        _bringToFront: function(layer) {
            toFront(layer._container);
        },
        _bringToBack: function(layer) {
            toBack(layer._container);
        }
    };
    var create = Browser.vml ? vmlCreate : svgCreate;
    /*
   * @class SVG
   * @inherits Renderer
   * @aka L.SVG
   *
   * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/svg), SVG is not
   * available in all web browsers, notably Android 2.x and 3.x.
   *
   * Although SVG is not available on IE7 and IE8, these browsers support
   * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
   * (a now deprecated technology), and the SVG renderer will fall back to VML in
   * this case.
   *
   * @example
   *
   * Use SVG by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.svg()
   * });
   * ```
   *
   * Use a SVG renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.svg({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var SVG = Renderer.extend({
        _initContainer: function() {
            this._container = create('svg');
            // makes it possible to click through svg root; we'll reset it back in individual paths
            this._container.setAttribute('pointer-events', 'none');
            this._rootGroup = create('g');
            this._container.appendChild(this._rootGroup);
        },
        _destroyContainer: function() {
            remove(this._container);
            off(this._container);
            delete this._container;
            delete this._rootGroup;
            delete this._svgSize;
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, size = b.getSize(), container = this._container;
            // set size of svg-container if changed
            if (!this._svgSize || !this._svgSize.equals(size)) {
                this._svgSize = size;
                container.setAttribute('width', size.x);
                container.setAttribute('height', size.y);
            }
            // movement: update container viewBox so that we don't have to change coordinates of individual layers
            setPosition(container, b.min);
            container.setAttribute('viewBox', [
                b.min.x,
                b.min.y,
                size.x,
                size.y
            ].join(' '));
            this.fire('update');
        },
        // methods below are called by vector layers implementations
        _initPath: function(layer) {
            var path = layer._path = create('path');
            // @namespace Path
            // @option className: String = null
            // Custom class name set on an element. Only for SVG renderer.
            if (layer.options.className) addClass(path, layer.options.className);
            if (layer.options.interactive) addClass(path, 'leaflet-interactive');
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            if (!this._rootGroup) this._initContainer();
            this._rootGroup.appendChild(layer._path);
            layer.addInteractiveTarget(layer._path);
        },
        _removePath: function(layer) {
            remove(layer._path);
            layer.removeInteractiveTarget(layer._path);
            delete this._layers[stamp(layer)];
        },
        _updatePath: function(layer) {
            layer._project();
            layer._update();
        },
        _updateStyle: function(layer) {
            var path = layer._path, options = layer.options;
            if (!path) return;
            if (options.stroke) {
                path.setAttribute('stroke', options.color);
                path.setAttribute('stroke-opacity', options.opacity);
                path.setAttribute('stroke-width', options.weight);
                path.setAttribute('stroke-linecap', options.lineCap);
                path.setAttribute('stroke-linejoin', options.lineJoin);
                if (options.dashArray) path.setAttribute('stroke-dasharray', options.dashArray);
                else path.removeAttribute('stroke-dasharray');
                if (options.dashOffset) path.setAttribute('stroke-dashoffset', options.dashOffset);
                else path.removeAttribute('stroke-dashoffset');
            } else path.setAttribute('stroke', 'none');
            if (options.fill) {
                path.setAttribute('fill', options.fillColor || options.color);
                path.setAttribute('fill-opacity', options.fillOpacity);
                path.setAttribute('fill-rule', options.fillRule || 'evenodd');
            } else path.setAttribute('fill', 'none');
        },
        _updatePoly: function(layer, closed) {
            this._setPath(layer, pointsToPath(layer._parts, closed));
        },
        _updateCircle: function(layer) {
            var p = layer._point, r = Math.max(Math.round(layer._radius), 1), r2 = Math.max(Math.round(layer._radiusY), 1) || r, arc = 'a' + r + ',' + r2 + ' 0 1,0 ';
            // drawing a circle with two half-arcs
            var d = layer._empty() ? 'M0 0' : 'M' + (p.x - r) + ',' + p.y + arc + r * 2 + ',0 ' + arc + -r * 2 + ',0 ';
            this._setPath(layer, d);
        },
        _setPath: function(layer, path) {
            layer._path.setAttribute('d', path);
        },
        // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
        _bringToFront: function(layer) {
            toFront(layer._path);
        },
        _bringToBack: function(layer) {
            toBack(layer._path);
        }
    });
    if (Browser.vml) SVG.include(vmlMixin);
    // @namespace SVG
    // @factory L.svg(options?: Renderer options)
    // Creates a SVG renderer with the given options.
    function svg(options) {
        return Browser.svg || Browser.vml ? new SVG(options) : null;
    }
    Map.include({
        // @namespace Map; @method getRenderer(layer: Path): Renderer
        // Returns the instance of `Renderer` that should be used to render the given
        // `Path`. It will ensure that the `renderer` options of the map and paths
        // are respected, and that the renderers do exist on the map.
        getRenderer: function(layer) {
            // @namespace Path; @option renderer: Renderer
            // Use this specific instance of `Renderer` for this path. Takes
            // precedence over the map's [default renderer](#map-renderer).
            var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
            if (!renderer) renderer = this._renderer = this._createRenderer();
            if (!this.hasLayer(renderer)) this.addLayer(renderer);
            return renderer;
        },
        _getPaneRenderer: function(name) {
            if (name === 'overlayPane' || name === undefined) return false;
            var renderer = this._paneRenderers[name];
            if (renderer === undefined) {
                renderer = this._createRenderer({
                    pane: name
                });
                this._paneRenderers[name] = renderer;
            }
            return renderer;
        },
        _createRenderer: function(options) {
            // @namespace Map; @option preferCanvas: Boolean = false
            // Whether `Path`s should be rendered on a `Canvas` renderer.
            // By default, all `Path`s are rendered in a `SVG` renderer.
            return this.options.preferCanvas && canvas(options) || svg(options);
        }
    });
    /*
   * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
   */ /*
   * @class Rectangle
   * @aka L.Rectangle
   * @inherits Polygon
   *
   * A class for drawing rectangle overlays on a map. Extends `Polygon`.
   *
   * @example
   *
   * ```js
   * // define rectangle geographical bounds
   * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
   *
   * // create an orange rectangle
   * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
   *
   * // zoom the map to the rectangle bounds
   * map.fitBounds(bounds);
   * ```
   *
   */ var Rectangle = Polygon.extend({
        initialize: function(latLngBounds, options) {
            Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
        },
        // @method setBounds(latLngBounds: LatLngBounds): this
        // Redraws the rectangle with the passed bounds.
        setBounds: function(latLngBounds) {
            return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
        },
        _boundsToLatLngs: function(latLngBounds) {
            latLngBounds = toLatLngBounds(latLngBounds);
            return [
                latLngBounds.getSouthWest(),
                latLngBounds.getNorthWest(),
                latLngBounds.getNorthEast(),
                latLngBounds.getSouthEast()
            ];
        }
    });
    // @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
    function rectangle(latLngBounds, options) {
        return new Rectangle(latLngBounds, options);
    }
    SVG.create = create;
    SVG.pointsToPath = pointsToPath;
    GeoJSON.geometryToLayer = geometryToLayer;
    GeoJSON.coordsToLatLng = coordsToLatLng;
    GeoJSON.coordsToLatLngs = coordsToLatLngs;
    GeoJSON.latLngToCoords = latLngToCoords;
    GeoJSON.latLngsToCoords = latLngsToCoords;
    GeoJSON.getFeature = getFeature;
    GeoJSON.asFeature = asFeature;
    /*
   * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
   * (zoom to a selected bounding box), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option boxZoom: Boolean = true
        // Whether the map can be zoomed to a rectangular area specified by
        // dragging the mouse while pressing the shift key.
        boxZoom: true
    });
    var BoxZoom = Handler.extend({
        initialize: function(map) {
            this._map = map;
            this._container = map._container;
            this._pane = map._panes.overlayPane;
            this._resetStateTimeout = 0;
            map.on('unload', this._destroy, this);
        },
        addHooks: function() {
            on(this._container, 'mousedown', this._onMouseDown, this);
        },
        removeHooks: function() {
            off(this._container, 'mousedown', this._onMouseDown, this);
        },
        moved: function() {
            return this._moved;
        },
        _destroy: function() {
            remove(this._pane);
            delete this._pane;
        },
        _resetState: function() {
            this._resetStateTimeout = 0;
            this._moved = false;
        },
        _clearDeferredResetState: function() {
            if (this._resetStateTimeout !== 0) {
                clearTimeout(this._resetStateTimeout);
                this._resetStateTimeout = 0;
            }
        },
        _onMouseDown: function(e) {
            if (!e.shiftKey || e.which !== 1 && e.button !== 1) return false;
            // Clear the deferred resetState if it hasn't executed yet, otherwise it
            // will interrupt the interaction and orphan a box element in the container.
            this._clearDeferredResetState();
            this._resetState();
            disableTextSelection();
            disableImageDrag();
            this._startPoint = this._map.mouseEventToContainerPoint(e);
            on(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseMove: function(e) {
            if (!this._moved) {
                this._moved = true;
                this._box = create$1('div', 'leaflet-zoom-box', this._container);
                addClass(this._container, 'leaflet-crosshair');
                this._map.fire('boxzoomstart');
            }
            this._point = this._map.mouseEventToContainerPoint(e);
            var bounds = new Bounds(this._point, this._startPoint), size = bounds.getSize();
            setPosition(this._box, bounds.min);
            this._box.style.width = size.x + 'px';
            this._box.style.height = size.y + 'px';
        },
        _finish: function() {
            if (this._moved) {
                remove(this._box);
                removeClass(this._container, 'leaflet-crosshair');
            }
            enableTextSelection();
            enableImageDrag();
            off(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseUp: function(e) {
            if (e.which !== 1 && e.button !== 1) return;
            this._finish();
            if (!this._moved) return;
            // Postpone to next JS tick so internal click event handling
            // still see it as "moved".
            this._clearDeferredResetState();
            this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
            var bounds = new LatLngBounds(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point));
            this._map.fitBounds(bounds).fire('boxzoomend', {
                boxZoomBounds: bounds
            });
        },
        _onKeyDown: function(e) {
            if (e.keyCode === 27) {
                this._finish();
                this._clearDeferredResetState();
                this._resetState();
            }
        }
    });
    // @section Handlers
    // @property boxZoom: Handler
    // Box (shift-drag with mouse) zoom handler.
    Map.addInitHook('addHandler', 'boxZoom', BoxZoom);
    /*
   * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option doubleClickZoom: Boolean|String = true
        // Whether the map can be zoomed in by double clicking on it and
        // zoomed out by double clicking while holding shift. If passed
        // `'center'`, double-click zoom will zoom to the center of the
        //  view regardless of where the mouse was.
        doubleClickZoom: true
    });
    var DoubleClickZoom = Handler.extend({
        addHooks: function() {
            this._map.on('dblclick', this._onDoubleClick, this);
        },
        removeHooks: function() {
            this._map.off('dblclick', this._onDoubleClick, this);
        },
        _onDoubleClick: function(e) {
            var map = this._map, oldZoom = map.getZoom(), delta = map.options.zoomDelta, zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
            if (map.options.doubleClickZoom === 'center') map.setZoom(zoom);
            else map.setZoomAround(e.containerPoint, zoom);
        }
    });
    // @section Handlers
    //
    // Map properties include interaction handlers that allow you to control
    // interaction behavior in runtime, enabling or disabling certain features such
    // as dragging or touch zoom (see `Handler` methods). For example:
    //
    // ```js
    // map.doubleClickZoom.disable();
    // ```
    //
    // @property doubleClickZoom: Handler
    // Double click zoom handler.
    Map.addInitHook('addHandler', 'doubleClickZoom', DoubleClickZoom);
    /*
   * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option dragging: Boolean = true
        // Whether the map is draggable with mouse/touch or not.
        dragging: true,
        // @section Panning Inertia Options
        // @option inertia: Boolean = *
        // If enabled, panning of the map will have an inertia effect where
        // the map builds momentum while dragging and continues moving in
        // the same direction for some time. Feels especially nice on touch
        // devices. Enabled by default.
        inertia: true,
        // @option inertiaDeceleration: Number = 3000
        // The rate with which the inertial movement slows down, in pixels/second².
        inertiaDeceleration: 3400,
        // @option inertiaMaxSpeed: Number = Infinity
        // Max speed of the inertial movement, in pixels/second.
        inertiaMaxSpeed: Infinity,
        // @option easeLinearity: Number = 0.2
        easeLinearity: 0.2,
        // TODO refactor, move to CRS
        // @option worldCopyJump: Boolean = false
        // With this option enabled, the map tracks when you pan to another "copy"
        // of the world and seamlessly jumps to the original one so that all overlays
        // like markers and vector layers are still visible.
        worldCopyJump: false,
        // @option maxBoundsViscosity: Number = 0.0
        // If `maxBounds` is set, this option will control how solid the bounds
        // are when dragging the map around. The default value of `0.0` allows the
        // user to drag outside the bounds at normal speed, higher values will
        // slow down map dragging outside bounds, and `1.0` makes the bounds fully
        // solid, preventing the user from dragging outside the bounds.
        maxBoundsViscosity: 0.0
    });
    var Drag = Handler.extend({
        addHooks: function() {
            if (!this._draggable) {
                var map = this._map;
                this._draggable = new Draggable(map._mapPane, map._container);
                this._draggable.on({
                    dragstart: this._onDragStart,
                    drag: this._onDrag,
                    dragend: this._onDragEnd
                }, this);
                this._draggable.on('predrag', this._onPreDragLimit, this);
                if (map.options.worldCopyJump) {
                    this._draggable.on('predrag', this._onPreDragWrap, this);
                    map.on('zoomend', this._onZoomEnd, this);
                    map.whenReady(this._onZoomEnd, this);
                }
            }
            addClass(this._map._container, 'leaflet-grab leaflet-touch-drag');
            this._draggable.enable();
            this._positions = [];
            this._times = [];
        },
        removeHooks: function() {
            removeClass(this._map._container, 'leaflet-grab');
            removeClass(this._map._container, 'leaflet-touch-drag');
            this._draggable.disable();
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        moving: function() {
            return this._draggable && this._draggable._moving;
        },
        _onDragStart: function() {
            var map = this._map;
            map._stop();
            if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
                var bounds = toLatLngBounds(this._map.options.maxBounds);
                this._offsetLimit = toBounds(this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1), this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize()));
                this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
            } else this._offsetLimit = null;
            map.fire('movestart').fire('dragstart');
            if (map.options.inertia) {
                this._positions = [];
                this._times = [];
            }
        },
        _onDrag: function(e) {
            if (this._map.options.inertia) {
                var time = this._lastTime = +new Date(), pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
                this._positions.push(pos);
                this._times.push(time);
                this._prunePositions(time);
            }
            this._map.fire('move', e).fire('drag', e);
        },
        _prunePositions: function(time) {
            while(this._positions.length > 1 && time - this._times[0] > 50){
                this._positions.shift();
                this._times.shift();
            }
        },
        _onZoomEnd: function() {
            var pxCenter = this._map.getSize().divideBy(2), pxWorldCenter = this._map.latLngToLayerPoint([
                0,
                0
            ]);
            this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
            this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
        },
        _viscousLimit: function(value, threshold) {
            return value - (value - threshold) * this._viscosity;
        },
        _onPreDragLimit: function() {
            if (!this._viscosity || !this._offsetLimit) return;
            var offset = this._draggable._newPos.subtract(this._draggable._startPos);
            var limit = this._offsetLimit;
            if (offset.x < limit.min.x) offset.x = this._viscousLimit(offset.x, limit.min.x);
            if (offset.y < limit.min.y) offset.y = this._viscousLimit(offset.y, limit.min.y);
            if (offset.x > limit.max.x) offset.x = this._viscousLimit(offset.x, limit.max.x);
            if (offset.y > limit.max.y) offset.y = this._viscousLimit(offset.y, limit.max.y);
            this._draggable._newPos = this._draggable._startPos.add(offset);
        },
        _onPreDragWrap: function() {
            // TODO refactor to be able to adjust map pane position after zoom
            var worldWidth = this._worldWidth, halfWidth = Math.round(worldWidth / 2), dx = this._initialWorldOffset, x = this._draggable._newPos.x, newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx, newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx, newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
            this._draggable._absPos = this._draggable._newPos.clone();
            this._draggable._newPos.x = newX;
        },
        _onDragEnd: function(e) {
            var map = this._map, options = map.options, noInertia = !options.inertia || e.noInertia || this._times.length < 2;
            map.fire('dragend', e);
            if (noInertia) map.fire('moveend');
            else {
                this._prunePositions(+new Date());
                var direction = this._lastPos.subtract(this._positions[0]), duration = (this._lastTime - this._times[0]) / 1000, ease = options.easeLinearity, speedVector = direction.multiplyBy(ease / duration), speed = speedVector.distanceTo([
                    0,
                    0
                ]), limitedSpeed = Math.min(options.inertiaMaxSpeed, speed), limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed), decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease), offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
                if (!offset.x && !offset.y) map.fire('moveend');
                else {
                    offset = map._limitOffset(offset, map.options.maxBounds);
                    requestAnimFrame(function() {
                        map.panBy(offset, {
                            duration: decelerationDuration,
                            easeLinearity: ease,
                            noMoveStart: true,
                            animate: true
                        });
                    });
                }
            }
        }
    });
    // @section Handlers
    // @property dragging: Handler
    // Map dragging handler (by both mouse and touch).
    Map.addInitHook('addHandler', 'dragging', Drag);
    /*
   * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
   */ // @namespace Map
    // @section Keyboard Navigation Options
    Map.mergeOptions({
        // @option keyboard: Boolean = true
        // Makes the map focusable and allows users to navigate the map with keyboard
        // arrows and `+`/`-` keys.
        keyboard: true,
        // @option keyboardPanDelta: Number = 80
        // Amount of pixels to pan when pressing an arrow key.
        keyboardPanDelta: 80
    });
    var Keyboard = Handler.extend({
        keyCodes: {
            left: [
                37
            ],
            right: [
                39
            ],
            down: [
                40
            ],
            up: [
                38
            ],
            zoomIn: [
                187,
                107,
                61,
                171
            ],
            zoomOut: [
                189,
                109,
                54,
                173
            ]
        },
        initialize: function(map) {
            this._map = map;
            this._setPanDelta(map.options.keyboardPanDelta);
            this._setZoomDelta(map.options.zoomDelta);
        },
        addHooks: function() {
            var container = this._map._container;
            // make the container focusable by tabbing
            if (container.tabIndex <= 0) container.tabIndex = '0';
            on(container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.on({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        removeHooks: function() {
            this._removeHooks();
            off(this._map._container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.off({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        _onMouseDown: function() {
            if (this._focused) return;
            var body = document.body, docEl = document.documentElement, top = body.scrollTop || docEl.scrollTop, left = body.scrollLeft || docEl.scrollLeft;
            this._map._container.focus();
            window.scrollTo(left, top);
        },
        _onFocus: function() {
            this._focused = true;
            this._map.fire('focus');
        },
        _onBlur: function() {
            this._focused = false;
            this._map.fire('blur');
        },
        _setPanDelta: function(panDelta) {
            var keys = this._panKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.left.length; i < len; i++)keys[codes.left[i]] = [
                -1 * panDelta,
                0
            ];
            for(i = 0, len = codes.right.length; i < len; i++)keys[codes.right[i]] = [
                panDelta,
                0
            ];
            for(i = 0, len = codes.down.length; i < len; i++)keys[codes.down[i]] = [
                0,
                panDelta
            ];
            for(i = 0, len = codes.up.length; i < len; i++)keys[codes.up[i]] = [
                0,
                -1 * panDelta
            ];
        },
        _setZoomDelta: function(zoomDelta) {
            var keys = this._zoomKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.zoomIn.length; i < len; i++)keys[codes.zoomIn[i]] = zoomDelta;
            for(i = 0, len = codes.zoomOut.length; i < len; i++)keys[codes.zoomOut[i]] = -zoomDelta;
        },
        _addHooks: function() {
            on(document, 'keydown', this._onKeyDown, this);
        },
        _removeHooks: function() {
            off(document, 'keydown', this._onKeyDown, this);
        },
        _onKeyDown: function(e) {
            if (e.altKey || e.ctrlKey || e.metaKey) return;
            var key = e.keyCode, map = this._map, offset;
            if (key in this._panKeys) {
                if (!map._panAnim || !map._panAnim._inProgress) {
                    offset = this._panKeys[key];
                    if (e.shiftKey) offset = toPoint(offset).multiplyBy(3);
                    if (map.options.maxBounds) offset = map._limitOffset(toPoint(offset), map.options.maxBounds);
                    if (map.options.worldCopyJump) {
                        var newLatLng = map.wrapLatLng(map.unproject(map.project(map.getCenter()).add(offset)));
                        map.panTo(newLatLng);
                    } else map.panBy(offset);
                }
            } else if (key in this._zoomKeys) map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
            else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) map.closePopup();
            else return;
            stop(e);
        }
    });
    // @section Handlers
    // @section Handlers
    // @property keyboard: Handler
    // Keyboard navigation handler.
    Map.addInitHook('addHandler', 'keyboard', Keyboard);
    /*
   * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Mouse wheel options
        // @option scrollWheelZoom: Boolean|String = true
        // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
        // it will zoom to the center of the view regardless of where the mouse was.
        scrollWheelZoom: true,
        // @option wheelDebounceTime: Number = 40
        // Limits the rate at which a wheel can fire (in milliseconds). By default
        // user can't zoom via wheel more often than once per 40 ms.
        wheelDebounceTime: 40,
        // @option wheelPxPerZoomLevel: Number = 60
        // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
        // mean a change of one full zoom level. Smaller values will make wheel-zooming
        // faster (and vice versa).
        wheelPxPerZoomLevel: 60
    });
    var ScrollWheelZoom = Handler.extend({
        addHooks: function() {
            on(this._map._container, 'wheel', this._onWheelScroll, this);
            this._delta = 0;
        },
        removeHooks: function() {
            off(this._map._container, 'wheel', this._onWheelScroll, this);
        },
        _onWheelScroll: function(e) {
            var delta = getWheelDelta(e);
            var debounce = this._map.options.wheelDebounceTime;
            this._delta += delta;
            this._lastMousePos = this._map.mouseEventToContainerPoint(e);
            if (!this._startTime) this._startTime = +new Date();
            var left = Math.max(debounce - (+new Date() - this._startTime), 0);
            clearTimeout(this._timer);
            this._timer = setTimeout(bind(this._performZoom, this), left);
            stop(e);
        },
        _performZoom: function() {
            var map = this._map, zoom = map.getZoom(), snap = this._map.options.zoomSnap || 0;
            map._stop(); // stop panning and fly animations if any
            // map the delta with a sigmoid function to -4..4 range leaning on -1..1
            var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2, d4 = snap ? Math.ceil(d3 / snap) * snap : d3, delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
            this._delta = 0;
            this._startTime = null;
            if (!delta) return;
            if (map.options.scrollWheelZoom === 'center') map.setZoom(zoom + delta);
            else map.setZoomAround(this._lastMousePos, zoom + delta);
        }
    });
    // @section Handlers
    // @property scrollWheelZoom: Handler
    // Scroll wheel zoom handler.
    Map.addInitHook('addHandler', 'scrollWheelZoom', ScrollWheelZoom);
    /*
   * L.Map.TapHold is used to simulate `contextmenu` event on long hold,
   * which otherwise is not fired by mobile Safari.
   */ var tapHoldDelay = 600;
    // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option tapHold: Boolean
        // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
        tapHold: Browser.touchNative && Browser.safari && Browser.mobile,
        // @option tapTolerance: Number = 15
        // The max number of pixels a user can shift his finger during touch
        // for it to be considered a valid tap.
        tapTolerance: 15
    });
    var TapHold = Handler.extend({
        addHooks: function() {
            on(this._map._container, 'touchstart', this._onDown, this);
        },
        removeHooks: function() {
            off(this._map._container, 'touchstart', this._onDown, this);
        },
        _onDown: function(e) {
            clearTimeout(this._holdTimeout);
            if (e.touches.length !== 1) return;
            var first = e.touches[0];
            this._startPos = this._newPos = new Point(first.clientX, first.clientY);
            this._holdTimeout = setTimeout(bind(function() {
                this._cancel();
                if (!this._isTapValid()) return;
                // prevent simulated mouse events https://w3c.github.io/touch-events/#mouse-events
                on(document, 'touchend', preventDefault);
                on(document, 'touchend touchcancel', this._cancelClickPrevent);
                this._simulateEvent('contextmenu', first);
            }, this), tapHoldDelay);
            on(document, 'touchend touchcancel contextmenu', this._cancel, this);
            on(document, 'touchmove', this._onMove, this);
        },
        _cancelClickPrevent: function cancelClickPrevent() {
            off(document, 'touchend', preventDefault);
            off(document, 'touchend touchcancel', cancelClickPrevent);
        },
        _cancel: function() {
            clearTimeout(this._holdTimeout);
            off(document, 'touchend touchcancel contextmenu', this._cancel, this);
            off(document, 'touchmove', this._onMove, this);
        },
        _onMove: function(e) {
            var first = e.touches[0];
            this._newPos = new Point(first.clientX, first.clientY);
        },
        _isTapValid: function() {
            return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
        },
        _simulateEvent: function(type, e) {
            var simulatedEvent = new MouseEvent(type, {
                bubbles: true,
                cancelable: true,
                view: window,
                // detail: 1,
                screenX: e.screenX,
                screenY: e.screenY,
                clientX: e.clientX,
                clientY: e.clientY
            });
            simulatedEvent._simulated = true;
            e.target.dispatchEvent(simulatedEvent);
        }
    });
    // @section Handlers
    // @property tapHold: Handler
    // Long tap handler to simulate `contextmenu` event (useful in mobile Safari).
    Map.addInitHook('addHandler', 'tapHold', TapHold);
    /*
   * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option touchZoom: Boolean|String = *
        // Whether the map can be zoomed by touch-dragging with two fingers. If
        // passed `'center'`, it will zoom to the center of the view regardless of
        // where the touch events (fingers) were. Enabled for touch-capable web
        // browsers.
        touchZoom: Browser.touch,
        // @option bounceAtZoomLimits: Boolean = true
        // Set it to false if you don't want the map to zoom beyond min/max zoom
        // and then bounce back when pinch-zooming.
        bounceAtZoomLimits: true
    });
    var TouchZoom = Handler.extend({
        addHooks: function() {
            addClass(this._map._container, 'leaflet-touch-zoom');
            on(this._map._container, 'touchstart', this._onTouchStart, this);
        },
        removeHooks: function() {
            removeClass(this._map._container, 'leaflet-touch-zoom');
            off(this._map._container, 'touchstart', this._onTouchStart, this);
        },
        _onTouchStart: function(e) {
            var map = this._map;
            if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) return;
            var p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]);
            this._centerPoint = map.getSize()._divideBy(2);
            this._startLatLng = map.containerPointToLatLng(this._centerPoint);
            if (map.options.touchZoom !== 'center') this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
            this._startDist = p1.distanceTo(p2);
            this._startZoom = map.getZoom();
            this._moved = false;
            this._zooming = true;
            map._stop();
            on(document, 'touchmove', this._onTouchMove, this);
            on(document, 'touchend touchcancel', this._onTouchEnd, this);
            preventDefault(e);
        },
        _onTouchMove: function(e) {
            if (!e.touches || e.touches.length !== 2 || !this._zooming) return;
            var map = this._map, p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]), scale = p1.distanceTo(p2) / this._startDist;
            this._zoom = map.getScaleZoom(scale, this._startZoom);
            if (!map.options.bounceAtZoomLimits && (this._zoom < map.getMinZoom() && scale < 1 || this._zoom > map.getMaxZoom() && scale > 1)) this._zoom = map._limitZoom(this._zoom);
            if (map.options.touchZoom === 'center') {
                this._center = this._startLatLng;
                if (scale === 1) return;
            } else {
                // Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
                var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
                if (scale === 1 && delta.x === 0 && delta.y === 0) return;
                this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
            }
            if (!this._moved) {
                map._moveStart(true, false);
                this._moved = true;
            }
            cancelAnimFrame(this._animRequest);
            var moveFn = bind(map._move, map, this._center, this._zoom, {
                pinch: true,
                round: false
            }, undefined);
            this._animRequest = requestAnimFrame(moveFn, this, true);
            preventDefault(e);
        },
        _onTouchEnd: function() {
            if (!this._moved || !this._zooming) {
                this._zooming = false;
                return;
            }
            this._zooming = false;
            cancelAnimFrame(this._animRequest);
            off(document, 'touchmove', this._onTouchMove, this);
            off(document, 'touchend touchcancel', this._onTouchEnd, this);
            // Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
            if (this._map.options.zoomAnimation) this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
            else this._map._resetView(this._center, this._map._limitZoom(this._zoom));
        }
    });
    // @section Handlers
    // @property touchZoom: Handler
    // Touch zoom handler.
    Map.addInitHook('addHandler', 'touchZoom', TouchZoom);
    Map.BoxZoom = BoxZoom;
    Map.DoubleClickZoom = DoubleClickZoom;
    Map.Drag = Drag;
    Map.Keyboard = Keyboard;
    Map.ScrollWheelZoom = ScrollWheelZoom;
    Map.TapHold = TapHold;
    Map.TouchZoom = TouchZoom;
    exports1.Bounds = Bounds;
    exports1.Browser = Browser;
    exports1.CRS = CRS;
    exports1.Canvas = Canvas;
    exports1.Circle = Circle;
    exports1.CircleMarker = CircleMarker;
    exports1.Class = Class;
    exports1.Control = Control;
    exports1.DivIcon = DivIcon;
    exports1.DivOverlay = DivOverlay;
    exports1.DomEvent = DomEvent;
    exports1.DomUtil = DomUtil;
    exports1.Draggable = Draggable;
    exports1.Evented = Evented;
    exports1.FeatureGroup = FeatureGroup;
    exports1.GeoJSON = GeoJSON;
    exports1.GridLayer = GridLayer;
    exports1.Handler = Handler;
    exports1.Icon = Icon;
    exports1.ImageOverlay = ImageOverlay;
    exports1.LatLng = LatLng;
    exports1.LatLngBounds = LatLngBounds;
    exports1.Layer = Layer;
    exports1.LayerGroup = LayerGroup;
    exports1.LineUtil = LineUtil;
    exports1.Map = Map;
    exports1.Marker = Marker;
    exports1.Mixin = Mixin;
    exports1.Path = Path;
    exports1.Point = Point;
    exports1.PolyUtil = PolyUtil;
    exports1.Polygon = Polygon;
    exports1.Polyline = Polyline;
    exports1.Popup = Popup;
    exports1.PosAnimation = PosAnimation;
    exports1.Projection = index;
    exports1.Rectangle = Rectangle;
    exports1.Renderer = Renderer;
    exports1.SVG = SVG;
    exports1.SVGOverlay = SVGOverlay;
    exports1.TileLayer = TileLayer;
    exports1.Tooltip = Tooltip;
    exports1.Transformation = Transformation;
    exports1.Util = Util;
    exports1.VideoOverlay = VideoOverlay;
    exports1.bind = bind;
    exports1.bounds = toBounds;
    exports1.canvas = canvas;
    exports1.circle = circle;
    exports1.circleMarker = circleMarker;
    exports1.control = control;
    exports1.divIcon = divIcon;
    exports1.extend = extend;
    exports1.featureGroup = featureGroup;
    exports1.geoJSON = geoJSON;
    exports1.geoJson = geoJson;
    exports1.gridLayer = gridLayer;
    exports1.icon = icon;
    exports1.imageOverlay = imageOverlay;
    exports1.latLng = toLatLng;
    exports1.latLngBounds = toLatLngBounds;
    exports1.layerGroup = layerGroup;
    exports1.map = createMap;
    exports1.marker = marker;
    exports1.point = toPoint;
    exports1.polygon = polygon;
    exports1.polyline = polyline;
    exports1.popup = popup;
    exports1.rectangle = rectangle;
    exports1.setOptions = setOptions;
    exports1.stamp = stamp;
    exports1.svg = svg;
    exports1.svgOverlay = svgOverlay;
    exports1.tileLayer = tileLayer;
    exports1.tooltip = tooltip;
    exports1.transformation = toTransformation;
    exports1.version = version;
    exports1.videoOverlay = videoOverlay;
    var oldL = window.L;
    exports1.noConflict = function() {
        window.L = oldL;
        return this;
    };
    // Always export us to window global (see #2364)
    window.L = exports1;
});

});

/*
   Copyright 2023, Guillermo Vega-Gorgojo

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ 
var $33Kba = parcelRequire("33Kba");
var $ab6076c88a029044$exports = {};
$ab6076c88a029044$exports = JSON.parse('{"search":{"en":"Search","es":"Buscar","pt":"Pesquisar"},"label":{"en":"Label","es":"Etiqueta","pt":"Etiqueta"},"showmore":{"en":"Show more","es":"Mostrar m\xe1s","pt":"Mostrar mais"},"all":{"en":"ALL","es":"TODOS","PT":"TODOS"},"moreinfo":{"en":"More information","es":"M\xe1s informaci\xf3n"},"user":{"en":"User","es":"Usuario"},"homelocrel":{"en":"..","es":"../es"},"flaglang":{"en":"\uD83C\uDDEC\uD83C\uDDE7 EN","es":"\uD83C\uDDEA\uD83C\uDDF8 ES"},"starting":{"en":"Starting EducaWood","es":"Iniciando EducaWood"},"confdata":{"en":"Configuring data services","es":"Configurando los servicios de datos"},"conftaxon":{"en":"Extracting taxonomic data","es":"Extrayendo datos de taxones"},"spinnerLoading":{"en":"Loading data...","es":"Cargando datos..."},"spinnerInfo":{"en":"We are querying our fancy databases.","es":"Estamos consultando a nuestras molonas bases de datos."},"ntrees":{"en":" trees in this area","es":" \xe1rboles en esta zona"},"questtext":{"en":"Please answer a questionnaire<br>to help us to improve.","es":"Responde a un cuestionario<br>para ayudarnos a mejorar.","pt":"Quer responder a um question\xe1rio<br>para nos ajudar a melhorar?"},"questurl":{"en":"https://docs.google.com/forms/d/e/1FAIpQLSdj2YL-1yZFMFBi0dWHDnlOKp5oWg_58DkM7fAWykSgmONKZw/viewform?usp=sf_link","es":"https://docs.google.com/forms/d/e/1FAIpQLSdjLezgl169v5nCY2Y1bLskDimEy_rbDwO4GhMdQ2YdKijmPg/viewform?usp=sf_link"},"yes":{"en":"Yes","es":"S\xed","pt":"Sim"},"no":{"en":"No","es":"No","pt":"N\xe3o"},"later":{"en":"Maybe later","es":"M\xe1s tarde","pt":"Talvez mais tarde"},"errorEndpointTitle":{"en":"Data provider not accessible","es":"No puede accederse al proveedor de datos","pt":"Provedor de dados n\xe3o acess\xedvel"},"errorEndpointText":{"en":"The data provider is temporarily not accessible. \\t\\t\\tWe apologize for the inconvenience and recommend to try later.","es":"El proveedor de datos est\xe1 temporalmente no disponible. \\t\\t\\tLamentamos este inconveniente y recomendamos que pruebe m\xe1s tarde.","pt":"Servidor de dados est\xe1 temporariamente indispon\xedvel. \\t\\t\\tPedimos desculpas pelo transtorno e recomendamos que tente mais tarde."},"close":{"en":"Close","es":"Cerrar","pt":"Fechar"},"errorEducatreeTitle":{"en":"The tree does not exist","es":"No existe el \xe1rbol"},"errorEducatreeText":{"en":"There is no tree with identifier ","es":"No existe un \xe1rbol con identificador "},"zoomin":{"en":"Zoom in","es":"M\xe1s zoom","pt":"Aproximar"},"zoomout":{"en":"Zoom out","es":"Menos zoom","pt":"Afastar"},"mylocation":{"en":"My location","es":"Mi localizaci\xf3n","pt":"Minha localiza\xe7\xe3o"},"viewIFN":{"en":"View IFN trees","es":"Ver \xe1rboles IFN"},"refresh":{"en":"Refresh data","es":"Refrescar datos"},"esri":{"en":"Esri layer","es":"Capa Esri"},"downloadData":{"en":"Download data","es":"Descargar datos"},"tour":{"en":"Tour","es":"Tour"},"fullmap":{"en":"Full map","es":"Mapa completo"},"download":{"en":"Download","es":"Descargar"},"cancelPolygon":{"en":"Cancel polygon","es":"Cancelar pol\xedgono"},"finish":{"en":"Finish","es":"Terminar"},"finishPolygon":{"en":"Finish polygon","es":"Terminar pol\xedgono"},"deleteLastPoint":{"en":"Delete last point","es":"Borrar \xfaltimo punto"},"deleteLastPointDrawn":{"en":"Delete last point drawn","es":"Borrar \xfaltimo punto dibujado"},"startPolygon":{"en":"Click to start drawing the polygon.","es":"Clica para empezar a dibujar el pol\xedgono."},"contPolygon":{"en":"Click to continue drawing the polygon.","es":"Clica para continuar dibujando el pol\xedgono."},"endPolygon":{"en":"Click first point to close the polygon.","es":"Clica el primer punto para cerrar el pol\xedgono."},"errorPolygon":{"en":"<strong>Error:</strong> polygon lines cannot cross!","es":"<strong>Error:</strong> \xa1no pueden cruzarse las l\xedneas del pol\xedgono!"},"downloadMessage":{"en":"You will retrieve tree data within the polygon you have just drawn.","es":"Obtendr\xe1s los datos de los \xe1rboles en el pol\xedgono que acabas de dibujar."},"downloadMessagePrev":{"en":"You will get a file with the trees located within the currently visible area of the map:","es":"Obtendr\xe1s un fichero con los \xe1rboles comprendidos en la zona visible del mapa:"},"downloadChoices":{"en":"Choose what to download:","es":"Elige qu\xe9 quieres descargar:"},"checkTrees":{"en":"Summarized reports of EducaWood trees","es":"Fichas resumidas de \xe1rboles de EducaWood"},"checkAnnotations":{"en":"All annotations of EducaWood trees","es":"Todas las anotaciones de los \xe1rboles de EducaWood"},"downloadClusterNote":{"en":"Downloaded data may include tree clusters if the zoom is too low.","es":"Los datos descargados pueden incluir agrupaciones de \xe1rboles si el zoom es demasiado bajo."},"downloadNothing":{"en":"Nothing to download!","es":"\xa1No hay nada que descargar!"},"downloadNoFormat":{"en":"No format selected!","es":"\xa1No hay formato seleccionado!"},"downloadFormatChoose":{"en":"Choose your preferred data format:","es":"Elige el formato de datos:"},"downloadingTrees":{"en":"Downloading EducaWood trees","es":"Descargando \xe1rboles de EducaWood"},"treesDownloaded":{"en":"EducaWood trees downloaded","es":"\xc1rboles de EducaWood descargados"},"noTreesDownloaded":{"en":"No EducaWood trees to download","es":"No hab\xeda \xe1rboles de EducaWood para descargar"},"educawoodTrees":{"en":"EducaWood trees","es":"\xe1rboles de EducaWood"},"educawoodClusters":{"en":"tree clusters","es":"agrupaciones de \xe1rboles"},"downloadingAnnotations":{"en":"Downloading annotations of EducaWood trees","es":"Descargando anotaciones de \xe1rboles de EducaWood"},"educawoodAnnotations":{"en":"annotations of EducaWood trees","es":"anotaciones de \xe1rboles de EducaWood"},"noAnnotationsDownloaded":{"en":"No annotations of EducaWood trees to download","es":"No hab\xeda anotaciones de \xe1rboles de EducaWood para descargar"},"downloadSuccess":{"en":"Download successful","es":"Descarga de datos exitosa"},"toastDownload":{"en":"Wait until all data has been retrieved.","es":"Espera a que acabe de recuperar los datos."},"toastDownloadPolygon":{"en":"Draw a polygon for the data download","es":"Dibuja un pol\xedgono para la descarga de datos"},"toastZoom":{"en":"You need to zoom in to create trees.","es":"Para crear \xe1rboles tienes que aumentar el zoom."},"toastUser":{"en":"You need to sign up (top-right button) to create trees.","es":"Necesitas iniciar sesi\xf3n (bot\xf3n superior derecha) para crear \xe1rboles."},"toastCreateTree":{"en":"Push the map location where the new tree is situated.","es":"Pulsa la posici\xf3n del mapa en la que el nuevo \xe1rbol est\xe1 situado."},"home":{"en":"Home","es":"Inicio","pt":"In\xedcio"},"map":{"en":"Map","es":"Mapa"},"lastTrees":{"en":"Last trees","es":"\xdaltimos \xe1rboles"},"color0":{"en":"Green","es":"Verde","pt":"Verde"},"color1":{"en":"Gray","es":"Gris","pt":"Cinzento"},"color2":{"en":"Blue gray","es":"Gris azulado","pt":"Cinzento azulado"},"color3":{"en":"Orange","es":"Naranja","pt":"Laranja"},"color4":{"en":"Blue","es":"Azul","pt":"Azul"},"color5":{"en":"Pink","es":"Rosa","pt":"Rosa"},"color6":{"en":"Purple","es":"Violeta","pt":"Roxo"},"color7":{"en":"Indigo","es":"A\xf1il","pt":"Azul \xedndigo"},"color8":{"en":"Cyan","es":"Celeste","pt":"Ciano"},"color9":{"en":"Brown","es":"Marr\xf3n","pt":"Castanho"},"searchplace":{"en":"Search place...","es":"Buscar lugar...","pt":"Pesquisar lugar..."},"noplacesfound":{"en":"No places matched","es":"No hay lugares que coincidan","pt":"Nenhum lugar encontrado"},"population":{"en":"Population","es":"Poblaci\xf3n","pt":"Popula\xe7\xe3o"},"PPLC":{"en":"Capital of a country","es":"Capital de pa\xeds","pt":"Capital de pa\xeds"},"PPLA":{"en":"Seat of an autonomous region","es":"Capital de comunidad aut\xf3noma","pt":"Capital de uma regi\xe3o aut\xf3noma"},"PPLA2":{"en":"Seat of a province","es":"Capital de provincia","pt":"Capital de uma prov\xedncia"},"PPLA3":{"en":"Municipality","es":"Municipio","pt":"Munic\xedpio"},"PPLA4":{"en":"Populated place","es":"Poblaci\xf3n","pt":"Povoa\xe7\xe3o"},"PPL":{"en":"Populated place","es":"Poblaci\xf3n","pt":"Povoa\xe7\xe3o"},"FRST":{"en":"Forest","es":"Bosque","pt":"Floresta"},"HLL":{"en":"Hill","es":"Cerro","pt":"Colina"},"HLLS":{"en":"Hills","es":"Cerros","pt":"Colinas"},"MT":{"en":"Mountain","es":"Monta\xf1a","pt":"Montanha"},"MTS":{"en":"Mountains","es":"Monta\xf1as","pt":"Montanhas"},"PRK":{"en":"Park","es":"Parque","pt":"Parque"},"RDGE":{"en":"Ridge","es":"Sierra","pt":"Cume"},"RES":{"en":"Reserve","es":"Reserva","pt":"Reserva"},"RESF":{"en":"Forest reserve","es":"Reserva forestal","pt":"Reserva florestal"},"RESN":{"en":"Nature reserve","es":"Reserva natural","pt":"Reserva natural"},"RESW":{"en":"Wildlife reserve","es":"Reserva natural","pt":"Reserva natural"},"VAL":{"en":"Valley","es":"Valle","pt":"Vale"},"VALG":{"en":"Hanging valley","es":"Valle glaciar","pt":"Vale glaciar"},"taxonfilter":{"en":"Taxon","es":"Tax\xf3n","pt":"T\xe1xon"},"filter":{"en":"Filter","es":"Filtrar","pt":"Filtro"},"filtering":{"en":"Filtering","es":"Filtrando","pt":"Filtrando"},"removefilter":{"en":"Remove filter","es":"Quitar filtro","pt":"Remover filtro"},"searchtaxon":{"en":"Search taxon...","es":"Buscar tax\xf3n...","pt":"Pesquisar t\xe1xon..."},"notaxonfound":{"en":"No taxon matched","es":"No hay taxones que coincidan","pt":"N\xe3o h\xe1 taxa que coincidam"},"taxonid":{"es":"Tax\xf3n con id ","pt":"T\xe1xon com id "},"nomci":{"en":"Scientific names","es":"Nombres cient\xedficos","pt":"Nomes cient\xedficos"},"taxoninfo":{"en":"Taxon info","es":"Informaci\xf3n de tax\xf3n","pt":"Informa\xe7\xe3o de t\xe1xon"},"speciesinfo":{"en":"Species info","es":"Informaci\xf3n de especies","pt":"Informa\xe7\xe3o de esp\xe9cie"},"species":{"en":"Species","es":"Especie","pt":"Esp\xe9cie"},"genus":{"en":"Genus","es":"G\xe9nero","pt":"G\xe9nero"},"family":{"en":"Family","es":"Familia","pt":"Fam\xedlia"},"class":{"en":"Class","es":"Clase","pt":"Classe"},"importtaxon":{"en":"Import taxon","es":"Importar tax\xf3n"},"typesomething":{"en":"Type something.","es":"Escribe algo."},"typesomethingmore":{"en":"Type something more.","es":"Escribe algo m\xe1s."},"notaxonsfound":{"en":"No taxons found","es":"No se encontraron taxones"},"obtainingtaxons":{"en":"Obtaining taxons...","es":"Recuperando taxones..."},"tryanotherstring":{"en":"Try another string.","es":"Prueba con otra cadena."},"selectataxon":{"en":"Select a taxon.","es":"Selecciona un tax\xf3n."},"obtainingtaxondata":{"en":"Obtaining taxon data...","es":"Recuperando los datos del tax\xf3n..."},"readytoimport":{"en":"Ready to import.","es":"Listo para importar."},"taxonalreadyimported":{"en":"<b style=\\"color:red;\\">Taxon already imported!</b>","es":"<b style=\\"color:red;\\">\xa1El tax\xf3n ya ha sido importado!</b>"},"importingthetaxon":{"en":"Importing the taxon. Please wait...","es":"Importando el tax\xf3n. Por favor, espera..."},"taxonimported":{"en":"Taxon imported.","es":"Tax\xf3n importado."},"taxonimportingerror":{"en":"Error importing the taxon","es":"Error al importar el tax\xf3n"},"createtree":{"en":"Create tree","es":"Crear \xe1rbol"},"newtree":{"en":"New tree","es":"Nuevo \xe1rbol"},"formopt":{"en":"All form elements are optional.","es":"Todos los elementos del formulario son opcionales."},"signupToCreate":{"en":"Sign in to create trees.","es":"Inicia sesi\xf3n para crear \xe1rboles."},"location":{"en":"Location","es":"Localizaci\xf3n"},"position":{"en":"Position (WGS 84)","es":"Posici\xf3n (WGS 84)"},"dragmarker":{"en":"Drag the red marker to change the location of the new tree.","es":"Desplaza el marcador rojo para cambiar la localizaci\xf3n del nuevo \xe1rbol."},"mapclue":{"en":"Drag the map to change the position of the tree (red marker).","es":"Desplaza el mapa para cambiar la posici\xf3n del \xe1rbol (marcador rojo)."},"treenick":{"en":"Tree nick","es":"Apodo \xe1rbol"},"treetaxon":{"en":"Tree taxon","es":"Tax\xf3n \xe1rbol"},"photo":{"en":"Photo","es":"Foto"},"nophoto":{"en":"No tree photo.","es":"No hay foto del \xe1rbol."},"photouploaded":{"en":"Tree photo uploaded.","es":"Foto del \xe1rbol subida."},"partplanselection":{"en":"Select the part of the tree in the photo","es":"Selecciona la parte del \xe1rbol en la foto"},"heightm":{"en":"Height (m)","es":"Altura (m)"},"enterheightm":{"en":"Tree height in meters","es":"Altura del \xe1rbol en metros"},"diametermm":{"en":"Diameter (mm)","es":"Di\xe1metro (mm)"},"enterdiametermm":{"en":"Tree diameter at breast height in millimeters","es":"Di\xe1metro del \xe1rbol a la altura del pecho en mil\xedmetros"},"perimetermm":{"en":"Perimeter (mm)","es":"Per\xedmetro (mm)"},"enterperimetermm":{"en":"Tree perimeter at breast height in millimeters","es":"Per\xedmetro del \xe1rbol a la altura del pecho en mil\xedmetros"},"treeobservation":{"en":"Observation","es":"Observaci\xf3n"},"yourobservation":{"en":"Your observation","es":"Tu observaci\xf3n"},"cancel":{"en":"Cancel","es":"Cancelar"},"treeStatus":{"en":"Tree status","es":"Estado \xe1rbol"},"treestatusselection":{"en":"Select tree status","es":"Selecciona el estado del \xe1rbol"},"AliveTreeAnnotation":{"en":"Alive tree","es":"\xc1rbol vivo"},"DecliningTreeAnnotation":{"en":"Declining tree","es":"\xc1rbol en declive"},"DeadTreeAnnotation":{"en":"Dead tree","es":"\xc1rbol muerto"},"DeadTreeWithBarkAnnotation":{"en":"Dead tree with bark","es":"\xc1rbol muerto con corteza"},"DeadTreeWithLooseBarkAnnotation":{"en":"Dead tree with loose bark","es":"\xc1rbol muerto con corteza suelta"},"DeadTreeWithNoBarkAnnotation":{"en":"Dead tree with no bark","es":"\xc1rbol muerto sin corteza"},"DecomposedTreeAnnotation":{"en":"Decomposed dead tree","es":"\xc1rbol descompuesto"},"StumpAnnotation":{"en":"Stump","es":"Toc\xf3n"},"uploadingphoto":{"en":"Uploading photo...","es":"Subiendo foto..."},"uploadingphotoerror":{"en":"Error uploading the photo","es":"Error al subir la foto"},"deletingphotoerror":{"en":"Error deleting the photo","es":"Error al borrar la foto"},"creatingtree":{"en":"Creating the tree...","es":"Creando el \xe1rbol..."},"treecreationerror":{"en":"Error creating the tree","es":"Error al crear el \xe1rbol"},"treecreationsuccess":{"en":"The tree has been created","es":"Se ha creado el \xe1rbol"},"pleasewait":{"en":"Please wait.","es":"Por favor, espere"},"back":{"en":"Go back","es":"Volver"},"viewtree":{"en":"View tree","es":"Ver \xe1rbol"},"newAnnotation":{"en":"New annotation","es":"Nueva anotaci\xf3n"},"createAnnotation":{"en":"Create annotation","es":"Crear anotaci\xf3n"},"noAnnotation":{"en":"No annotation.","es":"No hay anotaci\xf3n."},"sameAnnotation":{"en":"Same annotation as the current value.","es":"Misma anotaci\xf3n que el valor actual."},"outOfRangeAnnotation":{"en":"Out of range annotation.","es":"Anotaci\xf3n fuera de rango."},"deleteAnnotation":{"en":"Delete annotation","es":"Borrar anotaci\xf3n"},"deleteAnnotationInfo":{"en":"Are you sure that you want to delete this annotation? This action cannot be reversed.","es":"\xbfEst\xe1s seguro de que quieres borrar esta anotaci\xf3n? Esta acci\xf3n no puede revertirse."},"deletingAnnotation":{"en":"Deleting the annotation...","es":"Borrando la anotaci\xf3n..."},"deleteAnnotationError":{"en":"Error deleting the annotation","es":"Error al borrar la anotaci\xf3n"},"deleteAnnotationSuccess":{"en":"The annotation has been deleted","es":"Se ha borrado la anotaci\xf3n"},"creatingannotation":{"en":"Creating the annotation...","es":"Creando la anotaci\xf3n..."},"treeannotationerror":{"en":"Error creating the annotation","es":"Error al crear la anotaci\xf3n"},"treeannotationsuccess":{"en":"The annotation has been created","es":"Se ha creado la anotaci\xf3n"},"formerPositions":{"en":"Former positions","es":"Posiciones anteriores"},"formerTreeTaxons":{"en":"Former taxons","es":"Taxones anteriores"},"formerTreeStatus":{"en":"Former statuses","es":"Estados anteriores"},"formerHeights":{"en":"Former heights","es":"Alturas anteriores"},"formerDiameters":{"en":"Former diameters","es":"Di\xe1metros anteriores"},"observations":{"en":"Observations","es":"Observaciones"},"moreobservations":{"en":"More observations","es":"M\xe1s observaciones"},"delete":{"en":"Delete","es":"Borrar"},"deleteTree":{"en":"Delete the tree","es":"Borrar el \xe1rbol"},"deleteTreeInfo":{"en":"Are you sure that you want to delete this tree and all its associated data? This action cannot be reversed.","es":"\xbfEst\xe1s seguro de que quieres borrar este \xe1rbol y todos sus datos? Esta acci\xf3n no puede revertirse."},"deletingtree":{"en":"Deleting the tree...","es":"Borrando el \xe1rbol..."},"treedeletionerror":{"en":"Error deleting the tree","es":"Error al borrar el \xe1rbol"},"treedeletionsuccess":{"en":"The tree has been deleted","es":"Se ha borrado el \xe1rbol"},"tree":{"en":"Tree","es":"\xc1rbol","pt":"\xc1rvore"},"trees":{"en":"trees","es":"\xe1rboles","pt":"\xe1rvores"},"height":{"en":"Height","es":"Altura","pt":"Altura"},"diameter":{"en":"Diameter","es":"Di\xe1metro","pt":"Di\xe2metro"},"created":{"en":"Created","es":"Creaci\xf3n"},"createdBy":{"en":"Created by ","es":"Creado por ","pt":"Criado por "},"annotatedBy":{"en":"Annotated by ","es":"Anotado por "},"createdByIFN":{"en":"Source IFNv3","es":"Fuente IFNv3","pt":"Fonte IFNv3"},"onDate":{"en":" on ","es":" el "},"ofTree":{"en":" of","es":" del"},"createdOn":{"en":"Created on ","es":"Creado el "},"creator":{"en":"Creator ","es":"Creador"},"annotationType":{"en":"Type","es":"Tipo"},"date":{"en":"Date","es":"Fecha"},"annotator":{"en":"Annotator","es":"Anotador"},"annotatedOn":{"en":"Annotated on ","es":"Anotado el "},"noCreatedTrees":{"en":"No created trees","es":"Ning\xfan \xe1rbol creado"},"noAnnotations":{"en":"No annotations","es":"Ninguna anotaci\xf3n"},"lastCreatedTrees":{"en":"Last created trees","es":"\xdaltimos \xe1rboles creados"},"lastAnnotations":{"en":"Last annotations","es":"\xdaltimas anotaciones"},"page":{"en":"Page","es":"P\xe1gina"},"latitude":{"en":"lat","es":"lat"},"longitude":{"en":"lng","es":"lng"},"signin":{"en":"Sign in","es":"Inicia sesi\xf3n"},"signout":{"en":"Sign out","es":"Salir"},"viewProfile":{"en":"View profile","es":"Ver perfil"},"newNick":{"en":"New nick","es":"Nuevo apodo"},"newTreeNick":{"en":"New tree nick","es":"Nuevo apodo del \xe1rbol"},"changeNick":{"en":"Change nick","es":"Cambiar apodo"},"change":{"en":"Change","es":"Cambiar"},"newNickTip":{"en":"Your cool new nick...","es":"Tu nuevo apodo..."},"newTreeNickTip":{"en":"A cool nick for this tree...","es":"Un apodo para este \xe1rbol..."},"noNick":{"en":"No nick.","es":"No hay apodo."},"nickTooshort":{"en":"Nick too short.","es":"Apodo demasiado corto."},"nickToolong":{"en":"Nick too long.","es":"Apodo demasiado largo."},"checkingNick":{"en":"Checking the nick...","es":"Comprobando el apodo..."},"nickTaken":{"en":"Nick already taken.","es":"Apodo ya cogido."},"changeNickSuccess":{"en":"Nick changed","es":"Apodo cambiado"},"changeNickFailure":{"en":"Nick change failed","es":"Fall\xf3 el cambio de apodo"},"changeTreeNickSuccess":{"en":"Tree nick changed","es":"Apodo de \xe1rbol cambiado"},"changeTreeNickFailure":{"en":"Tree nick change failed","es":"Fall\xf3 el cambio de apodo del \xe1rbol"},"errorUserTitle":{"en":"The user does not exist","es":"No existe el usuario"},"errorUserText":{"en":"There is no user with identifier ","es":"No existe un usuario con identificador "},"userActive":{"en":"\uD83D\uDCC5 active since ","es":"\uD83D\uDCC5 activo desde "},"isMaster":{"en":"\uD83D\uDE0E is master","es":"\uD83D\uDE0E es m\xe1ster"},"cannotAnnotate":{"en":"\uD83D\uDC80 cannot annotate","es":"\uD83D\uDC80 no puede anotar"},"oneTreeCreated":{"en":"\uD83C\uDF33 creator of one tree","es":"\uD83C\uDF33 creador de un \xe1rbol"},"multipleTreesCreated":{"en":"\uD83C\uDF33 creator of %d trees","es":"\uD83C\uDF33 creador de %d \xe1rboles"},"oneAnnotation":{"en":"\uD83C\uDF32 creator of one annotation","es":"\uD83C\uDF32 creador de una anotaci\xf3n"},"multipleAnnotations":{"en":"\uD83C\uDF32 creator of %d annotations","es":"\uD83C\uDF32 creador de %d anotaciones"},"local":{"en":"en","es":"es","pt":"pt"},"tourTitle0":{"en":"Welcome","es":"Bienvenido"},"tourText0":{"en":"Welcome to EducaWood! There are a lot of things you can do with this application. Let\'s review the map controls.<br><br><i>You can exit this tour at any time by pushing the \'X\'.</i>","es":"\xa1Bienvenido a EducaWood! Hay muchas cosas que puedes hacer con esta aplicaci\xf3n. Empecemos revisando los controles.<br><br><i>Puedes salir de este tour en cualquier momento pulsando la \'X\'.</i>"},"tourTitle1":{"en":"The map","es":"El mapa"},"tourText1":{"en":"This is the main screen of EducaWood. Most of the actions in the application are initiated in this view.<br>You can use the touchscreen (or the mouse in PCs) for panning and zooming the map.","es":"\xc9sta es la pantalla principal de EducaWood. La mayor\xeda de las acciones posibles se inician aqu\xed.<br>Puedes usar la pantalla t\xe1ctil (o el rat\xf3n si es un PC) para mover el mapa o para hacer zoom."},"tourTitle2":{"en":"Zoom buttons","es":"Botones de zoom"},"tourText2":{"en":"You can also use these buttons for zooming in or out.","es":"Tambi\xe9n puedes usar estos botones para controlar el nivel de zoom."},"tourTitle3":{"en":"My location","es":"Mi localizaci\xf3n"},"tourText3":{"en":"Push this button to center the map in your current location. Please note that you need to grant permission to your browser.<br>In case of success, a blue dot will mark your location in the map (precision can vary).<br>Push the button again to remove the blue dot.","es":"Pulsa este bot\xf3n para centrar el mapa en tu posici\xf3n actual. Ten en cuenta que necesitas dar permiso al navegador para obtener tu posici\xf3n. En caso de \xe9xito, un punto azul marcar\xe1 tu posici\xf3n en el mapa (la precisi\xf3n puede variar).<br>Pulsa de nuevo el bot\xf3n para esconder el punto azul."},"tourTitle4":{"en":"Your profile","es":"Tu perfil"},"tourText4":{"en":"This is your avatar in EducaWood. Push it to view your profile or to sign out.","es":"\xc9ste es tu avatar en EducaWood. Pulsa en \xe9l para ver tu perfil o para cerrar la sesi\xf3n."},"tourTitle5":{"en":"Sign in","es":"Inicia sesi\xf3n"},"tourText5":{"en":"Push to sign in (a Google account is needed). This allows you to create and annotate trees in EducaWood.","es":"Pulsa para iniciar sesi\xf3n (requiere una cuenta de Google). Esto te permite crear y anotar \xe1rboles en EducaWood."},"tourTitle6":{"en":"Create trees","es":"Crea \xe1rboles"},"tourText6":{"en":"Push to create a new tree.<br>This button is only enabled if (1) you have signed in and (2) the zoom level is high enough.<br>After clicking this button, push the map location where the new tree will be created.","es":"Pulsa para crear un \xe1rbol.<br>El bot\xf3n s\xf3lo estar\xe1 habilitado si (1) has iniciado sesi\xf3n y (2) el nivel de zoom es suficientemente alto.<br>Tras clickar este bot\xf3n, pulsa la localizaci\xf3n del mapa en la que quieres crear el \xe1rbol."},"tourTitle7":{"en":"View IFN trees","es":"Ver \xe1rboles IFN"},"tourText7":{"en":"Push to show the IFN trees in the map view.<br>IFN is the official Spanish inventory of trees, so this functionality is only useful in Spain.","es":"Pulsa para mostrar los \xe1rboles del IFN en la vista del mapa.<br>IFN es el inventario oficial espa\xf1ol de \xe1rboles, por lo que esta funcionalidad s\xf3lo es \xfatil en Espa\xf1a."},"tourTitle7a":{"en":"Change map layer","es":"Cambia la capa del mapa"},"tourText7a":{"en":"Push to switch between the maps from OpenStreetMap and Esri.","es":"Pulsa para alternar entre los mapas de OpenStreetMap y Esri."},"tourTitle8":{"en":"Refresh data","es":"Refrescar datos"},"tourText8":{"en":"Push to force the application to gather fresh tree data from the server.<br>This is only needed to get the last minute updates, i.e. to obtain the trees that have just been created in the map view.","es":"Pulsa para obligar a la aplicaci\xf3n a recuperar los \xfaltimos datos de \xe1rboles del servidor.<br>Esto s\xf3lo hace falta para obtener las actualizaciones del \xfaltimo minuto, es decir, los \xe1rboles que acaban de crearse en la vista del mapa."},"tourTitle9":{"en":"Download data","es":"Descarga de datos"},"tourText9":{"en":"Download tree data in the visible area of the map.","es":"Descarga los datos de \xe1rboles de la zona visible del mapa."},"tourTitle10":{"en":"Filter taxon","es":"Filtrar tax\xf3n"},"tourText10":{"en":"Filter the trees in the map by taxon.","es":"Filtra los \xe1rboles en el mapa por tax\xf3n."},"tourTitle11":{"en":"Taxa names","es":"Nombres de taxones"},"tourText11":{"en":"Toggle button to choose between scientific or vulgar taxon names.","es":"Bot\xf3n para elegir entre nombres taxon\xf3micos cient\xedficos o vulgares."},"tourTitle12":{"en":"Search places","es":"Buscar lugares"},"tourText12":{"en":"Center the map in a specific a place by typing its name.","es":"Centra el mapa en el lugar deseado al teclear su nombre."},"tourTitle13":{"en":"More options","es":"M\xe1s opciones"},"tourText13":{"en":"Push to go to the landing or the last trees pages.","es":"Pulsa para ir a las p\xe1ginas de inicio o a la de \xfaltimos \xe1rboles creados."},"tourTitle14":{"en":"The end","es":"Hemos terminado"},"tourText14":{"en":"That\'s all for now. Enjoy EducaWood!","es":"Esto es todo por ahora. \xa1Disfruta de EducaWood!"},"tourExit":{"en":"Exit","es":"Salir"},"tourNext":{"en":"Next","es":"Siguiente"},"tourBack":{"en":"Back","es":"Atr\xe1s"},"tourDone":{"en":"Done","es":"Hecho"}}');


/*
   Copyright 2023, Guillermo Vega-Gorgojo
   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at
       http://www.apache.org/licenses/LICENSE-2.0
   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ 
/*
   Copyright 2023, Guillermo Vega-Gorgojo

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ 
var $33Kba = parcelRequire("33Kba");


var $2q7Wm = parcelRequire("2q7Wm");

var $6KOho = parcelRequire("6KOho");

// GENERACIÓN DEL ID
// nanoid: https://github.com/ai/nanoid/
// versión de https://cdn.jsdelivr.net/npm/nanoid/nanoid.js
let $96abbdd7193a3c4b$var$nanoid = (t = 21)=>crypto.getRandomValues(new Uint8Array(t)).reduce((t, e)=>t += (e &= 63) < 36 ? e.toString(36) : e < 62 ? (e - 26).toString(36).toUpperCase() : e > 62 ? "-" : "_", "");
function $96abbdd7193a3c4b$export$567fc7097e064344(length) {
    let id = $96abbdd7193a3c4b$var$nanoid(length);
    // no permito que el id empiece por '-' (ver qnames https://en.wikipedia.org/wiki/QName)
    if (id.startsWith('-')) id = id.replace('-', '_');
    return id;
}
// PARSING LOCATIONS
function $96abbdd7193a3c4b$export$6f6326edee345e29(cad) {
    const cachos = cad.split(",");
    if (cachos.length == 3) {
        const latpars = cachos[0];
        const lngpars = cachos[1];
        const zpars = cachos[2].split("z")[0];
        // compruebo que los valores estén bien antes de reajustar
        if (!isNaN(Number(latpars))) {
            if (!isNaN(Number(lngpars))) {
                if (Number.isInteger(Number(zpars))) {
                    if (Number(latpars) >= -90 && Number(latpars) <= 90) {
                        // LOCALIZACIÓN CORRECTA
                        let obj = {
                            lat: Number(latpars),
                            lng: Number(lngpars),
                            z: Number(zpars)
                        };
                        return obj;
                    }
                }
            }
        }
    }
    // si no consigo hacer el parsing con éxito
    return null;
}
function $96abbdd7193a3c4b$export$4a32c72e9ff1d1e0(loc) {
    // aquí no hago comprobaciones del objeto loc
    return loc.lat.toFixed(6) + ',' + loc.lng.toFixed(6) + ',' + loc.z + 'z';
}
// LENGUAJE Y LITERALES
// obtengo lenguaje preferido
function $96abbdd7193a3c4b$export$350964a2fface462() {
    let lang = localStorage.getItem('lang');
    if (!lang) {
        // elijo automáticamente a partir del lenguaje del navegador
        const preflangs = window.navigator.languages || [
            window.navigator.language || window.navigator.userLanguage
        ];
        for (let ltag of preflangs){
            const langev = ltag.substring(0, 2);
            if ((0, $2q7Wm.default).contains((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).langs, langev)) {
                lang = langev;
                break;
            }
        }
        if (!lang) lang = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).langs[0]; // inglés
    }
    return lang;
}
// la uso para comprobar si cadgrande incluye cadpeq utilizando cadenas normalizadas
function $96abbdd7193a3c4b$export$bc11d730045994ef(cadgrande, cadpeq) {
    // normalizo cadenas según: https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
    // adicionalmente las pongo en minúsculas para comparar
    var cgnorm = cadgrande.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    var cpnorm = cadpeq.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    return cgnorm.indexOf(cpnorm);
}
function $96abbdd7193a3c4b$export$177dc95d91ec95d1(litobj, def) {
    // si no está definido el objeto, valor por defecto
    if (litobj == undefined) return def;
    // 5/3/21 si es un array, convierto a un objeto
    if (Array.isArray(litobj)) {
        let aux = {};
        for(let i = 0; i < litobj.length; i++){
            const el = litobj[i];
            if (typeof el === 'object') {
                // incluyo en aux los pares clave-valor
                const claves = Object.keys(el);
                for(let j = 0; j < claves.length; j++){
                    const clave = claves[j];
                    aux[clave] = el[clave];
                }
            } else aux[(0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).nolang] = el;
        }
        // cambio el objeto a analizar
        litobj = aux;
    } else if (typeof litobj !== 'object') {
        let aux = {};
        aux[(0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).nolang] = litobj;
        litobj = aux;
    }
    // 2023-11 permito elegir el idioma
    let lang = $96abbdd7193a3c4b$export$350964a2fface462();
    // devuelvo la cadena en el lenguaje elegido si existe
    if (litobj[lang]) return litobj[lang];
    // en otro caso devuelvo la cadena sin etiqueta de idioma
    if (litobj[(0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).nolang]) return litobj[(0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).nolang];
    // pruebo en latín...
    if (litobj['la']) return litobj['la'];
    // cadena por defecto en otro caso...
    if (def) return def;
    // pruebo con el resto de lenguas de la configuración
    for (let ltag of (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).langs){
        if (ltag !== lang && litobj[ltag]) return litobj[ltag];
    }
    // nada que hacer...
    return undefined;
}
function $96abbdd7193a3c4b$export$1690e12b840569b9(obj) {
    let cad = null;
    if (obj.latWGS84 && obj.lngWGS84) cad = $96abbdd7193a3c4b$export$177dc95d91ec95d1((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).latitude) + " " + obj.latWGS84.toFixed(6) + ", " + $96abbdd7193a3c4b$export$177dc95d91ec95d1((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).longitude) + " " + obj.lngWGS84.toFixed(6); // + " (WGS 84)";
    return cad;
}
function $96abbdd7193a3c4b$export$4d0c182344beaa87(obj, pref) {
    let cad = null;
    if (obj.creator) {
        cad = pref + $96abbdd7193a3c4b$export$6efd817d0963408a(obj, true);
        // fecha
        const fecha = $96abbdd7193a3c4b$export$aa350b96d91cd94(obj);
        if (fecha) cad += $96abbdd7193a3c4b$export$177dc95d91ec95d1((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).onDate) + fecha;
    }
    return cad;
}
function $96abbdd7193a3c4b$export$6efd817d0963408a(obj, conhiperenlace) {
    const target = obj.creator ? obj.creator : obj;
    if (target) {
        const criri = target.iri ? $96abbdd7193a3c4b$export$177dc95d91ec95d1(target.iri) : $96abbdd7193a3c4b$export$177dc95d91ec95d1(target);
        const uid = criri.lastIndexOf("/") === -1 ? criri : criri.substring(criri.lastIndexOf("/") + 1);
        // cojo primero el nick en Datos.usuarios[uid] (por si actualizó su nick),
        // en segunda opción el nick del objeto y si no, el uid
        let cr = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[uid] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[uid].nick ? $96abbdd7193a3c4b$export$177dc95d91ec95d1((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[uid].nick) : target.nick ? $96abbdd7193a3c4b$export$177dc95d91ec95d1(target.nick) : uid;
        if (cr.length > 15) cr = cr.substring(0, 12) + "\u2026";
        if (conhiperenlace) cr = '<a class="pagusuario" uid="' + uid + '" href="/user/' + uid + '">' + cr + '</a>';
        return cr;
    }
    return null;
}
function $96abbdd7193a3c4b$export$f91175dce0722b24(obj) {
    const target = obj.creator ? obj.creator : obj;
    if (target) {
        const criri = target.iri ? $96abbdd7193a3c4b$export$177dc95d91ec95d1(target.iri) : $96abbdd7193a3c4b$export$177dc95d91ec95d1(target);
        const uid = criri.lastIndexOf("/") === -1 ? criri : criri.substring(criri.lastIndexOf("/") + 1);
        const crobj = {
            id: uid
        };
        // si hay nick lo incluyo
        const nick = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[uid] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[uid].nick ? $96abbdd7193a3c4b$export$177dc95d91ec95d1((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[uid].nick) : target.nick ? $96abbdd7193a3c4b$export$177dc95d91ec95d1(target.nick) : null;
        if (nick) crobj.nick = nick;
        return crobj;
    }
    return null;
}
function $96abbdd7193a3c4b$export$aa350b96d91cd94(obj) {
    const fecha = obj.created ? obj.created : obj;
    if (fecha) {
        const dops = {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        };
        if (fecha != undefined && !isNaN(Date.parse(fecha))) return new Date(Date.parse(fecha)).toLocaleDateString($96abbdd7193a3c4b$export$177dc95d91ec95d1((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).local), dops);
    }
    return null;
}
function $96abbdd7193a3c4b$export$daf0fdd0a2e008c2(obj) {
    const fecha = obj.created ? obj.created : obj;
    if (fecha && !isNaN(Date.parse(fecha))) return new Date(Date.parse(fecha)).toLocaleDateString($96abbdd7193a3c4b$export$177dc95d91ec95d1((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).local));
    return null;
}
// extracción primer elemento válido siguiendo las claves en keys
// la dificultad está en que el objeto puede tener elementos que sean objetos o arrays
function $96abbdd7193a3c4b$export$92cb375194bc8a33(obj, keys, decomposelastarray) {
    // cojo primer elemento
    const subobj = obj[keys[0]];
    if (keys.length == 1) {
        // hemos llegado al final (hoja)
        if (decomposelastarray && Array.isArray(subobj)) // si el elemento final es un array y nos piden descomponerlo, nos quedamos con el primer elemento y a volar
        return subobj[0];
        else return subobj;
    } else {
        const newkeys = (0, $2q7Wm.default).rest(keys);
        if (Array.isArray(subobj)) {
            // caso delicado, toca iterar por cada elemento del array a ver si hay suerte y alguno lo consigue
            for(let j = 0; j < subobj.length; j++){
                let res = $96abbdd7193a3c4b$export$92cb375194bc8a33(subobj[j], newkeys);
                if (res != null) return res; // lo conseguimos			
            }
            // no hubo suerte...
            return null;
        } else if (typeof subobj === 'object') // aplicamos recursión, sin más
        return $96abbdd7193a3c4b$export$92cb375194bc8a33(subobj, newkeys);
        else return null;
    }
}
// aquí no queremos uno, sino que cogemos todos (DEVUELVE SIEMPRE UN ARRAY)
function $96abbdd7193a3c4b$export$326843c69d38a183(obj, keys) {
    // cojo primer elemento
    const subobj = obj[keys[0]];
    if (keys.length == 1) {
        // hemos llegado al final (hoja)
        if (subobj == undefined) return [];
        else if (Array.isArray(subobj)) return subobj;
        else return [
            subobj
        ];
    } else {
        const newkeys = (0, $2q7Wm.default).rest(keys);
        if (Array.isArray(subobj)) {
            // caso delicado, toca iterar por cada elemento del array
            let subels = []; // aquí metemos los subelementos que nos van valiendo
            for(let j = 0; j < subobj.length; j++){
                let parcels = $96abbdd7193a3c4b$export$326843c69d38a183(subobj[j], newkeys);
                if (parcels.length > 0) subels = subels.concat(parcels);
            }
            return subels;
        } else if (typeof subobj === 'object') // aplicamos recursión, sin más
        return $96abbdd7193a3c4b$export$326843c69d38a183(subobj, newkeys);
        else return [];
    }
}
function $96abbdd7193a3c4b$export$56b19e10c1699553(uri) {
    // extraigo la última parte de la uri
    let lit = "";
    if (uri.split("#").length > 1) lit = uri.split("#")[uri.split("#").length - 1];
    else {
        lit = uri.split("/")[uri.split("/").length - 1];
        if (lit === "") lit = uri.split("/")[uri.split("/").length - 2];
    }
    // sustituyo - y _ por espacio
    lit = lit.replace(/-/g, " ");
    lit = lit.replace(/_/g, " ");
    return lit;
}
function $96abbdd7193a3c4b$export$57fe19e45e887809(lit) {
    if (lit != undefined && lit.length > 0) return lit.charAt(0).toUpperCase() + lit.slice(1);
    else return lit;
}
function $96abbdd7193a3c4b$export$e1dbea550ef5ab44(lit) {
    if (lit != undefined && lit.length > 0) return lit.charAt(0).toLowerCase() + lit.slice(1);
    else return lit;
}
///////////////
// CONFIG MODAL
function $96abbdd7193a3c4b$export$859065cca4d855fc(opciones, titulo, body, footer) {
    // inicializo el header con el título 	
    let header = '<h1 id="mimodaltitle" class="modal-title fs-5">' + titulo + '</h1>';
    // si hay opciones...
    if (opciones) {
        // tamaño grande o no
        if (opciones.lg) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodalDialog").addClass("modal-lg");
        else (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodalDialog").removeClass("modal-lg");
        // centrado vertical o no
        if (opciones.vertcent) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodalDialog").addClass("modal-dialog-centered");
        else (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodalDialog").removeClass("modal-dialog-centered");
        // combino static con la preparación del header
        if (opciones.static) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodal").attr("data-bs-backdrop", "static");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodal").attr("data-bs-keyboard", false);
        } else {
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodal").removeAttr("data-bs-backdrop");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodal").removeAttr("data-bs-keyboard");
            header += '<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>';
        }
        // no body?		
        if (opciones.nobody) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodalBody").addClass("d-none");
        else (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodalBody").removeClass("d-none");
        // no footer?		
        if (opciones.nofooter) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodalFooter").addClass("d-none");
        else (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodalFooter").removeClass("d-none");
        // spinner o no
        if (opciones.spinner) {
            let mibody = '<div class="col-1"> \
						<div class="spinner-border text-secondary" role="status"> \
							<span class="visually-hidden">Loading...</span> \
	  					</div> \
					</div>';
            if (opciones.spinnerMessage) mibody += '<div class="col ms-3">' + opciones.spinnerMessage + '</div>';
            // pongo el body
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodalBody").html(mibody);
            // y activo bodyrow para alinear el spinner (aunque no esté en las opciones)
            opciones.bodyrow = true;
        }
        // row en el body o no
        if (opciones.bodyrow) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodalBody").addClass("row");
        else (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodalBody").removeClass("row");
    }
    // si hay título, pongo el header que he preparado
    if (titulo) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodalHeader").html(header);
    // si hay body...
    if (body) {
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodalBody").html(body);
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodalBody").removeClass("d-none");
    }
    // si hay footer...
    if (footer) {
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodalFooter").html(footer);
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodalFooter").removeClass("d-none");
    }
}


/*********************
*** TEMPLATES FILE ***
**********************/ let $646ceeeec66fabd8$export$f3d44414f0a0d0b1, $646ceeeec66fabd8$export$900677b7c5ee40b7, $646ceeeec66fabd8$export$fafd45cc9f2ab26c, $646ceeeec66fabd8$export$502b32cc8ed2e37e, $646ceeeec66fabd8$export$217f5a5fe852abe6, $646ceeeec66fabd8$export$cbaf9c974071f389, $646ceeeec66fabd8$export$1cfea2c3e1d7bf94, $646ceeeec66fabd8$export$df6117506e1c4c3b, $646ceeeec66fabd8$export$27eb5f8cf2bf64a7, $646ceeeec66fabd8$export$d15beb852fc82fa2, $646ceeeec66fabd8$export$f3dc3f942ad7cadb, $646ceeeec66fabd8$export$170c21d6f8f459cf, $646ceeeec66fabd8$export$afb205d6a878a5e7, $646ceeeec66fabd8$export$d4de91556d149ac6, $646ceeeec66fabd8$export$dd1b8137336daa0c, $646ceeeec66fabd8$export$43bbd40c30a74965, $646ceeeec66fabd8$export$3fc5053bf2a10407, $646ceeeec66fabd8$export$ab832a4d4ceb9113, $646ceeeec66fabd8$export$ce041e830841d411, $646ceeeec66fabd8$export$9fac9ed2fe46e816, $646ceeeec66fabd8$export$eaebbbf45ac961b6, $646ceeeec66fabd8$export$af3959eda01cc433, $646ceeeec66fabd8$export$62b82cd57460378a, $646ceeeec66fabd8$export$a76d078e0f25e96f, $646ceeeec66fabd8$export$96346f251ef3b3fb, $646ceeeec66fabd8$export$c75e99c9076bb133;
var $de92502364952e0e$exports = {};
$de92502364952e0e$exports = import.meta.resolve("3Pfll");


let $646ceeeec66fabd8$var$urlLogo = new URL($de92502364952e0e$exports);
function $646ceeeec66fabd8$export$5e43259f1480bd05() {
    $646ceeeec66fabd8$export$f3d44414f0a0d0b1 = '<div id="tarjeta" class="card-body mitarjeta p-1" > \
	<div class="d-flex flex-row"> \
		<div class="dropdown"> \
			<button id ="bot_inicio" class="btn btn-outline-secondary" type="button" \
				data-bs-toggle="dropdown" aria-expanded="false"><i class="bi bi-list"></i> \
			</button> \
			<ul class="dropdown-menu"> \
				<li><a id="tarjeta-home" class="dropdown-item home" href="#">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).home) + '</a></li> \
				<li><a id="tarjeta-lasttrees" class="dropdown-item lasttrees" href="#">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).lastTrees) + '</a></li> 			    <li><hr class="dropdown-divider"></li> 			    <li><a class="dropdown-item lang" tag="en" href="#">\uD83C\uDDEC\uD83C\uDDE7 EN</a></li> 				<li><a class="dropdown-item lang" tag="es" href="#">\uD83C\uDDEA\uD83C\uDDF8 ES</a></li> 			</ul> 		</div> 		<div class="btn-group"> 			<button id="bot_taxones" class="text-nowrap btn btn-outline-secondary ms-1" type="button" disabled> 				' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).taxonfilter) + '</button> \
			<input id="mapchecknomci" type="checkbox" class="btn-check nomci" id="btn-check" autocomplete="off" {{#nomci}}checked{{/nomci}} > \
			<label id="bot_mapnomci" class="btn btn-outline-secondary" for="mapchecknomci"><i class="bi bi-mortarboard-fill"></i></label> \
		</div> \
		<div id="lugares_heading" class="flex-fill ms-1 me-1 me-sm-0 d-none"> \
			<input id="in_lugares" autocomplete="off" type="search" class="form-control " \
				placeholder="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).searchplace) + '" aria-label="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).searchplace) + '"> \
		</div> \
		<div class="ms-auto usuario d-block d-sm-none d-flex align-items-center"></div> \
	</div> \
	<div id="sugelugares" class="list-group mt-2 d-none"></div> \
	<div id="taxones_subheading"></div> \
	<div id="taxones_block" class="taxones_block list-group overflow-auto mt-1 pe-1 pe-sm-2 d-none" style="max-height:50vh;"></div> \
	<div id="filtro_taxon" class="d-none"> \
		<div class="d-flex align-items-center border mt-1"> \
			<div id="div_label_filtro_taxon" class="ms-2"></div> \
			<div class="ms-auto"> \
				<button id="bot_info_filtro_taxon" class="btn btn-sm" type="button" turi="" > \
					<i class="bi bi-info-circle-fill"></i> \
				</button> \
			</div> \
			<div class="me-2"> \
				<button id="bot_color_filtro" class="btn btn-sm" type="button" data-bs-toggle="dropdown" aria-expanded="false"> \
					<i class="bi bi-droplet-fill"></i> \
				</button> \
				<ul class="dropdown-menu" aria-labelledby="dropdownMenu"> \
					<li><a class="dropdown-item dropdown_color_taxon" href="#" cind="5">Pink</a></li> \
					<li><a class="dropdown-item dropdown_color_taxon" href="#" cind="6">Purple</a></li> \
					<li><a class="dropdown-item dropdown_color_taxon" href="#" cind="7">Indigo</a></li> \
					<li><a class="dropdown-item dropdown_color_taxon" href="#" cind="8">Cyan</a></li> \
					<li><a class="dropdown-item dropdown_color_taxon" href="#" cind="9">Brown</a></li> \
				</ul> \
			</div> \
			<div id="bot_quitar_taxon" class="me-2 pb-1"> \
				<button type="button" class="btn-close" aria-label="Close"></button> \
			</div> \
		</div> \
	</div> \
	<div id="mibarradiv" class="progress mt-1 d-none" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"> \
		<div id="mibarra" class="progress-bar progress-bar-striped progress-bar-animated bg-secondary" style="width: 0%" >0%</div> \
		<div id="mibarra_loading" class="text-center text-dark" style="width: 100%">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).spinnerLoading) + '</div> \
    </div> \
</div>';
    $646ceeeec66fabd8$export$900677b7c5ee40b7 = '{{#activar}} \
		{{#esformulario}}<div class="input-group my-1">{{/esformulario}} \
		<input autocomplete="off" type="search" class="in_taxon form-control{{^esformulario}} my-1{{/esformulario}}" \
				 placeholder="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).searchtaxon) + '" aria-label="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).searchtaxon) + '"> \
		{{#esformulario}}<button id="importTaxonButton" type="button" class="btn btn-outline-primary">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).importtaxon) + '</button></div>{{/esformulario}} \
	{{/activar}} \
	<div class="sugetaxones list-group"></div>';
    $646ceeeec66fabd8$export$fafd45cc9f2ab26c = '{{#sugerencias}} \
		<button class="list-group-item list-group-item-action bot_suge_taxon" type="button" spuri="{{uri}}"> \
			{{#nc}}<i>{{/nc}}{{{labelshown}}}{{#nc}}</i>{{/nc}}<span class="badge rounded-pill text-bg-secondary float-end me-0">{{nclasses}} S</span> \
			<span class="badge rounded-pill text-bg-secondary float-end me-1">{{nindivs}}</span> \
		</button> \
	{{/sugerencias}} \
	{{#nosugerencias}} \
		<button type="button" class="list-group-item list-group-item-action py-2 bot_suge_taxon" disabled>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).notaxonfound) + '</button> \
	{{/nosugerencias}}';
    $646ceeeec66fabd8$export$502b32cc8ed2e37e = '{{#.}} \
		<div class="{{^esconder}}d-flex {{/esconder}}bd-highlight border-bottom border-left border-right taxon {{#esconder}}d-none{{/esconder}}" indice="{{indice}}"> \
			{{#botonesconder}} \
				<div><span>{{{indentspace}}}</span><span><button type="button" class="btn btn-outline-secondary btn-sm showmore">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).showmore) + '</button></span></div> \
			{{/botonesconder}} \
			{{^botonesconder}} \
				<div class="flex-grow-1"> \
					<button class="list-group-item list-group-item-action border-0 bot_sel_taxon" type="button" spuri="{{uri}}"> \
						{{{indentspace}}}{{#nc}}<i>{{/nc}}{{label}}{{#nc}}</i>{{/nc}} \
						<span class="badge rounded-pill text-bg-secondary float-end me-0">{{nclasses}} S</span> \
						<span class="badge rounded-pill text-bg-secondary float-end me-1">{{nindivs}}</span> \
					</button> \
				</div> \
				<div class="p-1"> \
					<button class="btn btn-outline-secondary btn-sm bot_expandir_taxon {{#nosubclasses}}invisible{{/nosubclasses}}" \
						type="button" data-placement="top"><i class="bi bi-chevron-right"></i> \
					</button> \
				</div> \
			{{/botonesconder}} \
		</div> \
	{{/.}}';
    $646ceeeec66fabd8$export$217f5a5fe852abe6 = '{{#sugerencias}} \
		<button type="button" class="list-group-item list-group-item-action py-2 bot_suge_lugar" id="{{id}}">{{{name}}}</button> \
	{{/sugerencias}} \
	{{#nosugerencias}} \
		<button type="button" class="list-group-item list-group-item-action py-2" disabled>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noplacesfound) + '</button> \
	{{/nosugerencias}}';
    $646ceeeec66fabd8$export$cbaf9c974071f389 = '{{#sugerencias}} \
		<button type="button" wdiri="{{{wdiri}}}" class="list-group-item list-group-item-action py-2 bot_suge_taxonWD"><i>{{{title}}}</i><br><small>{{{desc}}}</small></button> \
	{{/sugerencias}} \
	{{#nosugerencias}} \
		<button type="button" class="list-group-item list-group-item-action py-2" disabled>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).notaxonsfound) + '</button> \
	{{/nosugerencias}}';
    $646ceeeec66fabd8$export$1cfea2c3e1d7bf94 = '<div class="container-fluid"> \
		{{#hayimagen}} \
			<div class="row"> \
				<div class="col-sm-5"> \
		{{/hayimagen}} \
					<h5 class="text-muted">{{tipo}}</h5> \
		{{#hayimagen}} \
			{{^multimages}} \
					<img class="img-fluid mt-1 mb-2" src="{{{image}}}"> \
			{{/multimages}} \
			{{#multimages}} \
				<div id="carouselPopupTaxon" class="carousel slide" data-bs-ride="carousel"> \
					<div class="carousel-inner"> \
						{{#image}} \
							<div class="carousel-item {{#active}}active{{/active}}"> \
								<img src="{{{src}}}" > \
							</div> \
						{{/image}} \
					</div> \
					<button class="carousel-control-prev" type="button" data-bs-target="#carouselPopupTaxon" data-bs-slide="prev"> \
						<span class="carousel-control-prev-icon" aria-hidden="true"></span> \
						<span class="visually-hidden">Previous</span> \
					</button> \
					<button class="carousel-control-next" type="button" data-bs-target="#carouselPopupTaxon" data-bs-slide="next"> \
						<span class="carousel-control-next-icon" aria-hidden="true"></span> \
						<span class="visually-hidden">Next</span> \
					</button>   \
				</div> \
			{{/multimages}} \
				</div> \
				<div class="col-sm-7"> \
		{{/hayimagen}} \
					{{#resumen}} \
						<p>{{resumen}}</p> \
					{{/resumen}} \
					{{#gbifPage}} \
						<a href="{{{.}}}" target="_blank" \
							class="btn btn-secondary btn-sm">GBIF</a> \
					{{/gbifPage}} \
					{{#wikidataPage}} \
						<a href="{{{.}}}" target="_blank" \
							class="btn btn-secondary btn-sm">Wikidata</a> \
					{{/wikidataPage}} \
					{{#wikipediaPage}} \
						<a href="{{{.}}}" target="_blank" \
							class="btn btn-secondary btn-sm">Wikipedia</a> \
					{{/wikipediaPage}} \
					{{#wikispeciesPage}} \
						<a href="{{{.}}}" target="_blank" \
							class="btn btn-secondary btn-sm">WikiSpecies</a> \
					{{/wikispeciesPage}} \
		{{#hayimagen}} \
				</div> \
			</div> \
		{{/hayimagen}} \
	</div>';
    $646ceeeec66fabd8$export$df6117506e1c4c3b = '<div style="max-width: 180px;"> \
		{{#image}}<img class="card-img-top" src="{{{.}}}" width="180px">{{/image}} \
		{{#multimages}} \
			<div id="carouselPopupTree" class="carousel slide" data-bs-ride="carousel"> \
				<div class="carousel-inner"> \
					{{#images}} \
						<div class="carousel-item {{#active}}active{{/active}}"> \
							<img src="{{{srcimg}}}" width="180px" class="d-block w-100"> \
						</div> \
					{{/images}} \
				</div> \
				<button class="carousel-control-prev" type="button" data-bs-target="#carouselPopupTree" data-bs-slide="prev"> \
					<span class="carousel-control-prev-icon" aria-hidden="true"></span> \
					<span class="visually-hidden">Previous</span> \
				</button> \
				<button class="carousel-control-next" type="button" data-bs-target="#carouselPopupTree" data-bs-slide="next"> \
					<span class="carousel-control-next-icon" aria-hidden="true"></span> \
					<span class="visually-hidden">Next</span> \
				</button>   \
			</div> \
		{{/multimages}}	\
		{{#nick}}<h6>{{.}}</h6>{{/nick}} \
		{{#taxon}}<h6 class="card-subtitle text-muted">{{{.}}}</h6>{{/taxon}} \
		{{#desc}}<p class="my-1 my-sm-2 card-text">{{{.}}}</p>{{/desc}} \
		{{#creator}}<p class="my-1 my-sm-2 text-muted">{{{.}}}</p>{{/creator}} \
		<div style="display: flex; justify-content: center;"> \
			<button etid="{{{etid}}}" class="educatree btn btn-secondary" type="button">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).moreinfo) + '</button> \
		</div> \
	</div>';
    $646ceeeec66fabd8$export$27eb5f8cf2bf64a7 = '<div class="d-flex flex-row bd-highlight m-5"> \
		<div class="p-3 bd-highlight"><div class="spinner-border" role="status" aria-hidden="true"></div></div> \
		<div class="ml-5 bd-highlight"><div><h3 id="titleSpinner">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).spinnerLoading) + '</h3><p id="infoSpinner" class="font-weight-light">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).spinnerInfo) + '</p></div></div> \
	</div>';
    $646ceeeec66fabd8$export$d15beb852fc82fa2 = '<nav class="navbar navbar-expand-md" style="background-color: #DCEDC8;"> \
		<div class="container-fluid"> \
			<a class="navbar-brand d-none d-md-block" href="#"> \
				<img src="' + $646ceeeec66fabd8$var$urlLogo + '" alt="EducaWood" height="40"> \
			</a> \
			<button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation"> \
				<span class="navbar-toggler-icon"></span> \
			</button> \
			<div class="collapse navbar-collapse" id="navbarNav"> \
				<ul class="navbar-nav"> \
					<li class="nav-item"> \
						<a class="nav-link home" href="#">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).home) + '</a> \
					</li> \
					<li class="nav-item"> \
						<a class="nav-link map" href="#">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).map) + '</a> \
					</li> \
					<li class="nav-item"> \
						<a class="nav-link lasttrees {{#enPagLastrees}}active{{/enPagLastrees}}" {{#enPagLastrees}}aria-current="page"{{/enPagLastrees}} href="#">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).lastTrees) + '</a> \
					</li> \
					<li class="nav-item dropdown"> \
						<a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).flaglang) + '</a> 						<ul class="dropdown-menu"> 							<li><a class="dropdown-item lang" tag="en" href="#">\uD83C\uDDEC\uD83C\uDDE7 EN</a></li> 							<li><a class="dropdown-item lang" tag="es" href="#">\uD83C\uDDEA\uD83C\uDDF8 ES</a></li> 						</ul> 					</li> 				</ul> 			</div> 			<a class="navbar-brand d-block d-md-none" href="#"> 				<img src="' + $646ceeeec66fabd8$var$urlLogo + '" alt="EducaWood" height="28"> \
			</a> \
			{{^usuario}} \
			<button class="nav-item btn btn-light usersignin" type="button"><i class="bi bi-box-arrow-in-right"></i></button> \
			{{/usuario}} \
			{{#usuario}} \
			<div class="nav-item dropstart"> \
				<button class="btn p-0" type="button" data-bs-toggle="dropdown" aria-expanded="false" style="border-color: transparent;"> \
					<img class="avatar avatar-32 avatar-sm-48 bg-light rounded-circle text-white {{^usuarioImg}}p-1 p-sm-2{{/usuarioImg}}" \
						src="{{#usuarioImg}}{{{.}}}{{/usuarioImg}}{{^usuarioImg}}https://raw.githubusercontent.com/twbs/icons/main/icons/person.svg{{/usuarioImg}}" \
						referrerpolicy="no-referrer"> \
				</button> \
				<ul class="dropdown-menu"> \
					<li><a href="#" class="dropdown-item userprofile">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).viewProfile) + '</a></li> \
					<li><a href="#" class="dropdown-item usersignout">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).signout) + '</a></li> \
				</ul> \
			</div> \
			{{/usuario}} \
		</div> \
	</nav>';
    $646ceeeec66fabd8$export$f3dc3f942ad7cadb = $646ceeeec66fabd8$export$d15beb852fc82fa2 + '<div class="container pb-4"> \
		<div class="container-fluid"> \
			<div class="row justify-content-lg-center mt-4 p-0"> \
				<div class="col-lg-8 p-0"> \
					<div class="card text-center p-0"> \
						<div class="card-header"> \
							<h5 class="col card-title">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).newtree) + '</h5> \
						</div> \
						<div class="card-body p-0"> \
							<div id="mapaedutree" style="height: 300px;"> \
								<div id="overlay" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; pointer-events: none; z-index: 9999;"> \
									<div class="d-flex justify-content-center align-items-center overlay-backdrop" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5);"> \
										<div class="spinner-border" role="status"> \
											<span class="visually-hidden">Loading...</span> \
										</div> \
									</div> \
								</div> \
							</div> \
							<div id="mapclue" class="form-text d-none">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).mapclue) + '</div> \
						</div> \
					</div> \
				</div> \
			</div> \
			<div class="row justify-content-lg-center"> \
				<form id="createTreeForm" class="col-lg-8 py-4"> \
					<!-- POSITION --> \
					<div class="pb-4 row"> \
						<label for="inputPosition" class="col-md-3 col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).position) + '</label> \
						<div class="col-md-9"> \
							<div class="input-group"> \
								<input id="inputPosition" type="text" class="form-control" value="" disabled readonly> \
							</div> \
						</div> \
					</div> \
					<!-- NICK --> \
					<div class="pb-4 row"> \
						<label for="inputTreeNick" class="col-md-3 col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treenick) + '</label> \
						<div class="col-md-9"> \
							<div class="input-group"> \
								<input id="inputTreeNick" type="text" class="form-control" value="" minlength="3" maxlength="30" placeholder="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).newTreeNickTip) + '"> \
							</div> \
							<div id="statusNick" class="form-text">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noNick) + '</div> \
						</div> \
					</div> \
					<!-- TREE TAXON --> \
					<div class="pb-4 row"> \
						<label for="inputTreeTaxonEd" class="col-md-3 col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treetaxon) + '</label> \
						<div class="col-md-9"> \
							<div class="input-group"> \
								<button id="setTreeTaxonEd" class="btn btn-outline-secondary" type="button">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).taxonfilter) + '</button> \
								<input id="inputTreeTaxonEd" type="text" class="form-control taxon" placeholder="" aria-describedby="handlerSetTreeTaxonEd" disabled readonly> \
								<button class="btn btn-outline-secondary d-none delete" type="button" id="deleteTreeTaxon"><i class="bi bi-x-lg"></i></button> \
								<button id="infoTaxonDbpedia" class="btn btn-outline-secondary d-none dbpedia" type="button" turi="" > \
									<i class="bi bi-info-circle-fill"></i> \
								</button> \
								<input id="crchecknomci" type="checkbox" class="btn-check nomci" id="btn-check" autocomplete="off"> \
								<label class="btn btn-outline-secondary" for="crchecknomci"><i class="bi bi-mortarboard-fill"></i></label> \
							</div> \
							<div id="taxones_subheading_newtree" class="d-none"></div> \
							<div id="taxones_block_newtree" class="taxones_block list-group overflow-auto mt-1 d-none pe-1 pe-sm-2" style="max-height:50vh;"></div> \
						</div> \
					</div> \
					<!-- TREE STATUS --> \
					<div class="pb-4 row"> \
						<label for="selectTreeStatus" class="col-md-3 col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treeStatus) + '</label> \
						<div class="col-md-9"> \
							<div class="input-group"> \
								<select id="selectTreeStatus" class="form-select" \
									aria-label="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treestatusselection) + '"></select> \
								<button class="btn btn-outline-secondary" type="button" id="botTreeStatusInfo"><i class="bi bi-info-circle-fill"></i></button> \
							</div> \
						</div> \
					</div> \
					<!-- TREE PHOTO --> \
					<div class="pb-4 row"> \
						<label for="treePhoto" class="col-md-3 col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).photo) + '</label> \
						<div class="col-md-9"> \
							<div class="input-group"> \
								<input id="treePhoto" class="form-control" type="file" accept="image/*" \
									{{#esMovil}}{{#camera}}capture="environment"{{/camera}}{{/esMovil}} > \
								<button class="btn btn-outline-secondary d-none" type="button" id="deleteTreePhoto"><i class="bi bi-x-lg"></i></button> \
								{{#esMovil}} \
									<input id="checkCamera" type="checkbox" class="btn-check camera" id="btn-check" autocomplete="off" {{#camera}}checked{{/camera}}> \
									<label class="btn btn-outline-secondary" for="checkCamera"><i class="bi bi-camera-fill"></i></label> \
								{{/esMovil}} \
							</div> \
							<select id="selectTreePartPhoto" class="d-none form-select mt-1" \
								aria-label="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).partplanselection) + '"></select> \
							<input type="hidden" id="resizedTreePhoto"> \
							<div class="form-text"><span id="textTreePhoto">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).nophoto) + '</span><img id="treeThumbnail" class="d-none ms-3 mt-1" src="" width="80px"></div> \
						</div> \
					</div> \
					<!-- TREE HEIGHT --> \
					<div class="pb-4 row"> \
						<label for="treeHeight" class="col-md-3 col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).heightm) + '</label> \
						<div class="col-md-9"> \
							<input type="number" class="form-control" id="treeHeight" step="any" min="0" max="150" placeholder="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).enterheightm) + '"> \
						</div> \
					</div> \
					<!-- TREE DIAMETER --> \
					<div class="pb-4 row"> \
						<label id="labelTreeDiameter" for="treeDiameter" class="col-md-3 col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).diametermm) + '</label> \
						<div class="col-md-9"> \
							<div class="input-group"> \
								<input id="treeDiameter" type="number" class="form-control" step="1" min="0" max="20000" placeholder="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).enterdiametermm) + '"> \
								<input id="checkPerimeter" type="checkbox" class="btn-check perimeter" id="btn-check" autocomplete="off"> \
								<label class="btn btn-outline-secondary" for="checkPerimeter"><i class="bi bi-circle"></i></label> \
							</div> \
						</div> \
		  			</div> \
					<!-- TREE OBSERVATION --> \
					<div class="pb-4 row"> \
						<label id="labelTreeObservation for="treeObservation" class="col-md-3 col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treeobservation) + '</label> \
						<div class="col-md-9"> \
							<div class="input-group"> \
								<textarea class="form-control" id="treeObservation" autocomplete="off" placeholder="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).yourobservation) + '" minlength="5" maxlength="500"></textarea> \
							</div> \
						</div> \
		  			</div> \
					<div class="form-text pb-4">{{^usuario}}<strong>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).signupToCreate) + '<strong>{{/usuario}}{{#usuario}}' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).formopt) + '{{/usuario}}</div> \
					<div class="d-flex"> \
						<button id="goBackButton" type="button" class="me-auto btn btn-secondary">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).cancel) + '</button> \
						<button id="createTreeButton" type="submit" class="btn btn-primary" {{^usuario}}disabled{{/usuario}}>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).createtree) + '</button> \
					</div> \
				</form> \
			</div> \
		</div> \
	</div>';
    $646ceeeec66fabd8$export$170c21d6f8f459cf = '<option value="" selected>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treestatusselection) + '</option> \
	{{#.}} \
		<option value="{{{iri}}}">{{{pref}}}{{label}}</option> \
	{{/.}}';
    $646ceeeec66fabd8$export$afb205d6a878a5e7 = '<option value="" selected>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).partplanselection) + '</option> \
	{{#.}} \
		<option value="{{{uri}}}">{{label}}</option> \
	{{/.}}';
    $646ceeeec66fabd8$export$d4de91556d149ac6 = '<div class="dropdown"> \
		<button class="btn p-0" type="button" data-bs-toggle="dropdown" aria-expanded="false" style="border-color: transparent;"> \
			<img class="avatar avatar-32 avatar-sm-48 bg-light rounded-circle text-white {{^img}}p-1 p-sm-2{{/img}}" \
    			src="{{#img}}{{{.}}}{{/img}}{{^img}}https://raw.githubusercontent.com/twbs/icons/main/icons/person.svg{{/img}}" \
    			referrerpolicy="no-referrer"> \
		</button> \
		<ul class="dropdown-menu"> \
			<li><a href="#" class="dropdown-item userprofile">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).viewProfile) + '</a></li> \
			<li><a href="#" class="dropdown-item usersignout">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).signout) + '</a></li> \
		</ul> \
	</div>';
    $646ceeeec66fabd8$export$dd1b8137336daa0c = $646ceeeec66fabd8$export$d15beb852fc82fa2 + '<div class="container pb-4"> \
		<div class="container-fluid"> \
			<div class="row justify-content-lg-center mt-4 p-0"> \
				<div class="col-lg-8 p-0"> \
					<div class="card text-center p-0"> \
						<div class="card-header"> \
							<h5 class="col card-title">{{{title}}}</h5> \
							{{#treeCreator}}<p class="col card-text">{{{.}}}</p>{{/treeCreator}} \
							{{#removable}}<button id="changeTreeNick" type="button" class="btn btn-primary mt-1">{{nickButtonLabel}}</button>{{/removable}} \
						</div> \
						<div class="card-body p-0"> \
							<div id="mapaedutree" style="height: 300px;"> \
								<div id="overlay" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; pointer-events: none; z-index: 9999;"> \
									<div class="d-flex justify-content-center align-items-center overlay-backdrop" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5);"> \
										<div class="spinner-border" role="status"> \
											<span class="visually-hidden">Loading...</span> \
										</div> \
									</div> \
								</div> \
							</div> \
						</div> \
					</div> \
				</div> \
			</div> \
			<div class="row justify-content-lg-center"> \
				<div class="col-lg-8 py-4 px-0 px-sm-3"> \
					<!-- POSITION --> \
					<div class="row"> \
						<label for="inputPosition" class="col-md-3 col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).position) + '</label> \
						<div class="col-md-9"> \
							<div class="input-group"> \
								<input id="inputPosition" type="text" class="form-control" value="{{position.value}}" disabled readonly> \
							</div> \
						</div> \
					</div> \
					<div class="row pt-1 justify-content-between"> \
						{{#editable}} \
						<div class="btn-group col-auto" role="group"> \
							<button class="btn btn-outline-primary position create" type="button"><i class="bi bi-plus-lg"></i></button> \
						</div> \
						{{/editable}} \
						<div class="form-text col text-end {{#position.removable}}px-0{{/position.removable}}">{{{position.creator}}}</div> \
						{{#position.removable}} \
						<div class="btn-group col-auto" role="group"> \
							<button class="col-auto btn btn-outline-danger position delete" iri="{{{position.iri}}}" type="button"><i class="bi bi-x-lg"></i></button> \
						</div> \
						{{/position.removable}} \
					</div> \
					{{#hasFormerPositions}} \
					<div class="row pt-1 justify-content-end"> \
						<div class="btn-group col-auto" role="group"> \
							<button class="btn btn-outline-secondary" type="button" data-bs-toggle="collapse" data-bs-target="#collapsePositions" \
								aria-expanded="false" aria-controls="collapsePositions">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).formerPositions) + '</button> \
						</div> \
					</div> \
					<div id="collapsePositions" class="collapse pt-1"> \
						{{#formerPositions}} \
						<div class="row"> \
							<div class="col-md-3"></div> \
							<div class="col-md-9"> \
								<div class="input-group"> \
									<input id="inputPosition" type="text" class="form-control" value="{{value}}" disabled readonly> \
								</div> \
							</div> \
						</div> \
						<div class="row py-1 justify-content-between"> \
							<div class="form-text col text-end {{#removable}}px-0{{/removable}}">{{{creator}}}</div> \
							{{#removable}} \
							<div class="btn-group col-auto" role="group"> \
								<button class="col-auto btn btn-outline-danger position delete" iri="{{{iri}}}" type="button"><i class="bi bi-x-lg"></i></button> \
							</div> \
							{{/removable}} \
						</div> \
						{{/formerPositions}} \
					</div> \
					{{/hasFormerPositions}} \
					<!-- TREE TAXON --> \
					{{#treeTaxon}} \
					<div class="row pt-4"> \
						<label for="viewTreeTaxon" class="col-md-3 col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treetaxon) + '</label> \
						{{#treeTaxon.value}} \
						<div class="col-md-9"> \
							<div class="input-group"> \
								<input id="viewTreeTaxon" type="text" class="form-control taxon" iri="{{{treeTaxon.value}}}" disabled readonly> \
								{{#treeTaxon.wikidata}} \
								<button id="viewInfoTaxonDbpedia" class="btn btn-outline-secondary dbpedia" type="button" turi="{{{treeTaxon.value}}}" > \
									<i class="bi bi-info-circle-fill"></i> \
								</button> \
								{{/treeTaxon.wikidata}} \
								<input id="viewchecknomci" type="checkbox" class="btn-check nomci" id="btn-check" autocomplete="off"> \
								<label class="btn btn-outline-secondary" for="viewchecknomci"><i class="bi bi-mortarboard-fill"></i></label> \
							</div> \
						</div> \
						{{/treeTaxon.value}} \
					</div> \
					<div class="row pt-1 justify-content-between"> \
						{{#editable}} \
						<div class="btn-group col-auto" role="group"> \
							<button class="btn btn-outline-primary treeTaxon create" type="button"><i class="bi bi-plus-lg"></i></button> \
						</div> \
						{{/editable}} \
						<div class="form-text col text-end {{#treeTaxon.removable}}px-0{{/treeTaxon.removable}}">{{{treeTaxon.creator}}}</div> \
						{{#treeTaxon.removable}} \
						<div class="btn-group col-auto" role="group"> \
							<button class="btn btn-outline-danger treeTaxon delete" iri="{{{treeTaxon.iri}}}" type="button"><i class="bi bi-x-lg"></i></button> \
						</div> \
						{{/treeTaxon.removable}} \
					</div> \
					{{#hasFormerTaxa}} \
					<div class="row pt-1 justify-content-end"> \
						<div class="btn-group col-auto" role="group"> \
							<button class="btn btn-outline-secondary" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTaxa" \
								aria-expanded="false" aria-controls="collapseTaxa">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).formerTreeTaxons) + '</button> \
						</div> \
					</div> \
					<div id="collapseTaxa" class="collapse pt-1"> \
						{{#formerTaxa}} \
						<div class="row"> \
							<div class="col-md-3"></div> \
							<div class="col-md-9"> \
								<div class="input-group"> \
									<input type="text" class="form-control taxon" iri="{{{value}}}" disabled readonly> \
									{{#wikidata}} \
									<button class="btn btn-outline-secondary dbpedia" type="button" turi="{{{value}}}" > \
										<i class="bi bi-info-circle-fill"></i> \
									</button> \
									{{/wikidata}} \
								</div> \
							</div> \
						</div> \
						<div class="row py-1 justify-content-between"> \
							<div class="form-text col text-end {{#removable}}px-0{{/removable}}">{{{creator}}}</div> \
							{{#removable}} \
							<div class="btn-group col-auto" role="group"> \
								<button class="col-auto btn btn-outline-danger treeTaxon delete" iri="{{{iri}}}" type="button"><i class="bi bi-x-lg"></i></button> \
							</div> \
							{{/removable}} \
						</div> \
						{{/formerTaxa}} \
					</div> \
					{{/hasFormerTaxa}} \
					{{/treeTaxon}} \
					<!-- TREE STATUS --> \
					{{#treeStatus}} \
					<div class="row pt-4"> \
						<label for="inputTreeStatus" class="col-md-3 col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treeStatus) + '</label> \
						{{#treeStatus.value}} \
						<div class="col-md-9"> \
							<div class="input-group"> \
								<input id="inputTreeStatus" type="text" class="form-control" value="{{treeStatus.value}}" disabled readonly> \
								<button id="botTreeStatusInfo" class="btn btn-outline-secondary" type="button"><i class="bi bi-info-circle-fill"></i></button> \
							</div> \
						</div> \
						{{/treeStatus.value}} \
					</div> \
					<div class="row pt-1 justify-content-between"> \
						{{#editable}} \
						<div class="btn-group col-auto" role="group"> \
							<button class="btn btn-outline-primary treeStatus create" type="button"><i class="bi bi-plus-lg"></i></button> \
						</div> \
						{{/editable}} \
						<div class="form-text col text-end {{#treeStatus.removable}}px-0{{/treeStatus.removable}}">{{{treeStatus.creator}}}</div> \
						{{#treeStatus.removable}} \
						<div class="btn-group col-auto" role="group"> \
							<button class="btn btn-outline-danger treeStatus delete" iri="{{{treeStatus.iri}}}" type="button"><i class="bi bi-x-lg"></i></button> \
						</div> \
						{{/treeStatus.removable}} \
					</div> \
					{{#hasFormerStatus}} \
					<div class="row pt-1 justify-content-end"> \
						<div class="btn-group col-auto" role="group"> \
							<button class="btn btn-outline-secondary" type="button" data-bs-toggle="collapse" data-bs-target="#collapseStatus" \
								aria-expanded="false" aria-controls="collapseStatus">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).formerTreeStatus) + '</button> \
						</div> \
					</div> \
					<div id="collapseStatus" class="collapse pt-1"> \
						{{#formerStatus}} \
						<div class="row"> \
							<div class="col-md-3"></div> \
							<div class="col-md-9"> \
								<div class="input-group"> \
									<input type="text" class="form-control" value="{{value}}" disabled readonly> \
								</div> \
							</div> \
						</div> \
						<div class="row py-1 justify-content-between"> \
							<div class="form-text col text-end {{#removable}}px-0{{/removable}}">{{{creator}}}</div> \
							{{#removable}} \
							<div class="btn-group col-auto" role="group"> \
								<button class="col-auto btn btn-outline-danger treeStatus delete" iri="{{{iri}}}" type="button"><i class="bi bi-x-lg"></i></button> \
							</div> \
							{{/removable}} \
						</div> \
						{{/formerStatus}} \
					</div> \
					{{/hasFormerStatus}} \
					{{/treeStatus}} \
					<!-- PHOTOS --> \
					{{#photoLabel}} \
					<div class="row pt-4"> \
						<label class="col-md-3 col-form-label">{{photoLabel}}</label> \
					</div> \
					{{#hasPhotos}} \
					<div id="miCarrusel" class="row carousel slide"> \
						{{^onePhoto}} \
						<div class="carousel-indicators" style="margin-left: 0;"> \
							{{#photos}} \
							<button type="button" data-bs-target="#miCarrusel" data-bs-slide-to="{{index}}" {{#first}}class="active"{{/first}}></button> \
							{{/photos}} \
					  	</div> \
						{{/onePhoto}} \
						<div class="carousel-inner"> \
							{{#photos}} \
							<div class="carousel-item {{#first}}active{{/first}}"> \
								<img src="{{{src}}}" class="d-block w-100"> \
								{{#plantPart}} \
								<div class="carousel-caption d-block"> \
									<p>{{plantPart}}</p> \
								</div> \
								{{/plantPart}} \
							</div> \
							{{/photos}} \
						</div> \
						{{^onePhoto}} \
					 	<button class="carousel-control-prev" type="button" data-bs-target="#miCarrusel" data-bs-slide="prev"> \
							<span class="carousel-control-prev-icon" aria-hidden="true"></span> \
							<span class="visually-hidden">Previous</span> \
					  	</button> \
					  	<button class="carousel-control-next" type="button" data-bs-target="#miCarrusel" data-bs-slide="next"> \
							<span class="carousel-control-next-icon" aria-hidden="true"></span> \
							<span class="visually-hidden">Next</span> \
					  	</button> \
						{{/onePhoto}} \
					</div> \
					{{/hasPhotos}} \
					{{#photos}} \
					<div class="row pt-1 justify-content-between photoCreator {{^first}}d-none{{/first}}" index="{{index}}"> \
						{{#editable}} \
						<div class="btn-group col-auto" role="group"> \
							<button class="btn btn-outline-primary photo create" type="button"><i class="bi bi-plus-lg"></i></button> \
						</div> \
						{{/editable}} \
						<div class="form-text col text-end {{#removable}}px-0{{/removable}}">{{{creator}}}</div> \
						{{#removable}} \
						<div class="btn-group col-auto" role="group"> \
							<button class="btn btn-outline-danger photo delete" iri="{{{iri}}}" type="button"><i class="bi bi-x-lg"></i></button> \
						</div> \
						{{/removable}} \
					</div> \
					{{/photos}} \
					{{^hasPhotos}} \
					{{#editable}} \
					<div class="row pt-1 justify-content-between"> \
						<div class="btn-group col-auto" role="group"> \
							<button class="btn btn-outline-primary photo create" type="button"><i class="bi bi-plus-lg"></i></button> \
						</div> \
					</div> \
					{{/editable}} \
					{{/hasPhotos}} \
					{{/photoLabel}} \
					<!-- HEIGHT --> \
					{{#height}} \
					<div class="row pt-4"> \
						<label for="inputHeight" class="col-md-3 col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).heightm) + '</label> \
						{{#height.value}} \
						<div class="col-md-9"> \
							<div class="input-group"> \
								<input id="inputHeight" type="text" class="form-control" value="{{height.value}}" disabled readonly> \
							</div> \
						</div> \
						{{/height.value}} \
					</div> \
					<div class="row pt-1 justify-content-between"> \
						{{#editable}} \
						<div class="btn-group col-auto" role="group"> \
							<button class="btn btn-outline-primary height create" type="button"><i class="bi bi-plus-lg"></i></button> \
						</div> \
						{{/editable}} \
						<div class="form-text col text-end {{#height.removable}}px-0{{/height.removable}}">{{{height.creator}}}</div> \
						{{#height.removable}} \
						<div class="btn-group col-auto" role="group"> \
							<button class="btn btn-outline-danger height delete" iri="{{{height.iri}}}" type="button"><i class="bi bi-x-lg"></i></button> \
						</div> \
						{{/height.removable}} \
					</div> \
					{{#hasFormerHeight}} \
					<div class="row pt-1 justify-content-end"> \
						<div class="btn-group col-auto" role="group"> \
							<button class="btn btn-outline-secondary" type="button" data-bs-toggle="collapse" data-bs-target="#collapseHeight" \
								aria-expanded="false" aria-controls="collapseHeight">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).formerHeights) + '</button> \
						</div> \
					</div> \
					<div id="collapseHeight" class="collapse pt-1"> \
						{{#formerHeights}} \
						<div class="row"> \
							<div class="col-md-3"></div> \
							<div class="col-md-9"> \
								<div class="input-group"> \
									<input type="text" class="form-control" value="{{value}}" disabled readonly> \
								</div> \
							</div> \
						</div> \
						<div class="row py-1 justify-content-between"> \
							<div class="form-text col text-end {{#removable}}px-0{{/removable}}">{{{creator}}}</div> \
							{{#removable}} \
							<div class="btn-group col-auto" role="group"> \
								<button class="col-auto btn btn-outline-danger height delete" iri="{{{iri}}}" type="button"><i class="bi bi-x-lg"></i></button> \
							</div> \
							{{/removable}} \
						</div> \
						{{/formerHeights}} \
					</div> \
					{{/hasFormerHeight}} \
					{{/height}} \
					<!-- DIAMETER --> \
					{{#diameter}} \
					<div class="row pt-4"> \
						<label for="inputDiameter" class="col-md-3 col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).diametermm) + '</label> \
						{{#diameter.value}} \
						<div class="col-md-9"> \
							<div class="input-group"> \
								<input id="inputDiameter" type="text" class="form-control" value="{{diameter.value}}" disabled readonly> \
							</div> \
						</div> \
						{{/diameter.value}} \
					</div> \
					<div class="row pt-1 justify-content-between"> \
						{{#editable}} \
						<div class="btn-group col-auto" role="group"> \
							<button class="btn btn-outline-primary diameter create" type="button"><i class="bi bi-plus-lg"></i></button> \
						</div> \
						{{/editable}} \
						<div class="form-text col text-end {{#diameter.removable}}px-0{{/diameter.removable}}">{{{diameter.creator}}}</div> \
						{{#diameter.removable}} \
						<div class="btn-group col-auto" role="group"> \
							<button class="btn btn-outline-danger diameter delete" iri="{{{diameter.iri}}}" type="button"><i class="bi bi-x-lg"></i></button> \
						</div> \
						{{/diameter.removable}} \
					</div> \
					{{#hasFormerDiameter}} \
					<div class="row pt-1 justify-content-end"> \
						<div class="btn-group col-auto" role="group"> \
							<button class="btn btn-outline-secondary" type="button" data-bs-toggle="collapse" data-bs-target="#collapseDiameter" \
								aria-expanded="false" aria-controls="collapseDiameter">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).formerDiameters) + '</button> \
						</div> \
					</div> \
					<div id="collapseDiameter" class="collapse pt-1"> \
						{{#formerDiameters}} \
						<div class="row"> \
							<div class="col-md-3"></div> \
							<div class="col-md-9"> \
								<div class="input-group"> \
									<input type="text" class="form-control" value="{{value}}" disabled readonly> \
								</div> \
							</div> \
						</div> \
						<div class="row py-1 justify-content-between"> \
							<div class="form-text col text-end {{#removable}}px-0{{/removable}}">{{{creator}}}</div> \
							{{#removable}} \
							<div class="btn-group col-auto" role="group"> \
								<button class="col-auto btn btn-outline-danger diameter delete" iri="{{{iri}}}" type="button"><i class="bi bi-x-lg"></i></button> \
							</div> \
							{{/removable}} \
						</div> \
						{{/formerDiameters}} \
					</div> \
					{{/hasFormerDiameter}} \
					{{/diameter}} \
					<!-- OBSERVACIONES --> \
					{{#observation}} \
					<div class="row pt-4"> \
						<label for="inputObservation" class="col-md-3 col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).observations) + '</label> \
						{{#observation.value}} \
						<div class="col-md-9"> \
							<div class="input-group"> \
								<textarea id="inputObservation" class="form-control" disabled readonly>{{{observation.value}}}</textarea> \
							</div> \
						</div> \
						{{/observation.value}} \
					</div> \
					<div class="row pt-1 justify-content-between"> \
						{{#editable}} \
						<div class="btn-group col-auto" role="group"> \
							<button class="btn btn-outline-primary observation create" type="button"><i class="bi bi-plus-lg"></i></button> \
						</div> \
						{{/editable}} \
						<div class="form-text col text-end {{#observation.removable}}px-0{{/observation.removable}}">{{{observation.creator}}}</div> \
						{{#observation.removable}} \
						<div class="btn-group col-auto" role="group"> \
							<button class="btn btn-outline-danger observation delete" iri="{{{observation.iri}}}" type="button"><i class="bi bi-x-lg"></i></button> \
						</div> \
						{{/observation.removable}} \
					</div> \
					{{#hasMoreObservations}} \
					<div class="row pt-1 justify-content-end"> \
						<div class="btn-group col-auto" role="group"> \
							<button class="btn btn-outline-secondary" type="button" data-bs-toggle="collapse" data-bs-target="#collapseObservation" \
								aria-expanded="false" aria-controls="collapseObservation">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).moreobservations) + '</button> \
						</div> \
					</div> \
					<div id="collapseObservation" class="collapse pt-1"> \
						{{#moreObservations}} \
						<div class="row"> \
							<div class="col-md-3"></div> \
							<div class="col-md-9"> \
								<div class="input-group"> \
									<textarea class="form-control" disabled readonly>{{{value}}}</textarea> \
								</div> \
							</div> \
						</div> \
						<div class="row py-1 justify-content-between"> \
							<div class="form-text col text-end {{#removable}}px-0{{/removable}}">{{{creator}}}</div> \
							{{#removable}} \
							<div class="btn-group col-auto" role="group"> \
								<button class="col-auto btn btn-outline-danger observation delete" iri="{{{iri}}}" type="button"><i class="bi bi-x-lg"></i></button> \
							</div> \
							{{/removable}} \
						</div> \
						{{/moreObservations}} \
					</div> \
					{{/hasMoreObservations}} \
					{{/observation}} \
					<!-- BACK AND DELETE BUTTONS --> \
					<div class="d-flex pt-5"> \
						<button type="button" class="btn btn-secondary goBack">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).back) + '</button> \
						{{#removable}} \
						<button id="deleteEducaTree" type="button" class="ms-auto btn btn-danger">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).deleteTree) + '</button> \
						{{/removable}} \
					</div> \
				</div> \
			</div> \
		</div> \
	</div>';
    $646ceeeec66fabd8$export$43bbd40c30a74965 = {
        position: '<div id="mapaAnn" style="height: 300px;"> \
			<div id="overlayAnn" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; pointer-events: none; z-index: 9999;"> \
				<div class="d-flex justify-content-center align-items-center overlay-backdrop" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5);"> \
					<div class="spinner-border" role="status"> \
						<span class="visually-hidden">Loading...</span> \
					</div> \
				</div> \
			</div> \
		</div> \
		<div id="mapclueAnn" class="form-text d-none">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).mapclue) + '</div> \
		<label for="inputPositionAnn" class="col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).position) + '</label> \
		<input id="inputPositionAnn" type="text" class="form-control" value="" disabled readonly> \
		<div id="statusAnnotation" class="form-text pt-2">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).sameAnnotation) + '</div>',
        treeTaxon: '<label for="inputTreeTaxonEd" class="col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treetaxon) + '</label> \
		<div class="row"> \
			<div class="input-group"> \
				<button id="setTreeTaxonEd" class="btn btn-outline-secondary" type="button">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).taxonfilter) + '</button> \
				<input id="inputTreeTaxonEd" type="text" class="form-control taxon" placeholder="" aria-describedby="handlerSetTreeTaxonEd" disabled readonly> \
				<button class="btn btn-outline-secondary d-none delete" type="button" id="deleteTreeTaxon"><i class="bi bi-x-lg"></i></button> \
				<input id="anchecknomci" type="checkbox" class="btn-check nomci" id="btn-check" autocomplete="off"> \
				<label class="btn btn-outline-secondary" for="anchecknomci"><i class="bi bi-mortarboard-fill"></i></label> \
			</div> \
			<div id="taxones_subheading_newtree" class="d-none"></div> \
			<div id="taxones_block_newtree" class="taxones_block list-group overflow-auto mt-1 d-none pe-1 pe-sm-2" style="max-height:50vh;"></div> \
		</div> \
		<div id="statusAnnotation" class="form-text pt-2">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noAnnotation) + '</div>',
        treeStatus: '<label for="selectTreeStatus" class="col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treeStatus) + '</label> \
		<select id="selectTreeStatus" class="form-select" aria-label="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treestatusselection) + '"></select> \
		<div id="statusAnnotation" class="form-text pt-2">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noAnnotation) + '</div>',
        photo: '<label for="treePhoto" class="col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).photo) + '</label> \
		<div class="input-group"> \
			<input id="treePhoto" class="form-control" type="file" accept="image/*" \
				{{#esMovil}}{{#camera}}capture="environment"{{/camera}}{{/esMovil}} > \
			<button class="btn btn-outline-secondary d-none" type="button" id="deleteTreePhoto"><i class="bi bi-x-lg"></i></button> \
			{{#esMovil}} \
				<input id="checkCamera" type="checkbox" class="btn-check camera" id="btn-check" autocomplete="off" {{#camera}}checked{{/camera}}> \
				<label class="btn btn-outline-secondary" for="checkCamera"><i class="bi bi-camera-fill"></i></label> \
			{{/esMovil}} \
		</div> \
		<select id="selectTreePartPhoto" class="d-none form-select mt-1" \
				aria-label="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).partplanselection) + '"></select> \
		<input type="hidden" id="resizedTreePhoto"> \
		<div class="form-text"><span id="textTreePhoto">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).nophoto) + '</span><img id="treeThumbnail" class="d-none ms-3 mt-1" src="" width="80px"></div>',
        height: '<label for="treeHeight" class="col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).heightm) + '</label> \
		<input id="treeHeight" type="number" class="form-control" step="any" min="0" max="150" placeholder="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).enterheightm) + '"> \
		<div id="statusAnnotation" class="form-text pt-2">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noAnnotation) + '</div>',
        diameter: '<label id="labelTreeDiameter" for="treeDiameter" class="col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).diametermm) + '</label> \
		<div class="input-group"> \
			<input id="treeDiameter" type="number" class="form-control" step="1" min="0" max="20000" placeholder="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).enterdiametermm) + '"> \
			<input id="checkPerimeter" type="checkbox" class="btn-check perimeter" id="btn-check" autocomplete="off"> \
			<label class="btn btn-outline-secondary" for="checkPerimeter"><i class="bi bi-circle"></i></label> \
		</div> \
		<div id="statusAnnotation" class="form-text pt-2">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noAnnotation) + '</div>',
        observation: '<label for="observation" class="col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treeobservation) + '</label> \
		<textarea class="form-control" id="observation" autocomplete="off" placeholder="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).yourobservation) + '" minlength="5" maxlength="500"></textarea> \
		<div id="statusAnnotation" class="form-text pt-2">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noAnnotation) + '</div>',
        importTaxon: '<label for="importTaxon" class="col-form-label"></label> \
		<div class="row"> \
			<div class="input-group"> \
				<input id="in_importTaxon" autocomplete="off" type="search" class="form-control" \
					 placeholder="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).searchtaxon) + '" aria-label="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).searchtaxon) + '" wdiri="" > \
				<button id="clearImportTaxon" class="btn btn-outline-secondary d-none" type="button"><i class="bi bi-x-lg"></i></button> \
			</div> \
			<div id="sugetaxonesWD" class="list-group mt-2 mx-2 d-none"></div> \
		</div> \
		<div id="infoTaxonImportar" class="row d-none mt-2"></div> \
		<div class="d-flex align-items-center mt-2"> \
			<div id="spinnerImport" class="spinner-border me-2 d-none" role="status"></div> \
			<div id="statusImportTaxon" class="form-text">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).typesomething) + '</div> \
		</div>'
    };
    $646ceeeec66fabd8$export$3fc5053bf2a10407 = {
        creacionExito: '<button type="button" class="btn btn-secondary goBack" \
			data-bs-dismiss="modal">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).back) + '</button> \
		<button type="button" class="btn btn-primary cargarURL" \
			data-bs-dismiss="modal">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).viewtree) + '</button>',
        creacionError: '<button type="button" class="btn btn-secondary goBack" \
			data-bs-dismiss="modal">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).back) + '</button>',
        confirmarBorradoArbol: '<button type="button" class="btn btn-secondary" \
			data-bs-dismiss="modal" aria-label="Close">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).cancel) + '</button> \
		<button id="procesarBorradoArbol" type="button" class="btn btn-danger">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).delete) + '</button>',
        borradoArbolExito: '<button type="button" class="btn btn-secondary goBack" \
			data-bs-dismiss="modal">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).back) + '</button>',
        borradoArbolError: '<button type="button" class="btn btn-secondary goBack" \
			data-bs-dismiss="modal">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).back) + '</button> \
		<button type="button" class="btn btn-danger" \
			data-bs-dismiss="modal" aria-label="Close">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).close) + '</button>',
        crearAnotacion: '<button type="button" class="btn btn-secondary" \
			data-bs-dismiss="modal" aria-label="Close">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).cancel) + '</button> \
		<button id="botcreatemodalannotation" type="button" class="btn btn-primary" \
			disabled>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).createAnnotation) + '</button>',
        anotacionExito: '<button id="botAnotacionExito" type="button" class="btn btn-secondary" \
			data-bs-dismiss="modal">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).close) + '</button>',
        anotacionError: '<button type="button" class="btn btn-secondary" \
			data-bs-dismiss="modal">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).close) + '</button>',
        confirmarBorradoAnotacion: '<button type="button" class="btn btn-secondary" \
			data-bs-dismiss="modal" aria-label="Close">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).cancel) + '</button> \
		<button id="botonBorradoAnotacion" type="button" class="btn btn-danger">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).delete) + '</button>',
        cambiarNick: '<button type="button" class="btn btn-secondary" \
			data-bs-dismiss="modal" aria-label="Close">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).cancel) + '</button> \
		<button id="botonCambioNick" type="button" class="btn btn-primary" disabled>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).change) + '</button>',
        nickCambiado: '<button type="button" class="btn btn-secondary" \
			data-bs-dismiss="modal">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).close) + '</button>',
        treeNickCambiado: '<button type="button" class="btn btn-secondary" \
			data-bs-dismiss="modal">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).close) + '</button>',
        descargaDatos: '<button id="downloadClose" type="button" class="btn btn-secondary" \
			data-bs-dismiss="modal" aria-label="Close">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).cancel) + '</button> \
		<button id="downloadData" type="button" class="btn btn-primary" disabled>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).download) + '</button>',
        importarTaxon: '<button type="button" class="btn btn-secondary" \
			data-bs-dismiss="modal" aria-label="Close">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).cancel) + '</button> \
		<button id="botimporttaxonwikidata" type="button" class="btn btn-primary" \
			disabled>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).importtaxon) + '</button>'
    };
    $646ceeeec66fabd8$export$ce041e830841d411 = '<div> \
		<p>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).downloadMessage) + '</p> \
		<span>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).downloadChoices) + '</span> \
		<div class="form-check"> \
			<input class="form-check-input check-download trees" type="checkbox" value="" id="checkTrees"> \
			<label class="form-check-label" for="checkTrees">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).checkTrees) + '</label> \
		</div> \
		<div class="form-check"> \
			<input class="form-check-input check-download annotations" type="checkbox" value="" id="checkAnnotations"> \
			<label class="form-check-label" for="checkAnnotations">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).checkAnnotations) + '</label> \
		</div> \
		<div id="downloadClusterNote"><small><i>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).downloadClusterNote) + '</i></small></div> \
		<div id="downloadNothing"><strong>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).downloadNothing) + '</strong></div> \
		<br><div>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).downloadFormatChoose) + '</div> \
		<input type="radio" class="btn-check downloadRadio" name="format" id="GeoJSON" autocomplete="off"> \
		<label class="btn btn-outline-primary" for="GeoJSON">GeoJSON</label> \
		<input type="radio" class="btn-check downloadRadio" name="format" id="CSV" autocomplete="off"> \
		<label class="btn btn-outline-primary" for="CSV">CSV</label> \
		<input type="radio" class="btn-check downloadRadio" name="format" id="KML" autocomplete="off"> \
		<label class="btn btn-outline-primary" for="KML">KML</label> \
		<div id="downloadNoFormat"><strong>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).downloadNoFormat) + '</strong></div> \
	</div>';
    $646ceeeec66fabd8$export$9fac9ed2fe46e816 = '<div> \
		<div id="downloadingTrees" class="d-none"><i class="bi bi-arrow-right-circle"></i> \
			<span class="ms-1">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).downloadingTrees) + '</span> \
		</div> \
		<div id="treesDownloaded" class="d-none"><i class="bi bi-check-lg"></i> \
			<span class="ms-1">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treesDownloaded) + '</span> \
		</div> \
		<div id="noTreesDownloaded" class="d-none"><i class="bi bi-info-circle"></i> \
			<span class="ms-1">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noTreesDownloaded) + '</span> \
		</div> \
		<div id="downloadingAnnotations" class="d-none"><i class="bi bi-arrow-right-circle"></i> \
			<span class="ms-1">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).downloadingAnnotations) + '</span> \
		</div> \
		<div id="annotationsDownloaded" class="d-none"><i class="bi bi-check-lg"></i> \
			<span class="ms-1">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).annotationsDownloaded) + '</span> \
		</div> \
		<div id="noAnnotationsDownloaded" class="d-none"><i class="bi bi-info-circle"></i> \
			<span class="ms-1">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noAnnotationsDownloaded) + '</span> \
		</div> \
		<div id="mibarradescarga_div" class="progress my-1" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"> \
			<div id="mibarradescarga" class="progress-bar progress-bar-striped progress-bar-animated bg-primary" style="width: 0%" >0%</div> \
		</div> \
		<div id="imgDownload" class="d-none mt-1"><img src="./downloadData.png" class="d-block w-100"></div> \
	</div>';
    $646ceeeec66fabd8$export$ab832a4d4ceb9113 = '<img id="imgTreeDeletion" src="./treeDeletion.png" class="d-block w-100">';
    $646ceeeec66fabd8$export$eaebbbf45ac961b6 = '<button class="btn btn-outline-secondary d-block d-sm-none usersignin" type="button"><i class="bi bi-box-arrow-in-right"></i></button> \
	<button class="btn btn-light d-none d-sm-block usersignin" type="button"><i class="bi bi-box-arrow-in-right"></i></button>';
    $646ceeeec66fabd8$export$af3959eda01cc433 = '<input id="newNick" type="text" class="form-control" minlength="3" maxlength="20" placeholder="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).newNickTip) + '"> \
	<div id="statusNick" class="form-text pt-2">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noNick) + '</div> \
	<img id="imgNewNick" src="./newNick.png" class="d-none d-block w-100">';
    $646ceeeec66fabd8$export$62b82cd57460378a = '<input id="newTreeNick" type="text" class="form-control" minlength="3" maxlength="30" \
			placeholder="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).newTreeNickTip) + '"> \
	<div id="statusNick" class="form-text pt-2">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noNick) + '</div> \
	<img id="imgNewTreeNick" src="./newNick.png" class="d-none d-block w-100">';
    $646ceeeec66fabd8$export$a76d078e0f25e96f = $646ceeeec66fabd8$export$d15beb852fc82fa2 + '<div class="container pb-4"> \
		<div class="row"> \
			<div class="col-md-6 mt-4 mx-auto"> \
				<!-- TARJETA USUARIO --> \
				<div class="card text-center"> \
					<div class="card-header d-flex justify-content-center"> \
						<img class="card-img-top avatar avatar-128 bg-light rounded-circle text-white {{^img}}p-1 p-sm-2{{/img}}" \
							src="{{#img}}{{{.}}}{{/img}}{{^img}}https://raw.githubusercontent.com/twbs/icons/main/icons/person.svg{{/img}}" \
							referrerpolicy="no-referrer"> \
					</div> \
					<div class="card-body"> \
						<h5 class="card-title">{{{name}}}</h5> \
						{{#activeLabel}}<p class="card-text">{{.}}</p>{{/activeLabel}} \
						{{#master}}<p class="card-text">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).isMaster) + '</p>{{/master}} \
						{{#cannotAnnotate}}<p class="card-text">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).cannotAnnotate) + '</p>{{/cannotAnnotate}} 						{{#edutreesLabel}}<p class="card-text">{{.}}</p>{{/edutreesLabel}} 						{{#annotationsLabel}}<p class="card-text">{{.}}</p>{{/annotationsLabel}} 						{{#nickButtonLabel}}<button id="changeNick" type="button" class="btn btn-primary mt-1">{{.}}</button>{{/nickButtonLabel}} 					</div> 				</div> 				<!-- BOT\xd3N ATR\xc1S DISPS GRANDES --> 				<div class="d-none d-md-block col my-4 mx-auto"> 					<div class="d-flex ms-0"> 						<button type="button" class="ms-0 btn btn-secondary goback">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).back) + '</button> 					</div> 				</div> 			</div> 			<!-- ACORDE\xd3N --> 			<div class="col-md-6 my-4 mx-auto"> 				<div class="accordion" id="accordionTrees"> 					<div class="accordion-item"> 						<h2 class="accordion-header"> 							<button class="accordion-button {{#showann}}collapsed{{/showann}}" type="button" data-bs-toggle="collapse" data-bs-target="#collapseCreated" 								aria-expanded="{{^showann}}true{{/showann}}{{#showann}}false{{/showann}}" aria-controls="collapseCreated">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).lastCreatedTrees) + '</button> \
						</h2> \
						<div id="collapseCreated" class="accordion-collapse collapse {{^showann}}show{{/showann}}" data-bs-parent="#accordionTrees"> \
							<div class="accordion-body {{#hayUltedutrees}}pt-0{{/hayUltedutrees}} {{^hayUltedutrees}}pb-0{{/hayUltedutrees}}"> \
								{{^hayUltedutrees}}<p>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noCreatedTrees) + '</p>{{/hayUltedutrees}} \
								{{#hayUltedutrees}} \
								<div class="d-flex align-items-center justify-content-between my-2"> \
									<h6 class="text-muted mt-2">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).page) + ' #{{pagUltedutrees}}</h6> \
									<span class="btn-group" role="group"> \
										<button class="btn btn-outline-secondary pagina prev created" type="button" {{^hayUltedutreesPrev}}disabled{{/hayUltedutreesPrev}}><i class="bi bi-chevron-left"></i></button> \
										<button class="btn btn-outline-secondary pagina sig created" type="button" {{^hayUltedutreesSig}}disabled{{/hayUltedutreesSig}}><i class="bi bi-chevron-right"></i></button> \
									</span> \
								</div> \
								<ul class="list-group"> \
									{{#ultedutrees}} \
									<li class="list-group-item">{{{.}}}</li> \
									{{/ultedutrees}} \
								</ul> \
								{{/hayUltedutrees}} \
							</div> \
						</div> \
					</div> \
					<div class="accordion-item"> \
						<h2 class="accordion-header"> \
							<button class="accordion-button {{^showann}}collapsed{{/showann}}" type="button" data-bs-toggle="collapse" \
								data-bs-target="#collapseAnnotated" aria-expanded="{{^showann}}false{{/showann}}{{#showann}}true{{/showann}}" aria-controls="collapseAnnotated"> \
								' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).lastAnnotations) + '</button> \
						</h2> \
						<div id="collapseAnnotated" class="accordion-collapse collapse {{#showann}}show{{/showann}}" data-bs-parent="#accordionTrees"> \
							<div class="accordion-body {{#hayUltanns}}pt-0{{/hayUltanns}} {{^hayUltanns}}pb-0{{/hayUltanns}}"> \
								{{^hayUltanns}}<p>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noAnnotations) + '</p>{{/hayUltanns}} \
								{{#hayUltanns}} \
								<div class="d-flex align-items-center justify-content-between my-2"> \
									<h6 class="text-muted mt-2">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).page) + ' #{{pagUltanns}}</h6> \
									<span class="btn-group" role="group"> \
										<button class="btn btn-outline-secondary pagina prev annotated" type="button" {{^hayUltannsPrev}}disabled{{/hayUltannsPrev}}><i class="bi bi-chevron-left"></i></button> \
										<button class="btn btn-outline-secondary pagina sig annotated" type="button" {{^hayUltannsSig}}disabled{{/hayUltannsSig}}><i class="bi bi-chevron-right"></i></button> \
									</span> \
								</div> \
								<ul class="list-group"> \
									{{#ultanns}} \
									<li class="list-group-item">{{{.}}}</li> \
									{{/ultanns}} \
								</ul> \
								{{/hayUltanns}} \
							</div> \
						</div> \
					</div> \
				</div>	 \
			</div> \
		</div> \
		<!-- BACK BUTTON (SMALL) --> \
		<div class="d-block d-md-none row"> \
			<div class="col mb-4 mx-auto"> \
				<div class="d-flex ms-0"> \
					<button type="button" class="ms-0 btn btn-secondary goback">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).back) + '</button> \
				</div> \
			</div> \
		</div> \
	</div>';
    $646ceeeec66fabd8$export$96346f251ef3b3fb = $646ceeeec66fabd8$export$d15beb852fc82fa2 + '<div class="container pb-4"> 		<!-- ACORDE\xd3N --> 		<div class="col-md-8 my-4 mx-auto"> 			<div class="accordion" id="accordionTrees"> 				<div class="accordion-item"> 					<h2 class="accordion-header"> 						<button class="accordion-button {{#showann}}collapsed{{/showann}}" type="button" data-bs-toggle="collapse" data-bs-target="#collapseCreated" 							aria-expanded="{{^showann}}true{{/showann}}{{#showann}}false{{/showann}}" aria-controls="collapseCreated">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).lastCreatedTrees) + '</button> \
					</h2> \
					<div id="collapseCreated" class="accordion-collapse collapse {{^showann}}show{{/showann}}" data-bs-parent="#accordionTrees"> \
						<div class="accordion-body {{#hayUltedutrees}}pt-0 px-2 px-md-4{{/hayUltedutrees}} pb-0"> \
							{{^hayUltedutrees}}<p>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noCreatedTrees) + '</p>{{/hayUltedutrees}} \
							{{#hayUltedutrees}} \
							<div class="d-flex align-items-center justify-content-between my-2"> \
								<h6 class="text-muted mt-2">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).page) + ' #{{pagUltedutrees}}</h6> \
								<span class="btn-group" role="group"> \
									<button class="btn btn-outline-secondary pagina prev created" type="button" {{^hayUltedutreesPrev}}disabled{{/hayUltedutreesPrev}}><i class="bi bi-chevron-left"></i></button> \
									<button class="btn btn-outline-secondary pagina sig created" type="button" {{^hayUltedutreesSig}}disabled{{/hayUltedutreesSig}}><i class="bi bi-chevron-right"></i></button> \
								</span> \
							</div> \
							<div> \
								<table class="table table-striped"> \
									<thead> \
										<tr> \
											<th scope="col">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tree) + '</th> \
											<th scope="col">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).created) + '</th> \
											<th scope="col">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).creator) + '</th> \
										</tr> \
									</thead> \
									<tbody class="table-group-divider"> \
										{{#ultedutrees}} \
										<tr> \
											<td><a href="{{{treeHref}}}" etid="{{{etid}}}" class="educatree">{{treeLabel}}</a></td> \
											<td>{{created}}</td> \
											<td><a href="{{{userHref}}}" uid="{{{uid}}}" class="pagusuario">{{userLabel}}</a> \</td> \
										</tr> \
										{{/ultedutrees}} \
									</tbody> \
								</table> \
							</div> \
							{{/hayUltedutrees}} \
						</div> \
					</div> \
				</div> \
				<div class="accordion-item"> \
					<h2 class="accordion-header"> \
						<button class="accordion-button {{^showann}}collapsed{{/showann}}" type="button" data-bs-toggle="collapse" \
							data-bs-target="#collapseAnnotated" aria-expanded="{{^showann}}false{{/showann}}{{#showann}}true{{/showann}}" aria-controls="collapseAnnotated"> \
							' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).lastAnnotations) + '</button> \
					</h2> \
					<div id="collapseAnnotated" class="accordion-collapse collapse {{#showann}}show{{/showann}}" data-bs-parent="#accordionTrees"> \
						<div class="accordion-body {{#hayUltanns}}pt-0 px-2 px-md-4{{/hayUltanns}} pb-0"> \
							{{^hayUltanns}}<p>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noAnnotations) + '</p>{{/hayUltanns}} \
							{{#hayUltanns}} \
							<div class="d-flex align-items-center justify-content-between my-2"> \
								<h6 class="text-muted mt-2">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).page) + ' #{{pagUltanns}}</h6> \
								<span class="btn-group" role="group"> \
									<button class="btn btn-outline-secondary pagina prev annotated" type="button" {{^hayUltannsPrev}}disabled{{/hayUltannsPrev}}><i class="bi bi-chevron-left"></i></button> \
									<button class="btn btn-outline-secondary pagina sig annotated" type="button" {{^hayUltannsSig}}disabled{{/hayUltannsSig}}><i class="bi bi-chevron-right"></i></button> \
								</span> \
							</div> \
							<div> \
								<table class="table table-striped"> \
									<thead> \
										<tr> \
											<th scope="col">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tree) + '</th> \
											<th scope="col">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).annotationType) + '</th> \
											<th scope="col">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).annotator) + '</th> \
										</tr> \
									</thead> \
									<tbody class="table-group-divider"> \
										{{#ultanns}} \
										<tr> \
											<td><a href="{{{treeHref}}}" etid="{{{etid}}}" class="educatree">{{treeLabel}}</a></td> \
											<td>{{annotationType}}</td> \
											<td><a href="{{{userHref}}}" uid="{{{uid}}}" class="pagusuario">{{userLabel}}</a>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).onDate) + '{{annotated}}</td> \
										</tr> \
										{{/ultanns}} \
									</tbody> \
								</table> \
							</div> \
							{{/hayUltanns}} \
						</div> \
					</div> \
				</div> \
			</div>	 \
		</div> \
		<!-- BACK BUTTON --> \
		<div class="col-sm-8 my-4 mx-auto"> \
			<div class="d-flex ms-0"> \
				<button id="goBackButton" type="button" class="ms-0 btn btn-secondary">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).back) + '</button> \
			</div> \
		</div> \
	</div>';
    $646ceeeec66fabd8$export$c75e99c9076bb133 = '<div id="questalert" class="alert alert-light ms-2 ms-md-2 mb-4 p-2 alert-dismissible fade show" role="alert"> \
		<p class="mb-1">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).questtext) + '</p> \
		<button id="questbotyes" type="button" questurl="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).questurl) + '" class="btn btn-outline-secondary btn-sm">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).yes) + '</button>\
		<button id="questbotno" type="button" class="btn btn-outline-secondary btn-sm">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).no) + '</button>\
		<button id="questbotlater" type="button" class="btn btn-outline-secondary btn-sm">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).later) + '</button>\
	</div>';
}











var $8JYDX = parcelRequire("8JYDX");
var $73221a8bfd8f0132$exports = {};

/*!
Copyright (c) 2016 Dominik Moritz

This file is part of the leaflet locate control. It is licensed under the MIT license.
You can find the project at: https://github.com/domoritz/leaflet-locatecontrol
*/ (function(factory, window1) {
    // see https://github.com/Leaflet/Leaflet/blob/master/PLUGIN-GUIDE.md#module-loaders
    // for details on how to structure a leaflet plugin.
    // define an AMD module that relies on 'leaflet'
    if (typeof define === "function" && define.amd) define([
        "leaflet"
    ], factory);
    else if (true) {
        if (typeof window1 !== "undefined" && window1.L) $73221a8bfd8f0132$exports = factory(L);
        else $73221a8bfd8f0132$exports = factory((parcelRequire("8JYDX")));
    }
    // attach your plugin to the global 'L' variable
    if (typeof window1 !== "undefined" && window1.L) window1.L.Control.Locate = factory(L);
})(function(L1) {
    const LDomUtilApplyClassesMethod = (method, element, classNames)=>{
        classNames = classNames.split(" ");
        classNames.forEach(function(className) {
            L1.DomUtil[method].call(this, element, className);
        });
    };
    const addClasses = (el, names)=>LDomUtilApplyClassesMethod("addClass", el, names);
    const removeClasses = (el, names)=>LDomUtilApplyClassesMethod("removeClass", el, names);
    /**
   * Compatible with L.Circle but a true marker instead of a path
   */ const LocationMarker = L1.Marker.extend({
        initialize (latlng, options) {
            L1.Util.setOptions(this, options);
            this._latlng = latlng;
            this.createIcon();
        },
        /**
     * Create a styled circle location marker
     */ createIcon () {
            const opt = this.options;
            let style = "";
            if (opt.color !== undefined) style += `stroke:${opt.color};`;
            if (opt.weight !== undefined) style += `stroke-width:${opt.weight};`;
            if (opt.fillColor !== undefined) style += `fill:${opt.fillColor};`;
            if (opt.fillOpacity !== undefined) style += `fill-opacity:${opt.fillOpacity};`;
            if (opt.opacity !== undefined) style += `opacity:${opt.opacity};`;
            const icon = this._getIconSVG(opt, style);
            this._locationIcon = L1.divIcon({
                className: icon.className,
                html: icon.svg,
                iconSize: [
                    icon.w,
                    icon.h
                ]
            });
            this.setIcon(this._locationIcon);
        },
        /**
     * Return the raw svg for the shape
     *
     * Split so can be easily overridden
     */ _getIconSVG (options, style) {
            const r = options.radius;
            const w = options.weight;
            const s = r + w;
            const s2 = s * 2;
            const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${s2}" height="${s2}" version="1.1" viewBox="-${s} -${s} ${s2} ${s2}">` + '<circle r="' + r + '" style="' + style + '" />' + "</svg>";
            return {
                className: "leaflet-control-locate-location",
                svg: svg,
                w: s2,
                h: s2
            };
        },
        setStyle (style) {
            L1.Util.setOptions(this, style);
            this.createIcon();
        }
    });
    const CompassMarker = LocationMarker.extend({
        initialize (latlng, heading, options) {
            L1.Util.setOptions(this, options);
            this._latlng = latlng;
            this._heading = heading;
            this.createIcon();
        },
        setHeading (heading) {
            this._heading = heading;
        },
        /**
     * Create a styled arrow compass marker
     */ _getIconSVG (options, style) {
            const r = options.radius;
            const w = options.width + options.weight;
            const h = (r + options.depth + options.weight) * 2;
            const path = `M0,0 l${options.width / 2},${options.depth} l-${w},0 z`;
            const svgstyle = `transform: rotate(${this._heading}deg)`;
            const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="${h}" version="1.1" viewBox="-${w / 2} 0 ${w} ${h}" style="${svgstyle}">` + '<path d="' + path + '" style="' + style + '" />' + "</svg>";
            return {
                className: "leaflet-control-locate-heading",
                svg: svg,
                w: w,
                h: h
            };
        }
    });
    const LocateControl = L1.Control.extend({
        options: {
            /** Position of the control */ position: "topleft",
            /** The layer that the user's location should be drawn on. By default creates a new layer. */ layer: undefined,
            /**
       * Automatically sets the map view (zoom and pan) to the user's location as it updates.
       * While the map is following the user's location, the control is in the `following` state,
       * which changes the style of the control and the circle marker.
       *
       * Possible values:
       *  - false: never updates the map view when location changes.
       *  - 'once': set the view when the location is first determined
       *  - 'always': always updates the map view when location changes.
       *              The map view follows the user's location.
       *  - 'untilPan': like 'always', except stops updating the
       *                view if the user has manually panned the map.
       *                The map view follows the user's location until she pans.
       *  - 'untilPanOrZoom': (default) like 'always', except stops updating the
       *                view if the user has manually panned the map.
       *                The map view follows the user's location until she pans.
       */ setView: "untilPanOrZoom",
            /** Keep the current map zoom level when setting the view and only pan. */ keepCurrentZoomLevel: false,
            /** After activating the plugin by clicking on the icon, zoom to the selected zoom level, even when keepCurrentZoomLevel is true. Set to 'false' to disable this feature. */ initialZoomLevel: false,
            /**
       * This callback can be used to override the viewport tracking
       * This function should return a LatLngBounds object.
       *
       * For example to extend the viewport to ensure that a particular LatLng is visible:
       *
       * getLocationBounds: function(locationEvent) {
       *    return locationEvent.bounds.extend([-33.873085, 151.219273]);
       * },
       */ getLocationBounds (locationEvent) {
                return locationEvent.bounds;
            },
            /** Smooth pan and zoom to the location of the marker. Only works in Leaflet 1.0+. */ flyTo: false,
            /**
       * The user location can be inside and outside the current view when the user clicks on the
       * control that is already active. Both cases can be configures separately.
       * Possible values are:
       *  - 'setView': zoom and pan to the current location
       *  - 'stop': stop locating and remove the location marker
       */ clickBehavior: {
                /** What should happen if the user clicks on the control while the location is within the current view. */ inView: "stop",
                /** What should happen if the user clicks on the control while the location is outside the current view. */ outOfView: "setView",
                /**
         * What should happen if the user clicks on the control while the location is within the current view
         * and we could be following but are not. Defaults to a special value which inherits from 'inView';
         */ inViewNotFollowing: "inView"
            },
            /**
       * If set, save the map bounds just before centering to the user's
       * location. When control is disabled, set the view back to the
       * bounds that were saved.
       */ returnToPrevBounds: false,
            /**
       * Keep a cache of the location after the user deactivates the control. If set to false, the user has to wait
       * until the locate API returns a new location before they see where they are again.
       */ cacheLocation: true,
            /** If set, a circle that shows the location accuracy is drawn. */ drawCircle: true,
            /** If set, the marker at the users' location is drawn. */ drawMarker: true,
            /** If set and supported then show the compass heading */ showCompass: true,
            /** The class to be used to create the marker. For example L.CircleMarker or L.Marker */ markerClass: LocationMarker,
            /** The class us be used to create the compass bearing arrow */ compassClass: CompassMarker,
            /** Accuracy circle style properties. NOTE these styles should match the css animations styles */ circleStyle: {
                className: "leaflet-control-locate-circle",
                color: "#136AEC",
                fillColor: "#136AEC",
                fillOpacity: 0.15,
                weight: 0
            },
            /** Inner marker style properties. Only works if your marker class supports `setStyle`. */ markerStyle: {
                className: "leaflet-control-locate-marker",
                color: "#fff",
                fillColor: "#2A93EE",
                fillOpacity: 1,
                weight: 3,
                opacity: 1,
                radius: 9
            },
            /** Compass */ compassStyle: {
                fillColor: "#2A93EE",
                fillOpacity: 1,
                weight: 0,
                color: "#fff",
                opacity: 1,
                radius: 9,
                width: 9,
                depth: 6 // Length of the arrow
            },
            /**
       * Changes to accuracy circle and inner marker while following.
       * It is only necessary to provide the properties that should change.
       */ followCircleStyle: {},
            followMarkerStyle: {
            },
            followCompassStyle: {},
            /** The CSS class for the icon. For example fa-location-arrow or fa-map-marker */ icon: "leaflet-control-locate-location-arrow",
            iconLoading: "leaflet-control-locate-spinner",
            /** The element to be created for icons. For example span or i */ iconElementTag: "span",
            /** The element to be created for the text. For example small or span */ textElementTag: "small",
            /** Padding around the accuracy circle. */ circlePadding: [
                0,
                0
            ],
            /** Use metric units. */ metric: true,
            /**
       * This callback can be used in case you would like to override button creation behavior.
       * This is useful for DOM manipulation frameworks such as angular etc.
       * This function should return an object with HtmlElement for the button (link property) and the icon (icon property).
       */ createButtonCallback (container, options) {
                const link = L1.DomUtil.create("a", "leaflet-bar-part leaflet-bar-part-single", container);
                link.title = options.strings.title;
                link.href = "#";
                link.setAttribute("role", "button");
                const icon = L1.DomUtil.create(options.iconElementTag, options.icon, link);
                if (options.strings.text !== undefined) {
                    const text = L1.DomUtil.create(options.textElementTag, "leaflet-locate-text", link);
                    text.textContent = options.strings.text;
                    link.classList.add("leaflet-locate-text-active");
                    link.parentNode.style.display = "flex";
                    if (options.icon.length > 0) icon.classList.add("leaflet-locate-icon");
                }
                return {
                    link: link,
                    icon: icon
                };
            },
            /** This event is called in case of any location error that is not a time out error. */ onLocationError (err, control) {
                alert(err.message);
            },
            /**
       * This event is called when the user's location is outside the bounds set on the map.
       * The event is called repeatedly when the location changes.
       */ onLocationOutsideMapBounds (control) {
                control.stop();
                alert(control.options.strings.outsideMapBoundsMsg);
            },
            /** Display a pop-up when the user click on the inner marker. */ showPopup: true,
            strings: {
                title: "Show me where I am",
                metersUnit: "meters",
                feetUnit: "feet",
                popup: "You are within {distance} {unit} from this point",
                outsideMapBoundsMsg: "You seem located outside the boundaries of the map"
            },
            /** The default options passed to leaflets locate method. */ locateOptions: {
                maxZoom: Infinity,
                watch: true,
                setView: false // have to set this to false because we have to
            }
        },
        initialize (options) {
            // set default options if nothing is set (merge one step deep)
            for(const i in options)if (typeof this.options[i] === "object") L1.extend(this.options[i], options[i]);
            else this.options[i] = options[i];
            // extend the follow marker style and circle from the normal style
            this.options.followMarkerStyle = L1.extend({}, this.options.markerStyle, this.options.followMarkerStyle);
            this.options.followCircleStyle = L1.extend({}, this.options.circleStyle, this.options.followCircleStyle);
            this.options.followCompassStyle = L1.extend({}, this.options.compassStyle, this.options.followCompassStyle);
        },
        /**
     * Add control to map. Returns the container for the control.
     */ onAdd (map) {
            const container = L1.DomUtil.create("div", "leaflet-control-locate leaflet-bar leaflet-control");
            this._container = container;
            this._map = map;
            this._layer = this.options.layer || new L1.LayerGroup();
            this._layer.addTo(map);
            this._event = undefined;
            this._compassHeading = null;
            this._prevBounds = null;
            const linkAndIcon = this.options.createButtonCallback(container, this.options);
            this._link = linkAndIcon.link;
            this._icon = linkAndIcon.icon;
            L1.DomEvent.on(this._link, "click", function(ev) {
                L1.DomEvent.stopPropagation(ev);
                L1.DomEvent.preventDefault(ev);
                this._onClick();
            }, this).on(this._link, "dblclick", L1.DomEvent.stopPropagation);
            this._resetVariables();
            this._map.on("unload", this._unload, this);
            return container;
        },
        /**
     * This method is called when the user clicks on the control.
     */ _onClick () {
            this._justClicked = true;
            const wasFollowing = this._isFollowing();
            this._userPanned = false;
            this._userZoomed = false;
            if (this._active && !this._event) // click while requesting
            this.stop();
            else if (this._active) {
                const behaviors = this.options.clickBehavior;
                let behavior = behaviors.outOfView;
                if (this._map.getBounds().contains(this._event.latlng)) behavior = wasFollowing ? behaviors.inView : behaviors.inViewNotFollowing;
                // Allow inheriting from another behavior
                if (behaviors[behavior]) behavior = behaviors[behavior];
                switch(behavior){
                    case "setView":
                        this.setView();
                        break;
                    case "stop":
                        this.stop();
                        if (this.options.returnToPrevBounds) {
                            const f = this.options.flyTo ? this._map.flyToBounds : this._map.fitBounds;
                            f.bind(this._map)(this._prevBounds);
                        }
                        break;
                }
            } else {
                if (this.options.returnToPrevBounds) this._prevBounds = this._map.getBounds();
                this.start();
            }
            this._updateContainerStyle();
        },
        /**
     * Starts the plugin:
     * - activates the engine
     * - draws the marker (if coordinates available)
     */ start () {
            this._activate();
            if (this._event) {
                this._drawMarker(this._map);
                // if we already have a location but the user clicked on the control
                if (this.options.setView) this.setView();
            }
            this._updateContainerStyle();
        },
        /**
     * Stops the plugin:
     * - deactivates the engine
     * - reinitializes the button
     * - removes the marker
     */ stop () {
            this._deactivate();
            this._cleanClasses();
            this._resetVariables();
            this._removeMarker();
        },
        /**
     * Keep the control active but stop following the location
     */ stopFollowing () {
            this._userPanned = true;
            this._updateContainerStyle();
            this._drawMarker();
        },
        /**
     * This method launches the location engine.
     * It is called before the marker is updated,
     * event if it does not mean that the event will be ready.
     *
     * Override it if you want to add more functionalities.
     * It should set the this._active to true and do nothing if
     * this._active is true.
     */ _activate () {
            if (this._active || !this._map) return;
            this._map.locate(this.options.locateOptions);
            this._map.fire("locateactivate", this);
            this._active = true;
            // bind event listeners
            this._map.on("locationfound", this._onLocationFound, this);
            this._map.on("locationerror", this._onLocationError, this);
            this._map.on("dragstart", this._onDrag, this);
            this._map.on("zoomstart", this._onZoom, this);
            this._map.on("zoomend", this._onZoomEnd, this);
            if (this.options.showCompass) {
                const oriAbs = "ondeviceorientationabsolute" in window;
                if (oriAbs || "ondeviceorientation" in window) {
                    const _this = this;
                    const deviceorientation = function() {
                        L1.DomEvent.on(window, oriAbs ? "deviceorientationabsolute" : "deviceorientation", _this._onDeviceOrientation, _this);
                    };
                    if (DeviceOrientationEvent && typeof DeviceOrientationEvent.requestPermission === "function") DeviceOrientationEvent.requestPermission().then(function(permissionState) {
                        if (permissionState === "granted") deviceorientation();
                    });
                    else deviceorientation();
                }
            }
        },
        /**
     * Called to stop the location engine.
     *
     * Override it to shutdown any functionalities you added on start.
     */ _deactivate () {
            if (!this._active || !this._map) return;
            this._map.stopLocate();
            this._map.fire("locatedeactivate", this);
            this._active = false;
            if (!this.options.cacheLocation) this._event = undefined;
            // unbind event listeners
            this._map.off("locationfound", this._onLocationFound, this);
            this._map.off("locationerror", this._onLocationError, this);
            this._map.off("dragstart", this._onDrag, this);
            this._map.off("zoomstart", this._onZoom, this);
            this._map.off("zoomend", this._onZoomEnd, this);
            if (this.options.showCompass) {
                this._compassHeading = null;
                if ("ondeviceorientationabsolute" in window) L1.DomEvent.off(window, "deviceorientationabsolute", this._onDeviceOrientation, this);
                else if ("ondeviceorientation" in window) L1.DomEvent.off(window, "deviceorientation", this._onDeviceOrientation, this);
            }
        },
        /**
     * Zoom (unless we should keep the zoom level) and an to the current view.
     */ setView () {
            this._drawMarker();
            if (this._isOutsideMapBounds()) {
                this._event = undefined; // clear the current location so we can get back into the bounds
                this.options.onLocationOutsideMapBounds(this);
            } else {
                if (this._justClicked && this.options.initialZoomLevel !== false) {
                    var f = this.options.flyTo ? this._map.flyTo : this._map.setView;
                    f.bind(this._map)([
                        this._event.latitude,
                        this._event.longitude
                    ], this.options.initialZoomLevel);
                } else if (this.options.keepCurrentZoomLevel) {
                    var f = this.options.flyTo ? this._map.flyTo : this._map.panTo;
                    f.bind(this._map)([
                        this._event.latitude,
                        this._event.longitude
                    ]);
                } else {
                    var f = this.options.flyTo ? this._map.flyToBounds : this._map.fitBounds;
                    // Ignore zoom events while setting the viewport as these would stop following
                    this._ignoreEvent = true;
                    f.bind(this._map)(this.options.getLocationBounds(this._event), {
                        padding: this.options.circlePadding,
                        maxZoom: this.options.initialZoomLevel || this.options.locateOptions.maxZoom
                    });
                    L1.Util.requestAnimFrame(function() {
                        // Wait until after the next animFrame because the flyTo can be async
                        this._ignoreEvent = false;
                    }, this);
                }
            }
        },
        /**
     *
     */ _drawCompass () {
            if (!this._event) return;
            const latlng = this._event.latlng;
            if (this.options.showCompass && latlng && this._compassHeading !== null) {
                const cStyle = this._isFollowing() ? this.options.followCompassStyle : this.options.compassStyle;
                if (!this._compass) this._compass = new this.options.compassClass(latlng, this._compassHeading, cStyle).addTo(this._layer);
                else {
                    this._compass.setLatLng(latlng);
                    this._compass.setHeading(this._compassHeading);
                    // If the compassClass can be updated with setStyle, update it.
                    if (this._compass.setStyle) this._compass.setStyle(cStyle);
                }
            //
            }
            if (this._compass && (!this.options.showCompass || this._compassHeading === null)) {
                this._compass.removeFrom(this._layer);
                this._compass = null;
            }
        },
        /**
     * Draw the marker and accuracy circle on the map.
     *
     * Uses the event retrieved from onLocationFound from the map.
     */ _drawMarker () {
            if (this._event.accuracy === undefined) this._event.accuracy = 0;
            const radius = this._event.accuracy;
            const latlng = this._event.latlng;
            // circle with the radius of the location's accuracy
            if (this.options.drawCircle) {
                const style = this._isFollowing() ? this.options.followCircleStyle : this.options.circleStyle;
                if (!this._circle) this._circle = L1.circle(latlng, radius, style).addTo(this._layer);
                else this._circle.setLatLng(latlng).setRadius(radius).setStyle(style);
            }
            let distance;
            let unit;
            if (this.options.metric) {
                distance = radius.toFixed(0);
                unit = this.options.strings.metersUnit;
            } else {
                distance = (radius * 3.2808399).toFixed(0);
                unit = this.options.strings.feetUnit;
            }
            // small inner marker
            if (this.options.drawMarker) {
                const mStyle = this._isFollowing() ? this.options.followMarkerStyle : this.options.markerStyle;
                if (!this._marker) this._marker = new this.options.markerClass(latlng, mStyle).addTo(this._layer);
                else {
                    this._marker.setLatLng(latlng);
                    // If the markerClass can be updated with setStyle, update it.
                    if (this._marker.setStyle) this._marker.setStyle(mStyle);
                }
            }
            this._drawCompass();
            const t = this.options.strings.popup;
            function getPopupText() {
                if (typeof t === "string") return L1.Util.template(t, {
                    distance: distance,
                    unit: unit
                });
                else if (typeof t === "function") return t({
                    distance: distance,
                    unit: unit
                });
                else return t;
            }
            if (this.options.showPopup && t && this._marker) this._marker.bindPopup(getPopupText())._popup.setLatLng(latlng);
            if (this.options.showPopup && t && this._compass) this._compass.bindPopup(getPopupText())._popup.setLatLng(latlng);
        },
        /**
     * Remove the marker from map.
     */ _removeMarker () {
            this._layer.clearLayers();
            this._marker = undefined;
            this._circle = undefined;
        },
        /**
     * Unload the plugin and all event listeners.
     * Kind of the opposite of onAdd.
     */ _unload () {
            this.stop();
            this._map.off("unload", this._unload, this);
        },
        /**
     * Sets the compass heading
     */ _setCompassHeading (angle) {
            if (!isNaN(parseFloat(angle)) && isFinite(angle)) {
                angle = Math.round(angle);
                this._compassHeading = angle;
                L1.Util.requestAnimFrame(this._drawCompass, this);
            } else this._compassHeading = null;
        },
        /**
     * If the compass fails calibration just fail safely and remove the compass
     */ _onCompassNeedsCalibration () {
            this._setCompassHeading();
        },
        /**
     * Process and normalise compass events
     */ _onDeviceOrientation (e) {
            if (!this._active) return;
            if (e.webkitCompassHeading) // iOS
            this._setCompassHeading(e.webkitCompassHeading);
            else if (e.absolute && e.alpha) // Android
            this._setCompassHeading(360 - e.alpha);
        },
        /**
     * Calls deactivate and dispatches an error.
     */ _onLocationError (err) {
            // ignore time out error if the location is watched
            if (err.code == 3 && this.options.locateOptions.watch) return;
            this.stop();
            this.options.onLocationError(err, this);
        },
        /**
     * Stores the received event and updates the marker.
     */ _onLocationFound (e) {
            // no need to do anything if the location has not changed
            if (this._event && this._event.latlng.lat === e.latlng.lat && this._event.latlng.lng === e.latlng.lng && this._event.accuracy === e.accuracy) return;
            if (!this._active) // we may have a stray event
            return;
            this._event = e;
            this._drawMarker();
            this._updateContainerStyle();
            switch(this.options.setView){
                case "once":
                    if (this._justClicked) this.setView();
                    break;
                case "untilPan":
                    if (!this._userPanned) this.setView();
                    break;
                case "untilPanOrZoom":
                    if (!this._userPanned && !this._userZoomed) this.setView();
                    break;
                case "always":
                    this.setView();
                    break;
                case false:
                    break;
            }
            this._justClicked = false;
        },
        /**
     * When the user drags. Need a separate event so we can bind and unbind event listeners.
     */ _onDrag () {
            // only react to drags once we have a location
            if (this._event && !this._ignoreEvent) {
                this._userPanned = true;
                this._updateContainerStyle();
                this._drawMarker();
            }
        },
        /**
     * When the user zooms. Need a separate event so we can bind and unbind event listeners.
     */ _onZoom () {
            // only react to drags once we have a location
            if (this._event && !this._ignoreEvent) {
                this._userZoomed = true;
                this._updateContainerStyle();
                this._drawMarker();
            }
        },
        /**
     * After a zoom ends update the compass and handle sideways zooms
     */ _onZoomEnd () {
            if (this._event) this._drawCompass();
            if (this._event && !this._ignoreEvent) // If we have zoomed in and out and ended up sideways treat it as a pan
            {
                if (this._marker && !this._map.getBounds().pad(-0.3).contains(this._marker.getLatLng())) {
                    this._userPanned = true;
                    this._updateContainerStyle();
                    this._drawMarker();
                }
            }
        },
        /**
     * Compute whether the map is following the user location with pan and zoom.
     */ _isFollowing () {
            if (!this._active) return false;
            if (this.options.setView === "always") return true;
            else if (this.options.setView === "untilPan") return !this._userPanned;
            else if (this.options.setView === "untilPanOrZoom") return !this._userPanned && !this._userZoomed;
        },
        /**
     * Check if location is in map bounds
     */ _isOutsideMapBounds () {
            if (this._event === undefined) return false;
            return this._map.options.maxBounds && !this._map.options.maxBounds.contains(this._event.latlng);
        },
        /**
     * Toggles button class between following and active.
     */ _updateContainerStyle () {
            if (!this._container) return;
            if (this._active && !this._event) // active but don't have a location yet
            this._setClasses("requesting");
            else if (this._isFollowing()) this._setClasses("following");
            else if (this._active) this._setClasses("active");
            else this._cleanClasses();
        },
        /**
     * Sets the CSS classes for the state.
     */ _setClasses (state) {
            if (state == "requesting") {
                removeClasses(this._container, "active following");
                addClasses(this._container, "requesting");
                removeClasses(this._icon, this.options.icon);
                addClasses(this._icon, this.options.iconLoading);
            } else if (state == "active") {
                removeClasses(this._container, "requesting following");
                addClasses(this._container, "active");
                removeClasses(this._icon, this.options.iconLoading);
                addClasses(this._icon, this.options.icon);
            } else if (state == "following") {
                removeClasses(this._container, "requesting");
                addClasses(this._container, "active following");
                removeClasses(this._icon, this.options.iconLoading);
                addClasses(this._icon, this.options.icon);
            }
        },
        /**
     * Removes all classes from button.
     */ _cleanClasses () {
            L1.DomUtil.removeClass(this._container, "requesting");
            L1.DomUtil.removeClass(this._container, "active");
            L1.DomUtil.removeClass(this._container, "following");
            removeClasses(this._icon, this.options.iconLoading);
            addClasses(this._icon, this.options.icon);
        },
        /**
     * Reinitializes state variables.
     */ _resetVariables () {
            // whether locate is active or not
            this._active = false;
            // true if the control was clicked for the first time
            // we need this so we can pan and zoom once we have the location
            this._justClicked = false;
            // true if the user has panned the map after clicking the control
            this._userPanned = false;
            // true if the user has zoomed the map after clicking the control
            this._userZoomed = false;
        }
    });
    L1.control.locate = (options)=>new L1.Control.Locate(options);
    return LocateControl;
}, window);



var $6KOho = parcelRequire("6KOho");

var $dktVJ = parcelRequire("dktVJ");

/*
   Copyright 2023, Guillermo Vega-Gorgojo

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ 
var $33Kba = parcelRequire("33Kba");



var $fhN3L = parcelRequire("fhN3L");

var $6AR8M = parcelRequire("6AR8M");

var $6KOho = parcelRequire("6KOho");
var $d486cd8337e91fbc$exports = {};
(function(global, factory) {
    $d486cd8337e91fbc$exports = factory();
})($d486cd8337e91fbc$exports, function() {
    'use strict';
    /*!
   * mustache.js - Logic-less {{mustache}} templates with JavaScript
   * http://github.com/janl/mustache.js
   */ var objectToString = Object.prototype.toString;
    var isArray = Array.isArray || function isArrayPolyfill(object) {
        return objectToString.call(object) === '[object Array]';
    };
    function isFunction(object) {
        return typeof object === 'function';
    }
    /**
   * More correct typeof string handling array
   * which normally returns typeof 'object'
   */ function typeStr(obj) {
        return isArray(obj) ? 'array' : typeof obj;
    }
    function escapeRegExp(string) {
        return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&');
    }
    /**
   * Null safe way of checking whether or not an object,
   * including its prototype, has a given property
   */ function hasProperty(obj, propName) {
        return obj != null && typeof obj === 'object' && propName in obj;
    }
    /**
   * Safe way of detecting whether or not the given thing is a primitive and
   * whether it has the given property
   */ function primitiveHasOwnProperty(primitive, propName) {
        return primitive != null && typeof primitive !== 'object' && primitive.hasOwnProperty && primitive.hasOwnProperty(propName);
    }
    // Workaround for https://issues.apache.org/jira/browse/COUCHDB-577
    // See https://github.com/janl/mustache.js/issues/189
    var regExpTest = RegExp.prototype.test;
    function testRegExp(re, string) {
        return regExpTest.call(re, string);
    }
    var nonSpaceRe = /\S/;
    function isWhitespace(string) {
        return !testRegExp(nonSpaceRe, string);
    }
    var entityMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
        '/': '&#x2F;',
        '`': '&#x60;',
        '=': '&#x3D;'
    };
    function escapeHtml(string) {
        return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap(s) {
            return entityMap[s];
        });
    }
    var whiteRe = /\s*/;
    var spaceRe = /\s+/;
    var equalsRe = /\s*=/;
    var curlyRe = /\s*\}/;
    var tagRe = /#|\^|\/|>|\{|&|=|!/;
    /**
   * Breaks up the given `template` string into a tree of tokens. If the `tags`
   * argument is given here it must be an array with two string values: the
   * opening and closing tags used in the template (e.g. [ "<%", "%>" ]). Of
   * course, the default is to use mustaches (i.e. mustache.tags).
   *
   * A token is an array with at least 4 elements. The first element is the
   * mustache symbol that was used inside the tag, e.g. "#" or "&". If the tag
   * did not contain a symbol (i.e. {{myValue}}) this element is "name". For
   * all text that appears outside a symbol this element is "text".
   *
   * The second element of a token is its "value". For mustache tags this is
   * whatever else was inside the tag besides the opening symbol. For text tokens
   * this is the text itself.
   *
   * The third and fourth elements of the token are the start and end indices,
   * respectively, of the token in the original template.
   *
   * Tokens that are the root node of a subtree contain two more elements: 1) an
   * array of tokens in the subtree and 2) the index in the original template at
   * which the closing tag for that section begins.
   *
   * Tokens for partials also contain two more elements: 1) a string value of
   * indendation prior to that tag and 2) the index of that tag on that line -
   * eg a value of 2 indicates the partial is the third tag on this line.
   */ function parseTemplate(template, tags) {
        if (!template) return [];
        var lineHasNonSpace = false;
        var sections = []; // Stack to hold section tokens
        var tokens = []; // Buffer to hold the tokens
        var spaces = []; // Indices of whitespace tokens on the current line
        var hasTag = false; // Is there a {{tag}} on the current line?
        var nonSpace = false; // Is there a non-space char on the current line?
        var indentation = ''; // Tracks indentation for tags that use it
        var tagIndex = 0; // Stores a count of number of tags encountered on a line
        // Strips all whitespace tokens array for the current line
        // if there was a {{#tag}} on it and otherwise only space.
        function stripSpace() {
            if (hasTag && !nonSpace) while(spaces.length)delete tokens[spaces.pop()];
            else spaces = [];
            hasTag = false;
            nonSpace = false;
        }
        var openingTagRe, closingTagRe, closingCurlyRe;
        function compileTags(tagsToCompile) {
            if (typeof tagsToCompile === 'string') tagsToCompile = tagsToCompile.split(spaceRe, 2);
            if (!isArray(tagsToCompile) || tagsToCompile.length !== 2) throw new Error('Invalid tags: ' + tagsToCompile);
            openingTagRe = new RegExp(escapeRegExp(tagsToCompile[0]) + '\\s*');
            closingTagRe = new RegExp('\\s*' + escapeRegExp(tagsToCompile[1]));
            closingCurlyRe = new RegExp('\\s*' + escapeRegExp('}' + tagsToCompile[1]));
        }
        compileTags(tags || mustache.tags);
        var scanner = new Scanner(template);
        var start, type, value, chr, token, openSection;
        while(!scanner.eos()){
            start = scanner.pos;
            // Match any text between tags.
            value = scanner.scanUntil(openingTagRe);
            if (value) for(var i = 0, valueLength = value.length; i < valueLength; ++i){
                chr = value.charAt(i);
                if (isWhitespace(chr)) {
                    spaces.push(tokens.length);
                    indentation += chr;
                } else {
                    nonSpace = true;
                    lineHasNonSpace = true;
                    indentation += ' ';
                }
                tokens.push([
                    'text',
                    chr,
                    start,
                    start + 1
                ]);
                start += 1;
                // Check for whitespace on the current line.
                if (chr === '\n') {
                    stripSpace();
                    indentation = '';
                    tagIndex = 0;
                    lineHasNonSpace = false;
                }
            }
            // Match the opening tag.
            if (!scanner.scan(openingTagRe)) break;
            hasTag = true;
            // Get the tag type.
            type = scanner.scan(tagRe) || 'name';
            scanner.scan(whiteRe);
            // Get the tag value.
            if (type === '=') {
                value = scanner.scanUntil(equalsRe);
                scanner.scan(equalsRe);
                scanner.scanUntil(closingTagRe);
            } else if (type === '{') {
                value = scanner.scanUntil(closingCurlyRe);
                scanner.scan(curlyRe);
                scanner.scanUntil(closingTagRe);
                type = '&';
            } else value = scanner.scanUntil(closingTagRe);
            // Match the closing tag.
            if (!scanner.scan(closingTagRe)) throw new Error('Unclosed tag at ' + scanner.pos);
            if (type == '>') token = [
                type,
                value,
                start,
                scanner.pos,
                indentation,
                tagIndex,
                lineHasNonSpace
            ];
            else token = [
                type,
                value,
                start,
                scanner.pos
            ];
            tagIndex++;
            tokens.push(token);
            if (type === '#' || type === '^') sections.push(token);
            else if (type === '/') {
                // Check section nesting.
                openSection = sections.pop();
                if (!openSection) throw new Error('Unopened section "' + value + '" at ' + start);
                if (openSection[1] !== value) throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
            } else if (type === 'name' || type === '{' || type === '&') nonSpace = true;
            else if (type === '=') // Set the tags for the next time around.
            compileTags(value);
        }
        stripSpace();
        // Make sure there are no open sections when we're done.
        openSection = sections.pop();
        if (openSection) throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);
        return nestTokens(squashTokens(tokens));
    }
    /**
   * Combines the values of consecutive text tokens in the given `tokens` array
   * to a single token.
   */ function squashTokens(tokens) {
        var squashedTokens = [];
        var token, lastToken;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            token = tokens[i];
            if (token) {
                if (token[0] === 'text' && lastToken && lastToken[0] === 'text') {
                    lastToken[1] += token[1];
                    lastToken[3] = token[3];
                } else {
                    squashedTokens.push(token);
                    lastToken = token;
                }
            }
        }
        return squashedTokens;
    }
    /**
   * Forms the given array of `tokens` into a nested tree structure where
   * tokens that represent a section have two additional items: 1) an array of
   * all tokens that appear in that section and 2) the index in the original
   * template that represents the end of that section.
   */ function nestTokens(tokens) {
        var nestedTokens = [];
        var collector = nestedTokens;
        var sections = [];
        var token, section;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            token = tokens[i];
            switch(token[0]){
                case '#':
                case '^':
                    collector.push(token);
                    sections.push(token);
                    collector = token[4] = [];
                    break;
                case '/':
                    section = sections.pop();
                    section[5] = token[2];
                    collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
                    break;
                default:
                    collector.push(token);
            }
        }
        return nestedTokens;
    }
    /**
   * A simple string scanner that is used by the template parser to find
   * tokens in template strings.
   */ function Scanner(string) {
        this.string = string;
        this.tail = string;
        this.pos = 0;
    }
    /**
   * Returns `true` if the tail is empty (end of string).
   */ Scanner.prototype.eos = function eos() {
        return this.tail === '';
    };
    /**
   * Tries to match the given regular expression at the current position.
   * Returns the matched text if it can match, the empty string otherwise.
   */ Scanner.prototype.scan = function scan(re) {
        var match = this.tail.match(re);
        if (!match || match.index !== 0) return '';
        var string = match[0];
        this.tail = this.tail.substring(string.length);
        this.pos += string.length;
        return string;
    };
    /**
   * Skips all text until the given regular expression can be matched. Returns
   * the skipped string, which is the entire tail if no match can be made.
   */ Scanner.prototype.scanUntil = function scanUntil(re) {
        var index = this.tail.search(re), match;
        switch(index){
            case -1:
                match = this.tail;
                this.tail = '';
                break;
            case 0:
                match = '';
                break;
            default:
                match = this.tail.substring(0, index);
                this.tail = this.tail.substring(index);
        }
        this.pos += match.length;
        return match;
    };
    /**
   * Represents a rendering context by wrapping a view object and
   * maintaining a reference to the parent context.
   */ function Context(view, parentContext) {
        this.view = view;
        this.cache = {
            '.': this.view
        };
        this.parent = parentContext;
    }
    /**
   * Creates a new context using the given view with this context
   * as the parent.
   */ Context.prototype.push = function push(view) {
        return new Context(view, this);
    };
    /**
   * Returns the value of the given name in this context, traversing
   * up the context hierarchy if the value is absent in this context's view.
   */ Context.prototype.lookup = function lookup(name) {
        var cache1 = this.cache;
        var value;
        if (cache1.hasOwnProperty(name)) value = cache1[name];
        else {
            var context = this, intermediateValue, names, index, lookupHit = false;
            while(context){
                if (name.indexOf('.') > 0) {
                    intermediateValue = context.view;
                    names = name.split('.');
                    index = 0;
                    /**
           * Using the dot notion path in `name`, we descend through the
           * nested objects.
           *
           * To be certain that the lookup has been successful, we have to
           * check if the last object in the path actually has the property
           * we are looking for. We store the result in `lookupHit`.
           *
           * This is specially necessary for when the value has been set to
           * `undefined` and we want to avoid looking up parent contexts.
           *
           * In the case where dot notation is used, we consider the lookup
           * to be successful even if the last "object" in the path is
           * not actually an object but a primitive (e.g., a string, or an
           * integer), because it is sometimes useful to access a property
           * of an autoboxed primitive, such as the length of a string.
           **/ while(intermediateValue != null && index < names.length){
                        if (index === names.length - 1) lookupHit = hasProperty(intermediateValue, names[index]) || primitiveHasOwnProperty(intermediateValue, names[index]);
                        intermediateValue = intermediateValue[names[index++]];
                    }
                } else {
                    intermediateValue = context.view[name];
                    /**
           * Only checking against `hasProperty`, which always returns `false` if
           * `context.view` is not an object. Deliberately omitting the check
           * against `primitiveHasOwnProperty` if dot notation is not used.
           *
           * Consider this example:
           * ```
           * Mustache.render("The length of a football field is {{#length}}{{length}}{{/length}}.", {length: "100 yards"})
           * ```
           *
           * If we were to check also against `primitiveHasOwnProperty`, as we do
           * in the dot notation case, then render call would return:
           *
           * "The length of a football field is 9."
           *
           * rather than the expected:
           *
           * "The length of a football field is 100 yards."
           **/ lookupHit = hasProperty(context.view, name);
                }
                if (lookupHit) {
                    value = intermediateValue;
                    break;
                }
                context = context.parent;
            }
            cache1[name] = value;
        }
        if (isFunction(value)) value = value.call(this.view);
        return value;
    };
    /**
   * A Writer knows how to take a stream of tokens and render them to a
   * string, given a context. It also maintains a cache of templates to
   * avoid the need to parse the same template twice.
   */ function Writer() {
        this.templateCache = {
            _cache: {},
            set: function set(key, value) {
                this._cache[key] = value;
            },
            get: function get(key) {
                return this._cache[key];
            },
            clear: function clear() {
                this._cache = {};
            }
        };
    }
    /**
   * Clears all cached templates in this writer.
   */ Writer.prototype.clearCache = function clearCache() {
        if (typeof this.templateCache !== 'undefined') this.templateCache.clear();
    };
    /**
   * Parses and caches the given `template` according to the given `tags` or
   * `mustache.tags` if `tags` is omitted,  and returns the array of tokens
   * that is generated from the parse.
   */ Writer.prototype.parse = function parse(template, tags) {
        var cache1 = this.templateCache;
        var cacheKey = template + ':' + (tags || mustache.tags).join(':');
        var isCacheEnabled = typeof cache1 !== 'undefined';
        var tokens = isCacheEnabled ? cache1.get(cacheKey) : undefined;
        if (tokens == undefined) {
            tokens = parseTemplate(template, tags);
            isCacheEnabled && cache1.set(cacheKey, tokens);
        }
        return tokens;
    };
    /**
   * High-level method that is used to render the given `template` with
   * the given `view`.
   *
   * The optional `partials` argument may be an object that contains the
   * names and templates of partials that are used in the template. It may
   * also be a function that is used to load partial templates on the fly
   * that takes a single argument: the name of the partial.
   *
   * If the optional `config` argument is given here, then it should be an
   * object with a `tags` attribute or an `escape` attribute or both.
   * If an array is passed, then it will be interpreted the same way as
   * a `tags` attribute on a `config` object.
   *
   * The `tags` attribute of a `config` object must be an array with two
   * string values: the opening and closing tags used in the template (e.g.
   * [ "<%", "%>" ]). The default is to mustache.tags.
   *
   * The `escape` attribute of a `config` object must be a function which
   * accepts a string as input and outputs a safely escaped string.
   * If an `escape` function is not provided, then an HTML-safe string
   * escaping function is used as the default.
   */ Writer.prototype.render = function render(template, view, partials, config) {
        var tags = this.getConfigTags(config);
        var tokens = this.parse(template, tags);
        var context = view instanceof Context ? view : new Context(view, undefined);
        return this.renderTokens(tokens, context, partials, template, config);
    };
    /**
   * Low-level method that renders the given array of `tokens` using
   * the given `context` and `partials`.
   *
   * Note: The `originalTemplate` is only ever used to extract the portion
   * of the original template that was contained in a higher-order section.
   * If the template doesn't use higher-order sections, this argument may
   * be omitted.
   */ Writer.prototype.renderTokens = function renderTokens(tokens, context, partials, originalTemplate, config) {
        var buffer = '';
        var token, symbol, value;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            value = undefined;
            token = tokens[i];
            symbol = token[0];
            if (symbol === '#') value = this.renderSection(token, context, partials, originalTemplate, config);
            else if (symbol === '^') value = this.renderInverted(token, context, partials, originalTemplate, config);
            else if (symbol === '>') value = this.renderPartial(token, context, partials, config);
            else if (symbol === '&') value = this.unescapedValue(token, context);
            else if (symbol === 'name') value = this.escapedValue(token, context, config);
            else if (symbol === 'text') value = this.rawValue(token);
            if (value !== undefined) buffer += value;
        }
        return buffer;
    };
    Writer.prototype.renderSection = function renderSection(token, context, partials, originalTemplate, config) {
        var self = this;
        var buffer = '';
        var value = context.lookup(token[1]);
        // This function is used to render an arbitrary template
        // in the current context by higher-order sections.
        function subRender(template) {
            return self.render(template, context, partials, config);
        }
        if (!value) return;
        if (isArray(value)) for(var j = 0, valueLength = value.length; j < valueLength; ++j)buffer += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate, config);
        else if (typeof value === 'object' || typeof value === 'string' || typeof value === 'number') buffer += this.renderTokens(token[4], context.push(value), partials, originalTemplate, config);
        else if (isFunction(value)) {
            if (typeof originalTemplate !== 'string') throw new Error('Cannot use higher-order sections without the original template');
            // Extract the portion of the original template that the section contains.
            value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);
            if (value != null) buffer += value;
        } else buffer += this.renderTokens(token[4], context, partials, originalTemplate, config);
        return buffer;
    };
    Writer.prototype.renderInverted = function renderInverted(token, context, partials, originalTemplate, config) {
        var value = context.lookup(token[1]);
        // Use JavaScript's definition of falsy. Include empty arrays.
        // See https://github.com/janl/mustache.js/issues/186
        if (!value || isArray(value) && value.length === 0) return this.renderTokens(token[4], context, partials, originalTemplate, config);
    };
    Writer.prototype.indentPartial = function indentPartial(partial, indentation, lineHasNonSpace) {
        var filteredIndentation = indentation.replace(/[^ \t]/g, '');
        var partialByNl = partial.split('\n');
        for(var i = 0; i < partialByNl.length; i++)if (partialByNl[i].length && (i > 0 || !lineHasNonSpace)) partialByNl[i] = filteredIndentation + partialByNl[i];
        return partialByNl.join('\n');
    };
    Writer.prototype.renderPartial = function renderPartial(token, context, partials, config) {
        if (!partials) return;
        var tags = this.getConfigTags(config);
        var value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
        if (value != null) {
            var lineHasNonSpace = token[6];
            var tagIndex = token[5];
            var indentation = token[4];
            var indentedValue = value;
            if (tagIndex == 0 && indentation) indentedValue = this.indentPartial(value, indentation, lineHasNonSpace);
            var tokens = this.parse(indentedValue, tags);
            return this.renderTokens(tokens, context, partials, indentedValue, config);
        }
    };
    Writer.prototype.unescapedValue = function unescapedValue(token, context) {
        var value = context.lookup(token[1]);
        if (value != null) return value;
    };
    Writer.prototype.escapedValue = function escapedValue(token, context, config) {
        var escape = this.getConfigEscape(config) || mustache.escape;
        var value = context.lookup(token[1]);
        if (value != null) return typeof value === 'number' && escape === mustache.escape ? String(value) : escape(value);
    };
    Writer.prototype.rawValue = function rawValue(token) {
        return token[1];
    };
    Writer.prototype.getConfigTags = function getConfigTags(config) {
        if (isArray(config)) return config;
        else if (config && typeof config === 'object') return config.tags;
        else return undefined;
    };
    Writer.prototype.getConfigEscape = function getConfigEscape(config) {
        if (config && typeof config === 'object' && !isArray(config)) return config.escape;
        else return undefined;
    };
    var mustache = {
        name: 'mustache.js',
        version: '4.2.0',
        tags: [
            '{{',
            '}}'
        ],
        clearCache: undefined,
        escape: undefined,
        parse: undefined,
        render: undefined,
        Scanner: undefined,
        Context: undefined,
        Writer: undefined,
        /**
     * Allows a user to override the default caching strategy, by providing an
     * object with set, get and clear methods. This can also be used to disable
     * the cache by setting it to the literal `undefined`.
     */ set templateCache (cache){
            defaultWriter.templateCache = cache;
        },
        /**
     * Gets the default or overridden caching object from the default writer.
     */ get templateCache () {
            return defaultWriter.templateCache;
        }
    };
    // All high-level mustache.* functions use this writer.
    var defaultWriter = new Writer();
    /**
   * Clears all cached templates in the default writer.
   */ mustache.clearCache = function clearCache() {
        return defaultWriter.clearCache();
    };
    /**
   * Parses and caches the given template in the default writer and returns the
   * array of tokens it contains. Doing this ahead of time avoids the need to
   * parse templates on the fly as they are rendered.
   */ mustache.parse = function parse(template, tags) {
        return defaultWriter.parse(template, tags);
    };
    /**
   * Renders the `template` with the given `view`, `partials`, and `config`
   * using the default writer.
   */ mustache.render = function render(template, view, partials, config) {
        if (typeof template !== 'string') throw new TypeError('Invalid template! Template should be a "string" but "' + typeStr(template) + '" was given as the first ' + 'argument for mustache#render(template, view, partials)');
        return defaultWriter.render(template, view, partials, config);
    };
    // Export the escaping function so that the user may override it.
    // See https://github.com/janl/mustache.js/issues/244
    mustache.escape = escapeHtml;
    // Export these mainly for testing, but also for advanced usage.
    mustache.Scanner = Scanner;
    mustache.Context = Context;
    mustache.Writer = Writer;
    return mustache;
});



var $dktVJ = parcelRequire("dktVJ");

/*
   Copyright 2023, Guillermo Vega-Gorgojo

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ 
var $33Kba = parcelRequire("33Kba");

var $2q7Wm = parcelRequire("2q7Wm");
var $e916d1c05dbae7b7$exports = {};
let $e916d1c05dbae7b7$var$numberRegexp = /[-+]?([0-9]*\.[0-9]+|[0-9]+)([eE][-+]?[0-9]+)?/;
// Matches sequences like '100 100' or '100 100 100'.
let $e916d1c05dbae7b7$var$coordFormat = new RegExp('^' + $e916d1c05dbae7b7$var$numberRegexp.source + '(\\s' + $e916d1c05dbae7b7$var$numberRegexp.source + '){1,}');
/**
 * Parse WKT and return GeoJSON.
 * @param wkt
 * @return {?Object} A GeoJSON geometry object
 */ const $e916d1c05dbae7b7$var$parse = (wkt)=>{
    let parts = wkt.split(';');
    let _ = parts.pop();
    let srid = (parts.shift() || '').split('=').pop();
    let i = 0;
    function $(re) {
        let match = _.substring(i).match(re);
        if (!match) return null;
        else {
            i += match[0].length;
            return match[0];
        }
    }
    function crs(obj) {
        if (obj && srid.match(/\d+/)) obj.crs = {
            type: 'name',
            properties: {
                name: 'urn:ogc:def:crs:EPSG::' + srid
            }
        };
        return obj;
    }
    function white() {
        $(/^\s*/);
    }
    function multicoords() {
        white();
        let depth = 0;
        let rings = [];
        let stack = [
            rings
        ];
        let pointer = rings;
        let elem;
        while(elem = $(/^(\()/) || $(/^(\))/) || $(/^(,)/) || $($e916d1c05dbae7b7$var$coordFormat)){
            if (elem === '(') {
                stack.push(pointer);
                pointer = [];
                stack[stack.length - 1].push(pointer);
                depth++;
            } else if (elem === ')') {
                // For the case: Polygon(), ...
                if (pointer.length === 0) return null;
                pointer = stack.pop();
                // the stack was empty, input was malformed
                if (!pointer) return null;
                depth--;
                if (depth === 0) break;
            } else if (elem === ',') {
                pointer = [];
                stack[stack.length - 1].push(pointer);
            } else if (!elem.split(/\s/g).some(isNaN)) Array.prototype.push.apply(pointer, elem.split(/\s/g).map(parseFloat));
            else return null;
            white();
        }
        if (depth !== 0) return null;
        return rings;
    }
    function coords() {
        let list = [];
        let item;
        let pt;
        while(pt = $($e916d1c05dbae7b7$var$coordFormat) || $(/^(,)/)){
            if (pt === ',') {
                list.push(item);
                item = [];
            } else if (!pt.split(/\s/g).some(isNaN)) {
                if (!item) item = [];
                Array.prototype.push.apply(item, pt.split(/\s/g).map(parseFloat));
            }
            white();
        }
        if (item) list.push(item);
        else return null;
        return list.length ? list : null;
    }
    function point() {
        if (!$(/^(point(\sz)?)/i)) return null;
        white();
        if (!$(/^(\()/)) return null;
        let c = coords();
        if (!c) return null;
        white();
        if (!$(/^(\))/)) return null;
        return {
            type: 'Point',
            coordinates: c[0]
        };
    }
    function multipoint() {
        if (!$(/^(multipoint(\sz)?)/i)) return null;
        white();
        let newCoordsFormat = _.substring(_.indexOf('(') + 1, _.length - 1).replace(/\(/g, '').replace(/\)/g, '');
        _ = 'MULTIPOINT (' + newCoordsFormat + ')';
        let c = multicoords();
        if (!c) return null;
        white();
        return {
            type: 'MultiPoint',
            coordinates: c
        };
    }
    function multilinestring() {
        if (!$(/^(multilinestring(\sz)?)/i)) return null;
        white();
        let c = multicoords();
        if (!c) return null;
        white();
        return {
            type: 'MultiLineString',
            coordinates: c
        };
    }
    function linestring() {
        if (!$(/^(linestring(\sz)?)/i)) return null;
        white();
        if (!$(/^(\()/)) return null;
        let c = coords();
        if (!c) return null;
        if (!$(/^(\))/)) return null;
        return {
            type: 'LineString',
            coordinates: c
        };
    }
    function polygon() {
        if (!$(/^(polygon(\sz)?)/i)) return null;
        white();
        let c = multicoords();
        if (!c) return null;
        return {
            type: 'Polygon',
            coordinates: c
        };
    }
    function multipolygon() {
        if (!$(/^(multipolygon(\sz)?)/i)) return null;
        white();
        let c = multicoords();
        if (!c) return null;
        return {
            type: 'MultiPolygon',
            coordinates: c
        };
    }
    function geometrycollection() {
        let geometries = [];
        let geometry;
        if (!$(/^(geometrycollection)/i)) return null;
        white();
        if (!$(/^(\()/)) return null;
        while(geometry = root()){
            geometries.push(geometry);
            white();
            $(/^(,)/);
            white();
        }
        if (!$(/^(\))/)) return null;
        return {
            type: 'GeometryCollection',
            geometries: geometries
        };
    }
    function root() {
        return point() || linestring() || polygon() || multipoint() || multilinestring() || multipolygon() || geometrycollection();
    }
    return crs(root());
};
/**
 * Stringifies a GeoJSON object into WKT
 */ const $e916d1c05dbae7b7$var$stringify = (geoJSON)=>{
    if (geoJSON.type === 'Feature') geoJSON = geoJSON.geometry;
    function pairWKT(c) {
        return c.join(' ');
    }
    function ringWKT(r) {
        return r.map(pairWKT).join(', ');
    }
    function ringsWKT(r) {
        return r.map(ringWKT).map(wrapParens).join(', ');
    }
    function multiRingsWKT(r) {
        return r.map(ringsWKT).map(wrapParens).join(', ');
    }
    function wrapParens(s) {
        return '(' + s + ')';
    }
    let gJ = geoJSON;
    switch(gJ.type){
        case 'Point':
            if (gJ.coordinates && gJ.coordinates.length === 3) return 'POINT Z (' + pairWKT(gJ.coordinates) + ')';
            else return 'POINT (' + pairWKT(gJ.coordinates) + ')';
        case 'LineString':
            if (gJ.coordinates && gJ.coordinates[0] && gJ.coordinates[0].length === 3) return 'LINESTRING Z (' + ringWKT(gJ.coordinates) + ')';
            else return 'LINESTRING (' + ringWKT(gJ.coordinates) + ')';
        case 'Polygon':
            if (gJ.coordinates && gJ.coordinates[0] && gJ.coordinates[0][0] && gJ.coordinates[0][0].length === 3) return 'POLYGON Z (' + ringsWKT(gJ.coordinates) + ')';
            else return 'POLYGON (' + ringsWKT(gJ.coordinates) + ')';
        case 'MultiPoint':
            if (gJ.coordinates && gJ.coordinates[0] && gJ.coordinates[0].length === 3) return 'MULTIPOINT Z (' + ringWKT(gJ.coordinates) + ')';
            else return 'MULTIPOINT (' + ringWKT(gJ.coordinates) + ')';
        case 'MultiLineString':
            if (gJ.coordinates && gJ.coordinates[0] && gJ.coordinates[0][0] && gJ.coordinates[0][0].length === 3) return 'MULTILINESTRING Z (' + ringsWKT(gJ.coordinates) + ')';
            else return 'MULTILINESTRING (' + ringsWKT(gJ.coordinates) + ')';
        case 'MultiPolygon':
            if (gJ.coordinates && gJ.coordinates[0] && gJ.coordinates[0][0] && gJ.coordinates[0][0] && gJ.coordinates[0][0][0].length === 3) return 'MULTIPOLYGON Z (' + multiRingsWKT(gJ.coordinates) + ')';
            else return 'MULTIPOLYGON (' + multiRingsWKT(gJ.coordinates) + ')';
        case 'GeometryCollection':
            return 'GEOMETRYCOLLECTION (' + gJ.geometries.map($e916d1c05dbae7b7$var$stringify).join(', ') + ')';
        default:
            throw new Error('stringify requires a valid GeoJSON Feature or geometry object as input');
    }
};
$e916d1c05dbae7b7$exports = {
    parse: $e916d1c05dbae7b7$var$parse,
    stringify: $e916d1c05dbae7b7$var$stringify
};



/*
   Copyright 2023, Guillermo Vega-Gorgojo

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ 
var $33Kba = parcelRequire("33Kba");

parcelRequire("8JYDX");
/*
 Leaflet.draw 1.0.4, a plugin that adds drawing and editing tools to Leaflet powered maps.
 (c) 2012-2017, Jacob Toye, Jon West, Smartrak, Leaflet

 https://github.com/Leaflet/Leaflet.draw
 http://leafletjs.com
 */ !function(t, e, i) {
    function o(t, e) {
        for(; (t = t.parentElement) && !t.classList.contains(e););
        return t;
    }
    L.drawVersion = "1.0.4", L.Draw = {}, L.drawLocal = {
        draw: {
            toolbar: {
                actions: {
                    title: "Cancel drawing",
                    text: "Cancel"
                },
                finish: {
                    title: "Finish drawing",
                    text: "Finish"
                },
                undo: {
                    title: "Delete last point drawn",
                    text: "Delete last point"
                },
                buttons: {
                    polyline: "Draw a polyline",
                    polygon: "Draw a polygon",
                    rectangle: "Draw a rectangle",
                    circle: "Draw a circle",
                    marker: "Draw a marker",
                    circlemarker: "Draw a circlemarker"
                }
            },
            handlers: {
                circle: {
                    tooltip: {
                        start: "Click and drag to draw circle."
                    },
                    radius: "Radius"
                },
                circlemarker: {
                    tooltip: {
                        start: "Click map to place circle marker."
                    }
                },
                marker: {
                    tooltip: {
                        start: "Click map to place marker."
                    }
                },
                polygon: {
                    tooltip: {
                        start: "Click to start drawing shape.",
                        cont: "Click to continue drawing shape.",
                        end: "Click first point to close this shape."
                    }
                },
                polyline: {
                    error: "<strong>Error:</strong> shape edges cannot cross!",
                    tooltip: {
                        start: "Click to start drawing line.",
                        cont: "Click to continue drawing line.",
                        end: "Click last point to finish line."
                    }
                },
                rectangle: {
                    tooltip: {
                        start: "Click and drag to draw rectangle."
                    }
                },
                simpleshape: {
                    tooltip: {
                        end: "Release mouse to finish drawing."
                    }
                }
            }
        },
        edit: {
            toolbar: {
                actions: {
                    save: {
                        title: "Save changes",
                        text: "Save"
                    },
                    cancel: {
                        title: "Cancel editing, discards all changes",
                        text: "Cancel"
                    },
                    clearAll: {
                        title: "Clear all layers",
                        text: "Clear All"
                    }
                },
                buttons: {
                    edit: "Edit layers",
                    editDisabled: "No layers to edit",
                    remove: "Delete layers",
                    removeDisabled: "No layers to delete"
                }
            },
            handlers: {
                edit: {
                    tooltip: {
                        text: "Drag handles or markers to edit features.",
                        subtext: "Click cancel to undo changes."
                    }
                },
                remove: {
                    tooltip: {
                        text: "Click on a feature to remove."
                    }
                }
            }
        }
    }, L.Draw.Event = {}, L.Draw.Event.CREATED = "draw:created", L.Draw.Event.EDITED = "draw:edited", L.Draw.Event.DELETED = "draw:deleted", L.Draw.Event.DRAWSTART = "draw:drawstart", L.Draw.Event.DRAWSTOP = "draw:drawstop", L.Draw.Event.DRAWVERTEX = "draw:drawvertex", L.Draw.Event.EDITSTART = "draw:editstart", L.Draw.Event.EDITMOVE = "draw:editmove", L.Draw.Event.EDITRESIZE = "draw:editresize", L.Draw.Event.EDITVERTEX = "draw:editvertex", L.Draw.Event.EDITSTOP = "draw:editstop", L.Draw.Event.DELETESTART = "draw:deletestart", L.Draw.Event.DELETESTOP = "draw:deletestop", L.Draw.Event.TOOLBAROPENED = "draw:toolbaropened", L.Draw.Event.TOOLBARCLOSED = "draw:toolbarclosed", L.Draw.Event.MARKERCONTEXT = "draw:markercontext", L.Draw = L.Draw || {}, L.Draw.Feature = L.Handler.extend({
        initialize: function(t, e) {
            this._map = t, this._container = t._container, this._overlayPane = t._panes.overlayPane, this._popupPane = t._panes.popupPane, e && e.shapeOptions && (e.shapeOptions = L.Util.extend({}, this.options.shapeOptions, e.shapeOptions)), L.setOptions(this, e);
            var i = L.version.split(".");
            1 === parseInt(i[0], 10) && parseInt(i[1], 10) >= 2 ? L.Draw.Feature.include(L.Evented.prototype) : L.Draw.Feature.include(L.Mixin.Events);
        },
        enable: function() {
            this._enabled || (L.Handler.prototype.enable.call(this), this.fire("enabled", {
                handler: this.type
            }), this._map.fire(L.Draw.Event.DRAWSTART, {
                layerType: this.type
            }));
        },
        disable: function() {
            this._enabled && (L.Handler.prototype.disable.call(this), this._map.fire(L.Draw.Event.DRAWSTOP, {
                layerType: this.type
            }), this.fire("disabled", {
                handler: this.type
            }));
        },
        addHooks: function() {
            var t = this._map;
            t && (L.DomUtil.disableTextSelection(), t.getContainer().focus(), this._tooltip = new L.Draw.Tooltip(this._map), L.DomEvent.on(this._container, "keyup", this._cancelDrawing, this));
        },
        removeHooks: function() {
            this._map && (L.DomUtil.enableTextSelection(), this._tooltip.dispose(), this._tooltip = null, L.DomEvent.off(this._container, "keyup", this._cancelDrawing, this));
        },
        setOptions: function(t) {
            L.setOptions(this, t);
        },
        _fireCreatedEvent: function(t) {
            this._map.fire(L.Draw.Event.CREATED, {
                layer: t,
                layerType: this.type
            });
        },
        _cancelDrawing: function(t) {
            27 === t.keyCode && (this._map.fire("draw:canceled", {
                layerType: this.type
            }), this.disable());
        }
    }), L.Draw.Polyline = L.Draw.Feature.extend({
        statics: {
            TYPE: "polyline"
        },
        Poly: L.Polyline,
        options: {
            allowIntersection: !0,
            repeatMode: !1,
            drawError: {
                color: "#b00b00",
                timeout: 2500
            },
            icon: new L.DivIcon({
                iconSize: new L.Point(8, 8),
                className: "leaflet-div-icon leaflet-editing-icon"
            }),
            touchIcon: new L.DivIcon({
                iconSize: new L.Point(20, 20),
                className: "leaflet-div-icon leaflet-editing-icon leaflet-touch-icon"
            }),
            guidelineDistance: 20,
            maxGuideLineLength: 4e3,
            shapeOptions: {
                stroke: !0,
                color: "#3388ff",
                weight: 4,
                opacity: .5,
                fill: !1,
                clickable: !0
            },
            metric: !0,
            feet: !0,
            nautic: !1,
            showLength: !0,
            zIndexOffset: 2e3,
            factor: 1,
            maxPoints: 0
        },
        initialize: function(t, e) {
            L.Browser.touch && (this.options.icon = this.options.touchIcon), this.options.drawError.message = L.drawLocal.draw.handlers.polyline.error, e && e.drawError && (e.drawError = L.Util.extend({}, this.options.drawError, e.drawError)), this.type = L.Draw.Polyline.TYPE, L.Draw.Feature.prototype.initialize.call(this, t, e);
        },
        addHooks: function() {
            L.Draw.Feature.prototype.addHooks.call(this), this._map && (this._markers = [], this._markerGroup = new L.LayerGroup, this._map.addLayer(this._markerGroup), this._poly = new L.Polyline([], this.options.shapeOptions), this._tooltip.updateContent(this._getTooltipText()), this._mouseMarker || (this._mouseMarker = L.marker(this._map.getCenter(), {
                icon: L.divIcon({
                    className: "leaflet-mouse-marker",
                    iconAnchor: [
                        20,
                        20
                    ],
                    iconSize: [
                        40,
                        40
                    ]
                }),
                opacity: 0,
                zIndexOffset: this.options.zIndexOffset
            })), this._mouseMarker.on("mouseout", this._onMouseOut, this).on("mousemove", this._onMouseMove, this).on("mousedown", this._onMouseDown, this).on("mouseup", this._onMouseUp, this).addTo(this._map), this._map.on("mouseup", this._onMouseUp, this).on("mousemove", this._onMouseMove, this).on("zoomlevelschange", this._onZoomEnd, this).on("touchstart", this._onTouch, this).on("zoomend", this._onZoomEnd, this));
        },
        removeHooks: function() {
            L.Draw.Feature.prototype.removeHooks.call(this), this._clearHideErrorTimeout(), this._cleanUpShape(), this._map.removeLayer(this._markerGroup), delete this._markerGroup, delete this._markers, this._map.removeLayer(this._poly), delete this._poly, this._mouseMarker.off("mousedown", this._onMouseDown, this).off("mouseout", this._onMouseOut, this).off("mouseup", this._onMouseUp, this).off("mousemove", this._onMouseMove, this), this._map.removeLayer(this._mouseMarker), delete this._mouseMarker, this._clearGuides(), this._map.off("mouseup", this._onMouseUp, this).off("mousemove", this._onMouseMove, this).off("zoomlevelschange", this._onZoomEnd, this).off("zoomend", this._onZoomEnd, this).off("touchstart", this._onTouch, this).off("click", this._onTouch, this);
        },
        deleteLastVertex: function() {
            if (!(this._markers.length <= 1)) {
                var t = this._markers.pop(), e = this._poly, i = e.getLatLngs(), o = i.splice(-1, 1)[0];
                this._poly.setLatLngs(i), this._markerGroup.removeLayer(t), e.getLatLngs().length < 2 && this._map.removeLayer(e), this._vertexChanged(o, !1);
            }
        },
        addVertex: function(t) {
            if (this._markers.length >= 2 && !this.options.allowIntersection && this._poly.newLatLngIntersects(t)) return void this._showErrorTooltip();
            this._errorShown && this._hideErrorTooltip(), this._markers.push(this._createMarker(t)), this._poly.addLatLng(t), 2 === this._poly.getLatLngs().length && this._map.addLayer(this._poly), this._vertexChanged(t, !0);
        },
        completeShape: function() {
            this._markers.length <= 1 || !this._shapeIsValid() || (this._fireCreatedEvent(), this.disable(), this.options.repeatMode && this.enable());
        },
        _finishShape: function() {
            var t = this._poly._defaultShape ? this._poly._defaultShape() : this._poly.getLatLngs(), e = this._poly.newLatLngIntersects(t[t.length - 1]);
            if (!this.options.allowIntersection && e || !this._shapeIsValid()) return void this._showErrorTooltip();
            this._fireCreatedEvent(), this.disable(), this.options.repeatMode && this.enable();
        },
        _shapeIsValid: function() {
            return !0;
        },
        _onZoomEnd: function() {
            null !== this._markers && this._updateGuide();
        },
        _onMouseMove: function(t) {
            var e = this._map.mouseEventToLayerPoint(t.originalEvent), i = this._map.layerPointToLatLng(e);
            this._currentLatLng = i, this._updateTooltip(i), this._updateGuide(e), this._mouseMarker.setLatLng(i), L.DomEvent.preventDefault(t.originalEvent);
        },
        _vertexChanged: function(t, e) {
            this._map.fire(L.Draw.Event.DRAWVERTEX, {
                layers: this._markerGroup
            }), this._updateFinishHandler(), this._updateRunningMeasure(t, e), this._clearGuides(), this._updateTooltip();
        },
        _onMouseDown: function(t) {
            if (!this._clickHandled && !this._touchHandled && !this._disableMarkers) {
                this._onMouseMove(t), this._clickHandled = !0, this._disableNewMarkers();
                var e = t.originalEvent, i = e.clientX, o = e.clientY;
                this._startPoint.call(this, i, o);
            }
        },
        _startPoint: function(t, e) {
            this._mouseDownOrigin = L.point(t, e);
        },
        _onMouseUp: function(t) {
            var e = t.originalEvent, i = e.clientX, o = e.clientY;
            this._endPoint.call(this, i, o, t), this._clickHandled = null;
        },
        _endPoint: function(e, i, o) {
            if (this._mouseDownOrigin) {
                var a = L.point(e, i).distanceTo(this._mouseDownOrigin), n = this._calculateFinishDistance(o.latlng);
                this.options.maxPoints > 1 && this.options.maxPoints == this._markers.length + 1 ? (this.addVertex(o.latlng), this._finishShape()) : n < 10 && L.Browser.touch ? this._finishShape() : Math.abs(a) < 9 * (t.devicePixelRatio || 1) && this.addVertex(o.latlng), this._enableNewMarkers();
            }
            this._mouseDownOrigin = null;
        },
        _onTouch: function(t) {
            var e, i, o = t.originalEvent;
            !o.touches || !o.touches[0] || this._clickHandled || this._touchHandled || this._disableMarkers || (e = o.touches[0].clientX, i = o.touches[0].clientY, this._disableNewMarkers(), this._touchHandled = !0, this._startPoint.call(this, e, i), this._endPoint.call(this, e, i, t), this._touchHandled = null), this._clickHandled = null;
        },
        _onMouseOut: function() {
            this._tooltip && this._tooltip._onMouseOut.call(this._tooltip);
        },
        _calculateFinishDistance: function(t) {
            var e;
            if (this._markers.length > 0) {
                var i;
                if (this.type === L.Draw.Polyline.TYPE) i = this._markers[this._markers.length - 1];
                else {
                    if (this.type !== L.Draw.Polygon.TYPE) return 1 / 0;
                    i = this._markers[0];
                }
                var o = this._map.latLngToContainerPoint(i.getLatLng()), a = new L.Marker(t, {
                    icon: this.options.icon,
                    zIndexOffset: 2 * this.options.zIndexOffset
                }), n = this._map.latLngToContainerPoint(a.getLatLng());
                e = o.distanceTo(n);
            } else e = 1 / 0;
            return e;
        },
        _updateFinishHandler: function() {
            var t = this._markers.length;
            t > 1 && this._markers[t - 1].on("click", this._finishShape, this), t > 2 && this._markers[t - 2].off("click", this._finishShape, this);
        },
        _createMarker: function(t) {
            var e = new L.Marker(t, {
                icon: this.options.icon,
                zIndexOffset: 2 * this.options.zIndexOffset
            });
            return this._markerGroup.addLayer(e), e;
        },
        _updateGuide: function(t) {
            var e = this._markers ? this._markers.length : 0;
            e > 0 && (t = t || this._map.latLngToLayerPoint(this._currentLatLng), this._clearGuides(), this._drawGuide(this._map.latLngToLayerPoint(this._markers[e - 1].getLatLng()), t));
        },
        _updateTooltip: function(t) {
            var e = this._getTooltipText();
            t && this._tooltip.updatePosition(t), this._errorShown || this._tooltip.updateContent(e);
        },
        _drawGuide: function(t, e) {
            var i, o, a, n = Math.floor(Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2))), s = this.options.guidelineDistance, r = this.options.maxGuideLineLength, l = n > r ? n - r : s;
            for(this._guidesContainer || (this._guidesContainer = L.DomUtil.create("div", "leaflet-draw-guides", this._overlayPane)); l < n; l += this.options.guidelineDistance)i = l / n, o = {
                x: Math.floor(t.x * (1 - i) + i * e.x),
                y: Math.floor(t.y * (1 - i) + i * e.y)
            }, a = L.DomUtil.create("div", "leaflet-draw-guide-dash", this._guidesContainer), a.style.backgroundColor = this._errorShown ? this.options.drawError.color : this.options.shapeOptions.color, L.DomUtil.setPosition(a, o);
        },
        _updateGuideColor: function(t) {
            if (this._guidesContainer) for(var e = 0, i = this._guidesContainer.childNodes.length; e < i; e++)this._guidesContainer.childNodes[e].style.backgroundColor = t;
        },
        _clearGuides: function() {
            if (this._guidesContainer) for(; this._guidesContainer.firstChild;)this._guidesContainer.removeChild(this._guidesContainer.firstChild);
        },
        _getTooltipText: function() {
            var t, e, i = this.options.showLength;
            return 0 === this._markers.length ? t = {
                text: L.drawLocal.draw.handlers.polyline.tooltip.start
            } : (e = i ? this._getMeasurementString() : "", t = 1 === this._markers.length ? {
                text: L.drawLocal.draw.handlers.polyline.tooltip.cont,
                subtext: e
            } : {
                text: L.drawLocal.draw.handlers.polyline.tooltip.end,
                subtext: e
            }), t;
        },
        _updateRunningMeasure: function(t, e) {
            var i, o, a = this._markers.length;
            1 === this._markers.length ? this._measurementRunningTotal = 0 : (i = a - (e ? 2 : 1), o = L.GeometryUtil.isVersion07x() ? t.distanceTo(this._markers[i].getLatLng()) * (this.options.factor || 1) : this._map.distance(t, this._markers[i].getLatLng()) * (this.options.factor || 1), this._measurementRunningTotal += o * (e ? 1 : -1));
        },
        _getMeasurementString: function() {
            var t, e = this._currentLatLng, i = this._markers[this._markers.length - 1].getLatLng();
            return t = L.GeometryUtil.isVersion07x() ? i && e && e.distanceTo ? this._measurementRunningTotal + e.distanceTo(i) * (this.options.factor || 1) : this._measurementRunningTotal || 0 : i && e ? this._measurementRunningTotal + this._map.distance(e, i) * (this.options.factor || 1) : this._measurementRunningTotal || 0, L.GeometryUtil.readableDistance(t, this.options.metric, this.options.feet, this.options.nautic, this.options.precision);
        },
        _showErrorTooltip: function() {
            this._errorShown = !0, this._tooltip.showAsError().updateContent({
                text: this.options.drawError.message
            }), this._updateGuideColor(this.options.drawError.color), this._poly.setStyle({
                color: this.options.drawError.color
            }), this._clearHideErrorTimeout(), this._hideErrorTimeout = setTimeout(L.Util.bind(this._hideErrorTooltip, this), this.options.drawError.timeout);
        },
        _hideErrorTooltip: function() {
            this._errorShown = !1, this._clearHideErrorTimeout(), this._tooltip.removeError().updateContent(this._getTooltipText()), this._updateGuideColor(this.options.shapeOptions.color), this._poly.setStyle({
                color: this.options.shapeOptions.color
            });
        },
        _clearHideErrorTimeout: function() {
            this._hideErrorTimeout && (clearTimeout(this._hideErrorTimeout), this._hideErrorTimeout = null);
        },
        _disableNewMarkers: function() {
            this._disableMarkers = !0;
        },
        _enableNewMarkers: function() {
            setTimeout((function() {
                this._disableMarkers = !1;
            }).bind(this), 50);
        },
        _cleanUpShape: function() {
            this._markers.length > 1 && this._markers[this._markers.length - 1].off("click", this._finishShape, this);
        },
        _fireCreatedEvent: function() {
            var t = new this.Poly(this._poly.getLatLngs(), this.options.shapeOptions);
            L.Draw.Feature.prototype._fireCreatedEvent.call(this, t);
        }
    }), L.Draw.Polygon = L.Draw.Polyline.extend({
        statics: {
            TYPE: "polygon"
        },
        Poly: L.Polygon,
        options: {
            showArea: !1,
            showLength: !1,
            shapeOptions: {
                stroke: !0,
                color: "#3388ff",
                weight: 4,
                opacity: .5,
                fill: !0,
                fillColor: null,
                fillOpacity: .2,
                clickable: !0
            },
            metric: !0,
            feet: !0,
            nautic: !1,
            precision: {}
        },
        initialize: function(t, e) {
            L.Draw.Polyline.prototype.initialize.call(this, t, e), this.type = L.Draw.Polygon.TYPE;
        },
        _updateFinishHandler: function() {
            var t = this._markers.length;
            1 === t && this._markers[0].on("click", this._finishShape, this), t > 2 && (this._markers[t - 1].on("dblclick", this._finishShape, this), t > 3 && this._markers[t - 2].off("dblclick", this._finishShape, this));
        },
        _getTooltipText: function() {
            var t, e;
            return 0 === this._markers.length ? t = L.drawLocal.draw.handlers.polygon.tooltip.start : this._markers.length < 3 ? (t = L.drawLocal.draw.handlers.polygon.tooltip.cont, e = this._getMeasurementString()) : (t = L.drawLocal.draw.handlers.polygon.tooltip.end, e = this._getMeasurementString()), {
                text: t,
                subtext: e
            };
        },
        _getMeasurementString: function() {
            var t = this._area, e = "";
            return t || this.options.showLength ? (this.options.showLength && (e = L.Draw.Polyline.prototype._getMeasurementString.call(this)), t && (e += "<br>" + L.GeometryUtil.readableArea(t, this.options.metric, this.options.precision)), e) : null;
        },
        _shapeIsValid: function() {
            return this._markers.length >= 3;
        },
        _vertexChanged: function(t, e) {
            var i;
            !this.options.allowIntersection && this.options.showArea && (i = this._poly.getLatLngs(), this._area = L.GeometryUtil.geodesicArea(i)), L.Draw.Polyline.prototype._vertexChanged.call(this, t, e);
        },
        _cleanUpShape: function() {
            var t = this._markers.length;
            t > 0 && (this._markers[0].off("click", this._finishShape, this), t > 2 && this._markers[t - 1].off("dblclick", this._finishShape, this));
        }
    }), L.SimpleShape = {}, L.Draw.SimpleShape = L.Draw.Feature.extend({
        options: {
            repeatMode: !1
        },
        initialize: function(t, e) {
            this._endLabelText = L.drawLocal.draw.handlers.simpleshape.tooltip.end, L.Draw.Feature.prototype.initialize.call(this, t, e);
        },
        addHooks: function() {
            L.Draw.Feature.prototype.addHooks.call(this), this._map && (this._mapDraggable = this._map.dragging.enabled(), this._mapDraggable && this._map.dragging.disable(), this._container.style.cursor = "crosshair", this._tooltip.updateContent({
                text: this._initialLabelText
            }), this._map.on("mousedown", this._onMouseDown, this).on("mousemove", this._onMouseMove, this).on("touchstart", this._onMouseDown, this).on("touchmove", this._onMouseMove, this), e.addEventListener("touchstart", L.DomEvent.preventDefault, {
                passive: !1
            }));
        },
        removeHooks: function() {
            L.Draw.Feature.prototype.removeHooks.call(this), this._map && (this._mapDraggable && this._map.dragging.enable(), this._container.style.cursor = "", this._map.off("mousedown", this._onMouseDown, this).off("mousemove", this._onMouseMove, this).off("touchstart", this._onMouseDown, this).off("touchmove", this._onMouseMove, this), L.DomEvent.off(e, "mouseup", this._onMouseUp, this), L.DomEvent.off(e, "touchend", this._onMouseUp, this), e.removeEventListener("touchstart", L.DomEvent.preventDefault), this._shape && (this._map.removeLayer(this._shape), delete this._shape)), this._isDrawing = !1;
        },
        _getTooltipText: function() {
            return {
                text: this._endLabelText
            };
        },
        _onMouseDown: function(t) {
            this._isDrawing = !0, this._startLatLng = t.latlng, L.DomEvent.on(e, "mouseup", this._onMouseUp, this).on(e, "touchend", this._onMouseUp, this).preventDefault(t.originalEvent);
        },
        _onMouseMove: function(t) {
            var e = t.latlng;
            this._tooltip.updatePosition(e), this._isDrawing && (this._tooltip.updateContent(this._getTooltipText()), this._drawShape(e));
        },
        _onMouseUp: function() {
            this._shape && this._fireCreatedEvent(), this.disable(), this.options.repeatMode && this.enable();
        }
    }), L.Draw.Rectangle = L.Draw.SimpleShape.extend({
        statics: {
            TYPE: "rectangle"
        },
        options: {
            shapeOptions: {
                stroke: !0,
                color: "#3388ff",
                weight: 4,
                opacity: .5,
                fill: !0,
                fillColor: null,
                fillOpacity: .2,
                clickable: !0
            },
            showArea: !0,
            metric: !0
        },
        initialize: function(t, e) {
            this.type = L.Draw.Rectangle.TYPE, this._initialLabelText = L.drawLocal.draw.handlers.rectangle.tooltip.start, L.Draw.SimpleShape.prototype.initialize.call(this, t, e);
        },
        disable: function() {
            this._enabled && (this._isCurrentlyTwoClickDrawing = !1, L.Draw.SimpleShape.prototype.disable.call(this));
        },
        _onMouseUp: function(t) {
            if (!this._shape && !this._isCurrentlyTwoClickDrawing) return void (this._isCurrentlyTwoClickDrawing = !0);
            this._isCurrentlyTwoClickDrawing && !o(t.target, "leaflet-pane") || L.Draw.SimpleShape.prototype._onMouseUp.call(this);
        },
        _drawShape: function(t) {
            this._shape ? this._shape.setBounds(new L.LatLngBounds(this._startLatLng, t)) : (this._shape = new L.Rectangle(new L.LatLngBounds(this._startLatLng, t), this.options.shapeOptions), this._map.addLayer(this._shape));
        },
        _fireCreatedEvent: function() {
            var t = new L.Rectangle(this._shape.getBounds(), this.options.shapeOptions);
            L.Draw.SimpleShape.prototype._fireCreatedEvent.call(this, t);
        },
        _getTooltipText: function() {
            var t, e, i, o = L.Draw.SimpleShape.prototype._getTooltipText.call(this), a = this._shape, n = this.options.showArea;
            return a && (t = this._shape._defaultShape ? this._shape._defaultShape() : this._shape.getLatLngs(), e = L.GeometryUtil.geodesicArea(t), i = n ? L.GeometryUtil.readableArea(e, this.options.metric) : ""), {
                text: o.text,
                subtext: i
            };
        }
    }), L.Draw.Marker = L.Draw.Feature.extend({
        statics: {
            TYPE: "marker"
        },
        options: {
            icon: new L.Icon.Default,
            repeatMode: !1,
            zIndexOffset: 2e3
        },
        initialize: function(t, e) {
            this.type = L.Draw.Marker.TYPE, this._initialLabelText = L.drawLocal.draw.handlers.marker.tooltip.start, L.Draw.Feature.prototype.initialize.call(this, t, e);
        },
        addHooks: function() {
            L.Draw.Feature.prototype.addHooks.call(this), this._map && (this._tooltip.updateContent({
                text: this._initialLabelText
            }), this._mouseMarker || (this._mouseMarker = L.marker(this._map.getCenter(), {
                icon: L.divIcon({
                    className: "leaflet-mouse-marker",
                    iconAnchor: [
                        20,
                        20
                    ],
                    iconSize: [
                        40,
                        40
                    ]
                }),
                opacity: 0,
                zIndexOffset: this.options.zIndexOffset
            })), this._mouseMarker.on("click", this._onClick, this).addTo(this._map), this._map.on("mousemove", this._onMouseMove, this), this._map.on("click", this._onTouch, this));
        },
        removeHooks: function() {
            L.Draw.Feature.prototype.removeHooks.call(this), this._map && (this._map.off("click", this._onClick, this).off("click", this._onTouch, this), this._marker && (this._marker.off("click", this._onClick, this), this._map.removeLayer(this._marker), delete this._marker), this._mouseMarker.off("click", this._onClick, this), this._map.removeLayer(this._mouseMarker), delete this._mouseMarker, this._map.off("mousemove", this._onMouseMove, this));
        },
        _onMouseMove: function(t) {
            var e = t.latlng;
            this._tooltip.updatePosition(e), this._mouseMarker.setLatLng(e), this._marker ? (e = this._mouseMarker.getLatLng(), this._marker.setLatLng(e)) : (this._marker = this._createMarker(e), this._marker.on("click", this._onClick, this), this._map.on("click", this._onClick, this).addLayer(this._marker));
        },
        _createMarker: function(t) {
            return new L.Marker(t, {
                icon: this.options.icon,
                zIndexOffset: this.options.zIndexOffset
            });
        },
        _onClick: function() {
            this._fireCreatedEvent(), this.disable(), this.options.repeatMode && this.enable();
        },
        _onTouch: function(t) {
            this._onMouseMove(t), this._onClick();
        },
        _fireCreatedEvent: function() {
            var t = new L.Marker.Touch(this._marker.getLatLng(), {
                icon: this.options.icon
            });
            L.Draw.Feature.prototype._fireCreatedEvent.call(this, t);
        }
    }), L.Draw.CircleMarker = L.Draw.Marker.extend({
        statics: {
            TYPE: "circlemarker"
        },
        options: {
            stroke: !0,
            color: "#3388ff",
            weight: 4,
            opacity: .5,
            fill: !0,
            fillColor: null,
            fillOpacity: .2,
            clickable: !0,
            zIndexOffset: 2e3
        },
        initialize: function(t, e) {
            this.type = L.Draw.CircleMarker.TYPE, this._initialLabelText = L.drawLocal.draw.handlers.circlemarker.tooltip.start, L.Draw.Feature.prototype.initialize.call(this, t, e);
        },
        _fireCreatedEvent: function() {
            var t = new L.CircleMarker(this._marker.getLatLng(), this.options);
            L.Draw.Feature.prototype._fireCreatedEvent.call(this, t);
        },
        _createMarker: function(t) {
            return new L.CircleMarker(t, this.options);
        }
    }), L.Draw.Circle = L.Draw.SimpleShape.extend({
        statics: {
            TYPE: "circle"
        },
        options: {
            shapeOptions: {
                stroke: !0,
                color: "#3388ff",
                weight: 4,
                opacity: .5,
                fill: !0,
                fillColor: null,
                fillOpacity: .2,
                clickable: !0
            },
            showRadius: !0,
            metric: !0,
            feet: !0,
            nautic: !1
        },
        initialize: function(t, e) {
            this.type = L.Draw.Circle.TYPE, this._initialLabelText = L.drawLocal.draw.handlers.circle.tooltip.start, L.Draw.SimpleShape.prototype.initialize.call(this, t, e);
        },
        _drawShape: function(t) {
            if (L.GeometryUtil.isVersion07x()) var e = this._startLatLng.distanceTo(t);
            else var e = this._map.distance(this._startLatLng, t);
            this._shape ? this._shape.setRadius(e) : (this._shape = new L.Circle(this._startLatLng, e, this.options.shapeOptions), this._map.addLayer(this._shape));
        },
        _fireCreatedEvent: function() {
            var t = new L.Circle(this._startLatLng, this._shape.getRadius(), this.options.shapeOptions);
            L.Draw.SimpleShape.prototype._fireCreatedEvent.call(this, t);
        },
        _onMouseMove: function(t) {
            var e, i = t.latlng, o = this.options.showRadius, a = this.options.metric;
            if (this._tooltip.updatePosition(i), this._isDrawing) {
                this._drawShape(i), e = this._shape.getRadius().toFixed(1);
                var n = "";
                o && (n = L.drawLocal.draw.handlers.circle.radius + ": " + L.GeometryUtil.readableDistance(e, a, this.options.feet, this.options.nautic)), this._tooltip.updateContent({
                    text: this._endLabelText,
                    subtext: n
                });
            }
        }
    }), L.Edit = L.Edit || {}, L.Edit.Marker = L.Handler.extend({
        initialize: function(t, e) {
            this._marker = t, L.setOptions(this, e);
        },
        addHooks: function() {
            var t = this._marker;
            t.dragging.enable(), t.on("dragend", this._onDragEnd, t), this._toggleMarkerHighlight();
        },
        removeHooks: function() {
            var t = this._marker;
            t.dragging.disable(), t.off("dragend", this._onDragEnd, t), this._toggleMarkerHighlight();
        },
        _onDragEnd: function(t) {
            var e = t.target;
            e.edited = !0, this._map.fire(L.Draw.Event.EDITMOVE, {
                layer: e
            });
        },
        _toggleMarkerHighlight: function() {
            var t = this._marker._icon;
            t && (t.style.display = "none", L.DomUtil.hasClass(t, "leaflet-edit-marker-selected") ? (L.DomUtil.removeClass(t, "leaflet-edit-marker-selected"), this._offsetMarker(t, -4)) : (L.DomUtil.addClass(t, "leaflet-edit-marker-selected"), this._offsetMarker(t, 4)), t.style.display = "");
        },
        _offsetMarker: function(t, e) {
            var i = parseInt(t.style.marginTop, 10) - e, o = parseInt(t.style.marginLeft, 10) - e;
            t.style.marginTop = i + "px", t.style.marginLeft = o + "px";
        }
    }), L.Marker.addInitHook(function() {
        L.Edit.Marker && (this.editing = new L.Edit.Marker(this), this.options.editable && this.editing.enable());
    }), L.Edit = L.Edit || {}, L.Edit.Poly = L.Handler.extend({
        initialize: function(t) {
            this.latlngs = [
                t._latlngs
            ], t._holes && (this.latlngs = this.latlngs.concat(t._holes)), this._poly = t, this._poly.on("revert-edited", this._updateLatLngs, this);
        },
        _defaultShape: function() {
            return L.Polyline._flat ? L.Polyline._flat(this._poly._latlngs) ? this._poly._latlngs : this._poly._latlngs[0] : this._poly._latlngs;
        },
        _eachVertexHandler: function(t) {
            for(var e = 0; e < this._verticesHandlers.length; e++)t(this._verticesHandlers[e]);
        },
        addHooks: function() {
            this._initHandlers(), this._eachVertexHandler(function(t) {
                t.addHooks();
            });
        },
        removeHooks: function() {
            this._eachVertexHandler(function(t) {
                t.removeHooks();
            });
        },
        updateMarkers: function() {
            this._eachVertexHandler(function(t) {
                t.updateMarkers();
            });
        },
        _initHandlers: function() {
            this._verticesHandlers = [];
            for(var t = 0; t < this.latlngs.length; t++)this._verticesHandlers.push(new L.Edit.PolyVerticesEdit(this._poly, this.latlngs[t], this._poly.options.poly));
        },
        _updateLatLngs: function(t) {
            this.latlngs = [
                t.layer._latlngs
            ], t.layer._holes && (this.latlngs = this.latlngs.concat(t.layer._holes));
        }
    }), L.Edit.PolyVerticesEdit = L.Handler.extend({
        options: {
            icon: new L.DivIcon({
                iconSize: new L.Point(8, 8),
                className: "leaflet-div-icon leaflet-editing-icon"
            }),
            touchIcon: new L.DivIcon({
                iconSize: new L.Point(20, 20),
                className: "leaflet-div-icon leaflet-editing-icon leaflet-touch-icon"
            }),
            drawError: {
                color: "#b00b00",
                timeout: 1e3
            }
        },
        initialize: function(t, e, i) {
            L.Browser.touch && (this.options.icon = this.options.touchIcon), this._poly = t, i && i.drawError && (i.drawError = L.Util.extend({}, this.options.drawError, i.drawError)), this._latlngs = e, L.setOptions(this, i);
        },
        _defaultShape: function() {
            return L.Polyline._flat ? L.Polyline._flat(this._latlngs) ? this._latlngs : this._latlngs[0] : this._latlngs;
        },
        addHooks: function() {
            var t = this._poly, e = t._path;
            t instanceof L.Polygon || (t.options.fill = !1, t.options.editing && (t.options.editing.fill = !1)), e && t.options.editing && t.options.editing.className && (t.options.original.className && t.options.original.className.split(" ").forEach(function(t) {
                L.DomUtil.removeClass(e, t);
            }), t.options.editing.className.split(" ").forEach(function(t) {
                L.DomUtil.addClass(e, t);
            })), t.setStyle(t.options.editing), this._poly._map && (this._map = this._poly._map, this._markerGroup || this._initMarkers(), this._poly._map.addLayer(this._markerGroup));
        },
        removeHooks: function() {
            var t = this._poly, e = t._path;
            e && t.options.editing && t.options.editing.className && (t.options.editing.className.split(" ").forEach(function(t) {
                L.DomUtil.removeClass(e, t);
            }), t.options.original.className && t.options.original.className.split(" ").forEach(function(t) {
                L.DomUtil.addClass(e, t);
            })), t.setStyle(t.options.original), t._map && (t._map.removeLayer(this._markerGroup), delete this._markerGroup, delete this._markers);
        },
        updateMarkers: function() {
            this._markerGroup.clearLayers(), this._initMarkers();
        },
        _initMarkers: function() {
            this._markerGroup || (this._markerGroup = new L.LayerGroup), this._markers = [];
            var t, e, i, o, a = this._defaultShape();
            for(t = 0, i = a.length; t < i; t++)o = this._createMarker(a[t], t), o.on("click", this._onMarkerClick, this), o.on("contextmenu", this._onContextMenu, this), this._markers.push(o);
            var n, s;
            for(t = 0, e = i - 1; t < i; e = t++)(0 !== t || L.Polygon && this._poly instanceof L.Polygon) && (n = this._markers[e], s = this._markers[t], this._createMiddleMarker(n, s), this._updatePrevNext(n, s));
        },
        _createMarker: function(t, e) {
            var i = new L.Marker.Touch(t, {
                draggable: !0,
                icon: this.options.icon
            });
            return i._origLatLng = t, i._index = e, i.on("dragstart", this._onMarkerDragStart, this).on("drag", this._onMarkerDrag, this).on("dragend", this._fireEdit, this).on("touchmove", this._onTouchMove, this).on("touchend", this._fireEdit, this).on("MSPointerMove", this._onTouchMove, this).on("MSPointerUp", this._fireEdit, this), this._markerGroup.addLayer(i), i;
        },
        _onMarkerDragStart: function() {
            this._poly.fire("editstart");
        },
        _spliceLatLngs: function() {
            var t = this._defaultShape(), e = [].splice.apply(t, arguments);
            return this._poly._convertLatLngs(t, !0), this._poly.redraw(), e;
        },
        _removeMarker: function(t) {
            var e = t._index;
            this._markerGroup.removeLayer(t), this._markers.splice(e, 1), this._spliceLatLngs(e, 1), this._updateIndexes(e, -1), t.off("dragstart", this._onMarkerDragStart, this).off("drag", this._onMarkerDrag, this).off("dragend", this._fireEdit, this).off("touchmove", this._onMarkerDrag, this).off("touchend", this._fireEdit, this).off("click", this._onMarkerClick, this).off("MSPointerMove", this._onTouchMove, this).off("MSPointerUp", this._fireEdit, this);
        },
        _fireEdit: function() {
            this._poly.edited = !0, this._poly.fire("edit"), this._poly._map.fire(L.Draw.Event.EDITVERTEX, {
                layers: this._markerGroup,
                poly: this._poly
            });
        },
        _onMarkerDrag: function(t) {
            var e = t.target, i = this._poly, o = L.LatLngUtil.cloneLatLng(e._origLatLng);
            if (L.extend(e._origLatLng, e._latlng), i.options.poly) {
                var a = i._map._editTooltip;
                if (!i.options.poly.allowIntersection && i.intersects()) {
                    L.extend(e._origLatLng, o), e.setLatLng(o);
                    var n = i.options.color;
                    i.setStyle({
                        color: this.options.drawError.color
                    }), a && a.updateContent({
                        text: L.drawLocal.draw.handlers.polyline.error
                    }), setTimeout(function() {
                        i.setStyle({
                            color: n
                        }), a && a.updateContent({
                            text: L.drawLocal.edit.handlers.edit.tooltip.text,
                            subtext: L.drawLocal.edit.handlers.edit.tooltip.subtext
                        });
                    }, 1e3);
                }
            }
            e._middleLeft && e._middleLeft.setLatLng(this._getMiddleLatLng(e._prev, e)), e._middleRight && e._middleRight.setLatLng(this._getMiddleLatLng(e, e._next)), this._poly._bounds._southWest = L.latLng(1 / 0, 1 / 0), this._poly._bounds._northEast = L.latLng(-1 / 0, -1 / 0);
            var s = this._poly.getLatLngs();
            this._poly._convertLatLngs(s, !0), this._poly.redraw(), this._poly.fire("editdrag");
        },
        _onMarkerClick: function(t) {
            var e = L.Polygon && this._poly instanceof L.Polygon ? 4 : 3, i = t.target;
            this._defaultShape().length < e || (this._removeMarker(i), this._updatePrevNext(i._prev, i._next), i._middleLeft && this._markerGroup.removeLayer(i._middleLeft), i._middleRight && this._markerGroup.removeLayer(i._middleRight), i._prev && i._next ? this._createMiddleMarker(i._prev, i._next) : i._prev ? i._next || (i._prev._middleRight = null) : i._next._middleLeft = null, this._fireEdit());
        },
        _onContextMenu: function(t) {
            var e = t.target;
            this._poly;
            this._poly._map.fire(L.Draw.Event.MARKERCONTEXT, {
                marker: e,
                layers: this._markerGroup,
                poly: this._poly
            }), L.DomEvent.stopPropagation;
        },
        _onTouchMove: function(t) {
            var e = this._map.mouseEventToLayerPoint(t.originalEvent.touches[0]), i = this._map.layerPointToLatLng(e), o = t.target;
            L.extend(o._origLatLng, i), o._middleLeft && o._middleLeft.setLatLng(this._getMiddleLatLng(o._prev, o)), o._middleRight && o._middleRight.setLatLng(this._getMiddleLatLng(o, o._next)), this._poly.redraw(), this.updateMarkers();
        },
        _updateIndexes: function(t, e) {
            this._markerGroup.eachLayer(function(i) {
                i._index > t && (i._index += e);
            });
        },
        _createMiddleMarker: function(t, e) {
            var i, o, a, n = this._getMiddleLatLng(t, e), s = this._createMarker(n);
            s.setOpacity(.6), t._middleRight = e._middleLeft = s, o = function() {
                s.off("touchmove", o, this);
                var a = e._index;
                s._index = a, s.off("click", i, this).on("click", this._onMarkerClick, this), n.lat = s.getLatLng().lat, n.lng = s.getLatLng().lng, this._spliceLatLngs(a, 0, n), this._markers.splice(a, 0, s), s.setOpacity(1), this._updateIndexes(a, 1), e._index++, this._updatePrevNext(t, s), this._updatePrevNext(s, e), this._poly.fire("editstart");
            }, a = function() {
                s.off("dragstart", o, this), s.off("dragend", a, this), s.off("touchmove", o, this), this._createMiddleMarker(t, s), this._createMiddleMarker(s, e);
            }, i = function() {
                o.call(this), a.call(this), this._fireEdit();
            }, s.on("click", i, this).on("dragstart", o, this).on("dragend", a, this).on("touchmove", o, this), this._markerGroup.addLayer(s);
        },
        _updatePrevNext: function(t, e) {
            t && (t._next = e), e && (e._prev = t);
        },
        _getMiddleLatLng: function(t, e) {
            var i = this._poly._map, o = i.project(t.getLatLng()), a = i.project(e.getLatLng());
            return i.unproject(o._add(a)._divideBy(2));
        }
    }), L.Polyline.addInitHook(function() {
        this.editing || (L.Edit.Poly && (this.editing = new L.Edit.Poly(this), this.options.editable && this.editing.enable()), this.on("add", function() {
            this.editing && this.editing.enabled() && this.editing.addHooks();
        }), this.on("remove", function() {
            this.editing && this.editing.enabled() && this.editing.removeHooks();
        }));
    }), L.Edit = L.Edit || {}, L.Edit.SimpleShape = L.Handler.extend({
        options: {
            moveIcon: new L.DivIcon({
                iconSize: new L.Point(8, 8),
                className: "leaflet-div-icon leaflet-editing-icon leaflet-edit-move"
            }),
            resizeIcon: new L.DivIcon({
                iconSize: new L.Point(8, 8),
                className: "leaflet-div-icon leaflet-editing-icon leaflet-edit-resize"
            }),
            touchMoveIcon: new L.DivIcon({
                iconSize: new L.Point(20, 20),
                className: "leaflet-div-icon leaflet-editing-icon leaflet-edit-move leaflet-touch-icon"
            }),
            touchResizeIcon: new L.DivIcon({
                iconSize: new L.Point(20, 20),
                className: "leaflet-div-icon leaflet-editing-icon leaflet-edit-resize leaflet-touch-icon"
            })
        },
        initialize: function(t, e) {
            L.Browser.touch && (this.options.moveIcon = this.options.touchMoveIcon, this.options.resizeIcon = this.options.touchResizeIcon), this._shape = t, L.Util.setOptions(this, e);
        },
        addHooks: function() {
            var t = this._shape;
            this._shape._map && (this._map = this._shape._map, t.setStyle(t.options.editing), t._map && (this._map = t._map, this._markerGroup || this._initMarkers(), this._map.addLayer(this._markerGroup)));
        },
        removeHooks: function() {
            var t = this._shape;
            if (t.setStyle(t.options.original), t._map) {
                this._unbindMarker(this._moveMarker);
                for(var e = 0, i = this._resizeMarkers.length; e < i; e++)this._unbindMarker(this._resizeMarkers[e]);
                this._resizeMarkers = null, this._map.removeLayer(this._markerGroup), delete this._markerGroup;
            }
            this._map = null;
        },
        updateMarkers: function() {
            this._markerGroup.clearLayers(), this._initMarkers();
        },
        _initMarkers: function() {
            this._markerGroup || (this._markerGroup = new L.LayerGroup), this._createMoveMarker(), this._createResizeMarker();
        },
        _createMoveMarker: function() {},
        _createResizeMarker: function() {},
        _createMarker: function(t, e) {
            var i = new L.Marker.Touch(t, {
                draggable: !0,
                icon: e,
                zIndexOffset: 10
            });
            return this._bindMarker(i), this._markerGroup.addLayer(i), i;
        },
        _bindMarker: function(t) {
            t.on("dragstart", this._onMarkerDragStart, this).on("drag", this._onMarkerDrag, this).on("dragend", this._onMarkerDragEnd, this).on("touchstart", this._onTouchStart, this).on("touchmove", this._onTouchMove, this).on("MSPointerMove", this._onTouchMove, this).on("touchend", this._onTouchEnd, this).on("MSPointerUp", this._onTouchEnd, this);
        },
        _unbindMarker: function(t) {
            t.off("dragstart", this._onMarkerDragStart, this).off("drag", this._onMarkerDrag, this).off("dragend", this._onMarkerDragEnd, this).off("touchstart", this._onTouchStart, this).off("touchmove", this._onTouchMove, this).off("MSPointerMove", this._onTouchMove, this).off("touchend", this._onTouchEnd, this).off("MSPointerUp", this._onTouchEnd, this);
        },
        _onMarkerDragStart: function(t) {
            t.target.setOpacity(0), this._shape.fire("editstart");
        },
        _fireEdit: function() {
            this._shape.edited = !0, this._shape.fire("edit");
        },
        _onMarkerDrag: function(t) {
            var e = t.target, i = e.getLatLng();
            e === this._moveMarker ? this._move(i) : this._resize(i), this._shape.redraw(), this._shape.fire("editdrag");
        },
        _onMarkerDragEnd: function(t) {
            t.target.setOpacity(1), this._fireEdit();
        },
        _onTouchStart: function(t) {
            if (L.Edit.SimpleShape.prototype._onMarkerDragStart.call(this, t), "function" == typeof this._getCorners) {
                var e = this._getCorners(), i = t.target, o = i._cornerIndex;
                i.setOpacity(0), this._oppositeCorner = e[(o + 2) % 4], this._toggleCornerMarkers(0, o);
            }
            this._shape.fire("editstart");
        },
        _onTouchMove: function(t) {
            var e = this._map.mouseEventToLayerPoint(t.originalEvent.touches[0]), i = this._map.layerPointToLatLng(e);
            return t.target === this._moveMarker ? this._move(i) : this._resize(i), this._shape.redraw(), !1;
        },
        _onTouchEnd: function(t) {
            t.target.setOpacity(1), this.updateMarkers(), this._fireEdit();
        },
        _move: function() {},
        _resize: function() {}
    }), L.Edit = L.Edit || {}, L.Edit.Rectangle = L.Edit.SimpleShape.extend({
        _createMoveMarker: function() {
            var t = this._shape.getBounds(), e = t.getCenter();
            this._moveMarker = this._createMarker(e, this.options.moveIcon);
        },
        _createResizeMarker: function() {
            var t = this._getCorners();
            this._resizeMarkers = [];
            for(var e = 0, i = t.length; e < i; e++)this._resizeMarkers.push(this._createMarker(t[e], this.options.resizeIcon)), this._resizeMarkers[e]._cornerIndex = e;
        },
        _onMarkerDragStart: function(t) {
            L.Edit.SimpleShape.prototype._onMarkerDragStart.call(this, t);
            var e = this._getCorners(), i = t.target, o = i._cornerIndex;
            this._oppositeCorner = e[(o + 2) % 4], this._toggleCornerMarkers(0, o);
        },
        _onMarkerDragEnd: function(t) {
            var e, i, o = t.target;
            o === this._moveMarker && (e = this._shape.getBounds(), i = e.getCenter(), o.setLatLng(i)), this._toggleCornerMarkers(1), this._repositionCornerMarkers(), L.Edit.SimpleShape.prototype._onMarkerDragEnd.call(this, t);
        },
        _move: function(t) {
            for(var e, i = this._shape._defaultShape ? this._shape._defaultShape() : this._shape.getLatLngs(), o = this._shape.getBounds(), a = o.getCenter(), n = [], s = 0, r = i.length; s < r; s++)e = [
                i[s].lat - a.lat,
                i[s].lng - a.lng
            ], n.push([
                t.lat + e[0],
                t.lng + e[1]
            ]);
            this._shape.setLatLngs(n), this._repositionCornerMarkers(), this._map.fire(L.Draw.Event.EDITMOVE, {
                layer: this._shape
            });
        },
        _resize: function(t) {
            var e;
            this._shape.setBounds(L.latLngBounds(t, this._oppositeCorner)), e = this._shape.getBounds(), this._moveMarker.setLatLng(e.getCenter()), this._map.fire(L.Draw.Event.EDITRESIZE, {
                layer: this._shape
            });
        },
        _getCorners: function() {
            var t = this._shape.getBounds();
            return [
                t.getNorthWest(),
                t.getNorthEast(),
                t.getSouthEast(),
                t.getSouthWest()
            ];
        },
        _toggleCornerMarkers: function(t) {
            for(var e = 0, i = this._resizeMarkers.length; e < i; e++)this._resizeMarkers[e].setOpacity(t);
        },
        _repositionCornerMarkers: function() {
            for(var t = this._getCorners(), e = 0, i = this._resizeMarkers.length; e < i; e++)this._resizeMarkers[e].setLatLng(t[e]);
        }
    }), L.Rectangle.addInitHook(function() {
        L.Edit.Rectangle && (this.editing = new L.Edit.Rectangle(this), this.options.editable && this.editing.enable());
    }), L.Edit = L.Edit || {}, L.Edit.CircleMarker = L.Edit.SimpleShape.extend({
        _createMoveMarker: function() {
            var t = this._shape.getLatLng();
            this._moveMarker = this._createMarker(t, this.options.moveIcon);
        },
        _createResizeMarker: function() {
            this._resizeMarkers = [];
        },
        _move: function(t) {
            if (this._resizeMarkers.length) {
                var e = this._getResizeMarkerPoint(t);
                this._resizeMarkers[0].setLatLng(e);
            }
            this._shape.setLatLng(t), this._map.fire(L.Draw.Event.EDITMOVE, {
                layer: this._shape
            });
        }
    }), L.CircleMarker.addInitHook(function() {
        L.Edit.CircleMarker && (this.editing = new L.Edit.CircleMarker(this), this.options.editable && this.editing.enable()), this.on("add", function() {
            this.editing && this.editing.enabled() && this.editing.addHooks();
        }), this.on("remove", function() {
            this.editing && this.editing.enabled() && this.editing.removeHooks();
        });
    }), L.Edit = L.Edit || {}, L.Edit.Circle = L.Edit.CircleMarker.extend({
        _createResizeMarker: function() {
            var t = this._shape.getLatLng(), e = this._getResizeMarkerPoint(t);
            this._resizeMarkers = [], this._resizeMarkers.push(this._createMarker(e, this.options.resizeIcon));
        },
        _getResizeMarkerPoint: function(t) {
            var e = this._shape._radius * Math.cos(Math.PI / 4), i = this._map.project(t);
            return this._map.unproject([
                i.x + e,
                i.y - e
            ]);
        },
        _resize: function(t) {
            var e = this._moveMarker.getLatLng();
            L.GeometryUtil.isVersion07x() ? radius = e.distanceTo(t) : radius = this._map.distance(e, t), this._shape.setRadius(radius), this._map.editTooltip && this._map._editTooltip.updateContent({
                text: L.drawLocal.edit.handlers.edit.tooltip.subtext + "<br />" + L.drawLocal.edit.handlers.edit.tooltip.text,
                subtext: L.drawLocal.draw.handlers.circle.radius + ": " + L.GeometryUtil.readableDistance(radius, !0, this.options.feet, this.options.nautic)
            }), this._shape.setRadius(radius), this._map.fire(L.Draw.Event.EDITRESIZE, {
                layer: this._shape
            });
        }
    }), L.Circle.addInitHook(function() {
        L.Edit.Circle && (this.editing = new L.Edit.Circle(this), this.options.editable && this.editing.enable());
    }), L.Map.mergeOptions({
        touchExtend: !0
    }), L.Map.TouchExtend = L.Handler.extend({
        initialize: function(t) {
            this._map = t, this._container = t._container, this._pane = t._panes.overlayPane;
        },
        addHooks: function() {
            L.DomEvent.on(this._container, "touchstart", this._onTouchStart, this), L.DomEvent.on(this._container, "touchend", this._onTouchEnd, this), L.DomEvent.on(this._container, "touchmove", this._onTouchMove, this), this._detectIE() ? (L.DomEvent.on(this._container, "MSPointerDown", this._onTouchStart, this), L.DomEvent.on(this._container, "MSPointerUp", this._onTouchEnd, this), L.DomEvent.on(this._container, "MSPointerMove", this._onTouchMove, this), L.DomEvent.on(this._container, "MSPointerCancel", this._onTouchCancel, this)) : (L.DomEvent.on(this._container, "touchcancel", this._onTouchCancel, this), L.DomEvent.on(this._container, "touchleave", this._onTouchLeave, this));
        },
        removeHooks: function() {
            L.DomEvent.off(this._container, "touchstart", this._onTouchStart, this), L.DomEvent.off(this._container, "touchend", this._onTouchEnd, this), L.DomEvent.off(this._container, "touchmove", this._onTouchMove, this), this._detectIE() ? (L.DomEvent.off(this._container, "MSPointerDown", this._onTouchStart, this), L.DomEvent.off(this._container, "MSPointerUp", this._onTouchEnd, this), L.DomEvent.off(this._container, "MSPointerMove", this._onTouchMove, this), L.DomEvent.off(this._container, "MSPointerCancel", this._onTouchCancel, this)) : (L.DomEvent.off(this._container, "touchcancel", this._onTouchCancel, this), L.DomEvent.off(this._container, "touchleave", this._onTouchLeave, this));
        },
        _touchEvent: function(t, e) {
            var i = {};
            if (void 0 !== t.touches) {
                if (!t.touches.length) return;
                i = t.touches[0];
            } else {
                if ("touch" !== t.pointerType) return;
                if (i = t, !this._filterClick(t)) return;
            }
            var o = this._map.mouseEventToContainerPoint(i), a = this._map.mouseEventToLayerPoint(i), n = this._map.layerPointToLatLng(a);
            this._map.fire(e, {
                latlng: n,
                layerPoint: a,
                containerPoint: o,
                pageX: i.pageX,
                pageY: i.pageY,
                originalEvent: t
            });
        },
        _filterClick: function(t) {
            var e = t.timeStamp || t.originalEvent.timeStamp, i = L.DomEvent._lastClick && e - L.DomEvent._lastClick;
            return i && i > 100 && i < 500 || t.target._simulatedClick && !t._simulated ? (L.DomEvent.stop(t), !1) : (L.DomEvent._lastClick = e, !0);
        },
        _onTouchStart: function(t) {
            if (this._map._loaded) this._touchEvent(t, "touchstart");
        },
        _onTouchEnd: function(t) {
            if (this._map._loaded) this._touchEvent(t, "touchend");
        },
        _onTouchCancel: function(t) {
            if (this._map._loaded) {
                var e = "touchcancel";
                this._detectIE() && (e = "pointercancel"), this._touchEvent(t, e);
            }
        },
        _onTouchLeave: function(t) {
            if (this._map._loaded) this._touchEvent(t, "touchleave");
        },
        _onTouchMove: function(t) {
            if (this._map._loaded) this._touchEvent(t, "touchmove");
        },
        _detectIE: function() {
            var e = t.navigator.userAgent, i = e.indexOf("MSIE ");
            if (i > 0) return parseInt(e.substring(i + 5, e.indexOf(".", i)), 10);
            if (e.indexOf("Trident/") > 0) {
                var o = e.indexOf("rv:");
                return parseInt(e.substring(o + 3, e.indexOf(".", o)), 10);
            }
            var a = e.indexOf("Edge/");
            return a > 0 && parseInt(e.substring(a + 5, e.indexOf(".", a)), 10);
        }
    }), L.Map.addInitHook("addHandler", "touchExtend", L.Map.TouchExtend), L.Marker.Touch = L.Marker.extend({
        _initInteraction: function() {
            return this.addInteractiveTarget ? L.Marker.prototype._initInteraction.apply(this) : this._initInteractionLegacy();
        },
        _initInteractionLegacy: function() {
            if (this.options.clickable) {
                var t = this._icon, e = [
                    "dblclick",
                    "mousedown",
                    "mouseover",
                    "mouseout",
                    "contextmenu",
                    "touchstart",
                    "touchend",
                    "touchmove"
                ];
                this._detectIE ? e.concat([
                    "MSPointerDown",
                    "MSPointerUp",
                    "MSPointerMove",
                    "MSPointerCancel"
                ]) : e.concat([
                    "touchcancel"
                ]), L.DomUtil.addClass(t, "leaflet-clickable"), L.DomEvent.on(t, "click", this._onMouseClick, this), L.DomEvent.on(t, "keypress", this._onKeyPress, this);
                for(var i = 0; i < e.length; i++)L.DomEvent.on(t, e[i], this._fireMouseEvent, this);
                L.Handler.MarkerDrag && (this.dragging = new L.Handler.MarkerDrag(this), this.options.draggable && this.dragging.enable());
            }
        },
        _detectIE: function() {
            var e = t.navigator.userAgent, i = e.indexOf("MSIE ");
            if (i > 0) return parseInt(e.substring(i + 5, e.indexOf(".", i)), 10);
            if (e.indexOf("Trident/") > 0) {
                var o = e.indexOf("rv:");
                return parseInt(e.substring(o + 3, e.indexOf(".", o)), 10);
            }
            var a = e.indexOf("Edge/");
            return a > 0 && parseInt(e.substring(a + 5, e.indexOf(".", a)), 10);
        }
    }), L.LatLngUtil = {
        cloneLatLngs: function(t) {
            for(var e = [], i = 0, o = t.length; i < o; i++)Array.isArray(t[i]) ? e.push(L.LatLngUtil.cloneLatLngs(t[i])) : e.push(this.cloneLatLng(t[i]));
            return e;
        },
        cloneLatLng: function(t) {
            return L.latLng(t.lat, t.lng);
        }
    }, function() {
        var t = {
            km: 2,
            ha: 2,
            m: 0,
            mi: 2,
            ac: 2,
            yd: 0,
            ft: 0,
            nm: 2
        };
        L.GeometryUtil = L.extend(L.GeometryUtil || {}, {
            geodesicArea: function(t) {
                var e, i, o = t.length, a = 0, n = Math.PI / 180;
                if (o > 2) {
                    for(var s = 0; s < o; s++)e = t[s], i = t[(s + 1) % o], a += (i.lng - e.lng) * n * (2 + Math.sin(e.lat * n) + Math.sin(i.lat * n));
                    a = 6378137 * a * 6378137 / 2;
                }
                return Math.abs(a);
            },
            formattedNumber: function(t, e) {
                var i = parseFloat(t).toFixed(e), o = L.drawLocal.format && L.drawLocal.format.numeric, a = o && o.delimiters, n = a && a.thousands, s = a && a.decimal;
                if (n || s) {
                    var r = i.split(".");
                    i = n ? r[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + n) : r[0], s = s || ".", r.length > 1 && (i = i + s + r[1]);
                }
                return i;
            },
            readableArea: function(e, i, o) {
                var a, n, o = L.Util.extend({}, t, o);
                return i ? (n = [
                    "ha",
                    "m"
                ], type = typeof i, "string" === type ? n = [
                    i
                ] : "boolean" !== type && (n = i), a = e >= 1e6 && -1 !== n.indexOf("km") ? L.GeometryUtil.formattedNumber(1e-6 * e, o.km) + " km\xb2" : e >= 1e4 && -1 !== n.indexOf("ha") ? L.GeometryUtil.formattedNumber(1e-4 * e, o.ha) + " ha" : L.GeometryUtil.formattedNumber(e, o.m) + " m\xb2") : (e /= .836127, a = e >= 3097600 ? L.GeometryUtil.formattedNumber(e / 3097600, o.mi) + " mi\xb2" : e >= 4840 ? L.GeometryUtil.formattedNumber(e / 4840, o.ac) + " acres" : L.GeometryUtil.formattedNumber(e, o.yd) + " yd\xb2"), a;
            },
            readableDistance: function(e, i, o, a, n) {
                var s, n = L.Util.extend({}, t, n);
                switch(i ? "string" == typeof i ? i : "metric" : o ? "feet" : a ? "nauticalMile" : "yards"){
                    case "metric":
                        s = e > 1e3 ? L.GeometryUtil.formattedNumber(e / 1e3, n.km) + " km" : L.GeometryUtil.formattedNumber(e, n.m) + " m";
                        break;
                    case "feet":
                        e *= 3.28083, s = L.GeometryUtil.formattedNumber(e, n.ft) + " ft";
                        break;
                    case "nauticalMile":
                        e *= .53996, s = L.GeometryUtil.formattedNumber(e / 1e3, n.nm) + " nm";
                        break;
                    case "yards":
                    default:
                        e *= 1.09361, s = e > 1760 ? L.GeometryUtil.formattedNumber(e / 1760, n.mi) + " miles" : L.GeometryUtil.formattedNumber(e, n.yd) + " yd";
                }
                return s;
            },
            isVersion07x: function() {
                var t = L.version.split(".");
                return 0 === parseInt(t[0], 10) && 7 === parseInt(t[1], 10);
            }
        });
    }(), L.Util.extend(L.LineUtil, {
        segmentsIntersect: function(t, e, i, o) {
            return this._checkCounterclockwise(t, i, o) !== this._checkCounterclockwise(e, i, o) && this._checkCounterclockwise(t, e, i) !== this._checkCounterclockwise(t, e, o);
        },
        _checkCounterclockwise: function(t, e, i) {
            return (i.y - t.y) * (e.x - t.x) > (e.y - t.y) * (i.x - t.x);
        }
    }), L.Polyline.include({
        intersects: function() {
            var t, e, i, o = this._getProjectedPoints(), a = o ? o.length : 0;
            if (this._tooFewPointsForIntersection()) return !1;
            for(t = a - 1; t >= 3; t--)if (e = o[t - 1], i = o[t], this._lineSegmentsIntersectsRange(e, i, t - 2)) return !0;
            return !1;
        },
        newLatLngIntersects: function(t, e) {
            return !!this._map && this.newPointIntersects(this._map.latLngToLayerPoint(t), e);
        },
        newPointIntersects: function(t, e) {
            var i = this._getProjectedPoints(), o = i ? i.length : 0, a = i ? i[o - 1] : null, n = o - 2;
            return !this._tooFewPointsForIntersection(1) && this._lineSegmentsIntersectsRange(a, t, n, e ? 1 : 0);
        },
        _tooFewPointsForIntersection: function(t) {
            var e = this._getProjectedPoints(), i = e ? e.length : 0;
            return i += t || 0, !e || i <= 3;
        },
        _lineSegmentsIntersectsRange: function(t, e, i, o) {
            var a, n, s = this._getProjectedPoints();
            o = o || 0;
            for(var r = i; r > o; r--)if (a = s[r - 1], n = s[r], L.LineUtil.segmentsIntersect(t, e, a, n)) return !0;
            return !1;
        },
        _getProjectedPoints: function() {
            if (!this._defaultShape) return this._originalPoints;
            for(var t = [], e = this._defaultShape(), i = 0; i < e.length; i++)t.push(this._map.latLngToLayerPoint(e[i]));
            return t;
        }
    }), L.Polygon.include({
        intersects: function() {
            var t, e, i, o, a = this._getProjectedPoints();
            return !this._tooFewPointsForIntersection() && (!!L.Polyline.prototype.intersects.call(this) || (t = a.length, e = a[0], i = a[t - 1], o = t - 2, this._lineSegmentsIntersectsRange(i, e, o, 1)));
        }
    }), L.Control.Draw = L.Control.extend({
        options: {
            position: "topleft",
            draw: {},
            edit: !1
        },
        initialize: function(t) {
            if (L.version < "0.7") throw new Error("Leaflet.draw 0.2.3+ requires Leaflet 0.7.0+. Download latest from https://github.com/Leaflet/Leaflet/");
            L.Control.prototype.initialize.call(this, t);
            var e;
            this._toolbars = {}, L.DrawToolbar && this.options.draw && (e = new L.DrawToolbar(this.options.draw), this._toolbars[L.DrawToolbar.TYPE] = e, this._toolbars[L.DrawToolbar.TYPE].on("enable", this._toolbarEnabled, this)), L.EditToolbar && this.options.edit && (e = new L.EditToolbar(this.options.edit), this._toolbars[L.EditToolbar.TYPE] = e, this._toolbars[L.EditToolbar.TYPE].on("enable", this._toolbarEnabled, this)), L.toolbar = this;
        },
        onAdd: function(t) {
            var e, i = L.DomUtil.create("div", "leaflet-draw"), o = !1;
            for(var a in this._toolbars)this._toolbars.hasOwnProperty(a) && (e = this._toolbars[a].addToolbar(t)) && (o || (L.DomUtil.hasClass(e, "leaflet-draw-toolbar-top") || L.DomUtil.addClass(e.childNodes[0], "leaflet-draw-toolbar-top"), o = !0), i.appendChild(e));
            return i;
        },
        onRemove: function() {
            for(var t in this._toolbars)this._toolbars.hasOwnProperty(t) && this._toolbars[t].removeToolbar();
        },
        setDrawingOptions: function(t) {
            for(var e in this._toolbars)this._toolbars[e] instanceof L.DrawToolbar && this._toolbars[e].setOptions(t);
        },
        _toolbarEnabled: function(t) {
            var e = t.target;
            for(var i in this._toolbars)this._toolbars[i] !== e && this._toolbars[i].disable();
        }
    }), L.Map.mergeOptions({
        drawControlTooltips: !0,
        drawControl: !1
    }), L.Map.addInitHook(function() {
        this.options.drawControl && (this.drawControl = new L.Control.Draw, this.addControl(this.drawControl));
    }), L.Toolbar = L.Class.extend({
        initialize: function(t) {
            L.setOptions(this, t), this._modes = {}, this._actionButtons = [], this._activeMode = null;
            var e = L.version.split(".");
            1 === parseInt(e[0], 10) && parseInt(e[1], 10) >= 2 ? L.Toolbar.include(L.Evented.prototype) : L.Toolbar.include(L.Mixin.Events);
        },
        enabled: function() {
            return null !== this._activeMode;
        },
        disable: function() {
            this.enabled() && this._activeMode.handler.disable();
        },
        addToolbar: function(t) {
            var e, i = L.DomUtil.create("div", "leaflet-draw-section"), o = 0, a = this._toolbarClass || "", n = this.getModeHandlers(t);
            for(this._toolbarContainer = L.DomUtil.create("div", "leaflet-draw-toolbar leaflet-bar"), this._map = t, e = 0; e < n.length; e++)n[e].enabled && this._initModeHandler(n[e].handler, this._toolbarContainer, o++, a, n[e].title);
            if (o) return this._lastButtonIndex = --o, this._actionsContainer = L.DomUtil.create("ul", "leaflet-draw-actions"), i.appendChild(this._toolbarContainer), i.appendChild(this._actionsContainer), i;
        },
        removeToolbar: function() {
            for(var t in this._modes)this._modes.hasOwnProperty(t) && (this._disposeButton(this._modes[t].button, this._modes[t].handler.enable, this._modes[t].handler), this._modes[t].handler.disable(), this._modes[t].handler.off("enabled", this._handlerActivated, this).off("disabled", this._handlerDeactivated, this));
            this._modes = {};
            for(var e = 0, i = this._actionButtons.length; e < i; e++)this._disposeButton(this._actionButtons[e].button, this._actionButtons[e].callback, this);
            this._actionButtons = [], this._actionsContainer = null;
        },
        _initModeHandler: function(t, e, i, o, a) {
            var n = t.type;
            this._modes[n] = {}, this._modes[n].handler = t, this._modes[n].button = this._createButton({
                type: n,
                title: a,
                className: o + "-" + n,
                container: e,
                callback: this._modes[n].handler.enable,
                context: this._modes[n].handler
            }), this._modes[n].buttonIndex = i, this._modes[n].handler.on("enabled", this._handlerActivated, this).on("disabled", this._handlerDeactivated, this);
        },
        _detectIOS: function() {
            return /iPad|iPhone|iPod/.test(navigator.userAgent) && !t.MSStream;
        },
        _createButton: function(t) {
            var e = L.DomUtil.create("a", t.className || "", t.container), i = L.DomUtil.create("span", "sr-only", t.container);
            e.href = "#", e.appendChild(i), t.title && (e.title = t.title, i.innerHTML = t.title), t.text && (e.innerHTML = t.text, i.innerHTML = t.text);
            var o = this._detectIOS() ? "touchstart" : "click";
            return L.DomEvent.on(e, "click", L.DomEvent.stopPropagation).on(e, "mousedown", L.DomEvent.stopPropagation).on(e, "dblclick", L.DomEvent.stopPropagation).on(e, "touchstart", L.DomEvent.stopPropagation).on(e, "click", L.DomEvent.preventDefault).on(e, o, t.callback, t.context), e;
        },
        _disposeButton: function(t, e) {
            var i = this._detectIOS() ? "touchstart" : "click";
            L.DomEvent.off(t, "click", L.DomEvent.stopPropagation).off(t, "mousedown", L.DomEvent.stopPropagation).off(t, "dblclick", L.DomEvent.stopPropagation).off(t, "touchstart", L.DomEvent.stopPropagation).off(t, "click", L.DomEvent.preventDefault).off(t, i, e);
        },
        _handlerActivated: function(t) {
            this.disable(), this._activeMode = this._modes[t.handler], L.DomUtil.addClass(this._activeMode.button, "leaflet-draw-toolbar-button-enabled"), this._showActionsToolbar(), this.fire("enable");
        },
        _handlerDeactivated: function() {
            this._hideActionsToolbar(), L.DomUtil.removeClass(this._activeMode.button, "leaflet-draw-toolbar-button-enabled"), this._activeMode = null, this.fire("disable");
        },
        _createActions: function(t) {
            var e, i, o, a, n = this._actionsContainer, s = this.getActions(t), r = s.length;
            for(i = 0, o = this._actionButtons.length; i < o; i++)this._disposeButton(this._actionButtons[i].button, this._actionButtons[i].callback);
            for(this._actionButtons = []; n.firstChild;)n.removeChild(n.firstChild);
            for(var l = 0; l < r; l++)"enabled" in s[l] && !s[l].enabled || (e = L.DomUtil.create("li", "", n), a = this._createButton({
                title: s[l].title,
                text: s[l].text,
                container: e,
                callback: s[l].callback,
                context: s[l].context
            }), this._actionButtons.push({
                button: a,
                callback: s[l].callback
            }));
        },
        _showActionsToolbar: function() {
            var t = this._activeMode.buttonIndex, e = this._lastButtonIndex, i = this._activeMode.button.offsetTop - 1;
            this._createActions(this._activeMode.handler), this._actionsContainer.style.top = i + "px", 0 === t && (L.DomUtil.addClass(this._toolbarContainer, "leaflet-draw-toolbar-notop"), L.DomUtil.addClass(this._actionsContainer, "leaflet-draw-actions-top")), t === e && (L.DomUtil.addClass(this._toolbarContainer, "leaflet-draw-toolbar-nobottom"), L.DomUtil.addClass(this._actionsContainer, "leaflet-draw-actions-bottom")), this._actionsContainer.style.display = "block", this._map.fire(L.Draw.Event.TOOLBAROPENED);
        },
        _hideActionsToolbar: function() {
            this._actionsContainer.style.display = "none", L.DomUtil.removeClass(this._toolbarContainer, "leaflet-draw-toolbar-notop"), L.DomUtil.removeClass(this._toolbarContainer, "leaflet-draw-toolbar-nobottom"), L.DomUtil.removeClass(this._actionsContainer, "leaflet-draw-actions-top"), L.DomUtil.removeClass(this._actionsContainer, "leaflet-draw-actions-bottom"), this._map.fire(L.Draw.Event.TOOLBARCLOSED);
        }
    }), L.Draw = L.Draw || {}, L.Draw.Tooltip = L.Class.extend({
        initialize: function(t) {
            this._map = t, this._popupPane = t._panes.popupPane, this._visible = !1, this._container = t.options.drawControlTooltips ? L.DomUtil.create("div", "leaflet-draw-tooltip", this._popupPane) : null, this._singleLineLabel = !1, this._map.on("mouseout", this._onMouseOut, this);
        },
        dispose: function() {
            this._map.off("mouseout", this._onMouseOut, this), this._container && (this._popupPane.removeChild(this._container), this._container = null);
        },
        updateContent: function(t) {
            return this._container ? (t.subtext = t.subtext || "", 0 !== t.subtext.length || this._singleLineLabel ? t.subtext.length > 0 && this._singleLineLabel && (L.DomUtil.removeClass(this._container, "leaflet-draw-tooltip-single"), this._singleLineLabel = !1) : (L.DomUtil.addClass(this._container, "leaflet-draw-tooltip-single"), this._singleLineLabel = !0), this._container.innerHTML = (t.subtext.length > 0 ? '<span class="leaflet-draw-tooltip-subtext">' + t.subtext + "</span><br />" : "") + "<span>" + t.text + "</span>", t.text || t.subtext ? (this._visible = !0, this._container.style.visibility = "inherit") : (this._visible = !1, this._container.style.visibility = "hidden"), this) : this;
        },
        updatePosition: function(t) {
            var e = this._map.latLngToLayerPoint(t), i = this._container;
            return this._container && (this._visible && (i.style.visibility = "inherit"), L.DomUtil.setPosition(i, e)), this;
        },
        showAsError: function() {
            return this._container && L.DomUtil.addClass(this._container, "leaflet-error-draw-tooltip"), this;
        },
        removeError: function() {
            return this._container && L.DomUtil.removeClass(this._container, "leaflet-error-draw-tooltip"), this;
        },
        _onMouseOut: function() {
            this._container && (this._container.style.visibility = "hidden");
        }
    }), L.DrawToolbar = L.Toolbar.extend({
        statics: {
            TYPE: "draw"
        },
        options: {
            polyline: {},
            polygon: {},
            rectangle: {},
            circle: {},
            marker: {},
            circlemarker: {}
        },
        initialize: function(t) {
            for(var e in this.options)this.options.hasOwnProperty(e) && t[e] && (t[e] = L.extend({}, this.options[e], t[e]));
            this._toolbarClass = "leaflet-draw-draw", L.Toolbar.prototype.initialize.call(this, t);
        },
        getModeHandlers: function(t) {
            return [
                {
                    enabled: this.options.polyline,
                    handler: new L.Draw.Polyline(t, this.options.polyline),
                    title: L.drawLocal.draw.toolbar.buttons.polyline
                },
                {
                    enabled: this.options.polygon,
                    handler: new L.Draw.Polygon(t, this.options.polygon),
                    title: L.drawLocal.draw.toolbar.buttons.polygon
                },
                {
                    enabled: this.options.rectangle,
                    handler: new L.Draw.Rectangle(t, this.options.rectangle),
                    title: L.drawLocal.draw.toolbar.buttons.rectangle
                },
                {
                    enabled: this.options.circle,
                    handler: new L.Draw.Circle(t, this.options.circle),
                    title: L.drawLocal.draw.toolbar.buttons.circle
                },
                {
                    enabled: this.options.marker,
                    handler: new L.Draw.Marker(t, this.options.marker),
                    title: L.drawLocal.draw.toolbar.buttons.marker
                },
                {
                    enabled: this.options.circlemarker,
                    handler: new L.Draw.CircleMarker(t, this.options.circlemarker),
                    title: L.drawLocal.draw.toolbar.buttons.circlemarker
                }
            ];
        },
        getActions: function(t) {
            return [
                {
                    enabled: t.completeShape,
                    title: L.drawLocal.draw.toolbar.finish.title,
                    text: L.drawLocal.draw.toolbar.finish.text,
                    callback: t.completeShape,
                    context: t
                },
                {
                    enabled: t.deleteLastVertex,
                    title: L.drawLocal.draw.toolbar.undo.title,
                    text: L.drawLocal.draw.toolbar.undo.text,
                    callback: t.deleteLastVertex,
                    context: t
                },
                {
                    title: L.drawLocal.draw.toolbar.actions.title,
                    text: L.drawLocal.draw.toolbar.actions.text,
                    callback: this.disable,
                    context: this
                }
            ];
        },
        setOptions: function(t) {
            L.setOptions(this, t);
            for(var e in this._modes)this._modes.hasOwnProperty(e) && t.hasOwnProperty(e) && this._modes[e].handler.setOptions(t[e]);
        }
    }), L.EditToolbar = L.Toolbar.extend({
        statics: {
            TYPE: "edit"
        },
        options: {
            edit: {
                selectedPathOptions: {
                    dashArray: "10, 10",
                    fill: !0,
                    fillColor: "#fe57a1",
                    fillOpacity: .1,
                    maintainColor: !1
                }
            },
            remove: {},
            poly: null,
            featureGroup: null
        },
        initialize: function(t) {
            t.edit && (void 0 === t.edit.selectedPathOptions && (t.edit.selectedPathOptions = this.options.edit.selectedPathOptions), t.edit.selectedPathOptions = L.extend({}, this.options.edit.selectedPathOptions, t.edit.selectedPathOptions)), t.remove && (t.remove = L.extend({}, this.options.remove, t.remove)), t.poly && (t.poly = L.extend({}, this.options.poly, t.poly)), this._toolbarClass = "leaflet-draw-edit", L.Toolbar.prototype.initialize.call(this, t), this._selectedFeatureCount = 0;
        },
        getModeHandlers: function(t) {
            var e = this.options.featureGroup;
            return [
                {
                    enabled: this.options.edit,
                    handler: new L.EditToolbar.Edit(t, {
                        featureGroup: e,
                        selectedPathOptions: this.options.edit.selectedPathOptions,
                        poly: this.options.poly
                    }),
                    title: L.drawLocal.edit.toolbar.buttons.edit
                },
                {
                    enabled: this.options.remove,
                    handler: new L.EditToolbar.Delete(t, {
                        featureGroup: e
                    }),
                    title: L.drawLocal.edit.toolbar.buttons.remove
                }
            ];
        },
        getActions: function(t) {
            var e = [
                {
                    title: L.drawLocal.edit.toolbar.actions.save.title,
                    text: L.drawLocal.edit.toolbar.actions.save.text,
                    callback: this._save,
                    context: this
                },
                {
                    title: L.drawLocal.edit.toolbar.actions.cancel.title,
                    text: L.drawLocal.edit.toolbar.actions.cancel.text,
                    callback: this.disable,
                    context: this
                }
            ];
            return t.removeAllLayers && e.push({
                title: L.drawLocal.edit.toolbar.actions.clearAll.title,
                text: L.drawLocal.edit.toolbar.actions.clearAll.text,
                callback: this._clearAllLayers,
                context: this
            }), e;
        },
        addToolbar: function(t) {
            var e = L.Toolbar.prototype.addToolbar.call(this, t);
            return this._checkDisabled(), this.options.featureGroup.on("layeradd layerremove", this._checkDisabled, this), e;
        },
        removeToolbar: function() {
            this.options.featureGroup.off("layeradd layerremove", this._checkDisabled, this), L.Toolbar.prototype.removeToolbar.call(this);
        },
        disable: function() {
            this.enabled() && (this._activeMode.handler.revertLayers(), L.Toolbar.prototype.disable.call(this));
        },
        _save: function() {
            this._activeMode.handler.save(), this._activeMode && this._activeMode.handler.disable();
        },
        _clearAllLayers: function() {
            this._activeMode.handler.removeAllLayers(), this._activeMode && this._activeMode.handler.disable();
        },
        _checkDisabled: function() {
            var t, e = this.options.featureGroup, i = 0 !== e.getLayers().length;
            this.options.edit && (t = this._modes[L.EditToolbar.Edit.TYPE].button, i ? L.DomUtil.removeClass(t, "leaflet-disabled") : L.DomUtil.addClass(t, "leaflet-disabled"), t.setAttribute("title", i ? L.drawLocal.edit.toolbar.buttons.edit : L.drawLocal.edit.toolbar.buttons.editDisabled)), this.options.remove && (t = this._modes[L.EditToolbar.Delete.TYPE].button, i ? L.DomUtil.removeClass(t, "leaflet-disabled") : L.DomUtil.addClass(t, "leaflet-disabled"), t.setAttribute("title", i ? L.drawLocal.edit.toolbar.buttons.remove : L.drawLocal.edit.toolbar.buttons.removeDisabled));
        }
    }), L.EditToolbar.Edit = L.Handler.extend({
        statics: {
            TYPE: "edit"
        },
        initialize: function(t, e) {
            if (L.Handler.prototype.initialize.call(this, t), L.setOptions(this, e), this._featureGroup = e.featureGroup, !(this._featureGroup instanceof L.FeatureGroup)) throw new Error("options.featureGroup must be a L.FeatureGroup");
            this._uneditedLayerProps = {}, this.type = L.EditToolbar.Edit.TYPE;
            var i = L.version.split(".");
            1 === parseInt(i[0], 10) && parseInt(i[1], 10) >= 2 ? L.EditToolbar.Edit.include(L.Evented.prototype) : L.EditToolbar.Edit.include(L.Mixin.Events);
        },
        enable: function() {
            !this._enabled && this._hasAvailableLayers() && (this.fire("enabled", {
                handler: this.type
            }), this._map.fire(L.Draw.Event.EDITSTART, {
                handler: this.type
            }), L.Handler.prototype.enable.call(this), this._featureGroup.on("layeradd", this._enableLayerEdit, this).on("layerremove", this._disableLayerEdit, this));
        },
        disable: function() {
            this._enabled && (this._featureGroup.off("layeradd", this._enableLayerEdit, this).off("layerremove", this._disableLayerEdit, this), L.Handler.prototype.disable.call(this), this._map.fire(L.Draw.Event.EDITSTOP, {
                handler: this.type
            }), this.fire("disabled", {
                handler: this.type
            }));
        },
        addHooks: function() {
            var t = this._map;
            t && (t.getContainer().focus(), this._featureGroup.eachLayer(this._enableLayerEdit, this), this._tooltip = new L.Draw.Tooltip(this._map), this._tooltip.updateContent({
                text: L.drawLocal.edit.handlers.edit.tooltip.text,
                subtext: L.drawLocal.edit.handlers.edit.tooltip.subtext
            }), t._editTooltip = this._tooltip, this._updateTooltip(), this._map.on("mousemove", this._onMouseMove, this).on("touchmove", this._onMouseMove, this).on("MSPointerMove", this._onMouseMove, this).on(L.Draw.Event.EDITVERTEX, this._updateTooltip, this));
        },
        removeHooks: function() {
            this._map && (this._featureGroup.eachLayer(this._disableLayerEdit, this), this._uneditedLayerProps = {}, this._tooltip.dispose(), this._tooltip = null, this._map.off("mousemove", this._onMouseMove, this).off("touchmove", this._onMouseMove, this).off("MSPointerMove", this._onMouseMove, this).off(L.Draw.Event.EDITVERTEX, this._updateTooltip, this));
        },
        revertLayers: function() {
            this._featureGroup.eachLayer(function(t) {
                this._revertLayer(t);
            }, this);
        },
        save: function() {
            var t = new L.LayerGroup;
            this._featureGroup.eachLayer(function(e) {
                e.edited && (t.addLayer(e), e.edited = !1);
            }), this._map.fire(L.Draw.Event.EDITED, {
                layers: t
            });
        },
        _backupLayer: function(t) {
            var e = L.Util.stamp(t);
            this._uneditedLayerProps[e] || (t instanceof L.Polyline || t instanceof L.Polygon || t instanceof L.Rectangle ? this._uneditedLayerProps[e] = {
                latlngs: L.LatLngUtil.cloneLatLngs(t.getLatLngs())
            } : t instanceof L.Circle ? this._uneditedLayerProps[e] = {
                latlng: L.LatLngUtil.cloneLatLng(t.getLatLng()),
                radius: t.getRadius()
            } : (t instanceof L.Marker || t instanceof L.CircleMarker) && (this._uneditedLayerProps[e] = {
                latlng: L.LatLngUtil.cloneLatLng(t.getLatLng())
            }));
        },
        _getTooltipText: function() {
            return {
                text: L.drawLocal.edit.handlers.edit.tooltip.text,
                subtext: L.drawLocal.edit.handlers.edit.tooltip.subtext
            };
        },
        _updateTooltip: function() {
            this._tooltip.updateContent(this._getTooltipText());
        },
        _revertLayer: function(t) {
            var e = L.Util.stamp(t);
            t.edited = !1, this._uneditedLayerProps.hasOwnProperty(e) && (t instanceof L.Polyline || t instanceof L.Polygon || t instanceof L.Rectangle ? t.setLatLngs(this._uneditedLayerProps[e].latlngs) : t instanceof L.Circle ? (t.setLatLng(this._uneditedLayerProps[e].latlng), t.setRadius(this._uneditedLayerProps[e].radius)) : (t instanceof L.Marker || t instanceof L.CircleMarker) && t.setLatLng(this._uneditedLayerProps[e].latlng), t.fire("revert-edited", {
                layer: t
            }));
        },
        _enableLayerEdit: function(t) {
            var e, i, o = t.layer || t.target || t;
            this._backupLayer(o), this.options.poly && (i = L.Util.extend({}, this.options.poly), o.options.poly = i), this.options.selectedPathOptions && (e = L.Util.extend({}, this.options.selectedPathOptions), e.maintainColor && (e.color = o.options.color, e.fillColor = o.options.fillColor), o.options.original = L.extend({}, o.options), o.options.editing = e), o instanceof L.Marker ? (o.editing && o.editing.enable(), o.dragging.enable(), o.on("dragend", this._onMarkerDragEnd).on("touchmove", this._onTouchMove, this).on("MSPointerMove", this._onTouchMove, this).on("touchend", this._onMarkerDragEnd, this).on("MSPointerUp", this._onMarkerDragEnd, this)) : o.editing.enable();
        },
        _disableLayerEdit: function(t) {
            var e = t.layer || t.target || t;
            e.edited = !1, e.editing && e.editing.disable(), delete e.options.editing, delete e.options.original, this._selectedPathOptions && (e instanceof L.Marker ? this._toggleMarkerHighlight(e) : (e.setStyle(e.options.previousOptions), delete e.options.previousOptions)), e instanceof L.Marker ? (e.dragging.disable(), e.off("dragend", this._onMarkerDragEnd, this).off("touchmove", this._onTouchMove, this).off("MSPointerMove", this._onTouchMove, this).off("touchend", this._onMarkerDragEnd, this).off("MSPointerUp", this._onMarkerDragEnd, this)) : e.editing.disable();
        },
        _onMouseMove: function(t) {
            this._tooltip.updatePosition(t.latlng);
        },
        _onMarkerDragEnd: function(t) {
            var e = t.target;
            e.edited = !0, this._map.fire(L.Draw.Event.EDITMOVE, {
                layer: e
            });
        },
        _onTouchMove: function(t) {
            var e = t.originalEvent.changedTouches[0], i = this._map.mouseEventToLayerPoint(e), o = this._map.layerPointToLatLng(i);
            t.target.setLatLng(o);
        },
        _hasAvailableLayers: function() {
            return 0 !== this._featureGroup.getLayers().length;
        }
    }), L.EditToolbar.Delete = L.Handler.extend({
        statics: {
            TYPE: "remove"
        },
        initialize: function(t, e) {
            if (L.Handler.prototype.initialize.call(this, t), L.Util.setOptions(this, e), this._deletableLayers = this.options.featureGroup, !(this._deletableLayers instanceof L.FeatureGroup)) throw new Error("options.featureGroup must be a L.FeatureGroup");
            this.type = L.EditToolbar.Delete.TYPE;
            var i = L.version.split(".");
            1 === parseInt(i[0], 10) && parseInt(i[1], 10) >= 2 ? L.EditToolbar.Delete.include(L.Evented.prototype) : L.EditToolbar.Delete.include(L.Mixin.Events);
        },
        enable: function() {
            !this._enabled && this._hasAvailableLayers() && (this.fire("enabled", {
                handler: this.type
            }), this._map.fire(L.Draw.Event.DELETESTART, {
                handler: this.type
            }), L.Handler.prototype.enable.call(this), this._deletableLayers.on("layeradd", this._enableLayerDelete, this).on("layerremove", this._disableLayerDelete, this));
        },
        disable: function() {
            this._enabled && (this._deletableLayers.off("layeradd", this._enableLayerDelete, this).off("layerremove", this._disableLayerDelete, this), L.Handler.prototype.disable.call(this), this._map.fire(L.Draw.Event.DELETESTOP, {
                handler: this.type
            }), this.fire("disabled", {
                handler: this.type
            }));
        },
        addHooks: function() {
            var t = this._map;
            t && (t.getContainer().focus(), this._deletableLayers.eachLayer(this._enableLayerDelete, this), this._deletedLayers = new L.LayerGroup, this._tooltip = new L.Draw.Tooltip(this._map), this._tooltip.updateContent({
                text: L.drawLocal.edit.handlers.remove.tooltip.text
            }), this._map.on("mousemove", this._onMouseMove, this));
        },
        removeHooks: function() {
            this._map && (this._deletableLayers.eachLayer(this._disableLayerDelete, this), this._deletedLayers = null, this._tooltip.dispose(), this._tooltip = null, this._map.off("mousemove", this._onMouseMove, this));
        },
        revertLayers: function() {
            this._deletedLayers.eachLayer(function(t) {
                this._deletableLayers.addLayer(t), t.fire("revert-deleted", {
                    layer: t
                });
            }, this);
        },
        save: function() {
            this._map.fire(L.Draw.Event.DELETED, {
                layers: this._deletedLayers
            });
        },
        removeAllLayers: function() {
            this._deletableLayers.eachLayer(function(t) {
                this._removeLayer({
                    layer: t
                });
            }, this), this.save();
        },
        _enableLayerDelete: function(t) {
            (t.layer || t.target || t).on("click", this._removeLayer, this);
        },
        _disableLayerDelete: function(t) {
            var e = t.layer || t.target || t;
            e.off("click", this._removeLayer, this), this._deletedLayers.removeLayer(e);
        },
        _removeLayer: function(t) {
            var e = t.layer || t.target || t;
            this._deletableLayers.removeLayer(e), this._deletedLayers.addLayer(e), e.fire("deleted");
        },
        _onMouseMove: function(t) {
            this._tooltip.updatePosition(t.latlng);
        },
        _hasAvailableLayers: function() {
            return 0 !== this._deletableLayers.getLayers().length;
        }
    });
}(window, document);



var $2q7Wm = parcelRequire("2q7Wm");

var $6KOho = parcelRequire("6KOho");

/*
   Copyright 2023, Guillermo Vega-Gorgojo

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ 
var $33Kba = parcelRequire("33Kba");

var $8JYDX = parcelRequire("8JYDX");

/////////////////
// CÁLCULO CELDAS
// obtengo el lado de cada celda (dependiente del zoom) a partir de la referencia:
// config.zDegreesStep4 es el número de grados para zoom 4
function $0a5d75214fa44e03$export$c7c0bc1741de0bee(zoom) {
    if (!(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).cellSide[zoom]) {
        const potencia = Math.pow(2, zoom - 4);
        (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).cellSide[zoom] = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zDegreesStep4 / potencia;
    }
    return (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).cellSide[zoom];
}
// a partir de unos bounds genero la malla que lo envuelve para el zoom z
function $0a5d75214fa44e03$export$85a47b3ccce199ed(bounds, z) {
    // recupero zoom
    const zoom = z ? z : Sesion.zoom;
    // recupero cellSide
    const cellSide = $0a5d75214fa44e03$export$c7c0bc1741de0bee(zoom);
    // preparo grid
    const grid = {
        'cellN': Math.floor(bounds.getNorth() / cellSide),
        'cellS': Math.floor(bounds.getSouth() / cellSide),
        'cellE': Math.floor(bounds.getEast() / cellSide),
        'cellW': Math.floor(bounds.getWest() / cellSide)
    };
    // devuelvo grid
    return grid;
}
// los bounds de un grid
function $0a5d75214fa44e03$export$bcb885fb505ac675(grid, z) {
    // recupero zoom
    const zoom = z ? z : Sesion.zoom;
    // recupero cellSide
    const cellSide = $0a5d75214fa44e03$export$c7c0bc1741de0bee(zoom);
    // devuelvo objeto bounds en formato Leaflet
    return (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).latLngBounds([
        [
            grid.cellS * cellSide,
            grid.cellW * cellSide
        ],
        [
            (grid.cellN + 1) * cellSide,
            (grid.cellE + 1) * cellSide
        ] // E			
    ]);
}
// los bounds de una celda
function $0a5d75214fa44e03$export$4e23e15d2ccb71f7(cellX, cellY, z) {
    // recupero zoom
    const zoom = z ? z : Sesion.zoom;
    // recupero cellSide
    const cellSide = $0a5d75214fa44e03$export$c7c0bc1741de0bee(zoom);
    // devuelvo objeto bounds en formato Leaflet
    return (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).latLngBounds([
        [
            cellY * cellSide,
            cellX * cellSide
        ],
        [
            (cellY + 1) * cellSide,
            (cellX + 1) * cellSide
        ] // E			
    ]);
}
// para una celda dada obtengo el grid para cada nivel de zoom
function $0a5d75214fa44e03$export$bed42eae0b34c43c(cellX, cellY, z, zvalidos) {
    // primero recupero los bounds de la celda
    let bounds = $0a5d75214fa44e03$export$4e23e15d2ccb71f7(cellX, cellY, z);
    // para evitar el efecto borde, contraigo ligeramente los bounds (1 por diez mil)
    const red = (bounds.getEast() - bounds.getWest()) / 10000;
    bounds = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).latLngBounds([
        [
            bounds.getSouth() + red,
            bounds.getWest() + red
        ],
        [
            bounds.getNorth() - red,
            bounds.getEast() - red
        ] // E
    ]);
    // preparo un objeto con el grid para cada nivel de zoom
    let ocgm = {};
    for(let i = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).minZoom; i <= (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).maxZoom; i++)if (zvalidos == undefined || zvalidos[i]) ocgm[i] = $0a5d75214fa44e03$export$85a47b3ccce199ed(bounds, i);
    return ocgm;
}



/*
   Copyright 2023, Guillermo Vega-Gorgojo

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ 
var $33Kba = parcelRequire("33Kba");



var $86cnQ = parcelRequire("86cnQ");

var $dPHSJ = parcelRequire("dPHSJ");

var $7vOQ3 = parcelRequire("7vOQ3");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Constants used in the Firebase Storage library.
 */ /**
 * Domain name for firebase storage.
 */ const $63c1f7f3542429ef$var$DEFAULT_HOST = 'firebasestorage.googleapis.com';
/**
 * The key in Firebase config json for the storage bucket.
 */ const $63c1f7f3542429ef$var$CONFIG_STORAGE_BUCKET_KEY = 'storageBucket';
/**
 * 2 minutes
 *
 * The timeout for all operations except upload.
 */ const $63c1f7f3542429ef$var$DEFAULT_MAX_OPERATION_RETRY_TIME = 120000;
/**
 * 10 minutes
 *
 * The timeout for upload.
 */ const $63c1f7f3542429ef$var$DEFAULT_MAX_UPLOAD_RETRY_TIME = 600000;
/**
 * 1 second
 */ const $63c1f7f3542429ef$var$DEFAULT_MIN_SLEEP_TIME_MILLIS = 1000;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An error returned by the Firebase Storage SDK.
 * @public
 */ class $63c1f7f3542429ef$export$697502632950e9d3 extends (0, $dPHSJ.FirebaseError) {
    /**
     * @param code - A `StorageErrorCode` string to be prefixed with 'storage/' and
     *  added to the end of the message.
     * @param message  - Error message.
     * @param status_ - Corresponding HTTP Status Code
     */ constructor(code, message, status_ = 0){
        super($63c1f7f3542429ef$var$prependCode(code), `Firebase Storage: ${message} (${$63c1f7f3542429ef$var$prependCode(code)})`);
        this.status_ = status_;
        /**
         * Stores custom error data unique to the `StorageError`.
         */ this.customData = {
            serverResponse: null
        };
        this._baseMessage = this.message;
        // Without this, `instanceof StorageError`, in tests for example,
        // returns false.
        Object.setPrototypeOf(this, $63c1f7f3542429ef$export$697502632950e9d3.prototype);
    }
    get status() {
        return this.status_;
    }
    set status(status) {
        this.status_ = status;
    }
    /**
     * Compares a `StorageErrorCode` against this error's code, filtering out the prefix.
     */ _codeEquals(code) {
        return $63c1f7f3542429ef$var$prependCode(code) === this.code;
    }
    /**
     * Optional response message that was added by the server.
     */ get serverResponse() {
        return this.customData.serverResponse;
    }
    set serverResponse(serverResponse) {
        this.customData.serverResponse = serverResponse;
        if (this.customData.serverResponse) this.message = `${this._baseMessage}\n${this.customData.serverResponse}`;
        else this.message = this._baseMessage;
    }
}
/**
 * @public
 * Error codes that can be attached to `StorageError` objects.
 */ var $63c1f7f3542429ef$export$54592d666d6ce114;
(function(StorageErrorCode) {
    // Shared between all platforms
    StorageErrorCode["UNKNOWN"] = "unknown";
    StorageErrorCode["OBJECT_NOT_FOUND"] = "object-not-found";
    StorageErrorCode["BUCKET_NOT_FOUND"] = "bucket-not-found";
    StorageErrorCode["PROJECT_NOT_FOUND"] = "project-not-found";
    StorageErrorCode["QUOTA_EXCEEDED"] = "quota-exceeded";
    StorageErrorCode["UNAUTHENTICATED"] = "unauthenticated";
    StorageErrorCode["UNAUTHORIZED"] = "unauthorized";
    StorageErrorCode["UNAUTHORIZED_APP"] = "unauthorized-app";
    StorageErrorCode["RETRY_LIMIT_EXCEEDED"] = "retry-limit-exceeded";
    StorageErrorCode["INVALID_CHECKSUM"] = "invalid-checksum";
    StorageErrorCode["CANCELED"] = "canceled";
    // JS specific
    StorageErrorCode["INVALID_EVENT_NAME"] = "invalid-event-name";
    StorageErrorCode["INVALID_URL"] = "invalid-url";
    StorageErrorCode["INVALID_DEFAULT_BUCKET"] = "invalid-default-bucket";
    StorageErrorCode["NO_DEFAULT_BUCKET"] = "no-default-bucket";
    StorageErrorCode["CANNOT_SLICE_BLOB"] = "cannot-slice-blob";
    StorageErrorCode["SERVER_FILE_WRONG_SIZE"] = "server-file-wrong-size";
    StorageErrorCode["NO_DOWNLOAD_URL"] = "no-download-url";
    StorageErrorCode["INVALID_ARGUMENT"] = "invalid-argument";
    StorageErrorCode["INVALID_ARGUMENT_COUNT"] = "invalid-argument-count";
    StorageErrorCode["APP_DELETED"] = "app-deleted";
    StorageErrorCode["INVALID_ROOT_OPERATION"] = "invalid-root-operation";
    StorageErrorCode["INVALID_FORMAT"] = "invalid-format";
    StorageErrorCode["INTERNAL_ERROR"] = "internal-error";
    StorageErrorCode["UNSUPPORTED_ENVIRONMENT"] = "unsupported-environment";
})($63c1f7f3542429ef$export$54592d666d6ce114 || ($63c1f7f3542429ef$export$54592d666d6ce114 = {}));
function $63c1f7f3542429ef$var$prependCode(code) {
    return 'storage/' + code;
}
function $63c1f7f3542429ef$var$unknown() {
    const message = "An unknown error occurred, please check the error payload for server response.";
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.UNKNOWN, message);
}
function $63c1f7f3542429ef$var$objectNotFound(path) {
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.OBJECT_NOT_FOUND, "Object '" + path + "' does not exist.");
}
function $63c1f7f3542429ef$var$quotaExceeded(bucket) {
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.QUOTA_EXCEEDED, "Quota for bucket '" + bucket + "' exceeded, please view quota on " + 'https://firebase.google.com/pricing/.');
}
function $63c1f7f3542429ef$var$unauthenticated() {
    const message = "User is not authenticated, please authenticate using Firebase Authentication and try again.";
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.UNAUTHENTICATED, message);
}
function $63c1f7f3542429ef$var$unauthorizedApp() {
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.UNAUTHORIZED_APP, 'This app does not have permission to access Firebase Storage on this project.');
}
function $63c1f7f3542429ef$var$unauthorized(path) {
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.UNAUTHORIZED, "User does not have permission to access '" + path + "'.");
}
function $63c1f7f3542429ef$var$retryLimitExceeded() {
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.RETRY_LIMIT_EXCEEDED, 'Max retry time for operation exceeded, please try again.');
}
function $63c1f7f3542429ef$var$canceled() {
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.CANCELED, 'User canceled the upload/download.');
}
function $63c1f7f3542429ef$var$invalidUrl(url) {
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.INVALID_URL, "Invalid URL '" + url + "'.");
}
function $63c1f7f3542429ef$var$invalidDefaultBucket(bucket) {
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.INVALID_DEFAULT_BUCKET, "Invalid default bucket '" + bucket + "'.");
}
function $63c1f7f3542429ef$var$noDefaultBucket() {
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.NO_DEFAULT_BUCKET, "No default bucket found. Did you set the '" + $63c1f7f3542429ef$var$CONFIG_STORAGE_BUCKET_KEY + "' property when initializing the app?");
}
function $63c1f7f3542429ef$var$cannotSliceBlob() {
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.CANNOT_SLICE_BLOB, 'Cannot slice blob for upload. Please retry the upload.');
}
function $63c1f7f3542429ef$var$serverFileWrongSize() {
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.SERVER_FILE_WRONG_SIZE, 'Server recorded incorrect upload file size, please retry the upload.');
}
function $63c1f7f3542429ef$var$noDownloadURL() {
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.NO_DOWNLOAD_URL, 'The given file does not have any download URLs.');
}
function $63c1f7f3542429ef$var$missingPolyFill(polyFill) {
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.UNSUPPORTED_ENVIRONMENT, `${polyFill} is missing. Make sure to install the required polyfills. See https://firebase.google.com/docs/web/environments-js-sdk#polyfills for more information.`);
}
/**
 * @internal
 */ function $63c1f7f3542429ef$export$8f74d9881d1936fd(message) {
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.INVALID_ARGUMENT, message);
}
function $63c1f7f3542429ef$var$appDeleted() {
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.APP_DELETED, 'The Firebase app was deleted.');
}
/**
 * @param name - The name of the operation that was invalid.
 *
 * @internal
 */ function $63c1f7f3542429ef$export$61f54cdc36500ad(name) {
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.INVALID_ROOT_OPERATION, "The operation '" + name + "' cannot be performed on a root reference, create a non-root " + "reference using child, such as .child('file.png').");
}
/**
 * @param format - The format that was not valid.
 * @param message - A message describing the format violation.
 */ function $63c1f7f3542429ef$var$invalidFormat(format, message) {
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.INVALID_FORMAT, "String does not match format '" + format + "': " + message);
}
/**
 * @param message - A message describing the internal error.
 */ function $63c1f7f3542429ef$var$internalError(message) {
    throw new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.INTERNAL_ERROR, 'Internal error: ' + message);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Functionality related to the parsing/composition of bucket/
 * object location.
 */ /**
 * Firebase Storage location data.
 *
 * @internal
 */ class $63c1f7f3542429ef$export$adb98fff6714334 {
    constructor(bucket, path){
        this.bucket = bucket;
        this.path_ = path;
    }
    get path() {
        return this.path_;
    }
    get isRoot() {
        return this.path.length === 0;
    }
    fullServerUrl() {
        const encode = encodeURIComponent;
        return '/b/' + encode(this.bucket) + '/o/' + encode(this.path);
    }
    bucketOnlyServerUrl() {
        const encode = encodeURIComponent;
        return '/b/' + encode(this.bucket) + '/o';
    }
    static makeFromBucketSpec(bucketString, host) {
        let bucketLocation;
        try {
            bucketLocation = $63c1f7f3542429ef$export$adb98fff6714334.makeFromUrl(bucketString, host);
        } catch (e) {
            // Not valid URL, use as-is. This lets you put bare bucket names in
            // config.
            return new $63c1f7f3542429ef$export$adb98fff6714334(bucketString, '');
        }
        if (bucketLocation.path === '') return bucketLocation;
        else throw $63c1f7f3542429ef$var$invalidDefaultBucket(bucketString);
    }
    static makeFromUrl(url, host) {
        let location = null;
        const bucketDomain = '([A-Za-z0-9.\\-_]+)';
        function gsModify(loc) {
            if (loc.path.charAt(loc.path.length - 1) === '/') loc.path_ = loc.path_.slice(0, -1);
        }
        const gsPath = '(/(.*))?$';
        const gsRegex = new RegExp('^gs://' + bucketDomain + gsPath, 'i');
        const gsIndices = {
            bucket: 1,
            path: 3
        };
        function httpModify(loc) {
            loc.path_ = decodeURIComponent(loc.path);
        }
        const version = 'v[A-Za-z0-9_]+';
        const firebaseStorageHost = host.replace(/[.]/g, '\\.');
        const firebaseStoragePath = '(/([^?#]*).*)?$';
        const firebaseStorageRegExp = new RegExp(`^https?://${firebaseStorageHost}/${version}/b/${bucketDomain}/o${firebaseStoragePath}`, 'i');
        const firebaseStorageIndices = {
            bucket: 1,
            path: 3
        };
        const cloudStorageHost = host === $63c1f7f3542429ef$var$DEFAULT_HOST ? '(?:storage.googleapis.com|storage.cloud.google.com)' : host;
        const cloudStoragePath = '([^?#]*)';
        const cloudStorageRegExp = new RegExp(`^https?://${cloudStorageHost}/${bucketDomain}/${cloudStoragePath}`, 'i');
        const cloudStorageIndices = {
            bucket: 1,
            path: 2
        };
        const groups = [
            {
                regex: gsRegex,
                indices: gsIndices,
                postModify: gsModify
            },
            {
                regex: firebaseStorageRegExp,
                indices: firebaseStorageIndices,
                postModify: httpModify
            },
            {
                regex: cloudStorageRegExp,
                indices: cloudStorageIndices,
                postModify: httpModify
            }
        ];
        for(let i = 0; i < groups.length; i++){
            const group = groups[i];
            const captures = group.regex.exec(url);
            if (captures) {
                const bucketValue = captures[group.indices.bucket];
                let pathValue = captures[group.indices.path];
                if (!pathValue) pathValue = '';
                location = new $63c1f7f3542429ef$export$adb98fff6714334(bucketValue, pathValue);
                group.postModify(location);
                break;
            }
        }
        if (location == null) throw $63c1f7f3542429ef$var$invalidUrl(url);
        return location;
    }
}
/**
 * A request whose promise always fails.
 */ class $63c1f7f3542429ef$var$FailRequest {
    constructor(error){
        this.promise_ = Promise.reject(error);
    }
    /** @inheritDoc */ getPromise() {
        return this.promise_;
    }
    /** @inheritDoc */ cancel(_appDelete = false) {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Accepts a callback for an action to perform (`doRequest`),
 * and then a callback for when the backoff has completed (`backoffCompleteCb`).
 * The callback sent to start requires an argument to call (`onRequestComplete`).
 * When `start` calls `doRequest`, it passes a callback for when the request has
 * completed, `onRequestComplete`. Based on this, the backoff continues, with
 * another call to `doRequest` and the above loop continues until the timeout
 * is hit, or a successful response occurs.
 * @description
 * @param doRequest Callback to perform request
 * @param backoffCompleteCb Callback to call when backoff has been completed
 */ function $63c1f7f3542429ef$var$start(doRequest, // eslint-disable-next-line @typescript-eslint/no-explicit-any
backoffCompleteCb, timeout) {
    // TODO(andysoto): make this code cleaner (probably refactor into an actual
    // type instead of a bunch of functions with state shared in the closure)
    let waitSeconds = 1;
    // Would type this as "number" but that doesn't work for Node so ¯\_(ツ)_/¯
    // TODO: find a way to exclude Node type definition for storage because storage only works in browser
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let retryTimeoutId = null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let globalTimeoutId = null;
    let hitTimeout = false;
    let cancelState = 0;
    function canceled() {
        return cancelState === 2;
    }
    let triggeredCallback = false;
    function triggerCallback(...args) {
        if (!triggeredCallback) {
            triggeredCallback = true;
            backoffCompleteCb.apply(null, args);
        }
    }
    function callWithDelay(millis) {
        retryTimeoutId = setTimeout(()=>{
            retryTimeoutId = null;
            doRequest(responseHandler, canceled());
        }, millis);
    }
    function clearGlobalTimeout() {
        if (globalTimeoutId) clearTimeout(globalTimeoutId);
    }
    function responseHandler(success, ...args) {
        if (triggeredCallback) {
            clearGlobalTimeout();
            return;
        }
        if (success) {
            clearGlobalTimeout();
            triggerCallback.call(null, success, ...args);
            return;
        }
        const mustStop = canceled() || hitTimeout;
        if (mustStop) {
            clearGlobalTimeout();
            triggerCallback.call(null, success, ...args);
            return;
        }
        if (waitSeconds < 64) /* TODO(andysoto): don't back off so quickly if we know we're offline. */ waitSeconds *= 2;
        let waitMillis;
        if (cancelState === 1) {
            cancelState = 2;
            waitMillis = 0;
        } else waitMillis = (waitSeconds + Math.random()) * 1000;
        callWithDelay(waitMillis);
    }
    let stopped = false;
    function stop(wasTimeout) {
        if (stopped) return;
        stopped = true;
        clearGlobalTimeout();
        if (triggeredCallback) return;
        if (retryTimeoutId !== null) {
            if (!wasTimeout) cancelState = 2;
            clearTimeout(retryTimeoutId);
            callWithDelay(0);
        } else if (!wasTimeout) cancelState = 1;
    }
    callWithDelay(0);
    globalTimeoutId = setTimeout(()=>{
        hitTimeout = true;
        stop(true);
    }, timeout);
    return stop;
}
/**
 * Stops the retry loop from repeating.
 * If the function is currently "in between" retries, it is invoked immediately
 * with the second parameter as "true". Otherwise, it will be invoked once more
 * after the current invocation finishes iff the current invocation would have
 * triggered another retry.
 */ function $63c1f7f3542429ef$var$stop(id) {
    id(false);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $63c1f7f3542429ef$var$isJustDef(p) {
    return p !== void 0;
}
// eslint-disable-next-line @typescript-eslint/ban-types
function $63c1f7f3542429ef$var$isFunction(p) {
    return typeof p === 'function';
}
function $63c1f7f3542429ef$var$isNonArrayObject(p) {
    return typeof p === 'object' && !Array.isArray(p);
}
function $63c1f7f3542429ef$var$isString(p) {
    return typeof p === 'string' || p instanceof String;
}
function $63c1f7f3542429ef$var$isNativeBlob(p) {
    return $63c1f7f3542429ef$var$isNativeBlobDefined() && p instanceof Blob;
}
function $63c1f7f3542429ef$var$isNativeBlobDefined() {
    return typeof Blob !== 'undefined';
}
function $63c1f7f3542429ef$var$validateNumber(argument, minValue, maxValue, value) {
    if (value < minValue) throw $63c1f7f3542429ef$export$8f74d9881d1936fd(`Invalid value for '${argument}'. Expected ${minValue} or greater.`);
    if (value > maxValue) throw $63c1f7f3542429ef$export$8f74d9881d1936fd(`Invalid value for '${argument}'. Expected ${maxValue} or less.`);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $63c1f7f3542429ef$var$makeUrl(urlPart, host, protocol) {
    let origin = host;
    if (protocol == null) origin = `https://${host}`;
    return `${protocol}://${origin}/v0${urlPart}`;
}
function $63c1f7f3542429ef$var$makeQueryString(params) {
    const encode = encodeURIComponent;
    let queryPart = '?';
    for(const key in params)if (params.hasOwnProperty(key)) {
        const nextPart = encode(key) + '=' + encode(params[key]);
        queryPart = queryPart + nextPart + '&';
    }
    // Chop off the extra '&' or '?' on the end
    queryPart = queryPart.slice(0, -1);
    return queryPart;
}
/**
 * Error codes for requests made by the XhrIo wrapper.
 */ var $63c1f7f3542429ef$var$ErrorCode;
(function(ErrorCode) {
    ErrorCode[ErrorCode["NO_ERROR"] = 0] = "NO_ERROR";
    ErrorCode[ErrorCode["NETWORK_ERROR"] = 1] = "NETWORK_ERROR";
    ErrorCode[ErrorCode["ABORT"] = 2] = "ABORT";
})($63c1f7f3542429ef$var$ErrorCode || ($63c1f7f3542429ef$var$ErrorCode = {}));
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks the status code to see if the action should be retried.
 *
 * @param status Current HTTP status code returned by server.
 * @param additionalRetryCodes additional retry codes to check against
 */ function $63c1f7f3542429ef$var$isRetryStatusCode(status, additionalRetryCodes) {
    // The codes for which to retry came from this page:
    // https://cloud.google.com/storage/docs/exponential-backoff
    const isFiveHundredCode = status >= 500 && status < 600;
    const extraRetryCodes = [
        // Request Timeout: web server didn't receive full request in time.
        408,
        // Too Many Requests: you're getting rate-limited, basically.
        429
    ];
    const isExtraRetryCode = extraRetryCodes.indexOf(status) !== -1;
    const isAdditionalRetryCode = additionalRetryCodes.indexOf(status) !== -1;
    return isFiveHundredCode || isExtraRetryCode || isAdditionalRetryCode;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Defines methods used to actually send HTTP requests from
 * abstract representations.
 */ /**
 * Handles network logic for all Storage Requests, including error reporting and
 * retries with backoff.
 *
 * @param I - the type of the backend's network response.
 * @param - O the output type used by the rest of the SDK. The conversion
 * happens in the specified `callback_`.
 */ class $63c1f7f3542429ef$var$NetworkRequest {
    constructor(url_, method_, headers_, body_, successCodes_, additionalRetryCodes_, callback_, errorCallback_, timeout_, progressCallback_, connectionFactory_, retry = true, isUsingEmulator = false){
        this.url_ = url_;
        this.method_ = method_;
        this.headers_ = headers_;
        this.body_ = body_;
        this.successCodes_ = successCodes_;
        this.additionalRetryCodes_ = additionalRetryCodes_;
        this.callback_ = callback_;
        this.errorCallback_ = errorCallback_;
        this.timeout_ = timeout_;
        this.progressCallback_ = progressCallback_;
        this.connectionFactory_ = connectionFactory_;
        this.retry = retry;
        this.isUsingEmulator = isUsingEmulator;
        this.pendingConnection_ = null;
        this.backoffId_ = null;
        this.canceled_ = false;
        this.appDelete_ = false;
        this.promise_ = new Promise((resolve, reject)=>{
            this.resolve_ = resolve;
            this.reject_ = reject;
            this.start_();
        });
    }
    /**
     * Actually starts the retry loop.
     */ start_() {
        const doTheRequest = (backoffCallback, canceled)=>{
            if (canceled) {
                backoffCallback(false, new $63c1f7f3542429ef$var$RequestEndStatus(false, null, true));
                return;
            }
            const connection = this.connectionFactory_();
            this.pendingConnection_ = connection;
            const progressListener = (progressEvent)=>{
                const loaded = progressEvent.loaded;
                const total = progressEvent.lengthComputable ? progressEvent.total : -1;
                if (this.progressCallback_ !== null) this.progressCallback_(loaded, total);
            };
            if (this.progressCallback_ !== null) connection.addUploadProgressListener(progressListener);
            // connection.send() never rejects, so we don't need to have a error handler or use catch on the returned promise.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            connection.send(this.url_, this.method_, this.isUsingEmulator, this.body_, this.headers_).then(()=>{
                if (this.progressCallback_ !== null) connection.removeUploadProgressListener(progressListener);
                this.pendingConnection_ = null;
                const hitServer = connection.getErrorCode() === $63c1f7f3542429ef$var$ErrorCode.NO_ERROR;
                const status = connection.getStatus();
                if (!hitServer || $63c1f7f3542429ef$var$isRetryStatusCode(status, this.additionalRetryCodes_) && this.retry) {
                    const wasCanceled = connection.getErrorCode() === $63c1f7f3542429ef$var$ErrorCode.ABORT;
                    backoffCallback(false, new $63c1f7f3542429ef$var$RequestEndStatus(false, null, wasCanceled));
                    return;
                }
                const successCode = this.successCodes_.indexOf(status) !== -1;
                backoffCallback(true, new $63c1f7f3542429ef$var$RequestEndStatus(successCode, connection));
            });
        };
        /**
         * @param requestWentThrough - True if the request eventually went
         *     through, false if it hit the retry limit or was canceled.
         */ const backoffDone = (requestWentThrough, status)=>{
            const resolve = this.resolve_;
            const reject = this.reject_;
            const connection = status.connection;
            if (status.wasSuccessCode) try {
                const result = this.callback_(connection, connection.getResponse());
                if ($63c1f7f3542429ef$var$isJustDef(result)) resolve(result);
                else resolve();
            } catch (e) {
                reject(e);
            }
            else {
                if (connection !== null) {
                    const err = $63c1f7f3542429ef$var$unknown();
                    err.serverResponse = connection.getErrorText();
                    if (this.errorCallback_) reject(this.errorCallback_(connection, err));
                    else reject(err);
                } else if (status.canceled) {
                    const err = this.appDelete_ ? $63c1f7f3542429ef$var$appDeleted() : $63c1f7f3542429ef$var$canceled();
                    reject(err);
                } else {
                    const err = $63c1f7f3542429ef$var$retryLimitExceeded();
                    reject(err);
                }
            }
        };
        if (this.canceled_) backoffDone(false, new $63c1f7f3542429ef$var$RequestEndStatus(false, null, true));
        else this.backoffId_ = $63c1f7f3542429ef$var$start(doTheRequest, backoffDone, this.timeout_);
    }
    /** @inheritDoc */ getPromise() {
        return this.promise_;
    }
    /** @inheritDoc */ cancel(appDelete) {
        this.canceled_ = true;
        this.appDelete_ = appDelete || false;
        if (this.backoffId_ !== null) $63c1f7f3542429ef$var$stop(this.backoffId_);
        if (this.pendingConnection_ !== null) this.pendingConnection_.abort();
    }
}
/**
 * A collection of information about the result of a network request.
 * @param opt_canceled - Defaults to false.
 */ class $63c1f7f3542429ef$var$RequestEndStatus {
    constructor(wasSuccessCode, connection, canceled){
        this.wasSuccessCode = wasSuccessCode;
        this.connection = connection;
        this.canceled = !!canceled;
    }
}
function $63c1f7f3542429ef$var$addAuthHeader_(headers, authToken) {
    if (authToken !== null && authToken.length > 0) headers['Authorization'] = 'Firebase ' + authToken;
}
function $63c1f7f3542429ef$var$addVersionHeader_(headers, firebaseVersion) {
    headers['X-Firebase-Storage-Version'] = 'webjs/' + (firebaseVersion ?? 'AppManager');
}
function $63c1f7f3542429ef$var$addGmpidHeader_(headers, appId) {
    if (appId) headers['X-Firebase-GMPID'] = appId;
}
function $63c1f7f3542429ef$var$addAppCheckHeader_(headers, appCheckToken) {
    if (appCheckToken !== null) headers['X-Firebase-AppCheck'] = appCheckToken;
}
function $63c1f7f3542429ef$var$makeRequest(requestInfo, appId, authToken, appCheckToken, requestFactory, firebaseVersion, retry = true, isUsingEmulator = false) {
    const queryPart = $63c1f7f3542429ef$var$makeQueryString(requestInfo.urlParams);
    const url = requestInfo.url + queryPart;
    const headers = Object.assign({}, requestInfo.headers);
    $63c1f7f3542429ef$var$addGmpidHeader_(headers, appId);
    $63c1f7f3542429ef$var$addAuthHeader_(headers, authToken);
    $63c1f7f3542429ef$var$addVersionHeader_(headers, firebaseVersion);
    $63c1f7f3542429ef$var$addAppCheckHeader_(headers, appCheckToken);
    return new $63c1f7f3542429ef$var$NetworkRequest(url, requestInfo.method, headers, requestInfo.body, requestInfo.successCodes, requestInfo.additionalRetryCodes, requestInfo.handler, requestInfo.errorHandler, requestInfo.timeout, requestInfo.progressCallback, requestFactory, retry, isUsingEmulator);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Some methods copied from goog.fs.
 * We don't include goog.fs because it pulls in a bunch of Deferred code that
 * bloats the size of the released binary.
 */ function $63c1f7f3542429ef$var$getBlobBuilder() {
    if (typeof BlobBuilder !== 'undefined') return BlobBuilder;
    else if (typeof WebKitBlobBuilder !== 'undefined') return WebKitBlobBuilder;
    else return undefined;
}
/**
 * Concatenates one or more values together and converts them to a Blob.
 *
 * @param args The values that will make up the resulting blob.
 * @return The blob.
 */ function $63c1f7f3542429ef$var$getBlob$1(...args) {
    const BlobBuilder1 = $63c1f7f3542429ef$var$getBlobBuilder();
    if (BlobBuilder1 !== undefined) {
        const bb = new BlobBuilder1();
        for(let i = 0; i < args.length; i++)bb.append(args[i]);
        return bb.getBlob();
    } else {
        if ($63c1f7f3542429ef$var$isNativeBlobDefined()) return new Blob(args);
        else throw new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.UNSUPPORTED_ENVIRONMENT, "This browser doesn't seem to support creating Blobs");
    }
}
/**
 * Slices the blob. The returned blob contains data from the start byte
 * (inclusive) till the end byte (exclusive). Negative indices cannot be used.
 *
 * @param blob The blob to be sliced.
 * @param start Index of the starting byte.
 * @param end Index of the ending byte.
 * @return The blob slice or null if not supported.
 */ function $63c1f7f3542429ef$var$sliceBlob(blob, start, end) {
    if (blob.webkitSlice) return blob.webkitSlice(start, end);
    else if (blob.mozSlice) return blob.mozSlice(start, end);
    else if (blob.slice) return blob.slice(start, end);
    return null;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ function $63c1f7f3542429ef$var$decodeBase64(encoded) {
    if (typeof atob === 'undefined') throw $63c1f7f3542429ef$var$missingPolyFill('base-64');
    return atob(encoded);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enumeration of the possible string formats for upload.
 * @public
 */ const $63c1f7f3542429ef$export$f22e7fe56db8ae03 = {
    /**
     * Indicates the string should be interpreted "raw", that is, as normal text.
     * The string will be interpreted as UTF-16, then uploaded as a UTF-8 byte
     * sequence.
     * Example: The string 'Hello! \\ud83d\\ude0a' becomes the byte sequence
     * 48 65 6c 6c 6f 21 20 f0 9f 98 8a
     */ RAW: 'raw',
    /**
     * Indicates the string should be interpreted as base64-encoded data.
     * Padding characters (trailing '='s) are optional.
     * Example: The string 'rWmO++E6t7/rlw==' becomes the byte sequence
     * ad 69 8e fb e1 3a b7 bf eb 97
     */ BASE64: 'base64',
    /**
     * Indicates the string should be interpreted as base64url-encoded data.
     * Padding characters (trailing '='s) are optional.
     * Example: The string 'rWmO--E6t7_rlw==' becomes the byte sequence
     * ad 69 8e fb e1 3a b7 bf eb 97
     */ BASE64URL: 'base64url',
    /**
     * Indicates the string is a data URL, such as one obtained from
     * canvas.toDataURL().
     * Example: the string 'data:application/octet-stream;base64,aaaa'
     * becomes the byte sequence
     * 69 a6 9a
     * (the content-type "application/octet-stream" is also applied, but can
     * be overridden in the metadata object).
     */ DATA_URL: 'data_url'
};
class $63c1f7f3542429ef$var$StringData {
    constructor(data, contentType){
        this.data = data;
        this.contentType = contentType || null;
    }
}
/**
 * @internal
 */ function $63c1f7f3542429ef$export$d80b9b5a2ccdd3e0(format, stringData) {
    switch(format){
        case $63c1f7f3542429ef$export$f22e7fe56db8ae03.RAW:
            return new $63c1f7f3542429ef$var$StringData($63c1f7f3542429ef$var$utf8Bytes_(stringData));
        case $63c1f7f3542429ef$export$f22e7fe56db8ae03.BASE64:
        case $63c1f7f3542429ef$export$f22e7fe56db8ae03.BASE64URL:
            return new $63c1f7f3542429ef$var$StringData($63c1f7f3542429ef$var$base64Bytes_(format, stringData));
        case $63c1f7f3542429ef$export$f22e7fe56db8ae03.DATA_URL:
            return new $63c1f7f3542429ef$var$StringData($63c1f7f3542429ef$var$dataURLBytes_(stringData), $63c1f7f3542429ef$var$dataURLContentType_(stringData));
    }
    // assert(false);
    throw $63c1f7f3542429ef$var$unknown();
}
function $63c1f7f3542429ef$var$utf8Bytes_(value) {
    const b = [];
    for(let i = 0; i < value.length; i++){
        let c = value.charCodeAt(i);
        if (c <= 127) b.push(c);
        else if (c <= 2047) b.push(192 | c >> 6, 128 | c & 63);
        else {
            if ((c & 64512) === 55296) {
                // The start of a surrogate pair.
                const valid = i < value.length - 1 && (value.charCodeAt(i + 1) & 64512) === 56320;
                if (!valid) // The second surrogate wasn't there.
                b.push(239, 191, 189);
                else {
                    const hi = c;
                    const lo = value.charCodeAt(++i);
                    c = 65536 | (hi & 1023) << 10 | lo & 1023;
                    b.push(240 | c >> 18, 128 | c >> 12 & 63, 128 | c >> 6 & 63, 128 | c & 63);
                }
            } else if ((c & 64512) === 56320) // Invalid low surrogate.
            b.push(239, 191, 189);
            else b.push(224 | c >> 12, 128 | c >> 6 & 63, 128 | c & 63);
        }
    }
    return new Uint8Array(b);
}
function $63c1f7f3542429ef$var$percentEncodedBytes_(value) {
    let decoded;
    try {
        decoded = decodeURIComponent(value);
    } catch (e) {
        throw $63c1f7f3542429ef$var$invalidFormat($63c1f7f3542429ef$export$f22e7fe56db8ae03.DATA_URL, 'Malformed data URL.');
    }
    return $63c1f7f3542429ef$var$utf8Bytes_(decoded);
}
function $63c1f7f3542429ef$var$base64Bytes_(format, value) {
    switch(format){
        case $63c1f7f3542429ef$export$f22e7fe56db8ae03.BASE64:
            {
                const hasMinus = value.indexOf('-') !== -1;
                const hasUnder = value.indexOf('_') !== -1;
                if (hasMinus || hasUnder) {
                    const invalidChar = hasMinus ? '-' : '_';
                    throw $63c1f7f3542429ef$var$invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64url encoded?");
                }
                break;
            }
        case $63c1f7f3542429ef$export$f22e7fe56db8ae03.BASE64URL:
            {
                const hasPlus = value.indexOf('+') !== -1;
                const hasSlash = value.indexOf('/') !== -1;
                if (hasPlus || hasSlash) {
                    const invalidChar = hasPlus ? '+' : '/';
                    throw $63c1f7f3542429ef$var$invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64 encoded?");
                }
                value = value.replace(/-/g, '+').replace(/_/g, '/');
                break;
            }
    }
    let bytes;
    try {
        bytes = $63c1f7f3542429ef$var$decodeBase64(value);
    } catch (e) {
        if (e.message.includes('polyfill')) throw e;
        throw $63c1f7f3542429ef$var$invalidFormat(format, 'Invalid character found');
    }
    const array = new Uint8Array(bytes.length);
    for(let i = 0; i < bytes.length; i++)array[i] = bytes.charCodeAt(i);
    return array;
}
class $63c1f7f3542429ef$var$DataURLParts {
    constructor(dataURL){
        this.base64 = false;
        this.contentType = null;
        const matches = dataURL.match(/^data:([^,]+)?,/);
        if (matches === null) throw $63c1f7f3542429ef$var$invalidFormat($63c1f7f3542429ef$export$f22e7fe56db8ae03.DATA_URL, "Must be formatted 'data:[<mediatype>][;base64],<data>");
        const middle = matches[1] || null;
        if (middle != null) {
            this.base64 = $63c1f7f3542429ef$var$endsWith(middle, ';base64');
            this.contentType = this.base64 ? middle.substring(0, middle.length - 7) : middle;
        }
        this.rest = dataURL.substring(dataURL.indexOf(',') + 1);
    }
}
function $63c1f7f3542429ef$var$dataURLBytes_(dataUrl) {
    const parts = new $63c1f7f3542429ef$var$DataURLParts(dataUrl);
    if (parts.base64) return $63c1f7f3542429ef$var$base64Bytes_($63c1f7f3542429ef$export$f22e7fe56db8ae03.BASE64, parts.rest);
    else return $63c1f7f3542429ef$var$percentEncodedBytes_(parts.rest);
}
function $63c1f7f3542429ef$var$dataURLContentType_(dataUrl) {
    const parts = new $63c1f7f3542429ef$var$DataURLParts(dataUrl);
    return parts.contentType;
}
function $63c1f7f3542429ef$var$endsWith(s, end) {
    const longEnough = s.length >= end.length;
    if (!longEnough) return false;
    return s.substring(s.length - end.length) === end;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @file Provides a Blob-like wrapper for various binary types (including the
 * native Blob type). This makes it possible to upload types like ArrayBuffers,
 * making uploads possible in environments without the native Blob type.
 */ /**
 * @param opt_elideCopy - If true, doesn't copy mutable input data
 *     (e.g. Uint8Arrays). Pass true only if you know the objects will not be
 *     modified after this blob's construction.
 *
 * @internal
 */ class $63c1f7f3542429ef$export$8deea8629ff0b8a7 {
    constructor(data, elideCopy){
        let size = 0;
        let blobType = '';
        if ($63c1f7f3542429ef$var$isNativeBlob(data)) {
            this.data_ = data;
            size = data.size;
            blobType = data.type;
        } else if (data instanceof ArrayBuffer) {
            if (elideCopy) this.data_ = new Uint8Array(data);
            else {
                this.data_ = new Uint8Array(data.byteLength);
                this.data_.set(new Uint8Array(data));
            }
            size = this.data_.length;
        } else if (data instanceof Uint8Array) {
            if (elideCopy) this.data_ = data;
            else {
                this.data_ = new Uint8Array(data.length);
                this.data_.set(data);
            }
            size = data.length;
        }
        this.size_ = size;
        this.type_ = blobType;
    }
    size() {
        return this.size_;
    }
    type() {
        return this.type_;
    }
    slice(startByte, endByte) {
        if ($63c1f7f3542429ef$var$isNativeBlob(this.data_)) {
            const realBlob = this.data_;
            const sliced = $63c1f7f3542429ef$var$sliceBlob(realBlob, startByte, endByte);
            if (sliced === null) return null;
            return new $63c1f7f3542429ef$export$8deea8629ff0b8a7(sliced);
        } else {
            const slice = new Uint8Array(this.data_.buffer, startByte, endByte - startByte);
            return new $63c1f7f3542429ef$export$8deea8629ff0b8a7(slice, true);
        }
    }
    static getBlob(...args) {
        if ($63c1f7f3542429ef$var$isNativeBlobDefined()) {
            const blobby = args.map((val)=>{
                if (val instanceof $63c1f7f3542429ef$export$8deea8629ff0b8a7) return val.data_;
                else return val;
            });
            return new $63c1f7f3542429ef$export$8deea8629ff0b8a7($63c1f7f3542429ef$var$getBlob$1.apply(null, blobby));
        } else {
            const uint8Arrays = args.map((val)=>{
                if ($63c1f7f3542429ef$var$isString(val)) return $63c1f7f3542429ef$export$d80b9b5a2ccdd3e0($63c1f7f3542429ef$export$f22e7fe56db8ae03.RAW, val).data;
                else // Blobs don't exist, so this has to be a Uint8Array.
                return val.data_;
            });
            let finalLength = 0;
            uint8Arrays.forEach((array)=>{
                finalLength += array.byteLength;
            });
            const merged = new Uint8Array(finalLength);
            let index = 0;
            uint8Arrays.forEach((array)=>{
                for(let i = 0; i < array.length; i++)merged[index++] = array[i];
            });
            return new $63c1f7f3542429ef$export$8deea8629ff0b8a7(merged, true);
        }
    }
    uploadData() {
        return this.data_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the Object resulting from parsing the given JSON, or null if the
 * given string does not represent a JSON object.
 */ function $63c1f7f3542429ef$var$jsonObjectOrNull(s) {
    let obj;
    try {
        obj = JSON.parse(s);
    } catch (e) {
        return null;
    }
    if ($63c1f7f3542429ef$var$isNonArrayObject(obj)) return obj;
    else return null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Contains helper methods for manipulating paths.
 */ /**
 * @return Null if the path is already at the root.
 */ function $63c1f7f3542429ef$var$parent(path) {
    if (path.length === 0) return null;
    const index = path.lastIndexOf('/');
    if (index === -1) return '';
    const newPath = path.slice(0, index);
    return newPath;
}
function $63c1f7f3542429ef$var$child(path, childPath) {
    const canonicalChildPath = childPath.split('/').filter((component)=>component.length > 0).join('/');
    if (path.length === 0) return canonicalChildPath;
    else return path + '/' + canonicalChildPath;
}
/**
 * Returns the last component of a path.
 * '/foo/bar' -> 'bar'
 * '/foo/bar/baz/' -> 'baz/'
 * '/a' -> 'a'
 */ function $63c1f7f3542429ef$var$lastComponent(path) {
    const index = path.lastIndexOf('/', path.length - 2);
    if (index === -1) return path;
    else return path.slice(index + 1);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $63c1f7f3542429ef$var$noXform_(metadata, value) {
    return value;
}
class $63c1f7f3542429ef$var$Mapping {
    constructor(server, local, writable, xform){
        this.server = server;
        this.local = local || server;
        this.writable = !!writable;
        this.xform = xform || $63c1f7f3542429ef$var$noXform_;
    }
}
let $63c1f7f3542429ef$var$mappings_ = null;
function $63c1f7f3542429ef$var$xformPath(fullPath) {
    if (!$63c1f7f3542429ef$var$isString(fullPath) || fullPath.length < 2) return fullPath;
    else return $63c1f7f3542429ef$var$lastComponent(fullPath);
}
function $63c1f7f3542429ef$var$getMappings() {
    if ($63c1f7f3542429ef$var$mappings_) return $63c1f7f3542429ef$var$mappings_;
    const mappings = [];
    mappings.push(new $63c1f7f3542429ef$var$Mapping('bucket'));
    mappings.push(new $63c1f7f3542429ef$var$Mapping('generation'));
    mappings.push(new $63c1f7f3542429ef$var$Mapping('metageneration'));
    mappings.push(new $63c1f7f3542429ef$var$Mapping('name', 'fullPath', true));
    function mappingsXformPath(_metadata, fullPath) {
        return $63c1f7f3542429ef$var$xformPath(fullPath);
    }
    const nameMapping = new $63c1f7f3542429ef$var$Mapping('name');
    nameMapping.xform = mappingsXformPath;
    mappings.push(nameMapping);
    /**
     * Coerces the second param to a number, if it is defined.
     */ function xformSize(_metadata, size) {
        if (size !== undefined) return Number(size);
        else return size;
    }
    const sizeMapping = new $63c1f7f3542429ef$var$Mapping('size');
    sizeMapping.xform = xformSize;
    mappings.push(sizeMapping);
    mappings.push(new $63c1f7f3542429ef$var$Mapping('timeCreated'));
    mappings.push(new $63c1f7f3542429ef$var$Mapping('updated'));
    mappings.push(new $63c1f7f3542429ef$var$Mapping('md5Hash', null, true));
    mappings.push(new $63c1f7f3542429ef$var$Mapping('cacheControl', null, true));
    mappings.push(new $63c1f7f3542429ef$var$Mapping('contentDisposition', null, true));
    mappings.push(new $63c1f7f3542429ef$var$Mapping('contentEncoding', null, true));
    mappings.push(new $63c1f7f3542429ef$var$Mapping('contentLanguage', null, true));
    mappings.push(new $63c1f7f3542429ef$var$Mapping('contentType', null, true));
    mappings.push(new $63c1f7f3542429ef$var$Mapping('metadata', 'customMetadata', true));
    $63c1f7f3542429ef$var$mappings_ = mappings;
    return $63c1f7f3542429ef$var$mappings_;
}
function $63c1f7f3542429ef$var$addRef(metadata, service) {
    function generateRef() {
        const bucket = metadata['bucket'];
        const path = metadata['fullPath'];
        const loc = new $63c1f7f3542429ef$export$adb98fff6714334(bucket, path);
        return service._makeStorageReference(loc);
    }
    Object.defineProperty(metadata, 'ref', {
        get: generateRef
    });
}
function $63c1f7f3542429ef$var$fromResource(service, resource, mappings) {
    const metadata = {};
    metadata['type'] = 'file';
    const len = mappings.length;
    for(let i = 0; i < len; i++){
        const mapping = mappings[i];
        metadata[mapping.local] = mapping.xform(metadata, resource[mapping.server]);
    }
    $63c1f7f3542429ef$var$addRef(metadata, service);
    return metadata;
}
function $63c1f7f3542429ef$var$fromResourceString(service, resourceString, mappings) {
    const obj = $63c1f7f3542429ef$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    const resource = obj;
    return $63c1f7f3542429ef$var$fromResource(service, resource, mappings);
}
function $63c1f7f3542429ef$var$downloadUrlFromResourceString(metadata, resourceString, host, protocol) {
    const obj = $63c1f7f3542429ef$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    if (!$63c1f7f3542429ef$var$isString(obj['downloadTokens'])) // This can happen if objects are uploaded through GCS and retrieved
    // through list, so we don't want to throw an Error.
    return null;
    const tokens = obj['downloadTokens'];
    if (tokens.length === 0) return null;
    const encode = encodeURIComponent;
    const tokensList = tokens.split(',');
    const urls = tokensList.map((token)=>{
        const bucket = metadata['bucket'];
        const path = metadata['fullPath'];
        const urlPart = '/b/' + encode(bucket) + '/o/' + encode(path);
        const base = $63c1f7f3542429ef$var$makeUrl(urlPart, host, protocol);
        const queryString = $63c1f7f3542429ef$var$makeQueryString({
            alt: 'media',
            token: token
        });
        return base + queryString;
    });
    return urls[0];
}
function $63c1f7f3542429ef$var$toResourceString(metadata, mappings) {
    const resource = {};
    const len = mappings.length;
    for(let i = 0; i < len; i++){
        const mapping = mappings[i];
        if (mapping.writable) resource[mapping.server] = metadata[mapping.local];
    }
    return JSON.stringify(resource);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Documentation for the listOptions and listResult format
 */ const $63c1f7f3542429ef$var$PREFIXES_KEY = 'prefixes';
const $63c1f7f3542429ef$var$ITEMS_KEY = 'items';
function $63c1f7f3542429ef$var$fromBackendResponse(service, bucket, resource) {
    const listResult = {
        prefixes: [],
        items: [],
        nextPageToken: resource['nextPageToken']
    };
    if (resource[$63c1f7f3542429ef$var$PREFIXES_KEY]) for (const path of resource[$63c1f7f3542429ef$var$PREFIXES_KEY]){
        const pathWithoutTrailingSlash = path.replace(/\/$/, '');
        const reference = service._makeStorageReference(new $63c1f7f3542429ef$export$adb98fff6714334(bucket, pathWithoutTrailingSlash));
        listResult.prefixes.push(reference);
    }
    if (resource[$63c1f7f3542429ef$var$ITEMS_KEY]) for (const item of resource[$63c1f7f3542429ef$var$ITEMS_KEY]){
        const reference = service._makeStorageReference(new $63c1f7f3542429ef$export$adb98fff6714334(bucket, item['name']));
        listResult.items.push(reference);
    }
    return listResult;
}
function $63c1f7f3542429ef$var$fromResponseString(service, bucket, resourceString) {
    const obj = $63c1f7f3542429ef$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    const resource = obj;
    return $63c1f7f3542429ef$var$fromBackendResponse(service, bucket, resource);
}
/**
 * Contains a fully specified request.
 *
 * @param I - the type of the backend's network response.
 * @param O - the output response type used by the rest of the SDK.
 */ class $63c1f7f3542429ef$var$RequestInfo {
    constructor(url, method, /**
     * Returns the value with which to resolve the request's promise. Only called
     * if the request is successful. Throw from this function to reject the
     * returned Request's promise with the thrown error.
     * Note: The XhrIo passed to this function may be reused after this callback
     * returns. Do not keep a reference to it in any way.
     */ handler, timeout){
        this.url = url;
        this.method = method;
        this.handler = handler;
        this.timeout = timeout;
        this.urlParams = {};
        this.headers = {};
        this.body = null;
        this.errorHandler = null;
        /**
         * Called with the current number of bytes uploaded and total size (-1 if not
         * computable) of the request body (i.e. used to report upload progress).
         */ this.progressCallback = null;
        this.successCodes = [
            200
        ];
        this.additionalRetryCodes = [];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws the UNKNOWN StorageError if cndn is false.
 */ function $63c1f7f3542429ef$var$handlerCheck(cndn) {
    if (!cndn) throw $63c1f7f3542429ef$var$unknown();
}
function $63c1f7f3542429ef$var$metadataHandler(service, mappings) {
    function handler(xhr, text) {
        const metadata = $63c1f7f3542429ef$var$fromResourceString(service, text, mappings);
        $63c1f7f3542429ef$var$handlerCheck(metadata !== null);
        return metadata;
    }
    return handler;
}
function $63c1f7f3542429ef$var$listHandler(service, bucket) {
    function handler(xhr, text) {
        const listResult = $63c1f7f3542429ef$var$fromResponseString(service, bucket, text);
        $63c1f7f3542429ef$var$handlerCheck(listResult !== null);
        return listResult;
    }
    return handler;
}
function $63c1f7f3542429ef$var$downloadUrlHandler(service, mappings) {
    function handler(xhr, text) {
        const metadata = $63c1f7f3542429ef$var$fromResourceString(service, text, mappings);
        $63c1f7f3542429ef$var$handlerCheck(metadata !== null);
        return $63c1f7f3542429ef$var$downloadUrlFromResourceString(metadata, text, service.host, service._protocol);
    }
    return handler;
}
function $63c1f7f3542429ef$var$sharedErrorHandler(location) {
    function errorHandler(xhr, err) {
        let newErr;
        if (xhr.getStatus() === 401) {
            if (// This exact message string is the only consistent part of the
            // server's error response that identifies it as an App Check error.
            xhr.getErrorText().includes('Firebase App Check token is invalid')) newErr = $63c1f7f3542429ef$var$unauthorizedApp();
            else newErr = $63c1f7f3542429ef$var$unauthenticated();
        } else {
            if (xhr.getStatus() === 402) newErr = $63c1f7f3542429ef$var$quotaExceeded(location.bucket);
            else if (xhr.getStatus() === 403) newErr = $63c1f7f3542429ef$var$unauthorized(location.path);
            else newErr = err;
        }
        newErr.status = xhr.getStatus();
        newErr.serverResponse = err.serverResponse;
        return newErr;
    }
    return errorHandler;
}
function $63c1f7f3542429ef$var$objectErrorHandler(location) {
    const shared = $63c1f7f3542429ef$var$sharedErrorHandler(location);
    function errorHandler(xhr, err) {
        let newErr = shared(xhr, err);
        if (xhr.getStatus() === 404) newErr = $63c1f7f3542429ef$var$objectNotFound(location.path);
        newErr.serverResponse = err.serverResponse;
        return newErr;
    }
    return errorHandler;
}
function $63c1f7f3542429ef$var$getMetadata$2(service, location, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $63c1f7f3542429ef$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $63c1f7f3542429ef$var$RequestInfo(url, method, $63c1f7f3542429ef$var$metadataHandler(service, mappings), timeout);
    requestInfo.errorHandler = $63c1f7f3542429ef$var$objectErrorHandler(location);
    return requestInfo;
}
function $63c1f7f3542429ef$var$list$2(service, location, delimiter, pageToken, maxResults) {
    const urlParams = {};
    if (location.isRoot) urlParams['prefix'] = '';
    else urlParams['prefix'] = location.path + '/';
    if (delimiter.length > 0) urlParams['delimiter'] = delimiter;
    if (pageToken) urlParams['pageToken'] = pageToken;
    if (maxResults) urlParams['maxResults'] = maxResults;
    const urlPart = location.bucketOnlyServerUrl();
    const url = $63c1f7f3542429ef$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $63c1f7f3542429ef$var$RequestInfo(url, method, $63c1f7f3542429ef$var$listHandler(service, location.bucket), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.errorHandler = $63c1f7f3542429ef$var$sharedErrorHandler(location);
    return requestInfo;
}
function $63c1f7f3542429ef$var$getBytes$1(service, location, maxDownloadSizeBytes) {
    const urlPart = location.fullServerUrl();
    const url = $63c1f7f3542429ef$var$makeUrl(urlPart, service.host, service._protocol) + '?alt=media';
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $63c1f7f3542429ef$var$RequestInfo(url, method, (_, data)=>data, timeout);
    requestInfo.errorHandler = $63c1f7f3542429ef$var$objectErrorHandler(location);
    if (maxDownloadSizeBytes !== undefined) {
        requestInfo.headers['Range'] = `bytes=0-${maxDownloadSizeBytes}`;
        requestInfo.successCodes = [
            200 /* OK */ ,
            206 /* Partial Content */ 
        ];
    }
    return requestInfo;
}
function $63c1f7f3542429ef$var$getDownloadUrl(service, location, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $63c1f7f3542429ef$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $63c1f7f3542429ef$var$RequestInfo(url, method, $63c1f7f3542429ef$var$downloadUrlHandler(service, mappings), timeout);
    requestInfo.errorHandler = $63c1f7f3542429ef$var$objectErrorHandler(location);
    return requestInfo;
}
function $63c1f7f3542429ef$var$updateMetadata$2(service, location, metadata, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $63c1f7f3542429ef$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'PATCH';
    const body = $63c1f7f3542429ef$var$toResourceString(metadata, mappings);
    const headers = {
        'Content-Type': 'application/json; charset=utf-8'
    };
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $63c1f7f3542429ef$var$RequestInfo(url, method, $63c1f7f3542429ef$var$metadataHandler(service, mappings), timeout);
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = $63c1f7f3542429ef$var$objectErrorHandler(location);
    return requestInfo;
}
function $63c1f7f3542429ef$var$deleteObject$2(service, location) {
    const urlPart = location.fullServerUrl();
    const url = $63c1f7f3542429ef$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'DELETE';
    const timeout = service.maxOperationRetryTime;
    function handler(_xhr, _text) {}
    const requestInfo = new $63c1f7f3542429ef$var$RequestInfo(url, method, handler, timeout);
    requestInfo.successCodes = [
        200,
        204
    ];
    requestInfo.errorHandler = $63c1f7f3542429ef$var$objectErrorHandler(location);
    return requestInfo;
}
function $63c1f7f3542429ef$var$determineContentType_(metadata, blob) {
    return metadata && metadata['contentType'] || blob && blob.type() || 'application/octet-stream';
}
function $63c1f7f3542429ef$var$metadataForUpload_(location, blob, metadata) {
    const metadataClone = Object.assign({}, metadata);
    metadataClone['fullPath'] = location.path;
    metadataClone['size'] = blob.size();
    if (!metadataClone['contentType']) metadataClone['contentType'] = $63c1f7f3542429ef$var$determineContentType_(null, blob);
    return metadataClone;
}
/**
 * Prepare RequestInfo for uploads as Content-Type: multipart.
 */ function $63c1f7f3542429ef$var$multipartUpload(service, location, mappings, blob, metadata) {
    const urlPart = location.bucketOnlyServerUrl();
    const headers = {
        'X-Goog-Upload-Protocol': 'multipart'
    };
    function genBoundary() {
        let str = '';
        for(let i = 0; i < 2; i++)str = str + Math.random().toString().slice(2);
        return str;
    }
    const boundary = genBoundary();
    headers['Content-Type'] = 'multipart/related; boundary=' + boundary;
    const metadata_ = $63c1f7f3542429ef$var$metadataForUpload_(location, blob, metadata);
    const metadataString = $63c1f7f3542429ef$var$toResourceString(metadata_, mappings);
    const preBlobPart = '--' + boundary + '\r\n' + 'Content-Type: application/json; charset=utf-8\r\n\r\n' + metadataString + '\r\n--' + boundary + '\r\n' + 'Content-Type: ' + metadata_['contentType'] + '\r\n\r\n';
    const postBlobPart = '\r\n--' + boundary + '--';
    const body = $63c1f7f3542429ef$export$8deea8629ff0b8a7.getBlob(preBlobPart, blob, postBlobPart);
    if (body === null) throw $63c1f7f3542429ef$var$cannotSliceBlob();
    const urlParams = {
        name: metadata_['fullPath']
    };
    const url = $63c1f7f3542429ef$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'POST';
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $63c1f7f3542429ef$var$RequestInfo(url, method, $63c1f7f3542429ef$var$metadataHandler(service, mappings), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.errorHandler = $63c1f7f3542429ef$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param current The number of bytes that have been uploaded so far.
 * @param total The total number of bytes in the upload.
 * @param opt_finalized True if the server has finished the upload.
 * @param opt_metadata The upload metadata, should
 *     only be passed if opt_finalized is true.
 */ class $63c1f7f3542429ef$var$ResumableUploadStatus {
    constructor(current, total, finalized, metadata){
        this.current = current;
        this.total = total;
        this.finalized = !!finalized;
        this.metadata = metadata || null;
    }
}
function $63c1f7f3542429ef$var$checkResumeHeader_(xhr, allowed) {
    let status = null;
    try {
        status = xhr.getResponseHeader('X-Goog-Upload-Status');
    } catch (e) {
        $63c1f7f3542429ef$var$handlerCheck(false);
    }
    const allowedStatus = allowed || [
        'active'
    ];
    $63c1f7f3542429ef$var$handlerCheck(!!status && allowedStatus.indexOf(status) !== -1);
    return status;
}
function $63c1f7f3542429ef$var$createResumableUpload(service, location, mappings, blob, metadata) {
    const urlPart = location.bucketOnlyServerUrl();
    const metadataForUpload = $63c1f7f3542429ef$var$metadataForUpload_(location, blob, metadata);
    const urlParams = {
        name: metadataForUpload['fullPath']
    };
    const url = $63c1f7f3542429ef$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'POST';
    const headers = {
        'X-Goog-Upload-Protocol': 'resumable',
        'X-Goog-Upload-Command': 'start',
        'X-Goog-Upload-Header-Content-Length': `${blob.size()}`,
        'X-Goog-Upload-Header-Content-Type': metadataForUpload['contentType'],
        'Content-Type': 'application/json; charset=utf-8'
    };
    const body = $63c1f7f3542429ef$var$toResourceString(metadataForUpload, mappings);
    const timeout = service.maxUploadRetryTime;
    function handler(xhr) {
        $63c1f7f3542429ef$var$checkResumeHeader_(xhr);
        let url;
        try {
            url = xhr.getResponseHeader('X-Goog-Upload-URL');
        } catch (e) {
            $63c1f7f3542429ef$var$handlerCheck(false);
        }
        $63c1f7f3542429ef$var$handlerCheck($63c1f7f3542429ef$var$isString(url));
        return url;
    }
    const requestInfo = new $63c1f7f3542429ef$var$RequestInfo(url, method, handler, timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = $63c1f7f3542429ef$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 */ function $63c1f7f3542429ef$var$getResumableUploadStatus(service, location, url, blob) {
    const headers = {
        'X-Goog-Upload-Command': 'query'
    };
    function handler(xhr) {
        const status = $63c1f7f3542429ef$var$checkResumeHeader_(xhr, [
            'active',
            'final'
        ]);
        let sizeString = null;
        try {
            sizeString = xhr.getResponseHeader('X-Goog-Upload-Size-Received');
        } catch (e) {
            $63c1f7f3542429ef$var$handlerCheck(false);
        }
        if (!sizeString) // null or empty string
        $63c1f7f3542429ef$var$handlerCheck(false);
        const size = Number(sizeString);
        $63c1f7f3542429ef$var$handlerCheck(!isNaN(size));
        return new $63c1f7f3542429ef$var$ResumableUploadStatus(size, blob.size(), status === 'final');
    }
    const method = 'POST';
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $63c1f7f3542429ef$var$RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.errorHandler = $63c1f7f3542429ef$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * Any uploads via the resumable upload API must transfer a number of bytes
 * that is a multiple of this number.
 */ const $63c1f7f3542429ef$var$RESUMABLE_UPLOAD_CHUNK_SIZE = 262144;
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 * @param chunkSize Number of bytes to upload.
 * @param status The previous status.
 *     If not passed or null, we start from the beginning.
 * @throws fbs.Error If the upload is already complete, the passed in status
 *     has a final size inconsistent with the blob, or the blob cannot be sliced
 *     for upload.
 */ function $63c1f7f3542429ef$var$continueResumableUpload(location, service, url, blob, chunkSize, mappings, status, progressCallback) {
    // TODO(andysoto): standardize on internal asserts
    // assert(!(opt_status && opt_status.finalized));
    const status_ = new $63c1f7f3542429ef$var$ResumableUploadStatus(0, 0);
    if (status) {
        status_.current = status.current;
        status_.total = status.total;
    } else {
        status_.current = 0;
        status_.total = blob.size();
    }
    if (blob.size() !== status_.total) throw $63c1f7f3542429ef$var$serverFileWrongSize();
    const bytesLeft = status_.total - status_.current;
    let bytesToUpload = bytesLeft;
    if (chunkSize > 0) bytesToUpload = Math.min(bytesToUpload, chunkSize);
    const startByte = status_.current;
    const endByte = startByte + bytesToUpload;
    let uploadCommand = '';
    if (bytesToUpload === 0) uploadCommand = 'finalize';
    else if (bytesLeft === bytesToUpload) uploadCommand = 'upload, finalize';
    else uploadCommand = 'upload';
    const headers = {
        'X-Goog-Upload-Command': uploadCommand,
        'X-Goog-Upload-Offset': `${status_.current}`
    };
    const body = blob.slice(startByte, endByte);
    if (body === null) throw $63c1f7f3542429ef$var$cannotSliceBlob();
    function handler(xhr, text) {
        // TODO(andysoto): Verify the MD5 of each uploaded range:
        // the 'x-range-md5' header comes back with status code 308 responses.
        // We'll only be able to bail out though, because you can't re-upload a
        // range that you previously uploaded.
        const uploadStatus = $63c1f7f3542429ef$var$checkResumeHeader_(xhr, [
            'active',
            'final'
        ]);
        const newCurrent = status_.current + bytesToUpload;
        const size = blob.size();
        let metadata;
        if (uploadStatus === 'final') metadata = $63c1f7f3542429ef$var$metadataHandler(service, mappings)(xhr, text);
        else metadata = null;
        return new $63c1f7f3542429ef$var$ResumableUploadStatus(newCurrent, size, uploadStatus === 'final', metadata);
    }
    const method = 'POST';
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $63c1f7f3542429ef$var$RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.progressCallback = progressCallback || null;
    requestInfo.errorHandler = $63c1f7f3542429ef$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event that is triggered on a task.
 * @internal
 */ const $63c1f7f3542429ef$export$2cf04e0422ce9b07 = {
    /**
     * For this event,
     * <ul>
     *   <li>The `next` function is triggered on progress updates and when the
     *       task is paused/resumed with an `UploadTaskSnapshot` as the first
     *       argument.</li>
     *   <li>The `error` function is triggered if the upload is canceled or fails
     *       for another reason.</li>
     *   <li>The `complete` function is triggered if the upload completes
     *       successfully.</li>
     * </ul>
     */ STATE_CHANGED: 'state_changed'
};
// type keys = keyof TaskState
/**
 * Represents the current state of a running upload.
 * @internal
 */ const $63c1f7f3542429ef$export$9dc4203728a9a7c9 = {
    /** The task is currently transferring data. */ RUNNING: 'running',
    /** The task was paused by the user. */ PAUSED: 'paused',
    /** The task completed successfully. */ SUCCESS: 'success',
    /** The task was canceled. */ CANCELED: 'canceled',
    /** The task failed with an error. */ ERROR: 'error'
};
function $63c1f7f3542429ef$var$taskStateFromInternalTaskState(state) {
    switch(state){
        case "running" /* InternalTaskState.RUNNING */ :
        case "pausing" /* InternalTaskState.PAUSING */ :
        case "canceling" /* InternalTaskState.CANCELING */ :
            return $63c1f7f3542429ef$export$9dc4203728a9a7c9.RUNNING;
        case "paused" /* InternalTaskState.PAUSED */ :
            return $63c1f7f3542429ef$export$9dc4203728a9a7c9.PAUSED;
        case "success" /* InternalTaskState.SUCCESS */ :
            return $63c1f7f3542429ef$export$9dc4203728a9a7c9.SUCCESS;
        case "canceled" /* InternalTaskState.CANCELED */ :
            return $63c1f7f3542429ef$export$9dc4203728a9a7c9.CANCELED;
        case "error" /* InternalTaskState.ERROR */ :
            return $63c1f7f3542429ef$export$9dc4203728a9a7c9.ERROR;
        default:
            // TODO(andysoto): assert(false);
            return $63c1f7f3542429ef$export$9dc4203728a9a7c9.ERROR;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $63c1f7f3542429ef$var$Observer {
    constructor(nextOrObserver, error, complete){
        const asFunctions = $63c1f7f3542429ef$var$isFunction(nextOrObserver) || error != null || complete != null;
        if (asFunctions) {
            this.next = nextOrObserver;
            this.error = error ?? undefined;
            this.complete = complete ?? undefined;
        } else {
            const observer = nextOrObserver;
            this.next = observer.next;
            this.error = observer.error;
            this.complete = observer.complete;
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a function that invokes f with its arguments asynchronously as a
 * microtask, i.e. as soon as possible after the current script returns back
 * into browser code.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $63c1f7f3542429ef$var$async(f) {
    return (...argsToForward)=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        Promise.resolve().then(()=>f(...argsToForward));
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Network layer for browsers. We use this instead of goog.net.XhrIo because
 * goog.net.XhrIo is hyuuuuge and doesn't work in React Native on Android.
 */ class $63c1f7f3542429ef$var$XhrConnection {
    constructor(){
        this.sent_ = false;
        this.xhr_ = new XMLHttpRequest();
        this.initXhr();
        this.errorCode_ = $63c1f7f3542429ef$var$ErrorCode.NO_ERROR;
        this.sendPromise_ = new Promise((resolve)=>{
            this.xhr_.addEventListener('abort', ()=>{
                this.errorCode_ = $63c1f7f3542429ef$var$ErrorCode.ABORT;
                resolve();
            });
            this.xhr_.addEventListener('error', ()=>{
                this.errorCode_ = $63c1f7f3542429ef$var$ErrorCode.NETWORK_ERROR;
                resolve();
            });
            this.xhr_.addEventListener('load', ()=>{
                resolve();
            });
        });
    }
    send(url, method, isUsingEmulator, body, headers) {
        if (this.sent_) throw $63c1f7f3542429ef$var$internalError('cannot .send() more than once');
        if ((0, $dPHSJ.isCloudWorkstation)(url) && isUsingEmulator) this.xhr_.withCredentials = true;
        this.sent_ = true;
        this.xhr_.open(method, url, true);
        if (headers !== undefined) {
            for(const key in headers)if (headers.hasOwnProperty(key)) this.xhr_.setRequestHeader(key, headers[key].toString());
        }
        if (body !== undefined) this.xhr_.send(body);
        else this.xhr_.send();
        return this.sendPromise_;
    }
    getErrorCode() {
        if (!this.sent_) throw $63c1f7f3542429ef$var$internalError('cannot .getErrorCode() before sending');
        return this.errorCode_;
    }
    getStatus() {
        if (!this.sent_) throw $63c1f7f3542429ef$var$internalError('cannot .getStatus() before sending');
        try {
            return this.xhr_.status;
        } catch (e) {
            return -1;
        }
    }
    getResponse() {
        if (!this.sent_) throw $63c1f7f3542429ef$var$internalError('cannot .getResponse() before sending');
        return this.xhr_.response;
    }
    getErrorText() {
        if (!this.sent_) throw $63c1f7f3542429ef$var$internalError('cannot .getErrorText() before sending');
        return this.xhr_.statusText;
    }
    /** Aborts the request. */ abort() {
        this.xhr_.abort();
    }
    getResponseHeader(header) {
        return this.xhr_.getResponseHeader(header);
    }
    addUploadProgressListener(listener) {
        if (this.xhr_.upload != null) this.xhr_.upload.addEventListener('progress', listener);
    }
    removeUploadProgressListener(listener) {
        if (this.xhr_.upload != null) this.xhr_.upload.removeEventListener('progress', listener);
    }
}
class $63c1f7f3542429ef$var$XhrTextConnection extends $63c1f7f3542429ef$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = 'text';
    }
}
function $63c1f7f3542429ef$var$newTextConnection() {
    return new $63c1f7f3542429ef$var$XhrTextConnection();
}
class $63c1f7f3542429ef$var$XhrBytesConnection extends $63c1f7f3542429ef$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = 'arraybuffer';
    }
}
function $63c1f7f3542429ef$var$newBytesConnection() {
    return new $63c1f7f3542429ef$var$XhrBytesConnection();
}
class $63c1f7f3542429ef$var$XhrBlobConnection extends $63c1f7f3542429ef$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = 'blob';
    }
}
function $63c1f7f3542429ef$var$newBlobConnection() {
    return new $63c1f7f3542429ef$var$XhrBlobConnection();
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Defines types for interacting with blob transfer tasks.
 */ /**
 * Represents a blob being uploaded. Can be used to pause/resume/cancel the
 * upload and manage callbacks for various events.
 * @internal
 */ class $63c1f7f3542429ef$export$86a2a9b92406a048 {
    isExponentialBackoffExpired() {
        return this.sleepTime > this.maxSleepTime;
    }
    /**
     * @param ref - The firebaseStorage.Reference object this task came
     *     from, untyped to avoid cyclic dependencies.
     * @param blob - The blob to upload.
     */ constructor(ref, blob, metadata = null){
        /**
         * Number of bytes transferred so far.
         */ this._transferred = 0;
        this._needToFetchStatus = false;
        this._needToFetchMetadata = false;
        this._observers = [];
        this._error = undefined;
        this._uploadUrl = undefined;
        this._request = undefined;
        this._chunkMultiplier = 1;
        this._resolve = undefined;
        this._reject = undefined;
        this._ref = ref;
        this._blob = blob;
        this._metadata = metadata;
        this._mappings = $63c1f7f3542429ef$var$getMappings();
        this._resumable = this._shouldDoResumable(this._blob);
        this._state = "running" /* InternalTaskState.RUNNING */ ;
        this._errorHandler = (error)=>{
            this._request = undefined;
            this._chunkMultiplier = 1;
            if (error._codeEquals($63c1f7f3542429ef$export$54592d666d6ce114.CANCELED)) {
                this._needToFetchStatus = true;
                this.completeTransitions_();
            } else {
                const backoffExpired = this.isExponentialBackoffExpired();
                if ($63c1f7f3542429ef$var$isRetryStatusCode(error.status, [])) {
                    if (backoffExpired) error = $63c1f7f3542429ef$var$retryLimitExceeded();
                    else {
                        this.sleepTime = Math.max(this.sleepTime * 2, $63c1f7f3542429ef$var$DEFAULT_MIN_SLEEP_TIME_MILLIS);
                        this._needToFetchStatus = true;
                        this.completeTransitions_();
                        return;
                    }
                }
                this._error = error;
                this._transition("error" /* InternalTaskState.ERROR */ );
            }
        };
        this._metadataErrorHandler = (error)=>{
            this._request = undefined;
            if (error._codeEquals($63c1f7f3542429ef$export$54592d666d6ce114.CANCELED)) this.completeTransitions_();
            else {
                this._error = error;
                this._transition("error" /* InternalTaskState.ERROR */ );
            }
        };
        this.sleepTime = 0;
        this.maxSleepTime = this._ref.storage.maxUploadRetryTime;
        this._promise = new Promise((resolve, reject)=>{
            this._resolve = resolve;
            this._reject = reject;
            this._start();
        });
        // Prevent uncaught rejections on the internal promise from bubbling out
        // to the top level with a dummy handler.
        this._promise.then(null, ()=>{});
    }
    _makeProgressCallback() {
        const sizeBefore = this._transferred;
        return (loaded)=>this._updateProgress(sizeBefore + loaded);
    }
    _shouldDoResumable(blob) {
        return blob.size() > 262144;
    }
    _start() {
        if (this._state !== "running" /* InternalTaskState.RUNNING */ ) // This can happen if someone pauses us in a resume callback, for example.
        return;
        if (this._request !== undefined) return;
        if (this._resumable) {
            if (this._uploadUrl === undefined) this._createResumable();
            else {
                if (this._needToFetchStatus) this._fetchStatus();
                else if (this._needToFetchMetadata) // Happens if we miss the metadata on upload completion.
                this._fetchMetadata();
                else this.pendingTimeout = setTimeout(()=>{
                    this.pendingTimeout = undefined;
                    this._continueUpload();
                }, this.sleepTime);
            }
        } else this._oneShotUpload();
    }
    _resolveToken(callback) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        Promise.all([
            this._ref.storage._getAuthToken(),
            this._ref.storage._getAppCheckToken()
        ]).then(([authToken, appCheckToken])=>{
            switch(this._state){
                case "running" /* InternalTaskState.RUNNING */ :
                    callback(authToken, appCheckToken);
                    break;
                case "canceling" /* InternalTaskState.CANCELING */ :
                    this._transition("canceled" /* InternalTaskState.CANCELED */ );
                    break;
                case "pausing" /* InternalTaskState.PAUSING */ :
                    this._transition("paused" /* InternalTaskState.PAUSED */ );
                    break;
            }
        });
    }
    // TODO(andysoto): assert false
    _createResumable() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $63c1f7f3542429ef$var$createResumableUpload(this._ref.storage, this._ref._location, this._mappings, this._blob, this._metadata);
            const createRequest = this._ref.storage._makeRequest(requestInfo, $63c1f7f3542429ef$var$newTextConnection, authToken, appCheckToken);
            this._request = createRequest;
            createRequest.getPromise().then((url)=>{
                this._request = undefined;
                this._uploadUrl = url;
                this._needToFetchStatus = false;
                this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _fetchStatus() {
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        const url = this._uploadUrl;
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $63c1f7f3542429ef$var$getResumableUploadStatus(this._ref.storage, this._ref._location, url, this._blob);
            const statusRequest = this._ref.storage._makeRequest(requestInfo, $63c1f7f3542429ef$var$newTextConnection, authToken, appCheckToken);
            this._request = statusRequest;
            statusRequest.getPromise().then((status)=>{
                status;
                this._request = undefined;
                this._updateProgress(status.current);
                this._needToFetchStatus = false;
                if (status.finalized) this._needToFetchMetadata = true;
                this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _continueUpload() {
        const chunkSize = $63c1f7f3542429ef$var$RESUMABLE_UPLOAD_CHUNK_SIZE * this._chunkMultiplier;
        const status = new $63c1f7f3542429ef$var$ResumableUploadStatus(this._transferred, this._blob.size());
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        const url = this._uploadUrl;
        this._resolveToken((authToken, appCheckToken)=>{
            let requestInfo;
            try {
                requestInfo = $63c1f7f3542429ef$var$continueResumableUpload(this._ref._location, this._ref.storage, url, this._blob, chunkSize, this._mappings, status, this._makeProgressCallback());
            } catch (e) {
                this._error = e;
                this._transition("error" /* InternalTaskState.ERROR */ );
                return;
            }
            const uploadRequest = this._ref.storage._makeRequest(requestInfo, $63c1f7f3542429ef$var$newTextConnection, authToken, appCheckToken, /*retry=*/ false // Upload requests should not be retried as each retry should be preceded by another query request. Which is handled in this file.
            );
            this._request = uploadRequest;
            uploadRequest.getPromise().then((newStatus)=>{
                this._increaseMultiplier();
                this._request = undefined;
                this._updateProgress(newStatus.current);
                if (newStatus.finalized) {
                    this._metadata = newStatus.metadata;
                    this._transition("success" /* InternalTaskState.SUCCESS */ );
                } else this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _increaseMultiplier() {
        const currentSize = $63c1f7f3542429ef$var$RESUMABLE_UPLOAD_CHUNK_SIZE * this._chunkMultiplier;
        // Max chunk size is 32M.
        if (currentSize * 2 < 33554432) this._chunkMultiplier *= 2;
    }
    _fetchMetadata() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $63c1f7f3542429ef$var$getMetadata$2(this._ref.storage, this._ref._location, this._mappings);
            const metadataRequest = this._ref.storage._makeRequest(requestInfo, $63c1f7f3542429ef$var$newTextConnection, authToken, appCheckToken);
            this._request = metadataRequest;
            metadataRequest.getPromise().then((metadata)=>{
                this._request = undefined;
                this._metadata = metadata;
                this._transition("success" /* InternalTaskState.SUCCESS */ );
            }, this._metadataErrorHandler);
        });
    }
    _oneShotUpload() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $63c1f7f3542429ef$var$multipartUpload(this._ref.storage, this._ref._location, this._mappings, this._blob, this._metadata);
            const multipartRequest = this._ref.storage._makeRequest(requestInfo, $63c1f7f3542429ef$var$newTextConnection, authToken, appCheckToken);
            this._request = multipartRequest;
            multipartRequest.getPromise().then((metadata)=>{
                this._request = undefined;
                this._metadata = metadata;
                this._updateProgress(this._blob.size());
                this._transition("success" /* InternalTaskState.SUCCESS */ );
            }, this._errorHandler);
        });
    }
    _updateProgress(transferred) {
        const old = this._transferred;
        this._transferred = transferred;
        // A progress update can make the "transferred" value smaller (e.g. a
        // partial upload not completed by server, after which the "transferred"
        // value may reset to the value at the beginning of the request).
        if (this._transferred !== old) this._notifyObservers();
    }
    _transition(state) {
        if (this._state === state) return;
        switch(state){
            case "canceling" /* InternalTaskState.CANCELING */ :
            case "pausing" /* InternalTaskState.PAUSING */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING);
                this._state = state;
                if (this._request !== undefined) this._request.cancel();
                else if (this.pendingTimeout) {
                    clearTimeout(this.pendingTimeout);
                    this.pendingTimeout = undefined;
                    this.completeTransitions_();
                }
                break;
            case "running" /* InternalTaskState.RUNNING */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.PAUSING);
                const wasPaused = this._state === "paused" /* InternalTaskState.PAUSED */ ;
                this._state = state;
                if (wasPaused) {
                    this._notifyObservers();
                    this._start();
                }
                break;
            case "paused" /* InternalTaskState.PAUSED */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSING);
                this._state = state;
                this._notifyObservers();
                break;
            case "canceled" /* InternalTaskState.CANCELED */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._error = $63c1f7f3542429ef$var$canceled();
                this._state = state;
                this._notifyObservers();
                break;
            case "error" /* InternalTaskState.ERROR */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._state = state;
                this._notifyObservers();
                break;
            case "success" /* InternalTaskState.SUCCESS */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._state = state;
                this._notifyObservers();
                break;
        }
    }
    completeTransitions_() {
        switch(this._state){
            case "pausing" /* InternalTaskState.PAUSING */ :
                this._transition("paused" /* InternalTaskState.PAUSED */ );
                break;
            case "canceling" /* InternalTaskState.CANCELING */ :
                this._transition("canceled" /* InternalTaskState.CANCELED */ );
                break;
            case "running" /* InternalTaskState.RUNNING */ :
                this._start();
                break;
        }
    }
    /**
     * A snapshot of the current task state.
     */ get snapshot() {
        const externalState = $63c1f7f3542429ef$var$taskStateFromInternalTaskState(this._state);
        return {
            bytesTransferred: this._transferred,
            totalBytes: this._blob.size(),
            state: externalState,
            metadata: this._metadata,
            task: this,
            ref: this._ref
        };
    }
    /**
     * Adds a callback for an event.
     * @param type - The type of event to listen for.
     * @param nextOrObserver -
     *     The `next` function, which gets called for each item in
     *     the event stream, or an observer object with some or all of these three
     *     properties (`next`, `error`, `complete`).
     * @param error - A function that gets called with a `StorageError`
     *     if the event stream ends due to an error.
     * @param completed - A function that gets called if the
     *     event stream ends normally.
     * @returns
     *     If only the event argument is passed, returns a function you can use to
     *     add callbacks (see the examples above). If more than just the event
     *     argument is passed, returns a function you can call to unregister the
     *     callbacks.
     */ on(type, nextOrObserver, error, completed) {
        // Note: `type` isn't being used. Its type is also incorrect. TaskEvent should not be a string.
        const observer = new $63c1f7f3542429ef$var$Observer(nextOrObserver || undefined, error || undefined, completed || undefined);
        this._addObserver(observer);
        return ()=>{
            this._removeObserver(observer);
        };
    }
    /**
     * This object behaves like a Promise, and resolves with its snapshot data
     * when the upload completes.
     * @param onFulfilled - The fulfillment callback. Promise chaining works as normal.
     * @param onRejected - The rejection callback.
     */ then(onFulfilled, onRejected) {
        // These casts are needed so that TypeScript can infer the types of the
        // resulting Promise.
        return this._promise.then(onFulfilled, onRejected);
    }
    /**
     * Equivalent to calling `then(null, onRejected)`.
     */ catch(onRejected) {
        return this.then(null, onRejected);
    }
    /**
     * Adds the given observer.
     */ _addObserver(observer) {
        this._observers.push(observer);
        this._notifyObserver(observer);
    }
    /**
     * Removes the given observer.
     */ _removeObserver(observer) {
        const i = this._observers.indexOf(observer);
        if (i !== -1) this._observers.splice(i, 1);
    }
    _notifyObservers() {
        this._finishPromise();
        const observers = this._observers.slice();
        observers.forEach((observer)=>{
            this._notifyObserver(observer);
        });
    }
    _finishPromise() {
        if (this._resolve !== undefined) {
            let triggered = true;
            switch($63c1f7f3542429ef$var$taskStateFromInternalTaskState(this._state)){
                case $63c1f7f3542429ef$export$9dc4203728a9a7c9.SUCCESS:
                    $63c1f7f3542429ef$var$async(this._resolve.bind(null, this.snapshot))();
                    break;
                case $63c1f7f3542429ef$export$9dc4203728a9a7c9.CANCELED:
                case $63c1f7f3542429ef$export$9dc4203728a9a7c9.ERROR:
                    const toCall = this._reject;
                    $63c1f7f3542429ef$var$async(toCall.bind(null, this._error))();
                    break;
                default:
                    triggered = false;
                    break;
            }
            if (triggered) {
                this._resolve = undefined;
                this._reject = undefined;
            }
        }
    }
    _notifyObserver(observer) {
        const externalState = $63c1f7f3542429ef$var$taskStateFromInternalTaskState(this._state);
        switch(externalState){
            case $63c1f7f3542429ef$export$9dc4203728a9a7c9.RUNNING:
            case $63c1f7f3542429ef$export$9dc4203728a9a7c9.PAUSED:
                if (observer.next) $63c1f7f3542429ef$var$async(observer.next.bind(observer, this.snapshot))();
                break;
            case $63c1f7f3542429ef$export$9dc4203728a9a7c9.SUCCESS:
                if (observer.complete) $63c1f7f3542429ef$var$async(observer.complete.bind(observer))();
                break;
            case $63c1f7f3542429ef$export$9dc4203728a9a7c9.CANCELED:
            case $63c1f7f3542429ef$export$9dc4203728a9a7c9.ERROR:
                if (observer.error) $63c1f7f3542429ef$var$async(observer.error.bind(observer, this._error))();
                break;
            default:
                // TODO(andysoto): assert(false);
                if (observer.error) $63c1f7f3542429ef$var$async(observer.error.bind(observer, this._error))();
        }
    }
    /**
     * Resumes a paused task. Has no effect on a currently running or failed task.
     * @returns True if the operation took effect, false if ignored.
     */ resume() {
        const valid = this._state === "paused" /* InternalTaskState.PAUSED */  || this._state === "pausing" /* InternalTaskState.PAUSING */ ;
        if (valid) this._transition("running" /* InternalTaskState.RUNNING */ );
        return valid;
    }
    /**
     * Pauses a currently running task. Has no effect on a paused or failed task.
     * @returns True if the operation took effect, false if ignored.
     */ pause() {
        const valid = this._state === "running" /* InternalTaskState.RUNNING */ ;
        if (valid) this._transition("pausing" /* InternalTaskState.PAUSING */ );
        return valid;
    }
    /**
     * Cancels a currently running or paused task. Has no effect on a complete or
     * failed task.
     * @returns True if the operation took effect, false if ignored.
     */ cancel() {
        const valid = this._state === "running" /* InternalTaskState.RUNNING */  || this._state === "pausing" /* InternalTaskState.PAUSING */ ;
        if (valid) this._transition("canceling" /* InternalTaskState.CANCELING */ );
        return valid;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Defines the Firebase StorageReference class.
 */ /**
 * Provides methods to interact with a bucket in the Firebase Storage service.
 * @internal
 * @param _location - An fbs.location, or the URL at
 *     which to base this object, in one of the following forms:
 *         gs://<bucket>/<object-path>
 *         http[s]://firebasestorage.googleapis.com/
 *                     <api-version>/b/<bucket>/o/<object-path>
 *     Any query or fragment strings will be ignored in the http[s]
 *     format. If no value is passed, the storage object will use a URL based on
 *     the project ID of the base firebase.App instance.
 */ class $63c1f7f3542429ef$var$Reference {
    constructor(_service, location){
        this._service = _service;
        if (location instanceof $63c1f7f3542429ef$export$adb98fff6714334) this._location = location;
        else this._location = $63c1f7f3542429ef$export$adb98fff6714334.makeFromUrl(location, _service.host);
    }
    /**
     * Returns the URL for the bucket and path this object references,
     *     in the form gs://<bucket>/<object-path>
     * @override
     */ toString() {
        return 'gs://' + this._location.bucket + '/' + this._location.path;
    }
    _newRef(service, location) {
        return new $63c1f7f3542429ef$var$Reference(service, location);
    }
    /**
     * A reference to the root of this object's bucket.
     */ get root() {
        const location = new $63c1f7f3542429ef$export$adb98fff6714334(this._location.bucket, '');
        return this._newRef(this._service, location);
    }
    /**
     * The name of the bucket containing this reference's object.
     */ get bucket() {
        return this._location.bucket;
    }
    /**
     * The full path of this object.
     */ get fullPath() {
        return this._location.path;
    }
    /**
     * The short name of this object, which is the last component of the full path.
     * For example, if fullPath is 'full/path/image.png', name is 'image.png'.
     */ get name() {
        return $63c1f7f3542429ef$var$lastComponent(this._location.path);
    }
    /**
     * The `StorageService` instance this `StorageReference` is associated with.
     */ get storage() {
        return this._service;
    }
    /**
     * A `StorageReference` pointing to the parent location of this `StorageReference`, or null if
     * this reference is the root.
     */ get parent() {
        const newPath = $63c1f7f3542429ef$var$parent(this._location.path);
        if (newPath === null) return null;
        const location = new $63c1f7f3542429ef$export$adb98fff6714334(this._location.bucket, newPath);
        return new $63c1f7f3542429ef$var$Reference(this._service, location);
    }
    /**
     * Utility function to throw an error in methods that do not accept a root reference.
     */ _throwIfRoot(name) {
        if (this._location.path === '') throw $63c1f7f3542429ef$export$61f54cdc36500ad(name);
    }
}
/**
 * Download the bytes at the object's location.
 * @returns A Promise containing the downloaded bytes.
 */ function $63c1f7f3542429ef$var$getBytesInternal(ref, maxDownloadSizeBytes) {
    ref._throwIfRoot('getBytes');
    const requestInfo = $63c1f7f3542429ef$var$getBytes$1(ref.storage, ref._location, maxDownloadSizeBytes);
    return ref.storage.makeRequestWithTokens(requestInfo, $63c1f7f3542429ef$var$newBytesConnection).then((bytes)=>maxDownloadSizeBytes !== undefined ? bytes.slice(0, maxDownloadSizeBytes) : bytes);
}
/**
 * Download the bytes at the object's location.
 * @returns A Promise containing the downloaded blob.
 */ function $63c1f7f3542429ef$var$getBlobInternal(ref, maxDownloadSizeBytes) {
    ref._throwIfRoot('getBlob');
    const requestInfo = $63c1f7f3542429ef$var$getBytes$1(ref.storage, ref._location, maxDownloadSizeBytes);
    return ref.storage.makeRequestWithTokens(requestInfo, $63c1f7f3542429ef$var$newBlobConnection).then((blob)=>maxDownloadSizeBytes !== undefined ? blob.slice(0, maxDownloadSizeBytes) : blob);
}
/**
 * Uploads data to this object's location.
 * The upload is not resumable.
 *
 * @param ref - StorageReference where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the newly uploaded data.
 * @returns A Promise containing an UploadResult
 */ function $63c1f7f3542429ef$var$uploadBytes$1(ref, data, metadata) {
    ref._throwIfRoot('uploadBytes');
    const requestInfo = $63c1f7f3542429ef$var$multipartUpload(ref.storage, ref._location, $63c1f7f3542429ef$var$getMappings(), new $63c1f7f3542429ef$export$8deea8629ff0b8a7(data, true), metadata);
    return ref.storage.makeRequestWithTokens(requestInfo, $63c1f7f3542429ef$var$newTextConnection).then((finalMetadata)=>{
        return {
            metadata: finalMetadata,
            ref: ref
        };
    });
}
/**
 * Uploads data to this object's location.
 * The upload can be paused and resumed, and exposes progress updates.
 * @public
 * @param ref - StorageReference where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the newly uploaded data.
 * @returns An UploadTask
 */ function $63c1f7f3542429ef$var$uploadBytesResumable$1(ref, data, metadata) {
    ref._throwIfRoot('uploadBytesResumable');
    return new $63c1f7f3542429ef$export$86a2a9b92406a048(ref, new $63c1f7f3542429ef$export$8deea8629ff0b8a7(data), metadata);
}
/**
 * Uploads a string to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - StorageReference where string should be uploaded.
 * @param value - The string to upload.
 * @param format - The format of the string to upload.
 * @param metadata - Metadata for the newly uploaded string.
 * @returns A Promise containing an UploadResult
 */ function $63c1f7f3542429ef$var$uploadString$1(ref, value, format = $63c1f7f3542429ef$export$f22e7fe56db8ae03.RAW, metadata) {
    ref._throwIfRoot('uploadString');
    const data = $63c1f7f3542429ef$export$d80b9b5a2ccdd3e0(format, value);
    const metadataClone = {
        ...metadata
    };
    if (metadataClone['contentType'] == null && data.contentType != null) metadataClone['contentType'] = data.contentType;
    return $63c1f7f3542429ef$var$uploadBytes$1(ref, data.data, metadataClone);
}
/**
 * List all items (files) and prefixes (folders) under this storage reference.
 *
 * This is a helper method for calling list() repeatedly until there are
 * no more results. The default pagination size is 1000.
 *
 * Note: The results may not be consistent if objects are changed while this
 * operation is running.
 *
 * Warning: listAll may potentially consume too many resources if there are
 * too many results.
 * @public
 * @param ref - StorageReference to get list from.
 *
 * @returns A Promise that resolves with all the items and prefixes under
 *      the current storage reference. `prefixes` contains references to
 *      sub-directories and `items` contains references to objects in this
 *      folder. `nextPageToken` is never returned.
 */ function $63c1f7f3542429ef$var$listAll$1(ref) {
    const accumulator = {
        prefixes: [],
        items: []
    };
    return $63c1f7f3542429ef$var$listAllHelper(ref, accumulator).then(()=>accumulator);
}
/**
 * Separated from listAll because async functions can't use "arguments".
 * @param ref
 * @param accumulator
 * @param pageToken
 */ async function $63c1f7f3542429ef$var$listAllHelper(ref, accumulator, pageToken) {
    const opt = {
        pageToken: // maxResults is 1000 by default.
        pageToken
    };
    const nextPage = await $63c1f7f3542429ef$var$list$1(ref, opt);
    accumulator.prefixes.push(...nextPage.prefixes);
    accumulator.items.push(...nextPage.items);
    if (nextPage.nextPageToken != null) await $63c1f7f3542429ef$var$listAllHelper(ref, accumulator, nextPage.nextPageToken);
}
/**
 * List items (files) and prefixes (folders) under this storage reference.
 *
 * List API is only available for Firebase Rules Version 2.
 *
 * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
 * delimited folder structure.
 * Refer to GCS's List API if you want to learn more.
 *
 * To adhere to Firebase Rules's Semantics, Firebase Storage does not
 * support objects whose paths end with "/" or contain two consecutive
 * "/"s. Firebase Storage List API will filter these unsupported objects.
 * list() may fail if there are too many unsupported objects in the bucket.
 * @public
 *
 * @param ref - StorageReference to get list from.
 * @param options - See ListOptions for details.
 * @returns A Promise that resolves with the items and prefixes.
 *      `prefixes` contains references to sub-folders and `items`
 *      contains references to objects in this folder. `nextPageToken`
 *      can be used to get the rest of the results.
 */ function $63c1f7f3542429ef$var$list$1(ref, options) {
    if (options != null) {
        if (typeof options.maxResults === 'number') $63c1f7f3542429ef$var$validateNumber('options.maxResults', /* minValue= */ 1, /* maxValue= */ 1000, options.maxResults);
    }
    const op = options || {};
    const requestInfo = $63c1f7f3542429ef$var$list$2(ref.storage, ref._location, /*delimiter= */ '/', op.pageToken, op.maxResults);
    return ref.storage.makeRequestWithTokens(requestInfo, $63c1f7f3542429ef$var$newTextConnection);
}
/**
 * A `Promise` that resolves with the metadata for this object. If this
 * object doesn't exist or metadata cannot be retrieved, the promise is
 * rejected.
 * @public
 * @param ref - StorageReference to get metadata from.
 */ function $63c1f7f3542429ef$var$getMetadata$1(ref) {
    ref._throwIfRoot('getMetadata');
    const requestInfo = $63c1f7f3542429ef$var$getMetadata$2(ref.storage, ref._location, $63c1f7f3542429ef$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $63c1f7f3542429ef$var$newTextConnection);
}
/**
 * Updates the metadata for this object.
 * @public
 * @param ref - StorageReference to update metadata for.
 * @param metadata - The new metadata for the object.
 *     Only values that have been explicitly set will be changed. Explicitly
 *     setting a value to null will remove the metadata.
 * @returns A `Promise` that resolves
 *     with the new metadata for this object.
 *     See `firebaseStorage.Reference.prototype.getMetadata`
 */ function $63c1f7f3542429ef$var$updateMetadata$1(ref, metadata) {
    ref._throwIfRoot('updateMetadata');
    const requestInfo = $63c1f7f3542429ef$var$updateMetadata$2(ref.storage, ref._location, metadata, $63c1f7f3542429ef$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $63c1f7f3542429ef$var$newTextConnection);
}
/**
 * Returns the download URL for the given Reference.
 * @public
 * @returns A `Promise` that resolves with the download
 *     URL for this object.
 */ function $63c1f7f3542429ef$var$getDownloadURL$1(ref) {
    ref._throwIfRoot('getDownloadURL');
    const requestInfo = $63c1f7f3542429ef$var$getDownloadUrl(ref.storage, ref._location, $63c1f7f3542429ef$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $63c1f7f3542429ef$var$newTextConnection).then((url)=>{
        if (url === null) throw $63c1f7f3542429ef$var$noDownloadURL();
        return url;
    });
}
/**
 * Deletes the object at this location.
 * @public
 * @param ref - StorageReference for object to delete.
 * @returns A `Promise` that resolves if the deletion succeeds.
 */ function $63c1f7f3542429ef$var$deleteObject$1(ref) {
    ref._throwIfRoot('deleteObject');
    const requestInfo = $63c1f7f3542429ef$var$deleteObject$2(ref.storage, ref._location);
    return ref.storage.makeRequestWithTokens(requestInfo, $63c1f7f3542429ef$var$newTextConnection);
}
/**
 * Returns reference for object obtained by appending `childPath` to `ref`.
 *
 * @param ref - StorageReference to get child of.
 * @param childPath - Child path from provided ref.
 * @returns A reference to the object obtained by
 * appending childPath, removing any duplicate, beginning, or trailing
 * slashes.
 *
 */ function $63c1f7f3542429ef$var$_getChild$1(ref, childPath) {
    const newPath = $63c1f7f3542429ef$var$child(ref._location.path, childPath);
    const location = new $63c1f7f3542429ef$export$adb98fff6714334(ref._location.bucket, newPath);
    return new $63c1f7f3542429ef$var$Reference(ref.storage, location);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $63c1f7f3542429ef$var$isUrl(path) {
    return /^[A-Za-z]+:\/\//.test(path);
}
/**
 * Returns a firebaseStorage.Reference for the given url.
 */ function $63c1f7f3542429ef$var$refFromURL(service, url) {
    return new $63c1f7f3542429ef$var$Reference(service, url);
}
/**
 * Returns a firebaseStorage.Reference for the given path in the default
 * bucket.
 */ function $63c1f7f3542429ef$var$refFromPath(ref, path) {
    if (ref instanceof $63c1f7f3542429ef$var$FirebaseStorageImpl) {
        const service = ref;
        if (service._bucket == null) throw $63c1f7f3542429ef$var$noDefaultBucket();
        const reference = new $63c1f7f3542429ef$var$Reference(service, service._bucket);
        if (path != null) return $63c1f7f3542429ef$var$refFromPath(reference, path);
        else return reference;
    } else {
        // ref is a Reference
        if (path !== undefined) return $63c1f7f3542429ef$var$_getChild$1(ref, path);
        else return ref;
    }
}
function $63c1f7f3542429ef$var$ref$1(serviceOrRef, pathOrUrl) {
    if (pathOrUrl && $63c1f7f3542429ef$var$isUrl(pathOrUrl)) {
        if (serviceOrRef instanceof $63c1f7f3542429ef$var$FirebaseStorageImpl) return $63c1f7f3542429ef$var$refFromURL(serviceOrRef, pathOrUrl);
        else throw $63c1f7f3542429ef$export$8f74d9881d1936fd('To use ref(service, url), the first argument must be a Storage instance.');
    } else return $63c1f7f3542429ef$var$refFromPath(serviceOrRef, pathOrUrl);
}
function $63c1f7f3542429ef$var$extractBucket(host, config) {
    const bucketString = config?.[$63c1f7f3542429ef$var$CONFIG_STORAGE_BUCKET_KEY];
    if (bucketString == null) return null;
    return $63c1f7f3542429ef$export$adb98fff6714334.makeFromBucketSpec(bucketString, host);
}
function $63c1f7f3542429ef$var$connectStorageEmulator$1(storage, host, port, options = {}) {
    storage.host = `${host}:${port}`;
    const useSsl = (0, $dPHSJ.isCloudWorkstation)(host);
    // Workaround to get cookies in Firebase Studio
    if (useSsl) (0, $dPHSJ.pingServer)(`https://${storage.host}/b`).catch(()=>{});
    storage._isUsingEmulator = true;
    storage._protocol = useSsl ? 'https' : 'http';
    const { mockUserToken: mockUserToken } = options;
    if (mockUserToken) storage._overrideAuthToken = typeof mockUserToken === 'string' ? mockUserToken : (0, $dPHSJ.createMockUserToken)(mockUserToken, storage.app.options.projectId);
}
/**
 * A service that provides Firebase Storage Reference instances.
 * @param opt_url - gs:// url to a custom Storage Bucket
 *
 * @internal
 */ class $63c1f7f3542429ef$var$FirebaseStorageImpl {
    constructor(/**
     * FirebaseApp associated with this StorageService instance.
     */ app, _authProvider, /**
     * @internal
     */ _appCheckProvider, /**
     * @internal
     */ _url, _firebaseVersion, _isUsingEmulator = false){
        this.app = app;
        this._authProvider = _authProvider;
        this._appCheckProvider = _appCheckProvider;
        this._url = _url;
        this._firebaseVersion = _firebaseVersion;
        this._isUsingEmulator = _isUsingEmulator;
        this._bucket = null;
        /**
         * This string can be in the formats:
         * - host
         * - host:port
         */ this._host = $63c1f7f3542429ef$var$DEFAULT_HOST;
        this._protocol = 'https';
        this._appId = null;
        this._deleted = false;
        this._maxOperationRetryTime = $63c1f7f3542429ef$var$DEFAULT_MAX_OPERATION_RETRY_TIME;
        this._maxUploadRetryTime = $63c1f7f3542429ef$var$DEFAULT_MAX_UPLOAD_RETRY_TIME;
        this._requests = new Set();
        if (_url != null) this._bucket = $63c1f7f3542429ef$export$adb98fff6714334.makeFromBucketSpec(_url, this._host);
        else this._bucket = $63c1f7f3542429ef$var$extractBucket(this._host, this.app.options);
    }
    /**
     * The host string for this service, in the form of `host` or
     * `host:port`.
     */ get host() {
        return this._host;
    }
    set host(host) {
        this._host = host;
        if (this._url != null) this._bucket = $63c1f7f3542429ef$export$adb98fff6714334.makeFromBucketSpec(this._url, host);
        else this._bucket = $63c1f7f3542429ef$var$extractBucket(host, this.app.options);
    }
    /**
     * The maximum time to retry uploads in milliseconds.
     */ get maxUploadRetryTime() {
        return this._maxUploadRetryTime;
    }
    set maxUploadRetryTime(time) {
        $63c1f7f3542429ef$var$validateNumber('time', /* minValue=*/ 0, /* maxValue= */ Number.POSITIVE_INFINITY, time);
        this._maxUploadRetryTime = time;
    }
    /**
     * The maximum time to retry operations other than uploads or downloads in
     * milliseconds.
     */ get maxOperationRetryTime() {
        return this._maxOperationRetryTime;
    }
    set maxOperationRetryTime(time) {
        $63c1f7f3542429ef$var$validateNumber('time', /* minValue=*/ 0, /* maxValue= */ Number.POSITIVE_INFINITY, time);
        this._maxOperationRetryTime = time;
    }
    async _getAuthToken() {
        if (this._overrideAuthToken) return this._overrideAuthToken;
        const auth = this._authProvider.getImmediate({
            optional: true
        });
        if (auth) {
            const tokenData = await auth.getToken();
            if (tokenData !== null) return tokenData.accessToken;
        }
        return null;
    }
    async _getAppCheckToken() {
        if ((0, $86cnQ._isFirebaseServerApp)(this.app) && this.app.settings.appCheckToken) return this.app.settings.appCheckToken;
        const appCheck = this._appCheckProvider.getImmediate({
            optional: true
        });
        if (appCheck) {
            const result = await appCheck.getToken();
            // TODO: What do we want to do if there is an error getting the token?
            // Context: appCheck.getToken() will never throw even if an error happened. In the error case, a dummy token will be
            // returned along with an error field describing the error. In general, we shouldn't care about the error condition and just use
            // the token (actual or dummy) to send requests.
            return result.token;
        }
        return null;
    }
    /**
     * Stop running requests and prevent more from being created.
     */ _delete() {
        if (!this._deleted) {
            this._deleted = true;
            this._requests.forEach((request)=>request.cancel());
            this._requests.clear();
        }
        return Promise.resolve();
    }
    /**
     * Returns a new firebaseStorage.Reference object referencing this StorageService
     * at the given Location.
     */ _makeStorageReference(loc) {
        return new $63c1f7f3542429ef$var$Reference(this, loc);
    }
    /**
     * @param requestInfo - HTTP RequestInfo object
     * @param authToken - Firebase auth token
     */ _makeRequest(requestInfo, requestFactory, authToken, appCheckToken, retry = true) {
        if (!this._deleted) {
            const request = $63c1f7f3542429ef$var$makeRequest(requestInfo, this._appId, authToken, appCheckToken, requestFactory, this._firebaseVersion, retry, this._isUsingEmulator);
            this._requests.add(request);
            // Request removes itself from set when complete.
            request.getPromise().then(()=>this._requests.delete(request), ()=>this._requests.delete(request));
            return request;
        } else return new $63c1f7f3542429ef$var$FailRequest($63c1f7f3542429ef$var$appDeleted());
    }
    async makeRequestWithTokens(requestInfo, requestFactory) {
        const [authToken, appCheckToken] = await Promise.all([
            this._getAuthToken(),
            this._getAppCheckToken()
        ]);
        return this._makeRequest(requestInfo, requestFactory, authToken, appCheckToken).getPromise();
    }
}
const $63c1f7f3542429ef$var$name = "@firebase/storage";
const $63c1f7f3542429ef$var$version = "0.14.6";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Storage.
 */ const $63c1f7f3542429ef$var$STORAGE_TYPE = 'storage';
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Downloads the data at the object's location. Returns an error if the object
 * is not found.
 *
 * To use this functionality, you have to whitelist your app's origin in your
 * Cloud Storage bucket. See also
 * https://cloud.google.com/storage/docs/configuring-cors
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A Promise containing the object's bytes
 */ function $63c1f7f3542429ef$export$a3521add2594f3c8(ref, maxDownloadSizeBytes) {
    ref = (0, $dPHSJ.getModularInstance)(ref);
    return $63c1f7f3542429ef$var$getBytesInternal(ref, maxDownloadSizeBytes);
}
/**
 * Uploads data to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - {@link StorageReference} where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the data to upload.
 * @returns A Promise containing an UploadResult
 */ function $63c1f7f3542429ef$export$ac40f56b52f99dd1(ref, data, metadata) {
    ref = (0, $dPHSJ.getModularInstance)(ref);
    return $63c1f7f3542429ef$var$uploadBytes$1(ref, data, metadata);
}
/**
 * Uploads a string to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - {@link StorageReference} where string should be uploaded.
 * @param value - The string to upload.
 * @param format - The format of the string to upload.
 * @param metadata - Metadata for the string to upload.
 * @returns A Promise containing an UploadResult
 */ function $63c1f7f3542429ef$export$d885b2eb178808b3(ref, value, format, metadata) {
    ref = (0, $dPHSJ.getModularInstance)(ref);
    return $63c1f7f3542429ef$var$uploadString$1(ref, value, format, metadata);
}
/**
 * Uploads data to this object's location.
 * The upload can be paused and resumed, and exposes progress updates.
 * @public
 * @param ref - {@link StorageReference} where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the data to upload.
 * @returns An UploadTask
 */ function $63c1f7f3542429ef$export$3895d39eb7ac9b25(ref, data, metadata) {
    ref = (0, $dPHSJ.getModularInstance)(ref);
    return $63c1f7f3542429ef$var$uploadBytesResumable$1(ref, data, metadata);
}
/**
 * A `Promise` that resolves with the metadata for this object. If this
 * object doesn't exist or metadata cannot be retrieved, the promise is
 * rejected.
 * @public
 * @param ref - {@link StorageReference} to get metadata from.
 */ function $63c1f7f3542429ef$export$8548546c0aa631e6(ref) {
    ref = (0, $dPHSJ.getModularInstance)(ref);
    return $63c1f7f3542429ef$var$getMetadata$1(ref);
}
/**
 * Updates the metadata for this object.
 * @public
 * @param ref - {@link StorageReference} to update metadata for.
 * @param metadata - The new metadata for the object.
 *     Only values that have been explicitly set will be changed. Explicitly
 *     setting a value to null will remove the metadata.
 * @returns A `Promise` that resolves with the new metadata for this object.
 */ function $63c1f7f3542429ef$export$f64791b2d30456a0(ref, metadata) {
    ref = (0, $dPHSJ.getModularInstance)(ref);
    return $63c1f7f3542429ef$var$updateMetadata$1(ref, metadata);
}
/**
 * List items (files) and prefixes (folders) under this storage reference.
 *
 * List API is only available for Firebase Rules Version 2.
 *
 * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
 * delimited folder structure.
 * Refer to GCS's List API if you want to learn more.
 *
 * To adhere to Firebase Rules's Semantics, Firebase Storage does not
 * support objects whose paths end with "/" or contain two consecutive
 * "/"s. Firebase Storage List API will filter these unsupported objects.
 * list() may fail if there are too many unsupported objects in the bucket.
 * @public
 *
 * @param ref - {@link StorageReference} to get list from.
 * @param options - See {@link ListOptions} for details.
 * @returns A `Promise` that resolves with the items and prefixes.
 *      `prefixes` contains references to sub-folders and `items`
 *      contains references to objects in this folder. `nextPageToken`
 *      can be used to get the rest of the results.
 */ function $63c1f7f3542429ef$export$8837f4fc672e936d(ref, options) {
    ref = (0, $dPHSJ.getModularInstance)(ref);
    return $63c1f7f3542429ef$var$list$1(ref, options);
}
/**
 * List all items (files) and prefixes (folders) under this storage reference.
 *
 * This is a helper method for calling list() repeatedly until there are
 * no more results. The default pagination size is 1000.
 *
 * Note: The results may not be consistent if objects are changed while this
 * operation is running.
 *
 * Warning: `listAll` may potentially consume too many resources if there are
 * too many results.
 * @public
 * @param ref - {@link StorageReference} to get list from.
 *
 * @returns A `Promise` that resolves with all the items and prefixes under
 *      the current storage reference. `prefixes` contains references to
 *      sub-directories and `items` contains references to objects in this
 *      folder. `nextPageToken` is never returned.
 */ function $63c1f7f3542429ef$export$6a265a7d315dec03(ref) {
    ref = (0, $dPHSJ.getModularInstance)(ref);
    return $63c1f7f3542429ef$var$listAll$1(ref);
}
/**
 * Returns the download URL for the given {@link StorageReference}.
 * @public
 * @param ref - {@link StorageReference} to get the download URL for.
 * @returns A `Promise` that resolves with the download
 *     URL for this object.
 */ function $63c1f7f3542429ef$export$c8bf645a0c2a7d9f(ref) {
    ref = (0, $dPHSJ.getModularInstance)(ref);
    return $63c1f7f3542429ef$var$getDownloadURL$1(ref);
}
/**
 * Deletes the object at this location.
 * @public
 * @param ref - {@link StorageReference} for object to delete.
 * @returns A `Promise` that resolves if the deletion succeeds.
 */ function $63c1f7f3542429ef$export$39c5ed4ec960eade(ref) {
    ref = (0, $dPHSJ.getModularInstance)(ref);
    return $63c1f7f3542429ef$var$deleteObject$1(ref);
}
function $63c1f7f3542429ef$export$eff4d24c3ff7876e(serviceOrRef, pathOrUrl) {
    serviceOrRef = (0, $dPHSJ.getModularInstance)(serviceOrRef);
    return $63c1f7f3542429ef$var$ref$1(serviceOrRef, pathOrUrl);
}
/**
 * @internal
 */ function $63c1f7f3542429ef$export$9acd24c0fce96a85(ref, childPath) {
    return $63c1f7f3542429ef$var$_getChild$1(ref, childPath);
}
/**
 * Gets a {@link FirebaseStorage} instance for the given Firebase app.
 * @public
 * @param app - Firebase app to get {@link FirebaseStorage} instance for.
 * @param bucketUrl - The gs:// url to your Firebase Storage Bucket.
 * If not passed, uses the app's default Storage Bucket.
 * @returns A {@link FirebaseStorage} instance.
 */ function $63c1f7f3542429ef$export$fbd9b57a66480737(app = (0, $86cnQ.getApp)(), bucketUrl) {
    app = (0, $dPHSJ.getModularInstance)(app);
    const storageProvider = (0, $86cnQ._getProvider)(app, $63c1f7f3542429ef$var$STORAGE_TYPE);
    const storageInstance = storageProvider.getImmediate({
        identifier: bucketUrl
    });
    const emulator = (0, $dPHSJ.getDefaultEmulatorHostnameAndPort)('storage');
    if (emulator) $63c1f7f3542429ef$export$9850e656f954b889(storageInstance, ...emulator);
    return storageInstance;
}
/**
 * Modify this {@link FirebaseStorage} instance to communicate with the Cloud Storage emulator.
 *
 * @param storage - The {@link FirebaseStorage} instance
 * @param host - The emulator host (ex: localhost)
 * @param port - The emulator port (ex: 5001)
 * @param options - Emulator options. `options.mockUserToken` is the mock auth
 * token to use for unit testing Security Rules.
 * @public
 */ function $63c1f7f3542429ef$export$9850e656f954b889(storage, host, port, options = {}) {
    $63c1f7f3542429ef$var$connectStorageEmulator$1(storage, host, port, options);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Downloads the data at the object's location. Returns an error if the object
 * is not found.
 *
 * To use this functionality, you have to whitelist your app's origin in your
 * Cloud Storage bucket. See also
 * https://cloud.google.com/storage/docs/configuring-cors
 *
 * This API is not available in Node.
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A Promise that resolves with a Blob containing the object's bytes
 */ function $63c1f7f3542429ef$export$37610328929d7521(ref, maxDownloadSizeBytes) {
    ref = (0, $dPHSJ.getModularInstance)(ref);
    return $63c1f7f3542429ef$var$getBlobInternal(ref, maxDownloadSizeBytes);
}
/**
 * Downloads the data at the object's location. Raises an error event if the
 * object is not found.
 *
 * This API is only available in Node.
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A stream with the object's data as bytes
 */ function $63c1f7f3542429ef$export$747191980cdf43e8(ref, maxDownloadSizeBytes) {
    throw new Error('getStream() is only supported by NodeJS builds');
}
/**
 * Cloud Storage for Firebase
 *
 * @packageDocumentation
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // eslint-disable-next-line import/no-extraneous-dependencies
function $63c1f7f3542429ef$var$factory(container, { instanceIdentifier: url }) {
    const app = container.getProvider('app').getImmediate();
    const authProvider = container.getProvider('auth-internal');
    const appCheckProvider = container.getProvider('app-check-internal');
    return new $63c1f7f3542429ef$var$FirebaseStorageImpl(app, authProvider, appCheckProvider, url, (0, $86cnQ.SDK_VERSION));
}
function $63c1f7f3542429ef$var$registerStorage() {
    (0, $86cnQ._registerComponent)(new (0, $7vOQ3.Component)($63c1f7f3542429ef$var$STORAGE_TYPE, $63c1f7f3542429ef$var$factory, "PUBLIC" /* ComponentType.PUBLIC */ ).setMultipleInstances(true));
    //RUNTIME_ENV will be replaced during the compilation to "node" for nodejs and an empty string for browser
    (0, $86cnQ.registerVersion)($63c1f7f3542429ef$var$name, $63c1f7f3542429ef$var$version, '');
    // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    (0, $86cnQ.registerVersion)($63c1f7f3542429ef$var$name, $63c1f7f3542429ef$var$version, 'esm2020');
}
$63c1f7f3542429ef$var$registerStorage();





var $6KOho = parcelRequire("6KOho");


var $2q7Wm = parcelRequire("2q7Wm");

var $dktVJ = parcelRequire("dktVJ");

var $8JYDX = parcelRequire("8JYDX");




/*
   Copyright 2023, Guillermo Vega-Gorgojo

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ 
var $33Kba = parcelRequire("33Kba");




var $6KOho = parcelRequire("6KOho");

var $dktVJ = parcelRequire("dktVJ");

var $8JYDX = parcelRequire("8JYDX");





/*
   Copyright 2023, Guillermo Vega-Gorgojo

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ 
var $33Kba = parcelRequire("33Kba");



var $6KOho = parcelRequire("6KOho");

var $2q7Wm = parcelRequire("2q7Wm");


var $dktVJ = parcelRequire("dktVJ");



/*
   Copyright 2023, Guillermo Vega-Gorgojo

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ 
var $33Kba = parcelRequire("33Kba");




var $6KOho = parcelRequire("6KOho");


var $2q7Wm = parcelRequire("2q7Wm");

var $dktVJ = parcelRequire("dktVJ");

var $8JYDX = parcelRequire("8JYDX");






/*
   Copyright 2023, Guillermo Vega-Gorgojo

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ 
var $86cnQ = parcelRequire("86cnQ");

var $7I6Lr = parcelRequire("7I6Lr");

var $dPHSJ = parcelRequire("dPHSJ");

var $7vOQ3 = parcelRequire("7vOQ3");

var $86cnQ = parcelRequire("86cnQ");

var $7vOQ3 = parcelRequire("7vOQ3");

var $dPHSJ = parcelRequire("dPHSJ");

var $iItpQ = parcelRequire("iItpQ");
const $32f99e13847fca05$var$name = "@firebase/installations";
const $32f99e13847fca05$var$version = "0.6.24";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $32f99e13847fca05$var$PENDING_TIMEOUT_MS = 10000;
const $32f99e13847fca05$var$PACKAGE_VERSION = `w:${$32f99e13847fca05$var$version}`;
const $32f99e13847fca05$var$INTERNAL_AUTH_VERSION = 'FIS_v2';
const $32f99e13847fca05$var$INSTALLATIONS_API_URL = 'https://firebaseinstallations.googleapis.com/v1';
const $32f99e13847fca05$var$TOKEN_EXPIRATION_BUFFER = 3600000; // One hour
const $32f99e13847fca05$var$SERVICE = 'installations';
const $32f99e13847fca05$var$SERVICE_NAME = 'Installations';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $32f99e13847fca05$var$ERROR_DESCRIPTION_MAP = {
    ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ ]: 'Missing App configuration value: "{$valueName}"',
    ["not-registered" /* ErrorCode.NOT_REGISTERED */ ]: 'Firebase Installation is not registered.',
    ["installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ ]: 'Firebase Installation not found.',
    ["request-failed" /* ErrorCode.REQUEST_FAILED */ ]: '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
    ["app-offline" /* ErrorCode.APP_OFFLINE */ ]: 'Could not process request. Application offline.',
    ["delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ ]: "Can't delete installation while there is a pending registration request."
};
const $32f99e13847fca05$var$ERROR_FACTORY = new (0, $dPHSJ.ErrorFactory)($32f99e13847fca05$var$SERVICE, $32f99e13847fca05$var$SERVICE_NAME, $32f99e13847fca05$var$ERROR_DESCRIPTION_MAP);
/** Returns true if error is a FirebaseError that is based on an error from the server. */ function $32f99e13847fca05$var$isServerError(error) {
    return error instanceof (0, $dPHSJ.FirebaseError) && error.code.includes("request-failed" /* ErrorCode.REQUEST_FAILED */ );
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $32f99e13847fca05$var$getInstallationsEndpoint({ projectId: projectId }) {
    return `${$32f99e13847fca05$var$INSTALLATIONS_API_URL}/projects/${projectId}/installations`;
}
function $32f99e13847fca05$var$extractAuthTokenInfoFromResponse(response) {
    return {
        token: response.token,
        requestStatus: 2 /* RequestStatus.COMPLETED */ ,
        expiresIn: $32f99e13847fca05$var$getExpiresInFromResponseExpiresIn(response.expiresIn),
        creationTime: Date.now()
    };
}
async function $32f99e13847fca05$var$getErrorFromResponse(requestName, response) {
    const responseJson = await response.json();
    const errorData = responseJson.error;
    return $32f99e13847fca05$var$ERROR_FACTORY.create("request-failed" /* ErrorCode.REQUEST_FAILED */ , {
        requestName: requestName,
        serverCode: errorData.code,
        serverMessage: errorData.message,
        serverStatus: errorData.status
    });
}
function $32f99e13847fca05$var$getHeaders({ apiKey: apiKey }) {
    return new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'x-goog-api-key': apiKey
    });
}
function $32f99e13847fca05$var$getHeadersWithAuth(appConfig, { refreshToken: refreshToken }) {
    const headers = $32f99e13847fca05$var$getHeaders(appConfig);
    headers.append('Authorization', $32f99e13847fca05$var$getAuthorizationHeader(refreshToken));
    return headers;
}
/**
 * Calls the passed in fetch wrapper and returns the response.
 * If the returned response has a status of 5xx, re-runs the function once and
 * returns the response.
 */ async function $32f99e13847fca05$var$retryIfServerError(fn) {
    const result = await fn();
    if (result.status >= 500 && result.status < 600) // Internal Server Error. Retry request.
    return fn();
    return result;
}
function $32f99e13847fca05$var$getExpiresInFromResponseExpiresIn(responseExpiresIn) {
    // This works because the server will never respond with fractions of a second.
    return Number(responseExpiresIn.replace('s', '000'));
}
function $32f99e13847fca05$var$getAuthorizationHeader(refreshToken) {
    return `${$32f99e13847fca05$var$INTERNAL_AUTH_VERSION} ${refreshToken}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $32f99e13847fca05$var$createInstallationRequest({ appConfig: appConfig, heartbeatServiceProvider: heartbeatServiceProvider }, { fid: fid }) {
    const endpoint = $32f99e13847fca05$var$getInstallationsEndpoint(appConfig);
    const headers = $32f99e13847fca05$var$getHeaders(appConfig);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append('x-firebase-client', heartbeatsHeader);
    }
    const body = {
        fid: fid,
        authVersion: $32f99e13847fca05$var$INTERNAL_AUTH_VERSION,
        appId: appConfig.appId,
        sdkVersion: $32f99e13847fca05$var$PACKAGE_VERSION
    };
    const request = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body)
    };
    const response = await $32f99e13847fca05$var$retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const registeredInstallationEntry = {
            fid: responseValue.fid || fid,
            registrationStatus: 2 /* RequestStatus.COMPLETED */ ,
            refreshToken: responseValue.refreshToken,
            authToken: $32f99e13847fca05$var$extractAuthTokenInfoFromResponse(responseValue.authToken)
        };
        return registeredInstallationEntry;
    } else throw await $32f99e13847fca05$var$getErrorFromResponse('Create Installation', response);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a promise that resolves after given time passes. */ function $32f99e13847fca05$var$sleep(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $32f99e13847fca05$var$bufferToBase64UrlSafe(array) {
    const b64 = btoa(String.fromCharCode(...array));
    return b64.replace(/\+/g, '-').replace(/\//g, '_');
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $32f99e13847fca05$var$VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
const $32f99e13847fca05$var$INVALID_FID = '';
/**
 * Generates a new FID using random values from Web Crypto API.
 * Returns an empty string if FID generation fails for any reason.
 */ function $32f99e13847fca05$var$generateFid() {
    try {
        // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
        // bytes. our implementation generates a 17 byte array instead.
        const fidByteArray = new Uint8Array(17);
        const crypto = self.crypto || self.msCrypto;
        crypto.getRandomValues(fidByteArray);
        // Replace the first 4 random bits with the constant FID header of 0b0111.
        fidByteArray[0] = 112 + fidByteArray[0] % 16;
        const fid = $32f99e13847fca05$var$encode(fidByteArray);
        return $32f99e13847fca05$var$VALID_FID_PATTERN.test(fid) ? fid : $32f99e13847fca05$var$INVALID_FID;
    } catch  {
        // FID generation errored
        return $32f99e13847fca05$var$INVALID_FID;
    }
}
/** Converts a FID Uint8Array to a base64 string representation. */ function $32f99e13847fca05$var$encode(fidByteArray) {
    const b64String = $32f99e13847fca05$var$bufferToBase64UrlSafe(fidByteArray);
    // Remove the 23rd character that was added because of the extra 4 bits at the
    // end of our 17 byte array, and the '=' padding.
    return b64String.substr(0, 22);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a string key that can be used to identify the app. */ function $32f99e13847fca05$var$getKey(appConfig) {
    return `${appConfig.appName}!${appConfig.appId}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $32f99e13847fca05$var$fidChangeCallbacks = new Map();
/**
 * Calls the onIdChange callbacks with the new FID value, and broadcasts the
 * change to other tabs.
 */ function $32f99e13847fca05$var$fidChanged(appConfig, fid) {
    const key = $32f99e13847fca05$var$getKey(appConfig);
    $32f99e13847fca05$var$callFidChangeCallbacks(key, fid);
    $32f99e13847fca05$var$broadcastFidChange(key, fid);
}
function $32f99e13847fca05$var$addCallback(appConfig, callback) {
    // Open the broadcast channel if it's not already open,
    // to be able to listen to change events from other tabs.
    $32f99e13847fca05$var$getBroadcastChannel();
    const key = $32f99e13847fca05$var$getKey(appConfig);
    let callbackSet = $32f99e13847fca05$var$fidChangeCallbacks.get(key);
    if (!callbackSet) {
        callbackSet = new Set();
        $32f99e13847fca05$var$fidChangeCallbacks.set(key, callbackSet);
    }
    callbackSet.add(callback);
}
function $32f99e13847fca05$var$removeCallback(appConfig, callback) {
    const key = $32f99e13847fca05$var$getKey(appConfig);
    const callbackSet = $32f99e13847fca05$var$fidChangeCallbacks.get(key);
    if (!callbackSet) return;
    callbackSet.delete(callback);
    if (callbackSet.size === 0) $32f99e13847fca05$var$fidChangeCallbacks.delete(key);
    // Close broadcast channel if there are no more callbacks.
    $32f99e13847fca05$var$closeBroadcastChannel();
}
function $32f99e13847fca05$var$callFidChangeCallbacks(key, fid) {
    const callbacks = $32f99e13847fca05$var$fidChangeCallbacks.get(key);
    if (!callbacks) return;
    for (const callback of callbacks)callback(fid);
}
function $32f99e13847fca05$var$broadcastFidChange(key, fid) {
    const channel = $32f99e13847fca05$var$getBroadcastChannel();
    if (channel) channel.postMessage({
        key: key,
        fid: fid
    });
    $32f99e13847fca05$var$closeBroadcastChannel();
}
let $32f99e13847fca05$var$broadcastChannel = null;
/** Opens and returns a BroadcastChannel if it is supported by the browser. */ function $32f99e13847fca05$var$getBroadcastChannel() {
    if (!$32f99e13847fca05$var$broadcastChannel && 'BroadcastChannel' in self) {
        $32f99e13847fca05$var$broadcastChannel = new BroadcastChannel('[Firebase] FID Change');
        $32f99e13847fca05$var$broadcastChannel.onmessage = (e)=>{
            $32f99e13847fca05$var$callFidChangeCallbacks(e.data.key, e.data.fid);
        };
    }
    return $32f99e13847fca05$var$broadcastChannel;
}
function $32f99e13847fca05$var$closeBroadcastChannel() {
    if ($32f99e13847fca05$var$fidChangeCallbacks.size === 0 && $32f99e13847fca05$var$broadcastChannel) {
        $32f99e13847fca05$var$broadcastChannel.close();
        $32f99e13847fca05$var$broadcastChannel = null;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $32f99e13847fca05$var$DATABASE_NAME = 'firebase-installations-database';
const $32f99e13847fca05$var$DATABASE_VERSION = 1;
const $32f99e13847fca05$var$OBJECT_STORE_NAME = 'firebase-installations-store';
let $32f99e13847fca05$var$dbPromise = null;
function $32f99e13847fca05$var$getDbPromise() {
    if (!$32f99e13847fca05$var$dbPromise) $32f99e13847fca05$var$dbPromise = (0, $iItpQ.openDB)($32f99e13847fca05$var$DATABASE_NAME, $32f99e13847fca05$var$DATABASE_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    db.createObjectStore($32f99e13847fca05$var$OBJECT_STORE_NAME);
            }
        }
    });
    return $32f99e13847fca05$var$dbPromise;
}
/** Assigns or overwrites the record for the given key with the given value. */ async function $32f99e13847fca05$var$set(appConfig, value) {
    const key = $32f99e13847fca05$var$getKey(appConfig);
    const db = await $32f99e13847fca05$var$getDbPromise();
    const tx = db.transaction($32f99e13847fca05$var$OBJECT_STORE_NAME, 'readwrite');
    const objectStore = tx.objectStore($32f99e13847fca05$var$OBJECT_STORE_NAME);
    const oldValue = await objectStore.get(key);
    await objectStore.put(value, key);
    await tx.done;
    if (!oldValue || oldValue.fid !== value.fid) $32f99e13847fca05$var$fidChanged(appConfig, value.fid);
    return value;
}
/** Removes record(s) from the objectStore that match the given key. */ async function $32f99e13847fca05$var$remove(appConfig) {
    const key = $32f99e13847fca05$var$getKey(appConfig);
    const db = await $32f99e13847fca05$var$getDbPromise();
    const tx = db.transaction($32f99e13847fca05$var$OBJECT_STORE_NAME, 'readwrite');
    await tx.objectStore($32f99e13847fca05$var$OBJECT_STORE_NAME).delete(key);
    await tx.done;
}
/**
 * Atomically updates a record with the result of updateFn, which gets
 * called with the current value. If newValue is undefined, the record is
 * deleted instead.
 * @return Updated value
 */ async function $32f99e13847fca05$var$update(appConfig, updateFn) {
    const key = $32f99e13847fca05$var$getKey(appConfig);
    const db = await $32f99e13847fca05$var$getDbPromise();
    const tx = db.transaction($32f99e13847fca05$var$OBJECT_STORE_NAME, 'readwrite');
    const store = tx.objectStore($32f99e13847fca05$var$OBJECT_STORE_NAME);
    const oldValue = await store.get(key);
    const newValue = updateFn(oldValue);
    if (newValue === undefined) await store.delete(key);
    else await store.put(newValue, key);
    await tx.done;
    if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) $32f99e13847fca05$var$fidChanged(appConfig, newValue.fid);
    return newValue;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates and returns the InstallationEntry from the database.
 * Also triggers a registration request if it is necessary and possible.
 */ async function $32f99e13847fca05$var$getInstallationEntry(installations) {
    let registrationPromise;
    const installationEntry = await $32f99e13847fca05$var$update(installations.appConfig, (oldEntry)=>{
        const installationEntry = $32f99e13847fca05$var$updateOrCreateInstallationEntry(oldEntry);
        const entryWithPromise = $32f99e13847fca05$var$triggerRegistrationIfNecessary(installations, installationEntry);
        registrationPromise = entryWithPromise.registrationPromise;
        return entryWithPromise.installationEntry;
    });
    if (installationEntry.fid === $32f99e13847fca05$var$INVALID_FID) // FID generation failed. Waiting for the FID from the server.
    return {
        installationEntry: await registrationPromise
    };
    return {
        installationEntry: installationEntry,
        registrationPromise: registrationPromise
    };
}
/**
 * Creates a new Installation Entry if one does not exist.
 * Also clears timed out pending requests.
 */ function $32f99e13847fca05$var$updateOrCreateInstallationEntry(oldEntry) {
    const entry = oldEntry || {
        fid: $32f99e13847fca05$var$generateFid(),
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return $32f99e13847fca05$var$clearTimedOutRequest(entry);
}
/**
 * If the Firebase Installation is not registered yet, this will trigger the
 * registration and return an InProgressInstallationEntry.
 *
 * If registrationPromise does not exist, the installationEntry is guaranteed
 * to be registered.
 */ function $32f99e13847fca05$var$triggerRegistrationIfNecessary(installations, installationEntry) {
    if (installationEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        if (!navigator.onLine) {
            // Registration required but app is offline.
            const registrationPromiseWithError = Promise.reject($32f99e13847fca05$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ ));
            return {
                installationEntry: installationEntry,
                registrationPromise: registrationPromiseWithError
            };
        }
        // Try registering. Change status to IN_PROGRESS.
        const inProgressEntry = {
            fid: installationEntry.fid,
            registrationStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
            registrationTime: Date.now()
        };
        const registrationPromise = $32f99e13847fca05$var$registerInstallation(installations, inProgressEntry);
        return {
            installationEntry: inProgressEntry,
            registrationPromise: registrationPromise
        };
    } else if (installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) return {
        installationEntry: installationEntry,
        registrationPromise: $32f99e13847fca05$var$waitUntilFidRegistration(installations)
    };
    else return {
        installationEntry: installationEntry
    };
}
/** This will be executed only once for each new Firebase Installation. */ async function $32f99e13847fca05$var$registerInstallation(installations, installationEntry) {
    try {
        const registeredInstallationEntry = await $32f99e13847fca05$var$createInstallationRequest(installations, installationEntry);
        return $32f99e13847fca05$var$set(installations.appConfig, registeredInstallationEntry);
    } catch (e) {
        if ($32f99e13847fca05$var$isServerError(e) && e.customData.serverCode === 409) // Server returned a "FID cannot be used" error.
        // Generate a new ID next time.
        await $32f99e13847fca05$var$remove(installations.appConfig);
        else // Registration failed. Set FID as not registered.
        await $32f99e13847fca05$var$set(installations.appConfig, {
            fid: installationEntry.fid,
            registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
        });
        throw e;
    }
}
/** Call if FID registration is pending in another request. */ async function $32f99e13847fca05$var$waitUntilFidRegistration(installations) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await $32f99e13847fca05$var$updateInstallationRequest(installations.appConfig);
    while(entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // createInstallation request still in progress.
        await $32f99e13847fca05$var$sleep(100);
        entry = await $32f99e13847fca05$var$updateInstallationRequest(installations.appConfig);
    }
    if (entry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        // The request timed out or failed in a different call. Try again.
        const { installationEntry: installationEntry, registrationPromise: registrationPromise } = await $32f99e13847fca05$var$getInstallationEntry(installations);
        if (registrationPromise) return registrationPromise;
        else // if there is no registrationPromise, entry is registered.
        return installationEntry;
    }
    return entry;
}
/**
 * Called only if there is a CreateInstallation request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * CreateInstallation request.
 *
 * Returns the updated InstallationEntry.
 */ function $32f99e13847fca05$var$updateInstallationRequest(appConfig) {
    return $32f99e13847fca05$var$update(appConfig, (oldEntry)=>{
        if (!oldEntry) throw $32f99e13847fca05$var$ERROR_FACTORY.create("installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ );
        return $32f99e13847fca05$var$clearTimedOutRequest(oldEntry);
    });
}
function $32f99e13847fca05$var$clearTimedOutRequest(entry) {
    if ($32f99e13847fca05$var$hasInstallationRequestTimedOut(entry)) return {
        fid: entry.fid,
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return entry;
}
function $32f99e13847fca05$var$hasInstallationRequestTimedOut(installationEntry) {
    return installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */  && installationEntry.registrationTime + $32f99e13847fca05$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $32f99e13847fca05$var$generateAuthTokenRequest({ appConfig: appConfig, heartbeatServiceProvider: heartbeatServiceProvider }, installationEntry) {
    const endpoint = $32f99e13847fca05$var$getGenerateAuthTokenEndpoint(appConfig, installationEntry);
    const headers = $32f99e13847fca05$var$getHeadersWithAuth(appConfig, installationEntry);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append('x-firebase-client', heartbeatsHeader);
    }
    const body = {
        installation: {
            sdkVersion: $32f99e13847fca05$var$PACKAGE_VERSION,
            appId: appConfig.appId
        }
    };
    const request = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body)
    };
    const response = await $32f99e13847fca05$var$retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const completedAuthToken = $32f99e13847fca05$var$extractAuthTokenInfoFromResponse(responseValue);
        return completedAuthToken;
    } else throw await $32f99e13847fca05$var$getErrorFromResponse('Generate Auth Token', response);
}
function $32f99e13847fca05$var$getGenerateAuthTokenEndpoint(appConfig, { fid: fid }) {
    return `${$32f99e13847fca05$var$getInstallationsEndpoint(appConfig)}/${fid}/authTokens:generate`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a valid authentication token for the installation. Generates a new
 * token if one doesn't exist, is expired or about to expire.
 *
 * Should only be called if the Firebase Installation is registered.
 */ async function $32f99e13847fca05$var$refreshAuthToken(installations, forceRefresh = false) {
    let tokenPromise;
    const entry = await $32f99e13847fca05$var$update(installations.appConfig, (oldEntry)=>{
        if (!$32f99e13847fca05$var$isEntryRegistered(oldEntry)) throw $32f99e13847fca05$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if (!forceRefresh && $32f99e13847fca05$var$isAuthTokenValid(oldAuthToken)) // There is a valid token in the DB.
        return oldEntry;
        else if (oldAuthToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ) {
            // There already is a token request in progress.
            tokenPromise = $32f99e13847fca05$var$waitUntilAuthTokenRequest(installations, forceRefresh);
            return oldEntry;
        } else {
            // No token or token expired.
            if (!navigator.onLine) throw $32f99e13847fca05$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            const inProgressEntry = $32f99e13847fca05$var$makeAuthTokenRequestInProgressEntry(oldEntry);
            tokenPromise = $32f99e13847fca05$var$fetchAuthTokenFromServer(installations, inProgressEntry);
            return inProgressEntry;
        }
    });
    const authToken = tokenPromise ? await tokenPromise : entry.authToken;
    return authToken;
}
/**
 * Call only if FID is registered and Auth Token request is in progress.
 *
 * Waits until the current pending request finishes. If the request times out,
 * tries once in this thread as well.
 */ async function $32f99e13847fca05$var$waitUntilAuthTokenRequest(installations, forceRefresh) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await $32f99e13847fca05$var$updateAuthTokenRequest(installations.appConfig);
    while(entry.authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // generateAuthToken still in progress.
        await $32f99e13847fca05$var$sleep(100);
        entry = await $32f99e13847fca05$var$updateAuthTokenRequest(installations.appConfig);
    }
    const authToken = entry.authToken;
    if (authToken.requestStatus === 0 /* RequestStatus.NOT_STARTED */ ) // The request timed out or failed in a different call. Try again.
    return $32f99e13847fca05$var$refreshAuthToken(installations, forceRefresh);
    else return authToken;
}
/**
 * Called only if there is a GenerateAuthToken request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * GenerateAuthToken request.
 *
 * Returns the updated InstallationEntry.
 */ function $32f99e13847fca05$var$updateAuthTokenRequest(appConfig) {
    return $32f99e13847fca05$var$update(appConfig, (oldEntry)=>{
        if (!$32f99e13847fca05$var$isEntryRegistered(oldEntry)) throw $32f99e13847fca05$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if ($32f99e13847fca05$var$hasAuthTokenRequestTimedOut(oldAuthToken)) return {
            ...oldEntry,
            authToken: {
                requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
            }
        };
        return oldEntry;
    });
}
async function $32f99e13847fca05$var$fetchAuthTokenFromServer(installations, installationEntry) {
    try {
        const authToken = await $32f99e13847fca05$var$generateAuthTokenRequest(installations, installationEntry);
        const updatedInstallationEntry = {
            ...installationEntry,
            authToken: authToken
        };
        await $32f99e13847fca05$var$set(installations.appConfig, updatedInstallationEntry);
        return authToken;
    } catch (e) {
        if ($32f99e13847fca05$var$isServerError(e) && (e.customData.serverCode === 401 || e.customData.serverCode === 404)) // Server returned a "FID not found" or a "Invalid authentication" error.
        // Generate a new ID next time.
        await $32f99e13847fca05$var$remove(installations.appConfig);
        else {
            const updatedInstallationEntry = {
                ...installationEntry,
                authToken: {
                    requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
                }
            };
            await $32f99e13847fca05$var$set(installations.appConfig, updatedInstallationEntry);
        }
        throw e;
    }
}
function $32f99e13847fca05$var$isEntryRegistered(installationEntry) {
    return installationEntry !== undefined && installationEntry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ;
}
function $32f99e13847fca05$var$isAuthTokenValid(authToken) {
    return authToken.requestStatus === 2 /* RequestStatus.COMPLETED */  && !$32f99e13847fca05$var$isAuthTokenExpired(authToken);
}
function $32f99e13847fca05$var$isAuthTokenExpired(authToken) {
    const now = Date.now();
    return now < authToken.creationTime || authToken.creationTime + authToken.expiresIn < now + $32f99e13847fca05$var$TOKEN_EXPIRATION_BUFFER;
}
/** Returns an updated InstallationEntry with an InProgressAuthToken. */ function $32f99e13847fca05$var$makeAuthTokenRequestInProgressEntry(oldEntry) {
    const inProgressAuthToken = {
        requestStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
        requestTime: Date.now()
    };
    return {
        ...oldEntry,
        authToken: inProgressAuthToken
    };
}
function $32f99e13847fca05$var$hasAuthTokenRequestTimedOut(authToken) {
    return authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */  && authToken.requestTime + $32f99e13847fca05$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a Firebase Installation if there isn't one for the app and
 * returns the Installation ID.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function $32f99e13847fca05$export$218c8c3169c024d2(installations) {
    const installationsImpl = installations;
    const { installationEntry: installationEntry, registrationPromise: registrationPromise } = await $32f99e13847fca05$var$getInstallationEntry(installationsImpl);
    if (registrationPromise) registrationPromise.catch(console.error);
    else // If the installation is already registered, update the authentication
    // token if needed.
    $32f99e13847fca05$var$refreshAuthToken(installationsImpl).catch(console.error);
    return installationEntry.fid;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a Firebase Installations auth token, identifying the current
 * Firebase Installation.
 * @param installations - The `Installations` instance.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $32f99e13847fca05$export$257b2d10b709d8ef(installations, forceRefresh = false) {
    const installationsImpl = installations;
    await $32f99e13847fca05$var$completeInstallationRegistration(installationsImpl);
    // At this point we either have a Registered Installation in the DB, or we've
    // already thrown an error.
    const authToken = await $32f99e13847fca05$var$refreshAuthToken(installationsImpl, forceRefresh);
    return authToken.token;
}
async function $32f99e13847fca05$var$completeInstallationRegistration(installations) {
    const { registrationPromise: registrationPromise } = await $32f99e13847fca05$var$getInstallationEntry(installations);
    if (registrationPromise) // A createInstallation request is in progress. Wait until it finishes.
    await registrationPromise;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $32f99e13847fca05$var$deleteInstallationRequest(appConfig, installationEntry) {
    const endpoint = $32f99e13847fca05$var$getDeleteEndpoint(appConfig, installationEntry);
    const headers = $32f99e13847fca05$var$getHeadersWithAuth(appConfig, installationEntry);
    const request = {
        method: 'DELETE',
        headers: headers
    };
    const response = await $32f99e13847fca05$var$retryIfServerError(()=>fetch(endpoint, request));
    if (!response.ok) throw await $32f99e13847fca05$var$getErrorFromResponse('Delete Installation', response);
}
function $32f99e13847fca05$var$getDeleteEndpoint(appConfig, { fid: fid }) {
    return `${$32f99e13847fca05$var$getInstallationsEndpoint(appConfig)}/${fid}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Deletes the Firebase Installation and all associated data.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function $32f99e13847fca05$export$5f6b87a08674814c(installations) {
    const { appConfig: appConfig } = installations;
    const entry = await $32f99e13847fca05$var$update(appConfig, (oldEntry)=>{
        if (oldEntry && oldEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) // Delete the unregistered entry without sending a deleteInstallation request.
        return undefined;
        return oldEntry;
    });
    if (entry) {
        if (entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) // Can't delete while trying to register.
        throw $32f99e13847fca05$var$ERROR_FACTORY.create("delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ );
        else if (entry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ) {
            if (!navigator.onLine) throw $32f99e13847fca05$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            else {
                await $32f99e13847fca05$var$deleteInstallationRequest(appConfig, entry);
                await $32f99e13847fca05$var$remove(appConfig);
            }
        }
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sets a new callback that will get called when Installation ID changes.
 * Returns an unsubscribe function that will remove the callback when called.
 * @param installations - The `Installations` instance.
 * @param callback - The callback function that is invoked when FID changes.
 * @returns A function that can be called to unsubscribe.
 *
 * @public
 */ function $32f99e13847fca05$export$ceb4c11381bc36e8(installations, callback) {
    const { appConfig: appConfig } = installations;
    $32f99e13847fca05$var$addCallback(appConfig, callback);
    return ()=>{
        $32f99e13847fca05$var$removeCallback(appConfig, callback);
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an instance of {@link Installations} associated with the given
 * {@link @firebase/app#FirebaseApp} instance.
 * @param app - The {@link @firebase/app#FirebaseApp} instance.
 *
 * @public
 */ function $32f99e13847fca05$export$9bfc115e43431ff5(app = (0, $86cnQ.getApp)()) {
    const installationsImpl = (0, $86cnQ._getProvider)(app, 'installations').getImmediate();
    return installationsImpl;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $32f99e13847fca05$var$extractAppConfig(app) {
    if (!app || !app.options) throw $32f99e13847fca05$var$getMissingValueError('App Configuration');
    if (!app.name) throw $32f99e13847fca05$var$getMissingValueError('App Name');
    // Required app config keys
    const configKeys = [
        'projectId',
        'apiKey',
        'appId'
    ];
    for (const keyName of configKeys){
        if (!app.options[keyName]) throw $32f99e13847fca05$var$getMissingValueError(keyName);
    }
    return {
        appName: app.name,
        projectId: app.options.projectId,
        apiKey: app.options.apiKey,
        appId: app.options.appId
    };
}
function $32f99e13847fca05$var$getMissingValueError(valueName) {
    return $32f99e13847fca05$var$ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ , {
        valueName: valueName
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $32f99e13847fca05$var$INSTALLATIONS_NAME = 'installations';
const $32f99e13847fca05$var$INSTALLATIONS_NAME_INTERNAL = 'installations-internal';
const $32f99e13847fca05$var$publicFactory = (container)=>{
    const app = container.getProvider('app').getImmediate();
    // Throws if app isn't configured properly.
    const appConfig = $32f99e13847fca05$var$extractAppConfig(app);
    const heartbeatServiceProvider = (0, $86cnQ._getProvider)(app, 'heartbeat');
    const installationsImpl = {
        app: app,
        appConfig: appConfig,
        heartbeatServiceProvider: heartbeatServiceProvider,
        _delete: ()=>Promise.resolve()
    };
    return installationsImpl;
};
const $32f99e13847fca05$var$internalFactory = (container)=>{
    const app = container.getProvider('app').getImmediate();
    // Internal FIS instance relies on public FIS instance.
    const installations = (0, $86cnQ._getProvider)(app, $32f99e13847fca05$var$INSTALLATIONS_NAME).getImmediate();
    const installationsInternal = {
        getId: ()=>$32f99e13847fca05$export$218c8c3169c024d2(installations),
        getToken: (forceRefresh)=>$32f99e13847fca05$export$257b2d10b709d8ef(installations, forceRefresh)
    };
    return installationsInternal;
};
function $32f99e13847fca05$var$registerInstallations() {
    (0, $86cnQ._registerComponent)(new (0, $7vOQ3.Component)($32f99e13847fca05$var$INSTALLATIONS_NAME, $32f99e13847fca05$var$publicFactory, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $86cnQ._registerComponent)(new (0, $7vOQ3.Component)($32f99e13847fca05$var$INSTALLATIONS_NAME_INTERNAL, $32f99e13847fca05$var$internalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
}
/**
 * The Firebase Installations Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */ /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ $32f99e13847fca05$var$registerInstallations();
(0, $86cnQ.registerVersion)($32f99e13847fca05$var$name, $32f99e13847fca05$var$version);
// BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
(0, $86cnQ.registerVersion)($32f99e13847fca05$var$name, $32f99e13847fca05$var$version, 'esm2020');


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Analytics.
 */ const $2ae19001f49ef294$var$ANALYTICS_TYPE = 'analytics';
// Key to attach FID to in gtag params.
const $2ae19001f49ef294$var$GA_FID_KEY = 'firebase_id';
const $2ae19001f49ef294$var$ORIGIN_KEY = 'origin';
const $2ae19001f49ef294$var$FETCH_TIMEOUT_MILLIS = 60000;
const $2ae19001f49ef294$var$DYNAMIC_CONFIG_URL = 'https://firebase.googleapis.com/v1alpha/projects/-/apps/{app-id}/webConfig';
const $2ae19001f49ef294$var$GTAG_URL = 'https://www.googletagmanager.com/gtag/js';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2ae19001f49ef294$var$logger = new (0, $7I6Lr.Logger)('@firebase/analytics');
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2ae19001f49ef294$var$ERRORS = {
    ["already-exists" /* AnalyticsError.ALREADY_EXISTS */ ]: "A Firebase Analytics instance with the appId {$id}  already exists. Only one Firebase Analytics instance can be created for each appId.",
    ["already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ ]: "initializeAnalytics() cannot be called again with different options than those it was initially called with. It can be called again with the same options to return the existing instance, or getAnalytics() can be used to get a reference to the already-initialized instance.",
    ["already-initialized-settings" /* AnalyticsError.ALREADY_INITIALIZED_SETTINGS */ ]: "Firebase Analytics has already been initialized.settings() must be called before initializing any Analytics instanceor it will have no effect.",
    ["interop-component-reg-failed" /* AnalyticsError.INTEROP_COMPONENT_REG_FAILED */ ]: 'Firebase Analytics Interop Component failed to instantiate: {$reason}',
    ["invalid-analytics-context" /* AnalyticsError.INVALID_ANALYTICS_CONTEXT */ ]: "Firebase Analytics is not supported in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}",
    ["indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ ]: "IndexedDB unavailable or restricted in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}",
    ["fetch-throttle" /* AnalyticsError.FETCH_THROTTLE */ ]: "The config fetch request timed out while in an exponential backoff state. Unix timestamp in milliseconds when fetch request throttling ends: {$throttleEndTimeMillis}.",
    ["config-fetch-failed" /* AnalyticsError.CONFIG_FETCH_FAILED */ ]: 'Dynamic config fetch failed: [{$httpStatus}] {$responseMessage}',
    ["no-api-key" /* AnalyticsError.NO_API_KEY */ ]: 'The "apiKey" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid API key.',
    ["no-app-id" /* AnalyticsError.NO_APP_ID */ ]: 'The "appId" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid app ID.',
    ["no-client-id" /* AnalyticsError.NO_CLIENT_ID */ ]: 'The "client_id" field is empty.',
    ["invalid-gtag-resource" /* AnalyticsError.INVALID_GTAG_RESOURCE */ ]: 'Trusted Types detected an invalid gtag resource: {$gtagURL}.'
};
const $2ae19001f49ef294$var$ERROR_FACTORY = new (0, $dPHSJ.ErrorFactory)('analytics', 'Analytics', $2ae19001f49ef294$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies and creates a TrustedScriptURL.
 */ function $2ae19001f49ef294$var$createGtagTrustedTypesScriptURL(url) {
    if (!url.startsWith($2ae19001f49ef294$var$GTAG_URL)) {
        const err = $2ae19001f49ef294$var$ERROR_FACTORY.create("invalid-gtag-resource" /* AnalyticsError.INVALID_GTAG_RESOURCE */ , {
            gtagURL: url
        });
        $2ae19001f49ef294$var$logger.warn(err.message);
        return '';
    }
    return url;
}
/**
 * Makeshift polyfill for Promise.allSettled(). Resolves when all promises
 * have either resolved or rejected.
 *
 * @param promises Array of promises to wait for.
 */ function $2ae19001f49ef294$var$promiseAllSettled(promises) {
    return Promise.all(promises.map((promise)=>promise.catch((e)=>e)));
}
/**
 * Creates a TrustedTypePolicy object that implements the rules passed as policyOptions.
 *
 * @param policyName A string containing the name of the policy
 * @param policyOptions Object containing implementations of instance methods for TrustedTypesPolicy, see {@link https://developer.mozilla.org/en-US/docs/Web/API/TrustedTypePolicy#instance_methods
 * | the TrustedTypePolicy reference documentation}.
 */ function $2ae19001f49ef294$var$createTrustedTypesPolicy(policyName, policyOptions) {
    // Create a TrustedTypes policy that we can use for updating src
    // properties
    let trustedTypesPolicy;
    if (window.trustedTypes) trustedTypesPolicy = window.trustedTypes.createPolicy(policyName, policyOptions);
    return trustedTypesPolicy;
}
/**
 * Inserts gtag script tag into the page to asynchronously download gtag.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function $2ae19001f49ef294$var$insertScriptTag(dataLayerName, measurementId) {
    const trustedTypesPolicy = $2ae19001f49ef294$var$createTrustedTypesPolicy('firebase-js-sdk-policy', {
        createScriptURL: $2ae19001f49ef294$var$createGtagTrustedTypesScriptURL
    });
    const script = document.createElement('script');
    // We are not providing an analyticsId in the URL because it would trigger a `page_view`
    // without fid. We will initialize ga-id using gtag (config) command together with fid.
    const gtagScriptURL = `${$2ae19001f49ef294$var$GTAG_URL}?l=${dataLayerName}&id=${measurementId}`;
    script.src = trustedTypesPolicy ? trustedTypesPolicy?.createScriptURL(gtagScriptURL) : gtagScriptURL;
    script.async = true;
    document.head.appendChild(script);
}
/**
 * Get reference to, or create, global datalayer.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function $2ae19001f49ef294$var$getOrCreateDataLayer(dataLayerName) {
    // Check for existing dataLayer and create if needed.
    let dataLayer = [];
    if (Array.isArray(window[dataLayerName])) dataLayer = window[dataLayerName];
    else window[dataLayerName] = dataLayer;
    return dataLayer;
}
/**
 * Wrapped gtag logic when gtag is called with 'config' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param measurementId GA Measurement ID to set config for.
 * @param gtagParams Gtag config params to set.
 */ async function $2ae19001f49ef294$var$gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams) {
    // If config is already fetched, we know the appId and can use it to look up what FID promise we
    /// are waiting for, and wait only on that one.
    const correspondingAppId = measurementIdToAppId[measurementId];
    try {
        if (correspondingAppId) await initializationPromisesMap[correspondingAppId];
        else {
            // If config is not fetched yet, wait for all configs (we don't know which one we need) and
            // find the appId (if any) corresponding to this measurementId. If there is one, wait on
            // that appId's initialization promise. If there is none, promise resolves and gtag
            // call goes through.
            const dynamicConfigResults = await $2ae19001f49ef294$var$promiseAllSettled(dynamicConfigPromisesList);
            const foundConfig = dynamicConfigResults.find((config)=>config.measurementId === measurementId);
            if (foundConfig) await initializationPromisesMap[foundConfig.appId];
        }
    } catch (e) {
        $2ae19001f49ef294$var$logger.error(e);
    }
    gtagCore("config" /* GtagCommand.CONFIG */ , measurementId, gtagParams);
}
/**
 * Wrapped gtag logic when gtag is called with 'event' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementId GA Measurement ID to log event to.
 * @param gtagParams Params to log with this event.
 */ async function $2ae19001f49ef294$var$gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams) {
    try {
        let initializationPromisesToWaitFor = [];
        // If there's a 'send_to' param, check if any ID specified matches
        // an initializeIds() promise we are waiting for.
        if (gtagParams && gtagParams['send_to']) {
            let gaSendToList = gtagParams['send_to'];
            // Make it an array if is isn't, so it can be dealt with the same way.
            if (!Array.isArray(gaSendToList)) gaSendToList = [
                gaSendToList
            ];
            // Checking 'send_to' fields requires having all measurement ID results back from
            // the dynamic config fetch.
            const dynamicConfigResults = await $2ae19001f49ef294$var$promiseAllSettled(dynamicConfigPromisesList);
            for (const sendToId of gaSendToList){
                // Any fetched dynamic measurement ID that matches this 'send_to' ID
                const foundConfig = dynamicConfigResults.find((config)=>config.measurementId === sendToId);
                const initializationPromise = foundConfig && initializationPromisesMap[foundConfig.appId];
                if (initializationPromise) initializationPromisesToWaitFor.push(initializationPromise);
                else {
                    // Found an item in 'send_to' that is not associated
                    // directly with an FID, possibly a group.  Empty this array,
                    // exit the loop early, and let it get populated below.
                    initializationPromisesToWaitFor = [];
                    break;
                }
            }
        }
        // This will be unpopulated if there was no 'send_to' field , or
        // if not all entries in the 'send_to' field could be mapped to
        // a FID. In these cases, wait on all pending initialization promises.
        if (initializationPromisesToWaitFor.length === 0) /* eslint-disable-next-line @typescript-eslint/no-floating-promises */ initializationPromisesToWaitFor = Object.values(initializationPromisesMap);
        // Run core gtag function with args after all relevant initialization
        // promises have been resolved.
        await Promise.all(initializationPromisesToWaitFor);
        // Workaround for http://b/141370449 - third argument cannot be undefined.
        gtagCore("event" /* GtagCommand.EVENT */ , measurementId, gtagParams || {});
    } catch (e) {
        $2ae19001f49ef294$var$logger.error(e);
    }
}
/**
 * Wraps a standard gtag function with extra code to wait for completion of
 * relevant initialization promises before sending requests.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 */ function $2ae19001f49ef294$var$wrapGtag(gtagCore, /**
 * Allows wrapped gtag calls to wait on whichever initialization promises are required,
 * depending on the contents of the gtag params' `send_to` field, if any.
 */ initializationPromisesMap, /**
 * Wrapped gtag calls sometimes require all dynamic config fetches to have returned
 * before determining what initialization promises (which include FIDs) to wait for.
 */ dynamicConfigPromisesList, /**
 * Wrapped gtag config calls can narrow down which initialization promise (with FID)
 * to wait for if the measurementId is already fetched, by getting the corresponding appId,
 * which is the key for the initialization promises map.
 */ measurementIdToAppId) {
    /**
     * Wrapper around gtag that ensures FID is sent with gtag calls.
     * @param command Gtag command type.
     * @param idOrNameOrParams Measurement ID if command is EVENT/CONFIG, params if command is SET.
     * @param gtagParams Params if event is EVENT/CONFIG.
     */ async function gtagWrapper(command, ...args) {
        try {
            // If event, check that relevant initialization promises have completed.
            if (command === "event" /* GtagCommand.EVENT */ ) {
                const [measurementId, gtagParams] = args;
                // If EVENT, second arg must be measurementId.
                await $2ae19001f49ef294$var$gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams);
            } else if (command === "config" /* GtagCommand.CONFIG */ ) {
                const [measurementId, gtagParams] = args;
                // If CONFIG, second arg must be measurementId.
                await $2ae19001f49ef294$var$gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams);
            } else if (command === "consent" /* GtagCommand.CONSENT */ ) {
                const [consentAction, gtagParams] = args;
                // consentAction can be one of 'default' or 'update'.
                gtagCore("consent" /* GtagCommand.CONSENT */ , consentAction, gtagParams);
            } else if (command === "get" /* GtagCommand.GET */ ) {
                const [measurementId, fieldName, callback] = args;
                gtagCore("get" /* GtagCommand.GET */ , measurementId, fieldName, callback);
            } else if (command === "set" /* GtagCommand.SET */ ) {
                const [customParams] = args;
                // If SET, second arg must be params.
                gtagCore("set" /* GtagCommand.SET */ , customParams);
            } else gtagCore(command, ...args);
        } catch (e) {
            $2ae19001f49ef294$var$logger.error(e);
        }
    }
    return gtagWrapper;
}
/**
 * Creates global gtag function or wraps existing one if found.
 * This wrapped function attaches Firebase instance ID (FID) to gtag 'config' and
 * 'event' calls that belong to the GAID associated with this Firebase instance.
 *
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param dataLayerName Name of global GA datalayer array.
 * @param gtagFunctionName Name of global gtag function ("gtag" if not user-specified).
 */ function $2ae19001f49ef294$var$wrapOrCreateGtag(initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, dataLayerName, gtagFunctionName) {
    // Create a basic core gtag function
    let gtagCore = function(..._args) {
        // Must push IArguments object, not an array.
        window[dataLayerName].push(arguments);
    };
    // Replace it with existing one if found
    if (window[gtagFunctionName] && typeof window[gtagFunctionName] === 'function') // @ts-ignore
    gtagCore = window[gtagFunctionName];
    window[gtagFunctionName] = $2ae19001f49ef294$var$wrapGtag(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId);
    return {
        gtagCore: gtagCore,
        wrappedGtag: window[gtagFunctionName]
    };
}
/**
 * Returns the script tag in the DOM matching both the gtag url pattern
 * and the provided data layer name.
 */ function $2ae19001f49ef294$var$findGtagScriptOnPage(dataLayerName) {
    const scriptTags = window.document.getElementsByTagName('script');
    for (const tag of Object.values(scriptTags)){
        if (tag.src && tag.src.includes($2ae19001f49ef294$var$GTAG_URL) && tag.src.includes(dataLayerName)) return tag;
    }
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Backoff factor for 503 errors, which we want to be conservative about
 * to avoid overloading servers. Each retry interval will be
 * BASE_INTERVAL_MILLIS * LONG_RETRY_FACTOR ^ retryCount, so the second one
 * will be ~30 seconds (with fuzzing).
 */ const $2ae19001f49ef294$var$LONG_RETRY_FACTOR = 30;
/**
 * Base wait interval to multiplied by backoffFactor^backoffCount.
 */ const $2ae19001f49ef294$var$BASE_INTERVAL_MILLIS = 1000;
/**
 * Stubbable retry data storage class.
 */ class $2ae19001f49ef294$var$RetryData {
    constructor(throttleMetadata = {}, intervalMillis = $2ae19001f49ef294$var$BASE_INTERVAL_MILLIS){
        this.throttleMetadata = throttleMetadata;
        this.intervalMillis = intervalMillis;
    }
    getThrottleMetadata(appId) {
        return this.throttleMetadata[appId];
    }
    setThrottleMetadata(appId, metadata) {
        this.throttleMetadata[appId] = metadata;
    }
    deleteThrottleMetadata(appId) {
        delete this.throttleMetadata[appId];
    }
}
const $2ae19001f49ef294$var$defaultRetryData = new $2ae19001f49ef294$var$RetryData();
/**
 * Set GET request headers.
 * @param apiKey App API key.
 */ function $2ae19001f49ef294$var$getHeaders(apiKey) {
    return new Headers({
        Accept: 'application/json',
        'x-goog-api-key': apiKey
    });
}
/**
 * Fetches dynamic config from backend.
 * @param app Firebase app to fetch config for.
 */ async function $2ae19001f49ef294$var$fetchDynamicConfig(appFields) {
    const { appId: appId, apiKey: apiKey } = appFields;
    const request = {
        method: 'GET',
        headers: $2ae19001f49ef294$var$getHeaders(apiKey)
    };
    const appUrl = $2ae19001f49ef294$var$DYNAMIC_CONFIG_URL.replace('{app-id}', appId);
    const response = await fetch(appUrl, request);
    if (response.status !== 200 && response.status !== 304) {
        let errorMessage = '';
        try {
            // Try to get any error message text from server response.
            const jsonResponse = await response.json();
            if (jsonResponse.error?.message) errorMessage = jsonResponse.error.message;
        } catch (_ignored) {}
        throw $2ae19001f49ef294$var$ERROR_FACTORY.create("config-fetch-failed" /* AnalyticsError.CONFIG_FETCH_FAILED */ , {
            httpStatus: response.status,
            responseMessage: errorMessage
        });
    }
    return response.json();
}
/**
 * Fetches dynamic config from backend, retrying if failed.
 * @param app Firebase app to fetch config for.
 */ async function $2ae19001f49ef294$var$fetchDynamicConfigWithRetry(app, // retryData and timeoutMillis are parameterized to allow passing a different value for testing.
retryData = $2ae19001f49ef294$var$defaultRetryData, timeoutMillis) {
    const { appId: appId, apiKey: apiKey, measurementId: measurementId } = app.options;
    if (!appId) throw $2ae19001f49ef294$var$ERROR_FACTORY.create("no-app-id" /* AnalyticsError.NO_APP_ID */ );
    if (!apiKey) {
        if (measurementId) return {
            measurementId: measurementId,
            appId: appId
        };
        throw $2ae19001f49ef294$var$ERROR_FACTORY.create("no-api-key" /* AnalyticsError.NO_API_KEY */ );
    }
    const throttleMetadata = retryData.getThrottleMetadata(appId) || {
        backoffCount: 0,
        throttleEndTimeMillis: Date.now()
    };
    const signal = new $2ae19001f49ef294$var$AnalyticsAbortSignal();
    setTimeout(async ()=>{
        // Note a very low delay, eg < 10ms, can elapse before listeners are initialized.
        signal.abort();
    }, $2ae19001f49ef294$var$FETCH_TIMEOUT_MILLIS);
    return $2ae19001f49ef294$var$attemptFetchDynamicConfigWithRetry({
        appId: appId,
        apiKey: apiKey,
        measurementId: measurementId
    }, throttleMetadata, signal, retryData);
}
/**
 * Runs one retry attempt.
 * @param appFields Necessary app config fields.
 * @param throttleMetadata Ongoing metadata to determine throttling times.
 * @param signal Abort signal.
 */ async function $2ae19001f49ef294$var$attemptFetchDynamicConfigWithRetry(appFields, { throttleEndTimeMillis: throttleEndTimeMillis, backoffCount: backoffCount }, signal, retryData = $2ae19001f49ef294$var$defaultRetryData // for testing
) {
    const { appId: appId, measurementId: measurementId } = appFields;
    // Starts with a (potentially zero) timeout to support resumption from stored state.
    // Ensures the throttle end time is honored if the last attempt timed out.
    // Note the SDK will never make a request if the fetch timeout expires at this point.
    try {
        await $2ae19001f49ef294$var$setAbortableTimeout(signal, throttleEndTimeMillis);
    } catch (e) {
        if (measurementId) {
            $2ae19001f49ef294$var$logger.warn(`Timed out fetching this Firebase app's measurement ID from the server.` + ` Falling back to the measurement ID ${measurementId}` + ` provided in the "measurementId" field in the local Firebase config. [${e?.message}]`);
            return {
                appId: appId,
                measurementId: measurementId
            };
        }
        throw e;
    }
    try {
        const response = await $2ae19001f49ef294$var$fetchDynamicConfig(appFields);
        // Note the SDK only clears throttle state if response is success or non-retriable.
        retryData.deleteThrottleMetadata(appId);
        return response;
    } catch (e) {
        const error = e;
        if (!$2ae19001f49ef294$var$isRetriableError(error)) {
            retryData.deleteThrottleMetadata(appId);
            if (measurementId) {
                $2ae19001f49ef294$var$logger.warn(`Failed to fetch this Firebase app's measurement ID from the server.` + ` Falling back to the measurement ID ${measurementId}` + ` provided in the "measurementId" field in the local Firebase config. [${error?.message}]`);
                return {
                    appId: appId,
                    measurementId: measurementId
                };
            } else throw e;
        }
        const backoffMillis = Number(error?.customData?.httpStatus) === 503 ? (0, $dPHSJ.calculateBackoffMillis)(backoffCount, retryData.intervalMillis, $2ae19001f49ef294$var$LONG_RETRY_FACTOR) : (0, $dPHSJ.calculateBackoffMillis)(backoffCount, retryData.intervalMillis);
        // Increments backoff state.
        const throttleMetadata = {
            throttleEndTimeMillis: Date.now() + backoffMillis,
            backoffCount: backoffCount + 1
        };
        // Persists state.
        retryData.setThrottleMetadata(appId, throttleMetadata);
        $2ae19001f49ef294$var$logger.debug(`Calling attemptFetch again in ${backoffMillis} millis`);
        return $2ae19001f49ef294$var$attemptFetchDynamicConfigWithRetry(appFields, throttleMetadata, signal, retryData);
    }
}
/**
 * Supports waiting on a backoff by:
 *
 * <ul>
 *   <li>Promisifying setTimeout, so we can set a timeout in our Promise chain</li>
 *   <li>Listening on a signal bus for abort events, just like the Fetch API</li>
 *   <li>Failing in the same way the Fetch API fails, so timing out a live request and a throttled
 *       request appear the same.</li>
 * </ul>
 *
 * <p>Visible for testing.
 */ function $2ae19001f49ef294$var$setAbortableTimeout(signal, throttleEndTimeMillis) {
    return new Promise((resolve, reject)=>{
        // Derives backoff from given end time, normalizing negative numbers to zero.
        const backoffMillis = Math.max(throttleEndTimeMillis - Date.now(), 0);
        const timeout = setTimeout(resolve, backoffMillis);
        // Adds listener, rather than sets onabort, because signal is a shared object.
        signal.addEventListener(()=>{
            clearTimeout(timeout);
            // If the request completes before this timeout, the rejection has no effect.
            reject($2ae19001f49ef294$var$ERROR_FACTORY.create("fetch-throttle" /* AnalyticsError.FETCH_THROTTLE */ , {
                throttleEndTimeMillis: throttleEndTimeMillis
            }));
        });
    });
}
/**
 * Returns true if the {@link Error} indicates a fetch request may succeed later.
 */ function $2ae19001f49ef294$var$isRetriableError(e) {
    if (!(e instanceof (0, $dPHSJ.FirebaseError)) || !e.customData) return false;
    // Uses string index defined by ErrorData, which FirebaseError implements.
    const httpStatus = Number(e.customData['httpStatus']);
    return httpStatus === 429 || httpStatus === 500 || httpStatus === 503 || httpStatus === 504;
}
/**
 * Shims a minimal AbortSignal (copied from Remote Config).
 *
 * <p>AbortController's AbortSignal conveniently decouples fetch timeout logic from other aspects
 * of networking, such as retries. Firebase doesn't use AbortController enough to justify a
 * polyfill recommendation, like we do with the Fetch API, but this minimal shim can easily be
 * swapped out if/when we do.
 */ class $2ae19001f49ef294$var$AnalyticsAbortSignal {
    constructor(){
        this.listeners = [];
    }
    addEventListener(listener) {
        this.listeners.push(listener);
    }
    abort() {
        this.listeners.forEach((listener)=>listener());
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Event parameters to set on 'gtag' during initialization.
 */ let $2ae19001f49ef294$var$defaultEventParametersForInit;
/**
 * Logs an analytics event through the Firebase SDK.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param eventName Google Analytics event name, choose from standard list or use a custom string.
 * @param eventParams Analytics event parameters.
 */ async function $2ae19001f49ef294$var$logEvent$1(gtagFunction, initializationPromise, eventName, eventParams, options) {
    if (options && options.global) {
        gtagFunction("event" /* GtagCommand.EVENT */ , eventName, eventParams);
        return;
    } else {
        const measurementId = await initializationPromise;
        const params = {
            ...eventParams,
            'send_to': measurementId
        };
        gtagFunction("event" /* GtagCommand.EVENT */ , eventName, params);
    }
}
/**
 * Set screen_name parameter for this Google Analytics ID.
 *
 * @deprecated Use {@link logEvent} with `eventName` as 'screen_view' and add relevant `eventParams`.
 * See {@link https://firebase.google.com/docs/analytics/screenviews | Track Screenviews}.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param screenName Screen name string to set.
 */ async function $2ae19001f49ef294$var$setCurrentScreen$1(gtagFunction, initializationPromise, screenName, options) {
    if (options && options.global) {
        gtagFunction("set" /* GtagCommand.SET */ , {
            'screen_name': screenName
        });
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            'screen_name': screenName
        });
    }
}
/**
 * Set user_id parameter for this Google Analytics ID.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param id User ID string to set
 */ async function $2ae19001f49ef294$var$setUserId$1(gtagFunction, initializationPromise, id, options) {
    if (options && options.global) {
        gtagFunction("set" /* GtagCommand.SET */ , {
            'user_id': id
        });
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            'user_id': id
        });
    }
}
/**
 * Set all other user properties other than user_id and screen_name.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param properties Map of user properties to set
 */ async function $2ae19001f49ef294$var$setUserProperties$1(gtagFunction, initializationPromise, properties, options) {
    if (options && options.global) {
        const flatProperties = {};
        for (const key of Object.keys(properties))// use dot notation for merge behavior in gtag.js
        flatProperties[`user_properties.${key}`] = properties[key];
        gtagFunction("set" /* GtagCommand.SET */ , flatProperties);
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            'user_properties': properties
        });
    }
}
/**
 * Retrieves a unique Google Analytics identifier for the web client.
 * See {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/config#client_id | client_id}.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 */ async function $2ae19001f49ef294$var$internalGetGoogleAnalyticsClientId(gtagFunction, initializationPromise) {
    const measurementId = await initializationPromise;
    return new Promise((resolve, reject)=>{
        gtagFunction("get" /* GtagCommand.GET */ , measurementId, 'client_id', (clientId)=>{
            if (!clientId) reject($2ae19001f49ef294$var$ERROR_FACTORY.create("no-client-id" /* AnalyticsError.NO_CLIENT_ID */ ));
            resolve(clientId);
        });
    });
}
/**
 * Set whether collection is enabled for this ID.
 *
 * @param enabled If true, collection is enabled for this ID.
 */ async function $2ae19001f49ef294$var$setAnalyticsCollectionEnabled$1(initializationPromise, enabled) {
    const measurementId = await initializationPromise;
    window[`ga-disable-${measurementId}`] = !enabled;
}
/**
 * Consent parameters to default to during 'gtag' initialization.
 */ let $2ae19001f49ef294$var$defaultConsentSettingsForInit;
/**
 * Sets the variable {@link defaultConsentSettingsForInit} for use in the initialization of
 * analytics.
 *
 * @param consentSettings Maps the applicable end user consent state for gtag.js.
 */ function $2ae19001f49ef294$var$_setConsentDefaultForInit(consentSettings) {
    $2ae19001f49ef294$var$defaultConsentSettingsForInit = consentSettings;
}
/**
 * Sets the variable `defaultEventParametersForInit` for use in the initialization of
 * analytics.
 *
 * @param customParams Any custom params the user may pass to gtag.js.
 */ function $2ae19001f49ef294$var$_setDefaultEventParametersForInit(customParams) {
    $2ae19001f49ef294$var$defaultEventParametersForInit = customParams;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $2ae19001f49ef294$var$validateIndexedDB() {
    if (!(0, $dPHSJ.isIndexedDBAvailable)()) {
        $2ae19001f49ef294$var$logger.warn($2ae19001f49ef294$var$ERROR_FACTORY.create("indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ , {
            errorInfo: 'IndexedDB is not available in this environment.'
        }).message);
        return false;
    } else try {
        await (0, $dPHSJ.validateIndexedDBOpenable)();
    } catch (e) {
        $2ae19001f49ef294$var$logger.warn($2ae19001f49ef294$var$ERROR_FACTORY.create("indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ , {
            errorInfo: e?.toString()
        }).message);
        return false;
    }
    return true;
}
/**
 * Initialize the analytics instance in gtag.js by calling config command with fid.
 *
 * NOTE: We combine analytics initialization and setting fid together because we want fid to be
 * part of the `page_view` event that's sent during the initialization
 * @param app Firebase app
 * @param gtagCore The gtag function that's not wrapped.
 * @param dynamicConfigPromisesList Array of all dynamic config promises.
 * @param measurementIdToAppId Maps measurementID to appID.
 * @param installations _FirebaseInstallationsInternal instance.
 *
 * @returns Measurement ID.
 */ async function $2ae19001f49ef294$var$_initializeAnalytics(app, dynamicConfigPromisesList, measurementIdToAppId, installations, gtagCore, dataLayerName, options) {
    const dynamicConfigPromise = $2ae19001f49ef294$var$fetchDynamicConfigWithRetry(app);
    // Once fetched, map measurementIds to appId, for ease of lookup in wrapped gtag function.
    dynamicConfigPromise.then((config)=>{
        measurementIdToAppId[config.measurementId] = config.appId;
        if (app.options.measurementId && config.measurementId !== app.options.measurementId) $2ae19001f49ef294$var$logger.warn(`The measurement ID in the local Firebase config (${app.options.measurementId})` + ` does not match the measurement ID fetched from the server (${config.measurementId}).` + ` To ensure analytics events are always sent to the correct Analytics property,` + ` update the` + ` measurement ID field in the local config or remove it from the local config.`);
    }).catch((e)=>$2ae19001f49ef294$var$logger.error(e));
    // Add to list to track state of all dynamic config promises.
    dynamicConfigPromisesList.push(dynamicConfigPromise);
    const fidPromise = $2ae19001f49ef294$var$validateIndexedDB().then((envIsValid)=>{
        if (envIsValid) return installations.getId();
        else return undefined;
    });
    const [dynamicConfig, fid] = await Promise.all([
        dynamicConfigPromise,
        fidPromise
    ]);
    // Detect if user has already put the gtag <script> tag on this page with the passed in
    // data layer name.
    if (!$2ae19001f49ef294$var$findGtagScriptOnPage(dataLayerName)) $2ae19001f49ef294$var$insertScriptTag(dataLayerName, dynamicConfig.measurementId);
    // Detects if there are consent settings that need to be configured.
    if ($2ae19001f49ef294$var$defaultConsentSettingsForInit) {
        gtagCore("consent" /* GtagCommand.CONSENT */ , 'default', $2ae19001f49ef294$var$defaultConsentSettingsForInit);
        $2ae19001f49ef294$var$_setConsentDefaultForInit(undefined);
    }
    // This command initializes gtag.js and only needs to be called once for the entire web app,
    // but since it is idempotent, we can call it multiple times.
    // We keep it together with other initialization logic for better code structure.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gtagCore('js', new Date());
    // User config added first. We don't want users to accidentally overwrite
    // base Firebase config properties.
    const configProperties = options?.config ?? {};
    // guard against developers accidentally setting properties with prefix `firebase_`
    configProperties[$2ae19001f49ef294$var$ORIGIN_KEY] = 'firebase';
    configProperties.update = true;
    if (fid != null) configProperties[$2ae19001f49ef294$var$GA_FID_KEY] = fid;
    // It should be the first config command called on this GA-ID
    // Initialize this GA-ID and set FID on it using the gtag config API.
    // Note: This will trigger a page_view event unless 'send_page_view' is set to false in
    // `configProperties`.
    gtagCore("config" /* GtagCommand.CONFIG */ , dynamicConfig.measurementId, configProperties);
    // Detects if there is data that will be set on every event logged from the SDK.
    if ($2ae19001f49ef294$var$defaultEventParametersForInit) {
        gtagCore("set" /* GtagCommand.SET */ , $2ae19001f49ef294$var$defaultEventParametersForInit);
        $2ae19001f49ef294$var$_setDefaultEventParametersForInit(undefined);
    }
    return dynamicConfig.measurementId;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Analytics Service class.
 */ class $2ae19001f49ef294$var$AnalyticsService {
    constructor(app){
        this.app = app;
    }
    _delete() {
        delete $2ae19001f49ef294$var$initializationPromisesMap[this.app.options.appId];
        return Promise.resolve();
    }
}
/**
 * Maps appId to full initialization promise. Wrapped gtag calls must wait on
 * all or some of these, depending on the call's `send_to` param and the status
 * of the dynamic config fetches (see below).
 */ let $2ae19001f49ef294$var$initializationPromisesMap = {};
/**
 * List of dynamic config fetch promises. In certain cases, wrapped gtag calls
 * wait on all these to be complete in order to determine if it can selectively
 * wait for only certain initialization (FID) promises or if it must wait for all.
 */ let $2ae19001f49ef294$var$dynamicConfigPromisesList = [];
/**
 * Maps fetched measurementIds to appId. Populated when the app's dynamic config
 * fetch completes. If already populated, gtag config calls can use this to
 * selectively wait for only this app's initialization promise (FID) instead of all
 * initialization promises.
 */ const $2ae19001f49ef294$var$measurementIdToAppId = {};
/**
 * Name for window global data layer array used by GA: defaults to 'dataLayer'.
 */ let $2ae19001f49ef294$var$dataLayerName = 'dataLayer';
/**
 * Name for window global gtag function used by GA: defaults to 'gtag'.
 */ let $2ae19001f49ef294$var$gtagName = 'gtag';
/**
 * Reproduction of standard gtag function or reference to existing
 * gtag function on window object.
 */ let $2ae19001f49ef294$var$gtagCoreFunction;
/**
 * Wrapper around gtag function that ensures FID is sent with all
 * relevant event and config calls.
 */ let $2ae19001f49ef294$var$wrappedGtagFunction;
/**
 * Flag to ensure page initialization steps (creation or wrapping of
 * dataLayer and gtag script) are only run once per page load.
 */ let $2ae19001f49ef294$var$globalInitDone = false;
/**
 * Configures Firebase Analytics to use custom `gtag` or `dataLayer` names.
 * Intended to be used if `gtag.js` script has been installed on
 * this page independently of Firebase Analytics, and is using non-default
 * names for either the `gtag` function or for `dataLayer`.
 * Must be called before calling `getAnalytics()` or it won't
 * have any effect.
 *
 * @public
 *
 * @param options - Custom gtag and dataLayer names.
 */ function $2ae19001f49ef294$export$a5a6e0b888b2c992(options) {
    if ($2ae19001f49ef294$var$globalInitDone) throw $2ae19001f49ef294$var$ERROR_FACTORY.create("already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ );
    if (options.dataLayerName) $2ae19001f49ef294$var$dataLayerName = options.dataLayerName;
    if (options.gtagName) $2ae19001f49ef294$var$gtagName = options.gtagName;
}
/**
 * Returns true if no environment mismatch is found.
 * If environment mismatches are found, throws an INVALID_ANALYTICS_CONTEXT
 * error that also lists details for each mismatch found.
 */ function $2ae19001f49ef294$var$warnOnBrowserContextMismatch() {
    const mismatchedEnvMessages = [];
    if ((0, $dPHSJ.isBrowserExtension)()) mismatchedEnvMessages.push('This is a browser extension environment.');
    if (!(0, $dPHSJ.areCookiesEnabled)()) mismatchedEnvMessages.push('Cookies are not available.');
    if (mismatchedEnvMessages.length > 0) {
        const details = mismatchedEnvMessages.map((message, index)=>`(${index + 1}) ${message}`).join(' ');
        const err = $2ae19001f49ef294$var$ERROR_FACTORY.create("invalid-analytics-context" /* AnalyticsError.INVALID_ANALYTICS_CONTEXT */ , {
            errorInfo: details
        });
        $2ae19001f49ef294$var$logger.warn(err.message);
    }
}
/**
 * Analytics instance factory.
 * @internal
 */ function $2ae19001f49ef294$var$factory(app, installations, options) {
    $2ae19001f49ef294$var$warnOnBrowserContextMismatch();
    const appId = app.options.appId;
    if (!appId) throw $2ae19001f49ef294$var$ERROR_FACTORY.create("no-app-id" /* AnalyticsError.NO_APP_ID */ );
    if (!app.options.apiKey) {
        if (app.options.measurementId) $2ae19001f49ef294$var$logger.warn(`The "apiKey" field is empty in the local Firebase config. This is needed to fetch the latest` + ` measurement ID for this Firebase app. Falling back to the measurement ID ${app.options.measurementId}` + ` provided in the "measurementId" field in the local Firebase config.`);
        else throw $2ae19001f49ef294$var$ERROR_FACTORY.create("no-api-key" /* AnalyticsError.NO_API_KEY */ );
    }
    if ($2ae19001f49ef294$var$initializationPromisesMap[appId] != null) throw $2ae19001f49ef294$var$ERROR_FACTORY.create("already-exists" /* AnalyticsError.ALREADY_EXISTS */ , {
        id: appId
    });
    if (!$2ae19001f49ef294$var$globalInitDone) {
        // Steps here should only be done once per page: creation or wrapping
        // of dataLayer and global gtag function.
        $2ae19001f49ef294$var$getOrCreateDataLayer($2ae19001f49ef294$var$dataLayerName);
        const { wrappedGtag: wrappedGtag, gtagCore: gtagCore } = $2ae19001f49ef294$var$wrapOrCreateGtag($2ae19001f49ef294$var$initializationPromisesMap, $2ae19001f49ef294$var$dynamicConfigPromisesList, $2ae19001f49ef294$var$measurementIdToAppId, $2ae19001f49ef294$var$dataLayerName, $2ae19001f49ef294$var$gtagName);
        $2ae19001f49ef294$var$wrappedGtagFunction = wrappedGtag;
        $2ae19001f49ef294$var$gtagCoreFunction = gtagCore;
        $2ae19001f49ef294$var$globalInitDone = true;
    }
    // Async but non-blocking.
    // This map reflects the completion state of all promises for each appId.
    $2ae19001f49ef294$var$initializationPromisesMap[appId] = $2ae19001f49ef294$var$_initializeAnalytics(app, $2ae19001f49ef294$var$dynamicConfigPromisesList, $2ae19001f49ef294$var$measurementIdToAppId, installations, $2ae19001f49ef294$var$gtagCoreFunction, $2ae19001f49ef294$var$dataLayerName, options);
    const analyticsInstance = new $2ae19001f49ef294$var$AnalyticsService(app);
    return analyticsInstance;
}
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable camelcase */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ function $2ae19001f49ef294$export$b0297573c90085aa(app = (0, $86cnQ.getApp)()) {
    app = (0, $dPHSJ.getModularInstance)(app);
    // Dependencies
    const analyticsProvider = (0, $86cnQ._getProvider)(app, $2ae19001f49ef294$var$ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) return analyticsProvider.getImmediate();
    return $2ae19001f49ef294$export$e1ffb6ba450b0317(app);
}
/**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ function $2ae19001f49ef294$export$e1ffb6ba450b0317(app, options = {}) {
    // Dependencies
    const analyticsProvider = (0, $86cnQ._getProvider)(app, $2ae19001f49ef294$var$ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) {
        const existingInstance = analyticsProvider.getImmediate();
        if ((0, $dPHSJ.deepEqual)(options, analyticsProvider.getOptions())) return existingInstance;
        else throw $2ae19001f49ef294$var$ERROR_FACTORY.create("already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ );
    }
    const analyticsInstance = analyticsProvider.initialize({
        options: options
    });
    return analyticsInstance;
}
/**
 * This is a public static method provided to users that wraps four different checks:
 *
 * 1. Check if it's not a browser extension environment.
 * 2. Check if cookies are enabled in current browser.
 * 3. Check if IndexedDB is supported by the browser environment.
 * 4. Check if the current browser context is valid for using `IndexedDB.open()`.
 *
 * @public
 *
 */ async function $2ae19001f49ef294$export$48c17662a6902497() {
    if ((0, $dPHSJ.isBrowserExtension)()) return false;
    if (!(0, $dPHSJ.areCookiesEnabled)()) return false;
    if (!(0, $dPHSJ.isIndexedDBAvailable)()) return false;
    try {
        const isDBOpenable = await (0, $dPHSJ.validateIndexedDBOpenable)();
        return isDBOpenable;
    } catch (error) {
        return false;
    }
}
/**
 * Use gtag `config` command to set `screen_name`.
 *
 * @public
 *
 * @deprecated Use {@link (logEvent:1) | logEvent} with `eventName` as 'screen_view' and add relevant `eventParams`.
 * See {@link https://firebase.google.com/docs/analytics/screenviews | Track Screenviews}.
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param screenName - Screen name to set.
 */ function $2ae19001f49ef294$export$a364c5ef84862575(analyticsInstance, screenName, options) {
    analyticsInstance = (0, $dPHSJ.getModularInstance)(analyticsInstance);
    $2ae19001f49ef294$var$setCurrentScreen$1($2ae19001f49ef294$var$wrappedGtagFunction, $2ae19001f49ef294$var$initializationPromisesMap[analyticsInstance.app.options.appId], screenName, options).catch((e)=>$2ae19001f49ef294$var$logger.error(e));
}
/**
 * Retrieves a unique Google Analytics identifier for the web client.
 * See {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/config#client_id | client_id}.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ async function $2ae19001f49ef294$export$108b704ce5c937fe(analyticsInstance) {
    analyticsInstance = (0, $dPHSJ.getModularInstance)(analyticsInstance);
    return $2ae19001f49ef294$var$internalGetGoogleAnalyticsClientId($2ae19001f49ef294$var$wrappedGtagFunction, $2ae19001f49ef294$var$initializationPromisesMap[analyticsInstance.app.options.appId]);
}
/**
 * Use gtag `config` command to set `user_id`.
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param id - User ID to set.
 */ function $2ae19001f49ef294$export$7f5abdb7f5093137(analyticsInstance, id, options) {
    analyticsInstance = (0, $dPHSJ.getModularInstance)(analyticsInstance);
    $2ae19001f49ef294$var$setUserId$1($2ae19001f49ef294$var$wrappedGtagFunction, $2ae19001f49ef294$var$initializationPromisesMap[analyticsInstance.app.options.appId], id, options).catch((e)=>$2ae19001f49ef294$var$logger.error(e));
}
/**
 * Use gtag `config` command to set all params specified.
 *
 * @public
 */ function $2ae19001f49ef294$export$d0e176862bf869b8(analyticsInstance, properties, options) {
    analyticsInstance = (0, $dPHSJ.getModularInstance)(analyticsInstance);
    $2ae19001f49ef294$var$setUserProperties$1($2ae19001f49ef294$var$wrappedGtagFunction, $2ae19001f49ef294$var$initializationPromisesMap[analyticsInstance.app.options.appId], properties, options).catch((e)=>$2ae19001f49ef294$var$logger.error(e));
}
/**
 * Sets whether Google Analytics collection is enabled for this app on this device.
 * Sets global `window['ga-disable-analyticsId'] = true;`
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param enabled - If true, enables collection, if false, disables it.
 */ function $2ae19001f49ef294$export$7d544a250c4ed423(analyticsInstance, enabled) {
    analyticsInstance = (0, $dPHSJ.getModularInstance)(analyticsInstance);
    $2ae19001f49ef294$var$setAnalyticsCollectionEnabled$1($2ae19001f49ef294$var$initializationPromisesMap[analyticsInstance.app.options.appId], enabled).catch((e)=>$2ae19001f49ef294$var$logger.error(e));
}
/**
 * Adds data that will be set on every event logged from the SDK, including automatic ones.
 * With gtag's "set" command, the values passed persist on the current page and are passed with
 * all subsequent events.
 * @public
 * @param customParams - Any custom params the user may pass to gtag.js.
 */ function $2ae19001f49ef294$export$9bde4a1551d6c3ba(customParams) {
    // Check if reference to existing gtag function on window object exists
    if ($2ae19001f49ef294$var$wrappedGtagFunction) $2ae19001f49ef294$var$wrappedGtagFunction("set" /* GtagCommand.SET */ , customParams);
    else $2ae19001f49ef294$var$_setDefaultEventParametersForInit(customParams);
}
/**
 * Sends a Google Analytics event with given `eventParams`. This method
 * automatically associates this logged event with this Firebase web
 * app instance on this device.
 * List of official event parameters can be found in the gtag.js
 * reference documentation:
 * {@link https://developers.google.com/gtagjs/reference/ga4-events
 * | the GA4 reference documentation}.
 *
 * @public
 */ function $2ae19001f49ef294$export$5e9eec8001665ac5(analyticsInstance, eventName, eventParams, options) {
    analyticsInstance = (0, $dPHSJ.getModularInstance)(analyticsInstance);
    $2ae19001f49ef294$var$logEvent$1($2ae19001f49ef294$var$wrappedGtagFunction, $2ae19001f49ef294$var$initializationPromisesMap[analyticsInstance.app.options.appId], eventName, eventParams, options).catch((e)=>$2ae19001f49ef294$var$logger.error(e));
}
/**
 * Sets the applicable end user consent state for this web app across all gtag references once
 * Firebase Analytics is initialized.
 *
 * Use the {@link ConsentSettings} to specify individual consent type values. By default consent
 * types are set to "granted".
 * @public
 * @param consentSettings - Maps the applicable end user consent state for gtag.js.
 */ function $2ae19001f49ef294$export$ff06c4c0781050d7(consentSettings) {
    // Check if reference to existing gtag function on window object exists
    if ($2ae19001f49ef294$var$wrappedGtagFunction) $2ae19001f49ef294$var$wrappedGtagFunction("consent" /* GtagCommand.CONSENT */ , 'update', consentSettings);
    else $2ae19001f49ef294$var$_setConsentDefaultForInit(consentSettings);
}
const $2ae19001f49ef294$var$name = "@firebase/analytics";
const $2ae19001f49ef294$var$version = "0.10.25";
/**
 * The Firebase Analytics Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */ /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $2ae19001f49ef294$var$registerAnalytics() {
    (0, $86cnQ._registerComponent)(new (0, $7vOQ3.Component)($2ae19001f49ef294$var$ANALYTICS_TYPE, (container, { options: analyticsOptions })=>{
        // getImmediate for FirebaseApp will always succeed
        const app = container.getProvider('app').getImmediate();
        const installations = container.getProvider('installations-internal').getImmediate();
        return $2ae19001f49ef294$var$factory(app, installations, analyticsOptions);
    }, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $86cnQ._registerComponent)(new (0, $7vOQ3.Component)('analytics-internal', internalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
    (0, $86cnQ.registerVersion)($2ae19001f49ef294$var$name, $2ae19001f49ef294$var$version);
    // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    (0, $86cnQ.registerVersion)($2ae19001f49ef294$var$name, $2ae19001f49ef294$var$version, 'esm2020');
    function internalFactory(container) {
        try {
            const analytics = container.getProvider($2ae19001f49ef294$var$ANALYTICS_TYPE).getImmediate();
            return {
                logEvent: (eventName, eventParams, options)=>$2ae19001f49ef294$export$5e9eec8001665ac5(analytics, eventName, eventParams, options),
                setUserProperties: (properties, options)=>$2ae19001f49ef294$export$d0e176862bf869b8(analytics, properties, options)
            };
        } catch (e) {
            throw $2ae19001f49ef294$var$ERROR_FACTORY.create("interop-component-reg-failed" /* AnalyticsError.INTEROP_COMPONENT_REG_FAILED */ , {
                reason: e
            });
        }
    }
}
$2ae19001f49ef294$var$registerAnalytics();







let $067277e156f7a571$var$analytics;
let $067277e156f7a571$var$eventData = undefined;
function $067277e156f7a571$export$626fff8d65416420() {
    $067277e156f7a571$var$eventData = {};
    // inicializo content_type, content_id, crafts_reqs, num_cells, cached_cells y taxon
    $067277e156f7a571$var$eventData.content_type = 'map';
    $067277e156f7a571$var$eventData.content_id = (0, $96abbdd7193a3c4b$export$4a32c72e9ff1d1e0)((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc);
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon) $067277e156f7a571$var$eventData.taxon = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon;
    $067277e156f7a571$var$eventData.crafts_reqs = 0;
    $067277e156f7a571$var$eventData.num_cells = 0;
    $067277e156f7a571$var$eventData.cached_cells = 0;
    // timestamp in milliseconds
    $067277e156f7a571$var$eventData.init = Date.now();
}
function $067277e156f7a571$export$639f48199cd2287d(initData) {
    $067277e156f7a571$var$eventData = {};
    // inicializo lo que me pase
    for(const key in initData)$067277e156f7a571$var$eventData[key] = initData[key];
    // inicializo crafts_reqs
    $067277e156f7a571$var$eventData.crafts_reqs = 0;
    // timestamp in milliseconds
    $067277e156f7a571$var$eventData.init = Date.now();
}
// común a cualquier evento para incrementar crafts_reqs o lo que haga falta
function $067277e156f7a571$export$2db6ab9500fc86e(key, amount) {
    if ($067277e156f7a571$var$eventData != undefined) {
        if ($067277e156f7a571$var$eventData[key] != undefined) $067277e156f7a571$var$eventData[key] += amount;
    }
}
// común a eventos select_content de mapa y de contenidos medibles
function $067277e156f7a571$export$6adbd77fe07ba13(eventName) {
    if ($067277e156f7a571$var$eventData != undefined) {
        // timestamp de fin en milisegundos
        $067277e156f7a571$var$eventData.end = Date.now(); // timestamp in milliseconds 		
        // calculo latencia y elimino init y end
        $067277e156f7a571$var$eventData.latency_ms = $067277e156f7a571$var$eventData.end - $067277e156f7a571$var$eventData.init;
        delete $067277e156f7a571$var$eventData.end;
        delete $067277e156f7a571$var$eventData.init;
        // envío el evento (por defecto evento 'select_content')
        const en = eventName ? eventName : 'select_content';
        $067277e156f7a571$export$7329bcdc3edcd90e(en, $067277e156f7a571$var$eventData);
    }
}
// caso especial para timeout del mapa
function $067277e156f7a571$export$cfc545666c0ce6d8() {
    if ($067277e156f7a571$var$eventData != undefined) {
        // cambio el content_type
        $067277e156f7a571$var$eventData.content_type = 'map_timeout';
        // pongo por latencia el timeout y elimino init y end
        $067277e156f7a571$var$eventData.latency_ms = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).timeout;
        delete $067277e156f7a571$var$eventData.end;
        delete $067277e156f7a571$var$eventData.init;
        // envío el evento
        $067277e156f7a571$export$7329bcdc3edcd90e('select_content', $067277e156f7a571$var$eventData);
    }
}
// mando evento
function $067277e156f7a571$export$7329bcdc3edcd90e(eventName, edata) {
    //console.log("- Enviando a GA evento de tipo " + eventName + " - Datos evento:")
    //console.log(eventData);
    if (!$067277e156f7a571$var$analytics) $067277e156f7a571$var$analytics = (0, $2ae19001f49ef294$export$b0297573c90085aa)((0, $c0304d280c7b00cb$export$54387eca9e368edc)());
    (0, $2ae19001f49ef294$export$5e9eec8001665ac5)($067277e156f7a571$var$analytics, eventName, edata);
}




/*
   Copyright 2023, Guillermo Vega-Gorgojo

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ 
var $33Kba = parcelRequire("33Kba");

var $8JYDX = parcelRequire("8JYDX");

var $2q7Wm = parcelRequire("2q7Wm");


// ICONOS
let $7b115b3c2cee4b53$var$iconos = {};
var $6377a2cf0916e753$exports = {};
$6377a2cf0916e753$exports = import.meta.resolve("fccLd");


var $182dcc9e33f92c8d$exports = {};
$182dcc9e33f92c8d$exports = import.meta.resolve("cOPwh");


var $a1c2dfbcffcda0e1$exports = {};
$a1c2dfbcffcda0e1$exports = import.meta.resolve("kwXqM");


function $7b115b3c2cee4b53$export$a207d0a28bdc4e1b() {
    // genero icono genérico de arbol
    $7b115b3c2cee4b53$var$iconos.arbol = {};
    $7b115b3c2cee4b53$var$iconos.arbol.edu = $7b115b3c2cee4b53$var$generaIconoArbol((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).treeicon);
    $7b115b3c2cee4b53$var$iconos.arbol.ifn = $7b115b3c2cee4b53$var$generaIconoArbol((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).treeicon + '_i');
    for (const cind of (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).coltxinds){
        $7b115b3c2cee4b53$var$iconos.arbol[cind + 'edu'] = $7b115b3c2cee4b53$var$generaIconoArbol((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).treeicon + cind);
        $7b115b3c2cee4b53$var$iconos.arbol[cind + 'ifn'] = $7b115b3c2cee4b53$var$generaIconoArbol((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).treeicon + cind + '_i');
    }
    // genero iconos por familia
    for(const furi in (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).familyicons){
        // inicializo objeto
        $7b115b3c2cee4b53$var$iconos[furi] = {};
        // iconos educatree e ifn
        $7b115b3c2cee4b53$var$iconos[furi].edu = $7b115b3c2cee4b53$var$generaIconoArbol((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).familyicons[furi]);
        $7b115b3c2cee4b53$var$iconos[furi].ifn = $7b115b3c2cee4b53$var$generaIconoArbol((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).familyicons[furi] + '_i');
        // iconos de colores
        for (const cind of (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).coltxinds){
            $7b115b3c2cee4b53$var$iconos[furi][cind + 'edu'] = $7b115b3c2cee4b53$var$generaIconoArbol((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).familyicons[furi] + cind);
            $7b115b3c2cee4b53$var$iconos[furi][cind + 'ifn'] = $7b115b3c2cee4b53$var$generaIconoArbol((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).familyicons[furi] + cind + '_i');
        }
    }
    // genero icono de lugar
    // a partir de https://github.com/pointhi/leaflet-color-markers
    $7b115b3c2cee4b53$var$iconos.lugar = new (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Icon({
        iconUrl: new URL($6377a2cf0916e753$exports),
        shadowUrl: new URL($182dcc9e33f92c8d$exports),
        iconSize: [
            25,
            41
        ],
        iconAnchor: [
            12,
            41
        ],
        popupAnchor: [
            1,
            -34
        ],
        shadowSize: [
            41,
            41
        ]
    });
    // genero icono de diana
    // a partir de https://icons.getbootstrap.com/icons/bullseye/
    $7b115b3c2cee4b53$var$iconos.diana = new (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Icon({
        iconUrl: new URL($a1c2dfbcffcda0e1$exports),
        iconSize: [
            40,
            40
        ],
        iconAnchor: [
            20,
            20
        ]
    });
    // inicializo iconos de especies
    $7b115b3c2cee4b53$var$iconos.especies = {};
}
var $82ae773c30513021$exports = {};
$82ae773c30513021$exports = import.meta.resolve("dB51P");


function $7b115b3c2cee4b53$var$generaIconoArbol(nfich) {
    // tengo que generar de forma muy rara la URL de la imagen por culpa de Parcel: https://github.com/parcel-bundler/parcel/issues/3056
    let urlarb = new URL($82ae773c30513021$exports); // url estática
    urlarb.pathname = nfich + '.png'; // y cambio aquí el pathname
    return (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).icon({
        iconUrl: urlarb,
        iconSize: [
            80,
            80
        ],
        iconAnchor: [
            40,
            76
        ],
        tooltipAnchor: [
            15,
            -35
        ],
        popupAnchor: [
            1,
            -55
        ]
    });
}
function $7b115b3c2cee4b53$export$b839616475ae6ec3() {
    return $7b115b3c2cee4b53$var$iconos.lugar;
}
function $7b115b3c2cee4b53$export$757419e715bb5039() {
    return $7b115b3c2cee4b53$var$iconos.diana;
}
function $7b115b3c2cee4b53$export$6274df672a45c12d(arb, conColor) {
    // lo primero es ver qué tipo de icono toca
    let icono = $7b115b3c2cee4b53$var$iconos.arbol; // valor por defecto
    const spuri = (0, $1ee989753a15371d$export$fa0799b379eb3758)(arb.species);
    if (spuri != undefined) {
        // si no está definido el icono de la especie, lo calculo
        if ($7b115b3c2cee4b53$var$iconos.especies[spuri] == undefined) {
            let icaux = $7b115b3c2cee4b53$var$iconos.arbol; // valor por defecto
            // analizamos las familias
            for(const furi in (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).familyicons)// compruebo si está incluido spuri en la lista de uris expandida de la familia
            if ((0, $2q7Wm.default).contains((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[furi].expuris, spuri)) icaux = $7b115b3c2cee4b53$var$iconos[furi]; // ¡es de la familia!
            // guardo para luego
            $7b115b3c2cee4b53$var$iconos.especies[spuri] = icaux;
        }
        // asigno el icono
        icono = $7b115b3c2cee4b53$var$iconos.especies[spuri];
    }
    // preparo sufijo para elegir el icono
    let suf = arb.iri != undefined ? 'edu' : 'ifn'; // educatree o ifn
    if (conColor || (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon != undefined) suf = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txcolor + suf;
    // y devuelvo el icono
    return icono[suf];
}


let $27fe9e683b34e1a0$export$c37f872725571dfc, $27fe9e683b34e1a0$var$Minimapann, $27fe9e683b34e1a0$var$Minitilelayer;
async function $27fe9e683b34e1a0$export$c2e76fbffb5b7346() {
    // obtengo iri del árbol
    const iri = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/tree/" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid;
    // pongo spinner con mensaje de cargando	
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#miarbol").html((0, $646ceeeec66fabd8$export$27eb5f8cf2bf64a7));
    window.scrollTo(0, 0);
    // inicializo el evento para enviar a GA
    (0, $067277e156f7a571$export$639f48199cd2287d)({
        content_type: 'tree',
        content_id: iri,
        crafts_reqs: 0
    });
    // pido datos a CRAFTS del educatree
    await (0, $174d363c054274ef$export$92baecf29370dcf)(iri);
    //console.log(Datos.educatrees[iri]);
    // hago el render
    $27fe9e683b34e1a0$export$d096c03518bc83df();
}
async function $27fe9e683b34e1a0$export$d096c03518bc83df() {
    // obtengo iri del árbol
    const iri = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/tree/" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid;
    // detecto llamada espúrea por la autenticación
    if (!(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri]) return;
    // si no hay posición asumo que el educatree no existe...	
    if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].position == undefined) {
        $27fe9e683b34e1a0$var$educatreeNoExiste();
        return;
    }
    // obtengo info del usuario
    const usiri = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario ? (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/user/" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid : null;
    const isMaster = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid].isMasterAnnotator;
    const cannotAnnotate = !(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario || (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid].cannotAnnotate;
    // 0) preparo objeto para el render del árbol
    let objet = {
        etid: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid,
        title: (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].nick ? (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].nick) : (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tree) + ' ' + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid,
        nickButtonLabel: (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].nick ? (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).changeNick) : (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).newNick),
        treeCreator: (0, $96abbdd7193a3c4b$export$4d0c182344beaa87)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri], (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).createdBy)),
        editable: !cannotAnnotate,
        removable: isMaster || (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].creator && ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].creator.iri === usiri || (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].creator === usiri),
        usuario: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario != undefined,
        usuarioImg: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario ? (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.photoURL : null
    };
    // NOTA: permito siempre borrar al creador del árbol (aunque haya anotaciones de otros)
    // si hay nick reajusto título de la página
    if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].nick) document.title = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].nick) + ' - EducaWood';
    // position
    objet.position = {
        iri: (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].position.iri,
        value: (0, $96abbdd7193a3c4b$export$1690e12b840569b9)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].position),
        creator: (0, $96abbdd7193a3c4b$export$4d0c182344beaa87)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].position, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).annotatedBy))
    };
    // posiciones previas
    objet.formerPositions = [];
    const fpels = (0, $96abbdd7193a3c4b$export$326843c69d38a183)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri], [
        "positionAnnotations"
    ]);
    for (const fpel of fpels)if (fpel.iri !== objet.position.iri) objet.formerPositions.push({
        iri: fpel.iri,
        value: (0, $96abbdd7193a3c4b$export$1690e12b840569b9)(fpel),
        creator: (0, $96abbdd7193a3c4b$export$4d0c182344beaa87)(fpel, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).annotatedBy)),
        created: fpel.created,
        removable: isMaster || fpel.creator && (fpel.creator.iri === usiri || fpel.creator === usiri)
    });
    objet.formerPositions = (0, $2q7Wm.default).sortBy(objet.formerPositions, function(obj) {
        return new Date(obj.created);
    }).reverse();
    objet.hasFormerPositions = objet.formerPositions.length > 0;
    // ajusto removable de position (especial porque no puede haber árbol sin posición)
    objet.position.removable = objet.hasFormerPositions && (isMaster || (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].position.creator && ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].position.creator.iri === usiri || (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].position.creator === usiri));
    // tree taxon
    if (objet.editable) objet.treeTaxon = {}; // para mostrar la etiqueta y editar incluso si no hay valor
    if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].species && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].species.species) {
        objet.treeTaxon = {
            iri: (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].species.iri,
            value: (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].species.species.iri,
            creator: (0, $96abbdd7193a3c4b$export$4d0c182344beaa87)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].species, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).annotatedBy)),
            removable: isMaster || (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].species.creator && ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].species.creator.iri === usiri || (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].species.creator === usiri)
        };
        //TODO previo
        //if (Datos.educatrees[iri].species.species.dbpedia)
        //	objet.treeTaxon.dbr = Datos.educatrees[iri].species.species.dbpedia;
        // 2023-11 ahora detecto si hay datos de wikidata en las especies
        if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].species.species.iri].wikidata) objet.treeTaxon.wikidata = true;
        // taxones previos
        objet.formerTaxa = [];
        const ftxels = (0, $96abbdd7193a3c4b$export$326843c69d38a183)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri], [
            "speciesAnnotations"
        ]);
        for (const ftxel of ftxels)if (ftxel.iri !== objet.treeTaxon.iri) {
            let objtx = {
                iri: ftxel.iri,
                value: ftxel.species.iri,
                creator: (0, $96abbdd7193a3c4b$export$4d0c182344beaa87)(ftxel, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).annotatedBy)),
                created: ftxel.created,
                removable: isMaster || ftxel.creator && (ftxel.creator.iri === usiri || ftxel.creator === usiri)
            };
            // TODO previo
            //if (ftxel.species.dbpedia)
            //	objtx.dbr = ftxel.species.dbpedia;
            // 2023-11 ahora detecto si hay datos de wikidata en las especies
            if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[ftxel.species.iri].wikidata) objtx.wikidata = true;
            objet.formerTaxa.push(objtx);
        }
        objet.formerTaxa = (0, $2q7Wm.default).sortBy(objet.formerTaxa, function(obj) {
            return new Date(obj.created);
        }).reverse();
        objet.hasFormerTaxa = objet.formerTaxa.length > 0;
    }
    // tree status
    if (objet.editable) objet.treeStatus = {}; // para mostrar la etiqueta y editar incluso si no hay valor
    if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].treeStatus && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].treeStatus.treeStatus) {
        const ts = (0, $2q7Wm.default).find((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).estadoArboles, function(el) {
            return el.iri === (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].treeStatus.treeStatus;
        });
        if (ts) objet.treeStatus = {
            iri: (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].treeStatus.iri,
            value: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(ts.label),
            creator: (0, $96abbdd7193a3c4b$export$4d0c182344beaa87)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].treeStatus, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).annotatedBy)),
            removable: isMaster || (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].treeStatus.creator && ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].treeStatus.creator.iri === usiri || (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].treeStatus.creator === usiri)
        };
        // status previos
        objet.formerStatus = [];
        const ftsels = (0, $96abbdd7193a3c4b$export$326843c69d38a183)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri], [
            "treeStatusAnnotations"
        ]);
        for (const ftsel of ftsels)if (ftsel.iri !== objet.treeStatus.iri) {
            const tsel = (0, $2q7Wm.default).find((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).estadoArboles, function(el) {
                return el.iri === ftsel.treeStatus;
            });
            if (tsel) objet.formerStatus.push({
                iri: ftsel.iri,
                value: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(tsel.label),
                creator: (0, $96abbdd7193a3c4b$export$4d0c182344beaa87)(ftsel, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).annotatedBy)),
                created: ftsel.created,
                removable: isMaster || ftsel.creator && (ftsel.creator.iri === usiri || ftsel.creator === usiri)
            });
        }
        objet.formerStatus = (0, $2q7Wm.default).sortBy(objet.formerStatus, function(obj) {
            return new Date(obj.created);
        }).reverse();
        objet.hasFormerStatus = objet.formerStatus.length > 0;
    }
    // photos
    if (objet.editable) objet.photoLabel = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).photo); // para mostrar la etiqueta y editar incluso si no hay valor
    if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].imageAnnotations) {
        objet.hasPhotos = true;
        objet.photoLabel = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).photo);
        objet.photos = [];
        const photos = (0, $96abbdd7193a3c4b$export$326843c69d38a183)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri], [
            "imageAnnotations"
        ]);
        if (photos.length > 1) objet.photoLabel += 's'; // plural
        else objet.onePhoto = true; // para quitar congtroles de navegación
        for(let i = 0; i < photos.length; i++){
            let phobj = {};
            phobj.index = i;
            if (i == 0) phobj.first = true;
            phobj.iri = photos[i].iri;
            phobj.src = photos[i].image.imageURL;
            if (photos[i].image.plantPart && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).partesPlantasFoto[photos[i].image.plantPart]) phobj.plantPart = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).partesPlantasFoto[photos[i].image.plantPart].label);
            phobj.creator = (0, $96abbdd7193a3c4b$export$4d0c182344beaa87)(photos[i], (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).annotatedBy));
            phobj.removable = isMaster || photos[i].creator && (photos[i].creator.iri === usiri || photos[i].creator === usiri);
            objet.photos.push(phobj);
        }
    }
    // height
    if (objet.editable) objet.height = {}; // para mostrar la etiqueta y editar incluso si no hay valor
    if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].height && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].height.meters) {
        objet.height = {
            iri: (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].height.iri,
            value: (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].height.meters,
            creator: (0, $96abbdd7193a3c4b$export$4d0c182344beaa87)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].height, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).annotatedBy)),
            removable: isMaster || (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].height.creator && ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].height.creator.iri === usiri || (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].height.creator === usiri)
        };
        // alturas previas
        objet.formerHeights = [];
        const fhels = (0, $96abbdd7193a3c4b$export$326843c69d38a183)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri], [
            "heightAnnotations"
        ]);
        for (const fhel of fhels)if (fhel.iri !== objet.height.iri) objet.formerHeights.push({
            iri: fhel.iri,
            value: fhel.meters,
            creator: (0, $96abbdd7193a3c4b$export$4d0c182344beaa87)(fhel, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).annotatedBy)),
            created: fhel.created,
            removable: isMaster || fhel.creator && (fhel.creator.iri === usiri || fhel.creator === usiri)
        });
        objet.formerHeights = (0, $2q7Wm.default).sortBy(objet.formerHeights, function(obj) {
            return new Date(obj.created);
        }).reverse();
        objet.hasFormerHeight = objet.formerHeights.length > 0;
    }
    // diameter
    if (objet.editable) objet.diameter = {}; // para mostrar la etiqueta y editar incluso si no hay valor
    if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].diameter && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].diameter.millimeters) {
        objet.diameter = {
            iri: (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].diameter.iri,
            value: (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].diameter.millimeters,
            creator: (0, $96abbdd7193a3c4b$export$4d0c182344beaa87)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].diameter, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).annotatedBy)),
            removable: isMaster || (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].diameter.creator && ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].diameter.creator.iri === usiri || (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].diameter.creator === usiri)
        };
        // diámetros previos
        objet.formerDiameters = [];
        const fdels = (0, $96abbdd7193a3c4b$export$326843c69d38a183)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri], [
            "diameterAnnotations"
        ]);
        for (const fdel of fdels)if (fdel.iri !== objet.diameter.iri) objet.formerDiameters.push({
            iri: fdel.iri,
            value: fdel.millimeters,
            creator: (0, $96abbdd7193a3c4b$export$4d0c182344beaa87)(fdel, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).annotatedBy)),
            created: fdel.created,
            removable: isMaster || fdel.creator && (fdel.creator.iri === usiri || fdel.creator === usiri)
        });
        objet.formerDiameters = (0, $2q7Wm.default).sortBy(objet.formerDiameters, function(obj) {
            return new Date(obj.created);
        }).reverse();
        objet.hasFormerDiameter = objet.formerDiameters.length > 0;
    }
    // observaciones	
    if (objet.editable) objet.observation = {}; // para mostrar la etiqueta y editar incluso si no hay valor
    if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].observations) {
        let obss = (0, $96abbdd7193a3c4b$export$326843c69d38a183)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri], [
            "observations"
        ]);
        // elimino las observaciones sin texto o con menos de 3 caracteres
        obss = (0, $2q7Wm.default).filter(obss, function(obs) {
            return obs.text && (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(obs.text).length > 3;
        });
        obss = (0, $2q7Wm.default).sortBy(obss, function(obj) {
            return new Date(obj.created);
        }).reverse();
        // sólo si hay alguna...
        if (obss.length > 0) {
            // pongo observación primera
            objet.observation = {
                iri: obss[0].iri,
                value: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(obss[0].text),
                creator: (0, $96abbdd7193a3c4b$export$4d0c182344beaa87)(obss[0], (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).annotatedBy)),
                removable: isMaster || obss[0].creator && (obss[0].creator.iri === usiri || obss[0].creator === usiri)
            };
            // observaciones anteriores
            if (obss.length > 1) {
                objet.hasMoreObservations = true;
                objet.moreObservations = [];
                for(let i = 1; i < obss.length; i++)objet.moreObservations.push({
                    iri: obss[i].iri,
                    value: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(obss[i].text),
                    creator: (0, $96abbdd7193a3c4b$export$4d0c182344beaa87)(obss[i], (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).annotatedBy)),
                    removable: isMaster || obss[i].creator && (obss[i].creator.iri === usiri || obss[i].creator === usiri)
                });
            }
        }
    }
    //console.log(objet);
    // 1) hago el rendering
    const htmlcontent = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$dd1b8137336daa0c), objet);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#miarbol").html(htmlcontent);
    // envío GA evento ver página árbol
    (0, $067277e156f7a571$export$6adbd77fe07ba13)();
    console.info("P\xe1gina \xe1rbol cargada: " + iri);
    // listener goBack
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".goBack").click((0, $ffd94e1d81f19b1c$export$28fca2ccfd38b8f));
    // listener borrarArbol
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#deleteEducaTree").click($27fe9e683b34e1a0$var$handlerDeleteEducatree);
    // pongo listeners a clickViewprofile, clickSignin y clickSignout
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".userprofile").click((0, $c0304d280c7b00cb$export$f98b6673fafc0e20));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".usersignin").click((0, $c0304d280c7b00cb$export$9ffe63492d76c086));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".usersignout").click((0, $c0304d280c7b00cb$export$daa0a882204fd973));
    // listener a cambiar el nick del árbol
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#changeTreeNick").click($27fe9e683b34e1a0$var$changeTreeNick);
    // listener ayuda treeStatusInfo
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botTreeStatusInfo").click((0, $3a9989d46007ef73$export$4ee351339f0443f3));
    // 2) ajustes taxón y fotos	
    // tree taxon => ajusto nomci, hago rendering del taxón y pongo handler del popver del taxón
    // ajusto nomci 
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#viewchecknomci").prop('checked', (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).nomci);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#viewchecknomci").change((0, $1ee989753a15371d$export$d67e2296dd6db17d));
    // llamo a visualizarTaxonFormulario para que haga el rendering del taxón (incluye el listener para mostrar popover)
    (0, $1ee989753a15371d$export$5dba38aff426bd77)();
    // photos => detecto cambios en el carrusel para mostrar la info de creación apropiada
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#miCarrusel').on('slid.bs.carousel', function() {
        let indice = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).find('.carousel-item.active').index();
        // ajusto visibilidad creadores imágenes (con sus botones de borrado y edición, claro)
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('.photoCreator').addClass('d-none');
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('.photoCreator').filter('[index="' + indice + '"]').removeClass('d-none');
    });
    // 3) listeners de creación y borrado de anotaciones
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".create").click($27fe9e683b34e1a0$var$handlerNewAnnotation);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".delete").click($27fe9e683b34e1a0$var$handlerDeleteAnnotation);
    // 4) ajusto coordenadas y cargo mapa
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].position.latWGS84;
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].position.lngWGS84;
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.z = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zMiniMapa;
    // preparo primero los bounds para que no se vaya a Cuenca
    const offset = 0.0004; // 1km es aproximadamente 0,008 grados en WGS84
    const bounds = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).latLngBounds((0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).latLng((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat - offset, (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng - 3 * offset), (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).latLng((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat + offset, (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng + 3 * offset)); //northEast	
    // meto tap: false, que parece es una fuente de problemas	
    $27fe9e683b34e1a0$export$c37f872725571dfc = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).map('mapaedutree', {
        maxBounds: bounds,
        maxBoundsViscosity: 1.0,
        zoomControl: false,
        tap: false,
        scrollWheelZoom: 'center',
        preferCanvas: true
    }).setView([
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat,
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng
    ], (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zMiniMapa);
    // cargo el tile layer que corresponda
    const { url: url, opts: opts } = (0, $69f04ba581843b2d$export$c1c1414601191e71)(true);
    $27fe9e683b34e1a0$var$Minitilelayer = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).tileLayer(url, opts).addTo($27fe9e683b34e1a0$export$c37f872725571dfc);
    // muestro escala del mapa
    (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).control.scale({
        imperial: false,
        position: 'bottomright'
    }).addTo($27fe9e683b34e1a0$export$c37f872725571dfc); // sin la escala imperial
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Browser.mobile) (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).control.zoom({
        position: 'bottomright',
        zoomInTitle: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).zoomin),
        zoomOutTitle: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).zoomout)
    }).addTo($27fe9e683b34e1a0$export$c37f872725571dfc);
    // Disable dragging
    $27fe9e683b34e1a0$export$c37f872725571dfc.dragging.disable();
    // cargo botones esri y volverMapa
    (0, $c853be3628706c6e$export$a54a51eb35d48691)($27fe9e683b34e1a0$export$c37f872725571dfc, [
        $27fe9e683b34e1a0$export$c37f872725571dfc,
        (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee)
    ], [
        $27fe9e683b34e1a0$var$Minitilelayer,
        (0, $ffd94e1d81f19b1c$export$6573f87b6f05c3d2)
    ], true);
    // 5) pido ifntrees y edutrees del mapa y pinto
    await (0, $3a9989d46007ef73$export$d3be837b79c08382)($27fe9e683b34e1a0$export$c37f872725571dfc, bounds);
    // pongo color al educatree
    const arb = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri];
    // obtengo icono con color
    const aicon = (0, $7b115b3c2cee4b53$export$6274df672a45c12d)(arb, true);
    // y se lo asigno
    if ($27fe9e683b34e1a0$export$c37f872725571dfc.arbsPintados[iri]) $27fe9e683b34e1a0$export$c37f872725571dfc.arbsPintados[iri].setIcon(aicon);
    //quito el overlay con el que escondía el mapa y habilito el dragging
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#overlay").addClass('d-none');
    $27fe9e683b34e1a0$export$c37f872725571dfc.dragging.enable();
}
///////////////////////
// CREACIÓN ANOTACIONES
function $27fe9e683b34e1a0$var$handlerNewAnnotation() {
    // recupero iri
    const iri = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/tree/" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid;
    // inicialización modal
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        static: true,
        vertcent: true,
        nobody: true
    }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).newAnnotation), null, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).crearAnotacion);
    // detecto el tipo de anotación y cargo el body correspondiente
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass('position')) {
        // pongo body adecuado en el modal
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)(null, null, (0, $646ceeeec66fabd8$export$43bbd40c30a74965).position, null);
        // pinto posición
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#inputPositionAnn").val((0, $96abbdd7193a3c4b$export$1690e12b840569b9)({
            latWGS84: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat,
            lngWGS84: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng
        }));
        // espero a que el modal se haya mostrado
        document.getElementById('mimodal').addEventListener('shown.bs.modal', async function() {
            // preparo primero los bounds para que no se vaya a Cuenca
            const offset = 0.0004; // 1km es aproximadamente 0,008 grados en WGS84
            const bounds = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).latLngBounds((0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).latLng((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat - offset, (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng - 2.5 * offset), (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).latLng((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat + offset, (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng + 2.5 * offset)); //northEast	
            // meto tap: false, que parece es una fuente de problemas
            // meto scrollWheelZoom: 'center' para que no dé saltos raros la diana al cambiar el zoom
            $27fe9e683b34e1a0$var$Minimapann = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).map('mapaAnn', {
                maxBounds: bounds,
                maxBoundsViscosity: 1.0,
                zoomControl: false,
                tap: false,
                scrollWheelZoom: 'center',
                preferCanvas: true
            }).setView([
                (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat,
                (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng
            ], (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zMiniMapa);
            // cargo el tile layer que corresponda
            const { url: url, opts: opts } = (0, $69f04ba581843b2d$export$c1c1414601191e71)(true);
            const minianntl = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).tileLayer(url, opts).addTo($27fe9e683b34e1a0$var$Minimapann);
            // muestro escala del mapa
            (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).control.scale({
                imperial: false,
                position: 'bottomright'
            }).addTo($27fe9e683b34e1a0$var$Minimapann); // sin la escala imperial
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Browser.mobile) (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).control.zoom({
                position: 'bottomright',
                zoomInTitle: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).zoomin),
                zoomOutTitle: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).zoomout)
            }).addTo($27fe9e683b34e1a0$var$Minimapann);
            // Disable dragging
            $27fe9e683b34e1a0$var$Minimapann.dragging.disable();
            // cargo botón esri
            (0, $c853be3628706c6e$export$a54a51eb35d48691)($27fe9e683b34e1a0$var$Minimapann, [
                $27fe9e683b34e1a0$var$Minimapann,
                $27fe9e683b34e1a0$export$c37f872725571dfc,
                (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee)
            ], [
                minianntl,
                $27fe9e683b34e1a0$var$Minitilelayer,
                (0, $ffd94e1d81f19b1c$export$6573f87b6f05c3d2)
            ]);
            // 3) pido ifntrees y edutrees del mapa y pinto
            await (0, $3a9989d46007ef73$export$d3be837b79c08382)($27fe9e683b34e1a0$var$Minimapann, bounds);
            // 4) al acabar hago múltiples ajustes
            // quito el icono del árbol
            $27fe9e683b34e1a0$var$Minimapann.removeLayer($27fe9e683b34e1a0$var$Minimapann.arbsPintados[iri]);
            // quito el overlay con el que escondía el mapa, pongo la pista y habilito el dragging
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#overlayAnn").addClass('d-none');
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mapclueAnn").removeClass('d-none');
            $27fe9e683b34e1a0$var$Minimapann.dragging.enable();
            // 5) pinto marcador de diana
            const diana = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).marker([
                (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat,
                (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng
            ], {
                icon: (0, $7b115b3c2cee4b53$export$757419e715bb5039)(),
                zIndexOffset: 100
            }).addTo($27fe9e683b34e1a0$var$Minimapann);
            // 6) detecto eventos "move" y ajusto la diana	
            $27fe9e683b34e1a0$var$Minimapann.on('move', function(event) {
                const center = $27fe9e683b34e1a0$var$Minimapann.getCenter(); // Get the new center position of the map
                diana.setLatLng(center); // Set the marker position to the new center
            });
            // como hay muchos eventos 'move', actualizo cosas sólo con 'moveend'
            $27fe9e683b34e1a0$var$Minimapann.on('moveend', function(event) {
                const center = $27fe9e683b34e1a0$var$Minimapann.getCenter(); // Get the new center position of the map
                diana.setLatLng(center); // Set the marker position to the new center
                // ajusto texto
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#inputPositionAnn").val((0, $96abbdd7193a3c4b$export$1690e12b840569b9)({
                    latWGS84: center.lat,
                    lngWGS84: center.lng
                }));
                // detecto si hay cambio respecto a lo anterior
                if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].position.latWGS84.toFixed(6) === center.lat.toFixed(6) && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].position.lngWGS84.toFixed(6) === center.lng.toFixed(6)) {
                    // console.log("Misma posición que antes (!)");
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).sameAnnotation));
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").removeClass("d-none");
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botcreatemodalannotation").prop("disabled", true);
                } else {
                    //console.log("Todo OK");
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").addClass("d-none");
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botcreatemodalannotation").prop("disabled", false);
                }
            });
        }, {
            once: true
        }); // para que sólo se ejecute una vez
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass('treeTaxon')) {
        // pongo body adecuado en el modal
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)(null, null, (0, $646ceeeec66fabd8$export$43bbd40c30a74965).treeTaxon, null);
        // ajusto nomci 
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#anchecknomci").prop('checked', (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).nomci);
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#anchecknomci").change((0, $1ee989753a15371d$export$d67e2296dd6db17d));
        // listeners taxón
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#setTreeTaxonEd").click((0, $1ee989753a15371d$export$2d3916a1f0ae58c1));
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#deleteTreeTaxon").click((0, $1ee989753a15371d$export$e644c8daeec4ef49));
        // detecto cambio en treeTaxon
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#inputTreeTaxonEd").change(function() {
            const ttiri = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#inputTreeTaxonEd").attr("iri");
            // preinicializo
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").removeClass("d-none");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botcreatemodalannotation").prop("disabled", true);
            if (!ttiri) //console.log("No hay nada");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noAnnotation));
            else if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].species && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].species.species && ttiri === (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].species.species.iri) //console.log("Misma iri que antes (!)");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).sameAnnotation));
            else {
                //console.log("Todo OK");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").addClass("d-none");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botcreatemodalannotation").prop("disabled", false);
            }
        });
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass('treeStatus')) {
        // pongo body adecuado en el modal
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)(null, null, (0, $646ceeeec66fabd8$export$43bbd40c30a74965).treeStatus, null);
        // cargo tipos de estado del árbol en #selectTreeStatus
        let testarb = [];
        for (const el of (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).estadoArboles)testarb.push({
            "iri": el.iri,
            "label": (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(el.label),
            "pref": el.pref
        });
        const htmltest = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$170c21d6f8f459cf), testarb);
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#selectTreeStatus").html(htmltest);
        // detecto cambio en selectTreeStatus	
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#selectTreeStatus").change(function() {
            const tstiri = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#selectTreeStatus').val();
            // preinicializo
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").removeClass("d-none");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botcreatemodalannotation").prop("disabled", true);
            if (!tstiri) //console.log("No hay nada");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noAnnotation));
            else if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].treeStatus && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].treeStatus.treeStatus && tstiri === (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].treeStatus.treeStatus) //console.log("Misma iri que antes (!)");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).sameAnnotation));
            else {
                //console.log("Todo OK");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").addClass("d-none");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botcreatemodalannotation").prop("disabled", false);
            }
        });
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass('photo')) {
        // preparo el anotador
        const oa = {
            esMovil: (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Browser.mobile,
            camera: localStorage.getItem('camera') === "false" ? false : true // por defecto true
        };
        const htmlann = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$43bbd40c30a74965).photo, oa);
        // pongo body adecuado en el modal
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)(null, null, htmlann, null);
        // listener de la foto => compresión en #resizedTreePhoto y muestro thumbnail
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treePhoto").change((0, $3a9989d46007ef73$export$3a52a69d9f94a42b)); // más actualización estado anotación
        // listener borrar foto (antes de subir a Firebase)
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#deleteTreePhoto").click((0, $3a9989d46007ef73$export$e7db0c08a7276967));
        // cargo partes de árboles fotos en #selectTreePartPhoto
        let parbfotos = [];
        for(const paf in (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).partesPlantasFoto)parbfotos.push({
            "uri": paf,
            "label": (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).partesPlantasFoto[paf].label)
        });
        const htmlcontent = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$afb205d6a878a5e7), parbfotos);
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#selectTreePartPhoto").html(htmlcontent);
        // cambio de modo a cámara (sólo valdrá para móvil)
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#checkCamera").change((0, $3a9989d46007ef73$export$cd64dd1ec39c266d));
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass('height')) {
        // pongo body adecuado en el modal
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)(null, null, (0, $646ceeeec66fabd8$export$43bbd40c30a74965).height, null);
        // listener de cambio de altura
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treeHeight").change(function() {
            const alt = Number((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#treeHeight').val());
            // preinicializo
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").removeClass("d-none");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botcreatemodalannotation").prop("disabled", true);
            if (!alt) //console.log("No hay nada");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noAnnotation));
            else if (alt < 0 || alt > 150) //console.log("Fuera de rango");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).outOfRangeAnnotation));
            else if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].height && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].height.meters && alt === (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].height.meters) //console.log("Misma altura que antes (!)");				
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).sameAnnotation));
            else {
                //console.log("Todo OK");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").addClass("d-none");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botcreatemodalannotation").prop("disabled", false);
            }
        });
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass('diameter')) {
        // pongo body adecuado en el modal
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)(null, null, (0, $646ceeeec66fabd8$export$43bbd40c30a74965).diameter, null);
        // listener de medida de perímetro
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#checkPerimeter").change((0, $3a9989d46007ef73$export$1db9de3e81675e92));
        // listener de cambio de perímetro		
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treeDiameter").change(function() {
            let diam = Number((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#treeDiameter').val());
            // preinicializo
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").removeClass("d-none");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botcreatemodalannotation").prop("disabled", true);
            if (!diam) //console.log("No hay nada");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noAnnotation));
            else {
                // reajuste por el modo perímetro
                if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#checkPerimeter").prop("checked")) diam = Number((diam / Math.PI).toFixed(0));
                if (diam < 0 || diam > 20000) //console.log("Fuera de rango");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).outOfRangeAnnotation));
                else if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].diameter && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].diameter.millimeters && diam === (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].diameter.millimeters) //console.log("Mismo diámetro que antes (!)");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).sameAnnotation));
                else {
                    //console.log("Todo OK");
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").addClass("d-none");
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botcreatemodalannotation").prop("disabled", false);
                }
            }
        });
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass('observation')) {
        // pongo body adecuado en el modal
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)(null, null, (0, $646ceeeec66fabd8$export$43bbd40c30a74965).observation, null);
        // listener de cambio de altura
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#observation").on('input', function() {
            const obs = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#observation').val();
            // preinicializo
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").removeClass("d-none");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botcreatemodalannotation").prop("disabled", true);
            if (obs.length == 0) //console.log("No hay nada");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noAnnotation));
            else if (obs.length < 5) //console.log("Fuera de rango");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).typesomethingmore));
            else {
                //console.log("Todo OK");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").addClass("d-none");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botcreatemodalannotation").prop("disabled", false);
            }
        });
    } else return; // no debería llegar aquí, pero por si acaso
    // muestro el modal
    const mimodal = new (0, (/*@__PURE__*/$parcel$interopDefault($dktVJ))).Modal(document.getElementById('mimodal'));
    mimodal.show();
    // handler al botón de procesar anotación
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botcreatemodalannotation").click($27fe9e683b34e1a0$export$a8fce3b21dbb0466);
}
var $edac08b8dba83fcf$exports = {};
$edac08b8dba83fcf$exports = import.meta.resolve("8dGG7");


async function $27fe9e683b34e1a0$export$a8fce3b21dbb0466() {
    // recupero iri del árbol
    const iri = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/tree/" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid;
    // constantes de anotación
    const annid = (0, $96abbdd7193a3c4b$export$567fc7097e064344)(12);
    const ahora = new Date().toISOString();
    const creador = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/user/" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid;
    // inicializo tipo de anotación y anniri para el evento a GA
    let tipoann = null;
    let anniri = null;
    // preparo clones
    const tobjclon = JSON.parse(JSON.stringify((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri]));
    const bobjclon = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri] ? JSON.parse(JSON.stringify((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri])) : null; // puede no existir	
    // inicializo patch
    const patch = [];
    // detecto tipo de anotación
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#mapaAnn').length) {
        tipoann = 'position_annotation';
        //console.log("Anotación de posición");		
        const center = $27fe9e683b34e1a0$var$Minimapann.getCenter();
        const posann = {
            iri: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/posann/" + annid,
            creator: creador,
            created: ahora,
            latWGS84: center.lat,
            lngWGS84: center.lng,
            types: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/sta/ontology/PositionAnnotation"
        };
        anniri = posann.iri;
        // preparo patch con la nueva anotación de posición	
        patch.push({
            op: "replace",
            path: "/position",
            value: posann
        });
        // preparo el path adecuado en el array de posiciones 
        // (debería existir Datos.educatrees[iri].positionAnnotations, pero por si acaso)
        const pospath = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].positionAnnotations ? "/positionAnnotations/-" : "/positionAnnotations";
        patch.push({
            op: "add",
            path: pospath,
            value: posann.iri
        });
        // reajusto clones
        tobjclon.position = posann;
        tobjclon.positionAnnotations = !(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].positionAnnotations ? posann : Array.isArray((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].positionAnnotations) ? [
            posann,
            ...tobjclon.positionAnnotations
        ] : [
            posann,
            (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].positionAnnotations
        ];
        if (bobjclon) {
            bobjclon.lat = center.lat;
            bobjclon.lng = center.lng;
        }
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#inputTreeTaxonEd').length) {
        tipoann = 'taxon_annotation';
        //console.log("Anotación de taxón");
        const ttiri = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#inputTreeTaxonEd").attr("iri");
        const ttann = {
            iri: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/spann/" + annid,
            creator: creador,
            created: ahora,
            species: ttiri,
            types: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/sta/ontology/SpeciesAnnotation"
        };
        anniri = ttann.iri;
        // preparo patch con la nueva anotación de taxón
        const oper = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].species ? "replace" : "add";
        patch.push({
            op: oper,
            path: "/species",
            value: ttann
        });
        // preparo el path adecuado en el array de taxones
        const ttpath = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].speciesAnnotations ? "/speciesAnnotations/-" : "/speciesAnnotations";
        patch.push({
            op: "add",
            path: ttpath,
            value: ttann.iri
        });
        // reajusto clones (aquí más complejo para incorporar la info de especie)
        const ttannclon = JSON.parse(JSON.stringify(ttann));
        ttannclon.species = {
            iri: ttiri,
            scientificName: (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[ttiri].scientificName,
            vulgarName: (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[ttiri].vulgarName,
            wikispeciesPage: (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[ttiri].wikispeciesPage,
            wikipediaPage: (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[ttiri].wikipedia.en,
            wikidata: (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[ttiri].wikidata
        };
        tobjclon.species = ttannclon;
        tobjclon.speciesAnnotations = !(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].speciesAnnotations ? ttannclon : Array.isArray((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].speciesAnnotations) ? [
            ttannclon,
            ...tobjclon.speciesAnnotations
        ] : [
            ttannclon,
            (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].speciesAnnotations
        ];
        if (bobjclon) bobjclon.species = ttiri;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#selectTreeStatus').length) {
        tipoann = 'status_annotation';
        //console.log("Anotación de estado de árbol");
        const tstiri = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#selectTreeStatus').val();
        const tstann = {
            iri: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/treestann/" + annid,
            creator: creador,
            created: ahora,
            treeStatus: tstiri
        };
        anniri = tstann.iri;
        // preparo patch con la nueva anotación de tree status
        const oper = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].treeStatus ? "replace" : "add";
        patch.push({
            op: oper,
            path: "/treeStatus",
            value: tstann
        });
        // preparo el path adecuado en el array de taxones
        const tstpath = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].treeStatusAnnotations ? "/treeStatusAnnotations/-" : "/treeStatusAnnotations";
        patch.push({
            op: "add",
            path: tstpath,
            value: tstann.iri
        });
        // reajusto clones
        tobjclon.treeStatus = tstann;
        tobjclon.treeStatusAnnotations = !(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].treeStatusAnnotations ? tstann : Array.isArray((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].treeStatusAnnotations) ? [
            tstann,
            ...tobjclon.treeStatusAnnotations
        ] : [
            tstann,
            (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].treeStatusAnnotations
        ];
        if (bobjclon) bobjclon.treeStatus = tstiri;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#treePhoto').length) {
        tipoann = 'photo_annotation';
        //console.log("Anotación de foto");			
        // guardo primero en Firebase
        const imgDataUrl = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#resizedTreePhoto").val();
        let imgFirebasePath = 'images/' + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid + '/' + annid + '.png';
        let imgDownloadURL = null;
        // Get a reference to the storage service, which is used to create references in your storage bucket		
        const storage = (0, $63c1f7f3542429ef$export$fbd9b57a66480737)((0, $c0304d280c7b00cb$export$54387eca9e368edc)());
        // Create a storage reference from our storage service
        //const storageRef = storage.ref();
        // preparo referencia a imagen para guardar
        const imgRef = (0, $63c1f7f3542429ef$export$eff4d24c3ff7876e)(storage, imgFirebasePath);
        // recupero el tree part para que no se borre con el spinner
        const tppiri = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#selectTreePartPhoto').val();
        // pongo spinner (porque aquí hay que esperar y en el resto de casos no)
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
            static: true,
            vertcent: true,
            spinner: true,
            spinnerMessage: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).pleasewait),
            nofooter: true
        }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).creatingannotation), null, null);
        // guardo foto del árbol
        try {
            const snapshot = await (0, $63c1f7f3542429ef$export$d885b2eb178808b3)(imgRef, imgDataUrl, 'data_url');
            imgDownloadURL = await (0, $63c1f7f3542429ef$export$c8bf645a0c2a7d9f)(snapshot.ref);
            // mando evento de creación de foto en firebase a GA
            (0, $067277e156f7a571$export$7329bcdc3edcd90e)("create_content", {
                content_type: 'photo',
                content_id: imgDownloadURL,
                uid: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid
            });
            console.info("Foto subida a Firebase: " + imgDownloadURL);
        } catch (error) {
            console.error('Error: ' + error.message);
            const be = "<code>" + error + "</code>";
            (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
                static: true,
                vertcent: true
            }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).uploadingphotoerror), be, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).anotacionError);
            return; // terminamos
        }
        // ahora voy con la anotación
        const fotann = {
            iri: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/imgann/" + annid,
            creator: creador,
            created: ahora,
            image: {
                iri: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/img/" + annid,
                imageURL: imgDownloadURL,
                firebasePath: imgFirebasePath,
                types: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/sta/ontology/Image"
            },
            types: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/sta/ontology/ImageAnnotation"
        };
        anniri = fotann.iri;
        // si ha seleccionado el tipo de foto...
        if (tppiri !== "") fotann.image.plantPart = tppiri;
        // preparo el path adecuado en el array de fotos
        const fotpath = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].imageAnnotations ? "/imageAnnotations/-" : "/imageAnnotations";
        patch.push({
            op: "add",
            path: fotpath,
            value: fotann
        });
        // reajusto clones
        tobjclon.imageAnnotations = !(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].imageAnnotations ? fotann : Array.isArray((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].imageAnnotations) ? [
            fotann,
            ...tobjclon.imageAnnotations
        ] : [
            fotann,
            (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].imageAnnotations
        ];
        if (bobjclon) bobjclon.images = !(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].images ? imgDownloadURL : Array.isArray((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].images) ? [
            imgDownloadURL,
            ...bobjclon.images
        ] : [
            imgDownloadURL,
            bobjclon.images
        ];
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#treeHeight').length) {
        tipoann = 'height_annotation';
        //console.log("Anotación de altura");
        const alt = Number((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#treeHeight').val());
        const altann = {
            iri: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/heightann/" + annid,
            creator: creador,
            created: ahora,
            meters: alt,
            types: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/sta/ontology/HeightAnnotation"
        };
        anniri = altann.iri;
        // preparo patch con la nueva anotación de altura
        const oper = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].height ? "replace" : "add";
        patch.push({
            op: oper,
            path: "/height",
            value: altann
        });
        // preparo el path adecuado en el array de taxones
        const altpath = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].heightAnnotations ? "/heightAnnotations/-" : "/heightAnnotations";
        patch.push({
            op: "add",
            path: altpath,
            value: altann.iri
        });
        // reajusto clones
        tobjclon.height = altann;
        tobjclon.heightAnnotations = !(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].heightAnnotations ? altann : Array.isArray((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].heightAnnotations) ? [
            altann,
            ...tobjclon.heightAnnotations
        ] : [
            altann,
            (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].heightAnnotations
        ];
        if (bobjclon) bobjclon.height = alt;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#treeDiameter').length) {
        tipoann = 'diameter_annotation';
        //console.log("Anotación de diámetro");
        let diam = Number((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#treeDiameter').val());
        // reajuste por el modo perímetro
        if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#checkPerimeter").prop("checked")) diam = Number((diam / Math.PI).toFixed(0));
        const diann = {
            iri: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/diamann/" + annid,
            creator: creador,
            created: ahora,
            millimeters: diam,
            types: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/sta/ontology/DiameterAnnotation"
        };
        anniri = diann.iri;
        // preparo patch con la nueva anotación de diámetro
        const oper = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].diameter ? "replace" : "add";
        patch.push({
            op: oper,
            path: "/diameter",
            value: diann
        });
        // preparo el path adecuado en el array de diámetros
        const dipath = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].diameterAnnotations ? "/diameterAnnotations/-" : "/diameterAnnotations";
        patch.push({
            op: "add",
            path: dipath,
            value: diann.iri
        });
        // reajusto clones
        tobjclon.diameter = diann;
        tobjclon.diameterAnnotations = !(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].diameterAnnotations ? diann : Array.isArray((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].diameterAnnotations) ? [
            diann,
            ...tobjclon.diameterAnnotations
        ] : [
            diann,
            (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].diameterAnnotations
        ];
        if (bobjclon) bobjclon.dbh = diam;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#observation').length) {
        tipoann = 'observation_annotation';
        //console.log("Anotación de altura");
        const obs = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#observation').val();
        const obsann = {
            iri: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/observann/" + annid,
            creator: creador,
            created: ahora,
            text: {
                [(0, $96abbdd7193a3c4b$export$350964a2fface462)()]: obs
            },
            types: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/sta/ontology/ObservationAnnotation"
        };
        anniri = obsann.iri;
        // preparo el path adecuado en el array de observaciones
        const obspath = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].observations ? "/observations/-" : "/observations";
        patch.push({
            op: "add",
            path: obspath,
            value: obsann
        });
        // reajusto clones
        tobjclon.observations = !(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].observations ? obsann : Array.isArray((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].observations) ? [
            obsann,
            ...tobjclon.observations
        ] : [
            obsann,
            (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].observations
        ];
        if (bobjclon) bobjclon.observations = !(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].observations ? {
            [(0, $96abbdd7193a3c4b$export$350964a2fface462)()]: obs
        } : Array.isArray((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].observations) ? [
            {
                [(0, $96abbdd7193a3c4b$export$350964a2fface462)()]: obs
            },
            ...bobjclon.observations
        ] : [
            {
                [(0, $96abbdd7193a3c4b$export$350964a2fface462)()]: obs
            },
            bobjclon.observations
        ];
    } else return; // no debería llegar aquí, pero por si acaso
    //console.log(patch);
    // inicializo evento de creación de anotación a GA
    (0, $067277e156f7a571$export$639f48199cd2287d)({
        content_type: tipoann,
        content_id: anniri,
        tree_id: iri,
        uid: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid,
        crafts_reqs: 0
    });
    // hago la llamada para procesar el patch
    try {
        // pongo spinner (porque aquí hay que esperar y en el resto de casos no)
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
            static: true,
            vertcent: true,
            spinner: true,
            spinnerMessage: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).pleasewait),
            nofooter: true
        }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).creatingannotation), null, null);
        await (0, $174d363c054274ef$export$f78fa04d07774c6b)(iri, patch, tobjclon, bobjclon);
        // envío datos creación de anotación a GA
        (0, $067277e156f7a571$export$6adbd77fe07ba13)("create_content");
        console.info("Anotaci\xf3n creada con IRI: " + anniri); // log
    } catch (err) {
        console.error(err.message);
        // actualizo modal
        const be = "<code>" + err.message + "<br>" + JSON.stringify(err.error) + "</code>";
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
            static: true,
            vertcent: true
        }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treeannotationerror), be, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).anotacionError);
        return; // terminamos
    }
    // ajustes finales footer
    // /app/images/treeAnnotation.png
    const htmlbody = '<img id="imgTreeAnnotation" src="" class="d-block w-100">';
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        static: true,
        vertcent: true
    }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treeannotationsuccess), htmlbody, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).anotacionExito);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#imgTreeAnnotation").attr("src", new URL($edac08b8dba83fcf$exports));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botAnotacionExito").click($27fe9e683b34e1a0$export$d096c03518bc83df);
}
var $fb7951a532ae36c5$exports = {};
$fb7951a532ae36c5$exports = import.meta.resolve("7KQWG");


///////////////////////
// BORRADO ANOTACIONES
function $27fe9e683b34e1a0$var$handlerDeleteAnnotation() {
    // recupero iri del árbol
    const iri = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/tree/" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid;
    const edutree = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri];
    // recupero iri de la anotación
    const anniri = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).attr('iri');
    //console.log(anniri);
    if (!anniri) return; // no debería llegar aquí, pero por si acaso
    // inicializo tipo de anotación para el evento a GA
    let tipoann = null;
    // preparo clones
    const tobjclon = JSON.parse(JSON.stringify(edutree));
    const bobjclon = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri] ? JSON.parse(JSON.stringify((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri])) : null; // puede no existir	
    // inicializo patch
    const patch = [];
    // inicializo objetos a borrar para el dataManager 
    // (siempre 1, salvo en el caso de la foto en la que son 2)
    const objsborrar = [];
    // inicializo path de firebase a borrar para el caso de una imagen
    let pathFirebaseBorrar = null;
    // preparo patch y ajusto clones por tipo de anotación a borrar
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass('position')) {
        tipoann = 'position_annotation';
        // incluyo la anotación a borrar
        objsborrar.push({
            iri: anniri,
            id: 'PositionAnnotation'
        });
        // llamada para preparar patch y ajustar tobjclon
        $27fe9e683b34e1a0$var$ajustarPatchClonBorradoAnotacion(edutree, "position", "positionAnnotations", anniri, patch, tobjclon);
        // reajuste clon básico
        if (bobjclon) {
            if (tobjclon.position) {
                bobjclon.lat = tobjclon.position.latWGS84;
                bobjclon.lng = tobjclon.position.lngWGS84;
            } else {
                delete bobjclon.lat;
                delete bobjclon.lng;
            }
        }
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass('treeTaxon')) {
        tipoann = 'taxon_annotation';
        // incluyo la anotación a borrar
        objsborrar.push({
            iri: anniri,
            id: 'SpeciesAnnotation'
        });
        // llamada para preparar patch y ajustar tobjclon
        $27fe9e683b34e1a0$var$ajustarPatchClonBorradoAnotacion(edutree, "species", "speciesAnnotations", anniri, patch, tobjclon);
        // reajuste clon básico
        if (bobjclon) {
            if (tobjclon.species) bobjclon.species = tobjclon.species.species.iri;
            else delete bobjclon.species;
        }
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass('treeStatus')) {
        tipoann = 'status_annotation';
        // incluyo la anotación a borrar
        objsborrar.push({
            iri: anniri,
            id: 'TreeStatusAnnotation'
        });
        // llamada para preparar patch y ajustar tobjclon
        $27fe9e683b34e1a0$var$ajustarPatchClonBorradoAnotacion(edutree, "treeStatus", "treeStatusAnnotations", anniri, patch, tobjclon);
        // reajuste clon básico
        if (bobjclon) {
            if (tobjclon.treeStatus) bobjclon.treeStatus = tobjclon.treeStatus.treeStatus;
            else delete bobjclon.treeStatus;
        }
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass('photo')) {
        tipoann = 'photo_annotation';
        // caso especial
        // incluyo la anotación a borrar
        objsborrar.push({
            iri: anniri,
            id: 'ImageAnnotation'
        });
        // analizo anotaciones
        if (edutree.imageAnnotations) {
            let imageURL = null; // localizo para borrar en bobjclon
            // si es un array...
            if (Array.isArray(edutree.imageAnnotations)) {
                // localizo índice anotación
                const indice = (0, $2q7Wm.default).findIndex(edutree.imageAnnotations, {
                    iri: anniri
                });
                if (indice != -1) {
                    // marco para borrar
                    patch.push({
                        op: "remove",
                        path: "/imageAnnotations/" + indice
                    });
                    // localizo también la imagen a borrar
                    if (edutree.imageAnnotations[indice].image) {
                        objsborrar.push({
                            iri: edutree.imageAnnotations[indice].image.iri,
                            id: 'Image'
                        });
                        imageURL = edutree.imageAnnotations[indice].image.imageURL;
                        // extraigo pathFirebaseBorrar
                        if (edutree.imageAnnotations[indice].image.firebasePath) pathFirebaseBorrar = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(edutree.imageAnnotations[indice].image.firebasePath);
                    }
                    // borro del clon
                    tobjclon.imageAnnotations.splice(indice, 1);
                }
            } else if (edutree.imageAnnotations.iri === anniri) {
                // marco para borrar
                patch.push({
                    op: "remove",
                    path: "/imageAnnotations"
                });
                // localizo también la imagen a borrar
                if (edutree.imageAnnotations.image) {
                    objsborrar.push({
                        iri: edutree.imageAnnotations.image.iri,
                        id: 'Image'
                    });
                    imageURL = edutree.imageAnnotations.image.imageURL;
                    // extraigo pathFirebaseBorrar
                    if (edutree.imageAnnotations.image.firebasePath) pathFirebaseBorrar = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(edutree.imageAnnotations.image.firebasePath);
                }
                // borro del clon
                delete tobjclon.imageAnnotations;
            }
            // reajuste clon básico
            if (imageURL && bobjclon && bobjclon.images) {
                // si es un array...
                if (Array.isArray(bobjclon.images)) bobjclon.images = (0, $2q7Wm.default).without(bobjclon.images, imageURL);
                else if (bobjclon.images === imageURL) delete bobjclon.images;
            }
        }
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass('height')) {
        tipoann = 'height_annotation';
        // incluyo la anotación a borrar
        objsborrar.push({
            iri: anniri,
            id: 'HeightAnnotation'
        });
        // llamada para preparar patch y ajustar tobjclon
        $27fe9e683b34e1a0$var$ajustarPatchClonBorradoAnotacion(edutree, "height", "heightAnnotations", anniri, patch, tobjclon);
        // reajuste clon básico
        if (bobjclon) {
            if (tobjclon.height) bobjclon.height = tobjclon.height.meters;
            else delete bobjclon.height;
        }
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass('diameter')) {
        tipoann = 'diameter_annotation';
        // incluyo la anotación a borrar
        objsborrar.push({
            iri: anniri,
            id: 'DiameterAnnotation'
        });
        // llamada para preparar patch y ajustar tobjclon
        $27fe9e683b34e1a0$var$ajustarPatchClonBorradoAnotacion(edutree, "diameter", "diameterAnnotations", anniri, patch, tobjclon);
        // reajuste clon básico
        if (bobjclon) {
            if (tobjclon.diameter) bobjclon.dbh = tobjclon.diameter.millimeters;
            else delete bobjclon.dbh;
        }
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass('observation')) {
        tipoann = 'observation_annotation';
        // incluyo la anotación a borrar
        objsborrar.push({
            iri: anniri,
            id: 'ObservationAnnotation'
        });
        // analizo anotaciones
        if (edutree.observations) {
            // si es un array...
            if (Array.isArray(edutree.observations)) {
                // localizo índice anotación
                const indice = (0, $2q7Wm.default).findIndex(edutree.observations, {
                    iri: anniri
                });
                if (indice != -1) {
                    // marco para borrar
                    patch.push({
                        op: "remove",
                        path: "/observations/" + indice
                    });
                    // borro del clon
                    tobjclon.observations.splice(indice, 1);
                    // compruebo si hay que borrar el array del clon por estar vacío
                    if (tobjclon.observations.length == 0) delete tobjclon.observations;
                }
            } else if (edutree.observations.iri === anniri) {
                // marco para borrar
                patch.push({
                    op: "remove",
                    path: "/observations"
                });
                // borro del clon
                delete tobjclon.observations;
            }
        }
        // reajuste clon básico
        if (bobjclon) {
            delete bobjclon.observations;
            // genero a partir de las observaciones de tobjclon
            if (tobjclon.observations) {
                bobjclon.observations = [];
                for (let obs of tobjclon.observations)bobjclon.observations.push(obs.text);
            }
        }
    } else return; // no debería llegar aquí, pero por si acaso
    // inicialización modal con petición de confirmación
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        static: true,
        vertcent: true
    }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).deleteAnnotation), (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).deleteAnnotationInfo), (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).confirmarBorradoAnotacion);
    // muestro el modal
    const mimodal = new (0, (/*@__PURE__*/$parcel$interopDefault($dktVJ))).Modal(document.getElementById('mimodal'));
    mimodal.show();
    // handler de borrado de anotación
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botonBorradoAnotacion").click(async function() {
        //console.log("Borrando anotación " +anniri+ " del árbol " + iri);		
        //console.log(patch);
        // inicializo evento de borrado de anotación a GA
        (0, $067277e156f7a571$export$639f48199cd2287d)({
            content_type: tipoann,
            content_id: anniri,
            tree_id: iri,
            uid: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid,
            crafts_reqs: 0
        });
        // hago la llamada para borrar la anotación
        try {
            // pongo spinner (porque aquí hay que esperar y en el resto de casos no)
            (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
                static: true,
                vertcent: true,
                spinner: true,
                spinnerMessage: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).pleasewait),
                nofooter: true
            }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).deletingAnnotation), null, null);
            await (0, $174d363c054274ef$export$e2dbe74809c0905f)(iri, patch, objsborrar, tobjclon, bobjclon);
            // envío datos borrado de anotación a GA
            (0, $067277e156f7a571$export$6adbd77fe07ba13)("delete_content");
            console.info("Anotaci\xf3n borrada con IRI: " + anniri); // log
        } catch (err) {
            console.error(err.message);
            // actualizo modal
            const be = "<code>" + err.message + "\n" + JSON.stringify(err.error) + "</code>";
            (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
                static: true,
                vertcent: true
            }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treeannotationerror), be, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).anotacionError);
            return; // terminamos
        }
        // si hay que borrar la imagen en Firebase...
        if (pathFirebaseBorrar) {
            const storage = (0, $63c1f7f3542429ef$export$fbd9b57a66480737)((0, $c0304d280c7b00cb$export$54387eca9e368edc)());
            // Create a storage reference from our storage service
            //const storageRef = storage.ref();
            // ref a la imagen
            const imgRef = (0, $63c1f7f3542429ef$export$eff4d24c3ff7876e)(storage, pathFirebaseBorrar);
            // borro foto del árbol
            try {
                // compruebo primero que exista
                const imgDownloadURL = await (0, $63c1f7f3542429ef$export$c8bf645a0c2a7d9f)(imgRef);
                //console.log('File exists at: ' + imgDownloadURL);
                // ahora borro
                // cuidado con las reglas de seguridad de Firebase storage
                // para el borrado simplemente pongo que sea un usuario autenticado
                // para permitir así que un usuario de tipo máster pueda borrar fotos
                // creadas por otros usuarios
                await (0, $63c1f7f3542429ef$export$39c5ed4ec960eade)(imgRef);
                // mando evento de borrado de foto en firebase a GA
                (0, $067277e156f7a571$export$7329bcdc3edcd90e)("delete_content", {
                    content_type: 'photo',
                    content_id: imgDownloadURL,
                    uid: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid
                });
                console.info("Foto borrada de Firebase: " + imgDownloadURL);
            } catch (error) {
                if (error.code === 'storage/object-not-found') console.error('File does not exist.');
                else {
                    console.error('Error: ' + error.message);
                    // ajustes finales modal
                    const be = "<code>" + error + "</code>";
                    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
                        static: true,
                        vertcent: true
                    }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).deletingphotoerror), be, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).anotacionExito);
                    // pongo el footer de anotación de éxito porque así ha sido, sólo ha fallado el borrado de la foto						
                    return; // terminamos
                }
            }
        }
        // ajustes finales footer
        // /app/images/treeAnnotationRemoval.png
        const htmlbody = '<img id="imgTreeAnnotationRemoval" src="" class="d-block w-100">';
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
            static: true,
            vertcent: true
        }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).deleteAnnotationSuccess), htmlbody, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).anotacionExito);
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#imgTreeAnnotationRemoval").attr("src", new URL($fb7951a532ae36c5$exports));
        // y al cerrar renderizamos de nuevo...
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botAnotacionExito").click($27fe9e683b34e1a0$export$d096c03518bc83df);
    });
}
function $27fe9e683b34e1a0$var$ajustarPatchClonBorradoAnotacion(edutree, annprim, anotaciones, anniri, patch, tobjclon) {
    // preinicializo posición de reemplazo 
    let reemplazo = null;
    // analizo anotaciones
    if (edutree[anotaciones]) {
        // si es un array...
        if (Array.isArray(edutree[anotaciones])) {
            // localizo índice anotación
            const indice = (0, $2q7Wm.default).findIndex(edutree[anotaciones], {
                iri: anniri
            });
            if (indice != -1) {
                // marco para borrar
                patch.push({
                    op: "remove",
                    path: "/" + anotaciones + "/" + indice
                });
                // borro del clon
                tobjclon[anotaciones].splice(indice, 1);
            }
            // obtengo reemplazo (si lo hay)
            if (tobjclon[anotaciones].length > 0) reemplazo = (0, $2q7Wm.default).sortBy(tobjclon[anotaciones], function(obj) {
                return new Date(obj.created);
            }).reverse()[0];
            // compruebo si hay que borrar el array del clon por estar vacío
            // (importante para preparar bien los patches, ya que es diferente asignar un valor, 
            // ej. "/speciesAnnotations" que meter al final de un array existente, ej. "/speciesAnnotations/-")
            if (tobjclon[anotaciones].length == 0) delete tobjclon[anotaciones];
        } else if (edutree[anotaciones] && edutree[anotaciones].iri === anniri) {
            // marco para borrar
            patch.push({
                op: "remove",
                path: "/" + anotaciones
            });
            // borro del clon
            delete tobjclon[anotaciones];
        }
    }
    // analizo la anotación primaria
    if (edutree[annprim] && edutree[annprim].iri === anniri) {
        if (reemplazo) {
            // marco para reemplazar
            patch.push({
                op: "replace",
                path: "/" + annprim,
                value: reemplazo.iri
            });
            // reemplazo en el clon
            tobjclon[annprim] = reemplazo;
        } else {
            // marco para borrar
            patch.push({
                op: "remove",
                path: "/" + annprim
            });
            // borro en el clon
            delete tobjclon[annprim];
        }
    }
}
///////////////////////
// BORRADO ÁRBOL
function $27fe9e683b34e1a0$var$handlerDeleteEducatree() {
    // preparo contenido modal
    let tit = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).deleteTree);
    let body = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).deleteTreeInfo);
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        vertcent: true,
        static: true
    }, tit, body, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).confirmarBorradoArbol);
    // muestro modal
    const mimodal = new (0, (/*@__PURE__*/$parcel$interopDefault($dktVJ))).Modal(document.getElementById('mimodal'));
    mimodal.show();
    // handler procesarBorradoArbol
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#procesarBorradoArbol").click($27fe9e683b34e1a0$var$procesarBorradoArbol);
}
var $86fbd784597f5805$exports = {};
$86fbd784597f5805$exports = import.meta.resolve("8cm2G");


async function $27fe9e683b34e1a0$var$procesarBorradoArbol() {
    // recupero iri del árbol
    const iri = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/tree/" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid;
    // inicializo evento de borrado de árbol a GA
    (0, $067277e156f7a571$export$639f48199cd2287d)({
        content_type: 'tree',
        content_id: iri,
        uid: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid,
        crafts_reqs: 0
    });
    // actualizo modal
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        vertcent: true,
        static: true,
        spinner: true,
        spinnerMessage: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).pleasewait),
        nofooter: true
    }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).deletingtree), null, null);
    // cojo datos de las imágenes para borrar en Firebase, pero borro siempre antes el LOD
    // al ser strings sin etiqueta de idioma, los paths se guardan como objetos con clave "nolang"
    const pathsFirebaseBorrar = (0, $96abbdd7193a3c4b$export$326843c69d38a183)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri], [
        "imageAnnotations",
        "image",
        "firebasePath"
    ]);
    // hago la petición para borrar el árbol
    try {
        await (0, $174d363c054274ef$export$c4e23ce322fddcd9)(iri); // aquí se hace el borrado y la sincronización con el mapa si tiene éxito
        // envío datos borrado del árbol a GA
        (0, $067277e156f7a571$export$6adbd77fe07ba13)("delete_content");
        console.info("\xc1rbol borrado con IRI: " + iri); // log
    } catch (err) {
        console.error(err.message);
        // actualizo modal
        const be = "<code>" + err.message + "\n" + JSON.stringify(err.error) + "</code>";
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
            static: true,
            vertcent: true
        }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treedeletionerror), be, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).borradoArbolError);
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".goBack").click((0, $ffd94e1d81f19b1c$export$28fca2ccfd38b8f));
        return; // terminamos
    }
    // borro las imágenes que haya en Firebase
    if (pathsFirebaseBorrar.length > 0) {
        const storage = (0, $63c1f7f3542429ef$export$fbd9b57a66480737)((0, $c0304d280c7b00cb$export$54387eca9e368edc)());
        // Create a storage reference from our storage service
        //const storageRef = storage.ref();
        // voy imagen por imagen
        for (const pathobj of pathsFirebaseBorrar){
            const path = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(pathobj);
            const imgRef = (0, $63c1f7f3542429ef$export$eff4d24c3ff7876e)(storage, path);
            // borro foto del árbol
            try {
                // compruebo primero que exista
                const imgDownloadURL = await (0, $63c1f7f3542429ef$export$c8bf645a0c2a7d9f)(imgRef);
                //console.log('File exists at: ' + imgDownloadURL);
                // ahora borro
                // cuidado con las reglas de seguridad de Firebase storage
                // para el borrado simplemente pongo que sea un usuario autenticado
                // para permitir así que un usuario de tipo máster pueda borrar fotos
                // creadas por otros usuarios
                await (0, $63c1f7f3542429ef$export$39c5ed4ec960eade)(imgRef);
                // mando evento de borrado de foto en firebase a GA
                (0, $067277e156f7a571$export$7329bcdc3edcd90e)("delete_content", {
                    content_type: 'photo',
                    content_id: imgDownloadURL,
                    uid: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid
                });
                console.info("Foto borrada de Firebase: " + imgDownloadURL);
            } catch (error) {
                if (error.code === 'storage/object-not-found') console.error('File does not exist.');
                else {
                    console.error('Error: ' + error.message);
                    // ajustes finales modal
                    const be = "<code>" + error + "</code>";
                    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
                        static: true,
                        vertcent: true
                    }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).deletingphotoerror), be, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).borradoArbolExito);
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".goBack").click((0, $ffd94e1d81f19b1c$export$28fca2ccfd38b8f));
                    // pongo el footer de borrado de éxito porque así ha sido, sólo ha fallado el borrado de la foto						
                    return; // terminamos
                }
            }
        }
    }
    // ajustes finales modal
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        static: true,
        vertcent: true
    }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treedeletionsuccess), (0, $646ceeeec66fabd8$export$ab832a4d4ceb9113), (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).borradoArbolExito);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#imgTreeDeletion").attr("src", new URL($86fbd784597f5805$exports));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".goBack").click((0, $ffd94e1d81f19b1c$export$28fca2ccfd38b8f));
}
function $27fe9e683b34e1a0$var$educatreeNoExiste() {
    // pongo página en blanco
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#miarbol").html("");
    // pongo un modal para avisar de que no se puede explorar el inventario
    const body = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).errorEducatreeText) + ' "' + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid + '".';
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        vertcent: true,
        nofooter: true
    }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).errorEducatreeTitle), body, null);
    const mimodal = new (0, (/*@__PURE__*/$parcel$interopDefault($dktVJ))).Modal(document.getElementById('mimodal'));
    mimodal.show();
    // handler al esconderse
    document.getElementById('mimodal').addEventListener('hidden.bs.modal', (event)=>{
        // voy para atrás
        (0, $ffd94e1d81f19b1c$export$28fca2ccfd38b8f)();
    }, {
        'once': true
    });
}
var $083e2ee32f3551b0$exports = {};
$083e2ee32f3551b0$exports = import.meta.resolve("hgo2Y");


function $27fe9e683b34e1a0$var$changeTreeNick() {
    const iri = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/tree/" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid;
    // preparo contenido modal
    let tit = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).newTreeNick);
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        vertcent: true,
        static: true
    }, tit, (0, $646ceeeec66fabd8$export$62b82cd57460378a), (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).cambiarNick);
    // muestro modal
    const mimodal = new (0, (/*@__PURE__*/$parcel$interopDefault($dktVJ))).Modal(document.getElementById('mimodal'));
    mimodal.show();
    // listener de cambio de nick del árbol
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#newTreeNick").change(function() {
        const newtreenick = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#newTreeNick').val();
        // preinicializo
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").removeClass("d-none");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botonCambioNick").prop("disabled", true);
        if (!newtreenick) //console.log("No hay nada");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noNick));
        else if (newtreenick.length < 3) //console.log("Fuera de rango");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).nickTooshort));
        else if (newtreenick.length > 30) //console.log("Fuera de rango");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).nickToolong));
        else {
            //console.log("Todo OK");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").addClass("d-none");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botonCambioNick").prop("disabled", false);
        }
    });
    // listener del botón de cambio de nick
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botonCambioNick").click(async function() {
        // desabilito la entrada y quito el footer
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#newTreeNick").prop("disabled", true);
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
            vertcent: true,
            static: true,
            nofooter: true
        }, null, null, null);
        // recupero el nick
        const newtreenick = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#newTreeNick').val();
        // inicializo evento nuevo nick a GA
        (0, $067277e156f7a571$export$639f48199cd2287d)({
            value: newtreenick,
            crafts_reqs: 0
        });
        // vamos con el cambio
        try {
            // preparo patch con el cambio de nick
            const patch = [];
            const oper = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].nick ? "replace" : "add";
            patch.push({
                op: oper,
                path: "/nick",
                value: newtreenick
            });
            //console.log(patch);
            await (0, $174d363c054274ef$export$56e5489c2f38300e)(iri, patch);
            // envío evento nuevo nick a GA
            (0, $067277e156f7a571$export$6adbd77fe07ba13)('new_nick');
            console.info("Nick del \xe1rbol cambiado: " + newtreenick);
        } catch (err) {
            console.error(err.message);
            // actualizo modal
            const be = "<code>" + err.message + "\n" + JSON.stringify(err.error) + "</code>";
            (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
                static: true,
                vertcent: true
            }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).changeTreeNickFailure), be, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).anotacionError);
            return; // terminamos
        }
        // modal de éxito
        // escondo campos y muestro imagen
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#newTreeNick").addClass("d-none");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").addClass("d-none");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#imgNewTreeNick").attr("src", new URL($083e2ee32f3551b0$exports));
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#imgNewTreeNick").removeClass("d-none");
        //const htmlbody = '<img src="/app/images/newNick.png" class="d-block w-100">';
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
            vertcent: true,
            static: true
        }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).changeTreeNickSuccess), null, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).treeNickCambiado);
        // listener cierre modal
        document.getElementById('mimodal').addEventListener('hidden.bs.modal', (event)=>{
            $27fe9e683b34e1a0$export$d096c03518bc83df();
        }, {
            once: true
        });
    });
}


/*
   Copyright 2023, Guillermo Vega-Gorgojo

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ 
var $33Kba = parcelRequire("33Kba");



var $2q7Wm = parcelRequire("2q7Wm");


var $6KOho = parcelRequire("6KOho");









///////////////////
// PÁGINA lasttrees
///////////////////
async function $82a71c896f160eac$export$eca36acb6faff6b4(noborrarcache) {
    // pongo spinner con mensaje de cargando	
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#miarbol").html((0, $646ceeeec66fabd8$export$27eb5f8cf2bf64a7));
    window.scrollTo(0, 0);
    // inicializo el evento para enviar a GA
    (0, $067277e156f7a571$export$639f48199cd2287d)({
        content_type: 'lasttrees',
        crafts_reqs: 0
    });
    // pido datos a CRAFTS de las páginas de últimos educatrees
    const pe = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pe ? (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pe : 0; // por defecto la 0
    const pae = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pae ? (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pae : 0; // por defecto la 0
    await (0, $174d363c054274ef$export$5f671086e5404234)(pe, pae);
    // si están mal ajustadas las páginas (por no tener resultados y no ser 0), reajusto la URL
    let actualizar = false;
    if (pe > 0 && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees.global[pe].length == 0) {
        delete (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pe;
        actualizar = true;
    }
    if (pae > 0 && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones.global[pae].length == 0) {
        delete (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pae;
        actualizar = true;
    }
    if (actualizar) {
        //console.log("URL nueva: "+obtenerURL());
        // actualizo URL
        history.replaceState((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado, "", (0, $ffd94e1d81f19b1c$export$e5c8c113a1c69275)());
        // y lllamo de nuevo al método para que obtenga los datos de nuevo
        $82a71c896f160eac$export$eca36acb6faff6b4(true);
        return;
    }
    // caso normal: hago el render
    $82a71c896f160eac$export$afe524c3a091be69();
}
async function $82a71c896f160eac$export$afe524c3a091be69() {
    // detecto llamada espúrea por la autenticación
    if (!(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees.global || !(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones.global) return;
    // obtengo info páginas
    const pe = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pe ? (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pe : 0; // por defecto la 0
    const pae = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pae ? (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pae : 0; // por defecto la 0
    // preparo objeto plantilla
    const objltt = {
        usuario: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario != undefined,
        usuarioImg: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario ? (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.photoURL : null,
        enPagLastrees: true,
        showann: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.showann
    };
    // ultEducatrees
    const uet = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees.global[pe];
    objltt.hayUltedutrees = uet.length > 0;
    objltt.hayUltedutreesPrev = pe > 0;
    objltt.hayUltedutreesSig = uet.length > (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).page;
    objltt.pagUltedutrees = pe + 1;
    objltt.ultedutrees = [];
    for(let i = 0; i < uet.length && i < (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).page; i++){
        const uetel = uet[i];
        const etid = uetel.iri.split("/")[uetel.iri.split("/").length - 1];
        // cojo primero el nick en Datos.educatrees[iri] (por si actualizó su nick),
        // en segunda opción el nick del objeto y si no, el etid
        let etl = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[uetel.iri] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[uetel.iri].nick ? (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[uetel.iri].nick) : uetel.nick ? (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(uetel.nick) : etid;
        etl = etl.length > 14 ? etl.substring(0, 10) + "\u2026" : etl;
        const uid = uetel.creator.iri.split("/")[uetel.creator.iri.split("/").length - 1];
        objltt.ultedutrees.push({
            etid: etid,
            treeLabel: etl,
            treeHref: "/tree/" + etid,
            created: (0, $96abbdd7193a3c4b$export$aa350b96d91cd94)(uetel),
            userHref: "/user/" + uid,
            uid: uid,
            userLabel: (0, $96abbdd7193a3c4b$export$6efd817d0963408a)(uetel)
        });
    }
    // ultAnotaciones
    const uaet = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones.global[pae];
    objltt.hayUltanns = uaet.length > 0;
    objltt.hayUltannsPrev = pae > 0;
    objltt.hayUltannsSig = uaet.length > (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).page;
    objltt.pagUltanns = pae + 1;
    objltt.ultanns = [];
    for(let i = 0; i < uaet.length && i < (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).page; i++){
        const uaetel = uaet[i];
        const etid = uaetel.iri.split("/")[uaetel.iri.split("/").length - 1];
        // cojo primero el nick en Datos.educatrees[iri] (por si actualizó su nick),
        // en segunda opción el nick del objeto y si no, el etid
        let etl = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[uaetel.iri] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[uaetel.iri].nick ? (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[uaetel.iri].nick) : uaetel.nick ? (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(uaetel.nick) : etid;
        etl = etl.length > 14 ? etl.substring(0, 10) + "\u2026" : etl;
        const uid = uaetel.creator.iri.split("/")[uaetel.creator.iri.split("/").length - 1];
        const atl = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).annotationTypeLabels[uaetel.type];
        const typeLabel = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(atl, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).annotationTypeLabels.pordefecto));
        objltt.ultanns.push({
            etid: etid,
            treeLabel: etl,
            treeHref: "/tree/" + etid,
            annotationType: typeLabel,
            annotated: (0, $96abbdd7193a3c4b$export$aa350b96d91cd94)(uaetel),
            userHref: "/user/" + uid,
            uid: uid,
            userLabel: (0, $96abbdd7193a3c4b$export$6efd817d0963408a)(uaetel)
        });
    }
    // renderizo
    const htmlcontent = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$96346f251ef3b3fb), objltt);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#miarbol").html(htmlcontent);
    // envío GA evento ver página lasttrees
    (0, $067277e156f7a571$export$6adbd77fe07ba13)();
    console.info("P\xe1gina lasttrees cargada");
    // pongo listener del botón de volver
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#goBackButton").on("click", (0, $ffd94e1d81f19b1c$export$28fca2ccfd38b8f));
    // pongo listeners a clickViewprofile, clickSignin y clickSignout
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".userprofile").click((0, $c0304d280c7b00cb$export$f98b6673fafc0e20));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".usersignin").click((0, $c0304d280c7b00cb$export$9ffe63492d76c086));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".usersignout").click((0, $c0304d280c7b00cb$export$daa0a882204fd973));
    // handlers de páginas
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".pagina").click(function() {
        // detecto target de la página
        let target = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass("created") ? "pe" : "pae";
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.showann = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass("annotated");
        // detecto si retrocedo o avanzo
        if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass("prev")) {
            (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado[target]--;
            if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado[target] == 0) delete (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado[target];
        } else if (!(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado[target]) (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado[target] = 1;
        else (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado[target]++;
        // actualizo URL
        history.replaceState((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado, "", (0, $ffd94e1d81f19b1c$export$e5c8c113a1c69275)());
        // y cargo la URL para que obtenga los datos de nuevo
        $82a71c896f160eac$export$eca36acb6faff6b4(true);
    });
}
// ÁRBOLES
function $82a71c896f160eac$export$b07097befa6136ca(objcelda) {
    // sólo hago el rendering si me toca (objcelda.idtimeout es el mismo que Sesion.idTimeoutActualizar)
    if (objcelda.idtimeout == (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).idTimeoutActualizar) {
        if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).celdasPintadas[objcelda.et] == undefined) {
            // referencia a la celda
            const celda = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[objcelda.et];
            // objeto bounds de la celda (se usa en un par de sitios)
            const bounds = (0, $0a5d75214fa44e03$export$4e23e15d2ccb71f7)(objcelda.cellX, objcelda.cellY, objcelda.zoom);
            // detecto si hay cluster, ajustando etiqueta y z-index
            let etCluster = null;
            let zCluster = null;
            if (celda.edu.mmil || (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.ifn && celda.ifn.mmil) {
                etCluster = "+1K";
                zCluster = 1000;
            } else if (celda.edu.ntrees > (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).treeThreshold || (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.ifn && celda.edu.ntrees + celda.ifn.ntrees > (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).treeThreshold) {
                etCluster = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.ifn ? celda.edu.ntrees + celda.ifn.ntrees : celda.edu.ntrees;
                zCluster = etCluster;
            }
            // LIMPIEZA CASO ZOOM-OUT (si toca cluster borramos los marcadores que aglutina)
            if (objcelda.zoomout && etCluster) {
                // borrado de árboles en la celda
                let aborrar = [];
                (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).arbs.eachLayer(function(a) {
                    if (bounds.contains(a.getLatLng())) // guardo el árbol
                    aborrar.push(a);
                });
                for(let i = 0; i < aborrar.length; i++){
                    (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).arbs.removeLayer(aborrar[i]);
                    // borro también el árbol de Sesion.arbsPintados
                    delete (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados[aborrar[i].uri];
                }
            }
            // CLUSTERS
            if (etCluster != undefined) {
                // pongo el cluster en la localización de un árbol de la celda o si no hay en el centro de la celda
                const mLatLng = celda.edu.locCluster ? L.latLng(celda.edu.locCluster.lat, (0, $69f04ba581843b2d$export$a4829058f9fe1646)(celda.edu.locCluster.lng, objcelda.cellX, objcelda.zoom)) : (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.ifn && celda.ifn.locCluster ? L.latLng(celda.ifn.locCluster.lat, (0, $69f04ba581843b2d$export$a4829058f9fe1646)(celda.ifn.locCluster.lng, objcelda.cellX, objcelda.zoom)) : bounds.getCenter();
                // preparo icono
                const micon = new L.divIcon({
                    html: '<div class="marcadorTexto"><span>' + etCluster + '</span></div>',
                    className: '',
                    iconSize: [
                        52,
                        52
                    ],
                    iconAnchor: [
                        26,
                        26
                    ],
                    tooltipAnchor: [
                        12,
                        0
                    ] // point from which tooltips will "open", relative to the icon anchor
                });
                // creo marcador y añado a la capa de clusters
                const cpint = L.marker(mLatLng, {
                    icon: micon,
                    zIndexOffset: zCluster
                }).addTo((0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).clarbs);
                // ajusto cursor y handler de click con +3 de zoom
                $82a71c896f160eac$export$19f9855b4b37efc4(cpint);
                // añado tooltip si no es táctil
                if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).hayTooltips) cpint.bindTooltip(etCluster + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).ntrees));
            // (no ajusto condicionalmente el tooltip porque me da un error al clickar tras un unbindTooltip)
            } else {
                // no es un cluster, agrego los dos arrays de árboles y los trato de manera indiferente
                const alltrees = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.ifn && celda.ifn.trees ? celda.edu.trees ? celda.ifn.trees.concat(celda.edu.trees) : celda.ifn.trees : celda.edu.trees ? celda.edu.trees : [];
                // pinto árbol a árbol
                for (const turi of alltrees)// sólo pinto árbol si no estaba libre (para evitar efectos borde entre celdas)
                if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados[turi] == undefined) {
                    // recupero el árbol
                    const arb = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[turi];
                    // obtengo icono
                    const aicon = (0, $7b115b3c2cee4b53$export$6274df672a45c12d)(arb);
                    // reajuste de longitud por el antimeridiano
                    const lng = (0, $69f04ba581843b2d$export$a4829058f9fe1646)(arb.lng, objcelda.cellX, objcelda.zoom);
                    // pinto el marcador del árbol
                    let apint = L.marker([
                        arb.lat,
                        lng
                    ], {
                        icon: aicon
                    }).addTo((0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).arbs);
                    // le añado también la uri (para poder borrarlo en caso de zoom out)
                    apint.uri = turi;
                    // y lo guardo
                    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados[turi] = apint;
                    // pongo tooltips si es un ifntree (siempre)
                    // (no lo ajustaré condicionalmente con el modo de edición porque me da un error al clickar tras un unbindTooltip)
                    if (arb.iri == undefined) apint.bindTooltip($82a71c896f160eac$export$924c9d361ba12beb(arb));
                    // ajusto el cursor y el popup
                    $82a71c896f160eac$export$1f29254b983d0b7(turi);
                }
            }
            // actualizo las celdas pintadas
            (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).celdasPintadas[objcelda.et] = true;
        }
    }
}
function $82a71c896f160eac$export$19f9855b4b37efc4(cpint) {
    // actúo según esté en modo de creación de árbol o no
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).creandoArbol) {
        // cursor edición
        cpint.getElement().style.cursor = "crosshair";
        // fuera click handler
        cpint.off('click');
    } else {
        // cursor normal
        cpint.getElement().style.cursor = "";
        // pongo handler con +3 de zoom al hacer click
        cpint.on('click', function(e) {
            (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).flyTo(cpint.getLatLng(), (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoom + 3);
        });
    }
}
function $82a71c896f160eac$export$1f29254b983d0b7(auri) {
    // recupero árbol y árbol pintado
    const arb = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[auri];
    const apint = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados[auri];
    if (arb != undefined && apint != undefined) {
        // actúo según esté en modo de creación de árbol o no
        if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).creandoArbol) {
            // cursor edición
            apint.getElement().style.cursor = "crosshair";
            // fuera popup para edutrees
            if (arb.iri != undefined) apint.unbindPopup();
        } else {
            // cursor normal
            apint.getElement().style.cursor = "";
            // añado popup para edutrees
            if (arb.iri != undefined) {
                // añado popup
                apint.bindPopup($82a71c896f160eac$var$popupArbol(arb));
                // detecto si hay un error en la carga de la imagen y en tal caso la escondo (gracias, ChatGPT)
                apint.on('popupopen', function(e) {
                    const img = e.popup._contentNode.querySelector('img');
                    if (img) img.addEventListener('error', function() {
                        img.style.display = "none";
                        console.warn('Fallo al cargar esta imagen: ' + img.src);
                    });
                });
            }
        } // else Sesion.creandoArbol == false
    }
}
// TOOLTIPS
function $82a71c896f160eac$export$924c9d361ba12beb(arb) {
    return arb.iri == undefined ? $82a71c896f160eac$var$tooltipIfntree(arb) : $82a71c896f160eac$var$tooltipEdutree(arb);
}
function $82a71c896f160eac$var$tooltipIfntree(arb) {
    let tooltip = "<strong>" + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tree) + " " + (0, $96abbdd7193a3c4b$export$56b19e10c1699553)(arb.uri) + "</strong>";
    tooltip += "<br><i>" + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).createdByIFN) + "</i>";
    const espuri = (0, $1ee989753a15371d$export$fa0799b379eb3758)(arb.species);
    // especie
    if (espuri != undefined && espuri != null && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[espuri].vulgarName != undefined) {
        let nesp = (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[espuri].vulgarName, (0, $96abbdd7193a3c4b$export$56b19e10c1699553)(espuri)));
        // si hay nombre científico...
        if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).nomci) nesp = '<i>' + (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[espuri].scientificName, nesp)) + '</i>';
        tooltip += '<br>' + nesp;
    }
    // altura
    if (arb.heightM != undefined) tooltip += "<br>" + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).height) + ": " + Number((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(arb.heightM)).toFixed(2) + "m";
    // diámetro
    if (arb.dbh1mm && arb.dbh2mm) {
        // calculo media aritmética
        const dbh = ((arb.dbh1mm + arb.dbh2mm) / 2).toFixed(0);
        tooltip += '<br>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).diameter) + ': ' + dbh + 'mm';
    }
    return tooltip;
}
function $82a71c896f160eac$var$tooltipEdutree(arb) {
    let tooltip = "<strong>" + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tree) + " " + (0, $96abbdd7193a3c4b$export$56b19e10c1699553)(arb.iri) + "</strong>";
    if (arb.creator != undefined) tooltip += "<br><i>" + (0, $96abbdd7193a3c4b$export$4d0c182344beaa87)(arb, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).createdBy)) + "</i>";
    const espuri = (0, $1ee989753a15371d$export$fa0799b379eb3758)(arb.species);
    // especie
    if (espuri != undefined && espuri != null && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[espuri].vulgarName != undefined) {
        let nesp = (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[espuri].vulgarName, (0, $96abbdd7193a3c4b$export$56b19e10c1699553)(espuri)));
        // si hay nombre científico...
        if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).nomci) nesp = '<i>' + (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[espuri].scientificName, nesp)) + '</i>';
        tooltip += '<br>' + nesp;
    }
    // altura
    if (arb.height != undefined) tooltip += "<br>" + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).height) + ": " + Number((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(arb.height)).toFixed(2) + "m";
    // diámetro
    if (arb.dbh != undefined) tooltip += '<br>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).diameter) + ': ' + Number((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(arb.dbh)).toFixed(0) + 'mm';
    return tooltip;
}
// POPUPS
function $82a71c896f160eac$var$popupArbol(arb) {
    // preparo objeto para el popup con Mustache
    let pobj = {
        'iri': arb.iri,
        'etid': arb.iri.split("/").pop()
    };
    // nick
    if (arb.nick) pobj.nick = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(arb.nick);
    // taxón
    const espuri = (0, $1ee989753a15371d$export$fa0799b379eb3758)(arb.species);
    if (espuri != undefined && espuri != null && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[espuri].vulgarName != undefined) {
        let nesp = (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[espuri].vulgarName, (0, $96abbdd7193a3c4b$export$56b19e10c1699553)(espuri)));
        // si hay nombre científico...
        if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).nomci) nesp = '<i>' + (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[espuri].scientificName, nesp)) + '</i>';
        pobj.taxon = nesp;
    }
    // recupero todas las imágenes
    const images = (0, $96abbdd7193a3c4b$export$326843c69d38a183)(arb, [
        "images"
    ]);
    if (images.length) {
        if (images.length == 1) pobj.image = images[0];
        else {
            pobj.multimages = true;
            pobj.images = [];
            const inda = Math.floor(Math.random() * images.length);
            for(let i = 0; i < images.length; i++){
                let obji = {
                    srcimg: images[i]
                };
                if (i == inda) obji.active = true;
                pobj.images.push(obji);
            }
        }
    }
    // voy con la descripción
    pobj.desc = "";
    // treeStatus
    if (arb.treeStatus) {
        const ts = (0, $2q7Wm.default).find((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).estadoArboles, function(el) {
            return el.iri === arb.treeStatus;
        });
        if (ts) pobj.desc += (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(ts.label) + "<br>";
    }
    // altura
    if (arb.height) pobj.desc += (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).height) + ": " + Number((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(arb.height)).toFixed(2) + "m<br>";
    // diámetro
    if (arb.dbh) pobj.desc += (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).diameter) + ': ' + Number((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(arb.dbh)).toFixed(0) + 'mm<br>';
    // reajusto cadena descripción para quitar el <br> final
    const libr = pobj.desc.lastIndexOf("<br>");
    if (libr !== -1) pobj.desc = pobj.desc.substring(0, libr);
    // creador y fecha
    pobj.creator = (0, $96abbdd7193a3c4b$export$4d0c182344beaa87)(arb, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).createdBy));
    // devuelvo el html...
    return (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$df6117506e1c4c3b), pobj);
}


/*
   Copyright 2023, Guillermo Vega-Gorgojo

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ 
var $33Kba = parcelRequire("33Kba");



var $6KOho = parcelRequire("6KOho");





/////////////////////
// RENDER DEL CAJETÍN
function $d1e0875cf0f68e21$export$24073cf807c9abc3(mostrar) {
    if (mostrar && (0, $ffd94e1d81f19b1c$export$c398d137cd63b259) != null) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#lugares_heading').removeClass("d-none");
    else (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#lugares_heading').addClass("d-none");
}
///////////////////////////
// OBTENCIÓN DE SUGERENCIAS
async function $d1e0875cf0f68e21$export$a80214d90d6317cd(entrada) {
    try {
        // hago la llamada a solr y espero resultados
        const datos = await (0, $ffd94e1d81f19b1c$export$c398d137cd63b259).getSuggestions(entrada);
        // extraigo sugerencias del idioma adecuado
        const sugidioma = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).solrConfig.suggesters);
        let keys = Object.keys(datos.suggest[sugidioma]);
        if (keys.length > 0) return datos.suggest[sugidioma][keys[0]];
        else return {
            'numFound': 0
        };
    } catch (err) {
        reject(err);
    }
}
/////////////////////
// RENDER SUGERENCIAS
function $d1e0875cf0f68e21$export$49f32269b97f95f9(resultados) {
    // objeto sugerencias
    let sinfo = {};
    sinfo.sugerencias = [];
    // formateo las sugerencias
    if (resultados.numFound == 0) sinfo.nosugerencias = true;
    else for(let ind = 0; ind < resultados.suggestions.length; ind++)sinfo.sugerencias.push({
        'id': resultados.suggestions[ind].payload,
        'name': resultados.suggestions[ind].term // la sugerencia
    });
    // muestro sugerencias
    let cont = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$217f5a5fe852abe6), sinfo);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugelugares").html(cont);
    // handler de los botones de sugerencias de lugares
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".bot_suge_lugar").click(async function() {
        // obtengo id de la sugerencia
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).attr("id");
        // pedimos la información del lugar
        const datos = await (0, $ffd94e1d81f19b1c$export$c398d137cd63b259).getDocument(id);
        // si hay algo, vamos al primero
        if (datos.response.numFound > 0) $d1e0875cf0f68e21$var$seleccionarLugar(datos.response.docs[0]);
    });
    // inicializo focus
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarfocus = -1;
}
///////////////
// AJUSTE FOCUS
function $d1e0875cf0f68e21$export$41334320f2c99869() {
    // Sesion.lugarfocus = 0; => cajetín entrada
    // Sesion.lugarfocus = i; => num de sugerencia
    // obtengo número de sugerencias
    const ns = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugelugares").children(":enabled").length;
    // reajusto índice del focus si hace falta
    if (ns == 0) (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarfocus = -1;
    else if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarfocus >= ns) (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarfocus = 0;
    else if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarfocus < 0) (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarfocus = ns - 1;
    // y ahora las cosas visuales
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugelugares").children().removeClass("active");
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarfocus >= 0) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugelugares").children().eq((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarfocus).addClass("active");
}
////////////////////
// SELECCIONAR LUGAR
function $d1e0875cf0f68e21$var$seleccionarLugar(lugar) {
    // obtengo la etiqueta de idioma apropiada
    const lab = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).solrConfig.labels);
    // pongo nombre	en la entrada
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#in_lugares").val(lugar[lab]);
    // escondo la lista de sugerencias
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugelugares").addClass("d-none");
    // inicializo focus
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarfocus = -1;
    // si había marcador de lugar, lo quito
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarmarker != null) (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarmarker.remove();
    // pongo tooltip y marcador en el lugar
    let tooltip = '<strong>' + lugar[lab] + '</strong>';
    // coordenadas
    const coords = [
        lugar.lat,
        lugar.long
    ];
    // pongo marcador
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarmarker = L.marker(coords, {
        icon: (0, $7b115b3c2cee4b53$export$b839616475ae6ec3)()
    }).bindTooltip(tooltip).addTo((0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee));
    /*
	// pongo tooltip y marcador en el lugar
	let tooltip = '<strong>'+lugar.name+'</strong>';
	// pongo el tipo de lugar
	tooltip += '<br>' + getLiteral(dict[lugar.feature_code]);
	// población
	if (lugar.population > 0)
		tooltip += '<br>'+getLiteral(dict.population)+': '+Number(lugar.population).toLocaleString();
	// coordenadas
	const coords = [lugar.latitude, lugar.longitude];
	// pongo marcador
	Sesion.lugarmarker = L.marker(coords, {icon: Iconos.lugar})
		.bindTooltip(tooltip)
		.addTo(Mimapa);*/ // guardo lugar en la sesión (para poder hacer un zoom si se pulsa intro en la entrada)
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugar = lugar;
    // mando evento de selección de lugar a GA
    (0, $067277e156f7a571$export$7329bcdc3edcd90e)('select_content', {
        content_type: 'place_selection',
        content_id: lugar[lab]
    });
    // navegamos al municipio
    (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).flyTo(coords, (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zLugar, {
        animate: true,
        duration: 1
    });
}




function $1ee989753a15371d$export$fa0799b379eb3758(types) {
    if (!types) return undefined;
    // inicializaciones
    let suri = undefined;
    let nexpuris = null;
    // convierto en array si hace falta
    let arsp = Array.isArray(types) ? types : [
        types
    ];
    // evalúo cada uno de los tipos disponibles
    for (let evtype of arsp){
        if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[evtype] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[evtype].expuris) // aquí tengo uno válido, miro si es mejor que lo que tenía
        {
            if (nexpuris == null || (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[evtype].expuris.length < nexpuris) {
                suri = evtype;
                nexpuris = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[evtype].expuris.length;
            }
        }
    }
    // devuelvo suri
    return suri;
}
function $1ee989753a15371d$export$d67e2296dd6db17d() {
    // guardo valor (en memoria y en local storage para recordarlo entre sesiones)
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).nomci = this.checked;
    localStorage.setItem('nomci', (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).nomci); // guardará "true" o "false"
    // ajusto todos los switches de nombres científicos desactivando
    // los change listeners de manera temporal (gracias, chatGPT)
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('.nomci').off('change').prop('checked', (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).nomci).on('change', $1ee989753a15371d$export$d67e2296dd6db17d);
    // renderizado taxón (formularios)
    $1ee989753a15371d$export$5dba38aff426bd77();
    // etiqueta filtro de taxón (panel del mapa)
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon) {
        // pongo etiqueta
        const label = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).nomci ? '<i>' + (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon].scientificName)) + '</i>' : (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon].vulgarName, (0, $96abbdd7193a3c4b$export$56b19e10c1699553)((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon)));
        const et = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).filtering) + ' <strong>' + label + '</strong>';
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#div_label_filtro_taxon").html(et);
    }
    // ¡hay que cambiar el valor de todo!
    // cambio las etiquetas de todas las especies en la lista
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".taxones_block").find("[spuri]").each(function() {
        // obtengo la especie
        const spuri = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).attr("spuri");
        // nombre vulgar y científico
        const nvul = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[spuri] ? (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[spuri].vulgarName, (0, $96abbdd7193a3c4b$export$56b19e10c1699553)(spuri))) : (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$56b19e10c1699553)(spuri));
        const ncie = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[spuri] ? '<i>' + (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[spuri].scientificName, nvul)) + '</i>' : '<i>' + nvul + '</i>';
        // hago reemplazo en el markup del botón
        const oldmarkup = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).html();
        const newmarkup = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).nomci ? oldmarkup.replace(nvul, ncie) : oldmarkup.replace(ncie, nvul);
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).html(newmarkup);
    });
    // en teselas actualizo los popups
    //ajustarCursorPopupsTeselas(Object.keys(Sesion.tessPintadas));
    // en el mapa actualizo tooltips ifntrees y popups de edutrees (según el modo edición)
    for(const turi in (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados){
        // ajuste popup según modo edición
        (0, $82a71c896f160eac$export$1f29254b983d0b7)(turi);
        // tooltip sólo para ifntrees
        if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[turi].uri) {
            const tooltip = (0, $82a71c896f160eac$export$924c9d361ba12beb)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[turi]);
            (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados[turi].bindTooltip(tooltip);
        }
    }
    // si hay minimapa pongo tooltips a todos los árboles
    if ((0, $27fe9e683b34e1a0$export$c37f872725571dfc) && (0, $27fe9e683b34e1a0$export$c37f872725571dfc).arbsPintados) for(const turi in (0, $27fe9e683b34e1a0$export$c37f872725571dfc).arbsPintados)(0, $27fe9e683b34e1a0$export$c37f872725571dfc).arbsPintados[turi].bindTooltip((0, $82a71c896f160eac$export$924c9d361ba12beb)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[turi]));
    if ((0, $3a9989d46007ef73$export$c37f872725571dfc) && (0, $3a9989d46007ef73$export$c37f872725571dfc).arbsPintados) for(const turi in (0, $3a9989d46007ef73$export$c37f872725571dfc).arbsPintados)(0, $3a9989d46007ef73$export$c37f872725571dfc).arbsPintados[turi].bindTooltip((0, $82a71c896f160eac$export$924c9d361ba12beb)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[turi]));
}
////////////////////////////////
// VISUALIZACIÓN FILTRO TAXÓN (modo mapa)
// sólo se llama desde cargarURL
////////////////////////////////
function $1ee989753a15371d$export$99e344fe0d6549db() {
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon == undefined) // escondo el contenido
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#filtro_taxon").addClass("d-none");
    else {
        // pongo etiqueta
        const label = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).nomci ? '<i>' + (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon].scientificName)) + '</i>' : (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon].vulgarName, (0, $96abbdd7193a3c4b$export$56b19e10c1699553)((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon)));
        const et = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).filtering) + ' <strong>' + label + '</strong>';
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#div_label_filtro_taxon").html(et);
        // si hay info de wikidata hago visible el botón de info
        if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon].wikidata) {
            // incluyo uri de la especie
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#bot_info_filtro_taxon").attr("turi", (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon);
            // incluyo uri de DBpedia
            //$("#bot_info_filtro_taxon").attr("dbr", Datos.especies[Sesion.estado.taxon].dbpedia);
            // quito popover que hubiera
            //$("#bot_info_filtro_taxon").popover('dispose');	TODO: comprobar que esto no vale
            // botón de info visible
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#bot_info_filtro_taxon").removeClass("d-none");
        } else (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#bot_info_filtro_taxon").addClass("d-none");
        // hago visible el filtro
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#filtro_taxon").removeClass("d-none");
    }
}
////////////////////////////////////
// VISUALIZACIÓN TAXÓN (formulario)
////////////////////////////////////
function $1ee989753a15371d$export$5dba38aff426bd77() {
    // actualizo todas las entradas de clase taxón
    let $taxonInputs = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('input').filter('.taxon');
    $taxonInputs.each(function() {
        // cojo el botón de la dbpedia de este elemento (puede no existir)
        const $dbbut = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).siblings('.dbpedia');
        // cojo el botón de delete de este elemento (puede no existir)
        const $delbut = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).siblings('.delete');
        // obtengo uri del taxón	
        let turi = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).attr("iri");
        // preparo etiqueta
        const label = turi ? (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[turi] ? (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).nomci ? (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[turi].scientificName)) : (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[turi].vulgarName, (0, $96abbdd7193a3c4b$export$56b19e10c1699553)(turi))) : (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$56b19e10c1699553)(turi)) : "";
        // ajusto itálica	
        if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).nomci) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).attr("style", "font-style:italic");
        else (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).removeAttr("style");
        // pongo etiqueta
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).val(label);
        // muestro o escondo el botón de borrar
        if ($delbut) {
            if (turi) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#deleteTreeTaxon").removeClass("d-none");
            else (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#deleteTreeTaxon").addClass("d-none");
        }
        // trato con el botón de info de taxón a dbpedia
        if ($dbbut) {
            $dbbut.off("click"); // desactivo handlers previos
            // muestro o escondo el botón 
            if (turi && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[turi] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[turi].wikidata) {
                // incluyo uri de la especie
                $dbbut.attr("turi", turi);
                // quito popover que hubiera
                //$dbbut.popover('dispose');	TODO: comprobar que esto no vale
                // botón de info visible
                $dbbut.removeClass("d-none");
                // handler del popover taxón con info de DBpedia
                $dbbut.click($1ee989753a15371d$export$2c4bbd56989782d8);
            } else $dbbut.addClass("d-none");
        }
    });
}
//////////////////////////
// HANDLER setTreeTaxon (modo formulario)
// el handler está puesto directamente en el formulario creationEducatreeForm
function $1ee989753a15371d$export$2d3916a1f0ae58c1() {
    // obtengo nuevo estado del botón
    const activar = !(0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#setTreeTaxonEd").hasClass("active");
    // pongo el botón activo o no
    if (activar) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#setTreeTaxonEd").addClass("active");
    else (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#setTreeTaxonEd").removeClass("active");
    // render de la selección de taxón
    $1ee989753a15371d$var$renderSeleccionTaxon(activar, true);
}
//////////////////////////
// HANDLER deleteTreeTaxon (modo formulario)
function $1ee989753a15371d$export$e644c8daeec4ef49() {
    // borro iri y lanzo evento de "change" para poder hacer validación en las anotaciones
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#inputTreeTaxonEd").removeAttr("iri").trigger('change');
    // visualizo y a volar
    $1ee989753a15371d$export$5dba38aff426bd77();
}
//////////////////////////
// HANDLER FILTRAR TAXÓN (modo mapa)
function $1ee989753a15371d$export$79e952b071e79fc8() {
    // obtengo nuevo estado del botón
    const activar = !(0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#bot_taxones").hasClass("active");
    // pongo el botón activo o no
    if (activar) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#bot_taxones").addClass("active");
    else (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#bot_taxones").removeClass("active");
    // render de la selección de taxón
    $1ee989753a15371d$var$renderSeleccionTaxon(activar);
}
//////////////////////////
// RENDER SELECCIÓN TAXÓN
function $1ee989753a15371d$var$renderSeleccionTaxon(activar, esformulario) {
    // RENDER ENTRADA LUGARES (para que no interfiera)
    if (!esformulario) (0, $d1e0875cf0f68e21$export$24073cf807c9abc3)(!activar);
    // selecciono los divs apropiados según el modo
    const $divbus = esformulario ? (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#taxones_subheading_newtree") : (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#taxones_subheading");
    const $divnav = esformulario ? (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#taxones_block_newtree") : (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#taxones_block");
    // BÚSQUEDA CON ENTRADA DE TEXTO Y SUGERENCIAS DE TIPOS DE SITIOS
    if (activar) {
        // rendering del subheading
        const content = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$900677b7c5ee40b7), {
            'activar': activar,
            'esformulario': esformulario
        });
        $divbus.html(content);
        $divbus.removeClass("d-none");
        // listener de handlerImportTaxon
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#importTaxonButton").click($1ee989753a15371d$var$handlerImportTaxon);
        // handler de buscar taxon...
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".in_taxon").on("keyup search", function(e) {
            //console.log("Caracter: " + e.which);
            // trato las teclas de arriba, abajo y enter			
            if (e.which == 13) {
                // actúo según el focus
                if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txfocus == -1) // si hay al menos una sugerencia (y habilitada) voy a la primera
                {
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".sugetaxones").children(":enabled").length > 0) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".sugetaxones").children(":enabled").eq(0).click();
                } else (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".sugetaxones").children().eq((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txfocus).click();
            } else if (e.which == 40) {
                // incremento focus
                (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txfocus++;
                $1ee989753a15371d$var$ajustarTaxonfocus();
            } else if (e.which == 38) {
                // decremento focus
                (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txfocus--;
                $1ee989753a15371d$var$ajustarTaxonfocus();
            } else {
                const entrada = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).val();
                // analizo la cadena de entrada
                if (entrada.length < 1) {
                    $divnav.removeClass("d-none");
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".sugetaxones").html("");
                } else {
                    $divnav.addClass("d-none");
                    // obtengo sugerencias de tipos de sitios
                    const suges = $1ee989753a15371d$var$sugeTaxones(entrada);
                    // renderizo las sugerencias
                    $1ee989753a15371d$var$renderSugeTaxones(entrada, suges);
                }
            }
        });
    } else $divbus.addClass("d-none");
    // NAVEGACIÓN ONTOLOGÍA DE TIPOS
    if (activar) {
        $divnav.removeClass("d-none");
        // ¿caso inicial?
        if ($divnav.html() == "") {
            // preparo datos para mostrar
            let btaxainfo = [];
            // analizo los taxones top
            for (const spuri of (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).especiesTop){
                // obtengo información del objeto para formatear
                let spinfo = $1ee989753a15371d$var$getInfoSpecies(spuri);
                // incluyo también el indice
                spinfo.indice = 0;
                spinfo.indentspace = '';
                // añado
                btaxainfo.push(spinfo);
            }
            // sort elements
            btaxainfo = (0, $2q7Wm.default).sortBy(btaxainfo, 'label').reverse();
            //btaxainfo = _.sortBy(btaxainfo, function(el) { return (+el.nclasses*100 + +el.allindivs); });
            btaxainfo = (0, $2q7Wm.default).sortBy(btaxainfo, "score");
            btaxainfo = btaxainfo.reverse();
            // generate the mark-up
            const content = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$502b32cc8ed2e37e), btaxainfo);
            // pongo el contenido
            $divnav.html(content);
            // HANDLERS
            // handler de seleccionar taxón
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".bot_sel_taxon").click($1ee989753a15371d$var$handlerSeleccionarTaxon);
            // handler de expandir taxón
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".bot_expandir_taxon").click($1ee989753a15371d$var$handlerExpandTaxon);
            // handler de showmore
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".showmore").click($1ee989753a15371d$var$handlerShowmore);
        } else $divnav.removeClass("d-none");
    } else $divnav.addClass("d-none");
}
//////////////////////
// HANDLER SUGERENCIAS
//////////////////////
function $1ee989753a15371d$var$sugeTaxones(entrada) {
    let sugerencias = [];
    // sólo actúo si la entrada no es una cadena vacía
    if (entrada.length > 0) {
        // obtengo las uris de las especies ordenadas alfabéticamente
        const espuris = Object.keys((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies).sort();
        // evalúo cada especie si vale
        for (let espuri of espuris){
            // primero veo si descarto la especie: : sólo considero si tiene datos de wikidata y UN NOMBRE CIENTÍFICO DIFERENTE AL DEL PADRE
            let descarte = false;
            if (!(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[espuri].wikidata) descarte = true;
            else {
                for (let supiri of (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[espuri].superclasses)if ((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[supiri].scientificName) === (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[espuri].scientificName)) descarte = true;
            }
            if (!descarte) {
                // obtengo etiqueta de la especie (por defecto nombre vulgar)
                let labesp = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[espuri].vulgarName, (0, $96abbdd7193a3c4b$export$56b19e10c1699553)(espuri));
                // si hay nombre científico...		
                if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).nomci) labesp = (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[espuri].scientificName, labesp));
                // si coincide, a las sugerencias
                if ((0, $96abbdd7193a3c4b$export$bc11d730045994ef)(labesp, entrada) > -1) sugerencias.push(espuri);
            }
        }
    }
    return sugerencias;
}
function $1ee989753a15371d$var$renderSugeTaxones(entrada, sugerencias) {
    // preparo sugerencias
    let sinfo = {};
    sinfo.sugerencias = [];
    // obtengo las sugerencias si la entrada no está vacía
    if (sugerencias.length == 0) sinfo.nosugerencias = true;
    else for (let suge of sugerencias){
        // obtengo información del objeto para formatear
        let spinfo = $1ee989753a15371d$var$getInfoSpecies(suge);
        // índice en el que hubo match
        const ind = (0, $96abbdd7193a3c4b$export$bc11d730045994ef)(spinfo.label, entrada);
        // formateo el nombre a mostrar con negritas
        spinfo.labelshown = "";
        if (ind > 0) spinfo.labelshown += spinfo.label.substr(0, ind);
        spinfo.labelshown += "<strong>" + spinfo.label.substr(ind, entrada.length) + "</strong>";
        spinfo.labelshown += spinfo.label.substr(ind + entrada.length);
        /* siempre se añade
			// añado el objeto SÓLO SI TIENE INDIVIDUOS
			if (spinfo.allindivs > 0)
				sinfo.sugerencias.push(spinfo);*/ sinfo.sugerencias.push(spinfo);
    }
    // ordeno sugerencias por número de individuos y subclases
    //sinfo.sugerencias = _.sortBy(sinfo.sugerencias, function(el) { return (+el.nclasses*100 + +el.allindivs); });
    // ordeno por popularidad en Wikidata
    sinfo.sugerencias = (0, $2q7Wm.default).sortBy(sinfo.sugerencias, "score");
    sinfo.sugerencias = sinfo.sugerencias.reverse();
    // corto número de sugerencias
    sinfo.sugerencias = sinfo.sugerencias.slice(0, (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).numsugs);
    // muestro sugerencias
    const cont = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$fafd45cc9f2ab26c), sinfo);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".sugetaxones").html(cont);
    // handler de los botones de sugerencias
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".bot_suge_taxon").click($1ee989753a15371d$var$handlerSeleccionarTaxon);
    // inicializo focus
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txfocus = -1;
}
function $1ee989753a15371d$var$ajustarTaxonfocus(esWD) {
    const idel = esWD ? "#sugetaxonesWD" : ".sugetaxones";
    // Sesion.txfocus = 0; => cajetín entrada
    // Sesion.txfocus = i; => num de sugerencia
    // obtengo número de sugerencias que no están deshabilitadas
    const ns = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(idel).children(":enabled").length;
    //if (ns == 1 && $("#sugetaxones").children().eq(0)  )// corrección por si no es una sugerencia real
    // reajusto índice del focus si hace falta
    if (ns == 0) (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txfocus = -1;
    else if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txfocus >= ns) (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txfocus = 0;
    else if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txfocus < 0) (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txfocus = ns - 1;
    // y ahora las cosas visuales
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(idel).children().removeClass("active");
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txfocus >= 0) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(idel).children().eq((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txfocus).addClass("active");
}
/////////////////////////////
// HANDLER NAVEGACIÓN TAXONES
/////////////////////////////
function $1ee989753a15371d$var$handlerExpandTaxon() {
    // obtengo i para el icono
    let $i = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).find("i");
    let $div = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).closest(".taxon");
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass("active")) {
        // desactivo botón
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).removeClass("active");
        // pongo otro icono
        $i.removeClass("bi-chevron-down");
        $i.addClass("bi-chevron-right");
        // itero para quitar los elementos de la lista
        const indice = +$div.attr("indice");
        do {
            var $nextdiv = $div.next();
            var fin = true;
            if (+$nextdiv.attr("indice") > indice) {
                $nextdiv.remove();
                fin = false;
            }
        }while (!fin);
    } else {
        // activo botón
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).addClass("active");
        // pongo otro icono
        $i.removeClass("bi-chevron-right");
        $i.addClass("bi-chevron-down");
        // get uri of the class and prepare indentspace
        const spuri = $div.find(".bot_sel_taxon").attr("spuri");
        const newindice = +$div.attr("indice") + 1;
        let indentspace = "";
        for(let ind = 0; ind < newindice; ind++)indentspace += "&nbsp;&nbsp;&nbsp;&nbsp;";
        // generate aux object for the template
        let scobj = [];
        for (let subspuri of (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[spuri].subclasses){
            // obtengo información del objeto para formatear
            let subspinfo = $1ee989753a15371d$var$getInfoSpecies(subspuri);
            // incluyo también el indent
            subspinfo.indice = newindice;
            subspinfo.indentspace = indentspace;
            // sólo inserto si tiene datos de wikidata y UN NOMBRE CIENTÍFICO DIFERENTE AL DEL PADRE
            if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[subspuri].wikidata && (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[subspuri].scientificName) !== (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[spuri].scientificName)) scobj.push(subspinfo);
        }
        // sort elements
        scobj = (0, $2q7Wm.default).sortBy(scobj, 'label').reverse();
        //scobj = _.sortBy(scobj, function(el) { return (+el.nclasses*100 + +el.allindivs); });
        scobj = (0, $2q7Wm.default).sortBy(scobj, "score");
        scobj = scobj.reverse();
        // show more button
        if (scobj.length > (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).hidemax) {
            // include fake element for the button
            scobj.splice((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).hidebegin, 0, {
                "botonesconder": true,
                "indice": newindice,
                "indentspace": indentspace + "&nbsp;&nbsp;&nbsp;&nbsp;"
            });
            for(let ind = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).hidebegin + 1; ind < scobj.length; ind++)scobj[ind].esconder = true;
        }
        // generate content and add	to the DOM
        const newcontent = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$502b32cc8ed2e37e), scobj);
        $div.after(newcontent);
        // handler de seleccionar taxón
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".bot_sel_taxon").off('click');
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".bot_sel_taxon").click($1ee989753a15371d$var$handlerSeleccionarTaxon);
        // recreate handlers of the expand/collapse buttons
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".bot_expandir_taxon").off('click');
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".bot_expandir_taxon").click($1ee989753a15371d$var$handlerExpandTaxon);
        // recreate handlers of the showmore buttons
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".showmore").click($1ee989753a15371d$var$handlerShowmore);
    }
}
function $1ee989753a15371d$var$handlerShowmore() {
    let $div = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).closest(".taxon");
    const indice = +$div.attr("indice");
    // show elements
    let $aux = $div;
    let fin;
    do {
        $aux = $aux.next();
        fin = true;
        if (+$aux.attr("indice") == indice && $aux.hasClass("d-none")) {
            $aux.removeClass("d-none");
            $aux.addClass("d-flex");
            fin = false;
        }
    }while (!fin);
    // remove show more button
    $div.remove();
}
// para formatear las especies
function $1ee989753a15371d$var$getInfoSpecies(spuri) {
    // recupero especie
    const sp = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[spuri];
    // el objeto a devolver
    let spinfo = {};
    // incluyo la uri
    spinfo.uri = spuri;
    // por defecto nombre vulgar
    spinfo.label = (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(sp.vulgarName, (0, $96abbdd7193a3c4b$export$56b19e10c1699553)(spuri)));
    // si hay nombre científico...		
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).nomci) {
        spinfo.nc = true;
        spinfo.label = (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(sp.scientificName, spinfo.label));
    }
    // info número de clases
    spinfo.nclasses = 0;
    for (let suburi of (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[spuri].subclasses)// sólo inserto si tiene datos de wikidata y UN NOMBRE CIENTÍFICO DIFERENTE AL DEL PADRE
    if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[suburi] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[suburi].wikidata && (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[suburi].scientificName) !== (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[spuri].scientificName)) spinfo.nclasses++;
    if (spinfo.nclasses == 0) spinfo.nosubclasses = true;
    // calculo el score
    spinfo.score = 0;
    if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[spuri].wikidata && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[spuri].wikidata.sitelinks) spinfo.score += 3 * +(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[spuri].wikidata.sitelinks;
    if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[spuri].wikidata && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[spuri].wikidata.statements) spinfo.score += +(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[spuri].wikidata.statements;
    // devuelvo el objeto
    return spinfo;
}
//////////////////////////
// HANDLER SELECCIÓN TAXÓN (común a mapa y formulario)
//////////////////////////
function $1ee989753a15371d$var$handlerSeleccionarTaxon() {
    // obtengo uri del taxon
    const turi = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).attr("spuri");
    // vamos a la selección del taxón
    $1ee989753a15371d$export$17cdb3d0a52387b4(turi);
    // click en botón de seleccionar taxón para cerrar el panel correspondiente
    let $bot = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#bot_taxones");
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.path === 'newtree' || (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.path === 'tree') $bot = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#setTreeTaxonEd");
    $bot.click();
}
function $1ee989753a15371d$export$17cdb3d0a52387b4(turi) {
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.path === 'newtree' || (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.path === 'tree') {
        // guardo IRI y lanzo evento de "change" para poder hacer validación en las anotaciones
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#inputTreeTaxonEd").attr("iri", turi).trigger('change');
        // renderizado
        $1ee989753a15371d$export$5dba38aff426bd77();
    } else {
        // mando evento de filtro de taxón a GA		
        (0, $067277e156f7a571$export$7329bcdc3edcd90e)('select_content', {
            content_type: 'taxon_filter',
            content_id: turi
        });
        // pongo el taxón en la sesión y reajusto URL
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon = turi;
        history.replaceState((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado, "", (0, $ffd94e1d81f19b1c$export$e5c8c113a1c69275)());
        // cargo la URL
        (0, $ffd94e1d81f19b1c$export$db4341b92d8f97b0)();
    }
}
/////////////////////
// HANDLER INFO TAXÓN
/////////////////////
function $1ee989753a15371d$export$2c4bbd56989782d8() {
    // obtengo uri del taxón
    const turi = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).attr("turi");
    // 2023-11 ahora siempre tengo la info a mostrar del taxón, no hay que pedirla al vuelo
    // objeto taxón
    let taxon = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[turi];
    // preparo objeto del modal
    let popobj = {};
    /* previo
	// imagen
	if (taxon.wikidata.image) {
		popobj.hayimagen = true;
		let imgsaux = Array.isArray(taxon.wikidata.image)? taxon.wikidata.image : [ taxon.wikidata.image ];
		popobj.image = [];
		let first = true;
		for (let img of imgsaux) {
			// ajusto tamaño para que tarde menos en recuperarla
			const imgsrc = (img.startsWith('http://commons.wikimedia.org/wiki/Special:FilePath') && img.indexOf('?') === -1 )?
				img + "?width=300" : img;
			popobj.image.push( { src: imgsrc, active: first})
			first = false;
		}
		if (popobj.image.length == 1)
			popobj.image = popobj.image[0].src;
		else
			popobj.multimages = true;
	}
	// resumen
	if (taxon.wikidata.comment)
		popobj.resumen = getLiteral(taxon.wikidata.comment);*/ // imagen
    if (taxon.images != null && taxon.images.length > 0) {
        popobj.hayimagen = true;
        if (taxon.images.length == 1) popobj.image = taxon.images[0];
        else {
            popobj.multimages = true;
            const randomIndex = Math.floor(Math.random() * taxon.images.length);
            popobj.image = taxon.images.map((img, index)=>{
                return {
                    src: img,
                    active: index === randomIndex
                };
            });
        }
    }
    // resumen
    if (taxon.extract) popobj.resumen = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(taxon.extract);
    // nombre científico
    const label = (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(taxon.vulgarName, (0, $96abbdd7193a3c4b$export$56b19e10c1699553)(turi)));
    popobj.nomci = (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(taxon.scientificName, label));
    // gbifPage
    if (taxon.wikidata && taxon.wikidata.gbifPage) popobj.gbifPage = taxon.wikidata.gbifPage;
    // wikidataPage
    if (taxon.wikidata) popobj.wikidataPage = taxon.wikidata.iri;
    // wikipediaPage
    if (taxon.wikipedia) popobj.wikipediaPage = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(taxon.wikipedia);
    //if (taxon.wikipediaPage)
    //	popobj.wikipediaPage = taxon.wikipediaPage;
    // wikispeciesPage
    if (taxon.wikispeciesPage) popobj.wikispeciesPage = taxon.wikispeciesPage;
    // indico tipo: especie, género, familia o clase
    if (taxon.nivel == 0) popobj.tipo = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).species);
    else if (taxon.nivel == 1) popobj.tipo = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).genus);
    else if (taxon.nivel == 2) popobj.tipo = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).family);
    else if (taxon.nivel == 3) popobj.tipo = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).class);
    // preparo contenido modal
    let tit = '<i>' + popobj.nomci + '</i>';
    let htmlcontent = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$1cfea2c3e1d7bf94), popobj);
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        lg: true,
        nofooter: true
    }, tit, htmlcontent, null);
    // muestro modal
    const mimodal = new (0, (/*@__PURE__*/$parcel$interopDefault($dktVJ))).Modal(document.getElementById('mimodal'));
    mimodal.show();
    // mando evento de info taxón a GA		
    (0, $067277e156f7a571$export$7329bcdc3edcd90e)('select_content', {
        content_type: 'infoTaxon',
        content_id: turi
    });
}
/////////////////////
// HANDLER IMPORT TAXÓN
/////////////////////
// 2023-11-1 NUEVO
function $1ee989753a15371d$var$handlerImportTaxon() {
    // inicialización modal con su body y todo
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        static: true,
        vertcent: true
    }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).importtaxon), (0, $646ceeeec66fabd8$export$43bbd40c30a74965).importTaxon, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).importarTaxon);
    // muestro el modal sólo en modo newtree
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.path === "newtree") {
        const mimodal = new (0, (/*@__PURE__*/$parcel$interopDefault($dktVJ))).Modal(document.getElementById('mimodal'));
        mimodal.show();
    }
    // (en modo anotación ya lo tengo abierto y no hay que mostrarlo)
    // listener de importar
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botimporttaxonwikidata").click($1ee989753a15371d$var$importTaxon);
    // detecto cambios en la entrada de importar taxón
    // "search" es para detectar si el usuario hizo click en la X del formulario (clear button)
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#in_importTaxon").on("keyup search", async function(e) {
        // trato las teclas de arriba, abajo y enter			
        if (e.which == 13) // sólo actúo si hay al menos una sugerencia (y habilitada)
        {
            if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugetaxonesWD").children(":enabled").length > 0) {
                // si no había ninguna sugerencia seleccionada activo la primera
                if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txfocus == -1) {
                    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txfocus = 0;
                    $1ee989753a15371d$var$ajustarTaxonfocus(true);
                }
                // y ahora vamos al taxón seleccionado
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugetaxonesWD").children(":enabled").eq((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txfocus).click();
            }
        } else if (e.which == 40) {
            // incremento focus
            (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txfocus++;
            $1ee989753a15371d$var$ajustarTaxonfocus(true);
        } else if (e.which == 38) {
            // decremento focus
            (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txfocus--;
            $1ee989753a15371d$var$ajustarTaxonfocus(true);
        } else if (e.which != undefined) {
            // actúo según la entrada
            const entrada = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).val();
            if (entrada.length == 0) {
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugetaxonesWD").html("");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugetaxonesWD").addClass("d-none");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusImportTaxon").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).typesomething));
            } else if (entrada.length < 3) {
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugetaxonesWD").html("");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugetaxonesWD").addClass("d-none");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusImportTaxon").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).typesomethingmore));
            } else {
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugetaxonesWD").removeClass("d-none");
                //const sugtaxones = await 
                $1ee989753a15371d$var$obtenerSugerenciasTaxonesWD(entrada);
                // mando evento GA si la entrada > 2
                if (entrada.length > 2) (0, $067277e156f7a571$export$7329bcdc3edcd90e)('search', {
                    search_term: entrada,
                    content_type: "taxons"
                });
            }
        } else {
            // caso de la X del formulario... (quito las sugerencias)
            let entrada = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).val();
            if (entrada.length == 0) {
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugetaxonesWD").html("");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugetaxonesWD").addClass("d-none");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusImportTaxon").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).typesomething));
            }
        }
    }).focusin(function() {
        // vuelve el focus, muestro las sugerencias si hay algo
        let entrada = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).val();
        if (entrada.length > 2) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugetaxonesWD").removeClass("d-none");
    }).focusout(function() {
        // si pierde el focus escondemos las sugerencias tras un delay
        // el delay es importante para que se pueda clickar un botón antes de eliminar las sugerencias
        setTimeout(function() {
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#in_importTaxon").is(":focus")) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugetaxonesWD").addClass("d-none");
        }, 300);
    });
    // handler del botón "clearImportTaxon"
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#clearImportTaxon").click(function() {
        // reajusto tamaño del diálogo
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
            static: true,
            vertcent: true
        });
        // quito el taxón del textbox 
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#in_importTaxon").val("").attr('wdiri', '').prop('disabled', false);
        // habilito y escondo botón "clearImportTaxon"
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#clearImportTaxon").addClass("d-none");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusImportTaxon").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).typesomething));
        // escondo datos del taxón mostrado		
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#infoTaxonImportar").addClass("d-none");
    });
}
async function $1ee989753a15371d$var$obtenerSugerenciasTaxonesWD(entrada) {
    // inicialización API de búsqueda de texto de Wikidata
    const otwd = {
        lang: (0, $96abbdd7193a3c4b$export$350964a2fface462)(),
        limit: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).limitWD,
        input: entrada
    };
    const urlpet = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).tempTextWD, otwd);
    // spinner y mensaje
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#spinnerImport").removeClass("d-none");
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusImportTaxon").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).obtainingtaxons));
    try {
        // pido sugerencias a la API de texto de Wikidata		
        if (!(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).urlAPIWD[urlpet]) {
            console.debug(urlpet);
            const response = await fetch(urlpet);
            (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).urlAPIWD[urlpet] = await response.json();
        }
        let datos = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).urlAPIWD[urlpet];
        // pido los taxones válidos al punto SPARQL de WD y consolido datos
        const taxons = await (0, $174d363c054274ef$export$ad969a5713b03ee4)(datos.search);
        // sólo sigo si coincide la entrada del cajetín de texto con entrada
        const entcaj = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#in_importTaxon").val();
        if (entrada === entcaj) {
            // preparo array de resultados con la respuesta
            let resultados = [];
            for (let tx of taxons){
                let res = (0, $2q7Wm.default).clone((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[tx]);
                // le meto un score para el sorting
                res.score = 3 * (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[tx].sitelinks + +(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[tx].statements;
                // extra de 300 si es una especie (la detecto porque el nombre tiene dos términos en vez de uno de género o familia)
                if (res.label.split(" ").length == 2) res.score += 300;
                // incluyo en los resultados
                resultados.push(res);
            }
            // ordeno resultados y aplico límite
            resultados = (0, $2q7Wm.default).sortBy(resultados, 'score').reverse();
            resultados = resultados.slice(0, (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).numsugs);
            // compruebo heurístico de escribir más para desambiguar
            const heurTypeMore = entcaj.length < 5 && datos.search.length == (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).limitWD;
            // visualizo			
            $1ee989753a15371d$var$renderSugerenciasTaxonesWD(resultados, heurTypeMore);
        }
    } catch (error) {
        console.error('Error fetching data: ', error);
    }
}
function $1ee989753a15371d$var$renderSugerenciasTaxonesWD(resultados, heurTypeMore) {
    // quito spinner
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#spinnerImport").addClass("d-none");
    // objeto sugerencias
    let sinfo = {};
    sinfo.sugerencias = [];
    // formateo las sugerencias
    if (resultados.length == 0) {
        sinfo.nosugerencias = true;
        if (heurTypeMore) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusImportTaxon").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).typesomethingmore));
        else (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusImportTaxon").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tryanotherstring));
    } else {
        for (let res of resultados)sinfo.sugerencias.push({
            'title': res.label,
            'desc': res.description,
            'wdiri': res.iri
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusImportTaxon").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).selectataxon));
    }
    // muestro sugerencias
    let cont = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$cbaf9c974071f389), sinfo);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugetaxonesWD").html(cont);
    // handler de los botones de sugerencias de taxones
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".bot_suge_taxonWD").click(async function() {
        // extraigo el taxón
        const wdiri = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).attr("wdiri");
        // pongo el taxón en el textbox, incluyo wdiri, deshabilito, muestro botón "clearImportTaxon" y quito sugerencias
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#in_importTaxon").val((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[wdiri].label).attr('wdiri', wdiri).prop('disabled', true);
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#clearImportTaxon").removeClass("d-none");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugetaxonesWD").html("");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugetaxonesWD").addClass("d-none");
        // spinner y mensaje
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#spinnerImport").removeClass("d-none");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusImportTaxon").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).obtainingtaxondata));
        // consigo datos del taxón (si no está)
        try {
            await (0, $174d363c054274ef$export$2389aabfa4796a70)(wdiri);
        } catch (err) {
            console.error(err.message);
            // actualizo modal
            const be = "<code>" + err.message + "<br>" + JSON.stringify(err.error) + "</code>";
            (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
                static: true,
                vertcent: true
            }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).taxonimportingerror), be, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).anotacionError);
            return; // terminamos
        }
        // spinner y mensaje
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#spinnerImport").addClass("d-none");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusImportTaxon").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).readytoimport));
        // preparo info del taxón para visualizar
        const txWD = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[wdiri];
        let popobj = {};
        /* previo
		// imagen
		if (txWD.image) {
			popobj.hayimagen = true;
			let imgsaux = Array.isArray(txWD.image)? txWD.image : [ txWD.image ];
			popobj.image = [];
			let first = true;
			for (let img of imgsaux) {
				const imgsrc = (img.startsWith('http://commons.wikimedia.org/wiki/Special:FilePath') && img.indexOf('?') === -1 )?
					img + "?width=300" : img;
				popobj.image.push( { src: imgsrc, active: first})
				first = false;
			}
			if (popobj.image.length == 1)
				popobj.image = popobj.image[0].src;
			else
				popobj.multimages = true;
		}
		// resumen
		if (txWD.comment)
			popobj.resumen = getLiteral(txWD.comment);*/ // imagen
        if (txWD.images != null && txWD.images.length > 0) {
            popobj.hayimagen = true;
            if (txWD.images.length == 1) popobj.image = txWD.images[0];
            else {
                popobj.multimages = true;
                const randomIndex = Math.floor(Math.random() * txWD.images.length);
                popobj.image = txWD.images.map((img, index)=>{
                    return {
                        src: img,
                        active: index === randomIndex
                    };
                });
            }
        }
        // resumen
        if (txWD.extract) popobj.resumen = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(txWD.extract);
        // nombre científico
        const label = (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(txWD.vulgarName, (0, $96abbdd7193a3c4b$export$56b19e10c1699553)(wdiri)));
        popobj.nomci = (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(txWD.scientificName, label));
        // wikidataPage
        popobj.wikidataPage = wdiri;
        // wikipediaPage
        if (txWD.gbifPage) popobj.gbifPage = txWD.gbifPage;
        // wikipediaPage
        //if (txWD.wikipediaPage)
        //	popobj.wikipediaPage = txWD.wikipediaPage;
        if (txWD.wikipedia) popobj.wikipediaPage = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(txWD.wikipedia);
        // wikispeciesPage
        if (txWD.wikispeciesPage) popobj.wikispeciesPage = txWD.wikispeciesPage;
        // indico tipo: especie, género o familia
        if (txWD.isSpecies) popobj.tipo = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).species);
        else if (txWD.family) popobj.tipo = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).genus);
        else popobj.tipo = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).family);
        // renderizo
        let htmlcontent = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$1cfea2c3e1d7bf94), popobj);
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#infoTaxonImportar").html(htmlcontent);
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#infoTaxonImportar").removeClass("d-none");
        // reajusto tamaño del diálogo
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
            static: true,
            vertcent: true,
            lg: true
        });
        // compruebo si existe el taxón
        const txuris = Object.keys((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies);
        const txexiste = (0, $2q7Wm.default).find(txuris, function(txuri) {
            return (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[txuri].wikidata && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[txuri].wikidata.iri === wdiri;
        });
        // si existe, deshabilito el botón de importar, si existe lo habilito
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botimporttaxonwikidata").prop('disabled', !(txexiste == undefined));
        // y si existe, cambio el mensaje adicionalmente
        if (txexiste) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusImportTaxon").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).taxonalreadyimported));
    });
    // inicializo focus
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txfocus = -1;
}
async function $1ee989753a15371d$var$importTaxon() {
    // ACTULIZACIÓN GUI
    // escondo el botón de quitar el taxón
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#clearImportTaxon").addClass("d-none"); //.prop('disabled', true);
    // escondo el contenido de info
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#infoTaxonImportar").addClass("d-none");
    // pongo spinner y mensaje
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#spinnerImport").removeClass("d-none");
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusImportTaxon").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).importingthetaxon));
    // actualizo modal para quitar el footer y ajustar tamaño
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        static: true,
        vertcent: true,
        nofooter: true
    });
    // recupero los datos del recurso de Wikidata a importar
    const wdiri = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#in_importTaxon").attr('wdiri');
    const txWD = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[wdiri];
    // cojo todos los taxones (para comprobar si hay que traer más cosas)	
    const txuris = Object.keys((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies);
    // preparo entradas para crear los objetos
    let entradas = [];
    // cada entrada consta de estos campos: iriWD, txWD, iri, iriPadre, pedir (varias desconocidas)
    // durante varios pasos completaremos estos datos desde arriba (familia) hasta abajo (especie)
    if (txWD.family) entradas.push({
        iriWD: txWD.family
    });
    if (txWD.genus) entradas.push({
        iriWD: txWD.genus
    });
    entradas.push({
        iriWD: wdiri,
        txWD: txWD
    });
    // extraigo los txWD de cada entrada
    // (pediré datos de WD que puede que no necesite, pero es un mal menor => máximo una petición para gen y otra para fam)
    for (let ent of entradas){
        if (!ent.txWD && (!(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[ent.iriWD] || (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[ent.iriWD].pending)) await (0, $174d363c054274ef$export$2389aabfa4796a70)(ent.iriWD);
        if (!ent.txWD) ent.txWD = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[ent.iriWD];
    }
    // aquí ya tengo completo iriWD y txWD en todas, completo resto de campos
    for (let ent of entradas){
        const iri = (0, $2q7Wm.default).find(txuris, function(txuri) {
            return (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[txuri].wikidata && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[txuri].wikidata.iri === ent.iriWD;
        });
        if (iri) ent.pedir = false;
        else {
            // hay que pedir, completo datos en campos restantes
            ent.pedir = true;
            ent.iri = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/taxon/" + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(ent.txWD.scientificName).replace(' ', '_');
            if (!ent.txWD.family) ent.iriPadre = ent.txWD.isConifer ? (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).especiesTop[0] : (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).especiesTop[1];
            else {
                // necesitaré buscar entre las especies a partir de iriPadreWD
                const iriPadreWD = ent.txWD.genus ? ent.txWD.genus : ent.txWD.family;
                ent.iriPadre = (0, $2q7Wm.default).find(txuris, function(txuri) {
                    return (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[txuri].wikidata && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[txuri].wikidata.iri === iriPadreWD;
                });
                if (!ent.iriPadre) {
                    const scPadre = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[iriPadreWD].scientificName;
                    ent.iriPadre = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/taxon/" + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(scPadre).replace(' ', '_');
                }
            }
        }
    }
    // en este punto compruebo que siguen sin existir los taxones a crear 
    // (para evitar que se creen dos veces, aunque esto no debería suponer un problema)
    const irisWDcomprobar = (0, $2q7Wm.default).pluck(entradas, 'iriWD');
    const irisWDexisten = await (0, $174d363c054274ef$export$5e6ebc4b1b859630)(irisWDcomprobar);
    // genero array de objetos con los recursos a crear
    let objetosCrear = [];
    let irisWDCrear = [];
    for (let ent of entradas)if (ent.pedir && !(0, $2q7Wm.default).contains(irisWDexisten, function(iri) {
        return ent.iriWD;
    })) objetosCrear.push($1ee989753a15371d$var$prepareTaxonObjectWD(ent.iri, ent.iriWD, ent.iriPadre));
    // hago las llamadas para crear las especies
    try {
        for (let oc of objetosCrear){
            // inicializo evento de creación de taxón a GA
            (0, $067277e156f7a571$export$639f48199cd2287d)({
                content_type: 'taxon',
                content_id: oc.iri,
                uid: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid,
                crafts_reqs: 0
            });
            // aquí sólo se hace el PUT a CRAFTS, el ajuste de datos se realiza en esta misma función 		
            await (0, $174d363c054274ef$export$f4b4fb77e87b331a)(oc);
            // envío datos creación de la especie a GA			
            (0, $067277e156f7a571$export$6adbd77fe07ba13)("create_content");
            console.info("Tax\xf3n creado con IRI: " + oc.iri); // log
        }
    } catch (err) {
        console.error(err.message);
        // actualizo modal
        const be = "<code>" + err.message + "<br>" + JSON.stringify(err.error) + "</code>";
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
            static: true,
            vertcent: true
        }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).taxonimportingerror), be, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).anotacionError);
        return; // terminamos
    }
    // ya están creados, incluyo nuevos taxones en Datos.especies
    // (esto lo hago incluso si fueron creados por otro usuario en el interlapso)
    for (let ent of entradas)if (ent.pedir) (0, $174d363c054274ef$export$25fe61d80318b90d)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies, ent.iri);
    for (let ent of entradas)if (ent.pedir) {
        //console.log("iri: " + ent.iri + " - iriPadre: " + ent.iriPadre);
        // guardo subclase
        (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[ent.iriPadre].subclasses.push(ent.iri);
        // guardo superclase
        (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[ent.iri].superclasses.push(ent.iriPadre);
        // guardo resto de datos
        (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[ent.iri].scientificName = ent.txWD.scientificName;
        (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[ent.iri].vulgarName = ent.txWD.vulgarName;
        // sept-26: cambios
        //Datos.especies[ent.iri].wikipediaPage = ent.txWD.wikipediaPage;
        (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[ent.iri].wikipedia = ent.txWD.wikipedia;
        (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[ent.iri].images = ent.txWD.images;
        (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[ent.iri].extract = ent.txWD.extract;
        // resto de datos
        (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[ent.iri].wikispeciesPage = ent.txWD.wikispeciesPage;
        (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[ent.iri].wikidata = {
            iri: ent.iriWD,
            //image: ent.txWD.image,
            gbifPage: ent.txWD.gbifPage,
            sitelinks: ent.txWD.sitelinks,
            statements: ent.txWD.statements
        };
    }
    // regenero las especies expandidas
    (0, $174d363c054274ef$export$14ba48f8fbb8469)(true);
    // por último, vuelvo a la tarea anterior
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.path === "newtree") {
        // informo en el diálogo
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusImportTaxon").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).taxonimported));
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#spinnerImport").addClass("d-none");
        // actualizo modal para mostrar el footer
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
            static: true,
            vertcent: true
        }, null, null, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).anotacionError);
        // hago la selección del taxón (por fin)
        // ojo: uso la iri de la última entrada
        $1ee989753a15371d$export$17cdb3d0a52387b4(entradas[entradas.length - 1].iri);
        // click en botón de seleccionar taxón para cerrar el panel correspondiente
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#setTreeTaxonEd").click();
    } else {
        // estoy anotando un taxón, rehago el diálogo
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
            static: true,
            vertcent: true,
            nobody: true
        }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).newAnnotation), (0, $646ceeeec66fabd8$export$43bbd40c30a74965).treeTaxon, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).crearAnotacion);
        // handler al botón de procesar anotación
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botcreatemodalannotation").click((0, $27fe9e683b34e1a0$export$a8fce3b21dbb0466));
        // ajusto nomci 
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#anchecknomci").prop('checked', (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).nomci);
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#anchecknomci").change($1ee989753a15371d$export$d67e2296dd6db17d);
        // detecto cambio en treeTaxon
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#inputTreeTaxonEd").change(function() {
            const iri = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/tree/" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid;
            const ttiri = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#inputTreeTaxonEd").attr("iri");
            // preinicializo
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").removeClass("d-none");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botcreatemodalannotation").prop("disabled", true);
            if (!ttiri) //console.log("No hay nada");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noAnnotation));
            else if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].species && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].species.species && ttiri === (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].species.species.iri) //console.log("Misma iri que antes (!)");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).sameAnnotation));
            else {
                //console.log("Todo OK");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").addClass("d-none");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botcreatemodalannotation").prop("disabled", false);
            }
        });
        // hago la selección del taxón (por fin)
        // ojo: uso la iri de la última entrada
        $1ee989753a15371d$export$17cdb3d0a52387b4(entradas[entradas.length - 1].iri);
    }
    // borro el contenido de la navegación de taxones
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#taxones_block_newtree").html("");
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#taxones_block").html("");
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#taxones_block").addClass("d-none");
}
function $1ee989753a15371d$var$prepareTaxonObjectWD(iri, iriWD, iriPadre) {
    // recupero info del taxón de Wikidata
    const txWD = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[iriWD];
    if (!txWD) return undefined;
    // preparo objeto a devolver
    let txobj = {
        "iri": iri,
        "creator": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/user/" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid,
        "created": new Date().toISOString(),
        "types": [
            "http://www.w3.org/2002/07/owl#Class",
            "http://www.w3.org/2000/01/rdf-schema#Class",
            txWD.isSpecies ? "https://datos.iepnb.es/def/sector-publico/medio-ambiente/ifn/Species" : txWD.family ? "https://datos.iepnb.es/def/sector-publico/medio-ambiente/ifn/Genus" : "https://datos.iepnb.es/def/sector-publico/medio-ambiente/ifn/Family"
        ],
        "subclasses": [
            iriPadre,
            txWD.iri
        ],
        "scientificName": (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(txWD.scientificName)
    };
    // fusiono vulgarName y label en vulgarName
    //txobj.vulgarName = fuseItems(txWD.vulgarName, txWD.label);
    if (txWD.vulgarName) txobj.vulgarName = txWD.vulgarName;
    //if (txWD.wikipediaPage)
    //	txobj.wikipediaPage = txWD.wikipediaPage;
    // sept-26: cambio
    if (txWD.wikipedia && txWD.wikipedia.en) txobj.wikipediaPage = txWD.wikipedia.en;
    if (txWD.wikispeciesPage) txobj.wikispeciesPage = txWD.wikispeciesPage;
    // y devuelvo
    return txobj;
}





/*
   Copyright 2023, Guillermo Vega-Gorgojo

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ 
/*! shepherd.js 15.3.0 */ function $2baf850be5795ad8$var$t(t) {
    return t instanceof HTMLElement;
}
function $2baf850be5795ad8$var$e(t) {
    return "function" == typeof t;
}
function $2baf850be5795ad8$var$n(t) {
    return "string" == typeof t;
}
function $2baf850be5795ad8$var$o(t) {
    return void 0 === t;
}
class $2baf850be5795ad8$var$i {
    on(t, e, n, i = !1) {
        var r;
        return $2baf850be5795ad8$var$o(this.bindings) && (this.bindings = {}), $2baf850be5795ad8$var$o(this.bindings[t]) && (this.bindings[t] = []), null == (r = this.bindings[t]) || r.push({
            handler: e,
            ctx: n,
            once: i
        }), this;
    }
    once(t, e, n) {
        return this.on(t, e, n, !0);
    }
    off(t, e) {
        var n;
        const i = null == (n = this.bindings) ? void 0 : n[t];
        return $2baf850be5795ad8$var$o(i) || ($2baf850be5795ad8$var$o(e) ? delete this.bindings[t] : this.bindings[t] = i.filter((t)=>t.handler !== e)), this;
    }
    trigger(t, ...e) {
        var n;
        const i = null == (n = this.bindings) ? void 0 : n[t];
        if ($2baf850be5795ad8$var$o(i)) return this;
        for (const n of i.slice()){
            const { ctx: o, handler: i, once: c } = n, a = o || this;
            if (i.apply(a, e), c) {
                var r, s;
                const e = null != (r = null == (s = this.bindings[t]) ? void 0 : s.indexOf(n)) ? r : -1;
                var l;
                if (-1 !== e) null == (l = this.bindings[t]) || l.splice(e, 1);
            }
        }
        return this;
    }
}
function $2baf850be5795ad8$var$r() {
    return $2baf850be5795ad8$var$r = Object.assign ? Object.assign.bind() : function(t) {
        for(var e = 1; e < arguments.length; e++){
            var n = arguments[e];
            for(var o in n)({}).hasOwnProperty.call(n, o) && (t[o] = n[o]);
        }
        return t;
    }, $2baf850be5795ad8$var$r.apply(null, arguments);
}
function $2baf850be5795ad8$var$s(t, e) {
    if (null == t) return {};
    var n = {};
    for(var o in t)if (({}).hasOwnProperty.call(t, o)) {
        if (-1 !== e.indexOf(o)) continue;
        n[o] = t[o];
    }
    return n;
}
const $2baf850be5795ad8$var$l = {
    defaultMerge: Symbol("deepmerge-ts: default merge"),
    skip: Symbol("deepmerge-ts: skip")
};
function $2baf850be5795ad8$var$c(t, e) {
    const n = {
        key: e.key,
        parents: e.parents,
        values: e.values,
        result: e.result
    }, o = null == t ? void 0 : t.hierarchy;
    return $2baf850be5795ad8$var$r({}, n, {
        hierarchy: void 0 === o ? [
            n
        ] : [
            ...o,
            n
        ]
    });
}
function $2baf850be5795ad8$var$a(t, e) {
    return t.includes(void 0) ? t.filter((t)=>void 0 !== t) : t;
}
function $2baf850be5795ad8$var$u(t, e, n) {
    return n === $2baf850be5795ad8$var$l.defaultMerge || t.useImplicitDefaultMerging && void 0 === n && t.mergeFunctions[e] !== t.defaultMergeFunctions[e];
}
function $2baf850be5795ad8$var$h(t, e) {
    return $2baf850be5795ad8$var$r({}, e, Object.fromEntries(Object.entries(t).filter(([t])=>Object.hasOwn(e, t)).map(([t, n])=>!1 === n ? [
            t,
            e.mergeOthers
        ] : "function" == typeof n ? [
            t,
            n
        ] : [
            t,
            e[t]
        ])));
}
var $2baf850be5795ad8$var$f;
function $2baf850be5795ad8$var$d(t) {
    return "object" != typeof t || null === t ? $2baf850be5795ad8$var$f.NOT : Array.isArray(t) ? $2baf850be5795ad8$var$f.ARRAY : function(t) {
        const e = Object.getPrototypeOf(t);
        if (null === e || e === Object.prototype) return !0;
        const n = Object.prototype.toString.call(t);
        if ("[object Object]" !== n && "[object Module]" !== n) return !1;
        const { constructor: o } = t;
        if (void 0 === o) return !0;
        const i = o.prototype;
        if (null === i || "object" != typeof i) return !1;
        const r = Object.prototype.toString.call(i);
        if ("[object Object]" !== r && "[object Module]" !== r) return !1;
        if (!Object.hasOwn(i, "isPrototypeOf")) return !1;
        return !0;
    }(t) ? $2baf850be5795ad8$var$f.RECORD : t instanceof Set ? $2baf850be5795ad8$var$f.SET : t instanceof Map ? $2baf850be5795ad8$var$f.MAP : $2baf850be5795ad8$var$f.OTHER;
}
function $2baf850be5795ad8$var$p(t) {
    const e = Object.getOwnPropertySymbols(t).filter((e)=>Object.prototype.propertyIsEnumerable.call(t, e));
    return [
        ...Object.keys(t),
        ...e
    ];
}
function $2baf850be5795ad8$var$m(t, e) {
    return "object" == typeof t && Object.prototype.propertyIsEnumerable.call(t, e);
}
function $2baf850be5795ad8$var$g(t, e, n) {
    if (void 0 === e || 0 === e.length) return 0;
    let o = 1;
    for(let i = e.length - 1; i >= 0; i--){
        const { parents: r } = e[i];
        if (r[n] === t || r.includes(t)) return o;
        o += 1;
    }
    return 0;
}
function $2baf850be5795ad8$var$v(t) {
    return null == t ? void 0 : t.hierarchy;
}
function $2baf850be5795ad8$var$y(t, e, n) {
    if ("object" != typeof t || null === t) return t;
    const o = $2baf850be5795ad8$var$v(n), i = $2baf850be5795ad8$var$g(t, o, 0);
    var r;
    if (i > 0 && void 0 !== o) return null == (r = o[o.length - i]) ? void 0 : r.result;
    if ($2baf850be5795ad8$var$d(t) === $2baf850be5795ad8$var$f.RECORD) {
        const o = t;
        let i = !1;
        const r = {};
        for (const t of $2baf850be5795ad8$var$p(o)){
            const s = o[t], l = e.metaDataUpdater(n, {
                key: t,
                parents: [
                    o
                ],
                values: [
                    s
                ],
                result: r
            }), c = $2baf850be5795ad8$var$y(s, e, l);
            c !== s && (i = !0), "__proto__" === t ? Object.defineProperty(r, t, {
                value: c,
                configurable: !0,
                enumerable: !0,
                writable: !0
            }) : r[t] = c;
        }
        return i ? r : t;
    }
    return t;
}
!function(t) {
    t[t.NOT = 0] = "NOT", t[t.RECORD = 1] = "RECORD", t[t.ARRAY = 2] = "ARRAY", t[t.SET = 3] = "SET", t[t.MAP = 4] = "MAP", t[t.OTHER = 5] = "OTHER";
}($2baf850be5795ad8$var$f || ($2baf850be5795ad8$var$f = {}));
const $2baf850be5795ad8$var$b = {
    mergeRecords: function(t, e, n) {
        if (2 === t.length) {
            const o = {}, i = (i, r)=>{
                const s = e.metaDataUpdater(n, {
                    key: i,
                    parents: t,
                    values: r,
                    result: o
                }), c = $2baf850be5795ad8$var$E(r, e, s);
                c !== $2baf850be5795ad8$var$l.skip && ("__proto__" === i ? Object.defineProperty(o, i, {
                    value: c,
                    configurable: !0,
                    enumerable: !0,
                    writable: !0
                }) : o[i] = c);
            }, r = t[0], s = t[1];
            for (const t of $2baf850be5795ad8$var$p(r))i(t, $2baf850be5795ad8$var$m(s, t) ? [
                r[t],
                s[t]
            ] : [
                r[t]
            ]);
            for (const t of $2baf850be5795ad8$var$p(s))$2baf850be5795ad8$var$m(r, t) || i(t, [
                s[t]
            ]);
            return o;
        }
        return function(t, e, n) {
            const o = {};
            for (const i of function(t) {
                const e = new Set;
                for (const n of t){
                    const t = Object.keys(n);
                    for (const n of t)e.add(n);
                    const o = Object.getOwnPropertySymbols(n);
                    if (o.length > 0) for (const t of o)Object.prototype.propertyIsEnumerable.call(n, t) && e.add(t);
                }
                return e;
            }(t)){
                const r = [];
                for (const e of t)$2baf850be5795ad8$var$m(e, i) && r.push(e[i]);
                const s = e.metaDataUpdater(n, {
                    key: i,
                    parents: t,
                    values: r,
                    result: o
                }), c = $2baf850be5795ad8$var$E(r, e, s);
                c !== $2baf850be5795ad8$var$l.skip && ("__proto__" === i ? Object.defineProperty(o, i, {
                    value: c,
                    configurable: !0,
                    enumerable: !0,
                    writable: !0
                }) : o[i] = c);
            }
            return o;
        }(t, e, n);
    },
    mergeArrays: function(t, e, n) {
        return t.flat();
    },
    mergeSets: function(t, e, n) {
        const o = new Set;
        for (const e of t)for (const t of e)o.add(t);
        return o;
    },
    mergeMaps: function(t, e, n) {
        const o = new Map, i = new Map;
        for (const e of t)for (const [t, n] of e){
            const e = i.get(t);
            void 0 === e ? i.set(t, [
                n
            ]) : e.push(n);
        }
        for (const [r, s] of i){
            const i = e.metaDataUpdater(n, {
                key: r,
                parents: t,
                values: s,
                result: o
            }), c = $2baf850be5795ad8$var$E(s, e, i);
            c !== $2baf850be5795ad8$var$l.skip && o.set(r, c);
        }
        return o;
    },
    mergeCircularReferences: function(t, e, n, o) {
        var i;
        const r = e[0], s = $2baf850be5795ad8$var$v(o);
        for(let i = 1; i < t.length; i++)if (e[i] !== r) {
            var l;
            const i = e.at(-1);
            return 0 === i ? $2baf850be5795ad8$var$y(t.at(-1), n, o) : null == s || null == (l = s[s.length - i]) ? void 0 : l.result;
        }
        return null == s || null == (i = s[s.length - r]) ? void 0 : i.result;
    },
    mergeOthers: function(t, e, n) {
        return t.at(-1);
    }
}, $2baf850be5795ad8$var$w = $2baf850be5795ad8$var$O();
function $2baf850be5795ad8$var$x(...t) {
    return $2baf850be5795ad8$var$w(...t);
}
function $2baf850be5795ad8$var$O(t = {}, e) {
    const n = function(t, e) {
        var n;
        const o = $2baf850be5795ad8$var$c;
        return {
            defaultMergeFunctions: $2baf850be5795ad8$var$b,
            mergeFunctions: $2baf850be5795ad8$var$h(t, $2baf850be5795ad8$var$b),
            metaDataUpdater: "function" == typeof t.metaDataUpdater ? t.metaDataUpdater : o,
            deepmerge: e,
            useImplicitDefaultMerging: null != (n = t.enableImplicitDefaultMerging) && n,
            filterValues: !1 === t.filterValues ? void 0 : "function" == typeof t.filterValues ? t.filterValues : $2baf850be5795ad8$var$a,
            maxDepth: "number" == typeof t.maxDepth && !Number.isNaN(t.maxDepth) && t.maxDepth >= 0 ? t.maxDepth : 1e3,
            actions: $2baf850be5795ad8$var$l
        };
    }(t, o);
    function o(...t) {
        return $2baf850be5795ad8$var$E(t, n, null != e ? e : void 0);
    }
    return o;
}
function $2baf850be5795ad8$var$E(t, e, n) {
    var o, i, r;
    const s = null != (o = null == e.filterValues ? void 0 : e.filterValues(t, n)) ? o : t;
    if (0 === s.length) return;
    const l = $2baf850be5795ad8$var$v(n), c = null != (i = null == l ? void 0 : l.length) ? i : "number" == typeof n ? n : null != (r = null == n ? void 0 : n.depth) ? r : 0;
    if (void 0 !== e.maxDepth && c >= e.maxDepth) return $2baf850be5795ad8$var$S(s, e, n);
    if (1 === s.length) {
        if (void 0 !== l) {
            const t = $2baf850be5795ad8$var$g(s[0], l, 0);
            var a, h, p;
            if (t > 0) return null != (a = null == (h = l[l.length - t]) ? void 0 : h.result) ? a : null == (p = l[l.length - t]) ? void 0 : p.parents[0];
        }
        return $2baf850be5795ad8$var$S(s, e, n);
    }
    const m = $2baf850be5795ad8$var$d(s[0]);
    if (m !== $2baf850be5795ad8$var$f.NOT && m !== $2baf850be5795ad8$var$f.OTHER) {
        if (2 === s.length) {
            if ($2baf850be5795ad8$var$d(s[1]) !== m) return $2baf850be5795ad8$var$S(s, e, n);
            const t = $2baf850be5795ad8$var$g(s[0], l, 0), o = $2baf850be5795ad8$var$g(s[1], l, 1);
            if (0 !== t || 0 !== o) return $2baf850be5795ad8$var$T(s, [
                t,
                o
            ], e, n);
        } else {
            const t = new Array(s.length);
            t[0] = $2baf850be5795ad8$var$g(s[0], l, 0);
            for(let o = 1; o < s.length; o++){
                if ($2baf850be5795ad8$var$d(s[o]) !== m) return $2baf850be5795ad8$var$S(s, e, n);
                t[o] = $2baf850be5795ad8$var$g(s[o], l, o);
            }
            if (t.some((t)=>0 !== t)) return $2baf850be5795ad8$var$T(s, t, e, n);
        }
    }
    switch(m){
        case $2baf850be5795ad8$var$f.RECORD:
            return function(t, e, n) {
                const o = e.mergeFunctions.mergeRecords(t, e, n);
                if ($2baf850be5795ad8$var$u(e, "mergeRecords", o)) return e.defaultMergeFunctions.mergeRecords(t, e, n);
                return o;
            }(s, e, n);
        case $2baf850be5795ad8$var$f.ARRAY:
            return function(t, e, n) {
                const o = e.mergeFunctions.mergeArrays(t, e, n);
                if ($2baf850be5795ad8$var$u(e, "mergeArrays", o)) return e.defaultMergeFunctions.mergeArrays(t);
                return o;
            }(s, e, n);
        case $2baf850be5795ad8$var$f.SET:
            return function(t, e, n) {
                const o = e.mergeFunctions.mergeSets(t, e, n);
                if ($2baf850be5795ad8$var$u(e, "mergeSets", o)) return e.defaultMergeFunctions.mergeSets(t);
                return o;
            }(s, e, n);
        case $2baf850be5795ad8$var$f.MAP:
            return function(t, e, n) {
                const o = e.mergeFunctions.mergeMaps(t, e, n);
                if ($2baf850be5795ad8$var$u(e, "mergeMaps", o)) return e.defaultMergeFunctions.mergeMaps(t, e, n);
                return o;
            }(s, e, n);
        default:
            return $2baf850be5795ad8$var$S(s, e, n);
    }
}
function $2baf850be5795ad8$var$T(t, e, n, o) {
    const i = n.mergeFunctions.mergeCircularReferences(t, e, n, o);
    return $2baf850be5795ad8$var$u(n, "mergeCircularReferences", i) ? n.defaultMergeFunctions.mergeCircularReferences(t, e, n, o) : i;
}
function $2baf850be5795ad8$var$S(t, e, n) {
    const o = e.mergeFunctions.mergeOthers(t, e, n);
    return $2baf850be5795ad8$var$u(e, "mergeOthers", o) ? e.defaultMergeFunctions.mergeOthers(t) : o;
}
function $2baf850be5795ad8$var$_(t) {
    const e = Object.getOwnPropertyNames(t.constructor.prototype);
    for(let n = 0; n < e.length; n++){
        const o = e[n], i = t[o];
        "constructor" !== o && "function" == typeof i && (t[o] = i.bind(t));
    }
    return t;
}
function $2baf850be5795ad8$var$A(t) {
    const { event: e, selector: n } = t.options.advanceOn || {};
    if (!e) return;
    const i = function(t, e) {
        return (n)=>{
            if (t.isOpen()) {
                const i = t.el && n.currentTarget === t.el;
                (!$2baf850be5795ad8$var$o(e) && n.currentTarget.matches(e) || i) && t.tour.next();
            }
        };
    }(t, n);
    if (!$2baf850be5795ad8$var$o(n)) {
        const t = document.querySelector(n);
        if (!t) return;
        return t.addEventListener(e, i), ()=>t.removeEventListener(e, i);
    }
    return document.body.addEventListener(e, i, !0), ()=>document.body.removeEventListener(e, i, !0);
}
function $2baf850be5795ad8$var$R(t) {
    return $2baf850be5795ad8$var$n(t) && "" !== t ? "-" !== t.charAt(t.length - 1) ? `${t}-` : t : "";
}
function $2baf850be5795ad8$var$L(t) {
    const o = t.options.attachTo || {};
    let i = $2baf850be5795ad8$var$e(o.element) ? o.element.call(t) : o.element;
    if ($2baf850be5795ad8$var$n(i)) try {
        i = document.querySelector(i);
    } catch (t) {
        i = null;
    }
    return i || null;
}
function $2baf850be5795ad8$var$C(t) {
    return null == t || !t.element || !t.on;
}
function $2baf850be5795ad8$var$P() {
    let t = Date.now();
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (e)=>{
        const n = (t + 16 * Math.random()) % 16 | 0;
        return t = Math.floor(t / 16), ("x" == e ? n : 3 & n | 8).toString(16);
    });
}
const $2baf850be5795ad8$var$M = [
    "start",
    "end"
], $2baf850be5795ad8$var$k = [
    "top",
    "right",
    "bottom",
    "left"
].reduce((t, e)=>t.concat(e, e + "-" + $2baf850be5795ad8$var$M[0], e + "-" + $2baf850be5795ad8$var$M[1]), []), $2baf850be5795ad8$var$D = Math.min, $2baf850be5795ad8$var$$ = Math.max, $2baf850be5795ad8$var$j = Math.round, $2baf850be5795ad8$var$H = Math.floor, $2baf850be5795ad8$var$I = (t)=>({
        x: t,
        y: t
    }), $2baf850be5795ad8$var$F = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $2baf850be5795ad8$var$B(t, e, n) {
    return $2baf850be5795ad8$var$$(t, $2baf850be5795ad8$var$D(e, n));
}
function $2baf850be5795ad8$var$V(t, e) {
    return "function" == typeof t ? t(e) : t;
}
function $2baf850be5795ad8$var$N(t) {
    return t.split("-")[0];
}
function $2baf850be5795ad8$var$W(t) {
    return t.split("-")[1];
}
function $2baf850be5795ad8$var$q(t) {
    return "x" === t ? "y" : "x";
}
function $2baf850be5795ad8$var$U(t) {
    return "y" === t ? "height" : "width";
}
function $2baf850be5795ad8$var$z(t) {
    const e = t[0];
    return "t" === e || "b" === e ? "y" : "x";
}
function $2baf850be5795ad8$var$Y(t) {
    return $2baf850be5795ad8$var$q($2baf850be5795ad8$var$z(t));
}
function $2baf850be5795ad8$var$G(t, e, n) {
    void 0 === n && (n = !1);
    const o = $2baf850be5795ad8$var$W(t), i = $2baf850be5795ad8$var$Y(t), r = $2baf850be5795ad8$var$U(i);
    let s = "x" === i ? o === (n ? "end" : "start") ? "right" : "left" : "start" === o ? "bottom" : "top";
    return e.reference[r] > e.floating[r] && (s = $2baf850be5795ad8$var$et(s)), [
        s,
        $2baf850be5795ad8$var$et(s)
    ];
}
function $2baf850be5795ad8$var$X(t) {
    return t.includes("start") ? t.replace("start", "end") : t.replace("end", "start");
}
const $2baf850be5795ad8$var$Z = [
    "left",
    "right"
], $2baf850be5795ad8$var$K = [
    "right",
    "left"
], $2baf850be5795ad8$var$J = [
    "top",
    "bottom"
], $2baf850be5795ad8$var$Q = [
    "bottom",
    "top"
];
function $2baf850be5795ad8$var$tt(t, e, n, o) {
    const i = $2baf850be5795ad8$var$W(t);
    let r = function(t, e, n) {
        switch(t){
            case "top":
            case "bottom":
                return n ? e ? $2baf850be5795ad8$var$K : $2baf850be5795ad8$var$Z : e ? $2baf850be5795ad8$var$Z : $2baf850be5795ad8$var$K;
            case "left":
            case "right":
                return e ? $2baf850be5795ad8$var$J : $2baf850be5795ad8$var$Q;
            default:
                return [];
        }
    }($2baf850be5795ad8$var$N(t), "start" === n, o);
    return i && (r = r.map((t)=>t + "-" + i), e && (r = r.concat(r.map($2baf850be5795ad8$var$X)))), r;
}
function $2baf850be5795ad8$var$et(t) {
    const e = $2baf850be5795ad8$var$N(t);
    return $2baf850be5795ad8$var$F[e] + t.slice(e.length);
}
function $2baf850be5795ad8$var$nt(t) {
    return "number" != typeof t ? function(t) {
        var e, n, o, i;
        return {
            top: null != (e = t.top) ? e : 0,
            right: null != (n = t.right) ? n : 0,
            bottom: null != (o = t.bottom) ? o : 0,
            left: null != (i = t.left) ? i : 0
        };
    }(t) : {
        top: t,
        right: t,
        bottom: t,
        left: t
    };
}
function $2baf850be5795ad8$var$ot(t) {
    const { x: e, y: n, width: o, height: i } = t;
    return {
        width: o,
        height: i,
        top: n,
        left: e,
        right: e + o,
        bottom: n + i,
        x: e,
        y: n
    };
}
const $2baf850be5795ad8$var$it = [
    "crossAxis",
    "alignment",
    "allowedPlacements",
    "autoAlignment"
], $2baf850be5795ad8$var$rt = [
    "mainAxis",
    "crossAxis",
    "fallbackPlacements",
    "fallbackStrategy",
    "fallbackAxisSideDirection",
    "flipAlignment"
], $2baf850be5795ad8$var$st = [
    "mainAxis",
    "crossAxis",
    "limiter"
];
function $2baf850be5795ad8$var$lt(t, e, n) {
    let { reference: o, floating: i } = t;
    const r = $2baf850be5795ad8$var$z(e), s = $2baf850be5795ad8$var$Y(e), l = $2baf850be5795ad8$var$U(s), c = $2baf850be5795ad8$var$N(e), a = "y" === r, u = o.x + o.width / 2 - i.width / 2, h = o.y + o.height / 2 - i.height / 2, f = o[l] / 2 - i[l] / 2;
    let d;
    switch(c){
        case "top":
            d = {
                x: u,
                y: o.y - i.height
            };
            break;
        case "bottom":
            d = {
                x: u,
                y: o.y + o.height
            };
            break;
        case "right":
            d = {
                x: o.x + o.width,
                y: h
            };
            break;
        case "left":
            d = {
                x: o.x - i.width,
                y: h
            };
            break;
        default:
            d = {
                x: o.x,
                y: o.y
            };
    }
    const p = $2baf850be5795ad8$var$W(e);
    return p && (d[s] += f * ("end" === p ? 1 : -1) * (n && a ? -1 : 1)), d;
}
async function $2baf850be5795ad8$var$ct(t, e) {
    var n;
    void 0 === e && (e = {});
    const { x: o, y: i, platform: r, rects: s, elements: l, strategy: c } = t, { boundary: a = "clippingAncestors", rootBoundary: u = "viewport", elementContext: h = "floating", altBoundary: f = !1, padding: d = 0 } = $2baf850be5795ad8$var$V(e, t), p = $2baf850be5795ad8$var$nt(d), m = l[f ? "floating" === h ? "reference" : "floating" : h], g = $2baf850be5795ad8$var$ot(await r.getClippingRect({
        element: null == (n = await (null == r.isElement ? void 0 : r.isElement(m))) || n ? m : m.contextElement || await (null == r.getDocumentElement ? void 0 : r.getDocumentElement(l.floating)),
        boundary: a,
        rootBoundary: u,
        strategy: c
    })), v = "floating" === h ? {
        x: o,
        y: i,
        width: s.floating.width,
        height: s.floating.height
    } : s.reference, y = await (null == r.getOffsetParent ? void 0 : r.getOffsetParent(l.floating)), b = await (null == r.isElement ? void 0 : r.isElement(y)) && await (null == r.getScale ? void 0 : r.getScale(y)) || {
        x: 1,
        y: 1
    }, w = $2baf850be5795ad8$var$ot(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: l,
        rect: v,
        offsetParent: y,
        strategy: c
    }) : v);
    return {
        top: (g.top - w.top + p.top) / b.y,
        bottom: (w.bottom - g.bottom + p.bottom) / b.y,
        left: (g.left - w.left + p.left) / b.x,
        right: (w.right - g.right + p.right) / b.x
    };
}
const $2baf850be5795ad8$var$at = new Set([
    "left",
    "top"
]);
function $2baf850be5795ad8$var$ut() {
    return "undefined" != typeof window;
}
function $2baf850be5795ad8$var$ht(t) {
    return $2baf850be5795ad8$var$pt(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function $2baf850be5795ad8$var$ft(t) {
    var e;
    return (null == t || null == (e = t.ownerDocument) ? void 0 : e.defaultView) || window;
}
function $2baf850be5795ad8$var$dt(t) {
    var e;
    return null == (e = ($2baf850be5795ad8$var$pt(t) ? t.ownerDocument : t.document) || window.document) ? void 0 : e.documentElement;
}
function $2baf850be5795ad8$var$pt(t) {
    return !!$2baf850be5795ad8$var$ut() && (t instanceof Node || t instanceof $2baf850be5795ad8$var$ft(t).Node);
}
function $2baf850be5795ad8$var$mt(t) {
    return !!$2baf850be5795ad8$var$ut() && (t instanceof Element || t instanceof $2baf850be5795ad8$var$ft(t).Element);
}
function $2baf850be5795ad8$var$gt(t) {
    return !!$2baf850be5795ad8$var$ut() && (t instanceof HTMLElement || t instanceof $2baf850be5795ad8$var$ft(t).HTMLElement);
}
function $2baf850be5795ad8$var$vt(t) {
    return !(!$2baf850be5795ad8$var$ut() || "undefined" == typeof ShadowRoot) && (t instanceof ShadowRoot || t instanceof $2baf850be5795ad8$var$ft(t).ShadowRoot);
}
function $2baf850be5795ad8$var$yt(t) {
    const { overflow: e, overflowX: n, overflowY: o, display: i } = $2baf850be5795ad8$var$Rt(t);
    return /auto|scroll|overlay|hidden|clip/.test(e + o + n) && "inline" !== i && "contents" !== i;
}
function $2baf850be5795ad8$var$bt(t) {
    return /^(table|td|th)$/.test($2baf850be5795ad8$var$ht(t));
}
function $2baf850be5795ad8$var$wt(t) {
    try {
        if (t.matches(":popover-open")) return !0;
    } catch (t) {}
    try {
        return t.matches(":modal");
    } catch (t) {
        return !1;
    }
}
const $2baf850be5795ad8$var$xt = /transform|translate|scale|rotate|perspective|filter/, $2baf850be5795ad8$var$Ot = /paint|layout|strict|content/, $2baf850be5795ad8$var$Et = (t)=>!!t && "none" !== t;
let $2baf850be5795ad8$var$Tt;
function $2baf850be5795ad8$var$St(t) {
    const e = $2baf850be5795ad8$var$mt(t) ? $2baf850be5795ad8$var$Rt(t) : t;
    return $2baf850be5795ad8$var$Et(e.transform) || $2baf850be5795ad8$var$Et(e.translate) || $2baf850be5795ad8$var$Et(e.scale) || $2baf850be5795ad8$var$Et(e.rotate) || $2baf850be5795ad8$var$Et(e.perspective) || !$2baf850be5795ad8$var$_t() && ($2baf850be5795ad8$var$Et(e.backdropFilter) || $2baf850be5795ad8$var$Et(e.filter)) || $2baf850be5795ad8$var$xt.test(e.willChange || "") || $2baf850be5795ad8$var$Ot.test(e.contain || "");
}
function $2baf850be5795ad8$var$_t() {
    return null == $2baf850be5795ad8$var$Tt && ($2baf850be5795ad8$var$Tt = "undefined" != typeof CSS && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), $2baf850be5795ad8$var$Tt;
}
function $2baf850be5795ad8$var$At(t) {
    return /^(html|body|#document)$/.test($2baf850be5795ad8$var$ht(t));
}
function $2baf850be5795ad8$var$Rt(t) {
    return $2baf850be5795ad8$var$ft(t).getComputedStyle(t);
}
function $2baf850be5795ad8$var$Lt(t) {
    return $2baf850be5795ad8$var$mt(t) ? {
        scrollLeft: t.scrollLeft,
        scrollTop: t.scrollTop
    } : {
        scrollLeft: t.scrollX,
        scrollTop: t.scrollY
    };
}
function $2baf850be5795ad8$var$Ct(t) {
    if ("html" === $2baf850be5795ad8$var$ht(t)) return t;
    const e = t.assignedSlot || t.parentNode || $2baf850be5795ad8$var$vt(t) && t.host || $2baf850be5795ad8$var$dt(t);
    return $2baf850be5795ad8$var$vt(e) ? e.host : e;
}
function $2baf850be5795ad8$var$Pt(t) {
    const e = $2baf850be5795ad8$var$Ct(t);
    return $2baf850be5795ad8$var$At(e) ? (t.ownerDocument || t).body : $2baf850be5795ad8$var$gt(e) && $2baf850be5795ad8$var$yt(e) ? e : $2baf850be5795ad8$var$Pt(e);
}
function $2baf850be5795ad8$var$Mt(t, e, n) {
    var o;
    void 0 === e && (e = []), void 0 === n && (n = !0);
    const i = $2baf850be5795ad8$var$Pt(t), r = i === (null == (o = t.ownerDocument) ? void 0 : o.body), s = $2baf850be5795ad8$var$ft(i);
    if (r) {
        const t = $2baf850be5795ad8$var$kt(s);
        return e.concat(s, s.visualViewport || [], $2baf850be5795ad8$var$yt(i) ? i : [], t && n ? $2baf850be5795ad8$var$Mt(t) : []);
    }
    return e.concat(i, $2baf850be5795ad8$var$Mt(i, [], n));
}
function $2baf850be5795ad8$var$kt(t) {
    return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
function $2baf850be5795ad8$var$Dt(t) {
    const e = $2baf850be5795ad8$var$Rt(t);
    let n = parseFloat(e.width) || 0, o = parseFloat(e.height) || 0;
    const i = $2baf850be5795ad8$var$gt(t), r = i ? t.offsetWidth : n, s = i ? t.offsetHeight : o, l = $2baf850be5795ad8$var$j(n) !== r || $2baf850be5795ad8$var$j(o) !== s;
    return l && (n = r, o = s), {
        width: n,
        height: o,
        $: l
    };
}
function $2baf850be5795ad8$var$$t(t) {
    return $2baf850be5795ad8$var$mt(t) ? t : t.contextElement;
}
function $2baf850be5795ad8$var$jt(t) {
    const e = $2baf850be5795ad8$var$$t(t);
    if (!$2baf850be5795ad8$var$gt(e)) return $2baf850be5795ad8$var$I(1);
    const n = e.getBoundingClientRect(), { width: o, height: i, $: r } = $2baf850be5795ad8$var$Dt(e);
    let s = (r ? $2baf850be5795ad8$var$j(n.width) : n.width) / o, l = (r ? $2baf850be5795ad8$var$j(n.height) : n.height) / i;
    return s && Number.isFinite(s) || (s = 1), l && Number.isFinite(l) || (l = 1), {
        x: s,
        y: l
    };
}
const $2baf850be5795ad8$var$Ht = $2baf850be5795ad8$var$I(0);
function $2baf850be5795ad8$var$It(t) {
    const e = $2baf850be5795ad8$var$ft(t);
    return $2baf850be5795ad8$var$_t() && e.visualViewport ? {
        x: e.visualViewport.offsetLeft,
        y: e.visualViewport.offsetTop
    } : $2baf850be5795ad8$var$Ht;
}
function $2baf850be5795ad8$var$Ft(t, e, n, o) {
    void 0 === e && (e = !1), void 0 === n && (n = !1);
    const i = t.getBoundingClientRect(), r = $2baf850be5795ad8$var$$t(t);
    let s = $2baf850be5795ad8$var$I(1);
    e && (o ? $2baf850be5795ad8$var$mt(o) && (s = $2baf850be5795ad8$var$jt(o)) : s = $2baf850be5795ad8$var$jt(t));
    const l = function(t, e, n) {
        return void 0 === e && (e = !1), !!n && e && n === $2baf850be5795ad8$var$ft(t);
    }(r, n, o) ? $2baf850be5795ad8$var$It(r) : $2baf850be5795ad8$var$I(0);
    let c = (i.left + l.x) / s.x, a = (i.top + l.y) / s.y, u = i.width / s.x, h = i.height / s.y;
    if (r && o) {
        const t = $2baf850be5795ad8$var$ft(r), e = $2baf850be5795ad8$var$mt(o) ? $2baf850be5795ad8$var$ft(o) : o;
        let n = t, i = $2baf850be5795ad8$var$kt(n);
        for(; i && e !== n;){
            const t = $2baf850be5795ad8$var$jt(i), e = i.getBoundingClientRect(), o = $2baf850be5795ad8$var$Rt(i), r = e.left + (i.clientLeft + parseFloat(o.paddingLeft)) * t.x, s = e.top + (i.clientTop + parseFloat(o.paddingTop)) * t.y;
            c *= t.x, a *= t.y, u *= t.x, h *= t.y, c += r, a += s, n = $2baf850be5795ad8$var$ft(i), i = $2baf850be5795ad8$var$kt(n);
        }
    }
    return $2baf850be5795ad8$var$ot({
        width: u,
        height: h,
        x: c,
        y: a
    });
}
function $2baf850be5795ad8$var$Bt(t, e) {
    const n = $2baf850be5795ad8$var$Lt(t).scrollLeft;
    return e ? e.left + n : $2baf850be5795ad8$var$Ft($2baf850be5795ad8$var$dt(t)).left + n;
}
function $2baf850be5795ad8$var$Vt(t, e) {
    const n = t.getBoundingClientRect();
    return {
        x: n.left + e.scrollLeft - $2baf850be5795ad8$var$Bt(t, n),
        y: n.top + e.scrollTop
    };
}
function $2baf850be5795ad8$var$Nt(t, e, n) {
    let o;
    if ("viewport" === e || "layoutViewport" === e) o = function(t, e, n) {
        void 0 === n && (n = "viewport");
        const o = "layoutViewport" === n, i = $2baf850be5795ad8$var$ft(t), r = $2baf850be5795ad8$var$dt(t), s = i.visualViewport;
        let l = r.clientWidth, c = r.clientHeight, a = 0, u = 0;
        if (s) {
            const t = !$2baf850be5795ad8$var$_t() || "fixed" === e;
            o ? t || (a = -s.offsetLeft, u = -s.offsetTop) : (l = s.width, c = s.height, t && (a = s.offsetLeft, u = s.offsetTop));
        }
        if ($2baf850be5795ad8$var$Bt(r) <= 0) {
            const t = r.ownerDocument, e = t.body, n = getComputedStyle(e), o = "CSS1Compat" === t.compatMode && parseFloat(n.marginLeft) + parseFloat(n.marginRight) || 0, i = Math.abs(r.clientWidth - e.clientWidth - o), s = "stable both-edges" === getComputedStyle(r).scrollbarGutter ? i / 2 : i;
            s <= 25 && (l -= s);
        }
        return {
            width: l,
            height: c,
            x: a,
            y: u
        };
    }(t, n, e);
    else if ("document" === e) o = function(t) {
        const e = $2baf850be5795ad8$var$Lt(t), n = t.ownerDocument.body, o = $2baf850be5795ad8$var$$(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), i = $2baf850be5795ad8$var$$(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
        let r = -e.scrollLeft + $2baf850be5795ad8$var$Bt(t);
        const s = -e.scrollTop;
        return "rtl" === $2baf850be5795ad8$var$Rt(n).direction && (r += $2baf850be5795ad8$var$$(t.clientWidth, n.clientWidth) - o), {
            width: o,
            height: i,
            x: r,
            y: s
        };
    }($2baf850be5795ad8$var$dt(t));
    else if ($2baf850be5795ad8$var$mt(e)) o = function(t, e) {
        const n = $2baf850be5795ad8$var$Ft(t, !0, "fixed" === e), o = n.top + t.clientTop, i = n.left + t.clientLeft, r = $2baf850be5795ad8$var$jt(t);
        return {
            width: t.clientWidth * r.x,
            height: t.clientHeight * r.y,
            x: i * r.x,
            y: o * r.y
        };
    }(e, n);
    else {
        const n = $2baf850be5795ad8$var$It(t);
        o = {
            x: e.x - n.x,
            y: e.y - n.y,
            width: e.width,
            height: e.height
        };
    }
    return $2baf850be5795ad8$var$ot(o);
}
function $2baf850be5795ad8$var$Wt(t, e, n) {
    const o = $2baf850be5795ad8$var$gt(e), i = $2baf850be5795ad8$var$dt(e), r = "fixed" === n, s = $2baf850be5795ad8$var$Ft(t, !0, r, e);
    let l = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const c = $2baf850be5795ad8$var$I(0);
    if ((o || !r) && (("body" !== $2baf850be5795ad8$var$ht(e) || $2baf850be5795ad8$var$yt(i)) && (l = $2baf850be5795ad8$var$Lt(e)), o)) {
        const t = $2baf850be5795ad8$var$Ft(e, !0, r, e);
        c.x = t.x + e.clientLeft, c.y = t.y + e.clientTop;
    }
    !o && i && (c.x = $2baf850be5795ad8$var$Bt(i));
    const a = !i || o || r ? $2baf850be5795ad8$var$I(0) : $2baf850be5795ad8$var$Vt(i, l);
    return {
        x: s.left + l.scrollLeft - c.x - a.x,
        y: s.top + l.scrollTop - c.y - a.y,
        width: s.width,
        height: s.height
    };
}
function $2baf850be5795ad8$var$qt(t) {
    return "static" === $2baf850be5795ad8$var$Rt(t).position;
}
function $2baf850be5795ad8$var$Ut(t, e) {
    if (!$2baf850be5795ad8$var$gt(t) || "fixed" === $2baf850be5795ad8$var$Rt(t).position) return null;
    if (e) return e(t);
    let n = t.offsetParent;
    return $2baf850be5795ad8$var$dt(t) === n && (n = n.ownerDocument.body), n;
}
function $2baf850be5795ad8$var$zt(t, e) {
    const n = $2baf850be5795ad8$var$ft(t);
    if ($2baf850be5795ad8$var$wt(t)) return n;
    if (!$2baf850be5795ad8$var$gt(t)) {
        let e = $2baf850be5795ad8$var$Ct(t);
        for(; e && !$2baf850be5795ad8$var$At(e);){
            if ($2baf850be5795ad8$var$mt(e) && !$2baf850be5795ad8$var$qt(e)) return e;
            e = $2baf850be5795ad8$var$Ct(e);
        }
        return n;
    }
    let o = $2baf850be5795ad8$var$Ut(t, e);
    for(; o && $2baf850be5795ad8$var$bt(o) && $2baf850be5795ad8$var$qt(o);)o = $2baf850be5795ad8$var$Ut(o, e);
    return o && $2baf850be5795ad8$var$At(o) && $2baf850be5795ad8$var$qt(o) && !$2baf850be5795ad8$var$St(o) ? n : o || function(t) {
        let e = $2baf850be5795ad8$var$Ct(t);
        for(; $2baf850be5795ad8$var$gt(e) && !$2baf850be5795ad8$var$At(e);){
            if ($2baf850be5795ad8$var$St(e)) return e;
            if ($2baf850be5795ad8$var$wt(e)) return null;
            e = $2baf850be5795ad8$var$Ct(e);
        }
        return null;
    }(t) || n;
}
const $2baf850be5795ad8$var$Yt = {
    convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
        let { elements: e, rect: n, offsetParent: o, strategy: i } = t;
        const r = "fixed" === i, s = $2baf850be5795ad8$var$dt(o), l = !!e && $2baf850be5795ad8$var$wt(e.floating);
        if (o === s || l && r) return n;
        let c = {
            scrollLeft: 0,
            scrollTop: 0
        }, a = $2baf850be5795ad8$var$I(1);
        const u = $2baf850be5795ad8$var$I(0), h = $2baf850be5795ad8$var$gt(o);
        if ((h || !r) && (("body" !== $2baf850be5795ad8$var$ht(o) || $2baf850be5795ad8$var$yt(s)) && (c = $2baf850be5795ad8$var$Lt(o)), h)) {
            const t = $2baf850be5795ad8$var$Ft(o);
            a = $2baf850be5795ad8$var$jt(o), u.x = t.x + o.clientLeft, u.y = t.y + o.clientTop;
        }
        const f = !s || h || r ? $2baf850be5795ad8$var$I(0) : $2baf850be5795ad8$var$Vt(s, c);
        return {
            width: n.width * a.x,
            height: n.height * a.y,
            x: n.x * a.x - c.scrollLeft * a.x + u.x + f.x,
            y: n.y * a.y - c.scrollTop * a.y + u.y + f.y
        };
    },
    getDocumentElement: $2baf850be5795ad8$var$dt,
    getClippingRect: function(t) {
        let { element: e, boundary: n, rootBoundary: o, strategy: i } = t;
        const r = [
            ..."clippingAncestors" === n ? $2baf850be5795ad8$var$wt(e) ? [] : function(t, e) {
                const n = e.get(t);
                if (n) return n;
                let o = $2baf850be5795ad8$var$Mt(t, [], !1).filter((t)=>$2baf850be5795ad8$var$mt(t) && "body" !== $2baf850be5795ad8$var$ht(t)), i = null;
                const r = "fixed" === $2baf850be5795ad8$var$Rt(t).position;
                let s = r ? $2baf850be5795ad8$var$Ct(t) : t;
                for(; $2baf850be5795ad8$var$mt(s) && !$2baf850be5795ad8$var$At(s);){
                    const t = $2baf850be5795ad8$var$Rt(s), e = $2baf850be5795ad8$var$St(s), n = i ? i.position : r ? "fixed" : "";
                    e || "fixed" !== n && ("absolute" !== n || "static" !== t.position) ? i = t : o = o.filter((t)=>t !== s), s = $2baf850be5795ad8$var$Ct(s);
                }
                return e.set(t, o), o;
            }(e, this._c) : [].concat(n),
            o
        ], s = $2baf850be5795ad8$var$Nt(e, r[0], i);
        let l = s.top, c = s.right, a = s.bottom, u = s.left;
        for(let t = 1; t < r.length; t++){
            const n = $2baf850be5795ad8$var$Nt(e, r[t], i);
            l = $2baf850be5795ad8$var$$(n.top, l), c = $2baf850be5795ad8$var$D(n.right, c), a = $2baf850be5795ad8$var$D(n.bottom, a), u = $2baf850be5795ad8$var$$(n.left, u);
        }
        return {
            width: c - u,
            height: a - l,
            x: u,
            y: l
        };
    },
    getOffsetParent: $2baf850be5795ad8$var$zt,
    getElementRects: async function(t) {
        const e = this.getOffsetParent || $2baf850be5795ad8$var$zt, n = this.getDimensions, o = await n(t.floating);
        return {
            reference: $2baf850be5795ad8$var$Wt(t.reference, await e(t.floating), t.strategy),
            floating: {
                x: 0,
                y: 0,
                width: o.width,
                height: o.height
            }
        };
    },
    getClientRects: function(t) {
        return t.getClientRects ? Array.from(t.getClientRects()) : [];
    },
    getDimensions: function(t) {
        const { width: e, height: n } = $2baf850be5795ad8$var$Dt(t);
        return {
            width: e,
            height: n
        };
    },
    getScale: $2baf850be5795ad8$var$jt,
    isElement: $2baf850be5795ad8$var$mt,
    isRTL: function(t) {
        return "rtl" === $2baf850be5795ad8$var$Rt(t).direction;
    }
};
function $2baf850be5795ad8$var$Gt(t, e) {
    return t.x === e.x && t.y === e.y && t.width === e.width && t.height === e.height;
}
function $2baf850be5795ad8$var$Xt(t, e, n, o) {
    void 0 === o && (o = {});
    const { ancestorScroll: i = !0, ancestorResize: s = !0, elementResize: l = "function" == typeof ResizeObserver, layoutShift: c = "function" == typeof IntersectionObserver, animationFrame: a = !1 } = o, u = $2baf850be5795ad8$var$$t(t), h = i || s ? [
        ...u ? $2baf850be5795ad8$var$Mt(u) : [],
        ...e ? $2baf850be5795ad8$var$Mt(e) : []
    ] : [];
    h.forEach((t)=>{
        i && t.addEventListener("scroll", n), s && t.addEventListener("resize", n);
    });
    const f = u && c ? function(t, e, n) {
        let o, i = null;
        const s = $2baf850be5795ad8$var$dt(t);
        function l() {
            var t;
            clearTimeout(o), null == (t = i) || t.disconnect(), i = null;
        }
        function c(n, a) {
            void 0 === n && (n = !1), void 0 === a && (a = 1), l();
            const u = t.getBoundingClientRect(), { left: h, top: f, width: d, height: p } = u;
            if (n || e(), !d || !p) return;
            const m = {
                rootMargin: -$2baf850be5795ad8$var$H(f) + "px " + -$2baf850be5795ad8$var$H(s.clientWidth - (h + d)) + "px " + -$2baf850be5795ad8$var$H(s.clientHeight - (f + p)) + "px " + -$2baf850be5795ad8$var$H(h) + "px",
                threshold: $2baf850be5795ad8$var$$(0, $2baf850be5795ad8$var$D(1, a)) || 1
            };
            let g = !0;
            function v(e) {
                const n = e[0].intersectionRatio;
                if (!$2baf850be5795ad8$var$Gt(u, t.getBoundingClientRect())) return c();
                if (n !== a) {
                    if (!g) return c();
                    n ? c(!1, n) : o = setTimeout(()=>{
                        c(!1, 1e-7);
                    }, 1e3);
                }
                g = !1;
            }
            try {
                i = new IntersectionObserver(v, $2baf850be5795ad8$var$r({}, m, {
                    root: s.ownerDocument
                }));
            } catch (t) {
                i = new IntersectionObserver(v, m);
            }
            i.observe(t);
        }
        const a = $2baf850be5795ad8$var$ft(t), u = ()=>c(n);
        return a.addEventListener("resize", u), c(!0), ()=>{
            a.removeEventListener("resize", u), l();
        };
    }(u, n, s) : null;
    let d, p = -1, m = null;
    l && (m = new ResizeObserver((t)=>{
        let [o] = t;
        o && o.target === u && m && e && (m.unobserve(e), cancelAnimationFrame(p), p = requestAnimationFrame(()=>{
            var t;
            null == (t = m) || t.observe(e);
        })), n();
    }), u && !a && m.observe(u), e && m.observe(e));
    let g = a ? $2baf850be5795ad8$var$Ft(t) : null;
    return a && function e() {
        const o = $2baf850be5795ad8$var$Ft(t);
        g && !$2baf850be5795ad8$var$Gt(g, o) && n();
        g = o, d = requestAnimationFrame(e);
    }(), n(), ()=>{
        var t;
        h.forEach((t)=>{
            i && t.removeEventListener("scroll", n), s && t.removeEventListener("resize", n);
        }), null == f || f(), null == (t = m) || t.disconnect(), m = null, a && cancelAnimationFrame(d);
    };
}
const $2baf850be5795ad8$var$Zt = function(t) {
    return void 0 === t && (t = {}), {
        name: "autoPlacement",
        options: t,
        async fn (e) {
            var n, o, i;
            const { rects: r, middlewareData: l, placement: c, platform: a, elements: u } = e, h = $2baf850be5795ad8$var$V(t, e), { crossAxis: f = !1, alignment: d, allowedPlacements: p = $2baf850be5795ad8$var$k, autoAlignment: m = !0 } = h, g = $2baf850be5795ad8$var$s(h, $2baf850be5795ad8$var$it), v = void 0 !== d || p === $2baf850be5795ad8$var$k ? function(t, e, n) {
                return (t ? [
                    ...n.filter((e)=>$2baf850be5795ad8$var$W(e) === t),
                    ...n.filter((e)=>$2baf850be5795ad8$var$W(e) !== t)
                ] : n.filter((t)=>$2baf850be5795ad8$var$N(t) === t)).filter((n)=>!t || $2baf850be5795ad8$var$W(n) === t || !!e && $2baf850be5795ad8$var$X(n) !== n);
            }(d || null, m, p) : p, y = (null == (n = l.autoPlacement) ? void 0 : n.index) || 0, b = v[y];
            if (null == b) return {};
            if (c !== b) return {
                reset: {
                    placement: v[0]
                }
            };
            const w = await a.detectOverflow(e, g), x = $2baf850be5795ad8$var$G(b, r, await (null == a.isRTL ? void 0 : a.isRTL(u.floating))), O = [
                w[$2baf850be5795ad8$var$N(b)],
                w[x[0]],
                w[x[1]]
            ], E = [
                ...(null == (o = l.autoPlacement) ? void 0 : o.overflows) || [],
                {
                    placement: b,
                    overflows: O
                }
            ], T = v[y + 1];
            if (T) return {
                data: {
                    index: y + 1,
                    overflows: E
                },
                reset: {
                    placement: T
                }
            };
            const S = E.map((t)=>{
                const e = $2baf850be5795ad8$var$W(t.placement);
                return [
                    t.placement,
                    e && f ? t.overflows.slice(0, 2).reduce((t, e)=>t + e, 0) : t.overflows[0],
                    t.overflows
                ];
            }).sort((t, e)=>t[1] - e[1]), _ = (null == (i = S.filter((t)=>t[2].slice(0, $2baf850be5795ad8$var$W(t[0]) ? 2 : 3).every((t)=>t <= 0))[0]) ? void 0 : i[0]) || S[0][0];
            return _ !== c ? {
                data: {
                    index: y + 1,
                    overflows: E
                },
                reset: {
                    placement: _
                }
            } : {};
        }
    };
}, $2baf850be5795ad8$var$Kt = function(t) {
    return void 0 === t && (t = {}), {
        name: "shift",
        options: t,
        async fn (e) {
            const { x: n, y: o, placement: i, platform: l } = e, c = $2baf850be5795ad8$var$V(t, e), { mainAxis: a = !0, crossAxis: u = !1, limiter: h = {
                fn: (t)=>{
                    let { x: e, y: n } = t;
                    return {
                        x: e,
                        y: n
                    };
                }
            } } = c, f = $2baf850be5795ad8$var$s(c, $2baf850be5795ad8$var$st), d = {
                x: n,
                y: o
            }, p = await l.detectOverflow(e, f), m = $2baf850be5795ad8$var$z(i), g = $2baf850be5795ad8$var$q(m);
            let v = d[g], y = d[m];
            const b = (t, e)=>$2baf850be5795ad8$var$B(e + p["y" === t ? "top" : "left"], e, e - p["y" === t ? "bottom" : "right"]);
            a && (v = b(g, v)), u && (y = b(m, y));
            const w = h.fn($2baf850be5795ad8$var$r({}, e, {
                [g]: v,
                [m]: y
            }));
            return $2baf850be5795ad8$var$r({}, w, {
                data: {
                    x: w.x - n,
                    y: w.y - o,
                    enabled: {
                        [g]: a,
                        [m]: u
                    }
                }
            });
        }
    };
}, $2baf850be5795ad8$var$Jt = function(t) {
    return void 0 === t && (t = {}), {
        name: "flip",
        options: t,
        async fn (e) {
            var n, o;
            const { placement: i, middlewareData: r, rects: l, initialPlacement: c, platform: a, elements: u } = e, h = $2baf850be5795ad8$var$V(t, e), { mainAxis: f = !0, crossAxis: d = !0, fallbackPlacements: p, fallbackStrategy: m = "bestFit", fallbackAxisSideDirection: g = "none", flipAlignment: v = !0 } = h, y = $2baf850be5795ad8$var$s(h, $2baf850be5795ad8$var$rt);
            if (null != (n = r.arrow) && n.alignmentOffset) return {};
            const b = $2baf850be5795ad8$var$N(i), w = $2baf850be5795ad8$var$z(c), x = $2baf850be5795ad8$var$N(c) === c, O = await (null == a.isRTL ? void 0 : a.isRTL(u.floating)), E = p || (x || !v ? [
                $2baf850be5795ad8$var$et(c)
            ] : function(t) {
                const e = $2baf850be5795ad8$var$et(t);
                return [
                    $2baf850be5795ad8$var$X(t),
                    e,
                    $2baf850be5795ad8$var$X(e)
                ];
            }(c)), T = "none" !== g;
            !p && T && E.push(...$2baf850be5795ad8$var$tt(c, v, g, O));
            const S = [
                c,
                ...E
            ], _ = await a.detectOverflow(e, y), A = [];
            let R = (null == (o = r.flip) ? void 0 : o.overflows) || [];
            if (f && A.push(_[b]), d) {
                const t = $2baf850be5795ad8$var$G(i, l, O);
                A.push(_[t[0]], _[t[1]]);
            }
            if (R = [
                ...R,
                {
                    placement: i,
                    overflows: A
                }
            ], !A.every((t)=>t <= 0)) {
                var L, C;
                const t = ((null == (L = r.flip) ? void 0 : L.index) || 0) + 1, e = S[t];
                if (e) {
                    if (!("alignment" === d && w !== $2baf850be5795ad8$var$z(e)) || R.every((t)=>$2baf850be5795ad8$var$z(t.placement) !== w || t.overflows[0] > 0)) return {
                        data: {
                            index: t,
                            overflows: R
                        },
                        reset: {
                            placement: e
                        }
                    };
                }
                let n = null == (C = R.filter((t)=>t.overflows[0] <= 0).sort((t, e)=>t.overflows[1] - e.overflows[1])[0]) ? void 0 : C.placement;
                if (!n) switch(m){
                    case "bestFit":
                        {
                            var P;
                            const t = null == (P = R.filter((t)=>{
                                if (T) {
                                    const e = $2baf850be5795ad8$var$z(t.placement);
                                    return e === w || "y" === e;
                                }
                                return !0;
                            }).map((t)=>[
                                    t.placement,
                                    t.overflows.filter((t)=>t > 0).reduce((t, e)=>t + e, 0)
                                ]).sort((t, e)=>t[1] - e[1])[0]) ? void 0 : P[0];
                            t && (n = t);
                            break;
                        }
                    case "initialPlacement":
                        n = c;
                }
                if (i !== n) return {
                    reset: {
                        placement: n
                    }
                };
            }
            return {};
        }
    };
}, $2baf850be5795ad8$var$Qt = (t)=>({
        name: "arrow",
        options: t,
        async fn (e) {
            const { x: n, y: o, placement: i, rects: s, platform: l, elements: c, middlewareData: a } = e, { element: u, padding: h = 0 } = $2baf850be5795ad8$var$V(t, e) || {};
            if (null == u) return {};
            const f = $2baf850be5795ad8$var$nt(h), d = {
                x: n,
                y: o
            }, p = $2baf850be5795ad8$var$Y(i), m = $2baf850be5795ad8$var$U(p), g = await l.getDimensions(u), v = "y" === p, y = v ? "top" : "left", b = v ? "bottom" : "right", w = v ? "clientHeight" : "clientWidth", x = s.reference[m] + s.reference[p] - d[p] - s.floating[m], O = d[p] - s.reference[p], E = await (null == l.getOffsetParent ? void 0 : l.getOffsetParent(u));
            let T = E ? E[w] : 0;
            T && await (null == l.isElement ? void 0 : l.isElement(E)) || (T = c.floating[w] || s.floating[m]);
            const S = x / 2 - O / 2, _ = T / 2 - g[m] / 2 - 1, A = $2baf850be5795ad8$var$D(f[y], _), R = $2baf850be5795ad8$var$D(f[b], _), L = T - g[m] - R, C = T / 2 - g[m] / 2 + S, P = $2baf850be5795ad8$var$B(A, C, L), M = !a.arrow && null != $2baf850be5795ad8$var$W(i) && C !== P && s.reference[m] / 2 - (C < A ? A : R) - g[m] / 2 < 0, k = M ? C < A ? C - A : C - L : 0;
            return {
                [p]: d[p] + k,
                data: $2baf850be5795ad8$var$r({
                    [p]: P,
                    centerOffset: C - P - k
                }, M && {
                    alignmentOffset: k
                }),
                reset: M
            };
        }
    }), $2baf850be5795ad8$var$te = function(t) {
    return void 0 === t && (t = {}), {
        options: t,
        fn (e) {
            var n, o;
            const { x: i, y: r, placement: s, rects: l, middlewareData: c } = e, { offset: a = 0, mainAxis: u = !0, crossAxis: h = !0 } = $2baf850be5795ad8$var$V(t, e), f = {
                x: i,
                y: r
            }, d = $2baf850be5795ad8$var$z(s), p = $2baf850be5795ad8$var$q(d);
            let m = f[p], g = f[d];
            const v = $2baf850be5795ad8$var$V(a, e), y = "number" == typeof v ? {
                mainAxis: v,
                crossAxis: 0
            } : {
                mainAxis: null != (n = v.mainAxis) ? n : 0,
                crossAxis: null != (o = v.crossAxis) ? o : 0
            };
            if (u) {
                const t = "y" === p ? "height" : "width", e = l.reference[p] - l.floating[t] + y.mainAxis, n = l.reference[p] + l.reference[t] - y.mainAxis;
                m < e ? m = e : m > n && (m = n);
            }
            if (h) {
                var b, w;
                const t = "y" === p ? "width" : "height", e = $2baf850be5795ad8$var$at.has($2baf850be5795ad8$var$N(s)), n = l.reference[d] - l.floating[t] + (e && (null == (b = c.offset) ? void 0 : b[d]) || 0) + (e ? 0 : y.crossAxis), o = l.reference[d] + l.reference[t] + (e ? 0 : (null == (w = c.offset) ? void 0 : w[d]) || 0) - (e ? y.crossAxis : 0);
                g < n ? g = n : g > o && (g = o);
            }
            return {
                [p]: m,
                [d]: g
            };
        }
    };
}, $2baf850be5795ad8$var$ee = (t, e, n)=>{
    const o = new Map, i = null != n ? n : {}, s = $2baf850be5795ad8$var$r({}, $2baf850be5795ad8$var$Yt, i.platform, {
        _c: o
    });
    return (async (t, e, n)=>{
        const { placement: o = "bottom", strategy: i = "absolute", middleware: s = [], platform: l } = n, c = l.detectOverflow ? l : $2baf850be5795ad8$var$r({}, l, {
            detectOverflow: $2baf850be5795ad8$var$ct
        }), a = await (null == l.isRTL ? void 0 : l.isRTL(e));
        let u = await l.getElementRects({
            reference: t,
            floating: e,
            strategy: i
        }), { x: h, y: f } = $2baf850be5795ad8$var$lt(u, o, a), d = o, p = 0;
        const m = {};
        for(let n = 0; n < s.length; n++){
            const g = s[n];
            if (!g) continue;
            const { name: v, fn: y } = g, { x: b, y: w, data: x, reset: O } = await y({
                x: h,
                y: f,
                initialPlacement: o,
                placement: d,
                strategy: i,
                middlewareData: m,
                rects: u,
                platform: c,
                elements: {
                    reference: t,
                    floating: e
                }
            });
            h = null != b ? b : h, f = null != w ? w : f, m[v] = $2baf850be5795ad8$var$r({}, m[v], x), O && p < 50 && (p++, "object" == typeof O && (O.placement && (d = O.placement), O.rects && (u = !0 === O.rects ? await l.getElementRects({
                reference: t,
                floating: e,
                strategy: i
            }) : O.rects), { x: h, y: f } = $2baf850be5795ad8$var$lt(u, d, a)), n = -1);
        }
        return {
            x: h,
            y: f,
            placement: d,
            strategy: i,
            middlewareData: m
        };
    })(t, e, $2baf850be5795ad8$var$r({}, i, {
        platform: s
    }));
};
function $2baf850be5795ad8$var$ne(e) {
    e.cleanup && e.cleanup();
    const n = e._getResolvedAttachToOptions();
    let o = n.element;
    const i = function(t, e) {
        var n, o, i;
        const r = {
            strategy: "absolute",
            middleware: []
        }, s = function(t) {
            if (t.options.arrow && t.el) return t.el.querySelector(".shepherd-arrow");
            return !1;
        }(e), l = $2baf850be5795ad8$var$C(t), c = null == (n = t.on) ? void 0 : n.includes("auto"), a = (null == t || null == (o = t.on) ? void 0 : o.includes("-start")) || (null == t || null == (i = t.on) ? void 0 : i.includes("-end"));
        if (!l) {
            var u;
            if (c) r.middleware.push($2baf850be5795ad8$var$Zt({
                crossAxis: !0,
                alignment: a ? null == t || null == (u = t.on) ? void 0 : u.split("-").pop() : null
            }));
            else r.middleware.push($2baf850be5795ad8$var$Jt());
            r.middleware.push($2baf850be5795ad8$var$Kt({
                limiter: $2baf850be5795ad8$var$te(),
                crossAxis: !0
            })), c || (r.placement = t.on);
        }
        const h = $2baf850be5795ad8$var$x(r, e.options.floatingUIOptions || {});
        if (!l && s && (d = h.middleware, !Boolean(null == d ? void 0 : d.some((t)=>(function(t) {
                return Boolean(t);
            })(t) && "arrow" === t.name)))) {
            var f;
            const t = "object" == typeof e.options.arrow ? e.options.arrow : {
                padding: 4
            };
            h.middleware = [
                ...null != (f = h.middleware) ? f : [],
                $2baf850be5795ad8$var$Qt({
                    element: s,
                    padding: a ? t.padding : 0
                })
            ];
        }
        var d;
        return h;
    }(n, e), r = $2baf850be5795ad8$var$C(n);
    if (r) {
        var s;
        o = document.body;
        const t = null == (s = e.shepherdElementComponent) ? void 0 : s.element;
        null == t || t.classList.add("shepherd-centered");
    }
    return e.cleanup = $2baf850be5795ad8$var$Xt(o, e.el, ()=>{
        e.el ? function(e, n, o, i) {
            $2baf850be5795ad8$var$ee(e, n.el, o).then(function(e, n) {
                return ({ x: o, y: i, strategy: r, placement: s, middlewareData: l })=>e.el ? (n ? Object.assign(e.el.style, {
                        position: "fixed",
                        left: "50%",
                        top: "50%",
                        transform: "translate(-50%, -50%)"
                    }) : Object.assign(e.el.style, {
                        position: r,
                        left: `${o}px`,
                        top: `${i}px`
                    }), e.el.dataset.popperPlacement = s, function(e, n) {
                        const o = e.querySelector(".shepherd-arrow");
                        if ($2baf850be5795ad8$var$t(o) && n.arrow) {
                            const { x: t, y: e } = n.arrow;
                            Object.assign(o.style, {
                                left: null != t ? `${t}px` : "",
                                top: null != e ? `${e}px` : ""
                            });
                        }
                    }(e.el, l), e) : e;
            }(n, i)).then((t)=>new Promise((e)=>{
                    setTimeout(()=>e(t), 300);
                })).then((t)=>{
                null != t && t.el && (t.el.tabIndex = 0, t.el.focus({
                    preventScroll: !0
                }));
            });
        }(o, e, i, r) : null == e.cleanup || e.cleanup();
    }), e.target = n.element, i;
}
function $2baf850be5795ad8$var$oe(t, e, ...n) {
    const o = document.createElement(t);
    return $2baf850be5795ad8$var$re(o, e), $2baf850be5795ad8$var$se(o, n), o;
}
function $2baf850be5795ad8$var$ie(t, e, ...n) {
    const o = document.createElementNS("http://www.w3.org/2000/svg", t);
    return $2baf850be5795ad8$var$re(o, e), $2baf850be5795ad8$var$se(o, n), o;
}
function $2baf850be5795ad8$var$re(t, e) {
    if (e) for (const [n, o] of Object.entries(e))null != o && !1 !== o && (n.startsWith("on") && "function" == typeof o ? t.addEventListener(n.slice(2).toLowerCase(), o) : "disabled" === n && !0 === o ? t.disabled = !0 : t.setAttribute(n, String(o)));
}
function $2baf850be5795ad8$var$se(t, e) {
    for (const n of e)null != n && !1 !== n && t.append("string" == typeof n ? document.createTextNode(n) : n);
}
function $2baf850be5795ad8$var$le(t, n) {
    return $2baf850be5795ad8$var$e(t) ? t.call(n) : t;
}
function $2baf850be5795ad8$var$ce(t, e) {
    const n = t.action ? t.action.bind(e.tour) : null, o = !!t.disabled && $2baf850be5795ad8$var$le(t.disabled, e), i = t.label ? $2baf850be5795ad8$var$le(t.label, e) : null, s = t.text ? $2baf850be5795ad8$var$le(t.text, e) : null, l = $2baf850be5795ad8$var$oe("button", $2baf850be5795ad8$var$r({}, t.attrs || {}, {
        "aria-label": i || null,
        class: `${t.classes || ""} shepherd-button ${t.secondary ? "shepherd-button-secondary" : ""}`,
        disabled: o || null,
        onclick: n,
        tabindex: "0",
        type: "button"
    }));
    return s && (l.innerHTML = s), l;
}
function $2baf850be5795ad8$var$ae(t, n) {
    const o = $2baf850be5795ad8$var$oe("header", {
        class: "shepherd-header"
    });
    return n.options.title && o.append(function(t, n) {
        const o = $2baf850be5795ad8$var$oe("h3", {
            id: t,
            class: "shepherd-title"
        }), i = $2baf850be5795ad8$var$e(n) ? n() : n;
        return o.innerHTML = i, o;
    }(t, n.options.title)), n.options.cancelIcon && n.options.cancelIcon.enabled && o.append(function(t, e) {
        return $2baf850be5795ad8$var$oe("button", $2baf850be5795ad8$var$r({}, t.attrs || {}, {
            "aria-label": t.label ? t.label : "Close Tour",
            class: "shepherd-cancel-icon",
            onclick: (t)=>{
                t.preventDefault(), e.cancel();
            },
            type: "button"
        }), $2baf850be5795ad8$var$oe("span", {
            "aria-hidden": "true"
        }, "\xd7"));
    }(n.options.cancelIcon, n)), o;
}
function $2baf850be5795ad8$var$ue(n, i, r) {
    const s = $2baf850be5795ad8$var$oe("div", {
        class: "shepherd-content"
    });
    return (!$2baf850be5795ad8$var$o(r.options.title) || r.options.cancelIcon && r.options.cancelIcon.enabled) && s.append($2baf850be5795ad8$var$ae(i, r)), $2baf850be5795ad8$var$o(r.options.text) || s.append(function(n, o) {
        const i = $2baf850be5795ad8$var$oe("div", {
            class: "shepherd-text",
            id: n
        });
        let r = o.options.text;
        return $2baf850be5795ad8$var$e(r) && (r = r.call(o)), $2baf850be5795ad8$var$t(r) ? i.appendChild(r) : i.innerHTML = r, i;
    }(n, r)), Array.isArray(r.options.buttons) && r.options.buttons.length && s.append(function(t) {
        const e = $2baf850be5795ad8$var$oe("footer", {
            class: "shepherd-footer"
        });
        if (t.options.buttons) for (const n of t.options.buttons)e.append($2baf850be5795ad8$var$ce(n, t));
        return e;
    }(r)), s;
}
class $2baf850be5795ad8$var$he extends $2baf850be5795ad8$var$i {
    constructor(t, e = {}){
        return super(), this._advanceOnCleanup = void 0, this._resolvedAttachTo = void 0, this._resolvedExtraHighlightElements = void 0, this._originalTabIndexes = void 0, this.classPrefix = void 0, this.el = void 0, this.shepherdElementComponent = void 0, this.target = void 0, this.tour = void 0, this.tour = t, this.classPrefix = this.tour.options ? $2baf850be5795ad8$var$R(this.tour.options.classPrefix) : "", this.styles = t.styles, this._resolvedAttachTo = null, this._originalTabIndexes = new Map, $2baf850be5795ad8$var$_(this), this._setOptions(e), this;
    }
    cancel() {
        this.tour.cancel(), this.trigger("cancel");
    }
    complete() {
        this.tour.complete(), this.trigger("complete");
    }
    destroy() {
        this._teardownElements(), this.trigger("destroy");
    }
    _teardownElements() {
        var e;
        this._advanceOnCleanup && (this._advanceOnCleanup(), this._advanceOnCleanup = null), (e = this).cleanup && e.cleanup(), e.cleanup = null, this.shepherdElementComponent && (this.shepherdElementComponent.cleanup(), this.shepherdElementComponent = void 0), $2baf850be5795ad8$var$t(this.el) && (this.el.remove(), this.el = null), this._updateStepTargetOnHide(), this._originalTabIndexes.clear();
    }
    getTour() {
        return this.tour;
    }
    hide() {
        var t;
        null == (t = this.tour.modal) || t.hide(), this.trigger("before-hide"), this.el && (this.el.hidden = !0), this._updateStepTargetOnHide(), this.trigger("hide");
    }
    _resolveExtraHiglightElements() {
        var t;
        return this._resolvedExtraHighlightElements = (t = this).options.extraHighlights ? t.options.extraHighlights.flatMap((t)=>Array.from(document.querySelectorAll(t))) : [], this._resolvedExtraHighlightElements;
    }
    _resolveAttachToOptions() {
        return this._resolvedAttachTo = function(t) {
            const o = t.options.attachTo || {}, i = Object.assign({}, o);
            if ($2baf850be5795ad8$var$e(i.element) && (i.element = i.element.call(t)), $2baf850be5795ad8$var$n(i.element)) {
                try {
                    i.element = document.querySelector(i.element);
                } catch (t) {}
                !i.element && t.options.skipMissingElement;
            }
            return i;
        }(this), this._resolvedAttachTo;
    }
    _getResolvedAttachToOptions() {
        return null === this._resolvedAttachTo ? this._resolveAttachToOptions() : this._resolvedAttachTo;
    }
    isOpen() {
        return Boolean(this.el && !this.el.hidden);
    }
    show() {
        return $2baf850be5795ad8$var$e(this.options.beforeShowPromise) ? Promise.resolve(this.options.beforeShowPromise()).then(()=>this._show()) : Promise.resolve(this._show());
    }
    updateStepOptions(t) {
        Object.assign(this.options, t), this.shepherdElementComponent && this.el && (this._teardownElements(), this._setupElements());
    }
    getElement() {
        return this.el;
    }
    getTarget() {
        return this.target;
    }
    _storeOriginalTabIndex(t) {
        const e = t.getAttribute("tabindex");
        null !== e && this._originalTabIndexes.set(t, e);
    }
    _restoreOriginalTabIndexes() {
        const t = this.target;
        t && (this._originalTabIndexes.has(t) ? t.setAttribute("tabindex", this._originalTabIndexes.get(t)) : t.removeAttribute("tabindex"));
    }
    _createTooltipContent() {
        const t = `${this.id}-description`, i = `${this.id}-label`;
        this.shepherdElementComponent = function(t) {
            var i, r, s, l;
            const { classPrefix: c, descriptionId: a, labelId: u, step: h } = t;
            let f, d, p, m, g, v, y;
            const b = null != (i = null == (r = h.options) || null == (r = r.cancelIcon) ? void 0 : r.enabled) && i, w = null != (s = null == (l = h.options) ? void 0 : l.title) && s, x = w ? void 0 : $2baf850be5795ad8$var$e(h.options.label) ? h.options.label.call(h) : h.options.label, O = $2baf850be5795ad8$var$n(x) && x.trim() ? x : null, E = (t)=>{
                const { tour: e } = h;
                switch(t.keyCode){
                    case 9:
                        if ((!d || 0 === d.length) && v && 0 === v.length) {
                            t.preventDefault();
                            break;
                        }
                        var n, o, i;
                        if (t.shiftKey) {
                            if (document.activeElement === g || null != (n = document.activeElement) && n.classList.contains("shepherd-element")) t.preventDefault(), null == (o = null != m ? m : y) || o.focus();
                            else if (document.activeElement === p) {
                                var r;
                                t.preventDefault(), null == (r = y) || r.focus();
                            }
                        } else if (document.activeElement === y) t.preventDefault(), null == (i = null != p ? p : g) || i.focus();
                        else if (document.activeElement === m) {
                            var s;
                            t.preventDefault(), null == (s = g) || s.focus();
                        }
                        break;
                    case 27:
                        e.options.exitOnEsc && (t.preventDefault(), t.stopPropagation(), h.cancel());
                        break;
                    case 37:
                        e.options.keyboardNavigation && (t.preventDefault(), t.stopPropagation(), e.back());
                        break;
                    case 39:
                        e.options.keyboardNavigation && (t.preventDefault(), t.stopPropagation(), e.next());
                }
            }, T = $2baf850be5795ad8$var$oe("dialog", {
                "aria-describedby": $2baf850be5795ad8$var$o(h.options.text) ? null : a,
                "aria-label": O,
                "aria-labelledby": h.options.title ? u : null,
                class: [
                    "shepherd-element",
                    b ? "shepherd-has-cancel-icon" : "",
                    w ? "shepherd-has-title" : ""
                ].filter(Boolean).join(" "),
                [`data-${c}shepherd-step-id`]: h.id,
                onkeydown: E,
                open: "true"
            });
            if (h.options.arrow && h.options.attachTo && h.options.attachTo.element && h.options.attachTo.on && T.append($2baf850be5795ad8$var$oe("div", {
                class: "shepherd-arrow",
                "data-popper-arrow": ""
            })), T.append($2baf850be5795ad8$var$ue(a, u, h)), $2baf850be5795ad8$var$n(h.options.classes)) {
                const t = h.options.classes.split(" ").filter((t)=>!!t.length);
                t.length && T.classList.add(...t);
            }
            const S = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]';
            v = [
                ...T.querySelectorAll(S)
            ], g = v[0], y = v[v.length - 1];
            const _ = h._getResolvedAttachToOptions();
            return null != _ && _.element && (f = _.element, h._storeOriginalTabIndex(f), f.tabIndex = 0, d = [
                f,
                ...f.querySelectorAll(S)
            ], p = d[0], m = d[d.length - 1], f.addEventListener("keydown", E)), {
                element: T,
                cleanup: ()=>{
                    var t;
                    null == (t = f) || t.removeEventListener("keydown", E);
                }
            };
        }({
            classPrefix: this.classPrefix,
            descriptionId: t,
            labelId: i,
            step: this
        });
        return (this.tour.options.stepsContainer || document.body).append(this.shepherdElementComponent.element), this.shepherdElementComponent.element;
    }
    _scrollTo(t) {
        const { element: n } = this._getResolvedAttachToOptions();
        $2baf850be5795ad8$var$e(this.options.scrollToHandler) ? this.options.scrollToHandler(n) : n instanceof Element && "function" == typeof n.scrollIntoView && n.scrollIntoView(t);
    }
    _getClassOptions(t) {
        const e = this.tour && this.tour.options && this.tour.options.defaultStepOptions, n = t.classes ? t.classes : "", o = e && e.classes ? e.classes : "", i = [
            ...n.split(" "),
            ...o.split(" ")
        ], r = new Set(i);
        return Array.from(r).join(" ").trim();
    }
    _setOptions(t = {}) {
        let e = this.tour && this.tour.options && this.tour.options.defaultStepOptions;
        e = $2baf850be5795ad8$var$x({}, e || {}), this.options = Object.assign({
            arrow: !0
        }, e, t, function(t, e) {
            return {
                floatingUIOptions: $2baf850be5795ad8$var$x(t.floatingUIOptions || {}, e.floatingUIOptions || {})
            };
        }(e, t));
        const { when: n } = this.options;
        this.options.classes = this._getClassOptions(t), this._teardownElements(), this.id = this.options.id || `step-${$2baf850be5795ad8$var$P()}`, n && Object.keys(n).forEach((t)=>{
            this.on(t, n[t], this);
        });
    }
    _setupElements() {
        var e;
        ($2baf850be5795ad8$var$t(this.el) && this._teardownElements(), this.el = this._createTooltipContent(), this.options.advanceOn) && (this._advanceOnCleanup = null != (e = $2baf850be5795ad8$var$A(this)) ? e : null);
        $2baf850be5795ad8$var$ne(this);
    }
    _show() {
        var t;
        this.trigger("before-show"), this._resolveAttachToOptions(), this._resolveExtraHiglightElements(), this._setupElements(), this.tour.modal || this.tour.setupModal(), null == (t = this.tour.modal) || t.setupForStep(this), this._styleTargetElementForStep(this), this.el && (this.el.hidden = !1), this.options.scrollTo && setTimeout(()=>{
            this._scrollTo(this.options.scrollTo);
        }), this.el && (this.el.hidden = !1);
        const e = this.shepherdElementComponent.element, n = this.target || document.body, o = this._resolvedExtraHighlightElements;
        n.classList.add(`${this.classPrefix}shepherd-enabled`), n.classList.add(`${this.classPrefix}shepherd-target`), e.classList.add("shepherd-enabled"), null == o || o.forEach((t)=>{
            t.classList.add(`${this.classPrefix}shepherd-enabled`), t.classList.add(`${this.classPrefix}shepherd-target`);
        }), this.trigger("show");
    }
    _styleTargetElementForStep(t) {
        const e = t.target, n = t._resolvedExtraHighlightElements;
        if (!e) return;
        const o = t.options.highlightClass;
        o && (e.classList.add(o), null == n || n.forEach((t)=>t.classList.add(o))), e.classList.remove("shepherd-target-click-disabled"), null == n || n.forEach((t)=>t.classList.remove("shepherd-target-click-disabled")), !1 === t.options.canClickTarget && (e.classList.add("shepherd-target-click-disabled"), null == n || n.forEach((t)=>t.classList.add("shepherd-target-click-disabled")));
    }
    _updateStepTargetOnHide() {
        const t = this.target || document.body, e = this._resolvedExtraHighlightElements, n = this.options.highlightClass;
        n && (t.classList.remove(n), null == e || e.forEach((t)=>t.classList.remove(n))), t.classList.remove("shepherd-target-click-disabled", `${this.classPrefix}shepherd-enabled`, `${this.classPrefix}shepherd-target`), null == e || e.forEach((t)=>{
            t.classList.remove("shepherd-target-click-disabled", `${this.classPrefix}shepherd-enabled`, `${this.classPrefix}shepherd-target`);
        }), this._restoreOriginalTabIndexes();
    }
}
function $2baf850be5795ad8$var$fe(t) {
    let e, n = new WeakMap, o = [
        {
            width: 0,
            height: 0,
            x: 0,
            y: 0,
            r: 0
        }
    ];
    const i = $2baf850be5795ad8$var$ie("path"), r = $2baf850be5795ad8$var$ie("svg", {
        class: "shepherd-modal-overlay-container"
    }, i);
    function s() {
        i.setAttribute("d", function(t) {
            let e = "";
            const { innerWidth: n, innerHeight: o } = window;
            return t.forEach((t)=>{
                const { width: n, height: o, x: i = 0, y: r = 0, r: s = 0 } = t, { topLeft: l = 0, topRight: c = 0, bottomRight: a = 0, bottomLeft: u = 0 } = "number" == typeof s ? {
                    topLeft: s,
                    topRight: s,
                    bottomRight: s,
                    bottomLeft: s
                } : s;
                e += `M${i + l},${r}a${l},${l},0,0,0-${l},${l}V` + (o + r - u) + `a${u},${u},0,0,0,${u},${u}H` + (n + i - a) + `a${a},${a},0,0,0,${a}-${a}` + `V${r + c}` + `a${c},${c},0,0,0-${c}-${c}Z`;
            }), `M${n},${o}H0V0H${n}V${o}Z${e}`.replace(/\s/g, "");
        }(o));
    }
    function l() {
        o = [
            {
                width: 0,
                height: 0,
                x: 0,
                y: 0,
                r: 0
            }
        ], s();
    }
    function c() {
        r.classList.remove("shepherd-modal-is-visible"), d();
    }
    function a() {
        r.classList.add("shepherd-modal-is-visible");
    }
    function u(t = 0, e = 0, n = 0, i = 0, r, c, a) {
        if (c) {
            {
                const s = [
                    c,
                    ...a || []
                ], l = [], u = r ? [
                    r,
                    ...g(r.parentElement)
                ] : [], h = (t)=>t === c ? u : g(t);
                for (const o of s){
                    if (!o) continue;
                    if (s.indexOf(o) !== s.lastIndexOf(o)) continue;
                    const { y: r, height: c } = v(o, h(o)), { x: a, width: u, left: f } = o.getBoundingClientRect();
                    s.some((t)=>{
                        if (t === o) return !1;
                        const e = t.getBoundingClientRect(), { y: n, height: i } = v(t, h(t));
                        return a >= e.left && a + u <= e.left + e.width && r >= n && r + c <= n + i;
                    }) || l.push({
                        width: u + 2 * t,
                        height: c + 2 * t,
                        x: (a || f) + n - t,
                        y: r + i - t,
                        r: e
                    });
                }
                o = l;
            }
            s();
        } else l();
    }
    function h(t) {
        t.stopPropagation();
    }
    r.addEventListener("touchmove", h), s(), t.append(r);
    const f = (t)=>{
        t.preventDefault();
    };
    function d() {
        e && (cancelAnimationFrame(e), e = void 0), n = new WeakMap, window.removeEventListener("touchmove", f, {
            passive: !1
        });
    }
    function p(t, e) {
        const { overflowY: n } = e;
        return "hidden" !== n && "visible" !== n && t.scrollHeight >= t.clientHeight;
    }
    function m(t) {
        if (!(t instanceof HTMLElement)) return [];
        const { position: e } = window.getComputedStyle(t);
        if ("fixed" === e) return [];
        const n = [];
        let o = "absolute" !== e;
        for(let e = t; e; e = e.parentElement){
            const i = window.getComputedStyle(e);
            o || e === t || "static" === i.position || (o = !0), o && p(e, i) && n.push(e);
        }
        return n;
    }
    function g(t) {
        if (!t) return [];
        const e = n.get(t);
        if (e) return e;
        const o = m(t);
        return n.set(t, o), o;
    }
    function v(t, e) {
        const n = t.getBoundingClientRect();
        let o = n.y || n.top, i = n.bottom || o + n.height;
        for (const t of e){
            const e = t.getBoundingClientRect(), n = e.y || e.top, r = e.bottom || n + e.height;
            o = Math.max(o, n), i = Math.min(i, r);
        }
        return {
            y: o,
            height: Math.max(i - o, 0)
        };
    }
    return {
        closeModalOpening: l,
        destroy: function() {
            d(), r.removeEventListener("touchmove", h), r.remove();
        },
        hide: c,
        positionModal: u,
        setupForStep: function(t) {
            d(), t.tour.options.useModalOverlay ? (!function(t) {
                const { modalOverlayOpeningPadding: n, modalOverlayOpeningRadius: o, modalOverlayOpeningXOffset: i = 0, modalOverlayOpeningYOffset: r = 0 } = t.options, s = function(t) {
                    const e = {
                        top: 0,
                        left: 0
                    };
                    if (!t) return e;
                    let n = t.ownerDocument.defaultView;
                    try {
                        for(; n && n !== window.top;){
                            var o;
                            const t = null == (o = n) ? void 0 : o.frameElement;
                            if (t) {
                                const n = t.getBoundingClientRect();
                                e.top += n.top + t.scrollTop, e.left += n.left + t.scrollLeft;
                            }
                            n = n.parent;
                        }
                    } catch (t) {}
                    return e;
                }(t.target), l = (a = t.target, null != (h = m(a)[0]) ? h : null), c = ()=>{
                    e = void 0, u(n, o, i + s.left, r + s.top, l, t.target, t._resolvedExtraHighlightElements), e = requestAnimationFrame(c);
                };
                var a, h;
                c(), window.addEventListener("touchmove", f, {
                    passive: !1
                });
            }(t), a()) : c();
        },
        show: a,
        getElement: function() {
            return r;
        }
    };
}
class $2baf850be5795ad8$export$788b3677e442107c extends $2baf850be5795ad8$var$i {
    constructor(){
        super(), this.activeTour = void 0, $2baf850be5795ad8$var$_(this);
    }
}
const $2baf850be5795ad8$export$2e2bcd8739ae039 = new $2baf850be5795ad8$export$788b3677e442107c, $2baf850be5795ad8$var$me = "undefined" == typeof window;
$2baf850be5795ad8$export$2e2bcd8739ae039.Step = $2baf850be5795ad8$var$me ? class {
    constructor(t){}
} : $2baf850be5795ad8$var$he, $2baf850be5795ad8$export$2e2bcd8739ae039.Tour = $2baf850be5795ad8$var$me ? class {
    constructor(t, e){}
} : class extends $2baf850be5795ad8$var$i {
    constructor(t = {}){
        super(), this.trackedEvents = [
            "active",
            "cancel",
            "complete",
            "show"
        ], this.classPrefix = void 0, this.currentStep = void 0, this.focusedElBeforeOpen = void 0, this.id = void 0, this.modal = void 0, this.options = void 0, this.steps = void 0, this._showGeneration = 0, $2baf850be5795ad8$var$_(this);
        this.options = Object.assign({}, {
            exitOnEsc: !0,
            keyboardNavigation: !0
        }, t), this.classPrefix = $2baf850be5795ad8$var$R(this.options.classPrefix), this.steps = [], this.addSteps(this.options.steps);
        return [
            "active",
            "cancel",
            "complete",
            "inactive",
            "show",
            "start"
        ].map((t)=>{
            ((t)=>{
                this.on(t, (e)=>{
                    (e = e || {}).tour = this, $2baf850be5795ad8$export$2e2bcd8739ae039.trigger(t, e);
                });
            })(t);
        }), this._setTourID(t.id), this;
    }
    addStep(t, e) {
        let n = t;
        return n instanceof $2baf850be5795ad8$var$he ? n.tour = this : n = new $2baf850be5795ad8$var$he(this, n), $2baf850be5795ad8$var$o(e) ? this.steps.push(n) : this.steps.splice(e, 0, n), n;
    }
    addSteps(t) {
        return Array.isArray(t) && t.forEach((t)=>{
            this.addStep(t);
        }), this;
    }
    back() {
        const t = this.steps.indexOf(this.currentStep);
        return this.show(t - 1, !1);
    }
    async cancel() {
        if (this.options.confirmCancel) {
            const t = this.options.confirmCancelMessage || "Are you sure you want to stop the tour?";
            let n;
            n = $2baf850be5795ad8$var$e(this.options.confirmCancel) ? await this.options.confirmCancel() : window.confirm(t), n && this._done("cancel");
        } else this._done("cancel");
    }
    complete() {
        this._done("complete");
    }
    getById(t) {
        return this.steps.find((e)=>e.id === t);
    }
    getCurrentStep() {
        return this.currentStep;
    }
    hide() {
        const t = this.getCurrentStep();
        if (t) return t.hide();
    }
    isActive() {
        return $2baf850be5795ad8$export$2e2bcd8739ae039.activeTour === this;
    }
    next() {
        const t = this.steps.indexOf(this.currentStep);
        if (t !== this.steps.length - 1) return this.show(t + 1, !0);
        this.complete();
    }
    removeStep(t) {
        const e = this.getCurrentStep();
        this.steps.some((e, n)=>{
            if (e.id === t) return e.isOpen() && e.hide(), e.destroy(), this.steps.splice(n, 1), !0;
        }), e && e.id === t && (this.currentStep = void 0, this.steps.length ? this.show(0) : this.cancel());
    }
    show(t = 0, o = !0) {
        const i = $2baf850be5795ad8$var$n(t) ? this.getById(t) : this.steps[t];
        if (!i) return;
        this._updateStateBeforeShow();
        const r = ++this._showGeneration;
        if ($2baf850be5795ad8$var$e(i.options.showOn) && !i.options.showOn()) return this._skipStep(i, o);
        const { skipMissingElement: s, waitForElement: l } = i.options, c = i.options.attachTo && i.options.attachTo.element, a = "number" == typeof l && l > 0 ? l : 0;
        if (($2baf850be5795ad8$var$n(c) || $2baf850be5795ad8$var$e(c)) && (s || a > 0) && !$2baf850be5795ad8$var$L(i)) {
            if (a > 0) return (function(t, e) {
                return new Promise((n)=>{
                    const o = $2baf850be5795ad8$var$L(t);
                    if (o || !(e > 0)) return void n(o);
                    let i = null, r = null, s = null;
                    const l = (t)=>{
                        var e;
                        null == (e = i) || e.disconnect(), null !== r && clearInterval(r), null !== s && clearTimeout(s), n(t);
                    }, c = ()=>{
                        const e = $2baf850be5795ad8$var$L(t);
                        e && l(e);
                    };
                    s = setTimeout(()=>l(null), e), "undefined" != typeof MutationObserver ? (i = new MutationObserver(c), i.observe(document.documentElement, {
                        attributes: !0,
                        childList: !0,
                        subtree: !0
                    })) : r = setInterval(c, 50);
                });
            })(i, a).then((t)=>{
                if (r === this._showGeneration && this.isActive()) return !t && s ? this._skipStep(i, o) : void this._showStep(i);
            });
            if (s) return this._skipStep(i, o);
        }
        this._showStep(i);
    }
    _showStep(t) {
        var e;
        const n = null != (e = this.currentStep) ? e : null;
        this.currentStep = t, this.trigger("show", {
            step: t,
            previous: n
        }), t.show();
    }
    async start() {
        return this.trigger("start"), this.focusedElBeforeOpen = document.activeElement, this.currentStep = null, this.setupModal(), this._setupActiveTour(), this.next();
    }
    _done(e) {
        const n = this.steps.indexOf(this.currentStep);
        Array.isArray(this.steps) && this.steps.forEach((t)=>t.destroy()), function(e) {
            if (e) {
                const { steps: n } = e;
                n.forEach((e)=>{
                    e.options && !1 === e.options.canClickTarget && e.options.attachTo && ($2baf850be5795ad8$var$t(e.target) && e.target.classList.remove("shepherd-target-click-disabled"), e._resolvedExtraHighlightElements && e._resolvedExtraHighlightElements.forEach((e)=>{
                        $2baf850be5795ad8$var$t(e) && e.classList.remove("shepherd-target-click-disabled");
                    }));
                });
            }
        }(this), this.trigger(e, {
            index: n
        }), $2baf850be5795ad8$export$2e2bcd8739ae039.activeTour = null, this.trigger("inactive", {
            tour: this
        }), this.modal && this.modal.hide(), "cancel" !== e && "complete" !== e || this.modal && (this.modal.destroy(), this.modal = null), $2baf850be5795ad8$var$t(this.focusedElBeforeOpen) && this.focusedElBeforeOpen.focus();
    }
    _setupActiveTour() {
        this.trigger("active", {
            tour: this
        }), $2baf850be5795ad8$export$2e2bcd8739ae039.activeTour = this;
    }
    setupModal() {
        const t = this.options.modalContainer || document.body;
        this.modal = $2baf850be5795ad8$var$fe(t);
    }
    _skipStep(t, e) {
        const n = this.steps.indexOf(t), o = e ? n + 1 : n - 1;
        if (o < 0) this.cancel();
        else {
            if (!(o >= this.steps.length)) return this.show(o, e);
            this.complete();
        }
    }
    _updateStateBeforeShow() {
        this.currentStep && this.currentStep.hide(), this.isActive() || this._setupActiveTour();
    }
    _setTourID(t) {
        const e = this.options.tourName || "tour", n = t || $2baf850be5795ad8$var$P();
        this.id = `${e}--${n}`;
    }
};




function $2fa03f5d455d6f0a$export$cdda91dfb91997f3() {
    // marco como completado el tour para que no recargue todo el rato el tour
    localStorage.setItem('tourCompletado', true); // cuidado, que setItem sólo guarda strings
    // creo tour
    const tour = new (0, $2baf850be5795ad8$export$2e2bcd8739ae039).Tour({
        useModalOverlay: true,
        defaultStepOptions: {
            cancelIcon: {
                enabled: true
            },
            //classes: 'class-1 class-2',
            scrollTo: {
                behavior: 'smooth',
                block: 'center'
            }
        }
    });
    // creo los pasos del tour
    //'Welcome',
    tour.addStep({
        title: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourTitle0),
        text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourText0),
        buttons: [
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourExit),
                classes: 'shepherd-button-secondary',
                action () {
                    return this.complete();
                }
            },
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourNext),
                action: tour.next
            }
        ]
    });
    // "The map",
    tour.addStep({
        title: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourTitle1),
        text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourText1),
        buttons: [
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourBack),
                classes: 'shepherd-button-secondary',
                action () {
                    return this.back();
                }
            },
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourNext),
                action: tour.next
            }
        ]
    });
    //'Zoom',
    if (!L.Browser.mobile) tour.addStep({
        title: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourTitle2),
        text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourText2),
        classes: 'mb-3',
        attachTo: {
            element: '.leaflet-control-zoom',
            on: 'top-start'
        },
        buttons: [
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourBack),
                classes: 'shepherd-button-secondary',
                action () {
                    return this.back();
                }
            },
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourNext),
                action () {
                    return this.next();
                }
            }
        ]
    });
    //'Mi localización',
    tour.addStep({
        title: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourTitle3),
        text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourText3),
        classes: 'mb-3',
        attachTo: {
            element: '.leaflet-control-locate',
            on: 'top-start'
        },
        buttons: [
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourBack),
                classes: 'shepherd-button-secondary',
                action () {
                    return this.back();
                }
            },
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourNext),
                action () {
                    return this.next();
                }
            }
        ]
    });
    // obtengo el elemento visible de clase usuario
    const usuarioElements = document.querySelectorAll('.usuario');
    // Iterate through the elements to find the visible one
    let visibleUsuarioElement = null;
    usuarioElements.forEach((element)=>{
        const style = getComputedStyle(element);
        if (style.display !== 'none' && style.visibility !== 'hidden') {
            visibleUsuarioElement = element;
            return;
        }
    });
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario) //'Your profile',
    tour.addStep({
        title: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourTitle4),
        text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourText4),
        classes: 'mt-3',
        attachTo: {
            element: visibleUsuarioElement,
            on: 'bottom'
        },
        buttons: [
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourBack),
                classes: 'shepherd-button-secondary',
                action () {
                    return this.back();
                }
            },
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourNext),
                action () {
                    return this.next();
                }
            }
        ]
    });
    else //'Sign in',
    tour.addStep({
        title: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourTitle5),
        text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourText5),
        classes: 'mt-3',
        attachTo: {
            element: visibleUsuarioElement,
            on: 'bottom'
        },
        buttons: [
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourBack),
                classes: 'shepherd-button-secondary',
                action () {
                    return this.back();
                }
            },
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourNext),
                action () {
                    return this.next();
                }
            }
        ]
    });
    //'Create tree',
    tour.addStep({
        title: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourTitle6),
        text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourText6),
        classes: 'mb-3',
        attachTo: {
            element: '.createtree',
            on: 'top-start'
        },
        buttons: [
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourBack),
                classes: 'shepherd-button-secondary',
                action () {
                    return this.back();
                }
            },
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourNext),
                action () {
                    return this.next();
                }
            }
        ]
    });
    //'View IFN trees',
    tour.addStep({
        title: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourTitle7),
        text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourText7),
        classes: 'mb-3',
        attachTo: {
            element: '.verifn',
            on: 'top-start'
        },
        buttons: [
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourBack),
                classes: 'shepherd-button-secondary',
                action () {
                    return this.back();
                }
            },
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourNext),
                action () {
                    return this.next();
                }
            }
        ]
    });
    //'Choose map layer',
    tour.addStep({
        title: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourTitle7a),
        text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourText7a),
        classes: 'mb-3',
        attachTo: {
            element: '.esri',
            on: 'top-start'
        },
        buttons: [
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourBack),
                classes: 'shepherd-button-secondary',
                action () {
                    return this.back();
                }
            },
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourNext),
                action () {
                    return this.next();
                }
            }
        ]
    });
    //'Refresh data',
    tour.addStep({
        title: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourTitle8),
        text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourText8),
        classes: 'mb-3',
        attachTo: {
            element: '.refresh',
            on: 'top-start'
        },
        buttons: [
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourBack),
                classes: 'shepherd-button-secondary',
                action () {
                    return this.back();
                }
            },
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourNext),
                action () {
                    return this.next();
                }
            }
        ]
    });
    //'Download data',
    tour.addStep({
        title: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourTitle9),
        text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourText9),
        classes: 'mb-3',
        attachTo: {
            element: '.download',
            on: 'top-start'
        },
        buttons: [
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourBack),
                classes: 'shepherd-button-secondary',
                action () {
                    return this.back();
                }
            },
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourNext),
                action () {
                    return this.next();
                }
            }
        ]
    });
    //'Filter taxon',	
    tour.addStep({
        title: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourTitle10),
        text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourText10),
        classes: 'mt-3',
        attachTo: {
            element: '#bot_taxones',
            on: 'bottom'
        },
        buttons: [
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourBack),
                classes: 'shepherd-button-secondary',
                action () {
                    return this.back();
                }
            },
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourNext),
                action () {
                    return this.next();
                }
            }
        ]
    });
    //'Scientific names',
    tour.addStep({
        title: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourTitle11),
        text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourText11),
        classes: 'mt-3',
        attachTo: {
            element: '#bot_mapnomci',
            on: 'bottom'
        },
        buttons: [
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourBack),
                classes: 'shepherd-button-secondary',
                action () {
                    return this.back();
                }
            },
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourNext),
                action () {
                    return this.next();
                }
            }
        ]
    });
    if (0, $ffd94e1d81f19b1c$export$c398d137cd63b259) //'Search places',	
    tour.addStep({
        title: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourTitle12),
        text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourText12),
        classes: 'mt-3',
        attachTo: {
            element: '#lugares_heading',
            on: 'bottom'
        },
        buttons: [
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourBack),
                classes: 'shepherd-button-secondary',
                action () {
                    return this.back();
                }
            },
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourNext),
                action () {
                    return this.next();
                }
            }
        ]
    });
    //'More options',
    tour.addStep({
        title: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourTitle13),
        text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourText13),
        classes: 'mt-3',
        attachTo: {
            element: '#bot_inicio',
            on: 'bottom'
        },
        buttons: [
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourBack),
                classes: 'shepherd-button-secondary',
                action () {
                    return this.back();
                }
            },
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourNext),
                action () {
                    return this.next();
                }
            }
        ]
    });
    //'The end',
    tour.addStep({
        title: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourTitle14),
        text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourText14),
        buttons: [
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourBack),
                classes: 'shepherd-button-secondary',
                action () {
                    return this.back();
                }
            },
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourDone),
                action () {
                    return this.complete();
                }
            }
        ]
    });
    // lanzo...
    tour.start();
}


/*
   Copyright 2023, Guillermo Vega-Gorgojo

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ 
var $33Kba = parcelRequire("33Kba");



var $2q7Wm = parcelRequire("2q7Wm");

var $6KOho = parcelRequire("6KOho");

var $dktVJ = parcelRequire("dktVJ");
var $cd948d9b215c1263$exports = {};
!function(t, e) {
    e($cd948d9b215c1263$exports);
}($cd948d9b215c1263$exports, function(t) {
    "use strict";
    function e(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for(var n = 0, r = Array(e); n < e; n++)r[n] = t[n];
        return r;
    }
    function n(t) {
        if (Array.isArray(t)) return t;
    }
    function r(t, e, n) {
        return e = l(e), function(t, e) {
            if (e && ("object" == typeof e || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return function(t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            }(t);
        }(t, c() ? Reflect.construct(e, n || [], l(t).constructor) : e.apply(t, n));
    }
    function i(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    function o(t, e) {
        for(var n = 0; n < e.length; n++){
            var r = e[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, x(r.key), r);
        }
    }
    function s(t, e, n) {
        return e && o(t.prototype, e), n && o(t, n), Object.defineProperty(t, "prototype", {
            writable: !1
        }), t;
    }
    function a(t, e) {
        var n = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
        if (!n) {
            if (Array.isArray(t) || (n = k(t)) || e) {
                n && (t = n);
                var r = 0, i = function() {};
                return {
                    s: i,
                    n: function() {
                        return r >= t.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: t[r++]
                        };
                    },
                    e: function(t) {
                        throw t;
                    },
                    f: i
                };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        var o, s = !0, a = !1;
        return {
            s: function() {
                n = n.call(t);
            },
            n: function() {
                var t = n.next();
                return s = t.done, t;
            },
            e: function(t) {
                a = !0, o = t;
            },
            f: function() {
                try {
                    s || null == n.return || n.return();
                } finally{
                    if (a) throw o;
                }
            }
        };
    }
    function u(t, e, n) {
        return (e = x(e)) in t ? Object.defineProperty(t, e, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t[e] = n, t;
    }
    function l(t) {
        return l = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
            return t.__proto__ || Object.getPrototypeOf(t);
        }, l(t);
    }
    function h(t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
            constructor: {
                value: t,
                writable: !0,
                configurable: !0
            }
        }), Object.defineProperty(t, "prototype", {
            writable: !1
        }), e && y(t, e);
    }
    function c() {
        try {
            var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        } catch (t) {}
        return (c = function() {
            return !!t;
        })();
    }
    function f(t) {
        if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
    }
    function v() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function g() {
        /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var t, e, n = "function" == typeof Symbol ? Symbol : {}, r = n.iterator || "@@iterator", i = n.toStringTag || "@@toStringTag";
        function o(n, r, i, o) {
            var u = r && r.prototype instanceof a ? r : a, l = Object.create(u.prototype);
            return d(l, "_invoke", function(n, r, i) {
                var o, a, u, l = 0, h = i || [], c = !1, f = {
                    p: 0,
                    n: 0,
                    v: t,
                    a: v,
                    f: v.bind(t, 4),
                    d: function(e, n) {
                        return o = e, a = 0, u = t, f.n = n, s;
                    }
                };
                function v(n, r) {
                    for(a = n, u = r, e = 0; !c && l && !i && e < h.length; e++){
                        var i, o = h[e], v = f.p, g = o[2];
                        n > 3 ? (i = g === r) && (u = o[(a = o[4]) ? 5 : (a = 3, 3)], o[4] = o[5] = t) : o[0] <= v && ((i = n < 2 && v < o[1]) ? (a = 0, f.v = r, f.n = o[1]) : v < g && (i = n < 3 || o[0] > r || r > g) && (o[4] = n, o[5] = r, f.n = g, a = 0));
                    }
                    if (i || n > 1) return s;
                    throw c = !0, r;
                }
                return function(i, h, g) {
                    if (l > 1) throw TypeError("Generator is already running");
                    for(c && 1 === h && v(h, g), a = h, u = g; (e = a < 2 ? t : u) || !c;){
                        o || (a ? a < 3 ? (a > 1 && (f.n = -1), v(a, u)) : f.n = u : f.v = u);
                        try {
                            if (l = 2, o) {
                                if (a || (i = "next"), e = o[i]) {
                                    if (!(e = e.call(o, u))) throw TypeError("iterator result is not an object");
                                    if (!e.done) return e;
                                    u = e.value, a < 2 && (a = 0);
                                } else 1 === a && (e = o.return) && e.call(o), a < 2 && (u = TypeError("The iterator does not provide a '" + i + "' method"), a = 1);
                                o = t;
                            } else if ((e = (c = f.n < 0) ? u : n.call(r, f)) !== s) break;
                        } catch (e) {
                            o = t, a = 1, u = e;
                        } finally{
                            l = 1;
                        }
                    }
                    return {
                        value: e,
                        done: c
                    };
                };
            }(n, i, o), !0), l;
        }
        var s = {};
        function a() {}
        function u() {}
        function l() {}
        e = Object.getPrototypeOf;
        var h = [][r] ? e(e([][r]())) : (d(e = {}, r, function() {
            return this;
        }), e), c = l.prototype = a.prototype = Object.create(h);
        function f(t) {
            return Object.setPrototypeOf ? Object.setPrototypeOf(t, l) : (t.__proto__ = l, d(t, i, "GeneratorFunction")), t.prototype = Object.create(c), t;
        }
        return u.prototype = l, d(c, "constructor", l), d(l, "constructor", u), u.displayName = "GeneratorFunction", d(l, i, "GeneratorFunction"), d(c), d(c, i, "Generator"), d(c, r, function() {
            return this;
        }), d(c, "toString", function() {
            return "[object Generator]";
        }), (g = function() {
            return {
                w: o,
                m: f
            };
        })();
    }
    function d(t, e, n, r) {
        var i = Object.defineProperty;
        try {
            i({}, "", {});
        } catch (t) {
            i = 0;
        }
        d = function(t, e, n, r) {
            function o(e, n) {
                d(t, e, function(t) {
                    return this._invoke(e, n, t);
                });
            }
            e ? i ? i(t, e, {
                value: n,
                enumerable: !r,
                configurable: !r,
                writable: !r
            }) : t[e] = n : (o("next", 0), o("throw", 1), o("return", 2));
        }, d(t, e, n, r);
    }
    function p(t) {
        if (null != t) {
            var e = t["function" == typeof Symbol && Symbol.iterator || "@@iterator"], n = 0;
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;
            if (!isNaN(t.length)) return {
                next: function() {
                    return t && n >= t.length && (t = void 0), {
                        value: t && t[n++],
                        done: !t
                    };
                }
            };
        }
        throw new TypeError(typeof t + " is not iterable");
    }
    function y(t, e) {
        return y = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
            return t.__proto__ = e, t;
        }, y(t, e);
    }
    function m(t, e) {
        return n(t) || function(t, e) {
            var n = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
            if (null != n) {
                var r, i, o, s, a = [], u = !0, l = !1;
                try {
                    if (o = (n = n.call(t)).next, 0 === e) {
                        if (Object(n) !== n) return;
                        u = !1;
                    } else for(; !(u = (r = o.call(n)).done) && (a.push(r.value), a.length !== e); u = !0);
                } catch (t) {
                    l = !0, i = t;
                } finally{
                    try {
                        if (!u && null != n.return && (s = n.return(), Object(s) !== s)) return;
                    } finally{
                        if (l) throw i;
                    }
                }
                return a;
            }
        }(t, e) || k(t, e) || v();
    }
    function _(t) {
        return function(t) {
            if (Array.isArray(t)) return e(t);
        }(t) || f(t) || k(t) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function x(t) {
        var e = function(t, e) {
            if ("object" != typeof t || !t) return t;
            var n = t[Symbol.toPrimitive];
            if (void 0 !== n) {
                var r = n.call(t, e);
                if ("object" != typeof r) return r;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === e ? String : Number)(t);
        }(t, "string");
        return "symbol" == typeof e ? e : e + "";
    }
    function E(t) {
        return E = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
            return typeof t;
        } : function(t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, E(t);
    }
    function k(t, n) {
        if (t) {
            if ("string" == typeof t) return e(t, n);
            var r = ({}).toString.call(t).slice(8, -1);
            return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? e(t, n) : void 0;
        }
    }
    var w = 6371008.8, b = {
        centimeters: 637100880,
        centimetres: 637100880,
        cm: 637100880,
        degrees: 360 / (2 * Math.PI),
        deg: 360 / (2 * Math.PI),
        feet: 20902260.511392,
        ft: 20902260.511392,
        inches: 39.37 * w,
        in: 39.37 * w,
        kilometers: 6371.0088,
        kilometres: 6371.0088,
        km: 6371.0088,
        meters: w,
        metres: w,
        m: w,
        miles: 3958.761333810546,
        mi: 3958.761333810546,
        millimeters: 6371008800,
        millimetres: 6371008800,
        mm: 6371008800,
        nauticalmiles: w / 1852,
        nmi: w / 1852,
        radians: 1,
        rad: 1,
        yards: 6967335.223679999,
        yd: 6967335.223679999
    }, I = {
        acres: 247105e-9,
        ac: 247105e-9,
        centimeters: 1e4,
        centimetres: 1e4,
        cm: 1e4,
        feet: 10.763910417,
        ft: 10.763910417,
        hectares: 1e-4,
        ha: 1e-4,
        inches: 1550.003100006,
        in: 1550.003100006,
        kilometers: 1e-6,
        kilometres: 1e-6,
        km: 1e-6,
        meters: 1,
        metres: 1,
        m: 1,
        miles: 386e-9,
        mi: 386e-9,
        nauticalmiles: 2.9155334959812285e-7,
        nmi: 2.9155334959812285e-7,
        millimeters: 1e6,
        millimetres: 1e6,
        mm: 1e6,
        yards: 1.195990046,
        yd: 1.195990046
    };
    function N(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, r = {
            type: "Feature"
        };
        return (0 === n.id || n.id) && (r.id = n.id), n.bbox && (r.bbox = n.bbox), r.properties = e || {}, r.geometry = t, r;
    }
    function S(t, e) {
        switch(t){
            case "Point":
                return M(e).geometry;
            case "LineString":
                return T(e).geometry;
            case "Polygon":
                return P(e).geometry;
            case "MultiPoint":
                return D(e).geometry;
            case "MultiLineString":
                return A(e).geometry;
            case "MultiPolygon":
                return F(e).geometry;
            default:
                throw new Error(t + " is invalid");
        }
    }
    function M(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        if (!t) throw new Error("coordinates is required");
        if (!Array.isArray(t)) throw new Error("coordinates must be an Array");
        if (t.length < 2) throw new Error("coordinates must be at least 2 numbers long");
        if (!W(t[0]) || !W(t[1])) throw new Error("coordinates must contain numbers");
        return N({
            type: "Point",
            coordinates: t
        }, e, n);
    }
    function L(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        return R(t.map(function(t) {
            return M(t, e);
        }), n);
    }
    function P(t, e) {
        var n, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, i = a(t);
        try {
            for(i.s(); !(n = i.n()).done;){
                var o = n.value;
                if (o.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
                if (o[o.length - 1].length !== o[0].length) throw new Error("First and last Position are not equivalent.");
                for(var s = 0; s < o[o.length - 1].length; s++)if (o[o.length - 1][s] !== o[0][s]) throw new Error("First and last Position are not equivalent.");
            }
        } catch (t) {
            i.e(t);
        } finally{
            i.f();
        }
        return N({
            type: "Polygon",
            coordinates: t
        }, e, r);
    }
    function C(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        return R(t.map(function(t) {
            return P(t, e);
        }), n);
    }
    function T(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        if (t.length < 2) throw new Error("coordinates must be an array of two or more positions");
        return N({
            type: "LineString",
            coordinates: t
        }, e, n);
    }
    function O(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        return R(t.map(function(t) {
            return T(t, e);
        }), n);
    }
    function R(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = {
            type: "FeatureCollection"
        };
        return e.id && (n.id = e.id), e.bbox && (n.bbox = e.bbox), n.features = t, n;
    }
    function A(t, e) {
        return N({
            type: "MultiLineString",
            coordinates: t
        }, e, arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {});
    }
    function D(t, e) {
        return N({
            type: "MultiPoint",
            coordinates: t
        }, e, arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {});
    }
    function F(t, e) {
        return N({
            type: "MultiPolygon",
            coordinates: t
        }, e, arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {});
    }
    function q(t, e) {
        return N({
            type: "GeometryCollection",
            geometries: t
        }, e, arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {});
    }
    function G(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
        if (e && !(e >= 0)) throw new Error("precision must be a positive number");
        var n = Math.pow(10, e || 0);
        return Math.round(t * n) / n;
    }
    function Y(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "kilometers", n = b[e];
        if (!n) throw new Error(e + " units is invalid");
        return t * n;
    }
    function B(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "kilometers", n = b[e];
        if (!n) throw new Error(e + " units is invalid");
        return t / n;
    }
    function z(t, e) {
        return U(B(t, e));
    }
    function j(t) {
        var e = t % 360;
        return e < 0 && (e += 360), e;
    }
    function X(t) {
        return (t %= 360) > 180 ? t - 360 : t < -180 ? t + 360 : t;
    }
    function U(t) {
        return 180 * (t % (2 * Math.PI)) / Math.PI;
    }
    function V(t) {
        return t % 360 * Math.PI / 180;
    }
    function Z(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "kilometers", n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "kilometers";
        if (!(t >= 0)) throw new Error("length must be a positive number");
        return Y(B(t, e), n);
    }
    function H(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "meters", n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "kilometers";
        if (!(t >= 0)) throw new Error("area must be a positive number");
        var r = I[e];
        if (!r) throw new Error("invalid original units");
        var i = I[n];
        if (!i) throw new Error("invalid final units");
        return t / r * i;
    }
    function W(t) {
        return !isNaN(t) && null !== t && !Array.isArray(t);
    }
    function J(t) {
        return null !== t && "object" === E(t) && !Array.isArray(t);
    }
    function K(t) {
        delete t.bbox, "Feature" === t.type ? t.geometry && K(t.geometry) : "FeatureCollection" === t.type ? t.features.forEach(K) : "GeometryCollection" === t.type && t.geometries.forEach(K);
    }
    function Q(t) {
        if (!t) throw new Error("bbox is required");
        if (!Array.isArray(t)) throw new Error("bbox must be an Array");
        if (4 !== t.length && 6 !== t.length) throw new Error("bbox must be an Array of 4 or 6 numbers");
        t.forEach(function(t) {
            if (!W(t)) throw new Error("bbox must only contain numbers");
        });
    }
    function $(t) {
        if (!t) throw new Error("id is required");
        if (-1 === [
            "string",
            "number"
        ].indexOf(E(t))) throw new Error("id must be a number or a string");
    }
    var tt = Object.freeze({
        __proto__: null,
        areaFactors: I,
        azimuthToBearing: X,
        bearingToAzimuth: j,
        convertArea: H,
        convertLength: Z,
        degreesToRadians: V,
        earthRadius: w,
        factors: b,
        feature: N,
        featureCollection: R,
        geometry: S,
        geometryCollection: q,
        isNumber: W,
        isObject: J,
        lengthToDegrees: z,
        lengthToRadians: B,
        lineString: T,
        lineStrings: O,
        multiLineString: A,
        multiPoint: D,
        multiPolygon: F,
        point: M,
        points: L,
        polygon: P,
        polygons: C,
        radiansToDegrees: U,
        radiansToLength: Y,
        removeBbox: K,
        round: G,
        validateBBox: Q,
        validateId: $
    });
    function et(t) {
        if (!t) throw new Error("coord is required");
        if (!Array.isArray(t)) {
            if ("Feature" === t.type && null !== t.geometry && "Point" === t.geometry.type) return _(t.geometry.coordinates);
            if ("Point" === t.type) return _(t.coordinates);
        }
        if (Array.isArray(t) && t.length >= 2 && !Array.isArray(t[0]) && !Array.isArray(t[1])) return _(t);
        throw new Error("coord must be GeoJSON Point or an Array of numbers");
    }
    function nt(t) {
        if (Array.isArray(t)) return t;
        if ("Feature" === t.type) {
            if (null !== t.geometry) return t.geometry.coordinates;
        } else if (t.coordinates) return t.coordinates;
        throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
    }
    function rt(t) {
        if (t.length > 1 && W(t[0]) && W(t[1])) return !0;
        if (Array.isArray(t[0]) && t[0].length) return rt(t[0]);
        throw new Error("coordinates must only contain numbers");
    }
    function it(t, e, n) {
        if (!e || !n) throw new Error("type and name required");
        if (!t || t.type !== e) throw new Error("Invalid input to " + n + ": must be a " + e + ", given " + t.type);
    }
    function ot(t, e, n) {
        if (!t) throw new Error("No feature passed");
        if (!n) throw new Error(".featureOf() requires a name");
        if (!t || "Feature" !== t.type || !t.geometry) throw new Error("Invalid input to " + n + ", Feature with geometry required");
        if (!t.geometry || t.geometry.type !== e) throw new Error("Invalid input to " + n + ": must be a " + e + ", given " + t.geometry.type);
    }
    function st(t, e, n) {
        if (!t) throw new Error("No featureCollection passed");
        if (!n) throw new Error(".collectionOf() requires a name");
        if (!t || "FeatureCollection" !== t.type) throw new Error("Invalid input to " + n + ", FeatureCollection required");
        var r, i = a(t.features);
        try {
            for(i.s(); !(r = i.n()).done;){
                var o = r.value;
                if (!o || "Feature" !== o.type || !o.geometry) throw new Error("Invalid input to " + n + ", Feature with geometry required");
                if (!o.geometry || o.geometry.type !== e) throw new Error("Invalid input to " + n + ": must be a " + e + ", given " + o.geometry.type);
            }
        } catch (t) {
            i.e(t);
        } finally{
            i.f();
        }
    }
    function at(t) {
        return "Feature" === t.type ? t.geometry : t;
    }
    function ut(t, e) {
        return "FeatureCollection" === t.type ? "FeatureCollection" : "GeometryCollection" === t.type ? "GeometryCollection" : "Feature" === t.type && null !== t.geometry ? t.geometry.type : t.type;
    }
    var lt = Object.freeze({
        __proto__: null,
        collectionOf: st,
        containsNumber: rt,
        featureOf: ot,
        geojsonType: it,
        getCoord: et,
        getCoords: nt,
        getGeom: at,
        getType: ut
    });
    function ht(t, e) {
        if (!0 === (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}).final) return function(t, e) {
            var n = ht(e, t);
            return (n = (n + 180) % 360) > 180 ? n - 360 : n;
        }(t, e);
        var n = et(t), r = et(e), i = V(n[0]), o = V(r[0]), s = V(n[1]), a = V(r[1]), u = Math.sin(o - i) * Math.cos(a), l = Math.cos(s) * Math.sin(a) - Math.sin(s) * Math.cos(a) * Math.cos(o - i);
        return U(Math.atan2(u, l));
    }
    function ct(t, e, n) {
        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}, i = et(t), o = V(i[0]), s = V(i[1]), a = V(n), u = B(e, r.units), l = Math.asin(Math.sin(s) * Math.cos(u) + Math.cos(s) * Math.sin(u) * Math.cos(a)), h = U(o + Math.atan2(Math.sin(a) * Math.sin(u) * Math.cos(s), Math.cos(u) - Math.sin(s) * Math.sin(l))), c = U(l);
        return void 0 !== i[2] ? M([
            h,
            c,
            i[2]
        ], r.properties) : M([
            h,
            c
        ], r.properties);
    }
    function ft(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, r = et(t), i = et(e), o = V(i[1] - r[1]), s = V(i[0] - r[0]), a = V(r[1]), u = V(i[1]), l = Math.pow(Math.sin(o / 2), 2) + Math.pow(Math.sin(s / 2), 2) * Math.cos(a) * Math.cos(u);
        return Y(2 * Math.atan2(Math.sqrt(l), Math.sqrt(1 - l)), n.units);
    }
    function vt(t, e) {
        var n;
        return (n = (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}).final ? gt(et(e), et(t)) : gt(et(t), et(e))) > 180 ? -(360 - n) : n;
    }
    function gt(t, e) {
        var n = V(t[1]), r = V(e[1]), i = V(e[0] - t[0]);
        i > Math.PI && (i -= 2 * Math.PI), i < -Math.PI && (i += 2 * Math.PI);
        var o = Math.log(Math.tan(r / 2 + Math.PI / 4) / Math.tan(n / 2 + Math.PI / 4));
        return (U(Math.atan2(i, o)) + 360) % 360;
    }
    function dt(t, e, n) {
        if (null !== t) for(var r, i, o, s, a, u, l, h, c = 0, f = 0, v = t.type, g = "FeatureCollection" === v, d = "Feature" === v, p = g ? t.features.length : 1, y = 0; y < p; y++){
            a = (h = !!(l = g ? t.features[y].geometry : d ? t.geometry : t) && "GeometryCollection" === l.type) ? l.geometries.length : 1;
            for(var m = 0; m < a; m++){
                var _ = 0, x = 0;
                if (null !== (s = h ? l.geometries[m] : l)) {
                    u = s.coordinates;
                    var E = s.type;
                    switch(c = !n || "Polygon" !== E && "MultiPolygon" !== E ? 0 : 1, E){
                        case null:
                            break;
                        case "Point":
                            if (!1 === e(u, f, y, _, x)) return !1;
                            f++, _++;
                            break;
                        case "LineString":
                        case "MultiPoint":
                            for(r = 0; r < u.length; r++){
                                if (!1 === e(u[r], f, y, _, x)) return !1;
                                f++, "MultiPoint" === E && _++;
                            }
                            "LineString" === E && _++;
                            break;
                        case "Polygon":
                        case "MultiLineString":
                            for(r = 0; r < u.length; r++){
                                for(i = 0; i < u[r].length - c; i++){
                                    if (!1 === e(u[r][i], f, y, _, x)) return !1;
                                    f++;
                                }
                                "MultiLineString" === E && _++, "Polygon" === E && x++;
                            }
                            "Polygon" === E && _++;
                            break;
                        case "MultiPolygon":
                            for(r = 0; r < u.length; r++){
                                for(x = 0, i = 0; i < u[r].length; i++){
                                    for(o = 0; o < u[r][i].length - c; o++){
                                        if (!1 === e(u[r][i][o], f, y, _, x)) return !1;
                                        f++;
                                    }
                                    x++;
                                }
                                _++;
                            }
                            break;
                        case "GeometryCollection":
                            for(r = 0; r < s.geometries.length; r++)if (!1 === dt(s.geometries[r], e, n)) return !1;
                            break;
                        default:
                            throw new Error("Unknown Geometry Type");
                    }
                }
            }
        }
    }
    function pt(t, e, n, r) {
        var i = n;
        return dt(t, function(t, r, o, s, a) {
            i = 0 === r && void 0 === n ? t : e(i, t, r, o, s, a);
        }, r), i;
    }
    function yt(t, e) {
        var n;
        switch(t.type){
            case "FeatureCollection":
                for(n = 0; n < t.features.length && !1 !== e(t.features[n].properties, n); n++);
                break;
            case "Feature":
                e(t.properties, 0);
        }
    }
    function mt(t, e, n) {
        var r = n;
        return yt(t, function(t, i) {
            r = 0 === i && void 0 === n ? t : e(r, t, i);
        }), r;
    }
    function _t(t, e) {
        if ("Feature" === t.type) e(t, 0);
        else if ("FeatureCollection" === t.type) for(var n = 0; n < t.features.length && !1 !== e(t.features[n], n); n++);
    }
    function xt(t, e, n) {
        var r = n;
        return _t(t, function(t, i) {
            r = 0 === i && void 0 === n ? t : e(r, t, i);
        }), r;
    }
    function Et(t) {
        var e = [];
        return dt(t, function(t) {
            e.push(t);
        }), e;
    }
    function kt(t, e) {
        var n, r, i, o, s, a, u, l, h, c, f = 0, v = "FeatureCollection" === t.type, g = "Feature" === t.type, d = v ? t.features.length : 1;
        for(n = 0; n < d; n++){
            for(a = v ? t.features[n].geometry : g ? t.geometry : t, l = v ? t.features[n].properties : g ? t.properties : {}, h = v ? t.features[n].bbox : g ? t.bbox : void 0, c = v ? t.features[n].id : g ? t.id : void 0, s = (u = !!a && "GeometryCollection" === a.type) ? a.geometries.length : 1, i = 0; i < s; i++)if (null !== (o = u ? a.geometries[i] : a)) switch(o.type){
                case "Point":
                case "LineString":
                case "MultiPoint":
                case "Polygon":
                case "MultiLineString":
                case "MultiPolygon":
                    if (!1 === e(o, f, l, h, c)) return !1;
                    break;
                case "GeometryCollection":
                    for(r = 0; r < o.geometries.length; r++)if (!1 === e(o.geometries[r], f, l, h, c)) return !1;
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
            else if (!1 === e(null, f, l, h, c)) return !1;
            f++;
        }
    }
    function wt(t, e, n) {
        var r = n;
        return kt(t, function(t, i, o, s, a) {
            r = 0 === i && void 0 === n ? t : e(r, t, i, o, s, a);
        }), r;
    }
    function bt(t, e) {
        kt(t, function(t, n, r, i, o) {
            var s, a = null === t ? null : t.type;
            switch(a){
                case null:
                case "Point":
                case "LineString":
                case "Polygon":
                    return !1 !== e(N(t, r, {
                        bbox: i,
                        id: o
                    }), n, 0) && void 0;
            }
            switch(a){
                case "MultiPoint":
                    s = "Point";
                    break;
                case "MultiLineString":
                    s = "LineString";
                    break;
                case "MultiPolygon":
                    s = "Polygon";
            }
            for(var u = 0; u < t.coordinates.length; u++){
                var l = t.coordinates[u];
                if (!1 === e(N({
                    type: s,
                    coordinates: l
                }, r), n, u)) return !1;
            }
        });
    }
    function It(t, e, n) {
        var r = n;
        return bt(t, function(t, i, o) {
            r = 0 === i && 0 === o && void 0 === n ? t : e(r, t, i, o);
        }), r;
    }
    function Nt(t, e) {
        bt(t, function(t, n, r) {
            var i = 0;
            if (t.geometry) {
                var o = t.geometry.type;
                if ("Point" !== o && "MultiPoint" !== o) {
                    var s, a = 0, u = 0, l = 0;
                    return !1 !== dt(t, function(o, h, c, f, v) {
                        if (void 0 === s || n > a || f > u || v > l) return s = o, a = n, u = f, l = v, void (i = 0);
                        var g = T([
                            s,
                            o
                        ], t.properties);
                        if (!1 === e(g, n, r, v, i)) return !1;
                        i++, s = o;
                    }) && void 0;
                }
            }
        });
    }
    function St(t, e, n) {
        var r = n, i = !1;
        return Nt(t, function(t, o, s, a, u) {
            r = !1 === i && void 0 === n ? t : e(r, t, o, s, a, u), i = !0;
        }), r;
    }
    function Mt(t, e) {
        if (!t) throw new Error("geojson is required");
        bt(t, function(t, n, r) {
            if (null !== t.geometry) {
                var i = t.geometry.type, o = t.geometry.coordinates;
                switch(i){
                    case "LineString":
                        if (!1 === e(t, n, r, 0, 0)) return !1;
                        break;
                    case "Polygon":
                        for(var s = 0; s < o.length; s++)if (!1 === e(T(o[s], t.properties), n, r, s)) return !1;
                }
            }
        });
    }
    function Lt(t, e, n) {
        var r = n;
        return Mt(t, function(t, i, o, s) {
            r = 0 === i && void 0 === n ? t : e(r, t, i, o, s);
        }), r;
    }
    function Pt(t, e) {
        if (!J(e = e || {})) throw new Error("options is invalid");
        var n, r = e.featureIndex || 0, i = e.multiFeatureIndex || 0, o = e.geometryIndex || 0, s = e.segmentIndex || 0, a = e.properties;
        switch(t.type){
            case "FeatureCollection":
                r < 0 && (r = t.features.length + r), a = a || t.features[r].properties, n = t.features[r].geometry;
                break;
            case "Feature":
                a = a || t.properties, n = t.geometry;
                break;
            case "Point":
            case "MultiPoint":
                return null;
            case "LineString":
            case "Polygon":
            case "MultiLineString":
            case "MultiPolygon":
                n = t;
                break;
            default:
                throw new Error("geojson is invalid");
        }
        if (null === n) return null;
        var u = n.coordinates;
        switch(n.type){
            case "Point":
            case "MultiPoint":
                return null;
            case "LineString":
                return s < 0 && (s = u.length + s - 1), T([
                    u[s],
                    u[s + 1]
                ], a, e);
            case "Polygon":
                return o < 0 && (o = u.length + o), s < 0 && (s = u[o].length + s - 1), T([
                    u[o][s],
                    u[o][s + 1]
                ], a, e);
            case "MultiLineString":
                return i < 0 && (i = u.length + i), s < 0 && (s = u[i].length + s - 1), T([
                    u[i][s],
                    u[i][s + 1]
                ], a, e);
            case "MultiPolygon":
                return i < 0 && (i = u.length + i), o < 0 && (o = u[i].length + o), s < 0 && (s = u[i][o].length - s - 1), T([
                    u[i][o][s],
                    u[i][o][s + 1]
                ], a, e);
        }
        throw new Error("geojson is invalid");
    }
    function Ct(t, e) {
        if (!J(e = e || {})) throw new Error("options is invalid");
        var n, r = e.featureIndex || 0, i = e.multiFeatureIndex || 0, o = e.geometryIndex || 0, s = e.coordIndex || 0, a = e.properties;
        switch(t.type){
            case "FeatureCollection":
                r < 0 && (r = t.features.length + r), a = a || t.features[r].properties, n = t.features[r].geometry;
                break;
            case "Feature":
                a = a || t.properties, n = t.geometry;
                break;
            case "Point":
            case "MultiPoint":
                return null;
            case "LineString":
            case "Polygon":
            case "MultiLineString":
            case "MultiPolygon":
                n = t;
                break;
            default:
                throw new Error("geojson is invalid");
        }
        if (null === n) return null;
        var u = n.coordinates;
        switch(n.type){
            case "Point":
                return M(u, a, e);
            case "MultiPoint":
                return i < 0 && (i = u.length + i), M(u[i], a, e);
            case "LineString":
                return s < 0 && (s = u.length + s), M(u[s], a, e);
            case "Polygon":
                return o < 0 && (o = u.length + o), s < 0 && (s = u[o].length + s), M(u[o][s], a, e);
            case "MultiLineString":
                return i < 0 && (i = u.length + i), s < 0 && (s = u[i].length + s), M(u[i][s], a, e);
            case "MultiPolygon":
                return i < 0 && (i = u.length + i), o < 0 && (o = u[i].length + o), s < 0 && (s = u[i][o].length - s), M(u[i][o][s], a, e);
        }
        throw new Error("geojson is invalid");
    }
    var Tt = Object.freeze({
        __proto__: null,
        coordAll: Et,
        coordEach: dt,
        coordReduce: pt,
        featureEach: _t,
        featureReduce: xt,
        findPoint: Ct,
        findSegment: Pt,
        flattenEach: bt,
        flattenReduce: It,
        geomEach: kt,
        geomReduce: wt,
        lineEach: Mt,
        lineReduce: Lt,
        propEach: yt,
        propReduce: mt,
        segmentEach: Nt,
        segmentReduce: St
    });
    function Ot(t) {
        return wt(t, function(t, e) {
            return t + function(t) {
                var e, n = 0;
                switch(t.type){
                    case "Polygon":
                        return Rt(t.coordinates);
                    case "MultiPolygon":
                        for(e = 0; e < t.coordinates.length; e++)n += Rt(t.coordinates[e]);
                        return n;
                    case "Point":
                    case "MultiPoint":
                    case "LineString":
                    case "MultiLineString":
                        return 0;
                }
                return 0;
            }(e);
        }, 0);
    }
    function Rt(t) {
        var e = 0;
        if (t && t.length > 0) {
            e += Math.abs(Ft(t[0]));
            for(var n = 1; n < t.length; n++)e -= Math.abs(Ft(t[n]));
        }
        return e;
    }
    var At = 20294876564838.72, Dt = Math.PI / 180;
    function Ft(t) {
        var e = t.length - 1;
        if (e <= 2) return 0;
        for(var n = 0, r = 0; r < e;){
            var i = t[r], o = t[r + 1 === e ? 0 : r + 1], s = t[r + 2 >= e ? (r + 2) % e : r + 2], a = i[0] * Dt, u = o[1] * Dt;
            n += (s[0] * Dt - a) * Math.sin(u), r++;
        }
        return n * At;
    }
    function qt(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        if (null != t.bbox && !0 !== e.recompute) return t.bbox;
        var n = [
            1 / 0,
            1 / 0,
            -1 / 0,
            -1 / 0
        ];
        return dt(t, function(t) {
            n[0] > t[0] && (n[0] = t[0]), n[1] > t[1] && (n[1] = t[1]), n[2] < t[0] && (n[2] = t[0]), n[3] < t[1] && (n[3] = t[1]);
        }), n;
    }
    function Gt(t, e) {
        var n, r, i, o, s, a, u;
        for(r = 1; r <= 8; r *= 2){
            for(n = [], o = !(Bt(i = t[t.length - 1], e) & r), s = 0; s < t.length; s++)(u = !(Bt(a = t[s], e) & r)) !== o && n.push(Yt(i, a, r, e)), u && n.push(a), i = a, o = u;
            if (!(t = n).length) break;
        }
        return n;
    }
    function Yt(t, e, n, r) {
        return 8 & n ? [
            t[0] + (e[0] - t[0]) * (r[3] - t[1]) / (e[1] - t[1]),
            r[3]
        ] : 4 & n ? [
            t[0] + (e[0] - t[0]) * (r[1] - t[1]) / (e[1] - t[1]),
            r[1]
        ] : 2 & n ? [
            r[2],
            t[1] + (e[1] - t[1]) * (r[2] - t[0]) / (e[0] - t[0])
        ] : 1 & n ? [
            r[0],
            t[1] + (e[1] - t[1]) * (r[0] - t[0]) / (e[0] - t[0])
        ] : null;
    }
    function Bt(t, e) {
        var n = 0;
        return t[0] < e[0] ? n |= 1 : t[0] > e[2] && (n |= 2), t[1] < e[1] ? n |= 4 : t[1] > e[3] && (n |= 8), n;
    }
    function zt(t, e) {
        var n, r = [], i = a(t);
        try {
            for(i.s(); !(n = i.n()).done;){
                var o = Gt(n.value, e);
                o.length > 0 && (o[0][0] === o[o.length - 1][0] && o[0][1] === o[o.length - 1][1] || o.push(o[0]), o.length >= 4 && r.push(o));
            }
        } catch (t) {
            i.e(t);
        } finally{
            i.f();
        }
        return r;
    }
    function jt(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = Number(t[0]), r = Number(t[1]), i = Number(t[2]), o = Number(t[3]);
        if (6 === t.length) throw new Error("@turf/bbox-polygon does not support BBox with 6 positions");
        var s = [
            n,
            r
        ];
        return P([
            [
                s,
                [
                    i,
                    r
                ],
                [
                    i,
                    o
                ],
                [
                    n,
                    o
                ],
                s
            ]
        ], e.properties, {
            bbox: t,
            id: e.id
        });
    }
    var Xt = function() {
        return s(function t(e) {
            i(this, t), this.points = e.points || [], this.duration = e.duration || 1e4, this.sharpness = e.sharpness || .85, this.centers = [], this.controls = [], this.stepLength = e.stepLength || 60, this.length = this.points.length, this.delay = 0;
            for(var n = 0; n < this.length; n++)this.points[n].z = this.points[n].z || 0;
            for(var r = 0; r < this.length - 1; r++){
                var o = this.points[r], s = this.points[r + 1];
                this.centers.push({
                    x: (o.x + s.x) / 2,
                    y: (o.y + s.y) / 2,
                    z: (o.z + s.z) / 2
                });
            }
            this.controls.push([
                this.points[0],
                this.points[0]
            ]);
            for(var a = 0; a < this.centers.length - 1; a++){
                var u = this.points[a + 1].x - (this.centers[a].x + this.centers[a + 1].x) / 2, l = this.points[a + 1].y - (this.centers[a].y + this.centers[a + 1].y) / 2, h = this.points[a + 1].z - (this.centers[a].z + this.centers[a + 1].z) / 2;
                this.controls.push([
                    {
                        x: (1 - this.sharpness) * this.points[a + 1].x + this.sharpness * (this.centers[a].x + u),
                        y: (1 - this.sharpness) * this.points[a + 1].y + this.sharpness * (this.centers[a].y + l),
                        z: (1 - this.sharpness) * this.points[a + 1].z + this.sharpness * (this.centers[a].z + h)
                    },
                    {
                        x: (1 - this.sharpness) * this.points[a + 1].x + this.sharpness * (this.centers[a + 1].x + u),
                        y: (1 - this.sharpness) * this.points[a + 1].y + this.sharpness * (this.centers[a + 1].y + l),
                        z: (1 - this.sharpness) * this.points[a + 1].z + this.sharpness * (this.centers[a + 1].z + h)
                    }
                ]);
            }
            return this.controls.push([
                this.points[this.length - 1],
                this.points[this.length - 1]
            ]), this.steps = this.cacheSteps(this.stepLength), this;
        }, [
            {
                key: "cacheSteps",
                value: function(t) {
                    var e = [], n = this.pos(0);
                    e.push(0);
                    for(var r = 0; r < this.duration; r += 10){
                        var i = this.pos(r);
                        Math.sqrt((i.x - n.x) * (i.x - n.x) + (i.y - n.y) * (i.y - n.y) + (i.z - n.z) * (i.z - n.z)) > t && (e.push(r), n = i);
                    }
                    return e;
                }
            },
            {
                key: "vector",
                value: function(t) {
                    var e = this.pos(t + 10), n = this.pos(t - 10);
                    return {
                        angle: 180 * Math.atan2(e.y - n.y, e.x - n.x) / 3.14,
                        speed: Math.sqrt((n.x - e.x) * (n.x - e.x) + (n.y - e.y) * (n.y - e.y) + (n.z - e.z) * (n.z - e.z))
                    };
                }
            },
            {
                key: "pos",
                value: function(t) {
                    var e = t - this.delay;
                    e < 0 && (e = 0), e > this.duration && (e = this.duration - 1);
                    var n = e / this.duration;
                    if (n >= 1) return this.points[this.length - 1];
                    var r = Math.floor((this.points.length - 1) * n);
                    return function(t, e, n, r, i) {
                        var o = function(t) {
                            var e = t * t, n = e * t;
                            return [
                                n,
                                3 * e * (1 - t),
                                3 * t * (1 - t) * (1 - t),
                                (1 - t) * (1 - t) * (1 - t)
                            ];
                        }(t), s = {
                            x: i.x * o[0] + r.x * o[1] + n.x * o[2] + e.x * o[3],
                            y: i.y * o[0] + r.y * o[1] + n.y * o[2] + e.y * o[3],
                            z: i.z * o[0] + r.z * o[1] + n.z * o[2] + e.z * o[3]
                        };
                        return s;
                    }((this.length - 1) * n - r, this.points[r], this.controls[r][1], this.controls[r + 1][0], this.points[r + 1]);
                }
            }
        ]);
    }();
    function Ut(t) {
        for(var e, n, r = nt(t), i = 0, o = 1; o < r.length;)e = n || r[0], i += ((n = r[o])[0] - e[0]) * (n[1] + e[1]), o++;
        return i > 0;
    }
    function Vt(t, e) {
        for(var n = 0, r = 0, i = 0, o = 0, s = 0, a = 0, u = 0, l = 0, h = null, c = null, f = t[0], v = t[1], g = e.length; n < g; n++){
            r = 0;
            var d = e[n].length - 1, p = e[n];
            if ((h = p[0])[0] !== p[d][0] && h[1] !== p[d][1]) throw new Error("First and last coordinates in a ring must be the same");
            for(s = h[0] - f, a = h[1] - v; r < d; r++)if (l = (c = p[r + 1])[1] - v, a < 0 && l < 0 || a > 0 && l > 0) a = l, s = (h = c)[0] - f;
            else {
                if (u = c[0] - t[0], l > 0 && a <= 0) {
                    if ((o = s * l - u * a) > 0) i += 1;
                    else if (0 === o) return 0;
                } else if (a > 0 && l <= 0) {
                    if ((o = s * l - u * a) < 0) i += 1;
                    else if (0 === o) return 0;
                } else if (0 === l && a < 0) {
                    if (0 === (o = s * l - u * a)) return 0;
                } else if (0 === a && l < 0) {
                    if (0 === (o = s * l - u * a)) return 0;
                } else if (0 === a && 0 === l) {
                    if (u <= 0 && s >= 0) return 0;
                    if (s <= 0 && u >= 0) return 0;
                }
                h = c, a = l, s = u;
            }
        }
        return i % 2 != 0;
    }
    function Zt(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        if (!t) throw new Error("point is required");
        if (!e) throw new Error("polygon is required");
        var r = et(t), i = at(e), o = i.type, s = e.bbox, a = i.coordinates;
        if (s && !1 === function(t, e) {
            return e[0] <= t[0] && e[1] <= t[1] && e[2] >= t[0] && e[3] >= t[1];
        }(r, s)) return !1;
        "Polygon" === o && (a = [
            a
        ]);
        for(var u = 0; u < a.length; ++u){
            var l = Vt(r, a[u]);
            if (0 === l && !n.ignoreBoundary) return !0;
            if (l) return !0;
        }
        return !1;
    }
    function Ht(t, e) {
        for(var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, r = et(t), i = nt(e), o = 0; o < i.length - 1; o++){
            var s = !1;
            if (n.ignoreEndVertices && (0 === o && (s = "start"), o === i.length - 2 && (s = "end"), 0 === o && o + 1 === i.length - 1 && (s = "both")), Wt(i[o], i[o + 1], r, s, void 0 === n.epsilon ? null : n.epsilon)) return !0;
        }
        return !1;
    }
    function Wt(t, e, n, r, i) {
        var o = n[0], s = n[1], a = t[0], u = t[1], l = e[0], h = e[1], c = l - a, f = h - u, v = (n[0] - a) * f - (n[1] - u) * c;
        if (null !== i) {
            if (Math.abs(v) > i) return !1;
        } else if (0 !== v) return !1;
        return Math.abs(c) === Math.abs(f) && 0 === Math.abs(c) ? !r && n[0] === t[0] && n[1] === t[1] : r ? "start" === r ? Math.abs(c) >= Math.abs(f) ? c > 0 ? a < o && o <= l : l <= o && o < a : f > 0 ? u < s && s <= h : h <= s && s < u : "end" === r ? Math.abs(c) >= Math.abs(f) ? c > 0 ? a <= o && o < l : l < o && o <= a : f > 0 ? u <= s && s < h : h < s && s <= u : "both" === r && (Math.abs(c) >= Math.abs(f) ? c > 0 ? a < o && o < l : l < o && o < a : f > 0 ? u < s && s < h : h < s && s < u) : Math.abs(c) >= Math.abs(f) ? c > 0 ? a <= o && o <= l : l <= o && o <= a : f > 0 ? u <= s && s <= h : h <= s && s <= u;
    }
    function Jt(t, e, n, r, i) {
        Kt(t, e, n || 0, r || t.length - 1, i || $t);
    }
    function Kt(t, e, n, r, i) {
        for(; r > n;){
            if (r - n > 600) {
                var o = r - n + 1, s = e - n + 1, a = Math.log(o), u = .5 * Math.exp(2 * a / 3), l = .5 * Math.sqrt(a * u * (o - u) / o) * (s - o / 2 < 0 ? -1 : 1);
                Kt(t, e, Math.max(n, Math.floor(e - s * u / o + l)), Math.min(r, Math.floor(e + (o - s) * u / o + l)), i);
            }
            var h = t[e], c = n, f = r;
            for(Qt(t, n, e), i(t[r], h) > 0 && Qt(t, n, r); c < f;){
                for(Qt(t, c, f), c++, f--; i(t[c], h) < 0;)c++;
                for(; i(t[f], h) > 0;)f--;
            }
            0 === i(t[n], h) ? Qt(t, n, f) : Qt(t, ++f, r), f <= e && (n = f + 1), e <= f && (r = f - 1);
        }
    }
    function Qt(t, e, n) {
        var r = t[e];
        t[e] = t[n], t[n] = r;
    }
    function $t(t, e) {
        return t < e ? -1 : t > e ? 1 : 0;
    }
    var te = function() {
        return s(function t() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 9;
            i(this, t), this._maxEntries = Math.max(4, e), this._minEntries = Math.max(2, Math.ceil(.4 * this._maxEntries)), this.clear();
        }, [
            {
                key: "all",
                value: function() {
                    return this._all(this.data, []);
                }
            },
            {
                key: "search",
                value: function(t) {
                    var e = this.data, n = [];
                    if (!fe(t, e)) return n;
                    for(var r = this.toBBox, i = []; e;){
                        for(var o = 0; o < e.children.length; o++){
                            var s = e.children[o], a = e.leaf ? r(s) : s;
                            fe(t, a) && (e.leaf ? n.push(s) : ce(t, a) ? this._all(s, n) : i.push(s));
                        }
                        e = i.pop();
                    }
                    return n;
                }
            },
            {
                key: "collides",
                value: function(t) {
                    var e = this.data;
                    if (!fe(t, e)) return !1;
                    for(var n = []; e;){
                        for(var r = 0; r < e.children.length; r++){
                            var i = e.children[r], o = e.leaf ? this.toBBox(i) : i;
                            if (fe(t, o)) {
                                if (e.leaf || ce(t, o)) return !0;
                                n.push(i);
                            }
                        }
                        e = n.pop();
                    }
                    return !1;
                }
            },
            {
                key: "load",
                value: function(t) {
                    if (!t || !t.length) return this;
                    if (t.length < this._minEntries) {
                        for(var e = 0; e < t.length; e++)this.insert(t[e]);
                        return this;
                    }
                    var n = this._build(t.slice(), 0, t.length - 1, 0);
                    if (this.data.children.length) {
                        if (this.data.height === n.height) this._splitRoot(this.data, n);
                        else {
                            if (this.data.height < n.height) {
                                var r = this.data;
                                this.data = n, n = r;
                            }
                            this._insert(n, this.data.height - n.height - 1, !0);
                        }
                    } else this.data = n;
                    return this;
                }
            },
            {
                key: "insert",
                value: function(t) {
                    return t && this._insert(t, this.data.height - 1), this;
                }
            },
            {
                key: "clear",
                value: function() {
                    return this.data = ve([]), this;
                }
            },
            {
                key: "remove",
                value: function(t, e) {
                    if (!t) return this;
                    for(var n, r, i, o = this.data, s = this.toBBox(t), a = [], u = []; o || a.length;){
                        if (o || (o = a.pop(), r = a[a.length - 1], n = u.pop(), i = !0), o.leaf) {
                            var l = ee(t, o.children, e);
                            if (-1 !== l) return o.children.splice(l, 1), a.push(o), this._condense(a), this;
                        }
                        i || o.leaf || !ce(o, s) ? r ? (n++, o = r.children[n], i = !1) : o = null : (a.push(o), u.push(n), n = 0, r = o, o = o.children[0]);
                    }
                    return this;
                }
            },
            {
                key: "toBBox",
                value: function(t) {
                    return t;
                }
            },
            {
                key: "compareMinX",
                value: function(t, e) {
                    return t.minX - e.minX;
                }
            },
            {
                key: "compareMinY",
                value: function(t, e) {
                    return t.minY - e.minY;
                }
            },
            {
                key: "toJSON",
                value: function() {
                    return this.data;
                }
            },
            {
                key: "fromJSON",
                value: function(t) {
                    return this.data = t, this;
                }
            },
            {
                key: "_all",
                value: function(t, e) {
                    for(var n = []; t;)t.leaf ? e.push.apply(e, _(t.children)) : n.push.apply(n, _(t.children)), t = n.pop();
                    return e;
                }
            },
            {
                key: "_build",
                value: function(t, e, n, r) {
                    var i, o = n - e + 1, s = this._maxEntries;
                    if (o <= s) return ne(i = ve(t.slice(e, n + 1)), this.toBBox), i;
                    r || (r = Math.ceil(Math.log(o) / Math.log(s)), s = Math.ceil(o / Math.pow(s, r - 1))), (i = ve([])).leaf = !1, i.height = r;
                    var a = Math.ceil(o / s), u = a * Math.ceil(Math.sqrt(s));
                    ge(t, e, n, u, this.compareMinX);
                    for(var l = e; l <= n; l += u){
                        var h = Math.min(l + u - 1, n);
                        ge(t, l, h, a, this.compareMinY);
                        for(var c = l; c <= h; c += a){
                            var f = Math.min(c + a - 1, h);
                            i.children.push(this._build(t, c, f, r - 1));
                        }
                    }
                    return ne(i, this.toBBox), i;
                }
            },
            {
                key: "_chooseSubtree",
                value: function(t, e, n, r) {
                    for(; r.push(e), !e.leaf && r.length - 1 !== n;){
                        for(var i = 1 / 0, o = 1 / 0, s = void 0, a = 0; a < e.children.length; a++){
                            var u = e.children[a], l = ae(u), h = le(t, u) - l;
                            h < o ? (o = h, i = l < i ? l : i, s = u) : h === o && l < i && (i = l, s = u);
                        }
                        e = s || e.children[0];
                    }
                    return e;
                }
            },
            {
                key: "_insert",
                value: function(t, e, n) {
                    var r = n ? t : this.toBBox(t), i = [], o = this._chooseSubtree(r, this.data, e, i);
                    for(o.children.push(t), ie(o, r); e >= 0 && i[e].children.length > this._maxEntries;)this._split(i, e), e--;
                    this._adjustParentBBoxes(r, i, e);
                }
            },
            {
                key: "_split",
                value: function(t, e) {
                    var n = t[e], r = n.children.length, i = this._minEntries;
                    this._chooseSplitAxis(n, i, r);
                    var o = this._chooseSplitIndex(n, i, r), s = ve(n.children.splice(o, n.children.length - o));
                    s.height = n.height, s.leaf = n.leaf, ne(n, this.toBBox), ne(s, this.toBBox), e ? t[e - 1].children.push(s) : this._splitRoot(n, s);
                }
            },
            {
                key: "_splitRoot",
                value: function(t, e) {
                    this.data = ve([
                        t,
                        e
                    ]), this.data.height = t.height + 1, this.data.leaf = !1, ne(this.data, this.toBBox);
                }
            },
            {
                key: "_chooseSplitIndex",
                value: function(t, e, n) {
                    for(var r, i = 1 / 0, o = 1 / 0, s = e; s <= n - e; s++){
                        var a = re(t, 0, s, this.toBBox), u = re(t, s, n, this.toBBox), l = he(a, u), h = ae(a) + ae(u);
                        l < i ? (i = l, r = s, o = h < o ? h : o) : l === i && h < o && (o = h, r = s);
                    }
                    return r || n - e;
                }
            },
            {
                key: "_chooseSplitAxis",
                value: function(t, e, n) {
                    var r = t.leaf ? this.compareMinX : oe, i = t.leaf ? this.compareMinY : se;
                    this._allDistMargin(t, e, n, r) < this._allDistMargin(t, e, n, i) && t.children.sort(r);
                }
            },
            {
                key: "_allDistMargin",
                value: function(t, e, n, r) {
                    t.children.sort(r);
                    for(var i = this.toBBox, o = re(t, 0, e, i), s = re(t, n - e, n, i), a = ue(o) + ue(s), u = e; u < n - e; u++){
                        var l = t.children[u];
                        ie(o, t.leaf ? i(l) : l), a += ue(o);
                    }
                    for(var h = n - e - 1; h >= e; h--){
                        var c = t.children[h];
                        ie(s, t.leaf ? i(c) : c), a += ue(s);
                    }
                    return a;
                }
            },
            {
                key: "_adjustParentBBoxes",
                value: function(t, e, n) {
                    for(var r = n; r >= 0; r--)ie(e[r], t);
                }
            },
            {
                key: "_condense",
                value: function(t) {
                    for(var e, n = t.length - 1; n >= 0; n--)0 === t[n].children.length ? n > 0 ? (e = t[n - 1].children).splice(e.indexOf(t[n]), 1) : this.clear() : ne(t[n], this.toBBox);
                }
            }
        ]);
    }();
    function ee(t, e, n) {
        if (!n) return e.indexOf(t);
        for(var r = 0; r < e.length; r++)if (n(t, e[r])) return r;
        return -1;
    }
    function ne(t, e) {
        re(t, 0, t.children.length, e, t);
    }
    function re(t, e, n, r, i) {
        i || (i = ve(null)), i.minX = 1 / 0, i.minY = 1 / 0, i.maxX = -1 / 0, i.maxY = -1 / 0;
        for(var o = e; o < n; o++){
            var s = t.children[o];
            ie(i, t.leaf ? r(s) : s);
        }
        return i;
    }
    function ie(t, e) {
        return t.minX = Math.min(t.minX, e.minX), t.minY = Math.min(t.minY, e.minY), t.maxX = Math.max(t.maxX, e.maxX), t.maxY = Math.max(t.maxY, e.maxY), t;
    }
    function oe(t, e) {
        return t.minX - e.minX;
    }
    function se(t, e) {
        return t.minY - e.minY;
    }
    function ae(t) {
        return (t.maxX - t.minX) * (t.maxY - t.minY);
    }
    function ue(t) {
        return t.maxX - t.minX + (t.maxY - t.minY);
    }
    function le(t, e) {
        return (Math.max(e.maxX, t.maxX) - Math.min(e.minX, t.minX)) * (Math.max(e.maxY, t.maxY) - Math.min(e.minY, t.minY));
    }
    function he(t, e) {
        var n = Math.max(t.minX, e.minX), r = Math.max(t.minY, e.minY), i = Math.min(t.maxX, e.maxX), o = Math.min(t.maxY, e.maxY);
        return Math.max(0, i - n) * Math.max(0, o - r);
    }
    function ce(t, e) {
        return t.minX <= e.minX && t.minY <= e.minY && e.maxX <= t.maxX && e.maxY <= t.maxY;
    }
    function fe(t, e) {
        return e.minX <= t.maxX && e.minY <= t.maxY && e.maxX >= t.minX && e.maxY >= t.minY;
    }
    function ve(t) {
        return {
            children: t,
            height: 1,
            leaf: !0,
            minX: 1 / 0,
            minY: 1 / 0,
            maxX: -1 / 0,
            maxY: -1 / 0
        };
    }
    function ge(t, e, n, r, i) {
        for(var o = [
            e,
            n
        ]; o.length;)if (!((n = o.pop()) - (e = o.pop()) <= r)) {
            var s = e + Math.ceil((n - e) / r / 2) * r;
            Jt(t, s, e, n, i), o.push(e, s, s, n);
        }
    }
    var de = Object.freeze({
        __proto__: null,
        default: te
    });
    function pe(t) {
        var e;
        if (t.bbox) e = t.bbox;
        else if (Array.isArray(t) && 4 === t.length) e = t;
        else if (Array.isArray(t) && 6 === t.length) e = [
            t[0],
            t[1],
            t[3],
            t[4]
        ];
        else if ("Feature" === t.type) e = qt(t);
        else {
            if ("FeatureCollection" !== t.type) throw new Error("invalid geojson");
            e = qt(t);
        }
        return {
            minX: e[0],
            minY: e[1],
            maxX: e[2],
            maxY: e[3]
        };
    }
    var ye = function() {
        return s(function t() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 9;
            i(this, t), this.tree = new te(e), this.tree.toBBox = pe;
        }, [
            {
                key: "insert",
                value: function(t) {
                    if ("Feature" !== t.type) throw new Error("invalid feature");
                    return t.bbox = t.bbox ? t.bbox : qt(t), this.tree.insert(t), this;
                }
            },
            {
                key: "load",
                value: function(t) {
                    var e = [];
                    return Array.isArray(t) ? t.forEach(function(t) {
                        if ("Feature" !== t.type) throw new Error("invalid features");
                        t.bbox = t.bbox ? t.bbox : qt(t), e.push(t);
                    }) : _t(t, function(t) {
                        if ("Feature" !== t.type) throw new Error("invalid features");
                        t.bbox = t.bbox ? t.bbox : qt(t), e.push(t);
                    }), this.tree.load(e), this;
                }
            },
            {
                key: "remove",
                value: function(t, e) {
                    if ("Feature" !== t.type) throw new Error("invalid feature");
                    return t.bbox = t.bbox ? t.bbox : qt(t), this.tree.remove(t, e), this;
                }
            },
            {
                key: "clear",
                value: function() {
                    return this.tree.clear(), this;
                }
            },
            {
                key: "search",
                value: function(t) {
                    return R(this.tree.search(pe(t)));
                }
            },
            {
                key: "collides",
                value: function(t) {
                    return this.tree.collides(pe(t));
                }
            },
            {
                key: "all",
                value: function() {
                    return R(this.tree.all());
                }
            },
            {
                key: "toJSON",
                value: function() {
                    return this.tree.toJSON();
                }
            },
            {
                key: "fromJSON",
                value: function(t) {
                    return this.tree.fromJSON(t), this;
                }
            }
        ]);
    }();
    function me(t) {
        return new ye(t);
    }
    function _e(t, e) {
        if (!J(e = null != e ? e : {})) throw new Error("options is invalid");
        var n = e.precision, r = e.coordinates, i = e.mutate;
        if (n = null == n || isNaN(n) ? 6 : n, r = null == r || isNaN(r) ? 3 : r, !t) throw new Error("<geojson> is required");
        if ("number" != typeof n) throw new Error("<precision> must be a number");
        if ("number" != typeof r) throw new Error("<coordinates> must be a number");
        !1 !== i && void 0 !== i || (t = JSON.parse(JSON.stringify(t)));
        var o = Math.pow(10, n);
        return dt(t, function(t) {
            !function(t, e, n) {
                t.length > n && t.splice(n, t.length);
                for(var r = 0; r < t.length; r++)t[r] = Math.round(t[r] * e) / e;
            }(t, o, r);
        }), t;
    }
    function xe(t) {
        if (!t) throw new Error("geojson is required");
        var e = [];
        return bt(t, function(t) {
            !function(t, e) {
                var n = [], r = t.geometry;
                if (null !== r) {
                    switch(r.type){
                        case "Polygon":
                            n = nt(r);
                            break;
                        case "LineString":
                            n = [
                                nt(r)
                            ];
                    }
                    n.forEach(function(n) {
                        var r = function(t, e) {
                            var n = [];
                            return t.reduce(function(t, r) {
                                var i = T([
                                    t,
                                    r
                                ], e);
                                return i.bbox = function(t, e) {
                                    var n = t[0], r = t[1], i = e[0], o = e[1], s = n < i ? n : i, a = r < o ? r : o, u = n > i ? n : i, l = r > o ? r : o;
                                    return [
                                        s,
                                        a,
                                        u,
                                        l
                                    ];
                                }(t, r), n.push(i), r;
                            }), n;
                        }(n, t.properties);
                        r.forEach(function(t) {
                            t.id = e.length, e.push(t);
                        });
                    });
                }
            }(t, e);
        }), R(e);
    }
    var Ee = function() {
        return s(function t() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ke;
            if (i(this, t), this.data = e, this.length = this.data.length, this.compare = n, this.length > 0) for(var r = (this.length >> 1) - 1; r >= 0; r--)this._down(r);
        }, [
            {
                key: "push",
                value: function(t) {
                    this.data.push(t), this.length++, this._up(this.length - 1);
                }
            },
            {
                key: "pop",
                value: function() {
                    if (0 !== this.length) {
                        var t = this.data[0], e = this.data.pop();
                        return this.length--, this.length > 0 && (this.data[0] = e, this._down(0)), t;
                    }
                }
            },
            {
                key: "peek",
                value: function() {
                    return this.data[0];
                }
            },
            {
                key: "_up",
                value: function(t) {
                    for(var e = this.data, n = this.compare, r = e[t]; t > 0;){
                        var i = t - 1 >> 1, o = e[i];
                        if (n(r, o) >= 0) break;
                        e[t] = o, t = i;
                    }
                    e[t] = r;
                }
            },
            {
                key: "_down",
                value: function(t) {
                    for(var e = this.data, n = this.compare, r = this.length >> 1, i = e[t]; t < r;){
                        var o = 1 + (t << 1), s = e[o], a = o + 1;
                        if (a < this.length && n(e[a], s) < 0 && (o = a, s = e[a]), n(s, i) >= 0) break;
                        e[t] = s, t = o;
                    }
                    e[t] = i;
                }
            }
        ]);
    }();
    function ke(t, e) {
        return t < e ? -1 : t > e ? 1 : 0;
    }
    var we = Object.freeze({
        __proto__: null,
        default: Ee
    }), be = 134217729;
    function Ie(t, e, n, r, i) {
        var o, s, a, u, l = e[0], h = r[0], c = 0, f = 0;
        h > l == h > -l ? (o = l, l = e[++c]) : (o = h, h = r[++f]);
        var v = 0;
        if (c < t && f < n) for(h > l == h > -l ? (a = o - ((s = l + o) - l), l = e[++c]) : (a = o - ((s = h + o) - h), h = r[++f]), o = s, 0 !== a && (i[v++] = a); c < t && f < n;)h > l == h > -l ? (a = o - ((s = o + l) - (u = s - o)) + (l - u), l = e[++c]) : (a = o - ((s = o + h) - (u = s - o)) + (h - u), h = r[++f]), o = s, 0 !== a && (i[v++] = a);
        for(; c < t;)a = o - ((s = o + l) - (u = s - o)) + (l - u), l = e[++c], o = s, 0 !== a && (i[v++] = a);
        for(; f < n;)a = o - ((s = o + h) - (u = s - o)) + (h - u), h = r[++f], o = s, 0 !== a && (i[v++] = a);
        return 0 === o && 0 !== v || (i[v++] = o), v;
    }
    function Ne(t) {
        return new Float64Array(t);
    }
    var Se = Ne(4), Me = Ne(8), Le = Ne(12), Pe = Ne(16), Ce = Ne(4);
    function Te(t, e, n, r, i, o) {
        var s = (e - o) * (n - i), a = (t - i) * (r - o), u = s - a;
        if (0 === s || 0 === a || s > 0 != a > 0) return u;
        var l = Math.abs(s + a);
        return Math.abs(u) >= 33306690738754716e-32 * l ? u : -function(t, e, n, r, i, o, s) {
            var a, u, l, h, c, f, v, g, d, p, y, m, _, x, E, k, w, b, I = t - i, N = n - i, S = e - o, M = r - o;
            c = (E = (g = I - (v = (f = be * I) - (f - I))) * (p = M - (d = (f = be * M) - (f - M))) - ((x = I * M) - v * d - g * d - v * p)) - (y = E - (w = (g = S - (v = (f = be * S) - (f - S))) * (p = N - (d = (f = be * N) - (f - N))) - ((k = S * N) - v * d - g * d - v * p))), Se[0] = E - (y + c) + (c - w), c = (_ = x - ((m = x + y) - (c = m - x)) + (y - c)) - (y = _ - k), Se[1] = _ - (y + c) + (c - k), c = (b = m + y) - m, Se[2] = m - (b - c) + (y - c), Se[3] = b;
            var L = function(t, e) {
                for(var n = e[0], r = 1; r < t; r++)n += e[r];
                return n;
            }(4, Se), P = 22204460492503146e-32 * s;
            if (L >= P || -L >= P) return L;
            if (a = t - (I + (c = t - I)) + (c - i), l = n - (N + (c = n - N)) + (c - i), u = e - (S + (c = e - S)) + (c - o), h = r - (M + (c = r - M)) + (c - o), 0 === a && 0 === u && 0 === l && 0 === h) return L;
            if (P = 11093356479670487e-47 * s + 33306690738754706e-32 * Math.abs(L), (L += I * h + M * a - (S * l + N * u)) >= P || -L >= P) return L;
            c = (E = (g = a - (v = (f = be * a) - (f - a))) * (p = M - (d = (f = be * M) - (f - M))) - ((x = a * M) - v * d - g * d - v * p)) - (y = E - (w = (g = u - (v = (f = be * u) - (f - u))) * (p = N - (d = (f = be * N) - (f - N))) - ((k = u * N) - v * d - g * d - v * p))), Ce[0] = E - (y + c) + (c - w), c = (_ = x - ((m = x + y) - (c = m - x)) + (y - c)) - (y = _ - k), Ce[1] = _ - (y + c) + (c - k), c = (b = m + y) - m, Ce[2] = m - (b - c) + (y - c), Ce[3] = b;
            var C = Ie(4, Se, 4, Ce, Me);
            c = (E = (g = I - (v = (f = be * I) - (f - I))) * (p = h - (d = (f = be * h) - (f - h))) - ((x = I * h) - v * d - g * d - v * p)) - (y = E - (w = (g = S - (v = (f = be * S) - (f - S))) * (p = l - (d = (f = be * l) - (f - l))) - ((k = S * l) - v * d - g * d - v * p))), Ce[0] = E - (y + c) + (c - w), c = (_ = x - ((m = x + y) - (c = m - x)) + (y - c)) - (y = _ - k), Ce[1] = _ - (y + c) + (c - k), c = (b = m + y) - m, Ce[2] = m - (b - c) + (y - c), Ce[3] = b;
            var T = Ie(C, Me, 4, Ce, Le);
            c = (E = (g = a - (v = (f = be * a) - (f - a))) * (p = h - (d = (f = be * h) - (f - h))) - ((x = a * h) - v * d - g * d - v * p)) - (y = E - (w = (g = u - (v = (f = be * u) - (f - u))) * (p = l - (d = (f = be * l) - (f - l))) - ((k = u * l) - v * d - g * d - v * p))), Ce[0] = E - (y + c) + (c - w), c = (_ = x - ((m = x + y) - (c = m - x)) + (y - c)) - (y = _ - k), Ce[1] = _ - (y + c) + (c - k), c = (b = m + y) - m, Ce[2] = m - (b - c) + (y - c), Ce[3] = b;
            var O = Ie(T, Le, 4, Ce, Pe);
            return Pe[O - 1];
        }(t, e, n, r, i, o, l);
    }
    function Oe(t, e) {
        var n = new Ee([], Re);
        return function(t, e) {
            if ("FeatureCollection" === t.type) for(var n = t.features, r = 0; r < n.length; r++)Ge(n[r], e);
            else Ge(t, e);
        }(t, n), function(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], n = [], r = new Ee([], Ae);
            for(; t.length;){
                var i = t.pop();
                if (i.isLeftEndpoint) {
                    for(var o = new Be(i), s = 0; s < r.data.length; s++){
                        var a = r.data[s];
                        if (!e || a.leftSweepEvent.featureId !== i.featureId) {
                            var u = ze(o, a);
                            !1 !== u && n.push(u);
                        }
                    }
                    r.push(o);
                } else !1 === i.isLeftEndpoint && r.pop();
            }
            return n;
        }(n, e);
    }
    function Re(t, e) {
        return t.p.x > e.p.x ? 1 : t.p.x < e.p.x ? -1 : t.p.x !== e.p.x || t.featureId === e.featureId && t.ringId === e.ringId || !t.isLeftEndpoint || e.isLeftEndpoint ? t.p.y !== e.p.y ? t.p.y > e.p.y ? 1 : -1 : 1 : -1;
    }
    function Ae(t, e) {
        return t.rightSweepEvent.p.x > e.rightSweepEvent.p.x ? 1 : t.rightSweepEvent.p.x < e.rightSweepEvent.p.x ? -1 : t.rightSweepEvent.p.y !== e.rightSweepEvent.p.y ? t.rightSweepEvent.p.y < e.rightSweepEvent.p.y ? 1 : -1 : 1;
    }
    var De = 0, Fe = 0, qe = 0;
    function Ge(t, e) {
        var n = "Feature" === t.type ? t.geometry : t, r = n.coordinates;
        "Polygon" !== n.type && "MultiLineString" !== n.type || (r = [
            r
        ]), "LineString" === n.type && (r = [
            [
                r
            ]
        ]);
        for(var i = 0; i < r.length; i++)for(var o = 0; o < r[i].length; o++){
            var s = r[i][o][0], a = null;
            Fe += 1;
            for(var u = 0; u < r[i][o].length - 1; u++){
                a = r[i][o][u + 1];
                var l = new Ye(s, De, Fe, qe), h = new Ye(a, De, Fe, qe + 1);
                l.otherEvent = h, h.otherEvent = l, Re(l, h) > 0 ? (h.isLeftEndpoint = !0, l.isLeftEndpoint = !1) : (l.isLeftEndpoint = !0, h.isLeftEndpoint = !1), e.push(l), e.push(h), s = a, qe += 1;
            }
        }
        De += 1;
    }
    var Ye = function() {
        return s(function t(e, n, r, o) {
            i(this, t), this.p = {
                x: e[0],
                y: e[1]
            }, this.featureId = n, this.ringId = r, this.eventId = o, this.otherEvent = null, this.isLeftEndpoint = null;
        }, [
            {
                key: "isSamePoint",
                value: function(t) {
                    return this.p.x === t.p.x && this.p.y === t.p.y;
                }
            },
            {
                key: "asNewXY",
                value: function() {
                    return [
                        this.p.x,
                        this.p.y
                    ];
                }
            }
        ]);
    }();
    var Be = s(function t(e) {
        i(this, t), this.leftSweepEvent = e, this.rightSweepEvent = e.otherEvent;
    });
    function ze(t, e) {
        if (null === t || null === e) return !1;
        var n = t.leftSweepEvent.p.x, r = t.leftSweepEvent.p.y, i = t.rightSweepEvent.p.x, o = t.rightSweepEvent.p.y, s = e.leftSweepEvent.p.x, a = e.leftSweepEvent.p.y, u = e.rightSweepEvent.p.x, l = e.rightSweepEvent.p.y, h = Te(n, r, i, o, s, a), c = Te(n, r, i, o, u, l);
        if (h > 0 && c > 0) return !1;
        if (h < 0 && c < 0) return !1;
        if (t.leftSweepEvent.ringId === e.leftSweepEvent.ringId) {
            if (t.rightSweepEvent.isSamePoint(e.leftSweepEvent) || t.rightSweepEvent.isSamePoint(e.rightSweepEvent) || t.leftSweepEvent.isSamePoint(e.leftSweepEvent) || t.leftSweepEvent.isSamePoint(e.rightSweepEvent)) return !1;
        } else {
            if (t.rightSweepEvent.isSamePoint(e.leftSweepEvent)) return e.leftSweepEvent.asNewXY();
            if (t.rightSweepEvent.isSamePoint(e.rightSweepEvent)) return e.rightSweepEvent.asNewXY();
            if (t.leftSweepEvent.isSamePoint(e.leftSweepEvent)) return e.leftSweepEvent.asNewXY();
            if (t.leftSweepEvent.isSamePoint(e.rightSweepEvent)) return e.rightSweepEvent.asNewXY();
        }
        var f = (l - a) * (i - n) - (u - s) * (o - r), v = (u - s) * (r - a) - (l - a) * (n - s), g = (i - n) * (r - a) - (o - r) * (n - s);
        if (0 === f) return !1;
        var d = v / f, p = g / f;
        return d >= 0 && d <= 1 && p >= 0 && p <= 1 && [
            n + d * (i - n),
            r + d * (o - r)
        ];
    }
    function je(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, r = n.removeDuplicates, i = void 0 === r || r, o = n.ignoreSelfIntersections, s = void 0 === o || o, a = [];
        "FeatureCollection" === t.type ? a = a.concat(t.features) : "Feature" === t.type ? a.push(t) : "LineString" !== t.type && "Polygon" !== t.type && "MultiLineString" !== t.type && "MultiPolygon" !== t.type || a.push(N(t)), "FeatureCollection" === e.type ? a = a.concat(e.features) : "Feature" === e.type ? a.push(e) : "LineString" !== e.type && "Polygon" !== e.type && "MultiLineString" !== e.type && "MultiPolygon" !== e.type || a.push(N(e));
        var u = Oe(R(a), s), l = [];
        if (i) {
            var h = {};
            u.forEach(function(t) {
                var e = t.join(",");
                h[e] || (h[e] = !0, l.push(t));
            });
        } else l = u;
        return R(l.map(function(t) {
            return M(t);
        }));
    }
    var Xe = Object.defineProperty, Ue = Object.defineProperties, Ve = Object.getOwnPropertyDescriptors, Ze = Object.getOwnPropertySymbols, He = Object.prototype.hasOwnProperty, We = Object.prototype.propertyIsEnumerable, Je = function(t, e, n) {
        return e in t ? Xe(t, e, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: n
        }) : t[e] = n;
    }, Ke = function(t, e) {
        for(var n in e || (e = {}))He.call(e, n) && Je(t, n, e[n]);
        if (Ze) {
            var r, i = a(Ze(e));
            try {
                for(i.s(); !(r = i.n()).done;){
                    n = r.value;
                    We.call(e, n) && Je(t, n, e[n]);
                }
            } catch (t) {
                i.e(t);
            } finally{
                i.f();
            }
        }
        return t;
    }, Qe = function(t, e) {
        return Ue(t, Ve(e));
    };
    function $e(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        if (!t || !e) throw new Error("lines and inputPoint are required arguments");
        var r = et(e), i = M([
            1 / 0,
            1 / 0
        ], {
            lineStringIndex: -1,
            segmentIndex: -1,
            totalDistance: -1,
            lineDistance: -1,
            segmentDistance: -1,
            pointDistance: 1 / 0,
            multiFeatureIndex: -1,
            index: -1,
            location: -1,
            dist: 1 / 0
        }), o = 0, s = 0, a = -1;
        return bt(t, function(t, u, l) {
            a !== l && (a = l, s = 0);
            for(var h = nt(t), c = 0; c < h.length - 1; c++){
                var f = M(h[c]), v = et(f), g = M(h[c + 1]), d = et(g), p = ft(f, g, n), y = void 0, _ = void 0;
                if (d[0] === r[0] && d[1] === r[1]) y = d, _ = !0;
                else if (v[0] === r[0] && v[1] === r[1]) y = v, _ = !1;
                else {
                    var x = m(sn(v, d, r), 2);
                    y = x[0], _ = x[1];
                }
                var E = ft(e, y, n);
                if (E < i.properties.pointDistance) {
                    var k = ft(f, y, n);
                    (i = M(y, {
                        lineStringIndex: l,
                        segmentIndex: _ ? c + 1 : c,
                        totalDistance: o + k,
                        lineDistance: s + k,
                        segmentDistance: k,
                        pointDistance: E,
                        multiFeatureIndex: -1,
                        index: -1,
                        location: -1,
                        dist: 1 / 0
                    })).properties = Qe(Ke({}, i.properties), {
                        multiFeatureIndex: i.properties.lineStringIndex,
                        index: i.properties.segmentIndex,
                        location: i.properties.totalDistance,
                        dist: i.properties.pointDistance
                    });
                }
                o += p, s += p;
            }
        }), i;
    }
    function tn(t, e) {
        var n = m(t, 3), r = n[0], i = n[1], o = n[2], s = m(e, 3);
        return r * s[0] + i * s[1] + o * s[2];
    }
    function en(t, e) {
        var n = m(t, 3), r = n[0], i = n[1], o = n[2], s = m(e, 3), a = s[0], u = s[1], l = s[2];
        return [
            i * l - o * u,
            o * a - r * l,
            r * u - i * a
        ];
    }
    function nn(t) {
        var e = function(t) {
            return Math.sqrt(Math.pow(t[0], 2) + Math.pow(t[1], 2) + Math.pow(t[2], 2));
        }(t);
        return [
            t[0] / e,
            t[1] / e,
            t[2] / e
        ];
    }
    function rn(t) {
        var e = V(t[1]), n = V(t[0]);
        return [
            Math.cos(e) * Math.cos(n),
            Math.cos(e) * Math.sin(n),
            Math.sin(e)
        ];
    }
    function on(t) {
        var e = m(t, 3), n = e[0], r = e[1], i = e[2], o = Math.min(Math.max(i, -1), 1), s = U(Math.asin(o));
        return [
            U(Math.atan2(r, n)),
            s
        ];
    }
    function sn(t, e, n) {
        var r = rn(t), i = rn(e), o = rn(n), s = en(r, i);
        if (0 === s[0] && 0 === s[1] && 0 === s[2]) return tn(r, i) > 0 ? [
            _(e),
            !0
        ] : [
            _(n),
            !1
        ];
        var a = en(s, o);
        if (0 === a[0] && 0 === a[1] && 0 === a[2]) return [
            _(e),
            !0
        ];
        var u = nn(en(a, s)), l = [
            -u[0],
            -u[1],
            -u[2]
        ], h = tn(o, u) > tn(o, l) ? u : l, c = nn(s), f = tn(en(r, h), c), v = tn(en(h, i), c);
        return f >= 0 && v >= 0 ? [
            on(h),
            !1
        ] : tn(r, o) > tn(i, o) ? [
            _(t),
            !1
        ] : [
            _(e),
            !0
        ];
    }
    function an(t, e) {
        if (!t) throw new Error("line is required");
        if (!e) throw new Error("splitter is required");
        var n = ut(t), r = ut(e);
        if ("LineString" !== n) throw new Error("line must be LineString");
        if ("FeatureCollection" === r) throw new Error("splitter cannot be a FeatureCollection");
        if ("GeometryCollection" === r) throw new Error("splitter cannot be a GeometryCollection");
        var i = _e(e, {
            precision: 7
        });
        switch("Feature" !== t.type && (t = N(t)), r){
            case "Point":
                return ln(t, i);
            case "MultiPoint":
                return un(t, i);
            case "LineString":
            case "MultiLineString":
            case "Polygon":
            case "MultiPolygon":
                return un(t, je(t, i, {
                    ignoreSelfIntersections: !0
                }));
        }
    }
    function un(t, e) {
        var n = [], r = me();
        return bt(e, function(e) {
            if (n.forEach(function(t, e) {
                t.id = e;
            }), n.length) {
                var i = r.search(e);
                if (i.features.length) {
                    var o = hn(e, i);
                    n = n.filter(function(t) {
                        return t.id !== o.id;
                    }), r.remove(o), _t(ln(o, e), function(t) {
                        n.push(t), r.insert(t);
                    });
                }
            } else n = ln(t, e).features, r.load(R(n));
        }), R(n);
    }
    function ln(t, e) {
        var n = [], r = nt(t)[0], i = nt(t)[t.geometry.coordinates.length - 1];
        if (cn(r, et(e)) || cn(i, et(e))) return R([
            t
        ]);
        var o = me(), s = xe(t);
        o.load(s);
        var a = o.search(e);
        if (!a.features.length) return R([
            t
        ]);
        var u = hn(e, a), l = xt(s, function(t, r, i) {
            var o = nt(r)[1], s = et(e);
            return i === u.id ? (t.push(s), n.push(T(t)), cn(s, o) ? [
                s
            ] : [
                s,
                o
            ]) : (t.push(o), t);
        }, [
            r
        ]);
        return l.length > 1 && n.push(T(l)), R(n);
    }
    function hn(t, e) {
        if (!e.features.length) throw new Error("lines must contain features");
        if (1 === e.features.length) return e.features[0];
        var n, r = 1 / 0;
        return _t(e, function(e) {
            var i = $e(e, t).properties.pointDistance;
            i < r && (n = e, r = i);
        }), n;
    }
    function cn(t, e) {
        return t[0] === e[0] && t[1] === e[1];
    }
    function fn(t, e) {
        var n = at(t), r = at(e), i = n.type, o = r.type, s = n.coordinates, u = r.coordinates;
        switch(i){
            case "Point":
                if ("Point" === o) return En(s, u);
                throw new Error("feature2 " + o + " geometry not supported");
            case "MultiPoint":
                switch(o){
                    case "Point":
                        return function(t, e) {
                            var n, r = !1;
                            for(n = 0; n < t.coordinates.length; n++)if (En(t.coordinates[n], e.coordinates)) {
                                r = !0;
                                break;
                            }
                            return r;
                        }(n, r);
                    case "MultiPoint":
                        return function(t, e) {
                            var n, r = a(e.coordinates);
                            try {
                                for(r.s(); !(n = r.n()).done;){
                                    var i, o = n.value, s = !1, u = a(t.coordinates);
                                    try {
                                        for(u.s(); !(i = u.n()).done;)if (En(o, i.value)) {
                                            s = !0;
                                            break;
                                        }
                                    } catch (t) {
                                        u.e(t);
                                    } finally{
                                        u.f();
                                    }
                                    if (!s) return !1;
                                }
                            } catch (t) {
                                r.e(t);
                            } finally{
                                r.f();
                            }
                            return !0;
                        }(n, r);
                    default:
                        throw new Error("feature2 " + o + " geometry not supported");
                }
            case "LineString":
                switch(o){
                    case "Point":
                        return Ht(r, n, {
                            ignoreEndVertices: !0
                        });
                    case "LineString":
                        return function(t, e) {
                            for(var n = !1, r = e.coordinates, i = 0; i < r.length; i++){
                                var o = r[i];
                                if (!Ht(o, t)) return !1;
                                if (!n) {
                                    if (Ht(o, t, {
                                        ignoreEndVertices: !0
                                    })) n = !0;
                                    else if (i > 0) Ht([
                                        (r[i - 1][0] + o[0]) / 2,
                                        (r[i - 1][1] + o[1]) / 2
                                    ], t, {
                                        ignoreEndVertices: !0
                                    }) && (n = !0);
                                }
                            }
                            return n;
                        }(n, r);
                    case "MultiPoint":
                        return function(t, e) {
                            var n, r = !1, i = a(e.coordinates);
                            try {
                                for(i.s(); !(n = i.n()).done;){
                                    var o = n.value;
                                    if (!Ht(o, t)) return !1;
                                    !r && Ht(o, t, {
                                        ignoreEndVertices: !0
                                    }) && (r = !0);
                                }
                            } catch (t) {
                                i.e(t);
                            } finally{
                                i.f();
                            }
                            return r;
                        }(n, r);
                    default:
                        throw new Error("feature2 " + o + " geometry not supported");
                }
            case "Polygon":
                switch(o){
                    case "Point":
                        return Zt(r, n, {
                            ignoreBoundary: !0
                        });
                    case "LineString":
                        return gn(n, r);
                    case "Polygon":
                        return pn(n, r);
                    case "MultiPoint":
                        return function(t, e) {
                            var n, r = !1, i = a(e.coordinates);
                            try {
                                for(i.s(); !(n = i.n()).done;){
                                    var o = n.value;
                                    if (!Zt(o, t)) return !1;
                                    r || (r = Zt(o, t, {
                                        ignoreBoundary: !0
                                    }));
                                }
                            } catch (t) {
                                i.e(t);
                            } finally{
                                i.f();
                            }
                            return r;
                        }(n, r);
                    case "MultiPolygon":
                        return function(t, e) {
                            return e.coordinates.every(function(e) {
                                return pn(t, {
                                    type: "Polygon",
                                    coordinates: e
                                });
                            });
                        }(n, r);
                    default:
                        throw new Error("feature2 " + o + " geometry not supported");
                }
            case "MultiPolygon":
                switch(o){
                    case "Point":
                        return function(t, e) {
                            return Zt(e, t, {
                                ignoreBoundary: !0
                            });
                        }(n, r);
                    case "MultiPoint":
                        return function(t, e) {
                            var n, r = !1, i = a(e.coordinates);
                            try {
                                for(i.s(); !(n = i.n()).done;){
                                    var o = n.value;
                                    if (!Zt(o, t)) return !1;
                                    r || (r = Zt(o, t, {
                                        ignoreBoundary: !0
                                    }));
                                }
                            } catch (t) {
                                i.e(t);
                            } finally{
                                i.f();
                            }
                            return r;
                        }(n, r);
                    case "LineString":
                        return function(t, e) {
                            return t.coordinates.some(function(t) {
                                return gn({
                                    type: "Polygon",
                                    coordinates: t
                                }, e);
                            });
                        }(n, r);
                    case "MultiLineString":
                        return function(t, e) {
                            var n, r = !1, i = a(e.coordinates);
                            try {
                                for(i.s(); !(n = i.n()).done;){
                                    var o, s = {
                                        type: "LineString",
                                        coordinates: n.value
                                    }, u = "outside", l = a(t.coordinates);
                                    try {
                                        for(l.s(); !(o = l.n()).done;){
                                            var h = dn({
                                                type: "Polygon",
                                                coordinates: o.value
                                            }, s);
                                            if ("interior" === h) {
                                                u = h;
                                                break;
                                            }
                                            "boundary" === h && (u = h);
                                        }
                                    } catch (t) {
                                        l.e(t);
                                    } finally{
                                        l.f();
                                    }
                                    if ("outside" === u) return !1;
                                    "interior" === u && (r = !0);
                                }
                            } catch (t) {
                                i.e(t);
                            } finally{
                                i.f();
                            }
                            return r;
                        }(n, r);
                    case "Polygon":
                        return function(t, e) {
                            var n = qt(e);
                            return t.coordinates.some(function(t) {
                                return pn({
                                    type: "Polygon",
                                    coordinates: t
                                }, e, n);
                            });
                        }(n, r);
                    case "MultiPolygon":
                        return function(t, e) {
                            var n, r = a(e.coordinates);
                            try {
                                var i, o = function() {
                                    var e = {
                                        type: "Polygon",
                                        coordinates: n.value
                                    }, r = qt(e);
                                    if (!t.coordinates.some(function(t) {
                                        return pn({
                                            type: "Polygon",
                                            coordinates: t
                                        }, e, r);
                                    })) return {
                                        v: !1
                                    };
                                };
                                for(r.s(); !(n = r.n()).done;)if (i = o()) return i.v;
                            } catch (t) {
                                r.e(t);
                            } finally{
                                r.f();
                            }
                            return !0;
                        }(n, r);
                    default:
                        throw new Error("feature2 " + o + " geometry not supported");
                }
            default:
                throw new Error("feature1 " + i + " geometry not supported");
        }
    }
    function vn(t, e) {
        for(var n = t.coordinates, r = [], i = 0; i < n.length - 1; i++){
            var o = T([
                n[i],
                n[i + 1]
            ]), s = an(o, N(e));
            0 === s.features.length ? r.push(o) : r.push.apply(r, _(s.features));
        }
        return R(r);
    }
    function gn(t, e) {
        return "interior" === dn(t, e);
    }
    function dn(t, e) {
        if (!xn(qt(t), qt(e))) return "outside";
        var n, r = a(e.coordinates);
        try {
            for(r.s(); !(n = r.n()).done;){
                if (!Zt(n.value, t)) return "outside";
            }
        } catch (t) {
            r.e(t);
        } finally{
            r.f();
        }
        var i, o = !1, s = a(vn(e, t).features);
        try {
            for(s.s(); !(i = s.n()).done;){
                var u = i.value, l = kn(u.geometry.coordinates[0], u.geometry.coordinates[1]);
                if (!Zt(l, t)) return "outside";
                !o && Zt(l, t, {
                    ignoreBoundary: !0
                }) && (o = !0);
            }
        } catch (t) {
            s.e(t);
        } finally{
            s.f();
        }
        return o ? "interior" : "boundary";
    }
    function pn(t, e, n) {
        if ("Feature" === t.type && null === t.geometry) return !1;
        if ("Feature" === e.type && null === e.geometry) return !1;
        if (!xn(qt(t), null != n ? n : qt(e))) return !1;
        var r, i = at(t), o = a(at(e).coordinates);
        try {
            for(o.s(); !(r = o.n()).done;){
                var s, u = r.value, l = a(u);
                try {
                    for(l.s(); !(s = l.n()).done;){
                        if (!Zt(s.value, t)) return !1;
                    }
                } catch (t) {
                    l.e(t);
                } finally{
                    l.f();
                }
                var h, c = a(vn({
                    type: "LineString",
                    coordinates: u
                }, i).features);
                try {
                    for(c.s(); !(h = c.n()).done;){
                        var f = h.value, v = kn(f.geometry.coordinates[0], f.geometry.coordinates[1]);
                        if (!Zt(v, t) && !_n(v, i)) return !1;
                    }
                } catch (t) {
                    c.e(t);
                } finally{
                    c.f();
                }
            }
        } catch (t) {
            o.e(t);
        } finally{
            o.f();
        }
        return !0;
    }
    var yn = 1e-6;
    function mn(t, e, n) {
        var r = n[0] - e[0], i = n[1] - e[1], o = r * r + i * i, s = 0;
        o > 0 && (s = ((t[0] - e[0]) * r + (t[1] - e[1]) * i) / o, s = Math.max(0, Math.min(1, s)));
        var a = e[0] + s * r, u = e[1] + s * i, l = t[0] - a, h = t[1] - u;
        return Math.sqrt(l * l + h * h);
    }
    function _n(t, e) {
        return e.coordinates.some(function(e) {
            for(var n = 0; n < e.length - 1; n++)if (mn(t, e[n], e[n + 1]) <= yn) return !0;
            return !1;
        });
    }
    function xn(t, e) {
        return !(t[0] > e[0]) && !(t[2] < e[2]) && !(t[1] > e[1]) && !(t[3] < e[3]);
    }
    function En(t, e) {
        return t[0] === e[0] && t[1] === e[1];
    }
    function kn(t, e) {
        return [
            (t[0] + e[0]) / 2,
            (t[1] + e[1]) / 2
        ];
    }
    function wn(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = at(t);
        switch(e.properties || "Feature" !== t.type || (e.properties = t.properties), n.type){
            case "Polygon":
                return function(t) {
                    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = at(t), r = n.coordinates, i = e.properties ? e.properties : "Feature" === t.type ? t.properties : {};
                    return bn(r, i);
                }(n, e);
            case "MultiPolygon":
                return function(t) {
                    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = at(t), r = n.coordinates, i = e.properties ? e.properties : "Feature" === t.type ? t.properties : {}, o = [];
                    return r.forEach(function(t) {
                        o.push(bn(t, i));
                    }), R(o);
                }(n, e);
            default:
                throw new Error("invalid poly");
        }
    }
    function bn(t, e) {
        return t.length > 1 ? A(t, e) : T(t[0], e);
    }
    var In = Object.defineProperty, Nn = function(t, e) {
        return In(t, "name", {
            value: e,
            configurable: !0
        });
    }, Sn = function() {
        return s(function t(e) {
            var n, r, o;
            i(this, t), this.direction = !1, this.compareProperties = !0, this.precision = Math.pow(10, -(null != (n = null == e ? void 0 : e.precision) ? n : 17)), this.direction = null != (r = null == e ? void 0 : e.direction) && r, this.compareProperties = null == (o = null == e ? void 0 : e.compareProperties) || o;
        }, [
            {
                key: "compare",
                value: function(t, e) {
                    var n = this;
                    if (t.type !== e.type) return !1;
                    if (!Ln(t, e)) return !1;
                    switch(t.type){
                        case "Point":
                            return this.compareCoord(t.coordinates, e.coordinates);
                        case "LineString":
                            return this.compareLine(t.coordinates, e.coordinates);
                        case "Polygon":
                            return this.comparePolygon(t, e);
                        case "GeometryCollection":
                            return this.compareGeometryCollection(t, e);
                        case "Feature":
                            return this.compareFeature(t, e);
                        case "FeatureCollection":
                            return this.compareFeatureCollection(t, e);
                        default:
                            if (t.type.startsWith("Multi")) {
                                var r = Pn(t), i = Pn(e);
                                return r.every(function(t) {
                                    return i.some(function(e) {
                                        return n.compare(t, e);
                                    });
                                });
                            }
                    }
                    return !1;
                }
            },
            {
                key: "compareCoord",
                value: function(t, e) {
                    var n = this;
                    return t.length === e.length && t.every(function(t, r) {
                        return Math.abs(t - e[r]) < n.precision;
                    });
                }
            },
            {
                key: "compareLine",
                value: function(t, e) {
                    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                    if (!Ln(t, e)) return !1;
                    var i = t, o = e;
                    if (r && !this.compareCoord(i[0], o[0])) {
                        var s = this.fixStartIndex(o, i);
                        if (!s) return !1;
                        o = s;
                    }
                    var a = this.compareCoord(i[n], o[n]);
                    return this.direction || a ? this.comparePath(i, o) : !!this.compareCoord(i[n], o[o.length - (1 + n)]) && this.comparePath(i.slice().reverse(), o);
                }
            },
            {
                key: "fixStartIndex",
                value: function(t, e) {
                    for(var n, r = -1, i = 0; i < t.length; i++)if (this.compareCoord(t[i], e[0])) {
                        r = i;
                        break;
                    }
                    return r >= 0 && (n = [].concat(t.slice(r, t.length), t.slice(1, r + 1))), n;
                }
            },
            {
                key: "comparePath",
                value: function(t, e) {
                    var n = this;
                    return t.every(function(t, r) {
                        return n.compareCoord(t, e[r]);
                    });
                }
            },
            {
                key: "comparePolygon",
                value: function(t, e) {
                    var n = this;
                    if (this.compareLine(t.coordinates[0], e.coordinates[0], 1, !0)) {
                        var r = t.coordinates.slice(1, t.coordinates.length), i = e.coordinates.slice(1, e.coordinates.length);
                        return r.every(function(t) {
                            return i.some(function(e) {
                                return n.compareLine(t, e, 1, !0);
                            });
                        });
                    }
                    return !1;
                }
            },
            {
                key: "compareGeometryCollection",
                value: function(t, e) {
                    var n = this;
                    return Ln(t.geometries, e.geometries) && this.compareBBox(t, e) && t.geometries.every(function(t, r) {
                        return n.compare(t, e.geometries[r]);
                    });
                }
            },
            {
                key: "compareFeature",
                value: function(t, e) {
                    return t.id === e.id && (!this.compareProperties || Tn(t.properties, e.properties)) && this.compareBBox(t, e) && this.compare(t.geometry, e.geometry);
                }
            },
            {
                key: "compareFeatureCollection",
                value: function(t, e) {
                    var n = this;
                    return Ln(t.features, e.features) && this.compareBBox(t, e) && t.features.every(function(t, r) {
                        return n.compare(t, e.features[r]);
                    });
                }
            },
            {
                key: "compareBBox",
                value: function(t, e) {
                    return Boolean(!t.bbox && !e.bbox) || !(!t.bbox || !e.bbox) && this.compareCoord(t.bbox, e.bbox);
                }
            }
        ]);
    }();
    Nn(Sn, "GeojsonEquality");
    var Mn = Sn;
    function Ln(t, e) {
        return t.coordinates ? t.coordinates.length === e.coordinates.length : t.length === e.length;
    }
    function Pn(t) {
        return t.coordinates.map(function(e) {
            return {
                type: t.type.replace("Multi", ""),
                coordinates: e
            };
        });
    }
    function Cn(t, e, n) {
        return new Mn(n).compare(t, e);
    }
    function Tn(t, e) {
        if (null === t && null === e) return !0;
        if (null === t || null === e) return !1;
        var n = Object.keys(t), r = Object.keys(e);
        if (n.length !== r.length) return !1;
        for(var i = 0, o = n; i < o.length; i++){
            var s = o[i], a = t[s], u = e[s], l = An(a) && An(u);
            if (l && !Tn(a, u) || !l && a !== u) return !1;
        }
        return !0;
    }
    Nn(Ln, "sameLength"), Nn(Pn, "explode"), Nn(Cn, "geojsonEquality"), Nn(Tn, "equal");
    var On, Rn, An = Nn(function(t) {
        return null != t && "object" === E(t);
    }, "isObject");
    function Dn(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = "object" === E(e) ? e.mutate : e;
        if (!t) throw new Error("geojson is required");
        var r = ut(t), i = [];
        switch(r){
            case "LineString":
                i = Fn(t, r);
                break;
            case "MultiLineString":
            case "Polygon":
                nt(t).forEach(function(t) {
                    i.push(Fn(t, r));
                });
                break;
            case "MultiPolygon":
                nt(t).forEach(function(t) {
                    var e = [];
                    t.forEach(function(t) {
                        e.push(Fn(t, r));
                    }), i.push(e);
                });
                break;
            case "Point":
                return t;
            case "MultiPoint":
                var o = {};
                nt(t).forEach(function(t) {
                    var e = t.join("-");
                    Object.prototype.hasOwnProperty.call(o, e) || (i.push(t), o[e] = !0);
                });
                break;
            default:
                throw new Error(r + " geometry not supported");
        }
        return t.coordinates ? !0 === n ? (t.coordinates = i, t) : {
            type: r,
            coordinates: i
        } : !0 === n ? (t.geometry.coordinates = i, t) : N({
            type: r,
            coordinates: i
        }, t.properties, {
            bbox: t.bbox,
            id: t.id
        });
    }
    function Fn(t, e) {
        var n = nt(t);
        if (2 === n.length && !qn(n[0], n[1])) return n;
        var r = [], i = 0, o = 1, s = 2;
        for(r.push(n[i]); s < n.length;)Ht(n[o], T([
            n[i],
            n[s]
        ])) ? o = s : (r.push(n[o]), i = o, s = ++o), s++;
        if (r.push(n[o]), "Polygon" === e || "MultiPolygon" === e) {
            if (Ht(r[0], T([
                r[1],
                r[r.length - 2]
            ])) && (r.shift(), r.pop(), r.push(r[0])), r.length < 4) throw new Error("invalid polygon, fewer than 4 points");
            if (!qn(r[0], r[r.length - 1])) throw new Error("invalid polygon, first and last points not equal");
        }
        return r;
    }
    function qn(t, e) {
        return t[0] === e[0] && t[1] === e[1];
    }
    function Gn(t, e) {
        var n = (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}).precision;
        if ("number" != typeof (n = null == n || isNaN(n) ? 6 : n) || !(n >= 0)) throw new Error("precision must be a positive number");
        return at(t).type === at(e).type && Cn(Dn(t), Dn(e), {
            precision: n
        });
    }
    function Yn(t, e) {
        var n = at(t), r = at(e), i = n.type, o = r.type;
        switch(i){
            case "MultiPoint":
                switch(o){
                    case "LineString":
                        return Bn(n, r);
                    case "Polygon":
                        return jn(n, r);
                    default:
                        throw new Error("feature2 " + o + " geometry not supported");
                }
            case "LineString":
                switch(o){
                    case "MultiPoint":
                        return Bn(r, n);
                    case "LineString":
                        return function(t, e) {
                            var n = je(t, e);
                            if (0 === n.features.length) return !1;
                            var r, i = a(n.features);
                            try {
                                for(i.s(); !(r = i.n()).done;){
                                    var o = r.value;
                                    if (!(Gn(o, M(t.coordinates[0])) || Gn(o, M(t.coordinates[t.coordinates.length - 1])) || Gn(o, M(e.coordinates[0])) || Gn(o, M(e.coordinates[e.coordinates.length - 1])))) return !0;
                                }
                            } catch (t) {
                                i.e(t);
                            } finally{
                                i.f();
                            }
                            return !1;
                        }(n, r);
                    case "Polygon":
                        return zn(n, r);
                    default:
                        throw new Error("feature2 " + o + " geometry not supported");
                }
            case "Polygon":
                switch(o){
                    case "MultiPoint":
                        return jn(r, n);
                    case "LineString":
                        return zn(r, n);
                    default:
                        throw new Error("feature2 " + o + " geometry not supported");
                }
            default:
                throw new Error("feature1 " + i + " geometry not supported");
        }
    }
    function Bn(t, e) {
        for(var n = !1, r = !1, i = t.coordinates.length, o = 0; o < i && (!n || !r); o++){
            for(var s = !1, a = 0; a < e.coordinates.length - 1; a++){
                var u = !0;
                if (0 !== a && a !== e.coordinates.length - 2 || (u = !1), Xn(e.coordinates[a], e.coordinates[a + 1], t.coordinates[o], u)) {
                    s = !0;
                    break;
                }
            }
            s ? n = !0 : r = !0;
        }
        return n && r;
    }
    function zn(t, e) {
        return je(t, wn(e)).features.length > 0;
    }
    function jn(t, e) {
        for(var n = !1, r = !1, i = t.coordinates.length, o = 0; o < i && (!n || !r); o++)Zt(M(t.coordinates[o]), e) ? n = !0 : r = !0;
        return r && n;
    }
    function Xn(t, e, n, r) {
        var i = n[0] - t[0], o = n[1] - t[1], s = e[0] - t[0], a = e[1] - t[1];
        return 0 === i * a - o * s && (r ? Math.abs(s) >= Math.abs(a) ? s > 0 ? t[0] <= n[0] && n[0] <= e[0] : e[0] <= n[0] && n[0] <= t[0] : a > 0 ? t[1] <= n[1] && n[1] <= e[1] : e[1] <= n[1] && n[1] <= t[1] : Math.abs(s) >= Math.abs(a) ? s > 0 ? t[0] < n[0] && n[0] < e[0] : e[0] < n[0] && n[0] < t[0] : a > 0 ? t[1] < n[1] && n[1] < e[1] : e[1] < n[1] && n[1] < t[1]);
    }
    function Un(t, e) {
        var n = (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
            ignoreSelfIntersections: !0
        }).ignoreSelfIntersections, r = void 0 === n || n, i = !0;
        return bt(t, function(t) {
            bt(e, function(e) {
                if (!1 === i) return !1;
                i = function(t, e, n) {
                    switch(t.type){
                        case "Point":
                            switch(e.type){
                                case "Point":
                                    return r = t.coordinates, i = e.coordinates, !(r[0] === i[0] && r[1] === i[1]);
                                case "LineString":
                                    return !Vn(e, t);
                                case "Polygon":
                                    return !Zt(t, e);
                            }
                            break;
                        case "LineString":
                            switch(e.type){
                                case "Point":
                                    return !Vn(t, e);
                                case "LineString":
                                    return !function(t, e, n) {
                                        var r = je(t, e, {
                                            ignoreSelfIntersections: n
                                        });
                                        if (r.features.length > 0) return !0;
                                        var i, o = a(t.coordinates);
                                        try {
                                            for(o.s(); !(i = o.n()).done;){
                                                if (Vn(e, {
                                                    type: "Point",
                                                    coordinates: i.value
                                                })) return !0;
                                            }
                                        } catch (t) {
                                            o.e(t);
                                        } finally{
                                            o.f();
                                        }
                                        var s, u = a(e.coordinates);
                                        try {
                                            for(u.s(); !(s = u.n()).done;){
                                                if (Vn(t, {
                                                    type: "Point",
                                                    coordinates: s.value
                                                })) return !0;
                                            }
                                        } catch (t) {
                                            u.e(t);
                                        } finally{
                                            u.f();
                                        }
                                        return !1;
                                    }(t, e, n);
                                case "Polygon":
                                    return !Zn(e, t, n);
                            }
                            break;
                        case "Polygon":
                            switch(e.type){
                                case "Point":
                                    return !Zt(e, t);
                                case "LineString":
                                    return !Zn(t, e, n);
                                case "Polygon":
                                    return !function(t, e, n) {
                                        var r, i = a(t.coordinates[0]);
                                        try {
                                            for(i.s(); !(r = i.n()).done;){
                                                if (Zt(r.value, e)) return !0;
                                            }
                                        } catch (t) {
                                            i.e(t);
                                        } finally{
                                            i.f();
                                        }
                                        var o, s = a(e.coordinates[0]);
                                        try {
                                            for(s.s(); !(o = s.n()).done;){
                                                if (Zt(o.value, t)) return !0;
                                            }
                                        } catch (t) {
                                            s.e(t);
                                        } finally{
                                            s.f();
                                        }
                                        var u = je(wn(t), wn(e), {
                                            ignoreSelfIntersections: n
                                        });
                                        if (u.features.length > 0) return !0;
                                        return !1;
                                    }(e, t, n);
                            }
                    }
                    var r, i;
                    return !1;
                }(t.geometry, e.geometry, r);
            });
        }), i;
    }
    function Vn(t, e) {
        for(var n = 0; n < t.coordinates.length - 1; n++)if (Hn(t.coordinates[n], t.coordinates[n + 1], e.coordinates)) return !0;
        return !1;
    }
    function Zn(t, e, n) {
        var r, i = a(e.coordinates);
        try {
            for(i.s(); !(r = i.n()).done;){
                if (Zt(r.value, t)) return !0;
            }
        } catch (t) {
            i.e(t);
        } finally{
            i.f();
        }
        return je(e, wn(t), {
            ignoreSelfIntersections: n
        }).features.length > 0;
    }
    function Hn(t, e, n) {
        var r = n[0] - t[0], i = n[1] - t[1], o = e[0] - t[0], s = e[1] - t[1];
        return 0 === r * s - i * o && (Math.abs(o) >= Math.abs(s) ? o > 0 ? t[0] <= n[0] && n[0] <= e[0] : e[0] <= n[0] && n[0] <= t[0] : s > 0 ? t[1] <= n[1] && n[1] <= e[1] : e[1] <= n[1] && n[1] <= t[1]);
    }
    function Wn(t, e) {
        var n = (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}).ignoreSelfIntersections;
        return !Un(t, e, {
            ignoreSelfIntersections: void 0 === n || n
        });
    }
    function Jn(t) {
        return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
    }
    function Kn(t) {
        if (Object.prototype.hasOwnProperty.call(t, "__esModule")) return t;
        var e = t.default;
        if ("function" == typeof e) {
            var n = function t() {
                var n = !1;
                try {
                    n = this instanceof t;
                } catch (t) {}
                return n ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
            };
            n.prototype = e.prototype;
        } else n = {};
        return Object.defineProperty(n, "__esModule", {
            value: !0
        }), Object.keys(t).forEach(function(e) {
            var r = Object.getOwnPropertyDescriptor(t, e);
            Object.defineProperty(n, e, r.get ? r : {
                enumerable: !0,
                get: function() {
                    return t[e];
                }
            });
        }), n;
    }
    var Qn = (Rn || (Rn = 1, On = function t(e, n) {
        if (e === n) return !0;
        if (e && n && "object" == E(e) && "object" == E(n)) {
            if (e.constructor !== n.constructor) return !1;
            var r, i, o;
            if (Array.isArray(e)) {
                if ((r = e.length) != n.length) return !1;
                for(i = r; 0 !== i--;)if (!t(e[i], n[i])) return !1;
                return !0;
            }
            if (e.constructor === RegExp) return e.source === n.source && e.flags === n.flags;
            if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === n.valueOf();
            if (e.toString !== Object.prototype.toString) return e.toString() === n.toString();
            if ((r = (o = Object.keys(e)).length) !== Object.keys(n).length) return !1;
            for(i = r; 0 !== i--;)if (!Object.prototype.hasOwnProperty.call(n, o[i])) return !1;
            for(i = r; 0 !== i--;){
                var s = o[i];
                if (!t(e[s], n[s])) return !1;
            }
            return !0;
        }
        return e != e && n != n;
    }), On), $n = Jn(Qn);
    function tr(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        if (!J(n = n || {})) throw new Error("options is invalid");
        var r, i = n.tolerance || 0, o = [], s = me(), a = xe(t);
        s.load(a);
        var u = [];
        return Nt(e, function(t) {
            var e = !1;
            if (t) {
                var n = t;
                if (0 !== i) {
                    var a = z(i, "kilometers"), l = qt(t);
                    n = [
                        l[0] - a,
                        l[1] - a,
                        l[2] + a,
                        l[3] + a
                    ];
                }
                _t(s.search(n), function(n) {
                    if (!1 === e) {
                        var o = nt(t).sort(), s = nt(n).sort();
                        if ($n(o, s)) e = !0, r = r ? er(r, t) || r : t;
                        else if (0 === i ? Ht(o[0], n) && Ht(o[1], n) : $e(n, o[0]).properties.pointDistance <= i && $e(n, o[1]).properties.pointDistance <= i) e = !0, r = r ? er(r, t) || r : t;
                        else if (0 === i ? Ht(s[0], t) && Ht(s[1], t) : $e(t, s[0]).properties.pointDistance <= i && $e(t, s[1]).properties.pointDistance <= i) {
                            if (r) {
                                var a = er(r, n);
                                a ? r = a : u.push(n);
                            } else r = n;
                        }
                    }
                }), !1 === e && r && (o.push(r), u.length && (o = o.concat(u), u = []), r = void 0);
            }
        }), r && o.push(r), R(o);
    }
    function er(t, e) {
        var n = nt(e), r = nt(t), i = r[0], o = r[r.length - 1], s = t.geometry.coordinates;
        if ($n(n[0], i)) s.unshift(n[1]);
        else if ($n(n[0], o)) s.push(n[1]);
        else if ($n(n[1], i)) s.unshift(n[0]);
        else {
            if (!$n(n[1], o)) return;
            s.push(n[0]);
        }
        return t;
    }
    function nr(t, e) {
        var n = j(vt(t[0], t[1])), r = j(vt(e[0], e[1]));
        return n === r || (r - n) % 180 == 0;
    }
    function rr(t, e) {
        if (t.geometry && t.geometry.type) return t.geometry.type;
        if (t.type) return t.type;
        throw new Error("Invalid GeoJSON object for " + e);
    }
    function ir(t, e) {
        return !!or(e.coordinates[0], t.coordinates) || !!or(e.coordinates[e.coordinates.length - 1], t.coordinates);
    }
    function or(t, e) {
        return t[0] === e[0] && t[1] === e[1];
    }
    var sr = new Set([
        "Point",
        "LineString",
        "MultiLineString",
        "MultiPoint",
        "Polygon",
        "MultiPolygon"
    ]);
    function ar(t) {
        return t[0][0] === t[t.length - 1][0] && t[0][1] === t[t.length - 1][1];
    }
    function ur(t) {
        for(var e = 0; e < t.length - 1; e++)for(var n = t[e], r = e + 1; r < t.length - 2; r++){
            if (Ht(n, T([
                t[r],
                t[r + 1]
            ]))) return !0;
        }
        return !1;
    }
    function lr(t, e, n) {
        for(var r = P(t), i = n + 1; i < e.length; i++)if (!Un(r, P(e[i])) && Yn(r, T(e[i][0]))) return !1;
        return !0;
    }
    function hr(t, e) {
        return fn(e, t);
    }
    function cr(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = qt(t);
        return M([
            (n[0] + n[2]) / 2,
            (n[1] + n[3]) / 2
        ], e.properties, e);
    }
    var fr, vr = {
        exports: {}
    };
    var gr = (fr || (fr = 1, function(t) {
        t.exports = function() {
            function t(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            function e(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            function n(t, n, r) {
                return n && e(t.prototype, n), r && e(t, r), t;
            }
            function r(t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                t.prototype = Object.create(e && e.prototype, {
                    constructor: {
                        value: t,
                        writable: !0,
                        configurable: !0
                    }
                }), e && o(t, e);
            }
            function i(t) {
                return i = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
                    return t.__proto__ || Object.getPrototypeOf(t);
                }, i(t);
            }
            function o(t, e) {
                return o = Object.setPrototypeOf || function(t, e) {
                    return t.__proto__ = e, t;
                }, o(t, e);
            }
            function s() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (t) {
                    return !1;
                }
            }
            function a(t, e, n) {
                return a = s() ? Reflect.construct : function(t, e, n) {
                    var r = [
                        null
                    ];
                    r.push.apply(r, e);
                    var i = new (Function.bind.apply(t, r));
                    return n && o(i, n.prototype), i;
                }, a.apply(null, arguments);
            }
            function u(t) {
                var e = "function" == typeof Map ? new Map : void 0;
                return u = function(t) {
                    if (null === t || (n = t, -1 === Function.toString.call(n).indexOf("[native code]"))) return t;
                    var n;
                    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
                    if (void 0 !== e) {
                        if (e.has(t)) return e.get(t);
                        e.set(t, r);
                    }
                    function r() {
                        return a(t, arguments, i(this).constructor);
                    }
                    return r.prototype = Object.create(t.prototype, {
                        constructor: {
                            value: r,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), o(r, t);
                }, u(t);
            }
            function l(t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            }
            function h(t, e) {
                if (e && ("object" == E(e) || "function" == typeof e)) return e;
                if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
                return l(t);
            }
            function c(t) {
                var e = s();
                return function() {
                    var n, r = i(t);
                    if (e) {
                        var o = i(this).constructor;
                        n = Reflect.construct(r, arguments, o);
                    } else n = r.apply(this, arguments);
                    return h(this, n);
                };
            }
            function f(t, e, n) {
                return f = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(t, e, n) {
                    var r = function(t, e) {
                        for(; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = i(t)););
                        return t;
                    }(t, e);
                    if (r) {
                        var o = Object.getOwnPropertyDescriptor(r, e);
                        return o.get ? o.get.call(n) : o.value;
                    }
                }, f(t, e, n || t);
            }
            function v(t) {
                return function(t) {
                    if (Array.isArray(t)) return d(t);
                }(t) || function(t) {
                    if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
                }(t) || g(t) || function() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }();
            }
            function g(t, e) {
                if (t) {
                    if ("string" == typeof t) return d(t, e);
                    var n = Object.prototype.toString.call(t).slice(8, -1);
                    return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? d(t, e) : void 0;
                }
            }
            function d(t, e) {
                (null == e || e > t.length) && (e = t.length);
                for(var n = 0, r = new Array(e); n < e; n++)r[n] = t[n];
                return r;
            }
            function p(t, e) {
                var n = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                if (!n) {
                    if (Array.isArray(t) || (n = g(t)) || e) {
                        n && (t = n);
                        var r = 0, i = function() {};
                        return {
                            s: i,
                            n: function() {
                                return r >= t.length ? {
                                    done: !0
                                } : {
                                    done: !1,
                                    value: t[r++]
                                };
                            },
                            e: function(t) {
                                throw t;
                            },
                            f: i
                        };
                    }
                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                var o, s = !0, a = !1;
                return {
                    s: function() {
                        n = n.call(t);
                    },
                    n: function() {
                        var t = n.next();
                        return s = t.done, t;
                    },
                    e: function(t) {
                        a = !0, o = t;
                    },
                    f: function() {
                        try {
                            s || null == n.return || n.return();
                        } finally{
                            if (a) throw o;
                        }
                    }
                };
            }
            var y = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "getEndCapStyle",
                        value: function() {
                            return this._endCapStyle;
                        }
                    },
                    {
                        key: "isSingleSided",
                        value: function() {
                            return this._isSingleSided;
                        }
                    },
                    {
                        key: "setQuadrantSegments",
                        value: function(t) {
                            this._quadrantSegments = t, 0 === this._quadrantSegments && (this._joinStyle = e.JOIN_BEVEL), this._quadrantSegments < 0 && (this._joinStyle = e.JOIN_MITRE, this._mitreLimit = Math.abs(this._quadrantSegments)), t <= 0 && (this._quadrantSegments = 1), this._joinStyle !== e.JOIN_ROUND && (this._quadrantSegments = e.DEFAULT_QUADRANT_SEGMENTS);
                        }
                    },
                    {
                        key: "getJoinStyle",
                        value: function() {
                            return this._joinStyle;
                        }
                    },
                    {
                        key: "setJoinStyle",
                        value: function(t) {
                            this._joinStyle = t;
                        }
                    },
                    {
                        key: "setSimplifyFactor",
                        value: function(t) {
                            this._simplifyFactor = t < 0 ? 0 : t;
                        }
                    },
                    {
                        key: "getSimplifyFactor",
                        value: function() {
                            return this._simplifyFactor;
                        }
                    },
                    {
                        key: "getQuadrantSegments",
                        value: function() {
                            return this._quadrantSegments;
                        }
                    },
                    {
                        key: "setEndCapStyle",
                        value: function(t) {
                            this._endCapStyle = t;
                        }
                    },
                    {
                        key: "getMitreLimit",
                        value: function() {
                            return this._mitreLimit;
                        }
                    },
                    {
                        key: "setMitreLimit",
                        value: function(t) {
                            this._mitreLimit = t;
                        }
                    },
                    {
                        key: "setSingleSided",
                        value: function(t) {
                            this._isSingleSided = t;
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            if (this._quadrantSegments = e.DEFAULT_QUADRANT_SEGMENTS, this._endCapStyle = e.CAP_ROUND, this._joinStyle = e.JOIN_ROUND, this._mitreLimit = e.DEFAULT_MITRE_LIMIT, this._isSingleSided = !1, this._simplifyFactor = e.DEFAULT_SIMPLIFY_FACTOR, 0 === arguments.length) ;
                            else if (1 === arguments.length) {
                                var t = arguments[0];
                                this.setQuadrantSegments(t);
                            } else if (2 === arguments.length) {
                                var n = arguments[0], r = arguments[1];
                                this.setQuadrantSegments(n), this.setEndCapStyle(r);
                            } else if (4 === arguments.length) {
                                var i = arguments[0], o = arguments[1], s = arguments[2], a = arguments[3];
                                this.setQuadrantSegments(i), this.setEndCapStyle(o), this.setJoinStyle(s), this.setMitreLimit(a);
                            }
                        }
                    },
                    {
                        key: "bufferDistanceError",
                        value: function(t) {
                            var e = Math.PI / 2 / t;
                            return 1 - Math.cos(e / 2);
                        }
                    }
                ]), e;
            }();
            y.CAP_ROUND = 1, y.CAP_FLAT = 2, y.CAP_SQUARE = 3, y.JOIN_ROUND = 1, y.JOIN_MITRE = 2, y.JOIN_BEVEL = 3, y.DEFAULT_QUADRANT_SEGMENTS = 8, y.DEFAULT_MITRE_LIMIT = 5, y.DEFAULT_SIMPLIFY_FACTOR = .01;
            var m = function(e) {
                r(o, e);
                var i = c(o);
                function o(e) {
                    var n;
                    return t(this, o), (n = i.call(this, e)).name = Object.keys({
                        Exception: o
                    })[0], n;
                }
                return n(o, [
                    {
                        key: "toString",
                        value: function() {
                            return this.message;
                        }
                    }
                ]), o;
            }(u(Error)), _ = function(e) {
                r(i, e);
                var n = c(i);
                function i(e) {
                    var r;
                    return t(this, i), (r = n.call(this, e)).name = Object.keys({
                        IllegalArgumentException: i
                    })[0], r;
                }
                return i;
            }(m), x = function() {
                function e() {
                    t(this, e);
                }
                return n(e, [
                    {
                        key: "filter",
                        value: function(t) {}
                    }
                ]), e;
            }();
            function k() {}
            function w() {}
            function b() {}
            var I, N, S, M, L, P, C, T, O = function() {
                function e() {
                    t(this, e);
                }
                return n(e, null, [
                    {
                        key: "equalsWithTolerance",
                        value: function(t, e, n) {
                            return Math.abs(t - e) <= n;
                        }
                    }
                ]), e;
            }(), R = function() {
                function e(n, r) {
                    t(this, e), this.low = r || 0, this.high = n || 0;
                }
                return n(e, null, [
                    {
                        key: "toBinaryString",
                        value: function(t) {
                            var e, n = "";
                            for(e = 2147483648; e > 0; e >>>= 1)n += (t.high & e) === e ? "1" : "0";
                            for(e = 2147483648; e > 0; e >>>= 1)n += (t.low & e) === e ? "1" : "0";
                            return n;
                        }
                    }
                ]), e;
            }();
            function A() {}
            function D() {}
            A.NaN = NaN, A.isNaN = function(t) {
                return Number.isNaN(t);
            }, A.isInfinite = function(t) {
                return !Number.isFinite(t);
            }, A.MAX_VALUE = Number.MAX_VALUE, A.POSITIVE_INFINITY = Number.POSITIVE_INFINITY, A.NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY, "function" == typeof Float64Array && "function" == typeof Int32Array ? (P = 2146435072, C = new Float64Array(1), T = new Int32Array(C.buffer), A.doubleToLongBits = function(t) {
                C[0] = t;
                var e = 0 | T[0], n = 0 | T[1];
                return (n & P) === P && !!(1048575 & n) && 0 !== e && (e = 0, n = 2146959360), new R(n, e);
            }, A.longBitsToDouble = function(t) {
                return T[0] = t.low, T[1] = t.high, C[0];
            }) : (I = 1023, N = Math.log2, S = Math.floor, M = Math.pow, L = function() {
                for(var t = 53; t > 0; t--){
                    var e = M(2, t) - 1;
                    if (S(N(e)) + 1 === t) return e;
                }
                return 0;
            }(), A.doubleToLongBits = function(t) {
                var e, n, r, i, o, s, a, u, l;
                if (t < 0 || 1 / t === Number.NEGATIVE_INFINITY ? (s = -2147483648, t = -t) : s = 0, 0 === t) return new R(u = s, l = 0);
                if (t === 1 / 0) return new R(u = 2146435072 | s, l = 0);
                if (t != t) return new R(u = 2146959360, l = 0);
                if (i = 0, l = 0, (e = S(t)) > 1) {
                    if (e <= L) (i = S(N(e))) <= 20 ? (l = 0, u = e << 20 - i & 1048575) : (l = e % (n = M(2, r = i - 20)) << 32 - r, u = e / n & 1048575);
                    else for(r = e, l = 0; 0 !== (r = S(n = r / 2));)i++, l >>>= 1, l |= (1 & u) << 31, u >>>= 1, n !== r && (u |= 524288);
                }
                if (a = i + I, o = 0 === e, e = t - e, i < 52 && 0 !== e) for(r = 0;;){
                    if ((n = 2 * e) >= 1 ? (e = n - 1, o ? (a--, o = !1) : (r <<= 1, r |= 1, i++)) : (e = n, o ? 0 == --a && (i++, o = !1) : (r <<= 1, i++)), 20 === i) u |= r, r = 0;
                    else if (52 === i) {
                        l |= r;
                        break;
                    }
                    if (1 === n) {
                        i < 20 ? u |= r << 20 - i : i < 52 && (l |= r << 52 - i);
                        break;
                    }
                }
                return u |= a << 20, new R(u |= s, l);
            }, A.longBitsToDouble = function(t) {
                var e, n, r, i, o = t.high, s = t.low, a = o & -2147483648 ? -1 : 1;
                for(r = ((2146435072 & o) >> 20) - I, i = 0, n = 524288, e = 1; e <= 20; e++)o & n && (i += M(2, -e)), n >>>= 1;
                for(n = -2147483648, e = 21; e <= 52; e++)s & n && (i += M(2, -e)), n >>>= 1;
                if (-1023 === r) {
                    if (0 === i) return 0 * a;
                    r = -1022;
                } else {
                    if (1024 === r) return 0 === i ? a / 0 : NaN;
                    i += 1;
                }
                return a * i * M(2, r);
            });
            var F = function(e) {
                r(i, e);
                var n = c(i);
                function i(e) {
                    var r;
                    return t(this, i), (r = n.call(this, e)).name = Object.keys({
                        RuntimeException: i
                    })[0], r;
                }
                return i;
            }(m), q = function(e) {
                r(o, e);
                var i = c(o);
                function o() {
                    var e;
                    return t(this, o), e = i.call(this), o.constructor_.apply(l(e), arguments), e;
                }
                return n(o, null, [
                    {
                        key: "constructor_",
                        value: function() {
                            if (0 === arguments.length) F.constructor_.call(this);
                            else if (1 === arguments.length) {
                                var t = arguments[0];
                                F.constructor_.call(this, t);
                            }
                        }
                    }
                ]), o;
            }(F), G = function() {
                function e() {
                    t(this, e);
                }
                return n(e, null, [
                    {
                        key: "shouldNeverReachHere",
                        value: function() {
                            if (0 === arguments.length) e.shouldNeverReachHere(null);
                            else if (1 === arguments.length) {
                                var t = arguments[0];
                                throw new q("Should never reach here" + (null !== t ? ": " + t : ""));
                            }
                        }
                    },
                    {
                        key: "isTrue",
                        value: function() {
                            if (1 === arguments.length) {
                                var t = arguments[0];
                                e.isTrue(t, null);
                            } else if (2 === arguments.length) {
                                var n = arguments[1];
                                if (!arguments[0]) throw null === n ? new q : new q(n);
                            }
                        }
                    },
                    {
                        key: "equals",
                        value: function() {
                            if (2 === arguments.length) {
                                var t = arguments[0], n = arguments[1];
                                e.equals(t, n, null);
                            } else if (3 === arguments.length) {
                                var r = arguments[0], i = arguments[1], o = arguments[2];
                                if (!i.equals(r)) throw new q("Expected " + r + " but encountered " + i + (null !== o ? ": " + o : ""));
                            }
                        }
                    }
                ]), e;
            }(), Y = new ArrayBuffer(8), B = new Float64Array(Y), z = new Int32Array(Y), j = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "getM",
                        value: function() {
                            return A.NaN;
                        }
                    },
                    {
                        key: "setOrdinate",
                        value: function(t, n) {
                            switch(t){
                                case e.X:
                                    this.x = n;
                                    break;
                                case e.Y:
                                    this.y = n;
                                    break;
                                case e.Z:
                                    this.setZ(n);
                                    break;
                                default:
                                    throw new _("Invalid ordinate index: " + t);
                            }
                        }
                    },
                    {
                        key: "equals2D",
                        value: function() {
                            if (1 === arguments.length) {
                                var t = arguments[0];
                                return this.x === t.x && this.y === t.y;
                            }
                            if (2 === arguments.length) {
                                var e = arguments[0], n = arguments[1];
                                return !!O.equalsWithTolerance(this.x, e.x, n) && !!O.equalsWithTolerance(this.y, e.y, n);
                            }
                        }
                    },
                    {
                        key: "setM",
                        value: function(t) {
                            throw new _("Invalid ordinate index: " + e.M);
                        }
                    },
                    {
                        key: "getZ",
                        value: function() {
                            return this.z;
                        }
                    },
                    {
                        key: "getOrdinate",
                        value: function(t) {
                            switch(t){
                                case e.X:
                                    return this.x;
                                case e.Y:
                                    return this.y;
                                case e.Z:
                                    return this.getZ();
                            }
                            throw new _("Invalid ordinate index: " + t);
                        }
                    },
                    {
                        key: "equals3D",
                        value: function(t) {
                            return this.x === t.x && this.y === t.y && (this.getZ() === t.getZ() || A.isNaN(this.getZ()) && A.isNaN(t.getZ()));
                        }
                    },
                    {
                        key: "equals",
                        value: function(t) {
                            return t instanceof e && this.equals2D(t);
                        }
                    },
                    {
                        key: "equalInZ",
                        value: function(t, e) {
                            return O.equalsWithTolerance(this.getZ(), t.getZ(), e);
                        }
                    },
                    {
                        key: "setX",
                        value: function(t) {
                            this.x = t;
                        }
                    },
                    {
                        key: "compareTo",
                        value: function(t) {
                            var e = t;
                            return this.x < e.x ? -1 : this.x > e.x ? 1 : this.y < e.y ? -1 : this.y > e.y ? 1 : 0;
                        }
                    },
                    {
                        key: "getX",
                        value: function() {
                            return this.x;
                        }
                    },
                    {
                        key: "setZ",
                        value: function(t) {
                            this.z = t;
                        }
                    },
                    {
                        key: "clone",
                        value: function() {
                            try {
                                return null;
                            } catch (t) {
                                if (t instanceof CloneNotSupportedException) return G.shouldNeverReachHere("this shouldn't happen because this class is Cloneable"), null;
                                throw t;
                            }
                        }
                    },
                    {
                        key: "copy",
                        value: function() {
                            return new e(this);
                        }
                    },
                    {
                        key: "toString",
                        value: function() {
                            return "(" + this.x + ", " + this.y + ", " + this.getZ() + ")";
                        }
                    },
                    {
                        key: "distance3D",
                        value: function(t) {
                            var e = this.x - t.x, n = this.y - t.y, r = this.getZ() - t.getZ();
                            return Math.sqrt(e * e + n * n + r * r);
                        }
                    },
                    {
                        key: "getY",
                        value: function() {
                            return this.y;
                        }
                    },
                    {
                        key: "setY",
                        value: function(t) {
                            this.y = t;
                        }
                    },
                    {
                        key: "distance",
                        value: function(t) {
                            var e = this.x - t.x, n = this.y - t.y;
                            return Math.sqrt(e * e + n * n);
                        }
                    },
                    {
                        key: "hashCode",
                        value: function() {
                            var t = 17;
                            return 37 * (t = 37 * t + e.hashCode(this.x)) + e.hashCode(this.y);
                        }
                    },
                    {
                        key: "setCoordinate",
                        value: function(t) {
                            this.x = t.x, this.y = t.y, this.z = t.getZ();
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                k,
                                w,
                                b
                            ];
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            if (this.x = null, this.y = null, this.z = null, 0 === arguments.length) e.constructor_.call(this, 0, 0);
                            else if (1 === arguments.length) {
                                var t = arguments[0];
                                e.constructor_.call(this, t.x, t.y, t.getZ());
                            } else if (2 === arguments.length) {
                                var n = arguments[0], r = arguments[1];
                                e.constructor_.call(this, n, r, e.NULL_ORDINATE);
                            } else if (3 === arguments.length) {
                                var i = arguments[0], o = arguments[1], s = arguments[2];
                                this.x = i, this.y = o, this.z = s;
                            }
                        }
                    },
                    {
                        key: "hashCode",
                        value: function(t) {
                            return B[0] = t, z[0] ^ z[1];
                        }
                    }
                ]), e;
            }(), X = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "compare",
                        value: function(t, n) {
                            var r = e.compare(t.x, n.x);
                            if (0 !== r) return r;
                            var i = e.compare(t.y, n.y);
                            return 0 !== i ? i : this._dimensionsToTest <= 2 ? 0 : e.compare(t.getZ(), n.getZ());
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                D
                            ];
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            if (this._dimensionsToTest = 2, 0 === arguments.length) e.constructor_.call(this, 2);
                            else if (1 === arguments.length) {
                                var t = arguments[0];
                                if (2 !== t && 3 !== t) throw new _("only 2 or 3 dimensions may be specified");
                                this._dimensionsToTest = t;
                            }
                        }
                    },
                    {
                        key: "compare",
                        value: function(t, e) {
                            return t < e ? -1 : t > e ? 1 : A.isNaN(t) ? A.isNaN(e) ? 0 : -1 : A.isNaN(e) ? 1 : 0;
                        }
                    }
                ]), e;
            }();
            j.DimensionalComparator = X, j.NULL_ORDINATE = A.NaN, j.X = 0, j.Y = 1, j.Z = 2, j.M = 3;
            var U = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "getArea",
                        value: function() {
                            return this.getWidth() * this.getHeight();
                        }
                    },
                    {
                        key: "equals",
                        value: function(t) {
                            if (!(t instanceof e)) return !1;
                            var n = t;
                            return this.isNull() ? n.isNull() : this._maxx === n.getMaxX() && this._maxy === n.getMaxY() && this._minx === n.getMinX() && this._miny === n.getMinY();
                        }
                    },
                    {
                        key: "intersection",
                        value: function(t) {
                            if (this.isNull() || t.isNull() || !this.intersects(t)) return new e;
                            var n = this._minx > t._minx ? this._minx : t._minx, r = this._miny > t._miny ? this._miny : t._miny;
                            return new e(n, this._maxx < t._maxx ? this._maxx : t._maxx, r, this._maxy < t._maxy ? this._maxy : t._maxy);
                        }
                    },
                    {
                        key: "isNull",
                        value: function() {
                            return this._maxx < this._minx;
                        }
                    },
                    {
                        key: "getMaxX",
                        value: function() {
                            return this._maxx;
                        }
                    },
                    {
                        key: "covers",
                        value: function() {
                            if (1 === arguments.length) {
                                if (arguments[0] instanceof j) {
                                    var t = arguments[0];
                                    return this.covers(t.x, t.y);
                                }
                                if (arguments[0] instanceof e) {
                                    var n = arguments[0];
                                    return !this.isNull() && !n.isNull() && n.getMinX() >= this._minx && n.getMaxX() <= this._maxx && n.getMinY() >= this._miny && n.getMaxY() <= this._maxy;
                                }
                            } else if (2 === arguments.length) {
                                var r = arguments[0], i = arguments[1];
                                return !this.isNull() && r >= this._minx && r <= this._maxx && i >= this._miny && i <= this._maxy;
                            }
                        }
                    },
                    {
                        key: "intersects",
                        value: function() {
                            if (1 === arguments.length) {
                                if (arguments[0] instanceof e) {
                                    var t = arguments[0];
                                    return !this.isNull() && !t.isNull() && !(t._minx > this._maxx || t._maxx < this._minx || t._miny > this._maxy || t._maxy < this._miny);
                                }
                                if (arguments[0] instanceof j) {
                                    var n = arguments[0];
                                    return this.intersects(n.x, n.y);
                                }
                            } else if (2 === arguments.length) {
                                if (arguments[0] instanceof j && arguments[1] instanceof j) {
                                    var r = arguments[0], i = arguments[1];
                                    return !(this.isNull() || (r.x < i.x ? r.x : i.x) > this._maxx || (r.x > i.x ? r.x : i.x) < this._minx || (r.y < i.y ? r.y : i.y) > this._maxy || (r.y > i.y ? r.y : i.y) < this._miny);
                                }
                                if ("number" == typeof arguments[0] && "number" == typeof arguments[1]) {
                                    var o = arguments[0], s = arguments[1];
                                    return !this.isNull() && !(o > this._maxx || o < this._minx || s > this._maxy || s < this._miny);
                                }
                            }
                        }
                    },
                    {
                        key: "getMinY",
                        value: function() {
                            return this._miny;
                        }
                    },
                    {
                        key: "getDiameter",
                        value: function() {
                            if (this.isNull()) return 0;
                            var t = this.getWidth(), e = this.getHeight();
                            return Math.sqrt(t * t + e * e);
                        }
                    },
                    {
                        key: "getMinX",
                        value: function() {
                            return this._minx;
                        }
                    },
                    {
                        key: "expandToInclude",
                        value: function() {
                            if (1 === arguments.length) {
                                if (arguments[0] instanceof j) {
                                    var t = arguments[0];
                                    this.expandToInclude(t.x, t.y);
                                } else if (arguments[0] instanceof e) {
                                    var n = arguments[0];
                                    if (n.isNull()) return null;
                                    this.isNull() ? (this._minx = n.getMinX(), this._maxx = n.getMaxX(), this._miny = n.getMinY(), this._maxy = n.getMaxY()) : (n._minx < this._minx && (this._minx = n._minx), n._maxx > this._maxx && (this._maxx = n._maxx), n._miny < this._miny && (this._miny = n._miny), n._maxy > this._maxy && (this._maxy = n._maxy));
                                }
                            } else if (2 === arguments.length) {
                                var r = arguments[0], i = arguments[1];
                                this.isNull() ? (this._minx = r, this._maxx = r, this._miny = i, this._maxy = i) : (r < this._minx && (this._minx = r), r > this._maxx && (this._maxx = r), i < this._miny && (this._miny = i), i > this._maxy && (this._maxy = i));
                            }
                        }
                    },
                    {
                        key: "minExtent",
                        value: function() {
                            if (this.isNull()) return 0;
                            var t = this.getWidth(), e = this.getHeight();
                            return t < e ? t : e;
                        }
                    },
                    {
                        key: "getWidth",
                        value: function() {
                            return this.isNull() ? 0 : this._maxx - this._minx;
                        }
                    },
                    {
                        key: "compareTo",
                        value: function(t) {
                            var e = t;
                            return this.isNull() ? e.isNull() ? 0 : -1 : e.isNull() ? 1 : this._minx < e._minx ? -1 : this._minx > e._minx ? 1 : this._miny < e._miny ? -1 : this._miny > e._miny ? 1 : this._maxx < e._maxx ? -1 : this._maxx > e._maxx ? 1 : this._maxy < e._maxy ? -1 : this._maxy > e._maxy ? 1 : 0;
                        }
                    },
                    {
                        key: "translate",
                        value: function(t, e) {
                            if (this.isNull()) return null;
                            this.init(this.getMinX() + t, this.getMaxX() + t, this.getMinY() + e, this.getMaxY() + e);
                        }
                    },
                    {
                        key: "copy",
                        value: function() {
                            return new e(this);
                        }
                    },
                    {
                        key: "toString",
                        value: function() {
                            return "Env[" + this._minx + " : " + this._maxx + ", " + this._miny + " : " + this._maxy + "]";
                        }
                    },
                    {
                        key: "setToNull",
                        value: function() {
                            this._minx = 0, this._maxx = -1, this._miny = 0, this._maxy = -1;
                        }
                    },
                    {
                        key: "disjoint",
                        value: function(t) {
                            return !(!this.isNull() && !t.isNull()) || t._minx > this._maxx || t._maxx < this._minx || t._miny > this._maxy || t._maxy < this._miny;
                        }
                    },
                    {
                        key: "getHeight",
                        value: function() {
                            return this.isNull() ? 0 : this._maxy - this._miny;
                        }
                    },
                    {
                        key: "maxExtent",
                        value: function() {
                            if (this.isNull()) return 0;
                            var t = this.getWidth(), e = this.getHeight();
                            return t > e ? t : e;
                        }
                    },
                    {
                        key: "expandBy",
                        value: function() {
                            if (1 === arguments.length) {
                                var t = arguments[0];
                                this.expandBy(t, t);
                            } else if (2 === arguments.length) {
                                var e = arguments[0], n = arguments[1];
                                if (this.isNull()) return null;
                                this._minx -= e, this._maxx += e, this._miny -= n, this._maxy += n, (this._minx > this._maxx || this._miny > this._maxy) && this.setToNull();
                            }
                        }
                    },
                    {
                        key: "contains",
                        value: function() {
                            if (1 === arguments.length) {
                                if (arguments[0] instanceof e) {
                                    var t = arguments[0];
                                    return this.covers(t);
                                }
                                if (arguments[0] instanceof j) {
                                    var n = arguments[0];
                                    return this.covers(n);
                                }
                            } else if (2 === arguments.length) {
                                var r = arguments[0], i = arguments[1];
                                return this.covers(r, i);
                            }
                        }
                    },
                    {
                        key: "centre",
                        value: function() {
                            return this.isNull() ? null : new j((this.getMinX() + this.getMaxX()) / 2, (this.getMinY() + this.getMaxY()) / 2);
                        }
                    },
                    {
                        key: "init",
                        value: function() {
                            if (0 === arguments.length) this.setToNull();
                            else if (1 === arguments.length) {
                                if (arguments[0] instanceof j) {
                                    var t = arguments[0];
                                    this.init(t.x, t.x, t.y, t.y);
                                } else if (arguments[0] instanceof e) {
                                    var n = arguments[0];
                                    this._minx = n._minx, this._maxx = n._maxx, this._miny = n._miny, this._maxy = n._maxy;
                                }
                            } else if (2 === arguments.length) {
                                var r = arguments[0], i = arguments[1];
                                this.init(r.x, i.x, r.y, i.y);
                            } else if (4 === arguments.length) {
                                var o = arguments[0], s = arguments[1], a = arguments[2], u = arguments[3];
                                o < s ? (this._minx = o, this._maxx = s) : (this._minx = s, this._maxx = o), a < u ? (this._miny = a, this._maxy = u) : (this._miny = u, this._maxy = a);
                            }
                        }
                    },
                    {
                        key: "getMaxY",
                        value: function() {
                            return this._maxy;
                        }
                    },
                    {
                        key: "distance",
                        value: function(t) {
                            if (this.intersects(t)) return 0;
                            var e = 0;
                            this._maxx < t._minx ? e = t._minx - this._maxx : this._minx > t._maxx && (e = this._minx - t._maxx);
                            var n = 0;
                            return this._maxy < t._miny ? n = t._miny - this._maxy : this._miny > t._maxy && (n = this._miny - t._maxy), 0 === e ? n : 0 === n ? e : Math.sqrt(e * e + n * n);
                        }
                    },
                    {
                        key: "hashCode",
                        value: function() {
                            var t = 17;
                            return 37 * (t = 37 * (t = 37 * (t = 37 * t + j.hashCode(this._minx)) + j.hashCode(this._maxx)) + j.hashCode(this._miny)) + j.hashCode(this._maxy);
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                k,
                                b
                            ];
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            if (this._minx = null, this._maxx = null, this._miny = null, this._maxy = null, 0 === arguments.length) this.init();
                            else if (1 === arguments.length) {
                                if (arguments[0] instanceof j) {
                                    var t = arguments[0];
                                    this.init(t.x, t.x, t.y, t.y);
                                } else if (arguments[0] instanceof e) {
                                    var n = arguments[0];
                                    this.init(n);
                                }
                            } else if (2 === arguments.length) {
                                var r = arguments[0], i = arguments[1];
                                this.init(r.x, i.x, r.y, i.y);
                            } else if (4 === arguments.length) {
                                var o = arguments[0], s = arguments[1], a = arguments[2], u = arguments[3];
                                this.init(o, s, a, u);
                            }
                        }
                    },
                    {
                        key: "intersects",
                        value: function() {
                            if (3 === arguments.length) {
                                var t = arguments[0], e = arguments[1], n = arguments[2];
                                return n.x >= (t.x < e.x ? t.x : e.x) && n.x <= (t.x > e.x ? t.x : e.x) && n.y >= (t.y < e.y ? t.y : e.y) && n.y <= (t.y > e.y ? t.y : e.y);
                            }
                            if (4 === arguments.length) {
                                var r = arguments[0], i = arguments[1], o = arguments[2], s = arguments[3], a = Math.min(o.x, s.x), u = Math.max(o.x, s.x), l = Math.min(r.x, i.x), h = Math.max(r.x, i.x);
                                return !(l > u || h < a || (a = Math.min(o.y, s.y), u = Math.max(o.y, s.y), l = Math.min(r.y, i.y), h = Math.max(r.y, i.y), l > u || h < a));
                            }
                        }
                    }
                ]), e;
            }(), V = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "isGeometryCollection",
                        value: function() {
                            return this.getTypeCode() === e.TYPECODE_GEOMETRYCOLLECTION;
                        }
                    },
                    {
                        key: "getFactory",
                        value: function() {
                            return this._factory;
                        }
                    },
                    {
                        key: "getGeometryN",
                        value: function(t) {
                            return this;
                        }
                    },
                    {
                        key: "getArea",
                        value: function() {
                            return 0;
                        }
                    },
                    {
                        key: "isRectangle",
                        value: function() {
                            return !1;
                        }
                    },
                    {
                        key: "equalsExact",
                        value: function(t) {
                            return this === t || this.equalsExact(t, 0);
                        }
                    },
                    {
                        key: "geometryChanged",
                        value: function() {
                            this.apply(e.geometryChangedFilter);
                        }
                    },
                    {
                        key: "geometryChangedAction",
                        value: function() {
                            this._envelope = null;
                        }
                    },
                    {
                        key: "equalsNorm",
                        value: function(t) {
                            return null !== t && this.norm().equalsExact(t.norm());
                        }
                    },
                    {
                        key: "getLength",
                        value: function() {
                            return 0;
                        }
                    },
                    {
                        key: "getNumGeometries",
                        value: function() {
                            return 1;
                        }
                    },
                    {
                        key: "compareTo",
                        value: function() {
                            var t;
                            if (1 === arguments.length) {
                                var e = arguments[0];
                                return t = e, this.getTypeCode() !== t.getTypeCode() ? this.getTypeCode() - t.getTypeCode() : this.isEmpty() && t.isEmpty() ? 0 : this.isEmpty() ? -1 : t.isEmpty() ? 1 : this.compareToSameClass(e);
                            }
                            if (2 === arguments.length) {
                                var n = arguments[0], r = arguments[1];
                                return t = n, this.getTypeCode() !== t.getTypeCode() ? this.getTypeCode() - t.getTypeCode() : this.isEmpty() && t.isEmpty() ? 0 : this.isEmpty() ? -1 : t.isEmpty() ? 1 : this.compareToSameClass(n, r);
                            }
                        }
                    },
                    {
                        key: "getUserData",
                        value: function() {
                            return this._userData;
                        }
                    },
                    {
                        key: "getSRID",
                        value: function() {
                            return this._SRID;
                        }
                    },
                    {
                        key: "getEnvelope",
                        value: function() {
                            return this.getFactory().toGeometry(this.getEnvelopeInternal());
                        }
                    },
                    {
                        key: "checkNotGeometryCollection",
                        value: function(t) {
                            if (t.getTypeCode() === e.TYPECODE_GEOMETRYCOLLECTION) throw new _("This method does not support GeometryCollection arguments");
                        }
                    },
                    {
                        key: "equal",
                        value: function(t, e, n) {
                            return 0 === n ? t.equals(e) : t.distance(e) <= n;
                        }
                    },
                    {
                        key: "norm",
                        value: function() {
                            var t = this.copy();
                            return t.normalize(), t;
                        }
                    },
                    {
                        key: "reverse",
                        value: function() {
                            var t = this.reverseInternal();
                            return null != this.envelope && (t.envelope = this.envelope.copy()), t.setSRID(this.getSRID()), t;
                        }
                    },
                    {
                        key: "copy",
                        value: function() {
                            var t = this.copyInternal();
                            return t.envelope = null == this._envelope ? null : this._envelope.copy(), t._SRID = this._SRID, t._userData = this._userData, t;
                        }
                    },
                    {
                        key: "getPrecisionModel",
                        value: function() {
                            return this._factory.getPrecisionModel();
                        }
                    },
                    {
                        key: "getEnvelopeInternal",
                        value: function() {
                            return null === this._envelope && (this._envelope = this.computeEnvelopeInternal()), new U(this._envelope);
                        }
                    },
                    {
                        key: "setSRID",
                        value: function(t) {
                            this._SRID = t;
                        }
                    },
                    {
                        key: "setUserData",
                        value: function(t) {
                            this._userData = t;
                        }
                    },
                    {
                        key: "compare",
                        value: function(t, e) {
                            for(var n = t.iterator(), r = e.iterator(); n.hasNext() && r.hasNext();){
                                var i = n.next(), o = r.next(), s = i.compareTo(o);
                                if (0 !== s) return s;
                            }
                            return n.hasNext() ? 1 : r.hasNext() ? -1 : 0;
                        }
                    },
                    {
                        key: "hashCode",
                        value: function() {
                            return this.getEnvelopeInternal().hashCode();
                        }
                    },
                    {
                        key: "isEquivalentClass",
                        value: function(t) {
                            return this.getClass() === t.getClass();
                        }
                    },
                    {
                        key: "isGeometryCollectionOrDerived",
                        value: function() {
                            return this.getTypeCode() === e.TYPECODE_GEOMETRYCOLLECTION || this.getTypeCode() === e.TYPECODE_MULTIPOINT || this.getTypeCode() === e.TYPECODE_MULTILINESTRING || this.getTypeCode() === e.TYPECODE_MULTIPOLYGON;
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                w,
                                k,
                                b
                            ];
                        }
                    },
                    {
                        key: "getClass",
                        value: function() {
                            return e;
                        }
                    }
                ], [
                    {
                        key: "hasNonEmptyElements",
                        value: function(t) {
                            for(var e = 0; e < t.length; e++)if (!t[e].isEmpty()) return !0;
                            return !1;
                        }
                    },
                    {
                        key: "hasNullElements",
                        value: function(t) {
                            for(var e = 0; e < t.length; e++)if (null === t[e]) return !0;
                            return !1;
                        }
                    }
                ]), e;
            }();
            V.constructor_ = function(t) {
                t && (this._envelope = null, this._userData = null, this._factory = t, this._SRID = t.getSRID());
            }, V.TYPECODE_POINT = 0, V.TYPECODE_MULTIPOINT = 1, V.TYPECODE_LINESTRING = 2, V.TYPECODE_LINEARRING = 3, V.TYPECODE_MULTILINESTRING = 4, V.TYPECODE_POLYGON = 5, V.TYPECODE_MULTIPOLYGON = 6, V.TYPECODE_GEOMETRYCOLLECTION = 7, V.TYPENAME_POINT = "Point", V.TYPENAME_MULTIPOINT = "MultiPoint", V.TYPENAME_LINESTRING = "LineString", V.TYPENAME_LINEARRING = "LinearRing", V.TYPENAME_MULTILINESTRING = "MultiLineString", V.TYPENAME_POLYGON = "Polygon", V.TYPENAME_MULTIPOLYGON = "MultiPolygon", V.TYPENAME_GEOMETRYCOLLECTION = "GeometryCollection", V.geometryChangedFilter = {
                get interfaces_ () {
                    return [
                        x
                    ];
                },
                filter: function(t) {
                    t.geometryChangedAction();
                }
            };
            var Z = function() {
                function e() {
                    t(this, e);
                }
                return n(e, null, [
                    {
                        key: "toLocationSymbol",
                        value: function(t) {
                            switch(t){
                                case e.EXTERIOR:
                                    return "e";
                                case e.BOUNDARY:
                                    return "b";
                                case e.INTERIOR:
                                    return "i";
                                case e.NONE:
                                    return "-";
                            }
                            throw new _("Unknown location value: " + t);
                        }
                    }
                ]), e;
            }();
            Z.INTERIOR = 0, Z.BOUNDARY = 1, Z.EXTERIOR = 2, Z.NONE = -1;
            var H = function() {
                function e() {
                    t(this, e);
                }
                return n(e, [
                    {
                        key: "add",
                        value: function() {}
                    },
                    {
                        key: "addAll",
                        value: function() {}
                    },
                    {
                        key: "isEmpty",
                        value: function() {}
                    },
                    {
                        key: "iterator",
                        value: function() {}
                    },
                    {
                        key: "size",
                        value: function() {}
                    },
                    {
                        key: "toArray",
                        value: function() {}
                    },
                    {
                        key: "remove",
                        value: function() {}
                    }
                ]), e;
            }(), W = function(e) {
                r(i, e);
                var n = c(i);
                function i(e) {
                    var r;
                    return t(this, i), (r = n.call(this, e)).name = Object.keys({
                        NoSuchElementException: i
                    })[0], r;
                }
                return i;
            }(m), J = function(e) {
                r(i, e);
                var n = c(i);
                function i(e) {
                    var r;
                    return t(this, i), (r = n.call(this, e)).name = Object.keys({
                        UnsupportedOperationException: i
                    })[0], r;
                }
                return i;
            }(m), K = function(e) {
                r(o, e);
                var i = c(o);
                function o() {
                    return t(this, o), i.apply(this, arguments);
                }
                return n(o, [
                    {
                        key: "contains",
                        value: function() {}
                    }
                ]), o;
            }(H), Q = function(e, i) {
                r(s, e);
                var o = c(s);
                function s(e) {
                    var n;
                    return t(this, s), (n = o.call(this)).map = new Map, e instanceof H && n.addAll(e), n;
                }
                return n(s, [
                    {
                        key: "contains",
                        value: function(t) {
                            var e = t.hashCode ? t.hashCode() : t;
                            return !!this.map.has(e);
                        }
                    },
                    {
                        key: "add",
                        value: function(t) {
                            var e = t.hashCode ? t.hashCode() : t;
                            return !this.map.has(e) && !!this.map.set(e, t);
                        }
                    },
                    {
                        key: "addAll",
                        value: function(t) {
                            var e, n = p(t);
                            try {
                                for(n.s(); !(e = n.n()).done;){
                                    var r = e.value;
                                    this.add(r);
                                }
                            } catch (t) {
                                n.e(t);
                            } finally{
                                n.f();
                            }
                            return !0;
                        }
                    },
                    {
                        key: "remove",
                        value: function() {
                            throw new J;
                        }
                    },
                    {
                        key: "size",
                        value: function() {
                            return this.map.size;
                        }
                    },
                    {
                        key: "isEmpty",
                        value: function() {
                            return 0 === this.map.size;
                        }
                    },
                    {
                        key: "toArray",
                        value: function() {
                            return Array.from(this.map.values());
                        }
                    },
                    {
                        key: "iterator",
                        value: function() {
                            return new $(this.map);
                        }
                    },
                    {
                        key: i,
                        value: function() {
                            return this.map;
                        }
                    }
                ]), s;
            }(K, Symbol.iterator), $ = function() {
                function e(n) {
                    t(this, e), this.iterator = n.values();
                    var r = this.iterator.next(), i = r.done, o = r.value;
                    this.done = i, this.value = o;
                }
                return n(e, [
                    {
                        key: "next",
                        value: function() {
                            if (this.done) throw new W;
                            var t = this.value, e = this.iterator.next(), n = e.done, r = e.value;
                            return this.done = n, this.value = r, t;
                        }
                    },
                    {
                        key: "hasNext",
                        value: function() {
                            return !this.done;
                        }
                    },
                    {
                        key: "remove",
                        value: function() {
                            throw new J;
                        }
                    }
                ]), e;
            }(), tt = function() {
                function e() {
                    t(this, e);
                }
                return n(e, null, [
                    {
                        key: "opposite",
                        value: function(t) {
                            return t === e.LEFT ? e.RIGHT : t === e.RIGHT ? e.LEFT : t;
                        }
                    }
                ]), e;
            }();
            tt.ON = 0, tt.LEFT = 1, tt.RIGHT = 2;
            var et = function(e) {
                r(i, e);
                var n = c(i);
                function i(e) {
                    var r;
                    return t(this, i), (r = n.call(this, e)).name = Object.keys({
                        EmptyStackException: i
                    })[0], r;
                }
                return i;
            }(m), nt = function(e) {
                r(i, e);
                var n = c(i);
                function i(e) {
                    var r;
                    return t(this, i), (r = n.call(this, e)).name = Object.keys({
                        IndexOutOfBoundsException: i
                    })[0], r;
                }
                return i;
            }(m), rt = function(e) {
                r(o, e);
                var i = c(o);
                function o() {
                    return t(this, o), i.apply(this, arguments);
                }
                return n(o, [
                    {
                        key: "get",
                        value: function() {}
                    },
                    {
                        key: "set",
                        value: function() {}
                    },
                    {
                        key: "isEmpty",
                        value: function() {}
                    }
                ]), o;
            }(H), it = function(e) {
                r(o, e);
                var i = c(o);
                function o() {
                    var e;
                    return t(this, o), (e = i.call(this)).array = [], e;
                }
                return n(o, [
                    {
                        key: "add",
                        value: function(t) {
                            return this.array.push(t), !0;
                        }
                    },
                    {
                        key: "get",
                        value: function(t) {
                            if (t < 0 || t >= this.size()) throw new nt;
                            return this.array[t];
                        }
                    },
                    {
                        key: "push",
                        value: function(t) {
                            return this.array.push(t), t;
                        }
                    },
                    {
                        key: "pop",
                        value: function() {
                            if (0 === this.array.length) throw new et;
                            return this.array.pop();
                        }
                    },
                    {
                        key: "peek",
                        value: function() {
                            if (0 === this.array.length) throw new et;
                            return this.array[this.array.length - 1];
                        }
                    },
                    {
                        key: "empty",
                        value: function() {
                            return 0 === this.array.length;
                        }
                    },
                    {
                        key: "isEmpty",
                        value: function() {
                            return this.empty();
                        }
                    },
                    {
                        key: "search",
                        value: function(t) {
                            return this.array.indexOf(t);
                        }
                    },
                    {
                        key: "size",
                        value: function() {
                            return this.array.length;
                        }
                    },
                    {
                        key: "toArray",
                        value: function() {
                            return this.array.slice();
                        }
                    }
                ]), o;
            }(rt);
            function ot(t, e) {
                return t.interfaces_ && t.interfaces_.indexOf(e) > -1;
            }
            var st = function() {
                function e(n) {
                    t(this, e), this.str = n;
                }
                return n(e, [
                    {
                        key: "append",
                        value: function(t) {
                            this.str += t;
                        }
                    },
                    {
                        key: "setCharAt",
                        value: function(t, e) {
                            this.str = this.str.substr(0, t) + e + this.str.substr(t + 1);
                        }
                    },
                    {
                        key: "toString",
                        value: function() {
                            return this.str;
                        }
                    }
                ]), e;
            }(), at = function() {
                function e(n) {
                    t(this, e), this.value = n;
                }
                return n(e, [
                    {
                        key: "intValue",
                        value: function() {
                            return this.value;
                        }
                    },
                    {
                        key: "compareTo",
                        value: function(t) {
                            return this.value < t ? -1 : this.value > t ? 1 : 0;
                        }
                    }
                ], [
                    {
                        key: "compare",
                        value: function(t, e) {
                            return t < e ? -1 : t > e ? 1 : 0;
                        }
                    },
                    {
                        key: "isNan",
                        value: function(t) {
                            return Number.isNaN(t);
                        }
                    },
                    {
                        key: "valueOf",
                        value: function(t) {
                            return new e(t);
                        }
                    }
                ]), e;
            }(), ut = function() {
                function e() {
                    t(this, e);
                }
                return n(e, null, [
                    {
                        key: "isWhitespace",
                        value: function(t) {
                            return t <= 32 && t >= 0 || 127 === t;
                        }
                    },
                    {
                        key: "toUpperCase",
                        value: function(t) {
                            return t.toUpperCase();
                        }
                    }
                ]), e;
            }(), lt = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "le",
                        value: function(t) {
                            return this._hi < t._hi || this._hi === t._hi && this._lo <= t._lo;
                        }
                    },
                    {
                        key: "extractSignificantDigits",
                        value: function(t, n) {
                            var r = this.abs(), i = e.magnitude(r._hi), o = e.TEN.pow(i);
                            (r = r.divide(o)).gt(e.TEN) ? (r = r.divide(e.TEN), i += 1) : r.lt(e.ONE) && (r = r.multiply(e.TEN), i -= 1);
                            for(var s = i + 1, a = new st, u = e.MAX_PRINT_DIGITS - 1, l = 0; l <= u; l++){
                                t && l === s && a.append(".");
                                var h = Math.trunc(r._hi);
                                if (h < 0) break;
                                var c = !1, f = 0;
                                h > 9 ? (c = !0, f = "9") : f = "0" + h, a.append(f), r = r.subtract(e.valueOf(h)).multiply(e.TEN), c && r.selfAdd(e.TEN);
                                var v = !0, g = e.magnitude(r._hi);
                                if (g < 0 && Math.abs(g) >= u - l && (v = !1), !v) break;
                            }
                            return n[0] = i, a.toString();
                        }
                    },
                    {
                        key: "sqr",
                        value: function() {
                            return this.multiply(this);
                        }
                    },
                    {
                        key: "doubleValue",
                        value: function() {
                            return this._hi + this._lo;
                        }
                    },
                    {
                        key: "subtract",
                        value: function() {
                            if (arguments[0] instanceof e) {
                                var t = arguments[0];
                                return this.add(t.negate());
                            }
                            if ("number" == typeof arguments[0]) {
                                var n = arguments[0];
                                return this.add(-n);
                            }
                        }
                    },
                    {
                        key: "equals",
                        value: function() {
                            if (1 === arguments.length && arguments[0] instanceof e) {
                                var t = arguments[0];
                                return this._hi === t._hi && this._lo === t._lo;
                            }
                        }
                    },
                    {
                        key: "isZero",
                        value: function() {
                            return 0 === this._hi && 0 === this._lo;
                        }
                    },
                    {
                        key: "selfSubtract",
                        value: function() {
                            if (arguments[0] instanceof e) {
                                var t = arguments[0];
                                return this.isNaN() ? this : this.selfAdd(-t._hi, -t._lo);
                            }
                            if ("number" == typeof arguments[0]) {
                                var n = arguments[0];
                                return this.isNaN() ? this : this.selfAdd(-n, 0);
                            }
                        }
                    },
                    {
                        key: "getSpecialNumberString",
                        value: function() {
                            return this.isZero() ? "0.0" : this.isNaN() ? "NaN " : null;
                        }
                    },
                    {
                        key: "min",
                        value: function(t) {
                            return this.le(t) ? this : t;
                        }
                    },
                    {
                        key: "selfDivide",
                        value: function() {
                            if (1 === arguments.length) {
                                if (arguments[0] instanceof e) {
                                    var t = arguments[0];
                                    return this.selfDivide(t._hi, t._lo);
                                }
                                if ("number" == typeof arguments[0]) {
                                    var n = arguments[0];
                                    return this.selfDivide(n, 0);
                                }
                            } else if (2 === arguments.length) {
                                var r = arguments[0], i = arguments[1], o = null, s = null, a = null, u = null, l = null, h = null, c = null, f = null;
                                return l = this._hi / r, f = (o = (h = e.SPLIT * l) - (o = h - l)) * (a = (f = e.SPLIT * r) - (a = f - r)) - (c = l * r) + o * (u = r - a) + (s = l - o) * a + s * u, f = l + (h = (this._hi - c - f + this._lo - l * i) / r), this._hi = f, this._lo = l - f + h, this;
                            }
                        }
                    },
                    {
                        key: "dump",
                        value: function() {
                            return "DD<" + this._hi + ", " + this._lo + ">";
                        }
                    },
                    {
                        key: "divide",
                        value: function() {
                            if (arguments[0] instanceof e) {
                                var t = arguments[0], n = null, r = null, i = null, o = null, s = null, a = null, u = null, l = null;
                                return r = (s = this._hi / t._hi) - (n = (a = e.SPLIT * s) - (n = a - s)), l = n * (i = (l = e.SPLIT * t._hi) - (i = l - t._hi)) - (u = s * t._hi) + n * (o = t._hi - i) + r * i + r * o, new e(l = s + (a = (this._hi - u - l + this._lo - s * t._lo) / t._hi), s - l + a);
                            }
                            if ("number" == typeof arguments[0]) {
                                var h = arguments[0];
                                return A.isNaN(h) ? e.createNaN() : e.copy(this).selfDivide(h, 0);
                            }
                        }
                    },
                    {
                        key: "ge",
                        value: function(t) {
                            return this._hi > t._hi || this._hi === t._hi && this._lo >= t._lo;
                        }
                    },
                    {
                        key: "pow",
                        value: function(t) {
                            if (0 === t) return e.valueOf(1);
                            var n = new e(this), r = e.valueOf(1), i = Math.abs(t);
                            if (i > 1) for(; i > 0;)i % 2 == 1 && r.selfMultiply(n), (i /= 2) > 0 && (n = n.sqr());
                            else r = n;
                            return t < 0 ? r.reciprocal() : r;
                        }
                    },
                    {
                        key: "ceil",
                        value: function() {
                            if (this.isNaN()) return e.NaN;
                            var t = Math.ceil(this._hi), n = 0;
                            return t === this._hi && (n = Math.ceil(this._lo)), new e(t, n);
                        }
                    },
                    {
                        key: "compareTo",
                        value: function(t) {
                            var e = t;
                            return this._hi < e._hi ? -1 : this._hi > e._hi ? 1 : this._lo < e._lo ? -1 : this._lo > e._lo ? 1 : 0;
                        }
                    },
                    {
                        key: "rint",
                        value: function() {
                            return this.isNaN() ? this : this.add(.5).floor();
                        }
                    },
                    {
                        key: "setValue",
                        value: function() {
                            if (arguments[0] instanceof e) {
                                var t = arguments[0];
                                return this.init(t), this;
                            }
                            if ("number" == typeof arguments[0]) {
                                var n = arguments[0];
                                return this.init(n), this;
                            }
                        }
                    },
                    {
                        key: "max",
                        value: function(t) {
                            return this.ge(t) ? this : t;
                        }
                    },
                    {
                        key: "sqrt",
                        value: function() {
                            if (this.isZero()) return e.valueOf(0);
                            if (this.isNegative()) return e.NaN;
                            var t = 1 / Math.sqrt(this._hi), n = this._hi * t, r = e.valueOf(n), i = this.subtract(r.sqr())._hi * (.5 * t);
                            return r.add(i);
                        }
                    },
                    {
                        key: "selfAdd",
                        value: function() {
                            if (1 === arguments.length) {
                                if (arguments[0] instanceof e) {
                                    var t = arguments[0];
                                    return this.selfAdd(t._hi, t._lo);
                                }
                                if ("number" == typeof arguments[0]) {
                                    var n = arguments[0], r = null, i = null, o = null, s = null, a = null, u = null;
                                    return s = (o = this._hi + n) - (a = o - this._hi), i = (u = (s = n - a + (this._hi - s)) + this._lo) + (o - (r = o + u)), this._hi = r + i, this._lo = i + (r - this._hi), this;
                                }
                            } else if (2 === arguments.length) {
                                var l = arguments[0], h = arguments[1], c = null, f = null, v = null, g = null, d = null, p = null, y = null;
                                g = this._hi + l, f = this._lo + h, d = g - (p = g - this._hi), v = f - (y = f - this._lo);
                                var m = (c = g + (p = (d = l - p + (this._hi - d)) + f)) + (p = (v = h - y + (this._lo - v)) + (p + (g - c))), _ = p + (c - m);
                                return this._hi = m, this._lo = _, this;
                            }
                        }
                    },
                    {
                        key: "selfMultiply",
                        value: function() {
                            if (1 === arguments.length) {
                                if (arguments[0] instanceof e) {
                                    var t = arguments[0];
                                    return this.selfMultiply(t._hi, t._lo);
                                }
                                if ("number" == typeof arguments[0]) {
                                    var n = arguments[0];
                                    return this.selfMultiply(n, 0);
                                }
                            } else if (2 === arguments.length) {
                                var r = arguments[0], i = arguments[1], o = null, s = null, a = null, u = null, l = null, h = null;
                                o = (l = e.SPLIT * this._hi) - this._hi, h = e.SPLIT * r, o = l - o, s = this._hi - o, a = h - r;
                                var c = (l = this._hi * r) + (h = o * (a = h - a) - l + o * (u = r - a) + s * a + s * u + (this._hi * i + this._lo * r)), f = h + (o = l - c);
                                return this._hi = c, this._lo = f, this;
                            }
                        }
                    },
                    {
                        key: "selfSqr",
                        value: function() {
                            return this.selfMultiply(this);
                        }
                    },
                    {
                        key: "floor",
                        value: function() {
                            if (this.isNaN()) return e.NaN;
                            var t = Math.floor(this._hi), n = 0;
                            return t === this._hi && (n = Math.floor(this._lo)), new e(t, n);
                        }
                    },
                    {
                        key: "negate",
                        value: function() {
                            return this.isNaN() ? this : new e(-this._hi, -this._lo);
                        }
                    },
                    {
                        key: "clone",
                        value: function() {
                            try {
                                return null;
                            } catch (t) {
                                if (t instanceof CloneNotSupportedException) return null;
                                throw t;
                            }
                        }
                    },
                    {
                        key: "multiply",
                        value: function() {
                            if (arguments[0] instanceof e) {
                                var t = arguments[0];
                                return t.isNaN() ? e.createNaN() : e.copy(this).selfMultiply(t);
                            }
                            if ("number" == typeof arguments[0]) {
                                var n = arguments[0];
                                return A.isNaN(n) ? e.createNaN() : e.copy(this).selfMultiply(n, 0);
                            }
                        }
                    },
                    {
                        key: "isNaN",
                        value: function() {
                            return A.isNaN(this._hi);
                        }
                    },
                    {
                        key: "intValue",
                        value: function() {
                            return Math.trunc(this._hi);
                        }
                    },
                    {
                        key: "toString",
                        value: function() {
                            var t = e.magnitude(this._hi);
                            return t >= -3 && t <= 20 ? this.toStandardNotation() : this.toSciNotation();
                        }
                    },
                    {
                        key: "toStandardNotation",
                        value: function() {
                            var t = this.getSpecialNumberString();
                            if (null !== t) return t;
                            var n = new Array(1).fill(null), r = this.extractSignificantDigits(!0, n), i = n[0] + 1, o = r;
                            if ("." === r.charAt(0)) o = "0" + r;
                            else if (i < 0) o = "0." + e.stringOfChar("0", -i) + r;
                            else if (-1 === r.indexOf(".")) {
                                var s = i - r.length;
                                o = r + e.stringOfChar("0", s) + ".0";
                            }
                            return this.isNegative() ? "-" + o : o;
                        }
                    },
                    {
                        key: "reciprocal",
                        value: function() {
                            var t, n, r, i, o = null, s = null, a = null, u = null;
                            t = (r = 1 / this._hi) - (o = (a = e.SPLIT * r) - (o = a - r)), s = (u = e.SPLIT * this._hi) - this._hi;
                            var l = r + (a = (1 - (i = r * this._hi) - (u = o * (s = u - s) - i + o * (n = this._hi - s) + t * s + t * n) - r * this._lo) / this._hi);
                            return new e(l, r - l + a);
                        }
                    },
                    {
                        key: "toSciNotation",
                        value: function() {
                            if (this.isZero()) return e.SCI_NOT_ZERO;
                            var t = this.getSpecialNumberString();
                            if (null !== t) return t;
                            var n = new Array(1).fill(null), r = this.extractSignificantDigits(!1, n), i = e.SCI_NOT_EXPONENT_CHAR + n[0];
                            if ("0" === r.charAt(0)) throw new IllegalStateException("Found leading zero: " + r);
                            var o = "";
                            r.length > 1 && (o = r.substring(1));
                            var s = r.charAt(0) + "." + o;
                            return this.isNegative() ? "-" + s + i : s + i;
                        }
                    },
                    {
                        key: "abs",
                        value: function() {
                            return this.isNaN() ? e.NaN : this.isNegative() ? this.negate() : new e(this);
                        }
                    },
                    {
                        key: "isPositive",
                        value: function() {
                            return this._hi > 0 || 0 === this._hi && this._lo > 0;
                        }
                    },
                    {
                        key: "lt",
                        value: function(t) {
                            return this._hi < t._hi || this._hi === t._hi && this._lo < t._lo;
                        }
                    },
                    {
                        key: "add",
                        value: function() {
                            if (arguments[0] instanceof e) {
                                var t = arguments[0];
                                return e.copy(this).selfAdd(t);
                            }
                            if ("number" == typeof arguments[0]) {
                                var n = arguments[0];
                                return e.copy(this).selfAdd(n);
                            }
                        }
                    },
                    {
                        key: "init",
                        value: function() {
                            if (1 === arguments.length) {
                                if ("number" == typeof arguments[0]) {
                                    var t = arguments[0];
                                    this._hi = t, this._lo = 0;
                                } else if (arguments[0] instanceof e) {
                                    var n = arguments[0];
                                    this._hi = n._hi, this._lo = n._lo;
                                }
                            } else if (2 === arguments.length) {
                                var r = arguments[0], i = arguments[1];
                                this._hi = r, this._lo = i;
                            }
                        }
                    },
                    {
                        key: "gt",
                        value: function(t) {
                            return this._hi > t._hi || this._hi === t._hi && this._lo > t._lo;
                        }
                    },
                    {
                        key: "isNegative",
                        value: function() {
                            return this._hi < 0 || 0 === this._hi && this._lo < 0;
                        }
                    },
                    {
                        key: "trunc",
                        value: function() {
                            return this.isNaN() ? e.NaN : this.isPositive() ? this.floor() : this.ceil();
                        }
                    },
                    {
                        key: "signum",
                        value: function() {
                            return this._hi > 0 ? 1 : this._hi < 0 ? -1 : this._lo > 0 ? 1 : this._lo < 0 ? -1 : 0;
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                b,
                                k,
                                w
                            ];
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            if (this._hi = 0, this._lo = 0, 0 === arguments.length) this.init(0);
                            else if (1 === arguments.length) {
                                if ("number" == typeof arguments[0]) {
                                    var t = arguments[0];
                                    this.init(t);
                                } else if (arguments[0] instanceof e) {
                                    var n = arguments[0];
                                    this.init(n);
                                } else if ("string" == typeof arguments[0]) {
                                    var r = arguments[0];
                                    e.constructor_.call(this, e.parse(r));
                                }
                            } else if (2 === arguments.length) {
                                var i = arguments[0], o = arguments[1];
                                this.init(i, o);
                            }
                        }
                    },
                    {
                        key: "determinant",
                        value: function() {
                            if ("number" == typeof arguments[3] && "number" == typeof arguments[2] && "number" == typeof arguments[0] && "number" == typeof arguments[1]) {
                                var t = arguments[0], n = arguments[1], r = arguments[2], i = arguments[3];
                                return e.determinant(e.valueOf(t), e.valueOf(n), e.valueOf(r), e.valueOf(i));
                            }
                            if (arguments[3] instanceof e && arguments[2] instanceof e && arguments[0] instanceof e && arguments[1] instanceof e) {
                                var o = arguments[1], s = arguments[2], a = arguments[3];
                                return arguments[0].multiply(a).selfSubtract(o.multiply(s));
                            }
                        }
                    },
                    {
                        key: "sqr",
                        value: function(t) {
                            return e.valueOf(t).selfMultiply(t);
                        }
                    },
                    {
                        key: "valueOf",
                        value: function() {
                            if ("string" == typeof arguments[0]) {
                                var t = arguments[0];
                                return e.parse(t);
                            }
                            if ("number" == typeof arguments[0]) return new e(arguments[0]);
                        }
                    },
                    {
                        key: "sqrt",
                        value: function(t) {
                            return e.valueOf(t).sqrt();
                        }
                    },
                    {
                        key: "parse",
                        value: function(t) {
                            for(var n = 0, r = t.length; ut.isWhitespace(t.charAt(n));)n++;
                            var i = !1;
                            if (n < r) {
                                var o = t.charAt(n);
                                "-" !== o && "+" !== o || (n++, "-" === o && (i = !0));
                            }
                            for(var s = new e, a = 0, u = 0, l = 0, h = !1; !(n >= r);){
                                var c = t.charAt(n);
                                if (n++, ut.isDigit(c)) {
                                    var f = c - "0";
                                    s.selfMultiply(e.TEN), s.selfAdd(f), a++;
                                } else {
                                    if ("." !== c) {
                                        if ("e" === c || "E" === c) {
                                            var v = t.substring(n);
                                            try {
                                                l = at.parseInt(v);
                                            } catch (e) {
                                                throw e instanceof NumberFormatException ? new NumberFormatException("Invalid exponent " + v + " in string " + t) : e;
                                            }
                                            break;
                                        }
                                        throw new NumberFormatException("Unexpected character '" + c + "' at position " + n + " in string " + t);
                                    }
                                    u = a, h = !0;
                                }
                            }
                            var g = s;
                            h || (u = a);
                            var d = a - u - l;
                            if (0 === d) g = s;
                            else if (d > 0) {
                                var p = e.TEN.pow(d);
                                g = s.divide(p);
                            } else if (d < 0) {
                                var y = e.TEN.pow(-d);
                                g = s.multiply(y);
                            }
                            return i ? g.negate() : g;
                        }
                    },
                    {
                        key: "createNaN",
                        value: function() {
                            return new e(A.NaN, A.NaN);
                        }
                    },
                    {
                        key: "copy",
                        value: function(t) {
                            return new e(t);
                        }
                    },
                    {
                        key: "magnitude",
                        value: function(t) {
                            var e = Math.abs(t), n = Math.log(e) / Math.log(10), r = Math.trunc(Math.floor(n));
                            return 10 * Math.pow(10, r) <= e && (r += 1), r;
                        }
                    },
                    {
                        key: "stringOfChar",
                        value: function(t, e) {
                            for(var n = new st, r = 0; r < e; r++)n.append(t);
                            return n.toString();
                        }
                    }
                ]), e;
            }();
            lt.PI = new lt(3.141592653589793, 12246467991473532e-32), lt.TWO_PI = new lt(6.283185307179586, 24492935982947064e-32), lt.PI_2 = new lt(1.5707963267948966, 6123233995736766e-32), lt.E = new lt(2.718281828459045, 14456468917292502e-32), lt.NaN = new lt(A.NaN, A.NaN), lt.EPS = 123259516440783e-46, lt.SPLIT = 134217729, lt.MAX_PRINT_DIGITS = 32, lt.TEN = lt.valueOf(10), lt.ONE = lt.valueOf(1), lt.SCI_NOT_EXPONENT_CHAR = "E", lt.SCI_NOT_ZERO = "0.0E0";
            var ht = function() {
                function e() {
                    t(this, e);
                }
                return n(e, null, [
                    {
                        key: "orientationIndex",
                        value: function(t, n, r) {
                            var i = e.orientationIndexFilter(t, n, r);
                            if (i <= 1) return i;
                            var o = lt.valueOf(n.x).selfAdd(-t.x), s = lt.valueOf(n.y).selfAdd(-t.y), a = lt.valueOf(r.x).selfAdd(-n.x), u = lt.valueOf(r.y).selfAdd(-n.y);
                            return o.selfMultiply(u).selfSubtract(s.selfMultiply(a)).signum();
                        }
                    },
                    {
                        key: "signOfDet2x2",
                        value: function() {
                            if (arguments[3] instanceof lt && arguments[2] instanceof lt && arguments[0] instanceof lt && arguments[1] instanceof lt) {
                                var t = arguments[1], e = arguments[2], n = arguments[3];
                                return arguments[0].multiply(n).selfSubtract(t.multiply(e)).signum();
                            }
                            if ("number" == typeof arguments[3] && "number" == typeof arguments[2] && "number" == typeof arguments[0] && "number" == typeof arguments[1]) {
                                var r = arguments[0], i = arguments[1], o = arguments[2], s = arguments[3], a = lt.valueOf(r), u = lt.valueOf(i), l = lt.valueOf(o), h = lt.valueOf(s);
                                return a.multiply(h).selfSubtract(u.multiply(l)).signum();
                            }
                        }
                    },
                    {
                        key: "intersection",
                        value: function(t, e, n, r) {
                            var i = new lt(t.y).selfSubtract(e.y), o = new lt(e.x).selfSubtract(t.x), s = new lt(t.x).selfMultiply(e.y).selfSubtract(new lt(e.x).selfMultiply(t.y)), a = new lt(n.y).selfSubtract(r.y), u = new lt(r.x).selfSubtract(n.x), l = new lt(n.x).selfMultiply(r.y).selfSubtract(new lt(r.x).selfMultiply(n.y)), h = o.multiply(l).selfSubtract(u.multiply(s)), c = a.multiply(s).selfSubtract(i.multiply(l)), f = i.multiply(u).selfSubtract(a.multiply(o)), v = h.selfDivide(f).doubleValue(), g = c.selfDivide(f).doubleValue();
                            return A.isNaN(v) || A.isInfinite(v) || A.isNaN(g) || A.isInfinite(g) ? null : new j(v, g);
                        }
                    },
                    {
                        key: "orientationIndexFilter",
                        value: function(t, n, r) {
                            var i = null, o = (t.x - r.x) * (n.y - r.y), s = (t.y - r.y) * (n.x - r.x), a = o - s;
                            if (o > 0) {
                                if (s <= 0) return e.signum(a);
                                i = o + s;
                            } else {
                                if (!(o < 0)) return e.signum(a);
                                if (s >= 0) return e.signum(a);
                                i = -o - s;
                            }
                            var u = e.DP_SAFE_EPSILON * i;
                            return a >= u || -a >= u ? e.signum(a) : 2;
                        }
                    },
                    {
                        key: "signum",
                        value: function(t) {
                            return t > 0 ? 1 : t < 0 ? -1 : 0;
                        }
                    }
                ]), e;
            }();
            ht.DP_SAFE_EPSILON = 1e-15;
            var ct = function() {
                function e() {
                    t(this, e);
                }
                return n(e, [
                    {
                        key: "getM",
                        value: function(t) {
                            if (this.hasM()) {
                                var e = this.getDimension() - this.getMeasures();
                                return this.getOrdinate(t, e);
                            }
                            return A.NaN;
                        }
                    },
                    {
                        key: "setOrdinate",
                        value: function(t, e, n) {}
                    },
                    {
                        key: "getZ",
                        value: function(t) {
                            return this.hasZ() ? this.getOrdinate(t, 2) : A.NaN;
                        }
                    },
                    {
                        key: "size",
                        value: function() {}
                    },
                    {
                        key: "getOrdinate",
                        value: function(t, e) {}
                    },
                    {
                        key: "getCoordinate",
                        value: function() {}
                    },
                    {
                        key: "getCoordinateCopy",
                        value: function(t) {}
                    },
                    {
                        key: "createCoordinate",
                        value: function() {}
                    },
                    {
                        key: "getDimension",
                        value: function() {}
                    },
                    {
                        key: "hasM",
                        value: function() {
                            return this.getMeasures() > 0;
                        }
                    },
                    {
                        key: "getX",
                        value: function(t) {}
                    },
                    {
                        key: "hasZ",
                        value: function() {
                            return this.getDimension() - this.getMeasures() > 2;
                        }
                    },
                    {
                        key: "getMeasures",
                        value: function() {
                            return 0;
                        }
                    },
                    {
                        key: "expandEnvelope",
                        value: function(t) {}
                    },
                    {
                        key: "copy",
                        value: function() {}
                    },
                    {
                        key: "getY",
                        value: function(t) {}
                    },
                    {
                        key: "toCoordinateArray",
                        value: function() {}
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                w
                            ];
                        }
                    }
                ]), e;
            }();
            ct.X = 0, ct.Y = 1, ct.Z = 2, ct.M = 3;
            var ft = function() {
                function e() {
                    t(this, e);
                }
                return n(e, null, [
                    {
                        key: "index",
                        value: function(t, e, n) {
                            return ht.orientationIndex(t, e, n);
                        }
                    },
                    {
                        key: "isCCW",
                        value: function() {
                            if (arguments[0] instanceof Array) {
                                var t = arguments[0], n = t.length - 1;
                                if (n < 3) throw new _("Ring has fewer than 4 points, so orientation cannot be determined");
                                for(var r = t[0], i = 0, o = 1; o <= n; o++){
                                    var s = t[o];
                                    s.y > r.y && (r = s, i = o);
                                }
                                var a = i;
                                do (a -= 1) < 0 && (a = n);
                                while (t[a].equals2D(r) && a !== i);
                                var u = i;
                                do u = (u + 1) % n;
                                while (t[u].equals2D(r) && u !== i);
                                var l = t[a], h = t[u];
                                if (l.equals2D(r) || h.equals2D(r) || l.equals2D(h)) return !1;
                                var c = e.index(l, r, h);
                                return 0 === c ? l.x > h.x : c > 0;
                            }
                            if (ot(arguments[0], ct)) {
                                var f = arguments[0], v = f.size() - 1;
                                if (v < 3) throw new _("Ring has fewer than 4 points, so orientation cannot be determined");
                                for(var g = f.getCoordinate(0), d = 0, p = 1; p <= v; p++){
                                    var y = f.getCoordinate(p);
                                    y.y > g.y && (g = y, d = p);
                                }
                                var m = null, x = d;
                                do (x -= 1) < 0 && (x = v), m = f.getCoordinate(x);
                                while (m.equals2D(g) && x !== d);
                                var E = null, k = d;
                                do k = (k + 1) % v, E = f.getCoordinate(k);
                                while (E.equals2D(g) && k !== d);
                                if (m.equals2D(g) || E.equals2D(g) || m.equals2D(E)) return !1;
                                var w = e.index(m, g, E);
                                return 0 === w ? m.x > E.x : w > 0;
                            }
                        }
                    }
                ]), e;
            }();
            ft.CLOCKWISE = -1, ft.RIGHT = ft.CLOCKWISE, ft.COUNTERCLOCKWISE = 1, ft.LEFT = ft.COUNTERCLOCKWISE, ft.COLLINEAR = 0, ft.STRAIGHT = ft.COLLINEAR;
            var vt = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "getCoordinate",
                        value: function() {
                            return this._minCoord;
                        }
                    },
                    {
                        key: "getRightmostSide",
                        value: function(t, e) {
                            var n = this.getRightmostSideOfSegment(t, e);
                            return n < 0 && (n = this.getRightmostSideOfSegment(t, e - 1)), n < 0 && (this._minCoord = null, this.checkForRightmostCoordinate(t)), n;
                        }
                    },
                    {
                        key: "findRightmostEdgeAtVertex",
                        value: function() {
                            var t = this._minDe.getEdge().getCoordinates();
                            G.isTrue(this._minIndex > 0 && this._minIndex < t.length, "rightmost point expected to be interior vertex of edge");
                            var e = t[this._minIndex - 1], n = t[this._minIndex + 1], r = ft.index(this._minCoord, n, e), i = !1;
                            (e.y < this._minCoord.y && n.y < this._minCoord.y && r === ft.COUNTERCLOCKWISE || e.y > this._minCoord.y && n.y > this._minCoord.y && r === ft.CLOCKWISE) && (i = !0), i && (this._minIndex = this._minIndex - 1);
                        }
                    },
                    {
                        key: "getRightmostSideOfSegment",
                        value: function(t, e) {
                            var n = t.getEdge().getCoordinates();
                            if (e < 0 || e + 1 >= n.length) return -1;
                            if (n[e].y === n[e + 1].y) return -1;
                            var r = tt.LEFT;
                            return n[e].y < n[e + 1].y && (r = tt.RIGHT), r;
                        }
                    },
                    {
                        key: "getEdge",
                        value: function() {
                            return this._orientedDe;
                        }
                    },
                    {
                        key: "checkForRightmostCoordinate",
                        value: function(t) {
                            for(var e = t.getEdge().getCoordinates(), n = 0; n < e.length - 1; n++)(null === this._minCoord || e[n].x > this._minCoord.x) && (this._minDe = t, this._minIndex = n, this._minCoord = e[n]);
                        }
                    },
                    {
                        key: "findRightmostEdgeAtNode",
                        value: function() {
                            var t = this._minDe.getNode().getEdges();
                            this._minDe = t.getRightmostEdge(), this._minDe.isForward() || (this._minDe = this._minDe.getSym(), this._minIndex = this._minDe.getEdge().getCoordinates().length - 1);
                        }
                    },
                    {
                        key: "findEdge",
                        value: function(t) {
                            for(var e = t.iterator(); e.hasNext();){
                                var n = e.next();
                                n.isForward() && this.checkForRightmostCoordinate(n);
                            }
                            G.isTrue(0 !== this._minIndex || this._minCoord.equals(this._minDe.getCoordinate()), "inconsistency in rightmost processing"), 0 === this._minIndex ? this.findRightmostEdgeAtNode() : this.findRightmostEdgeAtVertex(), this._orientedDe = this._minDe, this.getRightmostSide(this._minDe, this._minIndex) === tt.LEFT && (this._orientedDe = this._minDe.getSym());
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._minIndex = -1, this._minCoord = null, this._minDe = null, this._orientedDe = null;
                        }
                    }
                ]), e;
            }(), gt = function(e) {
                r(o, e);
                var i = c(o);
                function o(e, n) {
                    var r;
                    return t(this, o), (r = i.call(this, n ? e + " [ " + n + " ]" : e)).pt = n ? new j(n) : void 0, r.name = Object.keys({
                        TopologyException: o
                    })[0], r;
                }
                return n(o, [
                    {
                        key: "getCoordinate",
                        value: function() {
                            return this.pt;
                        }
                    }
                ]), o;
            }(F), dt = function() {
                function e() {
                    t(this, e), this.array = [];
                }
                return n(e, [
                    {
                        key: "addLast",
                        value: function(t) {
                            this.array.push(t);
                        }
                    },
                    {
                        key: "removeFirst",
                        value: function() {
                            return this.array.shift();
                        }
                    },
                    {
                        key: "isEmpty",
                        value: function() {
                            return 0 === this.array.length;
                        }
                    }
                ]), e;
            }(), pt = function(e, i) {
                r(s, e);
                var o = c(s);
                function s(e) {
                    var n;
                    return t(this, s), (n = o.call(this)).array = [], e instanceof H && n.addAll(e), n;
                }
                return n(s, [
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                rt,
                                H
                            ];
                        }
                    },
                    {
                        key: "ensureCapacity",
                        value: function() {}
                    },
                    {
                        key: "add",
                        value: function(t) {
                            return 1 === arguments.length ? this.array.push(t) : this.array.splice(arguments[0], 0, arguments[1]), !0;
                        }
                    },
                    {
                        key: "clear",
                        value: function() {
                            this.array = [];
                        }
                    },
                    {
                        key: "addAll",
                        value: function(t) {
                            var e, n = p(t);
                            try {
                                for(n.s(); !(e = n.n()).done;){
                                    var r = e.value;
                                    this.array.push(r);
                                }
                            } catch (t) {
                                n.e(t);
                            } finally{
                                n.f();
                            }
                        }
                    },
                    {
                        key: "set",
                        value: function(t, e) {
                            var n = this.array[t];
                            return this.array[t] = e, n;
                        }
                    },
                    {
                        key: "iterator",
                        value: function() {
                            return new yt(this);
                        }
                    },
                    {
                        key: "get",
                        value: function(t) {
                            if (t < 0 || t >= this.size()) throw new nt;
                            return this.array[t];
                        }
                    },
                    {
                        key: "isEmpty",
                        value: function() {
                            return 0 === this.array.length;
                        }
                    },
                    {
                        key: "sort",
                        value: function(t) {
                            t ? this.array.sort(function(e, n) {
                                return t.compare(e, n);
                            }) : this.array.sort();
                        }
                    },
                    {
                        key: "size",
                        value: function() {
                            return this.array.length;
                        }
                    },
                    {
                        key: "toArray",
                        value: function() {
                            return this.array.slice();
                        }
                    },
                    {
                        key: "remove",
                        value: function(t) {
                            for(var e = 0, n = this.array.length; e < n; e++)if (this.array[e] === t) return !!this.array.splice(e, 1);
                            return !1;
                        }
                    },
                    {
                        key: i,
                        value: function() {
                            return this.array.values();
                        }
                    }
                ]), s;
            }(rt, Symbol.iterator), yt = function() {
                function e(n) {
                    t(this, e), this.arrayList = n, this.position = 0;
                }
                return n(e, [
                    {
                        key: "next",
                        value: function() {
                            if (this.position === this.arrayList.size()) throw new W;
                            return this.arrayList.get(this.position++);
                        }
                    },
                    {
                        key: "hasNext",
                        value: function() {
                            return this.position < this.arrayList.size();
                        }
                    },
                    {
                        key: "set",
                        value: function(t) {
                            return this.arrayList.set(this.position - 1, t);
                        }
                    },
                    {
                        key: "remove",
                        value: function() {
                            this.arrayList.remove(this.arrayList.get(this.position));
                        }
                    }
                ]), e;
            }(), mt = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "clearVisitedEdges",
                        value: function() {
                            for(var t = this._dirEdgeList.iterator(); t.hasNext();)t.next().setVisited(!1);
                        }
                    },
                    {
                        key: "getRightmostCoordinate",
                        value: function() {
                            return this._rightMostCoord;
                        }
                    },
                    {
                        key: "computeNodeDepth",
                        value: function(t) {
                            for(var e = null, n = t.getEdges().iterator(); n.hasNext();){
                                var r = n.next();
                                if (r.isVisited() || r.getSym().isVisited()) {
                                    e = r;
                                    break;
                                }
                            }
                            if (null === e) throw new gt("unable to find edge to compute depths at " + t.getCoordinate());
                            t.getEdges().computeDepths(e);
                            for(var i = t.getEdges().iterator(); i.hasNext();){
                                var o = i.next();
                                o.setVisited(!0), this.copySymDepths(o);
                            }
                        }
                    },
                    {
                        key: "computeDepth",
                        value: function(t) {
                            this.clearVisitedEdges();
                            var e = this._finder.getEdge();
                            e.getNode(), e.getLabel(), e.setEdgeDepths(tt.RIGHT, t), this.copySymDepths(e), this.computeDepths(e);
                        }
                    },
                    {
                        key: "create",
                        value: function(t) {
                            this.addReachable(t), this._finder.findEdge(this._dirEdgeList), this._rightMostCoord = this._finder.getCoordinate();
                        }
                    },
                    {
                        key: "findResultEdges",
                        value: function() {
                            for(var t = this._dirEdgeList.iterator(); t.hasNext();){
                                var e = t.next();
                                e.getDepth(tt.RIGHT) >= 1 && e.getDepth(tt.LEFT) <= 0 && !e.isInteriorAreaEdge() && e.setInResult(!0);
                            }
                        }
                    },
                    {
                        key: "computeDepths",
                        value: function(t) {
                            var e = new Q, n = new dt, r = t.getNode();
                            for(n.addLast(r), e.add(r), t.setVisited(!0); !n.isEmpty();){
                                var i = n.removeFirst();
                                e.add(i), this.computeNodeDepth(i);
                                for(var o = i.getEdges().iterator(); o.hasNext();){
                                    var s = o.next().getSym();
                                    if (!s.isVisited()) {
                                        var a = s.getNode();
                                        e.contains(a) || (n.addLast(a), e.add(a));
                                    }
                                }
                            }
                        }
                    },
                    {
                        key: "compareTo",
                        value: function(t) {
                            var e = t;
                            return this._rightMostCoord.x < e._rightMostCoord.x ? -1 : this._rightMostCoord.x > e._rightMostCoord.x ? 1 : 0;
                        }
                    },
                    {
                        key: "getEnvelope",
                        value: function() {
                            if (null === this._env) {
                                for(var t = new U, e = this._dirEdgeList.iterator(); e.hasNext();)for(var n = e.next().getEdge().getCoordinates(), r = 0; r < n.length - 1; r++)t.expandToInclude(n[r]);
                                this._env = t;
                            }
                            return this._env;
                        }
                    },
                    {
                        key: "addReachable",
                        value: function(t) {
                            var e = new it;
                            for(e.add(t); !e.empty();){
                                var n = e.pop();
                                this.add(n, e);
                            }
                        }
                    },
                    {
                        key: "copySymDepths",
                        value: function(t) {
                            var e = t.getSym();
                            e.setDepth(tt.LEFT, t.getDepth(tt.RIGHT)), e.setDepth(tt.RIGHT, t.getDepth(tt.LEFT));
                        }
                    },
                    {
                        key: "add",
                        value: function(t, e) {
                            t.setVisited(!0), this._nodes.add(t);
                            for(var n = t.getEdges().iterator(); n.hasNext();){
                                var r = n.next();
                                this._dirEdgeList.add(r);
                                var i = r.getSym().getNode();
                                i.isVisited() || e.push(i);
                            }
                        }
                    },
                    {
                        key: "getNodes",
                        value: function() {
                            return this._nodes;
                        }
                    },
                    {
                        key: "getDirectedEdges",
                        value: function() {
                            return this._dirEdgeList;
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                k
                            ];
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._finder = null, this._dirEdgeList = new pt, this._nodes = new pt, this._rightMostCoord = null, this._env = null, this._finder = new vt;
                        }
                    }
                ]), e;
            }(), _t = function() {
                function e() {
                    t(this, e);
                }
                return n(e, null, [
                    {
                        key: "intersection",
                        value: function(t, e, n, r) {
                            var i = t.x < e.x ? t.x : e.x, o = t.y < e.y ? t.y : e.y, s = t.x > e.x ? t.x : e.x, a = t.y > e.y ? t.y : e.y, u = n.x < r.x ? n.x : r.x, l = n.y < r.y ? n.y : r.y, h = n.x > r.x ? n.x : r.x, c = n.y > r.y ? n.y : r.y, f = ((i > u ? i : u) + (s < h ? s : h)) / 2, v = ((o > l ? o : l) + (a < c ? a : c)) / 2, g = t.x - f, d = t.y - v, p = e.x - f, y = e.y - v, m = n.x - f, _ = n.y - v, x = r.x - f, E = r.y - v, k = d - y, w = p - g, b = g * y - p * d, I = _ - E, N = x - m, S = m * E - x * _, M = k * N - I * w, L = (w * S - N * b) / M, P = (I * b - k * S) / M;
                            return A.isNaN(L) || A.isInfinite(L) || A.isNaN(P) || A.isInfinite(P) ? null : new j(L + f, P + v);
                        }
                    }
                ]), e;
            }(), xt = function() {
                function e() {
                    t(this, e);
                }
                return n(e, null, [
                    {
                        key: "arraycopy",
                        value: function(t, e, n, r, i) {
                            for(var o = 0, s = e; s < e + i; s++)n[r + o] = t[s], o++;
                        }
                    },
                    {
                        key: "getProperty",
                        value: function(t) {
                            return ({
                                "line.separator": "\n"
                            })[t];
                        }
                    }
                ]), e;
            }(), Et = function() {
                function e() {
                    t(this, e);
                }
                return n(e, null, [
                    {
                        key: "log10",
                        value: function(t) {
                            var n = Math.log(t);
                            return A.isInfinite(n) || A.isNaN(n) ? n : n / e.LOG_10;
                        }
                    },
                    {
                        key: "min",
                        value: function(t, e, n, r) {
                            var i = t;
                            return e < i && (i = e), n < i && (i = n), r < i && (i = r), i;
                        }
                    },
                    {
                        key: "clamp",
                        value: function() {
                            if ("number" == typeof arguments[2] && "number" == typeof arguments[0] && "number" == typeof arguments[1]) {
                                var t = arguments[0], e = arguments[1], n = arguments[2];
                                return t < e ? e : t > n ? n : t;
                            }
                            if (Number.isInteger(arguments[2]) && Number.isInteger(arguments[0]) && Number.isInteger(arguments[1])) {
                                var r = arguments[0], i = arguments[1], o = arguments[2];
                                return r < i ? i : r > o ? o : r;
                            }
                        }
                    },
                    {
                        key: "wrap",
                        value: function(t, e) {
                            return t < 0 ? e - -t % e : t % e;
                        }
                    },
                    {
                        key: "max",
                        value: function() {
                            if (3 === arguments.length) {
                                var t = arguments[1], e = arguments[2], n = arguments[0];
                                return t > n && (n = t), e > n && (n = e), n;
                            }
                            if (4 === arguments.length) {
                                var r = arguments[1], i = arguments[2], o = arguments[3], s = arguments[0];
                                return r > s && (s = r), i > s && (s = i), o > s && (s = o), s;
                            }
                        }
                    },
                    {
                        key: "average",
                        value: function(t, e) {
                            return (t + e) / 2;
                        }
                    }
                ]), e;
            }();
            Et.LOG_10 = Math.log(10);
            var kt = function() {
                function e() {
                    t(this, e);
                }
                return n(e, null, [
                    {
                        key: "segmentToSegment",
                        value: function(t, n, r, i) {
                            if (t.equals(n)) return e.pointToSegment(t, r, i);
                            if (r.equals(i)) return e.pointToSegment(i, t, n);
                            var o = !1;
                            if (U.intersects(t, n, r, i)) {
                                var s = (n.x - t.x) * (i.y - r.y) - (n.y - t.y) * (i.x - r.x);
                                if (0 === s) o = !0;
                                else {
                                    var a = (t.y - r.y) * (i.x - r.x) - (t.x - r.x) * (i.y - r.y), u = ((t.y - r.y) * (n.x - t.x) - (t.x - r.x) * (n.y - t.y)) / s, l = a / s;
                                    (l < 0 || l > 1 || u < 0 || u > 1) && (o = !0);
                                }
                            } else o = !0;
                            return o ? Et.min(e.pointToSegment(t, r, i), e.pointToSegment(n, r, i), e.pointToSegment(r, t, n), e.pointToSegment(i, t, n)) : 0;
                        }
                    },
                    {
                        key: "pointToSegment",
                        value: function(t, e, n) {
                            if (e.x === n.x && e.y === n.y) return t.distance(e);
                            var r = (n.x - e.x) * (n.x - e.x) + (n.y - e.y) * (n.y - e.y), i = ((t.x - e.x) * (n.x - e.x) + (t.y - e.y) * (n.y - e.y)) / r;
                            if (i <= 0) return t.distance(e);
                            if (i >= 1) return t.distance(n);
                            var o = ((e.y - t.y) * (n.x - e.x) - (e.x - t.x) * (n.y - e.y)) / r;
                            return Math.abs(o) * Math.sqrt(r);
                        }
                    },
                    {
                        key: "pointToLinePerpendicular",
                        value: function(t, e, n) {
                            var r = (n.x - e.x) * (n.x - e.x) + (n.y - e.y) * (n.y - e.y), i = ((e.y - t.y) * (n.x - e.x) - (e.x - t.x) * (n.y - e.y)) / r;
                            return Math.abs(i) * Math.sqrt(r);
                        }
                    },
                    {
                        key: "pointToSegmentString",
                        value: function(t, n) {
                            if (0 === n.length) throw new _("Line array must contain at least one vertex");
                            for(var r = t.distance(n[0]), i = 0; i < n.length - 1; i++){
                                var o = e.pointToSegment(t, n[i], n[i + 1]);
                                o < r && (r = o);
                            }
                            return r;
                        }
                    }
                ]), e;
            }(), wt = function() {
                function e() {
                    t(this, e);
                }
                return n(e, [
                    {
                        key: "create",
                        value: function() {
                            if (1 === arguments.length) arguments[0] instanceof Array || ot(arguments[0], ct);
                            else if (2 === arguments.length) ;
                            else if (3 === arguments.length) {
                                var t = arguments[0], e = arguments[1];
                                return this.create(t, e);
                            }
                        }
                    }
                ]), e;
            }(), bt = function() {
                function e() {
                    t(this, e);
                }
                return n(e, [
                    {
                        key: "filter",
                        value: function(t) {}
                    }
                ]), e;
            }(), It = function() {
                function e() {
                    t(this, e);
                }
                return n(e, null, [
                    {
                        key: "ofLine",
                        value: function(t) {
                            var e = t.size();
                            if (e <= 1) return 0;
                            var n = 0, r = new j;
                            t.getCoordinate(0, r);
                            for(var i = r.x, o = r.y, s = 1; s < e; s++){
                                t.getCoordinate(s, r);
                                var a = r.x, u = r.y, l = a - i, h = u - o;
                                n += Math.sqrt(l * l + h * h), i = a, o = u;
                            }
                            return n;
                        }
                    }
                ]), e;
            }(), Nt = function e() {
                t(this, e);
            }, St = function() {
                function e() {
                    t(this, e);
                }
                return n(e, null, [
                    {
                        key: "copyCoord",
                        value: function(t, e, n, r) {
                            for(var i = Math.min(t.getDimension(), n.getDimension()), o = 0; o < i; o++)n.setOrdinate(r, o, t.getOrdinate(e, o));
                        }
                    },
                    {
                        key: "isRing",
                        value: function(t) {
                            var e = t.size();
                            return 0 === e || !(e <= 3) && t.getOrdinate(0, ct.X) === t.getOrdinate(e - 1, ct.X) && t.getOrdinate(0, ct.Y) === t.getOrdinate(e - 1, ct.Y);
                        }
                    },
                    {
                        key: "scroll",
                        value: function() {
                            if (2 === arguments.length) {
                                if (ot(arguments[0], ct) && Number.isInteger(arguments[1])) {
                                    var t = arguments[0], n = arguments[1];
                                    e.scroll(t, n, e.isRing(t));
                                } else if (ot(arguments[0], ct) && arguments[1] instanceof j) {
                                    var r = arguments[0], i = arguments[1], o = e.indexOf(i, r);
                                    if (o <= 0) return null;
                                    e.scroll(r, o);
                                }
                            } else if (3 === arguments.length) {
                                var s = arguments[0], a = arguments[1], u = arguments[2];
                                if (a <= 0) return null;
                                for(var l = s.copy(), h = u ? s.size() - 1 : s.size(), c = 0; c < h; c++)for(var f = 0; f < s.getDimension(); f++)s.setOrdinate(c, f, l.getOrdinate((a + c) % h, f));
                                if (u) for(var v = 0; v < s.getDimension(); v++)s.setOrdinate(h, v, s.getOrdinate(0, v));
                            }
                        }
                    },
                    {
                        key: "isEqual",
                        value: function(t, e) {
                            var n = t.size();
                            if (n !== e.size()) return !1;
                            for(var r = Math.min(t.getDimension(), e.getDimension()), i = 0; i < n; i++)for(var o = 0; o < r; o++){
                                var s = t.getOrdinate(i, o), a = e.getOrdinate(i, o);
                                if (!(t.getOrdinate(i, o) === e.getOrdinate(i, o) || A.isNaN(s) && A.isNaN(a))) return !1;
                            }
                            return !0;
                        }
                    },
                    {
                        key: "minCoordinateIndex",
                        value: function() {
                            if (1 === arguments.length) {
                                var t = arguments[0];
                                return e.minCoordinateIndex(t, 0, t.size() - 1);
                            }
                            if (3 === arguments.length) {
                                for(var n = arguments[0], r = arguments[2], i = -1, o = null, s = arguments[1]; s <= r; s++){
                                    var a = n.getCoordinate(s);
                                    (null === o || o.compareTo(a) > 0) && (o = a, i = s);
                                }
                                return i;
                            }
                        }
                    },
                    {
                        key: "extend",
                        value: function(t, n, r) {
                            var i = t.create(r, n.getDimension()), o = n.size();
                            if (e.copy(n, 0, i, 0, o), o > 0) for(var s = o; s < r; s++)e.copy(n, o - 1, i, s, 1);
                            return i;
                        }
                    },
                    {
                        key: "reverse",
                        value: function(t) {
                            for(var n = t.size() - 1, r = Math.trunc(n / 2), i = 0; i <= r; i++)e.swap(t, i, n - i);
                        }
                    },
                    {
                        key: "swap",
                        value: function(t, e, n) {
                            if (e === n) return null;
                            for(var r = 0; r < t.getDimension(); r++){
                                var i = t.getOrdinate(e, r);
                                t.setOrdinate(e, r, t.getOrdinate(n, r)), t.setOrdinate(n, r, i);
                            }
                        }
                    },
                    {
                        key: "copy",
                        value: function(t, n, r, i, o) {
                            for(var s = 0; s < o; s++)e.copyCoord(t, n + s, r, i + s);
                        }
                    },
                    {
                        key: "ensureValidRing",
                        value: function(t, n) {
                            var r = n.size();
                            return 0 === r ? n : r <= 3 ? e.createClosedRing(t, n, 4) : n.getOrdinate(0, ct.X) === n.getOrdinate(r - 1, ct.X) && n.getOrdinate(0, ct.Y) === n.getOrdinate(r - 1, ct.Y) ? n : e.createClosedRing(t, n, r + 1);
                        }
                    },
                    {
                        key: "indexOf",
                        value: function(t, e) {
                            for(var n = 0; n < e.size(); n++)if (t.x === e.getOrdinate(n, ct.X) && t.y === e.getOrdinate(n, ct.Y)) return n;
                            return -1;
                        }
                    },
                    {
                        key: "createClosedRing",
                        value: function(t, n, r) {
                            var i = t.create(r, n.getDimension()), o = n.size();
                            e.copy(n, 0, i, 0, o);
                            for(var s = o; s < r; s++)e.copy(n, 0, i, s, 1);
                            return i;
                        }
                    },
                    {
                        key: "minCoordinate",
                        value: function(t) {
                            for(var e = null, n = 0; n < t.size(); n++){
                                var r = t.getCoordinate(n);
                                (null === e || e.compareTo(r) > 0) && (e = r);
                            }
                            return e;
                        }
                    }
                ]), e;
            }(), Mt = function() {
                function e() {
                    t(this, e);
                }
                return n(e, null, [
                    {
                        key: "toDimensionSymbol",
                        value: function(t) {
                            switch(t){
                                case e.FALSE:
                                    return e.SYM_FALSE;
                                case e.TRUE:
                                    return e.SYM_TRUE;
                                case e.DONTCARE:
                                    return e.SYM_DONTCARE;
                                case e.P:
                                    return e.SYM_P;
                                case e.L:
                                    return e.SYM_L;
                                case e.A:
                                    return e.SYM_A;
                            }
                            throw new _("Unknown dimension value: " + t);
                        }
                    },
                    {
                        key: "toDimensionValue",
                        value: function(t) {
                            switch(ut.toUpperCase(t)){
                                case e.SYM_FALSE:
                                    return e.FALSE;
                                case e.SYM_TRUE:
                                    return e.TRUE;
                                case e.SYM_DONTCARE:
                                    return e.DONTCARE;
                                case e.SYM_P:
                                    return e.P;
                                case e.SYM_L:
                                    return e.L;
                                case e.SYM_A:
                                    return e.A;
                            }
                            throw new _("Unknown dimension symbol: " + t);
                        }
                    }
                ]), e;
            }();
            Mt.P = 0, Mt.L = 1, Mt.A = 2, Mt.FALSE = -1, Mt.TRUE = -2, Mt.DONTCARE = -3, Mt.SYM_FALSE = "F", Mt.SYM_TRUE = "T", Mt.SYM_DONTCARE = "*", Mt.SYM_P = "0", Mt.SYM_L = "1", Mt.SYM_A = "2";
            var Lt = function() {
                function e() {
                    t(this, e);
                }
                return n(e, [
                    {
                        key: "filter",
                        value: function(t) {}
                    }
                ]), e;
            }(), Pt = function() {
                function e() {
                    t(this, e);
                }
                return n(e, [
                    {
                        key: "filter",
                        value: function(t, e) {}
                    },
                    {
                        key: "isDone",
                        value: function() {}
                    },
                    {
                        key: "isGeometryChanged",
                        value: function() {}
                    }
                ]), e;
            }(), Ct = function(e) {
                r(s, e);
                var o = c(s);
                function s() {
                    var e;
                    return t(this, s), e = o.call(this), s.constructor_.apply(l(e), arguments), e;
                }
                return n(s, [
                    {
                        key: "computeEnvelopeInternal",
                        value: function() {
                            return this.isEmpty() ? new U : this._points.expandEnvelope(new U);
                        }
                    },
                    {
                        key: "isRing",
                        value: function() {
                            return this.isClosed() && this.isSimple();
                        }
                    },
                    {
                        key: "getCoordinates",
                        value: function() {
                            return this._points.toCoordinateArray();
                        }
                    },
                    {
                        key: "copyInternal",
                        value: function() {
                            return new s(this._points.copy(), this._factory);
                        }
                    },
                    {
                        key: "equalsExact",
                        value: function() {
                            if (2 === arguments.length && "number" == typeof arguments[1] && arguments[0] instanceof V) {
                                var t = arguments[0], e = arguments[1];
                                if (!this.isEquivalentClass(t)) return !1;
                                var n = t;
                                if (this._points.size() !== n._points.size()) return !1;
                                for(var r = 0; r < this._points.size(); r++)if (!this.equal(this._points.getCoordinate(r), n._points.getCoordinate(r), e)) return !1;
                                return !0;
                            }
                            return f(i(s.prototype), "equalsExact", this).apply(this, arguments);
                        }
                    },
                    {
                        key: "normalize",
                        value: function() {
                            for(var t = 0; t < Math.trunc(this._points.size() / 2); t++){
                                var e = this._points.size() - 1 - t;
                                if (!this._points.getCoordinate(t).equals(this._points.getCoordinate(e))) {
                                    if (this._points.getCoordinate(t).compareTo(this._points.getCoordinate(e)) > 0) {
                                        var n = this._points.copy();
                                        St.reverse(n), this._points = n;
                                    }
                                    return null;
                                }
                            }
                        }
                    },
                    {
                        key: "getCoordinate",
                        value: function() {
                            return this.isEmpty() ? null : this._points.getCoordinate(0);
                        }
                    },
                    {
                        key: "getBoundaryDimension",
                        value: function() {
                            return this.isClosed() ? Mt.FALSE : 0;
                        }
                    },
                    {
                        key: "isClosed",
                        value: function() {
                            return !this.isEmpty() && this.getCoordinateN(0).equals2D(this.getCoordinateN(this.getNumPoints() - 1));
                        }
                    },
                    {
                        key: "reverseInternal",
                        value: function() {
                            var t = this._points.copy();
                            return St.reverse(t), this.getFactory().createLineString(t);
                        }
                    },
                    {
                        key: "getEndPoint",
                        value: function() {
                            return this.isEmpty() ? null : this.getPointN(this.getNumPoints() - 1);
                        }
                    },
                    {
                        key: "getTypeCode",
                        value: function() {
                            return V.TYPECODE_LINESTRING;
                        }
                    },
                    {
                        key: "getDimension",
                        value: function() {
                            return 1;
                        }
                    },
                    {
                        key: "getLength",
                        value: function() {
                            return It.ofLine(this._points);
                        }
                    },
                    {
                        key: "getNumPoints",
                        value: function() {
                            return this._points.size();
                        }
                    },
                    {
                        key: "compareToSameClass",
                        value: function() {
                            if (1 === arguments.length) {
                                for(var t = arguments[0], e = 0, n = 0; e < this._points.size() && n < t._points.size();){
                                    var r = this._points.getCoordinate(e).compareTo(t._points.getCoordinate(n));
                                    if (0 !== r) return r;
                                    e++, n++;
                                }
                                return e < this._points.size() ? 1 : n < t._points.size() ? -1 : 0;
                            }
                            if (2 === arguments.length) {
                                var i = arguments[0];
                                return arguments[1].compare(this._points, i._points);
                            }
                        }
                    },
                    {
                        key: "apply",
                        value: function() {
                            if (ot(arguments[0], bt)) for(var t = arguments[0], e = 0; e < this._points.size(); e++)t.filter(this._points.getCoordinate(e));
                            else if (ot(arguments[0], Pt)) {
                                var n = arguments[0];
                                if (0 === this._points.size()) return null;
                                for(var r = 0; r < this._points.size() && (n.filter(this._points, r), !n.isDone()); r++);
                                n.isGeometryChanged() && this.geometryChanged();
                            } else (ot(arguments[0], Lt) || ot(arguments[0], x)) && arguments[0].filter(this);
                        }
                    },
                    {
                        key: "getBoundary",
                        value: function() {
                            throw new J;
                        }
                    },
                    {
                        key: "isEquivalentClass",
                        value: function(t) {
                            return t instanceof s;
                        }
                    },
                    {
                        key: "getCoordinateN",
                        value: function(t) {
                            return this._points.getCoordinate(t);
                        }
                    },
                    {
                        key: "getGeometryType",
                        value: function() {
                            return V.TYPENAME_LINESTRING;
                        }
                    },
                    {
                        key: "getCoordinateSequence",
                        value: function() {
                            return this._points;
                        }
                    },
                    {
                        key: "isEmpty",
                        value: function() {
                            return 0 === this._points.size();
                        }
                    },
                    {
                        key: "init",
                        value: function(t) {
                            if (null === t && (t = this.getFactory().getCoordinateSequenceFactory().create([])), 1 === t.size()) throw new _("Invalid number of points in LineString (found " + t.size() + " - must be 0 or >= 2)");
                            this._points = t;
                        }
                    },
                    {
                        key: "isCoordinate",
                        value: function(t) {
                            for(var e = 0; e < this._points.size(); e++)if (this._points.getCoordinate(e).equals(t)) return !0;
                            return !1;
                        }
                    },
                    {
                        key: "getStartPoint",
                        value: function() {
                            return this.isEmpty() ? null : this.getPointN(0);
                        }
                    },
                    {
                        key: "getPointN",
                        value: function(t) {
                            return this.getFactory().createPoint(this._points.getCoordinate(t));
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                Nt
                            ];
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            if (this._points = null, 0 === arguments.length) ;
                            else if (2 === arguments.length) {
                                var t = arguments[0], e = arguments[1];
                                V.constructor_.call(this, e), this.init(t);
                            }
                        }
                    }
                ]), s;
            }(V), Tt = function e() {
                t(this, e);
            }, Ot = function(e) {
                r(s, e);
                var o = c(s);
                function s() {
                    var e;
                    return t(this, s), e = o.call(this), s.constructor_.apply(l(e), arguments), e;
                }
                return n(s, [
                    {
                        key: "computeEnvelopeInternal",
                        value: function() {
                            if (this.isEmpty()) return new U;
                            var t = new U;
                            return t.expandToInclude(this._coordinates.getX(0), this._coordinates.getY(0)), t;
                        }
                    },
                    {
                        key: "getCoordinates",
                        value: function() {
                            return this.isEmpty() ? [] : [
                                this.getCoordinate()
                            ];
                        }
                    },
                    {
                        key: "copyInternal",
                        value: function() {
                            return new s(this._coordinates.copy(), this._factory);
                        }
                    },
                    {
                        key: "equalsExact",
                        value: function() {
                            if (2 === arguments.length && "number" == typeof arguments[1] && arguments[0] instanceof V) {
                                var t = arguments[0], e = arguments[1];
                                return !!this.isEquivalentClass(t) && (!(!this.isEmpty() || !t.isEmpty()) || this.isEmpty() === t.isEmpty() && this.equal(t.getCoordinate(), this.getCoordinate(), e));
                            }
                            return f(i(s.prototype), "equalsExact", this).apply(this, arguments);
                        }
                    },
                    {
                        key: "normalize",
                        value: function() {}
                    },
                    {
                        key: "getCoordinate",
                        value: function() {
                            return 0 !== this._coordinates.size() ? this._coordinates.getCoordinate(0) : null;
                        }
                    },
                    {
                        key: "getBoundaryDimension",
                        value: function() {
                            return Mt.FALSE;
                        }
                    },
                    {
                        key: "reverseInternal",
                        value: function() {
                            return this.getFactory().createPoint(this._coordinates.copy());
                        }
                    },
                    {
                        key: "getTypeCode",
                        value: function() {
                            return V.TYPECODE_POINT;
                        }
                    },
                    {
                        key: "getDimension",
                        value: function() {
                            return 0;
                        }
                    },
                    {
                        key: "getNumPoints",
                        value: function() {
                            return this.isEmpty() ? 0 : 1;
                        }
                    },
                    {
                        key: "getX",
                        value: function() {
                            if (null === this.getCoordinate()) throw new IllegalStateException("getX called on empty Point");
                            return this.getCoordinate().x;
                        }
                    },
                    {
                        key: "compareToSameClass",
                        value: function() {
                            if (1 === arguments.length) {
                                var t = arguments[0];
                                return this.getCoordinate().compareTo(t.getCoordinate());
                            }
                            if (2 === arguments.length) {
                                var e = arguments[0];
                                return arguments[1].compare(this._coordinates, e._coordinates);
                            }
                        }
                    },
                    {
                        key: "apply",
                        value: function() {
                            if (ot(arguments[0], bt)) {
                                var t = arguments[0];
                                if (this.isEmpty()) return null;
                                t.filter(this.getCoordinate());
                            } else if (ot(arguments[0], Pt)) {
                                var e = arguments[0];
                                if (this.isEmpty()) return null;
                                e.filter(this._coordinates, 0), e.isGeometryChanged() && this.geometryChanged();
                            } else (ot(arguments[0], Lt) || ot(arguments[0], x)) && arguments[0].filter(this);
                        }
                    },
                    {
                        key: "getBoundary",
                        value: function() {
                            return this.getFactory().createGeometryCollection();
                        }
                    },
                    {
                        key: "getGeometryType",
                        value: function() {
                            return V.TYPENAME_POINT;
                        }
                    },
                    {
                        key: "getCoordinateSequence",
                        value: function() {
                            return this._coordinates;
                        }
                    },
                    {
                        key: "getY",
                        value: function() {
                            if (null === this.getCoordinate()) throw new IllegalStateException("getY called on empty Point");
                            return this.getCoordinate().y;
                        }
                    },
                    {
                        key: "isEmpty",
                        value: function() {
                            return 0 === this._coordinates.size();
                        }
                    },
                    {
                        key: "init",
                        value: function(t) {
                            null === t && (t = this.getFactory().getCoordinateSequenceFactory().create([])), G.isTrue(t.size() <= 1), this._coordinates = t;
                        }
                    },
                    {
                        key: "isSimple",
                        value: function() {
                            return !0;
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                Tt
                            ];
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._coordinates = null;
                            var t = arguments[0], e = arguments[1];
                            V.constructor_.call(this, e), this.init(t);
                        }
                    }
                ]), s;
            }(V), Rt = function() {
                function e() {
                    t(this, e);
                }
                return n(e, null, [
                    {
                        key: "ofRing",
                        value: function() {
                            if (arguments[0] instanceof Array) {
                                var t = arguments[0];
                                return Math.abs(e.ofRingSigned(t));
                            }
                            if (ot(arguments[0], ct)) {
                                var n = arguments[0];
                                return Math.abs(e.ofRingSigned(n));
                            }
                        }
                    },
                    {
                        key: "ofRingSigned",
                        value: function() {
                            if (arguments[0] instanceof Array) {
                                var t = arguments[0];
                                if (t.length < 3) return 0;
                                for(var e = 0, n = t[0].x, r = 1; r < t.length - 1; r++){
                                    var i = t[r].x - n, o = t[r + 1].y;
                                    e += i * (t[r - 1].y - o);
                                }
                                return e / 2;
                            }
                            if (ot(arguments[0], ct)) {
                                var s = arguments[0], a = s.size();
                                if (a < 3) return 0;
                                var u = new j, l = new j, h = new j;
                                s.getCoordinate(0, l), s.getCoordinate(1, h);
                                var c = l.x;
                                h.x -= c;
                                for(var f = 0, v = 1; v < a - 1; v++)u.y = l.y, l.x = h.x, l.y = h.y, s.getCoordinate(v + 1, h), h.x -= c, f += l.x * (u.y - h.y);
                                return f / 2;
                            }
                        }
                    }
                ]), e;
            }(), At = function() {
                function e() {
                    t(this, e);
                }
                return n(e, null, [
                    {
                        key: "sort",
                        value: function() {
                            var t = arguments, e = arguments[0];
                            if (1 === arguments.length) e.sort(function(t, e) {
                                return t.compareTo(e);
                            });
                            else if (2 === arguments.length) e.sort(function(e, n) {
                                return t[1].compare(e, n);
                            });
                            else if (3 === arguments.length) {
                                var n = e.slice(arguments[1], arguments[2]);
                                n.sort();
                                var r = e.slice(0, arguments[1]).concat(n, e.slice(arguments[2], e.length));
                                e.splice(0, e.length);
                                var i, o = p(r);
                                try {
                                    for(o.s(); !(i = o.n()).done;){
                                        var s = i.value;
                                        e.push(s);
                                    }
                                } catch (t) {
                                    o.e(t);
                                } finally{
                                    o.f();
                                }
                            } else if (4 === arguments.length) {
                                var a = e.slice(arguments[1], arguments[2]);
                                a.sort(function(e, n) {
                                    return t[3].compare(e, n);
                                });
                                var u = e.slice(0, arguments[1]).concat(a, e.slice(arguments[2], e.length));
                                e.splice(0, e.length);
                                var l, h = p(u);
                                try {
                                    for(h.s(); !(l = h.n()).done;){
                                        var c = l.value;
                                        e.push(c);
                                    }
                                } catch (t) {
                                    h.e(t);
                                } finally{
                                    h.f();
                                }
                            }
                        }
                    },
                    {
                        key: "asList",
                        value: function(t) {
                            var e, n = new pt, r = p(t);
                            try {
                                for(r.s(); !(e = r.n()).done;){
                                    var i = e.value;
                                    n.add(i);
                                }
                            } catch (t) {
                                r.e(t);
                            } finally{
                                r.f();
                            }
                            return n;
                        }
                    },
                    {
                        key: "copyOf",
                        value: function(t, e) {
                            return t.slice(0, e);
                        }
                    }
                ]), e;
            }(), Dt = function e() {
                t(this, e);
            }, Ft = function(e) {
                r(s, e);
                var o = c(s);
                function s() {
                    var e;
                    return t(this, s), e = o.call(this), s.constructor_.apply(l(e), arguments), e;
                }
                return n(s, [
                    {
                        key: "computeEnvelopeInternal",
                        value: function() {
                            return this._shell.getEnvelopeInternal();
                        }
                    },
                    {
                        key: "getCoordinates",
                        value: function() {
                            if (this.isEmpty()) return [];
                            for(var t = new Array(this.getNumPoints()).fill(null), e = -1, n = this._shell.getCoordinates(), r = 0; r < n.length; r++)t[++e] = n[r];
                            for(var i = 0; i < this._holes.length; i++)for(var o = this._holes[i].getCoordinates(), s = 0; s < o.length; s++)t[++e] = o[s];
                            return t;
                        }
                    },
                    {
                        key: "getArea",
                        value: function() {
                            var t = 0;
                            t += Rt.ofRing(this._shell.getCoordinateSequence());
                            for(var e = 0; e < this._holes.length; e++)t -= Rt.ofRing(this._holes[e].getCoordinateSequence());
                            return t;
                        }
                    },
                    {
                        key: "copyInternal",
                        value: function() {
                            for(var t = this._shell.copy(), e = new Array(this._holes.length).fill(null), n = 0; n < this._holes.length; n++)e[n] = this._holes[n].copy();
                            return new s(t, e, this._factory);
                        }
                    },
                    {
                        key: "isRectangle",
                        value: function() {
                            if (0 !== this.getNumInteriorRing()) return !1;
                            if (null === this._shell) return !1;
                            if (5 !== this._shell.getNumPoints()) return !1;
                            for(var t = this._shell.getCoordinateSequence(), e = this.getEnvelopeInternal(), n = 0; n < 5; n++){
                                var r = t.getX(n);
                                if (r !== e.getMinX() && r !== e.getMaxX()) return !1;
                                var i = t.getY(n);
                                if (i !== e.getMinY() && i !== e.getMaxY()) return !1;
                            }
                            for(var o = t.getX(0), s = t.getY(0), a = 1; a <= 4; a++){
                                var u = t.getX(a), l = t.getY(a);
                                if (u !== o == (l !== s)) return !1;
                                o = u, s = l;
                            }
                            return !0;
                        }
                    },
                    {
                        key: "equalsExact",
                        value: function() {
                            if (2 === arguments.length && "number" == typeof arguments[1] && arguments[0] instanceof V) {
                                var t = arguments[0], e = arguments[1];
                                if (!this.isEquivalentClass(t)) return !1;
                                var n = t, r = this._shell, o = n._shell;
                                if (!r.equalsExact(o, e)) return !1;
                                if (this._holes.length !== n._holes.length) return !1;
                                for(var a = 0; a < this._holes.length; a++)if (!this._holes[a].equalsExact(n._holes[a], e)) return !1;
                                return !0;
                            }
                            return f(i(s.prototype), "equalsExact", this).apply(this, arguments);
                        }
                    },
                    {
                        key: "normalize",
                        value: function() {
                            if (0 === arguments.length) {
                                this._shell = this.normalized(this._shell, !0);
                                for(var t = 0; t < this._holes.length; t++)this._holes[t] = this.normalized(this._holes[t], !1);
                                At.sort(this._holes);
                            } else if (2 === arguments.length) {
                                var e = arguments[0], n = arguments[1];
                                if (e.isEmpty()) return null;
                                var r = e.getCoordinateSequence(), i = St.minCoordinateIndex(r, 0, r.size() - 2);
                                St.scroll(r, i, !0), ft.isCCW(r) === n && St.reverse(r);
                            }
                        }
                    },
                    {
                        key: "getCoordinate",
                        value: function() {
                            return this._shell.getCoordinate();
                        }
                    },
                    {
                        key: "getNumInteriorRing",
                        value: function() {
                            return this._holes.length;
                        }
                    },
                    {
                        key: "getBoundaryDimension",
                        value: function() {
                            return 1;
                        }
                    },
                    {
                        key: "reverseInternal",
                        value: function() {
                            for(var t = this.getExteriorRing().reverse(), e = new Array(this.getNumInteriorRing()).fill(null), n = 0; n < e.length; n++)e[n] = this.getInteriorRingN(n).reverse();
                            return this.getFactory().createPolygon(t, e);
                        }
                    },
                    {
                        key: "getTypeCode",
                        value: function() {
                            return V.TYPECODE_POLYGON;
                        }
                    },
                    {
                        key: "getDimension",
                        value: function() {
                            return 2;
                        }
                    },
                    {
                        key: "getLength",
                        value: function() {
                            var t = 0;
                            t += this._shell.getLength();
                            for(var e = 0; e < this._holes.length; e++)t += this._holes[e].getLength();
                            return t;
                        }
                    },
                    {
                        key: "getNumPoints",
                        value: function() {
                            for(var t = this._shell.getNumPoints(), e = 0; e < this._holes.length; e++)t += this._holes[e].getNumPoints();
                            return t;
                        }
                    },
                    {
                        key: "convexHull",
                        value: function() {
                            return this.getExteriorRing().convexHull();
                        }
                    },
                    {
                        key: "normalized",
                        value: function(t, e) {
                            var n = t.copy();
                            return this.normalize(n, e), n;
                        }
                    },
                    {
                        key: "compareToSameClass",
                        value: function() {
                            if (1 === arguments.length) {
                                var t = arguments[0], e = this._shell, n = t._shell;
                                return e.compareToSameClass(n);
                            }
                            if (2 === arguments.length) {
                                var r = arguments[1], i = arguments[0], o = this._shell, s = i._shell, a = o.compareToSameClass(s, r);
                                if (0 !== a) return a;
                                for(var u = this.getNumInteriorRing(), l = i.getNumInteriorRing(), h = 0; h < u && h < l;){
                                    var c = this.getInteriorRingN(h), f = i.getInteriorRingN(h), v = c.compareToSameClass(f, r);
                                    if (0 !== v) return v;
                                    h++;
                                }
                                return h < u ? 1 : h < l ? -1 : 0;
                            }
                        }
                    },
                    {
                        key: "apply",
                        value: function() {
                            if (ot(arguments[0], bt)) {
                                var t = arguments[0];
                                this._shell.apply(t);
                                for(var e = 0; e < this._holes.length; e++)this._holes[e].apply(t);
                            } else if (ot(arguments[0], Pt)) {
                                var n = arguments[0];
                                if (this._shell.apply(n), !n.isDone()) for(var r = 0; r < this._holes.length && (this._holes[r].apply(n), !n.isDone()); r++);
                                n.isGeometryChanged() && this.geometryChanged();
                            } else if (ot(arguments[0], Lt)) arguments[0].filter(this);
                            else if (ot(arguments[0], x)) {
                                var i = arguments[0];
                                i.filter(this), this._shell.apply(i);
                                for(var o = 0; o < this._holes.length; o++)this._holes[o].apply(i);
                            }
                        }
                    },
                    {
                        key: "getBoundary",
                        value: function() {
                            if (this.isEmpty()) return this.getFactory().createMultiLineString();
                            var t = new Array(this._holes.length + 1).fill(null);
                            t[0] = this._shell;
                            for(var e = 0; e < this._holes.length; e++)t[e + 1] = this._holes[e];
                            return t.length <= 1 ? this.getFactory().createLinearRing(t[0].getCoordinateSequence()) : this.getFactory().createMultiLineString(t);
                        }
                    },
                    {
                        key: "getGeometryType",
                        value: function() {
                            return V.TYPENAME_POLYGON;
                        }
                    },
                    {
                        key: "getExteriorRing",
                        value: function() {
                            return this._shell;
                        }
                    },
                    {
                        key: "isEmpty",
                        value: function() {
                            return this._shell.isEmpty();
                        }
                    },
                    {
                        key: "getInteriorRingN",
                        value: function(t) {
                            return this._holes[t];
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                Dt
                            ];
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._shell = null, this._holes = null;
                            var t = arguments[0], e = arguments[1], n = arguments[2];
                            if (V.constructor_.call(this, n), null === t && (t = this.getFactory().createLinearRing()), null === e && (e = []), V.hasNullElements(e)) throw new _("holes must not contain null elements");
                            if (t.isEmpty() && V.hasNonEmptyElements(e)) throw new _("shell is empty but holes are not");
                            this._shell = t, this._holes = e;
                        }
                    }
                ]), s;
            }(V), qt = function(e) {
                r(i, e);
                var n = c(i);
                function i() {
                    return t(this, i), n.apply(this, arguments);
                }
                return i;
            }(K), Gt = function(e) {
                r(o, e);
                var i = c(o);
                function o(e) {
                    var n;
                    return t(this, o), (n = i.call(this)).array = [], e instanceof H && n.addAll(e), n;
                }
                return n(o, [
                    {
                        key: "contains",
                        value: function(t) {
                            var e, n = p(this.array);
                            try {
                                for(n.s(); !(e = n.n()).done;)if (0 === e.value.compareTo(t)) return !0;
                            } catch (t) {
                                n.e(t);
                            } finally{
                                n.f();
                            }
                            return !1;
                        }
                    },
                    {
                        key: "add",
                        value: function(t) {
                            if (this.contains(t)) return !1;
                            for(var e = 0, n = this.array.length; e < n; e++)if (1 === this.array[e].compareTo(t)) return !!this.array.splice(e, 0, t);
                            return this.array.push(t), !0;
                        }
                    },
                    {
                        key: "addAll",
                        value: function(t) {
                            var e, n = p(t);
                            try {
                                for(n.s(); !(e = n.n()).done;){
                                    var r = e.value;
                                    this.add(r);
                                }
                            } catch (t) {
                                n.e(t);
                            } finally{
                                n.f();
                            }
                            return !0;
                        }
                    },
                    {
                        key: "remove",
                        value: function() {
                            throw new J;
                        }
                    },
                    {
                        key: "size",
                        value: function() {
                            return this.array.length;
                        }
                    },
                    {
                        key: "isEmpty",
                        value: function() {
                            return 0 === this.array.length;
                        }
                    },
                    {
                        key: "toArray",
                        value: function() {
                            return this.array.slice();
                        }
                    },
                    {
                        key: "iterator",
                        value: function() {
                            return new Yt(this.array);
                        }
                    }
                ]), o;
            }(qt), Yt = function() {
                function e(n) {
                    t(this, e), this.array = n, this.position = 0;
                }
                return n(e, [
                    {
                        key: "next",
                        value: function() {
                            if (this.position === this.array.length) throw new W;
                            return this.array[this.position++];
                        }
                    },
                    {
                        key: "hasNext",
                        value: function() {
                            return this.position < this.array.length;
                        }
                    },
                    {
                        key: "remove",
                        value: function() {
                            throw new J;
                        }
                    }
                ]), e;
            }(), Bt = function(e) {
                r(s, e);
                var o = c(s);
                function s() {
                    var e;
                    return t(this, s), e = o.call(this), s.constructor_.apply(l(e), arguments), e;
                }
                return n(s, [
                    {
                        key: "computeEnvelopeInternal",
                        value: function() {
                            for(var t = new U, e = 0; e < this._geometries.length; e++)t.expandToInclude(this._geometries[e].getEnvelopeInternal());
                            return t;
                        }
                    },
                    {
                        key: "getGeometryN",
                        value: function(t) {
                            return this._geometries[t];
                        }
                    },
                    {
                        key: "getCoordinates",
                        value: function() {
                            for(var t = new Array(this.getNumPoints()).fill(null), e = -1, n = 0; n < this._geometries.length; n++)for(var r = this._geometries[n].getCoordinates(), i = 0; i < r.length; i++)t[++e] = r[i];
                            return t;
                        }
                    },
                    {
                        key: "getArea",
                        value: function() {
                            for(var t = 0, e = 0; e < this._geometries.length; e++)t += this._geometries[e].getArea();
                            return t;
                        }
                    },
                    {
                        key: "copyInternal",
                        value: function() {
                            for(var t = new Array(this._geometries.length).fill(null), e = 0; e < t.length; e++)t[e] = this._geometries[e].copy();
                            return new s(t, this._factory);
                        }
                    },
                    {
                        key: "equalsExact",
                        value: function() {
                            if (2 === arguments.length && "number" == typeof arguments[1] && arguments[0] instanceof V) {
                                var t = arguments[0], e = arguments[1];
                                if (!this.isEquivalentClass(t)) return !1;
                                var n = t;
                                if (this._geometries.length !== n._geometries.length) return !1;
                                for(var r = 0; r < this._geometries.length; r++)if (!this._geometries[r].equalsExact(n._geometries[r], e)) return !1;
                                return !0;
                            }
                            return f(i(s.prototype), "equalsExact", this).apply(this, arguments);
                        }
                    },
                    {
                        key: "normalize",
                        value: function() {
                            for(var t = 0; t < this._geometries.length; t++)this._geometries[t].normalize();
                            At.sort(this._geometries);
                        }
                    },
                    {
                        key: "getCoordinate",
                        value: function() {
                            return this.isEmpty() ? null : this._geometries[0].getCoordinate();
                        }
                    },
                    {
                        key: "getBoundaryDimension",
                        value: function() {
                            for(var t = Mt.FALSE, e = 0; e < this._geometries.length; e++)t = Math.max(t, this._geometries[e].getBoundaryDimension());
                            return t;
                        }
                    },
                    {
                        key: "reverseInternal",
                        value: function() {
                            for(var t = this._geometries.length, e = new pt(t), n = 0; n < t; n++)e.add(this._geometries[n].reverse());
                            return this.getFactory().buildGeometry(e);
                        }
                    },
                    {
                        key: "getTypeCode",
                        value: function() {
                            return V.TYPECODE_GEOMETRYCOLLECTION;
                        }
                    },
                    {
                        key: "getDimension",
                        value: function() {
                            for(var t = Mt.FALSE, e = 0; e < this._geometries.length; e++)t = Math.max(t, this._geometries[e].getDimension());
                            return t;
                        }
                    },
                    {
                        key: "getLength",
                        value: function() {
                            for(var t = 0, e = 0; e < this._geometries.length; e++)t += this._geometries[e].getLength();
                            return t;
                        }
                    },
                    {
                        key: "getNumPoints",
                        value: function() {
                            for(var t = 0, e = 0; e < this._geometries.length; e++)t += this._geometries[e].getNumPoints();
                            return t;
                        }
                    },
                    {
                        key: "getNumGeometries",
                        value: function() {
                            return this._geometries.length;
                        }
                    },
                    {
                        key: "compareToSameClass",
                        value: function() {
                            if (1 === arguments.length) {
                                var t = arguments[0], e = new Gt(At.asList(this._geometries)), n = new Gt(At.asList(t._geometries));
                                return this.compare(e, n);
                            }
                            if (2 === arguments.length) {
                                for(var r = arguments[1], i = arguments[0], o = this.getNumGeometries(), s = i.getNumGeometries(), a = 0; a < o && a < s;){
                                    var u = this.getGeometryN(a), l = i.getGeometryN(a), h = u.compareToSameClass(l, r);
                                    if (0 !== h) return h;
                                    a++;
                                }
                                return a < o ? 1 : a < s ? -1 : 0;
                            }
                        }
                    },
                    {
                        key: "apply",
                        value: function() {
                            if (ot(arguments[0], bt)) for(var t = arguments[0], e = 0; e < this._geometries.length; e++)this._geometries[e].apply(t);
                            else if (ot(arguments[0], Pt)) {
                                var n = arguments[0];
                                if (0 === this._geometries.length) return null;
                                for(var r = 0; r < this._geometries.length && (this._geometries[r].apply(n), !n.isDone()); r++);
                                n.isGeometryChanged() && this.geometryChanged();
                            } else if (ot(arguments[0], Lt)) {
                                var i = arguments[0];
                                i.filter(this);
                                for(var o = 0; o < this._geometries.length; o++)this._geometries[o].apply(i);
                            } else if (ot(arguments[0], x)) {
                                var s = arguments[0];
                                s.filter(this);
                                for(var a = 0; a < this._geometries.length; a++)this._geometries[a].apply(s);
                            }
                        }
                    },
                    {
                        key: "getBoundary",
                        value: function() {
                            return V.checkNotGeometryCollection(this), G.shouldNeverReachHere(), null;
                        }
                    },
                    {
                        key: "getGeometryType",
                        value: function() {
                            return V.TYPENAME_GEOMETRYCOLLECTION;
                        }
                    },
                    {
                        key: "isEmpty",
                        value: function() {
                            for(var t = 0; t < this._geometries.length; t++)if (!this._geometries[t].isEmpty()) return !1;
                            return !0;
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            if (this._geometries = null, 0 === arguments.length) ;
                            else if (2 === arguments.length) {
                                var t = arguments[0], e = arguments[1];
                                if (V.constructor_.call(this, e), null === t && (t = []), V.hasNullElements(t)) throw new _("geometries must not contain null elements");
                                this._geometries = t;
                            }
                        }
                    }
                ]), s;
            }(V), zt = function(e) {
                r(s, e);
                var o = c(s);
                function s() {
                    var e;
                    return t(this, s), e = o.call(this), s.constructor_.apply(l(e), arguments), e;
                }
                return n(s, [
                    {
                        key: "copyInternal",
                        value: function() {
                            for(var t = new Array(this._geometries.length).fill(null), e = 0; e < t.length; e++)t[e] = this._geometries[e].copy();
                            return new s(t, this._factory);
                        }
                    },
                    {
                        key: "isValid",
                        value: function() {
                            return !0;
                        }
                    },
                    {
                        key: "equalsExact",
                        value: function() {
                            if (2 === arguments.length && "number" == typeof arguments[1] && arguments[0] instanceof V) {
                                var t = arguments[0], e = arguments[1];
                                return !!this.isEquivalentClass(t) && f(i(s.prototype), "equalsExact", this).call(this, t, e);
                            }
                            return f(i(s.prototype), "equalsExact", this).apply(this, arguments);
                        }
                    },
                    {
                        key: "getCoordinate",
                        value: function() {
                            if (1 === arguments.length && Number.isInteger(arguments[0])) {
                                var t = arguments[0];
                                return this._geometries[t].getCoordinate();
                            }
                            return f(i(s.prototype), "getCoordinate", this).apply(this, arguments);
                        }
                    },
                    {
                        key: "getBoundaryDimension",
                        value: function() {
                            return Mt.FALSE;
                        }
                    },
                    {
                        key: "getTypeCode",
                        value: function() {
                            return V.TYPECODE_MULTIPOINT;
                        }
                    },
                    {
                        key: "getDimension",
                        value: function() {
                            return 0;
                        }
                    },
                    {
                        key: "getBoundary",
                        value: function() {
                            return this.getFactory().createGeometryCollection();
                        }
                    },
                    {
                        key: "getGeometryType",
                        value: function() {
                            return V.TYPENAME_MULTIPOINT;
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                Tt
                            ];
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            var t = arguments[0], e = arguments[1];
                            Bt.constructor_.call(this, t, e);
                        }
                    }
                ]), s;
            }(Bt), jt = function(e) {
                r(s, e);
                var o = c(s);
                function s() {
                    var e;
                    return t(this, s), e = o.call(this), s.constructor_.apply(l(e), arguments), e;
                }
                return n(s, [
                    {
                        key: "copyInternal",
                        value: function() {
                            return new s(this._points.copy(), this._factory);
                        }
                    },
                    {
                        key: "getBoundaryDimension",
                        value: function() {
                            return Mt.FALSE;
                        }
                    },
                    {
                        key: "isClosed",
                        value: function() {
                            return !!this.isEmpty() || f(i(s.prototype), "isClosed", this).call(this);
                        }
                    },
                    {
                        key: "reverseInternal",
                        value: function() {
                            var t = this._points.copy();
                            return St.reverse(t), this.getFactory().createLinearRing(t);
                        }
                    },
                    {
                        key: "getTypeCode",
                        value: function() {
                            return V.TYPECODE_LINEARRING;
                        }
                    },
                    {
                        key: "validateConstruction",
                        value: function() {
                            if (!this.isEmpty() && !f(i(s.prototype), "isClosed", this).call(this)) throw new _("Points of LinearRing do not form a closed linestring");
                            if (this.getCoordinateSequence().size() >= 1 && this.getCoordinateSequence().size() < s.MINIMUM_VALID_SIZE) throw new _("Invalid number of points in LinearRing (found " + this.getCoordinateSequence().size() + " - must be 0 or >= 4)");
                        }
                    },
                    {
                        key: "getGeometryType",
                        value: function() {
                            return V.TYPENAME_LINEARRING;
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            var t = arguments[0], e = arguments[1];
                            Ct.constructor_.call(this, t, e), this.validateConstruction();
                        }
                    }
                ]), s;
            }(Ct);
            jt.MINIMUM_VALID_SIZE = 4;
            var Xt = function(e) {
                r(o, e);
                var i = c(o);
                function o() {
                    var e;
                    return t(this, o), e = i.call(this), o.constructor_.apply(l(e), arguments), e;
                }
                return n(o, [
                    {
                        key: "setOrdinate",
                        value: function(t, e) {
                            switch(t){
                                case o.X:
                                    this.x = e;
                                    break;
                                case o.Y:
                                    this.y = e;
                                    break;
                                default:
                                    throw new _("Invalid ordinate index: " + t);
                            }
                        }
                    },
                    {
                        key: "getZ",
                        value: function() {
                            return j.NULL_ORDINATE;
                        }
                    },
                    {
                        key: "getOrdinate",
                        value: function(t) {
                            switch(t){
                                case o.X:
                                    return this.x;
                                case o.Y:
                                    return this.y;
                            }
                            throw new _("Invalid ordinate index: " + t);
                        }
                    },
                    {
                        key: "setZ",
                        value: function(t) {
                            throw new _("CoordinateXY dimension 2 does not support z-ordinate");
                        }
                    },
                    {
                        key: "copy",
                        value: function() {
                            return new o(this);
                        }
                    },
                    {
                        key: "toString",
                        value: function() {
                            return "(" + this.x + ", " + this.y + ")";
                        }
                    },
                    {
                        key: "setCoordinate",
                        value: function(t) {
                            this.x = t.x, this.y = t.y, this.z = t.getZ();
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            if (0 === arguments.length) j.constructor_.call(this);
                            else if (1 === arguments.length) {
                                if (arguments[0] instanceof o) {
                                    var t = arguments[0];
                                    j.constructor_.call(this, t.x, t.y);
                                } else if (arguments[0] instanceof j) {
                                    var e = arguments[0];
                                    j.constructor_.call(this, e.x, e.y);
                                }
                            } else if (2 === arguments.length) {
                                var n = arguments[0], r = arguments[1];
                                j.constructor_.call(this, n, r, j.NULL_ORDINATE);
                            }
                        }
                    }
                ]), o;
            }(j);
            Xt.X = 0, Xt.Y = 1, Xt.Z = -1, Xt.M = -1;
            var Ut = function(e) {
                r(o, e);
                var i = c(o);
                function o() {
                    var e;
                    return t(this, o), e = i.call(this), o.constructor_.apply(l(e), arguments), e;
                }
                return n(o, [
                    {
                        key: "getM",
                        value: function() {
                            return this._m;
                        }
                    },
                    {
                        key: "setOrdinate",
                        value: function(t, e) {
                            switch(t){
                                case o.X:
                                    this.x = e;
                                    break;
                                case o.Y:
                                    this.y = e;
                                    break;
                                case o.M:
                                    this._m = e;
                                    break;
                                default:
                                    throw new _("Invalid ordinate index: " + t);
                            }
                        }
                    },
                    {
                        key: "setM",
                        value: function(t) {
                            this._m = t;
                        }
                    },
                    {
                        key: "getZ",
                        value: function() {
                            return j.NULL_ORDINATE;
                        }
                    },
                    {
                        key: "getOrdinate",
                        value: function(t) {
                            switch(t){
                                case o.X:
                                    return this.x;
                                case o.Y:
                                    return this.y;
                                case o.M:
                                    return this._m;
                            }
                            throw new _("Invalid ordinate index: " + t);
                        }
                    },
                    {
                        key: "setZ",
                        value: function(t) {
                            throw new _("CoordinateXY dimension 2 does not support z-ordinate");
                        }
                    },
                    {
                        key: "copy",
                        value: function() {
                            return new o(this);
                        }
                    },
                    {
                        key: "toString",
                        value: function() {
                            return "(" + this.x + ", " + this.y + " m=" + this.getM() + ")";
                        }
                    },
                    {
                        key: "setCoordinate",
                        value: function(t) {
                            this.x = t.x, this.y = t.y, this.z = t.getZ(), this._m = t.getM();
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            if (this._m = null, 0 === arguments.length) j.constructor_.call(this), this._m = 0;
                            else if (1 === arguments.length) {
                                if (arguments[0] instanceof o) {
                                    var t = arguments[0];
                                    j.constructor_.call(this, t.x, t.y), this._m = t._m;
                                } else if (arguments[0] instanceof j) {
                                    var e = arguments[0];
                                    j.constructor_.call(this, e.x, e.y), this._m = this.getM();
                                }
                            } else if (3 === arguments.length) {
                                var n = arguments[0], r = arguments[1], i = arguments[2];
                                j.constructor_.call(this, n, r, j.NULL_ORDINATE), this._m = i;
                            }
                        }
                    }
                ]), o;
            }(j);
            Ut.X = 0, Ut.Y = 1, Ut.Z = -1, Ut.M = 2;
            var Vt = function(e) {
                r(o, e);
                var i = c(o);
                function o() {
                    var e;
                    return t(this, o), e = i.call(this), o.constructor_.apply(l(e), arguments), e;
                }
                return n(o, [
                    {
                        key: "getM",
                        value: function() {
                            return this._m;
                        }
                    },
                    {
                        key: "setOrdinate",
                        value: function(t, e) {
                            switch(t){
                                case j.X:
                                    this.x = e;
                                    break;
                                case j.Y:
                                    this.y = e;
                                    break;
                                case j.Z:
                                    this.z = e;
                                    break;
                                case j.M:
                                    this._m = e;
                                    break;
                                default:
                                    throw new _("Invalid ordinate index: " + t);
                            }
                        }
                    },
                    {
                        key: "setM",
                        value: function(t) {
                            this._m = t;
                        }
                    },
                    {
                        key: "getOrdinate",
                        value: function(t) {
                            switch(t){
                                case j.X:
                                    return this.x;
                                case j.Y:
                                    return this.y;
                                case j.Z:
                                    return this.getZ();
                                case j.M:
                                    return this.getM();
                            }
                            throw new _("Invalid ordinate index: " + t);
                        }
                    },
                    {
                        key: "copy",
                        value: function() {
                            return new o(this);
                        }
                    },
                    {
                        key: "toString",
                        value: function() {
                            return "(" + this.x + ", " + this.y + ", " + this.getZ() + " m=" + this.getM() + ")";
                        }
                    },
                    {
                        key: "setCoordinate",
                        value: function(t) {
                            this.x = t.x, this.y = t.y, this.z = t.getZ(), this._m = t.getM();
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            if (this._m = null, 0 === arguments.length) j.constructor_.call(this), this._m = 0;
                            else if (1 === arguments.length) {
                                if (arguments[0] instanceof o) {
                                    var t = arguments[0];
                                    j.constructor_.call(this, t), this._m = t._m;
                                } else if (arguments[0] instanceof j) {
                                    var e = arguments[0];
                                    j.constructor_.call(this, e), this._m = this.getM();
                                }
                            } else if (4 === arguments.length) {
                                var n = arguments[0], r = arguments[1], i = arguments[2], s = arguments[3];
                                j.constructor_.call(this, n, r, i), this._m = s;
                            }
                        }
                    }
                ]), o;
            }(j), Zt = function() {
                function e() {
                    t(this, e);
                }
                return n(e, null, [
                    {
                        key: "measures",
                        value: function(t) {
                            return t instanceof Xt ? 0 : t instanceof Ut || t instanceof Vt ? 1 : 0;
                        }
                    },
                    {
                        key: "dimension",
                        value: function(t) {
                            return t instanceof Xt ? 2 : t instanceof Ut ? 3 : t instanceof Vt ? 4 : 3;
                        }
                    },
                    {
                        key: "create",
                        value: function() {
                            if (1 === arguments.length) {
                                var t = arguments[0];
                                return e.create(t, 0);
                            }
                            if (2 === arguments.length) {
                                var n = arguments[0], r = arguments[1];
                                return 2 === n ? new Xt : 3 === n && 0 === r ? new j : 3 === n && 1 === r ? new Ut : 4 === n && 1 === r ? new Vt : new j;
                            }
                        }
                    }
                ]), e;
            }(), Ht = function(e) {
                r(s, e);
                var o = c(s);
                function s() {
                    var e;
                    return t(this, s), e = o.call(this), s.constructor_.apply(l(e), arguments), e;
                }
                return n(s, [
                    {
                        key: "getCoordinate",
                        value: function(t) {
                            return this.get(t);
                        }
                    },
                    {
                        key: "addAll",
                        value: function() {
                            if (2 === arguments.length && "boolean" == typeof arguments[1] && ot(arguments[0], H)) {
                                for(var t = arguments[1], e = !1, n = arguments[0].iterator(); n.hasNext();)this.add(n.next(), t), e = !0;
                                return e;
                            }
                            return f(i(s.prototype), "addAll", this).apply(this, arguments);
                        }
                    },
                    {
                        key: "clone",
                        value: function() {
                            for(var t = f(i(s.prototype), "clone", this).call(this), e = 0; e < this.size(); e++)t.add(e, this.get(e).clone());
                            return t;
                        }
                    },
                    {
                        key: "toCoordinateArray",
                        value: function() {
                            if (0 === arguments.length) return this.toArray(s.coordArrayType);
                            if (1 === arguments.length) {
                                if (arguments[0]) return this.toArray(s.coordArrayType);
                                for(var t = this.size(), e = new Array(t).fill(null), n = 0; n < t; n++)e[n] = this.get(t - n - 1);
                                return e;
                            }
                        }
                    },
                    {
                        key: "add",
                        value: function() {
                            if (1 === arguments.length) {
                                var t = arguments[0];
                                return f(i(s.prototype), "add", this).call(this, t);
                            }
                            if (2 === arguments.length) {
                                if (arguments[0] instanceof Array && "boolean" == typeof arguments[1]) {
                                    var e = arguments[0], n = arguments[1];
                                    return this.add(e, n, !0), !0;
                                }
                                if (arguments[0] instanceof j && "boolean" == typeof arguments[1]) {
                                    var r = arguments[0];
                                    if (!arguments[1] && this.size() >= 1 && this.get(this.size() - 1).equals2D(r)) return null;
                                    f(i(s.prototype), "add", this).call(this, r);
                                } else if (arguments[0] instanceof Object && "boolean" == typeof arguments[1]) {
                                    var o = arguments[0], a = arguments[1];
                                    return this.add(o, a), !0;
                                }
                            } else if (3 === arguments.length) {
                                if ("boolean" == typeof arguments[2] && arguments[0] instanceof Array && "boolean" == typeof arguments[1]) {
                                    var u = arguments[0], l = arguments[1];
                                    if (arguments[2]) for(var h = 0; h < u.length; h++)this.add(u[h], l);
                                    else for(var c = u.length - 1; c >= 0; c--)this.add(u[c], l);
                                    return !0;
                                }
                                if ("boolean" == typeof arguments[2] && Number.isInteger(arguments[0]) && arguments[1] instanceof j) {
                                    var v = arguments[0], g = arguments[1];
                                    if (!arguments[2]) {
                                        var d = this.size();
                                        if (d > 0) {
                                            if (v > 0 && this.get(v - 1).equals2D(g)) return null;
                                            if (v < d && this.get(v).equals2D(g)) return null;
                                        }
                                    }
                                    f(i(s.prototype), "add", this).call(this, v, g);
                                }
                            } else if (4 === arguments.length) {
                                var p = arguments[0], y = arguments[1], m = arguments[2], _ = arguments[3], x = 1;
                                m > _ && (x = -1);
                                for(var E = m; E !== _; E += x)this.add(p[E], y);
                                return !0;
                            }
                        }
                    },
                    {
                        key: "closeRing",
                        value: function() {
                            if (this.size() > 0) {
                                var t = this.get(0).copy();
                                this.add(t, !1);
                            }
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            if (0 === arguments.length) ;
                            else if (1 === arguments.length) {
                                var t = arguments[0];
                                this.ensureCapacity(t.length), this.add(t, !0);
                            } else if (2 === arguments.length) {
                                var e = arguments[0], n = arguments[1];
                                this.ensureCapacity(e.length), this.add(e, n);
                            }
                        }
                    }
                ]), s;
            }(pt);
            Ht.coordArrayType = new Array(0).fill(null);
            var Wt = function() {
                function e() {
                    t(this, e);
                }
                return n(e, null, [
                    {
                        key: "isRing",
                        value: function(t) {
                            return !(t.length < 4 || !t[0].equals2D(t[t.length - 1]));
                        }
                    },
                    {
                        key: "ptNotInList",
                        value: function(t, n) {
                            for(var r = 0; r < t.length; r++){
                                var i = t[r];
                                if (e.indexOf(i, n) < 0) return i;
                            }
                            return null;
                        }
                    },
                    {
                        key: "scroll",
                        value: function(t, n) {
                            var r = e.indexOf(n, t);
                            if (r < 0) return null;
                            var i = new Array(t.length).fill(null);
                            xt.arraycopy(t, r, i, 0, t.length - r), xt.arraycopy(t, 0, i, t.length - r, r), xt.arraycopy(i, 0, t, 0, t.length);
                        }
                    },
                    {
                        key: "equals",
                        value: function() {
                            if (2 === arguments.length) {
                                var t = arguments[0], e = arguments[1];
                                if (t === e) return !0;
                                if (null === t || null === e) return !1;
                                if (t.length !== e.length) return !1;
                                for(var n = 0; n < t.length; n++)if (!t[n].equals(e[n])) return !1;
                                return !0;
                            }
                            if (3 === arguments.length) {
                                var r = arguments[0], i = arguments[1], o = arguments[2];
                                if (r === i) return !0;
                                if (null === r || null === i) return !1;
                                if (r.length !== i.length) return !1;
                                for(var s = 0; s < r.length; s++)if (0 !== o.compare(r[s], i[s])) return !1;
                                return !0;
                            }
                        }
                    },
                    {
                        key: "intersection",
                        value: function(t, e) {
                            for(var n = new Ht, r = 0; r < t.length; r++)e.intersects(t[r]) && n.add(t[r], !0);
                            return n.toCoordinateArray();
                        }
                    },
                    {
                        key: "measures",
                        value: function(t) {
                            if (null === t || 0 === t.length) return 0;
                            var e, n = 0, r = p(t);
                            try {
                                for(r.s(); !(e = r.n()).done;){
                                    var i = e.value;
                                    n = Math.max(n, Zt.measures(i));
                                }
                            } catch (t) {
                                r.e(t);
                            } finally{
                                r.f();
                            }
                            return n;
                        }
                    },
                    {
                        key: "hasRepeatedPoints",
                        value: function(t) {
                            for(var e = 1; e < t.length; e++)if (t[e - 1].equals(t[e])) return !0;
                            return !1;
                        }
                    },
                    {
                        key: "removeRepeatedPoints",
                        value: function(t) {
                            return e.hasRepeatedPoints(t) ? new Ht(t, !1).toCoordinateArray() : t;
                        }
                    },
                    {
                        key: "reverse",
                        value: function(t) {
                            for(var e = t.length - 1, n = Math.trunc(e / 2), r = 0; r <= n; r++){
                                var i = t[r];
                                t[r] = t[e - r], t[e - r] = i;
                            }
                        }
                    },
                    {
                        key: "removeNull",
                        value: function(t) {
                            for(var e = 0, n = 0; n < t.length; n++)null !== t[n] && e++;
                            var r = new Array(e).fill(null);
                            if (0 === e) return r;
                            for(var i = 0, o = 0; o < t.length; o++)null !== t[o] && (r[i++] = t[o]);
                            return r;
                        }
                    },
                    {
                        key: "copyDeep",
                        value: function() {
                            if (1 === arguments.length) {
                                for(var t = arguments[0], e = new Array(t.length).fill(null), n = 0; n < t.length; n++)e[n] = t[n].copy();
                                return e;
                            }
                            if (5 === arguments.length) for(var r = arguments[0], i = arguments[1], o = arguments[2], s = arguments[3], a = arguments[4], u = 0; u < a; u++)o[s + u] = r[i + u].copy();
                        }
                    },
                    {
                        key: "isEqualReversed",
                        value: function(t, e) {
                            for(var n = 0; n < t.length; n++){
                                var r = t[n], i = e[t.length - n - 1];
                                if (0 !== r.compareTo(i)) return !1;
                            }
                            return !0;
                        }
                    },
                    {
                        key: "envelope",
                        value: function(t) {
                            for(var e = new U, n = 0; n < t.length; n++)e.expandToInclude(t[n]);
                            return e;
                        }
                    },
                    {
                        key: "toCoordinateArray",
                        value: function(t) {
                            return t.toArray(e.coordArrayType);
                        }
                    },
                    {
                        key: "dimension",
                        value: function(t) {
                            if (null === t || 0 === t.length) return 3;
                            var e, n = 0, r = p(t);
                            try {
                                for(r.s(); !(e = r.n()).done;){
                                    var i = e.value;
                                    n = Math.max(n, Zt.dimension(i));
                                }
                            } catch (t) {
                                r.e(t);
                            } finally{
                                r.f();
                            }
                            return n;
                        }
                    },
                    {
                        key: "atLeastNCoordinatesOrNothing",
                        value: function(t, e) {
                            return e.length >= t ? e : [];
                        }
                    },
                    {
                        key: "indexOf",
                        value: function(t, e) {
                            for(var n = 0; n < e.length; n++)if (t.equals(e[n])) return n;
                            return -1;
                        }
                    },
                    {
                        key: "increasingDirection",
                        value: function(t) {
                            for(var e = 0; e < Math.trunc(t.length / 2); e++){
                                var n = t.length - 1 - e, r = t[e].compareTo(t[n]);
                                if (0 !== r) return r;
                            }
                            return 1;
                        }
                    },
                    {
                        key: "compare",
                        value: function(t, e) {
                            for(var n = 0; n < t.length && n < e.length;){
                                var r = t[n].compareTo(e[n]);
                                if (0 !== r) return r;
                                n++;
                            }
                            return n < e.length ? -1 : n < t.length ? 1 : 0;
                        }
                    },
                    {
                        key: "minCoordinate",
                        value: function(t) {
                            for(var e = null, n = 0; n < t.length; n++)(null === e || e.compareTo(t[n]) > 0) && (e = t[n]);
                            return e;
                        }
                    },
                    {
                        key: "extract",
                        value: function(t, e, n) {
                            e = Et.clamp(e, 0, t.length);
                            var r = (n = Et.clamp(n, -1, t.length)) - e + 1;
                            n < 0 && (r = 0), e >= t.length && (r = 0), n < e && (r = 0);
                            var i = new Array(r).fill(null);
                            if (0 === r) return i;
                            for(var o = 0, s = e; s <= n; s++)i[o++] = t[s];
                            return i;
                        }
                    }
                ]), e;
            }(), Jt = function() {
                function e() {
                    t(this, e);
                }
                return n(e, [
                    {
                        key: "compare",
                        value: function(t, e) {
                            var n = t, r = e;
                            return Wt.compare(n, r);
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                D
                            ];
                        }
                    }
                ]), e;
            }(), Kt = function() {
                function e() {
                    t(this, e);
                }
                return n(e, [
                    {
                        key: "compare",
                        value: function(t, e) {
                            var n = t, r = e;
                            if (n.length < r.length) return -1;
                            if (n.length > r.length) return 1;
                            if (0 === n.length) return 0;
                            var i = Wt.compare(n, r);
                            return Wt.isEqualReversed(n, r) ? 0 : i;
                        }
                    },
                    {
                        key: "OLDcompare",
                        value: function(t, e) {
                            var n = t, r = e;
                            if (n.length < r.length) return -1;
                            if (n.length > r.length) return 1;
                            if (0 === n.length) return 0;
                            for(var i = Wt.increasingDirection(n), o = Wt.increasingDirection(r), s = i > 0 ? 0 : n.length - 1, a = o > 0 ? 0 : n.length - 1, u = 0; u < n.length; u++){
                                var l = n[s].compareTo(r[a]);
                                if (0 !== l) return l;
                                s += i, a += o;
                            }
                            return 0;
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                D
                            ];
                        }
                    }
                ]), e;
            }();
            Wt.ForwardComparator = Jt, Wt.BidirectionalComparator = Kt, Wt.coordArrayType = new Array(0).fill(null);
            var Qt = function() {
                function e(n) {
                    t(this, e), this.str = n;
                }
                return n(e, [
                    {
                        key: "append",
                        value: function(t) {
                            this.str += t;
                        }
                    },
                    {
                        key: "setCharAt",
                        value: function(t, e) {
                            this.str = this.str.substr(0, t) + e + this.str.substr(t + 1);
                        }
                    },
                    {
                        key: "toString",
                        value: function() {
                            return this.str;
                        }
                    }
                ]), e;
            }(), $t = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "getM",
                        value: function(t) {
                            return this.hasM() ? this._coordinates[t].getM() : A.NaN;
                        }
                    },
                    {
                        key: "setOrdinate",
                        value: function(t, e, n) {
                            switch(e){
                                case ct.X:
                                    this._coordinates[t].x = n;
                                    break;
                                case ct.Y:
                                    this._coordinates[t].y = n;
                                    break;
                                default:
                                    this._coordinates[t].setOrdinate(e, n);
                            }
                        }
                    },
                    {
                        key: "getZ",
                        value: function(t) {
                            return this.hasZ() ? this._coordinates[t].getZ() : A.NaN;
                        }
                    },
                    {
                        key: "size",
                        value: function() {
                            return this._coordinates.length;
                        }
                    },
                    {
                        key: "getOrdinate",
                        value: function(t, e) {
                            switch(e){
                                case ct.X:
                                    return this._coordinates[t].x;
                                case ct.Y:
                                    return this._coordinates[t].y;
                                default:
                                    return this._coordinates[t].getOrdinate(e);
                            }
                        }
                    },
                    {
                        key: "getCoordinate",
                        value: function() {
                            if (1 === arguments.length) {
                                var t = arguments[0];
                                return this._coordinates[t];
                            }
                            if (2 === arguments.length) {
                                var e = arguments[0];
                                arguments[1].setCoordinate(this._coordinates[e]);
                            }
                        }
                    },
                    {
                        key: "getCoordinateCopy",
                        value: function(t) {
                            var e = this.createCoordinate();
                            return e.setCoordinate(this._coordinates[t]), e;
                        }
                    },
                    {
                        key: "createCoordinate",
                        value: function() {
                            return Zt.create(this.getDimension(), this.getMeasures());
                        }
                    },
                    {
                        key: "getDimension",
                        value: function() {
                            return this._dimension;
                        }
                    },
                    {
                        key: "getX",
                        value: function(t) {
                            return this._coordinates[t].x;
                        }
                    },
                    {
                        key: "getMeasures",
                        value: function() {
                            return this._measures;
                        }
                    },
                    {
                        key: "expandEnvelope",
                        value: function(t) {
                            for(var e = 0; e < this._coordinates.length; e++)t.expandToInclude(this._coordinates[e]);
                            return t;
                        }
                    },
                    {
                        key: "copy",
                        value: function() {
                            for(var t = new Array(this.size()).fill(null), n = 0; n < this._coordinates.length; n++){
                                var r = this.createCoordinate();
                                r.setCoordinate(this._coordinates[n]), t[n] = r;
                            }
                            return new e(t, this._dimension, this._measures);
                        }
                    },
                    {
                        key: "toString",
                        value: function() {
                            if (this._coordinates.length > 0) {
                                var t = new Qt(17 * this._coordinates.length);
                                t.append("("), t.append(this._coordinates[0]);
                                for(var e = 1; e < this._coordinates.length; e++)t.append(", "), t.append(this._coordinates[e]);
                                return t.append(")"), t.toString();
                            }
                            return "()";
                        }
                    },
                    {
                        key: "getY",
                        value: function(t) {
                            return this._coordinates[t].y;
                        }
                    },
                    {
                        key: "toCoordinateArray",
                        value: function() {
                            return this._coordinates;
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                ct,
                                b
                            ];
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            if (this._dimension = 3, this._measures = 0, this._coordinates = null, 1 === arguments.length) {
                                if (arguments[0] instanceof Array) {
                                    var t = arguments[0];
                                    e.constructor_.call(this, t, Wt.dimension(t), Wt.measures(t));
                                } else if (Number.isInteger(arguments[0])) {
                                    var n = arguments[0];
                                    this._coordinates = new Array(n).fill(null);
                                    for(var r = 0; r < n; r++)this._coordinates[r] = new j;
                                } else if (ot(arguments[0], ct)) {
                                    var i = arguments[0];
                                    if (null === i) return this._coordinates = new Array(0).fill(null), null;
                                    this._dimension = i.getDimension(), this._measures = i.getMeasures(), this._coordinates = new Array(i.size()).fill(null);
                                    for(var o = 0; o < this._coordinates.length; o++)this._coordinates[o] = i.getCoordinateCopy(o);
                                }
                            } else if (2 === arguments.length) {
                                if (arguments[0] instanceof Array && Number.isInteger(arguments[1])) {
                                    var s = arguments[0], a = arguments[1];
                                    e.constructor_.call(this, s, a, Wt.measures(s));
                                } else if (Number.isInteger(arguments[0]) && Number.isInteger(arguments[1])) {
                                    var u = arguments[0], l = arguments[1];
                                    this._coordinates = new Array(u).fill(null), this._dimension = l;
                                    for(var h = 0; h < u; h++)this._coordinates[h] = Zt.create(l);
                                }
                            } else if (3 === arguments.length) {
                                if (Number.isInteger(arguments[2]) && arguments[0] instanceof Array && Number.isInteger(arguments[1])) {
                                    var c = arguments[0], f = arguments[1], v = arguments[2];
                                    this._dimension = f, this._measures = v, this._coordinates = null === c ? new Array(0).fill(null) : c;
                                } else if (Number.isInteger(arguments[2]) && Number.isInteger(arguments[0]) && Number.isInteger(arguments[1])) {
                                    var g = arguments[0], d = arguments[1], p = arguments[2];
                                    this._coordinates = new Array(g).fill(null), this._dimension = d, this._measures = p;
                                    for(var y = 0; y < g; y++)this._coordinates[y] = this.createCoordinate();
                                }
                            }
                        }
                    }
                ]), e;
            }(), te = function() {
                function e() {
                    t(this, e);
                }
                return n(e, [
                    {
                        key: "readResolve",
                        value: function() {
                            return e.instance();
                        }
                    },
                    {
                        key: "create",
                        value: function() {
                            if (1 === arguments.length) {
                                if (arguments[0] instanceof Array) return new $t(arguments[0]);
                                if (ot(arguments[0], ct)) return new $t(arguments[0]);
                            } else {
                                if (2 === arguments.length) {
                                    var t = arguments[1];
                                    return t > 3 && (t = 3), t < 2 && (t = 2), new $t(arguments[0], t);
                                }
                                if (3 === arguments.length) {
                                    var e = arguments[2], n = arguments[1] - e;
                                    return e > 1 && (e = 1), n > 3 && (n = 3), n < 2 && (n = 2), new $t(arguments[0], n + e, e);
                                }
                            }
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                wt,
                                b
                            ];
                        }
                    }
                ], [
                    {
                        key: "instance",
                        value: function() {
                            return e.instanceObject;
                        }
                    }
                ]), e;
            }();
            te.instanceObject = new te;
            var ee = function(e) {
                r(s, e);
                var o = c(s);
                function s() {
                    var e;
                    return t(this, s), e = o.call(this), s.constructor_.apply(l(e), arguments), e;
                }
                return n(s, [
                    {
                        key: "copyInternal",
                        value: function() {
                            for(var t = new Array(this._geometries.length).fill(null), e = 0; e < t.length; e++)t[e] = this._geometries[e].copy();
                            return new s(t, this._factory);
                        }
                    },
                    {
                        key: "equalsExact",
                        value: function() {
                            if (2 === arguments.length && "number" == typeof arguments[1] && arguments[0] instanceof V) {
                                var t = arguments[0], e = arguments[1];
                                return !!this.isEquivalentClass(t) && f(i(s.prototype), "equalsExact", this).call(this, t, e);
                            }
                            return f(i(s.prototype), "equalsExact", this).apply(this, arguments);
                        }
                    },
                    {
                        key: "getBoundaryDimension",
                        value: function() {
                            return 1;
                        }
                    },
                    {
                        key: "getTypeCode",
                        value: function() {
                            return V.TYPECODE_MULTIPOLYGON;
                        }
                    },
                    {
                        key: "getDimension",
                        value: function() {
                            return 2;
                        }
                    },
                    {
                        key: "getBoundary",
                        value: function() {
                            if (this.isEmpty()) return this.getFactory().createMultiLineString();
                            for(var t = new pt, e = 0; e < this._geometries.length; e++)for(var n = this._geometries[e].getBoundary(), r = 0; r < n.getNumGeometries(); r++)t.add(n.getGeometryN(r));
                            var i = new Array(t.size()).fill(null);
                            return this.getFactory().createMultiLineString(t.toArray(i));
                        }
                    },
                    {
                        key: "getGeometryType",
                        value: function() {
                            return V.TYPENAME_MULTIPOLYGON;
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                Dt
                            ];
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            var t = arguments[0], e = arguments[1];
                            Bt.constructor_.call(this, t, e);
                        }
                    }
                ]), s;
            }(Bt), ne = function() {
                function e() {
                    t(this, e);
                }
                return n(e, [
                    {
                        key: "get",
                        value: function() {}
                    },
                    {
                        key: "put",
                        value: function() {}
                    },
                    {
                        key: "size",
                        value: function() {}
                    },
                    {
                        key: "values",
                        value: function() {}
                    },
                    {
                        key: "entrySet",
                        value: function() {}
                    }
                ]), e;
            }(), re = function(e) {
                r(o, e);
                var i = c(o);
                function o() {
                    var e;
                    return t(this, o), (e = i.call(this)).map = new Map, e;
                }
                return n(o, [
                    {
                        key: "get",
                        value: function(t) {
                            return this.map.get(t) || null;
                        }
                    },
                    {
                        key: "put",
                        value: function(t, e) {
                            return this.map.set(t, e), e;
                        }
                    },
                    {
                        key: "values",
                        value: function() {
                            for(var t = new pt, e = this.map.values(), n = e.next(); !n.done;)t.add(n.value), n = e.next();
                            return t;
                        }
                    },
                    {
                        key: "entrySet",
                        value: function() {
                            var t = new Q;
                            return this.map.entries().forEach(function(e) {
                                return t.add(e);
                            }), t;
                        }
                    },
                    {
                        key: "size",
                        value: function() {
                            return this.map.size();
                        }
                    }
                ]), o;
            }(ne), ie = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "equals",
                        value: function(t) {
                            if (!(t instanceof e)) return !1;
                            var n = t;
                            return this._modelType === n._modelType && this._scale === n._scale;
                        }
                    },
                    {
                        key: "compareTo",
                        value: function(t) {
                            var e = t, n = this.getMaximumSignificantDigits(), r = e.getMaximumSignificantDigits();
                            return at.compare(n, r);
                        }
                    },
                    {
                        key: "getScale",
                        value: function() {
                            return this._scale;
                        }
                    },
                    {
                        key: "isFloating",
                        value: function() {
                            return this._modelType === e.FLOATING || this._modelType === e.FLOATING_SINGLE;
                        }
                    },
                    {
                        key: "getType",
                        value: function() {
                            return this._modelType;
                        }
                    },
                    {
                        key: "toString",
                        value: function() {
                            var t = "UNKNOWN";
                            return this._modelType === e.FLOATING ? t = "Floating" : this._modelType === e.FLOATING_SINGLE ? t = "Floating-Single" : this._modelType === e.FIXED && (t = "Fixed (Scale=" + this.getScale() + ")"), t;
                        }
                    },
                    {
                        key: "makePrecise",
                        value: function() {
                            if ("number" == typeof arguments[0]) {
                                var t = arguments[0];
                                return A.isNaN(t) || this._modelType === e.FLOATING_SINGLE ? t : this._modelType === e.FIXED ? Math.round(t * this._scale) / this._scale : t;
                            }
                            if (arguments[0] instanceof j) {
                                var n = arguments[0];
                                if (this._modelType === e.FLOATING) return null;
                                n.x = this.makePrecise(n.x), n.y = this.makePrecise(n.y);
                            }
                        }
                    },
                    {
                        key: "getMaximumSignificantDigits",
                        value: function() {
                            var t = 16;
                            return this._modelType === e.FLOATING ? t = 16 : this._modelType === e.FLOATING_SINGLE ? t = 6 : this._modelType === e.FIXED && (t = 1 + Math.trunc(Math.ceil(Math.log(this.getScale()) / Math.log(10)))), t;
                        }
                    },
                    {
                        key: "setScale",
                        value: function(t) {
                            this._scale = Math.abs(t);
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                b,
                                k
                            ];
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            if (this._modelType = null, this._scale = null, 0 === arguments.length) this._modelType = e.FLOATING;
                            else if (1 === arguments.length) {
                                if (arguments[0] instanceof oe) {
                                    var t = arguments[0];
                                    this._modelType = t, t === e.FIXED && this.setScale(1);
                                } else if ("number" == typeof arguments[0]) {
                                    var n = arguments[0];
                                    this._modelType = e.FIXED, this.setScale(n);
                                } else if (arguments[0] instanceof e) {
                                    var r = arguments[0];
                                    this._modelType = r._modelType, this._scale = r._scale;
                                }
                            }
                        }
                    },
                    {
                        key: "mostPrecise",
                        value: function(t, e) {
                            return t.compareTo(e) >= 0 ? t : e;
                        }
                    }
                ]), e;
            }(), oe = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "readResolve",
                        value: function() {
                            return e.nameToTypeMap.get(this._name);
                        }
                    },
                    {
                        key: "toString",
                        value: function() {
                            return this._name;
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                b
                            ];
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._name = null;
                            var t = arguments[0];
                            this._name = t, e.nameToTypeMap.put(t, this);
                        }
                    }
                ]), e;
            }();
            oe.nameToTypeMap = new re, ie.Type = oe, ie.FIXED = new oe("FIXED"), ie.FLOATING = new oe("FLOATING"), ie.FLOATING_SINGLE = new oe("FLOATING SINGLE"), ie.maximumPreciseValue = 9007199254740992;
            var se = function(e) {
                r(s, e);
                var o = c(s);
                function s() {
                    var e;
                    return t(this, s), e = o.call(this), s.constructor_.apply(l(e), arguments), e;
                }
                return n(s, [
                    {
                        key: "copyInternal",
                        value: function() {
                            for(var t = new Array(this._geometries.length).fill(null), e = 0; e < t.length; e++)t[e] = this._geometries[e].copy();
                            return new s(t, this._factory);
                        }
                    },
                    {
                        key: "equalsExact",
                        value: function() {
                            if (2 === arguments.length && "number" == typeof arguments[1] && arguments[0] instanceof V) {
                                var t = arguments[0], e = arguments[1];
                                return !!this.isEquivalentClass(t) && f(i(s.prototype), "equalsExact", this).call(this, t, e);
                            }
                            return f(i(s.prototype), "equalsExact", this).apply(this, arguments);
                        }
                    },
                    {
                        key: "getBoundaryDimension",
                        value: function() {
                            return this.isClosed() ? Mt.FALSE : 0;
                        }
                    },
                    {
                        key: "isClosed",
                        value: function() {
                            if (this.isEmpty()) return !1;
                            for(var t = 0; t < this._geometries.length; t++)if (!this._geometries[t].isClosed()) return !1;
                            return !0;
                        }
                    },
                    {
                        key: "getTypeCode",
                        value: function() {
                            return V.TYPECODE_MULTILINESTRING;
                        }
                    },
                    {
                        key: "getDimension",
                        value: function() {
                            return 1;
                        }
                    },
                    {
                        key: "getBoundary",
                        value: function() {
                            throw new J;
                        }
                    },
                    {
                        key: "getGeometryType",
                        value: function() {
                            return V.TYPENAME_MULTILINESTRING;
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                Nt
                            ];
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            var t = arguments[0], e = arguments[1];
                            Bt.constructor_.call(this, t, e);
                        }
                    }
                ]), s;
            }(Bt), ae = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "createEmpty",
                        value: function(t) {
                            switch(t){
                                case -1:
                                    return this.createGeometryCollection();
                                case 0:
                                    return this.createPoint();
                                case 1:
                                    return this.createLineString();
                                case 2:
                                    return this.createPolygon();
                                default:
                                    throw new _("Invalid dimension: " + t);
                            }
                        }
                    },
                    {
                        key: "toGeometry",
                        value: function(t) {
                            return t.isNull() ? this.createPoint() : t.getMinX() === t.getMaxX() && t.getMinY() === t.getMaxY() ? this.createPoint(new j(t.getMinX(), t.getMinY())) : t.getMinX() === t.getMaxX() || t.getMinY() === t.getMaxY() ? this.createLineString([
                                new j(t.getMinX(), t.getMinY()),
                                new j(t.getMaxX(), t.getMaxY())
                            ]) : this.createPolygon(this.createLinearRing([
                                new j(t.getMinX(), t.getMinY()),
                                new j(t.getMinX(), t.getMaxY()),
                                new j(t.getMaxX(), t.getMaxY()),
                                new j(t.getMaxX(), t.getMinY()),
                                new j(t.getMinX(), t.getMinY())
                            ]), null);
                        }
                    },
                    {
                        key: "createLineString",
                        value: function() {
                            if (0 === arguments.length) return this.createLineString(this.getCoordinateSequenceFactory().create([]));
                            if (1 === arguments.length) {
                                if (arguments[0] instanceof Array) {
                                    var t = arguments[0];
                                    return this.createLineString(null !== t ? this.getCoordinateSequenceFactory().create(t) : null);
                                }
                                if (ot(arguments[0], ct)) return new Ct(arguments[0], this);
                            }
                        }
                    },
                    {
                        key: "createMultiLineString",
                        value: function() {
                            return 0 === arguments.length ? new se(null, this) : 1 === arguments.length ? new se(arguments[0], this) : void 0;
                        }
                    },
                    {
                        key: "buildGeometry",
                        value: function(t) {
                            for(var n = null, r = !1, i = !1, o = t.iterator(); o.hasNext();){
                                var s = o.next(), a = s.getTypeCode();
                                null === n && (n = a), a !== n && (r = !0), s instanceof Bt && (i = !0);
                            }
                            if (null === n) return this.createGeometryCollection();
                            if (r || i) return this.createGeometryCollection(e.toGeometryArray(t));
                            var u = t.iterator().next();
                            if (t.size() > 1) {
                                if (u instanceof Ft) return this.createMultiPolygon(e.toPolygonArray(t));
                                if (u instanceof Ct) return this.createMultiLineString(e.toLineStringArray(t));
                                if (u instanceof Ot) return this.createMultiPoint(e.toPointArray(t));
                                G.shouldNeverReachHere("Unhandled geometry type: " + u.getGeometryType());
                            }
                            return u;
                        }
                    },
                    {
                        key: "createMultiPointFromCoords",
                        value: function(t) {
                            return this.createMultiPoint(null !== t ? this.getCoordinateSequenceFactory().create(t) : null);
                        }
                    },
                    {
                        key: "createPoint",
                        value: function() {
                            if (0 === arguments.length) return this.createPoint(this.getCoordinateSequenceFactory().create([]));
                            if (1 === arguments.length) {
                                if (arguments[0] instanceof j) {
                                    var t = arguments[0];
                                    return this.createPoint(null !== t ? this.getCoordinateSequenceFactory().create([
                                        t
                                    ]) : null);
                                }
                                if (ot(arguments[0], ct)) return new Ot(arguments[0], this);
                            }
                        }
                    },
                    {
                        key: "getCoordinateSequenceFactory",
                        value: function() {
                            return this._coordinateSequenceFactory;
                        }
                    },
                    {
                        key: "createPolygon",
                        value: function() {
                            if (0 === arguments.length) return this.createPolygon(null, null);
                            if (1 === arguments.length) {
                                if (ot(arguments[0], ct)) {
                                    var t = arguments[0];
                                    return this.createPolygon(this.createLinearRing(t));
                                }
                                if (arguments[0] instanceof Array) {
                                    var e = arguments[0];
                                    return this.createPolygon(this.createLinearRing(e));
                                }
                                if (arguments[0] instanceof jt) {
                                    var n = arguments[0];
                                    return this.createPolygon(n, null);
                                }
                            } else if (2 === arguments.length) return new Ft(arguments[0], arguments[1], this);
                        }
                    },
                    {
                        key: "getSRID",
                        value: function() {
                            return this._SRID;
                        }
                    },
                    {
                        key: "createGeometryCollection",
                        value: function() {
                            return 0 === arguments.length ? new Bt(null, this) : 1 === arguments.length ? new Bt(arguments[0], this) : void 0;
                        }
                    },
                    {
                        key: "getPrecisionModel",
                        value: function() {
                            return this._precisionModel;
                        }
                    },
                    {
                        key: "createLinearRing",
                        value: function() {
                            if (0 === arguments.length) return this.createLinearRing(this.getCoordinateSequenceFactory().create([]));
                            if (1 === arguments.length) {
                                if (arguments[0] instanceof Array) {
                                    var t = arguments[0];
                                    return this.createLinearRing(null !== t ? this.getCoordinateSequenceFactory().create(t) : null);
                                }
                                if (ot(arguments[0], ct)) return new jt(arguments[0], this);
                            }
                        }
                    },
                    {
                        key: "createMultiPolygon",
                        value: function() {
                            return 0 === arguments.length ? new ee(null, this) : 1 === arguments.length ? new ee(arguments[0], this) : void 0;
                        }
                    },
                    {
                        key: "createMultiPoint",
                        value: function() {
                            if (0 === arguments.length) return new zt(null, this);
                            if (1 === arguments.length) {
                                if (arguments[0] instanceof Array) return new zt(arguments[0], this);
                                if (ot(arguments[0], ct)) {
                                    var t = arguments[0];
                                    if (null === t) return this.createMultiPoint(new Array(0).fill(null));
                                    for(var e = new Array(t.size()).fill(null), n = 0; n < t.size(); n++){
                                        var r = this.getCoordinateSequenceFactory().create(1, t.getDimension(), t.getMeasures());
                                        St.copy(t, n, r, 0, 1), e[n] = this.createPoint(r);
                                    }
                                    return this.createMultiPoint(e);
                                }
                            }
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                b
                            ];
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            if (this._precisionModel = null, this._coordinateSequenceFactory = null, this._SRID = null, 0 === arguments.length) e.constructor_.call(this, new ie, 0);
                            else if (1 === arguments.length) {
                                if (ot(arguments[0], wt)) {
                                    var t = arguments[0];
                                    e.constructor_.call(this, new ie, 0, t);
                                } else if (arguments[0] instanceof ie) {
                                    var n = arguments[0];
                                    e.constructor_.call(this, n, 0, e.getDefaultCoordinateSequenceFactory());
                                }
                            } else if (2 === arguments.length) {
                                var r = arguments[0], i = arguments[1];
                                e.constructor_.call(this, r, i, e.getDefaultCoordinateSequenceFactory());
                            } else if (3 === arguments.length) {
                                var o = arguments[0], s = arguments[1], a = arguments[2];
                                this._precisionModel = o, this._coordinateSequenceFactory = a, this._SRID = s;
                            }
                        }
                    },
                    {
                        key: "toMultiPolygonArray",
                        value: function(t) {
                            var e = new Array(t.size()).fill(null);
                            return t.toArray(e);
                        }
                    },
                    {
                        key: "toGeometryArray",
                        value: function(t) {
                            if (null === t) return null;
                            var e = new Array(t.size()).fill(null);
                            return t.toArray(e);
                        }
                    },
                    {
                        key: "getDefaultCoordinateSequenceFactory",
                        value: function() {
                            return te.instance();
                        }
                    },
                    {
                        key: "toMultiLineStringArray",
                        value: function(t) {
                            var e = new Array(t.size()).fill(null);
                            return t.toArray(e);
                        }
                    },
                    {
                        key: "toLineStringArray",
                        value: function(t) {
                            var e = new Array(t.size()).fill(null);
                            return t.toArray(e);
                        }
                    },
                    {
                        key: "toMultiPointArray",
                        value: function(t) {
                            var e = new Array(t.size()).fill(null);
                            return t.toArray(e);
                        }
                    },
                    {
                        key: "toLinearRingArray",
                        value: function(t) {
                            var e = new Array(t.size()).fill(null);
                            return t.toArray(e);
                        }
                    },
                    {
                        key: "toPointArray",
                        value: function(t) {
                            var e = new Array(t.size()).fill(null);
                            return t.toArray(e);
                        }
                    },
                    {
                        key: "toPolygonArray",
                        value: function(t) {
                            var e = new Array(t.size()).fill(null);
                            return t.toArray(e);
                        }
                    },
                    {
                        key: "createPointFromInternalCoord",
                        value: function(t, e) {
                            return e.getPrecisionModel().makePrecise(t), e.getFactory().createPoint(t);
                        }
                    }
                ]), e;
            }(), ue = "XY", le = "XYZ", he = "XYM", ce = "XYZM", fe = {
                POINT: "Point",
                LINE_STRING: "LineString",
                LINEAR_RING: "LinearRing",
                POLYGON: "Polygon",
                MULTI_POINT: "MultiPoint",
                MULTI_LINE_STRING: "MultiLineString",
                MULTI_POLYGON: "MultiPolygon",
                GEOMETRY_COLLECTION: "GeometryCollection",
                CIRCLE: "Circle"
            }, ve = "EMPTY", ge = 1, de = 2, pe = 3, ye = 4, me = 5, _e = 6;
            for(var xe in fe)fe[xe].toUpperCase();
            var Ee = function() {
                function e(n) {
                    t(this, e), this.wkt = n, this.index_ = -1;
                }
                return n(e, [
                    {
                        key: "isAlpha_",
                        value: function(t) {
                            return t >= "a" && t <= "z" || t >= "A" && t <= "Z";
                        }
                    },
                    {
                        key: "isNumeric_",
                        value: function(t, e) {
                            return t >= "0" && t <= "9" || "." == t && !(void 0 !== e && e);
                        }
                    },
                    {
                        key: "isWhiteSpace_",
                        value: function(t) {
                            return " " == t || "\t" == t || "\r" == t || "\n" == t;
                        }
                    },
                    {
                        key: "nextChar_",
                        value: function() {
                            return this.wkt.charAt(++this.index_);
                        }
                    },
                    {
                        key: "nextToken",
                        value: function() {
                            var t, e = this.nextChar_(), n = this.index_, r = e;
                            if ("(" == e) t = de;
                            else if ("," == e) t = me;
                            else if (")" == e) t = pe;
                            else if (this.isNumeric_(e) || "-" == e) t = ye, r = this.readNumber_();
                            else if (this.isAlpha_(e)) t = ge, r = this.readText_();
                            else {
                                if (this.isWhiteSpace_(e)) return this.nextToken();
                                if ("" !== e) throw new Error("Unexpected character: " + e);
                                t = _e;
                            }
                            return {
                                position: n,
                                value: r,
                                type: t
                            };
                        }
                    },
                    {
                        key: "readNumber_",
                        value: function() {
                            var t, e = this.index_, n = !1, r = !1;
                            do "." == t ? n = !0 : "e" != t && "E" != t || (r = !0), t = this.nextChar_();
                            while (this.isNumeric_(t, n) || !r && ("e" == t || "E" == t) || r && ("-" == t || "+" == t));
                            return parseFloat(this.wkt.substring(e, this.index_--));
                        }
                    },
                    {
                        key: "readText_",
                        value: function() {
                            var t, e = this.index_;
                            do t = this.nextChar_();
                            while (this.isAlpha_(t));
                            return this.wkt.substring(e, this.index_--).toUpperCase();
                        }
                    }
                ]), e;
            }(), ke = function() {
                function e(n, r) {
                    t(this, e), this.lexer_ = n, this.token_, this.layout_ = ue, this.factory = r;
                }
                return n(e, [
                    {
                        key: "consume_",
                        value: function() {
                            this.token_ = this.lexer_.nextToken();
                        }
                    },
                    {
                        key: "isTokenType",
                        value: function(t) {
                            return this.token_.type == t;
                        }
                    },
                    {
                        key: "match",
                        value: function(t) {
                            var e = this.isTokenType(t);
                            return e && this.consume_(), e;
                        }
                    },
                    {
                        key: "parse",
                        value: function() {
                            return this.consume_(), this.parseGeometry_();
                        }
                    },
                    {
                        key: "parseGeometryLayout_",
                        value: function() {
                            var t = ue, e = this.token_;
                            if (this.isTokenType(ge)) {
                                var n = e.value;
                                "Z" === n ? t = le : "M" === n ? t = he : "ZM" === n && (t = ce), t !== ue && this.consume_();
                            }
                            return t;
                        }
                    },
                    {
                        key: "parseGeometryCollectionText_",
                        value: function() {
                            if (this.match(de)) {
                                var t = [];
                                do t.push(this.parseGeometry_());
                                while (this.match(me));
                                if (this.match(pe)) return t;
                            } else if (this.isEmptyGeometry_()) return [];
                            throw new Error(this.formatErrorMessage_());
                        }
                    },
                    {
                        key: "parsePointText_",
                        value: function() {
                            if (this.match(de)) {
                                var t = this.parsePoint_();
                                if (this.match(pe)) return t;
                            } else if (this.isEmptyGeometry_()) return null;
                            throw new Error(this.formatErrorMessage_());
                        }
                    },
                    {
                        key: "parseLineStringText_",
                        value: function() {
                            if (this.match(de)) {
                                var t = this.parsePointList_();
                                if (this.match(pe)) return t;
                            } else if (this.isEmptyGeometry_()) return [];
                            throw new Error(this.formatErrorMessage_());
                        }
                    },
                    {
                        key: "parsePolygonText_",
                        value: function() {
                            if (this.match(de)) {
                                var t = this.parseLineStringTextList_();
                                if (this.match(pe)) return t;
                            } else if (this.isEmptyGeometry_()) return [];
                            throw new Error(this.formatErrorMessage_());
                        }
                    },
                    {
                        key: "parseMultiPointText_",
                        value: function() {
                            var t;
                            if (this.match(de)) {
                                if (t = this.token_.type == de ? this.parsePointTextList_() : this.parsePointList_(), this.match(pe)) return t;
                            } else if (this.isEmptyGeometry_()) return [];
                            throw new Error(this.formatErrorMessage_());
                        }
                    },
                    {
                        key: "parseMultiLineStringText_",
                        value: function() {
                            if (this.match(de)) {
                                var t = this.parseLineStringTextList_();
                                if (this.match(pe)) return t;
                            } else if (this.isEmptyGeometry_()) return [];
                            throw new Error(this.formatErrorMessage_());
                        }
                    },
                    {
                        key: "parseMultiPolygonText_",
                        value: function() {
                            if (this.match(de)) {
                                var t = this.parsePolygonTextList_();
                                if (this.match(pe)) return t;
                            } else if (this.isEmptyGeometry_()) return [];
                            throw new Error(this.formatErrorMessage_());
                        }
                    },
                    {
                        key: "parsePoint_",
                        value: function() {
                            for(var t = [], e = this.layout_.length, n = 0; n < e; ++n){
                                var r = this.token_;
                                if (!this.match(ye)) break;
                                t.push(r.value);
                            }
                            if (t.length == e) return t;
                            throw new Error(this.formatErrorMessage_());
                        }
                    },
                    {
                        key: "parsePointList_",
                        value: function() {
                            for(var t = [
                                this.parsePoint_()
                            ]; this.match(me);)t.push(this.parsePoint_());
                            return t;
                        }
                    },
                    {
                        key: "parsePointTextList_",
                        value: function() {
                            for(var t = [
                                this.parsePointText_()
                            ]; this.match(me);)t.push(this.parsePointText_());
                            return t;
                        }
                    },
                    {
                        key: "parseLineStringTextList_",
                        value: function() {
                            for(var t = [
                                this.parseLineStringText_()
                            ]; this.match(me);)t.push(this.parseLineStringText_());
                            return t;
                        }
                    },
                    {
                        key: "parsePolygonTextList_",
                        value: function() {
                            for(var t = [
                                this.parsePolygonText_()
                            ]; this.match(me);)t.push(this.parsePolygonText_());
                            return t;
                        }
                    },
                    {
                        key: "isEmptyGeometry_",
                        value: function() {
                            var t = this.isTokenType(ge) && this.token_.value == ve;
                            return t && this.consume_(), t;
                        }
                    },
                    {
                        key: "formatErrorMessage_",
                        value: function() {
                            return "Unexpected `" + this.token_.value + "` at position " + this.token_.position + " in `" + this.lexer_.wkt + "`";
                        }
                    },
                    {
                        key: "parseGeometry_",
                        value: function() {
                            var t = this.factory, e = function(t) {
                                return a(j, v(t));
                            }, n = function(n) {
                                var r = n.map(function(n) {
                                    return t.createLinearRing(n.map(e));
                                });
                                return r.length > 1 ? t.createPolygon(r[0], r.slice(1)) : t.createPolygon(r[0]);
                            }, r = this.token_;
                            if (this.match(ge)) {
                                var i = r.value;
                                if (this.layout_ = this.parseGeometryLayout_(), "GEOMETRYCOLLECTION" == i) {
                                    var o = this.parseGeometryCollectionText_();
                                    return t.createGeometryCollection(o);
                                }
                                switch(i){
                                    case "POINT":
                                        var s = this.parsePointText_();
                                        return s ? t.createPoint(a(j, v(s))) : t.createPoint();
                                    case "LINESTRING":
                                        var u = this.parseLineStringText_().map(e);
                                        return t.createLineString(u);
                                    case "LINEARRING":
                                        var l = this.parseLineStringText_().map(e);
                                        return t.createLinearRing(l);
                                    case "POLYGON":
                                        var h = this.parsePolygonText_();
                                        return h && 0 !== h.length ? n(h) : t.createPolygon();
                                    case "MULTIPOINT":
                                        var c = this.parseMultiPointText_();
                                        if (!c || 0 === c.length) return t.createMultiPoint();
                                        var f = c.map(e).map(function(e) {
                                            return t.createPoint(e);
                                        });
                                        return t.createMultiPoint(f);
                                    case "MULTILINESTRING":
                                        var g = this.parseMultiLineStringText_().map(function(n) {
                                            return t.createLineString(n.map(e));
                                        });
                                        return t.createMultiLineString(g);
                                    case "MULTIPOLYGON":
                                        var d = this.parseMultiPolygonText_();
                                        if (!d || 0 === d.length) return t.createMultiPolygon();
                                        var p = d.map(n);
                                        return t.createMultiPolygon(p);
                                    default:
                                        throw new Error("Invalid geometry type: " + i);
                                }
                            }
                            throw new Error(this.formatErrorMessage_());
                        }
                    }
                ]), e;
            }();
            function we(t) {
                if (t.isEmpty()) return "";
                var e = t.getCoordinate(), n = [
                    e.x,
                    e.y
                ];
                return void 0 === e.z || Number.isNaN(e.z) || n.push(e.z), void 0 === e.m || Number.isNaN(e.m) || n.push(e.m), n.join(" ");
            }
            function be(t) {
                for(var e = t.getCoordinates().map(function(t) {
                    var e = [
                        t.x,
                        t.y
                    ];
                    return void 0 === t.z || Number.isNaN(t.z) || e.push(t.z), void 0 === t.m || Number.isNaN(t.m) || e.push(t.m), e;
                }), n = [], r = 0, i = e.length; r < i; ++r)n.push(e[r].join(" "));
                return n.join(", ");
            }
            function Ie(t) {
                var e = [];
                e.push("(" + be(t.getExteriorRing()) + ")");
                for(var n = 0, r = t.getNumInteriorRing(); n < r; ++n)e.push("(" + be(t.getInteriorRingN(n)) + ")");
                return e.join(", ");
            }
            var Ne = {
                Point: we,
                LineString: be,
                LinearRing: be,
                Polygon: Ie,
                MultiPoint: function(t) {
                    for(var e = [], n = 0, r = t.getNumGeometries(); n < r; ++n)e.push("(" + we(t.getGeometryN(n)) + ")");
                    return e.join(", ");
                },
                MultiLineString: function(t) {
                    for(var e = [], n = 0, r = t.getNumGeometries(); n < r; ++n)e.push("(" + be(t.getGeometryN(n)) + ")");
                    return e.join(", ");
                },
                MultiPolygon: function(t) {
                    for(var e = [], n = 0, r = t.getNumGeometries(); n < r; ++n)e.push("(" + Ie(t.getGeometryN(n)) + ")");
                    return e.join(", ");
                },
                GeometryCollection: function(t) {
                    for(var e = [], n = 0, r = t.getNumGeometries(); n < r; ++n)e.push(Se(t.getGeometryN(n)));
                    return e.join(", ");
                }
            };
            function Se(t) {
                var e = t.getGeometryType(), n = Ne[e];
                e = e.toUpperCase();
                var r = function(t) {
                    var e = "";
                    if (t.isEmpty()) return e;
                    var n = t.getCoordinate();
                    return void 0 === n.z || Number.isNaN(n.z) || (e += "Z"), void 0 === n.m || Number.isNaN(n.m) || (e += "M"), e;
                }(t);
                return r.length > 0 && (e += " " + r), t.isEmpty() ? e + " " + ve : e + " (" + n(t) + ")";
            }
            var Me = function() {
                function e(n) {
                    t(this, e), this.geometryFactory = n || new ae, this.precisionModel = this.geometryFactory.getPrecisionModel();
                }
                return n(e, [
                    {
                        key: "read",
                        value: function(t) {
                            var e = new Ee(t);
                            return new ke(e, this.geometryFactory).parse();
                        }
                    },
                    {
                        key: "write",
                        value: function(t) {
                            return Se(t);
                        }
                    }
                ]), e;
            }(), Le = function() {
                function e(n) {
                    t(this, e), this.parser = new Me(n);
                }
                return n(e, [
                    {
                        key: "write",
                        value: function(t) {
                            return this.parser.write(t);
                        }
                    }
                ], [
                    {
                        key: "toLineString",
                        value: function(t, e) {
                            if (2 !== arguments.length) throw new Error("Not implemented");
                            return "LINESTRING ( " + t.x + " " + t.y + ", " + e.x + " " + e.y + " )";
                        }
                    }
                ]), e;
            }(), Pe = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "getIndexAlongSegment",
                        value: function(t, e) {
                            return this.computeIntLineIndex(), this._intLineIndex[t][e];
                        }
                    },
                    {
                        key: "getTopologySummary",
                        value: function() {
                            var t = new Qt;
                            return this.isEndPoint() && t.append(" endpoint"), this._isProper && t.append(" proper"), this.isCollinear() && t.append(" collinear"), t.toString();
                        }
                    },
                    {
                        key: "computeIntersection",
                        value: function(t, e, n, r) {
                            this._inputLines[0][0] = t, this._inputLines[0][1] = e, this._inputLines[1][0] = n, this._inputLines[1][1] = r, this._result = this.computeIntersect(t, e, n, r);
                        }
                    },
                    {
                        key: "getIntersectionNum",
                        value: function() {
                            return this._result;
                        }
                    },
                    {
                        key: "computeIntLineIndex",
                        value: function() {
                            if (0 === arguments.length) null === this._intLineIndex && (this._intLineIndex = Array(2).fill().map(function() {
                                return Array(2);
                            }), this.computeIntLineIndex(0), this.computeIntLineIndex(1));
                            else if (1 === arguments.length) {
                                var t = arguments[0];
                                this.getEdgeDistance(t, 0) > this.getEdgeDistance(t, 1) ? (this._intLineIndex[t][0] = 0, this._intLineIndex[t][1] = 1) : (this._intLineIndex[t][0] = 1, this._intLineIndex[t][1] = 0);
                            }
                        }
                    },
                    {
                        key: "isProper",
                        value: function() {
                            return this.hasIntersection() && this._isProper;
                        }
                    },
                    {
                        key: "setPrecisionModel",
                        value: function(t) {
                            this._precisionModel = t;
                        }
                    },
                    {
                        key: "isInteriorIntersection",
                        value: function() {
                            if (0 === arguments.length) return !!this.isInteriorIntersection(0) || !!this.isInteriorIntersection(1);
                            if (1 === arguments.length) {
                                for(var t = arguments[0], e = 0; e < this._result; e++)if (!this._intPt[e].equals2D(this._inputLines[t][0]) && !this._intPt[e].equals2D(this._inputLines[t][1])) return !0;
                                return !1;
                            }
                        }
                    },
                    {
                        key: "getIntersection",
                        value: function(t) {
                            return this._intPt[t];
                        }
                    },
                    {
                        key: "isEndPoint",
                        value: function() {
                            return this.hasIntersection() && !this._isProper;
                        }
                    },
                    {
                        key: "hasIntersection",
                        value: function() {
                            return this._result !== e.NO_INTERSECTION;
                        }
                    },
                    {
                        key: "getEdgeDistance",
                        value: function(t, n) {
                            return e.computeEdgeDistance(this._intPt[n], this._inputLines[t][0], this._inputLines[t][1]);
                        }
                    },
                    {
                        key: "isCollinear",
                        value: function() {
                            return this._result === e.COLLINEAR_INTERSECTION;
                        }
                    },
                    {
                        key: "toString",
                        value: function() {
                            return Le.toLineString(this._inputLines[0][0], this._inputLines[0][1]) + " - " + Le.toLineString(this._inputLines[1][0], this._inputLines[1][1]) + this.getTopologySummary();
                        }
                    },
                    {
                        key: "getEndpoint",
                        value: function(t, e) {
                            return this._inputLines[t][e];
                        }
                    },
                    {
                        key: "isIntersection",
                        value: function(t) {
                            for(var e = 0; e < this._result; e++)if (this._intPt[e].equals2D(t)) return !0;
                            return !1;
                        }
                    },
                    {
                        key: "getIntersectionAlongSegment",
                        value: function(t, e) {
                            return this.computeIntLineIndex(), this._intPt[this._intLineIndex[t][e]];
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._result = null, this._inputLines = Array(2).fill().map(function() {
                                return Array(2);
                            }), this._intPt = new Array(2).fill(null), this._intLineIndex = null, this._isProper = null, this._pa = null, this._pb = null, this._precisionModel = null, this._intPt[0] = new j, this._intPt[1] = new j, this._pa = this._intPt[0], this._pb = this._intPt[1], this._result = 0;
                        }
                    },
                    {
                        key: "computeEdgeDistance",
                        value: function(t, e, n) {
                            var r = Math.abs(n.x - e.x), i = Math.abs(n.y - e.y), o = -1;
                            if (t.equals(e)) o = 0;
                            else if (t.equals(n)) o = r > i ? r : i;
                            else {
                                var s = Math.abs(t.x - e.x), a = Math.abs(t.y - e.y);
                                0 !== (o = r > i ? s : a) || t.equals(e) || (o = Math.max(s, a));
                            }
                            return G.isTrue(!(0 === o && !t.equals(e)), "Bad distance calculation"), o;
                        }
                    },
                    {
                        key: "nonRobustComputeEdgeDistance",
                        value: function(t, e, n) {
                            var r = t.x - e.x, i = t.y - e.y, o = Math.sqrt(r * r + i * i);
                            return G.isTrue(!(0 === o && !t.equals(e)), "Invalid distance calculation"), o;
                        }
                    }
                ]), e;
            }();
            Pe.DONT_INTERSECT = 0, Pe.DO_INTERSECT = 1, Pe.COLLINEAR = 2, Pe.NO_INTERSECTION = 0, Pe.POINT_INTERSECTION = 1, Pe.COLLINEAR_INTERSECTION = 2;
            var Ce = function(e) {
                r(s, e);
                var o = c(s);
                function s() {
                    return t(this, s), o.call(this);
                }
                return n(s, [
                    {
                        key: "isInSegmentEnvelopes",
                        value: function(t) {
                            var e = new U(this._inputLines[0][0], this._inputLines[0][1]), n = new U(this._inputLines[1][0], this._inputLines[1][1]);
                            return e.contains(t) && n.contains(t);
                        }
                    },
                    {
                        key: "computeIntersection",
                        value: function() {
                            if (3 !== arguments.length) return f(i(s.prototype), "computeIntersection", this).apply(this, arguments);
                            var t = arguments[0], e = arguments[1], n = arguments[2];
                            if (this._isProper = !1, U.intersects(e, n, t) && 0 === ft.index(e, n, t) && 0 === ft.index(n, e, t)) return this._isProper = !0, (t.equals(e) || t.equals(n)) && (this._isProper = !1), this._result = Pe.POINT_INTERSECTION, null;
                            this._result = Pe.NO_INTERSECTION;
                        }
                    },
                    {
                        key: "intersection",
                        value: function(t, e, n, r) {
                            var i = this.intersectionSafe(t, e, n, r);
                            return this.isInSegmentEnvelopes(i) || (i = new j(s.nearestEndpoint(t, e, n, r))), null !== this._precisionModel && this._precisionModel.makePrecise(i), i;
                        }
                    },
                    {
                        key: "checkDD",
                        value: function(t, e, n, r, i) {
                            var o = ht.intersection(t, e, n, r), s = this.isInSegmentEnvelopes(o);
                            xt.out.println("DD in env = " + s + "  --------------------- " + o), i.distance(o) > 1e-4 && xt.out.println("Distance = " + i.distance(o));
                        }
                    },
                    {
                        key: "intersectionSafe",
                        value: function(t, e, n, r) {
                            var i = _t.intersection(t, e, n, r);
                            return null === i && (i = s.nearestEndpoint(t, e, n, r)), i;
                        }
                    },
                    {
                        key: "computeCollinearIntersection",
                        value: function(t, e, n, r) {
                            var i = U.intersects(t, e, n), o = U.intersects(t, e, r), s = U.intersects(n, r, t), a = U.intersects(n, r, e);
                            return i && o ? (this._intPt[0] = n, this._intPt[1] = r, Pe.COLLINEAR_INTERSECTION) : s && a ? (this._intPt[0] = t, this._intPt[1] = e, Pe.COLLINEAR_INTERSECTION) : i && s ? (this._intPt[0] = n, this._intPt[1] = t, !n.equals(t) || o || a ? Pe.COLLINEAR_INTERSECTION : Pe.POINT_INTERSECTION) : i && a ? (this._intPt[0] = n, this._intPt[1] = e, !n.equals(e) || o || s ? Pe.COLLINEAR_INTERSECTION : Pe.POINT_INTERSECTION) : o && s ? (this._intPt[0] = r, this._intPt[1] = t, !r.equals(t) || i || a ? Pe.COLLINEAR_INTERSECTION : Pe.POINT_INTERSECTION) : o && a ? (this._intPt[0] = r, this._intPt[1] = e, !r.equals(e) || i || s ? Pe.COLLINEAR_INTERSECTION : Pe.POINT_INTERSECTION) : Pe.NO_INTERSECTION;
                        }
                    },
                    {
                        key: "computeIntersect",
                        value: function(t, e, n, r) {
                            if (this._isProper = !1, !U.intersects(t, e, n, r)) return Pe.NO_INTERSECTION;
                            var i = ft.index(t, e, n), o = ft.index(t, e, r);
                            if (i > 0 && o > 0 || i < 0 && o < 0) return Pe.NO_INTERSECTION;
                            var s = ft.index(n, r, t), a = ft.index(n, r, e);
                            return s > 0 && a > 0 || s < 0 && a < 0 ? Pe.NO_INTERSECTION : 0 === i && 0 === o && 0 === s && 0 === a ? this.computeCollinearIntersection(t, e, n, r) : (0 === i || 0 === o || 0 === s || 0 === a ? (this._isProper = !1, t.equals2D(n) || t.equals2D(r) ? this._intPt[0] = t : e.equals2D(n) || e.equals2D(r) ? this._intPt[0] = e : 0 === i ? this._intPt[0] = new j(n) : 0 === o ? this._intPt[0] = new j(r) : 0 === s ? this._intPt[0] = new j(t) : 0 === a && (this._intPt[0] = new j(e))) : (this._isProper = !0, this._intPt[0] = this.intersection(t, e, n, r)), Pe.POINT_INTERSECTION);
                        }
                    }
                ], [
                    {
                        key: "nearestEndpoint",
                        value: function(t, e, n, r) {
                            var i = t, o = kt.pointToSegment(t, n, r), s = kt.pointToSegment(e, n, r);
                            return s < o && (o = s, i = e), (s = kt.pointToSegment(n, t, e)) < o && (o = s, i = n), (s = kt.pointToSegment(r, t, e)) < o && (o = s, i = r), i;
                        }
                    }
                ]), s;
            }(Pe), Te = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "countSegment",
                        value: function(t, e) {
                            if (t.x < this._p.x && e.x < this._p.x) return null;
                            if (this._p.x === e.x && this._p.y === e.y) return this._isPointOnSegment = !0, null;
                            if (t.y === this._p.y && e.y === this._p.y) {
                                var n = t.x, r = e.x;
                                return n > r && (n = e.x, r = t.x), this._p.x >= n && this._p.x <= r && (this._isPointOnSegment = !0), null;
                            }
                            if (t.y > this._p.y && e.y <= this._p.y || e.y > this._p.y && t.y <= this._p.y) {
                                var i = ft.index(t, e, this._p);
                                if (i === ft.COLLINEAR) return this._isPointOnSegment = !0, null;
                                e.y < t.y && (i = -i), i === ft.LEFT && this._crossingCount++;
                            }
                        }
                    },
                    {
                        key: "isPointInPolygon",
                        value: function() {
                            return this.getLocation() !== Z.EXTERIOR;
                        }
                    },
                    {
                        key: "getLocation",
                        value: function() {
                            return this._isPointOnSegment ? Z.BOUNDARY : this._crossingCount % 2 == 1 ? Z.INTERIOR : Z.EXTERIOR;
                        }
                    },
                    {
                        key: "isOnSegment",
                        value: function() {
                            return this._isPointOnSegment;
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._p = null, this._crossingCount = 0, this._isPointOnSegment = !1;
                            var t = arguments[0];
                            this._p = t;
                        }
                    },
                    {
                        key: "locatePointInRing",
                        value: function() {
                            if (arguments[0] instanceof j && ot(arguments[1], ct)) {
                                for(var t = arguments[1], n = new e(arguments[0]), r = new j, i = new j, o = 1; o < t.size(); o++)if (t.getCoordinate(o, r), t.getCoordinate(o - 1, i), n.countSegment(r, i), n.isOnSegment()) return n.getLocation();
                                return n.getLocation();
                            }
                            if (arguments[0] instanceof j && arguments[1] instanceof Array) {
                                for(var s = arguments[1], a = new e(arguments[0]), u = 1; u < s.length; u++){
                                    var l = s[u], h = s[u - 1];
                                    if (a.countSegment(l, h), a.isOnSegment()) return a.getLocation();
                                }
                                return a.getLocation();
                            }
                        }
                    }
                ]), e;
            }(), Oe = function() {
                function e() {
                    t(this, e);
                }
                return n(e, null, [
                    {
                        key: "isOnLine",
                        value: function() {
                            if (arguments[0] instanceof j && ot(arguments[1], ct)) {
                                for(var t = arguments[0], e = arguments[1], n = new Ce, r = new j, i = new j, o = e.size(), s = 1; s < o; s++)if (e.getCoordinate(s - 1, r), e.getCoordinate(s, i), n.computeIntersection(t, r, i), n.hasIntersection()) return !0;
                                return !1;
                            }
                            if (arguments[0] instanceof j && arguments[1] instanceof Array) {
                                for(var a = arguments[0], u = arguments[1], l = new Ce, h = 1; h < u.length; h++){
                                    var c = u[h - 1], f = u[h];
                                    if (l.computeIntersection(a, c, f), l.hasIntersection()) return !0;
                                }
                                return !1;
                            }
                        }
                    },
                    {
                        key: "locateInRing",
                        value: function(t, e) {
                            return Te.locatePointInRing(t, e);
                        }
                    },
                    {
                        key: "isInRing",
                        value: function(t, n) {
                            return e.locateInRing(t, n) !== Z.EXTERIOR;
                        }
                    }
                ]), e;
            }(), Re = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "setAllLocations",
                        value: function(t) {
                            for(var e = 0; e < this.location.length; e++)this.location[e] = t;
                        }
                    },
                    {
                        key: "isNull",
                        value: function() {
                            for(var t = 0; t < this.location.length; t++)if (this.location[t] !== Z.NONE) return !1;
                            return !0;
                        }
                    },
                    {
                        key: "setAllLocationsIfNull",
                        value: function(t) {
                            for(var e = 0; e < this.location.length; e++)this.location[e] === Z.NONE && (this.location[e] = t);
                        }
                    },
                    {
                        key: "isLine",
                        value: function() {
                            return 1 === this.location.length;
                        }
                    },
                    {
                        key: "merge",
                        value: function(t) {
                            if (t.location.length > this.location.length) {
                                var e = new Array(3).fill(null);
                                e[tt.ON] = this.location[tt.ON], e[tt.LEFT] = Z.NONE, e[tt.RIGHT] = Z.NONE, this.location = e;
                            }
                            for(var n = 0; n < this.location.length; n++)this.location[n] === Z.NONE && n < t.location.length && (this.location[n] = t.location[n]);
                        }
                    },
                    {
                        key: "getLocations",
                        value: function() {
                            return this.location;
                        }
                    },
                    {
                        key: "flip",
                        value: function() {
                            if (this.location.length <= 1) return null;
                            var t = this.location[tt.LEFT];
                            this.location[tt.LEFT] = this.location[tt.RIGHT], this.location[tt.RIGHT] = t;
                        }
                    },
                    {
                        key: "toString",
                        value: function() {
                            var t = new st;
                            return this.location.length > 1 && t.append(Z.toLocationSymbol(this.location[tt.LEFT])), t.append(Z.toLocationSymbol(this.location[tt.ON])), this.location.length > 1 && t.append(Z.toLocationSymbol(this.location[tt.RIGHT])), t.toString();
                        }
                    },
                    {
                        key: "setLocations",
                        value: function(t, e, n) {
                            this.location[tt.ON] = t, this.location[tt.LEFT] = e, this.location[tt.RIGHT] = n;
                        }
                    },
                    {
                        key: "get",
                        value: function(t) {
                            return t < this.location.length ? this.location[t] : Z.NONE;
                        }
                    },
                    {
                        key: "isArea",
                        value: function() {
                            return this.location.length > 1;
                        }
                    },
                    {
                        key: "isAnyNull",
                        value: function() {
                            for(var t = 0; t < this.location.length; t++)if (this.location[t] === Z.NONE) return !0;
                            return !1;
                        }
                    },
                    {
                        key: "setLocation",
                        value: function() {
                            if (1 === arguments.length) {
                                var t = arguments[0];
                                this.setLocation(tt.ON, t);
                            } else if (2 === arguments.length) {
                                var e = arguments[0], n = arguments[1];
                                this.location[e] = n;
                            }
                        }
                    },
                    {
                        key: "init",
                        value: function(t) {
                            this.location = new Array(t).fill(null), this.setAllLocations(Z.NONE);
                        }
                    },
                    {
                        key: "isEqualOnSide",
                        value: function(t, e) {
                            return this.location[e] === t.location[e];
                        }
                    },
                    {
                        key: "allPositionsEqual",
                        value: function(t) {
                            for(var e = 0; e < this.location.length; e++)if (this.location[e] !== t) return !1;
                            return !0;
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            if (this.location = null, 1 === arguments.length) {
                                if (arguments[0] instanceof Array) {
                                    var t = arguments[0];
                                    this.init(t.length);
                                } else if (Number.isInteger(arguments[0])) {
                                    var n = arguments[0];
                                    this.init(1), this.location[tt.ON] = n;
                                } else if (arguments[0] instanceof e) {
                                    var r = arguments[0];
                                    if (this.init(r.location.length), null !== r) for(var i = 0; i < this.location.length; i++)this.location[i] = r.location[i];
                                }
                            } else if (3 === arguments.length) {
                                var o = arguments[0], s = arguments[1], a = arguments[2];
                                this.init(3), this.location[tt.ON] = o, this.location[tt.LEFT] = s, this.location[tt.RIGHT] = a;
                            }
                        }
                    }
                ]), e;
            }(), Ae = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "getGeometryCount",
                        value: function() {
                            var t = 0;
                            return this.elt[0].isNull() || t++, this.elt[1].isNull() || t++, t;
                        }
                    },
                    {
                        key: "setAllLocations",
                        value: function(t, e) {
                            this.elt[t].setAllLocations(e);
                        }
                    },
                    {
                        key: "isNull",
                        value: function(t) {
                            return this.elt[t].isNull();
                        }
                    },
                    {
                        key: "setAllLocationsIfNull",
                        value: function() {
                            if (1 === arguments.length) {
                                var t = arguments[0];
                                this.setAllLocationsIfNull(0, t), this.setAllLocationsIfNull(1, t);
                            } else if (2 === arguments.length) {
                                var e = arguments[0], n = arguments[1];
                                this.elt[e].setAllLocationsIfNull(n);
                            }
                        }
                    },
                    {
                        key: "isLine",
                        value: function(t) {
                            return this.elt[t].isLine();
                        }
                    },
                    {
                        key: "merge",
                        value: function(t) {
                            for(var e = 0; e < 2; e++)null === this.elt[e] && null !== t.elt[e] ? this.elt[e] = new Re(t.elt[e]) : this.elt[e].merge(t.elt[e]);
                        }
                    },
                    {
                        key: "flip",
                        value: function() {
                            this.elt[0].flip(), this.elt[1].flip();
                        }
                    },
                    {
                        key: "getLocation",
                        value: function() {
                            if (1 === arguments.length) {
                                var t = arguments[0];
                                return this.elt[t].get(tt.ON);
                            }
                            if (2 === arguments.length) {
                                var e = arguments[0], n = arguments[1];
                                return this.elt[e].get(n);
                            }
                        }
                    },
                    {
                        key: "toString",
                        value: function() {
                            var t = new st;
                            return null !== this.elt[0] && (t.append("A:"), t.append(this.elt[0].toString())), null !== this.elt[1] && (t.append(" B:"), t.append(this.elt[1].toString())), t.toString();
                        }
                    },
                    {
                        key: "isArea",
                        value: function() {
                            if (0 === arguments.length) return this.elt[0].isArea() || this.elt[1].isArea();
                            if (1 === arguments.length) {
                                var t = arguments[0];
                                return this.elt[t].isArea();
                            }
                        }
                    },
                    {
                        key: "isAnyNull",
                        value: function(t) {
                            return this.elt[t].isAnyNull();
                        }
                    },
                    {
                        key: "setLocation",
                        value: function() {
                            if (2 === arguments.length) {
                                var t = arguments[0], e = arguments[1];
                                this.elt[t].setLocation(tt.ON, e);
                            } else if (3 === arguments.length) {
                                var n = arguments[0], r = arguments[1], i = arguments[2];
                                this.elt[n].setLocation(r, i);
                            }
                        }
                    },
                    {
                        key: "isEqualOnSide",
                        value: function(t, e) {
                            return this.elt[0].isEqualOnSide(t.elt[0], e) && this.elt[1].isEqualOnSide(t.elt[1], e);
                        }
                    },
                    {
                        key: "allPositionsEqual",
                        value: function(t, e) {
                            return this.elt[t].allPositionsEqual(e);
                        }
                    },
                    {
                        key: "toLine",
                        value: function(t) {
                            this.elt[t].isArea() && (this.elt[t] = new Re(this.elt[t].location[0]));
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            if (this.elt = new Array(2).fill(null), 1 === arguments.length) {
                                if (Number.isInteger(arguments[0])) {
                                    var t = arguments[0];
                                    this.elt[0] = new Re(t), this.elt[1] = new Re(t);
                                } else if (arguments[0] instanceof e) {
                                    var n = arguments[0];
                                    this.elt[0] = new Re(n.elt[0]), this.elt[1] = new Re(n.elt[1]);
                                }
                            } else if (2 === arguments.length) {
                                var r = arguments[0], i = arguments[1];
                                this.elt[0] = new Re(Z.NONE), this.elt[1] = new Re(Z.NONE), this.elt[r].setLocation(i);
                            } else if (3 === arguments.length) {
                                var o = arguments[0], s = arguments[1], a = arguments[2];
                                this.elt[0] = new Re(o, s, a), this.elt[1] = new Re(o, s, a);
                            } else if (4 === arguments.length) {
                                var u = arguments[0], l = arguments[1], h = arguments[2], c = arguments[3];
                                this.elt[0] = new Re(Z.NONE, Z.NONE, Z.NONE), this.elt[1] = new Re(Z.NONE, Z.NONE, Z.NONE), this.elt[u].setLocations(l, h, c);
                            }
                        }
                    },
                    {
                        key: "toLineLabel",
                        value: function(t) {
                            for(var n = new e(Z.NONE), r = 0; r < 2; r++)n.setLocation(r, t.getLocation(r));
                            return n;
                        }
                    }
                ]), e;
            }(), De = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "computeRing",
                        value: function() {
                            if (null !== this._ring) return null;
                            for(var t = new Array(this._pts.size()).fill(null), e = 0; e < this._pts.size(); e++)t[e] = this._pts.get(e);
                            this._ring = this._geometryFactory.createLinearRing(t), this._isHole = ft.isCCW(this._ring.getCoordinates());
                        }
                    },
                    {
                        key: "isIsolated",
                        value: function() {
                            return 1 === this._label.getGeometryCount();
                        }
                    },
                    {
                        key: "computePoints",
                        value: function(t) {
                            this._startDe = t;
                            var e = t, n = !0;
                            do {
                                if (null === e) throw new gt("Found null DirectedEdge");
                                if (e.getEdgeRing() === this) throw new gt("Directed Edge visited twice during ring-building at " + e.getCoordinate());
                                this._edges.add(e);
                                var r = e.getLabel();
                                G.isTrue(r.isArea()), this.mergeLabel(r), this.addPoints(e.getEdge(), e.isForward(), n), n = !1, this.setEdgeRing(e, this), e = this.getNext(e);
                            }while (e !== this._startDe);
                        }
                    },
                    {
                        key: "getLinearRing",
                        value: function() {
                            return this._ring;
                        }
                    },
                    {
                        key: "getCoordinate",
                        value: function(t) {
                            return this._pts.get(t);
                        }
                    },
                    {
                        key: "computeMaxNodeDegree",
                        value: function() {
                            this._maxNodeDegree = 0;
                            var t = this._startDe;
                            do {
                                var e = t.getNode().getEdges().getOutgoingDegree(this);
                                e > this._maxNodeDegree && (this._maxNodeDegree = e), t = this.getNext(t);
                            }while (t !== this._startDe);
                            this._maxNodeDegree *= 2;
                        }
                    },
                    {
                        key: "addPoints",
                        value: function(t, e, n) {
                            var r = t.getCoordinates();
                            if (e) {
                                var i = 1;
                                n && (i = 0);
                                for(var o = i; o < r.length; o++)this._pts.add(r[o]);
                            } else {
                                var s = r.length - 2;
                                n && (s = r.length - 1);
                                for(var a = s; a >= 0; a--)this._pts.add(r[a]);
                            }
                        }
                    },
                    {
                        key: "isHole",
                        value: function() {
                            return this._isHole;
                        }
                    },
                    {
                        key: "setInResult",
                        value: function() {
                            var t = this._startDe;
                            do t.getEdge().setInResult(!0), t = t.getNext();
                            while (t !== this._startDe);
                        }
                    },
                    {
                        key: "containsPoint",
                        value: function(t) {
                            var e = this.getLinearRing();
                            if (!e.getEnvelopeInternal().contains(t)) return !1;
                            if (!Oe.isInRing(t, e.getCoordinates())) return !1;
                            for(var n = this._holes.iterator(); n.hasNext();)if (n.next().containsPoint(t)) return !1;
                            return !0;
                        }
                    },
                    {
                        key: "addHole",
                        value: function(t) {
                            this._holes.add(t);
                        }
                    },
                    {
                        key: "isShell",
                        value: function() {
                            return null === this._shell;
                        }
                    },
                    {
                        key: "getLabel",
                        value: function() {
                            return this._label;
                        }
                    },
                    {
                        key: "getEdges",
                        value: function() {
                            return this._edges;
                        }
                    },
                    {
                        key: "getMaxNodeDegree",
                        value: function() {
                            return this._maxNodeDegree < 0 && this.computeMaxNodeDegree(), this._maxNodeDegree;
                        }
                    },
                    {
                        key: "getShell",
                        value: function() {
                            return this._shell;
                        }
                    },
                    {
                        key: "mergeLabel",
                        value: function() {
                            if (1 === arguments.length) {
                                var t = arguments[0];
                                this.mergeLabel(t, 0), this.mergeLabel(t, 1);
                            } else if (2 === arguments.length) {
                                var e = arguments[1], n = arguments[0].getLocation(e, tt.RIGHT);
                                if (n === Z.NONE) return null;
                                if (this._label.getLocation(e) === Z.NONE) return this._label.setLocation(e, n), null;
                            }
                        }
                    },
                    {
                        key: "setShell",
                        value: function(t) {
                            this._shell = t, null !== t && t.addHole(this);
                        }
                    },
                    {
                        key: "toPolygon",
                        value: function(t) {
                            for(var e = new Array(this._holes.size()).fill(null), n = 0; n < this._holes.size(); n++)e[n] = this._holes.get(n).getLinearRing();
                            return t.createPolygon(this.getLinearRing(), e);
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            if (this._startDe = null, this._maxNodeDegree = -1, this._edges = new pt, this._pts = new pt, this._label = new Ae(Z.NONE), this._ring = null, this._isHole = null, this._shell = null, this._holes = new pt, this._geometryFactory = null, 0 === arguments.length) ;
                            else if (2 === arguments.length) {
                                var t = arguments[0], e = arguments[1];
                                this._geometryFactory = e, this.computePoints(t), this.computeRing();
                            }
                        }
                    }
                ]), e;
            }(), Fe = function(e) {
                r(o, e);
                var i = c(o);
                function o() {
                    var e;
                    return t(this, o), e = i.call(this), o.constructor_.apply(l(e), arguments), e;
                }
                return n(o, [
                    {
                        key: "setEdgeRing",
                        value: function(t, e) {
                            t.setMinEdgeRing(e);
                        }
                    },
                    {
                        key: "getNext",
                        value: function(t) {
                            return t.getNextMin();
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            var t = arguments[0], e = arguments[1];
                            De.constructor_.call(this, t, e);
                        }
                    }
                ]), o;
            }(De), qe = function(e) {
                r(o, e);
                var i = c(o);
                function o() {
                    var e;
                    return t(this, o), e = i.call(this), o.constructor_.apply(l(e), arguments), e;
                }
                return n(o, [
                    {
                        key: "buildMinimalRings",
                        value: function() {
                            var t = new pt, e = this._startDe;
                            do {
                                if (null === e.getMinEdgeRing()) {
                                    var n = new Fe(e, this._geometryFactory);
                                    t.add(n);
                                }
                                e = e.getNext();
                            }while (e !== this._startDe);
                            return t;
                        }
                    },
                    {
                        key: "setEdgeRing",
                        value: function(t, e) {
                            t.setEdgeRing(e);
                        }
                    },
                    {
                        key: "linkDirectedEdgesForMinimalEdgeRings",
                        value: function() {
                            var t = this._startDe;
                            do t.getNode().getEdges().linkMinimalDirectedEdges(this), t = t.getNext();
                            while (t !== this._startDe);
                        }
                    },
                    {
                        key: "getNext",
                        value: function(t) {
                            return t.getNext();
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            var t = arguments[0], e = arguments[1];
                            De.constructor_.call(this, t, e);
                        }
                    }
                ]), o;
            }(De), Ge = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "setVisited",
                        value: function(t) {
                            this._isVisited = t;
                        }
                    },
                    {
                        key: "setInResult",
                        value: function(t) {
                            this._isInResult = t;
                        }
                    },
                    {
                        key: "isCovered",
                        value: function() {
                            return this._isCovered;
                        }
                    },
                    {
                        key: "isCoveredSet",
                        value: function() {
                            return this._isCoveredSet;
                        }
                    },
                    {
                        key: "setLabel",
                        value: function(t) {
                            this._label = t;
                        }
                    },
                    {
                        key: "getLabel",
                        value: function() {
                            return this._label;
                        }
                    },
                    {
                        key: "setCovered",
                        value: function(t) {
                            this._isCovered = t, this._isCoveredSet = !0;
                        }
                    },
                    {
                        key: "updateIM",
                        value: function(t) {
                            G.isTrue(this._label.getGeometryCount() >= 2, "found partial label"), this.computeIM(t);
                        }
                    },
                    {
                        key: "isInResult",
                        value: function() {
                            return this._isInResult;
                        }
                    },
                    {
                        key: "isVisited",
                        value: function() {
                            return this._isVisited;
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            if (this._label = null, this._isInResult = !1, this._isCovered = !1, this._isCoveredSet = !1, this._isVisited = !1, 0 === arguments.length) ;
                            else if (1 === arguments.length) {
                                var t = arguments[0];
                                this._label = t;
                            }
                        }
                    }
                ]), e;
            }(), Ye = function(e) {
                r(s, e);
                var o = c(s);
                function s() {
                    var e;
                    return t(this, s), e = o.call(this), s.constructor_.apply(l(e), arguments), e;
                }
                return n(s, [
                    {
                        key: "isIncidentEdgeInResult",
                        value: function() {
                            for(var t = this.getEdges().getEdges().iterator(); t.hasNext();)if (t.next().getEdge().isInResult()) return !0;
                            return !1;
                        }
                    },
                    {
                        key: "isIsolated",
                        value: function() {
                            return 1 === this._label.getGeometryCount();
                        }
                    },
                    {
                        key: "getCoordinate",
                        value: function() {
                            return this._coord;
                        }
                    },
                    {
                        key: "print",
                        value: function(t) {
                            t.println("node " + this._coord + " lbl: " + this._label);
                        }
                    },
                    {
                        key: "computeIM",
                        value: function(t) {}
                    },
                    {
                        key: "computeMergedLocation",
                        value: function(t, e) {
                            var n = Z.NONE;
                            if (n = this._label.getLocation(e), !t.isNull(e)) {
                                var r = t.getLocation(e);
                                n !== Z.BOUNDARY && (n = r);
                            }
                            return n;
                        }
                    },
                    {
                        key: "setLabel",
                        value: function() {
                            if (2 !== arguments.length || !Number.isInteger(arguments[1]) || !Number.isInteger(arguments[0])) return f(i(s.prototype), "setLabel", this).apply(this, arguments);
                            var t = arguments[0], e = arguments[1];
                            null === this._label ? this._label = new Ae(t, e) : this._label.setLocation(t, e);
                        }
                    },
                    {
                        key: "getEdges",
                        value: function() {
                            return this._edges;
                        }
                    },
                    {
                        key: "mergeLabel",
                        value: function() {
                            if (arguments[0] instanceof s) {
                                var t = arguments[0];
                                this.mergeLabel(t._label);
                            } else if (arguments[0] instanceof Ae) for(var e = arguments[0], n = 0; n < 2; n++){
                                var r = this.computeMergedLocation(e, n);
                                this._label.getLocation(n) === Z.NONE && this._label.setLocation(n, r);
                            }
                        }
                    },
                    {
                        key: "add",
                        value: function(t) {
                            this._edges.insert(t), t.setNode(this);
                        }
                    },
                    {
                        key: "setLabelBoundary",
                        value: function(t) {
                            if (null === this._label) return null;
                            var e = Z.NONE;
                            null !== this._label && (e = this._label.getLocation(t));
                            var n = null;
                            switch(e){
                                case Z.BOUNDARY:
                                    n = Z.INTERIOR;
                                    break;
                                case Z.INTERIOR:
                                default:
                                    n = Z.BOUNDARY;
                            }
                            this._label.setLocation(t, n);
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._coord = null, this._edges = null;
                            var t = arguments[0], e = arguments[1];
                            this._coord = t, this._edges = e, this._label = new Ae(0, Z.NONE);
                        }
                    }
                ]), s;
            }(Ge), Be = function(e) {
                r(i, e);
                var n = c(i);
                function i() {
                    return t(this, i), n.apply(this, arguments);
                }
                return i;
            }(ne);
            function ze(t) {
                return null == t ? 0 : t.color;
            }
            function je(t) {
                return null == t ? null : t.parent;
            }
            function Xe(t, e) {
                null !== t && (t.color = e);
            }
            function Ue(t) {
                return null == t ? null : t.left;
            }
            function Ve(t) {
                return null == t ? null : t.right;
            }
            var Ze = function(e) {
                r(o, e);
                var i = c(o);
                function o() {
                    var e;
                    return t(this, o), (e = i.call(this)).root_ = null, e.size_ = 0, e;
                }
                return n(o, [
                    {
                        key: "get",
                        value: function(t) {
                            for(var e = this.root_; null !== e;){
                                var n = t.compareTo(e.key);
                                if (n < 0) e = e.left;
                                else {
                                    if (!(n > 0)) return e.value;
                                    e = e.right;
                                }
                            }
                            return null;
                        }
                    },
                    {
                        key: "put",
                        value: function(t, e) {
                            if (null === this.root_) return this.root_ = {
                                key: t,
                                value: e,
                                left: null,
                                right: null,
                                parent: null,
                                color: 0,
                                getValue: function() {
                                    return this.value;
                                },
                                getKey: function() {
                                    return this.key;
                                }
                            }, this.size_ = 1, null;
                            var n, r, i = this.root_;
                            do if (n = i, (r = t.compareTo(i.key)) < 0) i = i.left;
                            else {
                                if (!(r > 0)) {
                                    var o = i.value;
                                    return i.value = e, o;
                                }
                                i = i.right;
                            }
                            while (null !== i);
                            var s = {
                                key: t,
                                left: null,
                                right: null,
                                value: e,
                                parent: n,
                                color: 0,
                                getValue: function() {
                                    return this.value;
                                },
                                getKey: function() {
                                    return this.key;
                                }
                            };
                            return r < 0 ? n.left = s : n.right = s, this.fixAfterInsertion(s), this.size_++, null;
                        }
                    },
                    {
                        key: "fixAfterInsertion",
                        value: function(t) {
                            var e;
                            for(t.color = 1; null != t && t !== this.root_ && 1 === t.parent.color;)je(t) === Ue(je(je(t))) ? 1 === ze(e = Ve(je(je(t)))) ? (Xe(je(t), 0), Xe(e, 0), Xe(je(je(t)), 1), t = je(je(t))) : (t === Ve(je(t)) && (t = je(t), this.rotateLeft(t)), Xe(je(t), 0), Xe(je(je(t)), 1), this.rotateRight(je(je(t)))) : 1 === ze(e = Ue(je(je(t)))) ? (Xe(je(t), 0), Xe(e, 0), Xe(je(je(t)), 1), t = je(je(t))) : (t === Ue(je(t)) && (t = je(t), this.rotateRight(t)), Xe(je(t), 0), Xe(je(je(t)), 1), this.rotateLeft(je(je(t))));
                            this.root_.color = 0;
                        }
                    },
                    {
                        key: "values",
                        value: function() {
                            var t = new pt, e = this.getFirstEntry();
                            if (null !== e) for(t.add(e.value); null !== (e = o.successor(e));)t.add(e.value);
                            return t;
                        }
                    },
                    {
                        key: "entrySet",
                        value: function() {
                            var t = new Q, e = this.getFirstEntry();
                            if (null !== e) for(t.add(e); null !== (e = o.successor(e));)t.add(e);
                            return t;
                        }
                    },
                    {
                        key: "rotateLeft",
                        value: function(t) {
                            if (null != t) {
                                var e = t.right;
                                t.right = e.left, null != e.left && (e.left.parent = t), e.parent = t.parent, null == t.parent ? this.root_ = e : t.parent.left === t ? t.parent.left = e : t.parent.right = e, e.left = t, t.parent = e;
                            }
                        }
                    },
                    {
                        key: "rotateRight",
                        value: function(t) {
                            if (null != t) {
                                var e = t.left;
                                t.left = e.right, null != e.right && (e.right.parent = t), e.parent = t.parent, null == t.parent ? this.root_ = e : t.parent.right === t ? t.parent.right = e : t.parent.left = e, e.right = t, t.parent = e;
                            }
                        }
                    },
                    {
                        key: "getFirstEntry",
                        value: function() {
                            var t = this.root_;
                            if (null != t) for(; null != t.left;)t = t.left;
                            return t;
                        }
                    },
                    {
                        key: "size",
                        value: function() {
                            return this.size_;
                        }
                    },
                    {
                        key: "containsKey",
                        value: function(t) {
                            for(var e = this.root_; null !== e;){
                                var n = t.compareTo(e.key);
                                if (n < 0) e = e.left;
                                else {
                                    if (!(n > 0)) return !0;
                                    e = e.right;
                                }
                            }
                            return !1;
                        }
                    }
                ], [
                    {
                        key: "successor",
                        value: function(t) {
                            var e;
                            if (null === t) return null;
                            if (null !== t.right) {
                                for(e = t.right; null !== e.left;)e = e.left;
                                return e;
                            }
                            e = t.parent;
                            for(var n = t; null !== e && n === e.right;)n = e, e = e.parent;
                            return e;
                        }
                    }
                ]), o;
            }(Be), He = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "find",
                        value: function(t) {
                            return this.nodeMap.get(t);
                        }
                    },
                    {
                        key: "addNode",
                        value: function() {
                            if (arguments[0] instanceof j) {
                                var t = arguments[0], e = this.nodeMap.get(t);
                                return null === e && (e = this.nodeFact.createNode(t), this.nodeMap.put(t, e)), e;
                            }
                            if (arguments[0] instanceof Ye) {
                                var n = arguments[0], r = this.nodeMap.get(n.getCoordinate());
                                return null === r ? (this.nodeMap.put(n.getCoordinate(), n), n) : (r.mergeLabel(n), r);
                            }
                        }
                    },
                    {
                        key: "print",
                        value: function(t) {
                            for(var e = this.iterator(); e.hasNext();)e.next().print(t);
                        }
                    },
                    {
                        key: "iterator",
                        value: function() {
                            return this.nodeMap.values().iterator();
                        }
                    },
                    {
                        key: "values",
                        value: function() {
                            return this.nodeMap.values();
                        }
                    },
                    {
                        key: "getBoundaryNodes",
                        value: function(t) {
                            for(var e = new pt, n = this.iterator(); n.hasNext();){
                                var r = n.next();
                                r.getLabel().getLocation(t) === Z.BOUNDARY && e.add(r);
                            }
                            return e;
                        }
                    },
                    {
                        key: "add",
                        value: function(t) {
                            var e = t.getCoordinate();
                            this.addNode(e).add(t);
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this.nodeMap = new Ze, this.nodeFact = null;
                            var t = arguments[0];
                            this.nodeFact = t;
                        }
                    }
                ]), e;
            }(), We = function() {
                function e() {
                    t(this, e);
                }
                return n(e, null, [
                    {
                        key: "isNorthern",
                        value: function(t) {
                            return t === e.NE || t === e.NW;
                        }
                    },
                    {
                        key: "isOpposite",
                        value: function(t, e) {
                            return t !== e && 2 == (t - e + 4) % 4;
                        }
                    },
                    {
                        key: "commonHalfPlane",
                        value: function(t, e) {
                            if (t === e) return t;
                            if (2 == (t - e + 4) % 4) return -1;
                            var n = t < e ? t : e;
                            return 0 === n && 3 === (t > e ? t : e) ? 3 : n;
                        }
                    },
                    {
                        key: "isInHalfPlane",
                        value: function(t, n) {
                            return n === e.SE ? t === e.SE || t === e.SW : t === n || t === n + 1;
                        }
                    },
                    {
                        key: "quadrant",
                        value: function() {
                            if ("number" == typeof arguments[0] && "number" == typeof arguments[1]) {
                                var t = arguments[0], n = arguments[1];
                                if (0 === t && 0 === n) throw new _("Cannot compute the quadrant for point ( " + t + ", " + n + " )");
                                return t >= 0 ? n >= 0 ? e.NE : e.SE : n >= 0 ? e.NW : e.SW;
                            }
                            if (arguments[0] instanceof j && arguments[1] instanceof j) {
                                var r = arguments[0], i = arguments[1];
                                if (i.x === r.x && i.y === r.y) throw new _("Cannot compute the quadrant for two identical points " + r);
                                return i.x >= r.x ? i.y >= r.y ? e.NE : e.SE : i.y >= r.y ? e.NW : e.SW;
                            }
                        }
                    }
                ]), e;
            }();
            We.NE = 0, We.NW = 1, We.SW = 2, We.SE = 3;
            var Je = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "compareDirection",
                        value: function(t) {
                            return this._dx === t._dx && this._dy === t._dy ? 0 : this._quadrant > t._quadrant ? 1 : this._quadrant < t._quadrant ? -1 : ft.index(t._p0, t._p1, this._p1);
                        }
                    },
                    {
                        key: "getDy",
                        value: function() {
                            return this._dy;
                        }
                    },
                    {
                        key: "getCoordinate",
                        value: function() {
                            return this._p0;
                        }
                    },
                    {
                        key: "setNode",
                        value: function(t) {
                            this._node = t;
                        }
                    },
                    {
                        key: "print",
                        value: function(t) {
                            var e = Math.atan2(this._dy, this._dx), n = this.getClass().getName(), r = n.lastIndexOf("."), i = n.substring(r + 1);
                            t.print("  " + i + ": " + this._p0 + " - " + this._p1 + " " + this._quadrant + ":" + e + "   " + this._label);
                        }
                    },
                    {
                        key: "compareTo",
                        value: function(t) {
                            var e = t;
                            return this.compareDirection(e);
                        }
                    },
                    {
                        key: "getDirectedCoordinate",
                        value: function() {
                            return this._p1;
                        }
                    },
                    {
                        key: "getDx",
                        value: function() {
                            return this._dx;
                        }
                    },
                    {
                        key: "getLabel",
                        value: function() {
                            return this._label;
                        }
                    },
                    {
                        key: "getEdge",
                        value: function() {
                            return this._edge;
                        }
                    },
                    {
                        key: "getQuadrant",
                        value: function() {
                            return this._quadrant;
                        }
                    },
                    {
                        key: "getNode",
                        value: function() {
                            return this._node;
                        }
                    },
                    {
                        key: "toString",
                        value: function() {
                            var t = Math.atan2(this._dy, this._dx), e = this.getClass().getName(), n = e.lastIndexOf(".");
                            return "  " + e.substring(n + 1) + ": " + this._p0 + " - " + this._p1 + " " + this._quadrant + ":" + t + "   " + this._label;
                        }
                    },
                    {
                        key: "computeLabel",
                        value: function(t) {}
                    },
                    {
                        key: "init",
                        value: function(t, e) {
                            this._p0 = t, this._p1 = e, this._dx = e.x - t.x, this._dy = e.y - t.y, this._quadrant = We.quadrant(this._dx, this._dy), G.isTrue(!(0 === this._dx && 0 === this._dy), "EdgeEnd with identical endpoints found");
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                k
                            ];
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            if (this._edge = null, this._label = null, this._node = null, this._p0 = null, this._p1 = null, this._dx = null, this._dy = null, this._quadrant = null, 1 === arguments.length) {
                                var t = arguments[0];
                                this._edge = t;
                            } else if (3 === arguments.length) {
                                var n = arguments[0], r = arguments[1], i = arguments[2];
                                e.constructor_.call(this, n, r, i, null);
                            } else if (4 === arguments.length) {
                                var o = arguments[0], s = arguments[1], a = arguments[2], u = arguments[3];
                                e.constructor_.call(this, o), this.init(s, a), this._label = u;
                            }
                        }
                    }
                ]), e;
            }(), Ke = function(e) {
                r(s, e);
                var o = c(s);
                function s() {
                    var e;
                    return t(this, s), e = o.call(this), s.constructor_.apply(l(e), arguments), e;
                }
                return n(s, [
                    {
                        key: "getNextMin",
                        value: function() {
                            return this._nextMin;
                        }
                    },
                    {
                        key: "getDepth",
                        value: function(t) {
                            return this._depth[t];
                        }
                    },
                    {
                        key: "setVisited",
                        value: function(t) {
                            this._isVisited = t;
                        }
                    },
                    {
                        key: "computeDirectedLabel",
                        value: function() {
                            this._label = new Ae(this._edge.getLabel()), this._isForward || this._label.flip();
                        }
                    },
                    {
                        key: "getNext",
                        value: function() {
                            return this._next;
                        }
                    },
                    {
                        key: "setDepth",
                        value: function(t, e) {
                            if (-999 !== this._depth[t] && this._depth[t] !== e) throw new gt("assigned depths do not match", this.getCoordinate());
                            this._depth[t] = e;
                        }
                    },
                    {
                        key: "isInteriorAreaEdge",
                        value: function() {
                            for(var t = !0, e = 0; e < 2; e++)this._label.isArea(e) && this._label.getLocation(e, tt.LEFT) === Z.INTERIOR && this._label.getLocation(e, tt.RIGHT) === Z.INTERIOR || (t = !1);
                            return t;
                        }
                    },
                    {
                        key: "setNextMin",
                        value: function(t) {
                            this._nextMin = t;
                        }
                    },
                    {
                        key: "print",
                        value: function(t) {
                            f(i(s.prototype), "print", this).call(this, t), t.print(" " + this._depth[tt.LEFT] + "/" + this._depth[tt.RIGHT]), t.print(" (" + this.getDepthDelta() + ")"), this._isInResult && t.print(" inResult");
                        }
                    },
                    {
                        key: "setMinEdgeRing",
                        value: function(t) {
                            this._minEdgeRing = t;
                        }
                    },
                    {
                        key: "isLineEdge",
                        value: function() {
                            var t = this._label.isLine(0) || this._label.isLine(1), e = !this._label.isArea(0) || this._label.allPositionsEqual(0, Z.EXTERIOR), n = !this._label.isArea(1) || this._label.allPositionsEqual(1, Z.EXTERIOR);
                            return t && e && n;
                        }
                    },
                    {
                        key: "setEdgeRing",
                        value: function(t) {
                            this._edgeRing = t;
                        }
                    },
                    {
                        key: "getMinEdgeRing",
                        value: function() {
                            return this._minEdgeRing;
                        }
                    },
                    {
                        key: "getDepthDelta",
                        value: function() {
                            var t = this._edge.getDepthDelta();
                            return this._isForward || (t = -t), t;
                        }
                    },
                    {
                        key: "setInResult",
                        value: function(t) {
                            this._isInResult = t;
                        }
                    },
                    {
                        key: "getSym",
                        value: function() {
                            return this._sym;
                        }
                    },
                    {
                        key: "isForward",
                        value: function() {
                            return this._isForward;
                        }
                    },
                    {
                        key: "getEdge",
                        value: function() {
                            return this._edge;
                        }
                    },
                    {
                        key: "printEdge",
                        value: function(t) {
                            this.print(t), t.print(" "), this._isForward ? this._edge.print(t) : this._edge.printReverse(t);
                        }
                    },
                    {
                        key: "setSym",
                        value: function(t) {
                            this._sym = t;
                        }
                    },
                    {
                        key: "setVisitedEdge",
                        value: function(t) {
                            this.setVisited(t), this._sym.setVisited(t);
                        }
                    },
                    {
                        key: "setEdgeDepths",
                        value: function(t, e) {
                            var n = this.getEdge().getDepthDelta();
                            this._isForward || (n = -n);
                            var r = 1;
                            t === tt.LEFT && (r = -1);
                            var i = tt.opposite(t), o = e + n * r;
                            this.setDepth(t, e), this.setDepth(i, o);
                        }
                    },
                    {
                        key: "getEdgeRing",
                        value: function() {
                            return this._edgeRing;
                        }
                    },
                    {
                        key: "isInResult",
                        value: function() {
                            return this._isInResult;
                        }
                    },
                    {
                        key: "setNext",
                        value: function(t) {
                            this._next = t;
                        }
                    },
                    {
                        key: "isVisited",
                        value: function() {
                            return this._isVisited;
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._isForward = null, this._isInResult = !1, this._isVisited = !1, this._sym = null, this._next = null, this._nextMin = null, this._edgeRing = null, this._minEdgeRing = null, this._depth = [
                                0,
                                -999,
                                -999
                            ];
                            var t = arguments[0], e = arguments[1];
                            if (Je.constructor_.call(this, t), this._isForward = e, e) this.init(t.getCoordinate(0), t.getCoordinate(1));
                            else {
                                var n = t.getNumPoints() - 1;
                                this.init(t.getCoordinate(n), t.getCoordinate(n - 1));
                            }
                            this.computeDirectedLabel();
                        }
                    },
                    {
                        key: "depthFactor",
                        value: function(t, e) {
                            return t === Z.EXTERIOR && e === Z.INTERIOR ? 1 : t === Z.INTERIOR && e === Z.EXTERIOR ? -1 : 0;
                        }
                    }
                ]), s;
            }(Je), Qe = function() {
                function e() {
                    t(this, e);
                }
                return n(e, [
                    {
                        key: "createNode",
                        value: function(t) {
                            return new Ye(t, null);
                        }
                    }
                ]), e;
            }(), $e = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "printEdges",
                        value: function(t) {
                            t.println("Edges:");
                            for(var e = 0; e < this._edges.size(); e++){
                                t.println("edge " + e + ":");
                                var n = this._edges.get(e);
                                n.print(t), n.eiList.print(t);
                            }
                        }
                    },
                    {
                        key: "find",
                        value: function(t) {
                            return this._nodes.find(t);
                        }
                    },
                    {
                        key: "addNode",
                        value: function() {
                            if (arguments[0] instanceof Ye) {
                                var t = arguments[0];
                                return this._nodes.addNode(t);
                            }
                            if (arguments[0] instanceof j) {
                                var e = arguments[0];
                                return this._nodes.addNode(e);
                            }
                        }
                    },
                    {
                        key: "getNodeIterator",
                        value: function() {
                            return this._nodes.iterator();
                        }
                    },
                    {
                        key: "linkResultDirectedEdges",
                        value: function() {
                            for(var t = this._nodes.iterator(); t.hasNext();)t.next().getEdges().linkResultDirectedEdges();
                        }
                    },
                    {
                        key: "debugPrintln",
                        value: function(t) {
                            xt.out.println(t);
                        }
                    },
                    {
                        key: "isBoundaryNode",
                        value: function(t, e) {
                            var n = this._nodes.find(e);
                            if (null === n) return !1;
                            var r = n.getLabel();
                            return null !== r && r.getLocation(t) === Z.BOUNDARY;
                        }
                    },
                    {
                        key: "linkAllDirectedEdges",
                        value: function() {
                            for(var t = this._nodes.iterator(); t.hasNext();)t.next().getEdges().linkAllDirectedEdges();
                        }
                    },
                    {
                        key: "matchInSameDirection",
                        value: function(t, e, n, r) {
                            return !!t.equals(n) && ft.index(t, e, r) === ft.COLLINEAR && We.quadrant(t, e) === We.quadrant(n, r);
                        }
                    },
                    {
                        key: "getEdgeEnds",
                        value: function() {
                            return this._edgeEndList;
                        }
                    },
                    {
                        key: "debugPrint",
                        value: function(t) {
                            xt.out.print(t);
                        }
                    },
                    {
                        key: "getEdgeIterator",
                        value: function() {
                            return this._edges.iterator();
                        }
                    },
                    {
                        key: "findEdgeInSameDirection",
                        value: function(t, e) {
                            for(var n = 0; n < this._edges.size(); n++){
                                var r = this._edges.get(n), i = r.getCoordinates();
                                if (this.matchInSameDirection(t, e, i[0], i[1])) return r;
                                if (this.matchInSameDirection(t, e, i[i.length - 1], i[i.length - 2])) return r;
                            }
                            return null;
                        }
                    },
                    {
                        key: "insertEdge",
                        value: function(t) {
                            this._edges.add(t);
                        }
                    },
                    {
                        key: "findEdgeEnd",
                        value: function(t) {
                            for(var e = this.getEdgeEnds().iterator(); e.hasNext();){
                                var n = e.next();
                                if (n.getEdge() === t) return n;
                            }
                            return null;
                        }
                    },
                    {
                        key: "addEdges",
                        value: function(t) {
                            for(var e = t.iterator(); e.hasNext();){
                                var n = e.next();
                                this._edges.add(n);
                                var r = new Ke(n, !0), i = new Ke(n, !1);
                                r.setSym(i), i.setSym(r), this.add(r), this.add(i);
                            }
                        }
                    },
                    {
                        key: "add",
                        value: function(t) {
                            this._nodes.add(t), this._edgeEndList.add(t);
                        }
                    },
                    {
                        key: "getNodes",
                        value: function() {
                            return this._nodes.values();
                        }
                    },
                    {
                        key: "findEdge",
                        value: function(t, e) {
                            for(var n = 0; n < this._edges.size(); n++){
                                var r = this._edges.get(n), i = r.getCoordinates();
                                if (t.equals(i[0]) && e.equals(i[1])) return r;
                            }
                            return null;
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            if (this._edges = new pt, this._nodes = null, this._edgeEndList = new pt, 0 === arguments.length) this._nodes = new He(new Qe);
                            else if (1 === arguments.length) {
                                var t = arguments[0];
                                this._nodes = new He(t);
                            }
                        }
                    },
                    {
                        key: "linkResultDirectedEdges",
                        value: function(t) {
                            for(var e = t.iterator(); e.hasNext();)e.next().getEdges().linkResultDirectedEdges();
                        }
                    }
                ]), e;
            }(), tn = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "sortShellsAndHoles",
                        value: function(t, e, n) {
                            for(var r = t.iterator(); r.hasNext();){
                                var i = r.next();
                                i.isHole() ? n.add(i) : e.add(i);
                            }
                        }
                    },
                    {
                        key: "computePolygons",
                        value: function(t) {
                            for(var e = new pt, n = t.iterator(); n.hasNext();){
                                var r = n.next().toPolygon(this._geometryFactory);
                                e.add(r);
                            }
                            return e;
                        }
                    },
                    {
                        key: "placeFreeHoles",
                        value: function(t, n) {
                            for(var r = n.iterator(); r.hasNext();){
                                var i = r.next();
                                if (null === i.getShell()) {
                                    var o = e.findEdgeRingContaining(i, t);
                                    if (null === o) throw new gt("unable to assign hole to a shell", i.getCoordinate(0));
                                    i.setShell(o);
                                }
                            }
                        }
                    },
                    {
                        key: "buildMinimalEdgeRings",
                        value: function(t, e, n) {
                            for(var r = new pt, i = t.iterator(); i.hasNext();){
                                var o = i.next();
                                if (o.getMaxNodeDegree() > 2) {
                                    o.linkDirectedEdgesForMinimalEdgeRings();
                                    var s = o.buildMinimalRings(), a = this.findShell(s);
                                    null !== a ? (this.placePolygonHoles(a, s), e.add(a)) : n.addAll(s);
                                } else r.add(o);
                            }
                            return r;
                        }
                    },
                    {
                        key: "buildMaximalEdgeRings",
                        value: function(t) {
                            for(var e = new pt, n = t.iterator(); n.hasNext();){
                                var r = n.next();
                                if (r.isInResult() && r.getLabel().isArea() && null === r.getEdgeRing()) {
                                    var i = new qe(r, this._geometryFactory);
                                    e.add(i), i.setInResult();
                                }
                            }
                            return e;
                        }
                    },
                    {
                        key: "placePolygonHoles",
                        value: function(t, e) {
                            for(var n = e.iterator(); n.hasNext();){
                                var r = n.next();
                                r.isHole() && r.setShell(t);
                            }
                        }
                    },
                    {
                        key: "getPolygons",
                        value: function() {
                            return this.computePolygons(this._shellList);
                        }
                    },
                    {
                        key: "findShell",
                        value: function(t) {
                            for(var e = 0, n = null, r = t.iterator(); r.hasNext();){
                                var i = r.next();
                                i.isHole() || (n = i, e++);
                            }
                            return G.isTrue(e <= 1, "found two shells in MinimalEdgeRing list"), n;
                        }
                    },
                    {
                        key: "add",
                        value: function() {
                            if (1 === arguments.length) {
                                var t = arguments[0];
                                this.add(t.getEdgeEnds(), t.getNodes());
                            } else if (2 === arguments.length) {
                                var e = arguments[0], n = arguments[1];
                                $e.linkResultDirectedEdges(n);
                                var r = this.buildMaximalEdgeRings(e), i = new pt, o = this.buildMinimalEdgeRings(r, this._shellList, i);
                                this.sortShellsAndHoles(o, this._shellList, i), this.placeFreeHoles(this._shellList, i);
                            }
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._geometryFactory = null, this._shellList = new pt;
                            var t = arguments[0];
                            this._geometryFactory = t;
                        }
                    },
                    {
                        key: "findEdgeRingContaining",
                        value: function(t, e) {
                            for(var n = t.getLinearRing(), r = n.getEnvelopeInternal(), i = n.getCoordinateN(0), o = null, s = null, a = e.iterator(); a.hasNext();){
                                var u = a.next(), l = u.getLinearRing(), h = l.getEnvelopeInternal();
                                if (!h.equals(r) && h.contains(r)) {
                                    i = Wt.ptNotInList(n.getCoordinates(), l.getCoordinates());
                                    var c = !1;
                                    Oe.isInRing(i, l.getCoordinates()) && (c = !0), c && (null === o || s.contains(h)) && (s = (o = u).getLinearRing().getEnvelopeInternal());
                                }
                            }
                            return o;
                        }
                    }
                ]), e;
            }(), en = function() {
                function e() {
                    t(this, e);
                }
                return n(e, [
                    {
                        key: "getBounds",
                        value: function() {}
                    }
                ]), e;
            }(), nn = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "getItem",
                        value: function() {
                            return this._item;
                        }
                    },
                    {
                        key: "getBounds",
                        value: function() {
                            return this._bounds;
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                en,
                                b
                            ];
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._bounds = null, this._item = null;
                            var t = arguments[0], e = arguments[1];
                            this._bounds = t, this._item = e;
                        }
                    }
                ]), e;
            }(), rn = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "poll",
                        value: function() {
                            if (this.isEmpty()) return null;
                            var t = this._items.get(1);
                            return this._items.set(1, this._items.get(this._size)), this._size -= 1, this.reorder(1), t;
                        }
                    },
                    {
                        key: "size",
                        value: function() {
                            return this._size;
                        }
                    },
                    {
                        key: "reorder",
                        value: function(t) {
                            for(var e = null, n = this._items.get(t); 2 * t <= this._size && ((e = 2 * t) !== this._size && this._items.get(e + 1).compareTo(this._items.get(e)) < 0 && e++, this._items.get(e).compareTo(n) < 0); t = e)this._items.set(t, this._items.get(e));
                            this._items.set(t, n);
                        }
                    },
                    {
                        key: "clear",
                        value: function() {
                            this._size = 0, this._items.clear();
                        }
                    },
                    {
                        key: "peek",
                        value: function() {
                            return this.isEmpty() ? null : this._items.get(1);
                        }
                    },
                    {
                        key: "isEmpty",
                        value: function() {
                            return 0 === this._size;
                        }
                    },
                    {
                        key: "add",
                        value: function(t) {
                            this._items.add(null), this._size += 1;
                            var e = this._size;
                            for(this._items.set(0, t); t.compareTo(this._items.get(Math.trunc(e / 2))) < 0; e /= 2)this._items.set(e, this._items.get(Math.trunc(e / 2)));
                            this._items.set(e, t);
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._size = null, this._items = null, this._size = 0, this._items = new pt, this._items.add(null);
                        }
                    }
                ]), e;
            }(), on = function() {
                function e() {
                    t(this, e);
                }
                return n(e, [
                    {
                        key: "insert",
                        value: function(t, e) {}
                    },
                    {
                        key: "remove",
                        value: function(t, e) {}
                    },
                    {
                        key: "query",
                        value: function() {}
                    }
                ]), e;
            }(), sn = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "getLevel",
                        value: function() {
                            return this._level;
                        }
                    },
                    {
                        key: "size",
                        value: function() {
                            return this._childBoundables.size();
                        }
                    },
                    {
                        key: "getChildBoundables",
                        value: function() {
                            return this._childBoundables;
                        }
                    },
                    {
                        key: "addChildBoundable",
                        value: function(t) {
                            G.isTrue(null === this._bounds), this._childBoundables.add(t);
                        }
                    },
                    {
                        key: "isEmpty",
                        value: function() {
                            return this._childBoundables.isEmpty();
                        }
                    },
                    {
                        key: "getBounds",
                        value: function() {
                            return null === this._bounds && (this._bounds = this.computeBounds()), this._bounds;
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                en,
                                b
                            ];
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            if (this._childBoundables = new pt, this._bounds = null, this._level = null, 0 === arguments.length) ;
                            else if (1 === arguments.length) {
                                var t = arguments[0];
                                this._level = t;
                            }
                        }
                    }
                ]), e;
            }(), an = {
                reverseOrder: function() {
                    return {
                        compare: function(t, e) {
                            return e.compareTo(t);
                        }
                    };
                },
                min: function(t) {
                    return an.sort(t), t.get(0);
                },
                sort: function(t, e) {
                    var n = t.toArray();
                    e ? At.sort(n, e) : At.sort(n);
                    for(var r = t.iterator(), i = 0, o = n.length; i < o; i++)r.next(), r.set(n[i]);
                },
                singletonList: function(t) {
                    var e = new pt;
                    return e.add(t), e;
                }
            }, un = function() {
                function e() {
                    t(this, e);
                }
                return n(e, null, [
                    {
                        key: "maxDistance",
                        value: function(t, n, r, i, o, s, a, u) {
                            var l = e.distance(t, n, o, s);
                            return l = Math.max(l, e.distance(t, n, a, u)), l = Math.max(l, e.distance(r, i, o, s)), Math.max(l, e.distance(r, i, a, u));
                        }
                    },
                    {
                        key: "distance",
                        value: function(t, e, n, r) {
                            var i = n - t, o = r - e;
                            return Math.sqrt(i * i + o * o);
                        }
                    },
                    {
                        key: "maximumDistance",
                        value: function(t, n) {
                            var r = Math.min(t.getMinX(), n.getMinX()), i = Math.min(t.getMinY(), n.getMinY()), o = Math.max(t.getMaxX(), n.getMaxX()), s = Math.max(t.getMaxY(), n.getMaxY());
                            return e.distance(r, i, o, s);
                        }
                    },
                    {
                        key: "minMaxDistance",
                        value: function(t, n) {
                            var r = t.getMinX(), i = t.getMinY(), o = t.getMaxX(), s = t.getMaxY(), a = n.getMinX(), u = n.getMinY(), l = n.getMaxX(), h = n.getMaxY(), c = e.maxDistance(r, i, r, s, a, u, a, h);
                            return c = Math.min(c, e.maxDistance(r, i, r, s, a, u, l, u)), c = Math.min(c, e.maxDistance(r, i, r, s, l, h, a, h)), c = Math.min(c, e.maxDistance(r, i, r, s, l, h, l, u)), c = Math.min(c, e.maxDistance(r, i, o, i, a, u, a, h)), c = Math.min(c, e.maxDistance(r, i, o, i, a, u, l, u)), c = Math.min(c, e.maxDistance(r, i, o, i, l, h, a, h)), c = Math.min(c, e.maxDistance(r, i, o, i, l, h, l, u)), c = Math.min(c, e.maxDistance(o, s, r, s, a, u, a, h)), c = Math.min(c, e.maxDistance(o, s, r, s, a, u, l, u)), c = Math.min(c, e.maxDistance(o, s, r, s, l, h, a, h)), c = Math.min(c, e.maxDistance(o, s, r, s, l, h, l, u)), c = Math.min(c, e.maxDistance(o, s, o, i, a, u, a, h)), c = Math.min(c, e.maxDistance(o, s, o, i, a, u, l, u)), c = Math.min(c, e.maxDistance(o, s, o, i, l, h, a, h)), Math.min(c, e.maxDistance(o, s, o, i, l, h, l, u));
                        }
                    }
                ]), e;
            }(), ln = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "maximumDistance",
                        value: function() {
                            return un.maximumDistance(this._boundable1.getBounds(), this._boundable2.getBounds());
                        }
                    },
                    {
                        key: "expandToQueue",
                        value: function(t, n) {
                            var r = e.isComposite(this._boundable1), i = e.isComposite(this._boundable2);
                            if (r && i) return e.area(this._boundable1) > e.area(this._boundable2) ? (this.expand(this._boundable1, this._boundable2, !1, t, n), null) : (this.expand(this._boundable2, this._boundable1, !0, t, n), null);
                            if (r) return this.expand(this._boundable1, this._boundable2, !1, t, n), null;
                            if (i) return this.expand(this._boundable2, this._boundable1, !0, t, n), null;
                            throw new _("neither boundable is composite");
                        }
                    },
                    {
                        key: "isLeaves",
                        value: function() {
                            return !(e.isComposite(this._boundable1) || e.isComposite(this._boundable2));
                        }
                    },
                    {
                        key: "compareTo",
                        value: function(t) {
                            var e = t;
                            return this._distance < e._distance ? -1 : this._distance > e._distance ? 1 : 0;
                        }
                    },
                    {
                        key: "expand",
                        value: function(t, n, r, i, o) {
                            for(var s = t.getChildBoundables().iterator(); s.hasNext();){
                                var a = s.next(), u = null;
                                (u = r ? new e(n, a, this._itemDistance) : new e(a, n, this._itemDistance)).getDistance() < o && i.add(u);
                            }
                        }
                    },
                    {
                        key: "getBoundable",
                        value: function(t) {
                            return 0 === t ? this._boundable1 : this._boundable2;
                        }
                    },
                    {
                        key: "getDistance",
                        value: function() {
                            return this._distance;
                        }
                    },
                    {
                        key: "distance",
                        value: function() {
                            return this.isLeaves() ? this._itemDistance.distance(this._boundable1, this._boundable2) : this._boundable1.getBounds().distance(this._boundable2.getBounds());
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                k
                            ];
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._boundable1 = null, this._boundable2 = null, this._distance = null, this._itemDistance = null;
                            var t = arguments[0], e = arguments[1], n = arguments[2];
                            this._boundable1 = t, this._boundable2 = e, this._itemDistance = n, this._distance = this.distance();
                        }
                    },
                    {
                        key: "area",
                        value: function(t) {
                            return t.getBounds().getArea();
                        }
                    },
                    {
                        key: "isComposite",
                        value: function(t) {
                            return t instanceof sn;
                        }
                    }
                ]), e;
            }(), hn = function() {
                function e() {
                    t(this, e);
                }
                return n(e, [
                    {
                        key: "visitItem",
                        value: function(t) {}
                    }
                ]), e;
            }(), cn = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "queryInternal",
                        value: function() {
                            if (ot(arguments[2], hn) && arguments[0] instanceof Object && arguments[1] instanceof sn) for(var t = arguments[0], e = arguments[2], n = arguments[1].getChildBoundables(), r = 0; r < n.size(); r++){
                                var i = n.get(r);
                                this.getIntersectsOp().intersects(i.getBounds(), t) && (i instanceof sn ? this.queryInternal(t, i, e) : i instanceof nn ? e.visitItem(i.getItem()) : G.shouldNeverReachHere());
                            }
                            else if (ot(arguments[2], rt) && arguments[0] instanceof Object && arguments[1] instanceof sn) for(var o = arguments[0], s = arguments[2], a = arguments[1].getChildBoundables(), u = 0; u < a.size(); u++){
                                var l = a.get(u);
                                this.getIntersectsOp().intersects(l.getBounds(), o) && (l instanceof sn ? this.queryInternal(o, l, s) : l instanceof nn ? s.add(l.getItem()) : G.shouldNeverReachHere());
                            }
                        }
                    },
                    {
                        key: "getNodeCapacity",
                        value: function() {
                            return this._nodeCapacity;
                        }
                    },
                    {
                        key: "lastNode",
                        value: function(t) {
                            return t.get(t.size() - 1);
                        }
                    },
                    {
                        key: "size",
                        value: function() {
                            if (0 === arguments.length) return this.isEmpty() ? 0 : (this.build(), this.size(this._root));
                            if (1 === arguments.length) {
                                for(var t = 0, e = arguments[0].getChildBoundables().iterator(); e.hasNext();){
                                    var n = e.next();
                                    n instanceof sn ? t += this.size(n) : n instanceof nn && (t += 1);
                                }
                                return t;
                            }
                        }
                    },
                    {
                        key: "removeItem",
                        value: function(t, e) {
                            for(var n = null, r = t.getChildBoundables().iterator(); r.hasNext();){
                                var i = r.next();
                                i instanceof nn && i.getItem() === e && (n = i);
                            }
                            return null !== n && (t.getChildBoundables().remove(n), !0);
                        }
                    },
                    {
                        key: "itemsTree",
                        value: function() {
                            if (0 === arguments.length) {
                                this.build();
                                var t = this.itemsTree(this._root);
                                return null === t ? new pt : t;
                            }
                            if (1 === arguments.length) {
                                for(var e = arguments[0], n = new pt, r = e.getChildBoundables().iterator(); r.hasNext();){
                                    var i = r.next();
                                    if (i instanceof sn) {
                                        var o = this.itemsTree(i);
                                        null !== o && n.add(o);
                                    } else i instanceof nn ? n.add(i.getItem()) : G.shouldNeverReachHere();
                                }
                                return n.size() <= 0 ? null : n;
                            }
                        }
                    },
                    {
                        key: "insert",
                        value: function(t, e) {
                            G.isTrue(!this._built, "Cannot insert items into an STR packed R-tree after it has been built."), this._itemBoundables.add(new nn(t, e));
                        }
                    },
                    {
                        key: "boundablesAtLevel",
                        value: function() {
                            if (1 === arguments.length) {
                                var t = arguments[0], e = new pt;
                                return this.boundablesAtLevel(t, this._root, e), e;
                            }
                            if (3 === arguments.length) {
                                var n = arguments[0], r = arguments[1], i = arguments[2];
                                if (G.isTrue(n > -2), r.getLevel() === n) return i.add(r), null;
                                for(var o = r.getChildBoundables().iterator(); o.hasNext();){
                                    var s = o.next();
                                    s instanceof sn ? this.boundablesAtLevel(n, s, i) : (G.isTrue(s instanceof nn), -1 === n && i.add(s));
                                }
                                return null;
                            }
                        }
                    },
                    {
                        key: "query",
                        value: function() {
                            if (1 === arguments.length) {
                                var t = arguments[0];
                                this.build();
                                var e = new pt;
                                return this.isEmpty() || this.getIntersectsOp().intersects(this._root.getBounds(), t) && this.queryInternal(t, this._root, e), e;
                            }
                            if (2 === arguments.length) {
                                var n = arguments[0], r = arguments[1];
                                if (this.build(), this.isEmpty()) return null;
                                this.getIntersectsOp().intersects(this._root.getBounds(), n) && this.queryInternal(n, this._root, r);
                            }
                        }
                    },
                    {
                        key: "build",
                        value: function() {
                            if (this._built) return null;
                            this._root = this._itemBoundables.isEmpty() ? this.createNode(0) : this.createHigherLevels(this._itemBoundables, -1), this._itemBoundables = null, this._built = !0;
                        }
                    },
                    {
                        key: "getRoot",
                        value: function() {
                            return this.build(), this._root;
                        }
                    },
                    {
                        key: "remove",
                        value: function() {
                            if (2 === arguments.length) {
                                var t = arguments[0], e = arguments[1];
                                return this.build(), !!this.getIntersectsOp().intersects(this._root.getBounds(), t) && this.remove(t, this._root, e);
                            }
                            if (3 === arguments.length) {
                                var n = arguments[0], r = arguments[1], i = arguments[2], o = this.removeItem(r, i);
                                if (o) return !0;
                                for(var s = null, a = r.getChildBoundables().iterator(); a.hasNext();){
                                    var u = a.next();
                                    if (this.getIntersectsOp().intersects(u.getBounds(), n) && u instanceof sn && (o = this.remove(n, u, i))) {
                                        s = u;
                                        break;
                                    }
                                }
                                return null !== s && s.getChildBoundables().isEmpty() && r.getChildBoundables().remove(s), o;
                            }
                        }
                    },
                    {
                        key: "createHigherLevels",
                        value: function(t, e) {
                            G.isTrue(!t.isEmpty());
                            var n = this.createParentBoundables(t, e + 1);
                            return 1 === n.size() ? n.get(0) : this.createHigherLevels(n, e + 1);
                        }
                    },
                    {
                        key: "depth",
                        value: function() {
                            if (0 === arguments.length) return this.isEmpty() ? 0 : (this.build(), this.depth(this._root));
                            if (1 === arguments.length) {
                                for(var t = 0, e = arguments[0].getChildBoundables().iterator(); e.hasNext();){
                                    var n = e.next();
                                    if (n instanceof sn) {
                                        var r = this.depth(n);
                                        r > t && (t = r);
                                    }
                                }
                                return t + 1;
                            }
                        }
                    },
                    {
                        key: "createParentBoundables",
                        value: function(t, e) {
                            G.isTrue(!t.isEmpty());
                            var n = new pt;
                            n.add(this.createNode(e));
                            var r = new pt(t);
                            an.sort(r, this.getComparator());
                            for(var i = r.iterator(); i.hasNext();){
                                var o = i.next();
                                this.lastNode(n).getChildBoundables().size() === this.getNodeCapacity() && n.add(this.createNode(e)), this.lastNode(n).addChildBoundable(o);
                            }
                            return n;
                        }
                    },
                    {
                        key: "isEmpty",
                        value: function() {
                            return this._built ? this._root.isEmpty() : this._itemBoundables.isEmpty();
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                b
                            ];
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            if (this._root = null, this._built = !1, this._itemBoundables = new pt, this._nodeCapacity = null, 0 === arguments.length) e.constructor_.call(this, e.DEFAULT_NODE_CAPACITY);
                            else if (1 === arguments.length) {
                                var t = arguments[0];
                                G.isTrue(t > 1, "Node capacity must be greater than 1"), this._nodeCapacity = t;
                            }
                        }
                    },
                    {
                        key: "compareDoubles",
                        value: function(t, e) {
                            return t > e ? 1 : t < e ? -1 : 0;
                        }
                    }
                ]), e;
            }();
            cn.IntersectsOp = function() {}, cn.DEFAULT_NODE_CAPACITY = 10;
            var fn = function() {
                function e() {
                    t(this, e);
                }
                return n(e, [
                    {
                        key: "distance",
                        value: function(t, e) {}
                    }
                ]), e;
            }(), vn = function(e) {
                r(s, e);
                var o = c(s);
                function s() {
                    var e;
                    return t(this, s), e = o.call(this), s.constructor_.apply(l(e), arguments), e;
                }
                return n(s, [
                    {
                        key: "createParentBoundablesFromVerticalSlices",
                        value: function(t, e) {
                            G.isTrue(t.length > 0);
                            for(var n = new pt, r = 0; r < t.length; r++)n.addAll(this.createParentBoundablesFromVerticalSlice(t[r], e));
                            return n;
                        }
                    },
                    {
                        key: "nearestNeighbourK",
                        value: function() {
                            if (2 === arguments.length) {
                                var t = arguments[0], e = arguments[1];
                                return this.nearestNeighbourK(t, A.POSITIVE_INFINITY, e);
                            }
                            if (3 === arguments.length) {
                                var n = arguments[0], r = arguments[2], i = arguments[1], o = new rn;
                                o.add(n);
                                for(var a = new rn; !o.isEmpty() && i >= 0;){
                                    var u = o.poll(), l = u.getDistance();
                                    if (l >= i) break;
                                    u.isLeaves() ? a.size() < r ? a.add(u) : (a.peek().getDistance() > l && (a.poll(), a.add(u)), i = a.peek().getDistance()) : u.expandToQueue(o, i);
                                }
                                return s.getItems(a);
                            }
                        }
                    },
                    {
                        key: "createNode",
                        value: function(t) {
                            return new gn(t);
                        }
                    },
                    {
                        key: "size",
                        value: function() {
                            return 0 === arguments.length ? f(i(s.prototype), "size", this).call(this) : f(i(s.prototype), "size", this).apply(this, arguments);
                        }
                    },
                    {
                        key: "insert",
                        value: function() {
                            if (!(2 === arguments.length && arguments[1] instanceof Object && arguments[0] instanceof U)) return f(i(s.prototype), "insert", this).apply(this, arguments);
                            var t = arguments[0], e = arguments[1];
                            if (t.isNull()) return null;
                            f(i(s.prototype), "insert", this).call(this, t, e);
                        }
                    },
                    {
                        key: "getIntersectsOp",
                        value: function() {
                            return s.intersectsOp;
                        }
                    },
                    {
                        key: "verticalSlices",
                        value: function(t, e) {
                            for(var n = Math.trunc(Math.ceil(t.size() / e)), r = new Array(e).fill(null), i = t.iterator(), o = 0; o < e; o++){
                                r[o] = new pt;
                                for(var s = 0; i.hasNext() && s < n;){
                                    var a = i.next();
                                    r[o].add(a), s++;
                                }
                            }
                            return r;
                        }
                    },
                    {
                        key: "query",
                        value: function() {
                            if (1 === arguments.length) {
                                var t = arguments[0];
                                return f(i(s.prototype), "query", this).call(this, t);
                            }
                            if (2 === arguments.length) {
                                var e = arguments[0], n = arguments[1];
                                f(i(s.prototype), "query", this).call(this, e, n);
                            }
                        }
                    },
                    {
                        key: "getComparator",
                        value: function() {
                            return s.yComparator;
                        }
                    },
                    {
                        key: "createParentBoundablesFromVerticalSlice",
                        value: function(t, e) {
                            return f(i(s.prototype), "createParentBoundables", this).call(this, t, e);
                        }
                    },
                    {
                        key: "remove",
                        value: function() {
                            if (2 === arguments.length && arguments[1] instanceof Object && arguments[0] instanceof U) {
                                var t = arguments[0], e = arguments[1];
                                return f(i(s.prototype), "remove", this).call(this, t, e);
                            }
                            return f(i(s.prototype), "remove", this).apply(this, arguments);
                        }
                    },
                    {
                        key: "depth",
                        value: function() {
                            return 0 === arguments.length ? f(i(s.prototype), "depth", this).call(this) : f(i(s.prototype), "depth", this).apply(this, arguments);
                        }
                    },
                    {
                        key: "createParentBoundables",
                        value: function(t, e) {
                            G.isTrue(!t.isEmpty());
                            var n = Math.trunc(Math.ceil(t.size() / this.getNodeCapacity())), r = new pt(t);
                            an.sort(r, s.xComparator);
                            var i = this.verticalSlices(r, Math.trunc(Math.ceil(Math.sqrt(n))));
                            return this.createParentBoundablesFromVerticalSlices(i, e);
                        }
                    },
                    {
                        key: "nearestNeighbour",
                        value: function() {
                            if (1 === arguments.length) {
                                if (ot(arguments[0], fn)) {
                                    var t = arguments[0];
                                    if (this.isEmpty()) return null;
                                    var e = new ln(this.getRoot(), this.getRoot(), t);
                                    return this.nearestNeighbour(e);
                                }
                                if (arguments[0] instanceof ln) {
                                    var n = arguments[0], r = A.POSITIVE_INFINITY, i = null, o = new rn;
                                    for(o.add(n); !o.isEmpty() && r > 0;){
                                        var s = o.poll(), a = s.getDistance();
                                        if (a >= r) break;
                                        s.isLeaves() ? (r = a, i = s) : s.expandToQueue(o, r);
                                    }
                                    return null === i ? null : [
                                        i.getBoundable(0).getItem(),
                                        i.getBoundable(1).getItem()
                                    ];
                                }
                            } else {
                                if (2 === arguments.length) {
                                    var u = arguments[0], l = arguments[1];
                                    if (this.isEmpty() || u.isEmpty()) return null;
                                    var h = new ln(this.getRoot(), u.getRoot(), l);
                                    return this.nearestNeighbour(h);
                                }
                                if (3 === arguments.length) {
                                    var c = arguments[2], f = new nn(arguments[0], arguments[1]), v = new ln(this.getRoot(), f, c);
                                    return this.nearestNeighbour(v)[0];
                                }
                                if (4 === arguments.length) {
                                    var g = arguments[2], d = arguments[3], p = new nn(arguments[0], arguments[1]), y = new ln(this.getRoot(), p, g);
                                    return this.nearestNeighbourK(y, d);
                                }
                            }
                        }
                    },
                    {
                        key: "isWithinDistance",
                        value: function() {
                            if (2 === arguments.length) {
                                var t = arguments[0], e = arguments[1], n = A.POSITIVE_INFINITY, r = new rn;
                                for(r.add(t); !r.isEmpty();){
                                    var i = r.poll(), o = i.getDistance();
                                    if (o > e) return !1;
                                    if (i.maximumDistance() <= e) return !0;
                                    if (i.isLeaves()) {
                                        if ((n = o) <= e) return !0;
                                    } else i.expandToQueue(r, n);
                                }
                                return !1;
                            }
                            if (3 === arguments.length) {
                                var s = arguments[0], a = arguments[1], u = arguments[2], l = new ln(this.getRoot(), s.getRoot(), a);
                                return this.isWithinDistance(l, u);
                            }
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                on,
                                b
                            ];
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            if (0 === arguments.length) s.constructor_.call(this, s.DEFAULT_NODE_CAPACITY);
                            else if (1 === arguments.length) {
                                var t = arguments[0];
                                cn.constructor_.call(this, t);
                            }
                        }
                    },
                    {
                        key: "centreX",
                        value: function(t) {
                            return s.avg(t.getMinX(), t.getMaxX());
                        }
                    },
                    {
                        key: "avg",
                        value: function(t, e) {
                            return (t + e) / 2;
                        }
                    },
                    {
                        key: "getItems",
                        value: function(t) {
                            for(var e = new Array(t.size()).fill(null), n = 0; !t.isEmpty();){
                                var r = t.poll();
                                e[n] = r.getBoundable(0).getItem(), n++;
                            }
                            return e;
                        }
                    },
                    {
                        key: "centreY",
                        value: function(t) {
                            return s.avg(t.getMinY(), t.getMaxY());
                        }
                    }
                ]), s;
            }(cn), gn = function(e) {
                r(o, e);
                var i = c(o);
                function o() {
                    var e;
                    return t(this, o), e = i.call(this), o.constructor_.apply(l(e), arguments), e;
                }
                return n(o, [
                    {
                        key: "computeBounds",
                        value: function() {
                            for(var t = null, e = this.getChildBoundables().iterator(); e.hasNext();){
                                var n = e.next();
                                null === t ? t = new U(n.getBounds()) : t.expandToInclude(n.getBounds());
                            }
                            return t;
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            var t = arguments[0];
                            sn.constructor_.call(this, t);
                        }
                    }
                ]), o;
            }(sn);
            vn.STRtreeNode = gn, vn.xComparator = new (function() {
                function e() {
                    t(this, e);
                }
                return n(e, [
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                D
                            ];
                        }
                    },
                    {
                        key: "compare",
                        value: function(t, e) {
                            return cn.compareDoubles(vn.centreX(t.getBounds()), vn.centreX(e.getBounds()));
                        }
                    }
                ]), e;
            }()), vn.yComparator = new (function() {
                function e() {
                    t(this, e);
                }
                return n(e, [
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                D
                            ];
                        }
                    },
                    {
                        key: "compare",
                        value: function(t, e) {
                            return cn.compareDoubles(vn.centreY(t.getBounds()), vn.centreY(e.getBounds()));
                        }
                    }
                ]), e;
            }()), vn.intersectsOp = new (function() {
                function e() {
                    t(this, e);
                }
                return n(e, [
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                IntersectsOp
                            ];
                        }
                    },
                    {
                        key: "intersects",
                        value: function(t, e) {
                            return t.intersects(e);
                        }
                    }
                ]), e;
            }()), vn.DEFAULT_NODE_CAPACITY = 10;
            var dn = function() {
                function e() {
                    t(this, e);
                }
                return n(e, null, [
                    {
                        key: "relativeSign",
                        value: function(t, e) {
                            return t < e ? -1 : t > e ? 1 : 0;
                        }
                    },
                    {
                        key: "compare",
                        value: function(t, n, r) {
                            if (n.equals2D(r)) return 0;
                            var i = e.relativeSign(n.x, r.x), o = e.relativeSign(n.y, r.y);
                            switch(t){
                                case 0:
                                    return e.compareValue(i, o);
                                case 1:
                                    return e.compareValue(o, i);
                                case 2:
                                    return e.compareValue(o, -i);
                                case 3:
                                    return e.compareValue(-i, o);
                                case 4:
                                    return e.compareValue(-i, -o);
                                case 5:
                                    return e.compareValue(-o, -i);
                                case 6:
                                    return e.compareValue(-o, i);
                                case 7:
                                    return e.compareValue(i, -o);
                            }
                            return G.shouldNeverReachHere("invalid octant value"), 0;
                        }
                    },
                    {
                        key: "compareValue",
                        value: function(t, e) {
                            return t < 0 ? -1 : t > 0 ? 1 : e < 0 ? -1 : e > 0 ? 1 : 0;
                        }
                    }
                ]), e;
            }(), pn = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "getCoordinate",
                        value: function() {
                            return this.coord;
                        }
                    },
                    {
                        key: "print",
                        value: function(t) {
                            t.print(this.coord), t.print(" seg # = " + this.segmentIndex);
                        }
                    },
                    {
                        key: "compareTo",
                        value: function(t) {
                            var e = t;
                            return this.segmentIndex < e.segmentIndex ? -1 : this.segmentIndex > e.segmentIndex ? 1 : this.coord.equals2D(e.coord) ? 0 : this._isInterior ? e._isInterior ? dn.compare(this._segmentOctant, this.coord, e.coord) : 1 : -1;
                        }
                    },
                    {
                        key: "isEndPoint",
                        value: function(t) {
                            return 0 === this.segmentIndex && !this._isInterior || this.segmentIndex === t;
                        }
                    },
                    {
                        key: "toString",
                        value: function() {
                            return this.segmentIndex + ":" + this.coord.toString();
                        }
                    },
                    {
                        key: "isInterior",
                        value: function() {
                            return this._isInterior;
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                k
                            ];
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._segString = null, this.coord = null, this.segmentIndex = null, this._segmentOctant = null, this._isInterior = null;
                            var t = arguments[0], e = arguments[1], n = arguments[2], r = arguments[3];
                            this._segString = t, this.coord = new j(e), this.segmentIndex = n, this._segmentOctant = r, this._isInterior = !e.equals2D(t.getCoordinate(n));
                        }
                    }
                ]), e;
            }(), yn = function() {
                function e() {
                    t(this, e);
                }
                return n(e, [
                    {
                        key: "hasNext",
                        value: function() {}
                    },
                    {
                        key: "next",
                        value: function() {}
                    },
                    {
                        key: "remove",
                        value: function() {}
                    }
                ]), e;
            }(), mn = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "getSplitCoordinates",
                        value: function() {
                            var t = new Ht;
                            this.addEndpoints();
                            for(var e = this.iterator(), n = e.next(); e.hasNext();){
                                var r = e.next();
                                this.addEdgeCoordinates(n, r, t), n = r;
                            }
                            return t.toCoordinateArray();
                        }
                    },
                    {
                        key: "addCollapsedNodes",
                        value: function() {
                            var t = new pt;
                            this.findCollapsesFromInsertedNodes(t), this.findCollapsesFromExistingVertices(t);
                            for(var e = t.iterator(); e.hasNext();){
                                var n = e.next().intValue();
                                this.add(this._edge.getCoordinate(n), n);
                            }
                        }
                    },
                    {
                        key: "createSplitEdgePts",
                        value: function(t, e) {
                            var n = e.segmentIndex - t.segmentIndex + 2;
                            if (2 === n) return [
                                new j(t.coord),
                                new j(e.coord)
                            ];
                            var r = this._edge.getCoordinate(e.segmentIndex), i = e.isInterior() || !e.coord.equals2D(r);
                            i || n--;
                            var o = new Array(n).fill(null), s = 0;
                            o[s++] = new j(t.coord);
                            for(var a = t.segmentIndex + 1; a <= e.segmentIndex; a++)o[s++] = this._edge.getCoordinate(a);
                            return i && (o[s] = new j(e.coord)), o;
                        }
                    },
                    {
                        key: "print",
                        value: function(t) {
                            t.println("Intersections:");
                            for(var e = this.iterator(); e.hasNext();)e.next().print(t);
                        }
                    },
                    {
                        key: "findCollapsesFromExistingVertices",
                        value: function(t) {
                            for(var e = 0; e < this._edge.size() - 2; e++){
                                var n = this._edge.getCoordinate(e);
                                this._edge.getCoordinate(e + 1);
                                var r = this._edge.getCoordinate(e + 2);
                                n.equals2D(r) && t.add(at.valueOf(e + 1));
                            }
                        }
                    },
                    {
                        key: "addEdgeCoordinates",
                        value: function(t, e, n) {
                            var r = this.createSplitEdgePts(t, e);
                            n.add(r, !1);
                        }
                    },
                    {
                        key: "iterator",
                        value: function() {
                            return this._nodeMap.values().iterator();
                        }
                    },
                    {
                        key: "addSplitEdges",
                        value: function(t) {
                            this.addEndpoints(), this.addCollapsedNodes();
                            for(var e = this.iterator(), n = e.next(); e.hasNext();){
                                var r = e.next(), i = this.createSplitEdge(n, r);
                                t.add(i), n = r;
                            }
                        }
                    },
                    {
                        key: "findCollapseIndex",
                        value: function(t, e, n) {
                            if (!t.coord.equals2D(e.coord)) return !1;
                            var r = e.segmentIndex - t.segmentIndex;
                            return e.isInterior() || r--, 1 === r && (n[0] = t.segmentIndex + 1, !0);
                        }
                    },
                    {
                        key: "findCollapsesFromInsertedNodes",
                        value: function(t) {
                            for(var e = new Array(1).fill(null), n = this.iterator(), r = n.next(); n.hasNext();){
                                var i = n.next();
                                this.findCollapseIndex(r, i, e) && t.add(at.valueOf(e[0])), r = i;
                            }
                        }
                    },
                    {
                        key: "getEdge",
                        value: function() {
                            return this._edge;
                        }
                    },
                    {
                        key: "addEndpoints",
                        value: function() {
                            var t = this._edge.size() - 1;
                            this.add(this._edge.getCoordinate(0), 0), this.add(this._edge.getCoordinate(t), t);
                        }
                    },
                    {
                        key: "createSplitEdge",
                        value: function(t, e) {
                            var n = this.createSplitEdgePts(t, e);
                            return new kn(n, this._edge.getData());
                        }
                    },
                    {
                        key: "add",
                        value: function(t, e) {
                            var n = new pn(this._edge, t, e, this._edge.getSegmentOctant(e)), r = this._nodeMap.get(n);
                            return null !== r ? (G.isTrue(r.coord.equals2D(t), "Found equal nodes with different coordinates"), r) : (this._nodeMap.put(n, n), n);
                        }
                    },
                    {
                        key: "checkSplitEdgesCorrectness",
                        value: function(t) {
                            var e = this._edge.getCoordinates(), n = t.get(0).getCoordinate(0);
                            if (!n.equals2D(e[0])) throw new F("bad split edge start point at " + n);
                            var r = t.get(t.size() - 1).getCoordinates(), i = r[r.length - 1];
                            if (!i.equals2D(e[e.length - 1])) throw new F("bad split edge end point at " + i);
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._nodeMap = new Ze, this._edge = null;
                            var t = arguments[0];
                            this._edge = t;
                        }
                    }
                ]), e;
            }(), _n = function() {
                function e() {
                    t(this, e);
                }
                return n(e, null, [
                    {
                        key: "octant",
                        value: function() {
                            if ("number" == typeof arguments[0] && "number" == typeof arguments[1]) {
                                var t = arguments[0], n = arguments[1];
                                if (0 === t && 0 === n) throw new _("Cannot compute the octant for point ( " + t + ", " + n + " )");
                                var r = Math.abs(t), i = Math.abs(n);
                                return t >= 0 ? n >= 0 ? r >= i ? 0 : 1 : r >= i ? 7 : 6 : n >= 0 ? r >= i ? 3 : 2 : r >= i ? 4 : 5;
                            }
                            if (arguments[0] instanceof j && arguments[1] instanceof j) {
                                var o = arguments[0], s = arguments[1], a = s.x - o.x, u = s.y - o.y;
                                if (0 === a && 0 === u) throw new _("Cannot compute the octant for two identical points " + o);
                                return e.octant(a, u);
                            }
                        }
                    }
                ]), e;
            }(), xn = function() {
                function e() {
                    t(this, e);
                }
                return n(e, [
                    {
                        key: "getCoordinates",
                        value: function() {}
                    },
                    {
                        key: "size",
                        value: function() {}
                    },
                    {
                        key: "getCoordinate",
                        value: function(t) {}
                    },
                    {
                        key: "isClosed",
                        value: function() {}
                    },
                    {
                        key: "setData",
                        value: function(t) {}
                    },
                    {
                        key: "getData",
                        value: function() {}
                    }
                ]), e;
            }(), En = function() {
                function e() {
                    t(this, e);
                }
                return n(e, [
                    {
                        key: "addIntersection",
                        value: function(t, e) {}
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                xn
                            ];
                        }
                    }
                ]), e;
            }(), kn = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "getCoordinates",
                        value: function() {
                            return this._pts;
                        }
                    },
                    {
                        key: "size",
                        value: function() {
                            return this._pts.length;
                        }
                    },
                    {
                        key: "getCoordinate",
                        value: function(t) {
                            return this._pts[t];
                        }
                    },
                    {
                        key: "isClosed",
                        value: function() {
                            return this._pts[0].equals(this._pts[this._pts.length - 1]);
                        }
                    },
                    {
                        key: "getSegmentOctant",
                        value: function(t) {
                            return t === this._pts.length - 1 ? -1 : this.safeOctant(this.getCoordinate(t), this.getCoordinate(t + 1));
                        }
                    },
                    {
                        key: "setData",
                        value: function(t) {
                            this._data = t;
                        }
                    },
                    {
                        key: "safeOctant",
                        value: function(t, e) {
                            return t.equals2D(e) ? 0 : _n.octant(t, e);
                        }
                    },
                    {
                        key: "getData",
                        value: function() {
                            return this._data;
                        }
                    },
                    {
                        key: "addIntersection",
                        value: function() {
                            if (2 === arguments.length) {
                                var t = arguments[0], e = arguments[1];
                                this.addIntersectionNode(t, e);
                            } else if (4 === arguments.length) {
                                var n = arguments[1], r = arguments[3], i = new j(arguments[0].getIntersection(r));
                                this.addIntersection(i, n);
                            }
                        }
                    },
                    {
                        key: "toString",
                        value: function() {
                            return Le.toLineString(new $t(this._pts));
                        }
                    },
                    {
                        key: "getNodeList",
                        value: function() {
                            return this._nodeList;
                        }
                    },
                    {
                        key: "addIntersectionNode",
                        value: function(t, e) {
                            var n = e, r = n + 1;
                            if (r < this._pts.length) {
                                var i = this._pts[r];
                                t.equals2D(i) && (n = r);
                            }
                            return this._nodeList.add(t, n);
                        }
                    },
                    {
                        key: "addIntersections",
                        value: function(t, e, n) {
                            for(var r = 0; r < t.getIntersectionNum(); r++)this.addIntersection(t, e, n, r);
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                En
                            ];
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._nodeList = new mn(this), this._pts = null, this._data = null;
                            var t = arguments[0], e = arguments[1];
                            this._pts = t, this._data = e;
                        }
                    },
                    {
                        key: "getNodedSubstrings",
                        value: function() {
                            if (1 === arguments.length) {
                                var t = arguments[0], n = new pt;
                                return e.getNodedSubstrings(t, n), n;
                            }
                            if (2 === arguments.length) for(var r = arguments[1], i = arguments[0].iterator(); i.hasNext();)i.next().getNodeList().addSplitEdges(r);
                        }
                    }
                ]), e;
            }(), wn = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "minX",
                        value: function() {
                            return Math.min(this.p0.x, this.p1.x);
                        }
                    },
                    {
                        key: "orientationIndex",
                        value: function() {
                            if (arguments[0] instanceof e) {
                                var t = arguments[0], n = ft.index(this.p0, this.p1, t.p0), r = ft.index(this.p0, this.p1, t.p1);
                                return n >= 0 && r >= 0 || n <= 0 && r <= 0 ? Math.max(n, r) : 0;
                            }
                            if (arguments[0] instanceof j) {
                                var i = arguments[0];
                                return ft.index(this.p0, this.p1, i);
                            }
                        }
                    },
                    {
                        key: "toGeometry",
                        value: function(t) {
                            return t.createLineString([
                                this.p0,
                                this.p1
                            ]);
                        }
                    },
                    {
                        key: "isVertical",
                        value: function() {
                            return this.p0.x === this.p1.x;
                        }
                    },
                    {
                        key: "equals",
                        value: function(t) {
                            if (!(t instanceof e)) return !1;
                            var n = t;
                            return this.p0.equals(n.p0) && this.p1.equals(n.p1);
                        }
                    },
                    {
                        key: "intersection",
                        value: function(t) {
                            var e = new Ce;
                            return e.computeIntersection(this.p0, this.p1, t.p0, t.p1), e.hasIntersection() ? e.getIntersection(0) : null;
                        }
                    },
                    {
                        key: "project",
                        value: function() {
                            if (arguments[0] instanceof j) {
                                var t = arguments[0];
                                if (t.equals(this.p0) || t.equals(this.p1)) return new j(t);
                                var n = this.projectionFactor(t), r = new j;
                                return r.x = this.p0.x + n * (this.p1.x - this.p0.x), r.y = this.p0.y + n * (this.p1.y - this.p0.y), r;
                            }
                            if (arguments[0] instanceof e) {
                                var i = arguments[0], o = this.projectionFactor(i.p0), s = this.projectionFactor(i.p1);
                                if (o >= 1 && s >= 1) return null;
                                if (o <= 0 && s <= 0) return null;
                                var a = this.project(i.p0);
                                o < 0 && (a = this.p0), o > 1 && (a = this.p1);
                                var u = this.project(i.p1);
                                return s < 0 && (u = this.p0), s > 1 && (u = this.p1), new e(a, u);
                            }
                        }
                    },
                    {
                        key: "normalize",
                        value: function() {
                            this.p1.compareTo(this.p0) < 0 && this.reverse();
                        }
                    },
                    {
                        key: "angle",
                        value: function() {
                            return Math.atan2(this.p1.y - this.p0.y, this.p1.x - this.p0.x);
                        }
                    },
                    {
                        key: "getCoordinate",
                        value: function(t) {
                            return 0 === t ? this.p0 : this.p1;
                        }
                    },
                    {
                        key: "distancePerpendicular",
                        value: function(t) {
                            return kt.pointToLinePerpendicular(t, this.p0, this.p1);
                        }
                    },
                    {
                        key: "minY",
                        value: function() {
                            return Math.min(this.p0.y, this.p1.y);
                        }
                    },
                    {
                        key: "midPoint",
                        value: function() {
                            return e.midPoint(this.p0, this.p1);
                        }
                    },
                    {
                        key: "projectionFactor",
                        value: function(t) {
                            if (t.equals(this.p0)) return 0;
                            if (t.equals(this.p1)) return 1;
                            var e = this.p1.x - this.p0.x, n = this.p1.y - this.p0.y, r = e * e + n * n;
                            return r <= 0 ? A.NaN : ((t.x - this.p0.x) * e + (t.y - this.p0.y) * n) / r;
                        }
                    },
                    {
                        key: "closestPoints",
                        value: function(t) {
                            var e = this.intersection(t);
                            if (null !== e) return [
                                e,
                                e
                            ];
                            var n = new Array(2).fill(null), r = A.MAX_VALUE, i = null, o = this.closestPoint(t.p0);
                            r = o.distance(t.p0), n[0] = o, n[1] = t.p0;
                            var s = this.closestPoint(t.p1);
                            (i = s.distance(t.p1)) < r && (r = i, n[0] = s, n[1] = t.p1);
                            var a = t.closestPoint(this.p0);
                            (i = a.distance(this.p0)) < r && (r = i, n[0] = this.p0, n[1] = a);
                            var u = t.closestPoint(this.p1);
                            return (i = u.distance(this.p1)) < r && (r = i, n[0] = this.p1, n[1] = u), n;
                        }
                    },
                    {
                        key: "closestPoint",
                        value: function(t) {
                            var e = this.projectionFactor(t);
                            return e > 0 && e < 1 ? this.project(t) : this.p0.distance(t) < this.p1.distance(t) ? this.p0 : this.p1;
                        }
                    },
                    {
                        key: "maxX",
                        value: function() {
                            return Math.max(this.p0.x, this.p1.x);
                        }
                    },
                    {
                        key: "getLength",
                        value: function() {
                            return this.p0.distance(this.p1);
                        }
                    },
                    {
                        key: "compareTo",
                        value: function(t) {
                            var e = t, n = this.p0.compareTo(e.p0);
                            return 0 !== n ? n : this.p1.compareTo(e.p1);
                        }
                    },
                    {
                        key: "reverse",
                        value: function() {
                            var t = this.p0;
                            this.p0 = this.p1, this.p1 = t;
                        }
                    },
                    {
                        key: "equalsTopo",
                        value: function(t) {
                            return this.p0.equals(t.p0) && this.p1.equals(t.p1) || this.p0.equals(t.p1) && this.p1.equals(t.p0);
                        }
                    },
                    {
                        key: "lineIntersection",
                        value: function(t) {
                            return _t.intersection(this.p0, this.p1, t.p0, t.p1);
                        }
                    },
                    {
                        key: "maxY",
                        value: function() {
                            return Math.max(this.p0.y, this.p1.y);
                        }
                    },
                    {
                        key: "pointAlongOffset",
                        value: function(t, e) {
                            var n = this.p0.x + t * (this.p1.x - this.p0.x), r = this.p0.y + t * (this.p1.y - this.p0.y), i = this.p1.x - this.p0.x, o = this.p1.y - this.p0.y, s = Math.sqrt(i * i + o * o), a = 0, u = 0;
                            if (0 !== e) {
                                if (s <= 0) throw new IllegalStateException("Cannot compute offset from zero-length line segment");
                                a = e * i / s, u = e * o / s;
                            }
                            return new j(n - u, r + a);
                        }
                    },
                    {
                        key: "setCoordinates",
                        value: function() {
                            if (1 === arguments.length) {
                                var t = arguments[0];
                                this.setCoordinates(t.p0, t.p1);
                            } else if (2 === arguments.length) {
                                var e = arguments[0], n = arguments[1];
                                this.p0.x = e.x, this.p0.y = e.y, this.p1.x = n.x, this.p1.y = n.y;
                            }
                        }
                    },
                    {
                        key: "segmentFraction",
                        value: function(t) {
                            var e = this.projectionFactor(t);
                            return e < 0 ? e = 0 : (e > 1 || A.isNaN(e)) && (e = 1), e;
                        }
                    },
                    {
                        key: "toString",
                        value: function() {
                            return "LINESTRING( " + this.p0.x + " " + this.p0.y + ", " + this.p1.x + " " + this.p1.y + ")";
                        }
                    },
                    {
                        key: "isHorizontal",
                        value: function() {
                            return this.p0.y === this.p1.y;
                        }
                    },
                    {
                        key: "reflect",
                        value: function(t) {
                            var e = this.p1.getY() - this.p0.getY(), n = this.p0.getX() - this.p1.getX(), r = this.p0.getY() * (this.p1.getX() - this.p0.getX()) - this.p0.getX() * (this.p1.getY() - this.p0.getY()), i = e * e + n * n, o = e * e - n * n, s = t.getX(), a = t.getY();
                            return new j((-o * s - 2 * e * n * a - 2 * e * r) / i, (o * a - 2 * e * n * s - 2 * n * r) / i);
                        }
                    },
                    {
                        key: "distance",
                        value: function() {
                            if (arguments[0] instanceof e) {
                                var t = arguments[0];
                                return kt.segmentToSegment(this.p0, this.p1, t.p0, t.p1);
                            }
                            if (arguments[0] instanceof j) {
                                var n = arguments[0];
                                return kt.pointToSegment(n, this.p0, this.p1);
                            }
                        }
                    },
                    {
                        key: "pointAlong",
                        value: function(t) {
                            var e = new j;
                            return e.x = this.p0.x + t * (this.p1.x - this.p0.x), e.y = this.p0.y + t * (this.p1.y - this.p0.y), e;
                        }
                    },
                    {
                        key: "hashCode",
                        value: function() {
                            var t = A.doubleToLongBits(this.p0.x);
                            t ^= 31 * A.doubleToLongBits(this.p0.y);
                            var e = Math.trunc(t) ^ Math.trunc(t >> 32), n = A.doubleToLongBits(this.p1.x);
                            return n ^= 31 * A.doubleToLongBits(this.p1.y), e ^ Math.trunc(n) ^ Math.trunc(n >> 32);
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                k,
                                b
                            ];
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            if (this.p0 = null, this.p1 = null, 0 === arguments.length) e.constructor_.call(this, new j, new j);
                            else if (1 === arguments.length) {
                                var t = arguments[0];
                                e.constructor_.call(this, t.p0, t.p1);
                            } else if (2 === arguments.length) {
                                var n = arguments[0], r = arguments[1];
                                this.p0 = n, this.p1 = r;
                            } else if (4 === arguments.length) {
                                var i = arguments[0], o = arguments[1], s = arguments[2], a = arguments[3];
                                e.constructor_.call(this, new j(i, o), new j(s, a));
                            }
                        }
                    },
                    {
                        key: "midPoint",
                        value: function(t, e) {
                            return new j((t.x + e.x) / 2, (t.y + e.y) / 2);
                        }
                    }
                ]), e;
            }(), bn = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "overlap",
                        value: function() {
                            if (2 === arguments.length) ;
                            else if (4 === arguments.length) {
                                var t = arguments[1], e = arguments[2], n = arguments[3];
                                arguments[0].getLineSegment(t, this._overlapSeg1), e.getLineSegment(n, this._overlapSeg2), this.overlap(this._overlapSeg1, this._overlapSeg2);
                            }
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._overlapSeg1 = new wn, this._overlapSeg2 = new wn;
                        }
                    }
                ]), e;
            }(), In = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "getLineSegment",
                        value: function(t, e) {
                            e.p0 = this._pts[t], e.p1 = this._pts[t + 1];
                        }
                    },
                    {
                        key: "computeSelect",
                        value: function(t, e, n, r) {
                            var i = this._pts[e], o = this._pts[n];
                            if (n - e == 1) return r.select(this, e), null;
                            if (!t.intersects(i, o)) return null;
                            var s = Math.trunc((e + n) / 2);
                            e < s && this.computeSelect(t, e, s, r), s < n && this.computeSelect(t, s, n, r);
                        }
                    },
                    {
                        key: "getCoordinates",
                        value: function() {
                            for(var t = new Array(this._end - this._start + 1).fill(null), e = 0, n = this._start; n <= this._end; n++)t[e++] = this._pts[n];
                            return t;
                        }
                    },
                    {
                        key: "computeOverlaps",
                        value: function() {
                            if (2 === arguments.length) {
                                var t = arguments[0], e = arguments[1];
                                this.computeOverlaps(this._start, this._end, t, t._start, t._end, e);
                            } else if (6 === arguments.length) {
                                var n = arguments[0], r = arguments[1], i = arguments[2], o = arguments[3], s = arguments[4], a = arguments[5];
                                if (r - n == 1 && s - o == 1) return a.overlap(this, n, i, o), null;
                                if (!this.overlaps(n, r, i, o, s)) return null;
                                var u = Math.trunc((n + r) / 2), l = Math.trunc((o + s) / 2);
                                n < u && (o < l && this.computeOverlaps(n, u, i, o, l, a), l < s && this.computeOverlaps(n, u, i, l, s, a)), u < r && (o < l && this.computeOverlaps(u, r, i, o, l, a), l < s && this.computeOverlaps(u, r, i, l, s, a));
                            }
                        }
                    },
                    {
                        key: "setId",
                        value: function(t) {
                            this._id = t;
                        }
                    },
                    {
                        key: "select",
                        value: function(t, e) {
                            this.computeSelect(t, this._start, this._end, e);
                        }
                    },
                    {
                        key: "getEnvelope",
                        value: function() {
                            if (null === this._env) {
                                var t = this._pts[this._start], e = this._pts[this._end];
                                this._env = new U(t, e);
                            }
                            return this._env;
                        }
                    },
                    {
                        key: "overlaps",
                        value: function(t, e, n, r, i) {
                            return U.intersects(this._pts[t], this._pts[e], n._pts[r], n._pts[i]);
                        }
                    },
                    {
                        key: "getEndIndex",
                        value: function() {
                            return this._end;
                        }
                    },
                    {
                        key: "getStartIndex",
                        value: function() {
                            return this._start;
                        }
                    },
                    {
                        key: "getContext",
                        value: function() {
                            return this._context;
                        }
                    },
                    {
                        key: "getId",
                        value: function() {
                            return this._id;
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._pts = null, this._start = null, this._end = null, this._env = null, this._context = null, this._id = null;
                            var t = arguments[0], e = arguments[1], n = arguments[2], r = arguments[3];
                            this._pts = t, this._start = e, this._end = n, this._context = r;
                        }
                    }
                ]), e;
            }(), Nn = function() {
                function e() {
                    t(this, e);
                }
                return n(e, null, [
                    {
                        key: "findChainEnd",
                        value: function(t, e) {
                            for(var n = e; n < t.length - 1 && t[n].equals2D(t[n + 1]);)n++;
                            if (n >= t.length - 1) return t.length - 1;
                            for(var r = We.quadrant(t[n], t[n + 1]), i = e + 1; i < t.length && (t[i - 1].equals2D(t[i]) || We.quadrant(t[i - 1], t[i]) === r);)i++;
                            return i - 1;
                        }
                    },
                    {
                        key: "getChains",
                        value: function() {
                            if (1 === arguments.length) {
                                var t = arguments[0];
                                return e.getChains(t, null);
                            }
                            if (2 === arguments.length) {
                                var n = arguments[0], r = arguments[1], i = new pt, o = 0;
                                do {
                                    var s = e.findChainEnd(n, o), a = new In(n, o, s, r);
                                    i.add(a), o = s;
                                }while (o < n.length - 1);
                                return i;
                            }
                        }
                    }
                ]), e;
            }(), Sn = function() {
                function e() {
                    t(this, e);
                }
                return n(e, [
                    {
                        key: "computeNodes",
                        value: function(t) {}
                    },
                    {
                        key: "getNodedSubstrings",
                        value: function() {}
                    }
                ]), e;
            }(), Mn = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "setSegmentIntersector",
                        value: function(t) {
                            this._segInt = t;
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                Sn
                            ];
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            if (this._segInt = null, 0 === arguments.length) ;
                            else if (1 === arguments.length) {
                                var t = arguments[0];
                                this.setSegmentIntersector(t);
                            }
                        }
                    }
                ]), e;
            }(), Ln = function(e) {
                r(o, e);
                var i = c(o);
                function o() {
                    var e;
                    return t(this, o), e = i.call(this), o.constructor_.apply(l(e), arguments), e;
                }
                return n(o, [
                    {
                        key: "getMonotoneChains",
                        value: function() {
                            return this._monoChains;
                        }
                    },
                    {
                        key: "getNodedSubstrings",
                        value: function() {
                            return kn.getNodedSubstrings(this._nodedSegStrings);
                        }
                    },
                    {
                        key: "getIndex",
                        value: function() {
                            return this._index;
                        }
                    },
                    {
                        key: "add",
                        value: function(t) {
                            for(var e = Nn.getChains(t.getCoordinates(), t).iterator(); e.hasNext();){
                                var n = e.next();
                                n.setId(this._idCounter++), this._index.insert(n.getEnvelope(), n), this._monoChains.add(n);
                            }
                        }
                    },
                    {
                        key: "computeNodes",
                        value: function(t) {
                            this._nodedSegStrings = t;
                            for(var e = t.iterator(); e.hasNext();)this.add(e.next());
                            this.intersectChains();
                        }
                    },
                    {
                        key: "intersectChains",
                        value: function() {
                            for(var t = new Pn(this._segInt), e = this._monoChains.iterator(); e.hasNext();)for(var n = e.next(), r = this._index.query(n.getEnvelope()).iterator(); r.hasNext();){
                                var i = r.next();
                                if (i.getId() > n.getId() && (n.computeOverlaps(i, t), this._nOverlaps++), this._segInt.isDone()) return null;
                            }
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            if (this._monoChains = new pt, this._index = new vn, this._idCounter = 0, this._nodedSegStrings = null, this._nOverlaps = 0, 0 === arguments.length) ;
                            else if (1 === arguments.length) {
                                var t = arguments[0];
                                Mn.constructor_.call(this, t);
                            }
                        }
                    }
                ]), o;
            }(Mn), Pn = function(e) {
                r(s, e);
                var o = c(s);
                function s() {
                    var e;
                    return t(this, s), e = o.call(this), s.constructor_.apply(l(e), arguments), e;
                }
                return n(s, [
                    {
                        key: "overlap",
                        value: function() {
                            if (4 !== arguments.length) return f(i(s.prototype), "overlap", this).apply(this, arguments);
                            var t = arguments[1], e = arguments[2], n = arguments[3], r = arguments[0].getContext(), o = e.getContext();
                            this._si.processIntersections(r, t, o, n);
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._si = null;
                            var t = arguments[0];
                            this._si = t;
                        }
                    }
                ]), s;
            }(bn);
            Ln.SegmentOverlapAction = Pn;
            var Cn = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "isDeletable",
                        value: function(t, e, n, r) {
                            var i = this._inputLine[t], o = this._inputLine[e], s = this._inputLine[n];
                            return !!this.isConcave(i, o, s) && !!this.isShallow(i, o, s, r) && this.isShallowSampled(i, o, t, n, r);
                        }
                    },
                    {
                        key: "deleteShallowConcavities",
                        value: function() {
                            for(var t = 1, n = this.findNextNonDeletedIndex(t), r = this.findNextNonDeletedIndex(n), i = !1; r < this._inputLine.length;){
                                var o = !1;
                                this.isDeletable(t, n, r, this._distanceTol) && (this._isDeleted[n] = e.DELETE, o = !0, i = !0), t = o ? r : n, n = this.findNextNonDeletedIndex(t), r = this.findNextNonDeletedIndex(n);
                            }
                            return i;
                        }
                    },
                    {
                        key: "isShallowConcavity",
                        value: function(t, e, n, r) {
                            return ft.index(t, e, n) === this._angleOrientation && kt.pointToSegment(e, t, n) < r;
                        }
                    },
                    {
                        key: "isShallowSampled",
                        value: function(t, n, r, i, o) {
                            var s = Math.trunc((i - r) / e.NUM_PTS_TO_CHECK);
                            s <= 0 && (s = 1);
                            for(var a = r; a < i; a += s)if (!this.isShallow(t, n, this._inputLine[a], o)) return !1;
                            return !0;
                        }
                    },
                    {
                        key: "isConcave",
                        value: function(t, e, n) {
                            return ft.index(t, e, n) === this._angleOrientation;
                        }
                    },
                    {
                        key: "simplify",
                        value: function(t) {
                            this._distanceTol = Math.abs(t), t < 0 && (this._angleOrientation = ft.CLOCKWISE), this._isDeleted = new Array(this._inputLine.length).fill(null);
                            var e = !1;
                            do e = this.deleteShallowConcavities();
                            while (e);
                            return this.collapseLine();
                        }
                    },
                    {
                        key: "findNextNonDeletedIndex",
                        value: function(t) {
                            for(var n = t + 1; n < this._inputLine.length && this._isDeleted[n] === e.DELETE;)n++;
                            return n;
                        }
                    },
                    {
                        key: "isShallow",
                        value: function(t, e, n, r) {
                            return kt.pointToSegment(e, t, n) < r;
                        }
                    },
                    {
                        key: "collapseLine",
                        value: function() {
                            for(var t = new Ht, n = 0; n < this._inputLine.length; n++)this._isDeleted[n] !== e.DELETE && t.add(this._inputLine[n]);
                            return t.toCoordinateArray();
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._inputLine = null, this._distanceTol = null, this._isDeleted = null, this._angleOrientation = ft.COUNTERCLOCKWISE;
                            var t = arguments[0];
                            this._inputLine = t;
                        }
                    },
                    {
                        key: "simplify",
                        value: function(t, n) {
                            return new e(t).simplify(n);
                        }
                    }
                ]), e;
            }();
            Cn.INIT = 0, Cn.DELETE = 1, Cn.KEEP = 1, Cn.NUM_PTS_TO_CHECK = 10;
            var Tn = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "getCoordinates",
                        value: function() {
                            return this._ptList.toArray(e.COORDINATE_ARRAY_TYPE);
                        }
                    },
                    {
                        key: "setPrecisionModel",
                        value: function(t) {
                            this._precisionModel = t;
                        }
                    },
                    {
                        key: "addPt",
                        value: function(t) {
                            var e = new j(t);
                            if (this._precisionModel.makePrecise(e), this.isRedundant(e)) return null;
                            this._ptList.add(e);
                        }
                    },
                    {
                        key: "reverse",
                        value: function() {}
                    },
                    {
                        key: "addPts",
                        value: function(t, e) {
                            if (e) for(var n = 0; n < t.length; n++)this.addPt(t[n]);
                            else for(var r = t.length - 1; r >= 0; r--)this.addPt(t[r]);
                        }
                    },
                    {
                        key: "isRedundant",
                        value: function(t) {
                            if (this._ptList.size() < 1) return !1;
                            var e = this._ptList.get(this._ptList.size() - 1);
                            return t.distance(e) < this._minimimVertexDistance;
                        }
                    },
                    {
                        key: "toString",
                        value: function() {
                            return (new ae).createLineString(this.getCoordinates()).toString();
                        }
                    },
                    {
                        key: "closeRing",
                        value: function() {
                            if (this._ptList.size() < 1) return null;
                            var t = new j(this._ptList.get(0)), e = this._ptList.get(this._ptList.size() - 1);
                            if (t.equals(e)) return null;
                            this._ptList.add(t);
                        }
                    },
                    {
                        key: "setMinimumVertexDistance",
                        value: function(t) {
                            this._minimimVertexDistance = t;
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._ptList = null, this._precisionModel = null, this._minimimVertexDistance = 0, this._ptList = new pt;
                        }
                    }
                ]), e;
            }();
            Tn.COORDINATE_ARRAY_TYPE = new Array(0).fill(null);
            var On = function() {
                function e() {
                    t(this, e);
                }
                return n(e, null, [
                    {
                        key: "toDegrees",
                        value: function(t) {
                            return 180 * t / Math.PI;
                        }
                    },
                    {
                        key: "normalize",
                        value: function(t) {
                            for(; t > Math.PI;)t -= e.PI_TIMES_2;
                            for(; t <= -Math.PI;)t += e.PI_TIMES_2;
                            return t;
                        }
                    },
                    {
                        key: "angle",
                        value: function() {
                            if (1 === arguments.length) {
                                var t = arguments[0];
                                return Math.atan2(t.y, t.x);
                            }
                            if (2 === arguments.length) {
                                var e = arguments[0], n = arguments[1], r = n.x - e.x, i = n.y - e.y;
                                return Math.atan2(i, r);
                            }
                        }
                    },
                    {
                        key: "isAcute",
                        value: function(t, e, n) {
                            var r = t.x - e.x, i = t.y - e.y;
                            return r * (n.x - e.x) + i * (n.y - e.y) > 0;
                        }
                    },
                    {
                        key: "isObtuse",
                        value: function(t, e, n) {
                            var r = t.x - e.x, i = t.y - e.y;
                            return r * (n.x - e.x) + i * (n.y - e.y) < 0;
                        }
                    },
                    {
                        key: "interiorAngle",
                        value: function(t, n, r) {
                            var i = e.angle(n, t), o = e.angle(n, r);
                            return Math.abs(o - i);
                        }
                    },
                    {
                        key: "normalizePositive",
                        value: function(t) {
                            if (t < 0) {
                                for(; t < 0;)t += e.PI_TIMES_2;
                                t >= e.PI_TIMES_2 && (t = 0);
                            } else {
                                for(; t >= e.PI_TIMES_2;)t -= e.PI_TIMES_2;
                                t < 0 && (t = 0);
                            }
                            return t;
                        }
                    },
                    {
                        key: "angleBetween",
                        value: function(t, n, r) {
                            var i = e.angle(n, t), o = e.angle(n, r);
                            return e.diff(i, o);
                        }
                    },
                    {
                        key: "diff",
                        value: function(t, e) {
                            var n = null;
                            return (n = t < e ? e - t : t - e) > Math.PI && (n = 2 * Math.PI - n), n;
                        }
                    },
                    {
                        key: "toRadians",
                        value: function(t) {
                            return t * Math.PI / 180;
                        }
                    },
                    {
                        key: "getTurn",
                        value: function(t, n) {
                            var r = Math.sin(n - t);
                            return r > 0 ? e.COUNTERCLOCKWISE : r < 0 ? e.CLOCKWISE : e.NONE;
                        }
                    },
                    {
                        key: "angleBetweenOriented",
                        value: function(t, n, r) {
                            var i = e.angle(n, t), o = e.angle(n, r) - i;
                            return o <= -Math.PI ? o + e.PI_TIMES_2 : o > Math.PI ? o - e.PI_TIMES_2 : o;
                        }
                    }
                ]), e;
            }();
            On.PI_TIMES_2 = 2 * Math.PI, On.PI_OVER_2 = Math.PI / 2, On.PI_OVER_4 = Math.PI / 4, On.COUNTERCLOCKWISE = ft.COUNTERCLOCKWISE, On.CLOCKWISE = ft.CLOCKWISE, On.NONE = ft.COLLINEAR;
            var Rn = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "addNextSegment",
                        value: function(t, e) {
                            if (this._s0 = this._s1, this._s1 = this._s2, this._s2 = t, this._seg0.setCoordinates(this._s0, this._s1), this.computeOffsetSegment(this._seg0, this._side, this._distance, this._offset0), this._seg1.setCoordinates(this._s1, this._s2), this.computeOffsetSegment(this._seg1, this._side, this._distance, this._offset1), this._s1.equals(this._s2)) return null;
                            var n = ft.index(this._s0, this._s1, this._s2), r = n === ft.CLOCKWISE && this._side === tt.LEFT || n === ft.COUNTERCLOCKWISE && this._side === tt.RIGHT;
                            0 === n ? this.addCollinear(e) : r ? this.addOutsideTurn(n, e) : this.addInsideTurn(n, e);
                        }
                    },
                    {
                        key: "addLineEndCap",
                        value: function(t, e) {
                            var n = new wn(t, e), r = new wn;
                            this.computeOffsetSegment(n, tt.LEFT, this._distance, r);
                            var i = new wn;
                            this.computeOffsetSegment(n, tt.RIGHT, this._distance, i);
                            var o = e.x - t.x, s = e.y - t.y, a = Math.atan2(s, o);
                            switch(this._bufParams.getEndCapStyle()){
                                case y.CAP_ROUND:
                                    this._segList.addPt(r.p1), this.addDirectedFillet(e, a + Math.PI / 2, a - Math.PI / 2, ft.CLOCKWISE, this._distance), this._segList.addPt(i.p1);
                                    break;
                                case y.CAP_FLAT:
                                    this._segList.addPt(r.p1), this._segList.addPt(i.p1);
                                    break;
                                case y.CAP_SQUARE:
                                    var u = new j;
                                    u.x = Math.abs(this._distance) * Math.cos(a), u.y = Math.abs(this._distance) * Math.sin(a);
                                    var l = new j(r.p1.x + u.x, r.p1.y + u.y), h = new j(i.p1.x + u.x, i.p1.y + u.y);
                                    this._segList.addPt(l), this._segList.addPt(h);
                            }
                        }
                    },
                    {
                        key: "getCoordinates",
                        value: function() {
                            return this._segList.getCoordinates();
                        }
                    },
                    {
                        key: "addMitreJoin",
                        value: function(t, e, n, r) {
                            var i = _t.intersection(e.p0, e.p1, n.p0, n.p1);
                            if (null !== i && (r <= 0 ? 1 : i.distance(t) / Math.abs(r)) <= this._bufParams.getMitreLimit()) return this._segList.addPt(i), null;
                            this.addLimitedMitreJoin(e, n, r, this._bufParams.getMitreLimit());
                        }
                    },
                    {
                        key: "addOutsideTurn",
                        value: function(t, n) {
                            if (this._offset0.p1.distance(this._offset1.p0) < this._distance * e.OFFSET_SEGMENT_SEPARATION_FACTOR) return this._segList.addPt(this._offset0.p1), null;
                            this._bufParams.getJoinStyle() === y.JOIN_MITRE ? this.addMitreJoin(this._s1, this._offset0, this._offset1, this._distance) : this._bufParams.getJoinStyle() === y.JOIN_BEVEL ? this.addBevelJoin(this._offset0, this._offset1) : (n && this._segList.addPt(this._offset0.p1), this.addCornerFillet(this._s1, this._offset0.p1, this._offset1.p0, t, this._distance), this._segList.addPt(this._offset1.p0));
                        }
                    },
                    {
                        key: "createSquare",
                        value: function(t) {
                            this._segList.addPt(new j(t.x + this._distance, t.y + this._distance)), this._segList.addPt(new j(t.x + this._distance, t.y - this._distance)), this._segList.addPt(new j(t.x - this._distance, t.y - this._distance)), this._segList.addPt(new j(t.x - this._distance, t.y + this._distance)), this._segList.closeRing();
                        }
                    },
                    {
                        key: "addSegments",
                        value: function(t, e) {
                            this._segList.addPts(t, e);
                        }
                    },
                    {
                        key: "addFirstSegment",
                        value: function() {
                            this._segList.addPt(this._offset1.p0);
                        }
                    },
                    {
                        key: "addCornerFillet",
                        value: function(t, e, n, r, i) {
                            var o = e.x - t.x, s = e.y - t.y, a = Math.atan2(s, o), u = n.x - t.x, l = n.y - t.y, h = Math.atan2(l, u);
                            r === ft.CLOCKWISE ? a <= h && (a += 2 * Math.PI) : a >= h && (a -= 2 * Math.PI), this._segList.addPt(e), this.addDirectedFillet(t, a, h, r, i), this._segList.addPt(n);
                        }
                    },
                    {
                        key: "addLastSegment",
                        value: function() {
                            this._segList.addPt(this._offset1.p1);
                        }
                    },
                    {
                        key: "initSideSegments",
                        value: function(t, e, n) {
                            this._s1 = t, this._s2 = e, this._side = n, this._seg1.setCoordinates(t, e), this.computeOffsetSegment(this._seg1, n, this._distance, this._offset1);
                        }
                    },
                    {
                        key: "addLimitedMitreJoin",
                        value: function(t, e, n, r) {
                            var i = this._seg0.p1, o = On.angle(i, this._seg0.p0), s = On.angleBetweenOriented(this._seg0.p0, i, this._seg1.p1) / 2, a = On.normalize(o + s), u = On.normalize(a + Math.PI), l = r * n, h = n - l * Math.abs(Math.sin(s)), c = i.x + l * Math.cos(u), f = i.y + l * Math.sin(u), v = new j(c, f), g = new wn(i, v), d = g.pointAlongOffset(1, h), p = g.pointAlongOffset(1, -h);
                            this._side === tt.LEFT ? (this._segList.addPt(d), this._segList.addPt(p)) : (this._segList.addPt(p), this._segList.addPt(d));
                        }
                    },
                    {
                        key: "addDirectedFillet",
                        value: function(t, e, n, r, i) {
                            var o = r === ft.CLOCKWISE ? -1 : 1, s = Math.abs(e - n), a = Math.trunc(s / this._filletAngleQuantum + .5);
                            if (a < 1) return null;
                            for(var u = s / a, l = new j, h = 0; h < a; h++){
                                var c = e + o * h * u;
                                l.x = t.x + i * Math.cos(c), l.y = t.y + i * Math.sin(c), this._segList.addPt(l);
                            }
                        }
                    },
                    {
                        key: "computeOffsetSegment",
                        value: function(t, e, n, r) {
                            var i = e === tt.LEFT ? 1 : -1, o = t.p1.x - t.p0.x, s = t.p1.y - t.p0.y, a = Math.sqrt(o * o + s * s), u = i * n * o / a, l = i * n * s / a;
                            r.p0.x = t.p0.x - l, r.p0.y = t.p0.y + u, r.p1.x = t.p1.x - l, r.p1.y = t.p1.y + u;
                        }
                    },
                    {
                        key: "addInsideTurn",
                        value: function(t, n) {
                            if (this._li.computeIntersection(this._offset0.p0, this._offset0.p1, this._offset1.p0, this._offset1.p1), this._li.hasIntersection()) this._segList.addPt(this._li.getIntersection(0));
                            else if (this._hasNarrowConcaveAngle = !0, this._offset0.p1.distance(this._offset1.p0) < this._distance * e.INSIDE_TURN_VERTEX_SNAP_DISTANCE_FACTOR) this._segList.addPt(this._offset0.p1);
                            else {
                                if (this._segList.addPt(this._offset0.p1), this._closingSegLengthFactor > 0) {
                                    var r = new j((this._closingSegLengthFactor * this._offset0.p1.x + this._s1.x) / (this._closingSegLengthFactor + 1), (this._closingSegLengthFactor * this._offset0.p1.y + this._s1.y) / (this._closingSegLengthFactor + 1));
                                    this._segList.addPt(r);
                                    var i = new j((this._closingSegLengthFactor * this._offset1.p0.x + this._s1.x) / (this._closingSegLengthFactor + 1), (this._closingSegLengthFactor * this._offset1.p0.y + this._s1.y) / (this._closingSegLengthFactor + 1));
                                    this._segList.addPt(i);
                                } else this._segList.addPt(this._s1);
                                this._segList.addPt(this._offset1.p0);
                            }
                        }
                    },
                    {
                        key: "createCircle",
                        value: function(t) {
                            var e = new j(t.x + this._distance, t.y);
                            this._segList.addPt(e), this.addDirectedFillet(t, 0, 2 * Math.PI, -1, this._distance), this._segList.closeRing();
                        }
                    },
                    {
                        key: "addBevelJoin",
                        value: function(t, e) {
                            this._segList.addPt(t.p1), this._segList.addPt(e.p0);
                        }
                    },
                    {
                        key: "init",
                        value: function(t) {
                            this._distance = t, this._maxCurveSegmentError = t * (1 - Math.cos(this._filletAngleQuantum / 2)), this._segList = new Tn, this._segList.setPrecisionModel(this._precisionModel), this._segList.setMinimumVertexDistance(t * e.CURVE_VERTEX_SNAP_DISTANCE_FACTOR);
                        }
                    },
                    {
                        key: "addCollinear",
                        value: function(t) {
                            this._li.computeIntersection(this._s0, this._s1, this._s1, this._s2), this._li.getIntersectionNum() >= 2 && (this._bufParams.getJoinStyle() === y.JOIN_BEVEL || this._bufParams.getJoinStyle() === y.JOIN_MITRE ? (t && this._segList.addPt(this._offset0.p1), this._segList.addPt(this._offset1.p0)) : this.addCornerFillet(this._s1, this._offset0.p1, this._offset1.p0, ft.CLOCKWISE, this._distance));
                        }
                    },
                    {
                        key: "closeRing",
                        value: function() {
                            this._segList.closeRing();
                        }
                    },
                    {
                        key: "hasNarrowConcaveAngle",
                        value: function() {
                            return this._hasNarrowConcaveAngle;
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._maxCurveSegmentError = 0, this._filletAngleQuantum = null, this._closingSegLengthFactor = 1, this._segList = null, this._distance = 0, this._precisionModel = null, this._bufParams = null, this._li = null, this._s0 = null, this._s1 = null, this._s2 = null, this._seg0 = new wn, this._seg1 = new wn, this._offset0 = new wn, this._offset1 = new wn, this._side = 0, this._hasNarrowConcaveAngle = !1;
                            var t = arguments[0], n = arguments[1], r = arguments[2];
                            this._precisionModel = t, this._bufParams = n, this._li = new Ce, this._filletAngleQuantum = Math.PI / 2 / n.getQuadrantSegments(), n.getQuadrantSegments() >= 8 && n.getJoinStyle() === y.JOIN_ROUND && (this._closingSegLengthFactor = e.MAX_CLOSING_SEG_LEN_FACTOR), this.init(r);
                        }
                    }
                ]), e;
            }();
            Rn.OFFSET_SEGMENT_SEPARATION_FACTOR = .001, Rn.INSIDE_TURN_VERTEX_SNAP_DISTANCE_FACTOR = .001, Rn.CURVE_VERTEX_SNAP_DISTANCE_FACTOR = 1e-6, Rn.MAX_CLOSING_SEG_LEN_FACTOR = 80;
            var An = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "getOffsetCurve",
                        value: function(t, e) {
                            if (this._distance = e, 0 === e) return null;
                            var n = e < 0, r = Math.abs(e), i = this.getSegGen(r);
                            t.length <= 1 ? this.computePointCurve(t[0], i) : this.computeOffsetCurve(t, n, i);
                            var o = i.getCoordinates();
                            return n && Wt.reverse(o), o;
                        }
                    },
                    {
                        key: "computeSingleSidedBufferCurve",
                        value: function(t, e, n) {
                            var r = this.simplifyTolerance(this._distance);
                            if (e) {
                                n.addSegments(t, !0);
                                var i = Cn.simplify(t, -r), o = i.length - 1;
                                n.initSideSegments(i[o], i[o - 1], tt.LEFT), n.addFirstSegment();
                                for(var s = o - 2; s >= 0; s--)n.addNextSegment(i[s], !0);
                            } else {
                                n.addSegments(t, !1);
                                var a = Cn.simplify(t, r), u = a.length - 1;
                                n.initSideSegments(a[0], a[1], tt.LEFT), n.addFirstSegment();
                                for(var l = 2; l <= u; l++)n.addNextSegment(a[l], !0);
                            }
                            n.addLastSegment(), n.closeRing();
                        }
                    },
                    {
                        key: "computeRingBufferCurve",
                        value: function(t, e, n) {
                            var r = this.simplifyTolerance(this._distance);
                            e === tt.RIGHT && (r = -r);
                            var i = Cn.simplify(t, r), o = i.length - 1;
                            n.initSideSegments(i[o - 1], i[0], e);
                            for(var s = 1; s <= o; s++){
                                var a = 1 !== s;
                                n.addNextSegment(i[s], a);
                            }
                            n.closeRing();
                        }
                    },
                    {
                        key: "computeLineBufferCurve",
                        value: function(t, e) {
                            var n = this.simplifyTolerance(this._distance), r = Cn.simplify(t, n), i = r.length - 1;
                            e.initSideSegments(r[0], r[1], tt.LEFT);
                            for(var o = 2; o <= i; o++)e.addNextSegment(r[o], !0);
                            e.addLastSegment(), e.addLineEndCap(r[i - 1], r[i]);
                            var s = Cn.simplify(t, -n), a = s.length - 1;
                            e.initSideSegments(s[a], s[a - 1], tt.LEFT);
                            for(var u = a - 2; u >= 0; u--)e.addNextSegment(s[u], !0);
                            e.addLastSegment(), e.addLineEndCap(s[1], s[0]), e.closeRing();
                        }
                    },
                    {
                        key: "computePointCurve",
                        value: function(t, e) {
                            switch(this._bufParams.getEndCapStyle()){
                                case y.CAP_ROUND:
                                    e.createCircle(t);
                                    break;
                                case y.CAP_SQUARE:
                                    e.createSquare(t);
                            }
                        }
                    },
                    {
                        key: "getLineCurve",
                        value: function(t, e) {
                            if (this._distance = e, this.isLineOffsetEmpty(e)) return null;
                            var n = Math.abs(e), r = this.getSegGen(n);
                            if (t.length <= 1) this.computePointCurve(t[0], r);
                            else if (this._bufParams.isSingleSided()) {
                                var i = e < 0;
                                this.computeSingleSidedBufferCurve(t, i, r);
                            } else this.computeLineBufferCurve(t, r);
                            return r.getCoordinates();
                        }
                    },
                    {
                        key: "getBufferParameters",
                        value: function() {
                            return this._bufParams;
                        }
                    },
                    {
                        key: "simplifyTolerance",
                        value: function(t) {
                            return t * this._bufParams.getSimplifyFactor();
                        }
                    },
                    {
                        key: "getRingCurve",
                        value: function(t, n, r) {
                            if (this._distance = r, t.length <= 2) return this.getLineCurve(t, r);
                            if (0 === r) return e.copyCoordinates(t);
                            var i = this.getSegGen(r);
                            return this.computeRingBufferCurve(t, n, i), i.getCoordinates();
                        }
                    },
                    {
                        key: "computeOffsetCurve",
                        value: function(t, e, n) {
                            var r = this.simplifyTolerance(this._distance);
                            if (e) {
                                var i = Cn.simplify(t, -r), o = i.length - 1;
                                n.initSideSegments(i[o], i[o - 1], tt.LEFT), n.addFirstSegment();
                                for(var s = o - 2; s >= 0; s--)n.addNextSegment(i[s], !0);
                            } else {
                                var a = Cn.simplify(t, r), u = a.length - 1;
                                n.initSideSegments(a[0], a[1], tt.LEFT), n.addFirstSegment();
                                for(var l = 2; l <= u; l++)n.addNextSegment(a[l], !0);
                            }
                            n.addLastSegment();
                        }
                    },
                    {
                        key: "isLineOffsetEmpty",
                        value: function(t) {
                            return 0 === t || t < 0 && !this._bufParams.isSingleSided();
                        }
                    },
                    {
                        key: "getSegGen",
                        value: function(t) {
                            return new Rn(this._precisionModel, this._bufParams, t);
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._distance = 0, this._precisionModel = null, this._bufParams = null;
                            var t = arguments[0], e = arguments[1];
                            this._precisionModel = t, this._bufParams = e;
                        }
                    },
                    {
                        key: "copyCoordinates",
                        value: function(t) {
                            for(var e = new Array(t.length).fill(null), n = 0; n < e.length; n++)e[n] = new j(t[n]);
                            return e;
                        }
                    }
                ]), e;
            }(), Dn = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "findStabbedSegments",
                        value: function() {
                            if (1 === arguments.length) {
                                for(var t = arguments[0], e = new pt, n = this._subgraphs.iterator(); n.hasNext();){
                                    var r = n.next(), i = r.getEnvelope();
                                    t.y < i.getMinY() || t.y > i.getMaxY() || this.findStabbedSegments(t, r.getDirectedEdges(), e);
                                }
                                return e;
                            }
                            if (3 === arguments.length) {
                                if (ot(arguments[2], rt) && arguments[0] instanceof j && arguments[1] instanceof Ke) {
                                    for(var o = arguments[0], s = arguments[1], a = arguments[2], u = s.getEdge().getCoordinates(), l = 0; l < u.length - 1; l++)if (this._seg.p0 = u[l], this._seg.p1 = u[l + 1], this._seg.p0.y > this._seg.p1.y && this._seg.reverse(), !(Math.max(this._seg.p0.x, this._seg.p1.x) < o.x || this._seg.isHorizontal() || o.y < this._seg.p0.y || o.y > this._seg.p1.y || ft.index(this._seg.p0, this._seg.p1, o) === ft.RIGHT)) {
                                        var h = s.getDepth(tt.LEFT);
                                        this._seg.p0.equals(u[l]) || (h = s.getDepth(tt.RIGHT));
                                        var c = new Fn(this._seg, h);
                                        a.add(c);
                                    }
                                } else if (ot(arguments[2], rt) && arguments[0] instanceof j && ot(arguments[1], rt)) for(var f = arguments[0], v = arguments[2], g = arguments[1].iterator(); g.hasNext();){
                                    var d = g.next();
                                    d.isForward() && this.findStabbedSegments(f, d, v);
                                }
                            }
                        }
                    },
                    {
                        key: "getDepth",
                        value: function(t) {
                            var e = this.findStabbedSegments(t);
                            return 0 === e.size() ? 0 : an.min(e)._leftDepth;
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._subgraphs = null, this._seg = new wn;
                            var t = arguments[0];
                            this._subgraphs = t;
                        }
                    }
                ]), e;
            }(), Fn = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "compareTo",
                        value: function(t) {
                            var e = t;
                            if (this._upwardSeg.minX() >= e._upwardSeg.maxX()) return 1;
                            if (this._upwardSeg.maxX() <= e._upwardSeg.minX()) return -1;
                            var n = this._upwardSeg.orientationIndex(e._upwardSeg);
                            return 0 !== n || 0 != (n = -1 * e._upwardSeg.orientationIndex(this._upwardSeg)) ? n : this._upwardSeg.compareTo(e._upwardSeg);
                        }
                    },
                    {
                        key: "compareX",
                        value: function(t, e) {
                            var n = t.p0.compareTo(e.p0);
                            return 0 !== n ? n : t.p1.compareTo(e.p1);
                        }
                    },
                    {
                        key: "toString",
                        value: function() {
                            return this._upwardSeg.toString();
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                k
                            ];
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._upwardSeg = null, this._leftDepth = null;
                            var t = arguments[0], e = arguments[1];
                            this._upwardSeg = new wn(t), this._leftDepth = e;
                        }
                    }
                ]), e;
            }();
            Dn.DepthSegment = Fn;
            var qn = function(e) {
                r(o, e);
                var i = c(o);
                function o() {
                    var e;
                    return t(this, o), e = i.call(this), o.constructor_.apply(l(e), arguments), e;
                }
                return n(o, null, [
                    {
                        key: "constructor_",
                        value: function() {
                            m.constructor_.call(this, "Projective point not representable on the Cartesian plane.");
                        }
                    }
                ]), o;
            }(m), Gn = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "getY",
                        value: function() {
                            var t = this.y / this.w;
                            if (A.isNaN(t) || A.isInfinite(t)) throw new qn;
                            return t;
                        }
                    },
                    {
                        key: "getX",
                        value: function() {
                            var t = this.x / this.w;
                            if (A.isNaN(t) || A.isInfinite(t)) throw new qn;
                            return t;
                        }
                    },
                    {
                        key: "getCoordinate",
                        value: function() {
                            var t = new j;
                            return t.x = this.getX(), t.y = this.getY(), t;
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            if (this.x = null, this.y = null, this.w = null, 0 === arguments.length) this.x = 0, this.y = 0, this.w = 1;
                            else if (1 === arguments.length) {
                                var t = arguments[0];
                                this.x = t.x, this.y = t.y, this.w = 1;
                            } else if (2 === arguments.length) {
                                if ("number" == typeof arguments[0] && "number" == typeof arguments[1]) {
                                    var n = arguments[0], r = arguments[1];
                                    this.x = n, this.y = r, this.w = 1;
                                } else if (arguments[0] instanceof e && arguments[1] instanceof e) {
                                    var i = arguments[0], o = arguments[1];
                                    this.x = i.y * o.w - o.y * i.w, this.y = o.x * i.w - i.x * o.w, this.w = i.x * o.y - o.x * i.y;
                                } else if (arguments[0] instanceof j && arguments[1] instanceof j) {
                                    var s = arguments[0], a = arguments[1];
                                    this.x = s.y - a.y, this.y = a.x - s.x, this.w = s.x * a.y - a.x * s.y;
                                }
                            } else if (3 === arguments.length) {
                                var u = arguments[0], l = arguments[1], h = arguments[2];
                                this.x = u, this.y = l, this.w = h;
                            } else if (4 === arguments.length) {
                                var c = arguments[0], f = arguments[1], v = arguments[2], g = arguments[3], d = c.y - f.y, p = f.x - c.x, y = c.x * f.y - f.x * c.y, m = v.y - g.y, _ = g.x - v.x, x = v.x * g.y - g.x * v.y;
                                this.x = p * x - _ * y, this.y = m * y - d * x, this.w = d * _ - m * p;
                            }
                        }
                    }
                ]), e;
            }(), Yn = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "area",
                        value: function() {
                            return e.area(this.p0, this.p1, this.p2);
                        }
                    },
                    {
                        key: "signedArea",
                        value: function() {
                            return e.signedArea(this.p0, this.p1, this.p2);
                        }
                    },
                    {
                        key: "interpolateZ",
                        value: function(t) {
                            if (null === t) throw new _("Supplied point is null.");
                            return e.interpolateZ(t, this.p0, this.p1, this.p2);
                        }
                    },
                    {
                        key: "longestSideLength",
                        value: function() {
                            return e.longestSideLength(this.p0, this.p1, this.p2);
                        }
                    },
                    {
                        key: "isAcute",
                        value: function() {
                            return e.isAcute(this.p0, this.p1, this.p2);
                        }
                    },
                    {
                        key: "circumcentre",
                        value: function() {
                            return e.circumcentre(this.p0, this.p1, this.p2);
                        }
                    },
                    {
                        key: "area3D",
                        value: function() {
                            return e.area3D(this.p0, this.p1, this.p2);
                        }
                    },
                    {
                        key: "centroid",
                        value: function() {
                            return e.centroid(this.p0, this.p1, this.p2);
                        }
                    },
                    {
                        key: "inCentre",
                        value: function() {
                            return e.inCentre(this.p0, this.p1, this.p2);
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this.p0 = null, this.p1 = null, this.p2 = null;
                            var t = arguments[0], e = arguments[1], n = arguments[2];
                            this.p0 = t, this.p1 = e, this.p2 = n;
                        }
                    },
                    {
                        key: "area",
                        value: function(t, e, n) {
                            return Math.abs(((n.x - t.x) * (e.y - t.y) - (e.x - t.x) * (n.y - t.y)) / 2);
                        }
                    },
                    {
                        key: "signedArea",
                        value: function(t, e, n) {
                            return ((n.x - t.x) * (e.y - t.y) - (e.x - t.x) * (n.y - t.y)) / 2;
                        }
                    },
                    {
                        key: "det",
                        value: function(t, e, n, r) {
                            return t * r - e * n;
                        }
                    },
                    {
                        key: "interpolateZ",
                        value: function(t, e, n, r) {
                            var i = e.x, o = e.y, s = n.x - i, a = r.x - i, u = n.y - o, l = r.y - o, h = s * l - a * u, c = t.x - i, f = t.y - o, v = (l * c - a * f) / h, g = (-u * c + s * f) / h;
                            return e.getZ() + v * (n.getZ() - e.getZ()) + g * (r.getZ() - e.getZ());
                        }
                    },
                    {
                        key: "longestSideLength",
                        value: function(t, e, n) {
                            var r = t.distance(e), i = e.distance(n), o = n.distance(t), s = r;
                            return i > s && (s = i), o > s && (s = o), s;
                        }
                    },
                    {
                        key: "circumcentreDD",
                        value: function(t, e, n) {
                            var r = lt.valueOf(t.x).subtract(n.x), i = lt.valueOf(t.y).subtract(n.y), o = lt.valueOf(e.x).subtract(n.x), s = lt.valueOf(e.y).subtract(n.y), a = lt.determinant(r, i, o, s).multiply(2), u = r.sqr().add(i.sqr()), l = o.sqr().add(s.sqr()), h = lt.determinant(i, u, s, l), c = lt.determinant(r, u, o, l), f = lt.valueOf(n.x).subtract(h.divide(a)).doubleValue(), v = lt.valueOf(n.y).add(c.divide(a)).doubleValue();
                            return new j(f, v);
                        }
                    },
                    {
                        key: "isAcute",
                        value: function(t, e, n) {
                            return !!On.isAcute(t, e, n) && !!On.isAcute(e, n, t) && !!On.isAcute(n, t, e);
                        }
                    },
                    {
                        key: "circumcentre",
                        value: function(t, n, r) {
                            var i = r.x, o = r.y, s = t.x - i, a = t.y - o, u = n.x - i, l = n.y - o, h = 2 * e.det(s, a, u, l), c = e.det(a, s * s + a * a, l, u * u + l * l), f = e.det(s, s * s + a * a, u, u * u + l * l);
                            return new j(i - c / h, o + f / h);
                        }
                    },
                    {
                        key: "perpendicularBisector",
                        value: function(t, e) {
                            var n = e.x - t.x, r = e.y - t.y, i = new Gn(t.x + n / 2, t.y + r / 2, 1), o = new Gn(t.x - r + n / 2, t.y + n + r / 2, 1);
                            return new Gn(i, o);
                        }
                    },
                    {
                        key: "angleBisector",
                        value: function(t, e, n) {
                            var r = e.distance(t), i = r / (r + e.distance(n)), o = n.x - t.x, s = n.y - t.y;
                            return new j(t.x + i * o, t.y + i * s);
                        }
                    },
                    {
                        key: "area3D",
                        value: function(t, e, n) {
                            var r = e.x - t.x, i = e.y - t.y, o = e.getZ() - t.getZ(), s = n.x - t.x, a = n.y - t.y, u = n.getZ() - t.getZ(), l = i * u - o * a, h = o * s - r * u, c = r * a - i * s, f = l * l + h * h + c * c;
                            return Math.sqrt(f) / 2;
                        }
                    },
                    {
                        key: "centroid",
                        value: function(t, e, n) {
                            var r = (t.x + e.x + n.x) / 3, i = (t.y + e.y + n.y) / 3;
                            return new j(r, i);
                        }
                    },
                    {
                        key: "inCentre",
                        value: function(t, e, n) {
                            var r = e.distance(n), i = t.distance(n), o = t.distance(e), s = r + i + o, a = (r * t.x + i * e.x + o * n.x) / s, u = (r * t.y + i * e.y + o * n.y) / s;
                            return new j(a, u);
                        }
                    }
                ]), e;
            }(), Bn = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "addRingSide",
                        value: function(t, e, n, r, i) {
                            if (0 === e && t.length < jt.MINIMUM_VALID_SIZE) return null;
                            var o = r, s = i;
                            t.length >= jt.MINIMUM_VALID_SIZE && ft.isCCW(t) && (o = i, s = r, n = tt.opposite(n));
                            var a = this._curveBuilder.getRingCurve(t, n, e);
                            this.addCurve(a, o, s);
                        }
                    },
                    {
                        key: "addRingBothSides",
                        value: function(t, e) {
                            this.addRingSide(t, e, tt.LEFT, Z.EXTERIOR, Z.INTERIOR), this.addRingSide(t, e, tt.RIGHT, Z.INTERIOR, Z.EXTERIOR);
                        }
                    },
                    {
                        key: "addPoint",
                        value: function(t) {
                            if (this._distance <= 0) return null;
                            var e = t.getCoordinates(), n = this._curveBuilder.getLineCurve(e, this._distance);
                            this.addCurve(n, Z.EXTERIOR, Z.INTERIOR);
                        }
                    },
                    {
                        key: "addPolygon",
                        value: function(t) {
                            var e = this._distance, n = tt.LEFT;
                            this._distance < 0 && (e = -this._distance, n = tt.RIGHT);
                            var r = t.getExteriorRing(), i = Wt.removeRepeatedPoints(r.getCoordinates());
                            if (this._distance < 0 && this.isErodedCompletely(r, this._distance)) return null;
                            if (this._distance <= 0 && i.length < 3) return null;
                            this.addRingSide(i, e, n, Z.EXTERIOR, Z.INTERIOR);
                            for(var o = 0; o < t.getNumInteriorRing(); o++){
                                var s = t.getInteriorRingN(o), a = Wt.removeRepeatedPoints(s.getCoordinates());
                                this._distance > 0 && this.isErodedCompletely(s, -this._distance) || this.addRingSide(a, e, tt.opposite(n), Z.INTERIOR, Z.EXTERIOR);
                            }
                        }
                    },
                    {
                        key: "isTriangleErodedCompletely",
                        value: function(t, e) {
                            var n = new Yn(t[0], t[1], t[2]), r = n.inCentre();
                            return kt.pointToSegment(r, n.p0, n.p1) < Math.abs(e);
                        }
                    },
                    {
                        key: "addLineString",
                        value: function(t) {
                            if (this._curveBuilder.isLineOffsetEmpty(this._distance)) return null;
                            var e = Wt.removeRepeatedPoints(t.getCoordinates());
                            if (Wt.isRing(e) && !this._curveBuilder.getBufferParameters().isSingleSided()) this.addRingBothSides(e, this._distance);
                            else {
                                var n = this._curveBuilder.getLineCurve(e, this._distance);
                                this.addCurve(n, Z.EXTERIOR, Z.INTERIOR);
                            }
                        }
                    },
                    {
                        key: "addCurve",
                        value: function(t, e, n) {
                            if (null === t || t.length < 2) return null;
                            var r = new kn(t, new Ae(0, Z.BOUNDARY, e, n));
                            this._curveList.add(r);
                        }
                    },
                    {
                        key: "getCurves",
                        value: function() {
                            return this.add(this._inputGeom), this._curveList;
                        }
                    },
                    {
                        key: "add",
                        value: function(t) {
                            if (t.isEmpty()) return null;
                            if (t instanceof Ft) this.addPolygon(t);
                            else if (t instanceof Ct) this.addLineString(t);
                            else if (t instanceof Ot) this.addPoint(t);
                            else if (t instanceof zt) this.addCollection(t);
                            else if (t instanceof se) this.addCollection(t);
                            else if (t instanceof ee) this.addCollection(t);
                            else {
                                if (!(t instanceof Bt)) throw new J(t.getGeometryType());
                                this.addCollection(t);
                            }
                        }
                    },
                    {
                        key: "isErodedCompletely",
                        value: function(t, e) {
                            var n = t.getCoordinates();
                            if (n.length < 4) return e < 0;
                            if (4 === n.length) return this.isTriangleErodedCompletely(n, e);
                            var r = t.getEnvelopeInternal(), i = Math.min(r.getHeight(), r.getWidth());
                            return e < 0 && 2 * Math.abs(e) > i;
                        }
                    },
                    {
                        key: "addCollection",
                        value: function(t) {
                            for(var e = 0; e < t.getNumGeometries(); e++){
                                var n = t.getGeometryN(e);
                                this.add(n);
                            }
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._inputGeom = null, this._distance = null, this._curveBuilder = null, this._curveList = new pt;
                            var t = arguments[0], e = arguments[1], n = arguments[2];
                            this._inputGeom = t, this._distance = e, this._curveBuilder = n;
                        }
                    }
                ]), e;
            }(), zn = function() {
                function e() {
                    t(this, e);
                }
                return n(e, [
                    {
                        key: "locate",
                        value: function(t) {}
                    }
                ]), e;
            }(), jn = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "next",
                        value: function() {
                            if (this._atStart) return this._atStart = !1, e.isAtomic(this._parent) && this._index++, this._parent;
                            if (null !== this._subcollectionIterator) {
                                if (this._subcollectionIterator.hasNext()) return this._subcollectionIterator.next();
                                this._subcollectionIterator = null;
                            }
                            if (this._index >= this._max) throw new W;
                            var t = this._parent.getGeometryN(this._index++);
                            return t instanceof Bt ? (this._subcollectionIterator = new e(t), this._subcollectionIterator.next()) : t;
                        }
                    },
                    {
                        key: "remove",
                        value: function() {
                            throw new J(this.getClass().getName());
                        }
                    },
                    {
                        key: "hasNext",
                        value: function() {
                            if (this._atStart) return !0;
                            if (null !== this._subcollectionIterator) {
                                if (this._subcollectionIterator.hasNext()) return !0;
                                this._subcollectionIterator = null;
                            }
                            return !(this._index >= this._max);
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                yn
                            ];
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._parent = null, this._atStart = null, this._max = null, this._index = null, this._subcollectionIterator = null;
                            var t = arguments[0];
                            this._parent = t, this._atStart = !0, this._index = 0, this._max = t.getNumGeometries();
                        }
                    },
                    {
                        key: "isAtomic",
                        value: function(t) {
                            return !(t instanceof Bt);
                        }
                    }
                ]), e;
            }(), Xn = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "locate",
                        value: function(t) {
                            return e.locate(t, this._geom);
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                zn
                            ];
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._geom = null;
                            var t = arguments[0];
                            this._geom = t;
                        }
                    },
                    {
                        key: "locatePointInPolygon",
                        value: function(t, n) {
                            if (n.isEmpty()) return Z.EXTERIOR;
                            var r = n.getExteriorRing(), i = e.locatePointInRing(t, r);
                            if (i !== Z.INTERIOR) return i;
                            for(var o = 0; o < n.getNumInteriorRing(); o++){
                                var s = n.getInteriorRingN(o), a = e.locatePointInRing(t, s);
                                if (a === Z.BOUNDARY) return Z.BOUNDARY;
                                if (a === Z.INTERIOR) return Z.EXTERIOR;
                            }
                            return Z.INTERIOR;
                        }
                    },
                    {
                        key: "locatePointInRing",
                        value: function(t, e) {
                            return e.getEnvelopeInternal().intersects(t) ? Oe.locateInRing(t, e.getCoordinates()) : Z.EXTERIOR;
                        }
                    },
                    {
                        key: "containsPointInPolygon",
                        value: function(t, n) {
                            return Z.EXTERIOR !== e.locatePointInPolygon(t, n);
                        }
                    },
                    {
                        key: "locateInGeometry",
                        value: function(t, n) {
                            if (n instanceof Ft) return e.locatePointInPolygon(t, n);
                            if (n instanceof Bt) for(var r = new jn(n); r.hasNext();){
                                var i = r.next();
                                if (i !== n) {
                                    var o = e.locateInGeometry(t, i);
                                    if (o !== Z.EXTERIOR) return o;
                                }
                            }
                            return Z.EXTERIOR;
                        }
                    },
                    {
                        key: "isContained",
                        value: function(t, n) {
                            return Z.EXTERIOR !== e.locate(t, n);
                        }
                    },
                    {
                        key: "locate",
                        value: function(t, n) {
                            return n.isEmpty() ? Z.EXTERIOR : n.getEnvelopeInternal().intersects(t) ? e.locateInGeometry(t, n) : Z.EXTERIOR;
                        }
                    }
                ]), e;
            }(), Un = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "getNextCW",
                        value: function(t) {
                            this.getEdges();
                            var e = this._edgeList.indexOf(t), n = e - 1;
                            return 0 === e && (n = this._edgeList.size() - 1), this._edgeList.get(n);
                        }
                    },
                    {
                        key: "propagateSideLabels",
                        value: function(t) {
                            for(var e = Z.NONE, n = this.iterator(); n.hasNext();){
                                var r = n.next().getLabel();
                                r.isArea(t) && r.getLocation(t, tt.LEFT) !== Z.NONE && (e = r.getLocation(t, tt.LEFT));
                            }
                            if (e === Z.NONE) return null;
                            for(var i = e, o = this.iterator(); o.hasNext();){
                                var s = o.next(), a = s.getLabel();
                                if (a.getLocation(t, tt.ON) === Z.NONE && a.setLocation(t, tt.ON, i), a.isArea(t)) {
                                    var u = a.getLocation(t, tt.LEFT), l = a.getLocation(t, tt.RIGHT);
                                    if (l !== Z.NONE) {
                                        if (l !== i) throw new gt("side location conflict", s.getCoordinate());
                                        u === Z.NONE && G.shouldNeverReachHere("found single null side (at " + s.getCoordinate() + ")"), i = u;
                                    } else G.isTrue(a.getLocation(t, tt.LEFT) === Z.NONE, "found single null side"), a.setLocation(t, tt.RIGHT, i), a.setLocation(t, tt.LEFT, i);
                                }
                            }
                        }
                    },
                    {
                        key: "getCoordinate",
                        value: function() {
                            var t = this.iterator();
                            return t.hasNext() ? t.next().getCoordinate() : null;
                        }
                    },
                    {
                        key: "print",
                        value: function(t) {
                            xt.out.println("EdgeEndStar:   " + this.getCoordinate());
                            for(var e = this.iterator(); e.hasNext();)e.next().print(t);
                        }
                    },
                    {
                        key: "isAreaLabelsConsistent",
                        value: function(t) {
                            return this.computeEdgeEndLabels(t.getBoundaryNodeRule()), this.checkAreaLabelsConsistent(0);
                        }
                    },
                    {
                        key: "checkAreaLabelsConsistent",
                        value: function(t) {
                            var e = this.getEdges();
                            if (e.size() <= 0) return !0;
                            var n = e.size() - 1, r = e.get(n).getLabel().getLocation(t, tt.LEFT);
                            G.isTrue(r !== Z.NONE, "Found unlabelled area edge");
                            for(var i = r, o = this.iterator(); o.hasNext();){
                                var s = o.next().getLabel();
                                G.isTrue(s.isArea(t), "Found non-area edge");
                                var a = s.getLocation(t, tt.LEFT), u = s.getLocation(t, tt.RIGHT);
                                if (a === u) return !1;
                                if (u !== i) return !1;
                                i = a;
                            }
                            return !0;
                        }
                    },
                    {
                        key: "findIndex",
                        value: function(t) {
                            this.iterator();
                            for(var e = 0; e < this._edgeList.size(); e++)if (this._edgeList.get(e) === t) return e;
                            return -1;
                        }
                    },
                    {
                        key: "iterator",
                        value: function() {
                            return this.getEdges().iterator();
                        }
                    },
                    {
                        key: "getEdges",
                        value: function() {
                            return null === this._edgeList && (this._edgeList = new pt(this._edgeMap.values())), this._edgeList;
                        }
                    },
                    {
                        key: "getLocation",
                        value: function(t, e, n) {
                            return this._ptInAreaLocation[t] === Z.NONE && (this._ptInAreaLocation[t] = Xn.locate(e, n[t].getGeometry())), this._ptInAreaLocation[t];
                        }
                    },
                    {
                        key: "toString",
                        value: function() {
                            var t = new st;
                            t.append("EdgeEndStar:   " + this.getCoordinate()), t.append("\n");
                            for(var e = this.iterator(); e.hasNext();){
                                var n = e.next();
                                t.append(n), t.append("\n");
                            }
                            return t.toString();
                        }
                    },
                    {
                        key: "computeEdgeEndLabels",
                        value: function(t) {
                            for(var e = this.iterator(); e.hasNext();)e.next().computeLabel(t);
                        }
                    },
                    {
                        key: "computeLabelling",
                        value: function(t) {
                            this.computeEdgeEndLabels(t[0].getBoundaryNodeRule()), this.propagateSideLabels(0), this.propagateSideLabels(1);
                            for(var e = [
                                !1,
                                !1
                            ], n = this.iterator(); n.hasNext();)for(var r = n.next().getLabel(), i = 0; i < 2; i++)r.isLine(i) && r.getLocation(i) === Z.BOUNDARY && (e[i] = !0);
                            for(var o = this.iterator(); o.hasNext();)for(var s = o.next(), a = s.getLabel(), u = 0; u < 2; u++)if (a.isAnyNull(u)) {
                                var l = Z.NONE;
                                if (e[u]) l = Z.EXTERIOR;
                                else {
                                    var h = s.getCoordinate();
                                    l = this.getLocation(u, h, t);
                                }
                                a.setAllLocationsIfNull(u, l);
                            }
                        }
                    },
                    {
                        key: "getDegree",
                        value: function() {
                            return this._edgeMap.size();
                        }
                    },
                    {
                        key: "insertEdgeEnd",
                        value: function(t, e) {
                            this._edgeMap.put(t, e), this._edgeList = null;
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._edgeMap = new Ze, this._edgeList = null, this._ptInAreaLocation = [
                                Z.NONE,
                                Z.NONE
                            ];
                        }
                    }
                ]), e;
            }(), Vn = function(e) {
                r(s, e);
                var o = c(s);
                function s() {
                    var e;
                    return t(this, s), e = o.call(this), s.constructor_.apply(l(e), arguments), e;
                }
                return n(s, [
                    {
                        key: "linkResultDirectedEdges",
                        value: function() {
                            this.getResultAreaEdges();
                            for(var t = null, e = null, n = this._SCANNING_FOR_INCOMING, r = 0; r < this._resultAreaEdgeList.size(); r++){
                                var i = this._resultAreaEdgeList.get(r), o = i.getSym();
                                if (i.getLabel().isArea()) switch(null === t && i.isInResult() && (t = i), n){
                                    case this._SCANNING_FOR_INCOMING:
                                        if (!o.isInResult()) continue;
                                        e = o, n = this._LINKING_TO_OUTGOING;
                                        break;
                                    case this._LINKING_TO_OUTGOING:
                                        if (!i.isInResult()) continue;
                                        e.setNext(i), n = this._SCANNING_FOR_INCOMING;
                                }
                            }
                            if (n === this._LINKING_TO_OUTGOING) {
                                if (null === t) throw new gt("no outgoing dirEdge found", this.getCoordinate());
                                G.isTrue(t.isInResult(), "unable to link last incoming dirEdge"), e.setNext(t);
                            }
                        }
                    },
                    {
                        key: "insert",
                        value: function(t) {
                            var e = t;
                            this.insertEdgeEnd(e, e);
                        }
                    },
                    {
                        key: "getRightmostEdge",
                        value: function() {
                            var t = this.getEdges(), e = t.size();
                            if (e < 1) return null;
                            var n = t.get(0);
                            if (1 === e) return n;
                            var r = t.get(e - 1), i = n.getQuadrant(), o = r.getQuadrant();
                            return We.isNorthern(i) && We.isNorthern(o) ? n : We.isNorthern(i) || We.isNorthern(o) ? 0 !== n.getDy() ? n : 0 !== r.getDy() ? r : (G.shouldNeverReachHere("found two horizontal edges incident on node"), null) : r;
                        }
                    },
                    {
                        key: "print",
                        value: function(t) {
                            xt.out.println("DirectedEdgeStar: " + this.getCoordinate());
                            for(var e = this.iterator(); e.hasNext();){
                                var n = e.next();
                                t.print("out "), n.print(t), t.println(), t.print("in "), n.getSym().print(t), t.println();
                            }
                        }
                    },
                    {
                        key: "getResultAreaEdges",
                        value: function() {
                            if (null !== this._resultAreaEdgeList) return this._resultAreaEdgeList;
                            this._resultAreaEdgeList = new pt;
                            for(var t = this.iterator(); t.hasNext();){
                                var e = t.next();
                                (e.isInResult() || e.getSym().isInResult()) && this._resultAreaEdgeList.add(e);
                            }
                            return this._resultAreaEdgeList;
                        }
                    },
                    {
                        key: "updateLabelling",
                        value: function(t) {
                            for(var e = this.iterator(); e.hasNext();){
                                var n = e.next().getLabel();
                                n.setAllLocationsIfNull(0, t.getLocation(0)), n.setAllLocationsIfNull(1, t.getLocation(1));
                            }
                        }
                    },
                    {
                        key: "linkAllDirectedEdges",
                        value: function() {
                            this.getEdges();
                            for(var t = null, e = null, n = this._edgeList.size() - 1; n >= 0; n--){
                                var r = this._edgeList.get(n), i = r.getSym();
                                null === e && (e = i), null !== t && i.setNext(t), t = r;
                            }
                            e.setNext(t);
                        }
                    },
                    {
                        key: "computeDepths",
                        value: function() {
                            if (1 === arguments.length) {
                                var t = arguments[0], e = this.findIndex(t), n = t.getDepth(tt.LEFT), r = t.getDepth(tt.RIGHT), i = this.computeDepths(e + 1, this._edgeList.size(), n);
                                if (this.computeDepths(0, e, i) !== r) throw new gt("depth mismatch at " + t.getCoordinate());
                            } else if (3 === arguments.length) {
                                for(var o = arguments[1], s = arguments[2], a = arguments[0]; a < o; a++){
                                    var u = this._edgeList.get(a);
                                    u.setEdgeDepths(tt.RIGHT, s), s = u.getDepth(tt.LEFT);
                                }
                                return s;
                            }
                        }
                    },
                    {
                        key: "mergeSymLabels",
                        value: function() {
                            for(var t = this.iterator(); t.hasNext();){
                                var e = t.next();
                                e.getLabel().merge(e.getSym().getLabel());
                            }
                        }
                    },
                    {
                        key: "linkMinimalDirectedEdges",
                        value: function(t) {
                            for(var e = null, n = null, r = this._SCANNING_FOR_INCOMING, i = this._resultAreaEdgeList.size() - 1; i >= 0; i--){
                                var o = this._resultAreaEdgeList.get(i), s = o.getSym();
                                switch(null === e && o.getEdgeRing() === t && (e = o), r){
                                    case this._SCANNING_FOR_INCOMING:
                                        if (s.getEdgeRing() !== t) continue;
                                        n = s, r = this._LINKING_TO_OUTGOING;
                                        break;
                                    case this._LINKING_TO_OUTGOING:
                                        if (o.getEdgeRing() !== t) continue;
                                        n.setNextMin(o), r = this._SCANNING_FOR_INCOMING;
                                }
                            }
                            r === this._LINKING_TO_OUTGOING && (G.isTrue(null !== e, "found null for first outgoing dirEdge"), G.isTrue(e.getEdgeRing() === t, "unable to link last incoming dirEdge"), n.setNextMin(e));
                        }
                    },
                    {
                        key: "getOutgoingDegree",
                        value: function() {
                            if (0 === arguments.length) {
                                for(var t = 0, e = this.iterator(); e.hasNext();)e.next().isInResult() && t++;
                                return t;
                            }
                            if (1 === arguments.length) {
                                for(var n = arguments[0], r = 0, i = this.iterator(); i.hasNext();)i.next().getEdgeRing() === n && r++;
                                return r;
                            }
                        }
                    },
                    {
                        key: "getLabel",
                        value: function() {
                            return this._label;
                        }
                    },
                    {
                        key: "findCoveredLineEdges",
                        value: function() {
                            for(var t = Z.NONE, e = this.iterator(); e.hasNext();){
                                var n = e.next(), r = n.getSym();
                                if (!n.isLineEdge()) {
                                    if (n.isInResult()) {
                                        t = Z.INTERIOR;
                                        break;
                                    }
                                    if (r.isInResult()) {
                                        t = Z.EXTERIOR;
                                        break;
                                    }
                                }
                            }
                            if (t === Z.NONE) return null;
                            for(var i = t, o = this.iterator(); o.hasNext();){
                                var s = o.next(), a = s.getSym();
                                s.isLineEdge() ? s.getEdge().setCovered(i === Z.INTERIOR) : (s.isInResult() && (i = Z.EXTERIOR), a.isInResult() && (i = Z.INTERIOR));
                            }
                        }
                    },
                    {
                        key: "computeLabelling",
                        value: function(t) {
                            f(i(s.prototype), "computeLabelling", this).call(this, t), this._label = new Ae(Z.NONE);
                            for(var e = this.iterator(); e.hasNext();)for(var n = e.next().getEdge().getLabel(), r = 0; r < 2; r++){
                                var o = n.getLocation(r);
                                o !== Z.INTERIOR && o !== Z.BOUNDARY || this._label.setLocation(r, Z.INTERIOR);
                            }
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._resultAreaEdgeList = null, this._label = null, this._SCANNING_FOR_INCOMING = 1, this._LINKING_TO_OUTGOING = 2;
                        }
                    }
                ]), s;
            }(Un), Zn = function(e) {
                r(o, e);
                var i = c(o);
                function o() {
                    return t(this, o), i.call(this);
                }
                return n(o, [
                    {
                        key: "createNode",
                        value: function(t) {
                            return new Ye(t, new Vn);
                        }
                    }
                ]), o;
            }(Qe), Hn = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "compareTo",
                        value: function(t) {
                            var n = t;
                            return e.compareOriented(this._pts, this._orientation, n._pts, n._orientation);
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                k
                            ];
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._pts = null, this._orientation = null;
                            var t = arguments[0];
                            this._pts = t, this._orientation = e.orientation(t);
                        }
                    },
                    {
                        key: "orientation",
                        value: function(t) {
                            return 1 === Wt.increasingDirection(t);
                        }
                    },
                    {
                        key: "compareOriented",
                        value: function(t, e, n, r) {
                            for(var i = e ? 1 : -1, o = r ? 1 : -1, s = e ? t.length : -1, a = r ? n.length : -1, u = e ? 0 : t.length - 1, l = r ? 0 : n.length - 1;;){
                                var h = t[u].compareTo(n[l]);
                                if (0 !== h) return h;
                                var c = (u += i) === s, f = (l += o) === a;
                                if (c && !f) return -1;
                                if (!c && f) return 1;
                                if (c && f) return 0;
                            }
                        }
                    }
                ]), e;
            }(), Wn = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "print",
                        value: function(t) {
                            t.print("MULTILINESTRING ( ");
                            for(var e = 0; e < this._edges.size(); e++){
                                var n = this._edges.get(e);
                                e > 0 && t.print(","), t.print("(");
                                for(var r = n.getCoordinates(), i = 0; i < r.length; i++)i > 0 && t.print(","), t.print(r[i].x + " " + r[i].y);
                                t.println(")");
                            }
                            t.print(")  ");
                        }
                    },
                    {
                        key: "addAll",
                        value: function(t) {
                            for(var e = t.iterator(); e.hasNext();)this.add(e.next());
                        }
                    },
                    {
                        key: "findEdgeIndex",
                        value: function(t) {
                            for(var e = 0; e < this._edges.size(); e++)if (this._edges.get(e).equals(t)) return e;
                            return -1;
                        }
                    },
                    {
                        key: "iterator",
                        value: function() {
                            return this._edges.iterator();
                        }
                    },
                    {
                        key: "getEdges",
                        value: function() {
                            return this._edges;
                        }
                    },
                    {
                        key: "get",
                        value: function(t) {
                            return this._edges.get(t);
                        }
                    },
                    {
                        key: "findEqualEdge",
                        value: function(t) {
                            var e = new Hn(t.getCoordinates());
                            return this._ocaMap.get(e);
                        }
                    },
                    {
                        key: "add",
                        value: function(t) {
                            this._edges.add(t);
                            var e = new Hn(t.getCoordinates());
                            this._ocaMap.put(e, t);
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._edges = new pt, this._ocaMap = new Ze;
                        }
                    }
                ]), e;
            }(), Jn = function() {
                function e() {
                    t(this, e);
                }
                return n(e, [
                    {
                        key: "processIntersections",
                        value: function(t, e, n, r) {}
                    },
                    {
                        key: "isDone",
                        value: function() {}
                    }
                ]), e;
            }(), Kn = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "isTrivialIntersection",
                        value: function(t, n, r, i) {
                            if (t === r && 1 === this._li.getIntersectionNum()) {
                                if (e.isAdjacentSegments(n, i)) return !0;
                                if (t.isClosed()) {
                                    var o = t.size() - 1;
                                    if (0 === n && i === o || 0 === i && n === o) return !0;
                                }
                            }
                            return !1;
                        }
                    },
                    {
                        key: "getProperIntersectionPoint",
                        value: function() {
                            return this._properIntersectionPoint;
                        }
                    },
                    {
                        key: "hasProperInteriorIntersection",
                        value: function() {
                            return this._hasProperInterior;
                        }
                    },
                    {
                        key: "getLineIntersector",
                        value: function() {
                            return this._li;
                        }
                    },
                    {
                        key: "hasProperIntersection",
                        value: function() {
                            return this._hasProper;
                        }
                    },
                    {
                        key: "processIntersections",
                        value: function(t, e, n, r) {
                            if (t === n && e === r) return null;
                            this.numTests++;
                            var i = t.getCoordinates()[e], o = t.getCoordinates()[e + 1], s = n.getCoordinates()[r], a = n.getCoordinates()[r + 1];
                            this._li.computeIntersection(i, o, s, a), this._li.hasIntersection() && (this.numIntersections++, this._li.isInteriorIntersection() && (this.numInteriorIntersections++, this._hasInterior = !0), this.isTrivialIntersection(t, e, n, r) || (this._hasIntersection = !0, t.addIntersections(this._li, e, 0), n.addIntersections(this._li, r, 1), this._li.isProper() && (this.numProperIntersections++, this._hasProper = !0, this._hasProperInterior = !0)));
                        }
                    },
                    {
                        key: "hasIntersection",
                        value: function() {
                            return this._hasIntersection;
                        }
                    },
                    {
                        key: "isDone",
                        value: function() {
                            return !1;
                        }
                    },
                    {
                        key: "hasInteriorIntersection",
                        value: function() {
                            return this._hasInterior;
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                Jn
                            ];
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._hasIntersection = !1, this._hasProper = !1, this._hasProperInterior = !1, this._hasInterior = !1, this._properIntersectionPoint = null, this._li = null, this._isSelfIntersection = null, this.numIntersections = 0, this.numInteriorIntersections = 0, this.numProperIntersections = 0, this.numTests = 0;
                            var t = arguments[0];
                            this._li = t;
                        }
                    },
                    {
                        key: "isAdjacentSegments",
                        value: function(t, e) {
                            return 1 === Math.abs(t - e);
                        }
                    }
                ]), e;
            }(), Qn = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "getSegmentIndex",
                        value: function() {
                            return this.segmentIndex;
                        }
                    },
                    {
                        key: "getCoordinate",
                        value: function() {
                            return this.coord;
                        }
                    },
                    {
                        key: "print",
                        value: function(t) {
                            t.print(this.coord), t.print(" seg # = " + this.segmentIndex), t.println(" dist = " + this.dist);
                        }
                    },
                    {
                        key: "compareTo",
                        value: function(t) {
                            var e = t;
                            return this.compare(e.segmentIndex, e.dist);
                        }
                    },
                    {
                        key: "isEndPoint",
                        value: function(t) {
                            return 0 === this.segmentIndex && 0 === this.dist || this.segmentIndex === t;
                        }
                    },
                    {
                        key: "toString",
                        value: function() {
                            return this.coord + " seg # = " + this.segmentIndex + " dist = " + this.dist;
                        }
                    },
                    {
                        key: "getDistance",
                        value: function() {
                            return this.dist;
                        }
                    },
                    {
                        key: "compare",
                        value: function(t, e) {
                            return this.segmentIndex < t ? -1 : this.segmentIndex > t ? 1 : this.dist < e ? -1 : this.dist > e ? 1 : 0;
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                k
                            ];
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this.coord = null, this.segmentIndex = null, this.dist = null;
                            var t = arguments[0], e = arguments[1], n = arguments[2];
                            this.coord = new j(t), this.segmentIndex = e, this.dist = n;
                        }
                    }
                ]), e;
            }(), $n = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "print",
                        value: function(t) {
                            t.println("Intersections:");
                            for(var e = this.iterator(); e.hasNext();)e.next().print(t);
                        }
                    },
                    {
                        key: "iterator",
                        value: function() {
                            return this._nodeMap.values().iterator();
                        }
                    },
                    {
                        key: "addSplitEdges",
                        value: function(t) {
                            this.addEndpoints();
                            for(var e = this.iterator(), n = e.next(); e.hasNext();){
                                var r = e.next(), i = this.createSplitEdge(n, r);
                                t.add(i), n = r;
                            }
                        }
                    },
                    {
                        key: "addEndpoints",
                        value: function() {
                            var t = this.edge.pts.length - 1;
                            this.add(this.edge.pts[0], 0, 0), this.add(this.edge.pts[t], t, 0);
                        }
                    },
                    {
                        key: "createSplitEdge",
                        value: function(t, e) {
                            var n = e.segmentIndex - t.segmentIndex + 2, r = this.edge.pts[e.segmentIndex], i = e.dist > 0 || !e.coord.equals2D(r);
                            i || n--;
                            var o = new Array(n).fill(null), s = 0;
                            o[s++] = new j(t.coord);
                            for(var a = t.segmentIndex + 1; a <= e.segmentIndex; a++)o[s++] = this.edge.pts[a];
                            return i && (o[s] = e.coord), new or(o, new Ae(this.edge._label));
                        }
                    },
                    {
                        key: "add",
                        value: function(t, e, n) {
                            var r = new Qn(t, e, n), i = this._nodeMap.get(r);
                            return null !== i ? i : (this._nodeMap.put(r, r), r);
                        }
                    },
                    {
                        key: "isIntersection",
                        value: function(t) {
                            for(var e = this.iterator(); e.hasNext();)if (e.next().coord.equals(t)) return !0;
                            return !1;
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._nodeMap = new Ze, this.edge = null;
                            var t = arguments[0];
                            this.edge = t;
                        }
                    }
                ]), e;
            }(), tr = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "isIntersects",
                        value: function() {
                            return !this.isDisjoint();
                        }
                    },
                    {
                        key: "isCovers",
                        value: function() {
                            return (e.isTrue(this._matrix[Z.INTERIOR][Z.INTERIOR]) || e.isTrue(this._matrix[Z.INTERIOR][Z.BOUNDARY]) || e.isTrue(this._matrix[Z.BOUNDARY][Z.INTERIOR]) || e.isTrue(this._matrix[Z.BOUNDARY][Z.BOUNDARY])) && this._matrix[Z.EXTERIOR][Z.INTERIOR] === Mt.FALSE && this._matrix[Z.EXTERIOR][Z.BOUNDARY] === Mt.FALSE;
                        }
                    },
                    {
                        key: "isCoveredBy",
                        value: function() {
                            return (e.isTrue(this._matrix[Z.INTERIOR][Z.INTERIOR]) || e.isTrue(this._matrix[Z.INTERIOR][Z.BOUNDARY]) || e.isTrue(this._matrix[Z.BOUNDARY][Z.INTERIOR]) || e.isTrue(this._matrix[Z.BOUNDARY][Z.BOUNDARY])) && this._matrix[Z.INTERIOR][Z.EXTERIOR] === Mt.FALSE && this._matrix[Z.BOUNDARY][Z.EXTERIOR] === Mt.FALSE;
                        }
                    },
                    {
                        key: "set",
                        value: function() {
                            if (1 === arguments.length) for(var t = arguments[0], e = 0; e < t.length; e++){
                                var n = Math.trunc(e / 3), r = e % 3;
                                this._matrix[n][r] = Mt.toDimensionValue(t.charAt(e));
                            }
                            else if (3 === arguments.length) {
                                var i = arguments[0], o = arguments[1], s = arguments[2];
                                this._matrix[i][o] = s;
                            }
                        }
                    },
                    {
                        key: "isContains",
                        value: function() {
                            return e.isTrue(this._matrix[Z.INTERIOR][Z.INTERIOR]) && this._matrix[Z.EXTERIOR][Z.INTERIOR] === Mt.FALSE && this._matrix[Z.EXTERIOR][Z.BOUNDARY] === Mt.FALSE;
                        }
                    },
                    {
                        key: "setAtLeast",
                        value: function() {
                            if (1 === arguments.length) for(var t = arguments[0], e = 0; e < t.length; e++){
                                var n = Math.trunc(e / 3), r = e % 3;
                                this.setAtLeast(n, r, Mt.toDimensionValue(t.charAt(e)));
                            }
                            else if (3 === arguments.length) {
                                var i = arguments[0], o = arguments[1], s = arguments[2];
                                this._matrix[i][o] < s && (this._matrix[i][o] = s);
                            }
                        }
                    },
                    {
                        key: "setAtLeastIfValid",
                        value: function(t, e, n) {
                            t >= 0 && e >= 0 && this.setAtLeast(t, e, n);
                        }
                    },
                    {
                        key: "isWithin",
                        value: function() {
                            return e.isTrue(this._matrix[Z.INTERIOR][Z.INTERIOR]) && this._matrix[Z.INTERIOR][Z.EXTERIOR] === Mt.FALSE && this._matrix[Z.BOUNDARY][Z.EXTERIOR] === Mt.FALSE;
                        }
                    },
                    {
                        key: "isTouches",
                        value: function(t, n) {
                            return t > n ? this.isTouches(n, t) : (t === Mt.A && n === Mt.A || t === Mt.L && n === Mt.L || t === Mt.L && n === Mt.A || t === Mt.P && n === Mt.A || t === Mt.P && n === Mt.L) && this._matrix[Z.INTERIOR][Z.INTERIOR] === Mt.FALSE && (e.isTrue(this._matrix[Z.INTERIOR][Z.BOUNDARY]) || e.isTrue(this._matrix[Z.BOUNDARY][Z.INTERIOR]) || e.isTrue(this._matrix[Z.BOUNDARY][Z.BOUNDARY]));
                        }
                    },
                    {
                        key: "isOverlaps",
                        value: function(t, n) {
                            return t === Mt.P && n === Mt.P || t === Mt.A && n === Mt.A ? e.isTrue(this._matrix[Z.INTERIOR][Z.INTERIOR]) && e.isTrue(this._matrix[Z.INTERIOR][Z.EXTERIOR]) && e.isTrue(this._matrix[Z.EXTERIOR][Z.INTERIOR]) : t === Mt.L && n === Mt.L && 1 === this._matrix[Z.INTERIOR][Z.INTERIOR] && e.isTrue(this._matrix[Z.INTERIOR][Z.EXTERIOR]) && e.isTrue(this._matrix[Z.EXTERIOR][Z.INTERIOR]);
                        }
                    },
                    {
                        key: "isEquals",
                        value: function(t, n) {
                            return t === n && e.isTrue(this._matrix[Z.INTERIOR][Z.INTERIOR]) && this._matrix[Z.INTERIOR][Z.EXTERIOR] === Mt.FALSE && this._matrix[Z.BOUNDARY][Z.EXTERIOR] === Mt.FALSE && this._matrix[Z.EXTERIOR][Z.INTERIOR] === Mt.FALSE && this._matrix[Z.EXTERIOR][Z.BOUNDARY] === Mt.FALSE;
                        }
                    },
                    {
                        key: "toString",
                        value: function() {
                            for(var t = new Qt("123456789"), e = 0; e < 3; e++)for(var n = 0; n < 3; n++)t.setCharAt(3 * e + n, Mt.toDimensionSymbol(this._matrix[e][n]));
                            return t.toString();
                        }
                    },
                    {
                        key: "setAll",
                        value: function(t) {
                            for(var e = 0; e < 3; e++)for(var n = 0; n < 3; n++)this._matrix[e][n] = t;
                        }
                    },
                    {
                        key: "get",
                        value: function(t, e) {
                            return this._matrix[t][e];
                        }
                    },
                    {
                        key: "transpose",
                        value: function() {
                            var t = this._matrix[1][0];
                            return this._matrix[1][0] = this._matrix[0][1], this._matrix[0][1] = t, t = this._matrix[2][0], this._matrix[2][0] = this._matrix[0][2], this._matrix[0][2] = t, t = this._matrix[2][1], this._matrix[2][1] = this._matrix[1][2], this._matrix[1][2] = t, this;
                        }
                    },
                    {
                        key: "matches",
                        value: function(t) {
                            if (9 !== t.length) throw new _("Should be length 9: " + t);
                            for(var n = 0; n < 3; n++)for(var r = 0; r < 3; r++)if (!e.matches(this._matrix[n][r], t.charAt(3 * n + r))) return !1;
                            return !0;
                        }
                    },
                    {
                        key: "add",
                        value: function(t) {
                            for(var e = 0; e < 3; e++)for(var n = 0; n < 3; n++)this.setAtLeast(e, n, t.get(e, n));
                        }
                    },
                    {
                        key: "isDisjoint",
                        value: function() {
                            return this._matrix[Z.INTERIOR][Z.INTERIOR] === Mt.FALSE && this._matrix[Z.INTERIOR][Z.BOUNDARY] === Mt.FALSE && this._matrix[Z.BOUNDARY][Z.INTERIOR] === Mt.FALSE && this._matrix[Z.BOUNDARY][Z.BOUNDARY] === Mt.FALSE;
                        }
                    },
                    {
                        key: "isCrosses",
                        value: function(t, n) {
                            return t === Mt.P && n === Mt.L || t === Mt.P && n === Mt.A || t === Mt.L && n === Mt.A ? e.isTrue(this._matrix[Z.INTERIOR][Z.INTERIOR]) && e.isTrue(this._matrix[Z.INTERIOR][Z.EXTERIOR]) : t === Mt.L && n === Mt.P || t === Mt.A && n === Mt.P || t === Mt.A && n === Mt.L ? e.isTrue(this._matrix[Z.INTERIOR][Z.INTERIOR]) && e.isTrue(this._matrix[Z.EXTERIOR][Z.INTERIOR]) : t === Mt.L && n === Mt.L && 0 === this._matrix[Z.INTERIOR][Z.INTERIOR];
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                w
                            ];
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            if (this._matrix = null, 0 === arguments.length) this._matrix = Array(3).fill().map(function() {
                                return Array(3);
                            }), this.setAll(Mt.FALSE);
                            else if (1 === arguments.length) {
                                if ("string" == typeof arguments[0]) {
                                    var t = arguments[0];
                                    e.constructor_.call(this), this.set(t);
                                } else if (arguments[0] instanceof e) {
                                    var n = arguments[0];
                                    e.constructor_.call(this), this._matrix[Z.INTERIOR][Z.INTERIOR] = n._matrix[Z.INTERIOR][Z.INTERIOR], this._matrix[Z.INTERIOR][Z.BOUNDARY] = n._matrix[Z.INTERIOR][Z.BOUNDARY], this._matrix[Z.INTERIOR][Z.EXTERIOR] = n._matrix[Z.INTERIOR][Z.EXTERIOR], this._matrix[Z.BOUNDARY][Z.INTERIOR] = n._matrix[Z.BOUNDARY][Z.INTERIOR], this._matrix[Z.BOUNDARY][Z.BOUNDARY] = n._matrix[Z.BOUNDARY][Z.BOUNDARY], this._matrix[Z.BOUNDARY][Z.EXTERIOR] = n._matrix[Z.BOUNDARY][Z.EXTERIOR], this._matrix[Z.EXTERIOR][Z.INTERIOR] = n._matrix[Z.EXTERIOR][Z.INTERIOR], this._matrix[Z.EXTERIOR][Z.BOUNDARY] = n._matrix[Z.EXTERIOR][Z.BOUNDARY], this._matrix[Z.EXTERIOR][Z.EXTERIOR] = n._matrix[Z.EXTERIOR][Z.EXTERIOR];
                                }
                            }
                        }
                    },
                    {
                        key: "matches",
                        value: function() {
                            if (Number.isInteger(arguments[0]) && "string" == typeof arguments[1]) {
                                var t = arguments[0], n = arguments[1];
                                return n === Mt.SYM_DONTCARE || n === Mt.SYM_TRUE && (t >= 0 || t === Mt.TRUE) || n === Mt.SYM_FALSE && t === Mt.FALSE || n === Mt.SYM_P && t === Mt.P || n === Mt.SYM_L && t === Mt.L || n === Mt.SYM_A && t === Mt.A;
                            }
                            if ("string" == typeof arguments[0] && "string" == typeof arguments[1]) {
                                var r = arguments[1];
                                return new e(arguments[0]).matches(r);
                            }
                        }
                    },
                    {
                        key: "isTrue",
                        value: function(t) {
                            return t >= 0 || t === Mt.TRUE;
                        }
                    }
                ]), e;
            }(), er = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "size",
                        value: function() {
                            return this._size;
                        }
                    },
                    {
                        key: "addAll",
                        value: function(t) {
                            return null === t || 0 === t.length ? null : (this.ensureCapacity(this._size + t.length), xt.arraycopy(t, 0, this._data, this._size, t.length), void (this._size += t.length));
                        }
                    },
                    {
                        key: "ensureCapacity",
                        value: function(t) {
                            if (t <= this._data.length) return null;
                            var e = Math.max(t, 2 * this._data.length);
                            this._data = At.copyOf(this._data, e);
                        }
                    },
                    {
                        key: "toArray",
                        value: function() {
                            var t = new Array(this._size).fill(null);
                            return xt.arraycopy(this._data, 0, t, 0, this._size), t;
                        }
                    },
                    {
                        key: "add",
                        value: function(t) {
                            this.ensureCapacity(this._size + 1), this._data[this._size] = t, ++this._size;
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            if (this._data = null, this._size = 0, 0 === arguments.length) e.constructor_.call(this, 10);
                            else if (1 === arguments.length) {
                                var t = arguments[0];
                                this._data = new Array(t).fill(null);
                            }
                        }
                    }
                ]), e;
            }(), nr = function() {
                function e() {
                    t(this, e);
                }
                return n(e, [
                    {
                        key: "getChainStartIndices",
                        value: function(t) {
                            var e = 0, n = new er(Math.trunc(t.length / 2));
                            n.add(e);
                            do {
                                var r = this.findChainEnd(t, e);
                                n.add(r), e = r;
                            }while (e < t.length - 1);
                            return n.toArray();
                        }
                    },
                    {
                        key: "findChainEnd",
                        value: function(t, e) {
                            for(var n = We.quadrant(t[e], t[e + 1]), r = e + 1; r < t.length && We.quadrant(t[r - 1], t[r]) === n;)r++;
                            return r - 1;
                        }
                    },
                    {
                        key: "OLDgetChainStartIndices",
                        value: function(t) {
                            var n = 0, r = new pt;
                            r.add(n);
                            do {
                                var i = this.findChainEnd(t, n);
                                r.add(i), n = i;
                            }while (n < t.length - 1);
                            return e.toIntArray(r);
                        }
                    }
                ], [
                    {
                        key: "toIntArray",
                        value: function(t) {
                            for(var e = new Array(t.size()).fill(null), n = 0; n < e.length; n++)e[n] = t.get(n).intValue();
                            return e;
                        }
                    }
                ]), e;
            }(), rr = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "getCoordinates",
                        value: function() {
                            return this.pts;
                        }
                    },
                    {
                        key: "getMaxX",
                        value: function(t) {
                            var e = this.pts[this.startIndex[t]].x, n = this.pts[this.startIndex[t + 1]].x;
                            return e > n ? e : n;
                        }
                    },
                    {
                        key: "getMinX",
                        value: function(t) {
                            var e = this.pts[this.startIndex[t]].x, n = this.pts[this.startIndex[t + 1]].x;
                            return e < n ? e : n;
                        }
                    },
                    {
                        key: "computeIntersectsForChain",
                        value: function() {
                            if (4 === arguments.length) {
                                var t = arguments[0], e = arguments[1], n = arguments[2], r = arguments[3];
                                this.computeIntersectsForChain(this.startIndex[t], this.startIndex[t + 1], e, e.startIndex[n], e.startIndex[n + 1], r);
                            } else if (6 === arguments.length) {
                                var i = arguments[0], o = arguments[1], s = arguments[2], a = arguments[3], u = arguments[4], l = arguments[5];
                                if (o - i == 1 && u - a == 1) return l.addIntersections(this.e, i, s.e, a), null;
                                if (!this.overlaps(i, o, s, a, u)) return null;
                                var h = Math.trunc((i + o) / 2), c = Math.trunc((a + u) / 2);
                                i < h && (a < c && this.computeIntersectsForChain(i, h, s, a, c, l), c < u && this.computeIntersectsForChain(i, h, s, c, u, l)), h < o && (a < c && this.computeIntersectsForChain(h, o, s, a, c, l), c < u && this.computeIntersectsForChain(h, o, s, c, u, l));
                            }
                        }
                    },
                    {
                        key: "overlaps",
                        value: function(t, e, n, r, i) {
                            return U.intersects(this.pts[t], this.pts[e], n.pts[r], n.pts[i]);
                        }
                    },
                    {
                        key: "getStartIndexes",
                        value: function() {
                            return this.startIndex;
                        }
                    },
                    {
                        key: "computeIntersects",
                        value: function(t, e) {
                            for(var n = 0; n < this.startIndex.length - 1; n++)for(var r = 0; r < t.startIndex.length - 1; r++)this.computeIntersectsForChain(n, t, r, e);
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this.e = null, this.pts = null, this.startIndex = null;
                            var t = arguments[0];
                            this.e = t, this.pts = t.getCoordinates();
                            var e = new nr;
                            this.startIndex = e.getChainStartIndices(this.pts);
                        }
                    }
                ]), e;
            }(), ir = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "getDepth",
                        value: function(t, e) {
                            return this._depth[t][e];
                        }
                    },
                    {
                        key: "setDepth",
                        value: function(t, e, n) {
                            this._depth[t][e] = n;
                        }
                    },
                    {
                        key: "isNull",
                        value: function() {
                            if (0 === arguments.length) {
                                for(var t = 0; t < 2; t++)for(var n = 0; n < 3; n++)if (this._depth[t][n] !== e.NULL_VALUE) return !1;
                                return !0;
                            }
                            if (1 === arguments.length) {
                                var r = arguments[0];
                                return this._depth[r][1] === e.NULL_VALUE;
                            }
                            if (2 === arguments.length) {
                                var i = arguments[0], o = arguments[1];
                                return this._depth[i][o] === e.NULL_VALUE;
                            }
                        }
                    },
                    {
                        key: "normalize",
                        value: function() {
                            for(var t = 0; t < 2; t++)if (!this.isNull(t)) {
                                var e = this._depth[t][1];
                                this._depth[t][2] < e && (e = this._depth[t][2]), e < 0 && (e = 0);
                                for(var n = 1; n < 3; n++){
                                    var r = 0;
                                    this._depth[t][n] > e && (r = 1), this._depth[t][n] = r;
                                }
                            }
                        }
                    },
                    {
                        key: "getDelta",
                        value: function(t) {
                            return this._depth[t][tt.RIGHT] - this._depth[t][tt.LEFT];
                        }
                    },
                    {
                        key: "getLocation",
                        value: function(t, e) {
                            return this._depth[t][e] <= 0 ? Z.EXTERIOR : Z.INTERIOR;
                        }
                    },
                    {
                        key: "toString",
                        value: function() {
                            return "A: " + this._depth[0][1] + "," + this._depth[0][2] + " B: " + this._depth[1][1] + "," + this._depth[1][2];
                        }
                    },
                    {
                        key: "add",
                        value: function() {
                            if (1 === arguments.length) for(var t = arguments[0], n = 0; n < 2; n++)for(var r = 1; r < 3; r++){
                                var i = t.getLocation(n, r);
                                i !== Z.EXTERIOR && i !== Z.INTERIOR || (this.isNull(n, r) ? this._depth[n][r] = e.depthAtLocation(i) : this._depth[n][r] += e.depthAtLocation(i));
                            }
                            else if (3 === arguments.length) {
                                var o = arguments[0], s = arguments[1];
                                arguments[2] === Z.INTERIOR && this._depth[o][s]++;
                            }
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._depth = Array(2).fill().map(function() {
                                return Array(3);
                            });
                            for(var t = 0; t < 2; t++)for(var n = 0; n < 3; n++)this._depth[t][n] = e.NULL_VALUE;
                        }
                    },
                    {
                        key: "depthAtLocation",
                        value: function(t) {
                            return t === Z.EXTERIOR ? 0 : t === Z.INTERIOR ? 1 : e.NULL_VALUE;
                        }
                    }
                ]), e;
            }();
            ir.NULL_VALUE = -1;
            var or = function(e) {
                r(s, e);
                var o = c(s);
                function s() {
                    var e;
                    return t(this, s), e = o.call(this), s.constructor_.apply(l(e), arguments), e;
                }
                return n(s, [
                    {
                        key: "getDepth",
                        value: function() {
                            return this._depth;
                        }
                    },
                    {
                        key: "getCollapsedEdge",
                        value: function() {
                            var t = new Array(2).fill(null);
                            return t[0] = this.pts[0], t[1] = this.pts[1], new s(t, Ae.toLineLabel(this._label));
                        }
                    },
                    {
                        key: "isIsolated",
                        value: function() {
                            return this._isIsolated;
                        }
                    },
                    {
                        key: "getCoordinates",
                        value: function() {
                            return this.pts;
                        }
                    },
                    {
                        key: "setIsolated",
                        value: function(t) {
                            this._isIsolated = t;
                        }
                    },
                    {
                        key: "setName",
                        value: function(t) {
                            this._name = t;
                        }
                    },
                    {
                        key: "equals",
                        value: function(t) {
                            if (!(t instanceof s)) return !1;
                            var e = t;
                            if (this.pts.length !== e.pts.length) return !1;
                            for(var n = !0, r = !0, i = this.pts.length, o = 0; o < this.pts.length; o++)if (this.pts[o].equals2D(e.pts[o]) || (n = !1), this.pts[o].equals2D(e.pts[--i]) || (r = !1), !n && !r) return !1;
                            return !0;
                        }
                    },
                    {
                        key: "getCoordinate",
                        value: function() {
                            if (0 === arguments.length) return this.pts.length > 0 ? this.pts[0] : null;
                            if (1 === arguments.length) {
                                var t = arguments[0];
                                return this.pts[t];
                            }
                        }
                    },
                    {
                        key: "print",
                        value: function(t) {
                            t.print("edge " + this._name + ": "), t.print("LINESTRING (");
                            for(var e = 0; e < this.pts.length; e++)e > 0 && t.print(","), t.print(this.pts[e].x + " " + this.pts[e].y);
                            t.print(")  " + this._label + " " + this._depthDelta);
                        }
                    },
                    {
                        key: "computeIM",
                        value: function(t) {
                            s.updateIM(this._label, t);
                        }
                    },
                    {
                        key: "isCollapsed",
                        value: function() {
                            return !!this._label.isArea() && 3 === this.pts.length && !!this.pts[0].equals(this.pts[2]);
                        }
                    },
                    {
                        key: "isClosed",
                        value: function() {
                            return this.pts[0].equals(this.pts[this.pts.length - 1]);
                        }
                    },
                    {
                        key: "getMaximumSegmentIndex",
                        value: function() {
                            return this.pts.length - 1;
                        }
                    },
                    {
                        key: "getDepthDelta",
                        value: function() {
                            return this._depthDelta;
                        }
                    },
                    {
                        key: "getNumPoints",
                        value: function() {
                            return this.pts.length;
                        }
                    },
                    {
                        key: "printReverse",
                        value: function(t) {
                            t.print("edge " + this._name + ": ");
                            for(var e = this.pts.length - 1; e >= 0; e--)t.print(this.pts[e] + " ");
                            t.println("");
                        }
                    },
                    {
                        key: "getMonotoneChainEdge",
                        value: function() {
                            return null === this._mce && (this._mce = new rr(this)), this._mce;
                        }
                    },
                    {
                        key: "getEnvelope",
                        value: function() {
                            if (null === this._env) {
                                this._env = new U;
                                for(var t = 0; t < this.pts.length; t++)this._env.expandToInclude(this.pts[t]);
                            }
                            return this._env;
                        }
                    },
                    {
                        key: "addIntersection",
                        value: function(t, e, n, r) {
                            var i = new j(t.getIntersection(r)), o = e, s = t.getEdgeDistance(n, r), a = o + 1;
                            if (a < this.pts.length) {
                                var u = this.pts[a];
                                i.equals2D(u) && (o = a, s = 0);
                            }
                            this.eiList.add(i, o, s);
                        }
                    },
                    {
                        key: "toString",
                        value: function() {
                            var t = new Qt;
                            t.append("edge " + this._name + ": "), t.append("LINESTRING (");
                            for(var e = 0; e < this.pts.length; e++)e > 0 && t.append(","), t.append(this.pts[e].x + " " + this.pts[e].y);
                            return t.append(")  " + this._label + " " + this._depthDelta), t.toString();
                        }
                    },
                    {
                        key: "isPointwiseEqual",
                        value: function(t) {
                            if (this.pts.length !== t.pts.length) return !1;
                            for(var e = 0; e < this.pts.length; e++)if (!this.pts[e].equals2D(t.pts[e])) return !1;
                            return !0;
                        }
                    },
                    {
                        key: "setDepthDelta",
                        value: function(t) {
                            this._depthDelta = t;
                        }
                    },
                    {
                        key: "getEdgeIntersectionList",
                        value: function() {
                            return this.eiList;
                        }
                    },
                    {
                        key: "addIntersections",
                        value: function(t, e, n) {
                            for(var r = 0; r < t.getIntersectionNum(); r++)this.addIntersection(t, e, n, r);
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            if (this.pts = null, this._env = null, this.eiList = new $n(this), this._name = null, this._mce = null, this._isIsolated = !0, this._depth = new ir, this._depthDelta = 0, 1 === arguments.length) {
                                var t = arguments[0];
                                s.constructor_.call(this, t, null);
                            } else if (2 === arguments.length) {
                                var e = arguments[0], n = arguments[1];
                                this.pts = e, this._label = n;
                            }
                        }
                    },
                    {
                        key: "updateIM",
                        value: function() {
                            if (!(2 === arguments.length && arguments[1] instanceof tr && arguments[0] instanceof Ae)) return f(i(s), "updateIM", this).apply(this, arguments);
                            var t = arguments[0], e = arguments[1];
                            e.setAtLeastIfValid(t.getLocation(0, tt.ON), t.getLocation(1, tt.ON), 1), t.isArea() && (e.setAtLeastIfValid(t.getLocation(0, tt.LEFT), t.getLocation(1, tt.LEFT), 2), e.setAtLeastIfValid(t.getLocation(0, tt.RIGHT), t.getLocation(1, tt.RIGHT), 2));
                        }
                    }
                ]), s;
            }(Ge), sr = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "setWorkingPrecisionModel",
                        value: function(t) {
                            this._workingPrecisionModel = t;
                        }
                    },
                    {
                        key: "insertUniqueEdge",
                        value: function(t) {
                            var n = this._edgeList.findEqualEdge(t);
                            if (null !== n) {
                                var r = n.getLabel(), i = t.getLabel();
                                n.isPointwiseEqual(t) || (i = new Ae(t.getLabel())).flip(), r.merge(i);
                                var o = e.depthDelta(i), s = n.getDepthDelta() + o;
                                n.setDepthDelta(s);
                            } else this._edgeList.add(t), t.setDepthDelta(e.depthDelta(t.getLabel()));
                        }
                    },
                    {
                        key: "buildSubgraphs",
                        value: function(t, e) {
                            for(var n = new pt, r = t.iterator(); r.hasNext();){
                                var i = r.next(), o = i.getRightmostCoordinate(), s = new Dn(n).getDepth(o);
                                i.computeDepth(s), i.findResultEdges(), n.add(i), e.add(i.getDirectedEdges(), i.getNodes());
                            }
                        }
                    },
                    {
                        key: "createSubgraphs",
                        value: function(t) {
                            for(var e = new pt, n = t.getNodes().iterator(); n.hasNext();){
                                var r = n.next();
                                if (!r.isVisited()) {
                                    var i = new mt;
                                    i.create(r), e.add(i);
                                }
                            }
                            return an.sort(e, an.reverseOrder()), e;
                        }
                    },
                    {
                        key: "createEmptyResultGeometry",
                        value: function() {
                            return this._geomFact.createPolygon();
                        }
                    },
                    {
                        key: "getNoder",
                        value: function(t) {
                            if (null !== this._workingNoder) return this._workingNoder;
                            var e = new Ln, n = new Ce;
                            return n.setPrecisionModel(t), e.setSegmentIntersector(new Kn(n)), e;
                        }
                    },
                    {
                        key: "buffer",
                        value: function(t, e) {
                            var n = this._workingPrecisionModel;
                            null === n && (n = t.getPrecisionModel()), this._geomFact = t.getFactory();
                            var r = new An(n, this._bufParams), i = new Bn(t, e, r).getCurves();
                            if (i.size() <= 0) return this.createEmptyResultGeometry();
                            this.computeNodedEdges(i, n), this._graph = new $e(new Zn), this._graph.addEdges(this._edgeList.getEdges());
                            var o = this.createSubgraphs(this._graph), s = new tn(this._geomFact);
                            this.buildSubgraphs(o, s);
                            var a = s.getPolygons();
                            return a.size() <= 0 ? this.createEmptyResultGeometry() : this._geomFact.buildGeometry(a);
                        }
                    },
                    {
                        key: "computeNodedEdges",
                        value: function(t, e) {
                            var n = this.getNoder(e);
                            n.computeNodes(t);
                            for(var r = n.getNodedSubstrings().iterator(); r.hasNext();){
                                var i = r.next(), o = i.getCoordinates();
                                if (2 !== o.length || !o[0].equals2D(o[1])) {
                                    var s = i.getData(), a = new or(i.getCoordinates(), new Ae(s));
                                    this.insertUniqueEdge(a);
                                }
                            }
                        }
                    },
                    {
                        key: "setNoder",
                        value: function(t) {
                            this._workingNoder = t;
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._bufParams = null, this._workingPrecisionModel = null, this._workingNoder = null, this._geomFact = null, this._graph = null, this._edgeList = new Wn;
                            var t = arguments[0];
                            this._bufParams = t;
                        }
                    },
                    {
                        key: "depthDelta",
                        value: function(t) {
                            var e = t.getLocation(0, tt.LEFT), n = t.getLocation(0, tt.RIGHT);
                            return e === Z.INTERIOR && n === Z.EXTERIOR ? 1 : e === Z.EXTERIOR && n === Z.INTERIOR ? -1 : 0;
                        }
                    },
                    {
                        key: "convertSegStrings",
                        value: function(t) {
                            for(var e = new ae, n = new pt; t.hasNext();){
                                var r = t.next(), i = e.createLineString(r.getCoordinates());
                                n.add(i);
                            }
                            return e.buildGeometry(n);
                        }
                    }
                ]), e;
            }(), ar = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "rescale",
                        value: function() {
                            if (ot(arguments[0], H)) for(var t = arguments[0].iterator(); t.hasNext();){
                                var e = t.next();
                                this.rescale(e.getCoordinates());
                            }
                            else if (arguments[0] instanceof Array) {
                                for(var n = arguments[0], r = 0; r < n.length; r++)n[r].x = n[r].x / this._scaleFactor + this._offsetX, n[r].y = n[r].y / this._scaleFactor + this._offsetY;
                                2 === n.length && n[0].equals2D(n[1]) && xt.out.println(n);
                            }
                        }
                    },
                    {
                        key: "scale",
                        value: function() {
                            if (ot(arguments[0], H)) {
                                for(var t = arguments[0], e = new pt(t.size()), n = t.iterator(); n.hasNext();){
                                    var r = n.next();
                                    e.add(new kn(this.scale(r.getCoordinates()), r.getData()));
                                }
                                return e;
                            }
                            if (arguments[0] instanceof Array) {
                                for(var i = arguments[0], o = new Array(i.length).fill(null), s = 0; s < i.length; s++)o[s] = new j(Math.round((i[s].x - this._offsetX) * this._scaleFactor), Math.round((i[s].y - this._offsetY) * this._scaleFactor), i[s].getZ());
                                return Wt.removeRepeatedPoints(o);
                            }
                        }
                    },
                    {
                        key: "isIntegerPrecision",
                        value: function() {
                            return 1 === this._scaleFactor;
                        }
                    },
                    {
                        key: "getNodedSubstrings",
                        value: function() {
                            var t = this._noder.getNodedSubstrings();
                            return this._isScaled && this.rescale(t), t;
                        }
                    },
                    {
                        key: "computeNodes",
                        value: function(t) {
                            var e = t;
                            this._isScaled && (e = this.scale(t)), this._noder.computeNodes(e);
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                Sn
                            ];
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            if (this._noder = null, this._scaleFactor = null, this._offsetX = null, this._offsetY = null, this._isScaled = !1, 2 === arguments.length) {
                                var t = arguments[0], n = arguments[1];
                                e.constructor_.call(this, t, n, 0, 0);
                            } else if (4 === arguments.length) {
                                var r = arguments[0], i = arguments[1];
                                this._noder = r, this._scaleFactor = i, this._isScaled = !this.isIntegerPrecision();
                            }
                        }
                    }
                ]), e;
            }(), ur = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "checkEndPtVertexIntersections",
                        value: function() {
                            if (0 === arguments.length) for(var t = this._segStrings.iterator(); t.hasNext();){
                                var e = t.next().getCoordinates();
                                this.checkEndPtVertexIntersections(e[0], this._segStrings), this.checkEndPtVertexIntersections(e[e.length - 1], this._segStrings);
                            }
                            else if (2 === arguments.length) {
                                for(var n = arguments[0], r = arguments[1].iterator(); r.hasNext();)for(var i = r.next().getCoordinates(), o = 1; o < i.length - 1; o++)if (i[o].equals(n)) throw new F("found endpt/interior pt intersection at index " + o + " :pt " + n);
                            }
                        }
                    },
                    {
                        key: "checkInteriorIntersections",
                        value: function() {
                            if (0 === arguments.length) for(var t = this._segStrings.iterator(); t.hasNext();)for(var e = t.next(), n = this._segStrings.iterator(); n.hasNext();){
                                var r = n.next();
                                this.checkInteriorIntersections(e, r);
                            }
                            else if (2 === arguments.length) for(var i = arguments[0], o = arguments[1], s = i.getCoordinates(), a = o.getCoordinates(), u = 0; u < s.length - 1; u++)for(var l = 0; l < a.length - 1; l++)this.checkInteriorIntersections(i, u, o, l);
                            else if (4 === arguments.length) {
                                var h = arguments[0], c = arguments[1], f = arguments[2], v = arguments[3];
                                if (h === f && c === v) return null;
                                var g = h.getCoordinates()[c], d = h.getCoordinates()[c + 1], p = f.getCoordinates()[v], y = f.getCoordinates()[v + 1];
                                if (this._li.computeIntersection(g, d, p, y), this._li.hasIntersection() && (this._li.isProper() || this.hasInteriorIntersection(this._li, g, d) || this.hasInteriorIntersection(this._li, p, y))) throw new F("found non-noded intersection at " + g + "-" + d + " and " + p + "-" + y);
                            }
                        }
                    },
                    {
                        key: "checkValid",
                        value: function() {
                            this.checkEndPtVertexIntersections(), this.checkInteriorIntersections(), this.checkCollapses();
                        }
                    },
                    {
                        key: "checkCollapses",
                        value: function() {
                            if (0 === arguments.length) for(var t = this._segStrings.iterator(); t.hasNext();){
                                var e = t.next();
                                this.checkCollapses(e);
                            }
                            else if (1 === arguments.length) for(var n = arguments[0].getCoordinates(), r = 0; r < n.length - 2; r++)this.checkCollapse(n[r], n[r + 1], n[r + 2]);
                        }
                    },
                    {
                        key: "hasInteriorIntersection",
                        value: function(t, e, n) {
                            for(var r = 0; r < t.getIntersectionNum(); r++){
                                var i = t.getIntersection(r);
                                if (!i.equals(e) && !i.equals(n)) return !0;
                            }
                            return !1;
                        }
                    },
                    {
                        key: "checkCollapse",
                        value: function(t, n, r) {
                            if (t.equals(r)) throw new F("found non-noded collapse at " + e.fact.createLineString([
                                t,
                                n,
                                r
                            ]));
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._li = new Ce, this._segStrings = null;
                            var t = arguments[0];
                            this._segStrings = t;
                        }
                    }
                ]), e;
            }();
            ur.fact = new ae;
            var lr = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "intersectsScaled",
                        value: function(t, e) {
                            var n = Math.min(t.x, e.x), r = Math.max(t.x, e.x), i = Math.min(t.y, e.y), o = Math.max(t.y, e.y), s = this._maxx < n || this._minx > r || this._maxy < i || this._miny > o;
                            if (s) return !1;
                            var a = this.intersectsToleranceSquare(t, e);
                            return G.isTrue(!(s && a), "Found bad envelope test"), a;
                        }
                    },
                    {
                        key: "initCorners",
                        value: function(t) {
                            var e = .5;
                            this._minx = t.x - e, this._maxx = t.x + e, this._miny = t.y - e, this._maxy = t.y + e, this._corner[0] = new j(this._maxx, this._maxy), this._corner[1] = new j(this._minx, this._maxy), this._corner[2] = new j(this._minx, this._miny), this._corner[3] = new j(this._maxx, this._miny);
                        }
                    },
                    {
                        key: "intersects",
                        value: function(t, e) {
                            return 1 === this._scaleFactor ? this.intersectsScaled(t, e) : (this.copyScaled(t, this._p0Scaled), this.copyScaled(e, this._p1Scaled), this.intersectsScaled(this._p0Scaled, this._p1Scaled));
                        }
                    },
                    {
                        key: "scale",
                        value: function(t) {
                            return Math.round(t * this._scaleFactor);
                        }
                    },
                    {
                        key: "getCoordinate",
                        value: function() {
                            return this._originalPt;
                        }
                    },
                    {
                        key: "copyScaled",
                        value: function(t, e) {
                            e.x = this.scale(t.x), e.y = this.scale(t.y);
                        }
                    },
                    {
                        key: "getSafeEnvelope",
                        value: function() {
                            if (null === this._safeEnv) {
                                var t = e.SAFE_ENV_EXPANSION_FACTOR / this._scaleFactor;
                                this._safeEnv = new U(this._originalPt.x - t, this._originalPt.x + t, this._originalPt.y - t, this._originalPt.y + t);
                            }
                            return this._safeEnv;
                        }
                    },
                    {
                        key: "intersectsPixelClosure",
                        value: function(t, e) {
                            return this._li.computeIntersection(t, e, this._corner[0], this._corner[1]), !!(this._li.hasIntersection() || (this._li.computeIntersection(t, e, this._corner[1], this._corner[2]), this._li.hasIntersection() || (this._li.computeIntersection(t, e, this._corner[2], this._corner[3]), this._li.hasIntersection() || (this._li.computeIntersection(t, e, this._corner[3], this._corner[0]), this._li.hasIntersection()))));
                        }
                    },
                    {
                        key: "intersectsToleranceSquare",
                        value: function(t, e) {
                            var n = !1, r = !1;
                            return this._li.computeIntersection(t, e, this._corner[0], this._corner[1]), !!(this._li.isProper() || (this._li.computeIntersection(t, e, this._corner[1], this._corner[2]), this._li.isProper() || (this._li.hasIntersection() && (n = !0), this._li.computeIntersection(t, e, this._corner[2], this._corner[3]), this._li.isProper() || (this._li.hasIntersection() && (r = !0), this._li.computeIntersection(t, e, this._corner[3], this._corner[0]), this._li.isProper() || n && r || t.equals(this._pt) || e.equals(this._pt)))));
                        }
                    },
                    {
                        key: "addSnappedNode",
                        value: function(t, e) {
                            var n = t.getCoordinate(e), r = t.getCoordinate(e + 1);
                            return !!this.intersects(n, r) && (t.addIntersection(this.getCoordinate(), e), !0);
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._li = null, this._pt = null, this._originalPt = null, this._ptScaled = null, this._p0Scaled = null, this._p1Scaled = null, this._scaleFactor = null, this._minx = null, this._maxx = null, this._miny = null, this._maxy = null, this._corner = new Array(4).fill(null), this._safeEnv = null;
                            var t = arguments[0], e = arguments[1], n = arguments[2];
                            if (this._originalPt = t, this._pt = t, this._scaleFactor = e, this._li = n, e <= 0) throw new _("Scale factor must be non-zero");
                            1 !== e && (this._pt = new j(this.scale(t.x), this.scale(t.y)), this._p0Scaled = new j, this._p1Scaled = new j), this.initCorners(this._pt);
                        }
                    }
                ]), e;
            }();
            lr.SAFE_ENV_EXPANSION_FACTOR = .75;
            var hr = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "select",
                        value: function() {
                            if (1 === arguments.length) ;
                            else if (2 === arguments.length) {
                                var t = arguments[1];
                                arguments[0].getLineSegment(t, this.selectedSegment), this.select(this.selectedSegment);
                            }
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this.selectedSegment = new wn;
                        }
                    }
                ]), e;
            }(), cr = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "snap",
                        value: function() {
                            if (1 === arguments.length) {
                                var e = arguments[0];
                                return this.snap(e, null, -1);
                            }
                            if (3 === arguments.length) {
                                var r = arguments[0], i = arguments[1], o = arguments[2], s = r.getSafeEnvelope(), a = new fr(r, i, o);
                                return this._index.query(s, new (function() {
                                    function e() {
                                        t(this, e);
                                    }
                                    return n(e, [
                                        {
                                            key: "interfaces_",
                                            get: function() {
                                                return [
                                                    hn
                                                ];
                                            }
                                        },
                                        {
                                            key: "visitItem",
                                            value: function(t) {
                                                t.select(s, a);
                                            }
                                        }
                                    ]), e;
                                }())), a.isNodeAdded();
                            }
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._index = null;
                            var t = arguments[0];
                            this._index = t;
                        }
                    }
                ]), e;
            }(), fr = function(e) {
                r(s, e);
                var o = c(s);
                function s() {
                    var e;
                    return t(this, s), e = o.call(this), s.constructor_.apply(l(e), arguments), e;
                }
                return n(s, [
                    {
                        key: "isNodeAdded",
                        value: function() {
                            return this._isNodeAdded;
                        }
                    },
                    {
                        key: "select",
                        value: function() {
                            if (!(2 === arguments.length && Number.isInteger(arguments[1]) && arguments[0] instanceof In)) return f(i(s.prototype), "select", this).apply(this, arguments);
                            var t = arguments[1], e = arguments[0].getContext();
                            if (this._parentEdge === e && (t === this._hotPixelVertexIndex || t + 1 === this._hotPixelVertexIndex)) return null;
                            this._isNodeAdded |= this._hotPixel.addSnappedNode(e, t);
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._hotPixel = null, this._parentEdge = null, this._hotPixelVertexIndex = null, this._isNodeAdded = !1;
                            var t = arguments[0], e = arguments[1], n = arguments[2];
                            this._hotPixel = t, this._parentEdge = e, this._hotPixelVertexIndex = n;
                        }
                    }
                ]), s;
            }(hr);
            cr.HotPixelSnapAction = fr;
            var vr = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "processIntersections",
                        value: function(t, e, n, r) {
                            if (t === n && e === r) return null;
                            var i = t.getCoordinates()[e], o = t.getCoordinates()[e + 1], s = n.getCoordinates()[r], a = n.getCoordinates()[r + 1];
                            if (this._li.computeIntersection(i, o, s, a), this._li.hasIntersection() && this._li.isInteriorIntersection()) {
                                for(var u = 0; u < this._li.getIntersectionNum(); u++)this._interiorIntersections.add(this._li.getIntersection(u));
                                t.addIntersections(this._li, e, 0), n.addIntersections(this._li, r, 1);
                            }
                        }
                    },
                    {
                        key: "isDone",
                        value: function() {
                            return !1;
                        }
                    },
                    {
                        key: "getInteriorIntersections",
                        value: function() {
                            return this._interiorIntersections;
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                Jn
                            ];
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._li = null, this._interiorIntersections = null;
                            var t = arguments[0];
                            this._li = t, this._interiorIntersections = new pt;
                        }
                    }
                ]), e;
            }(), gr = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "checkCorrectness",
                        value: function(t) {
                            var e = kn.getNodedSubstrings(t), n = new ur(e);
                            try {
                                n.checkValid();
                            } catch (t) {
                                if (!(t instanceof m)) throw t;
                                t.printStackTrace();
                            }
                        }
                    },
                    {
                        key: "getNodedSubstrings",
                        value: function() {
                            return kn.getNodedSubstrings(this._nodedSegStrings);
                        }
                    },
                    {
                        key: "snapRound",
                        value: function(t, e) {
                            var n = this.findInteriorIntersections(t, e);
                            this.computeIntersectionSnaps(n), this.computeVertexSnaps(t);
                        }
                    },
                    {
                        key: "findInteriorIntersections",
                        value: function(t, e) {
                            var n = new vr(e);
                            return this._noder.setSegmentIntersector(n), this._noder.computeNodes(t), n.getInteriorIntersections();
                        }
                    },
                    {
                        key: "computeVertexSnaps",
                        value: function() {
                            if (ot(arguments[0], H)) for(var t = arguments[0].iterator(); t.hasNext();){
                                var e = t.next();
                                this.computeVertexSnaps(e);
                            }
                            else if (arguments[0] instanceof kn) for(var n = arguments[0], r = n.getCoordinates(), i = 0; i < r.length; i++){
                                var o = new lr(r[i], this._scaleFactor, this._li);
                                this._pointSnapper.snap(o, n, i) && n.addIntersection(r[i], i);
                            }
                        }
                    },
                    {
                        key: "computeNodes",
                        value: function(t) {
                            this._nodedSegStrings = t, this._noder = new Ln, this._pointSnapper = new cr(this._noder.getIndex()), this.snapRound(t, this._li);
                        }
                    },
                    {
                        key: "computeIntersectionSnaps",
                        value: function(t) {
                            for(var e = t.iterator(); e.hasNext();){
                                var n = e.next(), r = new lr(n, this._scaleFactor, this._li);
                                this._pointSnapper.snap(r);
                            }
                        }
                    },
                    {
                        key: "interfaces_",
                        get: function() {
                            return [
                                Sn
                            ];
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            this._pm = null, this._li = null, this._scaleFactor = null, this._noder = null, this._pointSnapper = null, this._nodedSegStrings = null;
                            var t = arguments[0];
                            this._pm = t, this._li = new Ce, this._li.setPrecisionModel(t), this._scaleFactor = t.getScale();
                        }
                    }
                ]), e;
            }(), dr = function() {
                function e() {
                    t(this, e), e.constructor_.apply(this, arguments);
                }
                return n(e, [
                    {
                        key: "bufferFixedPrecision",
                        value: function(t) {
                            var e = new ar(new gr(new ie(1)), t.getScale()), n = new sr(this._bufParams);
                            n.setWorkingPrecisionModel(t), n.setNoder(e), this._resultGeometry = n.buffer(this._argGeom, this._distance);
                        }
                    },
                    {
                        key: "bufferReducedPrecision",
                        value: function() {
                            if (0 === arguments.length) {
                                for(var t = e.MAX_PRECISION_DIGITS; t >= 0; t--){
                                    try {
                                        this.bufferReducedPrecision(t);
                                    } catch (t) {
                                        if (!(t instanceof gt)) throw t;
                                        this._saveException = t;
                                    }
                                    if (null !== this._resultGeometry) return null;
                                }
                                throw this._saveException;
                            }
                            if (1 === arguments.length) {
                                var n = arguments[0], r = e.precisionScaleFactor(this._argGeom, this._distance, n), i = new ie(r);
                                this.bufferFixedPrecision(i);
                            }
                        }
                    },
                    {
                        key: "computeGeometry",
                        value: function() {
                            if (this.bufferOriginalPrecision(), null !== this._resultGeometry) return null;
                            var t = this._argGeom.getFactory().getPrecisionModel();
                            t.getType() === ie.FIXED ? this.bufferFixedPrecision(t) : this.bufferReducedPrecision();
                        }
                    },
                    {
                        key: "setQuadrantSegments",
                        value: function(t) {
                            this._bufParams.setQuadrantSegments(t);
                        }
                    },
                    {
                        key: "bufferOriginalPrecision",
                        value: function() {
                            try {
                                var t = new sr(this._bufParams);
                                this._resultGeometry = t.buffer(this._argGeom, this._distance);
                            } catch (t) {
                                if (!(t instanceof F)) throw t;
                                this._saveException = t;
                            }
                        }
                    },
                    {
                        key: "getResultGeometry",
                        value: function(t) {
                            return this._distance = t, this.computeGeometry(), this._resultGeometry;
                        }
                    },
                    {
                        key: "setEndCapStyle",
                        value: function(t) {
                            this._bufParams.setEndCapStyle(t);
                        }
                    }
                ], [
                    {
                        key: "constructor_",
                        value: function() {
                            if (this._argGeom = null, this._distance = null, this._bufParams = new y, this._resultGeometry = null, this._saveException = null, 1 === arguments.length) {
                                var t = arguments[0];
                                this._argGeom = t;
                            } else if (2 === arguments.length) {
                                var e = arguments[0], n = arguments[1];
                                this._argGeom = e, this._bufParams = n;
                            }
                        }
                    },
                    {
                        key: "bufferOp",
                        value: function() {
                            if (2 === arguments.length) {
                                var t = arguments[1];
                                return new e(arguments[0]).getResultGeometry(t);
                            }
                            if (3 === arguments.length) {
                                if (Number.isInteger(arguments[2]) && arguments[0] instanceof V && "number" == typeof arguments[1]) {
                                    var n = arguments[1], r = arguments[2], i = new e(arguments[0]);
                                    return i.setQuadrantSegments(r), i.getResultGeometry(n);
                                }
                                if (arguments[2] instanceof y && arguments[0] instanceof V && "number" == typeof arguments[1]) {
                                    var o = arguments[1];
                                    return new e(arguments[0], arguments[2]).getResultGeometry(o);
                                }
                            } else if (4 === arguments.length) {
                                var s = arguments[1], a = arguments[2], u = arguments[3], l = new e(arguments[0]);
                                return l.setQuadrantSegments(a), l.setEndCapStyle(u), l.getResultGeometry(s);
                            }
                        }
                    },
                    {
                        key: "precisionScaleFactor",
                        value: function(t, e, n) {
                            var r = t.getEnvelopeInternal(), i = Et.max(Math.abs(r.getMaxX()), Math.abs(r.getMaxY()), Math.abs(r.getMinX()), Math.abs(r.getMinY())) + 2 * (e > 0 ? e : 0), o = n - Math.trunc(Math.log(i) / Math.log(10) + 1);
                            return Math.pow(10, o);
                        }
                    }
                ]), e;
            }();
            dr.CAP_ROUND = y.CAP_ROUND, dr.CAP_BUTT = y.CAP_FLAT, dr.CAP_FLAT = y.CAP_FLAT, dr.CAP_SQUARE = y.CAP_SQUARE, dr.MAX_PRECISION_DIGITS = 12;
            var pr = [
                "Point",
                "MultiPoint",
                "LineString",
                "MultiLineString",
                "Polygon",
                "MultiPolygon"
            ], yr = function() {
                function e(n) {
                    t(this, e), this.geometryFactory = n || new ae;
                }
                return n(e, [
                    {
                        key: "read",
                        value: function(t) {
                            var e, n = (e = "string" == typeof t ? JSON.parse(t) : t).type;
                            if (!mr[n]) throw new Error("Unknown GeoJSON type: " + e.type);
                            return -1 !== pr.indexOf(n) ? mr[n].call(this, e.coordinates) : "GeometryCollection" === n ? mr[n].call(this, e.geometries) : mr[n].call(this, e);
                        }
                    },
                    {
                        key: "write",
                        value: function(t) {
                            var e = t.getGeometryType();
                            if (!_r[e]) throw new Error("Geometry is not supported");
                            return _r[e].call(this, t);
                        }
                    }
                ]), e;
            }(), mr = {
                Feature: function(t) {
                    var e = {};
                    for(var n in t)e[n] = t[n];
                    if (t.geometry) {
                        var r = t.geometry.type;
                        if (!mr[r]) throw new Error("Unknown GeoJSON type: " + t.type);
                        e.geometry = this.read(t.geometry);
                    }
                    return t.bbox && (e.bbox = mr.bbox.call(this, t.bbox)), e;
                },
                FeatureCollection: function(t) {
                    var e = {};
                    if (t.features) {
                        e.features = [];
                        for(var n = 0; n < t.features.length; ++n)e.features.push(this.read(t.features[n]));
                    }
                    return t.bbox && (e.bbox = this.parse.bbox.call(this, t.bbox)), e;
                },
                coordinates: function(t) {
                    for(var e = [], n = 0; n < t.length; ++n){
                        var r = t[n];
                        e.push(a(j, v(r)));
                    }
                    return e;
                },
                bbox: function(t) {
                    return this.geometryFactory.createLinearRing([
                        new j(t[0], t[1]),
                        new j(t[2], t[1]),
                        new j(t[2], t[3]),
                        new j(t[0], t[3]),
                        new j(t[0], t[1])
                    ]);
                },
                Point: function(t) {
                    var e = a(j, v(t));
                    return this.geometryFactory.createPoint(e);
                },
                MultiPoint: function(t) {
                    for(var e = [], n = 0; n < t.length; ++n)e.push(mr.Point.call(this, t[n]));
                    return this.geometryFactory.createMultiPoint(e);
                },
                LineString: function(t) {
                    var e = mr.coordinates.call(this, t);
                    return this.geometryFactory.createLineString(e);
                },
                MultiLineString: function(t) {
                    for(var e = [], n = 0; n < t.length; ++n)e.push(mr.LineString.call(this, t[n]));
                    return this.geometryFactory.createMultiLineString(e);
                },
                Polygon: function(t) {
                    for(var e = mr.coordinates.call(this, t[0]), n = this.geometryFactory.createLinearRing(e), r = [], i = 1; i < t.length; ++i){
                        var o = t[i], s = mr.coordinates.call(this, o), a = this.geometryFactory.createLinearRing(s);
                        r.push(a);
                    }
                    return this.geometryFactory.createPolygon(n, r);
                },
                MultiPolygon: function(t) {
                    for(var e = [], n = 0; n < t.length; ++n){
                        var r = t[n];
                        e.push(mr.Polygon.call(this, r));
                    }
                    return this.geometryFactory.createMultiPolygon(e);
                },
                GeometryCollection: function(t) {
                    for(var e = [], n = 0; n < t.length; ++n){
                        var r = t[n];
                        e.push(this.read(r));
                    }
                    return this.geometryFactory.createGeometryCollection(e);
                }
            }, _r = {
                coordinate: function(t) {
                    var e = [
                        t.x,
                        t.y
                    ];
                    return t.z && e.push(t.z), t.m && e.push(t.m), e;
                },
                Point: function(t) {
                    return {
                        type: "Point",
                        coordinates: _r.coordinate.call(this, t.getCoordinate())
                    };
                },
                MultiPoint: function(t) {
                    for(var e = [], n = 0; n < t._geometries.length; ++n){
                        var r = t._geometries[n], i = _r.Point.call(this, r);
                        e.push(i.coordinates);
                    }
                    return {
                        type: "MultiPoint",
                        coordinates: e
                    };
                },
                LineString: function(t) {
                    for(var e = [], n = t.getCoordinates(), r = 0; r < n.length; ++r){
                        var i = n[r];
                        e.push(_r.coordinate.call(this, i));
                    }
                    return {
                        type: "LineString",
                        coordinates: e
                    };
                },
                MultiLineString: function(t) {
                    for(var e = [], n = 0; n < t._geometries.length; ++n){
                        var r = t._geometries[n], i = _r.LineString.call(this, r);
                        e.push(i.coordinates);
                    }
                    return {
                        type: "MultiLineString",
                        coordinates: e
                    };
                },
                Polygon: function(t) {
                    var e = [], n = _r.LineString.call(this, t._shell);
                    e.push(n.coordinates);
                    for(var r = 0; r < t._holes.length; ++r){
                        var i = t._holes[r], o = _r.LineString.call(this, i);
                        e.push(o.coordinates);
                    }
                    return {
                        type: "Polygon",
                        coordinates: e
                    };
                },
                MultiPolygon: function(t) {
                    for(var e = [], n = 0; n < t._geometries.length; ++n){
                        var r = t._geometries[n], i = _r.Polygon.call(this, r);
                        e.push(i.coordinates);
                    }
                    return {
                        type: "MultiPolygon",
                        coordinates: e
                    };
                },
                GeometryCollection: function(t) {
                    for(var e = [], n = 0; n < t._geometries.length; ++n){
                        var r = t._geometries[n], i = r.getGeometryType();
                        e.push(_r[i].call(this, r));
                    }
                    return {
                        type: "GeometryCollection",
                        geometries: e
                    };
                }
            };
            return {
                BufferOp: dr,
                GeoJSONReader: function() {
                    function e(n) {
                        t(this, e), this.parser = new yr(n || new ae);
                    }
                    return n(e, [
                        {
                            key: "read",
                            value: function(t) {
                                return this.parser.read(t);
                            }
                        }
                    ]), e;
                }(),
                GeoJSONWriter: function() {
                    function e() {
                        t(this, e), this.parser = new yr(this.geometryFactory);
                    }
                    return n(e, [
                        {
                            key: "write",
                            value: function(t) {
                                return this.parser.write(t);
                            }
                        }
                    ]), e;
                }()
            };
        }();
    }(vr)), vr.exports), dr = Jn(gr), pr = function() {
        return s(function t() {
            i(this, t), this._partials = new Float64Array(32), this._n = 0;
        }, [
            {
                key: "add",
                value: function(t) {
                    for(var e = this._partials, n = 0, r = 0; r < this._n && r < 32; r++){
                        var i = e[r], o = t + i, s = Math.abs(t) < Math.abs(i) ? t - (o - i) : i - (o - t);
                        s && (e[n++] = s), t = o;
                    }
                    return e[n] = t, this._n = n + 1, this;
                }
            },
            {
                key: "valueOf",
                value: function() {
                    var t, e, n, r = this._partials, i = this._n, o = 0;
                    if (i > 0) {
                        for(o = r[--i]; i > 0 && (t = o, !(n = (e = r[--i]) - ((o = t + e) - t))););
                        i > 0 && (n < 0 && r[i - 1] < 0 || n > 0 && r[i - 1] > 0) && (e = 2 * n) == (t = o + e) - o && (o = t);
                    }
                    return o;
                }
            }
        ]);
    }(), yr = g().m(mr);
    function mr(t) {
        var e, n, r, i;
        return g().w(function(o) {
            for(;;)switch(o.p = o.n){
                case 0:
                    e = a(t), o.p = 1, e.s();
                case 2:
                    if ((n = e.n()).done) {
                        o.n = 4;
                        break;
                    }
                    return r = n.value, o.d(p(r), 3);
                case 3:
                    o.n = 2;
                    break;
                case 4:
                    o.n = 6;
                    break;
                case 5:
                    o.p = 5, i = o.v, e.e(i);
                case 6:
                    return o.p = 6, e.f(), o.f(6);
                case 7:
                    return o.a(2);
            }
        }, yr, null, [
            [
                1,
                5,
                6,
                7
            ]
        ]);
    }
    function _r(t) {
        return Array.from(mr(t));
    }
    var xr = 1e-6, Er = Math.PI, kr = Er / 2, wr = Er / 4, br = 2 * Er, Ir = 180 / Er, Nr = Er / 180, Sr = Math.abs, Mr = Math.atan, Lr = Math.atan2, Pr = Math.cos, Cr = Math.sin, Tr = Math.sign || function(t) {
        return t > 0 ? 1 : t < 0 ? -1 : 0;
    }, Or = Math.sqrt;
    function Rr(t) {
        return t > 1 ? 0 : t < -1 ? Er : Math.acos(t);
    }
    function Ar(t) {
        return t > 1 ? kr : t < -1 ? -kr : Math.asin(t);
    }
    function Dr() {}
    function Fr(t, e) {
        t && Gr.hasOwnProperty(t.type) && Gr[t.type](t, e);
    }
    var qr = {
        Feature: function(t, e) {
            Fr(t.geometry, e);
        },
        FeatureCollection: function(t, e) {
            for(var n = t.features, r = -1, i = n.length; ++r < i;)Fr(n[r].geometry, e);
        }
    }, Gr = {
        Sphere: function(t, e) {
            e.sphere();
        },
        Point: function(t, e) {
            t = t.coordinates, e.point(t[0], t[1], t[2]);
        },
        MultiPoint: function(t, e) {
            for(var n = t.coordinates, r = -1, i = n.length; ++r < i;)t = n[r], e.point(t[0], t[1], t[2]);
        },
        LineString: function(t, e) {
            Yr(t.coordinates, e, 0);
        },
        MultiLineString: function(t, e) {
            for(var n = t.coordinates, r = -1, i = n.length; ++r < i;)Yr(n[r], e, 0);
        },
        Polygon: function(t, e) {
            Br(t.coordinates, e);
        },
        MultiPolygon: function(t, e) {
            for(var n = t.coordinates, r = -1, i = n.length; ++r < i;)Br(n[r], e);
        },
        GeometryCollection: function(t, e) {
            for(var n = t.geometries, r = -1, i = n.length; ++r < i;)Fr(n[r], e);
        }
    };
    function Yr(t, e, n) {
        var r, i = -1, o = t.length - n;
        for(e.lineStart(); ++i < o;)r = t[i], e.point(r[0], r[1], r[2]);
        e.lineEnd();
    }
    function Br(t, e) {
        var n = -1, r = t.length;
        for(e.polygonStart(); ++n < r;)Yr(t[n], e, 1);
        e.polygonEnd();
    }
    function zr(t) {
        return [
            Lr(t[1], t[0]),
            Ar(t[2])
        ];
    }
    function jr(t) {
        var e = t[0], n = t[1], r = Pr(n);
        return [
            r * Pr(e),
            r * Cr(e),
            Cr(n)
        ];
    }
    function Xr(t, e) {
        return t[0] * e[0] + t[1] * e[1] + t[2] * e[2];
    }
    function Ur(t, e) {
        return [
            t[1] * e[2] - t[2] * e[1],
            t[2] * e[0] - t[0] * e[2],
            t[0] * e[1] - t[1] * e[0]
        ];
    }
    function Vr(t, e) {
        t[0] += e[0], t[1] += e[1], t[2] += e[2];
    }
    function Zr(t, e) {
        return [
            t[0] * e,
            t[1] * e,
            t[2] * e
        ];
    }
    function Hr(t) {
        var e = Or(t[0] * t[0] + t[1] * t[1] + t[2] * t[2]);
        t[0] /= e, t[1] /= e, t[2] /= e;
    }
    function Wr(t, e) {
        function n(n, r) {
            return n = t(n, r), e(n[0], n[1]);
        }
        return t.invert && e.invert && (n.invert = function(n, r) {
            return (n = e.invert(n, r)) && t.invert(n[0], n[1]);
        }), n;
    }
    function Jr(t, e) {
        return [
            Sr(t) > Er ? t + Math.round(-t / br) * br : t,
            e
        ];
    }
    function Kr(t) {
        return function(e, n) {
            return [
                (e += t) > Er ? e - br : e < -Er ? e + br : e,
                n
            ];
        };
    }
    function Qr(t) {
        var e = Kr(t);
        return e.invert = Kr(-t), e;
    }
    function $r(t, e) {
        var n = Pr(t), r = Cr(t), i = Pr(e), o = Cr(e);
        function s(t, e) {
            var s = Pr(e), a = Pr(t) * s, u = Cr(t) * s, l = Cr(e), h = l * n + a * r;
            return [
                Lr(u * i - h * o, a * n - l * r),
                Ar(h * i + u * o)
            ];
        }
        return s.invert = function(t, e) {
            var s = Pr(e), a = Pr(t) * s, u = Cr(t) * s, l = Cr(e), h = l * i - u * o;
            return [
                Lr(u * i + l * o, a * n + h * r),
                Ar(h * n - a * r)
            ];
        }, s;
    }
    function ti(t, e) {
        (e = jr(e))[0] -= t, Hr(e);
        var n = Rr(-e[1]);
        return ((-e[2] < 0 ? -n : n) + br - xr) % br;
    }
    function ei() {
        var t, e = [];
        return {
            point: function(e, n, r) {
                t.push([
                    e,
                    n,
                    r
                ]);
            },
            lineStart: function() {
                e.push(t = []);
            },
            lineEnd: Dr,
            rejoin: function() {
                e.length > 1 && e.push(e.pop().concat(e.shift()));
            },
            result: function() {
                var n = e;
                return e = [], t = null, n;
            }
        };
    }
    function ni(t, e) {
        return Sr(t[0] - e[0]) < xr && Sr(t[1] - e[1]) < xr;
    }
    function ri(t, e, n, r) {
        this.x = t, this.z = e, this.o = n, this.e = r, this.v = !1, this.n = this.p = null;
    }
    function ii(t, e, n, r, i) {
        var o, s, a = [], u = [];
        if (t.forEach(function(t) {
            if (!((e = t.length - 1) <= 0)) {
                var e, n, r = t[0], s = t[e];
                if (ni(r, s)) {
                    if (!r[2] && !s[2]) {
                        for(i.lineStart(), o = 0; o < e; ++o)i.point((r = t[o])[0], r[1]);
                        return void i.lineEnd();
                    }
                    s[0] += 2e-6;
                }
                a.push(n = new ri(r, t, null, !0)), u.push(n.o = new ri(r, null, n, !1)), a.push(n = new ri(s, t, null, !1)), u.push(n.o = new ri(s, null, n, !0));
            }
        }), a.length) {
            for(u.sort(e), oi(a), oi(u), o = 0, s = u.length; o < s; ++o)u[o].e = n = !n;
            for(var l, h, c = a[0];;){
                for(var f = c, v = !0; f.v;)if ((f = f.n) === c) return;
                l = f.z, i.lineStart();
                do {
                    if (f.v = f.o.v = !0, f.e) {
                        if (v) for(o = 0, s = l.length; o < s; ++o)i.point((h = l[o])[0], h[1]);
                        else r(f.x, f.n.x, 1, i);
                        f = f.n;
                    } else {
                        if (v) for(l = f.p.z, o = l.length - 1; o >= 0; --o)i.point((h = l[o])[0], h[1]);
                        else r(f.x, f.p.x, -1, i);
                        f = f.p;
                    }
                    l = (f = f.o).z, v = !v;
                }while (!f.v);
                i.lineEnd();
            }
        }
    }
    function oi(t) {
        if (e = t.length) {
            for(var e, n, r = 0, i = t[0]; ++r < e;)i.n = n = t[r], n.p = i, i = n;
            i.n = n = t[0], n.p = i;
        }
    }
    function si(t) {
        return Sr(t[0]) <= Er ? t[0] : Tr(t[0]) * ((Sr(t[0]) + Er) % br - Er);
    }
    function ai(t, e, n, r) {
        return function(i) {
            var o, s, a, u = e(i), l = ei(), h = e(l), c = !1, f = {
                point: v,
                lineStart: d,
                lineEnd: p,
                polygonStart: function() {
                    f.point = y, f.lineStart = m, f.lineEnd = _, s = [], o = [];
                },
                polygonEnd: function() {
                    f.point = v, f.lineStart = d, f.lineEnd = p, s = _r(s);
                    var t = function(t, e) {
                        var n = si(e), r = e[1], i = Cr(r), o = [
                            Cr(n),
                            -Pr(n),
                            0
                        ], s = 0, a = 0, u = new pr;
                        1 === i ? r = kr + xr : -1 === i && (r = -kr - xr);
                        for(var l = 0, h = t.length; l < h; ++l)if (f = (c = t[l]).length) for(var c, f, v = c[f - 1], g = si(v), d = v[1] / 2 + wr, p = Cr(d), y = Pr(d), m = 0; m < f; ++m, g = x, p = k, y = w, v = _){
                            var _ = c[m], x = si(_), E = _[1] / 2 + wr, k = Cr(E), w = Pr(E), b = x - g, I = b >= 0 ? 1 : -1, N = I * b, S = N > Er, M = p * k;
                            if (u.add(Lr(M * I * Cr(N), y * w + M * Pr(N))), s += S ? b + I * br : b, S ^ g >= n ^ x >= n) {
                                var L = Ur(jr(v), jr(_));
                                Hr(L);
                                var P = Ur(o, L);
                                Hr(P);
                                var C = (S ^ b >= 0 ? -1 : 1) * Ar(P[2]);
                                (r > C || r === C && (L[0] || L[1])) && (a += S ^ b >= 0 ? 1 : -1);
                            }
                        }
                        return (s < -0.000001 || s < xr && u < -0.000000000001) ^ 1 & a;
                    }(o, r);
                    s.length ? (c || (i.polygonStart(), c = !0), ii(s, li, t, n, i)) : t && (c || (i.polygonStart(), c = !0), i.lineStart(), n(null, null, 1, i), i.lineEnd()), c && (i.polygonEnd(), c = !1), s = o = null;
                },
                sphere: function() {
                    i.polygonStart(), i.lineStart(), n(null, null, 1, i), i.lineEnd(), i.polygonEnd();
                }
            };
            function v(e, n) {
                t(e, n) && i.point(e, n);
            }
            function g(t, e) {
                u.point(t, e);
            }
            function d() {
                f.point = g, u.lineStart();
            }
            function p() {
                f.point = v, u.lineEnd();
            }
            function y(t, e) {
                a.push([
                    t,
                    e
                ]), h.point(t, e);
            }
            function m() {
                h.lineStart(), a = [];
            }
            function _() {
                y(a[0][0], a[0][1]), h.lineEnd();
                var t, e, n, r, u = h.clean(), f = l.result(), v = f.length;
                if (a.pop(), o.push(a), a = null, v) {
                    if (1 & u) {
                        if ((e = (n = f[0]).length - 1) > 0) {
                            for(c || (i.polygonStart(), c = !0), i.lineStart(), t = 0; t < e; ++t)i.point((r = n[t])[0], r[1]);
                            i.lineEnd();
                        }
                    } else v > 1 && 2 & u && f.push(f.pop().concat(f.shift())), s.push(f.filter(ui));
                }
            }
            return f;
        };
    }
    function ui(t) {
        return t.length > 1;
    }
    function li(t, e) {
        return ((t = t.x)[0] < 0 ? t[1] - kr - xr : kr - t[1]) - ((e = e.x)[0] < 0 ? e[1] - kr - xr : kr - e[1]);
    }
    Jr.invert = Jr;
    var hi = ai(function() {
        return !0;
    }, function(t) {
        var e, n = NaN, r = NaN, i = NaN;
        return {
            lineStart: function() {
                t.lineStart(), e = 1;
            },
            point: function(o, s) {
                var a = o > 0 ? Er : -Er, u = Sr(o - n);
                Sr(u - Er) < xr ? (t.point(n, r = (r + s) / 2 > 0 ? kr : -kr), t.point(i, r), t.lineEnd(), t.lineStart(), t.point(a, r), t.point(o, r), e = 0) : i !== a && u >= Er && (Sr(n - i) < xr && (n -= i * xr), Sr(o - a) < xr && (o -= a * xr), r = function(t, e, n, r) {
                    var i, o, s = Cr(t - n);
                    return Sr(s) > xr ? Mr((Cr(e) * (o = Pr(r)) * Cr(n) - Cr(r) * (i = Pr(e)) * Cr(t)) / (i * o * s)) : (e + r) / 2;
                }(n, r, o, s), t.point(i, r), t.lineEnd(), t.lineStart(), t.point(a, r), e = 0), t.point(n = o, r = s), i = a;
            },
            lineEnd: function() {
                t.lineEnd(), n = r = NaN;
            },
            clean: function() {
                return 2 - e;
            }
        };
    }, function(t, e, n, r) {
        var i;
        if (null == t) i = n * kr, r.point(-Er, i), r.point(0, i), r.point(Er, i), r.point(Er, 0), r.point(Er, -i), r.point(0, -i), r.point(-Er, -i), r.point(-Er, 0), r.point(-Er, i);
        else if (Sr(t[0] - e[0]) > xr) {
            var o = t[0] < e[0] ? Er : -Er;
            i = n * o / 2, r.point(-o, i), r.point(0, i), r.point(o, i);
        } else r.point(e[0], e[1]);
    }, [
        -Er,
        -kr
    ]);
    function ci(t) {
        var e = Pr(t), n = 6 * Nr, r = e > 0, i = Sr(e) > xr;
        function o(t, n) {
            return Pr(t) * Pr(n) > e;
        }
        function s(t, n, r) {
            var i = [
                1,
                0,
                0
            ], o = Ur(jr(t), jr(n)), s = Xr(o, o), a = o[0], u = s - a * a;
            if (!u) return !r && t;
            var l = e * s / u, h = -e * a / u, c = Ur(i, o), f = Zr(i, l);
            Vr(f, Zr(o, h));
            var v = c, g = Xr(f, v), d = Xr(v, v), p = g * g - d * (Xr(f, f) - 1);
            if (!(p < 0)) {
                var y = Or(p), m = Zr(v, (-g - y) / d);
                if (Vr(m, f), m = zr(m), !r) return m;
                var _, x = t[0], E = n[0], k = t[1], w = n[1];
                E < x && (_ = x, x = E, E = _);
                var b = E - x, I = Sr(b - Er) < xr;
                if (!I && w < k && (_ = k, k = w, w = _), I || b < xr ? I ? k + w > 0 ^ m[1] < (Sr(m[0] - x) < xr ? k : w) : k <= m[1] && m[1] <= w : b > Er ^ (x <= m[0] && m[0] <= E)) {
                    var N = Zr(v, (-g + y) / d);
                    return Vr(N, f), [
                        m,
                        zr(N)
                    ];
                }
            }
        }
        function a(e, n) {
            var i = r ? t : Er - t, o = 0;
            return e < -i ? o |= 1 : e > i && (o |= 2), n < -i ? o |= 4 : n > i && (o |= 8), o;
        }
        return ai(o, function(t) {
            var e, n, u, l, h;
            return {
                lineStart: function() {
                    l = u = !1, h = 1;
                },
                point: function(c, f) {
                    var v, g = [
                        c,
                        f
                    ], d = o(c, f), p = r ? d ? 0 : a(c, f) : d ? a(c + (c < 0 ? Er : -Er), f) : 0;
                    if (!e && (l = u = d) && t.lineStart(), d !== u && (!(v = s(e, g)) || ni(e, v) || ni(g, v)) && (g[2] = 1), d !== u) h = 0, d ? (t.lineStart(), v = s(g, e), t.point(v[0], v[1])) : (v = s(e, g), t.point(v[0], v[1], 2), t.lineEnd()), e = v;
                    else if (i && e && r ^ d) {
                        var y;
                        p & n || !(y = s(g, e, !0)) || (h = 0, r ? (t.lineStart(), t.point(y[0][0], y[0][1]), t.point(y[1][0], y[1][1]), t.lineEnd()) : (t.point(y[1][0], y[1][1]), t.lineEnd(), t.lineStart(), t.point(y[0][0], y[0][1], 3)));
                    }
                    !d || e && ni(e, g) || t.point(g[0], g[1]), e = g, u = d, n = p;
                },
                lineEnd: function() {
                    u && t.lineEnd(), e = null;
                },
                clean: function() {
                    return h | (l && u) << 1;
                }
            };
        }, function(e, r, i, o) {
            !function(t, e, n, r, i, o) {
                if (n) {
                    var s = Pr(e), a = Cr(e), u = r * n;
                    null == i ? (i = e + r * br, o = e - u / 2) : (i = ti(s, i), o = ti(s, o), (r > 0 ? i < o : i > o) && (i += r * br));
                    for(var l, h = i; r > 0 ? h > o : h < o; h -= u)l = zr([
                        s,
                        -a * Pr(h),
                        -a * Cr(h)
                    ]), t.point(l[0], l[1]);
                }
            }(o, t, n, i, e, r);
        }, r ? [
            0,
            -t
        ] : [
            -Er,
            t - Er
        ]);
    }
    var fi = 1e9, vi = -fi;
    function gi(t, e, n, r) {
        function i(i, o) {
            return t <= i && i <= n && e <= o && o <= r;
        }
        function o(i, o, a, l) {
            var h = 0, c = 0;
            if (null == i || (h = s(i, a)) !== (c = s(o, a)) || u(i, o) < 0 ^ a > 0) do l.point(0 === h || 3 === h ? t : n, h > 1 ? r : e);
            while ((h = (h + a + 4) % 4) !== c);
            else l.point(o[0], o[1]);
        }
        function s(r, i) {
            return Sr(r[0] - t) < xr ? i > 0 ? 0 : 3 : Sr(r[0] - n) < xr ? i > 0 ? 2 : 1 : Sr(r[1] - e) < xr ? i > 0 ? 1 : 0 : i > 0 ? 3 : 2;
        }
        function a(t, e) {
            return u(t.x, e.x);
        }
        function u(t, e) {
            var n = s(t, 1), r = s(e, 1);
            return n !== r ? n - r : 0 === n ? e[1] - t[1] : 1 === n ? t[0] - e[0] : 2 === n ? t[1] - e[1] : e[0] - t[0];
        }
        return function(s) {
            var u, l, h, c, f, v, g, d, p, y, m, _ = s, x = ei(), E = {
                point: k,
                lineStart: function() {
                    E.point = w, l && l.push(h = []);
                    y = !0, p = !1, g = d = NaN;
                },
                lineEnd: function() {
                    u && (w(c, f), v && p && x.rejoin(), u.push(x.result()));
                    E.point = k, p && _.lineEnd();
                },
                polygonStart: function() {
                    _ = x, u = [], l = [], m = !0;
                },
                polygonEnd: function() {
                    var e = function() {
                        for(var e = 0, n = 0, i = l.length; n < i; ++n)for(var o, s, a = l[n], u = 1, h = a.length, c = a[0], f = c[0], v = c[1]; u < h; ++u)o = f, s = v, f = (c = a[u])[0], v = c[1], s <= r ? v > r && (f - o) * (r - s) > (v - s) * (t - o) && ++e : v <= r && (f - o) * (r - s) < (v - s) * (t - o) && --e;
                        return e;
                    }(), n = m && e, i = (u = _r(u)).length;
                    (n || i) && (s.polygonStart(), n && (s.lineStart(), o(null, null, 1, s), s.lineEnd()), i && ii(u, a, e, o, s), s.polygonEnd());
                    _ = s, u = l = h = null;
                }
            };
            function k(t, e) {
                i(t, e) && _.point(t, e);
            }
            function w(o, s) {
                var a = i(o, s);
                if (l && h.push([
                    o,
                    s
                ]), y) c = o, f = s, v = a, y = !1, a && (_.lineStart(), _.point(o, s));
                else if (a && p) _.point(o, s);
                else {
                    var u = [
                        g = Math.max(vi, Math.min(fi, g)),
                        d = Math.max(vi, Math.min(fi, d))
                    ], x = [
                        o = Math.max(vi, Math.min(fi, o)),
                        s = Math.max(vi, Math.min(fi, s))
                    ];
                    !function(t, e, n, r, i, o) {
                        var s, a = t[0], u = t[1], l = 0, h = 1, c = e[0] - a, f = e[1] - u;
                        if (s = n - a, c || !(s > 0)) {
                            if (s /= c, c < 0) {
                                if (s < l) return;
                                s < h && (h = s);
                            } else if (c > 0) {
                                if (s > h) return;
                                s > l && (l = s);
                            }
                            if (s = i - a, c || !(s < 0)) {
                                if (s /= c, c < 0) {
                                    if (s > h) return;
                                    s > l && (l = s);
                                } else if (c > 0) {
                                    if (s < l) return;
                                    s < h && (h = s);
                                }
                                if (s = r - u, f || !(s > 0)) {
                                    if (s /= f, f < 0) {
                                        if (s < l) return;
                                        s < h && (h = s);
                                    } else if (f > 0) {
                                        if (s > h) return;
                                        s > l && (l = s);
                                    }
                                    if (s = o - u, f || !(s < 0)) {
                                        if (s /= f, f < 0) {
                                            if (s > h) return;
                                            s > l && (l = s);
                                        } else if (f > 0) {
                                            if (s < l) return;
                                            s < h && (h = s);
                                        }
                                        return l > 0 && (t[0] = a + l * c, t[1] = u + l * f), h < 1 && (e[0] = a + h * c, e[1] = u + h * f), !0;
                                    }
                                }
                            }
                        }
                    }(u, x, t, e, n, r) ? a && (_.lineStart(), _.point(o, s), m = !1) : (p || (_.lineStart(), _.point(u[0], u[1])), _.point(x[0], x[1]), a || _.lineEnd(), m = !1);
                }
                g = o, d = s, p = a;
            }
            return E;
        };
    }
    var di = function(t) {
        return t;
    }, pi = 1 / 0, yi = pi, mi = -pi, _i = mi, xi = {
        point: function(t, e) {
            t < pi && (pi = t);
            t > mi && (mi = t);
            e < yi && (yi = e);
            e > _i && (_i = e);
        },
        lineStart: Dr,
        lineEnd: Dr,
        polygonStart: Dr,
        polygonEnd: Dr,
        result: function() {
            var t = [
                [
                    pi,
                    yi
                ],
                [
                    mi,
                    _i
                ]
            ];
            return mi = _i = -(yi = pi = 1 / 0), t;
        }
    };
    function Ei(t) {
        return function(e) {
            var n = new ki;
            for(var r in t)n[r] = t[r];
            return n.stream = e, n;
        };
    }
    function ki() {}
    function wi(t, e, n) {
        var r = t.clipExtent && t.clipExtent();
        return t.scale(150).translate([
            0,
            0
        ]), null != r && t.clipExtent(null), function(t, e) {
            t && qr.hasOwnProperty(t.type) ? qr[t.type](t, e) : Fr(t, e);
        }(n, t.stream(xi)), e(xi.result()), null != r && t.clipExtent(r), t;
    }
    function bi(t, e, n) {
        return wi(t, function(n) {
            var r = e[1][0] - e[0][0], i = e[1][1] - e[0][1], o = Math.min(r / (n[1][0] - n[0][0]), i / (n[1][1] - n[0][1])), s = +e[0][0] + (r - o * (n[1][0] + n[0][0])) / 2, a = +e[0][1] + (i - o * (n[1][1] + n[0][1])) / 2;
            t.scale(150 * o).translate([
                s,
                a
            ]);
        }, n);
    }
    ki.prototype = {
        constructor: ki,
        point: function(t, e) {
            this.stream.point(t, e);
        },
        sphere: function() {
            this.stream.sphere();
        },
        lineStart: function() {
            this.stream.lineStart();
        },
        lineEnd: function() {
            this.stream.lineEnd();
        },
        polygonStart: function() {
            this.stream.polygonStart();
        },
        polygonEnd: function() {
            this.stream.polygonEnd();
        }
    };
    var Ii = Pr(30 * Nr);
    function Ni(t, e) {
        return +e ? function(t, e) {
            function n(r, i, o, s, a, u, l, h, c, f, v, g, d, p) {
                var y = l - r, m = h - i, _ = y * y + m * m;
                if (_ > 4 * e && d--) {
                    var x = s + f, E = a + v, k = u + g, w = Or(x * x + E * E + k * k), b = Ar(k /= w), I = Sr(Sr(k) - 1) < xr || Sr(o - c) < xr ? (o + c) / 2 : Lr(E, x), N = t(I, b), S = N[0], M = N[1], L = S - r, P = M - i, C = m * L - y * P;
                    (C * C / _ > e || Sr((y * L + m * P) / _ - .5) > .3 || s * f + a * v + u * g < Ii) && (n(r, i, o, s, a, u, S, M, I, x /= w, E /= w, k, d, p), p.point(S, M), n(S, M, I, x, E, k, l, h, c, f, v, g, d, p));
                }
            }
            return function(e) {
                var r, i, o, s, a, u, l, h, c, f, v, g, d = {
                    point: p,
                    lineStart: y,
                    lineEnd: _,
                    polygonStart: function() {
                        e.polygonStart(), d.lineStart = x;
                    },
                    polygonEnd: function() {
                        e.polygonEnd(), d.lineStart = y;
                    }
                };
                function p(n, r) {
                    n = t(n, r), e.point(n[0], n[1]);
                }
                function y() {
                    h = NaN, d.point = m, e.lineStart();
                }
                function m(r, i) {
                    var o = jr([
                        r,
                        i
                    ]), s = t(r, i);
                    n(h, c, l, f, v, g, h = s[0], c = s[1], l = r, f = o[0], v = o[1], g = o[2], 16, e), e.point(h, c);
                }
                function _() {
                    d.point = p, e.lineEnd();
                }
                function x() {
                    y(), d.point = E, d.lineEnd = k;
                }
                function E(t, e) {
                    m(r = t, e), i = h, o = c, s = f, a = v, u = g, d.point = m;
                }
                function k() {
                    n(h, c, l, f, v, g, i, o, r, s, a, u, 16, e), d.lineEnd = _, _();
                }
                return d;
            };
        }(t, e) : function(t) {
            return Ei({
                point: function(e, n) {
                    e = t(e, n), this.stream.point(e[0], e[1]);
                }
            });
        }(t);
    }
    var Si = Ei({
        point: function(t, e) {
            this.stream.point(t * Nr, e * Nr);
        }
    });
    function Mi(t, e, n, r, i, o) {
        if (!o) return function(t, e, n, r, i) {
            function o(o, s) {
                return [
                    e + t * (o *= r),
                    n - t * (s *= i)
                ];
            }
            return o.invert = function(o, s) {
                return [
                    (o - e) / t * r,
                    (n - s) / t * i
                ];
            }, o;
        }(t, e, n, r, i);
        var s = Pr(o), a = Cr(o), u = s * t, l = a * t, h = s / t, c = a / t, f = (a * n - s * e) / t, v = (a * e + s * n) / t;
        function g(t, o) {
            return [
                u * (t *= r) - l * (o *= i) + e,
                n - l * t - u * o
            ];
        }
        return g.invert = function(t, e) {
            return [
                r * (h * t - c * e + f),
                i * (v - c * t - h * e)
            ];
        }, g;
    }
    function Li(t) {
        return (function(t) {
            var e, n, r, i, o, s, a, u, l, h, c = 150, f = 480, v = 250, g = 0, d = 0, p = 0, y = 0, m = 0, _ = 0, x = 1, E = 1, k = null, w = hi, b = null, I = di, N = .5;
            function S(t) {
                return u(t[0] * Nr, t[1] * Nr);
            }
            function M(t) {
                return (t = u.invert(t[0], t[1])) && [
                    t[0] * Ir,
                    t[1] * Ir
                ];
            }
            function L() {
                var t = Mi(c, 0, 0, x, E, _).apply(null, e(g, d)), r = Mi(c, f - t[0], v - t[1], x, E, _);
                return n = function(t, e, n) {
                    return (t %= br) ? e || n ? Wr(Qr(t), $r(e, n)) : Qr(t) : e || n ? $r(e, n) : Jr;
                }(p, y, m), a = Wr(e, r), u = Wr(n, a), s = Ni(a, N), P();
            }
            function P() {
                return l = h = null, S;
            }
            return S.stream = function(t) {
                return l && h === t ? l : l = Si((function(t) {
                    return Ei({
                        point: function(e, n) {
                            var r = t(e, n);
                            return this.stream.point(r[0], r[1]);
                        }
                    });
                })(n)(w(s(I(h = t)))));
            }, S.preclip = function(t) {
                return arguments.length ? (w = t, k = void 0, P()) : w;
            }, S.postclip = function(t) {
                return arguments.length ? (I = t, b = r = i = o = null, P()) : I;
            }, S.clipAngle = function(t) {
                return arguments.length ? (w = +t ? ci(k = t * Nr) : (k = null, hi), P()) : k * Ir;
            }, S.clipExtent = function(t) {
                return arguments.length ? (I = null == t ? (b = r = i = o = null, di) : gi(b = +t[0][0], r = +t[0][1], i = +t[1][0], o = +t[1][1]), P()) : null == b ? null : [
                    [
                        b,
                        r
                    ],
                    [
                        i,
                        o
                    ]
                ];
            }, S.scale = function(t) {
                return arguments.length ? (c = +t, L()) : c;
            }, S.translate = function(t) {
                return arguments.length ? (f = +t[0], v = +t[1], L()) : [
                    f,
                    v
                ];
            }, S.center = function(t) {
                return arguments.length ? (g = t[0] % 360 * Nr, d = t[1] % 360 * Nr, L()) : [
                    g * Ir,
                    d * Ir
                ];
            }, S.rotate = function(t) {
                return arguments.length ? (p = t[0] % 360 * Nr, y = t[1] % 360 * Nr, m = t.length > 2 ? t[2] % 360 * Nr : 0, L()) : [
                    p * Ir,
                    y * Ir,
                    m * Ir
                ];
            }, S.angle = function(t) {
                return arguments.length ? (_ = t % 360 * Nr, L()) : _ * Ir;
            }, S.reflectX = function(t) {
                return arguments.length ? (x = t ? -1 : 1, L()) : x < 0;
            }, S.reflectY = function(t) {
                return arguments.length ? (E = t ? -1 : 1, L()) : E < 0;
            }, S.precision = function(t) {
                return arguments.length ? (s = Ni(a, N = t * t), P()) : Or(N);
            }, S.fitExtent = function(t, e) {
                return bi(S, t, e);
            }, S.fitSize = function(t, e) {
                return function(t, e, n) {
                    return bi(t, [
                        [
                            0,
                            0
                        ],
                        e
                    ], n);
                }(S, t, e);
            }, S.fitWidth = function(t, e) {
                return function(t, e, n) {
                    return wi(t, function(n) {
                        var r = +e, i = r / (n[1][0] - n[0][0]), o = (r - i * (n[1][0] + n[0][0])) / 2, s = -i * n[0][1];
                        t.scale(150 * i).translate([
                            o,
                            s
                        ]);
                    }, n);
                }(S, t, e);
            }, S.fitHeight = function(t, e) {
                return function(t, e, n) {
                    return wi(t, function(n) {
                        var r = +e, i = r / (n[1][1] - n[0][1]), o = -i * n[0][0], s = (r - i * (n[1][1] + n[0][1])) / 2;
                        t.scale(150 * i).translate([
                            o,
                            s
                        ]);
                    }, n);
                }(S, t, e);
            }, function() {
                return e = t.apply(this, arguments), S.invert = e.invert && M, L();
            };
        })(function() {
            return t;
        })();
    }
    var Pi = function(t) {
        return function(e, n) {
            var r = Pr(e), i = Pr(n), o = t(r * i);
            return o === 1 / 0 ? [
                2,
                0
            ] : [
                o * i * Cr(e),
                o * Cr(n)
            ];
        };
    }(function(t) {
        return (t = Rr(t)) && t / Cr(t);
    });
    function Ci() {
        return Li(Pi).scale(79.4188).clipAngle(179.999);
    }
    Pi.invert = function(t) {
        return function(e, n) {
            var r = Or(e * e + n * n), i = t(r), o = Cr(i), s = Pr(i);
            return [
                Lr(e * o, r * s),
                Ar(r && n * o / r)
            ];
        };
    }(function(t) {
        return t;
    });
    var Ti = dr.BufferOp, Oi = dr.GeoJSONReader, Ri = dr.GeoJSONWriter;
    function Ai(t, e, n, r) {
        var i = t.properties || {}, o = "Feature" === t.type ? t.geometry : t;
        if ("GeometryCollection" === o.type) {
            var s = [];
            return kt(t, function(t) {
                var i = Ai(t, e, n, r);
                i && s.push(i);
            }), R(s);
        }
        var a = function(t) {
            var e = cr(t).geometry.coordinates, n = [
                -e[0],
                -e[1]
            ];
            return Ci().rotate(n).scale(w);
        }(o), u = {
            type: o.type,
            coordinates: Fi(o.coordinates, a)
        }, l = (new Oi).read(u), h = Y(B(e, n), "meters"), c = Ti.bufferOp(l, h, r);
        if (!Di((c = (new Ri).write(c)).coordinates)) return N({
            type: c.type,
            coordinates: qi(c.coordinates, a)
        }, i);
    }
    function Di(t) {
        return Array.isArray(t[0]) ? Di(t[0]) : isNaN(t[0]);
    }
    function Fi(t, e) {
        return "object" !== E(t[0]) ? e(t) : t.map(function(t) {
            return Fi(t, e);
        });
    }
    function qi(t, e) {
        return "object" !== E(t[0]) ? e.invert(t) : t.map(function(t) {
            return qi(t, e);
        });
    }
    function Gi(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = 0, r = 0, i = 0;
        return kt(t, function(t, o, s) {
            var a = e.weight ? null == s ? void 0 : s[e.weight] : void 0;
            if (!W(a = null == a ? 1 : a)) throw new Error("weight value must be a number for feature index " + o);
            (a = Number(a)) > 0 && dt(t, function(t) {
                n += t[0] * a, r += t[1] * a, i += a;
            });
        }), M([
            n / i,
            r / i
        ], e.properties, e);
    }
    function Yi(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = 0, r = 0, i = 0;
        return dt(t, function(t) {
            n += t[0], r += t[1], i++;
        }, !0), M([
            n / i,
            r / i
        ], e.properties);
    }
    function Bi(t, e, n, r, i) {
        var o = r.tolerance || .001, s = 0, a = 0, u = 0, l = 0;
        if (_t(n, function(e) {
            var n, r = null == (n = e.properties) ? void 0 : n.weight, i = null == r ? 1 : r;
            if (!W(i = Number(i))) throw new Error("weight value must be a number");
            if (i > 0) {
                l += 1;
                var o = i * ft(e, t);
                0 === o && (o = 1);
                var h = i / o;
                s += e.geometry.coordinates[0] * h, a += e.geometry.coordinates[1] * h, u += h;
            }
        }), l < 1) throw new Error("no features to measure");
        var h = s / u, c = a / u;
        return 1 === l || 0 === i || Math.abs(h - e[0]) < o && Math.abs(c - e[1]) < o ? M([
            h,
            c
        ], {
            medianCandidates: r.medianCandidates
        }) : (r.medianCandidates.push([
            h,
            c
        ]), Bi([
            h,
            c
        ], t, n, r, i - 1));
    }
    var zi, ji, Xi, Ui, Vi, Zi = {
        exports: {}
    }, Hi = Kn(de), Wi = Kn(we), Ji = {
        exports: {}
    };
    function Ki() {
        if (Vi) return Ji.exports;
        Vi = 1;
        var t = (ji || (ji = 1, zi = function(t, e, n, r) {
            var i = t[0], o = t[1], s = !1;
            void 0 === n && (n = 0), void 0 === r && (r = e.length);
            for(var a = (r - n) / 2, u = 0, l = a - 1; u < a; l = u++){
                var h = e[n + 2 * u + 0], c = e[n + 2 * u + 1], f = e[n + 2 * l + 0], v = e[n + 2 * l + 1];
                c > o != v > o && i < (f - h) * (o - c) / (v - c) + h && (s = !s);
            }
            return s;
        }), zi), e = (Ui || (Ui = 1, Xi = function(t, e, n, r) {
            var i = t[0], o = t[1], s = !1;
            void 0 === n && (n = 0), void 0 === r && (r = e.length);
            for(var a = r - n, u = 0, l = a - 1; u < a; l = u++){
                var h = e[u + n][0], c = e[u + n][1], f = e[l + n][0], v = e[l + n][1];
                c > o != v > o && i < (f - h) * (o - c) / (v - c) + h && (s = !s);
            }
            return s;
        }), Xi);
        return Ji.exports = function(n, r, i, o) {
            return r.length > 0 && Array.isArray(r[0]) ? e(n, r, i, o) : t(n, r, i, o);
        }, Ji.exports.nested = e, Ji.exports.flat = t, Ji.exports;
    }
    var Qi, $i, to = {
        exports: {}
    };
    function eo() {
        return Qi || (Qi = 1, function(t, e) {
            !function(t) {
                var e = 134217729, n = 33306690738754706e-32;
                function r(t, e, n, r, i) {
                    var o, s, a, u, l = e[0], h = r[0], c = 0, f = 0;
                    h > l == h > -l ? (o = l, l = e[++c]) : (o = h, h = r[++f]);
                    var v = 0;
                    if (c < t && f < n) for(h > l == h > -l ? (a = o - ((s = l + o) - l), l = e[++c]) : (a = o - ((s = h + o) - h), h = r[++f]), o = s, 0 !== a && (i[v++] = a); c < t && f < n;)h > l == h > -l ? (a = o - ((s = o + l) - (u = s - o)) + (l - u), l = e[++c]) : (a = o - ((s = o + h) - (u = s - o)) + (h - u), h = r[++f]), o = s, 0 !== a && (i[v++] = a);
                    for(; c < t;)a = o - ((s = o + l) - (u = s - o)) + (l - u), l = e[++c], o = s, 0 !== a && (i[v++] = a);
                    for(; f < n;)a = o - ((s = o + h) - (u = s - o)) + (h - u), h = r[++f], o = s, 0 !== a && (i[v++] = a);
                    return 0 === o && 0 !== v || (i[v++] = o), v;
                }
                function i(t) {
                    return new Float64Array(t);
                }
                var o = 33306690738754716e-32, s = 22204460492503146e-32, a = 11093356479670487e-47, u = i(4), l = i(8), h = i(12), c = i(16), f = i(4);
                t.orient2d = function(t, i, v, g, d, p) {
                    var y = (i - p) * (v - d), m = (t - d) * (g - p), _ = y - m;
                    if (0 === y || 0 === m || y > 0 != m > 0) return _;
                    var x = Math.abs(y + m);
                    return Math.abs(_) >= o * x ? _ : -function(t, i, o, v, g, d, p) {
                        var y, m, _, x, E, k, w, b, I, N, S, M, L, P, C, T, O, R, A = t - g, D = o - g, F = i - d, q = v - d;
                        E = (C = (b = A - (w = (k = e * A) - (k - A))) * (N = q - (I = (k = e * q) - (k - q))) - ((P = A * q) - w * I - b * I - w * N)) - (S = C - (O = (b = F - (w = (k = e * F) - (k - F))) * (N = D - (I = (k = e * D) - (k - D))) - ((T = F * D) - w * I - b * I - w * N))), u[0] = C - (S + E) + (E - O), E = (L = P - ((M = P + S) - (E = M - P)) + (S - E)) - (S = L - T), u[1] = L - (S + E) + (E - T), E = (R = M + S) - M, u[2] = M - (R - E) + (S - E), u[3] = R;
                        var G = function(t, e) {
                            for(var n = e[0], r = 1; r < t; r++)n += e[r];
                            return n;
                        }(4, u), Y = s * p;
                        if (G >= Y || -G >= Y) return G;
                        if (y = t - (A + (E = t - A)) + (E - g), _ = o - (D + (E = o - D)) + (E - g), m = i - (F + (E = i - F)) + (E - d), x = v - (q + (E = v - q)) + (E - d), 0 === y && 0 === m && 0 === _ && 0 === x) return G;
                        if (Y = a * p + n * Math.abs(G), (G += A * x + q * y - (F * _ + D * m)) >= Y || -G >= Y) return G;
                        E = (C = (b = y - (w = (k = e * y) - (k - y))) * (N = q - (I = (k = e * q) - (k - q))) - ((P = y * q) - w * I - b * I - w * N)) - (S = C - (O = (b = m - (w = (k = e * m) - (k - m))) * (N = D - (I = (k = e * D) - (k - D))) - ((T = m * D) - w * I - b * I - w * N))), f[0] = C - (S + E) + (E - O), E = (L = P - ((M = P + S) - (E = M - P)) + (S - E)) - (S = L - T), f[1] = L - (S + E) + (E - T), E = (R = M + S) - M, f[2] = M - (R - E) + (S - E), f[3] = R;
                        var B = r(4, u, 4, f, l);
                        E = (C = (b = A - (w = (k = e * A) - (k - A))) * (N = x - (I = (k = e * x) - (k - x))) - ((P = A * x) - w * I - b * I - w * N)) - (S = C - (O = (b = F - (w = (k = e * F) - (k - F))) * (N = _ - (I = (k = e * _) - (k - _))) - ((T = F * _) - w * I - b * I - w * N))), f[0] = C - (S + E) + (E - O), E = (L = P - ((M = P + S) - (E = M - P)) + (S - E)) - (S = L - T), f[1] = L - (S + E) + (E - T), E = (R = M + S) - M, f[2] = M - (R - E) + (S - E), f[3] = R;
                        var z = r(B, l, 4, f, h);
                        E = (C = (b = y - (w = (k = e * y) - (k - y))) * (N = x - (I = (k = e * x) - (k - x))) - ((P = y * x) - w * I - b * I - w * N)) - (S = C - (O = (b = m - (w = (k = e * m) - (k - m))) * (N = _ - (I = (k = e * _) - (k - _))) - ((T = m * _) - w * I - b * I - w * N))), f[0] = C - (S + E) + (E - O), E = (L = P - ((M = P + S) - (E = M - P)) + (S - E)) - (S = L - T), f[1] = L - (S + E) + (E - T), E = (R = M + S) - M, f[2] = M - (R - E) + (S - E), f[3] = R;
                        var j = r(z, h, 4, f, c);
                        return c[j - 1];
                    }(t, i, v, g, d, p, x);
                }, t.orient2dfast = function(t, e, n, r, i, o) {
                    return (e - o) * (n - i) - (t - i) * (r - o);
                }, Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            }(e);
        }(0, to.exports)), to.exports;
    }
    var no = function() {
        if ($i) return Zi.exports;
        $i = 1;
        var t = Hi, e = Wi, n = Ki(), r = eo().orient2d;
        function i(e, r, i) {
            r = Math.max(0, void 0 === r ? 2 : r), i = i || 0;
            var s = function(t) {
                for(var e = t[0], r = t[0], i = t[0], o = t[0], s = 0; s < t.length; s++){
                    var a = t[s];
                    a[0] < e[0] && (e = a), a[0] > i[0] && (i = a), a[1] < r[1] && (r = a), a[1] > o[1] && (o = a);
                }
                var u = [
                    e,
                    r,
                    i,
                    o
                ], l = u.slice();
                for(s = 0; s < t.length; s++)n(t[s], u) || l.push(t[s]);
                return function(t) {
                    t.sort(y);
                    for(var e = [], n = 0; n < t.length; n++){
                        for(; e.length >= 2 && h(e[e.length - 2], e[e.length - 1], t[n]) <= 0;)e.pop();
                        e.push(t[n]);
                    }
                    for(var r = [], i = t.length - 1; i >= 0; i--){
                        for(; r.length >= 2 && h(r[r.length - 2], r[r.length - 1], t[i]) <= 0;)r.pop();
                        r.push(t[i]);
                    }
                    return r.pop(), e.pop(), e.concat(r);
                }(l);
            }(e), a = new t(16);
            a.toBBox = function(t) {
                return {
                    minX: t[0],
                    minY: t[1],
                    maxX: t[0],
                    maxY: t[1]
                };
            }, a.compareMinX = function(t, e) {
                return t[0] - e[0];
            }, a.compareMinY = function(t, e) {
                return t[1] - e[1];
            }, a.load(e);
            for(var u, l = [], c = 0; c < s.length; c++){
                var d = s[c];
                a.remove(d), u = v(d, u), l.push(u);
            }
            var p = new t(16);
            for(c = 0; c < l.length; c++)p.insert(f(l[c]));
            for(var m = r * r, _ = i * i; l.length;){
                var x = l.shift(), E = x.p, k = x.next.p, w = g(E, k);
                if (!(w < _)) {
                    var b = w / m;
                    (d = o(a, x.prev.p, E, k, x.next.next.p, b, p)) && Math.min(g(d, E), g(d, k)) <= b && (l.push(x), l.push(v(d, x)), a.remove(d), p.remove(x), p.insert(f(x)), p.insert(f(x.next)));
                }
            }
            x = u;
            var I = [];
            do I.push(x.p), x = x.next;
            while (x !== u);
            return I.push(x.p), I;
        }
        function o(t, n, r, i, o, u, h) {
            for(var c = new e([], s), f = t.data; f;){
                for(var v = 0; v < f.children.length; v++){
                    var g = f.children[v], p = f.leaf ? d(g, r, i) : a(r, i, g);
                    p > u || c.push({
                        node: g,
                        dist: p
                    });
                }
                for(; c.length && !c.peek().node.children;){
                    var y = c.pop(), m = y.node, _ = d(m, n, r), x = d(m, i, o);
                    if (y.dist < _ && y.dist < x && l(r, m, h) && l(i, m, h)) return m;
                }
                (f = c.pop()) && (f = f.node);
            }
            return null;
        }
        function s(t, e) {
            return t.dist - e.dist;
        }
        function a(t, e, n) {
            if (u(t, n) || u(e, n)) return 0;
            var r = p(t[0], t[1], e[0], e[1], n.minX, n.minY, n.maxX, n.minY);
            if (0 === r) return 0;
            var i = p(t[0], t[1], e[0], e[1], n.minX, n.minY, n.minX, n.maxY);
            if (0 === i) return 0;
            var o = p(t[0], t[1], e[0], e[1], n.maxX, n.minY, n.maxX, n.maxY);
            if (0 === o) return 0;
            var s = p(t[0], t[1], e[0], e[1], n.minX, n.maxY, n.maxX, n.maxY);
            return 0 === s ? 0 : Math.min(r, i, o, s);
        }
        function u(t, e) {
            return t[0] >= e.minX && t[0] <= e.maxX && t[1] >= e.minY && t[1] <= e.maxY;
        }
        function l(t, e, n) {
            for(var r = Math.min(t[0], e[0]), i = Math.min(t[1], e[1]), o = Math.max(t[0], e[0]), s = Math.max(t[1], e[1]), a = n.search({
                minX: r,
                minY: i,
                maxX: o,
                maxY: s
            }), u = 0; u < a.length; u++)if (c(a[u].p, a[u].next.p, t, e)) return !1;
            return !0;
        }
        function h(t, e, n) {
            return r(t[0], t[1], e[0], e[1], n[0], n[1]);
        }
        function c(t, e, n, r) {
            return t !== r && e !== n && h(t, e, n) > 0 != h(t, e, r) > 0 && h(n, r, t) > 0 != h(n, r, e) > 0;
        }
        function f(t) {
            var e = t.p, n = t.next.p;
            return t.minX = Math.min(e[0], n[0]), t.minY = Math.min(e[1], n[1]), t.maxX = Math.max(e[0], n[0]), t.maxY = Math.max(e[1], n[1]), t;
        }
        function v(t, e) {
            var n = {
                p: t,
                prev: null,
                next: null,
                minX: 0,
                minY: 0,
                maxX: 0,
                maxY: 0
            };
            return e ? (n.next = e.next, n.prev = e, e.next.prev = n, e.next = n) : (n.prev = n, n.next = n), n;
        }
        function g(t, e) {
            var n = t[0] - e[0], r = t[1] - e[1];
            return n * n + r * r;
        }
        function d(t, e, n) {
            var r = e[0], i = e[1], o = n[0] - r, s = n[1] - i;
            if (0 !== o || 0 !== s) {
                var a = ((t[0] - r) * o + (t[1] - i) * s) / (o * o + s * s);
                a > 1 ? (r = n[0], i = n[1]) : a > 0 && (r += o * a, i += s * a);
            }
            return (o = t[0] - r) * o + (s = t[1] - i) * s;
        }
        function p(t, e, n, r, i, o, s, a) {
            var u, l, h, c, f = n - t, v = r - e, g = s - i, d = a - o, p = t - i, y = e - o, m = f * f + v * v, _ = f * g + v * d, x = g * g + d * d, E = f * p + v * y, k = g * p + d * y, w = m * x - _ * _, b = w, I = w;
            0 === w ? (l = 0, b = 1, c = k, I = x) : (c = m * k - _ * E, (l = _ * k - x * E) < 0 ? (l = 0, c = k, I = x) : l > b && (l = b, c = k + _, I = x)), c < 0 ? (c = 0, -E < 0 ? l = 0 : -E > m ? l = b : (l = -E, b = m)) : c > I && (c = I, -E + _ < 0 ? l = 0 : -E + _ > m ? l = b : (l = -E + _, b = m));
            var N = (1 - (h = 0 === c ? 0 : c / I)) * i + h * s - ((1 - (u = 0 === l ? 0 : l / b)) * t + u * n), S = (1 - h) * o + h * a - ((1 - u) * e + u * r);
            return N * N + S * S;
        }
        function y(t, e) {
            return t[0] === e[0] ? t[1] - e[1] : t[0] - e[0];
        }
        return e.default && (e = e.default), Zi.exports = i, Zi.exports.default = i, Zi.exports;
    }(), ro = Jn(no);
    function io(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        e.concavity = e.concavity || 1 / 0;
        var n = [];
        if (dt(t, function(t) {
            n.push([
                t[0],
                t[1]
            ]);
        }), !n.length) return null;
        var r = ro(n, e.concavity);
        return r.length > 3 ? P([
            r
        ], e.properties) : null;
    }
    function oo(t, e) {
        for(var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, r = n.steps || 64, i = n.properties ? n.properties : !Array.isArray(t) && "Feature" === t.type && t.properties ? t.properties : {}, o = [], s = 0; s < r; s++)o.push(ct(t, e, -360 * s / r, n).geometry.coordinates);
        return o.push(o[0]), P([
            o
        ], i);
    }
    function so(t) {
        if (!t) throw new Error("geojson is required");
        switch(t.type){
            case "Feature":
                return ao(t);
            case "FeatureCollection":
                return function(t) {
                    var e = {
                        type: "FeatureCollection"
                    };
                    return Object.keys(t).forEach(function(n) {
                        switch(n){
                            case "type":
                            case "features":
                                return;
                            default:
                                e[n] = t[n];
                        }
                    }), e.features = t.features.map(function(t) {
                        return ao(t);
                    }), e;
                }(t);
            case "Point":
            case "LineString":
            case "Polygon":
            case "MultiPoint":
            case "MultiLineString":
            case "MultiPolygon":
            case "GeometryCollection":
                return lo(t);
            default:
                throw new Error("unknown GeoJSON type");
        }
    }
    function ao(t) {
        var e = {
            type: "Feature"
        };
        return Object.keys(t).forEach(function(n) {
            switch(n){
                case "type":
                case "properties":
                case "geometry":
                    return;
                default:
                    e[n] = t[n];
            }
        }), e.properties = uo(t.properties), null == t.geometry ? e.geometry = null : e.geometry = lo(t.geometry), e;
    }
    function uo(t) {
        var e = {};
        return t ? (Object.keys(t).forEach(function(n) {
            var r = t[n];
            "object" === E(r) ? null === r ? e[n] = null : Array.isArray(r) ? e[n] = r.map(function(t) {
                return t;
            }) : e[n] = uo(r) : e[n] = r;
        }), e) : e;
    }
    function lo(t) {
        var e = {
            type: t.type
        };
        return t.bbox && (e.bbox = t.bbox), "GeometryCollection" === t.type ? (e.geometries = t.geometries.map(function(t) {
            return lo(t);
        }), e) : (e.coordinates = ho(t.coordinates), e);
    }
    function ho(t) {
        var e = t;
        return "object" !== E(e[0]) ? e.slice() : e.map(function(t) {
            return ho(t);
        });
    }
    function co(t, e) {
        if (!t) throw new Error("geojson is required");
        if ("FeatureCollection" !== t.type) throw new Error("geojson must be a FeatureCollection");
        if (null == e) throw new Error("filter is required");
        var n = [];
        return _t(t, function(t) {
            po(t.properties, e) && n.push(t);
        }), R(n);
    }
    function fo(t, e, n) {
        if (!t) throw new Error("geojson is required");
        if ("FeatureCollection" !== t.type) throw new Error("geojson must be a FeatureCollection");
        if (null == e) throw new Error("property is required");
        for(var r = go(t, e), i = Object.keys(r), o = 0; o < i.length; o++){
            for(var s = i[o], a = r[s], u = [], l = 0; l < a.length; l++)u.push(t.features[a[l]]);
            n(R(u), s, o);
        }
    }
    function vo(t, e, n, r) {
        var i = r;
        return fo(t, e, function(t, e, o) {
            i = 0 === o && void 0 === r ? t : n(i, t, e, o);
        }), i;
    }
    function go(t, e) {
        var n = {};
        return _t(t, function(t, r) {
            var i = t.properties || {};
            if (Object.prototype.hasOwnProperty.call(i, String(e))) {
                var o = i[e];
                Object.prototype.hasOwnProperty.call(n, o) ? n[o].push(r) : n[o] = [
                    r
                ];
            }
        }), n;
    }
    function po(t, e) {
        if (void 0 === t) return !1;
        var n = E(e);
        if ("number" === n || "string" === n) return Object.prototype.hasOwnProperty.call(t, e);
        if (Array.isArray(e)) {
            for(var r = 0; r < e.length; r++)if (!po(t, e[r])) return !1;
            return !0;
        }
        return yo(t, e);
    }
    function yo(t, e) {
        for(var n = Object.keys(e), r = 0; r < n.length; r++){
            var i = n[r];
            if (t[i] !== e[i]) return !1;
        }
        return !0;
    }
    function mo(t, e) {
        if (!e) return {};
        if (!e.length) return {};
        for(var n = {}, r = 0; r < e.length; r++){
            var i = e[r];
            Object.prototype.hasOwnProperty.call(t, i) && (n[i] = t[i]);
        }
        return n;
    }
    var _o, xo, Eo, ko, wo, bo, Io = Object.freeze({
        __proto__: null,
        applyFilter: po,
        clusterEach: fo,
        clusterReduce: vo,
        createBins: go,
        filterProperties: mo,
        getCluster: co,
        propertiesContainsFilter: yo
    });
    function No() {
        return xo || (xo = 1, _o = {
            eudist: function(t, e, n) {
                for(var r = t.length, i = 0, o = 0; o < r; o++){
                    var s = (t[o] || 0) - (e[o] || 0);
                    i += s * s;
                }
                return n ? Math.sqrt(i) : i;
            },
            mandist: function(t, e, n) {
                for(var r = t.length, i = 0, o = 0; o < r; o++)i += Math.abs((t[o] || 0) - (e[o] || 0));
                return n ? Math.sqrt(i) : i;
            },
            dist: function(t, e, n) {
                var r = Math.abs(t - e);
                return n ? r : r * r;
            }
        }), _o;
    }
    var So = function() {
        if (bo) return wo;
        bo = 1;
        var t = No(), e = function() {
            if (ko) return Eo;
            ko = 1;
            var t = No(), e = t.eudist, n = t.dist;
            return Eo = {
                kmrand: function(t, e) {
                    for(var n = {}, r = [], i = e << 2, o = t.length, s = t[0].length > 0; r.length < e && i-- > 0;){
                        var a = t[Math.floor(Math.random() * o)], u = s ? a.join("_") : "" + a;
                        n[u] || (n[u] = !0, r.push(a));
                    }
                    if (r.length < e) throw new Error("Error initializating clusters");
                    return r;
                },
                kmpp: function(t, r) {
                    var i = t[0].length ? e : n, o = [], s = t.length, a = t[0].length > 0, u = t[Math.floor(Math.random() * s)];
                    for(a && u.join("_"), o.push(u); o.length < r;){
                        for(var l = [], h = o.length, c = 0, f = [], v = 0; v < s; v++){
                            for(var g = 1 / 0, d = 0; d < h; d++){
                                var p = i(t[v], o[d]);
                                p <= g && (g = p);
                            }
                            l[v] = g;
                        }
                        for(var y = 0; y < s; y++)c += l[y];
                        for(var m = 0; m < s; m++)f[m] = {
                            i: m,
                            v: t[m],
                            pr: l[m] / c,
                            cs: 0
                        };
                        f.sort(function(t, e) {
                            return t.pr - e.pr;
                        }), f[0].cs = f[0].pr;
                        for(var _ = 1; _ < s; _++)f[_].cs = f[_ - 1].cs + f[_].pr;
                        for(var x = Math.random(), E = 0; E < s - 1 && f[E++].cs < x;);
                        o.push(f[E - 1].v);
                    }
                    return o;
                }
            }, Eo;
        }(), n = t.eudist;
        t.mandist, t.dist;
        var r = e.kmrand, i = e.kmpp;
        function o(t, e, n) {
            n = n || [];
            for(var r = 0; r < t; r++)n[r] = e;
            return n;
        }
        return wo = function(t, e, s, a) {
            var u = [], l = [], h = [], c = [], f = !1, v = a || 1e4, g = t.length, d = t[0].length, p = d > 0, y = [];
            if (s) u = "kmrand" == s ? r(t, e) : "kmpp" == s ? i(t, e) : s;
            else for(var m = {}; u.length < e;){
                var _ = Math.floor(Math.random() * g);
                m[_] || (m[_] = !0, u.push(t[_]));
            }
            do {
                o(e, 0, y);
                for(var x = 0; x < g; x++){
                    for(var E = 1 / 0, k = 0, w = 0; w < e; w++)(c = p ? n(t[x], u[w]) : Math.abs(t[x] - u[w])) <= E && (E = c, k = w);
                    h[x] = k, y[k]++;
                }
                for(var b = [], I = (l = [], 0); I < e; I++)b[I] = p ? o(d, 0, b[I]) : 0, l[I] = u[I];
                if (p) {
                    for(var N = 0; N < e; N++)u[N] = [];
                    for(var S = 0; S < g; S++)for(var M = b[h[S]], L = t[S], P = 0; P < d; P++)M[P] += L[P];
                    f = !0;
                    for(var C = 0; C < e; C++){
                        for(var T = u[C], O = b[C], R = l[C], A = y[C], D = 0; D < d; D++)T[D] = O[D] / A || 0;
                        if (f) {
                            for(var F = 0; F < d; F++)if (R[F] != T[F]) {
                                f = !1;
                                break;
                            }
                        }
                    }
                } else {
                    for(var q = 0; q < g; q++)b[h[q]] += t[q];
                    for(var G = 0; G < e; G++)u[G] = b[G] / y[G] || 0;
                    f = !0;
                    for(var Y = 0; Y < e; Y++)if (l[Y] != u[Y]) {
                        f = !1;
                        break;
                    }
                }
                f = f || --v <= 0;
            }while (!f);
            return {
                it: 1e4 - v,
                k: e,
                idxs: h,
                centroids: u
            };
        }, wo;
    }(), Mo = Jn(So);
    function Lo(t, e) {
        var n = !1;
        return R((function(t) {
            if (t.length < 3) return [];
            t.sort(Co);
            var e, n, r, i, o, s, a = t.length - 1, u = t[a].x, l = t[0].x, h = t[a].y, c = h, f = 1e-12;
            for(; a--;)t[a].y < h && (h = t[a].y), t[a].y > c && (c = t[a].y);
            var v, g = l - u, d = c - h, p = g > d ? g : d, y = .5 * (l + u), m = .5 * (c + h), _ = [
                new Po({
                    __sentinel: !0,
                    x: y - 20 * p,
                    y: m - p
                }, {
                    __sentinel: !0,
                    x: y,
                    y: m + 20 * p
                }, {
                    __sentinel: !0,
                    x: y + 20 * p,
                    y: m - p
                })
            ], x = [], E = [];
            a = t.length;
            for(; a--;){
                for(E.length = 0, v = _.length; v--;)(g = t[a].x - _[v].x) > 0 && g * g > _[v].r ? (x.push(_[v]), _.splice(v, 1)) : g * g + (d = t[a].y - _[v].y) * d > _[v].r || (E.push(_[v].a, _[v].b, _[v].b, _[v].c, _[v].c, _[v].a), _.splice(v, 1));
                for(To(E), v = E.length; v;)n = E[--v], e = E[--v], r = t[a], i = n.x - e.x, o = n.y - e.y, s = 2 * (i * (r.y - n.y) - o * (r.x - n.x)), Math.abs(s) > f && _.push(new Po(e, n, r));
            }
            Array.prototype.push.apply(x, _), a = x.length;
            for(; a--;)(x[a].a.__sentinel || x[a].b.__sentinel || x[a].c.__sentinel) && x.splice(a, 1);
            return x;
        })(t.features.map(function(t) {
            var r = {
                x: t.geometry.coordinates[0],
                y: t.geometry.coordinates[1]
            };
            return e ? r.z = t.properties[e] : 3 === t.geometry.coordinates.length && (n = !0, r.z = t.geometry.coordinates[2]), r;
        })).map(function(t) {
            var e = [
                t.a.x,
                t.a.y
            ], r = [
                t.b.x,
                t.b.y
            ], i = [
                t.c.x,
                t.c.y
            ], o = {};
            return n ? (e.push(t.a.z), r.push(t.b.z), i.push(t.c.z)) : o = {
                a: t.a.z,
                b: t.b.z,
                c: t.c.z
            }, P([
                [
                    e,
                    r,
                    i,
                    e
                ]
            ], o);
        }));
    }
    var Po = s(function t(e, n, r) {
        i(this, t), this.a = e, this.b = n, this.c = r;
        var o, s, a = n.x - e.x, u = n.y - e.y, l = r.x - e.x, h = r.y - e.y, c = a * (e.x + n.x) + u * (e.y + n.y), f = l * (e.x + r.x) + h * (e.y + r.y), v = 2 * (a * (r.y - n.y) - u * (r.x - n.x));
        this.x = (h * c - u * f) / v, this.y = (a * f - l * c) / v, o = this.x - e.x, s = this.y - e.y, this.r = o * o + s * s;
    });
    function Co(t, e) {
        return e.x - t.x;
    }
    function To(t) {
        var e, n, r, i, o, s = t.length;
        t: for(; s;)for(n = t[--s], e = t[--s], r = s; r;)if (o = t[--r], e === (i = t[--r]) && n === o || e === o && n === i) {
            t.splice(s, 2), t.splice(r, 2), s -= 2;
            continue t;
        }
    }
    function Oo(t) {
        return t;
    }
    function Ro(t, e) {
        var n = function(t) {
            if (null == t) return Oo;
            var e, n, r = t.scale[0], i = t.scale[1], o = t.translate[0], s = t.translate[1];
            return function(t, a) {
                a || (e = n = 0);
                var u = 2, l = t.length, h = new Array(l);
                for(h[0] = (e += t[0]) * r + o, h[1] = (n += t[1]) * i + s; u < l;)h[u] = t[u], ++u;
                return h;
            };
        }(t.transform), r = t.arcs;
        function i(t, e) {
            e.length && e.pop();
            for(var i = r[t < 0 ? ~t : t], o = 0, s = i.length; o < s; ++o)e.push(n(i[o], o));
            t < 0 && function(t, e) {
                for(var n, r = t.length, i = r - e; i < --r;)n = t[i], t[i++] = t[r], t[r] = n;
            }(e, s);
        }
        function o(t) {
            return n(t);
        }
        function s(t) {
            for(var e = [], n = 0, r = t.length; n < r; ++n)i(t[n], e);
            return e.length < 2 && e.push(e[0]), e;
        }
        function a(t) {
            for(var e = s(t); e.length < 4;)e.push(e[0]);
            return e;
        }
        function u(t) {
            return t.map(a);
        }
        return function t(e) {
            var n, r = e.type;
            switch(r){
                case "GeometryCollection":
                    return {
                        type: r,
                        geometries: e.geometries.map(t)
                    };
                case "Point":
                    n = o(e.coordinates);
                    break;
                case "MultiPoint":
                    n = e.coordinates.map(o);
                    break;
                case "LineString":
                    n = s(e.arcs);
                    break;
                case "MultiLineString":
                    n = e.arcs.map(s);
                    break;
                case "Polygon":
                    n = u(e.arcs);
                    break;
                case "MultiPolygon":
                    n = e.arcs.map(u);
                    break;
                default:
                    return null;
            }
            return {
                type: r,
                coordinates: n
            };
        }(e);
    }
    function Ao(t, e) {
        var n = {}, r = {}, i = {}, o = [], s = -1;
        function a(t, e) {
            for(var r in t){
                var i = t[r];
                delete e[i.start], delete i.start, delete i.end, i.forEach(function(t) {
                    n[t < 0 ? ~t : t] = 1;
                }), o.push(i);
            }
        }
        return e.forEach(function(n, r) {
            var i, o = t.arcs[n < 0 ? ~n : n];
            o.length < 3 && !o[1][0] && !o[1][1] && (i = e[++s], e[s] = n, e[r] = i);
        }), e.forEach(function(e) {
            var n, o, s = function(e) {
                var n, r = t.arcs[e < 0 ? ~e : e], i = r[0];
                t.transform ? (n = [
                    0,
                    0
                ], r.forEach(function(t) {
                    n[0] += t[0], n[1] += t[1];
                })) : n = r[r.length - 1];
                return e < 0 ? [
                    n,
                    i
                ] : [
                    i,
                    n
                ];
            }(e), a = s[0], u = s[1];
            if (n = i[a]) {
                if (delete i[n.end], n.push(e), n.end = u, o = r[u]) {
                    delete r[o.start];
                    var l = o === n ? n : n.concat(o);
                    r[l.start = n.start] = i[l.end = o.end] = l;
                } else r[n.start] = i[n.end] = n;
            } else if (n = r[u]) {
                if (delete r[n.start], n.unshift(e), n.start = a, o = i[a]) {
                    delete i[o.end];
                    var h = o === n ? n : o.concat(n);
                    r[h.start = o.start] = i[h.end = n.end] = h;
                } else r[n.start] = i[n.end] = n;
            } else r[(n = [
                e
            ]).start = a] = i[n.end = u] = n;
        }), a(i, r), a(r, i), e.forEach(function(t) {
            n[t < 0 ? ~t : t] || o.push([
                t
            ]);
        }), o;
    }
    function Do(t) {
        return Ro(t, Fo.apply(this, arguments));
    }
    function Fo(t, e) {
        var n = {}, r = [], i = [];
        function o(t) {
            t.forEach(function(e) {
                e.forEach(function(e) {
                    (n[e = e < 0 ? ~e : e] || (n[e] = [])).push(t);
                });
            }), r.push(t);
        }
        function s(e) {
            return function(t) {
                for(var e, n = -1, r = t.length, i = t[r - 1], o = 0; ++n < r;)e = i, i = t[n], o += e[0] * i[1] - e[1] * i[0];
                return Math.abs(o);
            }(Ro(t, {
                type: "Polygon",
                arcs: [
                    e
                ]
            }).coordinates[0]);
        }
        return e.forEach(function t(e) {
            switch(e.type){
                case "GeometryCollection":
                    e.geometries.forEach(t);
                    break;
                case "Polygon":
                    o(e.arcs);
                    break;
                case "MultiPolygon":
                    e.arcs.forEach(o);
            }
        }), r.forEach(function(t) {
            if (!t._) {
                var e = [], r = [
                    t
                ];
                for(t._ = 1, i.push(e); t = r.pop();)e.push(t), t.forEach(function(t) {
                    t.forEach(function(t) {
                        n[t < 0 ? ~t : t].forEach(function(t) {
                            t._ || (t._ = 1, r.push(t));
                        });
                    });
                });
            }
        }), r.forEach(function(t) {
            delete t._;
        }), {
            type: "MultiPolygon",
            arcs: i.map(function(e) {
                var r, i = [];
                if (e.forEach(function(t) {
                    t.forEach(function(t) {
                        t.forEach(function(t) {
                            n[t < 0 ? ~t : t].length < 2 && i.push(t);
                        });
                    });
                }), (r = (i = Ao(t, i)).length) > 1) for(var o, a, u = 1, l = s(i[0]); u < r; ++u)(o = s(i[u])) > l && (a = i[0], i[0] = i[u], i[u] = a, l = o);
                return i;
            }).filter(function(t) {
                return t.length > 0;
            })
        };
    }
    var qo = Object.prototype.hasOwnProperty;
    function Go(t, e, n, r, i, o) {
        3 === arguments.length && (r = o = Array, i = null);
        for(var s = new r(t = 1 << Math.max(4, Math.ceil(Math.log(t) / Math.LN2))), a = new o(t), u = t - 1, l = 0; l < t; ++l)s[l] = i;
        return {
            set: function(r, o) {
                for(var l = e(r) & u, h = s[l], c = 0; h != i;){
                    if (n(h, r)) return a[l] = o;
                    if (++c >= t) throw new Error("full hashmap");
                    h = s[l = l + 1 & u];
                }
                return s[l] = r, a[l] = o, o;
            },
            maybeSet: function(r, o) {
                for(var l = e(r) & u, h = s[l], c = 0; h != i;){
                    if (n(h, r)) return a[l];
                    if (++c >= t) throw new Error("full hashmap");
                    h = s[l = l + 1 & u];
                }
                return s[l] = r, a[l] = o, o;
            },
            get: function(r, o) {
                for(var l = e(r) & u, h = s[l], c = 0; h != i;){
                    if (n(h, r)) return a[l];
                    if (++c >= t) break;
                    h = s[l = l + 1 & u];
                }
                return o;
            },
            keys: function() {
                for(var t = [], e = 0, n = s.length; e < n; ++e){
                    var r = s[e];
                    r != i && t.push(r);
                }
                return t;
            }
        };
    }
    function Yo(t, e) {
        return t[0] === e[0] && t[1] === e[1];
    }
    var Bo = new ArrayBuffer(16), zo = new Float64Array(Bo), jo = new Uint32Array(Bo);
    function Xo(t) {
        zo[0] = t[0], zo[1] = t[1];
        var e = jo[0] ^ jo[1];
        return 2147483647 & (e = e << 5 ^ e >> 7 ^ jo[2] ^ jo[3]);
    }
    function Uo(t) {
        var e, n, r, i, o = t.coordinates, s = t.lines, a = t.rings, u = function() {
            for(var t = Go(1.4 * o.length, E, k, Int32Array, -1, Int32Array), e = new Int32Array(o.length), n = 0, r = o.length; n < r; ++n)e[n] = t.maybeSet(n, n);
            return e;
        }(), l = new Int32Array(o.length), h = new Int32Array(o.length), c = new Int32Array(o.length), f = new Int8Array(o.length), v = 0;
        for(e = 0, n = o.length; e < n; ++e)l[e] = h[e] = c[e] = -1;
        for(e = 0, n = s.length; e < n; ++e){
            var g = s[e], d = g[0], p = g[1];
            for(r = u[d], i = u[++d], ++v, f[r] = 1; ++d <= p;)x(e, r, r = i, i = u[d]);
            ++v, f[i] = 1;
        }
        for(e = 0, n = o.length; e < n; ++e)l[e] = -1;
        for(e = 0, n = a.length; e < n; ++e){
            var y = a[e], m = y[0] + 1, _ = y[1];
            for(x(e, u[_ - 1], r = u[m - 1], i = u[m]); ++m <= _;)x(e, r, r = i, i = u[m]);
        }
        function x(t, e, n, r) {
            if (l[n] !== t) {
                l[n] = t;
                var i = h[n];
                if (i >= 0) {
                    var o = c[n];
                    i === e && o === r || i === r && o === e || (++v, f[n] = 1);
                } else h[n] = e, c[n] = r;
            }
        }
        function E(t) {
            return Xo(o[t]);
        }
        function k(t, e) {
            return Yo(o[t], o[e]);
        }
        l = h = c = null;
        var w, b = function(t, e, n, r, i) {
            3 === arguments.length && (r = Array, i = null);
            for(var o = new r(t = 1 << Math.max(4, Math.ceil(Math.log(t) / Math.LN2))), s = t - 1, a = 0; a < t; ++a)o[a] = i;
            return {
                add: function(r) {
                    for(var a = e(r) & s, u = o[a], l = 0; u != i;){
                        if (n(u, r)) return !0;
                        if (++l >= t) throw new Error("full hashset");
                        u = o[a = a + 1 & s];
                    }
                    return o[a] = r, !0;
                },
                has: function(r) {
                    for(var a = e(r) & s, u = o[a], l = 0; u != i;){
                        if (n(u, r)) return !0;
                        if (++l >= t) break;
                        u = o[a = a + 1 & s];
                    }
                    return !1;
                },
                values: function() {
                    for(var t = [], e = 0, n = o.length; e < n; ++e){
                        var r = o[e];
                        r != i && t.push(r);
                    }
                    return t;
                }
            };
        }(1.4 * v, Xo, Yo);
        for(e = 0, n = o.length; e < n; ++e)f[w = u[e]] && b.add(o[w]);
        return b;
    }
    function Vo(t, e, n, r) {
        Zo(t, e, n), Zo(t, e, e + r), Zo(t, e + r, n);
    }
    function Zo(t, e, n) {
        for(var r, i = e + (n-- - e >> 1); e < i; ++e, --n)r = t[e], t[e] = t[n], t[n] = r;
    }
    function Ho(t) {
        return null == t ? {
            type: null
        } : ("FeatureCollection" === t.type ? Wo : "Feature" === t.type ? Jo : Ko)(t);
    }
    function Wo(t) {
        var e = {
            type: "GeometryCollection",
            geometries: t.features.map(Jo)
        };
        return null != t.bbox && (e.bbox = t.bbox), e;
    }
    function Jo(t) {
        var e, n = Ko(t.geometry);
        for(e in null != t.id && (n.id = t.id), null != t.bbox && (n.bbox = t.bbox), t.properties){
            n.properties = t.properties;
            break;
        }
        return n;
    }
    function Ko(t) {
        if (null == t) return {
            type: null
        };
        var e = "GeometryCollection" === t.type ? {
            type: "GeometryCollection",
            geometries: t.geometries.map(Ko)
        } : "Point" === t.type || "MultiPoint" === t.type ? {
            type: t.type,
            coordinates: t.coordinates
        } : {
            type: t.type,
            arcs: t.coordinates
        };
        return null != t.bbox && (e.bbox = t.bbox), e;
    }
    function Qo(t, e) {
        var n = function(t) {
            var e = 1 / 0, n = 1 / 0, r = -1 / 0, i = -1 / 0;
            function o(t) {
                null != t && qo.call(s, t.type) && s[t.type](t);
            }
            var s = {
                GeometryCollection: function(t) {
                    t.geometries.forEach(o);
                },
                Point: function(t) {
                    a(t.coordinates);
                },
                MultiPoint: function(t) {
                    t.coordinates.forEach(a);
                },
                LineString: function(t) {
                    u(t.arcs);
                },
                MultiLineString: function(t) {
                    t.arcs.forEach(u);
                },
                Polygon: function(t) {
                    t.arcs.forEach(u);
                },
                MultiPolygon: function(t) {
                    t.arcs.forEach(l);
                }
            };
            function a(t) {
                var o = t[0], s = t[1];
                o < e && (e = o), o > r && (r = o), s < n && (n = s), s > i && (i = s);
            }
            function u(t) {
                t.forEach(a);
            }
            function l(t) {
                t.forEach(u);
            }
            for(var h in t)o(t[h]);
            return r >= e && i >= n ? [
                e,
                n,
                r,
                i
            ] : void 0;
        }(t = function(t) {
            var e, n = {};
            for(e in t)n[e] = Ho(t[e]);
            return n;
        }(t)), r = function(t) {
            var e, n, r, i, o = t.coordinates, s = t.lines, a = t.rings, u = s.length + a.length;
            for(delete t.lines, delete t.rings, r = 0, i = s.length; r < i; ++r)for(e = s[r]; e = e.next;)++u;
            for(r = 0, i = a.length; r < i; ++r)for(n = a[r]; n = n.next;)++u;
            var l = Go(2 * u * 1.4, Xo, Yo), h = t.arcs = [];
            for(r = 0, i = s.length; r < i; ++r){
                e = s[r];
                do c(e);
                while (e = e.next);
            }
            for(r = 0, i = a.length; r < i; ++r)if ((n = a[r]).next) do c(n);
            while (n = n.next);
            else f(n);
            function c(t) {
                var e, n, r, i, s, a, u, c;
                if (r = l.get(e = o[t[0]])) {
                    for(u = 0, c = r.length; u < c; ++u)if (v(i = r[u], t)) return t[0] = i[0], void (t[1] = i[1]);
                }
                if (s = l.get(n = o[t[1]])) {
                    for(u = 0, c = s.length; u < c; ++u)if (g(a = s[u], t)) return t[1] = a[0], void (t[0] = a[1]);
                }
                r ? r.push(t) : l.set(e, [
                    t
                ]), s ? s.push(t) : l.set(n, [
                    t
                ]), h.push(t);
            }
            function f(t) {
                var e, n, r, i, s;
                if (n = l.get(o[t[0]])) for(i = 0, s = n.length; i < s; ++i){
                    if (d(r = n[i], t)) return t[0] = r[0], void (t[1] = r[1]);
                    if (p(r, t)) return t[0] = r[1], void (t[1] = r[0]);
                }
                if (n = l.get(e = o[t[0] + y(t)])) for(i = 0, s = n.length; i < s; ++i){
                    if (d(r = n[i], t)) return t[0] = r[0], void (t[1] = r[1]);
                    if (p(r, t)) return t[0] = r[1], void (t[1] = r[0]);
                }
                n ? n.push(t) : l.set(e, [
                    t
                ]), h.push(t);
            }
            function v(t, e) {
                var n = t[0], r = e[0], i = t[1];
                if (n - i !== r - e[1]) return !1;
                for(; n <= i; ++n, ++r)if (!Yo(o[n], o[r])) return !1;
                return !0;
            }
            function g(t, e) {
                var n = t[0], r = e[0], i = t[1], s = e[1];
                if (n - i !== r - s) return !1;
                for(; n <= i; ++n, --s)if (!Yo(o[n], o[s])) return !1;
                return !0;
            }
            function d(t, e) {
                var n = t[0], r = e[0], i = t[1] - n;
                if (i !== e[1] - r) return !1;
                for(var s = y(t), a = y(e), u = 0; u < i; ++u)if (!Yo(o[n + (u + s) % i], o[r + (u + a) % i])) return !1;
                return !0;
            }
            function p(t, e) {
                var n = t[0], r = e[0], i = t[1], s = e[1], a = i - n;
                if (a !== s - r) return !1;
                for(var u = y(t), l = a - y(e), h = 0; h < a; ++h)if (!Yo(o[n + (h + u) % a], o[s - (h + l) % a])) return !1;
                return !0;
            }
            function y(t) {
                for(var e = t[0], n = t[1], r = e, i = r, s = o[r]; ++r < n;){
                    var a = o[r];
                    (a[0] < s[0] || a[0] === s[0] && a[1] < s[1]) && (i = r, s = a);
                }
                return i - e;
            }
            return t;
        }(function(t) {
            var e, n, r, i = Uo(t), o = t.coordinates, s = t.lines, a = t.rings;
            for(n = 0, r = s.length; n < r; ++n)for(var u = s[n], l = u[0], h = u[1]; ++l < h;)i.has(o[l]) && (e = {
                0: l,
                1: u[1]
            }, u[1] = l, u = u.next = e);
            for(n = 0, r = a.length; n < r; ++n)for(var c = a[n], f = c[0], v = f, g = c[1], d = i.has(o[f]); ++v < g;)i.has(o[v]) && (d ? (e = {
                0: v,
                1: c[1]
            }, c[1] = v, c = c.next = e) : (Vo(o, f, g, g - v), o[g] = o[f], d = !0, v = f));
            return t;
        }(function(t) {
            var e = -1, n = [], r = [], i = [];
            function o(t) {
                t && qo.call(s, t.type) && s[t.type](t);
            }
            var s = {
                GeometryCollection: function(t) {
                    t.geometries.forEach(o);
                },
                LineString: function(t) {
                    t.arcs = a(t.arcs);
                },
                MultiLineString: function(t) {
                    t.arcs = t.arcs.map(a);
                },
                Polygon: function(t) {
                    t.arcs = t.arcs.map(u);
                },
                MultiPolygon: function(t) {
                    t.arcs = t.arcs.map(l);
                }
            };
            function a(t) {
                for(var r = 0, o = t.length; r < o; ++r)i[++e] = t[r];
                var s = {
                    0: e - o + 1,
                    1: e
                };
                return n.push(s), s;
            }
            function u(t) {
                for(var n = 0, o = t.length; n < o; ++n)i[++e] = t[n];
                var s = {
                    0: e - o + 1,
                    1: e
                };
                return r.push(s), s;
            }
            function l(t) {
                return t.map(u);
            }
            for(var h in t)o(t[h]);
            return {
                type: "Topology",
                coordinates: i,
                lines: n,
                rings: r,
                objects: t
            };
        }(t))), i = r.coordinates, o = Go(1.4 * r.arcs.length, $o, ts);
        function s(t) {
            t && qo.call(a, t.type) && a[t.type](t);
        }
        t = r.objects, r.bbox = n, r.arcs = r.arcs.map(function(t, e) {
            return o.set(t, e), i.slice(t[0], t[1] + 1);
        }), delete r.coordinates, i = null;
        var a = {
            GeometryCollection: function(t) {
                t.geometries.forEach(s);
            },
            LineString: function(t) {
                t.arcs = u(t.arcs);
            },
            MultiLineString: function(t) {
                t.arcs = t.arcs.map(u);
            },
            Polygon: function(t) {
                t.arcs = t.arcs.map(u);
            },
            MultiPolygon: function(t) {
                t.arcs = t.arcs.map(l);
            }
        };
        function u(t) {
            var e = [];
            do {
                var n = o.get(t);
                e.push(t[0] < t[1] ? n : ~n);
            }while (t = t.next);
            return e;
        }
        function l(t) {
            return t.map(u);
        }
        for(var h in t)s(t[h]);
        return r;
    }
    function $o(t) {
        var e, n = t[0], r = t[1];
        return r < n && (e = n, n = r, r = e), n + 31 * r;
    }
    function ts(t, e) {
        var n, r = t[0], i = t[1], o = e[0], s = e[1];
        return i < r && (n = r, r = i, i = n), s < o && (n = o, o = s, s = n), r === o && i === s;
    }
    function es(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        if (!J(e = e || {})) throw new Error("options is invalid");
        var n = e.mutate;
        if ("FeatureCollection" !== ut(t)) throw new Error("geojson must be a FeatureCollection");
        if (!t.features.length) throw new Error("geojson is empty");
        !1 !== n && void 0 !== n || (t = so(t));
        var r = [], i = Lt(t, function(t, e) {
            var n = function(t, e) {
                var n, r = t.geometry.coordinates, i = e.geometry.coordinates, o = ns(r[0]), s = ns(r[r.length - 1]), a = ns(i[0]), u = ns(i[i.length - 1]);
                if (o === u) n = i.concat(r.slice(1));
                else if (a === s) n = r.concat(i.slice(1));
                else if (o === a) n = r.slice(1).reverse().concat(i);
                else {
                    if (s !== u) return null;
                    n = r.concat(i.reverse().slice(1));
                }
                return T(n);
            }(t, e);
            return n || (r.push(t), e);
        });
        return i && r.push(i), r.length ? 1 === r.length ? r[0] : A(r.map(function(t) {
            return t.coordinates;
        })) : null;
    }
    function ns(t) {
        return t[0].toString() + "," + t[1].toString();
    }
    function rs(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        if (!J(e = e || {})) throw new Error("options is invalid");
        var n = e.mutate;
        if ("FeatureCollection" !== ut(t)) throw new Error("geojson must be a FeatureCollection");
        if (!t.features.length) throw new Error("geojson is empty");
        !1 !== n && void 0 !== n || (t = so(t));
        var r = function(t) {
            var e = {};
            bt(t, function(t) {
                e[t.geometry.type] = !0;
            });
            var n = Object.keys(e);
            if (1 === n.length) return n[0];
            return null;
        }(t);
        if (!r) throw new Error("geojson must be homogenous");
        var i = t;
        switch(r){
            case "LineString":
                return es(i, e);
            case "Polygon":
                return function(t) {
                    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    if ("FeatureCollection" !== ut(t)) throw new Error("geojson must be a FeatureCollection");
                    if (!t.features.length) throw new Error("geojson is empty");
                    !1 !== e.mutate && void 0 !== e.mutate || (t = so(t));
                    var n = [];
                    bt(t, function(t) {
                        n.push(t.geometry);
                    });
                    var r = Qo({
                        geoms: q(n).geometry
                    });
                    return Do(r, r.objects.geoms.geometries);
                }(i, e);
            default:
                throw new Error(r + " is not supported");
        }
    }
    var is = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, os = Math.ceil, ss = Math.floor, as = "[BigNumber Error] ", us = as + "Number primitive has more than 15 significant digits: ", ls = 1e14, hs = 14, cs = 9007199254740991, fs = [
        1,
        10,
        100,
        1e3,
        1e4,
        1e5,
        1e6,
        1e7,
        1e8,
        1e9,
        1e10,
        1e11,
        1e12,
        1e13
    ], vs = 1e7, gs = 1e9;
    function ds(t) {
        var e = 0 | t;
        return t > 0 || t === e ? e : e - 1;
    }
    function ps(t) {
        for(var e, n, r = 1, i = t.length, o = t[0] + ""; r < i;){
            for(e = t[r++] + "", n = hs - e.length; n--; e = "0" + e);
            o += e;
        }
        for(i = o.length; 48 === o.charCodeAt(--i););
        return o.slice(0, i + 1 || 1);
    }
    function ys(t, e) {
        var n, r, i = t.c, o = e.c, s = t.s, a = e.s, u = t.e, l = e.e;
        if (!s || !a) return null;
        if (n = i && !i[0], r = o && !o[0], n || r) return n ? r ? 0 : -a : s;
        if (s != a) return s;
        if (n = s < 0, r = u == l, !i || !o) return r ? 0 : !i ^ n ? 1 : -1;
        if (!r) return u > l ^ n ? 1 : -1;
        for(a = (u = i.length) < (l = o.length) ? u : l, s = 0; s < a; s++)if (i[s] != o[s]) return i[s] > o[s] ^ n ? 1 : -1;
        return u == l ? 0 : u > l ^ n ? 1 : -1;
    }
    function ms(t, e, n, r) {
        if (t < e || t > n || t !== ss(t)) throw Error(as + (r || "Argument") + ("number" == typeof t ? t < e || t > n ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(t));
    }
    function _s(t) {
        var e = t.c.length - 1;
        return ds(t.e / hs) == e && t.c[e] % 2 != 0;
    }
    function xs(t, e) {
        return (t.length > 1 ? t.charAt(0) + "." + t.slice(1) : t) + (e < 0 ? "e" : "e+") + e;
    }
    function Es(t, e, n) {
        var r, i;
        if (e < 0) {
            for(i = n + "."; ++e; i += n);
            t = i + t;
        } else if (++e > (r = t.length)) {
            for(i = n, e -= r; --e; i += n);
            t += i;
        } else e < r && (t = t.slice(0, e) + "." + t.slice(e));
        return t;
    }
    var ks = function t(e) {
        var n, r, i, o, s, a, u, l, h, c, f = S.prototype = {
            constructor: S,
            toString: null,
            valueOf: null
        }, v = new S(1), g = 20, d = 4, p = -7, y = 21, m = -10000000, _ = 1e7, x = !1, k = 1, w = 0, b = {
            prefix: "",
            groupSize: 3,
            secondaryGroupSize: 0,
            groupSeparator: ",",
            decimalSeparator: ".",
            fractionGroupSize: 0,
            fractionGroupSeparator: "\xa0",
            suffix: ""
        }, I = "0123456789abcdefghijklmnopqrstuvwxyz", N = !0;
        function S(t, e) {
            var n, o, s, a, u, l, h, c, f = this;
            if (!(f instanceof S)) return new S(t, e);
            if (null == e) {
                if (t && !0 === t._isBigNumber) return f.s = t.s, void (!t.c || t.e > _ ? f.c = f.e = null : t.e < m ? f.c = [
                    f.e = 0
                ] : (f.e = t.e, f.c = t.c.slice()));
                if ((l = "number" == typeof t) && 0 * t == 0) {
                    if (f.s = 1 / t < 0 ? (t = -t, -1) : 1, t === ~~t) {
                        for(a = 0, u = t; u >= 10; u /= 10, a++);
                        return void (a > _ ? f.c = f.e = null : (f.e = a, f.c = [
                            t
                        ]));
                    }
                    c = String(t);
                } else {
                    if (!is.test(c = String(t))) return i(f, c, l);
                    f.s = 45 == c.charCodeAt(0) ? (c = c.slice(1), -1) : 1;
                }
                (a = c.indexOf(".")) > -1 && (c = c.replace(".", "")), (u = c.search(/e/i)) > 0 ? (a < 0 && (a = u), a += +c.slice(u + 1), c = c.substring(0, u)) : a < 0 && (a = c.length);
            } else {
                if (ms(e, 2, I.length, "Base"), 10 == e && N) return C(f = new S(t), g + f.e + 1, d);
                if (c = String(t), l = "number" == typeof t) {
                    if (0 * t != 0) return i(f, c, l, e);
                    if (f.s = 1 / t < 0 ? (c = c.slice(1), -1) : 1, S.DEBUG && c.replace(/^0\.0*|\./, "").length > 15) throw Error(us + t);
                } else f.s = 45 === c.charCodeAt(0) ? (c = c.slice(1), -1) : 1;
                for(n = I.slice(0, e), a = u = 0, h = c.length; u < h; u++)if (n.indexOf(o = c.charAt(u)) < 0) {
                    if ("." == o) {
                        if (u > a) {
                            a = h;
                            continue;
                        }
                    } else if (!s && (c == c.toUpperCase() && (c = c.toLowerCase()) || c == c.toLowerCase() && (c = c.toUpperCase()))) {
                        s = !0, u = -1, a = 0;
                        continue;
                    }
                    return i(f, String(t), l, e);
                }
                l = !1, (a = (c = r(c, e, 10, f.s)).indexOf(".")) > -1 ? c = c.replace(".", "") : a = c.length;
            }
            for(u = 0; 48 === c.charCodeAt(u); u++);
            for(h = c.length; 48 === c.charCodeAt(--h););
            if (c = c.slice(u, ++h)) {
                if (h -= u, l && S.DEBUG && h > 15 && (t > cs || t !== ss(t))) throw Error(us + f.s * t);
                if ((a = a - u - 1) > _) f.c = f.e = null;
                else if (a < m) f.c = [
                    f.e = 0
                ];
                else {
                    if (f.e = a, f.c = [], u = (a + 1) % hs, a < 0 && (u += hs), u < h) {
                        for(u && f.c.push(+c.slice(0, u)), h -= hs; u < h;)f.c.push(+c.slice(u, u += hs));
                        u = hs - (c = c.slice(u)).length;
                    } else u -= h;
                    for(; u--; c += "0");
                    f.c.push(+c);
                }
            } else f.c = [
                f.e = 0
            ];
        }
        function M(t, e, n, r) {
            var i, o, s, a, u;
            if (null == n ? n = d : ms(n, 0, 8), !t.c) return t.toString();
            if (i = t.c[0], s = t.e, null == e) u = ps(t.c), u = 1 == r || 2 == r && (s <= p || s >= y) ? xs(u, s) : Es(u, s, "0");
            else if (o = (t = C(new S(t), e, n)).e, a = (u = ps(t.c)).length, 1 == r || 2 == r && (e <= o || o <= p)) {
                for(; a < e; u += "0", a++);
                u = xs(u, o);
            } else if (e -= s, u = Es(u, o, "0"), o + 1 > a) {
                if (--e > 0) for(u += "."; e--; u += "0");
            } else if ((e += o - a) > 0) for(o + 1 == a && (u += "."); e--; u += "0");
            return t.s < 0 && i ? "-" + u : u;
        }
        function L(t, e) {
            for(var n, r, i = 1, o = new S(t[0]); i < t.length; i++)(!(r = new S(t[i])).s || (n = ys(o, r)) === e || 0 === n && o.s === e) && (o = r);
            return o;
        }
        function P(t, e, n) {
            for(var r = 1, i = e.length; !e[--i]; e.pop());
            for(i = e[0]; i >= 10; i /= 10, r++);
            return (n = r + n * hs - 1) > _ ? t.c = t.e = null : n < m ? t.c = [
                t.e = 0
            ] : (t.e = n, t.c = e), t;
        }
        function C(t, e, n, r) {
            var i, o, s, a, u, l, h, c = t.c, f = fs;
            if (c) {
                t: {
                    for(i = 1, a = c[0]; a >= 10; a /= 10, i++);
                    if ((o = e - i) < 0) o += hs, s = e, u = c[l = 0], h = ss(u / f[i - s - 1] % 10);
                    else if ((l = os((o + 1) / hs)) >= c.length) {
                        if (!r) break t;
                        for(; c.length <= l; c.push(0));
                        u = h = 0, i = 1, s = (o %= hs) - hs + 1;
                    } else {
                        for(u = a = c[l], i = 1; a >= 10; a /= 10, i++);
                        h = (s = (o %= hs) - hs + i) < 0 ? 0 : ss(u / f[i - s - 1] % 10);
                    }
                    if (r = r || e < 0 || null != c[l + 1] || (s < 0 ? u : u % f[i - s - 1]), r = n < 4 ? (h || r) && (0 == n || n == (t.s < 0 ? 3 : 2)) : h > 5 || 5 == h && (4 == n || r || 6 == n && (o > 0 ? s > 0 ? u / f[i - s] : 0 : c[l - 1]) % 10 & 1 || n == (t.s < 0 ? 8 : 7)), e < 1 || !c[0]) return c.length = 0, r ? (e -= t.e + 1, c[0] = f[(hs - e % hs) % hs], t.e = -e || 0) : c[0] = t.e = 0, t;
                    if (0 == o ? (c.length = l, a = 1, l--) : (c.length = l + 1, a = f[hs - o], c[l] = s > 0 ? ss(u / f[i - s] % f[s]) * a : 0), r) for(;;){
                        if (0 == l) {
                            for(o = 1, s = c[0]; s >= 10; s /= 10, o++);
                            for(s = c[0] += a, a = 1; s >= 10; s /= 10, a++);
                            o != a && (t.e++, c[0] == ls && (c[0] = 1));
                            break;
                        }
                        if (c[l] += a, c[l] != ls) break;
                        c[l--] = 0, a = 1;
                    }
                    for(o = c.length; 0 === c[--o]; c.pop());
                }
                t.e > _ ? t.c = t.e = null : t.e < m && (t.c = [
                    t.e = 0
                ]);
            }
            return t;
        }
        function T(t) {
            var e, n = t.e;
            return null === n ? t.toString() : (e = ps(t.c), e = n <= p || n >= y ? xs(e, n) : Es(e, n, "0"), t.s < 0 ? "-" + e : e);
        }
        return S.clone = t, S.ROUND_UP = 0, S.ROUND_DOWN = 1, S.ROUND_CEIL = 2, S.ROUND_FLOOR = 3, S.ROUND_HALF_UP = 4, S.ROUND_HALF_DOWN = 5, S.ROUND_HALF_EVEN = 6, S.ROUND_HALF_CEIL = 7, S.ROUND_HALF_FLOOR = 8, S.EUCLID = 9, S.config = S.set = function(t) {
            var e, n;
            if (null != t) {
                if ("object" != E(t)) throw Error(as + "Object expected: " + t);
                if (t.hasOwnProperty(e = "DECIMAL_PLACES") && (ms(n = t[e], 0, gs, e), g = n), t.hasOwnProperty(e = "ROUNDING_MODE") && (ms(n = t[e], 0, 8, e), d = n), t.hasOwnProperty(e = "EXPONENTIAL_AT") && ((n = t[e]) && n.pop ? (ms(n[0], -gs, 0, e), ms(n[1], 0, gs, e), p = n[0], y = n[1]) : (ms(n, -gs, gs, e), p = -(y = n < 0 ? -n : n))), t.hasOwnProperty(e = "RANGE")) {
                    if ((n = t[e]) && n.pop) ms(n[0], -gs, -1, e), ms(n[1], 1, gs, e), m = n[0], _ = n[1];
                    else {
                        if (ms(n, -gs, gs, e), !n) throw Error(as + e + " cannot be zero: " + n);
                        m = -(_ = n < 0 ? -n : n);
                    }
                }
                if (t.hasOwnProperty(e = "CRYPTO")) {
                    if ((n = t[e]) !== !!n) throw Error(as + e + " not true or false: " + n);
                    if (n) {
                        if ("undefined" == typeof crypto || !crypto || !crypto.getRandomValues && !crypto.randomBytes) throw x = !n, Error(as + "crypto unavailable");
                        x = n;
                    } else x = n;
                }
                if (t.hasOwnProperty(e = "MODULO_MODE") && (ms(n = t[e], 0, 9, e), k = n), t.hasOwnProperty(e = "POW_PRECISION") && (ms(n = t[e], 0, gs, e), w = n), t.hasOwnProperty(e = "FORMAT")) {
                    if ("object" != E(n = t[e])) throw Error(as + e + " not an object: " + n);
                    b = n;
                }
                if (t.hasOwnProperty(e = "ALPHABET")) {
                    if ("string" != typeof (n = t[e]) || /^.?$|[+\-.\s]|(.).*\1/.test(n)) throw Error(as + e + " invalid: " + n);
                    N = "0123456789" == n.slice(0, 10), I = n;
                }
            }
            return {
                DECIMAL_PLACES: g,
                ROUNDING_MODE: d,
                EXPONENTIAL_AT: [
                    p,
                    y
                ],
                RANGE: [
                    m,
                    _
                ],
                CRYPTO: x,
                MODULO_MODE: k,
                POW_PRECISION: w,
                FORMAT: b,
                ALPHABET: I
            };
        }, S.isBigNumber = function(t) {
            if (!t || !0 !== t._isBigNumber) return !1;
            if (!S.DEBUG) return !0;
            var e, n, r = t.c, i = t.e, o = t.s;
            t: if ("[object Array]" == ({}).toString.call(r)) {
                if ((1 === o || -1 === o) && i >= -gs && i <= gs && i === ss(i)) {
                    if (0 === r[0]) {
                        if (0 === i && 1 === r.length) return !0;
                        break t;
                    }
                    if ((e = (i + 1) % hs) < 1 && (e += hs), String(r[0]).length == e) {
                        for(e = 0; e < r.length; e++)if ((n = r[e]) < 0 || n >= ls || n !== ss(n)) break t;
                        if (0 !== n) return !0;
                    }
                }
            } else if (null === r && null === i && (null === o || 1 === o || -1 === o)) return !0;
            throw Error(as + "Invalid BigNumber: " + t);
        }, S.maximum = S.max = function() {
            return L(arguments, -1);
        }, S.minimum = S.min = function() {
            return L(arguments, 1);
        }, S.random = (o = 9007199254740992, s = Math.random() * o & 2097151 ? function() {
            return ss(Math.random() * o);
        } : function() {
            return 8388608 * (1073741824 * Math.random() | 0) + (8388608 * Math.random() | 0);
        }, function(t) {
            var e, n, r, i, o, a = 0, u = [], l = new S(v);
            if (null == t ? t = g : ms(t, 0, gs), i = os(t / hs), x) {
                if (crypto.getRandomValues) {
                    for(e = crypto.getRandomValues(new Uint32Array(i *= 2)); a < i;)(o = 131072 * e[a] + (e[a + 1] >>> 11)) >= 9e15 ? (n = crypto.getRandomValues(new Uint32Array(2)), e[a] = n[0], e[a + 1] = n[1]) : (u.push(o % 1e14), a += 2);
                    a = i / 2;
                } else {
                    if (!crypto.randomBytes) throw x = !1, Error(as + "crypto unavailable");
                    for(e = crypto.randomBytes(i *= 7); a < i;)(o = 281474976710656 * (31 & e[a]) + 1099511627776 * e[a + 1] + 4294967296 * e[a + 2] + 16777216 * e[a + 3] + (e[a + 4] << 16) + (e[a + 5] << 8) + e[a + 6]) >= 9e15 ? crypto.randomBytes(7).copy(e, a) : (u.push(o % 1e14), a += 7);
                    a = i / 7;
                }
            }
            if (!x) for(; a < i;)(o = s()) < 9e15 && (u[a++] = o % 1e14);
            for(i = u[--a], t %= hs, i && t && (o = fs[hs - t], u[a] = ss(i / o) * o); 0 === u[a]; u.pop(), a--);
            if (a < 0) u = [
                r = 0
            ];
            else {
                for(r = -1; 0 === u[0]; u.splice(0, 1), r -= hs);
                for(a = 1, o = u[0]; o >= 10; o /= 10, a++);
                a < hs && (r -= hs - a);
            }
            return l.e = r, l.c = u, l;
        }), S.sum = function() {
            for(var t = 1, e = arguments, n = new S(e[0]); t < e.length;)n = n.plus(e[t++]);
            return n;
        }, r = function() {
            var t = "0123456789";
            function e(t, e, n, r) {
                for(var i, o, s = [
                    0
                ], a = 0, u = t.length; a < u;){
                    for(o = s.length; o--; s[o] *= e);
                    for(s[0] += r.indexOf(t.charAt(a++)), i = 0; i < s.length; i++)s[i] > n - 1 && (null == s[i + 1] && (s[i + 1] = 0), s[i + 1] += s[i] / n | 0, s[i] %= n);
                }
                return s.reverse();
            }
            return function(r, i, o, s, a) {
                var u, l, h, c, f, v, p, y, m = r.indexOf("."), _ = g, x = d;
                for(m >= 0 && (c = w, w = 0, r = r.replace(".", ""), v = (y = new S(i)).pow(r.length - m), w = c, y.c = e(Es(ps(v.c), v.e, "0"), 10, o, t), y.e = y.c.length), h = c = (p = e(r, i, o, a ? (u = I, t) : (u = t, I))).length; 0 == p[--c]; p.pop());
                if (!p[0]) return u.charAt(0);
                if (m < 0 ? --h : (v.c = p, v.e = h, v.s = s, p = (v = n(v, y, _, x, o)).c, f = v.r, h = v.e), m = p[l = h + _ + 1], c = o / 2, f = f || l < 0 || null != p[l + 1], f = x < 4 ? (null != m || f) && (0 == x || x == (v.s < 0 ? 3 : 2)) : m > c || m == c && (4 == x || f || 6 == x && 1 & p[l - 1] || x == (v.s < 0 ? 8 : 7)), l < 1 || !p[0]) r = f ? Es(u.charAt(1), -_, u.charAt(0)) : u.charAt(0);
                else {
                    if (p.length = l, f) for(--o; ++p[--l] > o;)p[l] = 0, l || (++h, p = [
                        1
                    ].concat(p));
                    for(c = p.length; !p[--c];);
                    for(m = 0, r = ""; m <= c; r += u.charAt(p[m++]));
                    r = Es(r, h, u.charAt(0));
                }
                return r;
            };
        }(), n = function() {
            function t(t, e, n) {
                var r, i, o, s, a = 0, u = t.length, l = e % vs, h = e / vs | 0;
                for(t = t.slice(); u--;)a = ((i = l * (o = t[u] % vs) + (r = h * o + (s = t[u] / vs | 0) * l) % vs * vs + a) / n | 0) + (r / vs | 0) + h * s, t[u] = i % n;
                return a && (t = [
                    a
                ].concat(t)), t;
            }
            function e(t, e, n, r) {
                var i, o;
                if (n != r) o = n > r ? 1 : -1;
                else for(i = o = 0; i < n; i++)if (t[i] != e[i]) {
                    o = t[i] > e[i] ? 1 : -1;
                    break;
                }
                return o;
            }
            function n(t, e, n, r) {
                for(var i = 0; n--;)t[n] -= i, i = t[n] < e[n] ? 1 : 0, t[n] = i * r + t[n] - e[n];
                for(; !t[0] && t.length > 1; t.splice(0, 1));
            }
            return function(r, i, o, s, a) {
                var u, l, h, c, f, v, g, d, p, y, m, _, x, E, k, w, b, I = r.s == i.s ? 1 : -1, N = r.c, M = i.c;
                if (!(N && N[0] && M && M[0])) return new S(r.s && i.s && (N ? !M || N[0] != M[0] : M) ? N && 0 == N[0] || !M ? 0 * I : I / 0 : NaN);
                for(p = (d = new S(I)).c = [], I = o + (l = r.e - i.e) + 1, a || (a = ls, l = ds(r.e / hs) - ds(i.e / hs), I = I / hs | 0), h = 0; M[h] == (N[h] || 0); h++);
                if (M[h] > (N[h] || 0) && l--, I < 0) p.push(1), c = !0;
                else {
                    for(E = N.length, w = M.length, h = 0, I += 2, (f = ss(a / (M[0] + 1))) > 1 && (M = t(M, f, a), N = t(N, f, a), w = M.length, E = N.length), x = w, m = (y = N.slice(0, w)).length; m < w; y[m++] = 0);
                    b = M.slice(), b = [
                        0
                    ].concat(b), k = M[0], M[1] >= a / 2 && k++;
                    do {
                        if (f = 0, (u = e(M, y, w, m)) < 0) {
                            if (_ = y[0], w != m && (_ = _ * a + (y[1] || 0)), (f = ss(_ / k)) > 1) for(f >= a && (f = a - 1), g = (v = t(M, f, a)).length, m = y.length; 1 == e(v, y, g, m);)f--, n(v, w < g ? b : M, g, a), g = v.length, u = 1;
                            else 0 == f && (u = f = 1), g = (v = M.slice()).length;
                            if (g < m && (v = [
                                0
                            ].concat(v)), n(y, v, m, a), m = y.length, -1 == u) for(; e(M, y, w, m) < 1;)f++, n(y, w < m ? b : M, m, a), m = y.length;
                        } else 0 === u && (f++, y = [
                            0
                        ]);
                        p[h++] = f, y[0] ? y[m++] = N[x] || 0 : (y = [
                            N[x]
                        ], m = 1);
                    }while ((x++ < E || null != y[0]) && I--);
                    c = null != y[0], p[0] || p.splice(0, 1);
                }
                if (a == ls) {
                    for(h = 1, I = p[0]; I >= 10; I /= 10, h++);
                    C(d, o + (d.e = h + l * hs - 1) + 1, s, c);
                } else d.e = l, d.r = +c;
                return d;
            };
        }(), a = /^(-?)0([xbo])(?=\w[\w.]*$)/i, u = /^([^.]+)\.$/, l = /^\.([^.]+)$/, h = /^-?(Infinity|NaN)$/, c = /^\s*\+(?=[\w.])|^\s+|\s+$/g, i = function(t, e, n, r) {
            var i, o = n ? e : e.replace(c, "");
            if (h.test(o)) t.s = isNaN(o) ? null : o < 0 ? -1 : 1;
            else {
                if (!n && (o = o.replace(a, function(t, e, n) {
                    return i = "x" == (n = n.toLowerCase()) ? 16 : "b" == n ? 2 : 8, r && r != i ? t : e;
                }), r && (i = r, o = o.replace(u, "$1").replace(l, "0.$1")), e != o)) return new S(o, i);
                if (S.DEBUG) throw Error(as + "Not a" + (r ? " base " + r : "") + " number: " + e);
                t.s = null;
            }
            t.c = t.e = null;
        }, f.absoluteValue = f.abs = function() {
            var t = new S(this);
            return t.s < 0 && (t.s = 1), t;
        }, f.comparedTo = function(t, e) {
            return ys(this, new S(t, e));
        }, f.decimalPlaces = f.dp = function(t, e) {
            var n, r, i, o = this;
            if (null != t) return ms(t, 0, gs), null == e ? e = d : ms(e, 0, 8), C(new S(o), t + o.e + 1, e);
            if (!(n = o.c)) return null;
            if (r = ((i = n.length - 1) - ds(this.e / hs)) * hs, i = n[i]) for(; i % 10 == 0; i /= 10, r--);
            return r < 0 && (r = 0), r;
        }, f.dividedBy = f.div = function(t, e) {
            return n(this, new S(t, e), g, d);
        }, f.dividedToIntegerBy = f.idiv = function(t, e) {
            return n(this, new S(t, e), 0, 1);
        }, f.exponentiatedBy = f.pow = function(t, e) {
            var n, r, i, o, s, a, u, l, h = this;
            if ((t = new S(t)).c && !t.isInteger()) throw Error(as + "Exponent not an integer: " + T(t));
            if (null != e && (e = new S(e)), s = t.e > 14, !h.c || !h.c[0] || 1 == h.c[0] && !h.e && 1 == h.c.length || !t.c || !t.c[0]) return l = new S(Math.pow(+T(h), s ? t.s * (2 - _s(t)) : +T(t))), e ? l.mod(e) : l;
            if (a = t.s < 0, e) {
                if (e.c ? !e.c[0] : !e.s) return new S(NaN);
                (r = !a && h.isInteger() && e.isInteger()) && (h = h.mod(e));
            } else {
                if (t.e > 9 && (h.e > 0 || h.e < -1 || (0 == h.e ? h.c[0] > 1 || s && h.c[1] >= 24e7 : h.c[0] < 8e13 || s && h.c[0] <= 9999975e7))) return o = h.s < 0 && _s(t) ? -0 : 0, h.e > -1 && (o = 1 / o), new S(a ? 1 / o : o);
                w && (o = os(w / hs + 2));
            }
            for(s ? (n = new S(.5), a && (t.s = 1), u = _s(t)) : u = (i = Math.abs(+T(t))) % 2, l = new S(v);;){
                if (u) {
                    if (!(l = l.times(h)).c) break;
                    o ? l.c.length > o && (l.c.length = o) : r && (l = l.mod(e));
                }
                if (i) {
                    if (0 === (i = ss(i / 2))) break;
                    u = i % 2;
                } else if (C(t = t.times(n), t.e + 1, 1), t.e > 14) u = _s(t);
                else {
                    if (0 === (i = +T(t))) break;
                    u = i % 2;
                }
                h = h.times(h), o ? h.c && h.c.length > o && (h.c.length = o) : r && (h = h.mod(e));
            }
            return r ? l : (a && (l = v.div(l)), e ? l.mod(e) : o ? C(l, w, d, void 0) : l);
        }, f.integerValue = function(t) {
            var e = new S(this);
            return null == t ? t = d : ms(t, 0, 8), C(e, e.e + 1, t);
        }, f.isEqualTo = f.eq = function(t, e) {
            return 0 === ys(this, new S(t, e));
        }, f.isFinite = function() {
            return !!this.c;
        }, f.isGreaterThan = f.gt = function(t, e) {
            return ys(this, new S(t, e)) > 0;
        }, f.isGreaterThanOrEqualTo = f.gte = function(t, e) {
            return 1 === (e = ys(this, new S(t, e))) || 0 === e;
        }, f.isInteger = function() {
            return !!this.c && ds(this.e / hs) > this.c.length - 2;
        }, f.isLessThan = f.lt = function(t, e) {
            return ys(this, new S(t, e)) < 0;
        }, f.isLessThanOrEqualTo = f.lte = function(t, e) {
            return -1 === (e = ys(this, new S(t, e))) || 0 === e;
        }, f.isNaN = function() {
            return !this.s;
        }, f.isNegative = function() {
            return this.s < 0;
        }, f.isPositive = function() {
            return this.s > 0;
        }, f.isZero = function() {
            return !!this.c && 0 == this.c[0];
        }, f.minus = function(t, e) {
            var n, r, i, o, s = this, a = s.s;
            if (e = (t = new S(t, e)).s, !a || !e) return new S(NaN);
            if (a != e) return t.s = -e, s.plus(t);
            var u = s.e / hs, l = t.e / hs, h = s.c, c = t.c;
            if (!u || !l) {
                if (!h || !c) return h ? (t.s = -e, t) : new S(c ? s : NaN);
                if (!h[0] || !c[0]) return c[0] ? (t.s = -e, t) : new S(h[0] ? s : 3 == d ? -0 : 0);
            }
            if (u = ds(u), l = ds(l), h = h.slice(), a = u - l) {
                for((o = a < 0) ? (a = -a, i = h) : (l = u, i = c), i.reverse(), e = a; e--; i.push(0));
                i.reverse();
            } else for(r = (o = (a = h.length) < (e = c.length)) ? a : e, a = e = 0; e < r; e++)if (h[e] != c[e]) {
                o = h[e] < c[e];
                break;
            }
            if (o && (i = h, h = c, c = i, t.s = -t.s), (e = (r = c.length) - (n = h.length)) > 0) for(; e--; h[n++] = 0);
            for(e = ls - 1; r > a;){
                if (h[--r] < c[r]) {
                    for(n = r; n && !h[--n]; h[n] = e);
                    --h[n], h[r] += ls;
                }
                h[r] -= c[r];
            }
            for(; 0 == h[0]; h.splice(0, 1), --l);
            return h[0] ? P(t, h, l) : (t.s = 3 == d ? -1 : 1, t.c = [
                t.e = 0
            ], t);
        }, f.modulo = f.mod = function(t, e) {
            var r, i, o = this;
            return t = new S(t, e), !o.c || !t.s || t.c && !t.c[0] ? new S(NaN) : !t.c || o.c && !o.c[0] ? new S(o) : (9 == k ? (i = t.s, t.s = 1, r = n(o, t, 0, 3), t.s = i, r.s *= i) : r = n(o, t, 0, k), (t = o.minus(r.times(t))).c[0] || 1 != k || (t.s = o.s), t);
        }, f.multipliedBy = f.times = function(t, e) {
            var n, r, i, o, s, a, u, l, h, c, f, v, g, d, p, y = this, m = y.c, _ = (t = new S(t, e)).c;
            if (!(m && _ && m[0] && _[0])) return !y.s || !t.s || m && !m[0] && !_ || _ && !_[0] && !m ? t.c = t.e = t.s = null : (t.s *= y.s, m && _ ? (t.c = [
                0
            ], t.e = 0) : t.c = t.e = null), t;
            for(r = ds(y.e / hs) + ds(t.e / hs), t.s *= y.s, (u = m.length) < (c = _.length) && (g = m, m = _, _ = g, i = u, u = c, c = i), i = u + c, g = []; i--; g.push(0));
            for(d = ls, p = vs, i = c; --i >= 0;){
                for(n = 0, f = _[i] % p, v = _[i] / p | 0, o = i + (s = u); o > i;)n = ((l = f * (l = m[--s] % p) + (a = v * l + (h = m[s] / p | 0) * f) % p * p + g[o] + n) / d | 0) + (a / p | 0) + v * h, g[o--] = l % d;
                g[o] = n;
            }
            return n ? ++r : g.splice(0, 1), P(t, g, r);
        }, f.negated = function() {
            var t = new S(this);
            return t.s = -t.s || null, t;
        }, f.plus = function(t, e) {
            var n, r = this, i = r.s;
            if (e = (t = new S(t, e)).s, !i || !e) return new S(NaN);
            if (i != e) return t.s = -e, r.minus(t);
            var o = r.e / hs, s = t.e / hs, a = r.c, u = t.c;
            if (!o || !s) {
                if (!a || !u) return new S(i / 0);
                if (!a[0] || !u[0]) return u[0] ? t : new S(a[0] ? r : 0 * i);
            }
            if (o = ds(o), s = ds(s), a = a.slice(), i = o - s) {
                for(i > 0 ? (s = o, n = u) : (i = -i, n = a), n.reverse(); i--; n.push(0));
                n.reverse();
            }
            for((i = a.length) - (e = u.length) < 0 && (n = u, u = a, a = n, e = i), i = 0; e;)i = (a[--e] = a[e] + u[e] + i) / ls | 0, a[e] = ls === a[e] ? 0 : a[e] % ls;
            return i && (a = [
                i
            ].concat(a), ++s), P(t, a, s);
        }, f.precision = f.sd = function(t, e) {
            var n, r, i, o = this;
            if (null != t && t !== !!t) return ms(t, 1, gs), null == e ? e = d : ms(e, 0, 8), C(new S(o), t, e);
            if (!(n = o.c)) return null;
            if (r = (i = n.length - 1) * hs + 1, i = n[i]) {
                for(; i % 10 == 0; i /= 10, r--);
                for(i = n[0]; i >= 10; i /= 10, r++);
            }
            return t && o.e + 1 > r && (r = o.e + 1), r;
        }, f.shiftedBy = function(t) {
            return ms(t, -9007199254740991, cs), this.times("1e" + t);
        }, f.squareRoot = f.sqrt = function() {
            var t, e, r, i, o, s = this, a = s.c, u = s.s, l = s.e, h = g + 4, c = new S("0.5");
            if (1 !== u || !a || !a[0]) return new S(!u || u < 0 && (!a || a[0]) ? NaN : a ? s : 1 / 0);
            if (0 == (u = Math.sqrt(+T(s))) || u == 1 / 0 ? (((e = ps(a)).length + l) % 2 == 0 && (e += "0"), u = Math.sqrt(+e), l = ds((l + 1) / 2) - (l < 0 || l % 2), r = new S(e = u == 1 / 0 ? "5e" + l : (e = u.toExponential()).slice(0, e.indexOf("e") + 1) + l)) : r = new S(u + ""), r.c[0]) {
                for((u = (l = r.e) + h) < 3 && (u = 0);;)if (o = r, r = c.times(o.plus(n(s, o, h, 1))), ps(o.c).slice(0, u) === (e = ps(r.c)).slice(0, u)) {
                    if (r.e < l && --u, "9999" != (e = e.slice(u - 3, u + 1)) && (i || "4999" != e)) {
                        +e && (+e.slice(1) || "5" != e.charAt(0)) || (C(r, r.e + g + 2, 1), t = !r.times(r).eq(s));
                        break;
                    }
                    if (!i && (C(o, o.e + g + 2, 0), o.times(o).eq(s))) {
                        r = o;
                        break;
                    }
                    h += 4, u += 4, i = 1;
                }
            }
            return C(r, r.e + g + 1, d, t);
        }, f.toExponential = function(t, e) {
            return null != t && (ms(t, 0, gs), t++), M(this, t, e, 1);
        }, f.toFixed = function(t, e) {
            return null != t && (ms(t, 0, gs), t = t + this.e + 1), M(this, t, e);
        }, f.toFormat = function(t, e, n) {
            var r, i = this;
            if (null == n) null != t && e && "object" == E(e) ? (n = e, e = null) : t && "object" == E(t) ? (n = t, t = e = null) : n = b;
            else if ("object" != E(n)) throw Error(as + "Argument not an object: " + n);
            if (r = i.toFixed(t, e), i.c) {
                var o, s = r.split("."), a = +n.groupSize, u = +n.secondaryGroupSize, l = n.groupSeparator || "", h = s[0], c = s[1], f = i.s < 0, v = f ? h.slice(1) : h, g = v.length;
                if (u && (o = a, a = u, u = o, g -= o), a > 0 && g > 0) {
                    for(o = g % a || a, h = v.substr(0, o); o < g; o += a)h += l + v.substr(o, a);
                    u > 0 && (h += l + v.slice(o)), f && (h = "-" + h);
                }
                r = c ? h + (n.decimalSeparator || "") + ((u = +n.fractionGroupSize) ? c.replace(new RegExp("\\d{" + u + "}\\B", "g"), "$&" + (n.fractionGroupSeparator || "")) : c) : h;
            }
            return (n.prefix || "") + r + (n.suffix || "");
        }, f.toFraction = function(t) {
            var e, r, i, o, s, a, u, l, h, c, f, g, p = this, y = p.c;
            if (null != t && (!(u = new S(t)).isInteger() && (u.c || 1 !== u.s) || u.lt(v))) throw Error(as + "Argument " + (u.isInteger() ? "out of range: " : "not an integer: ") + T(u));
            if (!y) return new S(p);
            for(e = new S(v), h = r = new S(v), i = l = new S(v), g = ps(y), s = e.e = g.length - p.e - 1, e.c[0] = fs[(a = s % hs) < 0 ? hs + a : a], t = !t || u.comparedTo(e) > 0 ? s > 0 ? e : h : u, a = _, _ = 1 / 0, u = new S(g), l.c[0] = 0; c = n(u, e, 0, 1), 1 != (o = r.plus(c.times(i))).comparedTo(t);)r = i, i = o, h = l.plus(c.times(o = h)), l = o, e = u.minus(c.times(o = e)), u = o;
            return o = n(t.minus(r), i, 0, 1), l = l.plus(o.times(h)), r = r.plus(o.times(i)), l.s = h.s = p.s, f = n(h, i, s *= 2, d).minus(p).abs().comparedTo(n(l, r, s, d).minus(p).abs()) < 1 ? [
                h,
                i
            ] : [
                l,
                r
            ], _ = a, f;
        }, f.toNumber = function() {
            return +T(this);
        }, f.toPrecision = function(t, e) {
            return null != t && ms(t, 1, gs), M(this, t, e, 2);
        }, f.toString = function(t) {
            var e, n = this, i = n.s, o = n.e;
            return null === o ? i ? (e = "Infinity", i < 0 && (e = "-" + e)) : e = "NaN" : (null == t ? e = o <= p || o >= y ? xs(ps(n.c), o) : Es(ps(n.c), o, "0") : 10 === t && N ? e = Es(ps((n = C(new S(n), g + o + 1, d)).c), n.e, "0") : (ms(t, 2, I.length, "Base"), e = r(Es(ps(n.c), o, "0"), 10, t, i, !0)), i < 0 && n.c[0] && (e = "-" + e)), e;
        }, f.valueOf = f.toJSON = function() {
            return T(this);
        }, f._isBigNumber = !0, f[Symbol.toStringTag] = "BigNumber", f[Symbol.for("nodejs.util.inspect.custom")] = f.valueOf, null != e && S.set(e), S;
    }(), ws = function(t) {
        function e(t) {
            return i(this, e), r(this, e, [
                t
            ]);
        }
        return h(e, t), s(e);
    }(s(function t(e) {
        i(this, t), u(this, "key", void 0), u(this, "left", null), u(this, "right", null), this.key = e;
    })), bs = function() {
        return s(function t() {
            i(this, t), u(this, "size", 0), u(this, "modificationCount", 0), u(this, "splayCount", 0);
        }, [
            {
                key: "splay",
                value: function(t) {
                    var e = this.root;
                    if (null == e) return this.compare(t, t), -1;
                    for(var n, r = null, i = null, o = null, s = null, a = e, u = this.compare;;)if ((n = u(a.key, t)) > 0) {
                        var l = a.left;
                        if (null == l) break;
                        if ((n = u(l.key, t)) > 0 && (a.left = l.right, l.right = a, null == (l = (a = l).left))) break;
                        null == r ? i = a : r.left = a, r = a, a = l;
                    } else {
                        if (!(n < 0)) break;
                        var h = a.right;
                        if (null == h) break;
                        if ((n = u(h.key, t)) < 0 && (a.right = h.left, h.left = a, null == (h = (a = h).right))) break;
                        null == o ? s = a : o.right = a, o = a, a = h;
                    }
                    return null != o && (o.right = a.left, a.left = s), null != r && (r.left = a.right, a.right = i), this.root !== a && (this.root = a, this.splayCount++), n;
                }
            },
            {
                key: "splayMin",
                value: function(t) {
                    for(var e = t, n = e.left; null != n;){
                        var r = n;
                        e.left = r.right, r.right = e, n = (e = r).left;
                    }
                    return e;
                }
            },
            {
                key: "splayMax",
                value: function(t) {
                    for(var e = t, n = e.right; null != n;){
                        var r = n;
                        e.right = r.left, r.left = e, n = (e = r).right;
                    }
                    return e;
                }
            },
            {
                key: "_delete",
                value: function(t) {
                    if (null == this.root) return null;
                    if (0 != this.splay(t)) return null;
                    var e = this.root, n = e, r = e.left;
                    if (this.size--, null == r) this.root = e.right;
                    else {
                        var i = e.right;
                        (e = this.splayMax(r)).right = i, this.root = e;
                    }
                    return this.modificationCount++, n;
                }
            },
            {
                key: "addNewRoot",
                value: function(t, e) {
                    this.size++, this.modificationCount++;
                    var n = this.root;
                    null != n ? (e < 0 ? (t.left = n, t.right = n.right, n.right = null) : (t.right = n, t.left = n.left, n.left = null), this.root = t) : this.root = t;
                }
            },
            {
                key: "_first",
                value: function() {
                    var t = this.root;
                    return null == t ? null : (this.root = this.splayMin(t), this.root);
                }
            },
            {
                key: "_last",
                value: function() {
                    var t = this.root;
                    return null == t ? null : (this.root = this.splayMax(t), this.root);
                }
            },
            {
                key: "clear",
                value: function() {
                    this.root = null, this.size = 0, this.modificationCount++;
                }
            },
            {
                key: "has",
                value: function(t) {
                    return this.validKey(t) && 0 == this.splay(t);
                }
            },
            {
                key: "defaultCompare",
                value: function() {
                    return function(t, e) {
                        return t < e ? -1 : t > e ? 1 : 0;
                    };
                }
            },
            {
                key: "wrap",
                value: function() {
                    var t = this;
                    return {
                        getRoot: function() {
                            return t.root;
                        },
                        setRoot: function(e) {
                            t.root = e;
                        },
                        getSize: function() {
                            return t.size;
                        },
                        getModificationCount: function() {
                            return t.modificationCount;
                        },
                        getSplayCount: function() {
                            return t.splayCount;
                        },
                        setSplayCount: function(e) {
                            t.splayCount = e;
                        },
                        splay: function(e) {
                            return t.splay(e);
                        },
                        has: function(e) {
                            return t.has(e);
                        }
                    };
                }
            }
        ]);
    }(), Is = function(t) {
        function e(t, n) {
            var o;
            return i(this, e), u(o = r(this, e), "root", null), u(o, "compare", void 0), u(o, "validKey", void 0), u(o, Symbol.toStringTag, "[object Set]"), o.compare = null != t ? t : o.defaultCompare(), o.validKey = null != n ? n : function(t) {
                return null != t && null != t;
            }, o;
        }
        return h(e, t), s(e, [
            {
                key: "delete",
                value: function(t) {
                    return !!this.validKey(t) && null != this._delete(t);
                }
            },
            {
                key: "deleteAll",
                value: function(t) {
                    var e, n = a(t);
                    try {
                        for(n.s(); !(e = n.n()).done;){
                            var r = e.value;
                            this.delete(r);
                        }
                    } catch (t) {
                        n.e(t);
                    } finally{
                        n.f();
                    }
                }
            },
            {
                key: "forEach",
                value: function(t) {
                    for(var e, n = this[Symbol.iterator](); !(e = n.next()).done;)t(e.value, e.value, this);
                }
            },
            {
                key: "add",
                value: function(t) {
                    var e = this.splay(t);
                    return 0 != e && this.addNewRoot(new ws(t), e), this;
                }
            },
            {
                key: "addAndReturn",
                value: function(t) {
                    var e = this.splay(t);
                    return 0 != e && this.addNewRoot(new ws(t), e), this.root.key;
                }
            },
            {
                key: "addAll",
                value: function(t) {
                    var e, n = a(t);
                    try {
                        for(n.s(); !(e = n.n()).done;){
                            var r = e.value;
                            this.add(r);
                        }
                    } catch (t) {
                        n.e(t);
                    } finally{
                        n.f();
                    }
                }
            },
            {
                key: "isEmpty",
                value: function() {
                    return null == this.root;
                }
            },
            {
                key: "isNotEmpty",
                value: function() {
                    return null != this.root;
                }
            },
            {
                key: "single",
                value: function() {
                    if (0 == this.size) throw "Bad state: No element";
                    if (this.size > 1) throw "Bad state: Too many element";
                    return this.root.key;
                }
            },
            {
                key: "first",
                value: function() {
                    if (0 == this.size) throw "Bad state: No element";
                    return this._first().key;
                }
            },
            {
                key: "last",
                value: function() {
                    if (0 == this.size) throw "Bad state: No element";
                    return this._last().key;
                }
            },
            {
                key: "lastBefore",
                value: function(t) {
                    if (null == t) throw "Invalid arguments(s)";
                    if (null == this.root) return null;
                    if (this.splay(t) < 0) return this.root.key;
                    var e = this.root.left;
                    if (null == e) return null;
                    for(var n = e.right; null != n;)n = (e = n).right;
                    return e.key;
                }
            },
            {
                key: "firstAfter",
                value: function(t) {
                    if (null == t) throw "Invalid arguments(s)";
                    if (null == this.root) return null;
                    if (this.splay(t) > 0) return this.root.key;
                    var e = this.root.right;
                    if (null == e) return null;
                    for(var n = e.left; null != n;)n = (e = n).left;
                    return e.key;
                }
            },
            {
                key: "retainAll",
                value: function(t) {
                    var n, r = new e(this.compare, this.validKey), i = this.modificationCount, o = a(t);
                    try {
                        for(o.s(); !(n = o.n()).done;){
                            var s = n.value;
                            if (i != this.modificationCount) throw "Concurrent modification during iteration.";
                            this.validKey(s) && 0 == this.splay(s) && r.add(this.root.key);
                        }
                    } catch (t) {
                        o.e(t);
                    } finally{
                        o.f();
                    }
                    r.size != this.size && (this.root = r.root, this.size = r.size, this.modificationCount++);
                }
            },
            {
                key: "lookup",
                value: function(t) {
                    return this.validKey(t) ? 0 != this.splay(t) ? null : this.root.key : null;
                }
            },
            {
                key: "intersection",
                value: function(t) {
                    var n, r = new e(this.compare, this.validKey), i = a(this);
                    try {
                        for(i.s(); !(n = i.n()).done;){
                            var o = n.value;
                            t.has(o) && r.add(o);
                        }
                    } catch (t) {
                        i.e(t);
                    } finally{
                        i.f();
                    }
                    return r;
                }
            },
            {
                key: "difference",
                value: function(t) {
                    var n, r = new e(this.compare, this.validKey), i = a(this);
                    try {
                        for(i.s(); !(n = i.n()).done;){
                            var o = n.value;
                            t.has(o) || r.add(o);
                        }
                    } catch (t) {
                        i.e(t);
                    } finally{
                        i.f();
                    }
                    return r;
                }
            },
            {
                key: "union",
                value: function(t) {
                    var e = this.clone();
                    return e.addAll(t), e;
                }
            },
            {
                key: "clone",
                value: function() {
                    var t = new e(this.compare, this.validKey);
                    return t.size = this.size, t.root = this.copyNode(this.root), t;
                }
            },
            {
                key: "copyNode",
                value: function(t) {
                    if (null == t) return null;
                    var e = new ws(t.key);
                    return function t(e, n) {
                        var r, i;
                        do {
                            if (r = e.left, i = e.right, null != r) {
                                var o = new ws(r.key);
                                n.left = o, t(r, o);
                            }
                            if (null != i) {
                                var s = new ws(i.key);
                                n.right = s, e = i, n = s;
                            }
                        }while (null != i);
                    }(t, e), e;
                }
            },
            {
                key: "toSet",
                value: function() {
                    return this.clone();
                }
            },
            {
                key: "entries",
                value: function() {
                    return new Ms(this.wrap());
                }
            },
            {
                key: "keys",
                value: function() {
                    return this[Symbol.iterator]();
                }
            },
            {
                key: "values",
                value: function() {
                    return this[Symbol.iterator]();
                }
            },
            {
                key: Symbol.iterator,
                value: function() {
                    return new Ss(this.wrap());
                }
            }
        ]);
    }(bs), Ns = function() {
        return s(function t(e) {
            i(this, t), u(this, "tree", void 0), u(this, "path", new Array), u(this, "modificationCount", null), u(this, "splayCount", void 0), this.tree = e, this.splayCount = e.getSplayCount();
        }, [
            {
                key: Symbol.iterator,
                value: function() {
                    return this;
                }
            },
            {
                key: "next",
                value: function() {
                    return this.moveNext() ? {
                        done: !1,
                        value: this.current()
                    } : {
                        done: !0,
                        value: null
                    };
                }
            },
            {
                key: "current",
                value: function() {
                    if (!this.path.length) return null;
                    var t = this.path[this.path.length - 1];
                    return this.getValue(t);
                }
            },
            {
                key: "rebuildPath",
                value: function(t) {
                    this.path.splice(0, this.path.length), this.tree.splay(t), this.path.push(this.tree.getRoot()), this.splayCount = this.tree.getSplayCount();
                }
            },
            {
                key: "findLeftMostDescendent",
                value: function(t) {
                    for(; null != t;)this.path.push(t), t = t.left;
                }
            },
            {
                key: "moveNext",
                value: function() {
                    if (this.modificationCount != this.tree.getModificationCount()) {
                        if (null == this.modificationCount) {
                            this.modificationCount = this.tree.getModificationCount();
                            for(var t = this.tree.getRoot(); null != t;)this.path.push(t), t = t.left;
                            return this.path.length > 0;
                        }
                        throw "Concurrent modification during iteration.";
                    }
                    if (!this.path.length) return !1;
                    this.splayCount != this.tree.getSplayCount() && this.rebuildPath(this.path[this.path.length - 1].key);
                    var e = this.path[this.path.length - 1], n = e.right;
                    if (null != n) {
                        for(; null != n;)this.path.push(n), n = n.left;
                        return !0;
                    }
                    for(this.path.pop(); this.path.length && this.path[this.path.length - 1].right === e;)e = this.path.pop();
                    return this.path.length > 0;
                }
            }
        ]);
    }(), Ss = function(t) {
        function e() {
            return i(this, e), r(this, e, arguments);
        }
        return h(e, t), s(e, [
            {
                key: "getValue",
                value: function(t) {
                    return t.key;
                }
            }
        ]);
    }(Ns), Ms = function(t) {
        function e() {
            return i(this, e), r(this, e, arguments);
        }
        return h(e, t), s(e, [
            {
                key: "getValue",
                value: function(t) {
                    return [
                        t.key,
                        t.key
                    ];
                }
            }
        ]);
    }(Ns), Ls = function(t) {
        return function() {
            return t;
        };
    }, Ps = function(t) {
        var e = t ? function(e, n) {
            return n.minus(e).abs().isLessThanOrEqualTo(t);
        } : Ls(!1);
        return function(t, n) {
            return e(t, n) ? 0 : t.comparedTo(n);
        };
    };
    function Cs(t) {
        var e = t ? function(e, n, r, i, o) {
            return e.exponentiatedBy(2).isLessThanOrEqualTo(i.minus(n).exponentiatedBy(2).plus(o.minus(r).exponentiatedBy(2)).times(t));
        } : Ls(!1);
        return function(t, n, r) {
            var i = t.x, o = t.y, s = r.x, a = r.y, u = o.minus(a).times(n.x.minus(s)).minus(i.minus(s).times(n.y.minus(a)));
            return e(u, i, o, s, a) ? 0 : u.comparedTo(0);
        };
    }
    var Ts = function(t) {
        return t;
    }, Os = function(t) {
        if (t) {
            var e = new Is(Ps(t)), n = new Is(Ps(t)), r = function(t, e) {
                return e.addAndReturn(t);
            }, i = function(t) {
                return {
                    x: r(t.x, e),
                    y: r(t.y, n)
                };
            };
            return i({
                x: new ks(0),
                y: new ks(0)
            }), i;
        }
        return Ts;
    }, Rs = function(t) {
        return {
            set: function(t) {
                As = Rs(t);
            },
            reset: function() {
                return Rs(t);
            },
            compare: Ps(t),
            snap: Os(t),
            orient: Cs(t)
        };
    }, As = Rs(), Ds = function(t, e) {
        return t.ll.x.isLessThanOrEqualTo(e.x) && e.x.isLessThanOrEqualTo(t.ur.x) && t.ll.y.isLessThanOrEqualTo(e.y) && e.y.isLessThanOrEqualTo(t.ur.y);
    }, Fs = function(t, e) {
        if (e.ur.x.isLessThan(t.ll.x) || t.ur.x.isLessThan(e.ll.x) || e.ur.y.isLessThan(t.ll.y) || t.ur.y.isLessThan(e.ll.y)) return null;
        var n = t.ll.x.isLessThan(e.ll.x) ? e.ll.x : t.ll.x, r = t.ur.x.isLessThan(e.ur.x) ? t.ur.x : e.ur.x;
        return {
            ll: {
                x: n,
                y: t.ll.y.isLessThan(e.ll.y) ? e.ll.y : t.ll.y
            },
            ur: {
                x: r,
                y: t.ur.y.isLessThan(e.ur.y) ? t.ur.y : e.ur.y
            }
        };
    }, qs = function(t, e) {
        return t.x.times(e.y).minus(t.y.times(e.x));
    }, Gs = function(t, e) {
        return t.x.times(e.x).plus(t.y.times(e.y));
    }, Ys = function(t) {
        return Gs(t, t).sqrt();
    }, Bs = function(t, e, n) {
        var r = {
            x: e.x.minus(t.x),
            y: e.y.minus(t.y)
        }, i = {
            x: n.x.minus(t.x),
            y: n.y.minus(t.y)
        };
        return Gs(i, r).div(Ys(i)).div(Ys(r));
    }, zs = function(t, e, n) {
        return e.y.isZero() ? null : {
            x: t.x.plus(e.x.div(e.y).times(n.minus(t.y))),
            y: n
        };
    }, js = function(t, e, n) {
        return e.x.isZero() ? null : {
            x: n,
            y: t.y.plus(e.y.div(e.x).times(n.minus(t.x)))
        };
    }, Xs = function() {
        function t(e, n) {
            i(this, t), u(this, "point", void 0), u(this, "isLeft", void 0), u(this, "segment", void 0), u(this, "otherSE", void 0), u(this, "consumedBy", void 0), void 0 === e.events ? e.events = [
                this
            ] : e.events.push(this), this.point = e, this.isLeft = n;
        }
        return s(t, [
            {
                key: "link",
                value: function(t) {
                    if (t.point === this.point) throw new Error("Tried to link already linked events");
                    for(var e = t.point.events, n = 0, r = e.length; n < r; n++){
                        var i = e[n];
                        this.point.events.push(i), i.point = this.point;
                    }
                    this.checkForConsuming();
                }
            },
            {
                key: "checkForConsuming",
                value: function() {
                    for(var t = this.point.events.length, e = 0; e < t; e++){
                        var n = this.point.events[e];
                        if (void 0 === n.segment.consumedBy) for(var r = e + 1; r < t; r++){
                            var i = this.point.events[r];
                            void 0 === i.consumedBy && n.otherSE.point.events === i.otherSE.point.events && n.segment.consume(i.segment);
                        }
                    }
                }
            },
            {
                key: "getAvailableLinkedEvents",
                value: function() {
                    for(var t = [], e = 0, n = this.point.events.length; e < n; e++){
                        var r = this.point.events[e];
                        r !== this && !r.segment.ringOut && r.segment.isInResult() && t.push(r);
                    }
                    return t;
                }
            },
            {
                key: "getLeftmostComparator",
                value: function(t) {
                    var e = this, n = new Map, r = function(r) {
                        var i, o, s, a, u, l = r.otherSE;
                        n.set(r, {
                            sine: (i = e.point, o = t.point, s = l.point, a = {
                                x: o.x.minus(i.x),
                                y: o.y.minus(i.y)
                            }, u = {
                                x: s.x.minus(i.x),
                                y: s.y.minus(i.y)
                            }, qs(u, a).div(Ys(u)).div(Ys(a))),
                            cosine: Bs(e.point, t.point, l.point)
                        });
                    };
                    return function(t, e) {
                        n.has(t) || r(t), n.has(e) || r(e);
                        var i = n.get(t), o = i.sine, s = i.cosine, a = n.get(e), u = a.sine, l = a.cosine;
                        return o.isGreaterThanOrEqualTo(0) && u.isGreaterThanOrEqualTo(0) ? s.isLessThan(l) ? 1 : s.isGreaterThan(l) ? -1 : 0 : o.isLessThan(0) && u.isLessThan(0) ? s.isLessThan(l) ? -1 : s.isGreaterThan(l) ? 1 : 0 : u.isLessThan(o) ? -1 : u.isGreaterThan(o) ? 1 : 0;
                    };
                }
            }
        ], [
            {
                key: "compare",
                value: function(e, n) {
                    var r = t.comparePoints(e.point, n.point);
                    return 0 !== r ? r : (e.point !== n.point && e.link(n), e.isLeft !== n.isLeft ? e.isLeft ? 1 : -1 : Qs.compare(e.segment, n.segment));
                }
            },
            {
                key: "comparePoints",
                value: function(t, e) {
                    return t.x.isLessThan(e.x) ? -1 : t.x.isGreaterThan(e.x) ? 1 : t.y.isLessThan(e.y) ? -1 : t.y.isGreaterThan(e.y) ? 1 : 0;
                }
            }
        ]);
    }(), Us = function() {
        function t(e) {
            i(this, t), u(this, "events", void 0), u(this, "poly", void 0), u(this, "_isExteriorRing", void 0), u(this, "_enclosingRing", void 0), this.events = e;
            for(var n = 0, r = e.length; n < r; n++)e[n].segment.ringOut = this;
            this.poly = null;
        }
        return s(t, [
            {
                key: "getGeom",
                value: function() {
                    for(var t = this.events[0].point, e = [
                        t
                    ], n = 1, r = this.events.length - 1; n < r; n++){
                        var i = this.events[n].point, o = this.events[n + 1].point;
                        0 !== As.orient(i, t, o) && (e.push(i), t = i);
                    }
                    if (1 === e.length) return null;
                    var s = e[0], a = e[1];
                    0 === As.orient(s, t, a) && e.shift(), e.push(e[0]);
                    for(var u = this.isExteriorRing() ? 1 : -1, l = this.isExteriorRing() ? 0 : e.length - 1, h = this.isExteriorRing() ? e.length : -1, c = [], f = l; f != h; f += u)c.push([
                        e[f].x.toNumber(),
                        e[f].y.toNumber()
                    ]);
                    return c;
                }
            },
            {
                key: "isExteriorRing",
                value: function() {
                    if (void 0 === this._isExteriorRing) {
                        var t = this.enclosingRing();
                        this._isExteriorRing = !t || !t.isExteriorRing();
                    }
                    return this._isExteriorRing;
                }
            },
            {
                key: "enclosingRing",
                value: function() {
                    return void 0 === this._enclosingRing && (this._enclosingRing = this._calcEnclosingRing()), this._enclosingRing;
                }
            },
            {
                key: "_calcEnclosingRing",
                value: function() {
                    for(var t = this.events[0], e = 1, n = this.events.length; e < n; e++){
                        var r = this.events[e];
                        Xs.compare(t, r) > 0 && (t = r);
                    }
                    for(var i = t.segment.prevInResult(), o = i ? i.prevInResult() : null;;){
                        if (!i) return null;
                        if (!o) return i.ringOut;
                        var s, a;
                        if (o.ringOut !== i.ringOut) return (null === (s = o.ringOut) || void 0 === s ? void 0 : s.enclosingRing()) !== i.ringOut ? i.ringOut : null === (a = i.ringOut) || void 0 === a ? void 0 : a.enclosingRing();
                        i = o.prevInResult(), o = i ? i.prevInResult() : null;
                    }
                }
            }
        ], [
            {
                key: "factory",
                value: function(e) {
                    for(var n = [], r = 0, i = e.length; r < i; r++){
                        var o = e[r];
                        if (o.isInResult() && !o.ringOut) {
                            for(var s = null, a = o.leftSE, u = o.rightSE, l = [
                                a
                            ], h = a.point, c = []; s = a, a = u, l.push(a), a.point !== h;)for(;;){
                                var f = a.getAvailableLinkedEvents();
                                if (0 === f.length) {
                                    var v = l[0].point, g = l[l.length - 1].point;
                                    throw new Error("Unable to complete output ring starting at [".concat(v.x, ", ").concat(v.y, "]. Last matching segment found ends at [").concat(g.x, ", ").concat(g.y, "]."));
                                }
                                if (1 === f.length) {
                                    u = f[0].otherSE;
                                    break;
                                }
                                for(var d = null, p = 0, y = c.length; p < y; p++)if (c[p].point === a.point) {
                                    d = p;
                                    break;
                                }
                                if (null === d) {
                                    c.push({
                                        index: l.length,
                                        point: a.point
                                    });
                                    var m = a.getLeftmostComparator(s);
                                    u = f.sort(m)[0].otherSE;
                                    break;
                                }
                                var _ = c.splice(d)[0], x = l.splice(_.index);
                                x.unshift(x[0].otherSE), n.push(new t(x.reverse()));
                            }
                            n.push(new t(l));
                        }
                    }
                    return n;
                }
            }
        ]);
    }(), Vs = function() {
        return s(function t(e) {
            i(this, t), u(this, "exteriorRing", void 0), u(this, "interiorRings", void 0), this.exteriorRing = e, e.poly = this, this.interiorRings = [];
        }, [
            {
                key: "addInterior",
                value: function(t) {
                    this.interiorRings.push(t), t.poly = this;
                }
            },
            {
                key: "getGeom",
                value: function() {
                    var t = this.exteriorRing.getGeom();
                    if (null === t) return null;
                    for(var e = [
                        t
                    ], n = 0, r = this.interiorRings.length; n < r; n++){
                        var i = this.interiorRings[n].getGeom();
                        null !== i && e.push(i);
                    }
                    return e;
                }
            }
        ]);
    }(), Zs = function() {
        return s(function t(e) {
            i(this, t), u(this, "rings", void 0), u(this, "polys", void 0), this.rings = e, this.polys = this._composePolys(e);
        }, [
            {
                key: "getGeom",
                value: function() {
                    for(var t = [], e = 0, n = this.polys.length; e < n; e++){
                        var r = this.polys[e].getGeom();
                        null !== r && t.push(r);
                    }
                    return t;
                }
            },
            {
                key: "_composePolys",
                value: function(t) {
                    for(var e = [], n = 0, r = t.length; n < r; n++){
                        var i = t[n];
                        if (!i.poly) {
                            if (i.isExteriorRing()) e.push(new Vs(i));
                            else {
                                var o, s = i.enclosingRing();
                                null != s && s.poly || e.push(new Vs(s)), null == s || null === (o = s.poly) || void 0 === o || o.addInterior(i);
                            }
                        }
                    }
                    return e;
                }
            }
        ]);
    }(), Hs = function() {
        return s(function t(e) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Qs.compare;
            i(this, t), u(this, "queue", void 0), u(this, "tree", void 0), u(this, "segments", void 0), this.queue = e, this.tree = new Is(n), this.segments = [];
        }, [
            {
                key: "process",
                value: function(t) {
                    var e = t.segment, n = [];
                    if (t.consumedBy) return t.isLeft ? this.queue.delete(t.otherSE) : this.tree.delete(e), n;
                    t.isLeft && this.tree.add(e);
                    var r = e, i = e;
                    do r = this.tree.lastBefore(r);
                    while (null != r && null != r.consumedBy);
                    do i = this.tree.firstAfter(i);
                    while (null != i && null != i.consumedBy);
                    if (t.isLeft) {
                        var o = null;
                        if (r) {
                            var s = r.getIntersection(e);
                            if (null !== s && (e.isAnEndpoint(s) || (o = s), !r.isAnEndpoint(s))) for(var a = this._splitSafely(r, s), u = 0, l = a.length; u < l; u++)n.push(a[u]);
                        }
                        var h = null;
                        if (i) {
                            var c = i.getIntersection(e);
                            if (null !== c && (e.isAnEndpoint(c) || (h = c), !i.isAnEndpoint(c))) for(var f = this._splitSafely(i, c), v = 0, g = f.length; v < g; v++)n.push(f[v]);
                        }
                        if (null !== o || null !== h) {
                            var d = null;
                            if (null === o) d = h;
                            else if (null === h) d = o;
                            else d = Xs.comparePoints(o, h) <= 0 ? o : h;
                            this.queue.delete(e.rightSE), n.push(e.rightSE);
                            for(var p = e.split(d), y = 0, m = p.length; y < m; y++)n.push(p[y]);
                        }
                        n.length > 0 ? (this.tree.delete(e), n.push(t)) : (this.segments.push(e), e.prev = r);
                    } else {
                        if (r && i) {
                            var _ = r.getIntersection(i);
                            if (null !== _) {
                                if (!r.isAnEndpoint(_)) for(var x = this._splitSafely(r, _), E = 0, k = x.length; E < k; E++)n.push(x[E]);
                                if (!i.isAnEndpoint(_)) for(var w = this._splitSafely(i, _), b = 0, I = w.length; b < I; b++)n.push(w[b]);
                            }
                        }
                        this.tree.delete(e);
                    }
                    return n;
                }
            },
            {
                key: "_splitSafely",
                value: function(t, e) {
                    this.tree.delete(t);
                    var n = t.rightSE;
                    this.queue.delete(n);
                    var r = t.split(e);
                    return r.push(n), void 0 === t.consumedBy && this.tree.add(t), r;
                }
            }
        ]);
    }(), Ws = new (function() {
        return s(function t() {
            i(this, t), u(this, "type", void 0), u(this, "numMultiPolys", void 0);
        }, [
            {
                key: "run",
                value: function(t, e, n) {
                    Ws.type = t;
                    for(var r = [
                        new ea(e, !0)
                    ], i = 0, o = n.length; i < o; i++)r.push(new ea(n[i], !1));
                    if (Ws.numMultiPolys = r.length, "difference" === Ws.type) for(var s = r[0], a = 1; a < r.length;)null !== Fs(r[a].bbox, s.bbox) ? a++ : r.splice(a, 1);
                    if ("intersection" === Ws.type) {
                        for(var u = 0, l = r.length; u < l; u++)for(var h = r[u], c = u + 1, f = r.length; c < f; c++)if (null === Fs(h.bbox, r[c].bbox)) return [];
                    }
                    for(var v = new Is(Xs.compare), g = 0, d = r.length; g < d; g++)for(var p = r[g].getSweepEvents(), y = 0, m = p.length; y < m; y++)v.add(p[y]);
                    var _ = new Hs(v), x = null;
                    for(0 != v.size && (x = v.first(), v.delete(x)); x;){
                        for(var E = _.process(x), k = 0, w = E.length; k < w; k++){
                            var b = E[k];
                            void 0 === b.consumedBy && v.add(b);
                        }
                        0 != v.size ? (x = v.first(), v.delete(x)) : x = null;
                    }
                    As.reset();
                    var I = Us.factory(_.segments);
                    return new Zs(I).getGeom();
                }
            }
        ]);
    }()), Js = Ws, Ks = 0, Qs = function() {
        function t(e, n, r, o) {
            i(this, t), u(this, "id", void 0), u(this, "leftSE", void 0), u(this, "rightSE", void 0), u(this, "rings", void 0), u(this, "windings", void 0), u(this, "ringOut", void 0), u(this, "consumedBy", void 0), u(this, "prev", void 0), u(this, "_prevInResult", void 0), u(this, "_beforeState", void 0), u(this, "_afterState", void 0), u(this, "_isInResult", void 0), this.id = ++Ks, this.leftSE = e, e.segment = this, e.otherSE = n, this.rightSE = n, n.segment = this, n.otherSE = e, this.rings = r, this.windings = o;
        }
        return s(t, [
            {
                key: "replaceRightSE",
                value: function(t) {
                    this.rightSE = t, this.rightSE.segment = this, this.rightSE.otherSE = this.leftSE, this.leftSE.otherSE = this.rightSE;
                }
            },
            {
                key: "bbox",
                value: function() {
                    var t = this.leftSE.point.y, e = this.rightSE.point.y;
                    return {
                        ll: {
                            x: this.leftSE.point.x,
                            y: t.isLessThan(e) ? t : e
                        },
                        ur: {
                            x: this.rightSE.point.x,
                            y: t.isGreaterThan(e) ? t : e
                        }
                    };
                }
            },
            {
                key: "vector",
                value: function() {
                    return {
                        x: this.rightSE.point.x.minus(this.leftSE.point.x),
                        y: this.rightSE.point.y.minus(this.leftSE.point.y)
                    };
                }
            },
            {
                key: "isAnEndpoint",
                value: function(t) {
                    return t.x.eq(this.leftSE.point.x) && t.y.eq(this.leftSE.point.y) || t.x.eq(this.rightSE.point.x) && t.y.eq(this.rightSE.point.y);
                }
            },
            {
                key: "comparePoint",
                value: function(t) {
                    return As.orient(this.leftSE.point, t, this.rightSE.point);
                }
            },
            {
                key: "getIntersection",
                value: function(t) {
                    var e = this.bbox(), n = t.bbox(), r = Fs(e, n);
                    if (null === r) return null;
                    var i = this.leftSE.point, o = this.rightSE.point, s = t.leftSE.point, a = t.rightSE.point, u = Ds(e, s) && 0 === this.comparePoint(s), l = Ds(n, i) && 0 === t.comparePoint(i), h = Ds(e, a) && 0 === this.comparePoint(a), c = Ds(n, o) && 0 === t.comparePoint(o);
                    if (l && u) return c && !h ? o : !c && h ? a : null;
                    if (l) return h && i.x.eq(a.x) && i.y.eq(a.y) ? null : i;
                    if (u) return c && o.x.eq(s.x) && o.y.eq(s.y) ? null : s;
                    if (c && h) return null;
                    if (c) return o;
                    if (h) return a;
                    var f = function(t, e, n, r) {
                        if (e.x.isZero()) return js(n, r, t.x);
                        if (r.x.isZero()) return js(t, e, n.x);
                        if (e.y.isZero()) return zs(n, r, t.y);
                        if (r.y.isZero()) return zs(t, e, n.y);
                        var i = qs(e, r);
                        if (i.isZero()) return null;
                        var o = {
                            x: n.x.minus(t.x),
                            y: n.y.minus(t.y)
                        }, s = qs(o, e).div(i), a = qs(o, r).div(i), u = t.x.plus(a.times(e.x)), l = n.x.plus(s.times(r.x)), h = t.y.plus(a.times(e.y)), c = n.y.plus(s.times(r.y));
                        return {
                            x: u.plus(l).div(2),
                            y: h.plus(c).div(2)
                        };
                    }(i, this.vector(), s, t.vector());
                    return null === f ? null : Ds(r, f) ? As.snap(f) : null;
                }
            },
            {
                key: "split",
                value: function(e) {
                    var n = [], r = void 0 !== e.events, i = new Xs(e, !0), o = new Xs(e, !1), s = this.rightSE;
                    this.replaceRightSE(o), n.push(o), n.push(i);
                    var a = new t(i, s, this.rings.slice(), this.windings.slice());
                    return Xs.comparePoints(a.leftSE.point, a.rightSE.point) > 0 && a.swapEvents(), Xs.comparePoints(this.leftSE.point, this.rightSE.point) > 0 && this.swapEvents(), r && (i.checkForConsuming(), o.checkForConsuming()), n;
                }
            },
            {
                key: "swapEvents",
                value: function() {
                    var t = this.rightSE;
                    this.rightSE = this.leftSE, this.leftSE = t, this.leftSE.isLeft = !0, this.rightSE.isLeft = !1;
                    for(var e = 0, n = this.windings.length; e < n; e++)this.windings[e] *= -1;
                }
            },
            {
                key: "consume",
                value: function(e) {
                    for(var n = this, r = e; n.consumedBy;)n = n.consumedBy;
                    for(; r.consumedBy;)r = r.consumedBy;
                    var i = t.compare(n, r);
                    if (0 !== i) {
                        if (i > 0) {
                            var o = n;
                            n = r, r = o;
                        }
                        if (n.prev === r) {
                            var s = n;
                            n = r, r = s;
                        }
                        for(var a = 0, u = r.rings.length; a < u; a++){
                            var l = r.rings[a], h = r.windings[a], c = n.rings.indexOf(l);
                            -1 === c ? (n.rings.push(l), n.windings.push(h)) : n.windings[c] += h;
                        }
                        r.rings = null, r.windings = null, r.consumedBy = n, r.leftSE.consumedBy = n.leftSE, r.rightSE.consumedBy = n.rightSE;
                    }
                }
            },
            {
                key: "prevInResult",
                value: function() {
                    return void 0 !== this._prevInResult || (this.prev ? this.prev.isInResult() ? this._prevInResult = this.prev : this._prevInResult = this.prev.prevInResult() : this._prevInResult = null), this._prevInResult;
                }
            },
            {
                key: "beforeState",
                value: function() {
                    if (void 0 !== this._beforeState) return this._beforeState;
                    if (this.prev) {
                        var t = this.prev.consumedBy || this.prev;
                        this._beforeState = t.afterState();
                    } else this._beforeState = {
                        rings: [],
                        windings: [],
                        multiPolys: []
                    };
                    return this._beforeState;
                }
            },
            {
                key: "afterState",
                value: function() {
                    if (void 0 !== this._afterState) return this._afterState;
                    var t = this.beforeState();
                    this._afterState = {
                        rings: t.rings.slice(0),
                        windings: t.windings.slice(0),
                        multiPolys: []
                    };
                    for(var e = this._afterState.rings, n = this._afterState.windings, r = this._afterState.multiPolys, i = 0, o = this.rings.length; i < o; i++){
                        var s = this.rings[i], a = this.windings[i], u = e.indexOf(s);
                        -1 === u ? (e.push(s), n.push(a)) : n[u] += a;
                    }
                    for(var l = [], h = [], c = 0, f = e.length; c < f; c++)if (0 !== n[c]) {
                        var v = e[c], g = v.poly;
                        if (-1 === h.indexOf(g)) {
                            if (v.isExterior) l.push(g);
                            else {
                                -1 === h.indexOf(g) && h.push(g);
                                var d = l.indexOf(v.poly);
                                -1 !== d && l.splice(d, 1);
                            }
                        }
                    }
                    for(var p = 0, y = l.length; p < y; p++){
                        var m = l[p].multiPoly;
                        -1 === r.indexOf(m) && r.push(m);
                    }
                    return this._afterState;
                }
            },
            {
                key: "isInResult",
                value: function() {
                    if (this.consumedBy) return !1;
                    if (void 0 !== this._isInResult) return this._isInResult;
                    var t = this.beforeState().multiPolys, e = this.afterState().multiPolys;
                    switch(Js.type){
                        case "union":
                            var n = 0 === t.length, r = 0 === e.length;
                            this._isInResult = n !== r;
                            break;
                        case "intersection":
                            var i, o;
                            t.length < e.length ? (i = t.length, o = e.length) : (i = e.length, o = t.length), this._isInResult = o === Js.numMultiPolys && i < o;
                            break;
                        case "xor":
                            var s = Math.abs(t.length - e.length);
                            this._isInResult = s % 2 == 1;
                            break;
                        case "difference":
                            var a = function(t) {
                                return 1 === t.length && t[0].isSubject;
                            };
                            this._isInResult = a(t) !== a(e);
                    }
                    return this._isInResult;
                }
            }
        ], [
            {
                key: "compare",
                value: function(t, e) {
                    var n = t.leftSE.point.x, r = e.leftSE.point.x, i = t.rightSE.point.x, o = e.rightSE.point.x;
                    if (o.isLessThan(n)) return 1;
                    if (i.isLessThan(r)) return -1;
                    var s = t.leftSE.point.y, a = e.leftSE.point.y, u = t.rightSE.point.y, l = e.rightSE.point.y;
                    if (n.isLessThan(r)) {
                        if (a.isLessThan(s) && a.isLessThan(u)) return 1;
                        if (a.isGreaterThan(s) && a.isGreaterThan(u)) return -1;
                        var h = t.comparePoint(e.leftSE.point);
                        if (h < 0) return 1;
                        if (h > 0) return -1;
                        var c = e.comparePoint(t.rightSE.point);
                        return 0 !== c ? c : -1;
                    }
                    if (n.isGreaterThan(r)) {
                        if (s.isLessThan(a) && s.isLessThan(l)) return -1;
                        if (s.isGreaterThan(a) && s.isGreaterThan(l)) return 1;
                        var f = e.comparePoint(t.leftSE.point);
                        if (0 !== f) return f;
                        var v = t.comparePoint(e.rightSE.point);
                        return v < 0 ? 1 : v > 0 ? -1 : 1;
                    }
                    if (s.isLessThan(a)) return -1;
                    if (s.isGreaterThan(a)) return 1;
                    if (i.isLessThan(o)) {
                        var g = e.comparePoint(t.rightSE.point);
                        if (0 !== g) return g;
                    }
                    if (i.isGreaterThan(o)) {
                        var d = t.comparePoint(e.rightSE.point);
                        if (d < 0) return 1;
                        if (d > 0) return -1;
                    }
                    if (!i.eq(o)) {
                        var p = u.minus(s), y = i.minus(n), m = l.minus(a), _ = o.minus(r);
                        if (p.isGreaterThan(y) && m.isLessThan(_)) return 1;
                        if (p.isLessThan(y) && m.isGreaterThan(_)) return -1;
                    }
                    return i.isGreaterThan(o) ? 1 : i.isLessThan(o) || u.isLessThan(l) ? -1 : u.isGreaterThan(l) ? 1 : t.id < e.id ? -1 : t.id > e.id ? 1 : 0;
                }
            },
            {
                key: "fromRing",
                value: function(e, n, r) {
                    var i, o, s, a = Xs.comparePoints(e, n);
                    if (a < 0) i = e, o = n, s = 1;
                    else {
                        if (!(a > 0)) throw new Error("Tried to create degenerate segment at [".concat(e.x, ", ").concat(e.y, "]"));
                        i = n, o = e, s = -1;
                    }
                    return new t(new Xs(i, !0), new Xs(o, !1), [
                        r
                    ], [
                        s
                    ]);
                }
            }
        ]);
    }(), $s = function() {
        return s(function t(e, n, r) {
            if (i(this, t), u(this, "poly", void 0), u(this, "isExterior", void 0), u(this, "segments", void 0), u(this, "bbox", void 0), !Array.isArray(e) || 0 === e.length) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
            if (this.poly = n, this.isExterior = r, this.segments = [], "number" != typeof e[0][0] || "number" != typeof e[0][1]) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
            var o = As.snap({
                x: new ks(e[0][0]),
                y: new ks(e[0][1])
            });
            this.bbox = {
                ll: {
                    x: o.x,
                    y: o.y
                },
                ur: {
                    x: o.x,
                    y: o.y
                }
            };
            for(var s = o, a = 1, l = e.length; a < l; a++){
                if ("number" != typeof e[a][0] || "number" != typeof e[a][1]) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
                var h = As.snap({
                    x: new ks(e[a][0]),
                    y: new ks(e[a][1])
                });
                h.x.eq(s.x) && h.y.eq(s.y) || (this.segments.push(Qs.fromRing(s, h, this)), h.x.isLessThan(this.bbox.ll.x) && (this.bbox.ll.x = h.x), h.y.isLessThan(this.bbox.ll.y) && (this.bbox.ll.y = h.y), h.x.isGreaterThan(this.bbox.ur.x) && (this.bbox.ur.x = h.x), h.y.isGreaterThan(this.bbox.ur.y) && (this.bbox.ur.y = h.y), s = h);
            }
            o.x.eq(s.x) && o.y.eq(s.y) || this.segments.push(Qs.fromRing(s, o, this));
        }, [
            {
                key: "getSweepEvents",
                value: function() {
                    for(var t = [], e = 0, n = this.segments.length; e < n; e++){
                        var r = this.segments[e];
                        t.push(r.leftSE), t.push(r.rightSE);
                    }
                    return t;
                }
            }
        ]);
    }(), ta = function() {
        return s(function t(e, n) {
            if (i(this, t), u(this, "multiPoly", void 0), u(this, "exteriorRing", void 0), u(this, "interiorRings", void 0), u(this, "bbox", void 0), !Array.isArray(e)) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
            this.exteriorRing = new $s(e[0], this, !0), this.bbox = {
                ll: {
                    x: this.exteriorRing.bbox.ll.x,
                    y: this.exteriorRing.bbox.ll.y
                },
                ur: {
                    x: this.exteriorRing.bbox.ur.x,
                    y: this.exteriorRing.bbox.ur.y
                }
            }, this.interiorRings = [];
            for(var r = 1, o = e.length; r < o; r++){
                var s = new $s(e[r], this, !1);
                s.bbox.ll.x.isLessThan(this.bbox.ll.x) && (this.bbox.ll.x = s.bbox.ll.x), s.bbox.ll.y.isLessThan(this.bbox.ll.y) && (this.bbox.ll.y = s.bbox.ll.y), s.bbox.ur.x.isGreaterThan(this.bbox.ur.x) && (this.bbox.ur.x = s.bbox.ur.x), s.bbox.ur.y.isGreaterThan(this.bbox.ur.y) && (this.bbox.ur.y = s.bbox.ur.y), this.interiorRings.push(s);
            }
            this.multiPoly = n;
        }, [
            {
                key: "getSweepEvents",
                value: function() {
                    for(var t = this.exteriorRing.getSweepEvents(), e = 0, n = this.interiorRings.length; e < n; e++)for(var r = this.interiorRings[e].getSweepEvents(), i = 0, o = r.length; i < o; i++)t.push(r[i]);
                    return t;
                }
            }
        ]);
    }(), ea = function() {
        return s(function t(e, n) {
            if (i(this, t), u(this, "isSubject", void 0), u(this, "polys", void 0), u(this, "bbox", void 0), !Array.isArray(e)) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
            try {
                "number" == typeof e[0][0][0] && (e = [
                    e
                ]);
            } catch (t) {}
            this.polys = [], this.bbox = {
                ll: {
                    x: new ks(Number.POSITIVE_INFINITY),
                    y: new ks(Number.POSITIVE_INFINITY)
                },
                ur: {
                    x: new ks(Number.NEGATIVE_INFINITY),
                    y: new ks(Number.NEGATIVE_INFINITY)
                }
            };
            for(var r = 0, o = e.length; r < o; r++){
                var s = new ta(e[r], this);
                s.bbox.ll.x.isLessThan(this.bbox.ll.x) && (this.bbox.ll.x = s.bbox.ll.x), s.bbox.ll.y.isLessThan(this.bbox.ll.y) && (this.bbox.ll.y = s.bbox.ll.y), s.bbox.ur.x.isGreaterThan(this.bbox.ur.x) && (this.bbox.ur.x = s.bbox.ur.x), s.bbox.ur.y.isGreaterThan(this.bbox.ur.y) && (this.bbox.ur.y = s.bbox.ur.y), this.polys.push(s);
            }
            this.isSubject = n;
        }, [
            {
                key: "getSweepEvents",
                value: function() {
                    for(var t = [], e = 0, n = this.polys.length; e < n; e++)for(var r = this.polys[e].getSweepEvents(), i = 0, o = r.length; i < o; i++)t.push(r[i]);
                    return t;
                }
            }
        ]);
    }(), na = function(t) {
        for(var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++)n[r - 1] = arguments[r];
        return Js.run("union", t, n);
    }, ra = function(t) {
        for(var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++)n[r - 1] = arguments[r];
        return Js.run("intersection", t, n);
    }, ia = function(t) {
        for(var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++)n[r - 1] = arguments[r];
        return Js.run("difference", t, n);
    }, oa = As.set, sa = Object.freeze({
        __proto__: null,
        difference: ia,
        intersection: ra,
        setPrecision: oa,
        union: na,
        xor: function(t) {
            for(var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++)n[r - 1] = arguments[r];
            return Js.run("xor", t, n);
        }
    });
    function aa(t) {
        if (!t) throw new Error("geojson is required");
        var e = [];
        return bt(t, function(t) {
            e.push(t);
        }), R(e);
    }
    function ua(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 2, r = et(t), i = et(e), o = r[0] - i[0], s = r[1] - i[1];
        return 1 === n ? Math.abs(o) + Math.abs(s) : Math.pow(Math.pow(o, n) + Math.pow(s, n), 1 / n);
    }
    function la(t, e) {
        var n, r, i = (e = e || {}).threshold || 1e4, o = e.p || 2, s = null != (n = e.binary) && n, a = e.alpha || -1, u = null != (r = e.standardization) && r, l = [];
        _t(t, function(t) {
            l.push(Yi(t));
        });
        for(var h = [], c = 0; c < l.length; c++)h[c] = [];
        for(var f = 0; f < l.length; f++)for(var v = f; v < l.length; v++){
            f === v && (h[f][v] = 0);
            var g = ua(l[f], l[v], o);
            h[f][v] = g, h[v][f] = g;
        }
        for(var d = 0; d < l.length; d++)for(var p = 0; p < l.length; p++){
            var y = h[d][p];
            0 !== y && (h[d][p] = s ? y <= i ? 1 : 0 : y <= i ? Math.pow(y, a) : 0);
        }
        if (u) for(var m = 0; m < l.length; m++)for(var _ = h[m].reduce(function(t, e) {
            return t + e;
        }, 0), x = 0; x < l.length; x++)h[m][x] = h[m][x] / _;
        return h;
    }
    function ha(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, r = et(t), i = et(e);
        i[0] += i[0] - r[0] > 180 ? -360 : r[0] - i[0] > 180 ? 360 : 0;
        var o = function(t, e, n) {
            var r = n = void 0 === n ? w : Number(n), i = t[1] * Math.PI / 180, o = e[1] * Math.PI / 180, s = o - i, a = Math.abs(e[0] - t[0]) * Math.PI / 180;
            a > Math.PI && (a -= 2 * Math.PI);
            var u = Math.log(Math.tan(o / 2 + Math.PI / 4) / Math.tan(i / 2 + Math.PI / 4)), l = Math.abs(u) > 1e-11 ? s / u : Math.cos(i);
            return Math.sqrt(s * s + l * l * a * a) * r;
        }(r, i);
        return Z(o, "meters", n.units);
    }
    function ca(t, e, n) {
        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}, i = e < 0, o = Z(Math.abs(e), r.units, "meters");
        i && (o = -Math.abs(o));
        var s = et(t), a = function(t, e, n, r) {
            r = void 0 === r ? w : Number(r);
            var i = e / r, o = t[0] * Math.PI / 180, s = V(t[1]), a = V(n), u = i * Math.cos(a), l = s + u;
            Math.abs(l) > Math.PI / 2 && (l = l > 0 ? Math.PI - l : -Math.PI - l);
            var h = Math.log(Math.tan(l / 2 + Math.PI / 4) / Math.tan(s / 2 + Math.PI / 4)), c = Math.abs(h) > 1e-11 ? u / h : Math.cos(s), f = i * Math.sin(a) / c;
            return [
                (180 * (o + f) / Math.PI + 540) % 360 - 180,
                180 * l / Math.PI
            ];
        }(s, o, n);
        return a[0] += a[0] - s[0] > 180 ? -360 : s[0] - a[0] > 180 ? 360 : 0, M(a, r.properties);
    }
    function fa(t, e, n) {
        if (!J(n = n || {})) throw new Error("options is invalid");
        var r = n.pivot, i = n.mutate;
        if (!t) throw new Error("geojson is required");
        if (null == e || isNaN(e)) throw new Error("angle is required");
        if (0 === e) return t;
        var o = null != r ? r : Yi(t);
        return !1 !== i && void 0 !== i || (t = so(t)), dt(t, function(t) {
            var n = vt(o, t) + e, r = ha(o, t), i = nt(ca(o, r, n));
            t[0] = i[0], t[1] = i[1];
        }), K(t), t;
    }
    function va(t, e, n, r) {
        var i = (r = r || {}).steps || 64, o = r.units || "kilometers", s = r.angle || 0, a = r.pivot || t, u = r.properties || {};
        if (!t) throw new Error("center is required");
        if (!e) throw new Error("xSemiAxis is required");
        if (!n) throw new Error("ySemiAxis is required");
        if (!J(r)) throw new Error("options must be an object");
        if (!W(i)) throw new Error("steps must be a number");
        if (!W(s)) throw new Error("angle must be a number");
        var l = et(fa(M(et(t)), s, {
            pivot: a
        }));
        s = -90 + s, i = Math.ceil(i / 4);
        for(var h = [], c = [], f = e, v = n, g = v, d = (f - v) / (Math.PI / 2), p = (f + v) * Math.PI / 4, y = i, m = 0, _ = 0, x = 0; x < i; x++)_ += m, m = 0 === d ? p / y / g : (-(d * _ + g) + Math.sqrt(Math.pow(d * _ + g, 2) - .5 * d * 4 * (-p / y))) / (.5 * d * 2), 0 != _ && h.push(_);
        c.push(0);
        for(var E = 0; E < h.length; E++)c.push(h[E]);
        c.push(Math.PI / 2);
        for(var k = 0; k < h.length; k++)c.push(Math.PI - h[h.length - k - 1]);
        c.push(Math.PI);
        for(var w = 0; w < h.length; w++)c.push(Math.PI + h[w]);
        c.push(3 * Math.PI / 2);
        for(var b = 0; b < h.length; b++)c.push(2 * Math.PI - h[h.length - b - 1]);
        c.push(0);
        for(var I = [], N = 0, S = c; N < S.length; N++){
            var L = S[N], C = Math.atan2(v * Math.sin(L), f * Math.cos(L)), T = Math.sqrt(Math.pow(f, 2) * Math.pow(v, 2) / (Math.pow(f * Math.sin(C), 2) + Math.pow(v * Math.cos(C), 2)));
            I.push(ct(l, T, s + U(C), {
                units: o
            }).geometry.coordinates);
        }
        return P([
            I
        ], u);
    }
    function ga(t) {
        return jt(qt(t));
    }
    function da(t) {
        var e = [];
        return "FeatureCollection" === t.type ? _t(t, function(t) {
            dt(t, function(n) {
                e.push(M(n, t.properties));
            });
        }) : "Feature" === t.type ? dt(t, function(n) {
            e.push(M(n, t.properties));
        }) : dt(t, function(t) {
            e.push(M(t));
        }), R(e);
    }
    function pa(t) {
        for(var e = Math.pow(10, 6), n = [], r = 0; r < t.length; r++){
            var i = t[r];
            void 0 !== i && (n[r] = Math.round((i + Number.EPSILON) * e) / e);
        }
        return n;
    }
    var ya = Math.PI / 180, ma = 180 / Math.PI, _a = function() {
        function t(e, n) {
            i(this, t), u(this, "lon", void 0), u(this, "lat", void 0), u(this, "x", void 0), u(this, "y", void 0), this.lon = e, this.lat = n, this.x = ya * e, this.y = ya * n;
        }
        return s(t, [
            {
                key: "view",
                value: function() {
                    return String(this.lon).slice(0, 4) + "," + String(this.lat).slice(0, 4);
                }
            },
            {
                key: "antipode",
                value: function() {
                    var e = -1 * this.lat;
                    return new t(this.lon < 0 ? 180 + this.lon : -1 * (180 - this.lon), e);
                }
            }
        ]);
    }(), xa = function() {
        return s(function t(e) {
            i(this, t), u(this, "properties", {}), u(this, "geometries", []), e && (this.properties = e);
        }, [
            {
                key: "json",
                value: function() {
                    if (0 === this.geometries.length) return {
                        type: "Feature",
                        geometry: {
                            type: "LineString",
                            coordinates: null
                        },
                        properties: this.properties
                    };
                    if (1 === this.geometries.length) {
                        var t = this.geometries[0];
                        return t ? {
                            type: "Feature",
                            geometry: {
                                type: "LineString",
                                coordinates: t.coords
                            },
                            properties: this.properties
                        } : {
                            type: "Feature",
                            geometry: {
                                type: "LineString",
                                coordinates: []
                            },
                            properties: this.properties
                        };
                    }
                    return {
                        type: "Feature",
                        geometry: {
                            type: "MultiLineString",
                            coordinates: this.geometries.filter(function(t) {
                                return void 0 !== t;
                            }).map(function(t) {
                                return t.coords;
                            })
                        },
                        properties: this.properties
                    };
                }
            },
            {
                key: "wkt",
                value: function() {
                    if (0 === this.geometries.length) return "";
                    var t, e = [], n = a(this.geometries);
                    try {
                        for(n.s(); !(t = n.n()).done;){
                            var r = t.value;
                            if (r && 0 !== r.coords.length) {
                                var i = r.coords.filter(function(t) {
                                    return void 0 !== t;
                                }).map(function(t) {
                                    var e, n, r = null !== (e = t[0]) && void 0 !== e ? e : 0, i = null !== (n = t[1]) && void 0 !== n ? n : 0;
                                    return "".concat(r, " ").concat(i);
                                });
                                0 === i.length ? e.push("LINESTRING EMPTY") : e.push("LINESTRING(".concat(i.join(","), ")"));
                            } else e.push("LINESTRING EMPTY");
                        }
                    } catch (t) {
                        n.e(t);
                    } finally{
                        n.f();
                    }
                    return e.join("; ");
                }
            }
        ]);
    }(), Ea = function() {
        return s(function t() {
            i(this, t), u(this, "coords", []), u(this, "length", 0);
        }, [
            {
                key: "move_to",
                value: function(t) {
                    this.length++, this.coords.push(t);
                }
            }
        ]);
    }(), ka = function() {
        return s(function t(e, n, r) {
            if (i(this, t), u(this, "start", void 0), u(this, "end", void 0), u(this, "properties", void 0), u(this, "g", void 0), !e || void 0 === e.x || void 0 === e.y) throw new Error("GreatCircle constructor expects two args: start and end objects with x and y properties");
            if (!n || void 0 === n.x || void 0 === n.y) throw new Error("GreatCircle constructor expects two args: start and end objects with x and y properties");
            this.start = new _a(e.x, e.y), this.end = new _a(n.x, n.y), this.properties = r || {};
            var o = this.start.x - this.end.x, s = this.start.y - this.end.y, a = Math.pow(Math.sin(s / 2), 2) + Math.cos(this.start.y) * Math.cos(this.end.y) * Math.pow(Math.sin(o / 2), 2);
            if (this.g = 2 * Math.asin(Math.sqrt(a)), this.g === Math.PI) throw new Error("it appears " + this.start.view() + " and " + this.end.view() + " are 'antipodal', e.g diametrically opposite, thus there is no single route but rather infinite");
            if (isNaN(this.g)) throw new Error("could not calculate great circle between " + e + " and " + n);
        }, [
            {
                key: "interpolate",
                value: function(t) {
                    var e = Math.sin((1 - t) * this.g) / Math.sin(this.g), n = Math.sin(t * this.g) / Math.sin(this.g), r = e * Math.cos(this.start.y) * Math.cos(this.start.x) + n * Math.cos(this.end.y) * Math.cos(this.end.x), i = e * Math.cos(this.start.y) * Math.sin(this.start.x) + n * Math.cos(this.end.y) * Math.sin(this.end.x), o = e * Math.sin(this.start.y) + n * Math.sin(this.end.y), s = ma * Math.atan2(o, Math.sqrt(Math.pow(r, 2) + Math.pow(i, 2)));
                    return [
                        ma * Math.atan2(i, r),
                        s
                    ];
                }
            },
            {
                key: "Arc",
                value: function(t, e) {
                    var n, r = [];
                    if (!t || t <= 2) r.push([
                        this.start.lon,
                        this.start.lat
                    ]), r.push([
                        this.end.lon,
                        this.end.lat
                    ]);
                    else for(var i = 1 / (t - 1), o = 0; o < t; ++o){
                        var s = i * o, a = this.interpolate(s);
                        r.push(a);
                    }
                    for(var u = !1, l = 0, h = null !== (n = null == e ? void 0 : e.offset) && void 0 !== n ? n : 10, c = 180 - h, f = -180 + h, v = 360 - h, g = 1; g < r.length; ++g){
                        var d, p, y, m, _ = null !== (d = null === (p = r[g - 1]) || void 0 === p ? void 0 : p[0]) && void 0 !== d ? d : 0, x = null !== (y = null === (m = r[g]) || void 0 === m ? void 0 : m[0]) && void 0 !== y ? y : 0, E = Math.abs(x - _);
                        E > v && (x > c && _ < f || _ > c && x < f) ? u = !0 : E > l && (l = E);
                    }
                    var k = [];
                    if (u && l < h) {
                        var w = [];
                        k.push(w);
                        for(var b = 0; b < r.length; ++b){
                            var I, N, S, M, L = parseFloat((null !== (I = null === (N = r[b]) || void 0 === N ? void 0 : N[0]) && void 0 !== I ? I : 0).toString());
                            if (b > 0 && Math.abs(L - (null !== (S = null === (M = r[b - 1]) || void 0 === M ? void 0 : M[0]) && void 0 !== S ? S : 0)) > v) {
                                var P, C, T, O, R, A, D, F, q, G, Y, B, z, j, X, U, V, Z, H = parseFloat((null !== (P = null === (C = r[b - 1]) || void 0 === C ? void 0 : C[0]) && void 0 !== P ? P : 0).toString()), W = parseFloat((null !== (T = null === (O = r[b - 1]) || void 0 === O ? void 0 : O[1]) && void 0 !== T ? T : 0).toString()), J = parseFloat((null !== (R = null === (A = r[b]) || void 0 === A ? void 0 : A[0]) && void 0 !== R ? R : 0).toString()), K = parseFloat((null !== (D = null === (F = r[b]) || void 0 === F ? void 0 : F[1]) && void 0 !== D ? D : 0).toString());
                                if (H > -180 && H < f && 180 === J && b + 1 < r.length && (null !== (q = null === (G = r[b - 1]) || void 0 === G ? void 0 : G[0]) && void 0 !== q ? q : 0) > -180 && (null !== (Y = null === (B = r[b - 1]) || void 0 === B ? void 0 : B[0]) && void 0 !== Y ? Y : 0) < f) {
                                    var Q, $, tt, et, nt, rt;
                                    w.push([
                                        -180,
                                        null !== (Q = null === ($ = r[b]) || void 0 === $ ? void 0 : $[1]) && void 0 !== Q ? Q : 0
                                    ]), b++, w.push([
                                        null !== (tt = null === (et = r[b]) || void 0 === et ? void 0 : et[0]) && void 0 !== tt ? tt : 0,
                                        null !== (nt = null === (rt = r[b]) || void 0 === rt ? void 0 : rt[1]) && void 0 !== nt ? nt : 0
                                    ]);
                                    continue;
                                }
                                if (H > c && H < 180 && -180 === J && b + 1 < r.length && (null !== (z = null === (j = r[b - 1]) || void 0 === j ? void 0 : j[0]) && void 0 !== z ? z : 0) > c && (null !== (X = null === (U = r[b - 1]) || void 0 === U ? void 0 : U[0]) && void 0 !== X ? X : 0) < 180) {
                                    var it, ot, st, at, ut, lt;
                                    w.push([
                                        180,
                                        null !== (it = null === (ot = r[b]) || void 0 === ot ? void 0 : ot[1]) && void 0 !== it ? it : 0
                                    ]), b++, w.push([
                                        null !== (st = null === (at = r[b]) || void 0 === at ? void 0 : at[0]) && void 0 !== st ? st : 0,
                                        null !== (ut = null === (lt = r[b]) || void 0 === lt ? void 0 : lt[1]) && void 0 !== ut ? ut : 0
                                    ]);
                                    continue;
                                }
                                if (H <= 180 && J >= 180 && H < J) {
                                    var ht, ct, ft, vt, gt = (180 - H) / (J - H), dt = gt * K + (1 - gt) * W;
                                    w.push([
                                        (null !== (ht = null === (ct = r[b - 1]) || void 0 === ct ? void 0 : ct[0]) && void 0 !== ht ? ht : 0) > c ? 180 : -180,
                                        dt
                                    ]), (w = []).push([
                                        (null !== (ft = null === (vt = r[b - 1]) || void 0 === vt ? void 0 : vt[0]) && void 0 !== ft ? ft : 0) > c ? -180 : 180,
                                        dt
                                    ]), k.push(w);
                                } else w = [], k.push(w);
                                w.push([
                                    L,
                                    null !== (V = null === (Z = r[b]) || void 0 === Z ? void 0 : Z[1]) && void 0 !== V ? V : 0
                                ]);
                            } else {
                                var pt, yt, mt, _t;
                                w.push([
                                    null !== (pt = null === (yt = r[b]) || void 0 === yt ? void 0 : yt[0]) && void 0 !== pt ? pt : 0,
                                    null !== (mt = null === (_t = r[b]) || void 0 === _t ? void 0 : _t[1]) && void 0 !== mt ? mt : 0
                                ]);
                            }
                        }
                    } else {
                        var xt = [];
                        k.push(xt);
                        for(var Et = 0; Et < r.length; ++Et){
                            var kt, wt, bt, It;
                            xt.push([
                                null !== (kt = null === (wt = r[Et]) || void 0 === wt ? void 0 : wt[0]) && void 0 !== kt ? kt : 0,
                                null !== (bt = null === (It = r[Et]) || void 0 === It ? void 0 : It[1]) && void 0 !== bt ? bt : 0
                            ]);
                        }
                    }
                    for(var Nt = new xa(this.properties), St = 0; St < k.length; ++St){
                        var Mt = new Ea;
                        Nt.geometries.push(Mt);
                        var Lt = k[St];
                        if (Lt) for(var Pt = 0; Pt < Lt.length; ++Pt){
                            var Ct = Lt[Pt];
                            Ct && Mt.move_to(pa([
                                Ct[0],
                                Ct[1]
                            ]));
                        }
                    }
                    return Nt;
                }
            }
        ]);
    }();
    function wa(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = [];
        if (kt(t, function(t) {
            n.push(t.coordinates);
        }), n.length < 2) throw new Error("Must specify at least 2 geometries");
        var r = ra.apply(sa, [
            n[0]
        ].concat(_(n.slice(1))));
        return 0 === r.length ? null : 1 === r.length ? P(r[0], e.properties) : F(r, e.properties);
    }
    function ba(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, r = JSON.stringify(n.properties || {}), i = m(t, 4), o = i[0], s = i[1], a = i[2], u = i[3], l = (s + u) / 2, h = (o + a) / 2, c = 2 * e / ft([
            o,
            l
        ], [
            a,
            l
        ], n) * (a - o), f = 2 * e / ft([
            h,
            s
        ], [
            h,
            u
        ], n) * (u - s), v = c / 2, g = 2 * v, d = Math.sqrt(3) / 2 * f, p = a - o, y = u - s, _ = 3 / 4 * g, x = d, E = (p - g) / (g - v / 2), k = Math.floor(E), w = (k * _ - v / 2 - p) / 2 - v / 2 + _ / 2, b = Math.floor((y - d) / d), I = (y - b * d) / 2, N = b * d - y > d / 2;
        N && (I -= d / 4);
        for(var S = [], M = [], L = 0; L < 6; L++){
            var P = 2 * Math.PI / 6 * L;
            S.push(Math.cos(P)), M.push(Math.sin(P));
        }
        for(var C = [], T = 0; T <= k; T++)for(var O = 0; O <= b; O++){
            var A = T % 2 == 1;
            if ((0 !== O || !A) && (0 !== O || !N)) {
                var D = T * _ + o - w, F = O * x + s + I;
                if (A && (F -= d / 2), !0 === n.triangles) Na([
                    D,
                    F
                ], c / 2, f / 2, JSON.parse(r), S, M).forEach(function(t) {
                    n.mask ? wa(R([
                        n.mask,
                        t
                    ])) && C.push(t) : C.push(t);
                });
                else {
                    var q = Ia([
                        D,
                        F
                    ], c / 2, f / 2, JSON.parse(r), S, M);
                    n.mask ? wa(R([
                        n.mask,
                        q
                    ])) && C.push(q) : C.push(q);
                }
            }
        }
        return R(C);
    }
    function Ia(t, e, n, r, i, o) {
        for(var s = [], a = 0; a < 6; a++){
            var u = t[0] + e * i[a], l = t[1] + n * o[a];
            s.push([
                u,
                l
            ]);
        }
        return s.push(s[0].slice()), P([
            s
        ], r);
    }
    function Na(t, e, n, r, i, o) {
        for(var s = [], a = 0; a < 6; a++){
            var u = [];
            u.push(t), u.push([
                t[0] + e * i[a],
                t[1] + n * o[a]
            ]), u.push([
                t[0] + e * i[(a + 1) % 6],
                t[1] + n * o[(a + 1) % 6]
            ]), u.push(t), s.push(P([
                u
            ], r));
        }
        return s;
    }
    function Sa(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        n.mask && !n.units && (n.units = "kilometers");
        for(var r = [], i = t[0], o = t[1], s = t[2], a = t[3], u = e / ft([
            i,
            o
        ], [
            s,
            o
        ], n) * (s - i), l = e / ft([
            i,
            o
        ], [
            i,
            a
        ], n) * (a - o), h = s - i, c = a - o, f = Math.floor(h / u), v = (c - Math.floor(c / l) * l) / 2, g = i + (h - f * u) / 2; g <= s;){
            for(var d = o + v; d <= a;){
                var p = M([
                    g,
                    d
                ], n.properties);
                n.mask ? hr(p, n.mask) && r.push(p) : r.push(p), d += l;
            }
            g += u;
        }
        return R(r);
    }
    function Ma(t, e, n) {
        for(var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}, i = [], o = t[0], s = t[1], a = t[2], u = t[3], l = a - o, h = Z(e, r.units, "degrees"), c = u - s, f = Z(n, r.units, "degrees"), v = Math.floor(Math.abs(l) / h), g = Math.floor(Math.abs(c) / f), d = (c - g * f) / 2, p = o + (l - v * h) / 2, y = 0; y < v; y++){
            for(var m = s + d, _ = 0; _ < g; _++){
                var x = P([
                    [
                        [
                            p,
                            m
                        ],
                        [
                            p,
                            m + f
                        ],
                        [
                            p + h,
                            m + f
                        ],
                        [
                            p + h,
                            m
                        ],
                        [
                            p,
                            m
                        ]
                    ]
                ], r.properties);
                r.mask ? Wn(r.mask, x) && i.push(x) : i.push(x), m += f;
            }
            p += h;
        }
        return R(i);
    }
    function La(t, e) {
        return Ma(t, e, e, arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {});
    }
    function Pa(t, e) {
        for(var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, r = [], i = e / ft([
            t[0],
            t[1]
        ], [
            t[2],
            t[1]
        ], n) * (t[2] - t[0]), o = e / ft([
            t[0],
            t[1]
        ], [
            t[0],
            t[3]
        ], n) * (t[3] - t[1]), s = 0, a = t[0]; a <= t[2];){
            for(var u = 0, l = t[1]; l <= t[3];){
                var h = null, c = null;
                s % 2 == 0 && u % 2 == 0 ? (h = P([
                    [
                        [
                            a,
                            l
                        ],
                        [
                            a,
                            l + o
                        ],
                        [
                            a + i,
                            l
                        ],
                        [
                            a,
                            l
                        ]
                    ]
                ], n.properties), c = P([
                    [
                        [
                            a,
                            l + o
                        ],
                        [
                            a + i,
                            l + o
                        ],
                        [
                            a + i,
                            l
                        ],
                        [
                            a,
                            l + o
                        ]
                    ]
                ], n.properties)) : s % 2 == 0 && u % 2 == 1 ? (h = P([
                    [
                        [
                            a,
                            l
                        ],
                        [
                            a + i,
                            l + o
                        ],
                        [
                            a + i,
                            l
                        ],
                        [
                            a,
                            l
                        ]
                    ]
                ], n.properties), c = P([
                    [
                        [
                            a,
                            l
                        ],
                        [
                            a,
                            l + o
                        ],
                        [
                            a + i,
                            l + o
                        ],
                        [
                            a,
                            l
                        ]
                    ]
                ], n.properties)) : u % 2 == 0 && s % 2 == 1 ? (h = P([
                    [
                        [
                            a,
                            l
                        ],
                        [
                            a,
                            l + o
                        ],
                        [
                            a + i,
                            l + o
                        ],
                        [
                            a,
                            l
                        ]
                    ]
                ], n.properties), c = P([
                    [
                        [
                            a,
                            l
                        ],
                        [
                            a + i,
                            l + o
                        ],
                        [
                            a + i,
                            l
                        ],
                        [
                            a,
                            l
                        ]
                    ]
                ], n.properties)) : u % 2 == 1 && s % 2 == 1 && (h = P([
                    [
                        [
                            a,
                            l
                        ],
                        [
                            a,
                            l + o
                        ],
                        [
                            a + i,
                            l
                        ],
                        [
                            a,
                            l
                        ]
                    ]
                ], n.properties), c = P([
                    [
                        [
                            a,
                            l + o
                        ],
                        [
                            a + i,
                            l + o
                        ],
                        [
                            a + i,
                            l
                        ],
                        [
                            a,
                            l + o
                        ]
                    ]
                ], n.properties)), n.mask ? (wa(R([
                    n.mask,
                    h
                ])) && r.push(h), wa(R([
                    n.mask,
                    c
                ])) && r.push(c)) : (r.push(h), r.push(c)), l += o, u++;
            }
            s++, a += i;
        }
        return R(r);
    }
    var Ca = Object.defineProperty, Ta = Object.getOwnPropertySymbols, Oa = Object.prototype.hasOwnProperty, Ra = Object.prototype.propertyIsEnumerable, Aa = function(t, e, n) {
        return e in t ? Ca(t, e, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: n
        }) : t[e] = n;
    }, Da = function(t, e) {
        for(var n in e || (e = {}))Oa.call(e, n) && Aa(t, n, e[n]);
        if (Ta) {
            var r, i = a(Ta(e));
            try {
                for(i.s(); !(r = i.n()).done;){
                    n = r.value;
                    Ra.call(e, n) && Aa(t, n, e[n]);
                }
            } catch (t) {
                i.e(t);
            } finally{
                i.f();
            }
        }
        return t;
    };
    function Fa(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        if (!J(e)) throw new Error("options is invalid");
        var n = e.zProperty, r = void 0 === n ? "elevation" : n, i = e.flip, o = void 0 !== i && i, s = e.flags, a = void 0 !== s && s;
        st(t, "Point", "input must contain Points");
        for(var u = function(t, e) {
            var n = {};
            _t(t, function(t) {
                var e = nt(t)[1];
                n[e] || (n[e] = []), n[e].push(t);
            });
            for(var r = [], i = 0, o = Object.values(n); i < o.length; i++){
                var s = o[i];
                r.push(s.sort(function(t, e) {
                    return nt(t)[0] - nt(e)[0];
                }));
            }
            return r.sort(e ? function(t, e) {
                return nt(t[0])[1] - nt(e[0])[1];
            } : function(t, e) {
                return nt(e[0])[1] - nt(t[0])[1];
            }), r;
        }(t, o), l = [], h = 0; h < u.length; h++){
            for(var c = u[h], f = [], v = 0; v < c.length; v++){
                var g = c[v];
                null == g.properties && (g.properties = {}), g.properties[r] ? f.push(g.properties[r]) : f.push(0), !0 === a && (g.properties.matrixPosition = [
                    h,
                    v
                ]);
            }
            l.push(f);
        }
        return l;
    }
    function qa(t, e) {
        for(var n = [], r = t[0].length, i = t.length, o = 0; o < i - 1; o++)for(var s = 0; s < r - 1; s++){
            var a = t[o + 1][s + 1], u = t[o][s + 1], l = t[o][s], h = t[o + 1][s];
            switch((h >= e ? 8 : 0) | (a >= e ? 4 : 0) | (u >= e ? 2 : 0) | (l >= e ? 1 : 0)){
                case 0:
                case 15:
                    continue;
                case 1:
                    n.push([
                        [
                            s + c(l, u),
                            o
                        ],
                        [
                            s,
                            o + c(l, h)
                        ]
                    ]);
                    break;
                case 2:
                    n.push([
                        [
                            s + 1,
                            o + c(u, a)
                        ],
                        [
                            s + c(l, u),
                            o
                        ]
                    ]);
                    break;
                case 3:
                    n.push([
                        [
                            s + 1,
                            o + c(u, a)
                        ],
                        [
                            s,
                            o + c(l, h)
                        ]
                    ]);
                    break;
                case 4:
                    n.push([
                        [
                            s + c(h, a),
                            o + 1
                        ],
                        [
                            s + 1,
                            o + c(u, a)
                        ]
                    ]);
                    break;
                case 5:
                    (h + a + u + l) / 4 >= e ? n.push([
                        [
                            s + c(h, a),
                            o + 1
                        ],
                        [
                            s,
                            o + c(l, h)
                        ]
                    ], [
                        [
                            s + c(l, u),
                            o
                        ],
                        [
                            s + 1,
                            o + c(u, a)
                        ]
                    ]) : n.push([
                        [
                            s + c(h, a),
                            o + 1
                        ],
                        [
                            s + 1,
                            o + c(u, a)
                        ]
                    ], [
                        [
                            s + c(l, u),
                            o
                        ],
                        [
                            s,
                            o + c(l, h)
                        ]
                    ]);
                    break;
                case 6:
                    n.push([
                        [
                            s + c(h, a),
                            o + 1
                        ],
                        [
                            s + c(l, u),
                            o
                        ]
                    ]);
                    break;
                case 7:
                    n.push([
                        [
                            s + c(h, a),
                            o + 1
                        ],
                        [
                            s,
                            o + c(l, h)
                        ]
                    ]);
                    break;
                case 8:
                    n.push([
                        [
                            s,
                            o + c(l, h)
                        ],
                        [
                            s + c(h, a),
                            o + 1
                        ]
                    ]);
                    break;
                case 9:
                    n.push([
                        [
                            s + c(l, u),
                            o
                        ],
                        [
                            s + c(h, a),
                            o + 1
                        ]
                    ]);
                    break;
                case 10:
                    (h + a + u + l) / 4 >= e ? n.push([
                        [
                            s,
                            o + c(l, h)
                        ],
                        [
                            s + c(l, u),
                            o
                        ]
                    ], [
                        [
                            s + 1,
                            o + c(u, a)
                        ],
                        [
                            s + c(h, a),
                            o + 1
                        ]
                    ]) : n.push([
                        [
                            s,
                            o + c(l, h)
                        ],
                        [
                            s + c(h, a),
                            o + 1
                        ]
                    ], [
                        [
                            s + 1,
                            o + c(u, a)
                        ],
                        [
                            s + c(l, u),
                            o
                        ]
                    ]);
                    break;
                case 11:
                    n.push([
                        [
                            s + 1,
                            o + c(u, a)
                        ],
                        [
                            s + c(h, a),
                            o + 1
                        ]
                    ]);
                    break;
                case 12:
                    n.push([
                        [
                            s,
                            o + c(l, h)
                        ],
                        [
                            s + 1,
                            o + c(u, a)
                        ]
                    ]);
                    break;
                case 13:
                    n.push([
                        [
                            s + c(l, u),
                            o
                        ],
                        [
                            s + 1,
                            o + c(u, a)
                        ]
                    ]);
                    break;
                case 14:
                    n.push([
                        [
                            s,
                            o + c(l, h)
                        ],
                        [
                            s + c(l, u),
                            o
                        ]
                    ]);
            }
        }
        return n;
        function c(t, n) {
            if (t === n) return .5;
            var r = (e - t) / (n - t);
            return r > 1 ? 1 : r < 0 ? 0 : r;
        }
    }
    function Ga(t, e) {
        for(var n = e.length, r = e[0].length, i = [], o = []; t.length > 0;){
            var s = _(t.shift());
            i.push(s);
            var u = void 0;
            do {
                u = !1;
                for(var l = 0; l < t.length; l++){
                    var h = t[l];
                    if (h[0][0] === s[s.length - 1][0] && h[0][1] === s[s.length - 1][1]) {
                        u = !0, s.push(h[1]), t.splice(l, 1);
                        break;
                    }
                    if (h[1][0] === s[0][0] && h[1][1] === s[0][1]) {
                        u = !0, s.unshift(h[0]), t.splice(l, 1);
                        break;
                    }
                }
            }while (u);
        }
        for(var c = function() {
            var t = i[0];
            if (t[0][0] === t[t.length - 1][0] && t[0][1] === t[t.length - 1][1]) return o.push(t), i.shift(), 1;
            var e, s, u = t[t.length - 1];
            if (0 === u[0] && 0 !== u[1]) e = Xa(i, function(t) {
                return 0 === t[0][0] && t[0][1] < u[1];
            }, function(t, e) {
                return e[0][1] - t[0][1];
            }), s = [
                0,
                0
            ];
            else if (0 === u[1] && u[0] !== r - 1) e = Xa(i, function(t) {
                return 0 === t[0][1] && t[0][0] > u[0];
            }, function(t, e) {
                return t[0][0] - e[0][0];
            }), s = [
                r - 1,
                0
            ];
            else if (u[0] === r - 1 && u[1] !== n - 1) e = Xa(i, function(t) {
                return t[0][0] === r - 1 && t[0][1] > u[1];
            }, function(t, e) {
                return t[0][1] - e[0][1];
            }), s = [
                r - 1,
                n - 1
            ];
            else {
                if (u[1] !== n - 1 || 0 === u[0]) throw new Error("Contour not closed but is not along an edge");
                e = Xa(i, function(t) {
                    return t[0][1] === n - 1 && t[0][0] < u[0];
                }, function(t, e) {
                    return e[0][0] - t[0][0];
                }), s = [
                    0,
                    n - 1
                ];
            }
            if (-1 === e) t.push(s);
            else if (0 === e) t.push([
                t[0][0],
                t[0][1]
            ]), o.push(t), i.shift();
            else {
                var l = i[e];
                i.splice(e, 1);
                var h, c = a(l);
                try {
                    for(c.s(); !(h = c.n()).done;){
                        var f = h.value;
                        t.push(f);
                    }
                } catch (t) {
                    c.e(t);
                } finally{
                    c.f();
                }
            }
        }; i.length > 0;)c();
        for(var f = 0; f < o.length; f++)o[f].length < 4 && (o.splice(f, 1), f--);
        return o;
    }
    function Ya(t) {
        var e = t.map(function(t) {
            return {
                ring: t,
                area: Ot(P([
                    t
                ]))
            };
        });
        return e.sort(function(t, e) {
            return e.area - t.area;
        }), e.map(function(t) {
            return t.ring;
        });
    }
    function Ba(t) {
        for(var e = t.map(function(t) {
            return {
                lrCoordinates: t,
                grouped: !1
            };
        }), n = []; !ja(e);)for(var r = 0; r < e.length; r++)if (!e[r].grouped) {
            var i = [];
            i.push(e[r].lrCoordinates), e[r].grouped = !0;
            var o = P([
                e[r].lrCoordinates
            ]);
            t: for(var s = r + 1; s < e.length; s++)if (!e[s].grouped) {
                var a = P([
                    e[s].lrCoordinates
                ]);
                if (za(a, o)) {
                    for(var u = 1; u < i.length; u++)if (za(a, P([
                        i[u]
                    ]))) continue t;
                    i.push(e[s].lrCoordinates), e[s].grouped = !0;
                }
            }
            n.push(i);
        }
        return n;
    }
    function za(t, e) {
        for(var n = da(t), r = 0; r < n.features.length; r++)if (!Zt(n.features[r], e)) return !1;
        return !0;
    }
    function ja(t) {
        for(var e = 0; e < t.length; e++)if (!1 === t[e].grouped) return !1;
        return !0;
    }
    function Xa(t, e, n) {
        for(var r = -1, i = 0; i < t.length; i++)e(t[i]) && (-1 === r || n(t[r], t[i]) > 0) && (r = i);
        return r;
    }
    var Ua = Object.defineProperty, Va = Object.getOwnPropertySymbols, Za = Object.prototype.hasOwnProperty, Ha = Object.prototype.propertyIsEnumerable, Wa = function(t, e, n) {
        return e in t ? Ua(t, e, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: n
        }) : t[e] = n;
    }, Ja = function(t, e) {
        for(var n in e || (e = {}))Za.call(e, n) && Wa(t, n, e[n]);
        if (Va) {
            var r, i = a(Va(e));
            try {
                for(i.s(); !(r = i.n()).done;){
                    n = r.value;
                    Ha.call(e, n) && Wa(t, n, e[n]);
                }
            } catch (t) {
                i.e(t);
            } finally{
                i.f();
            }
        }
        return t;
    };
    function Ka(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        if (!J(e)) throw new Error("options is invalid");
        var n = e.zProperty, r = void 0 === n ? "elevation" : n, i = e.flip, o = void 0 !== i && i, s = e.flags, a = void 0 !== s && s;
        st(t, "Point", "input must contain Points");
        for(var u = function(t, e) {
            var n = {};
            _t(t, function(t) {
                var e = nt(t)[1];
                n[e] || (n[e] = []), n[e].push(t);
            });
            for(var r = [], i = 0, o = Object.values(n); i < o.length; i++){
                var s = o[i];
                r.push(s.sort(function(t, e) {
                    return nt(t)[0] - nt(e)[0];
                }));
            }
            return r.sort(e ? function(t, e) {
                return nt(t[0])[1] - nt(e[0])[1];
            } : function(t, e) {
                return nt(e[0])[1] - nt(t[0])[1];
            }), r;
        }(t, o), l = [], h = 0; h < u.length; h++){
            for(var c = u[h], f = [], v = 0; v < c.length; v++){
                var g = c[v];
                null == g.properties && (g.properties = {}), g.properties[r] ? f.push(g.properties[r]) : f.push(0), !0 === a && (g.properties.matrixPosition = [
                    h,
                    v
                ]);
            }
            l.push(f);
        }
        return l;
    }
    function Qa(t, e) {
        for(var n = [], r = t.length, i = t[0].length, o = 0; o < r - 1; o++)for(var s = 0; s < i - 1; s++){
            var a = t[o + 1][s + 1], u = t[o][s + 1], l = t[o][s], h = t[o + 1][s];
            switch((h >= e ? 8 : 0) | (a >= e ? 4 : 0) | (u >= e ? 2 : 0) | (l >= e ? 1 : 0)){
                case 0:
                case 15:
                    continue;
                case 1:
                    n.push([
                        [
                            s + p(l, u),
                            o
                        ],
                        [
                            s,
                            o + p(l, h)
                        ]
                    ]);
                    break;
                case 2:
                    n.push([
                        [
                            s + 1,
                            o + p(u, a)
                        ],
                        [
                            s + p(l, u),
                            o
                        ]
                    ]);
                    break;
                case 3:
                    n.push([
                        [
                            s + 1,
                            o + p(u, a)
                        ],
                        [
                            s,
                            o + p(l, h)
                        ]
                    ]);
                    break;
                case 4:
                    n.push([
                        [
                            s + p(h, a),
                            o + 1
                        ],
                        [
                            s + 1,
                            o + p(u, a)
                        ]
                    ]);
                    break;
                case 5:
                    (h + a + u + l) / 4 >= e ? n.push([
                        [
                            s + p(h, a),
                            o + 1
                        ],
                        [
                            s,
                            o + p(l, h)
                        ]
                    ], [
                        [
                            s + p(l, u),
                            o
                        ],
                        [
                            s + 1,
                            o + p(u, a)
                        ]
                    ]) : n.push([
                        [
                            s + p(h, a),
                            o + 1
                        ],
                        [
                            s + 1,
                            o + p(u, a)
                        ]
                    ], [
                        [
                            s + p(l, u),
                            o
                        ],
                        [
                            s,
                            o + p(l, h)
                        ]
                    ]);
                    break;
                case 6:
                    n.push([
                        [
                            s + p(h, a),
                            o + 1
                        ],
                        [
                            s + p(l, u),
                            o
                        ]
                    ]);
                    break;
                case 7:
                    n.push([
                        [
                            s + p(h, a),
                            o + 1
                        ],
                        [
                            s,
                            o + p(l, h)
                        ]
                    ]);
                    break;
                case 8:
                    n.push([
                        [
                            s,
                            o + p(l, h)
                        ],
                        [
                            s + p(h, a),
                            o + 1
                        ]
                    ]);
                    break;
                case 9:
                    n.push([
                        [
                            s + p(l, u),
                            o
                        ],
                        [
                            s + p(h, a),
                            o + 1
                        ]
                    ]);
                    break;
                case 10:
                    (h + a + u + l) / 4 >= e ? n.push([
                        [
                            s,
                            o + p(l, h)
                        ],
                        [
                            s + p(l, u),
                            o
                        ]
                    ], [
                        [
                            s + 1,
                            o + p(u, a)
                        ],
                        [
                            s + p(h, a),
                            o + 1
                        ]
                    ]) : n.push([
                        [
                            s,
                            o + p(l, h)
                        ],
                        [
                            s + p(h, a),
                            o + 1
                        ]
                    ], [
                        [
                            s + 1,
                            o + p(u, a)
                        ],
                        [
                            s + p(l, u),
                            o
                        ]
                    ]);
                    break;
                case 11:
                    n.push([
                        [
                            s + 1,
                            o + p(u, a)
                        ],
                        [
                            s + p(h, a),
                            o + 1
                        ]
                    ]);
                    break;
                case 12:
                    n.push([
                        [
                            s,
                            o + p(l, h)
                        ],
                        [
                            s + 1,
                            o + p(u, a)
                        ]
                    ]);
                    break;
                case 13:
                    n.push([
                        [
                            s + p(l, u),
                            o
                        ],
                        [
                            s + 1,
                            o + p(u, a)
                        ]
                    ]);
                    break;
                case 14:
                    n.push([
                        [
                            s,
                            o + p(l, h)
                        ],
                        [
                            s + p(l, u),
                            o
                        ]
                    ]);
            }
        }
        for(var c = []; n.length > 0;){
            var f = _(n.shift());
            c.push(f);
            var v = void 0;
            do {
                v = !1;
                for(var g = 0; g < n.length; g++){
                    var d = n[g];
                    if (d[0][0] === f[f.length - 1][0] && d[0][1] === f[f.length - 1][1]) {
                        v = !0, f.push(d[1]), n.splice(g, 1);
                        break;
                    }
                    if (d[1][0] === f[0][0] && d[1][1] === f[0][1]) {
                        v = !0, f.unshift(d[0]), n.splice(g, 1);
                        break;
                    }
                }
            }while (v);
        }
        return c;
        function p(t, n) {
            if (t === n) return .5;
            var r = (e - t) / (n - t);
            return r > 1 ? 1 : r < 0 ? 0 : r;
        }
    }
    function $a(t, e, n, r, i, o, s, a) {
        var u, l, h, c, f = {
            x: null,
            y: null,
            onLine1: !1,
            onLine2: !1
        };
        return 0 === (u = (a - o) * (n - t) - (s - i) * (r - e)) ? null !== f.x && null !== f.y && f : (c = (n - t) * (l = e - o) - (r - e) * (h = t - i), l = ((s - i) * l - (a - o) * h) / u, h = c / u, f.x = t + l * (n - t), f.y = e + l * (r - e), l >= 0 && l <= 1 && (f.onLine1 = !0), h >= 0 && h <= 1 && (f.onLine2 = !0), !(!f.onLine1 || !f.onLine2) && [
            f.x,
            f.y
        ]);
    }
    function tu(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return St(t, function(t, n) {
            var r = n.geometry.coordinates;
            return t + ft(r[0], r[1], e);
        }, 0);
    }
    function eu(t, e, n, r) {
        var i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {}, o = i.steps || 64, s = nu(n), a = nu(r), u = Array.isArray(t) || "Feature" !== t.type ? {} : t.properties;
        if (s === a) return T(oo(t, e, i).geometry.coordinates[0], u);
        for(var l = s, h = s < a ? a : a + 360, c = [], f = (h - l) / o, v = 0; v <= o; v++){
            var g = v === o ? h : l + v * f;
            c.push(ct(t, e, g, i).geometry.coordinates);
        }
        return T(c, u);
    }
    function nu(t) {
        var e = t % 360;
        return e < 0 && (e += 360), e;
    }
    function ru(t, e, n) {
        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
        if (!J(r)) throw new Error("options is invalid");
        var i, o = r.units, s = void 0 === o ? "kilometers" : o, a = [];
        if ("Feature" === t.type) i = t.geometry.coordinates;
        else {
            if ("LineString" !== t.type) throw new Error("input must be a LineString Feature or Geometry");
            i = t.coordinates;
        }
        for(var u, l, h, c = i.length, f = 0, v = 0; v < i.length && !(e >= f && v === i.length - 1); v++){
            if (f > e && 0 === a.length) {
                var g = e - f;
                if (!g) return a.push(i[v]), T(a);
                l = ht(i[v], i[v - 1]) - 180, h = ct(i[v], g, l, {
                    units: s
                }), a.push(h.geometry.coordinates);
            }
            if (f >= n) return (u = n - f) ? (l = ht(i[v], i[v - 1]) - 180, h = ct(i[v], u, l, {
                units: s
            }), a.push(h.geometry.coordinates), T(a)) : (a.push(i[v]), T(a));
            if (f >= e && a.push(i[v]), v === i.length - 1) return T(a);
            f += ft(i[v], i[v + 1], {
                units: s
            });
        }
        if (f < e && i.length === c) throw new Error("Start position is beyond line");
        var d = i[i.length - 1];
        return T([
            d,
            d
        ]);
    }
    function iu(t) {
        var e = t[0], n = t[1];
        return [
            n[0] - e[0],
            n[1] - e[1]
        ];
    }
    function ou(t, e) {
        return t[0] * e[1] - e[0] * t[1];
    }
    function su(t, e) {
        return !function(t, e) {
            return 0 === ou(iu(t), iu(e));
        }(t, e) && function(t, e) {
            var n, r, i = t[0], o = iu(t), s = e[0], a = iu(e), u = ou(o, a), l = function(t, e) {
                return [
                    t[0] + e[0],
                    t[1] + e[1]
                ];
            }(i, function(t, e) {
                return [
                    t * e[0],
                    t * e[1]
                ];
            }(ou((r = i, [
                (n = s)[0] - r[0],
                n[1] - r[1]
            ]), a) / u, o));
            return l;
        }(t, e);
    }
    function au(t, e, n) {
        var r = [], i = z(e, n), o = nt(t), s = [];
        return o.forEach(function(t, e) {
            if (e !== o.length - 1) {
                var n = (l = t, h = o[e + 1], c = i, f = Math.sqrt((l[0] - h[0]) * (l[0] - h[0]) + (l[1] - h[1]) * (l[1] - h[1])), v = l[0] + c * (h[1] - l[1]) / f, g = h[0] + c * (h[1] - l[1]) / f, d = l[1] + c * (l[0] - h[0]) / f, p = h[1] + c * (l[0] - h[0]) / f, [
                    [
                        v,
                        d
                    ],
                    [
                        g,
                        p
                    ]
                ]);
                if (r.push(n), e > 0) {
                    var a = r[e - 1], u = su(n, a);
                    !1 !== u && (a[1] = u, n[0] = u), s.push(a[0]), e === o.length - 2 && (s.push(n[0]), s.push(n[1]));
                }
                2 === o.length && (s.push(n[0]), s.push(n[1]));
            }
            var l, h, c, f, v, g, d, p;
        }), T(s, "Feature" === t.type ? t.properties : {});
    }
    function uu(t, e) {
        var n = "Feature" === t.type ? t.geometry : t;
        e.properties.segmentIndex >= n.coordinates.length - 1 && (e.properties.segmentIndex = n.coordinates.length - 2);
    }
    function lu(t, e, n, r) {
        e = e || ("Feature" === t.type ? t.properties : {});
        var i = at(t), o = i.coordinates, s = i.type;
        if (!o.length) throw new Error("line must contain coordinates");
        switch(s){
            case "LineString":
                return n && (o = hu(o)), P([
                    o
                ], e);
            case "MultiLineString":
                var a = [], u = 0;
                return o.forEach(function(t) {
                    if (n && (t = hu(t)), r) {
                        var e = function(t) {
                            var e = t[0], n = t[1], r = t[2], i = t[3];
                            return Math.abs(e - r) * Math.abs(n - i);
                        }(qt(T(t)));
                        e > u ? (a.unshift(t), u = e) : a.push(t);
                    } else a.push(t);
                }), P(a, e);
            default:
                throw new Error("geometry type " + s + " is not supported");
        }
    }
    function hu(t) {
        var e = t[0], n = e[0], r = e[1], i = t[t.length - 1], o = i[0], s = i[1];
        return n === o && r === s || t.push(e), t;
    }
    function cu(t) {
        return F(t);
    }
    function fu(t) {
        var e = [
            [
                [
                    180,
                    90
                ],
                [
                    -180,
                    90
                ],
                [
                    -180,
                    -90
                ],
                [
                    180,
                    -90
                ],
                [
                    180,
                    90
                ]
            ]
        ];
        return t && (e = "Feature" === t.type ? t.geometry.coordinates : t.coordinates), P(e);
    }
    function vu(t) {
        var e, n = 0, r = a(t);
        try {
            for(r.s(); !(e = r.n()).done;)n += e.value;
        } catch (t) {
            r.e(t);
        } finally{
            r.f();
        }
        return n / t.length;
    }
    var gu = Object.defineProperty, du = Object.defineProperties, pu = Object.getOwnPropertyDescriptors, yu = Object.getOwnPropertySymbols, mu = Object.prototype.hasOwnProperty, _u = Object.prototype.propertyIsEnumerable, xu = function(t, e, n) {
        return e in t ? gu(t, e, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: n
        }) : t[e] = n;
    }, Eu = function(t, e) {
        for(var n in e || (e = {}))mu.call(e, n) && xu(t, n, e[n]);
        if (yu) {
            var r, i = a(yu(e));
            try {
                for(i.s(); !(r = i.n()).done;){
                    n = r.value;
                    _u.call(e, n) && xu(t, n, e[n]);
                }
            } catch (t) {
                i.e(t);
            } finally{
                i.f();
            }
        }
        return t;
    }, ku = function(t, e) {
        return du(t, pu(e));
    };
    function wu(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        if (!t) throw new Error("targetPoint is required");
        if (!e) throw new Error("points is required");
        var r = 1 / 0, i = 0;
        _t(e, function(e, o) {
            var s = ft(t, e, n);
            s < r && (i = o, r = s);
        });
        var o = so(e.features[i]);
        return ku(Eu({}, o), {
            properties: ku(Eu({}, o.properties), {
                featureIndex: i,
                distanceToPoint: r
            })
        });
    }
    function bu(t, e) {
        var n, r, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, o = null != (n = i.method) ? n : "geodesic", s = null != (r = i.units) ? r : "kilometers";
        if (!t) throw new Error("pt is required");
        if (Array.isArray(t) ? t = M(t) : "Point" === t.type ? t = N(t) : ot(t, "Point", "point"), !e) throw new Error("line is required");
        Array.isArray(e) ? e = T(e) : "LineString" === e.type ? e = N(e) : ot(e, "LineString", "line");
        var a = 1 / 0, u = t.geometry.coordinates;
        return Nt(e, function(t) {
            if (t) {
                var e = t.geometry.coordinates[0], n = t.geometry.coordinates[1], r = function(t, e, n, r) {
                    if ("geodesic" === r.method) return $e(T([
                        e,
                        n
                    ]).geometry, t, {
                        units: "degrees"
                    }).properties.pointDistance;
                    var i = [
                        n[0] - e[0],
                        n[1] - e[1]
                    ], o = [
                        t[0] - e[0],
                        t[1] - e[1]
                    ], s = Iu(o, i);
                    if (s <= 0) return ha(t, e, {
                        units: "degrees"
                    });
                    var a = Iu(i, i);
                    if (a <= s) return ha(t, n, {
                        units: "degrees"
                    });
                    var u = s / a, l = [
                        e[0] + u * i[0],
                        e[1] + u * i[1]
                    ];
                    return ha(t, l, {
                        units: "degrees"
                    });
                }(u, e, n, {
                    method: o
                });
                r < a && (a = r);
            }
        }), Z(a, "degrees", s);
    }
    function Iu(t, e) {
        return t[0] * e[0] + t[1] * e[1];
    }
    var Nu = Object.defineProperty, Su = Object.getOwnPropertySymbols, Mu = Object.prototype.hasOwnProperty, Lu = Object.prototype.propertyIsEnumerable, Pu = function(t, e, n) {
        return e in t ? Nu(t, e, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: n
        }) : t[e] = n;
    }, Cu = function(t, e) {
        for(var n in e || (e = {}))Mu.call(e, n) && Pu(t, n, e[n]);
        if (Su) {
            var r, i = a(Su(e));
            try {
                for(i.s(); !(r = i.n()).done;){
                    n = r.value;
                    Lu.call(e, n) && Pu(t, n, e[n]);
                }
            } catch (t) {
                i.e(t);
            } finally{
                i.f();
            }
        }
        return t;
    };
    function Tu(t, e, n, r, i, o) {
        return Math.sqrt((i - n) * (i - n) + (o - r) * (o - r)) === Math.sqrt((t - n) * (t - n) + (e - r) * (e - r)) + Math.sqrt((i - t) * (i - t) + (o - e) * (o - e));
    }
    function Ou(t, e) {
        var n = [];
        return _t(t, function(t) {
            var r = !1;
            if ("Point" === t.geometry.type) kt(e, function(e) {
                Zt(t, e) && (r = !0);
            }), r && n.push(t);
            else {
                if ("MultiPoint" !== t.geometry.type) throw new Error("Input geometry must be a Point or MultiPoint");
                var i = [];
                kt(e, function(e) {
                    dt(t, function(t) {
                        Zt(t, e) && (r = !0, i.push(t));
                    });
                }), r && n.push(D(i, t.properties));
            }
        }), R(n);
    }
    function Ru(t, e, n) {
        var r = e[0] - t[0], i = e[1] - t[1], o = n[0] - e[0];
        return function(t) {
            return (t > 0) - (t < 0) || +t;
        }(r * (n[1] - e[1]) - o * i);
    }
    function Au(t, e) {
        return e.geometry.coordinates[0].every(function(e) {
            return Zt(M(e), t);
        });
    }
    var Du = function() {
        return s(function t(e, n) {
            i(this, t), this.id = e, this.coordinates = n, this.innerEdges = [], this.outerEdges = [], this.outerEdgesSorted = !1;
        }, [
            {
                key: "removeInnerEdge",
                value: function(t) {
                    this.innerEdges = this.innerEdges.filter(function(e) {
                        return e.from.id !== t.from.id;
                    });
                }
            },
            {
                key: "removeOuterEdge",
                value: function(t) {
                    this.outerEdges = this.outerEdges.filter(function(e) {
                        return e.to.id !== t.to.id;
                    });
                }
            },
            {
                key: "addOuterEdge",
                value: function(t) {
                    this.outerEdges.push(t), this.outerEdgesSorted = !1;
                }
            },
            {
                key: "sortOuterEdges",
                value: function() {
                    var t = this;
                    this.outerEdgesSorted || (this.outerEdges.sort(function(e, n) {
                        var r = e.to, i = n.to;
                        if (r.coordinates[0] - t.coordinates[0] >= 0 && i.coordinates[0] - t.coordinates[0] < 0) return 1;
                        if (r.coordinates[0] - t.coordinates[0] < 0 && i.coordinates[0] - t.coordinates[0] >= 0) return -1;
                        if (r.coordinates[0] - t.coordinates[0] === 0 && i.coordinates[0] - t.coordinates[0] === 0) return r.coordinates[1] - t.coordinates[1] >= 0 || i.coordinates[1] - t.coordinates[1] >= 0 ? r.coordinates[1] - i.coordinates[1] : i.coordinates[1] - r.coordinates[1];
                        var o = Ru(t.coordinates, r.coordinates, i.coordinates);
                        return o < 0 ? 1 : o > 0 ? -1 : Math.pow(r.coordinates[0] - t.coordinates[0], 2) + Math.pow(r.coordinates[1] - t.coordinates[1], 2) - (Math.pow(i.coordinates[0] - t.coordinates[0], 2) + Math.pow(i.coordinates[1] - t.coordinates[1], 2));
                    }), this.outerEdgesSorted = !0);
                }
            },
            {
                key: "getOuterEdges",
                value: function() {
                    return this.sortOuterEdges(), this.outerEdges;
                }
            },
            {
                key: "getOuterEdge",
                value: function(t) {
                    return this.sortOuterEdges(), this.outerEdges[t];
                }
            },
            {
                key: "addInnerEdge",
                value: function(t) {
                    this.innerEdges.push(t);
                }
            }
        ]);
    }(), Fu = function() {
        function t(e, n) {
            i(this, t), this.from = e, this.to = n, this.next = void 0, this.label = void 0, this.symetric = void 0, this.ring = void 0, this.from.addOuterEdge(this), this.to.addInnerEdge(this);
        }
        return s(t, [
            {
                key: "getSymetric",
                value: function() {
                    return this.symetric || (this.symetric = new t(this.to, this.from), this.symetric.symetric = this), this.symetric;
                }
            },
            {
                key: "deleteEdge",
                value: function() {
                    this.from.removeOuterEdge(this), this.to.removeInnerEdge(this);
                }
            },
            {
                key: "isEqual",
                value: function(t) {
                    return this.from.id === t.from.id && this.to.id === t.to.id;
                }
            },
            {
                key: "toString",
                value: function() {
                    return "Edge { ".concat(this.from.id, " -> ").concat(this.to.id, " }");
                }
            },
            {
                key: "toLineString",
                value: function() {
                    return T([
                        this.from.coordinates,
                        this.to.coordinates
                    ]);
                }
            },
            {
                key: "compareTo",
                value: function(t) {
                    return Ru(t.from.coordinates, t.to.coordinates, this.to.coordinates);
                }
            }
        ]);
    }(), qu = function() {
        return s(function t() {
            i(this, t), this.edges = [], this.polygon = void 0, this.envelope = void 0;
        }, [
            {
                key: "push",
                value: function(t) {
                    this.edges.push(t), this.polygon = this.envelope = void 0;
                }
            },
            {
                key: "get",
                value: function(t) {
                    return this.edges[t];
                }
            },
            {
                key: "length",
                get: function() {
                    return this.edges.length;
                }
            },
            {
                key: "forEach",
                value: function(t) {
                    this.edges.forEach(t);
                }
            },
            {
                key: "map",
                value: function(t) {
                    return this.edges.map(t);
                }
            },
            {
                key: "some",
                value: function(t) {
                    return this.edges.some(t);
                }
            },
            {
                key: "isValid",
                value: function() {
                    return !0;
                }
            },
            {
                key: "isHole",
                value: function() {
                    var t = this, e = this.edges.reduce(function(e, n, r) {
                        return n.from.coordinates[1] > t.edges[e].from.coordinates[1] && (e = r), e;
                    }, 0), n = (0 === e ? this.length : e) - 1, r = (e + 1) % this.length, i = Ru(this.edges[n].from.coordinates, this.edges[e].from.coordinates, this.edges[r].from.coordinates);
                    return 0 === i ? this.edges[n].from.coordinates[0] > this.edges[r].from.coordinates[0] : i > 0;
                }
            },
            {
                key: "toMultiPoint",
                value: function() {
                    return D(this.edges.map(function(t) {
                        return t.from.coordinates;
                    }));
                }
            },
            {
                key: "toPolygon",
                value: function() {
                    if (this.polygon) return this.polygon;
                    var t = this.edges.map(function(t) {
                        return t.from.coordinates;
                    });
                    return t.push(this.edges[0].from.coordinates), this.polygon = P([
                        t
                    ]);
                }
            },
            {
                key: "getEnvelope",
                value: function() {
                    return this.envelope ? this.envelope : this.envelope = ga(this.toPolygon());
                }
            },
            {
                key: "inside",
                value: function(t) {
                    return Zt(t, this.toPolygon());
                }
            }
        ], [
            {
                key: "findEdgeRingContaining",
                value: function(t, e) {
                    var n, r, i = t.getEnvelope();
                    return e.forEach(function(e) {
                        var o, s, u, l, h, c, f = e.getEnvelope();
                        if ((r && (n = r.getEnvelope()), s = i, u = (o = f).geometry.coordinates[0].map(function(t) {
                            return t[0];
                        }), l = o.geometry.coordinates[0].map(function(t) {
                            return t[1];
                        }), h = s.geometry.coordinates[0].map(function(t) {
                            return t[0];
                        }), c = s.geometry.coordinates[0].map(function(t) {
                            return t[1];
                        }), Math.max.apply(null, u) !== Math.max.apply(null, h) || Math.max.apply(null, l) !== Math.max.apply(null, c) || Math.min.apply(null, u) !== Math.min.apply(null, h) || Math.min.apply(null, l) !== Math.min.apply(null, c)) && Au(f, i)) {
                            var v, g, d = a(t.map(function(t) {
                                return t.from.coordinates;
                            }));
                            try {
                                var p = function() {
                                    var t = g.value;
                                    e.some(function(e) {
                                        var n, r;
                                        return n = t, r = e.from.coordinates, n[0] === r[0] && n[1] === r[1];
                                    }) || (v = t);
                                };
                                for(d.s(); !(g = d.n()).done;)p();
                            } catch (t) {
                                d.e(t);
                            } finally{
                                d.f();
                            }
                            v && e.inside(M(v)) && (r && !Au(n, f) || (r = e));
                        }
                    }), r;
                }
            }
        ]);
    }();
    var Gu = function() {
        function t() {
            i(this, t), this.nodes = new Map, this.nodeId = 0, this.edges = new Map;
        }
        return s(t, [
            {
                key: "getNode",
                value: function(t) {
                    var e, n = null == (e = this.nodes.get(t[0])) ? void 0 : e.get(t[1]);
                    if (null == n) {
                        var r = new Du(this.nodeId++, t), i = this.nodes.get(t[0]);
                        return null == i && (i = new Map, this.nodes.set(t[0], i)), i.set(t[1], r), r;
                    }
                    return n;
                }
            },
            {
                key: "addEdge",
                value: function(t, e) {
                    var n;
                    if (!(null == (n = this.edges.get(t)) ? void 0 : n.has(e))) {
                        var r = new Fu(t, e), i = r.getSymetric(), o = this.edges.get(t);
                        null == o && (o = new Map, this.edges.set(t, o)), o.set(e, r);
                        var s = this.edges.get(e);
                        null == s && (s = new Map, this.edges.set(e, s)), s.set(t, i);
                    }
                }
            },
            {
                key: "deleteDangles",
                value: function() {
                    var t = this;
                    this._forEachNode(function(e) {
                        return t._removeIfDangle(e);
                    });
                }
            },
            {
                key: "_removeIfDangle",
                value: function(t) {
                    var e = this;
                    if (t.innerEdges.length <= 1) {
                        var n = t.getOuterEdges().map(function(t) {
                            return t.to;
                        });
                        this.removeNode(t), n.forEach(function(t) {
                            return e._removeIfDangle(t);
                        });
                    }
                }
            },
            {
                key: "deleteCutEdges",
                value: function() {
                    var t = this;
                    this._computeNextCWEdges(), this._findLabeledEdgeRings(), this._forEachEdge(function(e) {
                        e.label === e.symetric.label && (t.removeEdge(e.symetric), t.removeEdge(e));
                    });
                }
            },
            {
                key: "_computeNextCWEdges",
                value: function(t) {
                    var e = this;
                    null == t ? this._forEachNode(function(t) {
                        return e._computeNextCWEdges(t);
                    }) : t.getOuterEdges().forEach(function(e, n) {
                        t.getOuterEdge((0 === n ? t.getOuterEdges().length : n) - 1).symetric.next = e;
                    });
                }
            },
            {
                key: "_computeNextCCWEdges",
                value: function(t, e) {
                    for(var n, r, i = t.getOuterEdges(), o = i.length - 1; o >= 0; --o){
                        var s = i[o], a = s.symetric, u = void 0, l = void 0;
                        s.label === e && (u = s), a.label === e && (l = a), u && l && (l && (r = l), u && (r && (r.next = u, r = void 0), n || (n = u)));
                    }
                    r && (r.next = n);
                }
            },
            {
                key: "_findLabeledEdgeRings",
                value: function() {
                    var t = [], e = 0;
                    return this._forEachEdge(function(n) {
                        if (!(n.label >= 0)) {
                            t.push(n);
                            var r = n;
                            do r.label = e, r = r.next;
                            while (!n.isEqual(r));
                            e++;
                        }
                    }), t;
                }
            },
            {
                key: "getEdgeRings",
                value: function() {
                    var t = this;
                    this._computeNextCWEdges(), this._forEachEdge(function(t) {
                        t.label = void 0;
                    }), this._findLabeledEdgeRings().forEach(function(e) {
                        t._findIntersectionNodes(e).forEach(function(n) {
                            t._computeNextCCWEdges(n, e.label);
                        });
                    });
                    var e = [];
                    return this._forEachEdge(function(n) {
                        n.ring || e.push(t._findEdgeRing(n));
                    }), e;
                }
            },
            {
                key: "_findIntersectionNodes",
                value: function(t) {
                    var e = [], n = t, r = function() {
                        var r = 0;
                        n.from.getOuterEdges().forEach(function(e) {
                            e.label === t.label && ++r;
                        }), r > 1 && e.push(n.from), n = n.next;
                    };
                    do r();
                    while (!t.isEqual(n));
                    return e;
                }
            },
            {
                key: "_findEdgeRing",
                value: function(t) {
                    var e = t, n = new qu;
                    do n.push(e), e.ring = n, e = e.next;
                    while (!t.isEqual(e));
                    return n;
                }
            },
            {
                key: "removeNode",
                value: function(t) {
                    var e, n = this;
                    t.getOuterEdges().forEach(function(t) {
                        return n.removeEdge(t);
                    }), t.innerEdges.forEach(function(t) {
                        return n.removeEdge(t);
                    }), null == (e = this.nodes.get(t.coordinates[0])) || e.delete(t.coordinates[1]);
                }
            },
            {
                key: "removeEdge",
                value: function(t) {
                    var e;
                    null == (e = this.edges.get(t.from)) || e.delete(t.to), t.deleteEdge();
                }
            },
            {
                key: "_forEachNode",
                value: function(t) {
                    var e, n = a(this.nodes.values());
                    try {
                        for(n.s(); !(e = n.n()).done;){
                            var r, i = a(e.value.values());
                            try {
                                for(i.s(); !(r = i.n()).done;)t(r.value);
                            } catch (t) {
                                i.e(t);
                            } finally{
                                i.f();
                            }
                        }
                    } catch (t) {
                        n.e(t);
                    } finally{
                        n.f();
                    }
                }
            },
            {
                key: "_forEachEdge",
                value: function(t) {
                    var e, n = a(this.edges.values());
                    try {
                        for(n.s(); !(e = n.n()).done;){
                            var r, i = a(e.value.values());
                            try {
                                for(i.s(); !(r = i.n()).done;)t(r.value);
                            } catch (t) {
                                i.e(t);
                            } finally{
                                i.f();
                            }
                        }
                    } catch (t) {
                        n.e(t);
                    } finally{
                        n.f();
                    }
                }
            }
        ], [
            {
                key: "fromGeoJson",
                value: function(e) {
                    !function(t) {
                        if (!t) throw new Error("No geojson passed");
                        if ("FeatureCollection" !== t.type && "GeometryCollection" !== t.type && "MultiLineString" !== t.type && "LineString" !== t.type && "Feature" !== t.type) throw new Error("Invalid input type '".concat(t.type, "'. Geojson must be FeatureCollection, GeometryCollection, LineString, MultiLineString or Feature"));
                    }(e);
                    var n = new t;
                    return bt(e, function(t) {
                        ot(t, "LineString", "Graph::fromGeoJson"), pt(t, function(t, e) {
                            if (t) {
                                var r = n.getNode(t), i = n.getNode(e);
                                n.addEdge(r, i);
                            }
                            return e;
                        });
                    }), n;
                }
            }
        ]);
    }();
    function Yu(t, e) {
        var n, r;
        dt(t, function(t, i, o, s, a) {
            if (r !== a) e.push([]);
            else {
                var u = n[0], l = n[1], h = t[0], c = t[1];
                e[a].push([
                    .75 * u + .25 * h,
                    .75 * l + .25 * c
                ]), e[a].push([
                    .25 * u + .75 * h,
                    .25 * l + .75 * c
                ]);
            }
            n = t, r = a;
        }, !1), e.forEach(function(t) {
            t.push(t[0]);
        });
    }
    function Bu(t, e) {
        var n, r, i;
        dt(t, function(t, o, s, a, u) {
            if (r !== a) e.push([
                []
            ]);
            else if (i !== u) e[a].push([]);
            else {
                var l = n[0], h = n[1], c = t[0], f = t[1];
                e[a][u].push([
                    .75 * l + .25 * c,
                    .75 * h + .25 * f
                ]), e[a][u].push([
                    .25 * l + .75 * c,
                    .25 * h + .75 * f
                ]);
            }
            n = t, r = a, i = u;
        }, !1), e.forEach(function(t) {
            t.forEach(function(t) {
                t.push(t[0]);
            });
        });
    }
    function zu(t, e, n, r, i) {
        for(var o = 0; o < t.length; o++){
            var s = t[o], a = t[o + 1];
            o === t.length - 1 && (a = t[0]);
            var u = Uu(s, a, e);
            n <= 0 && u > 0 ? Xu(e, s, r) || (r = s) : n > 0 && u <= 0 && (ju(e, s, i) || (i = s)), n = u;
        }
        return [
            r,
            i
        ];
    }
    function ju(t, e, n) {
        return Uu(t, e, n) > 0;
    }
    function Xu(t, e, n) {
        return Uu(t, e, n) < 0;
    }
    function Uu(t, e, n) {
        return (e[0] - t[0]) * (n[1] - t[1]) - (n[0] - t[0]) * (e[1] - t[1]);
    }
    function Vu(t) {
        return Hu(t, "mercator", arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {});
    }
    function Zu(t) {
        return Hu(t, "wgs84", arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {});
    }
    function Hu(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, r = (n = n || {}).mutate;
        if (!t) throw new Error("geojson is required");
        return Array.isArray(t) && W(t[0]) ? t = "mercator" === e ? Wu(t) : Ju(t) : (!0 !== r && (t = so(t)), dt(t, function(t) {
            var n = "mercator" === e ? Wu(t) : Ju(t);
            t[0] = n[0], t[1] = n[1];
        })), t;
    }
    function Wu(t) {
        var e = Math.PI / 180, n = 6378137, r = 20037508.342789244, i = Math.abs(t[0]) <= 180 ? t[0] : t[0] - 360 * function(t) {
            return t < 0 ? -1 : t > 0 ? 1 : 0;
        }(t[0]), o = [
            n * i * e,
            n * Math.log(Math.tan(.25 * Math.PI + .5 * t[1] * e))
        ];
        return o[0] > r && (o[0] = r), o[0] < -r && (o[0] = -r), o[1] > r && (o[1] = r), o[1] < -r && (o[1] = -r), o;
    }
    function Ju(t) {
        var e = 180 / Math.PI, n = 6378137;
        return [
            t[0] * e / n,
            (.5 * Math.PI - 2 * Math.atan(Math.exp(-t[1] / n))) * e
        ];
    }
    var Ku = Object.freeze({
        __proto__: null,
        toMercator: Vu,
        toWgs84: Zu
    });
    var Qu = {
        20: 1.07275,
        15: 1.13795,
        10: 1.22385,
        5: 1.3581,
        2: 1.51743,
        1: 1.62762
    };
    function $u(t, e) {
        return e[0] <= t[0] && e[1] <= t[1] && e[2] >= t[0] && e[3] >= t[1];
    }
    function tl(t) {
        var e = [];
        return function t(n) {
            return 0 === n || 1 === n ? 1 : e[n] > 0 ? e[n] : e[n] = t(n - 1) * n;
        }(t);
    }
    function el(t) {
        return rl(t), nl(t);
    }
    function nl(t) {
        return Array.isArray(t) ? ul(t) : t && t.bbox ? ul(t.bbox) : [
            360 * al(),
            180 * al()
        ];
    }
    function rl(t) {
        null != t && (Array.isArray(t) ? Q(t) : null != t.bbox && Q(t.bbox));
    }
    function il(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        rl(e.bbox), null == t && (t = 1);
        for(var n = [], r = 0; r < t; r++)n.push(M(nl(e.bbox)));
        return R(n);
    }
    function ol(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        rl(e.bbox), null == t && (t = 1), void 0 !== e.bbox && null !== e.bbox || (e.bbox = [
            -180,
            -90,
            180,
            90
        ]), W(e.num_vertices) && void 0 !== e.num_vertices || (e.num_vertices = 10), W(e.max_radial_length) && void 0 !== e.max_radial_length || (e.max_radial_length = 10);
        var n = Math.abs(e.bbox[0] - e.bbox[2]), r = Math.abs(e.bbox[1] - e.bbox[3]), i = Math.min(n / 2, r / 2);
        if (e.max_radial_length > i) throw new Error("max_radial_length is greater than the radius of the bbox");
        for(var o = [
            e.bbox[0] + e.max_radial_length,
            e.bbox[1] + e.max_radial_length,
            e.bbox[2] - e.max_radial_length,
            e.bbox[3] - e.max_radial_length
        ], s = [], a = function() {
            var t, n = [], r = _(Array(e.num_vertices + 1)).map(Math.random);
            r.forEach(function(t, e, n) {
                n[e] = e > 0 ? t + n[e - 1] : t;
            }), r.forEach(function(t) {
                t = 2 * t * Math.PI / r[r.length - 1];
                var i = Math.random();
                n.push([
                    i * (e.max_radial_length || 10) * Math.sin(t),
                    i * (e.max_radial_length || 10) * Math.cos(t)
                ]);
            }), n[n.length - 1] = n[0], n = n.reverse().map((t = nl(o), function(e) {
                return [
                    e[0] + t[0],
                    e[1] + t[1]
                ];
            })), s.push(P([
                n
            ]));
        }, u = 0; u < t; u++)a();
        return R(s);
    }
    function sl(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        if (!J(e = e || {})) throw new Error("options is invalid");
        var n = e.bbox;
        rl(n);
        var r = e.num_vertices, i = e.max_length, o = e.max_rotation;
        null == t && (t = 1), (!W(r) || void 0 === r || r < 2) && (r = 10), W(i) && void 0 !== i || (i = 1e-4), W(o) && void 0 !== o || (o = Math.PI / 8);
        for(var s = [], a = 0; a < t; a++){
            for(var u = [
                nl(n)
            ], l = 0; l < r - 1; l++){
                var h = (0 === l ? 2 * Math.random() * Math.PI : Math.tan((u[l][1] - u[l - 1][1]) / (u[l][0] - u[l - 1][0]))) + (Math.random() - .5) * o * 2, c = Math.random() * i;
                u.push([
                    u[l][0] + c * Math.cos(h),
                    u[l][1] + c * Math.sin(h)
                ]);
            }
            s.push(T(u));
        }
        return R(s);
    }
    function al() {
        return Math.random() - .5;
    }
    function ul(t) {
        return [
            Math.random() * (t[2] - t[0]) + t[0],
            Math.random() * (t[3] - t[1]) + t[1]
        ];
    }
    var ll = Object.freeze({
        __proto__: null,
        randomLineString: sl,
        randomPoint: il,
        randomPolygon: ol,
        randomPosition: el
    });
    function hl(t, e) {
        switch("Feature" === t.type ? t.geometry.type : t.type){
            case "GeometryCollection":
                return kt(t, function(t) {
                    hl(t, e);
                }), t;
            case "LineString":
                return cl(nt(t), e), t;
            case "Polygon":
                return fl(nt(t), e), t;
            case "MultiLineString":
                return nt(t).forEach(function(t) {
                    cl(t, e);
                }), t;
            case "MultiPolygon":
                return nt(t).forEach(function(t) {
                    fl(t, e);
                }), t;
            case "Point":
            case "MultiPoint":
                return t;
        }
    }
    function cl(t, e) {
        Ut(t) === e && t.reverse();
    }
    function fl(t, e) {
        Ut(t[0]) !== e && t[0].reverse();
        for(var n = 1; n < t.length; n++)Ut(t[n]) === e && t[n].reverse();
    }
    function vl(t) {
        var e = t % 360;
        return e < 0 && (e += 360), e;
    }
    function gl(t, e, n) {
        if (!J(n = n || {})) throw new Error("options is invalid");
        var r = n.origin || "centroid", i = n.mutate || !1;
        if (!t) throw new Error("geojson required");
        if ("number" != typeof e || e <= 0) throw new Error("invalid factor");
        var o = Array.isArray(r) || "object" === E(r);
        return !0 !== i && (t = so(t)), "FeatureCollection" !== t.type || o ? dl(t, e, r) : (_t(t, function(n, i) {
            t.features[i] = dl(n, e, r);
        }), 1 !== e && delete t.bbox, t);
    }
    function dl(t, e, n) {
        var r = "Point" === ut(t), i = function(t, e) {
            null == e && (e = "centroid");
            if (Array.isArray(e) || "object" === E(e)) return et(e);
            var n = t.bbox ? t.bbox : qt(t, {
                recompute: !0
            }), r = n[0], i = n[1], o = n[2], s = n[3];
            switch(e){
                case "sw":
                case "southwest":
                case "westsouth":
                case "bottomleft":
                    return M([
                        r,
                        i
                    ]);
                case "se":
                case "southeast":
                case "eastsouth":
                case "bottomright":
                    return M([
                        o,
                        i
                    ]);
                case "nw":
                case "northwest":
                case "westnorth":
                case "topleft":
                    return M([
                        r,
                        s
                    ]);
                case "ne":
                case "northeast":
                case "eastnorth":
                case "topright":
                    return M([
                        o,
                        s
                    ]);
                case "center":
                    return cr(t);
                case void 0:
                case null:
                case "centroid":
                    return Yi(t);
                default:
                    throw new Error("invalid origin");
            }
        }(t, n);
        return 1 === e || r || (dt(t, function(t) {
            var n = ha(i, t), r = vt(i, t), o = nt(ca(i, n * e, r));
            t[0] = o[0], t[1] = o[1], 3 === t.length && (t[2] *= e);
        }), K(t)), t;
    }
    function pl(t) {
        for(var e = t, n = []; e.parent;)n.unshift(e), e = e.parent;
        return n;
    }
    var yl = {
        search: function(t, e, n) {
            var r, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
            t.cleanDirty(), i = i || {};
            var o = yl.heuristics.manhattan, s = null != (r = i.closest) && r, a = new xl(function(t) {
                return t.f;
            }), u = e;
            for(e.h = o(e, n), a.push(e); a.size() > 0;){
                var l = a.pop();
                if (l === n) return pl(l);
                l.closed = !0;
                for(var h = t.neighbors(l), c = 0, f = h.length; c < f; ++c){
                    var v = h[c];
                    if (!v.closed && !v.isWall()) {
                        var g = l.g + v.getCost(l), d = v.visited;
                        (!d || g < v.g) && (v.visited = !0, v.parent = l, v.h = v.h || o(v, n), v.g = g, v.f = v.g + v.h, t.markDirty(v), s && (v.h < u.h || v.h === u.h && v.g < u.g) && (u = v), d ? a.rescoreElement(v) : a.push(v));
                    }
                }
            }
            return s ? pl(u) : [];
        },
        heuristics: {
            manhattan: function(t, e) {
                return Math.abs(e.x - t.x) + Math.abs(e.y - t.y);
            },
            diagonal: function(t, e) {
                var n = Math.sqrt(2), r = Math.abs(e.x - t.x), i = Math.abs(e.y - t.y);
                return 1 * (r + i) + (n - 2) * Math.min(r, i);
            }
        },
        cleanNode: function(t) {
            t.f = 0, t.g = 0, t.h = 0, t.visited = !1, t.closed = !1, t.parent = void 0;
        }
    }, ml = function() {
        return s(function t(e) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            i(this, t), this.nodes = [], this.grid = [], this.dirtyNodes = [], this.diagonal = !!n.diagonal;
            for(var r = 0; r < e.length; r++){
                this.grid[r] = [];
                for(var o = 0, s = e[r]; o < s.length; o++){
                    var a = new _l(r, o, s[o]);
                    this.grid[r][o] = a, this.nodes.push(a);
                }
            }
            this.init();
        }, [
            {
                key: "init",
                value: function() {
                    this.dirtyNodes = [];
                    for(var t = 0; t < this.nodes.length; t++)yl.cleanNode(this.nodes[t]);
                }
            },
            {
                key: "cleanDirty",
                value: function() {
                    for(var t = 0; t < this.dirtyNodes.length; t++)yl.cleanNode(this.dirtyNodes[t]);
                    this.dirtyNodes = [];
                }
            },
            {
                key: "markDirty",
                value: function(t) {
                    this.dirtyNodes.push(t);
                }
            },
            {
                key: "neighbors",
                value: function(t) {
                    var e = [], n = t.x, r = t.y, i = this.grid;
                    return i[n - 1] && i[n - 1][r] && e.push(i[n - 1][r]), i[n + 1] && i[n + 1][r] && e.push(i[n + 1][r]), i[n] && i[n][r - 1] && e.push(i[n][r - 1]), i[n] && i[n][r + 1] && e.push(i[n][r + 1]), this.diagonal && (i[n - 1] && i[n - 1][r - 1] && e.push(i[n - 1][r - 1]), i[n + 1] && i[n + 1][r - 1] && e.push(i[n + 1][r - 1]), i[n - 1] && i[n - 1][r + 1] && e.push(i[n - 1][r + 1]), i[n + 1] && i[n + 1][r + 1] && e.push(i[n + 1][r + 1])), e;
                }
            },
            {
                key: "toString",
                value: function() {
                    for(var t, e, n, r, i = [], o = this.grid, s = 0, a = o.length; s < a; s++){
                        for(t = [], n = 0, r = (e = o[s]).length; n < r; n++)t.push(e[n].weight);
                        i.push(t.join(" "));
                    }
                    return i.join("\n");
                }
            }
        ]);
    }(), _l = function() {
        return s(function t(e, n, r) {
            i(this, t), this.visited = !1, this.h = 0, this.g = 0, this.f = 0, this.closed = !1, this.x = e, this.y = n, this.weight = r;
        }, [
            {
                key: "toString",
                value: function() {
                    return "[" + this.x + " " + this.y + "]";
                }
            },
            {
                key: "getCost",
                value: function(t) {
                    return t && t.x !== this.x && t.y !== this.y ? 1.41421 * this.weight : this.weight;
                }
            },
            {
                key: "isWall",
                value: function() {
                    return 0 === this.weight;
                }
            }
        ]);
    }(), xl = function() {
        return s(function t(e) {
            i(this, t), this.content = [], this.scoreFunction = e;
        }, [
            {
                key: "push",
                value: function(t) {
                    this.content.push(t), this.sinkDown(this.content.length - 1);
                }
            },
            {
                key: "pop",
                value: function() {
                    var t = this.content[0], e = this.content.pop();
                    return this.content.length > 0 && (this.content[0] = e, this.bubbleUp(0)), t;
                }
            },
            {
                key: "remove",
                value: function(t) {
                    var e = this.content.indexOf(t), n = this.content.pop();
                    e !== this.content.length - 1 && (this.content[e] = n, this.scoreFunction(n) < this.scoreFunction(t) ? this.sinkDown(e) : this.bubbleUp(e));
                }
            },
            {
                key: "size",
                value: function() {
                    return this.content.length;
                }
            },
            {
                key: "rescoreElement",
                value: function(t) {
                    this.sinkDown(this.content.indexOf(t));
                }
            },
            {
                key: "sinkDown",
                value: function(t) {
                    for(var e = this.content[t]; t > 0;){
                        var n = (t + 1 >> 1) - 1, r = this.content[n];
                        if (!(this.scoreFunction(e) < this.scoreFunction(r))) break;
                        this.content[n] = e, this.content[t] = r, t = n;
                    }
                }
            },
            {
                key: "bubbleUp",
                value: function(t) {
                    for(var e = this.content.length, n = this.content[t], r = this.scoreFunction(n);;){
                        var i, o = t + 1 << 1, s = o - 1, a = null;
                        if (s < e) {
                            var u = this.content[s];
                            (i = this.scoreFunction(u)) < r && (a = s);
                        }
                        if (o < e) {
                            var l = this.content[o];
                            this.scoreFunction(l) < (null === a ? r : i) && (a = o);
                        }
                        if (null === a) break;
                        this.content[t] = this.content[a], this.content[a] = n, t = a;
                    }
                }
            }
        ]);
    }();
    function El(t, e) {
        for(var n = 0; n < e.features.length; n++)if (Zt(t, e.features[n])) return !0;
        return !1;
    }
    function kl(t, e) {
        var n = t[0] - e[0], r = t[1] - e[1];
        return n * n + r * r;
    }
    function wl(t, e, n) {
        var r = e[0], i = e[1], o = n[0] - r, s = n[1] - i;
        if (0 !== o || 0 !== s) {
            var a = ((t[0] - r) * o + (t[1] - i) * s) / (o * o + s * s);
            a > 1 ? (r = n[0], i = n[1]) : a > 0 && (r += o * a, i += s * a);
        }
        return (o = t[0] - r) * o + (s = t[1] - i) * s;
    }
    function bl(t, e, n, r, i) {
        for(var o, s = r, a = e + 1; a < n; a++){
            var u = wl(t[a], t[e], t[n]);
            u > s && (o = a, s = u);
        }
        s > r && (o - e > 1 && bl(t, e, o, r, i), i.push(t[o]), n - o > 1 && bl(t, o, n, r, i));
    }
    function Il(t, e) {
        var n = t.length - 1, r = [
            t[0]
        ];
        return bl(t, 0, n, e, r), r.push(t[n]), r;
    }
    function Nl(t, e, n) {
        if (t.length <= 2) return t;
        var r = void 0 !== e ? e * e : 1;
        return t = n ? t : function(t, e) {
            for(var n, r = t[0], i = [
                r
            ], o = 1, s = t.length; o < s; o++)kl(n = t[o], r) > e && (i.push(n), r = n);
            return r !== n && i.push(n), i;
        }(t, r), t = Il(t, r);
    }
    function Sl(t, e, n) {
        return t.map(function(t) {
            if (t.length < 4) throw new Error("invalid polygon");
            for(var r = e, i = Nl(t, r, n); !Ml(i) && r >= Number.EPSILON;)i = Nl(t, r -= .01 * r, n);
            return Ml(i) ? (i[i.length - 1][0] === i[0][0] && i[i.length - 1][1] === i[0][1] || i.push(i[0]), i) : t;
        });
    }
    function Ml(t) {
        return !(t.length < 3) && !(3 === t.length && t[2][0] === t[0][0] && t[2][1] === t[0][1]);
    }
    function Ll(t, e) {
        return {
            x: t[0] - e[0],
            y: t[1] - e[1]
        };
    }
    var Pl, Cl = {
        exports: {}
    };
    var Tl = function() {
        if (Pl) return Cl.exports;
        function t(t, n, i) {
            i = i || 2;
            var o, s, a, h, c, v, g, d = n && n.length, p = d ? n[0] * i : t.length, y = e(t, 0, p, i, !0), m = [];
            if (!y || y.next === y.prev) return m;
            if (d && (y = function(t, n, r, i) {
                var o, s, a, h = [];
                for(o = 0, s = n.length; o < s; o++)(a = e(t, n[o] * i, o < s - 1 ? n[o + 1] * i : t.length, i, !1)) === a.next && (a.steiner = !0), h.push(f(a));
                for(h.sort(u), o = 0; o < h.length; o++)r = l(h[o], r);
                return r;
            }(t, n, y, i)), t.length > 80 * i) {
                o = a = t[0], s = h = t[1];
                for(var _ = i; _ < p; _ += i)(c = t[_]) < o && (o = c), (v = t[_ + 1]) < s && (s = v), c > a && (a = c), v > h && (h = v);
                g = 0 !== (g = Math.max(a - o, h - s)) ? 32767 / g : 0;
            }
            return r(y, m, i, o, s, g, 0), m;
        }
        function e(t, e, n, r, i) {
            var o, s;
            if (i === I(t, e, n, r) > 0) for(o = e; o < n; o += r)s = k(o, t[o], t[o + 1], s);
            else for(o = n - r; o >= e; o -= r)s = k(o, t[o], t[o + 1], s);
            return s && p(s, s.next) && (w(s), s = s.next), s;
        }
        function n(t, e) {
            if (!t) return t;
            e || (e = t);
            var n, r = t;
            do if (n = !1, r.steiner || !p(r, r.next) && 0 !== d(r.prev, r, r.next)) r = r.next;
            else {
                if (w(r), (r = e = r.prev) === r.next) break;
                n = !0;
            }
            while (n || r !== e);
            return e;
        }
        function r(t, e, u, l, h, f, v) {
            if (t) {
                !v && f && function(t, e, n, r) {
                    var i = t;
                    do 0 === i.z && (i.z = c(i.x, i.y, e, n, r)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
                    while (i !== t);
                    i.prevZ.nextZ = null, i.prevZ = null, function(t) {
                        var e, n, r, i, o, s, a, u, l = 1;
                        do {
                            for(n = t, t = null, o = null, s = 0; n;){
                                for(s++, r = n, a = 0, e = 0; e < l && (a++, r = r.nextZ); e++);
                                for(u = l; a > 0 || u > 0 && r;)0 !== a && (0 === u || !r || n.z <= r.z) ? (i = n, n = n.nextZ, a--) : (i = r, r = r.nextZ, u--), o ? o.nextZ = i : t = i, i.prevZ = o, o = i;
                                n = r;
                            }
                            o.nextZ = null, l *= 2;
                        }while (s > 1);
                    }(i);
                }(t, l, h, f);
                for(var g, d, p = t; t.prev !== t.next;)if (g = t.prev, d = t.next, f ? o(t, l, h, f) : i(t)) e.push(g.i / u | 0), e.push(t.i / u | 0), e.push(d.i / u | 0), w(t), t = d.next, p = d.next;
                else if ((t = d) === p) {
                    v ? 1 === v ? r(t = s(n(t), e, u), e, u, l, h, f, 2) : 2 === v && a(t, e, u, l, h, f) : r(n(t), e, u, l, h, f, 1);
                    break;
                }
            }
        }
        function i(t) {
            var e = t.prev, n = t, r = t.next;
            if (d(e, n, r) >= 0) return !1;
            for(var i = e.x, o = n.x, s = r.x, a = e.y, u = n.y, l = r.y, h = i < o ? i < s ? i : s : o < s ? o : s, c = a < u ? a < l ? a : l : u < l ? u : l, f = i > o ? i > s ? i : s : o > s ? o : s, g = a > u ? a > l ? a : l : u > l ? u : l, p = r.next; p !== e;){
                if (p.x >= h && p.x <= f && p.y >= c && p.y <= g && v(i, a, o, u, s, l, p.x, p.y) && d(p.prev, p, p.next) >= 0) return !1;
                p = p.next;
            }
            return !0;
        }
        function o(t, e, n, r) {
            var i = t.prev, o = t, s = t.next;
            if (d(i, o, s) >= 0) return !1;
            for(var a = i.x, u = o.x, l = s.x, h = i.y, f = o.y, g = s.y, p = a < u ? a < l ? a : l : u < l ? u : l, y = h < f ? h < g ? h : g : f < g ? f : g, m = a > u ? a > l ? a : l : u > l ? u : l, _ = h > f ? h > g ? h : g : f > g ? f : g, x = c(p, y, e, n, r), E = c(m, _, e, n, r), k = t.prevZ, w = t.nextZ; k && k.z >= x && w && w.z <= E;){
                if (k.x >= p && k.x <= m && k.y >= y && k.y <= _ && k !== i && k !== s && v(a, h, u, f, l, g, k.x, k.y) && d(k.prev, k, k.next) >= 0) return !1;
                if (k = k.prevZ, w.x >= p && w.x <= m && w.y >= y && w.y <= _ && w !== i && w !== s && v(a, h, u, f, l, g, w.x, w.y) && d(w.prev, w, w.next) >= 0) return !1;
                w = w.nextZ;
            }
            for(; k && k.z >= x;){
                if (k.x >= p && k.x <= m && k.y >= y && k.y <= _ && k !== i && k !== s && v(a, h, u, f, l, g, k.x, k.y) && d(k.prev, k, k.next) >= 0) return !1;
                k = k.prevZ;
            }
            for(; w && w.z <= E;){
                if (w.x >= p && w.x <= m && w.y >= y && w.y <= _ && w !== i && w !== s && v(a, h, u, f, l, g, w.x, w.y) && d(w.prev, w, w.next) >= 0) return !1;
                w = w.nextZ;
            }
            return !0;
        }
        function s(t, e, r) {
            var i = t;
            do {
                var o = i.prev, s = i.next.next;
                !p(o, s) && y(o, i, i.next, s) && x(o, s) && x(s, o) && (e.push(o.i / r | 0), e.push(i.i / r | 0), e.push(s.i / r | 0), w(i), w(i.next), i = t = s), i = i.next;
            }while (i !== t);
            return n(i);
        }
        function a(t, e, i, o, s, a) {
            var u = t;
            do {
                for(var l = u.next.next; l !== u.prev;){
                    if (u.i !== l.i && g(u, l)) {
                        var h = E(u, l);
                        return u = n(u, u.next), h = n(h, h.next), r(u, e, i, o, s, a, 0), void r(h, e, i, o, s, a, 0);
                    }
                    l = l.next;
                }
                u = u.next;
            }while (u !== t);
        }
        function u(t, e) {
            return t.x - e.x;
        }
        function l(t, e) {
            var r = function(t, e) {
                var n, r = e, i = t.x, o = t.y, s = -1 / 0;
                do {
                    if (o <= r.y && o >= r.next.y && r.next.y !== r.y) {
                        var a = r.x + (o - r.y) * (r.next.x - r.x) / (r.next.y - r.y);
                        if (a <= i && a > s && (s = a, n = r.x < r.next.x ? r : r.next, a === i)) return n;
                    }
                    r = r.next;
                }while (r !== e);
                if (!n) return null;
                var u, l = n, c = n.x, f = n.y, g = 1 / 0;
                r = n;
                do i >= r.x && r.x >= c && i !== r.x && v(o < f ? i : s, o, c, f, o < f ? s : i, o, r.x, r.y) && (u = Math.abs(o - r.y) / (i - r.x), x(r, t) && (u < g || u === g && (r.x > n.x || r.x === n.x && h(n, r))) && (n = r, g = u)), r = r.next;
                while (r !== l);
                return n;
            }(t, e);
            if (!r) return e;
            var i = E(r, t);
            return n(i, i.next), n(r, r.next);
        }
        function h(t, e) {
            return d(t.prev, t, e.prev) < 0 && d(e.next, t, t.next) < 0;
        }
        function c(t, e, n, r, i) {
            return (t = 1431655765 & ((t = 858993459 & ((t = 252645135 & ((t = 16711935 & ((t = (t - n) * i | 0) | t << 8)) | t << 4)) | t << 2)) | t << 1)) | (e = 1431655765 & ((e = 858993459 & ((e = 252645135 & ((e = 16711935 & ((e = (e - r) * i | 0) | e << 8)) | e << 4)) | e << 2)) | e << 1)) << 1;
        }
        function f(t) {
            var e = t, n = t;
            do (e.x < n.x || e.x === n.x && e.y < n.y) && (n = e), e = e.next;
            while (e !== t);
            return n;
        }
        function v(t, e, n, r, i, o, s, a) {
            return (i - s) * (e - a) >= (t - s) * (o - a) && (t - s) * (r - a) >= (n - s) * (e - a) && (n - s) * (o - a) >= (i - s) * (r - a);
        }
        function g(t, e) {
            return t.next.i !== e.i && t.prev.i !== e.i && !function(t, e) {
                var n = t;
                do {
                    if (n.i !== t.i && n.next.i !== t.i && n.i !== e.i && n.next.i !== e.i && y(n, n.next, t, e)) return !0;
                    n = n.next;
                }while (n !== t);
                return !1;
            }(t, e) && (x(t, e) && x(e, t) && function(t, e) {
                var n = t, r = !1, i = (t.x + e.x) / 2, o = (t.y + e.y) / 2;
                do n.y > o != n.next.y > o && n.next.y !== n.y && i < (n.next.x - n.x) * (o - n.y) / (n.next.y - n.y) + n.x && (r = !r), n = n.next;
                while (n !== t);
                return r;
            }(t, e) && (d(t.prev, t, e.prev) || d(t, e.prev, e)) || p(t, e) && d(t.prev, t, t.next) > 0 && d(e.prev, e, e.next) > 0);
        }
        function d(t, e, n) {
            return (e.y - t.y) * (n.x - e.x) - (e.x - t.x) * (n.y - e.y);
        }
        function p(t, e) {
            return t.x === e.x && t.y === e.y;
        }
        function y(t, e, n, r) {
            var i = _(d(t, e, n)), o = _(d(t, e, r)), s = _(d(n, r, t)), a = _(d(n, r, e));
            return i !== o && s !== a || !(0 !== i || !m(t, n, e)) || !(0 !== o || !m(t, r, e)) || !(0 !== s || !m(n, t, r)) || !(0 !== a || !m(n, e, r));
        }
        function m(t, e, n) {
            return e.x <= Math.max(t.x, n.x) && e.x >= Math.min(t.x, n.x) && e.y <= Math.max(t.y, n.y) && e.y >= Math.min(t.y, n.y);
        }
        function _(t) {
            return t > 0 ? 1 : t < 0 ? -1 : 0;
        }
        function x(t, e) {
            return d(t.prev, t, t.next) < 0 ? d(t, e, t.next) >= 0 && d(t, t.prev, e) >= 0 : d(t, e, t.prev) < 0 || d(t, t.next, e) < 0;
        }
        function E(t, e) {
            var n = new b(t.i, t.x, t.y), r = new b(e.i, e.x, e.y), i = t.next, o = e.prev;
            return t.next = e, e.prev = t, n.next = i, i.prev = n, r.next = n, n.prev = r, o.next = r, r.prev = o, r;
        }
        function k(t, e, n, r) {
            var i = new b(t, e, n);
            return r ? (i.next = r.next, i.prev = r, r.next.prev = i, r.next = i) : (i.prev = i, i.next = i), i;
        }
        function w(t) {
            t.next.prev = t.prev, t.prev.next = t.next, t.prevZ && (t.prevZ.nextZ = t.nextZ), t.nextZ && (t.nextZ.prevZ = t.prevZ);
        }
        function b(t, e, n) {
            this.i = t, this.x = e, this.y = n, this.prev = null, this.next = null, this.z = 0, this.prevZ = null, this.nextZ = null, this.steiner = !1;
        }
        function I(t, e, n, r) {
            for(var i = 0, o = e, s = n - r; o < n; o += r)i += (t[s] - t[o]) * (t[o + 1] + t[s + 1]), s = o;
            return i;
        }
        return Pl = 1, Cl.exports = t, Cl.exports.default = t, t.deviation = function(t, e, n, r) {
            var i = e && e.length, o = i ? e[0] * n : t.length, s = Math.abs(I(t, 0, o, n));
            if (i) for(var a = 0, u = e.length; a < u; a++){
                var l = e[a] * n, h = a < u - 1 ? e[a + 1] * n : t.length;
                s -= Math.abs(I(t, l, h, n));
            }
            var c = 0;
            for(a = 0; a < r.length; a += 3){
                var f = r[a] * n, v = r[a + 1] * n, g = r[a + 2] * n;
                c += Math.abs((t[f] - t[g]) * (t[v + 1] - t[f + 1]) - (t[f] - t[v]) * (t[g + 1] - t[f + 1]));
            }
            return 0 === s && 0 === c ? 0 : Math.abs((c - s) / s);
        }, t.flatten = function(t) {
            for(var e = t[0][0].length, n = {
                vertices: [],
                holes: [],
                dimensions: e
            }, r = 0, i = 0; i < t.length; i++){
                for(var o = 0; o < t[i].length; o++)for(var s = 0; s < e; s++)n.vertices.push(t[i][o][s]);
                i > 0 && (r += t[i - 1].length, n.holes.push(r));
            }
            return n;
        }, Cl.exports;
    }(), Ol = Jn(Tl);
    function Rl(t) {
        var e = function(t) {
            for(var e = 3, n = {
                vertices: [],
                holes: [],
                dimensions: e
            }, r = 0, i = 0; i < t.length; i++){
                for(var o = 0; o < t[i].length; o++)for(var s = 0; s < e; s++)n.vertices.push(t[i][o][s]);
                i > 0 && (r += t[i - 1].length, n.holes.push(r));
            }
            return n;
        }(t), n = Ol(e.vertices, e.holes, 3), r = [], i = [];
        n.forEach(function(t, r) {
            var o = n[r];
            void 0 !== e.vertices[3 * o + 2] ? i.push([
                e.vertices[3 * o],
                e.vertices[3 * o + 1],
                e.vertices[3 * o + 2]
            ]) : i.push([
                e.vertices[3 * o],
                e.vertices[3 * o + 1]
            ]);
        });
        for(var o = 0; o < i.length; o += 3){
            var s = i.slice(o, o + 3);
            s.push(i[o]), r.push(P([
                s
            ]));
        }
        return r;
    }
    function Al(t, e) {
        if ("Polygon" !== t.geometry.type) throw new Error("The input feature must be a Polygon");
        for(var n = t.geometry.coordinates, r = [], i = {}, o = [], s = 0; s < n.length; s++)for(var a = 0; a < n[s].length - 1; a++)o.push(f(s, a));
        var u = new te;
        u.load(o);
        for(var l = 0; l < n.length; l++)for(var h = 0; h < n[l].length - 1; h++)u.search(f(l, h)).forEach(function(t) {
            var e = t.ring, n = t.edge;
            c(l, h, e, n);
        });
        return r;
        function c(t, o, s, a) {
            var u, l, h = n[t][o], c = n[t][o + 1], f = n[s][a], v = n[s][a + 1], g = function(t, e, n, r) {
                if (Dl(t, n) || Dl(t, r) || Dl(e, n) || Dl(r, n)) return null;
                var i = t[0], o = t[1], s = e[0], a = e[1], u = n[0], l = n[1], h = r[0], c = r[1], f = (i - s) * (l - c) - (o - a) * (u - h);
                if (0 === f) return null;
                var v = ((i * a - o * s) * (u - h) - (i - s) * (u * c - l * h)) / f, g = ((i * a - o * s) * (l - c) - (o - a) * (u * c - l * h)) / f;
                return [
                    v,
                    g
                ];
            }(h, c, f, v);
            if (null !== g && (u = c[0] !== h[0] ? (g[0] - h[0]) / (c[0] - h[0]) : (g[1] - h[1]) / (c[1] - h[1]), l = v[0] !== f[0] ? (g[0] - f[0]) / (v[0] - f[0]) : (g[1] - f[1]) / (v[1] - f[1]), !(u >= 1 || u <= 0 || l >= 1 || l <= 0))) {
                var d = g, p = !i[d.toString()];
                p && (i[d.toString()] = !0), e && r.push(e(g, t, o, h, c, u, s, a, f, v, l, p));
            }
        }
        function f(t, e) {
            var r, i, o, s, a = n[t][e], u = n[t][e + 1];
            return a[0] < u[0] ? (r = a[0], i = u[0]) : (r = u[0], i = a[0]), a[1] < u[1] ? (o = a[1], s = u[1]) : (o = u[1], s = a[1]), {
                minX: r,
                minY: o,
                maxX: i,
                maxY: s,
                ring: t,
                edge: e
            };
        }
    }
    function Dl(t, e) {
        if (!t || !e) return !1;
        if (t.length !== e.length) return !1;
        for(var n = 0, r = t.length; n < r; n++)if (t[n] instanceof Array && e[n] instanceof Array) {
            if (!Dl(t[n], e[n])) return !1;
        } else if (t[n] !== e[n]) return !1;
        return !0;
    }
    function Fl(t) {
        if ("Feature" != t.type) throw new Error("The input must a geojson object of type Feature");
        if (void 0 === t.geometry || null == t.geometry) throw new Error("The input must a geojson object with a non-empty geometry");
        if ("Polygon" != t.geometry.type) throw new Error("The input must be a geojson Polygon");
        for(var e = t.geometry.coordinates.length, n = [], r = 0; r < e; r++){
            var i = t.geometry.coordinates[r];
            zl(i[0], i[i.length - 1]) || i.push(i[0]);
            for(var o = 0; o < i.length - 1; o++)n.push(i[o]);
        }
        if (!function(t) {
            for(var e = {}, n = 1, r = 0, i = t.length; r < i; ++r){
                if (Object.prototype.hasOwnProperty.call(e, t[r].toString())) {
                    n = 0;
                    break;
                }
                e[t[r].toString()] = 1;
            }
            return n;
        }(n)) throw new Error("The input polygon may not have duplicate vertices (except for the first and last vertex of each ring)");
        var s = n.length, a = Al(t, function(t, e, n, r, i, o, s, a, u, l, h, c) {
            return [
                t,
                e,
                n,
                r,
                i,
                o,
                s,
                a,
                u,
                l,
                h,
                c
            ];
        }), u = a.length;
        if (0 == u) {
            var l = [];
            for(r = 0; r < e; r++)l.push(P([
                t.geometry.coordinates[r]
            ], {
                parent: -1,
                winding: Bl(t.geometry.coordinates[r])
            }));
            var h = R(l);
            return Y(h), B(h), h;
        }
        var c = [], f = [];
        for(r = 0; r < e; r++){
            c.push([]);
            for(o = 0; o < t.geometry.coordinates[r].length - 1; o++)c[r].push([
                new ql(t.geometry.coordinates[r][jl(o + 1, t.geometry.coordinates[r].length - 1)], 1, [
                    r,
                    o
                ], [
                    r,
                    jl(o + 1, t.geometry.coordinates[r].length - 1)
                ], void 0)
            ]), f.push(new Gl(t.geometry.coordinates[r][o], [
                r,
                jl(o - 1, t.geometry.coordinates[r].length - 1)
            ], [
                r,
                o
            ], void 0, void 0, !1, !0));
        }
        for(r = 0; r < u; r++)c[a[r][1]][a[r][2]].push(new ql(a[r][0], a[r][5], [
            a[r][1],
            a[r][2]
        ], [
            a[r][6],
            a[r][7]
        ], void 0)), a[r][11] && f.push(new Gl(a[r][0], [
            a[r][1],
            a[r][2]
        ], [
            a[r][6],
            a[r][7]
        ], void 0, void 0, !0, !0));
        var v = f.length;
        for(r = 0; r < c.length; r++)for(o = 0; o < c[r].length; o++)c[r][o].sort(function(t, e) {
            return t.param < e.param ? -1 : 1;
        });
        var g = [];
        for(r = 0; r < v; r++)g.push({
            minX: f[r].coord[0],
            minY: f[r].coord[1],
            maxX: f[r].coord[0],
            maxY: f[r].coord[1],
            index: r
        });
        var d = new te;
        d.load(g);
        for(r = 0; r < c.length; r++)for(o = 0; o < c[r].length; o++)for(var p = 0; p < c[r][o].length; p++){
            var y = void 0;
            y = p == c[r][o].length - 1 ? c[r][jl(o + 1, t.geometry.coordinates[r].length - 1)][0].coord : c[r][o][p + 1].coord;
            var m = d.search({
                minX: y[0],
                minY: y[1],
                maxX: y[0],
                maxY: y[1]
            })[0];
            c[r][o][p].nxtIsectAlongEdgeIn = m.index;
        }
        for(r = 0; r < c.length; r++)for(o = 0; o < c[r].length; o++)for(p = 0; p < c[r][o].length; p++){
            var _ = c[r][o][p].coord, x = (m = d.search({
                minX: _[0],
                minY: _[1],
                maxX: _[0],
                maxY: _[1]
            })[0]).index;
            x < s ? f[x].nxtIsectAlongRingAndEdge2 = c[r][o][p].nxtIsectAlongEdgeIn : zl(f[x].ringAndEdge1, c[r][o][p].ringAndEdgeIn) ? f[x].nxtIsectAlongRingAndEdge1 = c[r][o][p].nxtIsectAlongEdgeIn : f[x].nxtIsectAlongRingAndEdge2 = c[r][o][p].nxtIsectAlongEdgeIn;
        }
        var E = [];
        for(r = 0, o = 0; o < e; o++){
            var k = r;
            for(p = 0; p < t.geometry.coordinates[o].length - 1; p++)f[r].coord[0] < f[k].coord[0] && (k = r), r++;
            var w = f[k].nxtIsectAlongRingAndEdge2;
            for(p = 0; p < f.length; p++)if (f[p].nxtIsectAlongRingAndEdge1 == k || f[p].nxtIsectAlongRingAndEdge2 == k) {
                var b = p;
                break;
            }
            var I = Yl([
                f[b].coord,
                f[k].coord,
                f[w].coord
            ], !0) ? 1 : -1;
            E.push({
                isect: k,
                parent: -1,
                winding: I
            });
        }
        E.sort(function(t, e) {
            return f[t.isect].coord > f[e.isect].coord ? -1 : 1;
        });
        for(l = []; E.length > 0;){
            var N = E.pop(), S = N.isect, M = N.parent, L = N.winding, C = l.length, T = [
                f[S].coord
            ], O = S;
            if (f[S].ringAndEdge1Walkable) var A = f[S].ringAndEdge1, D = f[S].nxtIsectAlongRingAndEdge1;
            else A = f[S].ringAndEdge2, D = f[S].nxtIsectAlongRingAndEdge2;
            for(; !zl(f[S].coord, f[D].coord);){
                T.push(f[D].coord);
                var F = void 0;
                for(r = 0; r < E.length; r++)if (E[r].isect == D) {
                    F = r;
                    break;
                }
                if (null != F && E.splice(F, 1), zl(A, f[D].ringAndEdge1)) {
                    if (A = f[D].ringAndEdge2, f[D].ringAndEdge2Walkable = !1, f[D].ringAndEdge1Walkable) {
                        var q = {
                            isect: D
                        };
                        Yl([
                            f[O].coord,
                            f[D].coord,
                            f[f[D].nxtIsectAlongRingAndEdge2].coord
                        ], 1 == L) ? (q.parent = M, q.winding = -L) : (q.parent = C, q.winding = L), E.push(q);
                    }
                    O = D, D = f[D].nxtIsectAlongRingAndEdge2;
                } else {
                    if (A = f[D].ringAndEdge1, f[D].ringAndEdge1Walkable = !1, f[D].ringAndEdge2Walkable) {
                        q = {
                            isect: D
                        };
                        Yl([
                            f[O].coord,
                            f[D].coord,
                            f[f[D].nxtIsectAlongRingAndEdge1].coord
                        ], 1 == L) ? (q.parent = M, q.winding = -L) : (q.parent = C, q.winding = L), E.push(q);
                    }
                    O = D, D = f[D].nxtIsectAlongRingAndEdge1;
                }
            }
            T.push(f[D].coord), l.push(P([
                T
            ], {
                index: C,
                parent: M,
                winding: L,
                netWinding: void 0
            }));
        }
        var G = R(l);
        function Y(t) {
            for(var e = [], n = 0; n < t.features.length; n++)-1 == t.features[n].properties.parent && e.push(n);
            if (e.length > 1) for(n = 0; n < e.length; n++){
                for(var r = -1, i = 1 / 0, o = 0; o < t.features.length; o++)e[n] != o && Zt(t.features[e[n]].geometry.coordinates[0][0], t.features[o], {
                    ignoreBoundary: !0
                }) && Ot(t.features[o]) < i && (r = o);
                t.features[e[n]].properties.parent = r;
            }
        }
        function B(t) {
            for(var e = 0; e < t.features.length; e++)if (-1 == t.features[e].properties.parent) {
                var n = t.features[e].properties.winding;
                t.features[e].properties.netWinding = n, z(t, e, n);
            }
        }
        function z(t, e, n) {
            for(var r = 0; r < t.features.length; r++)if (t.features[r].properties.parent == e) {
                var i = n + t.features[r].properties.winding;
                t.features[r].properties.netWinding = i, z(t, r, i);
            }
        }
        return Y(G), B(G), G;
    }
    var ql = s(function t(e, n, r, o, s) {
        i(this, t), this.coord = e, this.param = n, this.ringAndEdgeIn = r, this.ringAndEdgeOut = o, this.nxtIsectAlongEdgeIn = s;
    }), Gl = s(function t(e, n, r, o, s, a, u) {
        i(this, t), this.coord = e, this.ringAndEdge1 = n, this.ringAndEdge2 = r, this.nxtIsectAlongRingAndEdge1 = o, this.nxtIsectAlongRingAndEdge2 = s, this.ringAndEdge1Walkable = a, this.ringAndEdge2Walkable = u;
    });
    function Yl(t, e) {
        if (void 0 === e && (e = !0), 3 != t.length) throw new Error("This function requires an array of three points [x,y]");
        return (t[1][0] - t[0][0]) * (t[2][1] - t[0][1]) - (t[1][1] - t[0][1]) * (t[2][0] - t[0][0]) >= 0 == e;
    }
    function Bl(t) {
        for(var e = 0, n = 0; n < t.length - 1; n++)t[n][0] < t[e][0] && (e = n);
        if (Yl([
            t[jl(e - 1, t.length - 1)],
            t[e],
            t[jl(e + 1, t.length - 1)]
        ], !0)) var r = 1;
        else r = -1;
        return r;
    }
    function zl(t, e) {
        if (!t || !e) return !1;
        if (t.length != e.length) return !1;
        for(var n = 0, r = t.length; n < r; n++)if (t[n] instanceof Array && e[n] instanceof Array) {
            if (!zl(t[n], e[n])) return !1;
        } else if (t[n] != e[n]) return !1;
        return !0;
    }
    function jl(t, e) {
        return (t % e + e) % e;
    }
    function Xl(t) {
        return function() {
            return t;
        };
    }
    function Ul(t) {
        return t[0];
    }
    function Vl(t) {
        return t[1];
    }
    function Zl() {
        this._ = null;
    }
    function Hl(t) {
        t.U = t.C = t.L = t.R = t.P = t.N = null;
    }
    function Wl(t, e) {
        var n = e, r = e.R, i = n.U;
        i ? i.L === n ? i.L = r : i.R = r : t._ = r, r.U = i, n.U = r, n.R = r.L, n.R && (n.R.U = n), r.L = n;
    }
    function Jl(t, e) {
        var n = e, r = e.L, i = n.U;
        i ? i.L === n ? i.L = r : i.R = r : t._ = r, r.U = i, n.U = r, n.L = r.R, n.L && (n.L.U = n), r.R = n;
    }
    function Kl(t) {
        for(; t.L;)t = t.L;
        return t;
    }
    function Ql(t, e, n, r) {
        var i = [
            null,
            null
        ], o = kh.push(i) - 1;
        return i.left = t, i.right = e, n && th(i, t, e, n), r && th(i, e, t, r), xh[t.index].halfedges.push(o), xh[e.index].halfedges.push(o), i;
    }
    function $l(t, e, n) {
        var r = [
            e,
            n
        ];
        return r.left = t, r;
    }
    function th(t, e, n, r) {
        t[0] || t[1] ? t.left === n ? t[1] = r : t[0] = r : (t[0] = r, t.left = e, t.right = n);
    }
    function eh(t, e, n, r, i) {
        var o, s = t[0], a = t[1], u = s[0], l = s[1], h = 0, c = 1, f = a[0] - u, v = a[1] - l;
        if (o = e - u, f || !(o > 0)) {
            if (o /= f, f < 0) {
                if (o < h) return;
                o < c && (c = o);
            } else if (f > 0) {
                if (o > c) return;
                o > h && (h = o);
            }
            if (o = r - u, f || !(o < 0)) {
                if (o /= f, f < 0) {
                    if (o > c) return;
                    o > h && (h = o);
                } else if (f > 0) {
                    if (o < h) return;
                    o < c && (c = o);
                }
                if (o = n - l, v || !(o > 0)) {
                    if (o /= v, v < 0) {
                        if (o < h) return;
                        o < c && (c = o);
                    } else if (v > 0) {
                        if (o > c) return;
                        o > h && (h = o);
                    }
                    if (o = i - l, v || !(o < 0)) {
                        if (o /= v, v < 0) {
                            if (o > c) return;
                            o > h && (h = o);
                        } else if (v > 0) {
                            if (o < h) return;
                            o < c && (c = o);
                        }
                        return !(h > 0 || c < 1) || (h > 0 && (t[0] = [
                            u + h * f,
                            l + h * v
                        ]), c < 1 && (t[1] = [
                            u + c * f,
                            l + c * v
                        ]), !0);
                    }
                }
            }
        }
    }
    function nh(t, e, n, r, i) {
        var o = t[1];
        if (o) return !0;
        var s, a, u = t[0], l = t.left, h = t.right, c = l[0], f = l[1], v = h[0], g = h[1], d = (c + v) / 2, p = (f + g) / 2;
        if (g === f) {
            if (d < e || d >= r) return;
            if (c > v) {
                if (u) {
                    if (u[1] >= i) return;
                } else u = [
                    d,
                    n
                ];
                o = [
                    d,
                    i
                ];
            } else {
                if (u) {
                    if (u[1] < n) return;
                } else u = [
                    d,
                    i
                ];
                o = [
                    d,
                    n
                ];
            }
        } else if (a = p - (s = (c - v) / (g - f)) * d, s < -1 || s > 1) {
            if (c > v) {
                if (u) {
                    if (u[1] >= i) return;
                } else u = [
                    (n - a) / s,
                    n
                ];
                o = [
                    (i - a) / s,
                    i
                ];
            } else {
                if (u) {
                    if (u[1] < n) return;
                } else u = [
                    (i - a) / s,
                    i
                ];
                o = [
                    (n - a) / s,
                    n
                ];
            }
        } else if (f < g) {
            if (u) {
                if (u[0] >= r) return;
            } else u = [
                e,
                s * e + a
            ];
            o = [
                r,
                s * r + a
            ];
        } else {
            if (u) {
                if (u[0] < e) return;
            } else u = [
                r,
                s * r + a
            ];
            o = [
                e,
                s * e + a
            ];
        }
        return t[0] = u, t[1] = o, !0;
    }
    function rh(t, e) {
        var n = t.site, r = e.left, i = e.right;
        return n === i && (i = r, r = n), i ? Math.atan2(i[1] - r[1], i[0] - r[0]) : (n === r ? (r = e[1], i = e[0]) : (r = e[0], i = e[1]), Math.atan2(r[0] - i[0], i[1] - r[1]));
    }
    function ih(t, e) {
        return e[+(e.left !== t.site)];
    }
    function oh(t, e) {
        return e[+(e.left === t.site)];
    }
    Zl.prototype = {
        constructor: Zl,
        insert: function(t, e) {
            var n, r, i;
            if (t) {
                if (e.P = t, e.N = t.N, t.N && (t.N.P = e), t.N = e, t.R) {
                    for(t = t.R; t.L;)t = t.L;
                    t.L = e;
                } else t.R = e;
                n = t;
            } else this._ ? (t = Kl(this._), e.P = null, e.N = t, t.P = t.L = e, n = t) : (e.P = e.N = null, this._ = e, n = null);
            for(e.L = e.R = null, e.U = n, e.C = !0, t = e; n && n.C;)n === (r = n.U).L ? (i = r.R) && i.C ? (n.C = i.C = !1, r.C = !0, t = r) : (t === n.R && (Wl(this, n), n = (t = n).U), n.C = !1, r.C = !0, Jl(this, r)) : (i = r.L) && i.C ? (n.C = i.C = !1, r.C = !0, t = r) : (t === n.L && (Jl(this, n), n = (t = n).U), n.C = !1, r.C = !0, Wl(this, r)), n = t.U;
            this._.C = !1;
        },
        remove: function(t) {
            t.N && (t.N.P = t.P), t.P && (t.P.N = t.N), t.N = t.P = null;
            var e, n, r, i = t.U, o = t.L, s = t.R;
            if (n = o ? s ? Kl(s) : o : s, i ? i.L === t ? i.L = n : i.R = n : this._ = n, o && s ? (r = n.C, n.C = t.C, n.L = o, o.U = n, n !== s ? (i = n.U, n.U = t.U, t = n.R, i.L = t, n.R = s, s.U = n) : (n.U = i, i = n, t = n.R)) : (r = t.C, t = n), t && (t.U = i), !r) {
                if (t && t.C) t.C = !1;
                else {
                    do {
                        if (t === this._) break;
                        if (t === i.L) {
                            if ((e = i.R).C && (e.C = !1, i.C = !0, Wl(this, i), e = i.R), e.L && e.L.C || e.R && e.R.C) {
                                e.R && e.R.C || (e.L.C = !1, e.C = !0, Jl(this, e), e = i.R), e.C = i.C, i.C = e.R.C = !1, Wl(this, i), t = this._;
                                break;
                            }
                        } else if ((e = i.L).C && (e.C = !1, i.C = !0, Jl(this, i), e = i.L), e.L && e.L.C || e.R && e.R.C) {
                            e.L && e.L.C || (e.R.C = !1, e.C = !0, Wl(this, e), e = i.L), e.C = i.C, i.C = e.L.C = !1, Jl(this, i), t = this._;
                            break;
                        }
                        e.C = !0, t = i, i = i.U;
                    }while (!t.C);
                    t && (t.C = !1);
                }
            }
        }
    };
    var sh, ah = [];
    function uh() {
        Hl(this), this.x = this.y = this.arc = this.site = this.cy = null;
    }
    function lh(t) {
        var e = t.P, n = t.N;
        if (e && n) {
            var r = e.site, i = t.site, o = n.site;
            if (r !== o) {
                var s = i[0], a = i[1], u = r[0] - s, l = r[1] - a, h = o[0] - s, c = o[1] - a, f = 2 * (u * c - l * h);
                if (!(f >= -0.000000000001)) {
                    var v = u * u + l * l, g = h * h + c * c, d = (c * v - l * g) / f, p = (u * g - h * v) / f, y = ah.pop() || new uh;
                    y.arc = t, y.site = i, y.x = d + s, y.y = (y.cy = p + a) + Math.sqrt(d * d + p * p), t.circle = y;
                    for(var m = null, _ = Eh._; _;)if (y.y < _.y || y.y === _.y && y.x <= _.x) {
                        if (!_.L) {
                            m = _.P;
                            break;
                        }
                        _ = _.L;
                    } else {
                        if (!_.R) {
                            m = _;
                            break;
                        }
                        _ = _.R;
                    }
                    Eh.insert(m, y), m || (sh = y);
                }
            }
        }
    }
    function hh(t) {
        var e = t.circle;
        e && (e.P || (sh = e.N), Eh.remove(e), ah.push(e), Hl(e), t.circle = null);
    }
    var ch = [];
    function fh() {
        Hl(this), this.edge = this.site = this.circle = null;
    }
    function vh(t) {
        var e = ch.pop() || new fh;
        return e.site = t, e;
    }
    function gh(t) {
        hh(t), _h.remove(t), ch.push(t), Hl(t);
    }
    function dh(t) {
        var e = t.circle, n = e.x, r = e.cy, i = [
            n,
            r
        ], o = t.P, s = t.N, a = [
            t
        ];
        gh(t);
        for(var u = o; u.circle && Math.abs(n - u.circle.x) < wh && Math.abs(r - u.circle.cy) < wh;)o = u.P, a.unshift(u), gh(u), u = o;
        a.unshift(u), hh(u);
        for(var l = s; l.circle && Math.abs(n - l.circle.x) < wh && Math.abs(r - l.circle.cy) < wh;)s = l.N, a.push(l), gh(l), l = s;
        a.push(l), hh(l);
        var h, c = a.length;
        for(h = 1; h < c; ++h)l = a[h], u = a[h - 1], th(l.edge, u.site, l.site, i);
        u = a[0], (l = a[c - 1]).edge = Ql(u.site, l.site, null, i), lh(u), lh(l);
    }
    function ph(t) {
        for(var e, n, r, i, o = t[0], s = t[1], a = _h._; a;)if ((r = yh(a, s) - o) > wh) a = a.L;
        else {
            if (!((i = o - mh(a, s)) > wh)) {
                r > -wh ? (e = a.P, n = a) : i > -wh ? (e = a, n = a.N) : e = n = a;
                break;
            }
            if (!a.R) {
                e = a;
                break;
            }
            a = a.R;
        }
        !function(t) {
            xh[t.index] = {
                site: t,
                halfedges: []
            };
        }(t);
        var u = vh(t);
        if (_h.insert(e, u), e || n) {
            if (e === n) return hh(e), n = vh(e.site), _h.insert(u, n), u.edge = n.edge = Ql(e.site, u.site), lh(e), void lh(n);
            if (n) {
                hh(e), hh(n);
                var l = e.site, h = l[0], c = l[1], f = t[0] - h, v = t[1] - c, g = n.site, d = g[0] - h, p = g[1] - c, y = 2 * (f * p - v * d), m = f * f + v * v, _ = d * d + p * p, x = [
                    (p * m - v * _) / y + h,
                    (f * _ - d * m) / y + c
                ];
                th(n.edge, l, g, x), u.edge = Ql(l, t, null, x), n.edge = Ql(t, g, null, x), lh(e), lh(n);
            } else u.edge = Ql(e.site, u.site);
        }
    }
    function yh(t, e) {
        var n = t.site, r = n[0], i = n[1], o = i - e;
        if (!o) return r;
        var s = t.P;
        if (!s) return -1 / 0;
        var a = (n = s.site)[0], u = n[1], l = u - e;
        if (!l) return a;
        var h = a - r, c = 1 / o - 1 / l, f = h / l;
        return c ? (-f + Math.sqrt(f * f - 2 * c * (h * h / (-2 * l) - u + l / 2 + i - o / 2))) / c + r : (r + a) / 2;
    }
    function mh(t, e) {
        var n = t.N;
        if (n) return yh(n, e);
        var r = t.site;
        return r[1] === e ? r[0] : 1 / 0;
    }
    var _h, xh, Eh, kh, wh = 1e-6;
    function bh(t, e, n) {
        return (t[0] - n[0]) * (e[1] - t[1]) - (t[0] - e[0]) * (n[1] - t[1]);
    }
    function Ih(t, e) {
        return e[1] - t[1] || e[0] - t[0];
    }
    function Nh(t, e) {
        var n, r, i, o = t.sort(Ih).pop();
        for(kh = [], xh = new Array(t.length), _h = new Zl, Eh = new Zl;;)if (i = sh, o && (!i || o[1] < i.y || o[1] === i.y && o[0] < i.x)) o[0] === n && o[1] === r || (ph(o), n = o[0], r = o[1]), o = t.pop();
        else {
            if (!i) break;
            dh(i.arc);
        }
        if (function() {
            for(var t, e, n, r, i = 0, o = xh.length; i < o; ++i)if ((t = xh[i]) && (r = (e = t.halfedges).length)) {
                var s = new Array(r), a = new Array(r);
                for(n = 0; n < r; ++n)s[n] = n, a[n] = rh(t, kh[e[n]]);
                for(s.sort(function(t, e) {
                    return a[e] - a[t];
                }), n = 0; n < r; ++n)a[n] = e[s[n]];
                for(n = 0; n < r; ++n)e[n] = a[n];
            }
        }(), e) {
            var s = +e[0][0], a = +e[0][1], u = +e[1][0], l = +e[1][1];
            !function(t, e, n, r) {
                for(var i, o = kh.length; o--;)nh(i = kh[o], t, e, n, r) && eh(i, t, e, n, r) && (Math.abs(i[0][0] - i[1][0]) > wh || Math.abs(i[0][1] - i[1][1]) > wh) || delete kh[o];
            }(s, a, u, l), function(t, e, n, r) {
                var i, o, s, a, u, l, h, c, f, v, g, d, p = xh.length, y = !0;
                for(i = 0; i < p; ++i)if (o = xh[i]) {
                    for(s = o.site, a = (u = o.halfedges).length; a--;)kh[u[a]] || u.splice(a, 1);
                    for(a = 0, l = u.length; a < l;)g = (v = oh(o, kh[u[a]]))[0], d = v[1], c = (h = ih(o, kh[u[++a % l]]))[0], f = h[1], (Math.abs(g - c) > wh || Math.abs(d - f) > wh) && (u.splice(a, 0, kh.push($l(s, v, Math.abs(g - t) < wh && r - d > wh ? [
                        t,
                        Math.abs(c - t) < wh ? f : r
                    ] : Math.abs(d - r) < wh && n - g > wh ? [
                        Math.abs(f - r) < wh ? c : n,
                        r
                    ] : Math.abs(g - n) < wh && d - e > wh ? [
                        n,
                        Math.abs(c - n) < wh ? f : e
                    ] : Math.abs(d - e) < wh && g - t > wh ? [
                        Math.abs(f - e) < wh ? c : t,
                        e
                    ] : null)) - 1), ++l);
                    l && (y = !1);
                }
                if (y) {
                    var m, _, x, E = 1 / 0;
                    for(i = 0, y = null; i < p; ++i)(o = xh[i]) && (x = (m = (s = o.site)[0] - t) * m + (_ = s[1] - e) * _) < E && (E = x, y = o);
                    if (y) {
                        var k = [
                            t,
                            e
                        ], w = [
                            t,
                            r
                        ], b = [
                            n,
                            r
                        ], I = [
                            n,
                            e
                        ];
                        y.halfedges.push(kh.push($l(s = y.site, k, w)) - 1, kh.push($l(s, w, b)) - 1, kh.push($l(s, b, I)) - 1, kh.push($l(s, I, k)) - 1);
                    }
                }
                for(i = 0; i < p; ++i)(o = xh[i]) && (o.halfedges.length || delete xh[i]);
            }(s, a, u, l);
        }
        this.edges = kh, this.cells = xh, _h = Eh = kh = xh = null;
    }
    function Sh(t, e) {
        return e ? St(t, function(t, e) {
            return t + function(t) {
                var e = m(t[0], 2), n = e[0], r = e[1], i = m(t[1], 2), o = i[0] - n, s = i[1] - r;
                return Math.sqrt(Math.pow(o, 2) + Math.pow(s, 2));
            }(e.geometry.coordinates);
        }, 0) : tu(t, {
            units: "meters"
        });
    }
    function Mh(t) {
        var e = 90 - t;
        return e > 180 && (e -= 360), e;
    }
    function Lh(t, e) {
        var n = t[0], r = t[t.length - 1];
        if (e) {
            var i = m(n, 2), o = i[0], s = i[1], a = m(r, 2), u = a[0] - o, l = a[1] - s, h = Math.sqrt(Math.pow(u, 2) + Math.pow(l, 2));
            return h < 1e-9 ? [
                NaN,
                NaN
            ] : [
                l / h,
                u / h
            ];
        }
        var c = Mh(ht(n, r)) * Math.PI / 180;
        return [
            Math.sin(c),
            Math.cos(c)
        ];
    }
    function Ph(t, e, n, r) {
        if (r) {
            var i = m(t, 2), o = i[0], s = i[1], a = e * Math.PI / 180, u = Math.sin(a), l = Math.cos(a);
            return [
                [
                    o - n / 2 * l,
                    s - n / 2 * u
                ],
                [
                    o + n / 2 * l,
                    s + n / 2 * u
                ]
            ];
        }
        var h = ct(M(t), n / 2, e, {
            units: "meters"
        });
        return [
            et(ct(M(t), -n / 2, e, {
                units: "meters"
            })),
            et(h)
        ];
    }
    Nh.prototype = {
        constructor: Nh,
        polygons: function() {
            var t = this.edges;
            return this.cells.map(function(e) {
                var n = e.halfedges.map(function(n) {
                    return ih(e, t[n]);
                });
                return n.data = e.site.data, n;
            });
        },
        triangles: function() {
            var t = [], e = this.edges;
            return this.cells.forEach(function(n, r) {
                if (o = (i = n.halfedges).length) for(var i, o, s, a = n.site, u = -1, l = e[i[o - 1]], h = l.left === a ? l.right : l.left; ++u < o;)s = h, h = (l = e[i[u]]).left === a ? l.right : l.left, s && h && r < s.index && r < h.index && bh(a, s, h) < 0 && t.push([
                    a.data,
                    s.data,
                    h.data
                ]);
            }), t;
        },
        links: function() {
            return this.edges.filter(function(t) {
                return t.right;
            }).map(function(t) {
                return {
                    source: t.left.data,
                    target: t.right.data
                };
            });
        },
        find: function(t, e, n) {
            for(var r, i, o = this, s = o._found || 0, a = o.cells.length; !(i = o.cells[s]);)if (++s >= a) return null;
            var u = t - i.site[0], l = e - i.site[1], h = u * u + l * l;
            do i = o.cells[r = s], s = null, i.halfedges.forEach(function(n) {
                var r = o.edges[n], a = r.left;
                if (a !== i.site && a || (a = r.right)) {
                    var u = t - a[0], l = e - a[1], c = u * u + l * l;
                    c < h && (h = c, s = a.index);
                }
            });
            while (null !== s);
            return o._found = r, null == n || h <= n * n ? i.site : null;
        }
    }, t.along = function(t, e) {
        for(var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, r = at(t).coordinates, i = 0, o = 0; o < r.length && !(e >= i && o === r.length - 1); o++){
            if (i >= e) {
                var s = e - i;
                if (s) {
                    var a = ht(r[o], r[o - 1]) - 180;
                    return ct(r[o], s, a, n);
                }
                return M(r[o]);
            }
            i += ft(r[o], r[o + 1], n);
        }
        return M(r[r.length - 1]);
    }, t.angle = function(t, e, n) {
        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
        if (!J(r)) throw new Error("options is invalid");
        if (!t) throw new Error("startPoint is required");
        if (!e) throw new Error("midPoint is required");
        if (!n) throw new Error("endPoint is required");
        var i = t, o = e, s = n, a = j(!0 !== r.mercator ? ht(o, i) : vt(o, i)), u = j(!0 !== r.mercator ? ht(o, s) : vt(o, s));
        u < a && (u += 360);
        var l = u - a;
        return !0 === r.explementary ? 360 - l : l;
    }, t.applyFilter = po, t.area = Ot, t.areaFactors = I, t.azimuthToBearing = X, t.bbox = qt, t.bboxClip = function(t, e) {
        var n = at(t), r = n.type, i = "Feature" === t.type ? t.properties : {}, o = n.coordinates;
        switch(r){
            case "LineString":
            case "MultiLineString":
                var s = [];
                return "LineString" === r && (o = [
                    o
                ]), o.forEach(function(t) {
                    !function(t, e, n) {
                        var r, i, o, s, a, u = t.length, l = Bt(t[0], e), h = [];
                        for(n || (n = []), r = 1; r < u; r++){
                            for(s = t[r - 1], i = o = Bt(a = t[r], e);;){
                                if (!(l | i)) {
                                    h.push(s), i !== o ? (h.push(a), r < u - 1 && (n.push(h), h = [])) : r === u - 1 && h.push(a);
                                    break;
                                }
                                if (l & i) break;
                                l ? l = Bt(s = Yt(s, a, l, e), e) : i = Bt(a = Yt(s, a, i, e), e);
                            }
                            l = o;
                        }
                        h.length && n.push(h);
                    }(t, e, s);
                }), 1 === s.length ? T(s[0], i) : A(s, i);
            case "Polygon":
                return P(zt(o, e), i);
            case "MultiPolygon":
                return F(o.map(function(t) {
                    return zt(t, e);
                }), i);
            default:
                throw new Error("geometry " + r + " not supported");
        }
    }, t.bboxPolygon = jt, t.bearing = ht, t.bearingToAzimuth = j, t.bezierSpline = function(t) {
        for(var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = e.resolution || 1e4, r = e.sharpness || .85, i = [], o = at(t).coordinates.map(function(t) {
            return {
                x: t[0],
                y: t[1]
            };
        }), s = new Xt({
            duration: n,
            points: o,
            sharpness: r
        }), a = function(t) {
            var e = s.pos(t);
            Math.floor(t / 100) % 2 == 0 && i.push([
                e.x,
                e.y
            ]);
        }, u = 0; u < s.duration; u += 10)a(u);
        return a(s.duration), T(i, e.properties);
    }, t.booleanClockwise = Ut, t.booleanConcave = function(t) {
        var e = at(t).coordinates;
        if (e[0].length <= 4) return !1;
        for(var n = !1, r = e[0].length - 1, i = 0; i < r; i++){
            var o = e[0][(i + 2) % r][0] - e[0][(i + 1) % r][0], s = e[0][(i + 2) % r][1] - e[0][(i + 1) % r][1], a = e[0][i][0] - e[0][(i + 1) % r][0], u = o * (e[0][i][1] - e[0][(i + 1) % r][1]) - s * a;
            if (0 === i) n = u > 0;
            else if (n !== u > 0) return !0;
        }
        return !1;
    }, t.booleanContains = fn, t.booleanCrosses = Yn, t.booleanDisjoint = Un, t.booleanEqual = Gn, t.booleanIntersects = Wn, t.booleanOverlap = function(t, e) {
        var n = at(t), r = at(e), i = n.type, o = r.type;
        if ("MultiPoint" === i && "MultiPoint" !== o || ("LineString" === i || "MultiLineString" === i) && "LineString" !== o && "MultiLineString" !== o || ("Polygon" === i || "MultiPolygon" === i) && "Polygon" !== o && "MultiPolygon" !== o) throw new Error("features must be of the same type");
        if ("Point" === i) throw new Error("Point geometry not supported");
        if (Cn(t, e, {
            precision: 6
        })) return !1;
        var s = 0;
        switch(i){
            case "MultiPoint":
                for(var a = 0; a < n.coordinates.length; a++)for(var u = 0; u < r.coordinates.length; u++){
                    var l = n.coordinates[a], h = r.coordinates[u];
                    if (l[0] === h[0] && l[1] === h[1]) return !0;
                }
                return !1;
            case "LineString":
            case "MultiLineString":
                Nt(t, function(t) {
                    Nt(e, function(e) {
                        tr(t, e).features.length && s++;
                    });
                });
                break;
            case "Polygon":
            case "MultiPolygon":
                Nt(t, function(t) {
                    Nt(e, function(e) {
                        je(t, e).features.length && s++;
                    });
                });
        }
        return s > 0;
    }, t.booleanParallel = function(t, e) {
        if (!t) throw new Error("line1 is required");
        if (!e) throw new Error("line2 is required");
        if ("LineString" !== rr(t, "line1")) throw new Error("line1 must be a LineString");
        if ("LineString" !== rr(e, "line2")) throw new Error("line2 must be a LineString");
        for(var n = xe(Dn(t)).features, r = xe(Dn(e)).features, i = 0; i < n.length; i++){
            var o = n[i].geometry.coordinates;
            if (!r[i]) break;
            if (!nr(o, r[i].geometry.coordinates)) return !1;
        }
        return !0;
    }, t.booleanPointInPolygon = Zt, t.booleanPointOnLine = Ht, t.booleanTouches = function(t, e) {
        var n = at(t), r = at(e), i = n.type, o = r.type;
        switch(i){
            case "Point":
                switch(o){
                    case "LineString":
                        return ir(n, r);
                    case "MultiLineString":
                        for(var s = !1, a = 0; a < r.coordinates.length; a++)ir(n, {
                            coordinates: r.coordinates[a]
                        }) && (s = !0);
                        return s;
                    case "Polygon":
                        for(var u = 0; u < r.coordinates.length; u++)if (Ht(n, {
                            type: "LineString",
                            coordinates: r.coordinates[u]
                        })) return !0;
                        return !1;
                    case "MultiPolygon":
                        for(u = 0; u < r.coordinates.length; u++)for(a = 0; a < r.coordinates[u].length; a++)if (Ht(n, {
                            type: "LineString",
                            coordinates: r.coordinates[u][a]
                        })) return !0;
                        return !1;
                    default:
                        throw new Error("feature2 " + o + " geometry not supported");
                }
            case "MultiPoint":
                switch(o){
                    case "LineString":
                        for(s = !1, u = 0; u < n.coordinates.length; u++)if (s || ir({
                            coordinates: n.coordinates[u]
                        }, r) && (s = !0), Ht({
                            type: "Point",
                            coordinates: n.coordinates[u]
                        }, r, {
                            ignoreEndVertices: !0
                        })) return !1;
                        return s;
                    case "MultiLineString":
                        for(s = !1, u = 0; u < n.coordinates.length; u++)for(a = 0; a < r.coordinates.length; a++)if (s || ir({
                            coordinates: n.coordinates[u]
                        }, {
                            coordinates: r.coordinates[a]
                        }) && (s = !0), Ht({
                            type: "Point",
                            coordinates: n.coordinates[u]
                        }, {
                            type: "LineString",
                            coordinates: r.coordinates[a]
                        }, {
                            ignoreEndVertices: !0
                        })) return !1;
                        return s;
                    case "Polygon":
                        for(s = !1, u = 0; u < n.coordinates.length; u++)if (s || Ht({
                            type: "Point",
                            coordinates: n.coordinates[u]
                        }, {
                            type: "LineString",
                            coordinates: r.coordinates[0]
                        }) && (s = !0), Zt({
                            type: "Point",
                            coordinates: n.coordinates[u]
                        }, r, {
                            ignoreBoundary: !0
                        })) return !1;
                        return s;
                    case "MultiPolygon":
                        for(s = !1, u = 0; u < n.coordinates.length; u++)for(a = 0; a < r.coordinates.length; a++)if (s || Ht({
                            type: "Point",
                            coordinates: n.coordinates[u]
                        }, {
                            type: "LineString",
                            coordinates: r.coordinates[a][0]
                        }) && (s = !0), Zt({
                            type: "Point",
                            coordinates: n.coordinates[u]
                        }, {
                            type: "Polygon",
                            coordinates: r.coordinates[a]
                        }, {
                            ignoreBoundary: !0
                        })) return !1;
                        return s;
                    default:
                        throw new Error("feature2 " + o + " geometry not supported");
                }
            case "LineString":
                switch(o){
                    case "Point":
                        return ir(r, n);
                    case "MultiPoint":
                        for(s = !1, u = 0; u < r.coordinates.length; u++)if (s || ir({
                            coordinates: r.coordinates[u]
                        }, n) && (s = !0), Ht({
                            type: "Point",
                            coordinates: r.coordinates[u]
                        }, n, {
                            ignoreEndVertices: !0
                        })) return !1;
                        return s;
                    case "LineString":
                        var l = !1;
                        if (ir({
                            coordinates: n.coordinates[0]
                        }, r) && (l = !0), ir({
                            coordinates: n.coordinates[n.coordinates.length - 1]
                        }, r) && (l = !0), !1 === l) return !1;
                        for(u = 0; u < n.coordinates.length; u++)if (Ht({
                            type: "Point",
                            coordinates: n.coordinates[u]
                        }, r, {
                            ignoreEndVertices: !0
                        })) return !1;
                        return l;
                    case "MultiLineString":
                        for(l = !1, u = 0; u < r.coordinates.length; u++){
                            ir({
                                coordinates: n.coordinates[0]
                            }, {
                                coordinates: r.coordinates[u]
                            }) && (l = !0), ir({
                                coordinates: n.coordinates[n.coordinates.length - 1]
                            }, {
                                coordinates: r.coordinates[u]
                            }) && (l = !0);
                            for(a = 0; a < n.coordinates[u].length; a++)if (Ht({
                                type: "Point",
                                coordinates: n.coordinates[a]
                            }, {
                                type: "LineString",
                                coordinates: r.coordinates[u]
                            }, {
                                ignoreEndVertices: !0
                            })) return !1;
                        }
                        return l;
                    case "Polygon":
                        for(s = !1, u = 0; u < n.coordinates.length; u++)if (s || Ht({
                            type: "Point",
                            coordinates: n.coordinates[u]
                        }, {
                            type: "LineString",
                            coordinates: r.coordinates[0]
                        }) && (s = !0), Zt({
                            type: "Point",
                            coordinates: n.coordinates[u]
                        }, r, {
                            ignoreBoundary: !0
                        })) return !1;
                        return s;
                    case "MultiPolygon":
                        for(s = !1, u = 0; u < n.coordinates.length; u++){
                            for(a = 0; a < r.coordinates.length; a++)s || Ht({
                                type: "Point",
                                coordinates: n.coordinates[u]
                            }, {
                                type: "LineString",
                                coordinates: r.coordinates[a][0]
                            }) && (s = !0);
                            if (Zt({
                                type: "Point",
                                coordinates: n.coordinates[u]
                            }, r, {
                                ignoreBoundary: !0
                            })) return !1;
                        }
                        return s;
                    default:
                        throw new Error("feature2 " + o + " geometry not supported");
                }
            case "MultiLineString":
                switch(o){
                    case "Point":
                        for(u = 0; u < n.coordinates.length; u++)if (ir(r, {
                            coordinates: n.coordinates[u]
                        })) return !0;
                        return !1;
                    case "MultiPoint":
                        for(s = !1, u = 0; u < n.coordinates.length; u++)for(a = 0; a < r.coordinates.length; a++)if (s || ir({
                            coordinates: r.coordinates[a]
                        }, {
                            coordinates: n.coordinates[a]
                        }) && (s = !0), Ht({
                            type: "Point",
                            coordinates: r.coordinates[a]
                        }, {
                            type: "LineString",
                            coordinates: n.coordinates[a]
                        }, {
                            ignoreEndVertices: !0
                        })) return !1;
                        return s;
                    case "LineString":
                        for(l = !1, u = 0; u < n.coordinates.length; u++){
                            ir({
                                coordinates: n.coordinates[u][0]
                            }, r) && (l = !0), ir({
                                coordinates: n.coordinates[u][n.coordinates[u].length - 1]
                            }, r) && (l = !0);
                            for(a = 0; a < r.coordinates.length; a++)if (Ht({
                                type: "Point",
                                coordinates: r.coordinates[a]
                            }, {
                                type: "LineString",
                                coordinates: n.coordinates[u]
                            }, {
                                ignoreEndVertices: !0
                            })) return !1;
                        }
                        return l;
                    case "MultiLineString":
                        for(l = !1, u = 0; u < n.coordinates.length; u++)for(a = 0; a < r.coordinates.length; a++){
                            ir({
                                coordinates: n.coordinates[u][0]
                            }, {
                                coordinates: r.coordinates[a]
                            }) && (l = !0), ir({
                                coordinates: n.coordinates[u][n.coordinates[u].length - 1]
                            }, {
                                coordinates: r.coordinates[a]
                            }) && (l = !0);
                            for(var h = 0; h < n.coordinates[u].length; h++)if (Ht({
                                type: "Point",
                                coordinates: n.coordinates[u][h]
                            }, {
                                type: "LineString",
                                coordinates: r.coordinates[a]
                            }, {
                                ignoreEndVertices: !0
                            })) return !1;
                        }
                        return l;
                    case "Polygon":
                        for(s = !1, u = 0; u < n.coordinates.length; u++)for(a = 0; a < n.coordinates.length; a++)if (s || Ht({
                            type: "Point",
                            coordinates: n.coordinates[u][a]
                        }, {
                            type: "LineString",
                            coordinates: r.coordinates[0]
                        }) && (s = !0), Zt({
                            type: "Point",
                            coordinates: n.coordinates[u][a]
                        }, r, {
                            ignoreBoundary: !0
                        })) return !1;
                        return s;
                    case "MultiPolygon":
                        for(s = !1, u = 0; u < r.coordinates[0].length; u++)for(a = 0; a < n.coordinates.length; a++)for(h = 0; h < n.coordinates[a].length; h++)if (s || Ht({
                            type: "Point",
                            coordinates: n.coordinates[a][h]
                        }, {
                            type: "LineString",
                            coordinates: r.coordinates[0][u]
                        }) && (s = !0), Zt({
                            type: "Point",
                            coordinates: n.coordinates[a][h]
                        }, {
                            type: "Polygon",
                            coordinates: [
                                r.coordinates[0][u]
                            ]
                        }, {
                            ignoreBoundary: !0
                        })) return !1;
                        return s;
                    default:
                        throw new Error("feature2 " + o + " geometry not supported");
                }
            case "Polygon":
                switch(o){
                    case "Point":
                        for(u = 0; u < n.coordinates.length; u++)if (Ht(r, {
                            type: "LineString",
                            coordinates: n.coordinates[u]
                        })) return !0;
                        return !1;
                    case "MultiPoint":
                        for(s = !1, u = 0; u < r.coordinates.length; u++)if (s || Ht({
                            type: "Point",
                            coordinates: r.coordinates[u]
                        }, {
                            type: "LineString",
                            coordinates: n.coordinates[0]
                        }) && (s = !0), Zt({
                            type: "Point",
                            coordinates: r.coordinates[u]
                        }, n, {
                            ignoreBoundary: !0
                        })) return !1;
                        return s;
                    case "LineString":
                        for(s = !1, u = 0; u < r.coordinates.length; u++)if (s || Ht({
                            type: "Point",
                            coordinates: r.coordinates[u]
                        }, {
                            type: "LineString",
                            coordinates: n.coordinates[0]
                        }) && (s = !0), Zt({
                            type: "Point",
                            coordinates: r.coordinates[u]
                        }, n, {
                            ignoreBoundary: !0
                        })) return !1;
                        return s;
                    case "MultiLineString":
                        for(s = !1, u = 0; u < r.coordinates.length; u++)for(a = 0; a < r.coordinates[u].length; a++)if (s || Ht({
                            type: "Point",
                            coordinates: r.coordinates[u][a]
                        }, {
                            type: "LineString",
                            coordinates: n.coordinates[0]
                        }) && (s = !0), Zt({
                            type: "Point",
                            coordinates: r.coordinates[u][a]
                        }, n, {
                            ignoreBoundary: !0
                        })) return !1;
                        return s;
                    case "Polygon":
                        for(s = !1, u = 0; u < n.coordinates[0].length; u++)if (s || Ht({
                            type: "Point",
                            coordinates: n.coordinates[0][u]
                        }, {
                            type: "LineString",
                            coordinates: r.coordinates[0]
                        }) && (s = !0), Zt({
                            type: "Point",
                            coordinates: n.coordinates[0][u]
                        }, r, {
                            ignoreBoundary: !0
                        })) return !1;
                        return s;
                    case "MultiPolygon":
                        for(s = !1, u = 0; u < r.coordinates[0].length; u++)for(a = 0; a < n.coordinates[0].length; a++)if (s || Ht({
                            type: "Point",
                            coordinates: n.coordinates[0][a]
                        }, {
                            type: "LineString",
                            coordinates: r.coordinates[0][u]
                        }) && (s = !0), Zt({
                            type: "Point",
                            coordinates: n.coordinates[0][a]
                        }, {
                            type: "Polygon",
                            coordinates: r.coordinates[0][u]
                        }, {
                            ignoreBoundary: !0
                        })) return !1;
                        return s;
                    default:
                        throw new Error("feature2 " + o + " geometry not supported");
                }
            case "MultiPolygon":
                switch(o){
                    case "Point":
                        for(u = 0; u < n.coordinates[0].length; u++)if (Ht(r, {
                            type: "LineString",
                            coordinates: n.coordinates[0][u]
                        })) return !0;
                        return !1;
                    case "MultiPoint":
                        for(s = !1, u = 0; u < n.coordinates[0].length; u++)for(a = 0; a < r.coordinates.length; a++)if (s || Ht({
                            type: "Point",
                            coordinates: r.coordinates[a]
                        }, {
                            type: "LineString",
                            coordinates: n.coordinates[0][u]
                        }) && (s = !0), Zt({
                            type: "Point",
                            coordinates: r.coordinates[a]
                        }, {
                            type: "Polygon",
                            coordinates: n.coordinates[0][u]
                        }, {
                            ignoreBoundary: !0
                        })) return !1;
                        return s;
                    case "LineString":
                        for(s = !1, u = 0; u < n.coordinates[0].length; u++)for(a = 0; a < r.coordinates.length; a++)if (s || Ht({
                            type: "Point",
                            coordinates: r.coordinates[a]
                        }, {
                            type: "LineString",
                            coordinates: n.coordinates[0][u]
                        }) && (s = !0), Zt({
                            type: "Point",
                            coordinates: r.coordinates[a]
                        }, {
                            type: "Polygon",
                            coordinates: n.coordinates[0][u]
                        }, {
                            ignoreBoundary: !0
                        })) return !1;
                        return s;
                    case "MultiLineString":
                        for(s = !1, u = 0; u < n.coordinates.length; u++)for(a = 0; a < r.coordinates.length; a++)for(h = 0; h < r.coordinates[a].length; h++)if (s || Ht({
                            type: "Point",
                            coordinates: r.coordinates[a][h]
                        }, {
                            type: "LineString",
                            coordinates: n.coordinates[u][0]
                        }) && (s = !0), Zt({
                            type: "Point",
                            coordinates: r.coordinates[a][h]
                        }, {
                            type: "Polygon",
                            coordinates: [
                                n.coordinates[u][0]
                            ]
                        }, {
                            ignoreBoundary: !0
                        })) return !1;
                        return s;
                    case "Polygon":
                        for(s = !1, u = 0; u < n.coordinates[0].length; u++)for(a = 0; a < n.coordinates[0][u].length; a++)if (s || Ht({
                            type: "Point",
                            coordinates: n.coordinates[0][u][a]
                        }, {
                            type: "LineString",
                            coordinates: r.coordinates[0]
                        }) && (s = !0), Zt({
                            type: "Point",
                            coordinates: n.coordinates[0][u][a]
                        }, r, {
                            ignoreBoundary: !0
                        })) return !1;
                        return s;
                    case "MultiPolygon":
                        for(s = !1, u = 0; u < n.coordinates[0].length; u++)for(a = 0; a < r.coordinates[0].length; a++)for(h = 0; h < n.coordinates[0].length; h++)if (s || Ht({
                            type: "Point",
                            coordinates: n.coordinates[0][u][h]
                        }, {
                            type: "LineString",
                            coordinates: r.coordinates[0][a]
                        }) && (s = !0), Zt({
                            type: "Point",
                            coordinates: n.coordinates[0][u][h]
                        }, {
                            type: "Polygon",
                            coordinates: r.coordinates[0][a]
                        }, {
                            ignoreBoundary: !0
                        })) return !1;
                        return s;
                    default:
                        throw new Error("feature2 " + o + " geometry not supported");
                }
            default:
                throw new Error("feature1 " + i + " geometry not supported");
        }
    }, t.booleanValid = function t(e) {
        if (!e.type) return !1;
        var n = at(e), r = n.type, i = n.coordinates;
        switch(r){
            case "Point":
                return i.length > 1;
            case "MultiPoint":
                for(var o = 0; o < i.length; o++)if (i[o].length < 2) return !1;
                return !0;
            case "LineString":
                if (i.length < 2) return !1;
                for(o = 0; o < i.length; o++)if (i[o].length < 2) return !1;
                return !0;
            case "MultiLineString":
                if (i.length < 1) return !1;
                for(o = 0; o < i.length; o++)if (i[o].length < 2) return !1;
                return !0;
            case "Polygon":
                for(o = 0; o < n.coordinates.length; o++){
                    if (i[o].length < 4) return !1;
                    if (!ar(i[o])) return !1;
                    if (ur(i[o])) return !1;
                    if (o > 0 && je(P([
                        i[0]
                    ]), P([
                        i[o]
                    ])).features.length > 1) return !1;
                }
                return !0;
            case "MultiPolygon":
                for(o = 0; o < n.coordinates.length; o++)for(var s = n.coordinates[o], a = 0; a < s.length; a++){
                    if (s[a].length < 4) return !1;
                    if (!ar(s[a])) return !1;
                    if (ur(s[a])) return !1;
                    if (0 === a && !lr(s, n.coordinates, o)) return !1;
                    if (a > 0 && je(P([
                        s[0]
                    ]), P([
                        s[a]
                    ])).features.length > 1) return !1;
                }
                return !0;
            case "GeometryCollection":
                return !!n.geometries && Array.isArray(n.geometries) && n.geometries.length > 0 && n.geometries.every(function(e) {
                    return sr.has(e.type) && t(e);
                });
            default:
                return !1;
        }
    }, t.booleanWithin = hr, t.buffer = function(t, e, n) {
        var r = (n = n || {}).units || "kilometers", i = n.steps || 8;
        if (!t) throw new Error("geojson is required");
        if ("object" !== E(n)) throw new Error("options must be an object");
        if ("number" != typeof i) throw new Error("steps must be an number");
        if (void 0 === e) throw new Error("radius is required");
        if (i <= 0) throw new Error("steps must be greater than 0");
        var o = [];
        switch(t.type){
            case "GeometryCollection":
                return kt(t, function(t) {
                    var n = Ai(t, e, r, i);
                    n && o.push(n);
                }), R(o);
            case "FeatureCollection":
                return _t(t, function(t) {
                    var n = Ai(t, e, r, i);
                    n && _t(n, function(t) {
                        t && o.push(t);
                    });
                }), R(o);
        }
        return Ai(t, e, r, i);
    }, t.center = cr, t.centerMean = Gi, t.centerMedian = function(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        if (!J(e = e || {})) throw new Error("options is invalid");
        var n = e.counter || 10;
        if (!W(n)) throw new Error("counter must be a number");
        var r = e.weight, i = Gi(t, {
            weight: e.weight
        }), o = R([]);
        _t(t, function(t) {
            var e;
            o.features.push(Yi(t, {
                properties: {
                    weight: null == (e = t.properties) ? void 0 : e[r]
                }
            }));
        });
        var s = {
            tolerance: e.tolerance,
            medianCandidates: []
        };
        return Bi(i.geometry.coordinates, [
            0,
            0
        ], o, s, n);
    }, t.centerOfMass = function t(e) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        switch(ut(e)){
            case "Point":
                return M(et(e), n.properties);
            case "Polygon":
                var r = [];
                dt(e, function(t) {
                    r.push(t);
                });
                var i, o, s, a, u, l, h, c, f = Yi(e, {
                    properties: n.properties
                }), v = f.geometry.coordinates, g = 0, d = 0, p = 0, y = r.map(function(t) {
                    return [
                        t[0] - v[0],
                        t[1] - v[1]
                    ];
                });
                for(i = 0; i < r.length - 1; i++)a = (o = y[i])[0], l = o[1], u = (s = y[i + 1])[0], p += c = a * (h = s[1]) - u * l, g += (a + u) * c, d += (l + h) * c;
                if (0 === p) return f;
                var m = 1 / (6 * (.5 * p));
                return M([
                    v[0] + m * g,
                    v[1] + m * d
                ], n.properties);
            default:
                var _ = io(e);
                return _ ? t(_, {
                    properties: n.properties
                }) : Yi(e, {
                    properties: n.properties
                });
        }
    }, t.centroid = Yi, t.circle = oo, t.cleanCoords = Dn, t.clone = so, t.cloneProperties = uo, t.clusterEach = fo, t.clusterReduce = vo, t.clusters = Io, t.clustersDbscan = function(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        !0 !== n.mutate && (t = so(t));
        var r = n.minPoints || 3, i = z(e, n.units), o = new te(t.features.length), s = t.features.map(function(t) {
            return !1;
        }), a = t.features.map(function(t) {
            return !1;
        }), u = t.features.map(function(t) {
            return !1;
        }), l = t.features.map(function(t) {
            return -1;
        });
        o.load(t.features.map(function(t, e) {
            var n = m(t.geometry.coordinates, 2), r = n[0], i = n[1];
            return {
                minX: r,
                minY: i,
                maxX: r,
                maxY: i,
                index: e
            };
        }));
        var h = function(r) {
            var s = t.features[r], a = m(s.geometry.coordinates, 2), u = a[0], l = a[1], h = Math.max(l - i, -90), c = Math.min(l + i, 90), f = h < 0 && c > 0 ? i : Math.abs(h) < Math.abs(c) ? i / Math.cos(V(c)) : i / Math.cos(V(h)), v = Math.max(u - f, -360), g = Math.min(u + f, 360), d = {
                minX: v,
                minY: h,
                maxX: g,
                maxY: c
            };
            return o.search(d).filter(function(r) {
                var i = r.index, o = t.features[i];
                return ft(s, o, {
                    units: n.units
                }) <= e;
            });
        }, c = 0;
        return t.features.forEach(function(t, e) {
            if (!s[e]) {
                var n = h(e);
                if (n.length >= r) {
                    var i = c;
                    c++, s[e] = !0, function(t, e) {
                        for(var n = 0; n < e.length; n++){
                            var i = e[n].index;
                            if (!s[i]) {
                                s[i] = !0;
                                var o = h(i);
                                o.length >= r && e.push.apply(e, _(o));
                            }
                            a[i] || (a[i] = !0, l[i] = t);
                        }
                    }(i, n);
                } else u[e] = !0;
            }
        }), t.features.forEach(function(e, n) {
            var r = t.features[n];
            r.properties || (r.properties = {}), l[n] >= 0 ? (r.properties.dbscan = u[n] ? "edge" : "core", r.properties.cluster = l[n]) : r.properties.dbscan = "noise";
        }), t;
    }, t.clustersKmeans = function(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = t.features.length;
        e.numberOfClusters = e.numberOfClusters || Math.round(Math.sqrt(n / 2)), e.numberOfClusters > n && (e.numberOfClusters = n), !0 !== e.mutate && (t = so(t));
        var r = Et(t), i = r.slice(0, e.numberOfClusters), o = Mo(r, e.numberOfClusters, i), s = {};
        return o.centroids.forEach(function(t, e) {
            s[e] = t;
        }), _t(t, function(t, e) {
            var n = o.idxs[e];
            t.properties.cluster = n, t.properties.centroid = s[n];
        }), t;
    }, t.collect = function(t, e, n, r) {
        var i = new te(6), o = e.features.map(function(t) {
            var e;
            return {
                minX: t.geometry.coordinates[0],
                minY: t.geometry.coordinates[1],
                maxX: t.geometry.coordinates[0],
                maxY: t.geometry.coordinates[1],
                property: null == (e = t.properties) ? void 0 : e[n]
            };
        });
        return i.load(o), t.features.forEach(function(t) {
            t.properties || (t.properties = {});
            var e = qt(t), n = i.search({
                minX: e[0],
                minY: e[1],
                maxX: e[2],
                maxY: e[3]
            }), o = [];
            n.forEach(function(e) {
                Zt([
                    e.minX,
                    e.minY
                ], t) && o.push(e.property);
            }), t.properties[r] = o;
        }), t;
    }, t.collectionOf = st, t.combine = function(t) {
        var e = {
            MultiPoint: {
                coordinates: [],
                properties: []
            },
            MultiLineString: {
                coordinates: [],
                properties: []
            },
            MultiPolygon: {
                coordinates: [],
                properties: []
            }
        };
        return _t(t, function(t) {
            var n, r, i, o;
            switch(null == (o = t.geometry) ? void 0 : o.type){
                case "Point":
                    e.MultiPoint.coordinates.push(t.geometry.coordinates), e.MultiPoint.properties.push(t.properties);
                    break;
                case "MultiPoint":
                    (n = e.MultiPoint.coordinates).push.apply(n, _(t.geometry.coordinates)), e.MultiPoint.properties.push(t.properties);
                    break;
                case "LineString":
                    e.MultiLineString.coordinates.push(t.geometry.coordinates), e.MultiLineString.properties.push(t.properties);
                    break;
                case "MultiLineString":
                    (r = e.MultiLineString.coordinates).push.apply(r, _(t.geometry.coordinates)), e.MultiLineString.properties.push(t.properties);
                    break;
                case "Polygon":
                    e.MultiPolygon.coordinates.push(t.geometry.coordinates), e.MultiPolygon.properties.push(t.properties);
                    break;
                case "MultiPolygon":
                    (i = e.MultiPolygon.coordinates).push.apply(i, _(t.geometry.coordinates)), e.MultiPolygon.properties.push(t.properties);
            }
        }), R(Object.keys(e).filter(function(t) {
            return e[t].coordinates.length;
        }).sort().map(function(t) {
            return N({
                type: t,
                coordinates: e[t].coordinates
            }, {
                collectedProperties: e[t].properties
            });
        }));
    }, t.concave = function(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = e.maxEdge || 1 / 0, r = function(t) {
            var e = [], n = {};
            return _t(t, function(t) {
                if (t.geometry) {
                    var r = t.geometry.coordinates.join("-");
                    Object.prototype.hasOwnProperty.call(n, r) || (e.push(t), n[r] = !0);
                }
            }), R(e);
        }(t), i = Lo(r);
        if (i.features = i.features.filter(function(t) {
            var r = t.geometry.coordinates[0][0], i = t.geometry.coordinates[0][1], o = t.geometry.coordinates[0][2], s = ft(r, i, e), a = ft(i, o, e), u = ft(r, o, e);
            return s <= n && a <= n && u <= n;
        }), i.features.length < 1) return null;
        var o = rs(i);
        return 1 === o.coordinates.length && (o.coordinates = o.coordinates[0], o.type = "Polygon"), N(o);
    }, t.containsNumber = rt, t.convertArea = H, t.convertLength = Z, t.convex = io, t.coordAll = Et, t.coordEach = dt, t.coordReduce = pt, t.createBins = go, t.degreesToRadians = V, t.destination = ct, t.difference = function(t) {
        var e = [];
        if (kt(t, function(t) {
            e.push(t.coordinates);
        }), e.length < 2) throw new Error("Must have at least two features");
        var n = t.features[0].properties || {}, r = ia.apply(sa, [
            e[0]
        ].concat(_(e.slice(1))));
        return 0 === r.length ? null : 1 === r.length ? P(r[0], n) : F(r, n);
    }, t.directionalMean = function(t) {
        var e, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = !!n.planar, i = null != (e = n.segment) && e, o = 0, s = 0, a = 0, u = 0, l = [];
        i ? Nt(t, function(t) {
            var e = m(Lh(t.geometry.coordinates, r), 2), n = e[0], i = e[1], h = Sh(t, r);
            isNaN(n) || isNaN(i) || (o += n, s += i, a += 1, u += h, l.push(Yi(t)));
        }) : _t(t, function(t) {
            if ("LineString" !== t.geometry.type) throw new Error("shold to support MultiLineString?");
            var e = m(Lh(t.geometry.coordinates, r), 2), n = e[0], i = e[1], h = Sh(t, r);
            isNaN(n) || isNaN(i) || (o += n, s += i, a += 1, u += h, l.push(Yi(t)));
        });
        var h = function(t, e) {
            var n = 0;
            n = Math.abs(e) < 1e-9 ? 90 : 180 * Math.atan2(t, e) / Math.PI;
            t >= 0 ? e < 0 && (n += 180) : e < 0 && (n -= 180);
            return n;
        }(o, s), c = Mh(h), f = function(t, e, n) {
            if (0 === n) throw new Error("the size of the features set must be greater than 0");
            return 1 - Math.sqrt(Math.pow(t, 2) + Math.pow(e, 2)) / n;
        }(o, s, a), v = u / a, g = m(et(Yi(R(l))), 2), d = g[0], p = g[1];
        return T(Ph([
            d,
            p
        ], r ? h : c, v, r), {
            averageLength: v,
            averageX: d,
            averageY: p,
            bearingAngle: c,
            cartesianAngle: h,
            circularVariance: f,
            countOfLines: a
        });
    }, t.dissolve = function(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        if (!J(e = e || {})) throw new Error("options is invalid");
        var n = e.propertyName;
        st(t, "Polygon", "dissolve");
        var r = [];
        if (!n) return aa(F(na.apply(null, t.features.map(function(t) {
            return t.geometry.coordinates;
        }))));
        var i = {};
        _t(t, function(t) {
            t.properties && (Object.prototype.hasOwnProperty.call(i, t.properties[n]) || (i[t.properties[n]] = []), i[t.properties[n]].push(t));
        });
        for(var o = Object.keys(i), s = 0; s < o.length; s++){
            var a = F(na.apply(null, i[o[s]].map(function(t) {
                return t.geometry.coordinates;
            })));
            a && a.properties && (a.properties[n] = o[s], r.push(a));
        }
        return aa(R(r));
    }, t.distance = ft, t.distanceWeight = la, t.earthRadius = w, t.ellipse = va, t.envelope = ga, t.explode = da, t.factors = b, t.feature = N, t.featureCollection = R, t.featureEach = _t, t.featureOf = ot, t.featureReduce = xt, t.filterProperties = mo, t.findPoint = Ct, t.findSegment = Pt, t.flatten = aa, t.flattenEach = bt, t.flattenReduce = It, t.flip = function(t, e) {
        var n;
        if (!J(e = e || {})) throw new Error("options is invalid");
        var r = null != (n = e.mutate) && n;
        if (!t) throw new Error("geojson is required");
        return !1 !== r && void 0 !== r || (t = so(t)), dt(t, function(t) {
            var e = t[0], n = t[1];
            t[0] = n, t[1] = e;
        }), t;
    }, t.geojsonRbush = me, t.geojsonType = it, t.geomEach = kt, t.geomReduce = wt, t.geometry = S, t.geometryCollection = q, t.getCluster = co, t.getCoord = et, t.getCoords = nt, t.getGeom = at, t.getType = ut, t.greatCircle = function(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        if ("object" !== E(n)) throw new Error("options is invalid");
        var r = n.properties, i = void 0 === r ? {} : r, o = n.npoints, s = void 0 === o ? 100 : o, a = n.offset, u = void 0 === a ? 10 : a, l = et(t), h = et(e);
        return l[0] === h[0] && l[1] === h[1] ? T(Array(s).fill([
            l[0],
            l[1]
        ]), i) : new ka({
            x: l[0],
            y: l[1]
        }, {
            x: h[0],
            y: h[1]
        }, i || {}).Arc(s, {
            offset: u
        }).json();
    }, t.helpers = tt, t.hexGrid = ba, t.interpolate = function(t, e, n) {
        var r, i, o, s;
        if ("object" !== E(n = n || {})) throw new Error("options is invalid");
        if (!t) throw new Error("points is required");
        if (st(t, "Point", "input must contain Points"), !e) throw new Error("cellSize is required");
        var a, u = null != (r = n.gridType) ? r : "square", l = null != (i = n.property) ? i : "elevation", h = null != (o = n.weight) ? o : 1, c = null != (s = n.bbox) ? s : qt(t);
        if (void 0 !== h && "number" != typeof h) throw new Error("weight must be a number");
        switch(Q(c), u){
            case "point":
            case "points":
                a = Sa(c, e, n);
                break;
            case "square":
            case "squares":
                a = La(c, e, n);
                break;
            case "hex":
            case "hexes":
                a = ba(c, e, n);
                break;
            case "triangle":
            case "triangles":
                a = Pa(c, e, n);
                break;
            default:
                throw new Error("invalid gridType");
        }
        var f = [];
        return _t(a, function(e) {
            var r = 0, i = 0;
            _t(t, function(t) {
                var o, s, a = ft("point" === u ? e : Yi(e), t, n);
                if (void 0 !== l && (s = null == (o = t.properties) ? void 0 : o[l]), void 0 === s && (s = t.geometry.coordinates[2]), void 0 === s) throw new Error("zValue is missing");
                0 === a && (r = s);
                var c = 1 / Math.pow(a, h);
                i += c, r += c * s;
            });
            var o = so(e);
            null != o.properties || (o.properties = {}), o.properties[l] = r / i, f.push(o);
        }), R(f);
    }, t.intersect = wa, t.invariant = lt, t.isNumber = W, t.isObject = J, t.isobands = function(t, e, n) {
        if (!J(n = n || {})) throw new Error("options is invalid");
        var r = n.zProperty || "elevation", i = n.commonProperties || {}, o = n.breaksProperties || [];
        if (st(t, "Point", "Input must contain Points"), !e) throw new Error("breaks is required");
        if (!Array.isArray(e)) throw new Error("breaks is not an Array");
        if (!J(i)) throw new Error("commonProperties is not an Object");
        if (!Array.isArray(o)) throw new Error("breaksProperties is not an Array");
        var s = Fa(t, {
            zProperty: r,
            flip: !0
        }), a = s[0].length;
        if (s.length < 2 || a < 2) throw new Error("Matrix of points must be at least 2x2");
        for(var l = 1; l < s.length; l++)if (s[l].length !== a) throw new Error("Matrix of points is not uniform in the x dimension");
        var h = function(t, e, n) {
            for(var r, i = [], o = 1; o < e.length; o++){
                1 === o && (r = qa(t, +e[0]));
                var s = +e[o], a = +e[o - 1], l = qa(t, s), h = l.map(function(t) {
                    return t.map(function(t) {
                        return [
                            t[0],
                            t[1]
                        ];
                    }).reverse();
                }), c = Ba(Ya(Ga(r.concat(h), t)));
                if (0 === c.length && t[0][0] < s && t[0][0] >= a) {
                    var f = t[0].length, v = t.length;
                    c.push([
                        [
                            [
                                0,
                                0
                            ],
                            [
                                f - 1,
                                0
                            ],
                            [
                                f - 1,
                                v - 1
                            ],
                            [
                                0,
                                v - 1
                            ],
                            [
                                0,
                                0
                            ]
                        ]
                    ]);
                }
                i.push(u({
                    groupedRings: c
                }, n, a + "-" + s)), r = l;
            }
            return i;
        }(s, e, r);
        h = function(t, e, n) {
            var r = qt(n), i = r[2] - r[0], o = r[3] - r[1], s = r[0], a = r[1], u = e[0].length - 1, l = e.length - 1, h = i / u, c = o / l;
            return t.map(function(t) {
                return t.groupedRings = t.groupedRings.map(function(t) {
                    return t.map(function(t) {
                        return t.map(function(t) {
                            return [
                                t[0] * h + s,
                                t[1] * c + a
                            ];
                        });
                    });
                }), t;
            });
        }(h, s, t);
        var c = h.map(function(t, e) {
            if (o[e] && !J(o[e])) throw new Error("Each mappedProperty is required to be an Object");
            var n = Da(Da({}, i), o[e]);
            return n[r] = t[r], F(t.groupedRings, n);
        });
        return R(c);
    }, t.isolines = function(t, e, n) {
        if (!J(n = n || {})) throw new Error("options is invalid");
        var r = n.zProperty || "elevation", i = n.commonProperties || {}, o = n.breaksProperties || [];
        if (st(t, "Point", "Input must contain Points"), !e) throw new Error("breaks is required");
        if (!Array.isArray(e)) throw new Error("breaks must be an Array");
        if (!J(i)) throw new Error("commonProperties must be an Object");
        if (!Array.isArray(o)) throw new Error("breaksProperties must be an Array");
        var s = Ka(t, {
            zProperty: r,
            flip: !0
        }), a = s[0].length;
        if (s.length < 2 || a < 2) throw new Error("Matrix of points must be at least 2x2");
        for(var u = 1; u < s.length; u++)if (s[u].length !== a) throw new Error("Matrix of points is not uniform in the x dimension");
        var l = function(t, e, n) {
            var r = qt(n), i = r[2] - r[0], o = r[3] - r[1], s = r[0], a = r[1], u = e[0].length - 1, l = e.length - 1, h = i / u, c = o / l, f = function(t) {
                t[0] = t[0] * h + s, t[1] = t[1] * c + a;
            };
            return t.forEach(function(t) {
                dt(t, f);
            }), t;
        }(function(t, e, n, r, i) {
            for(var o = [], s = 0; s < e.length; s++){
                var a = +e[s], u = Ja(Ja({}, r), i[s]);
                u[n] = a;
                var l = A(Qa(t, a), u);
                o.push(l);
            }
            return o;
        }(s, e, r, i, o), s, t);
        return R(l);
    }, t.kinks = function(t) {
        var e, n, r = {
            type: "FeatureCollection",
            features: []
        };
        if ("LineString" === (n = "Feature" === t.type ? t.geometry : t).type) e = [
            n.coordinates
        ];
        else if ("MultiLineString" === n.type) e = n.coordinates;
        else if ("MultiPolygon" === n.type) {
            var i;
            e = (i = []).concat.apply(i, _(n.coordinates));
        } else {
            if ("Polygon" !== n.type) throw new Error("Input must be a LineString, MultiLineString, Polygon, or MultiPolygon Feature or Geometry");
            e = n.coordinates;
        }
        return e.forEach(function(t) {
            e.forEach(function(e) {
                for(var n = 0; n < t.length - 1; n++)for(var i = n; i < e.length - 1; i++){
                    if (t === e) {
                        if (1 === Math.abs(n - i)) continue;
                        if (0 === n && i === t.length - 2 && t[n][0] === t[t.length - 1][0] && t[n][1] === t[t.length - 1][1]) continue;
                    }
                    var o = $a(t[n][0], t[n][1], t[n + 1][0], t[n + 1][1], e[i][0], e[i][1], e[i + 1][0], e[i + 1][1]);
                    o && r.features.push(M([
                        o[0],
                        o[1]
                    ]));
                }
            });
        }), r;
    }, t.length = tu, t.lengthToDegrees = z, t.lengthToRadians = B, t.lineArc = eu, t.lineChunk = function(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        if (!J(n)) throw new Error("options is invalid");
        var r = n.units, i = void 0 === r ? "kilometers" : r, o = n.reverse, s = void 0 !== o && o;
        if (!t) throw new Error("geojson is required");
        if (e <= 0) throw new Error("segmentLength must be greater than 0");
        var a = [];
        return bt(t, function(t) {
            s && (t.geometry.coordinates = t.geometry.coordinates.reverse()), function(t, e, n, r) {
                var i = tu(t, {
                    units: n
                });
                if (i <= e) return r(t);
                var o = i / e;
                Number.isInteger(o) || (o = Math.floor(o) + 1);
                for(var s = 0; s < o; s++)r(ru(t, e * s, e * (s + 1), {
                    units: n
                }));
            }(t, e, i, function(t) {
                a.push(t);
            });
        }), R(a);
    }, t.lineEach = Mt, t.lineIntersect = je, t.lineOffset = function(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        if (!J(n = n || {})) throw new Error("options is invalid");
        var r = n.units, i = void 0 === r ? "kilometers" : r;
        if (!t) throw new Error("geojson is required");
        if (null == e || isNaN(e)) throw new Error("distance is required");
        var o = ut(t), s = "Feature" === t.type ? t.properties : {};
        switch(o){
            case "LineString":
                return au(t, e, i);
            case "MultiLineString":
                var a = [];
                return bt(t, function(t) {
                    a.push(au(t, e, i).geometry.coordinates);
                }), A(a, s);
            default:
                throw new Error("geometry " + o + " is not supported");
        }
    }, t.lineOverlap = tr, t.lineReduce = Lt, t.lineSegment = xe, t.lineSlice = function(t, e, n) {
        var r = nt(n);
        if ("LineString" !== ut(n)) throw new Error("line must be a LineString");
        var i = $e(n, t), o = $e(n, e);
        uu(n, i), uu(n, o);
        for(var s = i.properties.segmentIndex <= o.properties.segmentIndex ? [
            i,
            o
        ] : [
            o,
            i
        ], a = [
            s[0].geometry.coordinates
        ], u = s[0].properties.segmentIndex + 1; u < s[1].properties.segmentIndex + 1; u++)a.push(r[u]);
        return a.push(s[1].geometry.coordinates), T(a, "Feature" === n.type ? n.properties : {});
    }, t.lineSliceAlong = ru, t.lineSplit = an, t.lineString = T, t.lineStrings = O, t.lineToPolygon = function(t) {
        var e, n, r, i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, o = i.properties, s = null == (e = i.autoComplete) || e, a = null == (n = i.orderCoords) || n;
        if (null != (r = i.mutate) && r || (t = so(t)), "FeatureCollection" === t.type) {
            var u = [];
            return t.features.forEach(function(t) {
                u.push(nt(lu(t, {}, s, a)));
            }), F(u, o);
        }
        return lu(t, o, s, a);
    }, t.mask = function(t, e, n) {
        var r, i = null != (r = null == n ? void 0 : n.mutate) && r, o = e;
        e && !1 === i && (o = so(e));
        var s, a = fu(o);
        return ("FeatureCollection" === t.type ? cu(2 === (s = t).features.length ? na(s.features[0].geometry.coordinates, s.features[1].geometry.coordinates) : na.apply(sa, s.features.map(function(t) {
            return t.geometry.coordinates;
        }))) : "Feature" === t.type ? cu(na(t.geometry.coordinates)) : cu(na(t.coordinates))).geometry.coordinates.forEach(function(t) {
            a.geometry.coordinates.push(t[0]);
        }), a;
    }, t.meta = Tt, t.midpoint = function(t, e) {
        return ct(t, ft(t, e) / 2, ht(t, e));
    }, t.moranIndex = function(t, e) {
        var n, r, i = e.inputField, o = e.threshold || 1e5, s = e.p || 2, u = null != (n = e.binary) && n, l = la(t, {
            alpha: e.alpha || -1,
            binary: u,
            p: s,
            standardization: null == (r = e.standardization) || r,
            threshold: o
        }), h = [];
        _t(t, function(t) {
            var e = t.properties || {};
            h.push(e[i]);
        });
        for(var c = vu(h), f = function(t) {
            var e, n = vu(t), r = 0, i = a(t);
            try {
                for(i.s(); !(e = i.n()).done;){
                    var o = e.value;
                    r += Math.pow(o - n, 2);
                }
            } catch (t) {
                i.e(t);
            } finally{
                i.f();
            }
            return r / t.length;
        }(h), v = 0, g = 0, d = 0, p = 0, y = l.length, m = 0; m < y; m++){
            for(var _ = 0, x = 0; x < y; x++)v += l[m][x] * (h[m] - c) * (h[x] - c), g += l[m][x], d += Math.pow(l[m][x] + l[x][m], 2), _ += l[m][x] + l[x][m];
            p += Math.pow(_, 2);
        }
        var E = v / g / f, k = -1 / (y - 1), w = (y * y * (d *= .5) - y * p + g * g * 3) / ((y - 1) * (y + 1) * (g * g)) - k * k, b = Math.sqrt(w);
        return {
            expectedMoranIndex: k,
            moranIndex: E,
            stdNorm: b,
            zNorm: (E - k) / b
        };
    }, t.multiLineString = A, t.multiPoint = D, t.multiPolygon = F, t.nearestNeighborAnalysis = function(t, e) {
        var n = (e = e || {}).studyArea || jt(qt(t)), r = e.properties || {}, i = e.units || "kilometers", o = [];
        _t(t, function(t) {
            o.push(Yi(t));
        });
        var s = o.length, a = o.map(function(t, e) {
            return ft(t, wu(t, R(o.filter(function(t, n) {
                return n !== e;
            }))).geometry.coordinates, {
                units: i
            });
        }).reduce(function(t, e) {
            return t + e;
        }, 0) / s, u = s / H(Ot(n), "meters", i), l = 1 / (2 * Math.sqrt(u)), h = .26136 / Math.sqrt(s * u);
        return r.nearestNeighborAnalysis = {
            units: i,
            arealUnits: i + "\xb2",
            observedMeanDistance: a,
            expectedMeanDistance: l,
            nearestNeighborIndex: a / l,
            numberOfPoints: s,
            zScore: (a - l) / h
        }, n.properties = r, n;
    }, t.nearestPoint = wu, t.nearestPointOnLine = $e, t.nearestPointToLine = function(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, r = n.units, i = n.properties || {}, o = function(t) {
            var e = [];
            switch(t.geometry ? t.geometry.type : t.type){
                case "GeometryCollection":
                    return kt(t, function(t) {
                        "Point" === t.type && e.push({
                            type: "Feature",
                            properties: {},
                            geometry: t
                        });
                    }), {
                        type: "FeatureCollection",
                        features: e
                    };
                case "FeatureCollection":
                    return t.features = t.features.filter(function(t) {
                        return "Point" === t.geometry.type;
                    }), t;
                default:
                    throw new Error("points must be a Point Collection");
            }
        }(t);
        if (!o.features.length) throw new Error("points must contain features");
        if (!e) throw new Error("line is required");
        if ("LineString" !== ut(e)) throw new Error("line must be a LineString");
        var s = 1 / 0, a = null;
        return _t(o, function(t) {
            var n = bu(t, e, {
                units: r
            });
            n < s && (s = n, a = t);
        }), a && (a.properties = Cu(Cu(Cu({}, {
            dist: s
        }), a.properties), i)), a;
    }, t.planepoint = function(t, e) {
        var n = et(t), r = at(e).coordinates[0];
        if (r.length < 4) throw new Error("OuterRing of a Polygon must have 4 or more Positions.");
        var i = "Feature" === e.type && e.properties || {}, o = i.a, s = i.b, a = i.c, u = n[0], l = n[1], h = r[0][0], c = r[0][1], f = void 0 !== o ? o : r[0][2], v = r[1][0], g = r[1][1], d = void 0 !== s ? s : r[1][2], p = r[2][0], y = r[2][1], m = void 0 !== a ? a : r[2][2];
        return (m * (u - h) * (l - g) + f * (u - v) * (l - y) + d * (u - p) * (l - c) - d * (u - h) * (l - y) - m * (u - v) * (l - c) - f * (u - p) * (l - g)) / ((u - h) * (l - g) + (u - v) * (l - y) + (u - p) * (l - c) - (u - h) * (l - y) - (u - v) * (l - c) - (u - p) * (l - g));
    }, t.point = M, t.pointGrid = Sa, t.pointOnFeature = function(t) {
        for(var e = function(t) {
            if ("FeatureCollection" !== t.type) return "Feature" !== t.type ? R([
                N(t)
            ]) : R([
                t
            ]);
            return t;
        }(t), n = cr(e), r = !1, i = 0; !r && i < e.features.length;){
            var o = e.features[i].geometry, s = !1;
            if ("Point" === o.type) n.geometry.coordinates[0] === o.coordinates[0] && n.geometry.coordinates[1] === o.coordinates[1] && (r = !0);
            else if ("MultiPoint" === o.type) for(var a = !1, u = 0; !a && u < o.coordinates.length;)n.geometry.coordinates[0] === o.coordinates[u][0] && n.geometry.coordinates[1] === o.coordinates[u][1] && (r = !0, a = !0), u++;
            else if ("LineString" === o.type) for(var l = 0; !s && l < o.coordinates.length - 1;)Tu(n.geometry.coordinates[0], n.geometry.coordinates[1], o.coordinates[l][0], o.coordinates[l][1], o.coordinates[l + 1][0], o.coordinates[l + 1][1]) && (s = !0, r = !0), l++;
            else if ("MultiLineString" === o.type) for(var h = 0; h < o.coordinates.length;){
                s = !1;
                for(var c = 0, f = o.coordinates[h]; !s && c < f.length - 1;)Tu(n.geometry.coordinates[0], n.geometry.coordinates[1], f[c][0], f[c][1], f[c + 1][0], f[c + 1][1]) && (s = !0, r = !0), c++;
                h++;
            }
            else "Polygon" !== o.type && "MultiPolygon" !== o.type || Zt(n, o) && (r = !0);
            i++;
        }
        if (r) return n;
        for(var v = R([]), g = 0; g < e.features.length; g++)v.features = v.features.concat(da(e.features[g]).features);
        return M(wu(n, v).geometry.coordinates);
    }, t.pointToLineDistance = bu, t.pointToPolygonDistance = function t(r, i) {
        var o, s, a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, u = null != (o = a.method) ? o : "geodesic", l = null != (s = a.units) ? s : "kilometers";
        if (!r) throw new Error("point is required");
        if (!i) throw new Error("polygon or multi-polygon is required");
        var h, c = at(i);
        if ("MultiPolygon" === c.type) {
            var g = c.coordinates.map(function(e) {
                return t(r, P(e), {
                    method: u,
                    units: l
                });
            });
            return Math.min.apply(Math, _(g.map(Math.abs))) * (Zt(r, i) ? -1 : 1);
        }
        if (c.coordinates.length > 1) {
            var d = c.coordinates.map(function(e) {
                return t(r, P([
                    e
                ]), {
                    method: u,
                    units: l
                });
            }), p = n(h = d) || f(h) || k(h) || v(), y = p[0], m = e(p).slice(1);
            if (y >= 0) return y;
            var x = Math.min.apply(Math, _(m));
            return x < 0 ? Math.abs(x) : Math.max(-1 * x, y);
        }
        var E = wn(c), w = 1 / 0;
        return bt(E, function(t) {
            w = Math.min(w, bu(r, t, {
                method: u,
                units: l
            }));
        }), Zt(r, c) ? -w : w;
    }, t.points = L, t.pointsWithinPolygon = Ou, t.polygon = P, t.polygonSmooth = function(t, e) {
        (e = e || {}).iterations = e.iterations || 1;
        var n = e.iterations, r = [];
        if (!t) throw new Error("inputPolys is required");
        return kt(t, function(t, e, i) {
            if ("Polygon" === t.type) {
                for(var o = [
                    []
                ], s = 0; s < n; s++){
                    var a = [], u = t;
                    s > 0 && (u = P(o).geometry), Yu(u, a), o = a.slice(0);
                }
                r.push(P(o, i));
            } else {
                if ("MultiPolygon" !== t.type) throw new Error("geometry is invalid, must be Polygon or MultiPolygon");
                for(var l = [
                    [
                        []
                    ]
                ], h = 0; h < n; h++){
                    var c = [], f = t;
                    h > 0 && (f = F(l).geometry), Bu(f, c), l = c.slice(0);
                }
                r.push(F(l, i));
            }
        }), R(r);
    }, t.polygonTangents = function(t, e) {
        var n, r = nt(t), i = nt(e), o = [], s = [], a = qt(e), u = 0, l = null;
        switch(r[0] > a[0] && r[0] < a[2] && r[1] > a[1] && r[1] < a[3] && (u = (l = wu(t, da(e))).properties.featureIndex), ut(e)){
            case "Polygon":
                o = i[0][u], s = i[0][0], null !== l && l.geometry.coordinates[1] < r[1] && (s = i[0][u]), n = Uu(i[0][0], i[0][i[0].length - 1], r);
                var h = m(zu(i[0], r, n, o, s), 2);
                o = h[0], s = h[1];
                break;
            case "MultiPolygon":
                for(var c = 0, f = 0, v = 0, g = 0; g < i[0].length; g++){
                    c = g;
                    for(var d = !1, p = 0; p < i[0][g].length; p++){
                        if (f = p, v === u) {
                            d = !0;
                            break;
                        }
                        v++;
                    }
                    if (d) break;
                }
                o = i[0][c][f], s = i[0][c][f], n = Uu(i[0][0][0], i[0][0][i[0][0].length - 1], r), i.forEach(function(t) {
                    var e = m(zu(t[0], r, n, o, s), 2);
                    o = e[0], s = e[1];
                });
        }
        return R([
            M(o),
            M(s)
        ]);
    }, t.polygonToLine = wn, t.polygonize = function(t) {
        var e = Gu.fromGeoJson(t);
        e.deleteDangles(), e.deleteCutEdges();
        var n = [], r = [];
        return e.getEdgeRings().filter(function(t) {
            return t.isValid();
        }).forEach(function(t) {
            t.isHole() ? n.push(t) : r.push(t);
        }), n.forEach(function(t) {
            qu.findEdgeRingContaining(t, r) && r.push(t);
        }), R(r.map(function(t) {
            return t.toPolygon();
        }));
    }, t.polygons = C, t.projection = Ku, t.propEach = yt, t.propReduce = mt, t.propertiesContainsFilter = yo, t.quadratAnalysis = function(t, e) {
        for(var n = (e = e || {}).studyBbox || qt(t), r = e.confidenceLevel || 20, i = t.features, o = i.length, s = Ot(jt(n)), u = La(n, Math.sqrt(s / o * 2), {
            units: "meters"
        }).features, l = {}, h = 0; h < u.length; h++)l[h] = {
            box: qt(u[h]),
            cnt: 0
        };
        var c, f = 0, v = a(i);
        try {
            for(v.s(); !(c = v.n()).done;)for(var g = c.value, d = 0, p = Object.keys(l); d < p.length; d++){
                var y = p[d], m = l[y].box;
                if ($u(et(g), m)) {
                    l[y].cnt += 1, f += 1;
                    break;
                }
            }
        } catch (t) {
            v.e(t);
        } finally{
            v.f();
        }
        for(var _ = 0, x = 0, E = Object.keys(l); x < E.length; x++){
            var k = l[E[x]].cnt;
            k > _ && (_ = k);
        }
        for(var w = [], b = Object.keys(l).length, I = f / b, N = 0, S = 0; S < _ + 1; S++)N += Math.exp(-I) * Math.pow(I, S) / tl(S), w.push(N);
        for(var M = [], L = 0, P = 0; P < _ + 1; P++){
            for(var C = 0, T = Object.keys(l); C < T.length; C++)l[T[C]].cnt === P && (L += 1);
            var O = L / b;
            M.push(O);
        }
        for(var R = 0, A = 0; A < _ + 1; A++){
            var D = Math.abs(w[A] - M[A]);
            D > R && (R = D);
        }
        var F = Qu[r] / Math.sqrt(b), q = {
            criticalValue: F,
            isRandom: !0,
            maxAbsoluteDifference: R,
            observedDistribution: M
        };
        return R > F && (q.isRandom = !1), q;
    }, t.radiansToDegrees = U, t.radiansToLength = Y, t.random = ll, t.randomLineString = sl, t.randomPoint = il, t.randomPolygon = ol, t.randomPosition = el, t.rectangleGrid = Ma, t.removeBbox = K, t.rewind = function(t) {
        var e, n, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        if (!J(r = r || {})) throw new Error("options is invalid");
        var i = null != (e = r.mutate) && e, o = null != (n = r.reverse) && n;
        if (!t) throw new Error("<geojson> is required");
        if ("boolean" != typeof o) throw new Error("<reverse> must be a boolean");
        if ("boolean" != typeof i) throw new Error("<mutate> must be a boolean");
        i || "Point" === t.type || "MultiPoint" === t.type || (t = so(t));
        var s = [];
        switch(t.type){
            case "GeometryCollection":
                return kt(t, function(t) {
                    hl(t, o);
                }), t;
            case "FeatureCollection":
                return _t(t, function(t) {
                    _t(hl(t, o), function(t) {
                        s.push(t);
                    });
                }), R(s);
        }
        return hl(t, o);
    }, t.rhumbBearing = vt, t.rhumbDestination = ca, t.rhumbDistance = ha, t.round = G, t.sample = function(t, e) {
        if (!t) throw new Error("fc is required");
        if (null == e) throw new Error("num is required");
        if ("number" != typeof e) throw new Error("num must be a number");
        var n = R(function(t, e) {
            var n, r, i = t.slice(0), o = t.length, s = o - e;
            for(; o-- > s;)n = i[r = Math.floor((o + 1) * Math.random())], i[r] = i[o], i[o] = n;
            return i.slice(s);
        }(t.features, e));
        return n;
    }, t.sector = function(t, e, n, r) {
        var i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {};
        if (!J(i = i || {})) throw new Error("options is invalid");
        var o = i.properties;
        if (!t) throw new Error("center is required");
        if (null == n) throw new Error("bearing1 is required");
        if (null == r) throw new Error("bearing2 is required");
        if (!e) throw new Error("radius is required");
        if ("object" !== E(i)) throw new Error("options must be an object");
        if (vl(n) === vl(r)) return oo(t, e, i);
        var s = nt(t), a = eu(t, e, n, r, i), u = [
            [
                s
            ]
        ];
        return dt(a, function(t) {
            u[0].push(t);
        }), u[0].push(s), P(u, o);
    }, t.segmentEach = Nt, t.segmentReduce = St, t.shortestPath = function(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        if (!J(n = n || {})) throw new Error("options is invalid");
        var r = n.obstacles || R([]), i = n.resolution || 100;
        if (!t) throw new Error("start is required");
        if (!e) throw new Error("end is required");
        if (!W(i) || i <= 0) throw new Error("options.resolution must be a number, greater than 0");
        var o = et(t), s = et(e);
        if (t = M(o), e = M(s), "FeatureCollection" === r.type) {
            if (0 === r.features.length) return T([
                o,
                s
            ]);
        } else if ("Feature" === r.type && "Polygon" === r.geometry.type) r = R([
            r
        ]);
        else {
            if ("Polygon" !== r.type) throw new Error("invalid obstacles");
            r = R([
                N(at(r))
            ]);
        }
        var a = r;
        a.features.push(t), a.features.push(e);
        var u = m(qt(gl(jt(qt(a)), 1.15)), 4), l = u[0], h = u[1], c = u[2], f = u[3];
        a.features.pop(), a.features.pop();
        for(var v, g, d = ft([
            l,
            h
        ], [
            c,
            h
        ], n) / i, p = (c - l) / d, y = ft([
            l,
            h
        ], [
            l,
            f
        ], n) / i, _ = (f - h) / y, x = d % 1 * p / 2, E = [], k = [], w = 1 / 0, b = 1 / 0, I = f - y % 1 * _ / 2, S = 0; I >= h;){
            for(var L = [], P = [], C = l + x, O = 0; C <= c;){
                var A = M([
                    C,
                    I
                ]), D = El(A, r);
                L.push(D ? 0 : 1), P.push(C + "|" + I);
                var F = ft(A, t);
                !D && F < w && (w = F, v = {
                    x: O,
                    y: S
                });
                var q = ft(A, e);
                !D && q < b && (b = q, g = {
                    x: O,
                    y: S
                }), C += p, O++;
            }
            k.push(L), E.push(P), I -= _, S++;
        }
        var G = new ml(k, {
            diagonal: !0
        }), Y = G.grid[v.y][v.x], B = G.grid[g.y][g.x], z = yl.search(G, Y, B), j = [
            o
        ];
        return z.forEach(function(t) {
            var e = E[t.x][t.y].split("|");
            j.push([
                +e[0],
                +e[1]
            ]);
        }), j.push(s), Dn(T(j));
    }, t.simplify = function(t) {
        var e, n, r, i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        if (!J(i = null != i ? i : {})) throw new Error("options is invalid");
        var o = null != (e = i.tolerance) ? e : 1, s = null != (n = i.highQuality) && n, a = null != (r = i.mutate) && r;
        if (!t) throw new Error("geojson is required");
        if (o && o < 0) throw new Error("invalid tolerance");
        return !0 !== a && (t = so(t)), kt(t, function(t) {
            !function(t, e, n) {
                var r = t.type;
                if ("Point" === r || "MultiPoint" === r) return t;
                if (Dn(t, {
                    mutate: !0
                }), "GeometryCollection" !== r) switch(r){
                    case "LineString":
                        t.coordinates = Nl(t.coordinates, e, n);
                        break;
                    case "MultiLineString":
                        t.coordinates = t.coordinates.map(function(t) {
                            return Nl(t, e, n);
                        });
                        break;
                    case "Polygon":
                        t.coordinates = Sl(t.coordinates, e, n);
                        break;
                    case "MultiPolygon":
                        t.coordinates = t.coordinates.map(function(t) {
                            return Sl(t, e, n);
                        });
                }
            }(t, o, s);
        }), t;
    }, t.square = function(t) {
        var e = t[0], n = t[1], r = t[2], i = t[3];
        if (ft(t.slice(0, 2), [
            r,
            n
        ]) >= ft(t.slice(0, 2), [
            e,
            i
        ])) {
            var o = (n + i) / 2;
            return [
                e,
                o - (r - e) / 2,
                r,
                o + (r - e) / 2
            ];
        }
        var s = (e + r) / 2;
        return [
            s - (i - n) / 2,
            n,
            s + (i - n) / 2,
            i
        ];
    }, t.squareGrid = La, t.standardDeviationalEllipse = function(t, e) {
        var n;
        if (!J(e = e || {})) throw new Error("options is invalid");
        var r = e.steps || 64, i = e.weight, o = e.properties || {};
        if (!W(r)) throw new Error("steps must be a number");
        if (!J(o)) throw new Error("properties must be a number");
        var s = Et(t).length, a = Gi(t, {
            weight: i
        }), u = 0, l = 0, h = 0;
        _t(t, function(t) {
            var e, n = i && (null == (e = t.properties) ? void 0 : e[i]) || 1, r = Ll(nt(t), nt(a));
            u += Math.pow(r.x, 2) * n, l += Math.pow(r.y, 2) * n, h += r.x * r.y * n;
        });
        var c = u - l, f = Math.sqrt(Math.pow(c, 2) + 4 * Math.pow(h, 2)), v = 2 * h, g = Math.atan((c + f) / v), d = 180 * g / Math.PI, p = 0, y = 0, m = 0;
        _t(t, function(t) {
            var e, n = i && (null == (e = t.properties) ? void 0 : e[i]) || 1, r = Ll(nt(t), nt(a));
            p += Math.pow(r.x * Math.cos(g) - r.y * Math.sin(g), 2) * n, y += Math.pow(r.x * Math.sin(g) + r.y * Math.cos(g), 2) * n, m += n;
        });
        var _ = Math.sqrt(2 * p / m), x = Math.sqrt(2 * y / m), E = va(a, _, x, {
            units: "degrees",
            angle: d,
            steps: r,
            properties: o
        }), k = Ou(t, R([
            E
        ])), w = {
            meanCenterCoordinates: nt(a),
            semiMajorAxis: _,
            semiMinorAxis: x,
            numberOfFeatures: s,
            angle: d,
            percentageWithinEllipse: 100 * Et(k).length / s
        };
        return E.properties = null != (n = E.properties) ? n : {}, E.properties.standardDeviationalEllipse = w, E;
    }, t.tag = function(t, e, n, r) {
        return t = so(t), e = so(e), _t(t, function(t) {
            t.properties || (t.properties = {}), _t(e, function(e) {
                t.properties && e.properties && void 0 === t.properties[r] && Zt(t, e) && (t.properties[r] = e.properties[n]);
            });
        }), t;
    }, t.tesselate = function(t) {
        if (!t.geometry || "Polygon" !== t.geometry.type && "MultiPolygon" !== t.geometry.type) throw new Error("input must be a Polygon or MultiPolygon");
        var e = {
            type: "FeatureCollection",
            features: []
        };
        return "Polygon" === t.geometry.type ? e.features = Rl(t.geometry.coordinates) : t.geometry.coordinates.forEach(function(t) {
            e.features = e.features.concat(Rl(t));
        }), e;
    }, t.tin = Lo, t.toMercator = Vu, t.toWgs84 = Zu, t.transformRotate = fa, t.transformScale = gl, t.transformTranslate = function(t, e, n, r) {
        if (!J(r = r || {})) throw new Error("options is invalid");
        var i = r.units, o = r.zTranslation, s = r.mutate;
        if (!t) throw new Error("geojson is required");
        if (null == e || isNaN(e)) throw new Error("distance is required");
        if (o && "number" != typeof o && isNaN(o)) throw new Error("zTranslation is not a number");
        if (o = void 0 !== o ? o : 0, 0 === e && 0 === o) return t;
        if (null == n || isNaN(n)) throw new Error("direction is required");
        return e < 0 && (e = -e, n += 180), !1 !== s && void 0 !== s || (t = so(t)), dt(t, function(t) {
            var r = nt(ca(t, e, n, {
                units: i
            }));
            t[0] = r[0], t[1] = r[1], o && 3 === t.length && (t[2] += o);
        }), K(t), t;
    }, t.triangleGrid = Pa, t.truncate = _e, t.union = function(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = [];
        if (kt(t, function(t) {
            n.push(t.coordinates);
        }), n.length < 2) throw new Error("Must have at least 2 geometries");
        var r = na.apply(sa, [
            n[0]
        ].concat(_(n.slice(1))));
        return 0 === r.length ? null : 1 === r.length ? P(r[0], e.properties) : F(r, e.properties);
    }, t.unkinkPolygon = function(t) {
        var e = [];
        return bt(t, function(t) {
            "Polygon" === t.geometry.type && _t(Fl(t), function(n) {
                e.push(P(n.geometry.coordinates, t.properties));
            });
        }), R(e);
    }, t.validateBBox = Q, t.validateId = $, t.voronoi = function(t, e) {
        if (!J(e = e || {})) throw new Error("options is invalid");
        var n = e.bbox || [
            -180,
            -85,
            180,
            85
        ];
        if (!t) throw new Error("points is required");
        if (!Array.isArray(n)) throw new Error("bbox is invalid");
        return st(t, "Point", "points"), R((function() {
            var t = Ul, e = Vl, n = null;
            function r(r) {
                return new Nh(r.map(function(n, i) {
                    var o = [
                        Math.round(t(n, i, r) / wh) * wh,
                        Math.round(e(n, i, r) / wh) * wh
                    ];
                    return o.index = i, o.data = n, o;
                }), n);
            }
            return r.polygons = function(t) {
                return r(t).polygons();
            }, r.links = function(t) {
                return r(t).links();
            }, r.triangles = function(t) {
                return r(t).triangles();
            }, r.x = function(e) {
                return arguments.length ? (t = "function" == typeof e ? e : Xl(+e), r) : t;
            }, r.y = function(t) {
                return arguments.length ? (e = "function" == typeof t ? t : Xl(+t), r) : e;
            }, r.extent = function(t) {
                return arguments.length ? (n = null == t ? null : [
                    [
                        +t[0][0],
                        +t[0][1]
                    ],
                    [
                        +t[1][0],
                        +t[1][1]
                    ]
                ], r) : n && [
                    [
                        n[0][0],
                        n[0][1]
                    ],
                    [
                        n[1][0],
                        n[1][1]
                    ]
                ];
            }, r.size = function(t) {
                return arguments.length ? (n = null == t ? null : [
                    [
                        0,
                        0
                    ],
                    [
                        +t[0],
                        +t[1]
                    ]
                ], r) : n && [
                    n[1][0] - n[0][0],
                    n[1][1] - n[0][1]
                ];
            }, r;
        })().x(function(t) {
            return t.geometry.coordinates[0];
        }).y(function(t) {
            return t.geometry.coordinates[1];
        }).extent([
            [
                n[0],
                n[1]
            ],
            [
                n[2],
                n[3]
            ]
        ]).polygons(t.features).map(function(e, n) {
            return Object.assign(function(t) {
                return (t = t.slice()).push(t[0]), P([
                    t
                ]);
            }(e), {
                properties: uo(t.features[n].properties)
            });
        }));
    };
});


var $90f256c567e4c320$exports = {};
(function(a, b) {
    if ("function" == typeof define && define.amd) define([], b);
    else b();
})($90f256c567e4c320$exports, function() {
    "use strict";
    function b(a, b) {
        return "undefined" == typeof b ? b = {
            autoBom: !1
        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
            autoBom: !b
        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
            "\uFEFF",
            a
        ], {
            type: a.type
        }) : a;
    }
    function c(a, b, c) {
        var d = new XMLHttpRequest;
        d.open("GET", a), d.responseType = "blob", d.onload = function() {
            g(d.response, b, c);
        }, d.onerror = function() {
            console.error("could not download file");
        }, d.send();
    }
    function d(a) {
        var b = new XMLHttpRequest;
        b.open("HEAD", a, !1);
        try {
            b.send();
        } catch (a) {}
        return 200 <= b.status && 299 >= b.status;
    }
    function e(a) {
        try {
            a.dispatchEvent(new MouseEvent("click"));
        } catch (c) {
            var b = document.createEvent("MouseEvents");
            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
        }
    }
    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof $parcel$global && $parcel$global.global === $parcel$global ? $parcel$global : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {} : "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
        var i = f.URL || f.webkitURL, j = document.createElement("a");
        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
            i.revokeObjectURL(j.href);
        }, 4E4), setTimeout(function() {
            e(j);
        }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
        else if (d(f)) c(f, g, h);
        else {
            var i = document.createElement("a");
            i.href = f, i.target = "_blank", setTimeout(function() {
                e(i);
            });
        }
    } : function(b, d, e, g) {
        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((j || h && i || a) && "undefined" != typeof FileReader) {
            var k = new FileReader;
            k.onloadend = function() {
                var a = k.result;
                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
            }, k.readAsDataURL(b);
        } else {
            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                l.revokeObjectURL(m);
            }, 4E4);
        }
    });
    f.saveAs = g.saveAs = g, $90f256c567e4c320$exports = g;
});









function $f3cfa07bad7ee5f4$export$6bf11ff3cfb953a7() {
    // obtengo zoom del mapa
    const zoomCelda = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoom > (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zMaxCelda ? (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zMaxCelda : (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoom;
    // obtengo grid a partir del polígono
    if ((0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).editableLayer.getLayers().length == 0) return; // nada que hacer	
    const polygon = (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).editableLayer.getLayers()[0]; // sólo debería haber un polígono
    const geojsonpoly = polygon.toGeoJSON();
    const grid = (0, $0a5d75214fa44e03$export$85a47b3ccce199ed)(polygon.getBounds(), zoomCelda);
    // inicialización modal con petición de confirmación
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        static: true,
        vertcent: true
    }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).downloadData), (0, $646ceeeec66fabd8$export$ce041e830841d411), (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).descargaDatos);
    // muestro el modal
    const mimodal = new (0, (/*@__PURE__*/$parcel$interopDefault($dktVJ))).Modal(document.getElementById('mimodal'));
    mimodal.show();
    // listener al modal para que borre el polígono al cerrar
    document.getElementById('mimodal').addEventListener('hidden.bs.modal', (event)=>{
        (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).editableLayer.clearLayers();
    });
    // pongo listener a los checks de descarga para mensajillo y para habilitar el botón de descarga
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('.check-download').on('change', function() {
        const alguncheck = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('.check-download').is(':checked');
        if (alguncheck) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#downloadNothing').addClass("d-none");
            const algunradio = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('.downloadRadio').is(':checked');
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#downloadData').prop('disabled', !algunradio);
        } else {
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#downloadNothing').removeClass("d-none");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#downloadData').prop('disabled', true);
        }
    });
    // pongo listener al radio para habilitar el botón de descarga
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('.downloadRadio').on('change', function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#downloadNoFormat').addClass("d-none");
        const alguncheck = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('.check-download').is(':checked');
        if (alguncheck) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#downloadData').prop('disabled', false);
    });
    // listener al botón de descarga
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#downloadData').click(function() {
        // miro qué cosas quiere descargar
        let cosasDescargar = {
            trees: (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#checkTrees').is(':checked'),
            annotations: (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#checkAnnotations').is(':checked')
        };
        // detecto el formato de descarga y preparo nombre del fichero
        let format = "GeoJSON"; // valor por defecto
        if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#CSV').is(':checked')) format = "CSV";
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#KML').is(':checked')) format = "KML";
        // llamo a descargar los datos
        $f3cfa07bad7ee5f4$var$descargarDatos(cosasDescargar, grid, zoomCelda, format, geojsonpoly);
    });
}
async function $f3cfa07bad7ee5f4$var$descargarDatos(cosasDescargar, grid, zoomCelda, format, geojsonpoly) {
    // actualizo modal
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        static: true,
        vertcent: true,
        nofooter: true
    }, null, (0, $646ceeeec66fabd8$export$9fac9ed2fe46e816));
    // inicializo array de salidas
    const outputs = [];
    // obtengo los educatrees de las celdas del polígono
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#downloadingTrees").removeClass("d-none");
    // inicializaciones celdas
    let promesasCeldas = [];
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas = {
        total: (1 + grid.cellE - grid.cellW) * (1 + grid.cellN - grid.cellS),
        finalizadas: [],
        cacheadas: [],
        npc: [],
        ifn: false
    };
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).idTimeoutActualizar = 0; // para que no salten timeouts
    // pregenero los taxones más generales y más específicos para el cacheo
    let txgen = [
        'undefined'
    ];
    let txesp = [
        'undefined',
        ...(0, $2q7Wm.default).intersection(Object.keys((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txUsados), Object.keys((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies))
    ];
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).tx != undefined) {
        txgen = [
            'undefined',
            ...(0, $2q7Wm.default).intersection(Object.keys((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txUsados), (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).tx].superexpuris)
        ];
        txesp = (0, $2q7Wm.default).intersection(Object.keys((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txUsados), (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).tx].expuris);
    }
    // descarga de educatrees celda a celda
    for(let x = grid.cellW; x <= grid.cellE; x++)for(let y = grid.cellS; y <= grid.cellN; y++){
        // preparo objeto de la celda
        const objcelda = {
            zoomout: false,
            taxon: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).tx,
            txgen: txgen,
            txesp: txesp,
            zoom: zoomCelda,
            cellX: x,
            cellY: y,
            npc: [],
            et: 'z' + zoomCelda + '_x' + x + '_y' + y + '_' + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).tx,
            ifn: false,
            idtimeout: 0 // predefino el id de timeout
        };
        // enchufo el progreso
        objcelda.progreso = $f3cfa07bad7ee5f4$var$pintarBarraProgresoDescarga;
        // hago la petición de datos
        promesasCeldas.push((0, $174d363c054274ef$export$2579cebb92311e97)(objcelda));
    }
    await Promise.all(promesasCeldas);
    // logging celdas parcelas
    const tcc = (0, $2q7Wm.default).reduce((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.cacheadas, function(memo, num) {
        return memo + num;
    }, 0);
    const npc = (0, $2q7Wm.default).reduce((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.npc, function(memo, num) {
        return memo + num;
    }, 0);
    console.info("#celdas download total: " + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.total + " - cacheadas: " + tcc + " - #npc: " + npc);
    // obtengo iris de educatrees y preparo clusters
    let ediris = [];
    let clusters = [];
    for(let x = grid.cellW; x <= grid.cellE; x++)for(let y = grid.cellS; y <= grid.cellN; y++){
        const et = 'z' + zoomCelda + '_x' + x + '_y' + y + '_' + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).tx;
        const celda = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[et];
        if (celda.edu.trees) ediris = (0, $2q7Wm.default).union(ediris, celda.edu.trees);
        else if (celda.edu.mmil || celda.edu.ntrees > (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).treeThreshold) {
            const bounds = (0, $0a5d75214fa44e03$export$4e23e15d2ccb71f7)(x, y, zoomCelda);
            const lat = celda.edu.locCluster ? celda.edu.locCluster.lat : bounds.getCenter().lat;
            const lng = celda.edu.locCluster ? celda.edu.locCluster.lng : bounds.getCenter().lng;
            const taxon = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).tx ? {
                id: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).tx,
                scientificName: (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).tx].scientificName))
            } : "any";
            clusters.push({
                id: 'cluster_z' + zoomCelda + '_x' + x + '_y' + y,
                type: "cluster",
                clusterValue: celda.edu.mmil ? "+1K" : celda.edu.ntrees,
                latWGS84: lat,
                lngWGS84: lng,
                taxon: taxon
            });
        }
    }
    // filtro con turf los educatrees que caen dentro del polígono
    //console.log("#educatrees inicio: " + ediris.length);
    ediris = (0, $2q7Wm.default).filter(ediris, function(ediri) {
        const turfpoint = (0, $cd948d9b215c1263$exports.point)([
            (0, $69f04ba581843b2d$export$a4829058f9fe1646)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[ediri].lng, grid.cellW, zoomCelda),
            (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[ediri].lat
        ]);
        return (0, $cd948d9b215c1263$exports.booleanPointInPolygon)(turfpoint, geojsonpoly);
    });
    //console.log("#educatrees fin: " + ediris.length);		
    // ordeno
    ediris = (0, $2q7Wm.default).sortBy(ediris);
    // filtro con turf los clusters que caen dentro del polígono
    //console.log("#clusters inicio: " + clusters.length);
    clusters = (0, $2q7Wm.default).filter(clusters, function(cluster) {
        const turfpoint = (0, $cd948d9b215c1263$exports.point)([
            (0, $69f04ba581843b2d$export$a4829058f9fe1646)(cluster.lngWGS84, grid.cellW, zoomCelda),
            cluster.latWGS84
        ]);
        return (0, $cd948d9b215c1263$exports.booleanPointInPolygon)(turfpoint, geojsonpoly);
    });
    //console.log("#clusters fin: " + clusters.length);
    // quito mensajillo de descargando árboles
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#downloadingTrees").addClass("d-none");
    // procesamiento árboles y clusters
    if (cosasDescargar.trees) {
        let arbcls = [];
        // preparo los edutrees
        for (let ediri of ediris){
            const arb = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[ediri];
            const txarb = (0, $1ee989753a15371d$export$fa0799b379eb3758)(arb.species);
            // preparo objeto
            const objarb = {
                id: ediri,
                type: "tree",
                creator: (0, $96abbdd7193a3c4b$export$f91175dce0722b24)(arb),
                created: (0, $96abbdd7193a3c4b$export$daf0fdd0a2e008c2)(arb),
                latWGS84: arb.lat,
                lngWGS84: arb.lng
            };
            if (arb.nick) objarb.nick = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(arb.nick);
            if (txarb) objarb.taxon = {
                id: txarb,
                scientificName: (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[txarb].scientificName))
            };
            if (arb.height) objarb.heightMeters = Number(Number((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(arb.height)).toFixed(2));
            if (arb.dbh) objarb.dbhMillimeters = Number(Number((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(arb.dbh)).toFixed(0));
            if (arb.treeStatus) {
                const ts = (0, $2q7Wm.default).find((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).estadoArboles, function(el) {
                    return el.iri === arb.treeStatus;
                });
                if (ts) objarb.treeStatus = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(ts.label);
            }
            const images = (0, $96abbdd7193a3c4b$export$326843c69d38a183)(arb, [
                "images"
            ]);
            if (images.length) objarb.photos = images;
            const observations = (0, $96abbdd7193a3c4b$export$326843c69d38a183)(arb, [
                "observations"
            ]);
            if (observations.length) {
                objarb.observations = [];
                for (let obs of observations)objarb.observations.push((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(obs));
            }
            // guardo
            arbcls.push(objarb);
        }
        // agrego los clusters
        arbcls = arbcls.concat(clusters);
        // generación datos descarga
        if (arbcls.length > 0) {
            // preparo la salida y guardo
            const output = {
                data: $f3cfa07bad7ee5f4$var$formatearArbolesClusters(arbcls, format),
                nfich: format === 'GeoJSON' ? 'EducaWood_trees.json' : format === 'CSV' ? 'EducaWood_trees.csv' : 'EducaWood_trees.kml'
            };
            outputs.push(output);
            // preparo mensaje de info con el número de árboles y clusters
            let mens = ediris.length > 0 ? '<i class="bi bi-hand-thumbs-up"></i>' + ediris.length + " " + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).educawoodTrees) : "";
            if (clusters.length > 0) mens += mens === "" ? '<i class="bi bi-hand-thumbs-up"></i>' + clusters.length + " " + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).educawoodClusters) : '<br><i class="bi bi-hand-thumbs-up"></i>' + clusters.length + " " + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).educawoodClusters);
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treesDownloaded").html(mens);
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treesDownloaded").removeClass("d-none");
        } else (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#noTreesDownloaded").removeClass("d-none");
    }
    // si pidió las anotaciones extraigo los educatrees completos
    if (cosasDescargar.annotations) {
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#downloadingAnnotations").removeClass("d-none");
        // para el progreso
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas = {
            total: 10,
            finalizadas: [],
            cacheadas: [],
            npc: [],
            ifn: false
        };
        // pido los educawoods completos
        await (0, $174d363c054274ef$export$88055805f25eda73)(ediris, $f3cfa07bad7ee5f4$var$pintarBarraProgresoDescarga);
        // preparo las anotaciones
        let geojsonAnns = []; // para geoJSON
        let allAnss = []; // para CSV o KML
        for (let ediri of ediris){
            // extraigo edutree
            const edutree = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[ediri];
            // inicializo objeto de anotaciones del edutree para GeoJSON
            let geojsonObjann = {
                id: ediri,
                type: "tree",
                creator: (0, $96abbdd7193a3c4b$export$f91175dce0722b24)(edutree),
                created: (0, $96abbdd7193a3c4b$export$daf0fdd0a2e008c2)(edutree),
                latWGS84: edutree.position.latWGS84,
                lngWGS84: edutree.position.lngWGS84,
                positionAnnotations: [],
                treeStatusAnnotations: [],
                speciesAnnotations: [],
                diameterAnnotations: [],
                heightAnnotations: [],
                imageAnnotations: [],
                observations: []
            };
            if (edutree.nick) geojsonObjann.nick = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(edutree.nick);
            // preparo extracto común para CSV y KML
            const anncomun = {
                treeId: ediri,
                latWGS84: edutree.position.latWGS84,
                lngWGS84: edutree.position.lngWGS84
            };
            // posiciones
            if (edutree.positionAnnotations) {
                const posanns = (0, $96abbdd7193a3c4b$export$326843c69d38a183)(edutree, [
                    "positionAnnotations"
                ]);
                for (let annel of posanns){
                    // preparo objetos
                    let annbas = {
                        id: annel.iri,
                        creator: (0, $96abbdd7193a3c4b$export$f91175dce0722b24)(annel),
                        created: (0, $96abbdd7193a3c4b$export$daf0fdd0a2e008c2)(annel),
                        type: "PositionAnnotation",
                        primary: edutree.position && annel.iri === edutree.position.iri,
                        value: {
                            latWGS84: annel.latWGS84,
                            lngWGS84: annel.lngWGS84
                        }
                    };
                    let ann = Object.assign({}, annbas, anncomun);
                    // guardo
                    geojsonObjann.positionAnnotations.push(annbas);
                    allAnss.push(ann);
                }
            }
            // tree status
            if (edutree.treeStatusAnnotations) {
                const tsanns = (0, $96abbdd7193a3c4b$export$326843c69d38a183)(edutree, [
                    "treeStatusAnnotations"
                ]);
                for (let annel of tsanns){
                    const ts = (0, $2q7Wm.default).find((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).estadoArboles, function(el) {
                        return el.iri === annel.treeStatus;
                    });
                    if (ts) {
                        // preparo objetos
                        let annbas = {
                            id: annel.iri,
                            creator: (0, $96abbdd7193a3c4b$export$f91175dce0722b24)(annel),
                            created: (0, $96abbdd7193a3c4b$export$daf0fdd0a2e008c2)(annel),
                            type: "TreeStatusAnnotation",
                            primary: edutree.treeStatus && annel.iri === edutree.treeStatus.iri,
                            value: {
                                ts: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(ts.label)
                            }
                        };
                        let ann = Object.assign({}, annbas, anncomun);
                        // guardo
                        geojsonObjann.treeStatusAnnotations.push(annbas);
                        allAnss.push(ann);
                    }
                }
            }
            // especies
            if (edutree.speciesAnnotations) {
                const spanns = (0, $96abbdd7193a3c4b$export$326843c69d38a183)(edutree, [
                    "speciesAnnotations"
                ]);
                for (let annel of spanns){
                    const txarb = (0, $1ee989753a15371d$export$fa0799b379eb3758)(annel.species.iri);
                    // preparo objetos
                    let annbas = {
                        id: annel.iri,
                        creator: (0, $96abbdd7193a3c4b$export$f91175dce0722b24)(annel),
                        created: (0, $96abbdd7193a3c4b$export$daf0fdd0a2e008c2)(annel),
                        type: "SpeciesAnnotation",
                        primary: edutree.species && annel.iri === edutree.species.iri,
                        value: {
                            id: txarb,
                            scientificName: (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[txarb].scientificName))
                        }
                    };
                    let ann = Object.assign({}, annbas, anncomun);
                    // guardo
                    geojsonObjann.speciesAnnotations.push(annbas);
                    allAnss.push(ann);
                }
            }
            // diámetros
            if (edutree.diameterAnnotations) {
                const diamanns = (0, $96abbdd7193a3c4b$export$326843c69d38a183)(edutree, [
                    "diameterAnnotations"
                ]);
                for (let annel of diamanns){
                    // preparo objetos
                    let annbas = {
                        id: annel.iri,
                        creator: (0, $96abbdd7193a3c4b$export$f91175dce0722b24)(annel),
                        created: (0, $96abbdd7193a3c4b$export$daf0fdd0a2e008c2)(annel),
                        type: "DiameterAnnotation",
                        primary: edutree.diameter && annel.iri === edutree.diameter.iri,
                        value: {
                            dbhMillimeters: Number(Number((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(annel.millimeters)).toFixed(0))
                        }
                    };
                    let ann = Object.assign({}, annbas, anncomun);
                    // guardo
                    geojsonObjann.diameterAnnotations.push(annbas);
                    allAnss.push(ann);
                }
            }
            // alturas
            if (edutree.heightAnnotations) {
                const posanns = (0, $96abbdd7193a3c4b$export$326843c69d38a183)(edutree, [
                    "heightAnnotations"
                ]);
                for (let annel of posanns){
                    // preparo objetos
                    let annbas = {
                        id: annel.iri,
                        creator: (0, $96abbdd7193a3c4b$export$f91175dce0722b24)(annel),
                        created: (0, $96abbdd7193a3c4b$export$daf0fdd0a2e008c2)(annel),
                        type: "HeightAnnotation",
                        primary: edutree.height && annel.iri === edutree.height.iri,
                        value: {
                            heightMeters: Number(Number((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(annel.meters)).toFixed(2))
                        }
                    };
                    let ann = Object.assign({}, annbas, anncomun);
                    // guardo
                    geojsonObjann.heightAnnotations.push(annbas);
                    allAnss.push(ann);
                }
            }
            // fotos
            if (edutree.imageAnnotations) {
                const posanns = (0, $96abbdd7193a3c4b$export$326843c69d38a183)(edutree, [
                    "imageAnnotations"
                ]);
                for (let annel of posanns){
                    // preparo objetos
                    let annbas = {
                        id: annel.iri,
                        creator: (0, $96abbdd7193a3c4b$export$f91175dce0722b24)(annel),
                        created: (0, $96abbdd7193a3c4b$export$daf0fdd0a2e008c2)(annel),
                        type: "ImageAnnotation",
                        value: {
                            imageURL: annel.image.imageURL
                        }
                    };
                    if (annel.image.plantPart && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).partesPlantasFoto[annel.image.plantPart]) annbas.value.plantPart = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).partesPlantasFoto[annel.image.plantPart].label);
                    let ann = Object.assign({}, annbas, anncomun);
                    // guardo
                    geojsonObjann.imageAnnotations.push(annbas);
                    allAnss.push(ann);
                }
            }
            // observaciones
            if (edutree.observations) {
                const posanns = (0, $96abbdd7193a3c4b$export$326843c69d38a183)(edutree, [
                    "observations"
                ]);
                for (let annel of posanns){
                    // preparo objetos
                    let annbas = {
                        id: annel.iri,
                        creator: (0, $96abbdd7193a3c4b$export$f91175dce0722b24)(annel),
                        created: (0, $96abbdd7193a3c4b$export$daf0fdd0a2e008c2)(annel),
                        type: "ObservationAnnotation",
                        value: {
                            text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(annel.text)
                        }
                    };
                    let ann = Object.assign({}, annbas, anncomun);
                    // guardo
                    geojsonObjann.observations.push(annbas);
                    allAnss.push(ann);
                }
            }
            // guardo todas las anotaciones del edutree en geojsonAnns
            geojsonAnns.push(geojsonObjann);
        }
        // generación datos descarga
        if (allAnss.length > 0) {
            // preparo la salida y guardo
            const output = {
                data: $f3cfa07bad7ee5f4$var$formatearAnotacionesArboles(geojsonAnns, allAnss, format),
                nfich: format === 'GeoJSON' ? 'EducaWood_annotations.json' : format === 'CSV' ? 'EducaWood_annotations.csv' : 'EducaWood_annotations.kml'
            };
            outputs.push(output);
            // preparo mensaje de info con el número de anotaciones
            let mens = '<i class="bi bi-hand-thumbs-up"></i>' + allAnss.length + " " + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).educawoodAnnotations);
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#annotationsDownloaded").html(mens);
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#annotationsDownloaded").removeClass("d-none");
        } else (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#noAnnotationsDownloaded").removeClass("d-none");
        // actualizo mensajillos de info
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#downloadingAnnotations").addClass("d-none");
    }
    // hago las descargas
    for (let out of outputs){
        const blob = new Blob([
            out.data
        ], {
            type: "text/plain;charset=utf-8"
        });
        (0, $90f256c567e4c320$exports.saveAs)(blob, out.nfich);
    }
    // actualizo mensajillo de info
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#downloadSuccess").removeClass("d-none");
    // escondo barra de progreso
    $f3cfa07bad7ee5f4$var$pintarBarraProgresoDescarga(false);
    // envío evento GA descarga datos
    const datosga = {
        content_type: 'download_' + format,
        trees: cosasDescargar.trees,
        annotations: cosasDescargar.annotations
    };
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon) datosga.taxon = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon;
    (0, $067277e156f7a571$export$7329bcdc3edcd90e)('select_content', datosga);
    // actualizo modal
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#imgDownload").removeClass("d-none");
    const nuevotit = outputs.length == 0 ? (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).downloadNothing) : (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).downloadSuccess);
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        static: true,
        vertcent: true
    }, nuevotit, null, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).anotacionExito);
}
function $f3cfa07bad7ee5f4$var$formatearAnotacionesArboles(geojsonAnns, allAnss, format) {
    let output;
    switch(format){
        case 'GeoJSON':
            const features = [];
            for (const feat of geojsonAnns){
                // Extract relevant properties from each feature
                const { id: id, type: type, latWGS84: latWGS84, lngWGS84: lngWGS84, nick: nick, creator: creator, created: created, positionAnnotations: positionAnnotations, treeStatusAnnotations: treeStatusAnnotations, speciesAnnotations: speciesAnnotations, diameterAnnotations: diameterAnnotations, heightAnnotations: heightAnnotations, imageAnnotations: imageAnnotations, observations: observations } = feat;
                // Create a GeoJSON feature object
                const feature = {
                    type: 'Feature',
                    geometry: {
                        type: 'Point',
                        coordinates: [
                            lngWGS84,
                            latWGS84
                        ] // [longitude, latitude]
                    },
                    properties: {
                        id: id,
                        type: type,
                        nick: nick,
                        creator: creator,
                        created: created,
                        positionAnnotations: positionAnnotations,
                        treeStatusAnnotations: treeStatusAnnotations,
                        speciesAnnotations: speciesAnnotations,
                        diameterAnnotations: diameterAnnotations,
                        heightAnnotations: heightAnnotations,
                        imageAnnotations: imageAnnotations,
                        observations: observations
                    }
                };
                features.push(feature);
            }
            // Create the GeoJSON object
            const geoJSON = {
                type: 'FeatureCollection',
                features: features
            };
            output = JSON.stringify(geoJSON, null, 2);
            break;
        case 'CSV':
            // Extract the keys from the first tree object to create the CSV header
            const header = [
                "id",
                "treeId",
                "latWGS84",
                "lngWGS84",
                "creator.id",
                "creator.nick",
                "created",
                "type",
                "primary",
                "value.latWGS84",
                "value.lngWGS84",
                "value.ts",
                "value.id",
                "value.scientificName",
                "value.dbhMillimeters",
                "value.heightMeters",
                "value.imageURL",
                "value.plantPart",
                "value.text"
            ];
            // Generate the CSV rows
            // feb-2024 rehago para tratar las cadenas incluyendo "" y para escapar las "
            const rows = Object.values(allAnss).map((feature)=>{
                return header.map((key)=>{
                    let value = undefined;
                    if (key.indexOf(".") !== -1) {
                        // caso anidado, extraigo las dos claves
                        const subkeys = key.split(".");
                        if (feature[subkeys[0]] && feature[subkeys[0]][subkeys[1]]) value = feature[subkeys[0]][subkeys[1]];
                    // en otro caso no está definido
                    } else if (Array.isArray(feature[key])) value = feature[key].join('\n');
                    else if (typeof feature[key] === 'object') value = JSON.stringify(feature[key]);
                    else value = feature[key];
                    // procesamiento cadenas
                    if (typeof value === 'string' || value instanceof String) value = '"' + value.replace('"', '""') + '"';
                    // devuelvo
                    return value;
                });
            });
            // Combine the header and rows into a single CSV string
            output = [
                header.join(',')
            ].concat(rows.map((row)=>row.join(','))).join('\n');
            break;
        case 'KML':
            output = `<?xml version="1.0" encoding="UTF-8"?>
<kml xmlns="http://www.opengis.net/kml/2.2">
  <Document>`;
            for (const feat of allAnss){
                // Extract relevant properties from each feature
                const { id: id, treeId: treeId, latWGS84: latWGS84, lngWGS84: lngWGS84, creator: creator, created: created, type: type, primary: primary, value: value } = feat;
                // preparo extendedData de las cosas opcionales
                const extendedData = [];
                if (creator && creator.id) extendedData.push(`        <Data name="creator.id"><value>${creator.id}</value></Data>`);
                if (creator && creator.nick) extendedData.push(`        <Data name="creator.nick"><value>${creator.nick}</value></Data>`);
                if (created) extendedData.push(`        <Data name="created"><value>${created}</value></Data>`);
                if (value.latWGS84) extendedData.push(`        <Data name="value.latWGS84"><value>${value.latWGS84}</value></Data>`);
                if (value.lngWGS84) extendedData.push(`        <Data name="value.lngWGS84"><value>${value.lngWGS84}</value></Data>`);
                if (value.ts) extendedData.push(`        <Data name="value.ts"><value>${value.ts}</value></Data>`);
                if (value.id) extendedData.push(`        <Data name="value.id"><value>${value.id}</value></Data>`);
                if (value.scientificName) extendedData.push(`        <Data name="value.scientificName"><value>${value.scientificName}</value></Data>`);
                if (value.dbhMillimeters) extendedData.push(`        <Data name="value.dbhMillimeters"><value>${value.dbhMillimeters}</value></Data>`);
                if (value.heightMeters) extendedData.push(`        <Data name="value.heightMeters"><value>${value.heightMeters}</value></Data>`);
                if (value.imageURL) extendedData.push(`        <Data name="value.imageURL"><value>${value.imageURL}</value></Data>`);
                if (value.plantPart) extendedData.push(`        <Data name="value.plantPart"><value>${value.plantPart}</value></Data>`);
                if (value.text) extendedData.push(`        <Data name="value.text"><value>${value.text}</value></Data>`);
                // Generate the Placemark element for each feature
                const placemark = `
    <Placemark>
      <Point>
        <coordinates>${lngWGS84},${latWGS84}</coordinates>
      </Point>
      <ExtendedData>
        <Data name="id"><value>${id}</value></Data>
        <Data name="treeId"><value>${treeId}</value></Data>
        <Data name="type"><value>${type}</value></Data>
${extendedData.join('\n')}
      </ExtendedData>
    </Placemark>`;
                output += placemark;
            }
            output += `
  </Document>
</kml>`;
            break;
    }
    return output;
}
function $f3cfa07bad7ee5f4$var$formatearArbolesClusters(arbcls, format) {
    let output;
    switch(format){
        case 'GeoJSON':
            const features = [];
            for (const feat of arbcls){
                // Extract relevant properties from each feature
                const { id: id, type: type, latWGS84: latWGS84, lngWGS84: lngWGS84, nick: nick, taxon: taxon, clusterValue: clusterValue, creator: creator, created: created, heightMeters: heightMeters, dbhMillimeters: dbhMillimeters, treeStatus: treeStatus, photos: photos, observations: observations } = feat;
                // Create a GeoJSON feature object
                const feature = {
                    type: 'Feature',
                    geometry: {
                        type: 'Point',
                        coordinates: [
                            lngWGS84,
                            latWGS84
                        ] // [longitude, latitude]
                    },
                    properties: {
                        id: id,
                        type: type,
                        clusterValue: clusterValue,
                        nick: nick,
                        taxon: taxon,
                        creator: creator,
                        created: created,
                        heightMeters: heightMeters,
                        dbhMillimeters: dbhMillimeters,
                        treeStatus: treeStatus,
                        observations: observations,
                        photos: photos
                    }
                };
                features.push(feature);
            }
            // Create the GeoJSON object
            const geoJSON = {
                type: 'FeatureCollection',
                features: features
            };
            output = JSON.stringify(geoJSON, null, 2);
            break;
        case 'CSV':
            // Extract the keys from the first tree object to create the CSV header
            const header = [
                "id",
                "type",
                "latWGS84",
                "lngWGS84",
                "nick",
                "taxon.id",
                "taxon.scientificName",
                "clusterValue",
                "creator.id",
                "creator.nick",
                "created",
                "heightMeters",
                "dbhMillimeters",
                "treeStatus",
                "observations",
                "photos"
            ];
            // Generate the CSV rows
            // feb-2024 rehago para tratar las cadenas incluyendo "" y para escapar las "
            const rows = Object.values(arbcls).map((feature)=>{
                return header.map((key)=>{
                    let value = undefined;
                    if (key.indexOf(".") !== -1) {
                        // caso anidado, extraigo las dos claves
                        const subkeys = key.split(".");
                        if (feature[subkeys[0]] && feature[subkeys[0]][subkeys[1]]) value = feature[subkeys[0]][subkeys[1]];
                    // en otro caso no está definido
                    } else if (Array.isArray(feature[key])) value = feature[key].join('\n');
                    else if (typeof feature[key] === 'object') value = JSON.stringify(feature[key]);
                    else value = feature[key];
                    // procesamiento cadenas
                    if (typeof value === 'string' || value instanceof String) value = '"' + value.replace('"', '""') + '"';
                    // devuelvo
                    return value;
                });
            });
            // Combine the header and rows into a single CSV string
            output = [
                header.join(',')
            ].concat(rows.map((row)=>row.join(','))).join('\n');
            break;
        case 'KML':
            output = `<?xml version="1.0" encoding="UTF-8"?>
<kml xmlns="http://www.opengis.net/kml/2.2">
  <Document>`;
            for (const feat of arbcls){
                // Extract relevant properties from each feature
                const { id: id, type: type, latWGS84: latWGS84, lngWGS84: lngWGS84, nick: nick, taxon: taxon, clusterValue: clusterValue, creator: creator, created: created, heightMeters: heightMeters, dbhMillimeters: dbhMillimeters, treeStatus: treeStatus, photos: photos, observations: observations } = feat;
                // preparo extendedData de las cosas opcionales
                const extendedData = [];
                if (nick) extendedData.push(`        <Data name="nick"><value>${nick}</value></Data>`);
                if (taxon && taxon.id) extendedData.push(`        <Data name="taxon.id"><value>${taxon.id}</value></Data>`);
                if (taxon && taxon.scientificName) extendedData.push(`        <Data name="taxon.scientificName"><value>${taxon.scientificName}</value></Data>`);
                if (clusterValue) extendedData.push(`        <Data name="clusterValue"><value>${clusterValue}</value></Data>`);
                if (creator && creator.id) extendedData.push(`        <Data name="creator.id"><value>${creator.id}</value></Data>`);
                if (creator && creator.nick) extendedData.push(`        <Data name="creator.nick"><value>${creator.nick}</value></Data>`);
                if (created) extendedData.push(`        <Data name="created"><value>${created}</value></Data>`);
                if (heightMeters) extendedData.push(`        <Data name="heightMeters"><value>${heightMeters}</value></Data>`);
                if (dbhMillimeters) extendedData.push(`        <Data name="dbhMillimeters"><value>${dbhMillimeters}</value></Data>`);
                if (treeStatus) extendedData.push(`        <Data name="treeStatus"><value>${treeStatus}</value></Data>`);
                if (observations) extendedData.push(`        <Data name="observations"><value>${Array.isArray(observations) ? observations.join('; ') : observations}</value></Data>`);
                if (photos) extendedData.push(`        <Data name="photos"><value>${Array.isArray(photos) ? photos.join('; ') : photos}</value></Data>`);
                // Generate the Placemark element for each feature
                const placemark = `
    <Placemark>
      <Point>
        <coordinates>${lngWGS84},${latWGS84}</coordinates>
      </Point>
      <ExtendedData>
        <Data name="id"><value>${id}</value></Data>
        <Data name="type"><value>${type}</value></Data>
${extendedData.join('\n')}
      </ExtendedData>
    </Placemark>`;
                output += placemark;
            }
            output += `
  </Document>
</kml>`;
            break;
    }
    return output;
}
function $f3cfa07bad7ee5f4$var$pintarBarraProgresoDescarga(mostrar) {
    // variante sin JQuery para que vaya más rápida la actualización de la barra
    const mibarradiv = document.getElementById('mibarradescarga_div');
    if (mostrar) {
        // obtengo celdas completadas
        const celdascomp = (0, $2q7Wm.default).reduce((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.finalizadas, function(memo, num) {
            return memo + num;
        }, 0);
        // calculo porc (hasta 99)
        const porc = Math.floor(99 * celdascomp / (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.total);
        // ajusto barra
        let mibarra = document.getElementById('mibarradescarga');
        mibarradiv.setAttribute('aria-valuenow', porc);
        mibarra.style.width = porc + '%';
        mibarra.innerHTML = porc + '%';
        // muestro la barra de progreso
        mibarradiv.classList.remove('d-none');
    } else mibarradiv.classList.add('d-none');
}



let $c853be3628706c6e$var$drawControl;
// PANEL DE CONTROL
function $c853be3628706c6e$export$4412c4bf37c8e3a8() {
    // creo div con clase "usuario" sólo para dispositivos grandes
    const panuser = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).control({
        'position': 'topright'
    });
    panuser.onAdd = function(map) {
        // creo div con clase "usuario"	
        const container = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create('div', 'usuario me-2 mt-2 d-none d-sm-block'); // versión 5.3 bootstrap
        return container;
    };
    panuser.addTo((0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee));
    //  panel de control de info
    let panelInfo = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).control({
        'position': 'topleft'
    });
    panelInfo.onAdd = function(map) {
        // creo div con clase "card" de bootstrap
        this._div = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create('div', 'card ms-1 ms-sm-2 mt-1 mt-sm-2'); // versión 5.3 bootstrap
        return this._div;
    };
    panelInfo.init = function() {
        // inicializo el panel detectando si es móvil para poner padding
        // no consigo ajustar el padding por defecto, así que uso Mustache
        const obj = {
            esmovil: screen.width < 576,
            nomci: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).nomci
        };
        const cardhtml = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$f3d44414f0a0d0b1), obj);
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".card").html(cardhtml);
        // pongo nombres localizados a los colores al filtro de taxón
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('.dropdown_color_taxon').each(function() {
            let cind = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).attr('cind');
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports)))["color" + cind]));
        });
        // pongo color al filtro de taxón
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#filtro_taxon').css('background-color', (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).colores[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txcolor][1]);
        // quitar filtro de taxón
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#bot_quitar_taxon").click(function() {
            // mando evento de quitar filtro de taxón a GA (sólo si hay filtro activo)
            if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon) (0, $067277e156f7a571$export$7329bcdc3edcd90e)('select_content', {
                content_type: 'remove_taxon_filter',
                content_id: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon
            });
            // elimino el taxón en la sesión y reajusto URL
            delete (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon;
            history.replaceState((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado, "", (0, $ffd94e1d81f19b1c$export$e5c8c113a1c69275)());
            // cargo la URL
            (0, $ffd94e1d81f19b1c$export$db4341b92d8f97b0)();
        });
        // handler del nombre científico
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".nomci").change((0, $1ee989753a15371d$export$d67e2296dd6db17d));
        // handler del popover taxón
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#bot_info_filtro_taxon").click((0, $1ee989753a15371d$export$2c4bbd56989782d8));
        // cambio color del filtro de taxón
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".dropdown_color_taxon").click(function() {
            // actualizo el color
            (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txcolor = Number((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).attr("cind"));
            // cambio el color del filtro de taxón
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#filtro_taxon').css('background-color', (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).colores[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txcolor][1]);
            // actualizo iconos de los árboles pintados
            const arburis = Object.keys((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados);
            for (let arburi of arburis){
                // recupero el árbol
                const arb = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[arburi];
                // obtengo su icono
                const ticon = (0, $7b115b3c2cee4b53$export$6274df672a45c12d)(arb);
                // cambio el icono si no coincide
                if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados[arburi].getIcon() != ticon) (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados[arburi].setIcon(ticon);
            }
        });
        // detecto cambios en la entrada de lugares
        // "search" es para detectar si el usuario hizo click en la X del formulario (clear button)
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#in_lugares").on("keyup search", async function(e) {
            // trato las teclas de arriba, abajo y enter			
            if (e.which == 13) // sólo actúo si hay al menos una sugerencia (y habilitada)
            {
                if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugelugares").children(":enabled").length > 0) {
                    // si no había ninguna sugerencia seleccionada activo la primera
                    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarfocus == -1) {
                        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarfocus = 0;
                        (0, $d1e0875cf0f68e21$export$41334320f2c99869)();
                    }
                    // y ahora vamos al lugar seleccionado
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugelugares").children(":enabled").eq((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarfocus).click();
                }
            } else if (e.which == 40) {
                // incremento focus
                (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarfocus++;
                (0, $d1e0875cf0f68e21$export$41334320f2c99869)();
            } else if (e.which == 38) {
                // decremento focus
                (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarfocus--;
                (0, $d1e0875cf0f68e21$export$41334320f2c99869)();
            } else if (e.which != undefined) {
                // si había marcador de municipio, lo quito
                if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarmarker != null) {
                    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarmarker.remove();
                    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarmarker = null;
                    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugar = null;
                }
                // actúo según la entrada
                let entrada = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).val();
                if (entrada.length == 0) {
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugelugares").html("");
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugelugares").addClass("d-none");
                } else {
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugelugares").removeClass("d-none");
                    const sugs = await (0, $d1e0875cf0f68e21$export$a80214d90d6317cd)(entrada);
                    (0, $d1e0875cf0f68e21$export$49f32269b97f95f9)(sugs);
                    // mando evento GA si la entrada > 2
                    if (entrada.length > 2) (0, $067277e156f7a571$export$7329bcdc3edcd90e)('search', {
                        search_term: entrada,
                        content_type: "places"
                    });
                }
            } else {
                // caso de la X del formulario... (quito las sugerencias y el marcador si lo hay)
                let entrada = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).val();
                if (entrada.length == 0) {
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugelugares").html("");
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugelugares").addClass("d-none");
                    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarmarker != null) {
                        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarmarker.remove();
                        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarmarker = null;
                        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugar = null;
                    }
                }
            }
        }).focusin(function() {
            // vuelve el focus, muestro las sugerencias si hay algo
            let entrada = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).val();
            if (entrada.length > 0) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugelugares").removeClass("d-none");
        }).focusout(function() {
            // si pierde el focus escondemos las sugerencias tras un delay
            // el delay es importante para que se pueda clickar un botón antes de eliminar las sugerencias
            setTimeout(function() {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#in_lugares").is(":focus")) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugelugares").addClass("d-none");
            }, 300);
        });
        // handler de taxón
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#bot_taxones").click((0, $1ee989753a15371d$export$79e952b071e79fc8));
    };
    // incluyo el panel en el mapa
    panelInfo.addTo((0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee));
    // si es terminal táctil desactivo los eventos de dragging del mapa en el panel del formulario
    if ('ontouchstart' in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0) {
        panelInfo.getContainer().addEventListener('touchstart', function() {
            (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).dragging.disable();
        });
        panelInfo.getContainer().addEventListener('touchend', function() {
            (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).dragging.enable();
        });
    } else {
        // Disable dragging, scrollWheelZoom and doubleClickZoom when user's cursor enters the element
        panelInfo.getContainer().addEventListener('mouseover', function() {
            (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).dragging.disable();
            (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).scrollWheelZoom.disable();
            (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).doubleClickZoom.disable();
        });
        // Re-enable dragging, scrollWheelZoom and doubleClickZoom when user's cursor leaves the element
        panelInfo.getContainer().addEventListener('mouseout', function() {
            (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).dragging.enable();
            (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).scrollWheelZoom.enable();
            (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).doubleClickZoom.enable();
        });
    }
    // inicializo panel
    panelInfo.init();
}
function $c853be3628706c6e$export$a54a51eb35d48691(mm, mapas, tilelayers, volverMapa) {
    const controlBotones = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Control.extend({
        options: {
            position: 'bottomright'
        },
        onAdd: function(map) {
            // preparo botonera vertical
            const container = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create('div', "leaflet-bar leaflet-control btn-group-vertical");
            container.setAttribute("role", "group");
            // link esri
            const le = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("a", "leaflet-bar-part leaflet-bar-part-single esri", container);
            le.title = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).esri);
            le.href = "#";
            le.setAttribute("role", "button");
            const les = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create('span', 'bi bi-layers-fill', le);
            if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.esri) {
                le.setAttribute("style", "background-color: #6c757d;");
                les.setAttribute("style", "color: white;");
            }
            // listener esri
            le.addEventListener('click', function(e) {
                event.preventDefault(); // Prevent the default behavior of the hyperlink
                // actualizo Sesion.estado.esri y reajusto URL
                (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.esri = !(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.esri;
                history.replaceState((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado, "", (0, $ffd94e1d81f19b1c$export$e5c8c113a1c69275)());
                // actualizo mapas y tilelayers con URL y atribución
                const { url: url, opts: opts } = (0, $69f04ba581843b2d$export$c1c1414601191e71)(true);
                for (let tl of tilelayers)tl.setUrl(url);
                for (let ma of mapas){
                    ma.attributionControl.removeAttribution((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).geoConfigs.esriMap.options.attribution);
                    ma.attributionControl.removeAttribution((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).geoConfigs.osmMap.options.attribution);
                    ma.attributionControl.addAttribution(opts.attribution);
                }
                // actualizo aspecto botón y mando evento de esri a GA
                if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.esri) {
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".esri").attr("style", "background-color: #6c757d;");
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".esri span").attr("style", "color: white;");
                    (0, $067277e156f7a571$export$7329bcdc3edcd90e)('select_content', {
                        content_type: 'show_esri'
                    });
                } else {
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".esri").removeAttr("style");
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".esri span").removeAttr("style");
                    (0, $067277e156f7a571$export$7329bcdc3edcd90e)('select_content', {
                        content_type: 'show_osm'
                    });
                }
            });
            if (volverMapa) {
                // link volver mapa
                const lm = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("a", "leaflet-bar-part leaflet-bar-part-single", container);
                lm.title = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).fullmap);
                lm.href = "#";
                lm.setAttribute("role", "button");
                (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create('span', 'bi bi-fullscreen', lm);
                // listener volver mapa
                lm.addEventListener('click', function(e) {
                    event.preventDefault(); // Prevent the default behavior of the hyperlink
                    // actualizo path
                    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.path = "map";
                    // reajusto url y creo nueva página en la historia
                    history.pushState((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado, "", (0, $ffd94e1d81f19b1c$export$e5c8c113a1c69275)());
                    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).npags++; // una página más
                    // cargoURL => me llevará a verLasttrees
                    (0, $ffd94e1d81f19b1c$export$db4341b92d8f97b0)();
                });
            }
            return container;
        }
    });
    mm.addControl(new controlBotones());
}
// IDIOMA
function $c853be3628706c6e$export$789fff39a6a81ff3() {
    // actualizo etiquetas panel mapa
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#tarjeta-home").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).home));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#tarjeta-lasttrees").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).lastTrees));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#bot_taxones").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).taxonfilter));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#in_lugares").attr("placeholder", (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).searchplace));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#in_lugares").attr("aria-label", (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).searchplace));
    // cierro bot_taxones e inicializo a "" el navegador de taxones
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#bot_taxones").hasClass("active")) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#bot_taxones").click();
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#taxones_block").html("");
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#taxones_block").addClass("d-none");
    // actualizo botones usuario mapa
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".userprofile").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).viewProfile));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".usersignout").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).signout));
    // actualización tooltips panel lateral
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".createtree").attr("title", (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).createtree));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".verifn").attr("title", (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).viewIFN));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".esri").attr("title", (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).esri));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".refresh").attr("title", (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).refresh));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".download").attr("title", (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).downloadData));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".tour").attr("title", (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tour));
    // actualizamos etiquetas Leaflet Draw
    $c853be3628706c6e$var$actualizarEtiquetasLDraw();
}
var $551a5a55a87c7921$exports = {};
$551a5a55a87c7921$exports = import.meta.resolve("9RYvx");


var $6a604c9667341801$exports = {};
$6a604c9667341801$exports = import.meta.resolve("enTFY");


// BOTONES LATERALES MAPA
function $c853be3628706c6e$export$9e6c68482d899bf0() {
    // preparo botón de descarga con Leaflet Draw
    (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).editableLayer = new (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).FeatureGroup();
    (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).addLayer((0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).editableLayer);
    const ldo = {
        position: 'bottomright',
        draw: {
            polyline: false,
            polygon: {
                allowIntersection: false,
                drawError: {
                    //color: '#e1e100', // Color the shape will turn when intersects
                    message: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).errorPolygon)
                },
                shapeOptions: {
                }
            },
            circle: false,
            rectangle: false,
            marker: false,
            circlemarker: false
        },
        edit: false
    };
    $c853be3628706c6e$var$drawControl = new (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Control.Draw(ldo);
    (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).addControl($c853be3628706c6e$var$drawControl);
    (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).on((0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Draw.Event.CREATED, function(e) {
        // actualizo flag
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).poligonero = false;
        // actualizo aspecto botón (sin pulsar)
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".download").removeAttr("style");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".download span").removeAttr("style");
        // añado el polígono a la capa editable
        (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).editableLayer.addLayer(e.layer);
        // desde aquí llamo a la descarga de datos
        (0, $f3cfa07bad7ee5f4$export$6bf11ff3cfb953a7)();
    });
    // cambio icono polígono
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".leaflet-draw-draw-polygon").html('<span class="bi bi-cloud-download"></span>');
    // añado clase inicial "download"
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".leaflet-draw-draw-polygon").addClass("download");
    // llamo a actualizar las etiquetas de Leaflet Draw
    $c853be3628706c6e$var$actualizarEtiquetasLDraw();
    // listener botón
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".download").on('click', function(e) {
        // cojo ref al botón de cancelar
        //let cancelAnchor = $('ul.leaflet-draw-actions').find('li:eq(2) a');	
        let cancelAnchor = document.querySelector('ul.leaflet-draw-actions').querySelector('li:nth-child(3) a');
        // cambio el flag de poligonero
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).poligonero = !(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).poligonero;
        if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).poligonero) {
            // muestro tostada
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mitostadaBody").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).toastDownloadPolygon));
            const tostada = (0, (/*@__PURE__*/$parcel$interopDefault($dktVJ))).Toast.getOrCreateInstance(document.getElementById('mitostada'));
            tostada.show();
            // actualizo aspecto botón (pulsado)
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".download").attr("style", "background-color: #6c757d;");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".download span").attr("style", "color: white;");
            // pongo listener para que quede bien el flag de poligonero
            cancelAnchor.addEventListener('click', function(event1) {
                (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).poligonero = false;
                // actualizo aspecto botón (sin pulsar)
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".download").removeAttr("style");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".download span").removeAttr("style");
            });
        } else cancelAnchor.click();
    });
    // BOTONERA (sin download)
    const controlBotones = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Control.extend({
        options: {
            position: 'bottomright'
        },
        onAdd: function(map) {
            // preparo botonera vertical
            const container = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create('div', "leaflet-bar leaflet-control btn-group-vertical");
            container.setAttribute("role", "group");
            // link arbol
            const la = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("a", "leaflet-bar-part leaflet-bar-part-single createtree disabled", container);
            la.title = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).createtree);
            la.href = "#";
            la.setAttribute("role", "button");
            (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create('span', 'bi bi-tree-fill', la);
            // link IFN
            const li = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("a", "leaflet-bar-part leaflet-bar-part-single verifn", container);
            li.title = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).viewIFN);
            li.href = "#";
            li.setAttribute("role", "button");
            const licon = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create('img', '', li);
            if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.ifn) {
                li.setAttribute("style", "background-color: #6c757d;");
                licon.setAttribute("src", new URL($551a5a55a87c7921$exports));
            //licon.setAttribute("src", "/app/images/iconoIFNpushed.svg");
            } else licon.setAttribute("src", new URL($6a604c9667341801$exports));
            //licon.setAttribute("src", "/app/images/iconoIFN.svg");
            // link esri
            const le = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("a", "leaflet-bar-part leaflet-bar-part-single esri", container);
            le.title = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).esri);
            le.href = "#";
            le.setAttribute("role", "button");
            const les = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create('span', 'bi bi-layers-fill', le);
            if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.esri) {
                le.setAttribute("style", "background-color: #6c757d;");
                les.setAttribute("style", "color: white;");
            }
            // link refresh
            const lr = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("a", "leaflet-bar-part leaflet-bar-part-single refresh", container);
            lr.title = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).refresh);
            lr.href = "#";
            lr.setAttribute("role", "button");
            (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create('span', 'bi bi-arrow-clockwise', lr);
            // link tour
            const lt = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("a", "leaflet-bar-part leaflet-bar-part-single tour", container);
            lt.title = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tour);
            lt.href = "#";
            lt.setAttribute("role", "button");
            (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create('span', 'bi bi-question-lg', lt);
            // listener árbol
            la.addEventListener('click', function(e) {
                event.preventDefault(); // Prevent the default behavior of the hyperlink
                // si está deshabilitado muestro tostada
                if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('.createtree:first').hasClass("disabled")) {
                    const mensaje = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario ? (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).toastZoom) : (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).toastUser);
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mitostadaBody").html(mensaje);
                    const tostada = (0, (/*@__PURE__*/$parcel$interopDefault($dktVJ))).Toast.getOrCreateInstance(document.getElementById('mitostada'));
                    tostada.show();
                } else {
                    // cambio flag
                    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).creandoArbol = !(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).creandoArbol;
                    // tostada de ayuda si estoy creando
                    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).creandoArbol) {
                        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mitostadaBody").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).toastCreateTree));
                        const tostada = (0, (/*@__PURE__*/$parcel$interopDefault($dktVJ))).Toast.getOrCreateInstance(document.getElementById('mitostada'));
                        tostada.show();
                    }
                    // llamo a renderAjustesCreacionArbolMapa
                    (0, $3a9989d46007ef73$export$7c626a07c7c69914)(true);
                }
            });
            // listener ifn
            li.addEventListener('click', function(e) {
                event.preventDefault(); // Prevent the default behavior of the hyperlink
                // actualizo Sesion.estado.ifn y reajusto URL
                (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.ifn = !(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.ifn;
                history.replaceState((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado, "", (0, $ffd94e1d81f19b1c$export$e5c8c113a1c69275)());
                // llamo a actualizar la info del IFN
                $c853be3628706c6e$export$87931b6598ef9316();
            });
            // listener esri
            le.addEventListener('click', function(e) {
                event.preventDefault(); // Prevent the default behavior of the hyperlink
                // actualizo Sesion.estado.esri y reajusto URL
                (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.esri = !(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.esri;
                history.replaceState((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado, "", (0, $ffd94e1d81f19b1c$export$e5c8c113a1c69275)());
                // llamo a actualizar el mapa base
                $c853be3628706c6e$export$1319329b668abb17();
            });
            // listener refresh
            lr.addEventListener('click', function(e) {
                event.preventDefault(); // Prevent the default behavior of the hyperlink
                // borro datos
                // sólo me quedo con el usuario de la sesión
                if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario) {
                    const dus = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid];
                    (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios = {};
                    (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid] = dus;
                } else (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios = {};
                // fuera taxones
                (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies = {};
                // fuera educatrees
                (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees = {};
                // sólo me quedo con los árboles del ifn (con 'uri' en vez de 'iri')
                (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles = Object.fromEntries(Object.entries((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles).filter(([key, value])=>'uri' in value));
                // fuera últimos educatrees y últimas anotaciones (salvo los del usuario)
                if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario) {
                    const uetus = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid];
                    (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees = {};
                    (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid] = uetus;
                    const uanus = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid];
                    (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones = {};
                    (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid] = uanus;
                } else {
                    (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees = {};
                    (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones = {};
                }
                // elimino datos de educatrees de las celdas				
                for(const key in (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles)delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[key].edu;
                // borro clusters y árboles
                (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).arbs.clearLayers(); // quito marcadores árboles
                (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).clarbs.clearLayers(); // quito marcadores clusters
                (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).celdasPintadas = {}; // ninguna celda pintada
                (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados = {}; // ningún marcador de árbol				
                // desactivo temporalmente el botón de taxones
                if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#bot_taxones").hasClass("active")) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#bot_taxones").click();
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#bot_taxones").prop("disabled", true);
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#taxones_block").html(""); // y vacío para que repinte
                // espero a que cargue los taxones de nuevo
                (0, $174d363c054274ef$export$40a5140e3d2b7b8d)().then(()=>{
                    // habilito de nuevo el botón
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#bot_taxones").removeAttr('disabled');
                    // llamo a mover el mapa para que repinte
                    (0, $69f04ba581843b2d$export$c8207d40f45dcd81)();
                }).catch((error)=>console.error(error));
                // mando evento de refrescar mapa a GA
                (0, $067277e156f7a571$export$7329bcdc3edcd90e)('select_content', {
                    content_type: 'refresh_map'
                });
            });
            // listener tour
            lt.addEventListener('click', function(e) {
                (0, $2fa03f5d455d6f0a$export$cdda91dfb91997f3)();
            });
            return container;
        }
    });
    (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).addControl(new controlBotones());
}


// soporte IFN
function $c853be3628706c6e$export$87931b6598ef9316() {
    // borro clusters y árboles
    (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).arbs.clearLayers(); // quito marcadores árboles
    (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).clarbs.clearLayers(); // quito marcadores clusters
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).celdasPintadas = {}; // ninguna celda pintada
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados = {}; // ningún marcador de árbol				
    // llamo a mover el mapa para que repinte
    (0, $69f04ba581843b2d$export$c8207d40f45dcd81)();
    // actualizo aspecto botón y mando evento de IFN (show o hide) a GA
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.ifn) {
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".verifn").attr("style", "background-color: #6c757d;");
        //$(".verifn img").attr("src", "/app/images/iconoIFNpushed.svg");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".verifn img").attr("src", new URL($551a5a55a87c7921$exports));
        (0, $067277e156f7a571$export$7329bcdc3edcd90e)('select_content', {
            content_type: 'show_IFN'
        });
    } else {
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".verifn").removeAttr("style");
        //$(".verifn img").attr("src", "/app/images/iconoIFN.svg");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".verifn img").attr("src", new URL($6a604c9667341801$exports));
        (0, $067277e156f7a571$export$7329bcdc3edcd90e)('select_content', {
            content_type: 'hide_IFN'
        });
    }
}
// soporte mapa base
function $c853be3628706c6e$export$1319329b668abb17() {
    // actualizo Mitilelayer: URL y atribución
    const { url: url, opts: opts } = (0, $69f04ba581843b2d$export$c1c1414601191e71)(false);
    (0, $ffd94e1d81f19b1c$export$6573f87b6f05c3d2).setUrl(url);
    (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).attributionControl.removeAttribution((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).geoConfigs.esriMap.options.attribution);
    (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).attributionControl.removeAttribution((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).geoConfigs.osmMap.options.attribution);
    (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).attributionControl.addAttribution(opts.attribution);
    // actualizo aspecto botón y mando evento de IFN (show o hide) a GA
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.esri) {
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".esri").attr("style", "background-color: #6c757d;");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".esri span").attr("style", "color: white;");
        (0, $067277e156f7a571$export$7329bcdc3edcd90e)('select_content', {
            content_type: 'show_esri'
        });
    } else {
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".esri").removeAttr("style");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".esri span").removeAttr("style");
        (0, $067277e156f7a571$export$7329bcdc3edcd90e)('select_content', {
            content_type: 'show_osm'
        });
    }
}
// etiquetas Leaflet.Draw
function $c853be3628706c6e$var$actualizarEtiquetasLDraw() {
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".leaflet-draw-draw-polygon").attr("title", (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).downloadData));
    (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).drawLocal.draw.toolbar.actions.text = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).cancel);
    (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).drawLocal.draw.toolbar.actions.title = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).cancelPolygon);
    (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).drawLocal.draw.toolbar.finish.text = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).finish);
    (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).drawLocal.draw.toolbar.finish.title = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).finishPolygon);
    (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).drawLocal.draw.toolbar.undo.text = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).deleteLastPoint);
    (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).drawLocal.draw.toolbar.undo.title = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).deleteLastPointDrawn);
    (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).drawLocal.draw.toolbar.buttons.polygon = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).downloadData);
    (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).drawLocal.draw.handlers.polygon.tooltip.start = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).startPolygon);
    (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).drawLocal.draw.handlers.polygon.tooltip.cont = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).contPolygon);
    (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).drawLocal.draw.handlers.polygon.tooltip.end = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).endPolygon);
    (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).drawLocal.draw.handlers.polyline.error = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).errorPolygon);
    $c853be3628706c6e$var$drawControl.options.draw.polygon.drawError.message = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).errorPolygon);
}








/////////////////////// 
// BOTÓN DE CREAR ÁRBOL
///////////////////////
let $3a9989d46007ef73$export$c37f872725571dfc, $3a9989d46007ef73$var$Minitilelayer;
// función clave para comprobar si se habilita el botón (si hay usuario logueado y suficiente zoom)
// y para hacer los ajustes en la vista del mapa
function $3a9989d46007ef73$export$7c626a07c7c69914(huboclick) {
    // 1) inicializo hayajuste a si hubo click en el botón (o undefined en caso contrario)
    let hayajuste = huboclick;
    // 2) detecto si hay que mostrar el botón de crear árbol o no
    const hayboton = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario && (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).getZoom() >= (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zCreacion;
    if (hayboton) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".createtree").removeClass("disabled"); //.removeClass("d-none");
    else (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".createtree").addClass("disabled"); //.addClass("d-none");
    // 3) si no hay botón y está en modo creando árbol, hay que cambiar de estado y hacer ajuste
    if (!hayboton && (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).creandoArbol) {
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).creandoArbol = false;
        hayajuste = true;
    }
    // 4) hago los ajustes si es necesario
    if (hayajuste) {
        // ajusto popups, tooltips y cursor en árboles pintados (autoajustado con Sesion.creandoArbol)
        for(const auri in (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados)(0, $82a71c896f160eac$export$1f29254b983d0b7)(auri);
        // ajusto handler click, tooltips y cursor en clusters
        (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).clarbs.eachLayer(function(cpint) {
            (0, $82a71c896f160eac$export$19f9855b4b37efc4)(cpint);
        });
        // si estamos en modo creación de árbol...
        if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).creandoArbol) {
            // estilo botón en modo edición	
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".createtree").attr("style", "background-color: #6c757d;");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".createtree span").attr("style", "color: white;");
            // estilo cursor creación árbol en mapa
            (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).getContainer().style.cursor = "crosshair";
            // pongo listener para capturar la posición y abrir una pantalla de creación de Educatree
            (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).on('click', $3a9989d46007ef73$var$onTreeCreationClick);
        } else {
            // estilo botón normal
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".createtree").removeAttr("style");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".createtree span").removeAttr("style");
            // estilo cursor normal
            (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).getContainer().style.cursor = "";
            // quito listener onTreeCreationClick
            (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).off('click', $3a9989d46007ef73$var$onTreeCreationClick);
        }
    }
}
//////////////////////////
// PANTALLA CREACIÓN ÁRBOL
//////////////////////////
function $3a9989d46007ef73$var$onTreeCreationClick(e) {
    // detecto si el click se hace en un control del mapa
    const target = e.originalEvent.target;
    const escontrol = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.hasClass(target, 'leaflet-control') || target.closest('.leaflet-control') !== null;
    // en tal caso, no hago nada
    if (escontrol) return;
    // The event object (e) contains information about the clicked location
    //console.warn('Clicked at ' + e.latlng);
    // desactivo modo edición en el mapa
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).creandoArbol = false;
    // llamo a renderAjustesCreacionArbolMapa para actualizar vista mapa grande
    $3a9989d46007ef73$export$7c626a07c7c69914(true);
    // actualizo estado con la posición y el path de creación de educatree
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat = e.latlng.lat;
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng = e.latlng.lng;
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.z = (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).getZoom();
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.path = "newtree";
    // reajusto url y creo nueva página en la historia
    history.pushState((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado, "", (0, $ffd94e1d81f19b1c$export$e5c8c113a1c69275)());
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).npags++; // una página más
    // cargoURL => me llevará a iniciarCreacionArbol
    (0, $ffd94e1d81f19b1c$export$db4341b92d8f97b0)();
}
function $3a9989d46007ef73$export$966d5c02a501e12b() {
    // cambio el zoom a 20 y reajusto la URL
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.z = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zMiniMapa;
    history.replaceState((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado, "", (0, $ffd94e1d81f19b1c$export$e5c8c113a1c69275)());
    // mando evento de creando árbol a GA
    (0, $067277e156f7a571$export$7329bcdc3edcd90e)('select_content', {
        content_type: 'create_tree_form',
        content_id: (0, $96abbdd7193a3c4b$export$4a32c72e9ff1d1e0)((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc)
    });
    console.info("Creando \xe1rbol en posici\xf3n: " + (0, $96abbdd7193a3c4b$export$4a32c72e9ff1d1e0)((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc));
    // llamo al render
    $3a9989d46007ef73$export$da02fee09afb84d();
}
async function $3a9989d46007ef73$export$da02fee09afb84d() {
    // 1) cargo formulario y realizo ajustes
    // preparo objeto plantilla
    const ocat = {
        usuario: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario != undefined,
        usuarioImg: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario ? (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.photoURL : null,
        esMovil: (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Browser.mobile,
        camera: localStorage.getItem('camera') === "false" ? false : true // por defecto true
    };
    const htmlcontent = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$f3dc3f942ad7cadb), ocat);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#miarbol").html(htmlcontent);
    // pongo listeners a clickViewprofile, clickSignin y clickSignout
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".userprofile").click((0, $c0304d280c7b00cb$export$f98b6673fafc0e20));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".usersignin").click((0, $c0304d280c7b00cb$export$9ffe63492d76c086));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".usersignout").click((0, $c0304d280c7b00cb$export$daa0a882204fd973));
    // ajusto crchecknomci 
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#crchecknomci").prop('checked', (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).nomci);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#crchecknomci").change((0, $1ee989753a15371d$export$d67e2296dd6db17d));
    // pongo etiqueta de posición
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#inputPosition").val((0, $96abbdd7193a3c4b$export$1690e12b840569b9)({
        latWGS84: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat,
        lngWGS84: (0, $69f04ba581843b2d$export$9f306b5167a85c73)((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng)
    }));
    // listener info de estado árbol
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botTreeStatusInfo").click($3a9989d46007ef73$export$4ee351339f0443f3);
    // cambio de diámetro a perímetro
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#checkPerimeter").change($3a9989d46007ef73$export$1db9de3e81675e92);
    // cambio de modo a cámara (sólo valdrá para móvil)
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#checkCamera").change($3a9989d46007ef73$export$cd64dd1ec39c266d);
    // quito el envío preventivo del formulario
    // esto es para evitar que envíe el formulario,
    // afecta al navegar por las sugerencias de taxones
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#createTreeForm").on('keypress', function(event) {
        if (event.keyCode == 13) event.preventDefault();
    });
    // listener de cambio de nick
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#inputTreeNick").change(function() {
        const treenick = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#inputTreeNick').val();
        // preinicializo
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").removeClass("d-none");
        if (!treenick) //console.log("No hay nada");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noNick));
        else if (treenick.length < 3) //console.log("Fuera de rango");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).nickTooshort));
        else if (treenick.length > 30) //console.log("Fuera de rango");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).nickToolong));
        else //console.log("Todo OK");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").addClass("d-none");
    });
    // listeners taxón
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#setTreeTaxonEd").click((0, $1ee989753a15371d$export$2d3916a1f0ae58c1));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#deleteTreeTaxon").click((0, $1ee989753a15371d$export$e644c8daeec4ef49));
    // cargo tipos de estado del árbol en #selectTreeStatus
    let testarb = [];
    for (const el of (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).estadoArboles)testarb.push({
        "iri": el.iri,
        "label": (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(el.label),
        "pref": el.pref
    });
    const htmltest = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$170c21d6f8f459cf), testarb);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#selectTreeStatus").html(htmltest);
    // listener de la foto => compresión en #resizedTreePhoto y muestro thumbnail
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treePhoto").change($3a9989d46007ef73$export$3a52a69d9f94a42b);
    // listener borrar foto (antes de subir a Firebase)
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#deleteTreePhoto").click($3a9989d46007ef73$export$e7db0c08a7276967);
    // cargo partes de árboles fotos en #selectTreePartPhoto
    let parbfotos = [];
    for(const paf in (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).partesPlantasFoto)parbfotos.push({
        "uri": paf,
        "label": (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).partesPlantasFoto[paf].label)
    });
    const htmlpaf = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$afb205d6a878a5e7), parbfotos);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#selectTreePartPhoto").html(htmlpaf);
    // botones finales
    // pongo listener del botón de crear árbol
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#createTreeButton").on("click", $3a9989d46007ef73$var$handlerCreateTree);
    // pongo listener del botón de volver
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#goBackButton").on("click", (0, $ffd94e1d81f19b1c$export$28fca2ccfd38b8f));
    // 2) cargo mapa
    // preparo primero los bounds para que no se vaya a Cuenca
    const offset = 0.0004; // 1km es aproximadamente 0,008 grados en WGS84
    const bounds = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).latLngBounds((0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).latLng((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat - offset, (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng - 3 * offset), (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).latLng((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat + offset, (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng + 3 * offset)); //northEast	
    // meto tap: false, que parece es una fuente de problemas
    // meto scrollWheelZoom: 'center' para que no dé saltos raros la diana al cambiar el zoom
    $3a9989d46007ef73$export$c37f872725571dfc = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).map('mapaedutree', {
        maxBounds: bounds,
        maxBoundsViscosity: 1.0,
        zoomControl: false,
        tap: false,
        scrollWheelZoom: 'center',
        preferCanvas: true
    }).setView([
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat,
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng
    ], (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zMiniMapa);
    // cargo el tile layer que corresponda
    const { url: url, opts: opts } = (0, $69f04ba581843b2d$export$c1c1414601191e71)(true);
    $3a9989d46007ef73$var$Minitilelayer = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).tileLayer(url, opts).addTo($3a9989d46007ef73$export$c37f872725571dfc);
    // muestro escala del mapa
    (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).control.scale({
        imperial: false,
        position: 'bottomright'
    }).addTo($3a9989d46007ef73$export$c37f872725571dfc); // sin la escala imperial
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Browser.mobile) (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).control.zoom({
        position: 'bottomright',
        zoomInTitle: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).zoomin),
        zoomOutTitle: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).zoomout)
    }).addTo($3a9989d46007ef73$export$c37f872725571dfc);
    // Disable dragging
    $3a9989d46007ef73$export$c37f872725571dfc.dragging.disable();
    // cargo botón esri
    (0, $c853be3628706c6e$export$a54a51eb35d48691)($3a9989d46007ef73$export$c37f872725571dfc, [
        $3a9989d46007ef73$export$c37f872725571dfc,
        (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee)
    ], [
        $3a9989d46007ef73$var$Minitilelayer,
        (0, $ffd94e1d81f19b1c$export$6573f87b6f05c3d2)
    ]);
    // 3) pido ifntrees y edutrees del mapa y pinto
    await $3a9989d46007ef73$export$d3be837b79c08382($3a9989d46007ef73$export$c37f872725571dfc, bounds);
    // 4) al acabar quito el overlay con el que escondía el mapa, pongo la pista y habilito el dragging
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#overlay").addClass('d-none');
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mapclue").removeClass('d-none');
    $3a9989d46007ef73$export$c37f872725571dfc.dragging.enable();
    // 5) pinto marcador de diana
    const diana = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).marker([
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat,
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng
    ], {
        icon: (0, $7b115b3c2cee4b53$export$757419e715bb5039)(),
        zIndexOffset: 100
    }).addTo($3a9989d46007ef73$export$c37f872725571dfc);
    // 6) detecto eventos "move" y ajusto la diana	
    $3a9989d46007ef73$export$c37f872725571dfc.on('move', function(event) {
        const center = $3a9989d46007ef73$export$c37f872725571dfc.getCenter(); // Get the new center position of the map
        diana.setLatLng(center); // Set the marker position to the new center
    });
    // como hay muchos eventos 'move', actualizo cosas sólo con 'moveend'
    $3a9989d46007ef73$export$c37f872725571dfc.on('moveend', function(event) {
        const center = $3a9989d46007ef73$export$c37f872725571dfc.getCenter(); // Get the new center position of the map
        diana.setLatLng(center); // Set the marker position to the new center
        // ajusto localización en el estado de la sesión
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat = center.lat;
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng = center.lng;
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.z = $3a9989d46007ef73$export$c37f872725571dfc.getZoom();
        // ajusto texto
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#inputPosition").val((0, $96abbdd7193a3c4b$export$1690e12b840569b9)({
            latWGS84: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat,
            lngWGS84: (0, $69f04ba581843b2d$export$9f306b5167a85c73)((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng)
        }));
        // reajusto también la URL
        history.replaceState((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado, "", (0, $ffd94e1d81f19b1c$export$e5c8c113a1c69275)());
    });
}
function $3a9989d46007ef73$export$3a52a69d9f94a42b() {
    // recupero fichero
    const file = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).prop('files')[0];
    //console.log(file);	
    if (file) {
        // muestro botón de borrar foto
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#deleteTreePhoto").removeClass("d-none");
        // preparo imagen a diferente resolución con thumbnail
        const image = new Image();
        image.onload = function() {
            // creo una imagen png de 400 píxeles de ancho, misma relación de aspecto y resolución 0.5 
            const aspectRatio = image.height / image.width;
            const canvas = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('<canvas>')[0];
            canvas.width = image.width < 400 ? image.width : 400;
            canvas.height = canvas.width * aspectRatio;
            const context = canvas.getContext('2d');
            context.drawImage(image, 0, 0, canvas.width, canvas.height);
            const dataUrl = canvas.toDataURL("image/png", 0.5);
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#resizedTreePhoto").val(dataUrl);
            // actualizo mensaje imagen
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#textTreePhoto").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).photouploaded));
            // muestro #selectTreePartPhoto
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#selectTreePartPhoto").removeClass("d-none");
            // muestro thumbnail a partir de la imagen redimensionada creada
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treeThumbnail").removeClass("d-none");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treeThumbnail").attr('src', dataUrl);
        };
        const reader = new FileReader();
        reader.onload = function(event) {
            image.src = event.target.result;
        };
        reader.readAsDataURL(file);
        // actualización estado anotación		
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botcreatemodalannotation").prop("disabled", false);
    } else $3a9989d46007ef73$export$e7db0c08a7276967();
}
function $3a9989d46007ef73$export$e7db0c08a7276967() {
    // elimino entrada foto
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treePhoto").val('');
    // eliminado entrada foto redimensionada
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#resizedTreePhoto").val('');
    // actualizo mensaje imagen y escondo thumbnail y selectTreePartPhoto
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#textTreePhoto").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).nophoto));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treeThumbnail").addClass("d-none");
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#selectTreePartPhoto").addClass("d-none");
    // escondo botón borrar foto
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#deleteTreePhoto").addClass("d-none");
    // actualización estado anotación 
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botcreatemodalannotation").prop("disabled", true);
}
var $097fc50803730fd9$exports = {};
$097fc50803730fd9$exports = import.meta.resolve("5EqOX");


var $3d2f84f33d45afcf$exports = {};
$3d2f84f33d45afcf$exports = import.meta.resolve("3OE9u");


// preparo contenido modal botón ayuda
function $3a9989d46007ef73$export$4ee351339f0443f3() {
    // preparo contenido modal
    let tit = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treeStatus);
    //let hmtlcontent = '<img class="img-fluid" src="'+getLiteral(dict.treeStatusFile)+'">';	
    let hmtlcontent = '<img id="imgTreeStatusInfo" class="img-fluid" src="">';
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        vertcent: true,
        nofooter: true
    }, tit, hmtlcontent, null);
    // muestro modal
    const mimodal = new (0, (/*@__PURE__*/$parcel$interopDefault($dktVJ))).Modal(document.getElementById('mimodal'));
    mimodal.show();
    if ((0, $96abbdd7193a3c4b$export$350964a2fface462)() === "es") (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#imgTreeStatusInfo").attr("src", new URL($097fc50803730fd9$exports));
    else (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#imgTreeStatusInfo").attr("src", new URL($3d2f84f33d45afcf$exports));
}
// reajuste de diámetro a perímetro y viceversa
function $3a9989d46007ef73$export$1db9de3e81675e92() {
    // recupero el valor
    const valor = Number((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#treeDiameter').val());
    // reajusto según el modo
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#checkPerimeter").prop("checked")) {
        //console.log("CAMBIO A PERÍMETRO");
        // cambio a perímetro
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#labelTreeDiameter").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).perimetermm));
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treeDiameter").prop('placeholder', (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).enterperimetermm));
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treeDiameter").prop('max', (20000 * Math.PI).toFixed(0));
        if (valor) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treeDiameter").val((valor * Math.PI).toFixed(0));
    } else {
        //console.log("CAMBIO A DIÁMETRO");
        // cambio a diámetro
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#labelTreeDiameter").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).diametermm));
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treeDiameter").prop('placeholder', (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).enterdiametermm));
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treeDiameter").prop('max', 20000);
        if (valor) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treeDiameter").val((valor / Math.PI).toFixed(0));
    }
}
// reajuste modo cámara
function $3a9989d46007ef73$export$cd64dd1ec39c266d() {
    // reajusto según el modo
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#checkCamera").prop("checked")) {
        // ajusto localStorage
        localStorage.setItem('camera', 'true');
        // atributo capture a "environment"
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treePhoto").attr('capture', 'environment');
    } else {
        // ajusto localStorage
        localStorage.setItem('camera', 'false');
        // borro atributo capture
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treePhoto").removeAttr('capture');
    }
}
var $131d857d425836ee$exports = {};
$131d857d425836ee$exports = import.meta.resolve("11BTJ");


/////////////////////////////
// CREO ÁRBOL CON LO QUE HAYA
/////////////////////////////
async function $3a9989d46007ef73$var$handlerCreateTree(e) {
    if (e != undefined) {
        // Consume the click event
        e.preventDefault(); // Prevents the default behavior of the click event
        e.stopPropagation(); // Stops the propagation of the click event
    }
    // 1) pongo el modal: estático, con spinner y sin footer
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        static: true,
        vertcent: true,
        spinner: true,
        spinnerMessage: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).pleasewait),
        nofooter: true
    }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).creatingtree), null, null);
    // muestro modal		
    const mimodal = new (0, (/*@__PURE__*/$parcel$interopDefault($dktVJ))).Modal(document.getElementById('mimodal'));
    mimodal.show();
    // 2) genero un id de árbol => nanoid de 12 caracteres
    const etid = (0, $96abbdd7193a3c4b$export$567fc7097e064344)(12);
    const ahora = new Date().toISOString();
    const creador = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/user/" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid; // cojo el uid del usuario en firebase
    // inicializo evento de creación de árbol a GA
    (0, $067277e156f7a571$export$639f48199cd2287d)({
        content_type: 'tree',
        content_id: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/tree/" + etid,
        uid: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid,
        crafts_reqs: 0
    });
    // 3) si hay foto la guardo primero en Firebase
    const imgDataUrl = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#resizedTreePhoto").val();
    let imgDownloadURL = null;
    let imgFirebasePath = null;
    if (imgDataUrl) {
        //console.log("hay imagen");
        // Get a reference to the storage service, which is used to create references in your storage bucket
        const storage = (0, $63c1f7f3542429ef$export$fbd9b57a66480737)((0, $c0304d280c7b00cb$export$54387eca9e368edc)());
        // Create a storage reference from our storage service
        //const storageRef = ref();
        // preparo referencia a imagen para guardar
        imgFirebasePath = 'images/' + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid + '/' + etid + '.png';
        const imgRef = (0, $63c1f7f3542429ef$export$eff4d24c3ff7876e)(storage, imgFirebasePath);
        // guardo foto del árbol
        try {
            //const snapshot = await imgRef.putString(imgDataUrl, 'data_url');			
            //imgDownloadURL = await snapshot.ref.getDownloadURL();
            const snapshot = await (0, $63c1f7f3542429ef$export$d885b2eb178808b3)(imgRef, imgDataUrl, 'data_url');
            imgDownloadURL = await (0, $63c1f7f3542429ef$export$c8bf645a0c2a7d9f)(snapshot.ref);
            // mando evento de creación de foto en firebase a GA
            (0, $067277e156f7a571$export$7329bcdc3edcd90e)("create_content", {
                content_type: 'photo',
                content_id: imgDownloadURL,
                uid: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid
            });
            console.info("Foto subida a Firebase: " + imgDownloadURL);
        } catch (error) {
            console.error('Error: ' + error.message);
            const be = "<code>" + error + "</code>";
            (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
                static: true,
                vertcent: true
            }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).uploadingphotoerror), be, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).creacionError);
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".goBack").click((0, $ffd94e1d81f19b1c$export$28fca2ccfd38b8f));
            return; // terminamos
        }
    }
    // 4) preparo objetos JSON con los datos del árbol a crear
    // tobj de tipo EducaTree y bobj de tipo BasicEducaTree (éste es para actualizar los datos guardados)
    // datos básicos y posición
    let tobj = {
        "iri": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/tree/" + etid,
        "creator": creador,
        "created": ahora,
        "position": {
            "iri": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/posann/" + etid,
            "creator": creador,
            "created": ahora,
            "latWGS84": Number((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat),
            "lngWGS84": (0, $69f04ba581843b2d$export$9f306b5167a85c73)(Number((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng)),
            "types": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/sta/ontology/PositionAnnotation"
        },
        "positionAnnotations": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/posann/" + etid,
        "types": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/sta/ontology/Tree"
    };
    let bobj = {
        "iri": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/tree/" + etid,
        "creator": creador,
        "created": ahora,
        "lat": Number((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat),
        "lng": (0, $69f04ba581843b2d$export$9f306b5167a85c73)(Number((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng))
    };
    // nick
    const treenick = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#inputTreeNick').val();
    if (treenick && treenick.length >= 3) {
        tobj.nick = treenick;
        bobj.nick = treenick;
    }
    // taxón
    const turi = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#inputTreeTaxonEd").attr("iri");
    if (turi != undefined) {
        tobj.species = {
            "iri": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/spann/" + etid,
            "creator": creador,
            "created": ahora,
            "species": turi,
            "types": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/sta/ontology/SpeciesAnnotation"
        };
        tobj.speciesAnnotations = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/spann/" + etid;
        // el básico...
        bobj.species = turi;
    }
    // estado árbol
    const tstiri = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#selectTreeStatus').val();
    if (tstiri !== "") {
        tobj.treeStatus = {
            "iri": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/treestann/" + etid,
            "creator": creador,
            "created": ahora,
            "treeStatus": tstiri
        };
        tobj.treeStatusAnnotations = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/treestann/" + etid;
        // el básico... 
        bobj.treeStatus = tstiri;
    }
    // foto
    if (imgDownloadURL) {
        tobj.imageAnnotations = {
            "iri": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/imgann/" + etid,
            "creator": creador,
            "created": ahora,
            "image": {
                "iri": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/img/" + etid,
                "imageURL": imgDownloadURL,
                "firebasePath": imgFirebasePath,
                "types": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/sta/ontology/Image"
            },
            "types": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/sta/ontology/ImageAnnotation"
        };
        // si ha seleccionado el tipo de foto...
        const tppiri = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#selectTreePartPhoto').val();
        if (tppiri !== "") tobj.imageAnnotations.image.plantPart = tppiri;
        // el básico...
        bobj.images = imgDownloadURL;
    }
    // altura
    const alt = Number((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#treeHeight').val());
    if (alt && alt > 0 && alt < 150) {
        // hay altura y tiene un valor correcto
        tobj.height = {
            "iri": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/heightann/" + etid,
            "creator": creador,
            "created": ahora,
            "meters": alt,
            "types": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/sta/ontology/HeightAnnotation"
        };
        tobj.heightAnnotations = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/heightann/" + etid;
        // el básico...
        bobj.height = alt;
    }
    // diámetro
    let diam = Number((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#treeDiameter').val());
    if (diam) {
        // reajuste por el modo perímetro
        if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#checkPerimeter").prop("checked")) diam = Number((diam / Math.PI).toFixed(0));
        if (diam > 0 && diam < 20000) {
            // hay diámetro y tiene un valor correcto
            tobj.diameter = {
                "iri": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/diamann/" + etid,
                "creator": creador,
                "created": ahora,
                "millimeters": diam,
                "types": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/sta/ontology/DiameterAnnotation"
            };
            tobj.diameterAnnotations = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/diamann/" + etid;
            // el básico...
            bobj.dbh = diam;
        }
    }
    // observación
    const observation = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#treeObservation').val();
    if (observation && observation.length > 4) {
        // hay una observación
        tobj.observations = {
            "iri": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/observann/" + etid,
            "creator": creador,
            "created": ahora,
            "text": {
                [(0, $96abbdd7193a3c4b$export$350964a2fface462)()]: observation
            },
            "types": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/sta/ontology/ObservationAnnotation"
        };
        // el básico...
        bobj.observations = {
            [(0, $96abbdd7193a3c4b$export$350964a2fface462)()]: observation
        };
    }
    //console.log(tobj);
    //console.log(bobj);
    // 5) hago la llamada para crear el educatree
    try {
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)(null, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).creatingtree), null, null);
        await (0, $174d363c054274ef$export$12a337954d57ecd1)(tobj, bobj); // aquí se hace la creación y la sincronización con el mapa si tiene éxito		
        // envío datos creación del árbol a GA
        (0, $067277e156f7a571$export$6adbd77fe07ba13)("create_content");
        console.info("\xc1rbol creado con IRI: " + (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/tree/" + etid); // log
    } catch (err) {
        console.error(err.message);
        // actualizo modal
        const be = "<code>" + err.message + "<br>" + JSON.stringify(err.error) + "</code>";
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
            static: true,
            vertcent: true
        }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treecreationerror), be, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).creacionError);
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".goBack").click((0, $ffd94e1d81f19b1c$export$28fca2ccfd38b8f));
        return; // terminamos
    }
    // 6) dejo preparada la URL para ir a la página del educatree creado
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.path = "tree";
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid = etid;
    history.replaceState((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado, "", (0, $ffd94e1d81f19b1c$export$e5c8c113a1c69275)());
    // 7) ajustes finales modal
    // /app/images/treeCreation.png
    const htmlbody = '<img id="imgTreeCreation" src="" class="d-block w-100">';
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        static: true,
        vertcent: true
    }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treecreationsuccess), htmlbody, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).creacionExito);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#imgTreeCreation").attr("src", new URL($131d857d425836ee$exports));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".goBack").click((0, $ffd94e1d81f19b1c$export$28fca2ccfd38b8f));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".cargarURL").click(function() {
        (0, $ffd94e1d81f19b1c$export$db4341b92d8f97b0)();
    });
}
//////////////////////////
// MINIMAPA CREACIÓN ÁRBOL
//////////////////////////
async function $3a9989d46007ef73$export$d3be837b79c08382(mm, bounds) {
    // reajusto zoom a config.zMaxCelda (18) para reducir peticiones (respecto a 20)
    const zoom = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zMaxCelda; // 18;
    // incluyo zoom para el cacheo
    //Sesion.zoomUsados[Sesion.estado.loc.z] = true; 
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoomUsados[zoom] = true;
    // obtengo grid de celdas para el mapa
    //const grid = getGrid(bounds, Sesion.estado.loc.z);
    const grid = (0, $0a5d75214fa44e03$export$85a47b3ccce199ed)(bounds, zoom);
    // inicializo infoCeldas
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas = {
        total: (1 + grid.cellE - grid.cellW) * (1 + grid.cellN - grid.cellS),
        finalizadas: [],
        cacheadas: [],
        npc: [] // número de peticiones a crafts
    };
    // inicializo arbsPintados en Minimapa
    mm.arbsPintados = {};
    // inicializo promesas
    let promesas = [];
    // trabajo celda a celda
    for(let x = grid.cellW; x <= grid.cellE; x++)for(let y = grid.cellS; y <= grid.cellN; y++){
        // preparo objeto de la celda
        const objcelda = {
            zoom: zoom,
            txgen: [
                'undefined'
            ],
            txesp: [
                'undefined',
                ...(0, $2q7Wm.default).intersection(Object.keys((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txUsados), Object.keys((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies))
            ],
            cellX: x,
            cellY: y,
            npc: [],
            minimapa: mm,
            ifn: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.ifn,
            et: 'z' + zoom + '_x' + x + '_y' + y + '_undefined'
        };
        // enchufo el render
        objcelda.render = $3a9989d46007ef73$var$pintarCeldaMinimapa;
        // hago la petición de datos de árboles de la celda
        promesas.push((0, $174d363c054274ef$export$2579cebb92311e97)(objcelda));
    }
    // espero a que terminen todas las promesas
    await Promise.all(promesas);
}
function $3a9989d46007ef73$var$pintarCeldaMinimapa(objcelda) {
    // referencia a la celda
    const celda = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[objcelda.et];
    // objeto bounds de la celda
    const bounds = (0, $0a5d75214fa44e03$export$4e23e15d2ccb71f7)(objcelda.cellX, objcelda.cellY, objcelda.zoom);
    // detecto si hay cluster, ajustando etiqueta y z-index
    let etCluster = null;
    let zCluster = null;
    if (celda.edu.mmil || (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.ifn && celda.ifn.mmil) {
        etCluster = "+1K";
        zCluster = 1000;
    } else if (celda.edu.ntrees > (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).treeThreshold || (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.ifn && celda.edu.ntrees + celda.ifn.ntrees > (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).treeThreshold) {
        etCluster = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.ifn ? celda.edu.ntrees + celda.ifn.ntrees : celda.edu.ntrees;
        zCluster = etCluster;
    }
    // CLUSTERS
    if (etCluster != undefined) {
        // pongo el cluster en el centro de la celda
        const mLatLng = bounds.getCenter();
        // preparo icono
        const micon = new (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).divIcon({
            html: '<div class="marcadorTexto"><span>' + etCluster + '</span></div>',
            className: '',
            iconSize: [
                52,
                52
            ],
            iconAnchor: [
                26,
                26
            ],
            tooltipAnchor: [
                12,
                0
            ] // point from which tooltips will "open", relative to the icon anchor
        });
        // creo marcador y añado al minimapa
        const cpint = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).marker(mLatLng, {
            icon: micon
        }).addTo(objcelda.minimapa);
        // añado tooltip si no es táctil
        if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).hayTooltips) cpint.bindTooltip(etCluster + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).ntrees));
    } else {
        // no es un cluster, agrego los dos arrays de árboles y los trato de manera indiferente
        const alltrees = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.ifn && celda.ifn.trees ? celda.edu.trees ? celda.ifn.trees.concat(celda.edu.trees) : celda.ifn.trees : celda.edu.trees ? celda.edu.trees : [];
        // pinto árbol a árbol
        for (const turi of alltrees)// sólo pinto árbol si no estaba libre (para evitar efectos borde entre celdas)
        if (objcelda.minimapa.arbsPintados[turi] == undefined) {
            // recupero el árbol
            const arb = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[turi];
            // obtengo icono
            const aicon = (0, $7b115b3c2cee4b53$export$6274df672a45c12d)(arb);
            // reajuste de longitud por el antimeridiano
            const lng = (0, $69f04ba581843b2d$export$a4829058f9fe1646)(arb.lng, objcelda.cellX, objcelda.zoom);
            // pinto el marcador del árbol
            let apint = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).marker([
                arb.lat,
                lng
            ], {
                icon: aicon
            }).addTo(objcelda.minimapa);
            // y lo guardo
            objcelda.minimapa.arbsPintados[turi] = apint;
            // pongo tooltips en cualquier caso y a volar
            apint.bindTooltip((0, $82a71c896f160eac$export$924c9d361ba12beb)(arb));
        }
    }
}




////////////
// MAPA BASE
function $69f04ba581843b2d$export$c1c1414601191e71(esMini) {
    if (esMini) {
        const url = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.esri ? (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).geoConfigs.esriMinimap.url : (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).geoConfigs.osmMinimap.url;
        const opts = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.esri ? (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).geoConfigs.esriMinimap.options : (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).geoConfigs.osmMinimap.options;
        return {
            url: url,
            opts: opts
        };
    } else {
        const url = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.esri ? (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).geoConfigs.esriMap.url : (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).geoConfigs.osmMap.url;
        const opts = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.esri ? (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).geoConfigs.esriMap.options : (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).geoConfigs.osmMap.options;
        return {
            url: url,
            opts: opts
        };
    }
}
/////////////////
// ANTIMERIDIANO
// conversión Leaflet a las consultas al triplestore
function $69f04ba581843b2d$export$9f306b5167a85c73(lng) {
    // OJO CON EL ANTIMERIDIANO: en Leaflet los bounds pueden estar fuera del rango de longitud [-180, 180]
    // https://stackoverflow.com/questions/40532496/wrapping-lines-polygons-across-the-antimeridian-in-leaflet-js		
    // solución para el antimeridiano
    while(lng < -180)lng += 360;
    while(lng > 180)lng -= 360;
    return lng;
}
// conversión coordenadas triplestore a Leaflet
function $69f04ba581843b2d$export$a4829058f9fe1646(lng, cellX, zoom) {
    // recupero cellSide
    const cellSide = (0, $0a5d75214fa44e03$export$c7c0bc1741de0bee)(zoom);
    // nciclos será un entero menor que 0 para longitudes menores de -180
    // nciclos será un entero mayor que 0 para longitudes mayores de -180
    const nciclos = Math.floor((cellX * cellSide + cellSide / 2 + 180) / 360);
    // devuelvo lng ajustada
    return lng + nciclos * 360;
}
////////////////////////////
// BUCLE DE CONTROL DEL MAPA
function $69f04ba581843b2d$export$c8207d40f45dcd81() {
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).errordataprov == undefined) {
        if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).actualizandoMapa) {
            (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).mapaMovido = true; // pendiente de actualizar el mapa...
            console.log("Mapa movido: actualizaci\xf3n de mapa pendiente...");
        } else $69f04ba581843b2d$var$actualizarMapa();
    }
}
async function $69f04ba581843b2d$var$actualizarMapa() {
    // si no estoy en modo mapa no continúo con la actualización
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.path !== "map") return;
    // desactivo botón de descarga (no se reactivará hasta que termine felizmente finActualizarMapa)
    //$(".download").addClass("disabled");
    // ajustes en la sesión
    // actualizo info de filtro de taxón
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txPrevio = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).tx;
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).tx = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon;
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txUsados[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).tx] = true; // para el cacheo
    // actualizo zoom
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoomPrevio = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoom;
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoom = (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).getZoom();
    // si hubo cambio de zoom aplico ajustes del mapa botón de creación
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoomPrevio !== (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoom) (0, $3a9989d46007ef73$export$7c626a07c7c69914)();
    // limito el zoom en las celdas para evitar explosión en zooms muy altos que no aportan nada
    const zoomCelda = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoom > (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zMaxCelda ? (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zMaxCelda : (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoom;
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoomUsados[zoomCelda] = true; // para el cacheo	
    // obtengo grid de celdas para el mapa
    const grid = (0, $0a5d75214fa44e03$export$85a47b3ccce199ed)((0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).getBounds(), zoomCelda);
    // inicializaciones progreso y estadísticos celdas
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas = {
        total: (1 + grid.cellE - grid.cellW) * (1 + grid.cellN - grid.cellS),
        finalizadas: [],
        cacheadas: [],
        npc: [],
        ifn: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.ifn // sólo pediré datos de ifn si está activado
    };
    // inicialización primordial
    $69f04ba581843b2d$var$inicioActualizarMapa();
    const idtimeout = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).idTimeoutActualizar;
    //
    // CELDAS ÁRBOLES
    //	
    // inicializo promesas de las celdas
    let promesasCeldas = [];
    // actualizo info celdas para GA
    (0, $067277e156f7a571$export$2db6ab9500fc86e)('num_cells', (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.total);
    // inicializo zoomout
    let zoomout = false;
    // si hubo un cambio de filtro de taxón borro todo
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).tx !== (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txPrevio) {
        (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).arbs.clearLayers(); // quito marcadores árboles
        (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).clarbs.clearLayers(); // quito marcadores clusters
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).celdasPintadas = {}; // ninguna celda pintada
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados = {}; // ningún marcador de árbol
    } else if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoom != (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoomPrevio) {
        (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).clarbs.clearLayers(); // quito marcadores clusters
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).celdasPintadas = {}; // obligo a pintar cada celda
        // marco zoomout
        if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoom < (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoomPrevio) zoomout = true;
    }
    // pregenero los taxones más generales y más específicos para el cacheo
    let txgen = [
        'undefined'
    ];
    let txesp = [
        'undefined',
        ...(0, $2q7Wm.default).intersection(Object.keys((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txUsados), Object.keys((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies))
    ];
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).tx != undefined) {
        txgen = [
            'undefined',
            ...(0, $2q7Wm.default).intersection(Object.keys((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txUsados), (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).tx].superexpuris)
        ];
        txesp = (0, $2q7Wm.default).intersection(Object.keys((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txUsados), (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).tx].expuris);
    }
    // trabajo celda a celda
    for(let x = grid.cellW; x <= grid.cellE; x++)for(let y = grid.cellS; y <= grid.cellN; y++){
        // preparo objeto de la celda
        const objcelda = {
            zoomout: zoomout,
            taxon: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).tx,
            txgen: txgen,
            txesp: txesp,
            zoom: zoomCelda,
            cellX: x,
            cellY: y,
            npc: [],
            et: 'z' + zoomCelda + '_x' + x + '_y' + y + '_' + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).tx,
            ifn: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.ifn,
            idtimeout: idtimeout // para actualizar Sesion.infoCeldas sólo si toca
        };
        // enchufo el progreso
        objcelda.progreso = $69f04ba581843b2d$var$pintarBarraProgreso;
        // enchufo el render
        objcelda.render = (0, $82a71c896f160eac$export$b07097befa6136ca);
        // hago la petición de datos de sitios de la celda
        promesasCeldas.push((0, $174d363c054274ef$export$2579cebb92311e97)(objcelda));
    }
    // hago borrado de los árboles no visibles (para evitar problemas con el antimeridiano:
    //	-> un árbol sólo puede estar pintado una vez)
    //	-> no me preocupo por el borrado de los clusters
    //console.time("Borrado de árboles en celdas no visibles");
    const gridBounds = (0, $0a5d75214fa44e03$export$bcb885fb505ac675)(grid, zoomCelda); // bounds del grid
    //let numCellsBorradas = 0;
    //let numArbsBorrados = 0;	
    for(const cpet in (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).celdasPintadas){
        // extraigo z, x, y de cpet
        const cpetZ = Number(cpet.substring(1, cpet.indexOf('_')));
        const cpetX = Number(cpet.substring(cpet.indexOf('_x') + 2, cpet.indexOf('_', cpet.indexOf('_x') + 1)));
        const cpetY = Number(cpet.substring(cpet.indexOf('_y') + 2, cpet.indexOf('_', cpet.indexOf('_y') + 1)));
        const cpgrid = (0, $0a5d75214fa44e03$export$4e23e15d2ccb71f7)(cpetX, cpetY, cpetZ);
        // si no lo contiene...
        if (!gridBounds.contains(cpgrid)) {
            const celdaborrar = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[cpet];
            const alltreesborrar = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.ifn && celdaborrar.ifn.trees ? celdaborrar.edu.trees ? celdaborrar.ifn.trees.concat(celdaborrar.edu.trees) : celdaborrar.ifn.trees : celdaborrar.edu.trees ? celdaborrar.edu.trees : [];
            for (const airi of alltreesborrar)if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados[airi]) {
                (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).arbs.removeLayer((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados[airi]);
                delete (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados[airi];
            //numArbsBorrados++;
            }
            // la celda ya no está pintada
            delete (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).celdasPintadas[cpet];
        // estadístico celdas
        //numCellsBorradas++;
        }
    }
    //console.log("#celdas borradas: " + numCellsBorradas);
    //console.log("#árboles borrados: " + numArbsBorrados);
    //console.timeEnd("Borrado de árboles en celdas no visibles");
    // espero a que terminen todas las promesas de las celdas para hacer logging
    await Promise.all(promesasCeldas);
    // logging celdas si no ha vencido el temporizador de actualización...
    if (idtimeout == (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).idTimeoutActualizar) {
        // logging celdas
        //console.log("Celdas totales: " + infoceldas.npc.length);
        //console.log("Celdas cacheadas: " + infoceldas.cacheadas.length);
        const tcc = (0, $2q7Wm.default).reduce((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.cacheadas, function(memo, num) {
            return memo + num;
        }, 0);
        const npc = (0, $2q7Wm.default).reduce((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.npc, function(memo, num) {
            return memo + num;
        }, 0);
        console.info("#celdas I" + idtimeout + " total: " + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.total + " - cacheadas: " + tcc + " - #npc: " + npc);
        // actualizo info celdas cacheadas para GA
        (0, $067277e156f7a571$export$2db6ab9500fc86e)('cached_cells', tcc);
    }
    // rutina fin actualización del mapa si no ha vencido el temporizador de actualización
    if (idtimeout == (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).idTimeoutActualizar) $69f04ba581843b2d$export$7a39c88e7f3f42da();
}
function $69f04ba581843b2d$var$inicioActualizarMapa() {
    // mapa actual
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).mapaMovido = false;
    // quito timeout anterior (importante llamar tras Sesion.mapaMovido = false)
    $69f04ba581843b2d$export$7a39c88e7f3f42da();
    // pongo bloqueo a actualizaciones
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).actualizandoMapa = true;
    // pinto la barra de progreso
    $69f04ba581843b2d$var$pintarBarraProgreso(true);
    // actualizo la localización del estado de la sesión
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat = (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).getCenter().lat;
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng = (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).getCenter().lng;
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.z = (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).getZoom();
    // reajusto url y actualizo página en la historia si hay cambio en URL
    if (window.location !== (0, $ffd94e1d81f19b1c$export$e5c8c113a1c69275)()) history.replaceState((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado, "", (0, $ffd94e1d81f19b1c$export$e5c8c113a1c69275)());
    // ajuste propiedad meta de la url
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("meta[property='og:url']").attr('content', window.location);
    // pongo timeout para que quite el bloqueo tras 10 segundos (por si acaso se bloquea indefinidamente)
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).idTimeoutActualizar = setTimeout(function() {
        // mando evento de timeout a GA	
        (0, $067277e156f7a571$export$cfc545666c0ce6d8)();
        console.warn("Venci\xf3 el temporizador de " + Math.round((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).timeout / 1000) + " segundos antes de terminar de actualizar el mapa");
        console.groupEnd();
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).actualizandoMapa = false;
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).idTimeoutActualizar = null;
        // actualizo timeout
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).timeout += (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).timeoutStep;
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).huboTimeout = true;
        // y llamo a mapaMovido
        $69f04ba581843b2d$export$c8207d40f45dcd81();
    }, (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).timeout);
    // logging
    console.group("I" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).idTimeoutActualizar + " - Actualizando mapa");
    console.time("Actualizaci\xf3n I" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).idTimeoutActualizar);
    console.log("URL: " + window.location);
    console.log("Temporizador actualizaci\xf3n: " + Math.round((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).timeout / 1000) + " segundos");
    //console.log(" -> bloqueando actualizaciones y poniendo temporizador antibloqueo: " + Sesion.idTimeoutActualizar);
    // inicializo el evento para enviar a Google Analytics
    (0, $067277e156f7a571$export$626fff8d65416420)();
}
function $69f04ba581843b2d$export$7a39c88e7f3f42da() {
    //console.log(" -> fin de actualización del mapa, quito temporizador antibloqueo");
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).actualizandoMapa = false; // quito bloqueo
    // cancelo timeout anterior (si existiera)
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).idTimeoutActualizar != null) {
        clearTimeout((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).idTimeoutActualizar);
        console.timeEnd("Actualizaci\xf3n I" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).idTimeoutActualizar);
        console.info("I" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).idTimeoutActualizar + " - Fin actualizaci\xf3n del mapa");
        console.groupEnd();
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).idTimeoutActualizar = null;
        // activo botón de descarga
        //$(".download").removeClass("disabled");		
        // escondo la barra de progreso
        $69f04ba581843b2d$var$pintarBarraProgreso(false);
        // actualización timeout
        if (!(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).huboTimeout && (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).timeout > (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).timeout) (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).timeout -= (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).timeoutStep;
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).huboTimeout = false; // inicializo para la siguiente
        // mando evento de fin de actualización del mapa
        (0, $067277e156f7a571$export$6adbd77fe07ba13)();
    }
    // llamo a actualizar el mapa si es necesario
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).mapaMovido) {
        console.info("El mapa se hab\xeda movido, vuelvo a actualizar");
        $69f04ba581843b2d$export$c8207d40f45dcd81();
    } else if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).ponerAlertaCuestionario) {
        // miro si pongo el cuestionario
        const ahora = Date.now();
        if (ahora - (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).inicioSesion > (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).intraSessionQGap) {
            // pongo el cuestionario
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mapid").append((0, $646ceeeec66fabd8$export$c75e99c9076bb133));
            // ya no lo vuelvo a poner en la sesión
            (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).ponerAlertaCuestionario = false;
            // y pongo los handlers de los botones
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#questbotyes").click(function() {
                // vamos al questionario (nueva pestaña)
                const questurl = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).attr("questurl");
                const win = window.open(questurl, '_blank');
                win.focus();
                // no más cuestionarios
                localStorage.setItem('cuestionarioNo', true);
                // quito la alerta
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#questalert").alert('close');
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#questbotno").click(function() {
                // no más cuestionarios
                localStorage.setItem('cuestionarioNo', true);
                // quito la alerta
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#questalert").alert('close');
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#questbotlater").click(function() {
                // reajusto a ahora 
                localStorage.setItem('timestampPrimeraSesion', ahora);
                // quito la alerta
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#questalert").alert('close');
            });
        }
    }
}
function $69f04ba581843b2d$var$pintarBarraProgreso(mostrar) {
    // variante sin JQuery para que vaya más rápida la actualización de la barra
    const mibarradiv = document.getElementById('mibarradiv');
    if (mostrar) {
        // obtengo celdas completadas
        const celdascomp = (0, $2q7Wm.default).reduce((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.finalizadas, function(memo, num) {
            return memo + num;
        }, 0);
        // calculo porc (hasta 99)
        const porc = Math.floor(99 * celdascomp / (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.total);
        // ajusto barra
        let mibarra = document.getElementById('mibarra');
        mibarradiv.setAttribute('aria-valuenow', porc);
        mibarra.style.width = porc + '%';
        mibarra.innerHTML = porc + '%';
        // mensajillo de cargando
        let mibarraLoading = document.getElementById('mibarra_loading');
        const porcLoading = 100 - porc;
        if (porcLoading > 30) {
            mibarraLoading.classList.remove('d-none');
            mibarraLoading.style.width = porcLoading + '%';
        } else mibarraLoading.classList.add('d-none');
        // muestro la barra de progreso
        mibarradiv.classList.remove('d-none');
    } else mibarradiv.classList.add('d-none');
}





const $174d363c054274ef$var$CACHE_NAME = 'ew-wikimedia-cache-' + (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).versionCode;
let $174d363c054274ef$var$datacache;
// DESCOMPOSICIÓN LLAMADA RESOURCES
function $174d363c054274ef$var$descomponerCraftsResources(id, uris) {
    // array a devolver con la descomposición
    let devolver = [];
    // array de huérfanos (para combinar)
    let huerfanos = [];
    // organizo las uris por sus namespaces
    let nsuris = {};
    // analizo cada uri y la meto por su namespace
    for(let i = 0; i < uris.length; i++){
        const uri = uris[i];
        // obtengo namespace
        const indfin = Math.max(uri.lastIndexOf('/'), uri.lastIndexOf('#'));
        const ns = uri.substring(0, indfin + 1);
        // guardo
        if (nsuris[ns] == undefined) nsuris[ns] = [];
        nsuris[ns].push(uri);
    }
    // analizo cada namespace encontrado
    const nss = Object.keys(nsuris);
    for(let i = 0; i < nss.length; i++){
        // obtengo el namespace y sus uris
        const mins = nss[i];
        const misuris = nsuris[mins];
        // preparo lotes de 200
        const lote = 200;
        for(let ind = 0; misuris.length > ind * lote; ind++){
            const begin = ind * lote;
            const end = misuris.length > (ind + 1) * lote ? (ind + 1) * lote : misuris.length;
            // si este lote es inferior a 10, los meto en huérfanos
            if (end - begin < 10) huerfanos = huerfanos.concat(misuris.slice(begin, end));
            else {
                // creo un objeto para este lote
                let obj = {};
                obj.id = id;
                obj.ns = mins;
                obj.nspref = 'p'; // arbitrario
                obj.iris = [];
                // meto cada iri con prefijo en el lote
                for(let j = begin; j < end; j++){
                    const uri = misuris[j];
                    const prefuri = 'p:' + uri.substring(mins.length);
                    obj.iris.push(prefuri);
                }
                // y guardo el objeto en devolver
                devolver.push(obj);
            }
        }
    }
    // proceso los huérfanos en lotes de 40
    const lote = 40;
    for(let ind = 0; huerfanos.length > ind * lote; ind++){
        const begin = ind * lote;
        const end = huerfanos.length > (ind + 1) * lote ? (ind + 1) * lote : huerfanos.length;
        // creo un objeto para este lote
        let obj = {};
        obj.id = id;
        obj.iris = huerfanos.slice(begin, end);
        // y guardo el objeto en devolver
        devolver.push(obj);
    }
    // devuelvo la descomposición
    return devolver;
}
// INICIALIZACIONES PROVEEDOR DE DATOS
// datos tipos de partes de plantas para fotos
async function $174d363c054274ef$export$c2cc3ce4ebc083ee() {
    // preparo objeto para la petición a CRAFTS de pares de superclase-subclase a partir de config.usoTop
    const qobj = {
        'ancestor': (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).plantPartPhoto
    };
    const datos = await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).getData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.queryInfoClasses, qobj);
    // fue todo bien, guardo partes de plantas de fotos
    // analizo fila a fila
    for (const row of datos.results.bindings){
        // preparo objeto
        let obj = {
            uri: row.class.value,
            label: {}
        };
        // guardo labeles
        if (row.labes.value != undefined) obj.label.es = row.labes.value;
        // guardo labelen
        if (row.laben.value != undefined) obj.label.en = row.laben.value;
        // y guardo en los datos
        (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).partesPlantasFoto[obj.uri] = obj;
    }
}
// info de todas las especies
async function $174d363c054274ef$export$40a5140e3d2b7b8d() {
    // obtengo info de subclases de las especies
    for (let espTop of (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).especiesTop){
        // preparo objeto para la petición a CRAFTS de pares de superclase-subclase a partir de config.especiesTop
        const qobj = {
            'ancestor': espTop
        };
        const datos = await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).getData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.querySubclasses, qobj);
        // fue todo bien, inicializo clase config.especiesTop[i]		
        $174d363c054274ef$export$25fe61d80318b90d((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies, espTop);
        // analizo cada fila de los resultados
        for (let row of datos.results.bindings){
            // obtengo datos
            const supuri = row.sup.value;
            const suburi = row.sub.value;
            // inicializo clases
            $174d363c054274ef$export$25fe61d80318b90d((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies, supuri);
            $174d363c054274ef$export$25fe61d80318b90d((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies, suburi);
            // guardo subclase
            (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[supuri].subclasses.push(suburi);
            // guardo superclase
            (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[suburi].superclasses.push(supuri);
        }
    }
    // obtengo especies expandidas
    $174d363c054274ef$export$14ba48f8fbb8469();
    // ahora pido a CRAFTS la info de cada especie
    const suris = Object.keys((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies);
    let promesas = []; // inicializo promesas
    // pido descomponer en objetos para la llamada resources de CRAFTS
    const objrs = $174d363c054274ef$var$descomponerCraftsResources('Species', suris);
    // ya tengo los objetos a pedir, lanzo las peticiones en paralelo a CRAFTS
    for (const objr of objrs)// creo una promesa para cada petición
    promesas.push(new Promise(async function(resolve, reject) {
        try {
            // hago la llamada a CRAFTS	y espero resultados
            let datos = await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).getData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.resourcesTemplate, objr);
            // convierto en array si es necesario
            if (!Array.isArray(datos)) datos = [
                datos
            ];
            // actualizo especie a especie, fusionando con lo que tenía
            for (let dato of datos)Object.assign((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[dato.iri], dato);
            // resuelvo la promesa
            resolve(true);
        } catch (err) {
            reject(err);
        }
    }));
    // espero a que terminen todas las promesas
    await Promise.all(promesas);
    // sept-26: consultas a Wikimedia sin esperar a que acabe
    $174d363c054274ef$var$includeWikimediaSpeciesInfo(suris);
}
async function $174d363c054274ef$var$includeWikimediaSpeciesInfo(suris, tobj) {
    // valor por defecto tobj es Datos.especies
    if (!tobj) tobj = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies;
    // filtro primero a las especies existentes
    suris = suris.filter((suri)=>tobj[suri] != undefined);
    // inicialización Wikipedia e imágenes
    for (const suri of suris){
        const tx = tobj[suri];
        tx.images = [];
        tx.wikipedia = {};
        if (tx.wikipediaPage) {
            tx.wikipedia.en = tx.wikipediaPage;
            delete tx.wikipediaPage;
        }
        if (tx.wikidata && tx.wikidata.wikipediaPageES) tx.wikipedia.es = tx.wikidata.wikipediaPageES;
        if (tx.wikipediaPageES) {
            tx.wikipedia.es = tx.wikipediaPageES;
            delete tx.wikipediaPageES;
        }
    }
    // extraigo títulos Wikipedia (inglés y español) para la consulta a Wikimedia
    const tits = [];
    for (const suri of suris){
        const tx = tobj[suri];
        const tel = {
            "uri": tx.uri
        };
        if (tx.wikipedia.en) tel.titen = tx.wikipedia.en.slice(tx.wikipedia.en.lastIndexOf("/") + 1);
        if (tx.wikipedia.es) tel.tites = tx.wikipedia.es.slice(tx.wikipedia.es.lastIndexOf("/") + 1);
        tits.push(tel);
    }
    //console.log(tits); // quitar
    // peticiones por lotes (20 para no tener que paginar)
    for(let i = 0; i < tits.length; i += (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).limitWikimedia){
        const lote = tits.slice(i, i + (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).limitWikimedia);
        // url inglés
        //const urlen = config.wikimediaEN + lote.filter(el => el.titen).map(el => el.titen).join('|');
        const urlen = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).wmbaseEN + new URLSearchParams({
            action: 'query',
            format: 'json',
            origin: '*',
            prop: 'extracts|pageimages',
            redirects: '1',
            exintro: '1',
            explaintext: '1',
            pithumbsize: '300',
            titles: lote.filter((el)=>el.titen).map((el)=>el.titen).join('|')
        });
        //console.debug(urlen); // quitar
        // petición inglés...
        let datos = await $174d363c054274ef$var$retrieveWikimedia(urlen);
        if (datos.query) // para cada tit del lote
        lote.map((tit)=>{
            let title = tit.titen;
            // proceso la normalización
            if (datos.query.normalized) {
                const qn = datos.query.normalized.find((qn)=>title === qn.from);
                if (qn) title = qn.to;
            }
            // proceso redirects
            if (datos.query.redirects) {
                const qr = datos.query.redirects.find((qr)=>title === qr.from);
                if (qr) title = qr.to;
            }
            // recupero la página
            const page = Object.values(datos.query.pages).find((page)=>page.title === title);
            if (page) {
                // guardo imagen y extracto, si lo hay
                if (page.thumbnail) tobj[tit.uri].images.push(page.thumbnail.source);
                if (page.extract) tobj[tit.uri].extract = {
                    "en": page.extract
                };
            }
        });
        // url español
        const urles = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).wmbaseES + new URLSearchParams({
            action: 'query',
            format: 'json',
            origin: '*',
            prop: 'extracts|pageimages',
            redirects: '1',
            exintro: '1',
            explaintext: '1',
            pithumbsize: '300',
            titles: lote.filter((el)=>el.tites).map((el)=>el.tites).join('|')
        });
        //console.debug(urles);
        // petición español...
        datos = await $174d363c054274ef$var$retrieveWikimedia(urles);
        if (datos.query) // para cada tit del lote
        lote.map((tit)=>{
            let title = tit.tites;
            // proceso la normalización
            if (datos.query.normalized) {
                const qn = datos.query.normalized.find((qn)=>title === qn.from);
                if (qn) title = qn.to;
            }
            // proceso redirects
            if (datos.query.redirects) {
                const qr = datos.query.redirects.find((qr)=>title === qr.from);
                if (qr) title = qr.to;
            }
            // recupero la página
            const page = Object.values(datos.query.pages).find((page)=>page.title === title);
            if (page) {
                // guardo imagen y extracto, si lo hay
                if (page.thumbnail) // guardo la imagen si no está repetida
                {
                    if (tobj[tit.uri].images.length == 0 || tobj[tit.uri].images[0] !== page.thumbnail.source) tobj[tit.uri].images.push(page.thumbnail.source);
                }
                if (page.extract) {
                    if (!tobj[tit.uri].extract) tobj[tit.uri].extract = {};
                    tobj[tit.uri].extract.es = page.extract;
                }
            }
        });
    }
// prueba
//console.log(Datos.especies[lote[10].uri]);
}
// sept-26: CACHÉ WIKIMEDIA
async function $174d363c054274ef$var$retrieveWikimedia(url) {
    // inicializo si hace falta
    if (!$174d363c054274ef$var$datacache) {
        console.debug("Inicializando cach\xe9 Wikimedia");
        $174d363c054274ef$var$datacache = await caches.open($174d363c054274ef$var$CACHE_NAME);
        console.debug("Cach\xe9 Wikimedia inicializada");
    }
    // busco emparejamiento
    //console.time("Petición wikimedia");
    const cacheresp = await $174d363c054274ef$var$datacache.match(url);
    if (cacheresp) {
        console.debug("Acierto cach\xe9: " + url);
        //console.timeEnd("Petición wikimedia");
        return cacheresp.json();
    }
    // fallo caché, voy a la red
    console.debug("Fallo cach\xe9: " + url);
    // inicialización de opciones
    const options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    };
    const response = await fetch(url, options);
    if (response.ok) await $174d363c054274ef$var$datacache.put(url, response.clone());
    //console.timeEnd("Petición wikimedia");
    return response.json();
}
// util para usos y especies
function $174d363c054274ef$export$25fe61d80318b90d(objbase, cluri) {
    if (objbase[cluri] == undefined) objbase[cluri] = {
        "uri": cluri,
        "subclasses": [],
        "superclasses": []
    };
}
function $174d363c054274ef$export$14ba48f8fbb8469(borrar) {
    // obtengo las uris
    let evsuris = Object.keys((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies);
    if (borrar) // borro la info inicial que tuviera de nivel y especies expandidas
    for (let txuri of evsuris){
        delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[txuri].nivel;
        delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[txuri].expuris;
        delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[txuri].superexpuris;
    }
    // obtengo las especies expandidas
    while(evsuris.length > 0){
        let newevsuris = [];
        for (let suri of evsuris){
            // recupero especie
            const especie = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[suri];
            // ajusto nivel (para determinar si es especie/género/familia/clase)
            if (especie.nivel == undefined) especie.nivel = 0;
            else especie.nivel++;
            // obtengo la uri de cualquier subespecie sin expandir
            const algsubsuri = (0, $2q7Wm.default).find(especie.subclasses, function(subsuri) {
                return (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[subsuri].expuris == undefined;
            });
            // si no está definida, puedo hacer la expansión de uris
            if (algsubsuri == undefined) {
                // inicializo con la uri de la propia especie
                especie.expuris = [
                    suri
                ];
                // y ahora incluimos las de la subclases
                for (let subsuri of especie.subclasses)especie.expuris = (0, $2q7Wm.default).union(especie.expuris, (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[subsuri].expuris);
            } else newevsuris.push(suri);
        }
        // actualizo lista de tipos a evaluar
        evsuris = newevsuris;
    }
    // recalculo para obtener especies expandidas superiores
    evsuris = Object.keys((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies);
    while(evsuris.length > 0){
        let newevsuris = [];
        for (let suri of evsuris){
            // recupero especie
            const especie = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[suri];
            // obtengo la uri de cualquier superespecie sin expandir
            const algsupersuri = (0, $2q7Wm.default).find(especie.superclasses, function(supersuri) {
                return (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[supersuri].superexpuris == undefined;
            });
            // si no está definida, puedo hacer la expansión de uris
            if (algsupersuri == undefined) {
                // inicializo con la uri de la propia especie
                especie.superexpuris = [
                    suri
                ];
                // y ahora incluimos las de la superclases
                for (let supersuri of especie.superclasses)especie.superexpuris = (0, $2q7Wm.default).union(especie.superexpuris, (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[supersuri].superexpuris);
            } else newevsuris.push(suri);
        }
        // actualizo lista de tipos a evaluar
        evsuris = newevsuris;
    }
}
/////////
// TAXONS
/////////
async function $174d363c054274ef$export$ad969a5713b03ee4(resAPI) {
    // extraigo las IRIS de las entidades
    const entsWD = (0, $2q7Wm.default).pluck(resAPI, "concepturi");
    // extraigo las entidades que requieren consulta a Wikidata
    const entsconsultar = (0, $2q7Wm.default).filter(entsWD, function(ent) {
        return (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).esTaxonWD[ent] == undefined;
    });
    if (entsconsultar.length > 0) {
        // hago la llamada a CRAFTS
        const datos = await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).getData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.queryValidTaxons, {
            eiri: entsconsultar
        });
        // guardo fila a fila (resultados positivos)
        for (const row of datos.results.bindings){
            (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).esTaxonWD[row.taxon.value] = true;
            // incluyo los datos del punto SPARQL y de la API
            const res = (0, $2q7Wm.default).find(resAPI, function(el) {
                return el.concepturi === row.taxon.value;
            });
            (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[row.taxon.value] = {
                iri: row.taxon.value,
                uri: row.taxon.value,
                label: res.display.label.value,
                description: res.description,
                sitelinks: Number(row.sitelinks.value),
                statements: Number(row.statements.value),
                pending: true
            };
        }
        // y ahora guardo los resultados negativos
        for (let ent of entsconsultar)if (!(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).esTaxonWD[ent]) (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).esTaxonWD[ent] = false;
    }
    // extraigo los taxones válidos (ya está todo listo en Datos.esTaxonWD)
    return (0, $2q7Wm.default).filter(entsWD, function(ent) {
        return (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).esTaxonWD[ent];
    });
}
async function $174d363c054274ef$export$2389aabfa4796a70(wdiri) {
    // detecto si tengo los datos de la llamada getValidTaxons
    if (!(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[wdiri]) {
        // hago la llamada a CRAFTS
        const datos = await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).getData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.queryValidTaxons, {
            eiri: wdiri
        });
        // guardo el resultado (habrá al menos uno)
        for (const row of datos.results.bindings){
            (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).esTaxonWD[row.taxon.value] = true;
            // incluyo los datos del punto SPARQL
            (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[row.taxon.value] = {
                iri: row.taxon.value,
                uri: row.taxon.value,
                sitelinks: Number(row.sitelinks.value),
                statements: Number(row.statements.value),
                pending: true
            };
        }
    }
    // luego detecto si tengo los datos completos
    if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[wdiri] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[wdiri].pending) {
        // debería tener ya algo en Datos.taxonesWD[wdiri], si no, no hago nada
        // hago la llamada a CRAFTS	y espero resultados
        const datos = await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).getData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.resourceTemplate, {
            id: "WikidataTaxon",
            iri: wdiri
        });
        // fusiono con lo que tenía
        Object.assign((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[wdiri], datos);
        // caso especial si no vino de getValidTaxons para rellenar label
        if (!(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[wdiri].label) (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[wdiri].label = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(datos.scientificName);
        // sept-26: incluyo la info de wikimedia
        await $174d363c054274ef$var$includeWikimediaSpeciesInfo([
            wdiri
        ], (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD);
        //console.log(Datos.taxonesWD[wdiri]);
        // borro el flag de pending
        delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[wdiri].pending;
    }
}
async function $174d363c054274ef$export$5e6ebc4b1b859630(wdiris) {
    let existing = [];
    if (wdiris.length > 0) {
        // hago la llamada a CRAFTS
        const datos = await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).getData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.queryExistingWikidataTaxons, {
            wdiri: wdiris
        });
        // guardo fila a fila
        for (const row of datos.results.bindings)existing.push(row.wdiri.value);
    }
    return existing;
}
// CREACIÓN DEL TAXÓN
async function $174d363c054274ef$export$f4b4fb77e87b331a(txobj) {
    // preparo objeto parámetros plantilla
    const objpars = {
        iri: txobj.iri,
        id: "Species"
    };
    // hago la llamada a CRAFTS
    // creo el árbol y sus anotaciones asociadas
    await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).putData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.resourceTemplate, objpars, txobj);
    // todo OK
    return Promise.resolve(true);
}
////////
// USERS
////////
async function $174d363c054274ef$export$3f90b926bc531097(uid) {
    if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[uid] != undefined) return Promise.resolve(true); // ya los tenía
    // preparo objeto parámetros consulta
    const objpars = {
        iri: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/user/" + uid,
        id: "Person"
    };
    try {
        // hago la llamada a CRAFTS
        const datos = await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).getData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.resourceTemplate, objpars);
        // guardo datos
        (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[uid] = datos;
        // todo OK
        return Promise.resolve(true);
    } catch (err) {
        // si hay algún error rechazo la promesa
        console.error(err);
        return Promise.reject(err);
    }
}
async function $174d363c054274ef$export$9efbb920d7dd157b(nick) {
    // nunca cacheo esta petición
    // preparo objeto parámetros consulta
    let qobj = {
        nick: nick
    };
    try {
        // hago la llamada a CRAFTS
        const datos = await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).getData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.queryUsernick, qobj);
        // extraigo resultado
        const existe = datos.results.bindings.length;
        // todo OK
        return Promise.resolve(existe);
    } catch (err) {
        // si hay algún error rechazo la promesa
        console.error(err);
        return Promise.reject(err);
    }
}
async function $174d363c054274ef$export$b5be548bb8509ea6(uid, patch) {
    // preparo objeto plantilla recurso
    const objpars = {
        iri: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/user/" + uid,
        id: "Person"
    };
    // hago la llamada a CRAFTS con el patch
    //console.log("CAMBIANDO NICK...");
    try {
        await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).patchData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.resourceTemplate, objpars, patch);
        // actualizo nick
        (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[uid].nick = patch[0].value;
        // todo OK
        return Promise.resolve(true);
    } catch (err) {
        // si hay algún error rechazo la promesa
        console.error(err);
        return Promise.reject(err);
    }
}
async function $174d363c054274ef$export$5f671086e5404234(pe, pae, uid) {
    // si no hay uid, entonces las páginas son de todos (global)
    // tamaño de página depende de si es de usuario o de todos (global)
    const page = uid ? (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).pageus : (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).page;
    // preparo objeto parámetros consulta
    let qobj = {
        limit: page + 1,
        offset: page * pe
    };
    if (uid) qobj.user = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/user/" + uid;
    // NOTA: el límite está preconfigurado a 11 para saber si hay datos en la siguiente página (que son de 10 elementos)
    // selecciono el objeto adecuado dependiendo de si es petición del usuario  o si es global
    const clave = uid ? uid : "global";
    // petición ultEducatrees
    // inicializo el array
    if (!(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees[clave]) (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees[clave] = [];
    // compruebo si está cacheada
    if (!(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees[clave][pe]) try {
        // hago la llamada a CRAFTS		
        const datos = await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).getData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.queryMostRecentEducatrees, qobj);
        // inicializo array resultados
        (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees[clave][pe] = [];
        // guardo fila a fila
        for (const row of datos.results.bindings)(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees[clave][pe].push({
            iri: row.tree.value,
            created: row.date.value,
            nick: row.tnick ? row.tnick.value : undefined,
            creator: {
                iri: row.creator.value,
                nick: row.unick ? row.unick.value : undefined
            }
        });
    } catch (err) {
        // si hay algún error rechazo la promesa
        console.error(err);
        return Promise.reject(err);
    }
    // petición ultAnotaciones
    // actualizo offset
    qobj.offset = page * pae;
    // inicializo el array	
    if (!(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones[clave]) (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones[clave] = [];
    // compruebo si está cacheada
    if (!(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones[clave][pae]) try {
        // hago la llamada a CRAFTS		
        const datos = await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).getData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.queryMostRecentAnnotations, qobj);
        // inicializo array resultados
        (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones[clave][pae] = [];
        // guardo fila a fila
        for (const row of datos.results.bindings)(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones[clave][pae].push({
            iri: row.tree.value,
            created: row.date.value,
            type: row.annType.value,
            nick: row.tnick ? row.tnick.value : undefined,
            creator: {
                iri: row.annotator.value,
                nick: row.unick ? row.unick.value : undefined
            }
        });
    } catch (err) {
        // si hay algún error rechazo la promesa
        console.error(err);
        return Promise.reject(err);
    }
    // todo OK
    return Promise.resolve(true);
}
////////
// TREES
////////
// cambio del nick del árbol
async function $174d363c054274ef$export$56e5489c2f38300e(iri, patch) {
    // preparo objeto plantilla recurso
    const objpars = {
        iri: iri,
        id: "EducaTree"
    };
    // hago la llamada a CRAFTS con el patch
    //console.log("CAMBIANDO NICK...");
    try {
        await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).patchData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.resourceTemplate, objpars, patch);
        // actualizo nick
        (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].nick = patch[0].value;
        // todo OK
        return Promise.resolve(true);
    } catch (err) {
        // si hay algún error rechazo la promesa
        console.error(err);
        return Promise.reject(err);
    }
}
// RECUPERACIÓN DE EDUCATREE
async function $174d363c054274ef$export$92baecf29370dcf(iri) {
    // no hago nada si ya están los datos
    if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri] !== undefined) return;
    // preparo objeto para la llamada
    const objr = {
        id: 'EducaTree',
        iri: iri
    };
    // hago la llamada a CRAFTS	y espero resultados
    let datos = await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).getData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.resourceTemplate, objr);
    // guardo y a volar
    (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri] = datos;
}
// lote de educatrees (para la descarga de anotaciones de educatrees)
async function $174d363c054274ef$export$88055805f25eda73(iris, progreso) {
    // obtengo los educatrees de los que no tengo datos
    let pendingiris = (0, $2q7Wm.default).filter(iris, function(iri) {
        return (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri] == undefined;
    });
    if (pendingiris.length > 0) {
        // pido descomponer en objetos para la llamada resources de CRAFTS	
        const objrs = $174d363c054274ef$var$descomponerCraftsResources('EducaTree', pendingiris);
        // actualizo progreso
        if (progreso) {
            (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.total = objrs.length; // aquí tengo el total
            progreso(true);
        }
        // pido en secuencia
        try {
            for (let objr of objrs){
                // hago la llamada a CRAFTS	y espero resultados
                let datos = await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).getData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.resourcesTemplate, objr);
                // convierto en array si es necesario
                if (!Array.isArray(datos)) datos = [
                    datos
                ];
                // actualizo educatree a educatree
                for (let dato of datos)(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[dato.iri] = dato;
                // actualizo progreso
                if (progreso) {
                    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.npc.push(1);
                    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.finalizadas.push(1);
                    progreso(true);
                }
            }
        } catch (err) {
            console.error(err);
            return;
        }
    }
}
// CREACIÓN DE EDUCATREE
// tobj es el árbol en formato EducaTree y bobj en formato BasicEducaTree
async function $174d363c054274ef$export$12a337954d57ecd1(tobj, bobj) {
    // preparo objeto parámetros plantilla
    const objpars = {
        iri: tobj.iri,
        id: "EducaTree"
    };
    // hago la llamada a CRAFTS
    // creo el árbol y sus anotaciones asociadas
    //console.log("CREANDO EDUCATREE...");
    await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).putData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.resourceTemplate, objpars, tobj);
    // actualizo datos usuario para que cuente la nueva anotación
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid];
    await $174d363c054274ef$export$3f90b926bc531097((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid);
    // guardo árbol básico y me aseguro de borrar el árbol en formato EducaTree
    (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[bobj.iri] = bobj;
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[bobj.iri]; // para obligar a recuperar la info completa si quiere visualizarlo
    // borro también las páginas de árboles del usuario y globales
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees.global;
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid];
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones.global;
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid];
    // obtengo los taxones candidatos (igual o más generales que los del árbol 
    // y encajándolos con los filtros de taxón usados en la sesión)
    let txcands = [
        'undefined'
    ];
    if (bobj.species) txcands = [
        'undefined',
        ...(0, $2q7Wm.default).intersection(Object.keys((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txUsados), (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[bobj.species].superexpuris)
    ];
    // inserto el árbol de las celdas
    $174d363c054274ef$var$insertarArbolCeldas(bobj.iri, txcands);
    // borro clusters y árboles pintados en el mapa
    (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).arbs.clearLayers(); // quito marcadores árboles
    (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).clarbs.clearLayers(); // quito marcadores clusters
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).celdasPintadas = {}; // ninguna celda pintada
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados = {}; // ningún marcador de árbol
    // todo OK
    return Promise.resolve(true);
}
// ANOTACIÓN DE EDUCATREE
async function $174d363c054274ef$export$f78fa04d07774c6b(iri, patch, tobjclon, bobjclon) {
    // preparo objeto parámetros plantilla
    const objpars = {
        iri: iri,
        id: "EducaTree"
    };
    // hago la llamada a CRAFTS con el patch
    //console.log("ANOTANDO EDUCATREE...");
    //console.log(patch);
    await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).patchData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.resourceTemplate, objpars, patch);
    // actualizo datos usuario para que cuente la nueva anotación
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid];
    await $174d363c054274ef$export$3f90b926bc531097((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid);
    // actualizo datos del árbol
    // previo
    //Datos.educatrees[iri] = tobjclon;
    // sept-26: LO ANTERIOR ES PELIGROSO PORQUE EL ORDEN DE LAS ANOTACIONES CREADAS EN VIRTUOSO
    // NO TIENE POR QUÉ COINCIDIR CON EL ORDEN EN QUE LAS AÑADIMOS
    // PARA EVITARLO, SIMPLEMENTE VOLVEMOS A PEDIR LOS DATOS
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri];
    await $174d363c054274ef$export$92baecf29370dcf(iri);
    // para estas cosas no hay problema
    if (bobjclon) {
        // detecto cambio de posición o de taxón 
        if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri] && ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri].lat != bobjclon.lat || (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri].lng != bobjclon.lng || (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri].species !== bobjclon.species)) {
            // elimino el árbol "previo" de las celdas
            let txcands = [
                'undefined'
            ];
            if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri].species) txcands = [
                'undefined',
                ...(0, $2q7Wm.default).intersection(Object.keys((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txUsados), (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri].species].superexpuris)
            ];
            $174d363c054274ef$var$eliminarArbolCeldas(iri, txcands);
            // ahora actualizo el árbol básico para que coja bien los cambios de posición
            (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri] = bobjclon;
            // inserto el árbol "nuevo" de las celdas
            txcands = [
                'undefined'
            ];
            if (bobjclon.species) txcands = [
                'undefined',
                ...(0, $2q7Wm.default).intersection(Object.keys((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txUsados), (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[bobjclon.species].superexpuris)
            ];
            $174d363c054274ef$var$insertarArbolCeldas(iri, txcands);
        }
        // y ahora actualizo el árbol básico (para resto de casos)
        (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri] = bobjclon;
    }
    // borro también las páginas de árboles del usuario y globales
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees.global;
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid];
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones.global;
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid];
    // borro clusters y árboles pintados en el mapa
    (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).arbs.clearLayers(); // quito marcadores árboles
    (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).clarbs.clearLayers(); // quito marcadores clusters
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).celdasPintadas = {}; // ninguna celda pintada
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados = {}; // ningún marcador de árbol
    // todo OK
    return Promise.resolve(true);
}
// BORRADO DE ANOTACIÓN DE EDUCATREE
async function $174d363c054274ef$export$e2dbe74809c0905f(iri, patch, objsborrar, tobjclon, bobjclon) {
    // preparo objeto parámetros plantilla
    const objpars = {
        iri: iri,
        id: "EducaTree"
    };
    // hago la llamada a CRAFTS con el patch
    //console.log("BORRANDO ANOTACIÓN DE EDUCATREE...");
    //console.log(patch);
    await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).patchData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.resourceTemplate, objpars, patch);
    // llamadas a CRAFTS para borrar las anotaciones
    for (const elobj of objsborrar)//console.log("Borrando IRI "  + elobj.iri + " de tipo " + elobj.id);
    await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).deleteData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.resourceTemplate, elobj);
    // actualizo datos usuario para que actualice anotaciones
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid];
    await $174d363c054274ef$export$3f90b926bc531097((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid);
    // actualizo datos del árbol
    (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri] = tobjclon;
    if (bobjclon) {
        // detecto cambio de posición o de taxón 
        if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri] && ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri].lat != bobjclon.lat || (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri].lng != bobjclon.lng || (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri].species !== bobjclon.species)) {
            // elimino el árbol "previo" de las celdas
            let txcands = [
                'undefined'
            ];
            if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri].species) txcands = [
                'undefined',
                ...(0, $2q7Wm.default).intersection(Object.keys((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txUsados), (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri].species].superexpuris)
            ];
            $174d363c054274ef$var$eliminarArbolCeldas(iri, txcands);
            // ahora actualizo el árbol básico para que coja bien los cambios de posición
            (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri] = bobjclon;
            // inserto el árbol "nuevo" de las celdas
            txcands = [
                'undefined'
            ];
            if (bobjclon.species) txcands = [
                'undefined',
                ...(0, $2q7Wm.default).intersection(Object.keys((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txUsados), (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[bobjclon.species].superexpuris)
            ];
            $174d363c054274ef$var$insertarArbolCeldas(iri, txcands);
        }
        // y ahora actualizo el árbol básico (para resto de casos)
        (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri] = bobjclon;
    }
    // borro también las páginas de árboles del usuario y globales
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees.global;
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid];
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones.global;
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid];
    // borro clusters y árboles pintados en el mapa
    (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).arbs.clearLayers(); // quito marcadores árboles
    (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).clarbs.clearLayers(); // quito marcadores clusters
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).celdasPintadas = {}; // ninguna celda pintada
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados = {}; // ningún marcador de árbol
    // todo OK
    return Promise.resolve(true);
}
// BORRADO DE EDUCATREE
async function $174d363c054274ef$export$c4e23ce322fddcd9(iri) {
    // pido datos a CRAFTS del educatree (ya debería tenerlos)
    await $174d363c054274ef$export$92baecf29370dcf(iri);
    const et = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri];
    // analizo los datos para preparar los borrados con CRAFTS
    const objpars = [
        {
            iri: iri,
            id: "EducaTree"
        }
    ];
    // posiciones (funciona aunque no existan posiciones)
    const piris = (0, $2q7Wm.default).union((0, $96abbdd7193a3c4b$export$326843c69d38a183)(et, [
        'position',
        'iri'
    ]), (0, $96abbdd7193a3c4b$export$326843c69d38a183)(et, [
        'positionAnnotations',
        'iri'
    ]));
    for (const piri of piris)objpars.push({
        iri: piri,
        id: 'PositionAnnotation'
    });
    // especies (funciona aunque no existan especies)
    const eiris = (0, $2q7Wm.default).union((0, $96abbdd7193a3c4b$export$326843c69d38a183)(et, [
        'species',
        'iri'
    ]), (0, $96abbdd7193a3c4b$export$326843c69d38a183)(et, [
        'speciesAnnotations',
        'iri'
    ]));
    for (const eiri of eiris)objpars.push({
        iri: eiri,
        id: 'SpeciesAnnotation'
    });
    // tree status (funciona aunque no existan)
    const tsiris = (0, $2q7Wm.default).union((0, $96abbdd7193a3c4b$export$326843c69d38a183)(et, [
        'treeStatus',
        'iri'
    ]), (0, $96abbdd7193a3c4b$export$326843c69d38a183)(et, [
        'treeStatusAnnotations',
        'iri'
    ]));
    for (const tsiri of tsiris)objpars.push({
        iri: tsiri,
        id: 'TreeStatusAnnotation'
    });
    // fotos (funciona aunque no existan)
    const firis = (0, $96abbdd7193a3c4b$export$326843c69d38a183)(et, [
        'imageAnnotations',
        'iri'
    ]);
    for (const firi of firis)objpars.push({
        iri: firi,
        id: 'ImageAnnotation'
    });
    // imágenes de las fotos (funciona aunque no existan)
    const iiris = (0, $96abbdd7193a3c4b$export$326843c69d38a183)(et, [
        'imageAnnotations',
        'image',
        'iri'
    ]);
    for (const iiri of iiris)objpars.push({
        iri: iiri,
        id: 'Image'
    });
    // alturas (funciona aunque no existan)
    const airis = (0, $2q7Wm.default).union((0, $96abbdd7193a3c4b$export$326843c69d38a183)(et, [
        'height',
        'iri'
    ]), (0, $96abbdd7193a3c4b$export$326843c69d38a183)(et, [
        'heightAnnotations',
        'iri'
    ]));
    for (const airi of airis)objpars.push({
        iri: airi,
        id: 'HeightAnnotation'
    });
    // diámetros (funciona aunque no existan)
    const diris = (0, $2q7Wm.default).union((0, $96abbdd7193a3c4b$export$326843c69d38a183)(et, [
        'diameter',
        'iri'
    ]), (0, $96abbdd7193a3c4b$export$326843c69d38a183)(et, [
        'diameterAnnotations',
        'iri'
    ]));
    for (const diri of diris)objpars.push({
        iri: diri,
        id: 'DiameterAnnotation'
    });
    // observaciones (funciona aunque no existan)
    const oiris = (0, $96abbdd7193a3c4b$export$326843c69d38a183)(et, [
        'observations',
        'iri'
    ]);
    for (const oiri of oiris)objpars.push({
        iri: oiri,
        id: 'ObservationAnnotation'
    });
    //console.log(objpars);
    // borrados en CRAFTS
    //console.log("BORRANDO EDUCATREE...");
    for (const elobj of objpars)//console.log("Borrando IRI "  + elobj.iri + " de tipo " + elobj.id);
    await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).deleteData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.resourceTemplate, elobj);
    // obtengo los taxones candidatos (igual o más generales que los del árbol 
    // y encajándolos con los filtros de taxón usados en la sesión)
    let txcands = [
        'undefined'
    ];
    if (et.species && et.species.species) txcands = [
        'undefined',
        ...(0, $2q7Wm.default).intersection(Object.keys((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txUsados), (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[et.species.species.iri].superexpuris)
    ];
    // elimino el árbol de las celdas
    $174d363c054274ef$var$eliminarArbolCeldas(iri, txcands);
    // elimino los datos del árbol
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri];
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri];
    // borro también las páginas de árboles del usuario y globales
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees.global;
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid];
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones.global;
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid];
    // por último borro clusters y árboles pintados en el mapa
    (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).arbs.clearLayers(); // quito marcadores árboles
    (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).clarbs.clearLayers(); // quito marcadores clusters
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).celdasPintadas = {}; // ninguna celda pintada
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados = {}; // ningún marcador de árbol
}
// ACTUALIZACIÓN CELDAS POR INSERCIÓN ÁRBOL
function $174d363c054274ef$var$insertarArbolCeldas(iri, txcands) {
    const arb = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri];
    if (arb) {
        // obtengo bounds con la posición del árbol
        const bounds = L.latLngBounds([
            [
                arb.lat,
                arb.lng
            ],
            [
                arb.lat,
                arb.lng
            ]
        ]);
        // recorro todos los niveles de zoom usados en el mapa
        for(const z in (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoomUsados){
            // obtengo el grid (siempre se corresponderá con una celda al ser bounds un punto)
            const grid = (0, $0a5d75214fa44e03$export$85a47b3ccce199ed)(bounds, z);
            //console.log(" - Zoom: " + z + " - S: " + grid.cellS+ " - N: " + grid.cellN
            //	+ " - W: " + grid.cellW+ " - E: " + grid.cellE);
            // recorro txcands
            for (const tx of txcands){
                // genero etiqueta de celda
                const et = 'z' + z + '_x' + grid.cellW + '_y' + grid.cellN + '_' + tx;
                // si la celda existe...
                let celda = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[et];
                if (celda) {
                    if (celda.edu && !celda.edu.mmil) {
                        // actualización array edutrees
                        if (!celda.edu.trees) celda.edu.trees = [];
                        celda.edu.trees.push(iri);
                        // actualización ntrees
                        if (!celda.edu.ntrees) celda.edu.ntrees = 0;
                        celda.edu.ntrees++;
                    }
                }
            }
        }
    }
}
// ACTUALIZACIÓN CELDAS POR ELIMINACIÓN ÁRBOL
function $174d363c054274ef$var$eliminarArbolCeldas(iri, txcands) {
    const arb = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri];
    if (arb) {
        // obtengo bounds con la posición del árbol
        const bounds = L.latLngBounds([
            [
                arb.lat,
                arb.lng
            ],
            [
                arb.lat,
                arb.lng
            ]
        ]);
        // elimino árbol en las celdas pertinentes
        // recorriendo todos los niveles de zoom usados en el mapa
        for(const z in (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoomUsados){
            // obtengo el grid (siempre se corresponderá con una celda al ser bounds un punto)
            const grid = (0, $0a5d75214fa44e03$export$85a47b3ccce199ed)(bounds, z);
            // recorro txcands
            for (const tx of txcands){
                // genero etiqueta de celda
                const et = 'z' + z + '_x' + grid.cellW + '_y' + grid.cellN + '_' + tx;
                // si la celda existe...
                let celda = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[et];
                if (celda) {
                    if (celda.edu && !celda.edu.mmil) {
                        // actualización array edutrees => elimino árbol
                        if (celda.edu.trees) celda.edu.trees = celda.edu.trees.filter((item)=>item !== iri);
                        // actualización ntrees
                        if (!celda.edu.ntrees && celda.edu.ntrees != 0) celda.edu.ntrees--;
                    }
                }
            }
        }
    }
}
///////////////////////
// PROCESAMIENTO CELDAS
///////////////////////
// función clave para obtener los candidatos para cachear datos
function $174d363c054274ef$var$getCeldasCandidatas(arriba, ocgm, cz, taxones) {
    // calculo rango de zooms permitidos
    const zini = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).minZoom;
    // hacia abajo permito un máximo de 3 niveles para evitar explosión
    const zfin = cz + 3 > (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zMaxCelda ? (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zMaxCelda : cz + 3;
    // obtengo candidatos sin incluir el zoom cz
    let objc = {};
    for(let z = zini; z <= zfin; z++){
        // aquí es donde miro si es hacia arriba o hacia abajo
        if (arriba && z < cz || !arriba && z > cz) {
            if (ocgm[z]) {
                objc[z] = {}; // un objeto por nivel de zoom
                for (const tx of taxones){
                    objc[z][tx] = []; // un array por taxón
                    for(let x = ocgm[z].cellW; x <= ocgm[z].cellE; x++)for(let y = ocgm[z].cellS; y <= ocgm[z].cellN; y++){
                        const et = 'z' + z + '_x' + x + '_y' + y + '_' + tx;
                        objc[z][tx].push(et); // le enchufo la etiqueta
                    }
                }
            }
        }
    }
    return objc;
}
function $174d363c054274ef$var$getQueryCeldaBounds(cellX, cellY, z) {
    // obtengo primero los bounds
    const bounds = (0, $0a5d75214fa44e03$export$4e23e15d2ccb71f7)(cellX, cellY, z);
    // preparo objeto consulta celda quitando ciclos por el antimeridiano
    let qobj = {
        "latsouth": bounds.getSouth(),
        "latnorth": bounds.getNorth(),
        "lngwest": (0, $69f04ba581843b2d$export$9f306b5167a85c73)(bounds.getWest()),
        "lngeast": (0, $69f04ba581843b2d$export$9f306b5167a85c73)(bounds.getEast())
    };
    // devuelvo
    return qobj;
}
// RECUPERAR IFNTREES Y EDUCATREES POR CELDA
async function $174d363c054274ef$export$2579cebb92311e97(objcell) {
    // preparo qobj por si tengo que hacer una petición a CRAFTS
    let qobj = $174d363c054274ef$var$getQueryCeldaBounds(objcell.cellX, objcell.cellY, objcell.zoom);
    qobj.species = objcell.taxon;
    // referencia a mi celda
    let mycell = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[objcell.et];
    // OBTENGO CANDIDATOS PARA EL CACHEO
    // obtengo matriz de grids para esta celda (pero sólo para los zooms usados)
    const ocgm = (0, $0a5d75214fa44e03$export$bed42eae0b34c43c)(objcell.cellX, objcell.cellY, objcell.zoom, (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoomUsados);
    // aquí tengo las celdas candidatas por nivel de zoom y taxón (generales y específicas, incluyendo la etiqueta de mycell)
    const candgen = $174d363c054274ef$var$getCeldasCandidatas(true, ocgm, objcell.zoom, objcell.txgen);
    const candesp = $174d363c054274ef$var$getCeldasCandidatas(false, ocgm, objcell.zoom, objcell.txesp);
    // preinicializo la celda si no existe
    if (mycell == undefined) {
        (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[objcell.et] = {};
        mycell = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[objcell.et];
    }
    // detección +1000 árboles para caso ("ifn" y "edu"")  si no hay nada
    const casos = objcell.ifn ? [
        "ifn",
        "edu"
    ] : [
        "edu"
    ];
    for (const caso of casos)if (!mycell[caso]) {
        // comprobación especial de zona para el IFN
        if (caso === "ifn") {
            // compruebo primero si la celda cae en España
            // (si no, no tiene sentido pedir datos del IFN)
            let hayIFN = false;
            const celdabounds = (0, $0a5d75214fa44e03$export$4e23e15d2ccb71f7)(objcell.cellX, objcell.cellY, objcell.zoom);
            for (const zona of (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zonasIFN){
                // reajusto zona por el antimeridiano
                const zonareajustada = [
                    [
                        zona[0][0],
                        (0, $69f04ba581843b2d$export$a4829058f9fe1646)(zona[0][1], objcell.cellX, objcell.zoom)
                    ],
                    [
                        zona[1][0],
                        (0, $69f04ba581843b2d$export$a4829058f9fe1646)(zona[1][1], objcell.cellX, objcell.zoom)
                    ]
                ];
                const zonabounds = L.latLngBounds(zonareajustada);
                if (zonabounds.intersects(celdabounds)) hayIFN = true;
            }
            // si no está en España, asigno mmil a false y ntrees a 0
            if (!hayIFN) mycell[caso] = {
                mmil: false,
                ntrees: 0
            };
        }
        // si no hay datos sigo
        if (!mycell[caso]) {
            // inicializo
            mycell[caso] = {};
            // CACHEO: miro si me puedo ahorrar la petición
            let bingo = false;
            hayMmilLoop: for(const z in candesp)for(const tx in candesp[z]){
                for (const et of candesp[z][tx])if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[et] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[et][caso] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[et][caso].mmil) {
                    bingo = true;
                    mycell[caso].mmil = true;
                    mycell[caso].locCluster = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[et][caso].locCluster;
                    break hayMmilLoop;
                }
            }
            if (!bingo) noHayMmilLoop: for(const z in candgen)for(const tx in candgen[z]){
                for (const et of candgen[z][tx])if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[et] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[et][caso] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[et][caso].mmil != undefined && !(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[et][caso].mmil) {
                    bingo = true;
                    mycell[caso].mmil = false;
                    break noHayMmilLoop;
                }
            }
            // FIN CACHEO	
            if (!bingo) {
                qobj.limit = 1;
                qobj.offset = 1000;
                const template = caso === "ifn" ? (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.queryTreesinboxbasico : (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.queryEducatreesinbox;
                // hago la llamada a CRAFTS	y espero resultados
                objcell.npc.push(1);
                const datos = await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).getData(template, qobj);
                // inicializo mmil a false
                mycell[caso].mmil = false;
                // analizo primera fila, si la hay
                if (datos.results.bindings.length > 0) {
                    // si hay datos es que hay más de mil árboles
                    mycell[caso].mmil = true;
                    // aprovecho para guardar esa localización para posicionar el cluster
                    mycell[caso].locCluster = {
                        lat: Number(datos.results.bindings[0].lat.value),
                        lng: Number(datos.results.bindings[0].lng.value)
                    };
                }
            }
        }
    }
    // aquí hago un split de ifntrees y de educatrees
    let promesas = [];
    for (let caso of casos)promesas.push($174d363c054274ef$var$getCellTrees(mycell, candgen, objcell, qobj, caso));
    // espero a que terminen todas las promesas
    await Promise.all(promesas);
    // actualizo info del número de consultas y si la celda estaba cacheada (si no hizo falta hacer consultas)
    if (objcell.idtimeout == (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).idTimeoutActualizar) {
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.finalizadas.push(1);
        const totnpc = (0, $2q7Wm.default).reduce(objcell.npc, function(memo, num) {
            return memo + num;
        }, 0);
        if (totnpc == 0) (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.cacheadas.push(1);
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.npc.push(totnpc);
        // actualizo la barra de progreso (sólo si no ha vencido el temporizador)
        if (objcell.progreso) objcell.progreso(true);
    }
    // hacemos el render
    if (objcell.render) objcell.render(objcell);
    // fue todo bien, resuelvo la promesa
    return Promise.resolve();
}
async function $174d363c054274ef$var$getCellTrees(mycell, candgen, objcell, qobj, caso) {
    try {
        // si hay menos de mil árboles y no hay cuenta de trees, hay que calcularlo
        if (!mycell[caso].mmil && mycell[caso].ntrees == undefined) {
            // CACHEO: miro si me puedo ahorrar la petición
            let bingo = false;
            // obtengo los zooms de candgen de mayor a menor
            // (para empezar por las celdas de similar tamaño y así ahorrarme la comprobación del bounds)
            const zooms = Object.keys(candgen).map(Number).sort((a, b)=>b - a);
            cuentaLoop: for (const z of zooms){
                for(const tx in candgen[z])for (const et of candgen[z][tx]){
                    // compruebo si la cuenta de una celda más general es 0											
                    if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[et] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[et][caso] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[et][caso].ntrees == 0) {
                        bingo = true;
                        mycell[caso].ntrees = 0;
                        break cuentaLoop;
                    } else if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[et] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[et][caso] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[et][caso].trees != undefined) {
                        bingo = true;
                        // inicializo datos
                        mycell[caso].trees = [];
                        mycell[caso].ntrees = 0;
                        // si no coincide el zoom obtengo los bounds para comprobar si el árbol cae dentro
                        const bounds = z != objcell.zoom ? (0, $0a5d75214fa44e03$export$4e23e15d2ccb71f7)(objcell.cellX, objcell.cellY, objcell.zoom) : null;
                        // miro árbol a árbol en la celda más general en la que me baso							
                        for (const arbiri of (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[et][caso].trees){
                            const arb = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[arbiri];
                            // si no coincide el zoom tengo que comprobar que el árbol esté contenido en la celda
                            const llarb = L.latLng(arb.lat, (0, $69f04ba581843b2d$export$a4829058f9fe1646)(arb.lng, objcell.cellX, objcell.zoom));
                            if (bounds && !bounds.contains(llarb)) continue; // siguiente árbol...
                            // si hay filtro de taxón compruebo que esté incluido
                            if (objcell.taxon) {
                                const spuri = (0, $1ee989753a15371d$export$fa0799b379eb3758)(arb.species);
                                if (spuri == undefined || !(0, $2q7Wm.default).contains((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[objcell.taxon].expuris, spuri)) continue; // siguiente árbol...
                            }
                            // si llega aquí está todo bien e incluyo los datos
                            mycell[caso].trees.push(arbiri);
                            mycell[caso].ntrees++;
                        }
                        break cuentaLoop;
                    }
                }
            }
            // FIN CACHEO			
            if (!bingo) {
                // pido número de árboles de la celda
                // hago la llamada a CRAFTS	y espero resultados
                objcell.npc.push(1);
                const temp = caso === "ifn" ? (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.queryCountTreesinbox : (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.queryCountEducatreesinbox;
                const datos = await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).getData(temp, qobj);
                // inicializo (por si acaso, pero no debería hacer falta)
                mycell[caso].ntrees = 0;
                // guardo el dato de la cuenta
                for (const row of datos.results.bindings)mycell[caso].ntrees = Number(row.count.value);
            }
        }
        // pido los datos de los árboles de la celda si no los tiene y si pasa el umbral
        if (!mycell[caso].mmil && mycell[caso].ntrees <= (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).treeThreshold && mycell[caso].ntrees > 0 && mycell[caso].trees == undefined) {
            // quito offset y pongo un límite de  1000, más que suficiente para la petición
            delete qobj.offset;
            qobj.limit = 1000;
            // hago la llamada a CRAFTS	y espero resultados
            objcell.npc.push(1);
            const temp = caso === "ifn" ? (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.queryTreesinbox : (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.queryEducatreesinbox;
            const datos = await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).getData(temp, qobj);
            // inicializo array resultados
            mycell[caso].trees = [];
            // analizo fila a fila
            for (const row of datos.results.bindings){
                // uri del árbol
                const arbiri = row.tree.value;
                // incluyo en la celda si no estaba
                if (!(0, $2q7Wm.default).contains(mycell[caso].trees, arbiri)) mycell[caso].trees.push(arbiri);
                // guardo objeto con datos del árbol si no estaba
                if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[arbiri] == undefined) {
                    // aquí divido el procesamiento según el caso
                    if (caso === "ifn") {
                        if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[arbiri] == undefined) (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[arbiri] = {};
                        let arbobj = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[arbiri];
                        // guardo uri (sólo si no existía)
                        // NOTA: para árboles del IFN uso clave "uri" en vez de "iri"
                        // así los distingo fácilmente de los edutrees
                        if (arbobj.uri == undefined) arbobj.uri = arbiri;
                        // guardo posición (sólo si no existía)
                        if (arbobj.lat == undefined) arbobj.lat = Number(row.lat.value);
                        if (arbobj.lng == undefined) arbobj.lng = Number(row.lng.value);
                        // guardo cada medida (sólo si no existían)
                        if (arbobj.dbh1mm == undefined) arbobj.dbh1mm = Number(row.dbh1mm.value);
                        if (arbobj.dbh2mm == undefined) arbobj.dbh2mm = Number(row.dbh2mm.value);
                        if (arbobj.heightM == undefined) arbobj.heightM = Number(row.heightM.value);
                        // guardo especie (sólo si no existía)
                        if (arbobj.species == undefined && row.type != undefined) arbobj.species = row.type.value;
                    } else (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[arbiri] = {
                        'iri': arbiri,
                        'lat': Number(row.lat.value),
                        'lng': Number(row.lng.value),
                        'pending': true // clave para recuperar los datos en la siguiente petición
                    };
                }
            }
        }
        // caso "edu", recupero árboles si es necesario
        if (caso === "edu" && mycell[caso].trees != undefined) {
            // obtengo los edutrees pendientes de recuperar
            let eiris = [];
            for (const eiri of mycell[caso].trees)if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[eiri].pending) eiris.push(eiri);
            // pido descomponer en objetos para la llamada resources de CRAFTS	
            const objrs = $174d363c054274ef$var$descomponerCraftsResources('BasicEducaTree', eiris);
            // ya tengo los objetos a pedir, lanzo las peticiones en paralelo a CRAFTS
            let promesas = [];
            for (const objr of objrs)// creo una promesa para cada petición
            promesas.push(new Promise(async function(resolve, reject) {
                try {
                    // hago la llamada a CRAFTS	y espero resultados
                    objcell.npc.push(1);
                    let datos = await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).getData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.resourcesTemplate, objr);
                    // convierto en array si es necesario
                    if (!Array.isArray(datos)) datos = [
                        datos
                    ];
                    // y actualizo educatree a educatree
                    for (const eobj of datos)// si está pendiente reemplazo y a volar
                    if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[eobj.iri].pending) (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[eobj.iri] = eobj;
                    // resuelvo la promesa
                    resolve(true);
                } catch (err) {
                    reject(err);
                }
            }));
            try {
                // espero a que terminen todas las promesas
                await Promise.all(promesas);
            } catch (err) {
                console.error(err);
            }
        }
        // si hay que colocar un cluster entonces obtengo la localización de un árbol aleatorio de 0 a config.treeThreshold
        if (!mycell[caso].mmil && mycell[caso].ntrees > (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).treeThreshold && mycell[caso].locCluster == undefined) {
            // número aleatorio entre 0 y mycell[caso].ntrees (en vez de config.treeThreshold)
            qobj.offset = Math.floor(Math.random() * mycell[caso].ntrees);
            qobj.limit = 1; // sólo quiero un árbol
            // hago la llamada a CRAFTS	y espero resultados
            objcell.npc.push(1);
            const template = caso === "ifn" ? (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.queryTreesinboxbasico : (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.queryEducatreesinbox;
            const datos = await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).getData(template, qobj);
            // inicializo la localización
            mycell[caso].locCluster = null;
            // analizo primera fila, si la hay
            if (datos.results.bindings.length > 0) mycell[caso].locCluster = {
                lat: Number(datos.results.bindings[0].lat.value),
                lng: Number(datos.results.bindings[0].lng.value)
            };
        }
        // fue todo bien, resuelvo la promesa
        return Promise.resolve();
    } catch (err) {
        // si hay algún error rechazo la promesa
        console.error(err);
        return Promise.reject(err);
    }
}







/////////////////////////
// INICIALIZACIÓN FIREBASE
/////////////////////////
let $c0304d280c7b00cb$var$app;
let $c0304d280c7b00cb$var$provider;
function $c0304d280c7b00cb$export$54387eca9e368edc() {
    // TODO: config.firebaseConfig.authDomain: "localhost", // cambiar en producción a "educawood.gsic.uva.es",
    if (!$c0304d280c7b00cb$var$app) $c0304d280c7b00cb$var$app = (0, $fhN3L.initializeApp)((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).firebaseConfig);
    return $c0304d280c7b00cb$var$app;
}
/////////////////////////
// AUTENTICACIÓN FIREBASE
/////////////////////////
function $c0304d280c7b00cb$export$bba3f520b3fdb18() {
    // inicialización
    $c0304d280c7b00cb$var$provider = new (0, $6AR8M.GoogleAuthProvider)();
    const auth = (0, $6AR8M.getAuth)();
    auth.useDeviceLanguage();
    // handler para detectar si hay usuario
    (0, $6AR8M.onAuthStateChanged)(auth, async (user)=>{
        if (user) {
            // User is signed in, see docs for a list of available properties
            // https://firebase.google.com/docs/reference/js/firebase.User
            //var uid = user.uid;
            // ...
            console.info("Usuario conectado: " + user.uid);
            // guardo el usuario en la sesión
            (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario = user;
            // envío datos signin a GA
            (0, $067277e156f7a571$export$7329bcdc3edcd90e)("login", {
                method: "Google",
                uid: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid
            });
            // muestro avatar con dropdown de signout (MAPA)
            const htmluser = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$d4de91556d149ac6), {
                "img": (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.photoURL
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".usuario").html(htmluser);
            // pido a CRAFTS los datos del usuario si no lo tengo
            await (0, $174d363c054274ef$export$3f90b926bc531097)((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid);
        } else {
            //console.warn("EL USUARIO SE SALIÓ..."); // 
            console.info("El usuario se sali\xf3...");
            // envío datos signout a GA
            (0, $067277e156f7a571$export$7329bcdc3edcd90e)("sign_out");
            // borro usuario de la sesión
            delete (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario;
            // muestro botón de signin (MAPA)
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".usuario").html((0, $646ceeeec66fabd8$export$eaebbbf45ac961b6));
        }
        // pongo listeners a clickViewprofile, clickSignin y clickSignout
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".userprofile").click($c0304d280c7b00cb$export$f98b6673fafc0e20);
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".usersignin").click($c0304d280c7b00cb$export$9ffe63492d76c086);
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".usersignout").click($c0304d280c7b00cb$export$daa0a882204fd973);
        // ajustes del mapa botón de creación
        (0, $3a9989d46007ef73$export$7c626a07c7c69914)();
        // AJUSTES SEGÚN LA PANTALLA
        switch((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.path){
            case "user":
                // regenero página usuario
                $c0304d280c7b00cb$var$renderUsuario();
                break;
            case "lasttrees":
                // regenero página lasttrees
                (0, $82a71c896f160eac$export$afe524c3a091be69)();
                break;
            case "tree":
                // regenero página árbol
                (0, $27fe9e683b34e1a0$export$d096c03518bc83df)();
                break;
            case "newtree":
                // regenero formulario creación árbol
                (0, $3a9989d46007ef73$export$da02fee09afb84d)();
                break;
        } // fin del switch		
    });
}
function $c0304d280c7b00cb$export$9ffe63492d76c086(e) {
    e.preventDefault(); // Prevent the default behavior of the hyperlink
    const auth = (0, $6AR8M.getAuth)();
    (0, $6AR8M.signInWithRedirect)(auth, $c0304d280c7b00cb$var$provider);
}
function $c0304d280c7b00cb$export$daa0a882204fd973(e) {
    e.preventDefault(); // Prevent the default behavior of the hyperlink
    const auth = (0, $6AR8M.getAuth)();
    (0, $6AR8M.signOut)(auth);
}
function $c0304d280c7b00cb$export$f98b6673fafc0e20() {
    // voy a la página del usuario							
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.path = "user";
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid;
    // reajusto url y creo nueva página en la historia
    history.pushState((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado, "", (0, $ffd94e1d81f19b1c$export$e5c8c113a1c69275)());
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).npags++; // una página más
    // cargoURL => me llevará a verUsuario
    (0, $ffd94e1d81f19b1c$export$db4341b92d8f97b0)();
}
////////////////////
// PÁGINA DE USUARIO
////////////////////
async function $c0304d280c7b00cb$export$d4acb3475854cdbb(noborrarcache) {
    // pongo spinner con mensaje de cargando	
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#miarbol").html((0, $646ceeeec66fabd8$export$27eb5f8cf2bf64a7));
    window.scrollTo(0, 0);
    // inicializo el evento para enviar a GA
    (0, $067277e156f7a571$export$639f48199cd2287d)({
        content_type: 'user',
        content_id: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/user/" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid,
        crafts_reqs: 0
    });
    // quito el cacheo si se trata del usuario de la sesión (porque puede haber producido datos nuevos)
    if (!noborrarcache && (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario && (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid === (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid) {
        delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid];
        delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid];
        delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid];
    }
    // pido datos a CRAFTS del usuario
    await (0, $174d363c054274ef$export$3f90b926bc531097)((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid);
    // pido datos a CRAFTS de las páginas de educatrees del usuario
    const pe = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pe ? (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pe : 0; // por defecto la 0
    const pae = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pae ? (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pae : 0; // por defecto la 0
    await (0, $174d363c054274ef$export$5f671086e5404234)(pe, pae, (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid);
    // si están mal ajustadas las páginas (por no tener resultados y no ser 0), reajusto la URL
    let actualizar = false;
    if (pe > 0 && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid][pe].length == 0) {
        delete (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pe;
        actualizar = true;
    }
    if (pae > 0 && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid][pae].length == 0) {
        delete (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pae;
        actualizar = true;
    }
    if (actualizar) {
        //console.log("URL nueva: "+obtenerURL());
        // actualizo URL
        history.replaceState((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado, "", (0, $ffd94e1d81f19b1c$export$e5c8c113a1c69275)());
        // y cargo la URL para que obtenga los datos de nuevo
        //cargarURL();
        $c0304d280c7b00cb$export$d4acb3475854cdbb(true);
        return;
    }
    // caso normal: hago el render
    $c0304d280c7b00cb$var$renderUsuario();
}
async function $c0304d280c7b00cb$var$renderUsuario() {
    // detecto llamada espúrea por la autenticación
    if (!(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid] || !(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid] || !(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid]) return;
    // obtengo info básica del usuario
    const iri = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/user/" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid;
    const udata = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid];
    const uname = (0, $96abbdd7193a3c4b$export$6efd817d0963408a)(udata);
    const usesion = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario && (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid === (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid;
    const ufecha = (0, $96abbdd7193a3c4b$export$aa350b96d91cd94)(udata);
    const pe = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pe ? (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pe : 0; // por defecto la 0
    const pae = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pae ? (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pae : 0; // por defecto la 0
    // resto el número de árboles del de anotaciones (incluidas en las consultas)
    const numanots = udata.numberOfAnnotations ? udata.numberOfEducatrees ? udata.numberOfAnnotations - udata.numberOfEducatrees : udata.numberOfAnnotations : null;
    // si hay nick reajusto título de la página
    if (udata.nick) document.title = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(udata.nick) + ' - EducaWood';
    // si no tiene ninguna anotación y no es el usuario de la sesión, asumo que no existe
    if (!udata.numberOfAnnotations && !udata.numberOfEducatrees && !usesion) {
        $c0304d280c7b00cb$var$usuarioNoExiste();
        return;
    }
    // preparo objeto plantilla
    const objut = {
        uid: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid,
        usuario: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario != undefined,
        usuarioImg: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario ? (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.photoURL : null,
        name: uname,
        nickButtonLabel: usesion ? udata.nick ? (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).changeNick) : (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).newNick) : null,
        img: usesion ? (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.photoURL : null,
        activeLabel: udata.created ? (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).userActive) + ufecha : null,
        master: udata.isMasterAnnotator,
        cannotAnnotate: udata.cannotAnnotate,
        edutreesLabel: udata.numberOfEducatrees ? udata.numberOfEducatrees == 1 ? (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).oneTreeCreated) : (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).multipleTreesCreated).replace('%d', udata.numberOfEducatrees) : null,
        annotationsLabel: numanots ? numanots == 1 ? (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).oneAnnotation) : (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).multipleAnnotations).replace('%d', numanots) : null,
        showann: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.showann
    };
    // ultEducatrees
    const uet = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid][pe];
    objut.hayUltedutrees = uet.length > 0;
    objut.hayUltedutreesPrev = pe > 0;
    objut.hayUltedutreesSig = uet.length > (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).pageus;
    objut.pagUltedutrees = pe + 1;
    objut.ultedutrees = [];
    for(let i = 0; i < uet.length && i < (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).pageus; i++){
        const uetel = uet[i];
        const etid = uetel.iri.split("/")[uetel.iri.split("/").length - 1];
        // cojo primero el nick en Datos.educatrees[iri] (por si actualizó su nick),
        // en segunda opción el nick del objeto y si no, el etid
        const etl = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[uetel.iri] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[uetel.iri].nick ? (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[uetel.iri].nick) : uetel.nick ? (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(uetel.nick) : (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tree) + " " + etid;
        const htmledutree = '<a href="/tree/' + etid + '" etid="' + etid + '" class="educatree">' + etl + '</a><div class="text-muted">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).createdOn) + (0, $96abbdd7193a3c4b$export$aa350b96d91cd94)(uetel) + '</div>';
        objut.ultedutrees.push(htmledutree);
    }
    // ultAnotaciones
    const uaet = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid][pae];
    objut.hayUltanns = uaet.length > 0;
    objut.hayUltannsPrev = pae > 0;
    objut.hayUltannsSig = uaet.length > (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).pageus;
    objut.pagUltanns = pae + 1;
    objut.ultanns = [];
    for(let i = 0; i < uaet.length && i < (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).pageus; i++){
        const uaetel = uaet[i];
        const etid = uaetel.iri.split("/")[uaetel.iri.split("/").length - 1];
        // cojo primero el nick en Datos.educatrees[iri] (por si actualizó su nick),
        // en segunda opción el nick del objeto y si no, el etid
        const etl = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[uaetel.iri] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[uaetel.iri].nick ? (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[uaetel.iri].nick) : uaetel.nick ? (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(uaetel.nick) : (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tree) + " " + etid;
        // preparo htmlann con cuidado
        //const label = getLiteral(config.annotationTypeLabels.[uaetel.type], getLiteral(config.annotationTypeLabels.pordefecto))
        const atl = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).annotationTypeLabels[uaetel.type];
        const htmlann = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(atl, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).annotationTypeLabels.pordefecto)) + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).ofTree) + ' <a href="/tree/' + etid + '" etid="' + etid + '" class="educatree">' + etl + '</a><div class="text-muted">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).annotatedOn) + (0, $96abbdd7193a3c4b$export$aa350b96d91cd94)(uaetel) + '</div>';
        objut.ultanns.push(htmlann);
    }
    // renderizo
    const htmlcontent = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$a76d078e0f25e96f), objut);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#miarbol").html(htmlcontent);
    // envío GA evento ver página usuario
    (0, $067277e156f7a571$export$6adbd77fe07ba13)();
    console.info("P\xe1gina usuario cargada: " + iri);
    // pongo listener de botones de volver
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".goback").on("click", (0, $ffd94e1d81f19b1c$export$28fca2ccfd38b8f));
    // pongo listeners a clickViewprofile, clickSignin y clickSignout
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".userprofile").click($c0304d280c7b00cb$export$f98b6673fafc0e20);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".usersignin").click($c0304d280c7b00cb$export$9ffe63492d76c086);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".usersignout").click($c0304d280c7b00cb$export$daa0a882204fd973);
    // listener a changeNick
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#changeNick").click($c0304d280c7b00cb$var$changeNick);
    // handlers de páginas
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".pagina").click(function() {
        // detecto target de la página
        let target = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass("created") ? "pe" : "pae";
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.showann = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass("annotated");
        // detecto si retrocedo o avanzo
        if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass("prev")) {
            (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado[target]--;
            if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado[target] == 0) delete (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado[target];
        } else if (!(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado[target]) (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado[target] = 1;
        else (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado[target]++;
        // actualizo URL
        history.replaceState((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado, "", (0, $ffd94e1d81f19b1c$export$e5c8c113a1c69275)());
        // y cargo la URL para que obtenga los datos de nuevo
        $c0304d280c7b00cb$export$d4acb3475854cdbb(true);
    });
}

function $c0304d280c7b00cb$var$changeNick() {
    // preparo contenido modal
    let tit = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).newNick);
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        vertcent: true,
        static: true
    }, tit, (0, $646ceeeec66fabd8$export$af3959eda01cc433), (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).cambiarNick);
    // muestro modal
    const mimodal = new (0, (/*@__PURE__*/$parcel$interopDefault($dktVJ))).Modal(document.getElementById('mimodal'));
    mimodal.show();
    // listener de cambio de nick
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#newNick").change(function() {
        const newnick = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#newNick').val();
        // preinicializo
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").removeClass("d-none");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botonCambioNick").prop("disabled", true);
        if (!newnick) //console.log("No hay nada");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noNick));
        else if (newnick.length < 3) //console.log("Fuera de rango");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).nickTooshort));
        else if (newnick.length > 20) //console.log("Fuera de rango");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).nickToolong));
        else {
            //console.log("Todo OK");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").addClass("d-none");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botonCambioNick").prop("disabled", false);
        }
    });
    // listener del botón de cambio de nick
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botonCambioNick").click(async function() {
        // desabilito la entrada, cambio el tip y quito el footer
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#newNick").prop("disabled", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").removeClass("d-none");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).checkingNick));
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
            vertcent: true,
            static: true,
            nofooter: true
        }, null, null, null);
        // recupero el nick y compruebo si existe
        const newnick = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#newNick').val();
        const existe = await (0, $174d363c054274ef$export$9efbb920d7dd157b)(newnick);
        if (existe) {
            // no puede hacerse el cambio
            (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
                vertcent: true,
                static: true,
                nofooter: false
            }, null, null, null);
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#newNick").prop("disabled", false);
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).nickTaken));
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botonCambioNick").prop("disabled", true);
        } else {
            // inicializo evento nuevo nick a GA
            (0, $067277e156f7a571$export$639f48199cd2287d)({
                value: newnick,
                crafts_reqs: 0
            });
            // vamos con el cambio
            try {
                // preparo patch con el cambio de nick
                const patch = [];
                const oper = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid].nick ? "replace" : "add";
                patch.push({
                    op: oper,
                    path: "/nick",
                    value: newnick
                });
                //console.log(patch);
                await (0, $174d363c054274ef$export$b5be548bb8509ea6)((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid, patch);
                // envío evento nuevo nick a GA
                (0, $067277e156f7a571$export$6adbd77fe07ba13)('new_nick');
                console.info("Nick del usuario cambiado: " + newnick);
            } catch (err) {
                console.error(err.message);
                // actualizo modal
                const be = "<code>" + err.message + "\n" + JSON.stringify(err.error) + "</code>";
                (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
                    static: true,
                    vertcent: true
                }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).changeNickFailure), be, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).anotacionError);
                return; // terminamos
            }
            // modal de éxito
            // escondo campos y muestro imagen
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#newNick").addClass("d-none");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").addClass("d-none");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#imgNewNick").attr("src", new URL($083e2ee32f3551b0$exports));
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#imgNewNick").removeClass("d-none");
            //const htmlbody = '<img src="/app/images/newNick.png" class="d-block w-100">';
            (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
                vertcent: true,
                static: true
            }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).changeNickSuccess), null, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).nickCambiado);
            // listener cierre modal
            document.getElementById('mimodal').addEventListener('hidden.bs.modal', (event)=>{
                $c0304d280c7b00cb$var$renderUsuario();
            }, {
                once: true
            });
        }
    });
}
function $c0304d280c7b00cb$var$usuarioNoExiste() {
    // pongo página en blanco
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#miarbol").html("");
    // pongo un modal
    const body = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).errorUserText) + ' "' + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid + '".';
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        vertcent: true,
        nofooter: true
    }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).errorUserTitle), body, null);
    const mimodal = new (0, (/*@__PURE__*/$parcel$interopDefault($dktVJ))).Modal(document.getElementById('mimodal'));
    mimodal.show();
    // handler al esconderse
    document.getElementById('mimodal').addEventListener('hidden.bs.modal', (event)=>{
        // voy para atrás
        (0, $ffd94e1d81f19b1c$export$28fca2ccfd38b8f)();
    }, {
        'once': true
    });
}


/*
   Copyright 2023, Guillermo Vega-Gorgojo
   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at
       http://www.apache.org/licenses/LICENSE-2.0
   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ 
var $33Kba = parcelRequire("33Kba");


/////////////// SOLR
function $3d46cc2f44b0084a$export$cb8a624b93d2efe9(suggestPath, selectPath) {
    // inicialización de opciones
    const options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    };
    // test 
    this.test = async function() {
        // pruebo las sugerencias
        //console.debug(suggestPath);
        const sug = await fetch(suggestPath, options);
        if (sug.ok) {
            // fue bien, pruebo la selección
            //console.debug(selectPath);
            const sel = await fetch(selectPath, options);
            if (sel.ok) return Promise.resolve(true);
            else {
                // logging del error
                const mens = 'SOLR error - url: ' + selectPath + ' - code: ' + sel.status + ' - mens: ' + sel.statusText;
                // rechazo la promesa
                return Promise.reject(mens);
            }
        } else {
            // logging del error
            const mens = 'SOLR error - url: ' + suggestPath + ' - code: ' + sug.status + ' - mens: ' + sug.statusText;
            // rechazo la promesa
            return Promise.reject(mens);
        }
    };
    // petición sugerencias
    this.getSuggestions = async function(input) {
        // preparo la url de la petición
        const url = suggestPath + (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).solrConfig.suggestTemplate, {
            'input': input
        });
        // hago petición
        const datos = await this.getData(url);
        return datos;
    };
    // petición documento
    this.getDocument = async function(id) {
        // preparo la url de la petición
        const url = selectPath + (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).solrConfig.selectTemplate, {
            'id': id
        });
        // hago petición
        const datos = await this.getData(url);
        return datos;
    };
    this.getData = async function(url) {
        // hago log de la url
        //console.debug(url);
        // hago la petición
        const response = await fetch(url, options);
        if (response.ok) {
            // petición exitosa
            const datos = await response.json();
            // devuelvo los datos
            return Promise.resolve(datos);
        } else {
            const eobj = {
                status: response.status,
                url: url,
                mens: 'SOLR error - url: ' + url + ' - code: ' + response.status + ' - mens: ' + response.statusText
            };
            // rechazo la promesa
            return Promise.reject(eobj);
        }
    };
}
/////////////// CRAFTS
function $3d46cc2f44b0084a$export$c5d3759345e26cd8(craftsConfig) {
    // inicialización de opciones
    const options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': craftsConfig.auth
        }
    };
    // test 
    this.test = async function() {
        // ajusto método
        options.method = 'GET';
        // hago log de la url de prueba
        console.debug(craftsConfig.api);
        const response = await fetch(craftsConfig.api, options);
        if (response.ok) return Promise.resolve(true);
        else {
            // logging del error
            // leo la respuesta del error
            const resperr = await response.json();
            const eobj = {
                message: 'CRAFTS error: ' + resperr.message,
                error: {
                    url: craftsConfig.api,
                    status: response.status,
                    statusText: response.statusText
                }
            };
            // rechazo la promesa
            return Promise.reject(eobj);
        }
    };
    // petición tipo GET de CRAFTS
    this.getData = async function(template, objpars) {
        // ajusto método y body
        options.method = 'GET';
        delete options.body;
        // preparo la url de la petición
        const url = craftsConfig.api + (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render(template, objpars);
        // hago log de la url
        console.debug(url);
        // info para GA
        (0, $067277e156f7a571$export$2db6ab9500fc86e)('crafts_reqs', 1);
        // hago la petición
        const response = await fetch(url, options);
        if (response.ok) {
            // petición exitosa
            const datos = await response.json();
            // devuelvo los datos
            return Promise.resolve(datos);
        } else {
            // leo la respuesta del error
            const resperr = await response.json();
            const eobj = {
                message: 'CRAFTS error: ' + resperr.message,
                error: {
                    url: url,
                    status: response.status,
                    statusText: response.statusText
                }
            };
            // rechazo la promesa
            return Promise.reject(eobj);
        }
    };
    // petición tipo PUT de CRAFTS
    this.putData = async function(template, objpars, objdata) {
        // ajusto método y body
        options.method = 'PUT';
        if (objdata) options.body = JSON.stringify(objdata);
        // preparo la url de la petición
        const url = craftsConfig.api + (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render(template, objpars);
        // hago log de la url
        console.debug(url);
        // info para GA
        (0, $067277e156f7a571$export$2db6ab9500fc86e)('crafts_reqs', 1);
        // hago la petición
        const response = await fetch(url, options);
        if (response.ok) // devuelvo la respuesta
        return Promise.resolve(response);
        else {
            // leo la respuesta del error
            const resperr = await response.json();
            const eobj = {
                message: 'CRAFTS error: ' + resperr.message,
                error: {
                    url: url,
                    status: response.status,
                    statusText: response.statusText
                }
            };
            // rechazo la promesa
            return Promise.reject(eobj);
        }
    };
    // petición tipo PATCH de CRAFTS
    this.patchData = async function(template, objpars, objdata) {
        // ajusto método y body
        options.method = 'PATCH';
        if (objdata) options.body = JSON.stringify(objdata);
        // preparo la url de la petición
        const url = craftsConfig.api + (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render(template, objpars);
        // hago log de la url
        console.debug(url);
        // info para GA
        (0, $067277e156f7a571$export$2db6ab9500fc86e)('crafts_reqs', 1);
        // hago la petición
        const response = await fetch(url, options);
        if (response.ok) // devuelvo la respuesta
        return Promise.resolve(response);
        else {
            // leo la respuesta del error
            const resperr = await response.json();
            const eobj = {
                message: 'CRAFTS error: ' + resperr.message,
                error: {
                    url: url,
                    status: response.status,
                    statusText: response.statusText
                }
            };
            // rechazo la promesa
            return Promise.reject(eobj);
        }
    };
    // petición tipo DELETE de CRAFTS
    this.deleteData = async function(template, objpars) {
        // ajusto método y body
        options.method = 'DELETE';
        delete options.body;
        // preparo la url de la petición
        const url = craftsConfig.api + (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render(template, objpars);
        // hago log de la url
        console.debug(url);
        // info para GA
        (0, $067277e156f7a571$export$2db6ab9500fc86e)('crafts_reqs', 1);
        // hago la petición
        const response = await fetch(url, options);
        if (response.ok) // devuelvo la respuesta
        return Promise.resolve(response);
        else {
            // leo la respuesta del error
            const resperr = await response.json();
            const eobj = {
                message: 'CRAFTS error: ' + resperr.message,
                error: {
                    url: url,
                    status: response.status,
                    statusText: response.statusText
                }
            };
            // rechazo la promesa
            return Promise.reject(eobj);
        }
    };
}













// variables globales
let $ffd94e1d81f19b1c$export$7d414ec76c8c1259, $ffd94e1d81f19b1c$export$af4650068b70eb5d, $ffd94e1d81f19b1c$export$89312ce47c0ca777, $ffd94e1d81f19b1c$export$aabd6129ce9bddee, $ffd94e1d81f19b1c$export$6573f87b6f05c3d2, $ffd94e1d81f19b1c$export$afbe3be7a2115be4, $ffd94e1d81f19b1c$export$c398d137cd63b259, $ffd94e1d81f19b1c$var$mimodal;
// llamo a inicializar
$ffd94e1d81f19b1c$var$inicializar();
// INICIALIZACIÓN APLICACIÓN
async function $ffd94e1d81f19b1c$var$inicializar() {
    // genero plantillas HTML
    (0, $646ceeeec66fabd8$export$5e43259f1480bd05)();
    // modal de carga
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        static: true,
        vertcent: true,
        nofooter: true,
        spinner: true,
        spinnerMessage: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).confdata)
    }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).starting), null, null);
    $ffd94e1d81f19b1c$var$mimodal = new (0, (/*@__PURE__*/$parcel$interopDefault($dktVJ))).Modal(document.getElementById('mimodal'));
    $ffd94e1d81f19b1c$var$mimodal.show();
    // INICIALIZO Layers
    $ffd94e1d81f19b1c$export$89312ce47c0ca777 = {};
    // INICIALIZACIÓN SESIÓN
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259 = {};
    // inicializo número de páginas en la historia para controlar el ir hacia atrás
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.npags = 0;
    // inicializo timeouts
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.timeout = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).timeout;
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.huboTimeout = false;
    // bloqueo para pintar
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.actualizandoMapa = false; // bloqueo si se está actualizando el mapa
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.mapaMovido = false; // detecto si el mapa se movió para actualizar
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.idTimeoutActualizar = null; // id del timeout para actualización automática (para que no se bloquee)
    // no está dibujando el polígono de descarga
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.poligonero = false;
    // flag creación árbol
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.creandoArbol = false;
    // estado de la sesión (construido a partir de la URL)
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado = {};
    // inicialización zoom
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.zoom = undefined;
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.zoomPrevio = undefined;
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.zoomUsados = {}; // guardo los zooms usados en el mapa para facilitar el cacheo
    // progreso y estadísticos
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.infoCeldas = {};
    // inicializo nombres científicos con el valor de nomci en local storage o false
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.nomci = localStorage.getItem('nomci') === "true" ? true : false;
    //datos del filtro de taxón
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.tx = undefined;
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.txPrevio = undefined;
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.txUsados = {}; // guardo los taxones usados en el mapa para facilitar el cacheo
    // inicializo sugerencias taxones 
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.txfocus = -1;
    // inicializo color a uno de los posibles
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.txcolor = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).coltxinds[Math.floor(Math.random() * (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).coltxinds.length)];
    // inicializo las celdas y árboles pintados
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.celdasPintadas = {};
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.arbsPintados = {};
    // muestro tooltips si no es un touchscreen
    //Sesion.hayTooltips = 'ontouchstart' in window? false : true;
    // INICIALIZO DATOS
    $ffd94e1d81f19b1c$export$af4650068b70eb5d = {};
    $ffd94e1d81f19b1c$export$af4650068b70eb5d.especies = {};
    $ffd94e1d81f19b1c$export$af4650068b70eb5d.partesPlantasFoto = {};
    $ffd94e1d81f19b1c$export$af4650068b70eb5d.arboles = {}; // aquí meto la información de cada árbol del mapa
    $ffd94e1d81f19b1c$export$af4650068b70eb5d.educatrees = {}; // aquí meto la información de los educatrees para edición
    $ffd94e1d81f19b1c$export$af4650068b70eb5d.cellSide = {}; // aquí calculo el lado de cada celda por nivel de zoom
    $ffd94e1d81f19b1c$export$af4650068b70eb5d.celdasArboles = {}; // aquí meto la info de árboles de cada celda
    $ffd94e1d81f19b1c$export$af4650068b70eb5d.usuarios = {}; // aquí obtengo los datos de los usuarios (posiblemente 0 o 1)
    $ffd94e1d81f19b1c$export$af4650068b70eb5d.ultEducatrees = {}; // aquí obtengo el listado paginado de los últimos educatrees creados tanto globales (key: "global") como por usuario (key: uid) 
    $ffd94e1d81f19b1c$export$af4650068b70eb5d.ultAnotaciones = {}; // aquí obtengo el listado paginado de las últimas anotaciones a educatrees anotados tanto globales (key: "global") como por usuario (key: uid) 
    $ffd94e1d81f19b1c$export$af4650068b70eb5d.urlAPIWD = {}; // aquí guardo las respuestas de la API de Wikidata
    $ffd94e1d81f19b1c$export$af4650068b70eb5d.esTaxonWD = {}; // aquí guardo si una entidad de Wikidata es un taxón (según la consulta validTaxons)
    $ffd94e1d81f19b1c$export$af4650068b70eb5d.taxonesWD = {}; // aquí guardo los datos de los taxones extraídos de Wikidata (recurso WikidataTaxon)
    // CARGA INICIAL DE LA URL
    // 1) carga localización si la hay
    // 2) carga taxon sin comprobar existencia
    // 3) ajusta vista
    // 4) no hace nada en el mapa (que no está aún creado)
    $ffd94e1d81f19b1c$export$db4341b92d8f97b0(true);
    // SI NO HAY POSICIÓN INICIAL Y ESTÁ EN MODO MAPA, CARGO LA DE LA CONFIGURACIÓN Y PEDIRÉ GEOPOSICIONAR
    let pedirgeopos = false;
    if (!$ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.loc) {
        $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.loc = {
            lat: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).geolocstart[0],
            lng: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).geolocstart[1],
            z: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zStart
        };
        if ($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path === 'map' && !localStorage.getItem('tourCompletado')) pedirgeopos = true;
    }
    // CARGO MAPA CON LA LOCALIZACIÓN DE LA CONFIGURACIÓN
    // meto tap: false, que parece es una fuente de problemas
    // dec-23: incluyo scrollWheelZoom: 'center' para reducir saltos raros con el zoom en el ratón de Apple
    // dec-23: pongo preferCanvas: true que mejora mucho el borrado (y el resto parece que sigue bien)	
    $ffd94e1d81f19b1c$export$aabd6129ce9bddee = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).map('mimapa', {
        zoomControl: false,
        tap: false,
        scrollWheelZoom: 'center',
        preferCanvas: true
    }).setView([
        $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.loc.lat,
        $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.loc.lng
    ], $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.loc.z);
    // cargo el tile layer que corresponda tras cargar la URL
    const { url: url, opts: opts } = (0, $69f04ba581843b2d$export$c1c1414601191e71)(false);
    $ffd94e1d81f19b1c$export$6573f87b6f05c3d2 = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).tileLayer(url, opts).addTo($ffd94e1d81f19b1c$export$aabd6129ce9bddee);
    // REPOSICIONO CONTROLES DE ZOOM Y MUESTRO ESCALA DEL MAPA
    (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).control.scale({
        imperial: false,
        position: 'bottomright'
    }).addTo($ffd94e1d81f19b1c$export$aabd6129ce9bddee); // sin la escala imperial
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Browser.mobile) (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).control.zoom({
        position: 'bottomright',
        zoomInTitle: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).zoomin),
        zoomOutTitle: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).zoomout)
    }).addTo($ffd94e1d81f19b1c$export$aabd6129ce9bddee);
    // INCLUYO BOTÓN DE MI LOCALIZACIÓN CON Leaflet.Locate (ver https://github.com/domoritz/leaflet-locatecontrol)
    (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).control.locate({
        position: 'bottomright',
        icon: 'bi bi-geo-fill',
        locateOptions: {
            animate: true,
            duration: 1
        },
        initialZoomLevel: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zCreacion,
        flyTo: true,
        showPopup: false,
        drawCircle: false,
        showCompass: true,
        strings: {
            title: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).mylocation)
        }
    }).addTo($ffd94e1d81f19b1c$export$aabd6129ce9bddee);
    // cambio estilo del control de mi posición y mando evento de activate_my_location o deactivate_my_location a GA
    $ffd94e1d81f19b1c$export$aabd6129ce9bddee.on("locateactivate", function(e) {
        // estilo botón en modo edición
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".leaflet-control-locate a").attr("style", "background-color: #6c757d;");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".leaflet-control-locate a span").attr("style", "color: white;");
        (0, $067277e156f7a571$export$7329bcdc3edcd90e)('select_content', {
            content_type: 'activate_my_location'
        });
    });
    $ffd94e1d81f19b1c$export$aabd6129ce9bddee.on("locatedeactivate", function(e) {
        // estilo botón normal
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".leaflet-control-locate a").removeAttr("style");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".leaflet-control-locate a span").removeAttr("style");
        (0, $067277e156f7a571$export$7329bcdc3edcd90e)('select_content', {
            content_type: 'deactivate_my_location'
        });
    });
    // INCLUYO BOTONES DEL MAPA
    (0, $c853be3628706c6e$export$9e6c68482d899bf0)();
    // INICIALIZACIÓN FIREBASE
    (0, $c0304d280c7b00cb$export$54387eca9e368edc)();
    // INICIALIZACIÓN CRAFTS
    console.time("Configuraci\xf3n proveedor de datos");
    $ffd94e1d81f19b1c$export$afbe3be7a2115be4 = new (0, $3d46cc2f44b0084a$export$c5d3759345e26cd8)((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig);
    $ffd94e1d81f19b1c$export$afbe3be7a2115be4.test().then(()=>{
        // OK
        console.info("Proveedor de datos funciona");
        console.timeEnd("Configuraci\xf3n proveedor de datos");
        // CARGO PANEL (inicialmente desactivado el filtro de taxón)
        (0, $c853be3628706c6e$export$4412c4bf37c8e3a8)();
        // INICIALIZACIÓN AUTENTICACIÓN FIREBASE
        (0, $c0304d280c7b00cb$export$bba3f520b3fdb18)();
        // CONFIGURACIÓN SOLR
        $ffd94e1d81f19b1c$var$configurarSolr();
        // TODO: ¿hacer lo del puppeteer?
        // DETECCIÓN DE CAMBIOS EN EL MAPA
        $ffd94e1d81f19b1c$export$aabd6129ce9bddee.on('moveend', (0, $69f04ba581843b2d$export$c8207d40f45dcd81));
        $ffd94e1d81f19b1c$export$7d414ec76c8c1259.listenerMoveend = true; // para ajustar localización si hay que inicializar a la posición del usuario
        // INICIALIZACIONES CRAFTS
        console.group("Inicializaci\xf3n de datos");
        // obtengo datos de los usos para las teselas
        console.time("Carga de datos partes plantas para fotos");
        (0, $174d363c054274ef$export$c2cc3ce4ebc083ee)().then(()=>{
            console.info("Info de partes plantas para fotos cargada");
            console.timeEnd("Carga de datos partes plantas para fotos");
        }).catch((error)=>console.error(error));
        // actualizo modal
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
            static: true,
            vertcent: true,
            nofooter: true,
            spinner: true,
            spinnerMessage: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).conftaxon)
        }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).starting), null, null);
        // obtengo datos de todas las especies	
        console.time("Carga de datos de especies");
        (0, $174d363c054274ef$export$40a5140e3d2b7b8d)().then(()=>{
            console.info("Info de especies cargada");
            console.timeEnd("Carga de datos de especies");
            console.groupEnd();
            // escondo el modal (si no está mostrado pongo un listener para cerrarlo)							
            $ffd94e1d81f19b1c$var$mimodal.hide();
            document.getElementById('mimodal').addEventListener('shown.bs.modal', function() {
                $ffd94e1d81f19b1c$var$mimodal.hide();
            }, {
                once: true
            });
            // habilito el botón de filtrar por taxón (desactivado hasta ahora)
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#bot_taxones").removeAttr('disabled');
            // AQUÍ SE HACE LA PRIMERA ACTUALIZACIÓN COMPLETA DEL MAPA
            // trato el caso de filtro de taxón
            if ($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.taxon != undefined && $ffd94e1d81f19b1c$export$af4650068b70eb5d.especies[$ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.taxon] != undefined) (0, $1ee989753a15371d$export$17cdb3d0a52387b4)($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.taxon);
            else $ffd94e1d81f19b1c$export$db4341b92d8f97b0(); // aquí se eliminará el taxon espúreo si lo hubiera
        }).catch((error)=>console.error(error));
    }).catch((error)=>{
        console.error(error);
        console.timeEnd("Configuraci\xf3n proveedor de datos");
        // aviso error
        $ffd94e1d81f19b1c$var$errorProveedorDatosIrrecuperable(error);
    });
    // DETECCIÓN EVENTOS POPSTATE
    // https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
    window.onpopstate = function(event) {
        // cargo la URL
        $ffd94e1d81f19b1c$export$db4341b92d8f97b0();
    };
    // DETECCIÓN CLICKS EN ENLACES NAVBAR Y BOTÓN SANDWICH (con event delegation)
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(document).on("click", ".navbar-brand", function(e) {
        e.preventDefault(); // Prevents the default behavior of the click event
        e.stopPropagation(); // Stops the propagation of the click event
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(document).on("click", ".nav-link, .dropdown-item", function(event) {
        event.preventDefault(); // Prevent the default behavior of the hyperlink
        if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass("lasttrees")) {
            $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path = "lasttrees";
            delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.etid;
            delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.pae;
            delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.pe;
            delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.showann;
            // reajusto url y creo nueva página en la historia
            history.pushState($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado, "", $ffd94e1d81f19b1c$export$e5c8c113a1c69275());
            $ffd94e1d81f19b1c$export$7d414ec76c8c1259.npags++; // una página más
            // cargoURL => me llevará a verLasttrees
            $ffd94e1d81f19b1c$export$db4341b92d8f97b0();
        } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass("map")) {
            $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path = "map";
            delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.etid;
            delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.pae;
            delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.pe;
            delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.showann;
            // reajusto url y creo nueva página en la historia
            history.pushState($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado, "", $ffd94e1d81f19b1c$export$e5c8c113a1c69275());
            $ffd94e1d81f19b1c$export$7d414ec76c8c1259.npags++; // una página más
            // cargoURL => me llevará al mapa
            $ffd94e1d81f19b1c$export$db4341b92d8f97b0();
        } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass("home")) // landing page
        window.location.href = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).homelocrel); //'..';		
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass("lang")) {
            // recupero y actualizo idioma
            let nlang = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).attr("tag");
            localStorage.setItem('lang', nlang);
            // actualizo plantillas HTML
            (0, $646ceeeec66fabd8$export$5e43259f1480bd05)();
            // actualizo etiquetas mapa
            (0, $c853be3628706c6e$export$789fff39a6a81ff3)();
            // y cargo la URL (para las páginas no mapa)
            $ffd94e1d81f19b1c$export$db4341b92d8f97b0();
        }
    });
    // DETECCIÓN CLICKS EN ENLACES DE USUARIO (con event delegation)
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(document).on("click", ".pagusuario", function(event) {
        event.preventDefault(); // Prevent the default behavior of the hyperlink
        // voy a la página del usuario							
        $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path = "user";
        $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.etid = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).attr("uid");
        delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.pae;
        delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.pe;
        delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.showann;
        // reajusto url y creo nueva página en la historia
        history.pushState($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado, "", $ffd94e1d81f19b1c$export$e5c8c113a1c69275());
        $ffd94e1d81f19b1c$export$7d414ec76c8c1259.npags++; // una página más
        // cargoURL => me llevará a verUsuario
        $ffd94e1d81f19b1c$export$db4341b92d8f97b0();
    });
    // DETECCIÓN CLICKS EN ENLACES DE EDUCATREES (con event delegation)
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(document).on("click", ".educatree", function(event) {
        event.preventDefault(); // Prevent the default behavior of the hyperlink
        // voy a la página del usuario							
        $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path = "tree";
        $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.etid = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).attr("etid");
        delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.pae;
        delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.pe;
        delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.showann;
        // reajusto url y creo nueva página en la historia
        history.pushState($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado, "", $ffd94e1d81f19b1c$export$e5c8c113a1c69275());
        $ffd94e1d81f19b1c$export$7d414ec76c8c1259.npags++; // una página más
        // cargoURL => me llevará a verEducatree
        $ffd94e1d81f19b1c$export$db4341b92d8f97b0();
    });
    // INICIALIZO LayerGroup DE ÁRBOLES
    $ffd94e1d81f19b1c$export$89312ce47c0ca777.arbs = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).layerGroup().addTo($ffd94e1d81f19b1c$export$aabd6129ce9bddee);
    // INICIALIZO LayerGroup DE CLUSTERS DE ÁRBOLES
    $ffd94e1d81f19b1c$export$89312ce47c0ca777.clarbs = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).layerGroup().addTo($ffd94e1d81f19b1c$export$aabd6129ce9bddee);
    // GENERO ICONOS
    (0, $7b115b3c2cee4b53$export$a207d0a28bdc4e1b)();
    // TIMESTAMP ACTUAL (para geoposición y para formulario)
    const ahora = Date.now();
    // VUELO A LA POSICIÓN DEL USUARIO SI QUIERE
    // sólo si usuario no dijo que no anteriormente o ha pasado el barbecho
    if (pedirgeopos && (!localStorage.getItem('timestampPedirLoc') || Number(localStorage.getItem('timestampPedirLoc')) < ahora)) navigator.geolocation.getCurrentPosition(function(pos) {
        // vamos a la localización del usuario
        $ffd94e1d81f19b1c$export$aabd6129ce9bddee.flyTo([
            pos.coords.latitude,
            pos.coords.longitude
        ], (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zLugar, {
            animate: true,
            duration: 1
        });
        // reajusto la localización (si aún no se ha llamado al listener de 'moveend')
        if (!$ffd94e1d81f19b1c$export$7d414ec76c8c1259.listenerMoveend) $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.loc = {
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
            z: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zLugar
        };
    }, function(err) {
        // pongo barbecho si el usuario dijo que no
        // err.code 1 => https://developer.mozilla.org/en-US/docs/Web/API/GeolocationPositionError
        if (err.code == 1) localStorage.setItem('timestampPedirLoc', ahora + (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).mediumQuestGap); // barbecho de 4 días
    }, {
        timeout: 5000,
        maximumAge: 600000
    });
    // INICIALIZACIÓN CUESTIONARIO
    // variables en localStorage
    // timestampPrimeraSesion: timestamp de la primera vez que utilizó el explorador (o que pulsó el botón más tarde)
    // cuestionarioNo: no mostrar más el cuestionario
    // si no había, guardo timestamp primera sesión
    if (!localStorage.getItem('timestampPrimeraSesion')) localStorage.setItem('timestampPrimeraSesion', Date.now());
    // detecto si debo mostrar el cuestionario en la sesión
    const gapinicio = Date.now() - Number(localStorage.getItem('timestampPrimeraSesion'));
    if (gapinicio > (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).interSessionQGap && !localStorage.getItem('cuestionarioNo')) {
        $ffd94e1d81f19b1c$export$7d414ec76c8c1259.ponerAlertaCuestionario = true; // puede ponerse el cuestionario en la sesión
        $ffd94e1d81f19b1c$export$7d414ec76c8c1259.inicioSesion = Date.now(); // guardo inicio sesión
    } else $ffd94e1d81f19b1c$export$7d414ec76c8c1259.ponerAlertaCuestionario = false;
}
/////////////////////
// CONFIGURACIÓN SOLR
/////////////////////
function $ffd94e1d81f19b1c$var$configurarSolr() {
    //console.group("Inicialización motor de texto");
    console.time("Configuraci\xf3n motor de texto");
    // inicializo Solr
    $ffd94e1d81f19b1c$export$c398d137cd63b259 = new (0, $3d46cc2f44b0084a$export$cb8a624b93d2efe9)((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).solrConfig.path + (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).solrConfig.suggestHandler, (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).solrConfig.path + (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).solrConfig.selectHandler);
    $ffd94e1d81f19b1c$export$c398d137cd63b259.test().then(()=>{
        // OK
        console.info("Motor de texto funciona");
        console.timeEnd("Configuraci\xf3n motor de texto");
        // muestro la entrada de los lugares
        (0, $d1e0875cf0f68e21$export$24073cf807c9abc3)(true);
    }).catch((messageError)=>{
        // log del error
        console.error(messageError);
        console.timeEnd("Configuraci\xf3n motor de texto");
        // pongo Solr a null y escondo la entrada de los lugares
        $ffd94e1d81f19b1c$export$c398d137cd63b259 = null;
        (0, $d1e0875cf0f68e21$export$24073cf807c9abc3)(true);
    });
}
////////////////////////
// ERROR PROVEEDOR DATOS
////////////////////////
function $ffd94e1d81f19b1c$var$errorProveedorDatosIrrecuperable(messageError) {
    // ya no tiene sentido pedir datos
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.errordataprov = true;
    // pongo un modal para avisar de que no se puede explorar el inventario	
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        vertcent: true,
        nofooter: true
    }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).errorEndpointTitle), (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).errorEndpointText), null);
    // el modal ya se creó al inicializar la aplicación, por lo que no hace falta esta llamada:
    //const mimodal = new bootstrap.Modal(document.getElementById('mimodal'));
    // si no está mostrado lo hago
    if (!document.querySelector('.modal.show')) $ffd94e1d81f19b1c$var$mimodal.show();
    // quito temporizador
    (0, $69f04ba581843b2d$export$7a39c88e7f3f42da)();
}
///////////////////
// CARGA DE LA URL
// la función clave
///////////////////
function $ffd94e1d81f19b1c$export$db4341b92d8f97b0(inicial) {
    //console.warn(window.location);
    // 1) elimino alguna info del estado de la sesión
    delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path;
    delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.taxon; // quizá no sea adecuado borrarlo
    delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.etid;
    delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.pe;
    delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.pae;
    delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.showann;
    delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.zoom; // no es estado, pero lo borro para evitar desajustes en las celdas
    // 2) actualizo el estado de la sesión a partir de la URL	
    // parseo del querystring de la URL
    const urlParams = new URLSearchParams(window.location.search);
    // actualizo localización si hay localización y está bien
    // en otro caso no borro la localización que hubiera
    const cadloc = urlParams.get('loc');
    if (cadloc != null) {
        const loc = (0, $96abbdd7193a3c4b$export$6f6326edee345e29)(cadloc);
        if (loc != null) $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.loc = loc;
    }
    // obtengo el path y valido
    const pathels = window.location.pathname.split("/");
    switch(pathels[1]){
        case "user":
            if (pathels[2] != undefined) {
                $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path = pathels[1];
                $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.etid = pathels[2];
                // puede haber como query parámetros pe (num página educatree) y pae (num página educatree anotado)
                if (urlParams.get('pe') != null && /^[1-9]\d*$/.test(urlParams.get('pe'))) $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.pe = Number(urlParams.get('pe'));
                if (urlParams.get('pae') != null && /^[1-9]\d*$/.test(urlParams.get('pae'))) $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.pae = Number(urlParams.get('pae'));
                // también puede haber showann para mostrar las anotaciones
                if (urlParams.get('showann')) $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.showann = true;
            } else $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path = "map";
            break;
        case "lasttrees":
            $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path = pathels[1];
            // puede haber como query parámetros pe (num página educatree) y pae (num página educatree anotado)
            if (urlParams.get('pe') != null && /^[1-9]\d*$/.test(urlParams.get('pe'))) $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.pe = Number(urlParams.get('pe'));
            if (urlParams.get('pae') != null && /^[1-9]\d*$/.test(urlParams.get('pae'))) $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.pae = Number(urlParams.get('pae'));
            // también puede haber showann para mostrar las anotaciones
            if (urlParams.get('showann')) $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.showann = true;
            break;
        case "map":
            $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path = pathels[1];
            if (urlParams.get('ifn') != null && urlParams.get('ifn') === "true") $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.ifn = true;
            else $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.ifn = false;
            if (urlParams.get('esri') != null && urlParams.get('esri') === "true") $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.esri = true;
            else $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.esri = false;
            break;
        case "tree":
            if (pathels[2] != undefined) {
                $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path = pathels[1];
                $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.etid = pathels[2];
            } else $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path = "map";
            break;
        case "newtree":
            // sólo permito ir si el usuario está logueado y si hay localización
            if ($ffd94e1d81f19b1c$export$7d414ec76c8c1259.usuario && $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.loc != undefined) $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path = pathels[1];
            else $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path = "map";
            break;
        default:
            $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path = "map";
            break;
    }
    // en modo mapa incluyo filtro de taxón si está presente o si es el caso inicial (antes de cargar las especies)
    if ($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path === "map" && urlParams.get('taxon') != undefined) {
        let tx = urlParams.get('taxon');
        // incluyo el filtro de taxón si caso inicial o si existe
        if (inicial || $ffd94e1d81f19b1c$export$af4650068b70eb5d.especies[tx] != undefined) $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.taxon = tx;
    }
    //3) ajusto vista según el estado del path cargado
    switch($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path){
        case "user":
            // bloqueo actualizaciones del mapa
            $ffd94e1d81f19b1c$export$7d414ec76c8c1259.actualizandoMapa = true;
            // quito vista mapa
            $ffd94e1d81f19b1c$var$vistaMapa(false);
            // actualizo título de la página
            document.title = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).user) + ' ' + $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.etid + ' - EducaWood';
            // propiedades meta
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("meta[property='og:title']").attr('content', document.title);
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("meta[property='og:description']").attr('content', 'Page of user ' + $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.etid + ' in EducaWood.');
            // llamo a mostrar la página del usuario
            if (!inicial) (0, $c0304d280c7b00cb$export$d4acb3475854cdbb)();
            break;
        case "lasttrees":
            // bloqueo actualizaciones del mapa
            $ffd94e1d81f19b1c$export$7d414ec76c8c1259.actualizandoMapa = true;
            // quito vista mapa
            $ffd94e1d81f19b1c$var$vistaMapa(false);
            // actualizo título de la página
            document.title = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).lastTrees) + ' - EducaWood';
            // propiedades meta
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("meta[property='og:title']").attr('content', document.title);
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("meta[property='og:description']").attr('content', 'Last trees created in EducaWood.');
            // llamo a mostrar la página de lasttrees
            if (!inicial) (0, $82a71c896f160eac$export$eca36acb6faff6b4)();
            break;
        case "tree":
            // bloqueo actualizaciones del mapa
            $ffd94e1d81f19b1c$export$7d414ec76c8c1259.actualizandoMapa = true;
            // quito vista mapa
            $ffd94e1d81f19b1c$var$vistaMapa(false);
            // actualizo título de la página
            document.title = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tree) + ' ' + $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.etid + ' - EducaWood';
            // propiedades meta
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("meta[property='og:title']").attr('content', document.title);
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("meta[property='og:description']").attr('content', 'Page of tree ' + $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.etid + ' in EducaWood.');
            // llamo a mostrar la página del árbol
            if (!inicial) (0, $27fe9e683b34e1a0$export$c2e76fbffb5b7346)();
            break;
        case "newtree":
            // bloqueo actualizaciones del mapa
            $ffd94e1d81f19b1c$export$7d414ec76c8c1259.actualizandoMapa = true;
            // quito vista mapa
            $ffd94e1d81f19b1c$var$vistaMapa(false);
            // actualizo título de la página
            document.title = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).newtree) + ' - EducaWood';
            // propiedades meta
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("meta[property='og:title']").attr('content', document.title);
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("meta[property='og:description']").attr('content', 'Form for creating a tree in EducaWood.');
            // llamo a mostrar la página de creación del árbol
            if (!inicial) (0, $3a9989d46007ef73$export$966d5c02a501e12b)();
            break;
        case "map":
            // desbloqueo actualizaciones del mapa 
            $ffd94e1d81f19b1c$export$7d414ec76c8c1259.actualizandoMapa = false;
            // pongo vista mapa
            $ffd94e1d81f19b1c$var$vistaMapa(true);
            // actualizo título de la página
            document.title = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).map) + ' - EducaWood';
            // propiedades meta
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("meta[property='og:title']").attr('content', document.title);
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("meta[property='og:description']").attr('content', 'Navigating the map of EducaWood.');
            // si no es la llamada inicial hago más cosas...
            if (!inicial) {
                // centro el mapa en la localización de la sesión
                // esto dispara un evento de mapa movido, disparando su actualización en MODO MAPA
                $ffd94e1d81f19b1c$export$aabd6129ce9bddee.setView([
                    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.loc.lat,
                    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.loc.lng
                ], $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.loc.z);
                // incluyo esto para que el mapa se reajuste
                // parece que así se resuelve el problema que había al pasar de recurso a mapa
                // tengo que poner esto después del setview, en otro caso no reacciona al setview
                $ffd94e1d81f19b1c$export$aabd6129ce9bddee.invalidateSize();
                // visualización filtro de taxón
                (0, $1ee989753a15371d$export$99e344fe0d6549db)();
                // actualizo datos IFN
                (0, $c853be3628706c6e$export$87931b6598ef9316)();
                // actualizo mapa base
                (0, $c853be3628706c6e$export$1319329b668abb17)();
                // tour inicial
                if (!localStorage.getItem('tourCompletado')) (0, $2fa03f5d455d6f0a$export$cdda91dfb91997f3)();
            }
            break;
    } // fin del switch
}
function $ffd94e1d81f19b1c$var$vistaMapa(esmapa) {
    // ajuste propiedad meta de la url
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("meta[property='og:url']").attr('content', window.location.href);
    if (esmapa) {
        // actualizo viewport (escala fijada)
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#miviewport").attr("content", "width=device-width, initial-scale=1, maximum-scale=1, shrink-to-fit=no");
        // escondo miarbol y muestro mapa
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#miarbol").html(''); // borro contenido página
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#miarbol").addClass("d-none");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimapa").removeClass("d-none");
    } else {
        // actualizo viewport (puede ampliarse)
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#miviewport").attr("content", "width=device-width, initial-scale=1, shrink-to-fit=no");
        // escondo mapa y muestro página del árbol
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimapa").addClass("d-none");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#miarbol").html(''); // borro contenido página
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#miarbol").removeClass("d-none");
    }
}
//////////////////////////////////////////////
// GENERACIÓN DE LA URL A PARTIR DE LA SESIÓN
//////////////////////////////////////////////
function $ffd94e1d81f19b1c$export$e5c8c113a1c69275() {
    // preparo la URL base con el path de Sesion.estado.path
    const { protocol: protocol, host: host } = window.location;
    let url = protocol + '//' + host + '/' + $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path;
    // caso etid (segunda variable de path)
    if ($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.etid) url += '/' + $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.etid;
    // preparo searchpars
    const searchpars = [];
    if ($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.loc && ($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path === "map" || $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path === "newtree")) searchpars.push('loc=' + (0, $96abbdd7193a3c4b$export$4a32c72e9ff1d1e0)($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.loc));
    if ($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.ifn && $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path === "map") searchpars.push('ifn=true');
    if ($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.esri && $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path === "map") searchpars.push('esri=true');
    if ($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.taxon && $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path === "map") searchpars.push('taxon=' + $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.taxon);
    if ($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.pe && ($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path === "user" || $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path === "lasttrees")) searchpars.push('pe=' + $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.pe);
    if ($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.pae && ($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path === "user" || $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path === "lasttrees")) searchpars.push('pae=' + $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.pae);
    if ($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.showann && ($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path === "user" || $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path === "lasttrees")) searchpars.push('showann=true');
    // incluyo los searchpars
    for(let i = 0; i < searchpars.length; i++){
        const sep = i == 0 ? '?' : '&';
        url += sep + searchpars[i];
    }
    return url;
}
/////////////////////////////////////////
// PARA IR ATRÁS O AL MAPA SI NO HAY NADA
/////////////////////////////////////////
function $ffd94e1d81f19b1c$export$28fca2ccfd38b8f() {
    // si hay más páginas en la historia simplemente voy para atrás
    if ($ffd94e1d81f19b1c$export$7d414ec76c8c1259.npags > 0) {
        $ffd94e1d81f19b1c$export$7d414ec76c8c1259.npags--;
        history.back();
    } else {
        // actualizo path y URL
        $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path = "map";
        history.replaceState($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado, "", $ffd94e1d81f19b1c$export$e5c8c113a1c69275());
        // y cargo la URL para que me lleve al mapa completo
        $ffd94e1d81f19b1c$export$db4341b92d8f97b0();
    }
}


//# sourceMappingURL=app.896309a5.js.map
